/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 151);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(2)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(183)
var ieee754 = __webpack_require__(184)
var isArray = __webpack_require__(93)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright (c) 2012, Mark Cavage. All rights reserved.
// Copyright 2015 Joyent, Inc.

var assert = __webpack_require__(28);
var Stream = __webpack_require__(17).Stream;
var util = __webpack_require__(5);


///--- Globals

/* JSSTYLED */
var UUID_REGEXP = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;


///--- Internal

function _capitalize(str) {
    return (str.charAt(0).toUpperCase() + str.slice(1));
}

function _toss(name, expected, oper, arg, actual) {
    throw new assert.AssertionError({
        message: util.format('%s (%s) is required', name, expected),
        actual: (actual === undefined) ? typeof (arg) : actual(arg),
        expected: expected,
        operator: oper || '===',
        stackStartFunction: _toss.caller
    });
}

function _getClass(arg) {
    return (Object.prototype.toString.call(arg).slice(8, -1));
}

function noop() {
    // Why even bother with asserts?
}


///--- Exports

var types = {
    bool: {
        check: function (arg) { return typeof (arg) === 'boolean'; }
    },
    func: {
        check: function (arg) { return typeof (arg) === 'function'; }
    },
    string: {
        check: function (arg) { return typeof (arg) === 'string'; }
    },
    object: {
        check: function (arg) {
            return typeof (arg) === 'object' && arg !== null;
        }
    },
    number: {
        check: function (arg) {
            return typeof (arg) === 'number' && !isNaN(arg);
        }
    },
    finite: {
        check: function (arg) {
            return typeof (arg) === 'number' && !isNaN(arg) && isFinite(arg);
        }
    },
    buffer: {
        check: function (arg) { return Buffer.isBuffer(arg); },
        operator: 'Buffer.isBuffer'
    },
    array: {
        check: function (arg) { return Array.isArray(arg); },
        operator: 'Array.isArray'
    },
    stream: {
        check: function (arg) { return arg instanceof Stream; },
        operator: 'instanceof',
        actual: _getClass
    },
    date: {
        check: function (arg) { return arg instanceof Date; },
        operator: 'instanceof',
        actual: _getClass
    },
    regexp: {
        check: function (arg) { return arg instanceof RegExp; },
        operator: 'instanceof',
        actual: _getClass
    },
    uuid: {
        check: function (arg) {
            return typeof (arg) === 'string' && UUID_REGEXP.test(arg);
        },
        operator: 'isUUID'
    }
};

function _setExports(ndebug) {
    var keys = Object.keys(types);
    var out;

    /* re-export standard assert */
    if (Object({"NODE_ENV":"production","PUBLIC_URL":"."}).NODE_NDEBUG) {
        out = noop;
    } else {
        out = function (arg, msg) {
            if (!arg) {
                _toss(msg, 'true', arg);
            }
        };
    }

    /* standard checks */
    keys.forEach(function (k) {
        if (ndebug) {
            out[k] = noop;
            return;
        }
        var type = types[k];
        out[k] = function (arg, msg) {
            if (!type.check(arg)) {
                _toss(msg, k, type.operator, arg, type.actual);
            }
        };
    });

    /* optional checks */
    keys.forEach(function (k) {
        var name = 'optional' + _capitalize(k);
        if (ndebug) {
            out[name] = noop;
            return;
        }
        var type = types[k];
        out[name] = function (arg, msg) {
            if (arg === undefined || arg === null) {
                return;
            }
            if (!type.check(arg)) {
                _toss(msg, k, type.operator, arg, type.actual);
            }
        };
    });

    /* arrayOf checks */
    keys.forEach(function (k) {
        var name = 'arrayOf' + _capitalize(k);
        if (ndebug) {
            out[name] = noop;
            return;
        }
        var type = types[k];
        var expected = '[' + k + ']';
        out[name] = function (arg, msg) {
            if (!Array.isArray(arg)) {
                _toss(msg, expected, type.operator, arg, type.actual);
            }
            var i;
            for (i = 0; i < arg.length; i++) {
                if (!type.check(arg[i])) {
                    _toss(msg, expected, type.operator, arg, type.actual);
                }
            }
        };
    });

    /* optionalArrayOf checks */
    keys.forEach(function (k) {
        var name = 'optionalArrayOf' + _capitalize(k);
        if (ndebug) {
            out[name] = noop;
            return;
        }
        var type = types[k];
        var expected = '[' + k + ']';
        out[name] = function (arg, msg) {
            if (arg === undefined || arg === null) {
                return;
            }
            if (!Array.isArray(arg)) {
                _toss(msg, expected, type.operator, arg, type.actual);
            }
            var i;
            for (i = 0; i < arg.length; i++) {
                if (!type.check(arg[i])) {
                    _toss(msg, expected, type.operator, arg, type.actual);
                }
            }
        };
    });

    /* re-export built-in assertions */
    Object.keys(assert).forEach(function (k) {
        if (k === 'AssertionError') {
            out[k] = assert[k];
            return;
        }
        if (ndebug) {
            out[k] = noop;
            return;
        }
        out[k] = assert[k];
    });

    /* export ourselves (for unit tests _only_) */
    out._setExports = _setExports;

    return out;
}

module.exports = _setExports(Object({"NODE_ENV":"production","PUBLIC_URL":"."}).NODE_NDEBUG);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* eslint-disable node/no-deprecated-api */



var buffer = __webpack_require__(2)
var Buffer = buffer.Buffer

var safer = {}

var key

for (key in buffer) {
  if (!buffer.hasOwnProperty(key)) continue
  if (key === 'SlowBuffer' || key === 'Buffer') continue
  safer[key] = buffer[key]
}

var Safer = safer.Buffer = {}
for (key in Buffer) {
  if (!Buffer.hasOwnProperty(key)) continue
  if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue
  Safer[key] = Buffer[key]
}

safer.Buffer.prototype = Buffer.prototype

if (!Safer.from || Safer.from === Uint8Array.from) {
  Safer.from = function (value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value)
    }
    if (value && typeof value.length === 'undefined') {
      throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value)
    }
    return Buffer(value, encodingOrOffset, length)
  }
}

if (!Safer.alloc) {
  Safer.alloc = function (size, fill, encoding) {
    if (typeof size !== 'number') {
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size)
    }
    if (size < 0 || size >= 2 * (1 << 30)) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"')
    }
    var buf = Buffer(size)
    if (!fill || fill.length === 0) {
      buf.fill(0)
    } else if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
    return buf
  }
}

if (!safer.kStringMaxLength) {
  try {
    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength
  } catch (e) {
    // we can't determine kStringMaxLength in environments where process.binding
    // is unsupported, so let's not set it
  }
}

if (!safer.constants) {
  safer.constants = {
    MAX_LENGTH: safer.kMaxLength
  }
  if (safer.kStringMaxLength) {
    safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength
  }
}

module.exports = safer

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"."}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(176);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(0);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(31)
exports.createHash = exports.Hash = __webpack_require__(35)
exports.createHmac = exports.Hmac = __webpack_require__(101)

var algos = __webpack_require__(199)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(104)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(201)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(218)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(223)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(261)

var publicEncrypt = __webpack_require__(262)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(265)

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(219).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)(module)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

module.exports = {
	bufferSplit: bufferSplit,
	addRSAMissing: addRSAMissing,
	calculateDSAPublic: calculateDSAPublic,
	calculateED25519Public: calculateED25519Public,
	calculateX25519Public: calculateX25519Public,
	mpNormalize: mpNormalize,
	mpDenormalize: mpDenormalize,
	ecNormalize: ecNormalize,
	countZeros: countZeros,
	assertCompatible: assertCompatible,
	isCompatible: isCompatible,
	opensslKeyDeriv: opensslKeyDeriv,
	opensshCipherInfo: opensshCipherInfo,
	publicFromPrivateECDSA: publicFromPrivateECDSA,
	zeroPadToLength: zeroPadToLength,
	writeBitString: writeBitString,
	readBitString: readBitString
};

var assert = __webpack_require__(3);
var Buffer = __webpack_require__(4).Buffer;
var PrivateKey = __webpack_require__(13);
var Key = __webpack_require__(11);
var crypto = __webpack_require__(7);
var algs = __webpack_require__(12);
var asn1 = __webpack_require__(22);

var ec, jsbn;
var nacl;

var MAX_CLASS_DEPTH = 3;

function isCompatible(obj, klass, needVer) {
	if (obj === null || typeof (obj) !== 'object')
		return (false);
	if (needVer === undefined)
		needVer = klass.prototype._sshpkApiVersion;
	if (obj instanceof klass &&
	    klass.prototype._sshpkApiVersion[0] == needVer[0])
		return (true);
	var proto = Object.getPrototypeOf(obj);
	var depth = 0;
	while (proto.constructor.name !== klass.name) {
		proto = Object.getPrototypeOf(proto);
		if (!proto || ++depth > MAX_CLASS_DEPTH)
			return (false);
	}
	if (proto.constructor.name !== klass.name)
		return (false);
	var ver = proto._sshpkApiVersion;
	if (ver === undefined)
		ver = klass._oldVersionDetect(obj);
	if (ver[0] != needVer[0] || ver[1] < needVer[1])
		return (false);
	return (true);
}

function assertCompatible(obj, klass, needVer, name) {
	if (name === undefined)
		name = 'object';
	assert.ok(obj, name + ' must not be null');
	assert.object(obj, name + ' must be an object');
	if (needVer === undefined)
		needVer = klass.prototype._sshpkApiVersion;
	if (obj instanceof klass &&
	    klass.prototype._sshpkApiVersion[0] == needVer[0])
		return;
	var proto = Object.getPrototypeOf(obj);
	var depth = 0;
	while (proto.constructor.name !== klass.name) {
		proto = Object.getPrototypeOf(proto);
		assert.ok(proto && ++depth <= MAX_CLASS_DEPTH,
		    name + ' must be a ' + klass.name + ' instance');
	}
	assert.strictEqual(proto.constructor.name, klass.name,
	    name + ' must be a ' + klass.name + ' instance');
	var ver = proto._sshpkApiVersion;
	if (ver === undefined)
		ver = klass._oldVersionDetect(obj);
	assert.ok(ver[0] == needVer[0] && ver[1] >= needVer[1],
	    name + ' must be compatible with ' + klass.name + ' klass ' +
	    'version ' + needVer[0] + '.' + needVer[1]);
}

var CIPHER_LEN = {
	'des-ede3-cbc': { key: 7, iv: 8 },
	'aes-128-cbc': { key: 16, iv: 16 }
};
var PKCS5_SALT_LEN = 8;

function opensslKeyDeriv(cipher, salt, passphrase, count) {
	assert.buffer(salt, 'salt');
	assert.buffer(passphrase, 'passphrase');
	assert.number(count, 'iteration count');

	var clen = CIPHER_LEN[cipher];
	assert.object(clen, 'supported cipher');

	salt = salt.slice(0, PKCS5_SALT_LEN);

	var D, D_prev, bufs;
	var material = Buffer.alloc(0);
	while (material.length < clen.key + clen.iv) {
		bufs = [];
		if (D_prev)
			bufs.push(D_prev);
		bufs.push(passphrase);
		bufs.push(salt);
		D = Buffer.concat(bufs);
		for (var j = 0; j < count; ++j)
			D = crypto.createHash('md5').update(D).digest();
		material = Buffer.concat([material, D]);
		D_prev = D;
	}

	return ({
	    key: material.slice(0, clen.key),
	    iv: material.slice(clen.key, clen.key + clen.iv)
	});
}

/* Count leading zero bits on a buffer */
function countZeros(buf) {
	var o = 0, obit = 8;
	while (o < buf.length) {
		var mask = (1 << obit);
		if ((buf[o] & mask) === mask)
			break;
		obit--;
		if (obit < 0) {
			o++;
			obit = 8;
		}
	}
	return (o*8 + (8 - obit) - 1);
}

function bufferSplit(buf, chr) {
	assert.buffer(buf);
	assert.string(chr);

	var parts = [];
	var lastPart = 0;
	var matches = 0;
	for (var i = 0; i < buf.length; ++i) {
		if (buf[i] === chr.charCodeAt(matches))
			++matches;
		else if (buf[i] === chr.charCodeAt(0))
			matches = 1;
		else
			matches = 0;

		if (matches >= chr.length) {
			var newPart = i + 1;
			parts.push(buf.slice(lastPart, newPart - matches));
			lastPart = newPart;
			matches = 0;
		}
	}
	if (lastPart <= buf.length)
		parts.push(buf.slice(lastPart, buf.length));

	return (parts);
}

function ecNormalize(buf, addZero) {
	assert.buffer(buf);
	if (buf[0] === 0x00 && buf[1] === 0x04) {
		if (addZero)
			return (buf);
		return (buf.slice(1));
	} else if (buf[0] === 0x04) {
		if (!addZero)
			return (buf);
	} else {
		while (buf[0] === 0x00)
			buf = buf.slice(1);
		if (buf[0] === 0x02 || buf[0] === 0x03)
			throw (new Error('Compressed elliptic curve points ' +
			    'are not supported'));
		if (buf[0] !== 0x04)
			throw (new Error('Not a valid elliptic curve point'));
		if (!addZero)
			return (buf);
	}
	var b = Buffer.alloc(buf.length + 1);
	b[0] = 0x0;
	buf.copy(b, 1);
	return (b);
}

function readBitString(der, tag) {
	if (tag === undefined)
		tag = asn1.Ber.BitString;
	var buf = der.readString(tag, true);
	assert.strictEqual(buf[0], 0x00, 'bit strings with unused bits are ' +
	    'not supported (0x' + buf[0].toString(16) + ')');
	return (buf.slice(1));
}

function writeBitString(der, buf, tag) {
	if (tag === undefined)
		tag = asn1.Ber.BitString;
	var b = Buffer.alloc(buf.length + 1);
	b[0] = 0x00;
	buf.copy(b, 1);
	der.writeBuffer(b, tag);
}

function mpNormalize(buf) {
	assert.buffer(buf);
	while (buf.length > 1 && buf[0] === 0x00 && (buf[1] & 0x80) === 0x00)
		buf = buf.slice(1);
	if ((buf[0] & 0x80) === 0x80) {
		var b = Buffer.alloc(buf.length + 1);
		b[0] = 0x00;
		buf.copy(b, 1);
		buf = b;
	}
	return (buf);
}

function mpDenormalize(buf) {
	assert.buffer(buf);
	while (buf.length > 1 && buf[0] === 0x00)
		buf = buf.slice(1);
	return (buf);
}

function zeroPadToLength(buf, len) {
	assert.buffer(buf);
	assert.number(len);
	while (buf.length > len) {
		assert.equal(buf[0], 0x00);
		buf = buf.slice(1);
	}
	while (buf.length < len) {
		var b = Buffer.alloc(buf.length + 1);
		b[0] = 0x00;
		buf.copy(b, 1);
		buf = b;
	}
	return (buf);
}

function bigintToMpBuf(bigint) {
	var buf = Buffer.from(bigint.toByteArray());
	buf = mpNormalize(buf);
	return (buf);
}

function calculateDSAPublic(g, p, x) {
	assert.buffer(g);
	assert.buffer(p);
	assert.buffer(x);
	try {
		var bigInt = __webpack_require__(25).BigInteger;
	} catch (e) {
		throw (new Error('To load a PKCS#8 format DSA private key, ' +
		    'the node jsbn library is required.'));
	}
	g = new bigInt(g);
	p = new bigInt(p);
	x = new bigInt(x);
	var y = g.modPow(x, p);
	var ybuf = bigintToMpBuf(y);
	return (ybuf);
}

function calculateED25519Public(k) {
	assert.buffer(k);

	if (nacl === undefined)
		nacl = __webpack_require__(21);

	var kp = nacl.sign.keyPair.fromSeed(new Uint8Array(k));
	return (Buffer.from(kp.publicKey));
}

function calculateX25519Public(k) {
	assert.buffer(k);

	if (nacl === undefined)
		nacl = __webpack_require__(21);

	var kp = nacl.box.keyPair.fromSeed(new Uint8Array(k));
	return (Buffer.from(kp.publicKey));
}

function addRSAMissing(key) {
	assert.object(key);
	assertCompatible(key, PrivateKey, [1, 1]);
	try {
		var bigInt = __webpack_require__(25).BigInteger;
	} catch (e) {
		throw (new Error('To write a PEM private key from ' +
		    'this source, the node jsbn lib is required.'));
	}

	var d = new bigInt(key.part.d.data);
	var buf;

	if (!key.part.dmodp) {
		var p = new bigInt(key.part.p.data);
		var dmodp = d.mod(p.subtract(1));

		buf = bigintToMpBuf(dmodp);
		key.part.dmodp = {name: 'dmodp', data: buf};
		key.parts.push(key.part.dmodp);
	}
	if (!key.part.dmodq) {
		var q = new bigInt(key.part.q.data);
		var dmodq = d.mod(q.subtract(1));

		buf = bigintToMpBuf(dmodq);
		key.part.dmodq = {name: 'dmodq', data: buf};
		key.parts.push(key.part.dmodq);
	}
}

function publicFromPrivateECDSA(curveName, priv) {
	assert.string(curveName, 'curveName');
	assert.buffer(priv);
	if (ec === undefined)
		ec = __webpack_require__(44);
	if (jsbn === undefined)
		jsbn = __webpack_require__(25).BigInteger;
	var params = algs.curves[curveName];
	var p = new jsbn(params.p);
	var a = new jsbn(params.a);
	var b = new jsbn(params.b);
	var curve = new ec.ECCurveFp(p, a, b);
	var G = curve.decodePointHex(params.G.toString('hex'));

	var d = new jsbn(mpNormalize(priv));
	var pub = G.multiply(d);
	pub = Buffer.from(curve.encodePointHex(pub), 'hex');

	var parts = [];
	parts.push({name: 'curve', data: Buffer.from(curveName)});
	parts.push({name: 'Q', data: pub});

	var key = new Key({type: 'ecdsa', curve: curve, parts: parts});
	return (key);
}

function opensshCipherInfo(cipher) {
	var inf = {};
	switch (cipher) {
	case '3des-cbc':
		inf.keySize = 24;
		inf.blockSize = 8;
		inf.opensslName = 'des-ede3-cbc';
		break;
	case 'blowfish-cbc':
		inf.keySize = 16;
		inf.blockSize = 8;
		inf.opensslName = 'bf-cbc';
		break;
	case 'aes128-cbc':
	case 'aes128-ctr':
	case 'aes128-gcm@openssh.com':
		inf.keySize = 16;
		inf.blockSize = 16;
		inf.opensslName = 'aes-128-' + cipher.slice(7, 10);
		break;
	case 'aes192-cbc':
	case 'aes192-ctr':
	case 'aes192-gcm@openssh.com':
		inf.keySize = 24;
		inf.blockSize = 16;
		inf.opensslName = 'aes-192-' + cipher.slice(7, 10);
		break;
	case 'aes256-cbc':
	case 'aes256-ctr':
	case 'aes256-gcm@openssh.com':
		inf.keySize = 32;
		inf.blockSize = 16;
		inf.opensslName = 'aes-256-' + cipher.slice(7, 10);
		break;
	default:
		throw (new Error(
		    'Unsupported openssl cipher "' + cipher + '"'));
	}
	return (inf);
}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright 2017 Joyent, Inc.

module.exports = Key;

var assert = __webpack_require__(3);
var algs = __webpack_require__(12);
var crypto = __webpack_require__(7);
var Fingerprint = __webpack_require__(42);
var Signature = __webpack_require__(20);
var DiffieHellman = __webpack_require__(77).DiffieHellman;
var errs = __webpack_require__(19);
var utils = __webpack_require__(9);
var PrivateKey = __webpack_require__(13);
var edCompat;

try {
	edCompat = __webpack_require__(133);
} catch (e) {
	/* Just continue through, and bail out if we try to use it. */
}

var InvalidAlgorithmError = errs.InvalidAlgorithmError;
var KeyParseError = errs.KeyParseError;

var formats = {};
formats['auto'] = __webpack_require__(134);
formats['pem'] = __webpack_require__(26);
formats['pkcs1'] = __webpack_require__(80);
formats['pkcs8'] = __webpack_require__(45);
formats['rfc4253'] = __webpack_require__(29);
formats['ssh'] = __webpack_require__(136);
formats['ssh-private'] = __webpack_require__(57);
formats['openssh'] = formats['ssh-private'];
formats['dnssec'] = __webpack_require__(81);

function Key(opts) {
	assert.object(opts, 'options');
	assert.arrayOfObject(opts.parts, 'options.parts');
	assert.string(opts.type, 'options.type');
	assert.optionalString(opts.comment, 'options.comment');

	var algInfo = algs.info[opts.type];
	if (typeof (algInfo) !== 'object')
		throw (new InvalidAlgorithmError(opts.type));

	var partLookup = {};
	for (var i = 0; i < opts.parts.length; ++i) {
		var part = opts.parts[i];
		partLookup[part.name] = part;
	}

	this.type = opts.type;
	this.parts = opts.parts;
	this.part = partLookup;
	this.comment = undefined;
	this.source = opts.source;

	/* for speeding up hashing/fingerprint operations */
	this._rfc4253Cache = opts._rfc4253Cache;
	this._hashCache = {};

	var sz;
	this.curve = undefined;
	if (this.type === 'ecdsa') {
		var curve = this.part.curve.data.toString();
		this.curve = curve;
		sz = algs.curves[curve].size;
	} else if (this.type === 'ed25519' || this.type === 'curve25519') {
		sz = 256;
		this.curve = 'curve25519';
	} else {
		var szPart = this.part[algInfo.sizePart];
		sz = szPart.data.length;
		sz = sz * 8 - utils.countZeros(szPart.data);
	}
	this.size = sz;
}

Key.formats = formats;

Key.prototype.toBuffer = function (format, options) {
	if (format === undefined)
		format = 'ssh';
	assert.string(format, 'format');
	assert.object(formats[format], 'formats[format]');
	assert.optionalObject(options, 'options');

	if (format === 'rfc4253') {
		if (this._rfc4253Cache === undefined)
			this._rfc4253Cache = formats['rfc4253'].write(this);
		return (this._rfc4253Cache);
	}

	return (formats[format].write(this, options));
};

Key.prototype.toString = function (format, options) {
	return (this.toBuffer(format, options).toString());
};

Key.prototype.hash = function (algo) {
	assert.string(algo, 'algorithm');
	algo = algo.toLowerCase();
	if (algs.hashAlgs[algo] === undefined)
		throw (new InvalidAlgorithmError(algo));

	if (this._hashCache[algo])
		return (this._hashCache[algo]);
	var hash = crypto.createHash(algo).
	    update(this.toBuffer('rfc4253')).digest();
	this._hashCache[algo] = hash;
	return (hash);
};

Key.prototype.fingerprint = function (algo) {
	if (algo === undefined)
		algo = 'sha256';
	assert.string(algo, 'algorithm');
	var opts = {
		type: 'key',
		hash: this.hash(algo),
		algorithm: algo
	};
	return (new Fingerprint(opts));
};

Key.prototype.defaultHashAlgorithm = function () {
	var hashAlgo = 'sha1';
	if (this.type === 'rsa')
		hashAlgo = 'sha256';
	if (this.type === 'dsa' && this.size > 1024)
		hashAlgo = 'sha256';
	if (this.type === 'ed25519')
		hashAlgo = 'sha512';
	if (this.type === 'ecdsa') {
		if (this.size <= 256)
			hashAlgo = 'sha256';
		else if (this.size <= 384)
			hashAlgo = 'sha384';
		else
			hashAlgo = 'sha512';
	}
	return (hashAlgo);
};

Key.prototype.createVerify = function (hashAlgo) {
	if (hashAlgo === undefined)
		hashAlgo = this.defaultHashAlgorithm();
	assert.string(hashAlgo, 'hash algorithm');

	/* ED25519 is not supported by OpenSSL, use a javascript impl. */
	if (this.type === 'ed25519' && edCompat !== undefined)
		return (new edCompat.Verifier(this, hashAlgo));
	if (this.type === 'curve25519')
		throw (new Error('Curve25519 keys are not suitable for ' +
		    'signing or verification'));

	var v, nm, err;
	try {
		nm = hashAlgo.toUpperCase();
		v = crypto.createVerify(nm);
	} catch (e) {
		err = e;
	}
	if (v === undefined || (err instanceof Error &&
	    err.message.match(/Unknown message digest/))) {
		nm = 'RSA-';
		nm += hashAlgo.toUpperCase();
		v = crypto.createVerify(nm);
	}
	assert.ok(v, 'failed to create verifier');
	var oldVerify = v.verify.bind(v);
	var key = this.toBuffer('pkcs8');
	var curve = this.curve;
	var self = this;
	v.verify = function (signature, fmt) {
		if (Signature.isSignature(signature, [2, 0])) {
			if (signature.type !== self.type)
				return (false);
			if (signature.hashAlgorithm &&
			    signature.hashAlgorithm !== hashAlgo)
				return (false);
			if (signature.curve && self.type === 'ecdsa' &&
			    signature.curve !== curve)
				return (false);
			return (oldVerify(key, signature.toBuffer('asn1')));

		} else if (typeof (signature) === 'string' ||
		    Buffer.isBuffer(signature)) {
			return (oldVerify(key, signature, fmt));

		/*
		 * Avoid doing this on valid arguments, walking the prototype
		 * chain can be quite slow.
		 */
		} else if (Signature.isSignature(signature, [1, 0])) {
			throw (new Error('signature was created by too old ' +
			    'a version of sshpk and cannot be verified'));

		} else {
			throw (new TypeError('signature must be a string, ' +
			    'Buffer, or Signature object'));
		}
	};
	return (v);
};

Key.prototype.createDiffieHellman = function () {
	if (this.type === 'rsa')
		throw (new Error('RSA keys do not support Diffie-Hellman'));

	return (new DiffieHellman(this));
};
Key.prototype.createDH = Key.prototype.createDiffieHellman;

Key.parse = function (data, format, options) {
	if (typeof (data) !== 'string')
		assert.buffer(data, 'data');
	if (format === undefined)
		format = 'auto';
	assert.string(format, 'format');
	if (typeof (options) === 'string')
		options = { filename: options };
	assert.optionalObject(options, 'options');
	if (options === undefined)
		options = {};
	assert.optionalString(options.filename, 'options.filename');
	if (options.filename === undefined)
		options.filename = '(unnamed)';

	assert.object(formats[format], 'formats[format]');

	try {
		var k = formats[format].read(data, options);
		if (k instanceof PrivateKey)
			k = k.toPublic();
		if (!k.comment)
			k.comment = options.filename;
		return (k);
	} catch (e) {
		if (e.name === 'KeyEncryptedError')
			throw (e);
		throw (new KeyParseError(options.filename, format, e));
	}
};

Key.isKey = function (obj, ver) {
	return (utils.isCompatible(obj, Key, ver));
};

/*
 * API versions for Key:
 * [1,0] -- initial ver, may take Signature for createVerify or may not
 * [1,1] -- added pkcs1, pkcs8 formats
 * [1,2] -- added auto, ssh-private, openssh formats
 * [1,3] -- added defaultHashAlgorithm
 * [1,4] -- added ed support, createDH
 * [1,5] -- first explicitly tagged version
 * [1,6] -- changed ed25519 part names
 */
Key.prototype._sshpkApiVersion = [1, 6];

Key._oldVersionDetect = function (obj) {
	assert.func(obj.toBuffer);
	assert.func(obj.fingerprint);
	if (obj.createDH)
		return ([1, 4]);
	if (obj.defaultHashAlgorithm)
		return ([1, 3]);
	if (obj.formats['auto'])
		return ([1, 2]);
	if (obj.formats['pkcs1'])
		return ([1, 1]);
	return ([1, 0]);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

var Buffer = __webpack_require__(4).Buffer;

var algInfo = {
	'dsa': {
		parts: ['p', 'q', 'g', 'y'],
		sizePart: 'p'
	},
	'rsa': {
		parts: ['e', 'n'],
		sizePart: 'n'
	},
	'ecdsa': {
		parts: ['curve', 'Q'],
		sizePart: 'Q'
	},
	'ed25519': {
		parts: ['A'],
		sizePart: 'A'
	}
};
algInfo['curve25519'] = algInfo['ed25519'];

var algPrivInfo = {
	'dsa': {
		parts: ['p', 'q', 'g', 'y', 'x']
	},
	'rsa': {
		parts: ['n', 'e', 'd', 'iqmp', 'p', 'q']
	},
	'ecdsa': {
		parts: ['curve', 'Q', 'd']
	},
	'ed25519': {
		parts: ['A', 'k']
	}
};
algPrivInfo['curve25519'] = algPrivInfo['ed25519'];

var hashAlgs = {
	'md5': true,
	'sha1': true,
	'sha256': true,
	'sha384': true,
	'sha512': true
};

/*
 * Taken from
 * http://csrc.nist.gov/groups/ST/toolkit/documents/dss/NISTReCur.pdf
 */
var curves = {
	'nistp256': {
		size: 256,
		pkcs8oid: '1.2.840.10045.3.1.7',
		p: Buffer.from(('00' +
		    'ffffffff 00000001 00000000 00000000' +
		    '00000000 ffffffff ffffffff ffffffff').
		    replace(/ /g, ''), 'hex'),
		a: Buffer.from(('00' +
		    'FFFFFFFF 00000001 00000000 00000000' +
		    '00000000 FFFFFFFF FFFFFFFF FFFFFFFC').
		    replace(/ /g, ''), 'hex'),
		b: Buffer.from((
		    '5ac635d8 aa3a93e7 b3ebbd55 769886bc' +
		    '651d06b0 cc53b0f6 3bce3c3e 27d2604b').
		    replace(/ /g, ''), 'hex'),
		s: Buffer.from(('00' +
		    'c49d3608 86e70493 6a6678e1 139d26b7' +
		    '819f7e90').
		    replace(/ /g, ''), 'hex'),
		n: Buffer.from(('00' +
		    'ffffffff 00000000 ffffffff ffffffff' +
		    'bce6faad a7179e84 f3b9cac2 fc632551').
		    replace(/ /g, ''), 'hex'),
		G: Buffer.from(('04' +
		    '6b17d1f2 e12c4247 f8bce6e5 63a440f2' +
		    '77037d81 2deb33a0 f4a13945 d898c296' +
		    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16' +
		    '2bce3357 6b315ece cbb64068 37bf51f5').
		    replace(/ /g, ''), 'hex')
	},
	'nistp384': {
		size: 384,
		pkcs8oid: '1.3.132.0.34',
		p: Buffer.from(('00' +
		    'ffffffff ffffffff ffffffff ffffffff' +
		    'ffffffff ffffffff ffffffff fffffffe' +
		    'ffffffff 00000000 00000000 ffffffff').
		    replace(/ /g, ''), 'hex'),
		a: Buffer.from(('00' +
		    'FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF' +
		    'FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFE' +
		    'FFFFFFFF 00000000 00000000 FFFFFFFC').
		    replace(/ /g, ''), 'hex'),
		b: Buffer.from((
		    'b3312fa7 e23ee7e4 988e056b e3f82d19' +
		    '181d9c6e fe814112 0314088f 5013875a' +
		    'c656398d 8a2ed19d 2a85c8ed d3ec2aef').
		    replace(/ /g, ''), 'hex'),
		s: Buffer.from(('00' +
		    'a335926a a319a27a 1d00896a 6773a482' +
		    '7acdac73').
		    replace(/ /g, ''), 'hex'),
		n: Buffer.from(('00' +
		    'ffffffff ffffffff ffffffff ffffffff' +
		    'ffffffff ffffffff c7634d81 f4372ddf' +
		    '581a0db2 48b0a77a ecec196a ccc52973').
		    replace(/ /g, ''), 'hex'),
		G: Buffer.from(('04' +
		    'aa87ca22 be8b0537 8eb1c71e f320ad74' +
		    '6e1d3b62 8ba79b98 59f741e0 82542a38' +
		    '5502f25d bf55296c 3a545e38 72760ab7' +
		    '3617de4a 96262c6f 5d9e98bf 9292dc29' +
		    'f8f41dbd 289a147c e9da3113 b5f0b8c0' +
		    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f').
		    replace(/ /g, ''), 'hex')
	},
	'nistp521': {
		size: 521,
		pkcs8oid: '1.3.132.0.35',
		p: Buffer.from((
		    '01ffffff ffffffff ffffffff ffffffff' +
		    'ffffffff ffffffff ffffffff ffffffff' +
		    'ffffffff ffffffff ffffffff ffffffff' +
		    'ffffffff ffffffff ffffffff ffffffff' +
		    'ffff').replace(/ /g, ''), 'hex'),
		a: Buffer.from(('01FF' +
		    'FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF' +
		    'FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF' +
		    'FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFF' +
		    'FFFFFFFF FFFFFFFF FFFFFFFF FFFFFFFC').
		    replace(/ /g, ''), 'hex'),
		b: Buffer.from(('51' +
		    '953eb961 8e1c9a1f 929a21a0 b68540ee' +
		    'a2da725b 99b315f3 b8b48991 8ef109e1' +
		    '56193951 ec7e937b 1652c0bd 3bb1bf07' +
		    '3573df88 3d2c34f1 ef451fd4 6b503f00').
		    replace(/ /g, ''), 'hex'),
		s: Buffer.from(('00' +
		    'd09e8800 291cb853 96cc6717 393284aa' +
		    'a0da64ba').replace(/ /g, ''), 'hex'),
		n: Buffer.from(('01ff' +
		    'ffffffff ffffffff ffffffff ffffffff' +
		    'ffffffff ffffffff ffffffff fffffffa' +
		    '51868783 bf2f966b 7fcc0148 f709a5d0' +
		    '3bb5c9b8 899c47ae bb6fb71e 91386409').
		    replace(/ /g, ''), 'hex'),
		G: Buffer.from(('04' +
		    '00c6 858e06b7 0404e9cd 9e3ecb66 2395b442' +
		         '9c648139 053fb521 f828af60 6b4d3dba' +
		         'a14b5e77 efe75928 fe1dc127 a2ffa8de' +
		         '3348b3c1 856a429b f97e7e31 c2e5bd66' +
		    '0118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9' +
		         '98f54449 579b4468 17afbd17 273e662c' +
		         '97ee7299 5ef42640 c550b901 3fad0761' +
		         '353c7086 a272c240 88be9476 9fd16650').
		    replace(/ /g, ''), 'hex')
	}
};

module.exports = {
	info: algInfo,
	privInfo: algPrivInfo,
	hashAlgs: hashAlgs,
	curves: curves
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2017 Joyent, Inc.

module.exports = PrivateKey;

var assert = __webpack_require__(3);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var crypto = __webpack_require__(7);
var Fingerprint = __webpack_require__(42);
var Signature = __webpack_require__(20);
var errs = __webpack_require__(19);
var util = __webpack_require__(5);
var utils = __webpack_require__(9);
var dhe = __webpack_require__(77);
var generateECDSA = dhe.generateECDSA;
var generateED25519 = dhe.generateED25519;
var edCompat;
var nacl;

try {
	edCompat = __webpack_require__(133);
} catch (e) {
	/* Just continue through, and bail out if we try to use it. */
}

var Key = __webpack_require__(11);

var InvalidAlgorithmError = errs.InvalidAlgorithmError;
var KeyParseError = errs.KeyParseError;
var KeyEncryptedError = errs.KeyEncryptedError;

var formats = {};
formats['auto'] = __webpack_require__(134);
formats['pem'] = __webpack_require__(26);
formats['pkcs1'] = __webpack_require__(80);
formats['pkcs8'] = __webpack_require__(45);
formats['rfc4253'] = __webpack_require__(29);
formats['ssh-private'] = __webpack_require__(57);
formats['openssh'] = formats['ssh-private'];
formats['ssh'] = formats['ssh-private'];
formats['dnssec'] = __webpack_require__(81);

function PrivateKey(opts) {
	assert.object(opts, 'options');
	Key.call(this, opts);

	this._pubCache = undefined;
}
util.inherits(PrivateKey, Key);

PrivateKey.formats = formats;

PrivateKey.prototype.toBuffer = function (format, options) {
	if (format === undefined)
		format = 'pkcs1';
	assert.string(format, 'format');
	assert.object(formats[format], 'formats[format]');
	assert.optionalObject(options, 'options');

	return (formats[format].write(this, options));
};

PrivateKey.prototype.hash = function (algo) {
	return (this.toPublic().hash(algo));
};

PrivateKey.prototype.toPublic = function () {
	if (this._pubCache)
		return (this._pubCache);

	var algInfo = algs.info[this.type];
	var pubParts = [];
	for (var i = 0; i < algInfo.parts.length; ++i) {
		var p = algInfo.parts[i];
		pubParts.push(this.part[p]);
	}

	this._pubCache = new Key({
		type: this.type,
		source: this,
		parts: pubParts
	});
	if (this.comment)
		this._pubCache.comment = this.comment;
	return (this._pubCache);
};

PrivateKey.prototype.derive = function (newType) {
	assert.string(newType, 'type');
	var priv, pub, pair;

	if (this.type === 'ed25519' && newType === 'curve25519') {
		if (nacl === undefined)
			nacl = __webpack_require__(21);

		priv = this.part.k.data;
		if (priv[0] === 0x00)
			priv = priv.slice(1);

		pair = nacl.box.keyPair.fromSecretKey(new Uint8Array(priv));
		pub = Buffer.from(pair.publicKey);

		return (new PrivateKey({
			type: 'curve25519',
			parts: [
				{ name: 'A', data: utils.mpNormalize(pub) },
				{ name: 'k', data: utils.mpNormalize(priv) }
			]
		}));
	} else if (this.type === 'curve25519' && newType === 'ed25519') {
		if (nacl === undefined)
			nacl = __webpack_require__(21);

		priv = this.part.k.data;
		if (priv[0] === 0x00)
			priv = priv.slice(1);

		pair = nacl.sign.keyPair.fromSeed(new Uint8Array(priv));
		pub = Buffer.from(pair.publicKey);

		return (new PrivateKey({
			type: 'ed25519',
			parts: [
				{ name: 'A', data: utils.mpNormalize(pub) },
				{ name: 'k', data: utils.mpNormalize(priv) }
			]
		}));
	}
	throw (new Error('Key derivation not supported from ' + this.type +
	    ' to ' + newType));
};

PrivateKey.prototype.createVerify = function (hashAlgo) {
	return (this.toPublic().createVerify(hashAlgo));
};

PrivateKey.prototype.createSign = function (hashAlgo) {
	if (hashAlgo === undefined)
		hashAlgo = this.defaultHashAlgorithm();
	assert.string(hashAlgo, 'hash algorithm');

	/* ED25519 is not supported by OpenSSL, use a javascript impl. */
	if (this.type === 'ed25519' && edCompat !== undefined)
		return (new edCompat.Signer(this, hashAlgo));
	if (this.type === 'curve25519')
		throw (new Error('Curve25519 keys are not suitable for ' +
		    'signing or verification'));

	var v, nm, err;
	try {
		nm = hashAlgo.toUpperCase();
		v = crypto.createSign(nm);
	} catch (e) {
		err = e;
	}
	if (v === undefined || (err instanceof Error &&
	    err.message.match(/Unknown message digest/))) {
		nm = 'RSA-';
		nm += hashAlgo.toUpperCase();
		v = crypto.createSign(nm);
	}
	assert.ok(v, 'failed to create verifier');
	var oldSign = v.sign.bind(v);
	var key = this.toBuffer('pkcs1');
	var type = this.type;
	var curve = this.curve;
	v.sign = function () {
		var sig = oldSign(key);
		if (typeof (sig) === 'string')
			sig = Buffer.from(sig, 'binary');
		sig = Signature.parse(sig, type, 'asn1');
		sig.hashAlgorithm = hashAlgo;
		sig.curve = curve;
		return (sig);
	};
	return (v);
};

PrivateKey.parse = function (data, format, options) {
	if (typeof (data) !== 'string')
		assert.buffer(data, 'data');
	if (format === undefined)
		format = 'auto';
	assert.string(format, 'format');
	if (typeof (options) === 'string')
		options = { filename: options };
	assert.optionalObject(options, 'options');
	if (options === undefined)
		options = {};
	assert.optionalString(options.filename, 'options.filename');
	if (options.filename === undefined)
		options.filename = '(unnamed)';

	assert.object(formats[format], 'formats[format]');

	try {
		var k = formats[format].read(data, options);
		assert.ok(k instanceof PrivateKey, 'key is not a private key');
		if (!k.comment)
			k.comment = options.filename;
		return (k);
	} catch (e) {
		if (e.name === 'KeyEncryptedError')
			throw (e);
		throw (new KeyParseError(options.filename, format, e));
	}
};

PrivateKey.isPrivateKey = function (obj, ver) {
	return (utils.isCompatible(obj, PrivateKey, ver));
};

PrivateKey.generate = function (type, options) {
	if (options === undefined)
		options = {};
	assert.object(options, 'options');

	switch (type) {
	case 'ecdsa':
		if (options.curve === undefined)
			options.curve = 'nistp256';
		assert.string(options.curve, 'options.curve');
		return (generateECDSA(options.curve));
	case 'ed25519':
		return (generateED25519());
	default:
		throw (new Error('Key generation not supported with key ' +
		    'type "' + type + '"'));
	}
};

/*
 * API versions for PrivateKey:
 * [1,0] -- initial ver
 * [1,1] -- added auto, pkcs[18], openssh/ssh-private formats
 * [1,2] -- added defaultHashAlgorithm
 * [1,3] -- added derive, ed, createDH
 * [1,4] -- first tagged version
 * [1,5] -- changed ed25519 part names and format
 */
PrivateKey.prototype._sshpkApiVersion = [1, 5];

PrivateKey._oldVersionDetect = function (obj) {
	assert.func(obj.toPublic);
	assert.func(obj.createSign);
	if (obj.derive)
		return ([1, 3]);
	if (obj.defaultHashAlgorithm)
		return ([1, 2]);
	if (obj.formats['auto'])
		return ([1, 1]);
	return ([1, 0]);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(225).version;
elliptic.utils = __webpack_require__(226);
elliptic.rand = __webpack_require__(115);
elliptic.curve = __webpack_require__(53);
elliptic.curves = __webpack_require__(231);

// Protocols
elliptic.ec = __webpack_require__(239);
elliptic.eddsa = __webpack_require__(243);


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(62);
var util = __webpack_require__(173);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(48);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(49).EventEmitter;
var inherits = __webpack_require__(0);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(36);
Stream.Writable = __webpack_require__(190);
Stream.Duplex = __webpack_require__(191);
Stream.Transform = __webpack_require__(192);
Stream.PassThrough = __webpack_require__(193);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(15);
var inherits = __webpack_require__(0);

exports.inherits = inherits;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi)
          res.push(hi, lo);
        else
          res.push(lo);
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

var assert = __webpack_require__(3);
var util = __webpack_require__(5);

function FingerprintFormatError(fp, format) {
	if (Error.captureStackTrace)
		Error.captureStackTrace(this, FingerprintFormatError);
	this.name = 'FingerprintFormatError';
	this.fingerprint = fp;
	this.format = format;
	this.message = 'Fingerprint format is not supported, or is invalid: ';
	if (fp !== undefined)
		this.message += ' fingerprint = ' + fp;
	if (format !== undefined)
		this.message += ' format = ' + format;
}
util.inherits(FingerprintFormatError, Error);

function InvalidAlgorithmError(alg) {
	if (Error.captureStackTrace)
		Error.captureStackTrace(this, InvalidAlgorithmError);
	this.name = 'InvalidAlgorithmError';
	this.algorithm = alg;
	this.message = 'Algorithm "' + alg + '" is not supported';
}
util.inherits(InvalidAlgorithmError, Error);

function KeyParseError(name, format, innerErr) {
	if (Error.captureStackTrace)
		Error.captureStackTrace(this, KeyParseError);
	this.name = 'KeyParseError';
	this.format = format;
	this.keyName = name;
	this.innerErr = innerErr;
	this.message = 'Failed to parse ' + name + ' as a valid ' + format +
	    ' format key: ' + innerErr.message;
}
util.inherits(KeyParseError, Error);

function SignatureParseError(type, format, innerErr) {
	if (Error.captureStackTrace)
		Error.captureStackTrace(this, SignatureParseError);
	this.name = 'SignatureParseError';
	this.type = type;
	this.format = format;
	this.innerErr = innerErr;
	this.message = 'Failed to parse the given data as a ' + type +
	    ' signature in ' + format + ' format: ' + innerErr.message;
}
util.inherits(SignatureParseError, Error);

function CertificateParseError(name, format, innerErr) {
	if (Error.captureStackTrace)
		Error.captureStackTrace(this, CertificateParseError);
	this.name = 'CertificateParseError';
	this.format = format;
	this.certName = name;
	this.innerErr = innerErr;
	this.message = 'Failed to parse ' + name + ' as a valid ' + format +
	    ' format certificate: ' + innerErr.message;
}
util.inherits(CertificateParseError, Error);

function KeyEncryptedError(name, format) {
	if (Error.captureStackTrace)
		Error.captureStackTrace(this, KeyEncryptedError);
	this.name = 'KeyEncryptedError';
	this.format = format;
	this.keyName = name;
	this.message = 'The ' + format + ' format key ' + name + ' is ' +
	    'encrypted (password-protected), and no passphrase was ' +
	    'provided in `options`';
}
util.inherits(KeyEncryptedError, Error);

module.exports = {
	FingerprintFormatError: FingerprintFormatError,
	InvalidAlgorithmError: InvalidAlgorithmError,
	KeyParseError: KeyParseError,
	SignatureParseError: SignatureParseError,
	KeyEncryptedError: KeyEncryptedError,
	CertificateParseError: CertificateParseError
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

module.exports = Signature;

var assert = __webpack_require__(3);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var crypto = __webpack_require__(7);
var errs = __webpack_require__(19);
var utils = __webpack_require__(9);
var asn1 = __webpack_require__(22);
var SSHBuffer = __webpack_require__(46);

var InvalidAlgorithmError = errs.InvalidAlgorithmError;
var SignatureParseError = errs.SignatureParseError;

function Signature(opts) {
	assert.object(opts, 'options');
	assert.arrayOfObject(opts.parts, 'options.parts');
	assert.string(opts.type, 'options.type');

	var partLookup = {};
	for (var i = 0; i < opts.parts.length; ++i) {
		var part = opts.parts[i];
		partLookup[part.name] = part;
	}

	this.type = opts.type;
	this.hashAlgorithm = opts.hashAlgo;
	this.curve = opts.curve;
	this.parts = opts.parts;
	this.part = partLookup;
}

Signature.prototype.toBuffer = function (format) {
	if (format === undefined)
		format = 'asn1';
	assert.string(format, 'format');

	var buf;
	var stype = 'ssh-' + this.type;

	switch (this.type) {
	case 'rsa':
		switch (this.hashAlgorithm) {
		case 'sha256':
			stype = 'rsa-sha2-256';
			break;
		case 'sha512':
			stype = 'rsa-sha2-512';
			break;
		case 'sha1':
		case undefined:
			break;
		default:
			throw (new Error('SSH signature ' +
			    'format does not support hash ' +
			    'algorithm ' + this.hashAlgorithm));
		}
		if (format === 'ssh') {
			buf = new SSHBuffer({});
			buf.writeString(stype);
			buf.writePart(this.part.sig);
			return (buf.toBuffer());
		} else {
			return (this.part.sig.data);
		}
		break;

	case 'ed25519':
		if (format === 'ssh') {
			buf = new SSHBuffer({});
			buf.writeString(stype);
			buf.writePart(this.part.sig);
			return (buf.toBuffer());
		} else {
			return (this.part.sig.data);
		}
		break;

	case 'dsa':
	case 'ecdsa':
		var r, s;
		if (format === 'asn1') {
			var der = new asn1.BerWriter();
			der.startSequence();
			r = utils.mpNormalize(this.part.r.data);
			s = utils.mpNormalize(this.part.s.data);
			der.writeBuffer(r, asn1.Ber.Integer);
			der.writeBuffer(s, asn1.Ber.Integer);
			der.endSequence();
			return (der.buffer);
		} else if (format === 'ssh' && this.type === 'dsa') {
			buf = new SSHBuffer({});
			buf.writeString('ssh-dss');
			r = this.part.r.data;
			if (r.length > 20 && r[0] === 0x00)
				r = r.slice(1);
			s = this.part.s.data;
			if (s.length > 20 && s[0] === 0x00)
				s = s.slice(1);
			if ((this.hashAlgorithm &&
			    this.hashAlgorithm !== 'sha1') ||
			    r.length + s.length !== 40) {
				throw (new Error('OpenSSH only supports ' +
				    'DSA signatures with SHA1 hash'));
			}
			buf.writeBuffer(Buffer.concat([r, s]));
			return (buf.toBuffer());
		} else if (format === 'ssh' && this.type === 'ecdsa') {
			var inner = new SSHBuffer({});
			r = this.part.r.data;
			inner.writeBuffer(r);
			inner.writePart(this.part.s);

			buf = new SSHBuffer({});
			/* XXX: find a more proper way to do this? */
			var curve;
			if (r[0] === 0x00)
				r = r.slice(1);
			var sz = r.length * 8;
			if (sz === 256)
				curve = 'nistp256';
			else if (sz === 384)
				curve = 'nistp384';
			else if (sz === 528)
				curve = 'nistp521';
			buf.writeString('ecdsa-sha2-' + curve);
			buf.writeBuffer(inner.toBuffer());
			return (buf.toBuffer());
		}
		throw (new Error('Invalid signature format'));
	default:
		throw (new Error('Invalid signature data'));
	}
};

Signature.prototype.toString = function (format) {
	assert.optionalString(format, 'format');
	return (this.toBuffer(format).toString('base64'));
};

Signature.parse = function (data, type, format) {
	if (typeof (data) === 'string')
		data = Buffer.from(data, 'base64');
	assert.buffer(data, 'data');
	assert.string(format, 'format');
	assert.string(type, 'type');

	var opts = {};
	opts.type = type.toLowerCase();
	opts.parts = [];

	try {
		assert.ok(data.length > 0, 'signature must not be empty');
		switch (opts.type) {
		case 'rsa':
			return (parseOneNum(data, type, format, opts));
		case 'ed25519':
			return (parseOneNum(data, type, format, opts));

		case 'dsa':
		case 'ecdsa':
			if (format === 'asn1')
				return (parseDSAasn1(data, type, format, opts));
			else if (opts.type === 'dsa')
				return (parseDSA(data, type, format, opts));
			else
				return (parseECDSA(data, type, format, opts));

		default:
			throw (new InvalidAlgorithmError(type));
		}

	} catch (e) {
		if (e instanceof InvalidAlgorithmError)
			throw (e);
		throw (new SignatureParseError(type, format, e));
	}
};

function parseOneNum(data, type, format, opts) {
	if (format === 'ssh') {
		try {
			var buf = new SSHBuffer({buffer: data});
			var head = buf.readString();
		} catch (e) {
			/* fall through */
		}
		if (buf !== undefined) {
			var msg = 'SSH signature does not match expected ' +
			    'type (expected ' + type + ', got ' + head + ')';
			switch (head) {
			case 'ssh-rsa':
				assert.strictEqual(type, 'rsa', msg);
				opts.hashAlgo = 'sha1';
				break;
			case 'rsa-sha2-256':
				assert.strictEqual(type, 'rsa', msg);
				opts.hashAlgo = 'sha256';
				break;
			case 'rsa-sha2-512':
				assert.strictEqual(type, 'rsa', msg);
				opts.hashAlgo = 'sha512';
				break;
			case 'ssh-ed25519':
				assert.strictEqual(type, 'ed25519', msg);
				opts.hashAlgo = 'sha512';
				break;
			default:
				throw (new Error('Unknown SSH signature ' +
				    'type: ' + head));
			}
			var sig = buf.readPart();
			assert.ok(buf.atEnd(), 'extra trailing bytes');
			sig.name = 'sig';
			opts.parts.push(sig);
			return (new Signature(opts));
		}
	}
	opts.parts.push({name: 'sig', data: data});
	return (new Signature(opts));
}

function parseDSAasn1(data, type, format, opts) {
	var der = new asn1.BerReader(data);
	der.readSequence();
	var r = der.readString(asn1.Ber.Integer, true);
	var s = der.readString(asn1.Ber.Integer, true);

	opts.parts.push({name: 'r', data: utils.mpNormalize(r)});
	opts.parts.push({name: 's', data: utils.mpNormalize(s)});

	return (new Signature(opts));
}

function parseDSA(data, type, format, opts) {
	if (data.length != 40) {
		var buf = new SSHBuffer({buffer: data});
		var d = buf.readBuffer();
		if (d.toString('ascii') === 'ssh-dss')
			d = buf.readBuffer();
		assert.ok(buf.atEnd(), 'extra trailing bytes');
		assert.strictEqual(d.length, 40, 'invalid inner length');
		data = d;
	}
	opts.parts.push({name: 'r', data: data.slice(0, 20)});
	opts.parts.push({name: 's', data: data.slice(20, 40)});
	return (new Signature(opts));
}

function parseECDSA(data, type, format, opts) {
	var buf = new SSHBuffer({buffer: data});

	var r, s;
	var inner = buf.readBuffer();
	var stype = inner.toString('ascii');
	if (stype.slice(0, 6) === 'ecdsa-') {
		var parts = stype.split('-');
		assert.strictEqual(parts[0], 'ecdsa');
		assert.strictEqual(parts[1], 'sha2');
		opts.curve = parts[2];
		switch (opts.curve) {
		case 'nistp256':
			opts.hashAlgo = 'sha256';
			break;
		case 'nistp384':
			opts.hashAlgo = 'sha384';
			break;
		case 'nistp521':
			opts.hashAlgo = 'sha512';
			break;
		default:
			throw (new Error('Unsupported ECDSA curve: ' +
			    opts.curve));
		}
		inner = buf.readBuffer();
		assert.ok(buf.atEnd(), 'extra trailing bytes on outer');
		buf = new SSHBuffer({buffer: inner});
		r = buf.readPart();
	} else {
		r = {data: inner};
	}

	s = buf.readPart();
	assert.ok(buf.atEnd(), 'extra trailing bytes');

	r.name = 'r';
	s.name = 's';

	opts.parts.push(r);
	opts.parts.push(s);
	return (new Signature(opts));
}

Signature.isSignature = function (obj, ver) {
	return (utils.isCompatible(obj, Signature, ver));
};

/*
 * API versions for Signature:
 * [1,0] -- initial ver
 * [2,0] -- support for rsa in full ssh format, compat with sshpk-agent
 *          hashAlgorithm property
 * [2,1] -- first tagged version
 */
Signature.prototype._sshpkApiVersion = [2, 1];

Signature._oldVersionDetect = function (obj) {
	assert.func(obj.toBuffer);
	if (obj.hasOwnProperty('hashAlgorithm'))
		return ([2, 0]);
	return ([1, 0]);
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

(function(nacl) {
'use strict';

// Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
// Public domain.
//
// Implementation derived from TweetNaCl version 20140427.
// See for details: http://tweetnacl.cr.yp.to/

var gf = function(init) {
  var i, r = new Float64Array(16);
  if (init) for (i = 0; i < init.length; i++) r[i] = init[i];
  return r;
};

//  Pluggable, initialized in high-level API below.
var randombytes = function(/* x, n */) { throw new Error('no PRNG'); };

var _0 = new Uint8Array(16);
var _9 = new Uint8Array(32); _9[0] = 9;

var gf0 = gf(),
    gf1 = gf([1]),
    _121665 = gf([0xdb41, 1]),
    D = gf([0x78a3, 0x1359, 0x4dca, 0x75eb, 0xd8ab, 0x4141, 0x0a4d, 0x0070, 0xe898, 0x7779, 0x4079, 0x8cc7, 0xfe73, 0x2b6f, 0x6cee, 0x5203]),
    D2 = gf([0xf159, 0x26b2, 0x9b94, 0xebd6, 0xb156, 0x8283, 0x149a, 0x00e0, 0xd130, 0xeef3, 0x80f2, 0x198e, 0xfce7, 0x56df, 0xd9dc, 0x2406]),
    X = gf([0xd51a, 0x8f25, 0x2d60, 0xc956, 0xa7b2, 0x9525, 0xc760, 0x692c, 0xdc5c, 0xfdd6, 0xe231, 0xc0a4, 0x53fe, 0xcd6e, 0x36d3, 0x2169]),
    Y = gf([0x6658, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666]),
    I = gf([0xa0b0, 0x4a0e, 0x1b27, 0xc4ee, 0xe478, 0xad2f, 0x1806, 0x2f43, 0xd7a7, 0x3dfb, 0x0099, 0x2b4d, 0xdf0b, 0x4fc1, 0x2480, 0x2b83]);

function ts64(x, i, h, l) {
  x[i]   = (h >> 24) & 0xff;
  x[i+1] = (h >> 16) & 0xff;
  x[i+2] = (h >>  8) & 0xff;
  x[i+3] = h & 0xff;
  x[i+4] = (l >> 24)  & 0xff;
  x[i+5] = (l >> 16)  & 0xff;
  x[i+6] = (l >>  8)  & 0xff;
  x[i+7] = l & 0xff;
}

function vn(x, xi, y, yi, n) {
  var i,d = 0;
  for (i = 0; i < n; i++) d |= x[xi+i]^y[yi+i];
  return (1 & ((d - 1) >>> 8)) - 1;
}

function crypto_verify_16(x, xi, y, yi) {
  return vn(x,xi,y,yi,16);
}

function crypto_verify_32(x, xi, y, yi) {
  return vn(x,xi,y,yi,32);
}

function core_salsa20(o, p, k, c) {
  var j0  = c[ 0] & 0xff | (c[ 1] & 0xff)<<8 | (c[ 2] & 0xff)<<16 | (c[ 3] & 0xff)<<24,
      j1  = k[ 0] & 0xff | (k[ 1] & 0xff)<<8 | (k[ 2] & 0xff)<<16 | (k[ 3] & 0xff)<<24,
      j2  = k[ 4] & 0xff | (k[ 5] & 0xff)<<8 | (k[ 6] & 0xff)<<16 | (k[ 7] & 0xff)<<24,
      j3  = k[ 8] & 0xff | (k[ 9] & 0xff)<<8 | (k[10] & 0xff)<<16 | (k[11] & 0xff)<<24,
      j4  = k[12] & 0xff | (k[13] & 0xff)<<8 | (k[14] & 0xff)<<16 | (k[15] & 0xff)<<24,
      j5  = c[ 4] & 0xff | (c[ 5] & 0xff)<<8 | (c[ 6] & 0xff)<<16 | (c[ 7] & 0xff)<<24,
      j6  = p[ 0] & 0xff | (p[ 1] & 0xff)<<8 | (p[ 2] & 0xff)<<16 | (p[ 3] & 0xff)<<24,
      j7  = p[ 4] & 0xff | (p[ 5] & 0xff)<<8 | (p[ 6] & 0xff)<<16 | (p[ 7] & 0xff)<<24,
      j8  = p[ 8] & 0xff | (p[ 9] & 0xff)<<8 | (p[10] & 0xff)<<16 | (p[11] & 0xff)<<24,
      j9  = p[12] & 0xff | (p[13] & 0xff)<<8 | (p[14] & 0xff)<<16 | (p[15] & 0xff)<<24,
      j10 = c[ 8] & 0xff | (c[ 9] & 0xff)<<8 | (c[10] & 0xff)<<16 | (c[11] & 0xff)<<24,
      j11 = k[16] & 0xff | (k[17] & 0xff)<<8 | (k[18] & 0xff)<<16 | (k[19] & 0xff)<<24,
      j12 = k[20] & 0xff | (k[21] & 0xff)<<8 | (k[22] & 0xff)<<16 | (k[23] & 0xff)<<24,
      j13 = k[24] & 0xff | (k[25] & 0xff)<<8 | (k[26] & 0xff)<<16 | (k[27] & 0xff)<<24,
      j14 = k[28] & 0xff | (k[29] & 0xff)<<8 | (k[30] & 0xff)<<16 | (k[31] & 0xff)<<24,
      j15 = c[12] & 0xff | (c[13] & 0xff)<<8 | (c[14] & 0xff)<<16 | (c[15] & 0xff)<<24;

  var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7,
      x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14,
      x15 = j15, u;

  for (var i = 0; i < 20; i += 2) {
    u = x0 + x12 | 0;
    x4 ^= u<<7 | u>>>(32-7);
    u = x4 + x0 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x4 | 0;
    x12 ^= u<<13 | u>>>(32-13);
    u = x12 + x8 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x1 | 0;
    x9 ^= u<<7 | u>>>(32-7);
    u = x9 + x5 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x9 | 0;
    x1 ^= u<<13 | u>>>(32-13);
    u = x1 + x13 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x6 | 0;
    x14 ^= u<<7 | u>>>(32-7);
    u = x14 + x10 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x14 | 0;
    x6 ^= u<<13 | u>>>(32-13);
    u = x6 + x2 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x11 | 0;
    x3 ^= u<<7 | u>>>(32-7);
    u = x3 + x15 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x3 | 0;
    x11 ^= u<<13 | u>>>(32-13);
    u = x11 + x7 | 0;
    x15 ^= u<<18 | u>>>(32-18);

    u = x0 + x3 | 0;
    x1 ^= u<<7 | u>>>(32-7);
    u = x1 + x0 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x1 | 0;
    x3 ^= u<<13 | u>>>(32-13);
    u = x3 + x2 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x4 | 0;
    x6 ^= u<<7 | u>>>(32-7);
    u = x6 + x5 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x6 | 0;
    x4 ^= u<<13 | u>>>(32-13);
    u = x4 + x7 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x9 | 0;
    x11 ^= u<<7 | u>>>(32-7);
    u = x11 + x10 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x11 | 0;
    x9 ^= u<<13 | u>>>(32-13);
    u = x9 + x8 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x14 | 0;
    x12 ^= u<<7 | u>>>(32-7);
    u = x12 + x15 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x12 | 0;
    x14 ^= u<<13 | u>>>(32-13);
    u = x14 + x13 | 0;
    x15 ^= u<<18 | u>>>(32-18);
  }
   x0 =  x0 +  j0 | 0;
   x1 =  x1 +  j1 | 0;
   x2 =  x2 +  j2 | 0;
   x3 =  x3 +  j3 | 0;
   x4 =  x4 +  j4 | 0;
   x5 =  x5 +  j5 | 0;
   x6 =  x6 +  j6 | 0;
   x7 =  x7 +  j7 | 0;
   x8 =  x8 +  j8 | 0;
   x9 =  x9 +  j9 | 0;
  x10 = x10 + j10 | 0;
  x11 = x11 + j11 | 0;
  x12 = x12 + j12 | 0;
  x13 = x13 + j13 | 0;
  x14 = x14 + j14 | 0;
  x15 = x15 + j15 | 0;

  o[ 0] = x0 >>>  0 & 0xff;
  o[ 1] = x0 >>>  8 & 0xff;
  o[ 2] = x0 >>> 16 & 0xff;
  o[ 3] = x0 >>> 24 & 0xff;

  o[ 4] = x1 >>>  0 & 0xff;
  o[ 5] = x1 >>>  8 & 0xff;
  o[ 6] = x1 >>> 16 & 0xff;
  o[ 7] = x1 >>> 24 & 0xff;

  o[ 8] = x2 >>>  0 & 0xff;
  o[ 9] = x2 >>>  8 & 0xff;
  o[10] = x2 >>> 16 & 0xff;
  o[11] = x2 >>> 24 & 0xff;

  o[12] = x3 >>>  0 & 0xff;
  o[13] = x3 >>>  8 & 0xff;
  o[14] = x3 >>> 16 & 0xff;
  o[15] = x3 >>> 24 & 0xff;

  o[16] = x4 >>>  0 & 0xff;
  o[17] = x4 >>>  8 & 0xff;
  o[18] = x4 >>> 16 & 0xff;
  o[19] = x4 >>> 24 & 0xff;

  o[20] = x5 >>>  0 & 0xff;
  o[21] = x5 >>>  8 & 0xff;
  o[22] = x5 >>> 16 & 0xff;
  o[23] = x5 >>> 24 & 0xff;

  o[24] = x6 >>>  0 & 0xff;
  o[25] = x6 >>>  8 & 0xff;
  o[26] = x6 >>> 16 & 0xff;
  o[27] = x6 >>> 24 & 0xff;

  o[28] = x7 >>>  0 & 0xff;
  o[29] = x7 >>>  8 & 0xff;
  o[30] = x7 >>> 16 & 0xff;
  o[31] = x7 >>> 24 & 0xff;

  o[32] = x8 >>>  0 & 0xff;
  o[33] = x8 >>>  8 & 0xff;
  o[34] = x8 >>> 16 & 0xff;
  o[35] = x8 >>> 24 & 0xff;

  o[36] = x9 >>>  0 & 0xff;
  o[37] = x9 >>>  8 & 0xff;
  o[38] = x9 >>> 16 & 0xff;
  o[39] = x9 >>> 24 & 0xff;

  o[40] = x10 >>>  0 & 0xff;
  o[41] = x10 >>>  8 & 0xff;
  o[42] = x10 >>> 16 & 0xff;
  o[43] = x10 >>> 24 & 0xff;

  o[44] = x11 >>>  0 & 0xff;
  o[45] = x11 >>>  8 & 0xff;
  o[46] = x11 >>> 16 & 0xff;
  o[47] = x11 >>> 24 & 0xff;

  o[48] = x12 >>>  0 & 0xff;
  o[49] = x12 >>>  8 & 0xff;
  o[50] = x12 >>> 16 & 0xff;
  o[51] = x12 >>> 24 & 0xff;

  o[52] = x13 >>>  0 & 0xff;
  o[53] = x13 >>>  8 & 0xff;
  o[54] = x13 >>> 16 & 0xff;
  o[55] = x13 >>> 24 & 0xff;

  o[56] = x14 >>>  0 & 0xff;
  o[57] = x14 >>>  8 & 0xff;
  o[58] = x14 >>> 16 & 0xff;
  o[59] = x14 >>> 24 & 0xff;

  o[60] = x15 >>>  0 & 0xff;
  o[61] = x15 >>>  8 & 0xff;
  o[62] = x15 >>> 16 & 0xff;
  o[63] = x15 >>> 24 & 0xff;
}

function core_hsalsa20(o,p,k,c) {
  var j0  = c[ 0] & 0xff | (c[ 1] & 0xff)<<8 | (c[ 2] & 0xff)<<16 | (c[ 3] & 0xff)<<24,
      j1  = k[ 0] & 0xff | (k[ 1] & 0xff)<<8 | (k[ 2] & 0xff)<<16 | (k[ 3] & 0xff)<<24,
      j2  = k[ 4] & 0xff | (k[ 5] & 0xff)<<8 | (k[ 6] & 0xff)<<16 | (k[ 7] & 0xff)<<24,
      j3  = k[ 8] & 0xff | (k[ 9] & 0xff)<<8 | (k[10] & 0xff)<<16 | (k[11] & 0xff)<<24,
      j4  = k[12] & 0xff | (k[13] & 0xff)<<8 | (k[14] & 0xff)<<16 | (k[15] & 0xff)<<24,
      j5  = c[ 4] & 0xff | (c[ 5] & 0xff)<<8 | (c[ 6] & 0xff)<<16 | (c[ 7] & 0xff)<<24,
      j6  = p[ 0] & 0xff | (p[ 1] & 0xff)<<8 | (p[ 2] & 0xff)<<16 | (p[ 3] & 0xff)<<24,
      j7  = p[ 4] & 0xff | (p[ 5] & 0xff)<<8 | (p[ 6] & 0xff)<<16 | (p[ 7] & 0xff)<<24,
      j8  = p[ 8] & 0xff | (p[ 9] & 0xff)<<8 | (p[10] & 0xff)<<16 | (p[11] & 0xff)<<24,
      j9  = p[12] & 0xff | (p[13] & 0xff)<<8 | (p[14] & 0xff)<<16 | (p[15] & 0xff)<<24,
      j10 = c[ 8] & 0xff | (c[ 9] & 0xff)<<8 | (c[10] & 0xff)<<16 | (c[11] & 0xff)<<24,
      j11 = k[16] & 0xff | (k[17] & 0xff)<<8 | (k[18] & 0xff)<<16 | (k[19] & 0xff)<<24,
      j12 = k[20] & 0xff | (k[21] & 0xff)<<8 | (k[22] & 0xff)<<16 | (k[23] & 0xff)<<24,
      j13 = k[24] & 0xff | (k[25] & 0xff)<<8 | (k[26] & 0xff)<<16 | (k[27] & 0xff)<<24,
      j14 = k[28] & 0xff | (k[29] & 0xff)<<8 | (k[30] & 0xff)<<16 | (k[31] & 0xff)<<24,
      j15 = c[12] & 0xff | (c[13] & 0xff)<<8 | (c[14] & 0xff)<<16 | (c[15] & 0xff)<<24;

  var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7,
      x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14,
      x15 = j15, u;

  for (var i = 0; i < 20; i += 2) {
    u = x0 + x12 | 0;
    x4 ^= u<<7 | u>>>(32-7);
    u = x4 + x0 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x4 | 0;
    x12 ^= u<<13 | u>>>(32-13);
    u = x12 + x8 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x1 | 0;
    x9 ^= u<<7 | u>>>(32-7);
    u = x9 + x5 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x9 | 0;
    x1 ^= u<<13 | u>>>(32-13);
    u = x1 + x13 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x6 | 0;
    x14 ^= u<<7 | u>>>(32-7);
    u = x14 + x10 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x14 | 0;
    x6 ^= u<<13 | u>>>(32-13);
    u = x6 + x2 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x11 | 0;
    x3 ^= u<<7 | u>>>(32-7);
    u = x3 + x15 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x3 | 0;
    x11 ^= u<<13 | u>>>(32-13);
    u = x11 + x7 | 0;
    x15 ^= u<<18 | u>>>(32-18);

    u = x0 + x3 | 0;
    x1 ^= u<<7 | u>>>(32-7);
    u = x1 + x0 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x1 | 0;
    x3 ^= u<<13 | u>>>(32-13);
    u = x3 + x2 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x4 | 0;
    x6 ^= u<<7 | u>>>(32-7);
    u = x6 + x5 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x6 | 0;
    x4 ^= u<<13 | u>>>(32-13);
    u = x4 + x7 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x9 | 0;
    x11 ^= u<<7 | u>>>(32-7);
    u = x11 + x10 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x11 | 0;
    x9 ^= u<<13 | u>>>(32-13);
    u = x9 + x8 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x14 | 0;
    x12 ^= u<<7 | u>>>(32-7);
    u = x12 + x15 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x12 | 0;
    x14 ^= u<<13 | u>>>(32-13);
    u = x14 + x13 | 0;
    x15 ^= u<<18 | u>>>(32-18);
  }

  o[ 0] = x0 >>>  0 & 0xff;
  o[ 1] = x0 >>>  8 & 0xff;
  o[ 2] = x0 >>> 16 & 0xff;
  o[ 3] = x0 >>> 24 & 0xff;

  o[ 4] = x5 >>>  0 & 0xff;
  o[ 5] = x5 >>>  8 & 0xff;
  o[ 6] = x5 >>> 16 & 0xff;
  o[ 7] = x5 >>> 24 & 0xff;

  o[ 8] = x10 >>>  0 & 0xff;
  o[ 9] = x10 >>>  8 & 0xff;
  o[10] = x10 >>> 16 & 0xff;
  o[11] = x10 >>> 24 & 0xff;

  o[12] = x15 >>>  0 & 0xff;
  o[13] = x15 >>>  8 & 0xff;
  o[14] = x15 >>> 16 & 0xff;
  o[15] = x15 >>> 24 & 0xff;

  o[16] = x6 >>>  0 & 0xff;
  o[17] = x6 >>>  8 & 0xff;
  o[18] = x6 >>> 16 & 0xff;
  o[19] = x6 >>> 24 & 0xff;

  o[20] = x7 >>>  0 & 0xff;
  o[21] = x7 >>>  8 & 0xff;
  o[22] = x7 >>> 16 & 0xff;
  o[23] = x7 >>> 24 & 0xff;

  o[24] = x8 >>>  0 & 0xff;
  o[25] = x8 >>>  8 & 0xff;
  o[26] = x8 >>> 16 & 0xff;
  o[27] = x8 >>> 24 & 0xff;

  o[28] = x9 >>>  0 & 0xff;
  o[29] = x9 >>>  8 & 0xff;
  o[30] = x9 >>> 16 & 0xff;
  o[31] = x9 >>> 24 & 0xff;
}

function crypto_core_salsa20(out,inp,k,c) {
  core_salsa20(out,inp,k,c);
}

function crypto_core_hsalsa20(out,inp,k,c) {
  core_hsalsa20(out,inp,k,c);
}

var sigma = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
            // "expand 32-byte k"

function crypto_stream_salsa20_xor(c,cpos,m,mpos,b,n,k) {
  var z = new Uint8Array(16), x = new Uint8Array(64);
  var u, i;
  for (i = 0; i < 16; i++) z[i] = 0;
  for (i = 0; i < 8; i++) z[i] = n[i];
  while (b >= 64) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < 64; i++) c[cpos+i] = m[mpos+i] ^ x[i];
    u = 1;
    for (i = 8; i < 16; i++) {
      u = u + (z[i] & 0xff) | 0;
      z[i] = u & 0xff;
      u >>>= 8;
    }
    b -= 64;
    cpos += 64;
    mpos += 64;
  }
  if (b > 0) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < b; i++) c[cpos+i] = m[mpos+i] ^ x[i];
  }
  return 0;
}

function crypto_stream_salsa20(c,cpos,b,n,k) {
  var z = new Uint8Array(16), x = new Uint8Array(64);
  var u, i;
  for (i = 0; i < 16; i++) z[i] = 0;
  for (i = 0; i < 8; i++) z[i] = n[i];
  while (b >= 64) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < 64; i++) c[cpos+i] = x[i];
    u = 1;
    for (i = 8; i < 16; i++) {
      u = u + (z[i] & 0xff) | 0;
      z[i] = u & 0xff;
      u >>>= 8;
    }
    b -= 64;
    cpos += 64;
  }
  if (b > 0) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < b; i++) c[cpos+i] = x[i];
  }
  return 0;
}

function crypto_stream(c,cpos,d,n,k) {
  var s = new Uint8Array(32);
  crypto_core_hsalsa20(s,n,k,sigma);
  var sn = new Uint8Array(8);
  for (var i = 0; i < 8; i++) sn[i] = n[i+16];
  return crypto_stream_salsa20(c,cpos,d,sn,s);
}

function crypto_stream_xor(c,cpos,m,mpos,d,n,k) {
  var s = new Uint8Array(32);
  crypto_core_hsalsa20(s,n,k,sigma);
  var sn = new Uint8Array(8);
  for (var i = 0; i < 8; i++) sn[i] = n[i+16];
  return crypto_stream_salsa20_xor(c,cpos,m,mpos,d,sn,s);
}

/*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/

var poly1305 = function(key) {
  this.buffer = new Uint8Array(16);
  this.r = new Uint16Array(10);
  this.h = new Uint16Array(10);
  this.pad = new Uint16Array(8);
  this.leftover = 0;
  this.fin = 0;

  var t0, t1, t2, t3, t4, t5, t6, t7;

  t0 = key[ 0] & 0xff | (key[ 1] & 0xff) << 8; this.r[0] = ( t0                     ) & 0x1fff;
  t1 = key[ 2] & 0xff | (key[ 3] & 0xff) << 8; this.r[1] = ((t0 >>> 13) | (t1 <<  3)) & 0x1fff;
  t2 = key[ 4] & 0xff | (key[ 5] & 0xff) << 8; this.r[2] = ((t1 >>> 10) | (t2 <<  6)) & 0x1f03;
  t3 = key[ 6] & 0xff | (key[ 7] & 0xff) << 8; this.r[3] = ((t2 >>>  7) | (t3 <<  9)) & 0x1fff;
  t4 = key[ 8] & 0xff | (key[ 9] & 0xff) << 8; this.r[4] = ((t3 >>>  4) | (t4 << 12)) & 0x00ff;
  this.r[5] = ((t4 >>>  1)) & 0x1ffe;
  t5 = key[10] & 0xff | (key[11] & 0xff) << 8; this.r[6] = ((t4 >>> 14) | (t5 <<  2)) & 0x1fff;
  t6 = key[12] & 0xff | (key[13] & 0xff) << 8; this.r[7] = ((t5 >>> 11) | (t6 <<  5)) & 0x1f81;
  t7 = key[14] & 0xff | (key[15] & 0xff) << 8; this.r[8] = ((t6 >>>  8) | (t7 <<  8)) & 0x1fff;
  this.r[9] = ((t7 >>>  5)) & 0x007f;

  this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
  this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
  this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
  this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
  this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
  this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
  this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
  this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
};

poly1305.prototype.blocks = function(m, mpos, bytes) {
  var hibit = this.fin ? 0 : (1 << 11);
  var t0, t1, t2, t3, t4, t5, t6, t7, c;
  var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;

  var h0 = this.h[0],
      h1 = this.h[1],
      h2 = this.h[2],
      h3 = this.h[3],
      h4 = this.h[4],
      h5 = this.h[5],
      h6 = this.h[6],
      h7 = this.h[7],
      h8 = this.h[8],
      h9 = this.h[9];

  var r0 = this.r[0],
      r1 = this.r[1],
      r2 = this.r[2],
      r3 = this.r[3],
      r4 = this.r[4],
      r5 = this.r[5],
      r6 = this.r[6],
      r7 = this.r[7],
      r8 = this.r[8],
      r9 = this.r[9];

  while (bytes >= 16) {
    t0 = m[mpos+ 0] & 0xff | (m[mpos+ 1] & 0xff) << 8; h0 += ( t0                     ) & 0x1fff;
    t1 = m[mpos+ 2] & 0xff | (m[mpos+ 3] & 0xff) << 8; h1 += ((t0 >>> 13) | (t1 <<  3)) & 0x1fff;
    t2 = m[mpos+ 4] & 0xff | (m[mpos+ 5] & 0xff) << 8; h2 += ((t1 >>> 10) | (t2 <<  6)) & 0x1fff;
    t3 = m[mpos+ 6] & 0xff | (m[mpos+ 7] & 0xff) << 8; h3 += ((t2 >>>  7) | (t3 <<  9)) & 0x1fff;
    t4 = m[mpos+ 8] & 0xff | (m[mpos+ 9] & 0xff) << 8; h4 += ((t3 >>>  4) | (t4 << 12)) & 0x1fff;
    h5 += ((t4 >>>  1)) & 0x1fff;
    t5 = m[mpos+10] & 0xff | (m[mpos+11] & 0xff) << 8; h6 += ((t4 >>> 14) | (t5 <<  2)) & 0x1fff;
    t6 = m[mpos+12] & 0xff | (m[mpos+13] & 0xff) << 8; h7 += ((t5 >>> 11) | (t6 <<  5)) & 0x1fff;
    t7 = m[mpos+14] & 0xff | (m[mpos+15] & 0xff) << 8; h8 += ((t6 >>>  8) | (t7 <<  8)) & 0x1fff;
    h9 += ((t7 >>> 5)) | hibit;

    c = 0;

    d0 = c;
    d0 += h0 * r0;
    d0 += h1 * (5 * r9);
    d0 += h2 * (5 * r8);
    d0 += h3 * (5 * r7);
    d0 += h4 * (5 * r6);
    c = (d0 >>> 13); d0 &= 0x1fff;
    d0 += h5 * (5 * r5);
    d0 += h6 * (5 * r4);
    d0 += h7 * (5 * r3);
    d0 += h8 * (5 * r2);
    d0 += h9 * (5 * r1);
    c += (d0 >>> 13); d0 &= 0x1fff;

    d1 = c;
    d1 += h0 * r1;
    d1 += h1 * r0;
    d1 += h2 * (5 * r9);
    d1 += h3 * (5 * r8);
    d1 += h4 * (5 * r7);
    c = (d1 >>> 13); d1 &= 0x1fff;
    d1 += h5 * (5 * r6);
    d1 += h6 * (5 * r5);
    d1 += h7 * (5 * r4);
    d1 += h8 * (5 * r3);
    d1 += h9 * (5 * r2);
    c += (d1 >>> 13); d1 &= 0x1fff;

    d2 = c;
    d2 += h0 * r2;
    d2 += h1 * r1;
    d2 += h2 * r0;
    d2 += h3 * (5 * r9);
    d2 += h4 * (5 * r8);
    c = (d2 >>> 13); d2 &= 0x1fff;
    d2 += h5 * (5 * r7);
    d2 += h6 * (5 * r6);
    d2 += h7 * (5 * r5);
    d2 += h8 * (5 * r4);
    d2 += h9 * (5 * r3);
    c += (d2 >>> 13); d2 &= 0x1fff;

    d3 = c;
    d3 += h0 * r3;
    d3 += h1 * r2;
    d3 += h2 * r1;
    d3 += h3 * r0;
    d3 += h4 * (5 * r9);
    c = (d3 >>> 13); d3 &= 0x1fff;
    d3 += h5 * (5 * r8);
    d3 += h6 * (5 * r7);
    d3 += h7 * (5 * r6);
    d3 += h8 * (5 * r5);
    d3 += h9 * (5 * r4);
    c += (d3 >>> 13); d3 &= 0x1fff;

    d4 = c;
    d4 += h0 * r4;
    d4 += h1 * r3;
    d4 += h2 * r2;
    d4 += h3 * r1;
    d4 += h4 * r0;
    c = (d4 >>> 13); d4 &= 0x1fff;
    d4 += h5 * (5 * r9);
    d4 += h6 * (5 * r8);
    d4 += h7 * (5 * r7);
    d4 += h8 * (5 * r6);
    d4 += h9 * (5 * r5);
    c += (d4 >>> 13); d4 &= 0x1fff;

    d5 = c;
    d5 += h0 * r5;
    d5 += h1 * r4;
    d5 += h2 * r3;
    d5 += h3 * r2;
    d5 += h4 * r1;
    c = (d5 >>> 13); d5 &= 0x1fff;
    d5 += h5 * r0;
    d5 += h6 * (5 * r9);
    d5 += h7 * (5 * r8);
    d5 += h8 * (5 * r7);
    d5 += h9 * (5 * r6);
    c += (d5 >>> 13); d5 &= 0x1fff;

    d6 = c;
    d6 += h0 * r6;
    d6 += h1 * r5;
    d6 += h2 * r4;
    d6 += h3 * r3;
    d6 += h4 * r2;
    c = (d6 >>> 13); d6 &= 0x1fff;
    d6 += h5 * r1;
    d6 += h6 * r0;
    d6 += h7 * (5 * r9);
    d6 += h8 * (5 * r8);
    d6 += h9 * (5 * r7);
    c += (d6 >>> 13); d6 &= 0x1fff;

    d7 = c;
    d7 += h0 * r7;
    d7 += h1 * r6;
    d7 += h2 * r5;
    d7 += h3 * r4;
    d7 += h4 * r3;
    c = (d7 >>> 13); d7 &= 0x1fff;
    d7 += h5 * r2;
    d7 += h6 * r1;
    d7 += h7 * r0;
    d7 += h8 * (5 * r9);
    d7 += h9 * (5 * r8);
    c += (d7 >>> 13); d7 &= 0x1fff;

    d8 = c;
    d8 += h0 * r8;
    d8 += h1 * r7;
    d8 += h2 * r6;
    d8 += h3 * r5;
    d8 += h4 * r4;
    c = (d8 >>> 13); d8 &= 0x1fff;
    d8 += h5 * r3;
    d8 += h6 * r2;
    d8 += h7 * r1;
    d8 += h8 * r0;
    d8 += h9 * (5 * r9);
    c += (d8 >>> 13); d8 &= 0x1fff;

    d9 = c;
    d9 += h0 * r9;
    d9 += h1 * r8;
    d9 += h2 * r7;
    d9 += h3 * r6;
    d9 += h4 * r5;
    c = (d9 >>> 13); d9 &= 0x1fff;
    d9 += h5 * r4;
    d9 += h6 * r3;
    d9 += h7 * r2;
    d9 += h8 * r1;
    d9 += h9 * r0;
    c += (d9 >>> 13); d9 &= 0x1fff;

    c = (((c << 2) + c)) | 0;
    c = (c + d0) | 0;
    d0 = c & 0x1fff;
    c = (c >>> 13);
    d1 += c;

    h0 = d0;
    h1 = d1;
    h2 = d2;
    h3 = d3;
    h4 = d4;
    h5 = d5;
    h6 = d6;
    h7 = d7;
    h8 = d8;
    h9 = d9;

    mpos += 16;
    bytes -= 16;
  }
  this.h[0] = h0;
  this.h[1] = h1;
  this.h[2] = h2;
  this.h[3] = h3;
  this.h[4] = h4;
  this.h[5] = h5;
  this.h[6] = h6;
  this.h[7] = h7;
  this.h[8] = h8;
  this.h[9] = h9;
};

poly1305.prototype.finish = function(mac, macpos) {
  var g = new Uint16Array(10);
  var c, mask, f, i;

  if (this.leftover) {
    i = this.leftover;
    this.buffer[i++] = 1;
    for (; i < 16; i++) this.buffer[i] = 0;
    this.fin = 1;
    this.blocks(this.buffer, 0, 16);
  }

  c = this.h[1] >>> 13;
  this.h[1] &= 0x1fff;
  for (i = 2; i < 10; i++) {
    this.h[i] += c;
    c = this.h[i] >>> 13;
    this.h[i] &= 0x1fff;
  }
  this.h[0] += (c * 5);
  c = this.h[0] >>> 13;
  this.h[0] &= 0x1fff;
  this.h[1] += c;
  c = this.h[1] >>> 13;
  this.h[1] &= 0x1fff;
  this.h[2] += c;

  g[0] = this.h[0] + 5;
  c = g[0] >>> 13;
  g[0] &= 0x1fff;
  for (i = 1; i < 10; i++) {
    g[i] = this.h[i] + c;
    c = g[i] >>> 13;
    g[i] &= 0x1fff;
  }
  g[9] -= (1 << 13);

  mask = (c ^ 1) - 1;
  for (i = 0; i < 10; i++) g[i] &= mask;
  mask = ~mask;
  for (i = 0; i < 10; i++) this.h[i] = (this.h[i] & mask) | g[i];

  this.h[0] = ((this.h[0]       ) | (this.h[1] << 13)                    ) & 0xffff;
  this.h[1] = ((this.h[1] >>>  3) | (this.h[2] << 10)                    ) & 0xffff;
  this.h[2] = ((this.h[2] >>>  6) | (this.h[3] <<  7)                    ) & 0xffff;
  this.h[3] = ((this.h[3] >>>  9) | (this.h[4] <<  4)                    ) & 0xffff;
  this.h[4] = ((this.h[4] >>> 12) | (this.h[5] <<  1) | (this.h[6] << 14)) & 0xffff;
  this.h[5] = ((this.h[6] >>>  2) | (this.h[7] << 11)                    ) & 0xffff;
  this.h[6] = ((this.h[7] >>>  5) | (this.h[8] <<  8)                    ) & 0xffff;
  this.h[7] = ((this.h[8] >>>  8) | (this.h[9] <<  5)                    ) & 0xffff;

  f = this.h[0] + this.pad[0];
  this.h[0] = f & 0xffff;
  for (i = 1; i < 8; i++) {
    f = (((this.h[i] + this.pad[i]) | 0) + (f >>> 16)) | 0;
    this.h[i] = f & 0xffff;
  }

  mac[macpos+ 0] = (this.h[0] >>> 0) & 0xff;
  mac[macpos+ 1] = (this.h[0] >>> 8) & 0xff;
  mac[macpos+ 2] = (this.h[1] >>> 0) & 0xff;
  mac[macpos+ 3] = (this.h[1] >>> 8) & 0xff;
  mac[macpos+ 4] = (this.h[2] >>> 0) & 0xff;
  mac[macpos+ 5] = (this.h[2] >>> 8) & 0xff;
  mac[macpos+ 6] = (this.h[3] >>> 0) & 0xff;
  mac[macpos+ 7] = (this.h[3] >>> 8) & 0xff;
  mac[macpos+ 8] = (this.h[4] >>> 0) & 0xff;
  mac[macpos+ 9] = (this.h[4] >>> 8) & 0xff;
  mac[macpos+10] = (this.h[5] >>> 0) & 0xff;
  mac[macpos+11] = (this.h[5] >>> 8) & 0xff;
  mac[macpos+12] = (this.h[6] >>> 0) & 0xff;
  mac[macpos+13] = (this.h[6] >>> 8) & 0xff;
  mac[macpos+14] = (this.h[7] >>> 0) & 0xff;
  mac[macpos+15] = (this.h[7] >>> 8) & 0xff;
};

poly1305.prototype.update = function(m, mpos, bytes) {
  var i, want;

  if (this.leftover) {
    want = (16 - this.leftover);
    if (want > bytes)
      want = bytes;
    for (i = 0; i < want; i++)
      this.buffer[this.leftover + i] = m[mpos+i];
    bytes -= want;
    mpos += want;
    this.leftover += want;
    if (this.leftover < 16)
      return;
    this.blocks(this.buffer, 0, 16);
    this.leftover = 0;
  }

  if (bytes >= 16) {
    want = bytes - (bytes % 16);
    this.blocks(m, mpos, want);
    mpos += want;
    bytes -= want;
  }

  if (bytes) {
    for (i = 0; i < bytes; i++)
      this.buffer[this.leftover + i] = m[mpos+i];
    this.leftover += bytes;
  }
};

function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
  var s = new poly1305(k);
  s.update(m, mpos, n);
  s.finish(out, outpos);
  return 0;
}

function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
  var x = new Uint8Array(16);
  crypto_onetimeauth(x,0,m,mpos,n,k);
  return crypto_verify_16(h,hpos,x,0);
}

function crypto_secretbox(c,m,d,n,k) {
  var i;
  if (d < 32) return -1;
  crypto_stream_xor(c,0,m,0,d,n,k);
  crypto_onetimeauth(c, 16, c, 32, d - 32, c);
  for (i = 0; i < 16; i++) c[i] = 0;
  return 0;
}

function crypto_secretbox_open(m,c,d,n,k) {
  var i;
  var x = new Uint8Array(32);
  if (d < 32) return -1;
  crypto_stream(x,0,32,n,k);
  if (crypto_onetimeauth_verify(c, 16,c, 32,d - 32,x) !== 0) return -1;
  crypto_stream_xor(m,0,c,0,d,n,k);
  for (i = 0; i < 32; i++) m[i] = 0;
  return 0;
}

function set25519(r, a) {
  var i;
  for (i = 0; i < 16; i++) r[i] = a[i]|0;
}

function car25519(o) {
  var i, v, c = 1;
  for (i = 0; i < 16; i++) {
    v = o[i] + c + 65535;
    c = Math.floor(v / 65536);
    o[i] = v - c * 65536;
  }
  o[0] += c-1 + 37 * (c-1);
}

function sel25519(p, q, b) {
  var t, c = ~(b-1);
  for (var i = 0; i < 16; i++) {
    t = c & (p[i] ^ q[i]);
    p[i] ^= t;
    q[i] ^= t;
  }
}

function pack25519(o, n) {
  var i, j, b;
  var m = gf(), t = gf();
  for (i = 0; i < 16; i++) t[i] = n[i];
  car25519(t);
  car25519(t);
  car25519(t);
  for (j = 0; j < 2; j++) {
    m[0] = t[0] - 0xffed;
    for (i = 1; i < 15; i++) {
      m[i] = t[i] - 0xffff - ((m[i-1]>>16) & 1);
      m[i-1] &= 0xffff;
    }
    m[15] = t[15] - 0x7fff - ((m[14]>>16) & 1);
    b = (m[15]>>16) & 1;
    m[14] &= 0xffff;
    sel25519(t, m, 1-b);
  }
  for (i = 0; i < 16; i++) {
    o[2*i] = t[i] & 0xff;
    o[2*i+1] = t[i]>>8;
  }
}

function neq25519(a, b) {
  var c = new Uint8Array(32), d = new Uint8Array(32);
  pack25519(c, a);
  pack25519(d, b);
  return crypto_verify_32(c, 0, d, 0);
}

function par25519(a) {
  var d = new Uint8Array(32);
  pack25519(d, a);
  return d[0] & 1;
}

function unpack25519(o, n) {
  var i;
  for (i = 0; i < 16; i++) o[i] = n[2*i] + (n[2*i+1] << 8);
  o[15] &= 0x7fff;
}

function A(o, a, b) {
  for (var i = 0; i < 16; i++) o[i] = a[i] + b[i];
}

function Z(o, a, b) {
  for (var i = 0; i < 16; i++) o[i] = a[i] - b[i];
}

function M(o, a, b) {
  var v, c,
     t0 = 0,  t1 = 0,  t2 = 0,  t3 = 0,  t4 = 0,  t5 = 0,  t6 = 0,  t7 = 0,
     t8 = 0,  t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0,
    t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0,
    t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0,
    b0 = b[0],
    b1 = b[1],
    b2 = b[2],
    b3 = b[3],
    b4 = b[4],
    b5 = b[5],
    b6 = b[6],
    b7 = b[7],
    b8 = b[8],
    b9 = b[9],
    b10 = b[10],
    b11 = b[11],
    b12 = b[12],
    b13 = b[13],
    b14 = b[14],
    b15 = b[15];

  v = a[0];
  t0 += v * b0;
  t1 += v * b1;
  t2 += v * b2;
  t3 += v * b3;
  t4 += v * b4;
  t5 += v * b5;
  t6 += v * b6;
  t7 += v * b7;
  t8 += v * b8;
  t9 += v * b9;
  t10 += v * b10;
  t11 += v * b11;
  t12 += v * b12;
  t13 += v * b13;
  t14 += v * b14;
  t15 += v * b15;
  v = a[1];
  t1 += v * b0;
  t2 += v * b1;
  t3 += v * b2;
  t4 += v * b3;
  t5 += v * b4;
  t6 += v * b5;
  t7 += v * b6;
  t8 += v * b7;
  t9 += v * b8;
  t10 += v * b9;
  t11 += v * b10;
  t12 += v * b11;
  t13 += v * b12;
  t14 += v * b13;
  t15 += v * b14;
  t16 += v * b15;
  v = a[2];
  t2 += v * b0;
  t3 += v * b1;
  t4 += v * b2;
  t5 += v * b3;
  t6 += v * b4;
  t7 += v * b5;
  t8 += v * b6;
  t9 += v * b7;
  t10 += v * b8;
  t11 += v * b9;
  t12 += v * b10;
  t13 += v * b11;
  t14 += v * b12;
  t15 += v * b13;
  t16 += v * b14;
  t17 += v * b15;
  v = a[3];
  t3 += v * b0;
  t4 += v * b1;
  t5 += v * b2;
  t6 += v * b3;
  t7 += v * b4;
  t8 += v * b5;
  t9 += v * b6;
  t10 += v * b7;
  t11 += v * b8;
  t12 += v * b9;
  t13 += v * b10;
  t14 += v * b11;
  t15 += v * b12;
  t16 += v * b13;
  t17 += v * b14;
  t18 += v * b15;
  v = a[4];
  t4 += v * b0;
  t5 += v * b1;
  t6 += v * b2;
  t7 += v * b3;
  t8 += v * b4;
  t9 += v * b5;
  t10 += v * b6;
  t11 += v * b7;
  t12 += v * b8;
  t13 += v * b9;
  t14 += v * b10;
  t15 += v * b11;
  t16 += v * b12;
  t17 += v * b13;
  t18 += v * b14;
  t19 += v * b15;
  v = a[5];
  t5 += v * b0;
  t6 += v * b1;
  t7 += v * b2;
  t8 += v * b3;
  t9 += v * b4;
  t10 += v * b5;
  t11 += v * b6;
  t12 += v * b7;
  t13 += v * b8;
  t14 += v * b9;
  t15 += v * b10;
  t16 += v * b11;
  t17 += v * b12;
  t18 += v * b13;
  t19 += v * b14;
  t20 += v * b15;
  v = a[6];
  t6 += v * b0;
  t7 += v * b1;
  t8 += v * b2;
  t9 += v * b3;
  t10 += v * b4;
  t11 += v * b5;
  t12 += v * b6;
  t13 += v * b7;
  t14 += v * b8;
  t15 += v * b9;
  t16 += v * b10;
  t17 += v * b11;
  t18 += v * b12;
  t19 += v * b13;
  t20 += v * b14;
  t21 += v * b15;
  v = a[7];
  t7 += v * b0;
  t8 += v * b1;
  t9 += v * b2;
  t10 += v * b3;
  t11 += v * b4;
  t12 += v * b5;
  t13 += v * b6;
  t14 += v * b7;
  t15 += v * b8;
  t16 += v * b9;
  t17 += v * b10;
  t18 += v * b11;
  t19 += v * b12;
  t20 += v * b13;
  t21 += v * b14;
  t22 += v * b15;
  v = a[8];
  t8 += v * b0;
  t9 += v * b1;
  t10 += v * b2;
  t11 += v * b3;
  t12 += v * b4;
  t13 += v * b5;
  t14 += v * b6;
  t15 += v * b7;
  t16 += v * b8;
  t17 += v * b9;
  t18 += v * b10;
  t19 += v * b11;
  t20 += v * b12;
  t21 += v * b13;
  t22 += v * b14;
  t23 += v * b15;
  v = a[9];
  t9 += v * b0;
  t10 += v * b1;
  t11 += v * b2;
  t12 += v * b3;
  t13 += v * b4;
  t14 += v * b5;
  t15 += v * b6;
  t16 += v * b7;
  t17 += v * b8;
  t18 += v * b9;
  t19 += v * b10;
  t20 += v * b11;
  t21 += v * b12;
  t22 += v * b13;
  t23 += v * b14;
  t24 += v * b15;
  v = a[10];
  t10 += v * b0;
  t11 += v * b1;
  t12 += v * b2;
  t13 += v * b3;
  t14 += v * b4;
  t15 += v * b5;
  t16 += v * b6;
  t17 += v * b7;
  t18 += v * b8;
  t19 += v * b9;
  t20 += v * b10;
  t21 += v * b11;
  t22 += v * b12;
  t23 += v * b13;
  t24 += v * b14;
  t25 += v * b15;
  v = a[11];
  t11 += v * b0;
  t12 += v * b1;
  t13 += v * b2;
  t14 += v * b3;
  t15 += v * b4;
  t16 += v * b5;
  t17 += v * b6;
  t18 += v * b7;
  t19 += v * b8;
  t20 += v * b9;
  t21 += v * b10;
  t22 += v * b11;
  t23 += v * b12;
  t24 += v * b13;
  t25 += v * b14;
  t26 += v * b15;
  v = a[12];
  t12 += v * b0;
  t13 += v * b1;
  t14 += v * b2;
  t15 += v * b3;
  t16 += v * b4;
  t17 += v * b5;
  t18 += v * b6;
  t19 += v * b7;
  t20 += v * b8;
  t21 += v * b9;
  t22 += v * b10;
  t23 += v * b11;
  t24 += v * b12;
  t25 += v * b13;
  t26 += v * b14;
  t27 += v * b15;
  v = a[13];
  t13 += v * b0;
  t14 += v * b1;
  t15 += v * b2;
  t16 += v * b3;
  t17 += v * b4;
  t18 += v * b5;
  t19 += v * b6;
  t20 += v * b7;
  t21 += v * b8;
  t22 += v * b9;
  t23 += v * b10;
  t24 += v * b11;
  t25 += v * b12;
  t26 += v * b13;
  t27 += v * b14;
  t28 += v * b15;
  v = a[14];
  t14 += v * b0;
  t15 += v * b1;
  t16 += v * b2;
  t17 += v * b3;
  t18 += v * b4;
  t19 += v * b5;
  t20 += v * b6;
  t21 += v * b7;
  t22 += v * b8;
  t23 += v * b9;
  t24 += v * b10;
  t25 += v * b11;
  t26 += v * b12;
  t27 += v * b13;
  t28 += v * b14;
  t29 += v * b15;
  v = a[15];
  t15 += v * b0;
  t16 += v * b1;
  t17 += v * b2;
  t18 += v * b3;
  t19 += v * b4;
  t20 += v * b5;
  t21 += v * b6;
  t22 += v * b7;
  t23 += v * b8;
  t24 += v * b9;
  t25 += v * b10;
  t26 += v * b11;
  t27 += v * b12;
  t28 += v * b13;
  t29 += v * b14;
  t30 += v * b15;

  t0  += 38 * t16;
  t1  += 38 * t17;
  t2  += 38 * t18;
  t3  += 38 * t19;
  t4  += 38 * t20;
  t5  += 38 * t21;
  t6  += 38 * t22;
  t7  += 38 * t23;
  t8  += 38 * t24;
  t9  += 38 * t25;
  t10 += 38 * t26;
  t11 += 38 * t27;
  t12 += 38 * t28;
  t13 += 38 * t29;
  t14 += 38 * t30;
  // t15 left as is

  // first car
  c = 1;
  v =  t0 + c + 65535; c = Math.floor(v / 65536);  t0 = v - c * 65536;
  v =  t1 + c + 65535; c = Math.floor(v / 65536);  t1 = v - c * 65536;
  v =  t2 + c + 65535; c = Math.floor(v / 65536);  t2 = v - c * 65536;
  v =  t3 + c + 65535; c = Math.floor(v / 65536);  t3 = v - c * 65536;
  v =  t4 + c + 65535; c = Math.floor(v / 65536);  t4 = v - c * 65536;
  v =  t5 + c + 65535; c = Math.floor(v / 65536);  t5 = v - c * 65536;
  v =  t6 + c + 65535; c = Math.floor(v / 65536);  t6 = v - c * 65536;
  v =  t7 + c + 65535; c = Math.floor(v / 65536);  t7 = v - c * 65536;
  v =  t8 + c + 65535; c = Math.floor(v / 65536);  t8 = v - c * 65536;
  v =  t9 + c + 65535; c = Math.floor(v / 65536);  t9 = v - c * 65536;
  v = t10 + c + 65535; c = Math.floor(v / 65536); t10 = v - c * 65536;
  v = t11 + c + 65535; c = Math.floor(v / 65536); t11 = v - c * 65536;
  v = t12 + c + 65535; c = Math.floor(v / 65536); t12 = v - c * 65536;
  v = t13 + c + 65535; c = Math.floor(v / 65536); t13 = v - c * 65536;
  v = t14 + c + 65535; c = Math.floor(v / 65536); t14 = v - c * 65536;
  v = t15 + c + 65535; c = Math.floor(v / 65536); t15 = v - c * 65536;
  t0 += c-1 + 37 * (c-1);

  // second car
  c = 1;
  v =  t0 + c + 65535; c = Math.floor(v / 65536);  t0 = v - c * 65536;
  v =  t1 + c + 65535; c = Math.floor(v / 65536);  t1 = v - c * 65536;
  v =  t2 + c + 65535; c = Math.floor(v / 65536);  t2 = v - c * 65536;
  v =  t3 + c + 65535; c = Math.floor(v / 65536);  t3 = v - c * 65536;
  v =  t4 + c + 65535; c = Math.floor(v / 65536);  t4 = v - c * 65536;
  v =  t5 + c + 65535; c = Math.floor(v / 65536);  t5 = v - c * 65536;
  v =  t6 + c + 65535; c = Math.floor(v / 65536);  t6 = v - c * 65536;
  v =  t7 + c + 65535; c = Math.floor(v / 65536);  t7 = v - c * 65536;
  v =  t8 + c + 65535; c = Math.floor(v / 65536);  t8 = v - c * 65536;
  v =  t9 + c + 65535; c = Math.floor(v / 65536);  t9 = v - c * 65536;
  v = t10 + c + 65535; c = Math.floor(v / 65536); t10 = v - c * 65536;
  v = t11 + c + 65535; c = Math.floor(v / 65536); t11 = v - c * 65536;
  v = t12 + c + 65535; c = Math.floor(v / 65536); t12 = v - c * 65536;
  v = t13 + c + 65535; c = Math.floor(v / 65536); t13 = v - c * 65536;
  v = t14 + c + 65535; c = Math.floor(v / 65536); t14 = v - c * 65536;
  v = t15 + c + 65535; c = Math.floor(v / 65536); t15 = v - c * 65536;
  t0 += c-1 + 37 * (c-1);

  o[ 0] = t0;
  o[ 1] = t1;
  o[ 2] = t2;
  o[ 3] = t3;
  o[ 4] = t4;
  o[ 5] = t5;
  o[ 6] = t6;
  o[ 7] = t7;
  o[ 8] = t8;
  o[ 9] = t9;
  o[10] = t10;
  o[11] = t11;
  o[12] = t12;
  o[13] = t13;
  o[14] = t14;
  o[15] = t15;
}

function S(o, a) {
  M(o, a, a);
}

function inv25519(o, i) {
  var c = gf();
  var a;
  for (a = 0; a < 16; a++) c[a] = i[a];
  for (a = 253; a >= 0; a--) {
    S(c, c);
    if(a !== 2 && a !== 4) M(c, c, i);
  }
  for (a = 0; a < 16; a++) o[a] = c[a];
}

function pow2523(o, i) {
  var c = gf();
  var a;
  for (a = 0; a < 16; a++) c[a] = i[a];
  for (a = 250; a >= 0; a--) {
      S(c, c);
      if(a !== 1) M(c, c, i);
  }
  for (a = 0; a < 16; a++) o[a] = c[a];
}

function crypto_scalarmult(q, n, p) {
  var z = new Uint8Array(32);
  var x = new Float64Array(80), r, i;
  var a = gf(), b = gf(), c = gf(),
      d = gf(), e = gf(), f = gf();
  for (i = 0; i < 31; i++) z[i] = n[i];
  z[31]=(n[31]&127)|64;
  z[0]&=248;
  unpack25519(x,p);
  for (i = 0; i < 16; i++) {
    b[i]=x[i];
    d[i]=a[i]=c[i]=0;
  }
  a[0]=d[0]=1;
  for (i=254; i>=0; --i) {
    r=(z[i>>>3]>>>(i&7))&1;
    sel25519(a,b,r);
    sel25519(c,d,r);
    A(e,a,c);
    Z(a,a,c);
    A(c,b,d);
    Z(b,b,d);
    S(d,e);
    S(f,a);
    M(a,c,a);
    M(c,b,e);
    A(e,a,c);
    Z(a,a,c);
    S(b,a);
    Z(c,d,f);
    M(a,c,_121665);
    A(a,a,d);
    M(c,c,a);
    M(a,d,f);
    M(d,b,x);
    S(b,e);
    sel25519(a,b,r);
    sel25519(c,d,r);
  }
  for (i = 0; i < 16; i++) {
    x[i+16]=a[i];
    x[i+32]=c[i];
    x[i+48]=b[i];
    x[i+64]=d[i];
  }
  var x32 = x.subarray(32);
  var x16 = x.subarray(16);
  inv25519(x32,x32);
  M(x16,x16,x32);
  pack25519(q,x16);
  return 0;
}

function crypto_scalarmult_base(q, n) {
  return crypto_scalarmult(q, n, _9);
}

function crypto_box_keypair(y, x) {
  randombytes(x, 32);
  return crypto_scalarmult_base(y, x);
}

function crypto_box_beforenm(k, y, x) {
  var s = new Uint8Array(32);
  crypto_scalarmult(s, x, y);
  return crypto_core_hsalsa20(k, _0, s, sigma);
}

var crypto_box_afternm = crypto_secretbox;
var crypto_box_open_afternm = crypto_secretbox_open;

function crypto_box(c, m, d, n, y, x) {
  var k = new Uint8Array(32);
  crypto_box_beforenm(k, y, x);
  return crypto_box_afternm(c, m, d, n, k);
}

function crypto_box_open(m, c, d, n, y, x) {
  var k = new Uint8Array(32);
  crypto_box_beforenm(k, y, x);
  return crypto_box_open_afternm(m, c, d, n, k);
}

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function crypto_hashblocks_hl(hh, hl, m, n) {
  var wh = new Int32Array(16), wl = new Int32Array(16),
      bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7,
      bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7,
      th, tl, i, j, h, l, a, b, c, d;

  var ah0 = hh[0],
      ah1 = hh[1],
      ah2 = hh[2],
      ah3 = hh[3],
      ah4 = hh[4],
      ah5 = hh[5],
      ah6 = hh[6],
      ah7 = hh[7],

      al0 = hl[0],
      al1 = hl[1],
      al2 = hl[2],
      al3 = hl[3],
      al4 = hl[4],
      al5 = hl[5],
      al6 = hl[6],
      al7 = hl[7];

  var pos = 0;
  while (n >= 128) {
    for (i = 0; i < 16; i++) {
      j = 8 * i + pos;
      wh[i] = (m[j+0] << 24) | (m[j+1] << 16) | (m[j+2] << 8) | m[j+3];
      wl[i] = (m[j+4] << 24) | (m[j+5] << 16) | (m[j+6] << 8) | m[j+7];
    }
    for (i = 0; i < 80; i++) {
      bh0 = ah0;
      bh1 = ah1;
      bh2 = ah2;
      bh3 = ah3;
      bh4 = ah4;
      bh5 = ah5;
      bh6 = ah6;
      bh7 = ah7;

      bl0 = al0;
      bl1 = al1;
      bl2 = al2;
      bl3 = al3;
      bl4 = al4;
      bl5 = al5;
      bl6 = al6;
      bl7 = al7;

      // add
      h = ah7;
      l = al7;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      // Sigma1
      h = ((ah4 >>> 14) | (al4 << (32-14))) ^ ((ah4 >>> 18) | (al4 << (32-18))) ^ ((al4 >>> (41-32)) | (ah4 << (32-(41-32))));
      l = ((al4 >>> 14) | (ah4 << (32-14))) ^ ((al4 >>> 18) | (ah4 << (32-18))) ^ ((ah4 >>> (41-32)) | (al4 << (32-(41-32))));

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // Ch
      h = (ah4 & ah5) ^ (~ah4 & ah6);
      l = (al4 & al5) ^ (~al4 & al6);

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // K
      h = K[i*2];
      l = K[i*2+1];

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // w
      h = wh[i%16];
      l = wl[i%16];

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      th = c & 0xffff | d << 16;
      tl = a & 0xffff | b << 16;

      // add
      h = th;
      l = tl;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      // Sigma0
      h = ((ah0 >>> 28) | (al0 << (32-28))) ^ ((al0 >>> (34-32)) | (ah0 << (32-(34-32)))) ^ ((al0 >>> (39-32)) | (ah0 << (32-(39-32))));
      l = ((al0 >>> 28) | (ah0 << (32-28))) ^ ((ah0 >>> (34-32)) | (al0 << (32-(34-32)))) ^ ((ah0 >>> (39-32)) | (al0 << (32-(39-32))));

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // Maj
      h = (ah0 & ah1) ^ (ah0 & ah2) ^ (ah1 & ah2);
      l = (al0 & al1) ^ (al0 & al2) ^ (al1 & al2);

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      bh7 = (c & 0xffff) | (d << 16);
      bl7 = (a & 0xffff) | (b << 16);

      // add
      h = bh3;
      l = bl3;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      h = th;
      l = tl;

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      bh3 = (c & 0xffff) | (d << 16);
      bl3 = (a & 0xffff) | (b << 16);

      ah1 = bh0;
      ah2 = bh1;
      ah3 = bh2;
      ah4 = bh3;
      ah5 = bh4;
      ah6 = bh5;
      ah7 = bh6;
      ah0 = bh7;

      al1 = bl0;
      al2 = bl1;
      al3 = bl2;
      al4 = bl3;
      al5 = bl4;
      al6 = bl5;
      al7 = bl6;
      al0 = bl7;

      if (i%16 === 15) {
        for (j = 0; j < 16; j++) {
          // add
          h = wh[j];
          l = wl[j];

          a = l & 0xffff; b = l >>> 16;
          c = h & 0xffff; d = h >>> 16;

          h = wh[(j+9)%16];
          l = wl[(j+9)%16];

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          // sigma0
          th = wh[(j+1)%16];
          tl = wl[(j+1)%16];
          h = ((th >>> 1) | (tl << (32-1))) ^ ((th >>> 8) | (tl << (32-8))) ^ (th >>> 7);
          l = ((tl >>> 1) | (th << (32-1))) ^ ((tl >>> 8) | (th << (32-8))) ^ ((tl >>> 7) | (th << (32-7)));

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          // sigma1
          th = wh[(j+14)%16];
          tl = wl[(j+14)%16];
          h = ((th >>> 19) | (tl << (32-19))) ^ ((tl >>> (61-32)) | (th << (32-(61-32)))) ^ (th >>> 6);
          l = ((tl >>> 19) | (th << (32-19))) ^ ((th >>> (61-32)) | (tl << (32-(61-32)))) ^ ((tl >>> 6) | (th << (32-6)));

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          b += a >>> 16;
          c += b >>> 16;
          d += c >>> 16;

          wh[j] = (c & 0xffff) | (d << 16);
          wl[j] = (a & 0xffff) | (b << 16);
        }
      }
    }

    // add
    h = ah0;
    l = al0;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[0];
    l = hl[0];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[0] = ah0 = (c & 0xffff) | (d << 16);
    hl[0] = al0 = (a & 0xffff) | (b << 16);

    h = ah1;
    l = al1;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[1];
    l = hl[1];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[1] = ah1 = (c & 0xffff) | (d << 16);
    hl[1] = al1 = (a & 0xffff) | (b << 16);

    h = ah2;
    l = al2;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[2];
    l = hl[2];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[2] = ah2 = (c & 0xffff) | (d << 16);
    hl[2] = al2 = (a & 0xffff) | (b << 16);

    h = ah3;
    l = al3;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[3];
    l = hl[3];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[3] = ah3 = (c & 0xffff) | (d << 16);
    hl[3] = al3 = (a & 0xffff) | (b << 16);

    h = ah4;
    l = al4;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[4];
    l = hl[4];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[4] = ah4 = (c & 0xffff) | (d << 16);
    hl[4] = al4 = (a & 0xffff) | (b << 16);

    h = ah5;
    l = al5;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[5];
    l = hl[5];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[5] = ah5 = (c & 0xffff) | (d << 16);
    hl[5] = al5 = (a & 0xffff) | (b << 16);

    h = ah6;
    l = al6;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[6];
    l = hl[6];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[6] = ah6 = (c & 0xffff) | (d << 16);
    hl[6] = al6 = (a & 0xffff) | (b << 16);

    h = ah7;
    l = al7;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[7];
    l = hl[7];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[7] = ah7 = (c & 0xffff) | (d << 16);
    hl[7] = al7 = (a & 0xffff) | (b << 16);

    pos += 128;
    n -= 128;
  }

  return n;
}

function crypto_hash(out, m, n) {
  var hh = new Int32Array(8),
      hl = new Int32Array(8),
      x = new Uint8Array(256),
      i, b = n;

  hh[0] = 0x6a09e667;
  hh[1] = 0xbb67ae85;
  hh[2] = 0x3c6ef372;
  hh[3] = 0xa54ff53a;
  hh[4] = 0x510e527f;
  hh[5] = 0x9b05688c;
  hh[6] = 0x1f83d9ab;
  hh[7] = 0x5be0cd19;

  hl[0] = 0xf3bcc908;
  hl[1] = 0x84caa73b;
  hl[2] = 0xfe94f82b;
  hl[3] = 0x5f1d36f1;
  hl[4] = 0xade682d1;
  hl[5] = 0x2b3e6c1f;
  hl[6] = 0xfb41bd6b;
  hl[7] = 0x137e2179;

  crypto_hashblocks_hl(hh, hl, m, n);
  n %= 128;

  for (i = 0; i < n; i++) x[i] = m[b-n+i];
  x[n] = 128;

  n = 256-128*(n<112?1:0);
  x[n-9] = 0;
  ts64(x, n-8,  (b / 0x20000000) | 0, b << 3);
  crypto_hashblocks_hl(hh, hl, x, n);

  for (i = 0; i < 8; i++) ts64(out, 8*i, hh[i], hl[i]);

  return 0;
}

function add(p, q) {
  var a = gf(), b = gf(), c = gf(),
      d = gf(), e = gf(), f = gf(),
      g = gf(), h = gf(), t = gf();

  Z(a, p[1], p[0]);
  Z(t, q[1], q[0]);
  M(a, a, t);
  A(b, p[0], p[1]);
  A(t, q[0], q[1]);
  M(b, b, t);
  M(c, p[3], q[3]);
  M(c, c, D2);
  M(d, p[2], q[2]);
  A(d, d, d);
  Z(e, b, a);
  Z(f, d, c);
  A(g, d, c);
  A(h, b, a);

  M(p[0], e, f);
  M(p[1], h, g);
  M(p[2], g, f);
  M(p[3], e, h);
}

function cswap(p, q, b) {
  var i;
  for (i = 0; i < 4; i++) {
    sel25519(p[i], q[i], b);
  }
}

function pack(r, p) {
  var tx = gf(), ty = gf(), zi = gf();
  inv25519(zi, p[2]);
  M(tx, p[0], zi);
  M(ty, p[1], zi);
  pack25519(r, ty);
  r[31] ^= par25519(tx) << 7;
}

function scalarmult(p, q, s) {
  var b, i;
  set25519(p[0], gf0);
  set25519(p[1], gf1);
  set25519(p[2], gf1);
  set25519(p[3], gf0);
  for (i = 255; i >= 0; --i) {
    b = (s[(i/8)|0] >> (i&7)) & 1;
    cswap(p, q, b);
    add(q, p);
    add(p, p);
    cswap(p, q, b);
  }
}

function scalarbase(p, s) {
  var q = [gf(), gf(), gf(), gf()];
  set25519(q[0], X);
  set25519(q[1], Y);
  set25519(q[2], gf1);
  M(q[3], X, Y);
  scalarmult(p, q, s);
}

function crypto_sign_keypair(pk, sk, seeded) {
  var d = new Uint8Array(64);
  var p = [gf(), gf(), gf(), gf()];
  var i;

  if (!seeded) randombytes(sk, 32);
  crypto_hash(d, sk, 32);
  d[0] &= 248;
  d[31] &= 127;
  d[31] |= 64;

  scalarbase(p, d);
  pack(pk, p);

  for (i = 0; i < 32; i++) sk[i+32] = pk[i];
  return 0;
}

var L = new Float64Array([0xed, 0xd3, 0xf5, 0x5c, 0x1a, 0x63, 0x12, 0x58, 0xd6, 0x9c, 0xf7, 0xa2, 0xde, 0xf9, 0xde, 0x14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x10]);

function modL(r, x) {
  var carry, i, j, k;
  for (i = 63; i >= 32; --i) {
    carry = 0;
    for (j = i - 32, k = i - 12; j < k; ++j) {
      x[j] += carry - 16 * x[i] * L[j - (i - 32)];
      carry = (x[j] + 128) >> 8;
      x[j] -= carry * 256;
    }
    x[j] += carry;
    x[i] = 0;
  }
  carry = 0;
  for (j = 0; j < 32; j++) {
    x[j] += carry - (x[31] >> 4) * L[j];
    carry = x[j] >> 8;
    x[j] &= 255;
  }
  for (j = 0; j < 32; j++) x[j] -= carry * L[j];
  for (i = 0; i < 32; i++) {
    x[i+1] += x[i] >> 8;
    r[i] = x[i] & 255;
  }
}

function reduce(r) {
  var x = new Float64Array(64), i;
  for (i = 0; i < 64; i++) x[i] = r[i];
  for (i = 0; i < 64; i++) r[i] = 0;
  modL(r, x);
}

// Note: difference from C - smlen returned, not passed as argument.
function crypto_sign(sm, m, n, sk) {
  var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
  var i, j, x = new Float64Array(64);
  var p = [gf(), gf(), gf(), gf()];

  crypto_hash(d, sk, 32);
  d[0] &= 248;
  d[31] &= 127;
  d[31] |= 64;

  var smlen = n + 64;
  for (i = 0; i < n; i++) sm[64 + i] = m[i];
  for (i = 0; i < 32; i++) sm[32 + i] = d[32 + i];

  crypto_hash(r, sm.subarray(32), n+32);
  reduce(r);
  scalarbase(p, r);
  pack(sm, p);

  for (i = 32; i < 64; i++) sm[i] = sk[i];
  crypto_hash(h, sm, n + 64);
  reduce(h);

  for (i = 0; i < 64; i++) x[i] = 0;
  for (i = 0; i < 32; i++) x[i] = r[i];
  for (i = 0; i < 32; i++) {
    for (j = 0; j < 32; j++) {
      x[i+j] += h[i] * d[j];
    }
  }

  modL(sm.subarray(32), x);
  return smlen;
}

function unpackneg(r, p) {
  var t = gf(), chk = gf(), num = gf(),
      den = gf(), den2 = gf(), den4 = gf(),
      den6 = gf();

  set25519(r[2], gf1);
  unpack25519(r[1], p);
  S(num, r[1]);
  M(den, num, D);
  Z(num, num, r[2]);
  A(den, r[2], den);

  S(den2, den);
  S(den4, den2);
  M(den6, den4, den2);
  M(t, den6, num);
  M(t, t, den);

  pow2523(t, t);
  M(t, t, num);
  M(t, t, den);
  M(t, t, den);
  M(r[0], t, den);

  S(chk, r[0]);
  M(chk, chk, den);
  if (neq25519(chk, num)) M(r[0], r[0], I);

  S(chk, r[0]);
  M(chk, chk, den);
  if (neq25519(chk, num)) return -1;

  if (par25519(r[0]) === (p[31]>>7)) Z(r[0], gf0, r[0]);

  M(r[3], r[0], r[1]);
  return 0;
}

function crypto_sign_open(m, sm, n, pk) {
  var i, mlen;
  var t = new Uint8Array(32), h = new Uint8Array(64);
  var p = [gf(), gf(), gf(), gf()],
      q = [gf(), gf(), gf(), gf()];

  mlen = -1;
  if (n < 64) return -1;

  if (unpackneg(q, pk)) return -1;

  for (i = 0; i < n; i++) m[i] = sm[i];
  for (i = 0; i < 32; i++) m[i+32] = pk[i];
  crypto_hash(h, m, n);
  reduce(h);
  scalarmult(p, q, h);

  scalarbase(q, sm.subarray(32));
  add(p, q);
  pack(t, p);

  n -= 64;
  if (crypto_verify_32(sm, 0, t, 0)) {
    for (i = 0; i < n; i++) m[i] = 0;
    return -1;
  }

  for (i = 0; i < n; i++) m[i] = sm[i + 64];
  mlen = n;
  return mlen;
}

var crypto_secretbox_KEYBYTES = 32,
    crypto_secretbox_NONCEBYTES = 24,
    crypto_secretbox_ZEROBYTES = 32,
    crypto_secretbox_BOXZEROBYTES = 16,
    crypto_scalarmult_BYTES = 32,
    crypto_scalarmult_SCALARBYTES = 32,
    crypto_box_PUBLICKEYBYTES = 32,
    crypto_box_SECRETKEYBYTES = 32,
    crypto_box_BEFORENMBYTES = 32,
    crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES,
    crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES,
    crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES,
    crypto_sign_BYTES = 64,
    crypto_sign_PUBLICKEYBYTES = 32,
    crypto_sign_SECRETKEYBYTES = 64,
    crypto_sign_SEEDBYTES = 32,
    crypto_hash_BYTES = 64;

nacl.lowlevel = {
  crypto_core_hsalsa20: crypto_core_hsalsa20,
  crypto_stream_xor: crypto_stream_xor,
  crypto_stream: crypto_stream,
  crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
  crypto_stream_salsa20: crypto_stream_salsa20,
  crypto_onetimeauth: crypto_onetimeauth,
  crypto_onetimeauth_verify: crypto_onetimeauth_verify,
  crypto_verify_16: crypto_verify_16,
  crypto_verify_32: crypto_verify_32,
  crypto_secretbox: crypto_secretbox,
  crypto_secretbox_open: crypto_secretbox_open,
  crypto_scalarmult: crypto_scalarmult,
  crypto_scalarmult_base: crypto_scalarmult_base,
  crypto_box_beforenm: crypto_box_beforenm,
  crypto_box_afternm: crypto_box_afternm,
  crypto_box: crypto_box,
  crypto_box_open: crypto_box_open,
  crypto_box_keypair: crypto_box_keypair,
  crypto_hash: crypto_hash,
  crypto_sign: crypto_sign,
  crypto_sign_keypair: crypto_sign_keypair,
  crypto_sign_open: crypto_sign_open,

  crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
  crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
  crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
  crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
  crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
  crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
  crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
  crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
  crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
  crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
  crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
  crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
  crypto_sign_BYTES: crypto_sign_BYTES,
  crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
  crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
  crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
  crypto_hash_BYTES: crypto_hash_BYTES
};

/* High-level API */

function checkLengths(k, n) {
  if (k.length !== crypto_secretbox_KEYBYTES) throw new Error('bad key size');
  if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error('bad nonce size');
}

function checkBoxLengths(pk, sk) {
  if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error('bad public key size');
  if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error('bad secret key size');
}

function checkArrayTypes() {
  var t, i;
  for (i = 0; i < arguments.length; i++) {
     if ((t = Object.prototype.toString.call(arguments[i])) !== '[object Uint8Array]')
       throw new TypeError('unexpected type ' + t + ', use Uint8Array');
  }
}

function cleanup(arr) {
  for (var i = 0; i < arr.length; i++) arr[i] = 0;
}

// TODO: Completely remove this in v0.15.
if (!nacl.util) {
  nacl.util = {};
  nacl.util.decodeUTF8 = nacl.util.encodeUTF8 = nacl.util.encodeBase64 = nacl.util.decodeBase64 = function() {
    throw new Error('nacl.util moved into separate package: https://github.com/dchest/tweetnacl-util-js');
  };
}

nacl.randomBytes = function(n) {
  var b = new Uint8Array(n);
  randombytes(b, n);
  return b;
};

nacl.secretbox = function(msg, nonce, key) {
  checkArrayTypes(msg, nonce, key);
  checkLengths(key, nonce);
  var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
  var c = new Uint8Array(m.length);
  for (var i = 0; i < msg.length; i++) m[i+crypto_secretbox_ZEROBYTES] = msg[i];
  crypto_secretbox(c, m, m.length, nonce, key);
  return c.subarray(crypto_secretbox_BOXZEROBYTES);
};

nacl.secretbox.open = function(box, nonce, key) {
  checkArrayTypes(box, nonce, key);
  checkLengths(key, nonce);
  var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
  var m = new Uint8Array(c.length);
  for (var i = 0; i < box.length; i++) c[i+crypto_secretbox_BOXZEROBYTES] = box[i];
  if (c.length < 32) return false;
  if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return false;
  return m.subarray(crypto_secretbox_ZEROBYTES);
};

nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;

nacl.scalarMult = function(n, p) {
  checkArrayTypes(n, p);
  if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
  if (p.length !== crypto_scalarmult_BYTES) throw new Error('bad p size');
  var q = new Uint8Array(crypto_scalarmult_BYTES);
  crypto_scalarmult(q, n, p);
  return q;
};

nacl.scalarMult.base = function(n) {
  checkArrayTypes(n);
  if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
  var q = new Uint8Array(crypto_scalarmult_BYTES);
  crypto_scalarmult_base(q, n);
  return q;
};

nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;

nacl.box = function(msg, nonce, publicKey, secretKey) {
  var k = nacl.box.before(publicKey, secretKey);
  return nacl.secretbox(msg, nonce, k);
};

nacl.box.before = function(publicKey, secretKey) {
  checkArrayTypes(publicKey, secretKey);
  checkBoxLengths(publicKey, secretKey);
  var k = new Uint8Array(crypto_box_BEFORENMBYTES);
  crypto_box_beforenm(k, publicKey, secretKey);
  return k;
};

nacl.box.after = nacl.secretbox;

nacl.box.open = function(msg, nonce, publicKey, secretKey) {
  var k = nacl.box.before(publicKey, secretKey);
  return nacl.secretbox.open(msg, nonce, k);
};

nacl.box.open.after = nacl.secretbox.open;

nacl.box.keyPair = function() {
  var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
  crypto_box_keypair(pk, sk);
  return {publicKey: pk, secretKey: sk};
};

nacl.box.keyPair.fromSecretKey = function(secretKey) {
  checkArrayTypes(secretKey);
  if (secretKey.length !== crypto_box_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
  crypto_scalarmult_base(pk, secretKey);
  return {publicKey: pk, secretKey: new Uint8Array(secretKey)};
};

nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
nacl.box.nonceLength = crypto_box_NONCEBYTES;
nacl.box.overheadLength = nacl.secretbox.overheadLength;

nacl.sign = function(msg, secretKey) {
  checkArrayTypes(msg, secretKey);
  if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var signedMsg = new Uint8Array(crypto_sign_BYTES+msg.length);
  crypto_sign(signedMsg, msg, msg.length, secretKey);
  return signedMsg;
};

nacl.sign.open = function(signedMsg, publicKey) {
  if (arguments.length !== 2)
    throw new Error('nacl.sign.open accepts 2 arguments; did you mean to use nacl.sign.detached.verify?');
  checkArrayTypes(signedMsg, publicKey);
  if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
    throw new Error('bad public key size');
  var tmp = new Uint8Array(signedMsg.length);
  var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
  if (mlen < 0) return null;
  var m = new Uint8Array(mlen);
  for (var i = 0; i < m.length; i++) m[i] = tmp[i];
  return m;
};

nacl.sign.detached = function(msg, secretKey) {
  var signedMsg = nacl.sign(msg, secretKey);
  var sig = new Uint8Array(crypto_sign_BYTES);
  for (var i = 0; i < sig.length; i++) sig[i] = signedMsg[i];
  return sig;
};

nacl.sign.detached.verify = function(msg, sig, publicKey) {
  checkArrayTypes(msg, sig, publicKey);
  if (sig.length !== crypto_sign_BYTES)
    throw new Error('bad signature size');
  if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
    throw new Error('bad public key size');
  var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
  var m = new Uint8Array(crypto_sign_BYTES + msg.length);
  var i;
  for (i = 0; i < crypto_sign_BYTES; i++) sm[i] = sig[i];
  for (i = 0; i < msg.length; i++) sm[i+crypto_sign_BYTES] = msg[i];
  return (crypto_sign_open(m, sm, sm.length, publicKey) >= 0);
};

nacl.sign.keyPair = function() {
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
  crypto_sign_keypair(pk, sk);
  return {publicKey: pk, secretKey: sk};
};

nacl.sign.keyPair.fromSecretKey = function(secretKey) {
  checkArrayTypes(secretKey);
  if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  for (var i = 0; i < pk.length; i++) pk[i] = secretKey[32+i];
  return {publicKey: pk, secretKey: new Uint8Array(secretKey)};
};

nacl.sign.keyPair.fromSeed = function(seed) {
  checkArrayTypes(seed);
  if (seed.length !== crypto_sign_SEEDBYTES)
    throw new Error('bad seed size');
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
  for (var i = 0; i < 32; i++) sk[i] = seed[i];
  crypto_sign_keypair(pk, sk, true);
  return {publicKey: pk, secretKey: sk};
};

nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
nacl.sign.seedLength = crypto_sign_SEEDBYTES;
nacl.sign.signatureLength = crypto_sign_BYTES;

nacl.hash = function(msg) {
  checkArrayTypes(msg);
  var h = new Uint8Array(crypto_hash_BYTES);
  crypto_hash(h, msg, msg.length);
  return h;
};

nacl.hash.hashLength = crypto_hash_BYTES;

nacl.verify = function(x, y) {
  checkArrayTypes(x, y);
  // Zero length arguments are considered not equal.
  if (x.length === 0 || y.length === 0) return false;
  if (x.length !== y.length) return false;
  return (vn(x, 0, y, 0, x.length) === 0) ? true : false;
};

nacl.setPRNG = function(fn) {
  randombytes = fn;
};

(function() {
  // Initialize PRNG if environment provides CSPRNG.
  // If not, methods calling randombytes will throw.
  var crypto = typeof self !== 'undefined' ? (self.crypto || self.msCrypto) : null;
  if (crypto && crypto.getRandomValues) {
    // Browsers.
    var QUOTA = 65536;
    nacl.setPRNG(function(x, n) {
      var i, v = new Uint8Array(n);
      for (i = 0; i < n; i += QUOTA) {
        crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
      }
      for (i = 0; i < n; i++) x[i] = v[i];
      cleanup(v);
    });
  } else if (true) {
    // Node.js.
    crypto = __webpack_require__(287);
    if (crypto && crypto.randomBytes) {
      nacl.setPRNG(function(x, n) {
        var i, v = crypto.randomBytes(n);
        for (i = 0; i < n; i++) x[i] = v[i];
        cleanup(v);
      });
    }
  }
})();

})(typeof module !== 'undefined' && module.exports ? module.exports : (self.nacl = self.nacl || {}));


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.

// If you have no idea what ASN.1 or BER is, see this:
// ftp://ftp.rsa.com/pub/pkcs/ascii/layman.asc

var Ber = __webpack_require__(288);



// --- Exported API

module.exports = {

  Ber: Ber,

  BerReader: Ber.Reader,

  BerWriter: Ber.Writer

};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(158);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer
var Transform = __webpack_require__(17).Transform
var StringDecoder = __webpack_require__(67).StringDecoder
var inherits = __webpack_require__(0)

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

(function(){

    // Copyright (c) 2005  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.

    // Basic JavaScript BN library - subset useful for RSA encryption.

    // Bits per digit
    var dbits;

    // JavaScript engine analysis
    var canary = 0xdeadbeefcafe;
    var j_lm = ((canary&0xffffff)==0xefcafe);

    // (public) Constructor
    function BigInteger(a,b,c) {
      if(a != null)
        if("number" == typeof a) this.fromNumber(a,b,c);
        else if(b == null && "string" != typeof a) this.fromString(a,256);
        else this.fromString(a,b);
    }

    // return new, unset BigInteger
    function nbi() { return new BigInteger(null); }

    // am: Compute w_j += (x*this_i), propagate carries,
    // c is initial carry, returns final carry.
    // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
    // We need to select the fastest one that works in this environment.

    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    function am1(i,x,w,j,c,n) {
      while(--n >= 0) {
        var v = x*this[i++]+w[j]+c;
        c = Math.floor(v/0x4000000);
        w[j++] = v&0x3ffffff;
      }
      return c;
    }
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    function am2(i,x,w,j,c,n) {
      var xl = x&0x7fff, xh = x>>15;
      while(--n >= 0) {
        var l = this[i]&0x7fff;
        var h = this[i++]>>15;
        var m = xh*l+h*xl;
        l = xl*l+((m&0x7fff)<<15)+w[j]+(c&0x3fffffff);
        c = (l>>>30)+(m>>>15)+xh*h+(c>>>30);
        w[j++] = l&0x3fffffff;
      }
      return c;
    }
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    function am3(i,x,w,j,c,n) {
      var xl = x&0x3fff, xh = x>>14;
      while(--n >= 0) {
        var l = this[i]&0x3fff;
        var h = this[i++]>>14;
        var m = xh*l+h*xl;
        l = xl*l+((m&0x3fff)<<14)+w[j]+c;
        c = (l>>28)+(m>>14)+xh*h;
        w[j++] = l&0xfffffff;
      }
      return c;
    }
    var inBrowser = typeof navigator !== "undefined";
    if(inBrowser && j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
      BigInteger.prototype.am = am2;
      dbits = 30;
    }
    else if(inBrowser && j_lm && (navigator.appName != "Netscape")) {
      BigInteger.prototype.am = am1;
      dbits = 26;
    }
    else { // Mozilla/Netscape seems to prefer am3
      BigInteger.prototype.am = am3;
      dbits = 28;
    }

    BigInteger.prototype.DB = dbits;
    BigInteger.prototype.DM = ((1<<dbits)-1);
    BigInteger.prototype.DV = (1<<dbits);

    var BI_FP = 52;
    BigInteger.prototype.FV = Math.pow(2,BI_FP);
    BigInteger.prototype.F1 = BI_FP-dbits;
    BigInteger.prototype.F2 = 2*dbits-BI_FP;

    // Digit conversions
    var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
    var BI_RC = new Array();
    var rr,vv;
    rr = "0".charCodeAt(0);
    for(vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;
    rr = "a".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;
    rr = "A".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;

    function int2char(n) { return BI_RM.charAt(n); }
    function intAt(s,i) {
      var c = BI_RC[s.charCodeAt(i)];
      return (c==null)?-1:c;
    }

    // (protected) copy this to r
    function bnpCopyTo(r) {
      for(var i = this.t-1; i >= 0; --i) r[i] = this[i];
      r.t = this.t;
      r.s = this.s;
    }

    // (protected) set from integer value x, -DV <= x < DV
    function bnpFromInt(x) {
      this.t = 1;
      this.s = (x<0)?-1:0;
      if(x > 0) this[0] = x;
      else if(x < -1) this[0] = x+this.DV;
      else this.t = 0;
    }

    // return bigint initialized to value
    function nbv(i) { var r = nbi(); r.fromInt(i); return r; }

    // (protected) set from string and radix
    function bnpFromString(s,b) {
      var k;
      if(b == 16) k = 4;
      else if(b == 8) k = 3;
      else if(b == 256) k = 8; // byte array
      else if(b == 2) k = 1;
      else if(b == 32) k = 5;
      else if(b == 4) k = 2;
      else { this.fromRadix(s,b); return; }
      this.t = 0;
      this.s = 0;
      var i = s.length, mi = false, sh = 0;
      while(--i >= 0) {
        var x = (k==8)?s[i]&0xff:intAt(s,i);
        if(x < 0) {
          if(s.charAt(i) == "-") mi = true;
          continue;
        }
        mi = false;
        if(sh == 0)
          this[this.t++] = x;
        else if(sh+k > this.DB) {
          this[this.t-1] |= (x&((1<<(this.DB-sh))-1))<<sh;
          this[this.t++] = (x>>(this.DB-sh));
        }
        else
          this[this.t-1] |= x<<sh;
        sh += k;
        if(sh >= this.DB) sh -= this.DB;
      }
      if(k == 8 && (s[0]&0x80) != 0) {
        this.s = -1;
        if(sh > 0) this[this.t-1] |= ((1<<(this.DB-sh))-1)<<sh;
      }
      this.clamp();
      if(mi) BigInteger.ZERO.subTo(this,this);
    }

    // (protected) clamp off excess high words
    function bnpClamp() {
      var c = this.s&this.DM;
      while(this.t > 0 && this[this.t-1] == c) --this.t;
    }

    // (public) return string representation in given radix
    function bnToString(b) {
      if(this.s < 0) return "-"+this.negate().toString(b);
      var k;
      if(b == 16) k = 4;
      else if(b == 8) k = 3;
      else if(b == 2) k = 1;
      else if(b == 32) k = 5;
      else if(b == 4) k = 2;
      else return this.toRadix(b);
      var km = (1<<k)-1, d, m = false, r = "", i = this.t;
      var p = this.DB-(i*this.DB)%k;
      if(i-- > 0) {
        if(p < this.DB && (d = this[i]>>p) > 0) { m = true; r = int2char(d); }
        while(i >= 0) {
          if(p < k) {
            d = (this[i]&((1<<p)-1))<<(k-p);
            d |= this[--i]>>(p+=this.DB-k);
          }
          else {
            d = (this[i]>>(p-=k))&km;
            if(p <= 0) { p += this.DB; --i; }
          }
          if(d > 0) m = true;
          if(m) r += int2char(d);
        }
      }
      return m?r:"0";
    }

    // (public) -this
    function bnNegate() { var r = nbi(); BigInteger.ZERO.subTo(this,r); return r; }

    // (public) |this|
    function bnAbs() { return (this.s<0)?this.negate():this; }

    // (public) return + if this > a, - if this < a, 0 if equal
    function bnCompareTo(a) {
      var r = this.s-a.s;
      if(r != 0) return r;
      var i = this.t;
      r = i-a.t;
      if(r != 0) return (this.s<0)?-r:r;
      while(--i >= 0) if((r=this[i]-a[i]) != 0) return r;
      return 0;
    }

    // returns bit length of the integer x
    function nbits(x) {
      var r = 1, t;
      if((t=x>>>16) != 0) { x = t; r += 16; }
      if((t=x>>8) != 0) { x = t; r += 8; }
      if((t=x>>4) != 0) { x = t; r += 4; }
      if((t=x>>2) != 0) { x = t; r += 2; }
      if((t=x>>1) != 0) { x = t; r += 1; }
      return r;
    }

    // (public) return the number of bits in "this"
    function bnBitLength() {
      if(this.t <= 0) return 0;
      return this.DB*(this.t-1)+nbits(this[this.t-1]^(this.s&this.DM));
    }

    // (protected) r = this << n*DB
    function bnpDLShiftTo(n,r) {
      var i;
      for(i = this.t-1; i >= 0; --i) r[i+n] = this[i];
      for(i = n-1; i >= 0; --i) r[i] = 0;
      r.t = this.t+n;
      r.s = this.s;
    }

    // (protected) r = this >> n*DB
    function bnpDRShiftTo(n,r) {
      for(var i = n; i < this.t; ++i) r[i-n] = this[i];
      r.t = Math.max(this.t-n,0);
      r.s = this.s;
    }

    // (protected) r = this << n
    function bnpLShiftTo(n,r) {
      var bs = n%this.DB;
      var cbs = this.DB-bs;
      var bm = (1<<cbs)-1;
      var ds = Math.floor(n/this.DB), c = (this.s<<bs)&this.DM, i;
      for(i = this.t-1; i >= 0; --i) {
        r[i+ds+1] = (this[i]>>cbs)|c;
        c = (this[i]&bm)<<bs;
      }
      for(i = ds-1; i >= 0; --i) r[i] = 0;
      r[ds] = c;
      r.t = this.t+ds+1;
      r.s = this.s;
      r.clamp();
    }

    // (protected) r = this >> n
    function bnpRShiftTo(n,r) {
      r.s = this.s;
      var ds = Math.floor(n/this.DB);
      if(ds >= this.t) { r.t = 0; return; }
      var bs = n%this.DB;
      var cbs = this.DB-bs;
      var bm = (1<<bs)-1;
      r[0] = this[ds]>>bs;
      for(var i = ds+1; i < this.t; ++i) {
        r[i-ds-1] |= (this[i]&bm)<<cbs;
        r[i-ds] = this[i]>>bs;
      }
      if(bs > 0) r[this.t-ds-1] |= (this.s&bm)<<cbs;
      r.t = this.t-ds;
      r.clamp();
    }

    // (protected) r = this - a
    function bnpSubTo(a,r) {
      var i = 0, c = 0, m = Math.min(a.t,this.t);
      while(i < m) {
        c += this[i]-a[i];
        r[i++] = c&this.DM;
        c >>= this.DB;
      }
      if(a.t < this.t) {
        c -= a.s;
        while(i < this.t) {
          c += this[i];
          r[i++] = c&this.DM;
          c >>= this.DB;
        }
        c += this.s;
      }
      else {
        c += this.s;
        while(i < a.t) {
          c -= a[i];
          r[i++] = c&this.DM;
          c >>= this.DB;
        }
        c -= a.s;
      }
      r.s = (c<0)?-1:0;
      if(c < -1) r[i++] = this.DV+c;
      else if(c > 0) r[i++] = c;
      r.t = i;
      r.clamp();
    }

    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    function bnpMultiplyTo(a,r) {
      var x = this.abs(), y = a.abs();
      var i = x.t;
      r.t = i+y.t;
      while(--i >= 0) r[i] = 0;
      for(i = 0; i < y.t; ++i) r[i+x.t] = x.am(0,y[i],r,i,0,x.t);
      r.s = 0;
      r.clamp();
      if(this.s != a.s) BigInteger.ZERO.subTo(r,r);
    }

    // (protected) r = this^2, r != this (HAC 14.16)
    function bnpSquareTo(r) {
      var x = this.abs();
      var i = r.t = 2*x.t;
      while(--i >= 0) r[i] = 0;
      for(i = 0; i < x.t-1; ++i) {
        var c = x.am(i,x[i],r,2*i,0,1);
        if((r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1)) >= x.DV) {
          r[i+x.t] -= x.DV;
          r[i+x.t+1] = 1;
        }
      }
      if(r.t > 0) r[r.t-1] += x.am(i,x[i],r,2*i,0,1);
      r.s = 0;
      r.clamp();
    }

    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    function bnpDivRemTo(m,q,r) {
      var pm = m.abs();
      if(pm.t <= 0) return;
      var pt = this.abs();
      if(pt.t < pm.t) {
        if(q != null) q.fromInt(0);
        if(r != null) this.copyTo(r);
        return;
      }
      if(r == null) r = nbi();
      var y = nbi(), ts = this.s, ms = m.s;
      var nsh = this.DB-nbits(pm[pm.t-1]);   // normalize modulus
      if(nsh > 0) { pm.lShiftTo(nsh,y); pt.lShiftTo(nsh,r); }
      else { pm.copyTo(y); pt.copyTo(r); }
      var ys = y.t;
      var y0 = y[ys-1];
      if(y0 == 0) return;
      var yt = y0*(1<<this.F1)+((ys>1)?y[ys-2]>>this.F2:0);
      var d1 = this.FV/yt, d2 = (1<<this.F1)/yt, e = 1<<this.F2;
      var i = r.t, j = i-ys, t = (q==null)?nbi():q;
      y.dlShiftTo(j,t);
      if(r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t,r);
      }
      BigInteger.ONE.dlShiftTo(ys,t);
      t.subTo(y,y);  // "negative" y so we can replace sub with am later
      while(y.t < ys) y[y.t++] = 0;
      while(--j >= 0) {
        // Estimate quotient digit
        var qd = (r[--i]==y0)?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);
        if((r[i]+=y.am(0,qd,r,j,0,ys)) < qd) {   // Try it out
          y.dlShiftTo(j,t);
          r.subTo(t,r);
          while(r[i] < --qd) r.subTo(t,r);
        }
      }
      if(q != null) {
        r.drShiftTo(ys,q);
        if(ts != ms) BigInteger.ZERO.subTo(q,q);
      }
      r.t = ys;
      r.clamp();
      if(nsh > 0) r.rShiftTo(nsh,r); // Denormalize remainder
      if(ts < 0) BigInteger.ZERO.subTo(r,r);
    }

    // (public) this mod a
    function bnMod(a) {
      var r = nbi();
      this.abs().divRemTo(a,null,r);
      if(this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r,r);
      return r;
    }

    // Modular reduction using "classic" algorithm
    function Classic(m) { this.m = m; }
    function cConvert(x) {
      if(x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
      else return x;
    }
    function cRevert(x) { return x; }
    function cReduce(x) { x.divRemTo(this.m,null,x); }
    function cMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }
    function cSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

    Classic.prototype.convert = cConvert;
    Classic.prototype.revert = cRevert;
    Classic.prototype.reduce = cReduce;
    Classic.prototype.mulTo = cMulTo;
    Classic.prototype.sqrTo = cSqrTo;

    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    function bnpInvDigit() {
      if(this.t < 1) return 0;
      var x = this[0];
      if((x&1) == 0) return 0;
      var y = x&3;       // y == 1/x mod 2^2
      y = (y*(2-(x&0xf)*y))&0xf; // y == 1/x mod 2^4
      y = (y*(2-(x&0xff)*y))&0xff;   // y == 1/x mod 2^8
      y = (y*(2-(((x&0xffff)*y)&0xffff)))&0xffff;    // y == 1/x mod 2^16
      // last step - calculate inverse mod DV directly;
      // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
      y = (y*(2-x*y%this.DV))%this.DV;       // y == 1/x mod 2^dbits
      // we really want the negative inverse, and -DV < y < DV
      return (y>0)?this.DV-y:-y;
    }

    // Montgomery reduction
    function Montgomery(m) {
      this.m = m;
      this.mp = m.invDigit();
      this.mpl = this.mp&0x7fff;
      this.mph = this.mp>>15;
      this.um = (1<<(m.DB-15))-1;
      this.mt2 = 2*m.t;
    }

    // xR mod m
    function montConvert(x) {
      var r = nbi();
      x.abs().dlShiftTo(this.m.t,r);
      r.divRemTo(this.m,null,r);
      if(x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r,r);
      return r;
    }

    // x/R mod m
    function montRevert(x) {
      var r = nbi();
      x.copyTo(r);
      this.reduce(r);
      return r;
    }

    // x = x/R mod m (HAC 14.32)
    function montReduce(x) {
      while(x.t <= this.mt2) // pad x so am has enough room later
        x[x.t++] = 0;
      for(var i = 0; i < this.m.t; ++i) {
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i]&0x7fff;
        var u0 = (j*this.mpl+(((j*this.mph+(x[i]>>15)*this.mpl)&this.um)<<15))&x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i+this.m.t;
        x[j] += this.m.am(0,u0,x,i,0,this.m.t);
        // propagate carry
        while(x[j] >= x.DV) { x[j] -= x.DV; x[++j]++; }
      }
      x.clamp();
      x.drShiftTo(this.m.t,x);
      if(x.compareTo(this.m) >= 0) x.subTo(this.m,x);
    }

    // r = "x^2/R mod m"; x != r
    function montSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

    // r = "xy/R mod m"; x,y != r
    function montMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }

    Montgomery.prototype.convert = montConvert;
    Montgomery.prototype.revert = montRevert;
    Montgomery.prototype.reduce = montReduce;
    Montgomery.prototype.mulTo = montMulTo;
    Montgomery.prototype.sqrTo = montSqrTo;

    // (protected) true iff this is even
    function bnpIsEven() { return ((this.t>0)?(this[0]&1):this.s) == 0; }

    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    function bnpExp(e,z) {
      if(e > 0xffffffff || e < 1) return BigInteger.ONE;
      var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e)-1;
      g.copyTo(r);
      while(--i >= 0) {
        z.sqrTo(r,r2);
        if((e&(1<<i)) > 0) z.mulTo(r2,g,r);
        else { var t = r; r = r2; r2 = t; }
      }
      return z.revert(r);
    }

    // (public) this^e % m, 0 <= e < 2^32
    function bnModPowInt(e,m) {
      var z;
      if(e < 256 || m.isEven()) z = new Classic(m); else z = new Montgomery(m);
      return this.exp(e,z);
    }

    // protected
    BigInteger.prototype.copyTo = bnpCopyTo;
    BigInteger.prototype.fromInt = bnpFromInt;
    BigInteger.prototype.fromString = bnpFromString;
    BigInteger.prototype.clamp = bnpClamp;
    BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    BigInteger.prototype.lShiftTo = bnpLShiftTo;
    BigInteger.prototype.rShiftTo = bnpRShiftTo;
    BigInteger.prototype.subTo = bnpSubTo;
    BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    BigInteger.prototype.squareTo = bnpSquareTo;
    BigInteger.prototype.divRemTo = bnpDivRemTo;
    BigInteger.prototype.invDigit = bnpInvDigit;
    BigInteger.prototype.isEven = bnpIsEven;
    BigInteger.prototype.exp = bnpExp;

    // public
    BigInteger.prototype.toString = bnToString;
    BigInteger.prototype.negate = bnNegate;
    BigInteger.prototype.abs = bnAbs;
    BigInteger.prototype.compareTo = bnCompareTo;
    BigInteger.prototype.bitLength = bnBitLength;
    BigInteger.prototype.mod = bnMod;
    BigInteger.prototype.modPowInt = bnModPowInt;

    // "constants"
    BigInteger.ZERO = nbv(0);
    BigInteger.ONE = nbv(1);

    // Copyright (c) 2005-2009  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.

    // Extended JavaScript BN functions, required for RSA private ops.

    // Version 1.1: new BigInteger("0", 10) returns "proper" zero
    // Version 1.2: square() API, isProbablePrime fix

    // (public)
    function bnClone() { var r = nbi(); this.copyTo(r); return r; }

    // (public) return value as integer
    function bnIntValue() {
      if(this.s < 0) {
        if(this.t == 1) return this[0]-this.DV;
        else if(this.t == 0) return -1;
      }
      else if(this.t == 1) return this[0];
      else if(this.t == 0) return 0;
      // assumes 16 < DB < 32
      return ((this[1]&((1<<(32-this.DB))-1))<<this.DB)|this[0];
    }

    // (public) return value as byte
    function bnByteValue() { return (this.t==0)?this.s:(this[0]<<24)>>24; }

    // (public) return value as short (assumes DB>=16)
    function bnShortValue() { return (this.t==0)?this.s:(this[0]<<16)>>16; }

    // (protected) return x s.t. r^x < DV
    function bnpChunkSize(r) { return Math.floor(Math.LN2*this.DB/Math.log(r)); }

    // (public) 0 if this == 0, 1 if this > 0
    function bnSigNum() {
      if(this.s < 0) return -1;
      else if(this.t <= 0 || (this.t == 1 && this[0] <= 0)) return 0;
      else return 1;
    }

    // (protected) convert to radix string
    function bnpToRadix(b) {
      if(b == null) b = 10;
      if(this.signum() == 0 || b < 2 || b > 36) return "0";
      var cs = this.chunkSize(b);
      var a = Math.pow(b,cs);
      var d = nbv(a), y = nbi(), z = nbi(), r = "";
      this.divRemTo(d,y,z);
      while(y.signum() > 0) {
        r = (a+z.intValue()).toString(b).substr(1) + r;
        y.divRemTo(d,y,z);
      }
      return z.intValue().toString(b) + r;
    }

    // (protected) convert from radix string
    function bnpFromRadix(s,b) {
      this.fromInt(0);
      if(b == null) b = 10;
      var cs = this.chunkSize(b);
      var d = Math.pow(b,cs), mi = false, j = 0, w = 0;
      for(var i = 0; i < s.length; ++i) {
        var x = intAt(s,i);
        if(x < 0) {
          if(s.charAt(i) == "-" && this.signum() == 0) mi = true;
          continue;
        }
        w = b*w+x;
        if(++j >= cs) {
          this.dMultiply(d);
          this.dAddOffset(w,0);
          j = 0;
          w = 0;
        }
      }
      if(j > 0) {
        this.dMultiply(Math.pow(b,j));
        this.dAddOffset(w,0);
      }
      if(mi) BigInteger.ZERO.subTo(this,this);
    }

    // (protected) alternate constructor
    function bnpFromNumber(a,b,c) {
      if("number" == typeof b) {
        // new BigInteger(int,int,RNG)
        if(a < 2) this.fromInt(1);
        else {
          this.fromNumber(a,c);
          if(!this.testBit(a-1))	// force MSB set
            this.bitwiseTo(BigInteger.ONE.shiftLeft(a-1),op_or,this);
          if(this.isEven()) this.dAddOffset(1,0); // force odd
          while(!this.isProbablePrime(b)) {
            this.dAddOffset(2,0);
            if(this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a-1),this);
          }
        }
      }
      else {
        // new BigInteger(int,RNG)
        var x = new Array(), t = a&7;
        x.length = (a>>3)+1;
        b.nextBytes(x);
        if(t > 0) x[0] &= ((1<<t)-1); else x[0] = 0;
        this.fromString(x,256);
      }
    }

    // (public) convert to bigendian byte array
    function bnToByteArray() {
      var i = this.t, r = new Array();
      r[0] = this.s;
      var p = this.DB-(i*this.DB)%8, d, k = 0;
      if(i-- > 0) {
        if(p < this.DB && (d = this[i]>>p) != (this.s&this.DM)>>p)
          r[k++] = d|(this.s<<(this.DB-p));
        while(i >= 0) {
          if(p < 8) {
            d = (this[i]&((1<<p)-1))<<(8-p);
            d |= this[--i]>>(p+=this.DB-8);
          }
          else {
            d = (this[i]>>(p-=8))&0xff;
            if(p <= 0) { p += this.DB; --i; }
          }
          if((d&0x80) != 0) d |= -256;
          if(k == 0 && (this.s&0x80) != (d&0x80)) ++k;
          if(k > 0 || d != this.s) r[k++] = d;
        }
      }
      return r;
    }

    function bnEquals(a) { return(this.compareTo(a)==0); }
    function bnMin(a) { return(this.compareTo(a)<0)?this:a; }
    function bnMax(a) { return(this.compareTo(a)>0)?this:a; }

    // (protected) r = this op a (bitwise)
    function bnpBitwiseTo(a,op,r) {
      var i, f, m = Math.min(a.t,this.t);
      for(i = 0; i < m; ++i) r[i] = op(this[i],a[i]);
      if(a.t < this.t) {
        f = a.s&this.DM;
        for(i = m; i < this.t; ++i) r[i] = op(this[i],f);
        r.t = this.t;
      }
      else {
        f = this.s&this.DM;
        for(i = m; i < a.t; ++i) r[i] = op(f,a[i]);
        r.t = a.t;
      }
      r.s = op(this.s,a.s);
      r.clamp();
    }

    // (public) this & a
    function op_and(x,y) { return x&y; }
    function bnAnd(a) { var r = nbi(); this.bitwiseTo(a,op_and,r); return r; }

    // (public) this | a
    function op_or(x,y) { return x|y; }
    function bnOr(a) { var r = nbi(); this.bitwiseTo(a,op_or,r); return r; }

    // (public) this ^ a
    function op_xor(x,y) { return x^y; }
    function bnXor(a) { var r = nbi(); this.bitwiseTo(a,op_xor,r); return r; }

    // (public) this & ~a
    function op_andnot(x,y) { return x&~y; }
    function bnAndNot(a) { var r = nbi(); this.bitwiseTo(a,op_andnot,r); return r; }

    // (public) ~this
    function bnNot() {
      var r = nbi();
      for(var i = 0; i < this.t; ++i) r[i] = this.DM&~this[i];
      r.t = this.t;
      r.s = ~this.s;
      return r;
    }

    // (public) this << n
    function bnShiftLeft(n) {
      var r = nbi();
      if(n < 0) this.rShiftTo(-n,r); else this.lShiftTo(n,r);
      return r;
    }

    // (public) this >> n
    function bnShiftRight(n) {
      var r = nbi();
      if(n < 0) this.lShiftTo(-n,r); else this.rShiftTo(n,r);
      return r;
    }

    // return index of lowest 1-bit in x, x < 2^31
    function lbit(x) {
      if(x == 0) return -1;
      var r = 0;
      if((x&0xffff) == 0) { x >>= 16; r += 16; }
      if((x&0xff) == 0) { x >>= 8; r += 8; }
      if((x&0xf) == 0) { x >>= 4; r += 4; }
      if((x&3) == 0) { x >>= 2; r += 2; }
      if((x&1) == 0) ++r;
      return r;
    }

    // (public) returns index of lowest 1-bit (or -1 if none)
    function bnGetLowestSetBit() {
      for(var i = 0; i < this.t; ++i)
        if(this[i] != 0) return i*this.DB+lbit(this[i]);
      if(this.s < 0) return this.t*this.DB;
      return -1;
    }

    // return number of 1 bits in x
    function cbit(x) {
      var r = 0;
      while(x != 0) { x &= x-1; ++r; }
      return r;
    }

    // (public) return number of set bits
    function bnBitCount() {
      var r = 0, x = this.s&this.DM;
      for(var i = 0; i < this.t; ++i) r += cbit(this[i]^x);
      return r;
    }

    // (public) true iff nth bit is set
    function bnTestBit(n) {
      var j = Math.floor(n/this.DB);
      if(j >= this.t) return(this.s!=0);
      return((this[j]&(1<<(n%this.DB)))!=0);
    }

    // (protected) this op (1<<n)
    function bnpChangeBit(n,op) {
      var r = BigInteger.ONE.shiftLeft(n);
      this.bitwiseTo(r,op,r);
      return r;
    }

    // (public) this | (1<<n)
    function bnSetBit(n) { return this.changeBit(n,op_or); }

    // (public) this & ~(1<<n)
    function bnClearBit(n) { return this.changeBit(n,op_andnot); }

    // (public) this ^ (1<<n)
    function bnFlipBit(n) { return this.changeBit(n,op_xor); }

    // (protected) r = this + a
    function bnpAddTo(a,r) {
      var i = 0, c = 0, m = Math.min(a.t,this.t);
      while(i < m) {
        c += this[i]+a[i];
        r[i++] = c&this.DM;
        c >>= this.DB;
      }
      if(a.t < this.t) {
        c += a.s;
        while(i < this.t) {
          c += this[i];
          r[i++] = c&this.DM;
          c >>= this.DB;
        }
        c += this.s;
      }
      else {
        c += this.s;
        while(i < a.t) {
          c += a[i];
          r[i++] = c&this.DM;
          c >>= this.DB;
        }
        c += a.s;
      }
      r.s = (c<0)?-1:0;
      if(c > 0) r[i++] = c;
      else if(c < -1) r[i++] = this.DV+c;
      r.t = i;
      r.clamp();
    }

    // (public) this + a
    function bnAdd(a) { var r = nbi(); this.addTo(a,r); return r; }

    // (public) this - a
    function bnSubtract(a) { var r = nbi(); this.subTo(a,r); return r; }

    // (public) this * a
    function bnMultiply(a) { var r = nbi(); this.multiplyTo(a,r); return r; }

    // (public) this^2
    function bnSquare() { var r = nbi(); this.squareTo(r); return r; }

    // (public) this / a
    function bnDivide(a) { var r = nbi(); this.divRemTo(a,r,null); return r; }

    // (public) this % a
    function bnRemainder(a) { var r = nbi(); this.divRemTo(a,null,r); return r; }

    // (public) [this/a,this%a]
    function bnDivideAndRemainder(a) {
      var q = nbi(), r = nbi();
      this.divRemTo(a,q,r);
      return new Array(q,r);
    }

    // (protected) this *= n, this >= 0, 1 < n < DV
    function bnpDMultiply(n) {
      this[this.t] = this.am(0,n-1,this,0,0,this.t);
      ++this.t;
      this.clamp();
    }

    // (protected) this += n << w words, this >= 0
    function bnpDAddOffset(n,w) {
      if(n == 0) return;
      while(this.t <= w) this[this.t++] = 0;
      this[w] += n;
      while(this[w] >= this.DV) {
        this[w] -= this.DV;
        if(++w >= this.t) this[this.t++] = 0;
        ++this[w];
      }
    }

    // A "null" reducer
    function NullExp() {}
    function nNop(x) { return x; }
    function nMulTo(x,y,r) { x.multiplyTo(y,r); }
    function nSqrTo(x,r) { x.squareTo(r); }

    NullExp.prototype.convert = nNop;
    NullExp.prototype.revert = nNop;
    NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.sqrTo = nSqrTo;

    // (public) this^e
    function bnPow(e) { return this.exp(e,new NullExp()); }

    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    function bnpMultiplyLowerTo(a,n,r) {
      var i = Math.min(this.t+a.t,n);
      r.s = 0; // assumes a,this >= 0
      r.t = i;
      while(i > 0) r[--i] = 0;
      var j;
      for(j = r.t-this.t; i < j; ++i) r[i+this.t] = this.am(0,a[i],r,i,0,this.t);
      for(j = Math.min(a.t,n); i < j; ++i) this.am(0,a[i],r,i,0,n-i);
      r.clamp();
    }

    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    function bnpMultiplyUpperTo(a,n,r) {
      --n;
      var i = r.t = this.t+a.t-n;
      r.s = 0; // assumes a,this >= 0
      while(--i >= 0) r[i] = 0;
      for(i = Math.max(n-this.t,0); i < a.t; ++i)
        r[this.t+i-n] = this.am(n-i,a[i],r,0,0,this.t+i-n);
      r.clamp();
      r.drShiftTo(1,r);
    }

    // Barrett modular reduction
    function Barrett(m) {
      // setup Barrett
      this.r2 = nbi();
      this.q3 = nbi();
      BigInteger.ONE.dlShiftTo(2*m.t,this.r2);
      this.mu = this.r2.divide(m);
      this.m = m;
    }

    function barrettConvert(x) {
      if(x.s < 0 || x.t > 2*this.m.t) return x.mod(this.m);
      else if(x.compareTo(this.m) < 0) return x;
      else { var r = nbi(); x.copyTo(r); this.reduce(r); return r; }
    }

    function barrettRevert(x) { return x; }

    // x = x mod m (HAC 14.42)
    function barrettReduce(x) {
      x.drShiftTo(this.m.t-1,this.r2);
      if(x.t > this.m.t+1) { x.t = this.m.t+1; x.clamp(); }
      this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3);
      this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);
      while(x.compareTo(this.r2) < 0) x.dAddOffset(1,this.m.t+1);
      x.subTo(this.r2,x);
      while(x.compareTo(this.m) >= 0) x.subTo(this.m,x);
    }

    // r = x^2 mod m; x != r
    function barrettSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

    // r = x*y mod m; x,y != r
    function barrettMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }

    Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.reduce = barrettReduce;
    Barrett.prototype.mulTo = barrettMulTo;
    Barrett.prototype.sqrTo = barrettSqrTo;

    // (public) this^e % m (HAC 14.85)
    function bnModPow(e,m) {
      var i = e.bitLength(), k, r = nbv(1), z;
      if(i <= 0) return r;
      else if(i < 18) k = 1;
      else if(i < 48) k = 3;
      else if(i < 144) k = 4;
      else if(i < 768) k = 5;
      else k = 6;
      if(i < 8)
        z = new Classic(m);
      else if(m.isEven())
        z = new Barrett(m);
      else
        z = new Montgomery(m);

      // precomputation
      var g = new Array(), n = 3, k1 = k-1, km = (1<<k)-1;
      g[1] = z.convert(this);
      if(k > 1) {
        var g2 = nbi();
        z.sqrTo(g[1],g2);
        while(n <= km) {
          g[n] = nbi();
          z.mulTo(g2,g[n-2],g[n]);
          n += 2;
        }
      }

      var j = e.t-1, w, is1 = true, r2 = nbi(), t;
      i = nbits(e[j])-1;
      while(j >= 0) {
        if(i >= k1) w = (e[j]>>(i-k1))&km;
        else {
          w = (e[j]&((1<<(i+1))-1))<<(k1-i);
          if(j > 0) w |= e[j-1]>>(this.DB+i-k1);
        }

        n = k;
        while((w&1) == 0) { w >>= 1; --n; }
        if((i -= n) < 0) { i += this.DB; --j; }
        if(is1) {	// ret == 1, don't bother squaring or multiplying it
          g[w].copyTo(r);
          is1 = false;
        }
        else {
          while(n > 1) { z.sqrTo(r,r2); z.sqrTo(r2,r); n -= 2; }
          if(n > 0) z.sqrTo(r,r2); else { t = r; r = r2; r2 = t; }
          z.mulTo(r2,g[w],r);
        }

        while(j >= 0 && (e[j]&(1<<i)) == 0) {
          z.sqrTo(r,r2); t = r; r = r2; r2 = t;
          if(--i < 0) { i = this.DB-1; --j; }
        }
      }
      return z.revert(r);
    }

    // (public) gcd(this,a) (HAC 14.54)
    function bnGCD(a) {
      var x = (this.s<0)?this.negate():this.clone();
      var y = (a.s<0)?a.negate():a.clone();
      if(x.compareTo(y) < 0) { var t = x; x = y; y = t; }
      var i = x.getLowestSetBit(), g = y.getLowestSetBit();
      if(g < 0) return x;
      if(i < g) g = i;
      if(g > 0) {
        x.rShiftTo(g,x);
        y.rShiftTo(g,y);
      }
      while(x.signum() > 0) {
        if((i = x.getLowestSetBit()) > 0) x.rShiftTo(i,x);
        if((i = y.getLowestSetBit()) > 0) y.rShiftTo(i,y);
        if(x.compareTo(y) >= 0) {
          x.subTo(y,x);
          x.rShiftTo(1,x);
        }
        else {
          y.subTo(x,y);
          y.rShiftTo(1,y);
        }
      }
      if(g > 0) y.lShiftTo(g,y);
      return y;
    }

    // (protected) this % n, n < 2^26
    function bnpModInt(n) {
      if(n <= 0) return 0;
      var d = this.DV%n, r = (this.s<0)?n-1:0;
      if(this.t > 0)
        if(d == 0) r = this[0]%n;
        else for(var i = this.t-1; i >= 0; --i) r = (d*r+this[i])%n;
      return r;
    }

    // (public) 1/this % m (HAC 14.61)
    function bnModInverse(m) {
      var ac = m.isEven();
      if((this.isEven() && ac) || m.signum() == 0) return BigInteger.ZERO;
      var u = m.clone(), v = this.clone();
      var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);
      while(u.signum() != 0) {
        while(u.isEven()) {
          u.rShiftTo(1,u);
          if(ac) {
            if(!a.isEven() || !b.isEven()) { a.addTo(this,a); b.subTo(m,b); }
            a.rShiftTo(1,a);
          }
          else if(!b.isEven()) b.subTo(m,b);
          b.rShiftTo(1,b);
        }
        while(v.isEven()) {
          v.rShiftTo(1,v);
          if(ac) {
            if(!c.isEven() || !d.isEven()) { c.addTo(this,c); d.subTo(m,d); }
            c.rShiftTo(1,c);
          }
          else if(!d.isEven()) d.subTo(m,d);
          d.rShiftTo(1,d);
        }
        if(u.compareTo(v) >= 0) {
          u.subTo(v,u);
          if(ac) a.subTo(c,a);
          b.subTo(d,b);
        }
        else {
          v.subTo(u,v);
          if(ac) c.subTo(a,c);
          d.subTo(b,d);
        }
      }
      if(v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
      if(d.compareTo(m) >= 0) return d.subtract(m);
      if(d.signum() < 0) d.addTo(m,d); else return d;
      if(d.signum() < 0) return d.add(m); else return d;
    }

    var lowprimes = [2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997];
    var lplim = (1<<26)/lowprimes[lowprimes.length-1];

    // (public) test primality with certainty >= 1-.5^t
    function bnIsProbablePrime(t) {
      var i, x = this.abs();
      if(x.t == 1 && x[0] <= lowprimes[lowprimes.length-1]) {
        for(i = 0; i < lowprimes.length; ++i)
          if(x[0] == lowprimes[i]) return true;
        return false;
      }
      if(x.isEven()) return false;
      i = 1;
      while(i < lowprimes.length) {
        var m = lowprimes[i], j = i+1;
        while(j < lowprimes.length && m < lplim) m *= lowprimes[j++];
        m = x.modInt(m);
        while(i < j) if(m%lowprimes[i++] == 0) return false;
      }
      return x.millerRabin(t);
    }

    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    function bnpMillerRabin(t) {
      var n1 = this.subtract(BigInteger.ONE);
      var k = n1.getLowestSetBit();
      if(k <= 0) return false;
      var r = n1.shiftRight(k);
      t = (t+1)>>1;
      if(t > lowprimes.length) t = lowprimes.length;
      var a = nbi();
      for(var i = 0; i < t; ++i) {
        //Pick bases at random, instead of starting at 2
        a.fromInt(lowprimes[Math.floor(Math.random()*lowprimes.length)]);
        var y = a.modPow(r,this);
        if(y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
          var j = 1;
          while(j++ < k && y.compareTo(n1) != 0) {
            y = y.modPowInt(2,this);
            if(y.compareTo(BigInteger.ONE) == 0) return false;
          }
          if(y.compareTo(n1) != 0) return false;
        }
      }
      return true;
    }

    // protected
    BigInteger.prototype.chunkSize = bnpChunkSize;
    BigInteger.prototype.toRadix = bnpToRadix;
    BigInteger.prototype.fromRadix = bnpFromRadix;
    BigInteger.prototype.fromNumber = bnpFromNumber;
    BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    BigInteger.prototype.changeBit = bnpChangeBit;
    BigInteger.prototype.addTo = bnpAddTo;
    BigInteger.prototype.dMultiply = bnpDMultiply;
    BigInteger.prototype.dAddOffset = bnpDAddOffset;
    BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    BigInteger.prototype.modInt = bnpModInt;
    BigInteger.prototype.millerRabin = bnpMillerRabin;

    // public
    BigInteger.prototype.clone = bnClone;
    BigInteger.prototype.intValue = bnIntValue;
    BigInteger.prototype.byteValue = bnByteValue;
    BigInteger.prototype.shortValue = bnShortValue;
    BigInteger.prototype.signum = bnSigNum;
    BigInteger.prototype.toByteArray = bnToByteArray;
    BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.min = bnMin;
    BigInteger.prototype.max = bnMax;
    BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.or = bnOr;
    BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.not = bnNot;
    BigInteger.prototype.shiftLeft = bnShiftLeft;
    BigInteger.prototype.shiftRight = bnShiftRight;
    BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    BigInteger.prototype.bitCount = bnBitCount;
    BigInteger.prototype.testBit = bnTestBit;
    BigInteger.prototype.setBit = bnSetBit;
    BigInteger.prototype.clearBit = bnClearBit;
    BigInteger.prototype.flipBit = bnFlipBit;
    BigInteger.prototype.add = bnAdd;
    BigInteger.prototype.subtract = bnSubtract;
    BigInteger.prototype.multiply = bnMultiply;
    BigInteger.prototype.divide = bnDivide;
    BigInteger.prototype.remainder = bnRemainder;
    BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    BigInteger.prototype.modPow = bnModPow;
    BigInteger.prototype.modInverse = bnModInverse;
    BigInteger.prototype.pow = bnPow;
    BigInteger.prototype.gcd = bnGCD;
    BigInteger.prototype.isProbablePrime = bnIsProbablePrime;

    // JSBN-specific extension
    BigInteger.prototype.square = bnSquare;

    // Expose the Barrett function
    BigInteger.prototype.Barrett = Barrett

    // BigInteger interfaces not implemented in jsbn:

    // BigInteger(int signum, byte[] magnitude)
    // double doubleValue()
    // float floatValue()
    // int hashCode()
    // long longValue()
    // static BigInteger valueOf(long val)

	// Random number generator - requires a PRNG backend, e.g. prng4.js

	// For best results, put code like
	// <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
	// in your main HTML document.

	var rng_state;
	var rng_pool;
	var rng_pptr;

	// Mix in a 32-bit integer into the pool
	function rng_seed_int(x) {
	  rng_pool[rng_pptr++] ^= x & 255;
	  rng_pool[rng_pptr++] ^= (x >> 8) & 255;
	  rng_pool[rng_pptr++] ^= (x >> 16) & 255;
	  rng_pool[rng_pptr++] ^= (x >> 24) & 255;
	  if(rng_pptr >= rng_psize) rng_pptr -= rng_psize;
	}

	// Mix in the current time (w/milliseconds) into the pool
	function rng_seed_time() {
	  rng_seed_int(new Date().getTime());
	}

	// Initialize the pool with junk if needed.
	if(rng_pool == null) {
	  rng_pool = new Array();
	  rng_pptr = 0;
	  var t;
	  if(typeof window !== "undefined" && window.crypto) {
		if (window.crypto.getRandomValues) {
		  // Use webcrypto if available
		  var ua = new Uint8Array(32);
		  window.crypto.getRandomValues(ua);
		  for(t = 0; t < 32; ++t)
			rng_pool[rng_pptr++] = ua[t];
		}
		else if(navigator.appName == "Netscape" && navigator.appVersion < "5") {
		  // Extract entropy (256 bits) from NS4 RNG if available
		  var z = window.crypto.random(32);
		  for(t = 0; t < z.length; ++t)
			rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
		}
	  }
	  while(rng_pptr < rng_psize) {  // extract some randomness from Math.random()
		t = Math.floor(65536 * Math.random());
		rng_pool[rng_pptr++] = t >>> 8;
		rng_pool[rng_pptr++] = t & 255;
	  }
	  rng_pptr = 0;
	  rng_seed_time();
	  //rng_seed_int(window.screenX);
	  //rng_seed_int(window.screenY);
	}

	function rng_get_byte() {
	  if(rng_state == null) {
		rng_seed_time();
		rng_state = prng_newstate();
		rng_state.init(rng_pool);
		for(rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)
		  rng_pool[rng_pptr] = 0;
		rng_pptr = 0;
		//rng_pool = null;
	  }
	  // TODO: allow reseeding after first request
	  return rng_state.next();
	}

	function rng_get_bytes(ba) {
	  var i;
	  for(i = 0; i < ba.length; ++i) ba[i] = rng_get_byte();
	}

	function SecureRandom() {}

	SecureRandom.prototype.nextBytes = rng_get_bytes;

	// prng4.js - uses Arcfour as a PRNG

	function Arcfour() {
	  this.i = 0;
	  this.j = 0;
	  this.S = new Array();
	}

	// Initialize arcfour context from key, an array of ints, each from [0..255]
	function ARC4init(key) {
	  var i, j, t;
	  for(i = 0; i < 256; ++i)
		this.S[i] = i;
	  j = 0;
	  for(i = 0; i < 256; ++i) {
		j = (j + this.S[i] + key[i % key.length]) & 255;
		t = this.S[i];
		this.S[i] = this.S[j];
		this.S[j] = t;
	  }
	  this.i = 0;
	  this.j = 0;
	}

	function ARC4next() {
	  var t;
	  this.i = (this.i + 1) & 255;
	  this.j = (this.j + this.S[this.i]) & 255;
	  t = this.S[this.i];
	  this.S[this.i] = this.S[this.j];
	  this.S[this.j] = t;
	  return this.S[(t + this.S[this.i]) & 255];
	}

	Arcfour.prototype.init = ARC4init;
	Arcfour.prototype.next = ARC4next;

	// Plug in your RNG constructor here
	function prng_newstate() {
	  return new Arcfour();
	}

	// Pool size must be a multiple of 4 and greater than 32.
	// An array of bytes the size of the pool will be passed to init()
	var rng_psize = 256;

  BigInteger.SecureRandom = SecureRandom;
  BigInteger.BigInteger = BigInteger;
  if (true) {
    exports = module.exports = BigInteger;
  } else {
    this.BigInteger = BigInteger;
    this.SecureRandom = SecureRandom;
  }

}).call(this);


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

module.exports = {
	read: read,
	write: write
};

var assert = __webpack_require__(3);
var asn1 = __webpack_require__(22);
var crypto = __webpack_require__(7);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var utils = __webpack_require__(9);
var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);

var pkcs1 = __webpack_require__(80);
var pkcs8 = __webpack_require__(45);
var sshpriv = __webpack_require__(57);
var rfc4253 = __webpack_require__(29);

var errors = __webpack_require__(19);

/*
 * For reading we support both PKCS#1 and PKCS#8. If we find a private key,
 * we just take the public component of it and use that.
 */
function read(buf, options, forceType) {
	var input = buf;
	if (typeof (buf) !== 'string') {
		assert.buffer(buf, 'buf');
		buf = buf.toString('ascii');
	}

	var lines = buf.trim().split('\n');

	var m = lines[0].match(/*JSSTYLED*/
	    /[-]+[ ]*BEGIN ([A-Z0-9][A-Za-z0-9]+ )?(PUBLIC|PRIVATE) KEY[ ]*[-]+/);
	assert.ok(m, 'invalid PEM header');

	var m2 = lines[lines.length - 1].match(/*JSSTYLED*/
	    /[-]+[ ]*END ([A-Z0-9][A-Za-z0-9]+ )?(PUBLIC|PRIVATE) KEY[ ]*[-]+/);
	assert.ok(m2, 'invalid PEM footer');

	/* Begin and end banners must match key type */
	assert.equal(m[2], m2[2]);
	var type = m[2].toLowerCase();

	var alg;
	if (m[1]) {
		/* They also must match algorithms, if given */
		assert.equal(m[1], m2[1], 'PEM header and footer mismatch');
		alg = m[1].trim();
	}

	var headers = {};
	while (true) {
		lines = lines.slice(1);
		m = lines[0].match(/*JSSTYLED*/
		    /^([A-Za-z0-9-]+): (.+)$/);
		if (!m)
			break;
		headers[m[1].toLowerCase()] = m[2];
	}

	var cipher, key, iv;
	if (headers['proc-type']) {
		var parts = headers['proc-type'].split(',');
		if (parts[0] === '4' && parts[1] === 'ENCRYPTED') {
			if (typeof (options.passphrase) === 'string') {
				options.passphrase = Buffer.from(
				    options.passphrase, 'utf-8');
			}
			if (!Buffer.isBuffer(options.passphrase)) {
				throw (new errors.KeyEncryptedError(
				    options.filename, 'PEM'));
			} else {
				parts = headers['dek-info'].split(',');
				assert.ok(parts.length === 2);
				cipher = parts[0].toLowerCase();
				iv = Buffer.from(parts[1], 'hex');
				key = utils.opensslKeyDeriv(cipher, iv,
				    options.passphrase, 1).key;
			}
		}
	}

	/* Chop off the first and last lines */
	lines = lines.slice(0, -1).join('');
	buf = Buffer.from(lines, 'base64');

	if (cipher && key && iv) {
		var cipherStream = crypto.createDecipheriv(cipher, key, iv);
		var chunk, chunks = [];
		cipherStream.once('error', function (e) {
			if (e.toString().indexOf('bad decrypt') !== -1) {
				throw (new Error('Incorrect passphrase ' +
				    'supplied, could not decrypt key'));
			}
			throw (e);
		});
		cipherStream.write(buf);
		cipherStream.end();
		while ((chunk = cipherStream.read()) !== null)
			chunks.push(chunk);
		buf = Buffer.concat(chunks);
	}

	/* The new OpenSSH internal format abuses PEM headers */
	if (alg && alg.toLowerCase() === 'openssh')
		return (sshpriv.readSSHPrivate(type, buf, options));
	if (alg && alg.toLowerCase() === 'ssh2')
		return (rfc4253.readType(type, buf, options));

	var der = new asn1.BerReader(buf);
	der.originalInput = input;

	/*
	 * All of the PEM file types start with a sequence tag, so chop it
	 * off here
	 */
	der.readSequence();

	/* PKCS#1 type keys name an algorithm in the banner explicitly */
	if (alg) {
		if (forceType)
			assert.strictEqual(forceType, 'pkcs1');
		return (pkcs1.readPkcs1(alg, type, der));
	} else {
		if (forceType)
			assert.strictEqual(forceType, 'pkcs8');
		return (pkcs8.readPkcs8(alg, type, der));
	}
}

function write(key, options, type) {
	assert.object(key);

	var alg = {
	    'ecdsa': 'EC',
	    'rsa': 'RSA',
	    'dsa': 'DSA',
	    'ed25519': 'EdDSA'
	}[key.type];
	var header;

	var der = new asn1.BerWriter();

	if (PrivateKey.isPrivateKey(key)) {
		if (type && type === 'pkcs8') {
			header = 'PRIVATE KEY';
			pkcs8.writePkcs8(der, key);
		} else {
			if (type)
				assert.strictEqual(type, 'pkcs1');
			header = alg + ' PRIVATE KEY';
			pkcs1.writePkcs1(der, key);
		}

	} else if (Key.isKey(key)) {
		if (type && type === 'pkcs1') {
			header = alg + ' PUBLIC KEY';
			pkcs1.writePkcs1(der, key);
		} else {
			if (type)
				assert.strictEqual(type, 'pkcs8');
			header = 'PUBLIC KEY';
			pkcs8.writePkcs8(der, key);
		}

	} else {
		throw (new Error('key is not a Key or PrivateKey'));
	}

	var tmp = der.buffer.toString('base64');
	var len = tmp.length + (tmp.length / 64) +
	    18 + 16 + header.length*2 + 10;
	var buf = Buffer.alloc(len);
	var o = 0;
	o += buf.write('-----BEGIN ' + header + '-----\n', o);
	for (var i = 0; i < tmp.length; ) {
		var limit = i + 64;
		if (limit > tmp.length)
			limit = tmp.length;
		o += buf.write(tmp.slice(i, limit), o);
		buf[o++] = 10;
		i = limit;
	}
	o += buf.write('-----END ' + header + '-----\n', o);

	return (buf.slice(0, o));
}


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(50);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(32);
util.inherits = __webpack_require__(0);
/*</replacement>*/

var Readable = __webpack_require__(95);
var Writable = __webpack_require__(66);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(5);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

module.exports = {
	read: read.bind(undefined, false, undefined),
	readType: read.bind(undefined, false),
	write: write,
	/* semi-private api, used by sshpk-agent */
	readPartial: read.bind(undefined, true),

	/* shared with ssh format */
	readInternal: read,
	keyTypeToAlg: keyTypeToAlg,
	algToKeyType: algToKeyType
};

var assert = __webpack_require__(3);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var utils = __webpack_require__(9);
var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);
var SSHBuffer = __webpack_require__(46);

function algToKeyType(alg) {
	assert.string(alg);
	if (alg === 'ssh-dss')
		return ('dsa');
	else if (alg === 'ssh-rsa')
		return ('rsa');
	else if (alg === 'ssh-ed25519')
		return ('ed25519');
	else if (alg === 'ssh-curve25519')
		return ('curve25519');
	else if (alg.match(/^ecdsa-sha2-/))
		return ('ecdsa');
	else
		throw (new Error('Unknown algorithm ' + alg));
}

function keyTypeToAlg(key) {
	assert.object(key);
	if (key.type === 'dsa')
		return ('ssh-dss');
	else if (key.type === 'rsa')
		return ('ssh-rsa');
	else if (key.type === 'ed25519')
		return ('ssh-ed25519');
	else if (key.type === 'curve25519')
		return ('ssh-curve25519');
	else if (key.type === 'ecdsa')
		return ('ecdsa-sha2-' + key.part.curve.data.toString());
	else
		throw (new Error('Unknown key type ' + key.type));
}

function read(partial, type, buf, options) {
	if (typeof (buf) === 'string')
		buf = Buffer.from(buf);
	assert.buffer(buf, 'buf');

	var key = {};

	var parts = key.parts = [];
	var sshbuf = new SSHBuffer({buffer: buf});

	var alg = sshbuf.readString();
	assert.ok(!sshbuf.atEnd(), 'key must have at least one part');

	key.type = algToKeyType(alg);

	var partCount = algs.info[key.type].parts.length;
	if (type && type === 'private')
		partCount = algs.privInfo[key.type].parts.length;

	while (!sshbuf.atEnd() && parts.length < partCount)
		parts.push(sshbuf.readPart());
	while (!partial && !sshbuf.atEnd())
		parts.push(sshbuf.readPart());

	assert.ok(parts.length >= 1,
	    'key must have at least one part');
	assert.ok(partial || sshbuf.atEnd(),
	    'leftover bytes at end of key');

	var Constructor = Key;
	var algInfo = algs.info[key.type];
	if (type === 'private' || algInfo.parts.length !== parts.length) {
		algInfo = algs.privInfo[key.type];
		Constructor = PrivateKey;
	}
	assert.strictEqual(algInfo.parts.length, parts.length);

	if (key.type === 'ecdsa') {
		var res = /^ecdsa-sha2-(.+)$/.exec(alg);
		assert.ok(res !== null);
		assert.strictEqual(res[1], parts[0].data.toString());
	}

	var normalized = true;
	for (var i = 0; i < algInfo.parts.length; ++i) {
		var p = parts[i];
		p.name = algInfo.parts[i];
		/*
		 * OpenSSH stores ed25519 "private" keys as seed + public key
		 * concat'd together (k followed by A). We want to keep them
		 * separate for other formats that don't do this.
		 */
		if (key.type === 'ed25519' && p.name === 'k')
			p.data = p.data.slice(0, 32);

		if (p.name !== 'curve' && algInfo.normalize !== false) {
			var nd;
			if (key.type === 'ed25519') {
				nd = utils.zeroPadToLength(p.data, 32);
			} else {
				nd = utils.mpNormalize(p.data);
			}
			if (nd.toString('binary') !==
			    p.data.toString('binary')) {
				p.data = nd;
				normalized = false;
			}
		}
	}

	if (normalized)
		key._rfc4253Cache = sshbuf.toBuffer();

	if (partial && typeof (partial) === 'object') {
		partial.remainder = sshbuf.remainder();
		partial.consumed = sshbuf._offset;
	}

	return (new Constructor(key));
}

function write(key, options) {
	assert.object(key);

	var alg = keyTypeToAlg(key);
	var i;

	var algInfo = algs.info[key.type];
	if (PrivateKey.isPrivateKey(key))
		algInfo = algs.privInfo[key.type];
	var parts = algInfo.parts;

	var buf = new SSHBuffer({});

	buf.writeString(alg);

	for (i = 0; i < parts.length; ++i) {
		var data = key.part[parts[i]].data;
		if (algInfo.normalize !== false) {
			if (key.type === 'ed25519')
				data = utils.zeroPadToLength(data, 32);
			else
				data = utils.mpNormalize(data);
		}
		if (key.type === 'ed25519' && parts[i] === 'k')
			data = Buffer.concat([data, key.part.A.data]);
		buf.writeBuffer(data);
	}

	return (buf.toBuffer());
}


/***/ }),
/* 30 */
/***/ (function(module, exports) {



/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(1).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > 65536) throw new Error('requested too many random bytes')
  // in case browserify  isn't using the Uint8Array version
  var rawBytes = new global.Uint8Array(size)

  // This will not work in older browsers.
  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
  if (size > 0) {  // getRandomValues fails on IE if size == 0
    crypto.getRandomValues(rawBytes)
  }

  // XXX: phantomjs doesn't like a buffer being passed here
  var bytes = Buffer.from(rawBytes.buffer)

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(6)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



module.exports = {
  copy: copy,
  checkDataType: checkDataType,
  checkDataTypes: checkDataTypes,
  coerceToTypes: coerceToTypes,
  toHash: toHash,
  getProperty: getProperty,
  escapeQuotes: escapeQuotes,
  equal: __webpack_require__(84),
  ucs2length: __webpack_require__(313),
  varOccurences: varOccurences,
  varReplace: varReplace,
  cleanUpCode: cleanUpCode,
  finalCleanUpCode: finalCleanUpCode,
  schemaHasRules: schemaHasRules,
  schemaHasRulesExcept: schemaHasRulesExcept,
  toQuotedString: toQuotedString,
  getPathExpr: getPathExpr,
  getPath: getPath,
  getData: getData,
  unescapeFragment: unescapeFragment,
  unescapeJsonPointer: unescapeJsonPointer,
  escapeFragment: escapeFragment,
  escapeJsonPointer: escapeJsonPointer
};


function copy(o, to) {
  to = to || {};
  for (var key in o) to[key] = o[key];
  return to;
}


function checkDataType(dataType, data, negate) {
  var EQUAL = negate ? ' !== ' : ' === '
    , AND = negate ? ' || ' : ' && '
    , OK = negate ? '!' : ''
    , NOT = negate ? '' : '!';
  switch (dataType) {
    case 'null': return data + EQUAL + 'null';
    case 'array': return OK + 'Array.isArray(' + data + ')';
    case 'object': return '(' + OK + data + AND +
                          'typeof ' + data + EQUAL + '"object"' + AND +
                          NOT + 'Array.isArray(' + data + '))';
    case 'integer': return '(typeof ' + data + EQUAL + '"number"' + AND +
                           NOT + '(' + data + ' % 1)' +
                           AND + data + EQUAL + data + ')';
    default: return 'typeof ' + data + EQUAL + '"' + dataType + '"';
  }
}


function checkDataTypes(dataTypes, data) {
  switch (dataTypes.length) {
    case 1: return checkDataType(dataTypes[0], data, true);
    default:
      var code = '';
      var types = toHash(dataTypes);
      if (types.array && types.object) {
        code = types.null ? '(': '(!' + data + ' || ';
        code += 'typeof ' + data + ' !== "object")';
        delete types.null;
        delete types.array;
        delete types.object;
      }
      if (types.number) delete types.integer;
      for (var t in types)
        code += (code ? ' && ' : '' ) + checkDataType(t, data, true);

      return code;
  }
}


var COERCE_TO_TYPES = toHash([ 'string', 'number', 'integer', 'boolean', 'null' ]);
function coerceToTypes(optionCoerceTypes, dataTypes) {
  if (Array.isArray(dataTypes)) {
    var types = [];
    for (var i=0; i<dataTypes.length; i++) {
      var t = dataTypes[i];
      if (COERCE_TO_TYPES[t]) types[types.length] = t;
      else if (optionCoerceTypes === 'array' && t === 'array') types[types.length] = t;
    }
    if (types.length) return types;
  } else if (COERCE_TO_TYPES[dataTypes]) {
    return [dataTypes];
  } else if (optionCoerceTypes === 'array' && dataTypes === 'array') {
    return ['array'];
  }
}


function toHash(arr) {
  var hash = {};
  for (var i=0; i<arr.length; i++) hash[arr[i]] = true;
  return hash;
}


var IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
var SINGLE_QUOTE = /'|\\/g;
function getProperty(key) {
  return typeof key == 'number'
          ? '[' + key + ']'
          : IDENTIFIER.test(key)
            ? '.' + key
            : "['" + escapeQuotes(key) + "']";
}


function escapeQuotes(str) {
  return str.replace(SINGLE_QUOTE, '\\$&')
            .replace(/\n/g, '\\n')
            .replace(/\r/g, '\\r')
            .replace(/\f/g, '\\f')
            .replace(/\t/g, '\\t');
}


function varOccurences(str, dataVar) {
  dataVar += '[^0-9]';
  var matches = str.match(new RegExp(dataVar, 'g'));
  return matches ? matches.length : 0;
}


function varReplace(str, dataVar, expr) {
  dataVar += '([^0-9])';
  expr = expr.replace(/\$/g, '$$$$');
  return str.replace(new RegExp(dataVar, 'g'), expr + '$1');
}


var EMPTY_ELSE = /else\s*{\s*}/g
  , EMPTY_IF_NO_ELSE = /if\s*\([^)]+\)\s*\{\s*\}(?!\s*else)/g
  , EMPTY_IF_WITH_ELSE = /if\s*\(([^)]+)\)\s*\{\s*\}\s*else(?!\s*if)/g;
function cleanUpCode(out) {
  return out.replace(EMPTY_ELSE, '')
            .replace(EMPTY_IF_NO_ELSE, '')
            .replace(EMPTY_IF_WITH_ELSE, 'if (!($1))');
}


var ERRORS_REGEXP = /[^v.]errors/g
  , REMOVE_ERRORS = /var errors = 0;|var vErrors = null;|validate.errors = vErrors;/g
  , REMOVE_ERRORS_ASYNC = /var errors = 0;|var vErrors = null;/g
  , RETURN_VALID = 'return errors === 0;'
  , RETURN_TRUE = 'validate.errors = null; return true;'
  , RETURN_ASYNC = /if \(errors === 0\) return data;\s*else throw new ValidationError\(vErrors\);/
  , RETURN_DATA_ASYNC = 'return data;'
  , ROOTDATA_REGEXP = /[^A-Za-z_$]rootData[^A-Za-z0-9_$]/g
  , REMOVE_ROOTDATA = /if \(rootData === undefined\) rootData = data;/;

function finalCleanUpCode(out, async) {
  var matches = out.match(ERRORS_REGEXP);
  if (matches && matches.length == 2) {
    out = async
          ? out.replace(REMOVE_ERRORS_ASYNC, '')
               .replace(RETURN_ASYNC, RETURN_DATA_ASYNC)
          : out.replace(REMOVE_ERRORS, '')
               .replace(RETURN_VALID, RETURN_TRUE);
  }

  matches = out.match(ROOTDATA_REGEXP);
  if (!matches || matches.length !== 3) return out;
  return out.replace(REMOVE_ROOTDATA, '');
}


function schemaHasRules(schema, rules) {
  if (typeof schema == 'boolean') return !schema;
  for (var key in schema) if (rules[key]) return true;
}


function schemaHasRulesExcept(schema, rules, exceptKeyword) {
  if (typeof schema == 'boolean') return !schema && exceptKeyword != 'not';
  for (var key in schema) if (key != exceptKeyword && rules[key]) return true;
}


function toQuotedString(str) {
  return '\'' + escapeQuotes(str) + '\'';
}


function getPathExpr(currentPath, expr, jsonPointers, isNumber) {
  var path = jsonPointers // false by default
              ? '\'/\' + ' + expr + (isNumber ? '' : '.replace(/~/g, \'~0\').replace(/\\//g, \'~1\')')
              : (isNumber ? '\'[\' + ' + expr + ' + \']\'' : '\'[\\\'\' + ' + expr + ' + \'\\\']\'');
  return joinPaths(currentPath, path);
}


function getPath(currentPath, prop, jsonPointers) {
  var path = jsonPointers // false by default
              ? toQuotedString('/' + escapeJsonPointer(prop))
              : toQuotedString(getProperty(prop));
  return joinPaths(currentPath, path);
}


var JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
var RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function getData($data, lvl, paths) {
  var up, jsonPointer, data, matches;
  if ($data === '') return 'rootData';
  if ($data[0] == '/') {
    if (!JSON_POINTER.test($data)) throw new Error('Invalid JSON-pointer: ' + $data);
    jsonPointer = $data;
    data = 'rootData';
  } else {
    matches = $data.match(RELATIVE_JSON_POINTER);
    if (!matches) throw new Error('Invalid JSON-pointer: ' + $data);
    up = +matches[1];
    jsonPointer = matches[2];
    if (jsonPointer == '#') {
      if (up >= lvl) throw new Error('Cannot access property/index ' + up + ' levels up, current level is ' + lvl);
      return paths[lvl - up];
    }

    if (up > lvl) throw new Error('Cannot access data ' + up + ' levels up, current level is ' + lvl);
    data = 'data' + ((lvl - up) || '');
    if (!jsonPointer) return data;
  }

  var expr = data;
  var segments = jsonPointer.split('/');
  for (var i=0; i<segments.length; i++) {
    var segment = segments[i];
    if (segment) {
      data += getProperty(unescapeJsonPointer(segment));
      expr += ' && ' + data;
    }
  }
  return expr;
}


function joinPaths (a, b) {
  if (a == '""') return b;
  return (a + ' + ' + b).replace(/' \+ '/g, '');
}


function unescapeFragment(str) {
  return unescapeJsonPointer(decodeURIComponent(str));
}


function escapeFragment(str) {
  return encodeURIComponent(escapeJsonPointer(str));
}


function escapeJsonPointer(str) {
  return str.replace(/~/g, '~0').replace(/\//g, '~1');
}


function unescapeJsonPointer(str) {
  return str.replace(/~1/g, '/').replace(/~0/g, '~');
}


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(0)
var MD5 = __webpack_require__(65)
var RIPEMD160 = __webpack_require__(68)
var sha = __webpack_require__(69)
var Base = __webpack_require__(24)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(95);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(66);
exports.Duplex = __webpack_require__(27);
exports.Transform = __webpack_require__(98);
exports.PassThrough = __webpack_require__(189);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);
var assert = __webpack_require__(15);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(8);

asn1.define = __webpack_require__(247).define;
asn1.base = __webpack_require__(40);
asn1.constants = __webpack_require__(121);
asn1.decoders = __webpack_require__(253);
asn1.encoders = __webpack_require__(255);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(250).Reporter;
base.DecoderBuffer = __webpack_require__(120).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(120).EncoderBuffer;
base.Node = __webpack_require__(251);


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var ClientRequest = __webpack_require__(267)
var response = __webpack_require__(129)
var extend = __webpack_require__(269)
var statusCodes = __webpack_require__(270)
var url = __webpack_require__(16)

var http = exports

http.request = function (opts, cb) {
	if (typeof opts === 'string')
		opts = url.parse(opts)
	else
		opts = extend(opts)

	// Normally, the page is loaded from http or https, so not specifying a protocol
	// will result in a (valid) protocol-relative url. However, this won't work if
	// the protocol is something else, like 'file:'
	var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : ''

	var protocol = opts.protocol || defaultProtocol
	var host = opts.hostname || opts.host
	var port = opts.port
	var path = opts.path || '/'

	// Necessary for IPv6 addresses
	if (host && host.indexOf(':') !== -1)
		host = '[' + host + ']'

	// This may be a relative url. The browser should always be able to interpret it correctly.
	opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path
	opts.method = (opts.method || 'GET').toUpperCase()
	opts.headers = opts.headers || {}

	// Also valid opts.auth, opts.mode

	var req = new ClientRequest(opts)
	if (cb)
		req.on('response', cb)
	return req
}

http.get = function get (opts, cb) {
	var req = http.request(opts, cb)
	req.end()
	return req
}

http.ClientRequest = ClientRequest
http.IncomingMessage = response.IncomingMessage

http.Agent = function () {}
http.Agent.defaultMaxSockets = 4

http.globalAgent = new http.Agent()

http.STATUS_CODES = statusCodes

http.METHODS = [
	'CHECKOUT',
	'CONNECT',
	'COPY',
	'DELETE',
	'GET',
	'HEAD',
	'LOCK',
	'M-SEARCH',
	'MERGE',
	'MKACTIVITY',
	'MKCOL',
	'MOVE',
	'NOTIFY',
	'OPTIONS',
	'PATCH',
	'POST',
	'PROPFIND',
	'PROPPATCH',
	'PURGE',
	'PUT',
	'REPORT',
	'SEARCH',
	'SUBSCRIBE',
	'TRACE',
	'UNLOCK',
	'UNSUBSCRIBE'
]
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

module.exports = Fingerprint;

var assert = __webpack_require__(3);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var crypto = __webpack_require__(7);
var errs = __webpack_require__(19);
var Key = __webpack_require__(11);
var Certificate = __webpack_require__(43);
var utils = __webpack_require__(9);

var FingerprintFormatError = errs.FingerprintFormatError;
var InvalidAlgorithmError = errs.InvalidAlgorithmError;

function Fingerprint(opts) {
	assert.object(opts, 'options');
	assert.string(opts.type, 'options.type');
	assert.buffer(opts.hash, 'options.hash');
	assert.string(opts.algorithm, 'options.algorithm');

	this.algorithm = opts.algorithm.toLowerCase();
	if (algs.hashAlgs[this.algorithm] !== true)
		throw (new InvalidAlgorithmError(this.algorithm));

	this.hash = opts.hash;
	this.type = opts.type;
}

Fingerprint.prototype.toString = function (format) {
	if (format === undefined) {
		if (this.algorithm === 'md5')
			format = 'hex';
		else
			format = 'base64';
	}
	assert.string(format);

	switch (format) {
	case 'hex':
		return (addColons(this.hash.toString('hex')));
	case 'base64':
		return (sshBase64Format(this.algorithm,
		    this.hash.toString('base64')));
	default:
		throw (new FingerprintFormatError(undefined, format));
	}
};

Fingerprint.prototype.matches = function (other) {
	assert.object(other, 'key or certificate');
	if (this.type === 'key') {
		utils.assertCompatible(other, Key, [1, 0], 'key');
	} else {
		utils.assertCompatible(other, Certificate, [1, 0],
		    'certificate');
	}

	var theirHash = other.hash(this.algorithm);
	var theirHash2 = crypto.createHash(this.algorithm).
	    update(theirHash).digest('base64');

	if (this.hash2 === undefined)
		this.hash2 = crypto.createHash(this.algorithm).
		    update(this.hash).digest('base64');

	return (this.hash2 === theirHash2);
};

Fingerprint.parse = function (fp, options) {
	assert.string(fp, 'fingerprint');

	var alg, hash, enAlgs;
	if (Array.isArray(options)) {
		enAlgs = options;
		options = {};
	}
	assert.optionalObject(options, 'options');
	if (options === undefined)
		options = {};
	if (options.enAlgs !== undefined)
		enAlgs = options.enAlgs;
	assert.optionalArrayOfString(enAlgs, 'algorithms');

	var parts = fp.split(':');
	if (parts.length == 2) {
		alg = parts[0].toLowerCase();
		/*JSSTYLED*/
		var base64RE = /^[A-Za-z0-9+\/=]+$/;
		if (!base64RE.test(parts[1]))
			throw (new FingerprintFormatError(fp));
		try {
			hash = Buffer.from(parts[1], 'base64');
		} catch (e) {
			throw (new FingerprintFormatError(fp));
		}
	} else if (parts.length > 2) {
		alg = 'md5';
		if (parts[0].toLowerCase() === 'md5')
			parts = parts.slice(1);
		parts = parts.join('');
		/*JSSTYLED*/
		var md5RE = /^[a-fA-F0-9]+$/;
		if (!md5RE.test(parts))
			throw (new FingerprintFormatError(fp));
		try {
			hash = Buffer.from(parts, 'hex');
		} catch (e) {
			throw (new FingerprintFormatError(fp));
		}
	}

	if (alg === undefined)
		throw (new FingerprintFormatError(fp));

	if (algs.hashAlgs[alg] === undefined)
		throw (new InvalidAlgorithmError(alg));

	if (enAlgs !== undefined) {
		enAlgs = enAlgs.map(function (a) { return a.toLowerCase(); });
		if (enAlgs.indexOf(alg) === -1)
			throw (new InvalidAlgorithmError(alg));
	}

	return (new Fingerprint({
		algorithm: alg,
		hash: hash,
		type: options.type || 'key'
	}));
};

function addColons(s) {
	/*JSSTYLED*/
	return (s.replace(/(.{2})(?=.)/g, '$1:'));
}

function base64Strip(s) {
	/*JSSTYLED*/
	return (s.replace(/=*$/, ''));
}

function sshBase64Format(alg, h) {
	return (alg.toUpperCase() + ':' + base64Strip(h));
}

Fingerprint.isFingerprint = function (obj, ver) {
	return (utils.isCompatible(obj, Fingerprint, ver));
};

/*
 * API versions for Fingerprint:
 * [1,0] -- initial ver
 * [1,1] -- first tagged ver
 */
Fingerprint.prototype._sshpkApiVersion = [1, 1];

Fingerprint._oldVersionDetect = function (obj) {
	assert.func(obj.toString);
	assert.func(obj.matches);
	return ([1, 0]);
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2016 Joyent, Inc.

module.exports = Certificate;

var assert = __webpack_require__(3);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var crypto = __webpack_require__(7);
var Fingerprint = __webpack_require__(42);
var Signature = __webpack_require__(20);
var errs = __webpack_require__(19);
var util = __webpack_require__(5);
var utils = __webpack_require__(9);
var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);
var Identity = __webpack_require__(47);

var formats = {};
formats['openssh'] = __webpack_require__(291);
formats['x509'] = __webpack_require__(137);
formats['pem'] = __webpack_require__(292);

var CertificateParseError = errs.CertificateParseError;
var InvalidAlgorithmError = errs.InvalidAlgorithmError;

function Certificate(opts) {
	assert.object(opts, 'options');
	assert.arrayOfObject(opts.subjects, 'options.subjects');
	utils.assertCompatible(opts.subjects[0], Identity, [1, 0],
	    'options.subjects');
	utils.assertCompatible(opts.subjectKey, Key, [1, 0],
	    'options.subjectKey');
	utils.assertCompatible(opts.issuer, Identity, [1, 0], 'options.issuer');
	if (opts.issuerKey !== undefined) {
		utils.assertCompatible(opts.issuerKey, Key, [1, 0],
		    'options.issuerKey');
	}
	assert.object(opts.signatures, 'options.signatures');
	assert.buffer(opts.serial, 'options.serial');
	assert.date(opts.validFrom, 'options.validFrom');
	assert.date(opts.validUntil, 'optons.validUntil');

	assert.optionalArrayOfString(opts.purposes, 'options.purposes');

	this._hashCache = {};

	this.subjects = opts.subjects;
	this.issuer = opts.issuer;
	this.subjectKey = opts.subjectKey;
	this.issuerKey = opts.issuerKey;
	this.signatures = opts.signatures;
	this.serial = opts.serial;
	this.validFrom = opts.validFrom;
	this.validUntil = opts.validUntil;
	this.purposes = opts.purposes;
}

Certificate.formats = formats;

Certificate.prototype.toBuffer = function (format, options) {
	if (format === undefined)
		format = 'x509';
	assert.string(format, 'format');
	assert.object(formats[format], 'formats[format]');
	assert.optionalObject(options, 'options');

	return (formats[format].write(this, options));
};

Certificate.prototype.toString = function (format, options) {
	if (format === undefined)
		format = 'pem';
	return (this.toBuffer(format, options).toString());
};

Certificate.prototype.fingerprint = function (algo) {
	if (algo === undefined)
		algo = 'sha256';
	assert.string(algo, 'algorithm');
	var opts = {
		type: 'certificate',
		hash: this.hash(algo),
		algorithm: algo
	};
	return (new Fingerprint(opts));
};

Certificate.prototype.hash = function (algo) {
	assert.string(algo, 'algorithm');
	algo = algo.toLowerCase();
	if (algs.hashAlgs[algo] === undefined)
		throw (new InvalidAlgorithmError(algo));

	if (this._hashCache[algo])
		return (this._hashCache[algo]);

	var hash = crypto.createHash(algo).
	    update(this.toBuffer('x509')).digest();
	this._hashCache[algo] = hash;
	return (hash);
};

Certificate.prototype.isExpired = function (when) {
	if (when === undefined)
		when = new Date();
	return (!((when.getTime() >= this.validFrom.getTime()) &&
		(when.getTime() < this.validUntil.getTime())));
};

Certificate.prototype.isSignedBy = function (issuerCert) {
	utils.assertCompatible(issuerCert, Certificate, [1, 0], 'issuer');

	if (!this.issuer.equals(issuerCert.subjects[0]))
		return (false);
	if (this.issuer.purposes && this.issuer.purposes.length > 0 &&
	    this.issuer.purposes.indexOf('ca') === -1) {
		return (false);
	}

	return (this.isSignedByKey(issuerCert.subjectKey));
};

Certificate.prototype.isSignedByKey = function (issuerKey) {
	utils.assertCompatible(issuerKey, Key, [1, 2], 'issuerKey');

	if (this.issuerKey !== undefined) {
		return (this.issuerKey.
		    fingerprint('sha512').matches(issuerKey));
	}

	var fmt = Object.keys(this.signatures)[0];
	var valid = formats[fmt].verify(this, issuerKey);
	if (valid)
		this.issuerKey = issuerKey;
	return (valid);
};

Certificate.prototype.signWith = function (key) {
	utils.assertCompatible(key, PrivateKey, [1, 2], 'key');
	var fmts = Object.keys(formats);
	var didOne = false;
	for (var i = 0; i < fmts.length; ++i) {
		if (fmts[i] !== 'pem') {
			var ret = formats[fmts[i]].sign(this, key);
			if (ret === true)
				didOne = true;
		}
	}
	if (!didOne) {
		throw (new Error('Failed to sign the certificate for any ' +
		    'available certificate formats'));
	}
};

Certificate.createSelfSigned = function (subjectOrSubjects, key, options) {
	var subjects;
	if (Array.isArray(subjectOrSubjects))
		subjects = subjectOrSubjects;
	else
		subjects = [subjectOrSubjects];

	assert.arrayOfObject(subjects);
	subjects.forEach(function (subject) {
		utils.assertCompatible(subject, Identity, [1, 0], 'subject');
	});

	utils.assertCompatible(key, PrivateKey, [1, 2], 'private key');

	assert.optionalObject(options, 'options');
	if (options === undefined)
		options = {};
	assert.optionalObject(options.validFrom, 'options.validFrom');
	assert.optionalObject(options.validUntil, 'options.validUntil');
	var validFrom = options.validFrom;
	var validUntil = options.validUntil;
	if (validFrom === undefined)
		validFrom = new Date();
	if (validUntil === undefined) {
		assert.optionalNumber(options.lifetime, 'options.lifetime');
		var lifetime = options.lifetime;
		if (lifetime === undefined)
			lifetime = 10*365*24*3600;
		validUntil = new Date();
		validUntil.setTime(validUntil.getTime() + lifetime*1000);
	}
	assert.optionalBuffer(options.serial, 'options.serial');
	var serial = options.serial;
	if (serial === undefined)
		serial = Buffer.from('0000000000000001', 'hex');

	var purposes = options.purposes;
	if (purposes === undefined)
		purposes = [];

	if (purposes.indexOf('signature') === -1)
		purposes.push('signature');

	/* Self-signed certs are always CAs. */
	if (purposes.indexOf('ca') === -1)
		purposes.push('ca');
	if (purposes.indexOf('crl') === -1)
		purposes.push('crl');

	/*
	 * If we weren't explicitly given any other purposes, do the sensible
	 * thing and add some basic ones depending on the subject type.
	 */
	if (purposes.length <= 3) {
		var hostSubjects = subjects.filter(function (subject) {
			return (subject.type === 'host');
		});
		var userSubjects = subjects.filter(function (subject) {
			return (subject.type === 'user');
		});
		if (hostSubjects.length > 0) {
			if (purposes.indexOf('serverAuth') === -1)
				purposes.push('serverAuth');
		}
		if (userSubjects.length > 0) {
			if (purposes.indexOf('clientAuth') === -1)
				purposes.push('clientAuth');
		}
		if (userSubjects.length > 0 || hostSubjects.length > 0) {
			if (purposes.indexOf('keyAgreement') === -1)
				purposes.push('keyAgreement');
			if (key.type === 'rsa' &&
			    purposes.indexOf('encryption') === -1)
				purposes.push('encryption');
		}
	}

	var cert = new Certificate({
		subjects: subjects,
		issuer: subjects[0],
		subjectKey: key.toPublic(),
		issuerKey: key.toPublic(),
		signatures: {},
		serial: serial,
		validFrom: validFrom,
		validUntil: validUntil,
		purposes: purposes
	});
	cert.signWith(key);

	return (cert);
};

Certificate.create =
    function (subjectOrSubjects, key, issuer, issuerKey, options) {
	var subjects;
	if (Array.isArray(subjectOrSubjects))
		subjects = subjectOrSubjects;
	else
		subjects = [subjectOrSubjects];

	assert.arrayOfObject(subjects);
	subjects.forEach(function (subject) {
		utils.assertCompatible(subject, Identity, [1, 0], 'subject');
	});

	utils.assertCompatible(key, Key, [1, 0], 'key');
	if (PrivateKey.isPrivateKey(key))
		key = key.toPublic();
	utils.assertCompatible(issuer, Identity, [1, 0], 'issuer');
	utils.assertCompatible(issuerKey, PrivateKey, [1, 2], 'issuer key');

	assert.optionalObject(options, 'options');
	if (options === undefined)
		options = {};
	assert.optionalObject(options.validFrom, 'options.validFrom');
	assert.optionalObject(options.validUntil, 'options.validUntil');
	var validFrom = options.validFrom;
	var validUntil = options.validUntil;
	if (validFrom === undefined)
		validFrom = new Date();
	if (validUntil === undefined) {
		assert.optionalNumber(options.lifetime, 'options.lifetime');
		var lifetime = options.lifetime;
		if (lifetime === undefined)
			lifetime = 10*365*24*3600;
		validUntil = new Date();
		validUntil.setTime(validUntil.getTime() + lifetime*1000);
	}
	assert.optionalBuffer(options.serial, 'options.serial');
	var serial = options.serial;
	if (serial === undefined)
		serial = Buffer.from('0000000000000001', 'hex');

	var purposes = options.purposes;
	if (purposes === undefined)
		purposes = [];

	if (purposes.indexOf('signature') === -1)
		purposes.push('signature');

	if (options.ca === true) {
		if (purposes.indexOf('ca') === -1)
			purposes.push('ca');
		if (purposes.indexOf('crl') === -1)
			purposes.push('crl');
	}

	var hostSubjects = subjects.filter(function (subject) {
		return (subject.type === 'host');
	});
	var userSubjects = subjects.filter(function (subject) {
		return (subject.type === 'user');
	});
	if (hostSubjects.length > 0) {
		if (purposes.indexOf('serverAuth') === -1)
			purposes.push('serverAuth');
	}
	if (userSubjects.length > 0) {
		if (purposes.indexOf('clientAuth') === -1)
			purposes.push('clientAuth');
	}
	if (userSubjects.length > 0 || hostSubjects.length > 0) {
		if (purposes.indexOf('keyAgreement') === -1)
			purposes.push('keyAgreement');
		if (key.type === 'rsa' &&
		    purposes.indexOf('encryption') === -1)
			purposes.push('encryption');
	}

	var cert = new Certificate({
		subjects: subjects,
		issuer: issuer,
		subjectKey: key,
		issuerKey: issuerKey.toPublic(),
		signatures: {},
		serial: serial,
		validFrom: validFrom,
		validUntil: validUntil,
		purposes: purposes
	});
	cert.signWith(issuerKey);

	return (cert);
};

Certificate.parse = function (data, format, options) {
	if (typeof (data) !== 'string')
		assert.buffer(data, 'data');
	if (format === undefined)
		format = 'auto';
	assert.string(format, 'format');
	if (typeof (options) === 'string')
		options = { filename: options };
	assert.optionalObject(options, 'options');
	if (options === undefined)
		options = {};
	assert.optionalString(options.filename, 'options.filename');
	if (options.filename === undefined)
		options.filename = '(unnamed)';

	assert.object(formats[format], 'formats[format]');

	try {
		var k = formats[format].read(data, options);
		return (k);
	} catch (e) {
		throw (new CertificateParseError(options.filename, format, e));
	}
};

Certificate.isCertificate = function (obj, ver) {
	return (utils.isCompatible(obj, Certificate, ver));
};

/*
 * API versions for Certificate:
 * [1,0] -- initial ver
 */
Certificate.prototype._sshpkApiVersion = [1, 0];

Certificate._oldVersionDetect = function (obj) {
	return ([1, 0]);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// Basic Javascript Elliptic Curve implementation
// Ported loosely from BouncyCastle's Java EC code
// Only Fp curves implemented for now

// Requires jsbn.js and jsbn2.js
var BigInteger = __webpack_require__(25).BigInteger
var Barrett = BigInteger.prototype.Barrett

// ----------------
// ECFieldElementFp

// constructor
function ECFieldElementFp(q,x) {
    this.x = x;
    // TODO if(x.compareTo(q) >= 0) error
    this.q = q;
}

function feFpEquals(other) {
    if(other == this) return true;
    return (this.q.equals(other.q) && this.x.equals(other.x));
}

function feFpToBigInteger() {
    return this.x;
}

function feFpNegate() {
    return new ECFieldElementFp(this.q, this.x.negate().mod(this.q));
}

function feFpAdd(b) {
    return new ECFieldElementFp(this.q, this.x.add(b.toBigInteger()).mod(this.q));
}

function feFpSubtract(b) {
    return new ECFieldElementFp(this.q, this.x.subtract(b.toBigInteger()).mod(this.q));
}

function feFpMultiply(b) {
    return new ECFieldElementFp(this.q, this.x.multiply(b.toBigInteger()).mod(this.q));
}

function feFpSquare() {
    return new ECFieldElementFp(this.q, this.x.square().mod(this.q));
}

function feFpDivide(b) {
    return new ECFieldElementFp(this.q, this.x.multiply(b.toBigInteger().modInverse(this.q)).mod(this.q));
}

ECFieldElementFp.prototype.equals = feFpEquals;
ECFieldElementFp.prototype.toBigInteger = feFpToBigInteger;
ECFieldElementFp.prototype.negate = feFpNegate;
ECFieldElementFp.prototype.add = feFpAdd;
ECFieldElementFp.prototype.subtract = feFpSubtract;
ECFieldElementFp.prototype.multiply = feFpMultiply;
ECFieldElementFp.prototype.square = feFpSquare;
ECFieldElementFp.prototype.divide = feFpDivide;

// ----------------
// ECPointFp

// constructor
function ECPointFp(curve,x,y,z) {
    this.curve = curve;
    this.x = x;
    this.y = y;
    // Projective coordinates: either zinv == null or z * zinv == 1
    // z and zinv are just BigIntegers, not fieldElements
    if(z == null) {
      this.z = BigInteger.ONE;
    }
    else {
      this.z = z;
    }
    this.zinv = null;
    //TODO: compression flag
}

function pointFpGetX() {
    if(this.zinv == null) {
      this.zinv = this.z.modInverse(this.curve.q);
    }
    var r = this.x.toBigInteger().multiply(this.zinv);
    this.curve.reduce(r);
    return this.curve.fromBigInteger(r);
}

function pointFpGetY() {
    if(this.zinv == null) {
      this.zinv = this.z.modInverse(this.curve.q);
    }
    var r = this.y.toBigInteger().multiply(this.zinv);
    this.curve.reduce(r);
    return this.curve.fromBigInteger(r);
}

function pointFpEquals(other) {
    if(other == this) return true;
    if(this.isInfinity()) return other.isInfinity();
    if(other.isInfinity()) return this.isInfinity();
    var u, v;
    // u = Y2 * Z1 - Y1 * Z2
    u = other.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(other.z)).mod(this.curve.q);
    if(!u.equals(BigInteger.ZERO)) return false;
    // v = X2 * Z1 - X1 * Z2
    v = other.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(other.z)).mod(this.curve.q);
    return v.equals(BigInteger.ZERO);
}

function pointFpIsInfinity() {
    if((this.x == null) && (this.y == null)) return true;
    return this.z.equals(BigInteger.ZERO) && !this.y.toBigInteger().equals(BigInteger.ZERO);
}

function pointFpNegate() {
    return new ECPointFp(this.curve, this.x, this.y.negate(), this.z);
}

function pointFpAdd(b) {
    if(this.isInfinity()) return b;
    if(b.isInfinity()) return this;

    // u = Y2 * Z1 - Y1 * Z2
    var u = b.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(b.z)).mod(this.curve.q);
    // v = X2 * Z1 - X1 * Z2
    var v = b.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(b.z)).mod(this.curve.q);

    if(BigInteger.ZERO.equals(v)) {
        if(BigInteger.ZERO.equals(u)) {
            return this.twice(); // this == b, so double
        }
	return this.curve.getInfinity(); // this = -b, so infinity
    }

    var THREE = new BigInteger("3");
    var x1 = this.x.toBigInteger();
    var y1 = this.y.toBigInteger();
    var x2 = b.x.toBigInteger();
    var y2 = b.y.toBigInteger();

    var v2 = v.square();
    var v3 = v2.multiply(v);
    var x1v2 = x1.multiply(v2);
    var zu2 = u.square().multiply(this.z);

    // x3 = v * (z2 * (z1 * u^2 - 2 * x1 * v^2) - v^3)
    var x3 = zu2.subtract(x1v2.shiftLeft(1)).multiply(b.z).subtract(v3).multiply(v).mod(this.curve.q);
    // y3 = z2 * (3 * x1 * u * v^2 - y1 * v^3 - z1 * u^3) + u * v^3
    var y3 = x1v2.multiply(THREE).multiply(u).subtract(y1.multiply(v3)).subtract(zu2.multiply(u)).multiply(b.z).add(u.multiply(v3)).mod(this.curve.q);
    // z3 = v^3 * z1 * z2
    var z3 = v3.multiply(this.z).multiply(b.z).mod(this.curve.q);

    return new ECPointFp(this.curve, this.curve.fromBigInteger(x3), this.curve.fromBigInteger(y3), z3);
}

function pointFpTwice() {
    if(this.isInfinity()) return this;
    if(this.y.toBigInteger().signum() == 0) return this.curve.getInfinity();

    // TODO: optimized handling of constants
    var THREE = new BigInteger("3");
    var x1 = this.x.toBigInteger();
    var y1 = this.y.toBigInteger();

    var y1z1 = y1.multiply(this.z);
    var y1sqz1 = y1z1.multiply(y1).mod(this.curve.q);
    var a = this.curve.a.toBigInteger();

    // w = 3 * x1^2 + a * z1^2
    var w = x1.square().multiply(THREE);
    if(!BigInteger.ZERO.equals(a)) {
      w = w.add(this.z.square().multiply(a));
    }
    w = w.mod(this.curve.q);
    //this.curve.reduce(w);
    // x3 = 2 * y1 * z1 * (w^2 - 8 * x1 * y1^2 * z1)
    var x3 = w.square().subtract(x1.shiftLeft(3).multiply(y1sqz1)).shiftLeft(1).multiply(y1z1).mod(this.curve.q);
    // y3 = 4 * y1^2 * z1 * (3 * w * x1 - 2 * y1^2 * z1) - w^3
    var y3 = w.multiply(THREE).multiply(x1).subtract(y1sqz1.shiftLeft(1)).shiftLeft(2).multiply(y1sqz1).subtract(w.square().multiply(w)).mod(this.curve.q);
    // z3 = 8 * (y1 * z1)^3
    var z3 = y1z1.square().multiply(y1z1).shiftLeft(3).mod(this.curve.q);

    return new ECPointFp(this.curve, this.curve.fromBigInteger(x3), this.curve.fromBigInteger(y3), z3);
}

// Simple NAF (Non-Adjacent Form) multiplication algorithm
// TODO: modularize the multiplication algorithm
function pointFpMultiply(k) {
    if(this.isInfinity()) return this;
    if(k.signum() == 0) return this.curve.getInfinity();

    var e = k;
    var h = e.multiply(new BigInteger("3"));

    var neg = this.negate();
    var R = this;

    var i;
    for(i = h.bitLength() - 2; i > 0; --i) {
	R = R.twice();

	var hBit = h.testBit(i);
	var eBit = e.testBit(i);

	if (hBit != eBit) {
	    R = R.add(hBit ? this : neg);
	}
    }

    return R;
}

// Compute this*j + x*k (simultaneous multiplication)
function pointFpMultiplyTwo(j,x,k) {
  var i;
  if(j.bitLength() > k.bitLength())
    i = j.bitLength() - 1;
  else
    i = k.bitLength() - 1;

  var R = this.curve.getInfinity();
  var both = this.add(x);
  while(i >= 0) {
    R = R.twice();
    if(j.testBit(i)) {
      if(k.testBit(i)) {
        R = R.add(both);
      }
      else {
        R = R.add(this);
      }
    }
    else {
      if(k.testBit(i)) {
        R = R.add(x);
      }
    }
    --i;
  }

  return R;
}

ECPointFp.prototype.getX = pointFpGetX;
ECPointFp.prototype.getY = pointFpGetY;
ECPointFp.prototype.equals = pointFpEquals;
ECPointFp.prototype.isInfinity = pointFpIsInfinity;
ECPointFp.prototype.negate = pointFpNegate;
ECPointFp.prototype.add = pointFpAdd;
ECPointFp.prototype.twice = pointFpTwice;
ECPointFp.prototype.multiply = pointFpMultiply;
ECPointFp.prototype.multiplyTwo = pointFpMultiplyTwo;

// ----------------
// ECCurveFp

// constructor
function ECCurveFp(q,a,b) {
    this.q = q;
    this.a = this.fromBigInteger(a);
    this.b = this.fromBigInteger(b);
    this.infinity = new ECPointFp(this, null, null);
    this.reducer = new Barrett(this.q);
}

function curveFpGetQ() {
    return this.q;
}

function curveFpGetA() {
    return this.a;
}

function curveFpGetB() {
    return this.b;
}

function curveFpEquals(other) {
    if(other == this) return true;
    return(this.q.equals(other.q) && this.a.equals(other.a) && this.b.equals(other.b));
}

function curveFpGetInfinity() {
    return this.infinity;
}

function curveFpFromBigInteger(x) {
    return new ECFieldElementFp(this.q, x);
}

function curveReduce(x) {
    this.reducer.reduce(x);
}

// for now, work with hex strings because they're easier in JS
function curveFpDecodePointHex(s) {
    switch(parseInt(s.substr(0,2), 16)) { // first byte
    case 0:
	return this.infinity;
    case 2:
    case 3:
	// point compression not supported yet
	return null;
    case 4:
    case 6:
    case 7:
	var len = (s.length - 2) / 2;
	var xHex = s.substr(2, len);
	var yHex = s.substr(len+2, len);

	return new ECPointFp(this,
			     this.fromBigInteger(new BigInteger(xHex, 16)),
			     this.fromBigInteger(new BigInteger(yHex, 16)));

    default: // unsupported
	return null;
    }
}

function curveFpEncodePointHex(p) {
	if (p.isInfinity()) return "00";
	var xHex = p.getX().toBigInteger().toString(16);
	var yHex = p.getY().toBigInteger().toString(16);
	var oLen = this.getQ().toString(16).length;
	if ((oLen % 2) != 0) oLen++;
	while (xHex.length < oLen) {
		xHex = "0" + xHex;
	}
	while (yHex.length < oLen) {
		yHex = "0" + yHex;
	}
	return "04" + xHex + yHex;
}

ECCurveFp.prototype.getQ = curveFpGetQ;
ECCurveFp.prototype.getA = curveFpGetA;
ECCurveFp.prototype.getB = curveFpGetB;
ECCurveFp.prototype.equals = curveFpEquals;
ECCurveFp.prototype.getInfinity = curveFpGetInfinity;
ECCurveFp.prototype.fromBigInteger = curveFpFromBigInteger;
ECCurveFp.prototype.reduce = curveReduce;
//ECCurveFp.prototype.decodePointHex = curveFpDecodePointHex;
ECCurveFp.prototype.encodePointHex = curveFpEncodePointHex;

// from: https://github.com/kaielvin/jsbn-ec-point-compression
ECCurveFp.prototype.decodePointHex = function(s)
{
	var yIsEven;
    switch(parseInt(s.substr(0,2), 16)) { // first byte
    case 0:
	return this.infinity;
    case 2:
	yIsEven = false;
    case 3:
	if(yIsEven == undefined) yIsEven = true;
	var len = s.length - 2;
	var xHex = s.substr(2, len);
	var x = this.fromBigInteger(new BigInteger(xHex,16));
	var alpha = x.multiply(x.square().add(this.getA())).add(this.getB());
	var beta = alpha.sqrt();

    if (beta == null) throw "Invalid point compression";

    var betaValue = beta.toBigInteger();
    if (betaValue.testBit(0) != yIsEven)
    {
        // Use the other root
        beta = this.fromBigInteger(this.getQ().subtract(betaValue));
    }
    return new ECPointFp(this,x,beta);
    case 4:
    case 6:
    case 7:
	var len = (s.length - 2) / 2;
	var xHex = s.substr(2, len);
	var yHex = s.substr(len+2, len);

	return new ECPointFp(this,
			     this.fromBigInteger(new BigInteger(xHex, 16)),
			     this.fromBigInteger(new BigInteger(yHex, 16)));

    default: // unsupported
	return null;
    }
}
ECCurveFp.prototype.encodeCompressedPointHex = function(p)
{
	if (p.isInfinity()) return "00";
	var xHex = p.getX().toBigInteger().toString(16);
	var oLen = this.getQ().toString(16).length;
	if ((oLen % 2) != 0) oLen++;
	while (xHex.length < oLen)
		xHex = "0" + xHex;
	var yPrefix;
	if(p.getY().toBigInteger().isEven()) yPrefix = "02";
	else                                 yPrefix = "03";

	return yPrefix + xHex;
}


ECFieldElementFp.prototype.getR = function()
{
	if(this.r != undefined) return this.r;

    this.r = null;
    var bitLength = this.q.bitLength();
    if (bitLength > 128)
    {
        var firstWord = this.q.shiftRight(bitLength - 64);
        if (firstWord.intValue() == -1)
        {
            this.r = BigInteger.ONE.shiftLeft(bitLength).subtract(this.q);
        }
    }
    return this.r;
}
ECFieldElementFp.prototype.modMult = function(x1,x2)
{
    return this.modReduce(x1.multiply(x2));
}
ECFieldElementFp.prototype.modReduce = function(x)
{
    if (this.getR() != null)
    {
        var qLen = q.bitLength();
        while (x.bitLength() > (qLen + 1))
        {
            var u = x.shiftRight(qLen);
            var v = x.subtract(u.shiftLeft(qLen));
            if (!this.getR().equals(BigInteger.ONE))
            {
                u = u.multiply(this.getR());
            }
            x = u.add(v); 
        }
        while (x.compareTo(q) >= 0)
        {
            x = x.subtract(q);
        }
    }
    else
    {
        x = x.mod(q);
    }
    return x;
}
ECFieldElementFp.prototype.sqrt = function()
{
    if (!this.q.testBit(0)) throw "unsupported";

    // p mod 4 == 3
    if (this.q.testBit(1))
    {
    	var z = new ECFieldElementFp(this.q,this.x.modPow(this.q.shiftRight(2).add(BigInteger.ONE),this.q));
    	return z.square().equals(this) ? z : null;
    }

    // p mod 4 == 1
    var qMinusOne = this.q.subtract(BigInteger.ONE);

    var legendreExponent = qMinusOne.shiftRight(1);
    if (!(this.x.modPow(legendreExponent, this.q).equals(BigInteger.ONE)))
    {
        return null;
    }

    var u = qMinusOne.shiftRight(2);
    var k = u.shiftLeft(1).add(BigInteger.ONE);

    var Q = this.x;
    var fourQ = modDouble(modDouble(Q));

    var U, V;
    do
    {
        var P;
        do
        {
            P = new BigInteger(this.q.bitLength(), new SecureRandom());
        }
        while (P.compareTo(this.q) >= 0
            || !(P.multiply(P).subtract(fourQ).modPow(legendreExponent, this.q).equals(qMinusOne)));

        var result = this.lucasSequence(P, Q, k);
        U = result[0];
        V = result[1];

        if (this.modMult(V, V).equals(fourQ))
        {
            // Integer division by 2, mod q
            if (V.testBit(0))
            {
                V = V.add(q);
            }

            V = V.shiftRight(1);

            return new ECFieldElementFp(q,V);
        }
    }
    while (U.equals(BigInteger.ONE) || U.equals(qMinusOne));

    return null;
}
ECFieldElementFp.prototype.lucasSequence = function(P,Q,k)
{
    var n = k.bitLength();
    var s = k.getLowestSetBit();

    var Uh = BigInteger.ONE;
    var Vl = BigInteger.TWO;
    var Vh = P;
    var Ql = BigInteger.ONE;
    var Qh = BigInteger.ONE;

    for (var j = n - 1; j >= s + 1; --j)
    {
        Ql = this.modMult(Ql, Qh);

        if (k.testBit(j))
        {
            Qh = this.modMult(Ql, Q);
            Uh = this.modMult(Uh, Vh);
            Vl = this.modReduce(Vh.multiply(Vl).subtract(P.multiply(Ql)));
            Vh = this.modReduce(Vh.multiply(Vh).subtract(Qh.shiftLeft(1)));
        }
        else
        {
            Qh = Ql;
            Uh = this.modReduce(Uh.multiply(Vl).subtract(Ql));
            Vh = this.modReduce(Vh.multiply(Vl).subtract(P.multiply(Ql)));
            Vl = this.modReduce(Vl.multiply(Vl).subtract(Ql.shiftLeft(1)));
        }
    }

    Ql = this.modMult(Ql, Qh);
    Qh = this.modMult(Ql, Q);
    Uh = this.modReduce(Uh.multiply(Vl).subtract(Ql));
    Vl = this.modReduce(Vh.multiply(Vl).subtract(P.multiply(Ql)));
    Ql = this.modMult(Ql, Qh);

    for (var j = 1; j <= s; ++j)
    {
        Uh = this.modMult(Uh, Vl);
        Vl = this.modReduce(Vl.multiply(Vl).subtract(Ql.shiftLeft(1)));
        Ql = this.modMult(Ql, Ql);
    }

    return [ Uh, Vl ];
}

var exports = {
  ECCurveFp: ECCurveFp,
  ECPointFp: ECPointFp,
  ECFieldElementFp: ECFieldElementFp
}

module.exports = exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

module.exports = {
	read: read,
	readPkcs8: readPkcs8,
	write: write,
	writePkcs8: writePkcs8,

	readECDSACurve: readECDSACurve,
	writeECDSACurve: writeECDSACurve
};

var assert = __webpack_require__(3);
var asn1 = __webpack_require__(22);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var utils = __webpack_require__(9);
var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);
var pem = __webpack_require__(26);

function read(buf, options) {
	return (pem.read(buf, options, 'pkcs8'));
}

function write(key, options) {
	return (pem.write(key, options, 'pkcs8'));
}

/* Helper to read in a single mpint */
function readMPInt(der, nm) {
	assert.strictEqual(der.peek(), asn1.Ber.Integer,
	    nm + ' is not an Integer');
	return (utils.mpNormalize(der.readString(asn1.Ber.Integer, true)));
}

function readPkcs8(alg, type, der) {
	/* Private keys in pkcs#8 format have a weird extra int */
	if (der.peek() === asn1.Ber.Integer) {
		assert.strictEqual(type, 'private',
		    'unexpected Integer at start of public key');
		der.readString(asn1.Ber.Integer, true);
	}

	der.readSequence();
	var next = der.offset + der.length;

	var oid = der.readOID();
	switch (oid) {
	case '1.2.840.113549.1.1.1':
		der._offset = next;
		if (type === 'public')
			return (readPkcs8RSAPublic(der));
		else
			return (readPkcs8RSAPrivate(der));
	case '1.2.840.10040.4.1':
		if (type === 'public')
			return (readPkcs8DSAPublic(der));
		else
			return (readPkcs8DSAPrivate(der));
	case '1.2.840.10045.2.1':
		if (type === 'public')
			return (readPkcs8ECDSAPublic(der));
		else
			return (readPkcs8ECDSAPrivate(der));
	case '1.3.101.112':
		if (type === 'public') {
			return (readPkcs8EdDSAPublic(der));
		} else {
			return (readPkcs8EdDSAPrivate(der));
		}
	case '1.3.101.110':
		if (type === 'public') {
			return (readPkcs8X25519Public(der));
		} else {
			return (readPkcs8X25519Private(der));
		}
	default:
		throw (new Error('Unknown key type OID ' + oid));
	}
}

function readPkcs8RSAPublic(der) {
	// bit string sequence
	der.readSequence(asn1.Ber.BitString);
	der.readByte();
	der.readSequence();

	// modulus
	var n = readMPInt(der, 'modulus');
	var e = readMPInt(der, 'exponent');

	// now, make the key
	var key = {
		type: 'rsa',
		source: der.originalInput,
		parts: [
			{ name: 'e', data: e },
			{ name: 'n', data: n }
		]
	};

	return (new Key(key));
}

function readPkcs8RSAPrivate(der) {
	der.readSequence(asn1.Ber.OctetString);
	der.readSequence();

	var ver = readMPInt(der, 'version');
	assert.equal(ver[0], 0x0, 'unknown RSA private key version');

	// modulus then public exponent
	var n = readMPInt(der, 'modulus');
	var e = readMPInt(der, 'public exponent');
	var d = readMPInt(der, 'private exponent');
	var p = readMPInt(der, 'prime1');
	var q = readMPInt(der, 'prime2');
	var dmodp = readMPInt(der, 'exponent1');
	var dmodq = readMPInt(der, 'exponent2');
	var iqmp = readMPInt(der, 'iqmp');

	// now, make the key
	var key = {
		type: 'rsa',
		parts: [
			{ name: 'n', data: n },
			{ name: 'e', data: e },
			{ name: 'd', data: d },
			{ name: 'iqmp', data: iqmp },
			{ name: 'p', data: p },
			{ name: 'q', data: q },
			{ name: 'dmodp', data: dmodp },
			{ name: 'dmodq', data: dmodq }
		]
	};

	return (new PrivateKey(key));
}

function readPkcs8DSAPublic(der) {
	der.readSequence();

	var p = readMPInt(der, 'p');
	var q = readMPInt(der, 'q');
	var g = readMPInt(der, 'g');

	// bit string sequence
	der.readSequence(asn1.Ber.BitString);
	der.readByte();

	var y = readMPInt(der, 'y');

	// now, make the key
	var key = {
		type: 'dsa',
		parts: [
			{ name: 'p', data: p },
			{ name: 'q', data: q },
			{ name: 'g', data: g },
			{ name: 'y', data: y }
		]
	};

	return (new Key(key));
}

function readPkcs8DSAPrivate(der) {
	der.readSequence();

	var p = readMPInt(der, 'p');
	var q = readMPInt(der, 'q');
	var g = readMPInt(der, 'g');

	der.readSequence(asn1.Ber.OctetString);
	var x = readMPInt(der, 'x');

	/* The pkcs#8 format does not include the public key */
	var y = utils.calculateDSAPublic(g, p, x);

	var key = {
		type: 'dsa',
		parts: [
			{ name: 'p', data: p },
			{ name: 'q', data: q },
			{ name: 'g', data: g },
			{ name: 'y', data: y },
			{ name: 'x', data: x }
		]
	};

	return (new PrivateKey(key));
}

function readECDSACurve(der) {
	var curveName, curveNames;
	var j, c, cd;

	if (der.peek() === asn1.Ber.OID) {
		var oid = der.readOID();

		curveNames = Object.keys(algs.curves);
		for (j = 0; j < curveNames.length; ++j) {
			c = curveNames[j];
			cd = algs.curves[c];
			if (cd.pkcs8oid === oid) {
				curveName = c;
				break;
			}
		}

	} else {
		// ECParameters sequence
		der.readSequence();
		var version = der.readString(asn1.Ber.Integer, true);
		assert.strictEqual(version[0], 1, 'ECDSA key not version 1');

		var curve = {};

		// FieldID sequence
		der.readSequence();
		var fieldTypeOid = der.readOID();
		assert.strictEqual(fieldTypeOid, '1.2.840.10045.1.1',
		    'ECDSA key is not from a prime-field');
		var p = curve.p = utils.mpNormalize(
		    der.readString(asn1.Ber.Integer, true));
		/*
		 * p always starts with a 1 bit, so count the zeros to get its
		 * real size.
		 */
		curve.size = p.length * 8 - utils.countZeros(p);

		// Curve sequence
		der.readSequence();
		curve.a = utils.mpNormalize(
		    der.readString(asn1.Ber.OctetString, true));
		curve.b = utils.mpNormalize(
		    der.readString(asn1.Ber.OctetString, true));
		if (der.peek() === asn1.Ber.BitString)
			curve.s = der.readString(asn1.Ber.BitString, true);

		// Combined Gx and Gy
		curve.G = der.readString(asn1.Ber.OctetString, true);
		assert.strictEqual(curve.G[0], 0x4,
		    'uncompressed G is required');

		curve.n = utils.mpNormalize(
		    der.readString(asn1.Ber.Integer, true));
		curve.h = utils.mpNormalize(
		    der.readString(asn1.Ber.Integer, true));
		assert.strictEqual(curve.h[0], 0x1, 'a cofactor=1 curve is ' +
		    'required');

		curveNames = Object.keys(algs.curves);
		var ks = Object.keys(curve);
		for (j = 0; j < curveNames.length; ++j) {
			c = curveNames[j];
			cd = algs.curves[c];
			var equal = true;
			for (var i = 0; i < ks.length; ++i) {
				var k = ks[i];
				if (cd[k] === undefined)
					continue;
				if (typeof (cd[k]) === 'object' &&
				    cd[k].equals !== undefined) {
					if (!cd[k].equals(curve[k])) {
						equal = false;
						break;
					}
				} else if (Buffer.isBuffer(cd[k])) {
					if (cd[k].toString('binary')
					    !== curve[k].toString('binary')) {
						equal = false;
						break;
					}
				} else {
					if (cd[k] !== curve[k]) {
						equal = false;
						break;
					}
				}
			}
			if (equal) {
				curveName = c;
				break;
			}
		}
	}
	return (curveName);
}

function readPkcs8ECDSAPrivate(der) {
	var curveName = readECDSACurve(der);
	assert.string(curveName, 'a known elliptic curve');

	der.readSequence(asn1.Ber.OctetString);
	der.readSequence();

	var version = readMPInt(der, 'version');
	assert.equal(version[0], 1, 'unknown version of ECDSA key');

	var d = der.readString(asn1.Ber.OctetString, true);
	der.readSequence(0xa1);

	var Q = der.readString(asn1.Ber.BitString, true);
	Q = utils.ecNormalize(Q);

	var key = {
		type: 'ecdsa',
		parts: [
			{ name: 'curve', data: Buffer.from(curveName) },
			{ name: 'Q', data: Q },
			{ name: 'd', data: d }
		]
	};

	return (new PrivateKey(key));
}

function readPkcs8ECDSAPublic(der) {
	var curveName = readECDSACurve(der);
	assert.string(curveName, 'a known elliptic curve');

	var Q = der.readString(asn1.Ber.BitString, true);
	Q = utils.ecNormalize(Q);

	var key = {
		type: 'ecdsa',
		parts: [
			{ name: 'curve', data: Buffer.from(curveName) },
			{ name: 'Q', data: Q }
		]
	};

	return (new Key(key));
}

function readPkcs8EdDSAPublic(der) {
	if (der.peek() === 0x00)
		der.readByte();

	var A = utils.readBitString(der);

	var key = {
		type: 'ed25519',
		parts: [
			{ name: 'A', data: utils.zeroPadToLength(A, 32) }
		]
	};

	return (new Key(key));
}

function readPkcs8X25519Public(der) {
	var A = utils.readBitString(der);

	var key = {
		type: 'curve25519',
		parts: [
			{ name: 'A', data: utils.zeroPadToLength(A, 32) }
		]
	};

	return (new Key(key));
}

function readPkcs8EdDSAPrivate(der) {
	if (der.peek() === 0x00)
		der.readByte();

	der.readSequence(asn1.Ber.OctetString);
	var k = der.readString(asn1.Ber.OctetString, true);
	k = utils.zeroPadToLength(k, 32);

	var A;
	if (der.peek() === asn1.Ber.BitString) {
		A = utils.readBitString(der);
		A = utils.zeroPadToLength(A, 32);
	} else {
		A = utils.calculateED25519Public(k);
	}

	var key = {
		type: 'ed25519',
		parts: [
			{ name: 'A', data: utils.zeroPadToLength(A, 32) },
			{ name: 'k', data: utils.zeroPadToLength(k, 32) }
		]
	};

	return (new PrivateKey(key));
}

function readPkcs8X25519Private(der) {
	if (der.peek() === 0x00)
		der.readByte();

	der.readSequence(asn1.Ber.OctetString);
	var k = der.readString(asn1.Ber.OctetString, true);
	k = utils.zeroPadToLength(k, 32);

	var A = utils.calculateX25519Public(k);

	var key = {
		type: 'curve25519',
		parts: [
			{ name: 'A', data: utils.zeroPadToLength(A, 32) },
			{ name: 'k', data: utils.zeroPadToLength(k, 32) }
		]
	};

	return (new PrivateKey(key));
}

function writePkcs8(der, key) {
	der.startSequence();

	if (PrivateKey.isPrivateKey(key)) {
		var sillyInt = Buffer.from([0]);
		der.writeBuffer(sillyInt, asn1.Ber.Integer);
	}

	der.startSequence();
	switch (key.type) {
	case 'rsa':
		der.writeOID('1.2.840.113549.1.1.1');
		if (PrivateKey.isPrivateKey(key))
			writePkcs8RSAPrivate(key, der);
		else
			writePkcs8RSAPublic(key, der);
		break;
	case 'dsa':
		der.writeOID('1.2.840.10040.4.1');
		if (PrivateKey.isPrivateKey(key))
			writePkcs8DSAPrivate(key, der);
		else
			writePkcs8DSAPublic(key, der);
		break;
	case 'ecdsa':
		der.writeOID('1.2.840.10045.2.1');
		if (PrivateKey.isPrivateKey(key))
			writePkcs8ECDSAPrivate(key, der);
		else
			writePkcs8ECDSAPublic(key, der);
		break;
	case 'ed25519':
		der.writeOID('1.3.101.112');
		if (PrivateKey.isPrivateKey(key))
			throw (new Error('Ed25519 private keys in pkcs8 ' +
			    'format are not supported'));
		writePkcs8EdDSAPublic(key, der);
		break;
	default:
		throw (new Error('Unsupported key type: ' + key.type));
	}

	der.endSequence();
}

function writePkcs8RSAPrivate(key, der) {
	der.writeNull();
	der.endSequence();

	der.startSequence(asn1.Ber.OctetString);
	der.startSequence();

	var version = Buffer.from([0]);
	der.writeBuffer(version, asn1.Ber.Integer);

	der.writeBuffer(key.part.n.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.e.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.d.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.p.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.q.data, asn1.Ber.Integer);
	if (!key.part.dmodp || !key.part.dmodq)
		utils.addRSAMissing(key);
	der.writeBuffer(key.part.dmodp.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.dmodq.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.iqmp.data, asn1.Ber.Integer);

	der.endSequence();
	der.endSequence();
}

function writePkcs8RSAPublic(key, der) {
	der.writeNull();
	der.endSequence();

	der.startSequence(asn1.Ber.BitString);
	der.writeByte(0x00);

	der.startSequence();
	der.writeBuffer(key.part.n.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.e.data, asn1.Ber.Integer);
	der.endSequence();

	der.endSequence();
}

function writePkcs8DSAPrivate(key, der) {
	der.startSequence();
	der.writeBuffer(key.part.p.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.q.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.g.data, asn1.Ber.Integer);
	der.endSequence();

	der.endSequence();

	der.startSequence(asn1.Ber.OctetString);
	der.writeBuffer(key.part.x.data, asn1.Ber.Integer);
	der.endSequence();
}

function writePkcs8DSAPublic(key, der) {
	der.startSequence();
	der.writeBuffer(key.part.p.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.q.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.g.data, asn1.Ber.Integer);
	der.endSequence();
	der.endSequence();

	der.startSequence(asn1.Ber.BitString);
	der.writeByte(0x00);
	der.writeBuffer(key.part.y.data, asn1.Ber.Integer);
	der.endSequence();
}

function writeECDSACurve(key, der) {
	var curve = algs.curves[key.curve];
	if (curve.pkcs8oid) {
		/* This one has a name in pkcs#8, so just write the oid */
		der.writeOID(curve.pkcs8oid);

	} else {
		// ECParameters sequence
		der.startSequence();

		var version = Buffer.from([1]);
		der.writeBuffer(version, asn1.Ber.Integer);

		// FieldID sequence
		der.startSequence();
		der.writeOID('1.2.840.10045.1.1'); // prime-field
		der.writeBuffer(curve.p, asn1.Ber.Integer);
		der.endSequence();

		// Curve sequence
		der.startSequence();
		var a = curve.p;
		if (a[0] === 0x0)
			a = a.slice(1);
		der.writeBuffer(a, asn1.Ber.OctetString);
		der.writeBuffer(curve.b, asn1.Ber.OctetString);
		der.writeBuffer(curve.s, asn1.Ber.BitString);
		der.endSequence();

		der.writeBuffer(curve.G, asn1.Ber.OctetString);
		der.writeBuffer(curve.n, asn1.Ber.Integer);
		var h = curve.h;
		if (!h) {
			h = Buffer.from([1]);
		}
		der.writeBuffer(h, asn1.Ber.Integer);

		// ECParameters
		der.endSequence();
	}
}

function writePkcs8ECDSAPublic(key, der) {
	writeECDSACurve(key, der);
	der.endSequence();

	var Q = utils.ecNormalize(key.part.Q.data, true);
	der.writeBuffer(Q, asn1.Ber.BitString);
}

function writePkcs8ECDSAPrivate(key, der) {
	writeECDSACurve(key, der);
	der.endSequence();

	der.startSequence(asn1.Ber.OctetString);
	der.startSequence();

	var version = Buffer.from([1]);
	der.writeBuffer(version, asn1.Ber.Integer);

	der.writeBuffer(key.part.d.data, asn1.Ber.OctetString);

	der.startSequence(0xa1);
	var Q = utils.ecNormalize(key.part.Q.data, true);
	der.writeBuffer(Q, asn1.Ber.BitString);
	der.endSequence();

	der.endSequence();
	der.endSequence();
}

function writePkcs8EdDSAPublic(key, der) {
	der.endSequence();

	utils.writeBitString(der, key.part.A.data);
}

function writePkcs8EdDSAPrivate(key, der) {
	der.endSequence();

	var k = utils.mpNormalize(key.part.k.data, true);
	der.startSequence(asn1.Ber.OctetString);
	der.writeBuffer(k, asn1.Ber.OctetString);
	der.endSequence();
}


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

module.exports = SSHBuffer;

var assert = __webpack_require__(3);
var Buffer = __webpack_require__(4).Buffer;

function SSHBuffer(opts) {
	assert.object(opts, 'options');
	if (opts.buffer !== undefined)
		assert.buffer(opts.buffer, 'options.buffer');

	this._size = opts.buffer ? opts.buffer.length : 1024;
	this._buffer = opts.buffer || Buffer.alloc(this._size);
	this._offset = 0;
}

SSHBuffer.prototype.toBuffer = function () {
	return (this._buffer.slice(0, this._offset));
};

SSHBuffer.prototype.atEnd = function () {
	return (this._offset >= this._buffer.length);
};

SSHBuffer.prototype.remainder = function () {
	return (this._buffer.slice(this._offset));
};

SSHBuffer.prototype.skip = function (n) {
	this._offset += n;
};

SSHBuffer.prototype.expand = function () {
	this._size *= 2;
	var buf = Buffer.alloc(this._size);
	this._buffer.copy(buf, 0);
	this._buffer = buf;
};

SSHBuffer.prototype.readPart = function () {
	return ({data: this.readBuffer()});
};

SSHBuffer.prototype.readBuffer = function () {
	var len = this._buffer.readUInt32BE(this._offset);
	this._offset += 4;
	assert.ok(this._offset + len <= this._buffer.length,
	    'length out of bounds at +0x' + this._offset.toString(16) +
	    ' (data truncated?)');
	var buf = this._buffer.slice(this._offset, this._offset + len);
	this._offset += len;
	return (buf);
};

SSHBuffer.prototype.readString = function () {
	return (this.readBuffer().toString());
};

SSHBuffer.prototype.readCString = function () {
	var offset = this._offset;
	while (offset < this._buffer.length &&
	    this._buffer[offset] !== 0x00)
		offset++;
	assert.ok(offset < this._buffer.length, 'c string does not terminate');
	var str = this._buffer.slice(this._offset, offset).toString();
	this._offset = offset + 1;
	return (str);
};

SSHBuffer.prototype.readInt = function () {
	var v = this._buffer.readUInt32BE(this._offset);
	this._offset += 4;
	return (v);
};

SSHBuffer.prototype.readInt64 = function () {
	assert.ok(this._offset + 8 < this._buffer.length,
	    'buffer not long enough to read Int64');
	var v = this._buffer.slice(this._offset, this._offset + 8);
	this._offset += 8;
	return (v);
};

SSHBuffer.prototype.readChar = function () {
	var v = this._buffer[this._offset++];
	return (v);
};

SSHBuffer.prototype.writeBuffer = function (buf) {
	while (this._offset + 4 + buf.length > this._size)
		this.expand();
	this._buffer.writeUInt32BE(buf.length, this._offset);
	this._offset += 4;
	buf.copy(this._buffer, this._offset);
	this._offset += buf.length;
};

SSHBuffer.prototype.writeString = function (str) {
	this.writeBuffer(Buffer.from(str, 'utf8'));
};

SSHBuffer.prototype.writeCString = function (str) {
	while (this._offset + 1 + str.length > this._size)
		this.expand();
	this._buffer.write(str, this._offset);
	this._offset += str.length;
	this._buffer[this._offset++] = 0;
};

SSHBuffer.prototype.writeInt = function (v) {
	while (this._offset + 4 > this._size)
		this.expand();
	this._buffer.writeUInt32BE(v, this._offset);
	this._offset += 4;
};

SSHBuffer.prototype.writeInt64 = function (v) {
	assert.buffer(v, 'value');
	if (v.length > 8) {
		var lead = v.slice(0, v.length - 8);
		for (var i = 0; i < lead.length; ++i) {
			assert.strictEqual(lead[i], 0,
			    'must fit in 64 bits of precision');
		}
		v = v.slice(v.length - 8, v.length);
	}
	while (this._offset + 8 > this._size)
		this.expand();
	v.copy(this._buffer, this._offset);
	this._offset += 8;
};

SSHBuffer.prototype.writeChar = function (v) {
	while (this._offset + 1 > this._size)
		this.expand();
	this._buffer[this._offset++] = v;
};

SSHBuffer.prototype.writePart = function (p) {
	this.writeBuffer(p.data);
};

SSHBuffer.prototype.write = function (buf) {
	while (this._offset + buf.length > this._size)
		this.expand();
	buf.copy(this._buffer, this._offset);
	this._offset += buf.length;
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2017 Joyent, Inc.

module.exports = Identity;

var assert = __webpack_require__(3);
var algs = __webpack_require__(12);
var crypto = __webpack_require__(7);
var Fingerprint = __webpack_require__(42);
var Signature = __webpack_require__(20);
var errs = __webpack_require__(19);
var util = __webpack_require__(5);
var utils = __webpack_require__(9);
var asn1 = __webpack_require__(22);
var Buffer = __webpack_require__(4).Buffer;

/*JSSTYLED*/
var DNS_NAME_RE = /^([*]|[a-z0-9][a-z0-9\-]{0,62})(?:\.([*]|[a-z0-9][a-z0-9\-]{0,62}))*$/i;

var oids = {};
oids.cn = '2.5.4.3';
oids.o = '2.5.4.10';
oids.ou = '2.5.4.11';
oids.l = '2.5.4.7';
oids.s = '2.5.4.8';
oids.c = '2.5.4.6';
oids.sn = '2.5.4.4';
oids.dc = '0.9.2342.19200300.100.1.25';
oids.uid = '0.9.2342.19200300.100.1.1';
oids.mail = '0.9.2342.19200300.100.1.3';

var unoids = {};
Object.keys(oids).forEach(function (k) {
	unoids[oids[k]] = k;
});

function Identity(opts) {
	var self = this;
	assert.object(opts, 'options');
	assert.arrayOfObject(opts.components, 'options.components');
	this.components = opts.components;
	this.componentLookup = {};
	this.components.forEach(function (c) {
		if (c.name && !c.oid)
			c.oid = oids[c.name];
		if (c.oid && !c.name)
			c.name = unoids[c.oid];
		if (self.componentLookup[c.name] === undefined)
			self.componentLookup[c.name] = [];
		self.componentLookup[c.name].push(c);
	});
	if (this.componentLookup.cn && this.componentLookup.cn.length > 0) {
		this.cn = this.componentLookup.cn[0].value;
	}
	assert.optionalString(opts.type, 'options.type');
	if (opts.type === undefined) {
		if (this.components.length === 1 &&
		    this.componentLookup.cn &&
		    this.componentLookup.cn.length === 1 &&
		    this.componentLookup.cn[0].value.match(DNS_NAME_RE)) {
			this.type = 'host';
			this.hostname = this.componentLookup.cn[0].value;

		} else if (this.componentLookup.dc &&
		    this.components.length === this.componentLookup.dc.length) {
			this.type = 'host';
			this.hostname = this.componentLookup.dc.map(
			    function (c) {
				return (c.value);
			}).join('.');

		} else if (this.componentLookup.uid &&
		    this.components.length ===
		    this.componentLookup.uid.length) {
			this.type = 'user';
			this.uid = this.componentLookup.uid[0].value;

		} else if (this.componentLookup.cn &&
		    this.componentLookup.cn.length === 1 &&
		    this.componentLookup.cn[0].value.match(DNS_NAME_RE)) {
			this.type = 'host';
			this.hostname = this.componentLookup.cn[0].value;

		} else if (this.componentLookup.uid &&
		    this.componentLookup.uid.length === 1) {
			this.type = 'user';
			this.uid = this.componentLookup.uid[0].value;

		} else if (this.componentLookup.mail &&
		    this.componentLookup.mail.length === 1) {
			this.type = 'email';
			this.email = this.componentLookup.mail[0].value;

		} else if (this.componentLookup.cn &&
		    this.componentLookup.cn.length === 1) {
			this.type = 'user';
			this.uid = this.componentLookup.cn[0].value;

		} else {
			this.type = 'unknown';
		}
	} else {
		this.type = opts.type;
		if (this.type === 'host')
			this.hostname = opts.hostname;
		else if (this.type === 'user')
			this.uid = opts.uid;
		else if (this.type === 'email')
			this.email = opts.email;
		else
			throw (new Error('Unknown type ' + this.type));
	}
}

Identity.prototype.toString = function () {
	return (this.components.map(function (c) {
		return (c.name.toUpperCase() + '=' + c.value);
	}).join(', '));
};

/*
 * These are from X.680 -- PrintableString allowed chars are in section 37.4
 * table 8. Spec for IA5Strings is "1,6 + SPACE + DEL" where 1 refers to
 * ISO IR #001 (standard ASCII control characters) and 6 refers to ISO IR #006
 * (the basic ASCII character set).
 */
/* JSSTYLED */
var NOT_PRINTABLE = /[^a-zA-Z0-9 '(),+.\/:=?-]/;
/* JSSTYLED */
var NOT_IA5 = /[^\x00-\x7f]/;

Identity.prototype.toAsn1 = function (der, tag) {
	der.startSequence(tag);
	this.components.forEach(function (c) {
		der.startSequence(asn1.Ber.Constructor | asn1.Ber.Set);
		der.startSequence();
		der.writeOID(c.oid);
		/*
		 * If we fit in a PrintableString, use that. Otherwise use an
		 * IA5String or UTF8String.
		 *
		 * If this identity was parsed from a DN, use the ASN.1 types
		 * from the original representation (otherwise this might not
		 * be a full match for the original in some validators).
		 */
		if (c.asn1type === asn1.Ber.Utf8String ||
		    c.value.match(NOT_IA5)) {
			var v = Buffer.from(c.value, 'utf8');
			der.writeBuffer(v, asn1.Ber.Utf8String);

		} else if (c.asn1type === asn1.Ber.IA5String ||
		    c.value.match(NOT_PRINTABLE)) {
			der.writeString(c.value, asn1.Ber.IA5String);

		} else {
			var type = asn1.Ber.PrintableString;
			if (c.asn1type !== undefined)
				type = c.asn1type;
			der.writeString(c.value, type);
		}
		der.endSequence();
		der.endSequence();
	});
	der.endSequence();
};

function globMatch(a, b) {
	if (a === '**' || b === '**')
		return (true);
	var aParts = a.split('.');
	var bParts = b.split('.');
	if (aParts.length !== bParts.length)
		return (false);
	for (var i = 0; i < aParts.length; ++i) {
		if (aParts[i] === '*' || bParts[i] === '*')
			continue;
		if (aParts[i] !== bParts[i])
			return (false);
	}
	return (true);
}

Identity.prototype.equals = function (other) {
	if (!Identity.isIdentity(other, [1, 0]))
		return (false);
	if (other.components.length !== this.components.length)
		return (false);
	for (var i = 0; i < this.components.length; ++i) {
		if (this.components[i].oid !== other.components[i].oid)
			return (false);
		if (!globMatch(this.components[i].value,
		    other.components[i].value)) {
			return (false);
		}
	}
	return (true);
};

Identity.forHost = function (hostname) {
	assert.string(hostname, 'hostname');
	return (new Identity({
		type: 'host',
		hostname: hostname,
		components: [ { name: 'cn', value: hostname } ]
	}));
};

Identity.forUser = function (uid) {
	assert.string(uid, 'uid');
	return (new Identity({
		type: 'user',
		uid: uid,
		components: [ { name: 'uid', value: uid } ]
	}));
};

Identity.forEmail = function (email) {
	assert.string(email, 'email');
	return (new Identity({
		type: 'email',
		email: email,
		components: [ { name: 'mail', value: email } ]
	}));
};

Identity.parseDN = function (dn) {
	assert.string(dn, 'dn');
	var parts = dn.split(',');
	var cmps = parts.map(function (c) {
		c = c.trim();
		var eqPos = c.indexOf('=');
		var name = c.slice(0, eqPos).toLowerCase();
		var value = c.slice(eqPos + 1);
		return ({ name: name, value: value });
	});
	return (new Identity({ components: cmps }));
};

Identity.parseAsn1 = function (der, top) {
	var components = [];
	der.readSequence(top);
	var end = der.offset + der.length;
	while (der.offset < end) {
		der.readSequence(asn1.Ber.Constructor | asn1.Ber.Set);
		var after = der.offset + der.length;
		der.readSequence();
		var oid = der.readOID();
		var type = der.peek();
		var value;
		switch (type) {
		case asn1.Ber.PrintableString:
		case asn1.Ber.IA5String:
		case asn1.Ber.OctetString:
		case asn1.Ber.T61String:
			value = der.readString(type);
			break;
		case asn1.Ber.Utf8String:
			value = der.readString(type, true);
			value = value.toString('utf8');
			break;
		case asn1.Ber.CharacterString:
		case asn1.Ber.BMPString:
			value = der.readString(type, true);
			value = value.toString('utf16le');
			break;
		default:
			throw (new Error('Unknown asn1 type ' + type));
		}
		components.push({ oid: oid, asn1type: type, value: value });
		der._offset = after;
	}
	der._offset = end;
	return (new Identity({
		components: components
	}));
};

Identity.isIdentity = function (obj, ver) {
	return (utils.isCompatible(obj, Identity, ver));
};

/*
 * API versions for Identity:
 * [1,0] -- initial ver
 */
Identity.prototype._sshpkApiVersion = [1, 0];

Identity._oldVersionDetect = function (obj) {
	return ([1, 0]);
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(174);
exports.encode = exports.stringify = __webpack_require__(175);


/***/ }),
/* 49 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(1).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer
var MD5 = __webpack_require__(65)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(227);
curve.short = __webpack_require__(228);
curve.mont = __webpack_require__(229);
curve.edwards = __webpack_require__(230);


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var asn1 = __webpack_require__(246)
var aesid = __webpack_require__(258)
var fixProc = __webpack_require__(259)
var ciphers = __webpack_require__(71)
var compat = __webpack_require__(104)
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = new Buffer(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen)
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2012 Joyent, Inc.  All rights reserved.

var assert = __webpack_require__(3);
var sshpk = __webpack_require__(76);
var util = __webpack_require__(5);

var HASH_ALGOS = {
  'sha1': true,
  'sha256': true,
  'sha512': true
};

var PK_ALGOS = {
  'rsa': true,
  'dsa': true,
  'ecdsa': true
};

function HttpSignatureError(message, caller) {
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, caller || HttpSignatureError);

  this.message = message;
  this.name = caller.name;
}
util.inherits(HttpSignatureError, Error);

function InvalidAlgorithmError(message) {
  HttpSignatureError.call(this, message, InvalidAlgorithmError);
}
util.inherits(InvalidAlgorithmError, HttpSignatureError);

function validateAlgorithm(algorithm) {
  var alg = algorithm.toLowerCase().split('-');

  if (alg.length !== 2) {
    throw (new InvalidAlgorithmError(alg[0].toUpperCase() + ' is not a ' +
      'valid algorithm'));
  }

  if (alg[0] !== 'hmac' && !PK_ALGOS[alg[0]]) {
    throw (new InvalidAlgorithmError(alg[0].toUpperCase() + ' type keys ' +
      'are not supported'));
  }

  if (!HASH_ALGOS[alg[1]]) {
    throw (new InvalidAlgorithmError(alg[1].toUpperCase() + ' is not a ' +
      'supported hash algorithm'));
  }

  return (alg);
}

///--- API

module.exports = {

  HASH_ALGOS: HASH_ALGOS,
  PK_ALGOS: PK_ALGOS,

  HttpSignatureError: HttpSignatureError,
  InvalidAlgorithmError: InvalidAlgorithmError,

  validateAlgorithm: validateAlgorithm,

  /**
   * Converts an OpenSSH public key (rsa only) to a PKCS#8 PEM file.
   *
   * The intent of this module is to interoperate with OpenSSL only,
   * specifically the node crypto module's `verify` method.
   *
   * @param {String} key an OpenSSH public key.
   * @return {String} PEM encoded form of the RSA public key.
   * @throws {TypeError} on bad input.
   * @throws {Error} on invalid ssh key formatted data.
   */
  sshKeyToPEM: function sshKeyToPEM(key) {
    assert.string(key, 'ssh_key');

    var k = sshpk.parseKey(key, 'ssh');
    return (k.toString('pem'));
  },


  /**
   * Generates an OpenSSH fingerprint from an ssh public key.
   *
   * @param {String} key an OpenSSH public key.
   * @return {String} key fingerprint.
   * @throws {TypeError} on bad input.
   * @throws {Error} if what you passed doesn't look like an ssh public key.
   */
  fingerprint: function fingerprint(key) {
    assert.string(key, 'ssh_key');

    var k = sshpk.parseKey(key, 'ssh');
    return (k.fingerprint('md5').toString('hex'));
  },

  /**
   * Converts a PKGCS#8 PEM file to an OpenSSH public key (rsa)
   *
   * The reverse of the above function.
   */
  pemToRsaSSHKey: function pemToRsaSSHKey(pem, comment) {
    assert.equal('string', typeof (pem), 'typeof pem');

    var k = sshpk.parseKey(pem, 'pem');
    k.comment = comment;
    return (k.toString('ssh'));
  }
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

module.exports = {
	read: read,
	readSSHPrivate: readSSHPrivate,
	write: write
};

var assert = __webpack_require__(3);
var asn1 = __webpack_require__(22);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var utils = __webpack_require__(9);
var crypto = __webpack_require__(7);

var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);
var pem = __webpack_require__(26);
var rfc4253 = __webpack_require__(29);
var SSHBuffer = __webpack_require__(46);
var errors = __webpack_require__(19);

var bcrypt;

function read(buf, options) {
	return (pem.read(buf, options));
}

var MAGIC = 'openssh-key-v1';

function readSSHPrivate(type, buf, options) {
	buf = new SSHBuffer({buffer: buf});

	var magic = buf.readCString();
	assert.strictEqual(magic, MAGIC, 'bad magic string');

	var cipher = buf.readString();
	var kdf = buf.readString();
	var kdfOpts = buf.readBuffer();

	var nkeys = buf.readInt();
	if (nkeys !== 1) {
		throw (new Error('OpenSSH-format key file contains ' +
		    'multiple keys: this is unsupported.'));
	}

	var pubKey = buf.readBuffer();

	if (type === 'public') {
		assert.ok(buf.atEnd(), 'excess bytes left after key');
		return (rfc4253.read(pubKey));
	}

	var privKeyBlob = buf.readBuffer();
	assert.ok(buf.atEnd(), 'excess bytes left after key');

	var kdfOptsBuf = new SSHBuffer({ buffer: kdfOpts });
	switch (kdf) {
	case 'none':
		if (cipher !== 'none') {
			throw (new Error('OpenSSH-format key uses KDF "none" ' +
			     'but specifies a cipher other than "none"'));
		}
		break;
	case 'bcrypt':
		var salt = kdfOptsBuf.readBuffer();
		var rounds = kdfOptsBuf.readInt();
		var cinf = utils.opensshCipherInfo(cipher);
		if (bcrypt === undefined) {
			bcrypt = __webpack_require__(135);
		}

		if (typeof (options.passphrase) === 'string') {
			options.passphrase = Buffer.from(options.passphrase,
			    'utf-8');
		}
		if (!Buffer.isBuffer(options.passphrase)) {
			throw (new errors.KeyEncryptedError(
			    options.filename, 'OpenSSH'));
		}

		var pass = new Uint8Array(options.passphrase);
		var salti = new Uint8Array(salt);
		/* Use the pbkdf to derive both the key and the IV. */
		var out = new Uint8Array(cinf.keySize + cinf.blockSize);
		var res = bcrypt.pbkdf(pass, pass.length, salti, salti.length,
		    out, out.length, rounds);
		if (res !== 0) {
			throw (new Error('bcrypt_pbkdf function returned ' +
			    'failure, parameters invalid'));
		}
		out = Buffer.from(out);
		var ckey = out.slice(0, cinf.keySize);
		var iv = out.slice(cinf.keySize, cinf.keySize + cinf.blockSize);
		var cipherStream = crypto.createDecipheriv(cinf.opensslName,
		    ckey, iv);
		cipherStream.setAutoPadding(false);
		var chunk, chunks = [];
		cipherStream.once('error', function (e) {
			if (e.toString().indexOf('bad decrypt') !== -1) {
				throw (new Error('Incorrect passphrase ' +
				    'supplied, could not decrypt key'));
			}
			throw (e);
		});
		cipherStream.write(privKeyBlob);
		cipherStream.end();
		while ((chunk = cipherStream.read()) !== null)
			chunks.push(chunk);
		privKeyBlob = Buffer.concat(chunks);
		break;
	default:
		throw (new Error(
		    'OpenSSH-format key uses unknown KDF "' + kdf + '"'));
	}

	buf = new SSHBuffer({buffer: privKeyBlob});

	var checkInt1 = buf.readInt();
	var checkInt2 = buf.readInt();
	if (checkInt1 !== checkInt2) {
		throw (new Error('Incorrect passphrase supplied, could not ' +
		    'decrypt key'));
	}

	var ret = {};
	var key = rfc4253.readInternal(ret, 'private', buf.remainder());

	buf.skip(ret.consumed);

	var comment = buf.readString();
	key.comment = comment;

	return (key);
}

function write(key, options) {
	var pubKey;
	if (PrivateKey.isPrivateKey(key))
		pubKey = key.toPublic();
	else
		pubKey = key;

	var cipher = 'none';
	var kdf = 'none';
	var kdfopts = Buffer.alloc(0);
	var cinf = { blockSize: 8 };
	var passphrase;
	if (options !== undefined) {
		passphrase = options.passphrase;
		if (typeof (passphrase) === 'string')
			passphrase = Buffer.from(passphrase, 'utf-8');
		if (passphrase !== undefined) {
			assert.buffer(passphrase, 'options.passphrase');
			assert.optionalString(options.cipher, 'options.cipher');
			cipher = options.cipher;
			if (cipher === undefined)
				cipher = 'aes128-ctr';
			cinf = utils.opensshCipherInfo(cipher);
			kdf = 'bcrypt';
		}
	}

	var privBuf;
	if (PrivateKey.isPrivateKey(key)) {
		privBuf = new SSHBuffer({});
		var checkInt = crypto.randomBytes(4).readUInt32BE(0);
		privBuf.writeInt(checkInt);
		privBuf.writeInt(checkInt);
		privBuf.write(key.toBuffer('rfc4253'));
		privBuf.writeString(key.comment || '');

		var n = 1;
		while (privBuf._offset % cinf.blockSize !== 0)
			privBuf.writeChar(n++);
		privBuf = privBuf.toBuffer();
	}

	switch (kdf) {
	case 'none':
		break;
	case 'bcrypt':
		var salt = crypto.randomBytes(16);
		var rounds = 16;
		var kdfssh = new SSHBuffer({});
		kdfssh.writeBuffer(salt);
		kdfssh.writeInt(rounds);
		kdfopts = kdfssh.toBuffer();

		if (bcrypt === undefined) {
			bcrypt = __webpack_require__(135);
		}
		var pass = new Uint8Array(passphrase);
		var salti = new Uint8Array(salt);
		/* Use the pbkdf to derive both the key and the IV. */
		var out = new Uint8Array(cinf.keySize + cinf.blockSize);
		var res = bcrypt.pbkdf(pass, pass.length, salti, salti.length,
		    out, out.length, rounds);
		if (res !== 0) {
			throw (new Error('bcrypt_pbkdf function returned ' +
			    'failure, parameters invalid'));
		}
		out = Buffer.from(out);
		var ckey = out.slice(0, cinf.keySize);
		var iv = out.slice(cinf.keySize, cinf.keySize + cinf.blockSize);

		var cipherStream = crypto.createCipheriv(cinf.opensslName,
		    ckey, iv);
		cipherStream.setAutoPadding(false);
		var chunk, chunks = [];
		cipherStream.once('error', function (e) {
			throw (e);
		});
		cipherStream.write(privBuf);
		cipherStream.end();
		while ((chunk = cipherStream.read()) !== null)
			chunks.push(chunk);
		privBuf = Buffer.concat(chunks);
		break;
	default:
		throw (new Error('Unsupported kdf ' + kdf));
	}

	var buf = new SSHBuffer({});

	buf.writeCString(MAGIC);
	buf.writeString(cipher);	/* cipher */
	buf.writeString(kdf);		/* kdf */
	buf.writeBuffer(kdfopts);	/* kdfoptions */

	buf.writeInt(1);		/* nkeys */
	buf.writeBuffer(pubKey.toBuffer('rfc4253'));

	if (privBuf)
		buf.writeBuffer(privBuf);

	buf = buf.toBuffer();

	var header;
	if (PrivateKey.isPrivateKey(key))
		header = 'OPENSSH PRIVATE KEY';
	else
		header = 'OPENSSH PUBLIC KEY';

	var tmp = buf.toString('base64');
	var len = tmp.length + (tmp.length / 70) +
	    18 + 16 + header.length*2 + 10;
	buf = Buffer.alloc(len);
	var o = 0;
	o += buf.write('-----BEGIN ' + header + '-----\n', o);
	for (var i = 0; i < tmp.length; ) {
		var limit = i + 70;
		if (limit > tmp.length)
			limit = tmp.length;
		o += buf.write(tmp.slice(i, limit), o);
		buf[o++] = 10;
		i = limit;
	}
	o += buf.write('-----END ' + header + '-----\n', o);

	return (buf.slice(0, o));
}


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(364);
var bytesToUuid = __webpack_require__(365);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toolkit_metadata_json__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toolkit_metadata_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__toolkit_metadata_json__);
function CommunityComponent(props){var fraq=props.freq/props.totalFreq;var formattedDescription=props.desc;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'community',style:{'opacity':Math.min(1,0.1+2.0*(props.freq/props.maxFreq))}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name'},props.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc'},formattedDescription)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fraq',style:{width:Math.round(fraq*100)+"%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Math.round(fraq*100),'%'))));}function UserComponent(props){var communities=props.communities.split(";").map(function(c){return c.split(":");});communities.sort(function(a,b){return b[1]-a[1];});var totalFreq=communities.reduce(function(total,c){return total+parseFloat(c[1]);},0);var maxFreq=communities.reduce(function(total,c){return Math.max(total,parseFloat(c[1]));},0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'community-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Community name'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'left'}},'0%'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'User activity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'right'}},'100%'))),communities.map(function(c,i){var name=c[0];var freq=c[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CommunityComponent,{key:i,name:name,desc:__WEBPACK_IMPORTED_MODULE_1__toolkit_metadata_json___default.a[name]?__WEBPACK_IMPORTED_MODULE_1__toolkit_metadata_json___default.a[name]["description"]:null,freq:freq,totalFreq:totalFreq,maxFreq:maxFreq});}));}/* harmony default export */ __webpack_exports__["a"] = (UserComponent);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(88)(module), __webpack_require__(10)))

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate, process) {

var jsonSafeStringify = __webpack_require__(182)
var crypto = __webpack_require__(7)
var Buffer = __webpack_require__(1).Buffer

var defer = typeof setImmediate === 'undefined'
  ? process.nextTick
  : setImmediate

function paramsHaveRequestBody (params) {
  return (
    params.body ||
    params.requestBodyStream ||
    (params.json && typeof params.json !== 'boolean') ||
    params.multipart
  )
}

function safeStringify (obj, replacer) {
  var ret
  try {
    ret = JSON.stringify(obj, replacer)
  } catch (e) {
    ret = jsonSafeStringify(obj, replacer)
  }
  return ret
}

function md5 (str) {
  return crypto.createHash('md5').update(str).digest('hex')
}

function isReadStream (rs) {
  return rs.readable && rs.path && rs.mode
}

function toBase64 (str) {
  return Buffer.from(str || '', 'utf8').toString('base64')
}

function copy (obj) {
  var o = {}
  Object.keys(obj).forEach(function (i) {
    o[i] = obj[i]
  })
  return o
}

function version () {
  var numbers = process.version.replace('v', '').split('.')
  return {
    major: parseInt(numbers[0], 10),
    minor: parseInt(numbers[1], 10),
    patch: parseInt(numbers[2], 10)
  }
}

exports.paramsHaveRequestBody = paramsHaveRequestBody
exports.safeStringify = safeStringify
exports.md5 = md5
exports.isReadStream = isReadStream
exports.toBase64 = toBase64
exports.copy = copy
exports.version = version
exports.defer = defer

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64).setImmediate, __webpack_require__(6)))

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(181);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {
var inherits = __webpack_require__(0)
var HashBase = __webpack_require__(94)

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = new Buffer(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(50);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(32);
util.inherits = __webpack_require__(0);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(188)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(96);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(1).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(97);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(27);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(27);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(64).setImmediate, __webpack_require__(10)))

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(1).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(2).Buffer
var inherits = __webpack_require__(0)
var HashBase = __webpack_require__(94)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(194)
exports.sha1 = __webpack_require__(195)
exports.sha224 = __webpack_require__(196)
exports.sha256 = __webpack_require__(99)
exports.sha384 = __webpack_require__(197)
exports.sha512 = __webpack_require__(100)


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(203);
exports.Cipher = __webpack_require__(204);
exports.DES = __webpack_require__(205);
exports.CBC = __webpack_require__(206);
exports.EDE = __webpack_require__(207);


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(208)
var deciphers = __webpack_require__(216)
var modes = __webpack_require__(110)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(209),
  CBC: __webpack_require__(210),
  CFB: __webpack_require__(211),
  CFB8: __webpack_require__(212),
  CFB1: __webpack_require__(213),
  OFB: __webpack_require__(214),
  CTR: __webpack_require__(108),
  GCM: __webpack_require__(108)
}

var modes = __webpack_require__(110)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(8);
var randomBytes = __webpack_require__(31);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(18);
hash.common = __webpack_require__(38);
hash.sha = __webpack_require__(232);
hash.ripemd = __webpack_require__(236);
hash.hmac = __webpack_require__(237);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var http = __webpack_require__(41)
var url = __webpack_require__(16)

var https = module.exports

for (var key in http) {
  if (http.hasOwnProperty(key)) https[key] = http[key]
}

https.request = function (params, cb) {
  params = validateParams(params)
  return http.request.call(this, params, cb)
}

https.get = function (params, cb) {
  params = validateParams(params)
  return http.get.call(this, params, cb)
}

function validateParams (params) {
  if (typeof params === 'string') {
    params = url.parse(params)
  }
  if (!params.protocol) {
    params.protocol = 'https:'
  }
  if (params.protocol !== 'https:') {
    throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"')
  }
  return params
}


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

var Key = __webpack_require__(11);
var Fingerprint = __webpack_require__(42);
var Signature = __webpack_require__(20);
var PrivateKey = __webpack_require__(13);
var Certificate = __webpack_require__(43);
var Identity = __webpack_require__(47);
var errs = __webpack_require__(19);

module.exports = {
	/* top-level classes */
	Key: Key,
	parseKey: Key.parse,
	Fingerprint: Fingerprint,
	parseFingerprint: Fingerprint.parse,
	Signature: Signature,
	parseSignature: Signature.parse,
	PrivateKey: PrivateKey,
	parsePrivateKey: PrivateKey.parse,
	generatePrivateKey: PrivateKey.generate,
	Certificate: Certificate,
	parseCertificate: Certificate.parse,
	createSelfSignedCertificate: Certificate.createSelfSigned,
	createCertificate: Certificate.create,
	Identity: Identity,
	identityFromDN: Identity.parseDN,
	identityForHost: Identity.forHost,
	identityForUser: Identity.forUser,
	identityForEmail: Identity.forEmail,

	/* errors */
	FingerprintFormatError: errs.FingerprintFormatError,
	InvalidAlgorithmError: errs.InvalidAlgorithmError,
	KeyParseError: errs.KeyParseError,
	SignatureParseError: errs.SignatureParseError,
	KeyEncryptedError: errs.KeyEncryptedError,
	CertificateParseError: errs.CertificateParseError
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2017 Joyent, Inc.

module.exports = {
	DiffieHellman: DiffieHellman,
	generateECDSA: generateECDSA,
	generateED25519: generateED25519
};

var assert = __webpack_require__(3);
var crypto = __webpack_require__(7);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var utils = __webpack_require__(9);
var nacl;

var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);

var CRYPTO_HAVE_ECDH = (crypto.createECDH !== undefined);

var ecdh, ec, jsbn;

function DiffieHellman(key) {
	utils.assertCompatible(key, Key, [1, 4], 'key');
	this._isPriv = PrivateKey.isPrivateKey(key, [1, 3]);
	this._algo = key.type;
	this._curve = key.curve;
	this._key = key;
	if (key.type === 'dsa') {
		if (!CRYPTO_HAVE_ECDH) {
			throw (new Error('Due to bugs in the node 0.10 ' +
			    'crypto API, node 0.12.x or later is required ' +
			    'to use DH'));
		}
		this._dh = crypto.createDiffieHellman(
		    key.part.p.data, undefined,
		    key.part.g.data, undefined);
		this._p = key.part.p;
		this._g = key.part.g;
		if (this._isPriv)
			this._dh.setPrivateKey(key.part.x.data);
		this._dh.setPublicKey(key.part.y.data);

	} else if (key.type === 'ecdsa') {
		if (!CRYPTO_HAVE_ECDH) {
			if (ecdh === undefined)
				ecdh = __webpack_require__(132);
			if (ec === undefined)
				ec = __webpack_require__(44);
			if (jsbn === undefined)
				jsbn = __webpack_require__(25).BigInteger;

			this._ecParams = new X9ECParameters(this._curve);

			if (this._isPriv) {
				this._priv = new ECPrivate(
				    this._ecParams, key.part.d.data);
			}
			return;
		}

		var curve = {
			'nistp256': 'prime256v1',
			'nistp384': 'secp384r1',
			'nistp521': 'secp521r1'
		}[key.curve];
		this._dh = crypto.createECDH(curve);
		if (typeof (this._dh) !== 'object' ||
		    typeof (this._dh.setPrivateKey) !== 'function') {
			CRYPTO_HAVE_ECDH = false;
			DiffieHellman.call(this, key);
			return;
		}
		if (this._isPriv)
			this._dh.setPrivateKey(key.part.d.data);
		this._dh.setPublicKey(key.part.Q.data);

	} else if (key.type === 'curve25519') {
		if (nacl === undefined)
			nacl = __webpack_require__(21);

		if (this._isPriv) {
			utils.assertCompatible(key, PrivateKey, [1, 5], 'key');
			this._priv = key.part.k.data;
		}

	} else {
		throw (new Error('DH not supported for ' + key.type + ' keys'));
	}
}

DiffieHellman.prototype.getPublicKey = function () {
	if (this._isPriv)
		return (this._key.toPublic());
	return (this._key);
};

DiffieHellman.prototype.getPrivateKey = function () {
	if (this._isPriv)
		return (this._key);
	else
		return (undefined);
};
DiffieHellman.prototype.getKey = DiffieHellman.prototype.getPrivateKey;

DiffieHellman.prototype._keyCheck = function (pk, isPub) {
	assert.object(pk, 'key');
	if (!isPub)
		utils.assertCompatible(pk, PrivateKey, [1, 3], 'key');
	utils.assertCompatible(pk, Key, [1, 4], 'key');

	if (pk.type !== this._algo) {
		throw (new Error('A ' + pk.type + ' key cannot be used in ' +
		    this._algo + ' Diffie-Hellman'));
	}

	if (pk.curve !== this._curve) {
		throw (new Error('A key from the ' + pk.curve + ' curve ' +
		    'cannot be used with a ' + this._curve +
		    ' Diffie-Hellman'));
	}

	if (pk.type === 'dsa') {
		assert.deepEqual(pk.part.p, this._p,
		    'DSA key prime does not match');
		assert.deepEqual(pk.part.g, this._g,
		    'DSA key generator does not match');
	}
};

DiffieHellman.prototype.setKey = function (pk) {
	this._keyCheck(pk);

	if (pk.type === 'dsa') {
		this._dh.setPrivateKey(pk.part.x.data);
		this._dh.setPublicKey(pk.part.y.data);

	} else if (pk.type === 'ecdsa') {
		if (CRYPTO_HAVE_ECDH) {
			this._dh.setPrivateKey(pk.part.d.data);
			this._dh.setPublicKey(pk.part.Q.data);
		} else {
			this._priv = new ECPrivate(
			    this._ecParams, pk.part.d.data);
		}

	} else if (pk.type === 'curve25519') {
		var k = pk.part.k;
		if (!pk.part.k)
			k = pk.part.r;
		this._priv = k.data;
		if (this._priv[0] === 0x00)
			this._priv = this._priv.slice(1);
		this._priv = this._priv.slice(0, 32);
	}
	this._key = pk;
	this._isPriv = true;
};
DiffieHellman.prototype.setPrivateKey = DiffieHellman.prototype.setKey;

DiffieHellman.prototype.computeSecret = function (otherpk) {
	this._keyCheck(otherpk, true);
	if (!this._isPriv)
		throw (new Error('DH exchange has not been initialized with ' +
		    'a private key yet'));

	var pub;
	if (this._algo === 'dsa') {
		return (this._dh.computeSecret(
		    otherpk.part.y.data));

	} else if (this._algo === 'ecdsa') {
		if (CRYPTO_HAVE_ECDH) {
			return (this._dh.computeSecret(
			    otherpk.part.Q.data));
		} else {
			pub = new ECPublic(
			    this._ecParams, otherpk.part.Q.data);
			return (this._priv.deriveSharedSecret(pub));
		}

	} else if (this._algo === 'curve25519') {
		pub = otherpk.part.A.data;
		while (pub[0] === 0x00 && pub.length > 32)
			pub = pub.slice(1);
		var priv = this._priv;
		assert.strictEqual(pub.length, 32);
		assert.strictEqual(priv.length, 32);

		var secret = nacl.box.before(new Uint8Array(pub),
		    new Uint8Array(priv));

		return (Buffer.from(secret));
	}

	throw (new Error('Invalid algorithm: ' + this._algo));
};

DiffieHellman.prototype.generateKey = function () {
	var parts = [];
	var priv, pub;
	if (this._algo === 'dsa') {
		this._dh.generateKeys();

		parts.push({name: 'p', data: this._p.data});
		parts.push({name: 'q', data: this._key.part.q.data});
		parts.push({name: 'g', data: this._g.data});
		parts.push({name: 'y', data: this._dh.getPublicKey()});
		parts.push({name: 'x', data: this._dh.getPrivateKey()});
		this._key = new PrivateKey({
			type: 'dsa',
			parts: parts
		});
		this._isPriv = true;
		return (this._key);

	} else if (this._algo === 'ecdsa') {
		if (CRYPTO_HAVE_ECDH) {
			this._dh.generateKeys();

			parts.push({name: 'curve',
			    data: Buffer.from(this._curve)});
			parts.push({name: 'Q', data: this._dh.getPublicKey()});
			parts.push({name: 'd', data: this._dh.getPrivateKey()});
			this._key = new PrivateKey({
				type: 'ecdsa',
				curve: this._curve,
				parts: parts
			});
			this._isPriv = true;
			return (this._key);

		} else {
			var n = this._ecParams.getN();
			var r = new jsbn(crypto.randomBytes(n.bitLength()));
			var n1 = n.subtract(jsbn.ONE);
			priv = r.mod(n1).add(jsbn.ONE);
			pub = this._ecParams.getG().multiply(priv);

			priv = Buffer.from(priv.toByteArray());
			pub = Buffer.from(this._ecParams.getCurve().
			    encodePointHex(pub), 'hex');

			this._priv = new ECPrivate(this._ecParams, priv);

			parts.push({name: 'curve',
			    data: Buffer.from(this._curve)});
			parts.push({name: 'Q', data: pub});
			parts.push({name: 'd', data: priv});

			this._key = new PrivateKey({
				type: 'ecdsa',
				curve: this._curve,
				parts: parts
			});
			this._isPriv = true;
			return (this._key);
		}

	} else if (this._algo === 'curve25519') {
		var pair = nacl.box.keyPair();
		priv = Buffer.from(pair.secretKey);
		pub = Buffer.from(pair.publicKey);
		priv = Buffer.concat([priv, pub]);
		assert.strictEqual(priv.length, 64);
		assert.strictEqual(pub.length, 32);

		parts.push({name: 'A', data: pub});
		parts.push({name: 'k', data: priv});
		this._key = new PrivateKey({
			type: 'curve25519',
			parts: parts
		});
		this._isPriv = true;
		return (this._key);
	}

	throw (new Error('Invalid algorithm: ' + this._algo));
};
DiffieHellman.prototype.generateKeys = DiffieHellman.prototype.generateKey;

/* These are helpers for using ecc-jsbn (for node 0.10 compatibility). */

function X9ECParameters(name) {
	var params = algs.curves[name];
	assert.object(params);

	var p = new jsbn(params.p);
	var a = new jsbn(params.a);
	var b = new jsbn(params.b);
	var n = new jsbn(params.n);
	var h = jsbn.ONE;
	var curve = new ec.ECCurveFp(p, a, b);
	var G = curve.decodePointHex(params.G.toString('hex'));

	this.curve = curve;
	this.g = G;
	this.n = n;
	this.h = h;
}
X9ECParameters.prototype.getCurve = function () { return (this.curve); };
X9ECParameters.prototype.getG = function () { return (this.g); };
X9ECParameters.prototype.getN = function () { return (this.n); };
X9ECParameters.prototype.getH = function () { return (this.h); };

function ECPublic(params, buffer) {
	this._params = params;
	if (buffer[0] === 0x00)
		buffer = buffer.slice(1);
	this._pub = params.getCurve().decodePointHex(buffer.toString('hex'));
}

function ECPrivate(params, buffer) {
	this._params = params;
	this._priv = new jsbn(utils.mpNormalize(buffer));
}
ECPrivate.prototype.deriveSharedSecret = function (pubKey) {
	assert.ok(pubKey instanceof ECPublic);
	var S = pubKey._pub.multiply(this._priv);
	return (Buffer.from(S.getX().toBigInteger().toByteArray()));
};

function generateED25519() {
	if (nacl === undefined)
		nacl = __webpack_require__(21);

	var pair = nacl.sign.keyPair();
	var priv = Buffer.from(pair.secretKey);
	var pub = Buffer.from(pair.publicKey);
	assert.strictEqual(priv.length, 64);
	assert.strictEqual(pub.length, 32);

	var parts = [];
	parts.push({name: 'A', data: pub});
	parts.push({name: 'k', data: priv.slice(0, 32)});
	var key = new PrivateKey({
		type: 'ed25519',
		parts: parts
	});
	return (key);
}

/* Generates a new ECDSA private key on a given curve. */
function generateECDSA(curve) {
	var parts = [];
	var key;

	if (CRYPTO_HAVE_ECDH) {
		/*
		 * Node crypto doesn't expose key generation directly, but the
		 * ECDH instances can generate keys. It turns out this just
		 * calls into the OpenSSL generic key generator, and we can
		 * read its output happily without doing an actual DH. So we
		 * use that here.
		 */
		var osCurve = {
			'nistp256': 'prime256v1',
			'nistp384': 'secp384r1',
			'nistp521': 'secp521r1'
		}[curve];

		var dh = crypto.createECDH(osCurve);
		dh.generateKeys();

		parts.push({name: 'curve',
		    data: Buffer.from(curve)});
		parts.push({name: 'Q', data: dh.getPublicKey()});
		parts.push({name: 'd', data: dh.getPrivateKey()});

		key = new PrivateKey({
			type: 'ecdsa',
			curve: curve,
			parts: parts
		});
		return (key);
	} else {
		if (ecdh === undefined)
			ecdh = __webpack_require__(132);
		if (ec === undefined)
			ec = __webpack_require__(44);
		if (jsbn === undefined)
			jsbn = __webpack_require__(25).BigInteger;

		var ecParams = new X9ECParameters(curve);

		/* This algorithm taken from FIPS PUB 186-4 (section B.4.1) */
		var n = ecParams.getN();
		/*
		 * The crypto.randomBytes() function can only give us whole
		 * bytes, so taking a nod from X9.62, we round up.
		 */
		var cByteLen = Math.ceil((n.bitLength() + 64) / 8);
		var c = new jsbn(crypto.randomBytes(cByteLen));

		var n1 = n.subtract(jsbn.ONE);
		var priv = c.mod(n1).add(jsbn.ONE);
		var pub = ecParams.getG().multiply(priv);

		priv = Buffer.from(priv.toByteArray());
		pub = Buffer.from(ecParams.getCurve().
		    encodePointHex(pub), 'hex');

		parts.push({name: 'curve', data: Buffer.from(curve)});
		parts.push({name: 'Q', data: pub});
		parts.push({name: 'd', data: priv});

		key = new PrivateKey({
			type: 'ecdsa',
			curve: curve,
			parts: parts
		});
		return (key);
	}
}


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.


module.exports = {

  newInvalidAsn1Error: function (msg) {
    var e = new Error();
    e.name = 'InvalidAsn1Error';
    e.message = msg || '';
    return e;
  }

};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.


module.exports = {
  EOC: 0,
  Boolean: 1,
  Integer: 2,
  BitString: 3,
  OctetString: 4,
  Null: 5,
  OID: 6,
  ObjectDescriptor: 7,
  External: 8,
  Real: 9, // float
  Enumeration: 10,
  PDV: 11,
  Utf8String: 12,
  RelativeOID: 13,
  Sequence: 16,
  Set: 17,
  NumericString: 18,
  PrintableString: 19,
  T61String: 20,
  VideotexString: 21,
  IA5String: 22,
  UTCTime: 23,
  GeneralizedTime: 24,
  GraphicString: 25,
  VisibleString: 26,
  GeneralString: 28,
  UniversalString: 29,
  CharacterString: 30,
  BMPString: 31,
  Constructor: 32,
  Context: 128
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

module.exports = {
	read: read,
	readPkcs1: readPkcs1,
	write: write,
	writePkcs1: writePkcs1
};

var assert = __webpack_require__(3);
var asn1 = __webpack_require__(22);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var utils = __webpack_require__(9);

var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);
var pem = __webpack_require__(26);

var pkcs8 = __webpack_require__(45);
var readECDSACurve = pkcs8.readECDSACurve;

function read(buf, options) {
	return (pem.read(buf, options, 'pkcs1'));
}

function write(key, options) {
	return (pem.write(key, options, 'pkcs1'));
}

/* Helper to read in a single mpint */
function readMPInt(der, nm) {
	assert.strictEqual(der.peek(), asn1.Ber.Integer,
	    nm + ' is not an Integer');
	return (utils.mpNormalize(der.readString(asn1.Ber.Integer, true)));
}

function readPkcs1(alg, type, der) {
	switch (alg) {
	case 'RSA':
		if (type === 'public')
			return (readPkcs1RSAPublic(der));
		else if (type === 'private')
			return (readPkcs1RSAPrivate(der));
		throw (new Error('Unknown key type: ' + type));
	case 'DSA':
		if (type === 'public')
			return (readPkcs1DSAPublic(der));
		else if (type === 'private')
			return (readPkcs1DSAPrivate(der));
		throw (new Error('Unknown key type: ' + type));
	case 'EC':
	case 'ECDSA':
		if (type === 'private')
			return (readPkcs1ECDSAPrivate(der));
		else if (type === 'public')
			return (readPkcs1ECDSAPublic(der));
		throw (new Error('Unknown key type: ' + type));
	case 'EDDSA':
	case 'EdDSA':
		if (type === 'private')
			return (readPkcs1EdDSAPrivate(der));
		throw (new Error(type + ' keys not supported with EdDSA'));
	default:
		throw (new Error('Unknown key algo: ' + alg));
	}
}

function readPkcs1RSAPublic(der) {
	// modulus and exponent
	var n = readMPInt(der, 'modulus');
	var e = readMPInt(der, 'exponent');

	// now, make the key
	var key = {
		type: 'rsa',
		parts: [
			{ name: 'e', data: e },
			{ name: 'n', data: n }
		]
	};

	return (new Key(key));
}

function readPkcs1RSAPrivate(der) {
	var version = readMPInt(der, 'version');
	assert.strictEqual(version[0], 0);

	// modulus then public exponent
	var n = readMPInt(der, 'modulus');
	var e = readMPInt(der, 'public exponent');
	var d = readMPInt(der, 'private exponent');
	var p = readMPInt(der, 'prime1');
	var q = readMPInt(der, 'prime2');
	var dmodp = readMPInt(der, 'exponent1');
	var dmodq = readMPInt(der, 'exponent2');
	var iqmp = readMPInt(der, 'iqmp');

	// now, make the key
	var key = {
		type: 'rsa',
		parts: [
			{ name: 'n', data: n },
			{ name: 'e', data: e },
			{ name: 'd', data: d },
			{ name: 'iqmp', data: iqmp },
			{ name: 'p', data: p },
			{ name: 'q', data: q },
			{ name: 'dmodp', data: dmodp },
			{ name: 'dmodq', data: dmodq }
		]
	};

	return (new PrivateKey(key));
}

function readPkcs1DSAPrivate(der) {
	var version = readMPInt(der, 'version');
	assert.strictEqual(version.readUInt8(0), 0);

	var p = readMPInt(der, 'p');
	var q = readMPInt(der, 'q');
	var g = readMPInt(der, 'g');
	var y = readMPInt(der, 'y');
	var x = readMPInt(der, 'x');

	// now, make the key
	var key = {
		type: 'dsa',
		parts: [
			{ name: 'p', data: p },
			{ name: 'q', data: q },
			{ name: 'g', data: g },
			{ name: 'y', data: y },
			{ name: 'x', data: x }
		]
	};

	return (new PrivateKey(key));
}

function readPkcs1EdDSAPrivate(der) {
	var version = readMPInt(der, 'version');
	assert.strictEqual(version.readUInt8(0), 1);

	// private key
	var k = der.readString(asn1.Ber.OctetString, true);

	der.readSequence(0xa0);
	var oid = der.readOID();
	assert.strictEqual(oid, '1.3.101.112', 'the ed25519 curve identifier');

	der.readSequence(0xa1);
	var A = utils.readBitString(der);

	var key = {
		type: 'ed25519',
		parts: [
			{ name: 'A', data: utils.zeroPadToLength(A, 32) },
			{ name: 'k', data: k }
		]
	};

	return (new PrivateKey(key));
}

function readPkcs1DSAPublic(der) {
	var y = readMPInt(der, 'y');
	var p = readMPInt(der, 'p');
	var q = readMPInt(der, 'q');
	var g = readMPInt(der, 'g');

	var key = {
		type: 'dsa',
		parts: [
			{ name: 'y', data: y },
			{ name: 'p', data: p },
			{ name: 'q', data: q },
			{ name: 'g', data: g }
		]
	};

	return (new Key(key));
}

function readPkcs1ECDSAPublic(der) {
	der.readSequence();

	var oid = der.readOID();
	assert.strictEqual(oid, '1.2.840.10045.2.1', 'must be ecPublicKey');

	var curveOid = der.readOID();

	var curve;
	var curves = Object.keys(algs.curves);
	for (var j = 0; j < curves.length; ++j) {
		var c = curves[j];
		var cd = algs.curves[c];
		if (cd.pkcs8oid === curveOid) {
			curve = c;
			break;
		}
	}
	assert.string(curve, 'a known ECDSA named curve');

	var Q = der.readString(asn1.Ber.BitString, true);
	Q = utils.ecNormalize(Q);

	var key = {
		type: 'ecdsa',
		parts: [
			{ name: 'curve', data: Buffer.from(curve) },
			{ name: 'Q', data: Q }
		]
	};

	return (new Key(key));
}

function readPkcs1ECDSAPrivate(der) {
	var version = readMPInt(der, 'version');
	assert.strictEqual(version.readUInt8(0), 1);

	// private key
	var d = der.readString(asn1.Ber.OctetString, true);

	der.readSequence(0xa0);
	var curve = readECDSACurve(der);
	assert.string(curve, 'a known elliptic curve');

	der.readSequence(0xa1);
	var Q = der.readString(asn1.Ber.BitString, true);
	Q = utils.ecNormalize(Q);

	var key = {
		type: 'ecdsa',
		parts: [
			{ name: 'curve', data: Buffer.from(curve) },
			{ name: 'Q', data: Q },
			{ name: 'd', data: d }
		]
	};

	return (new PrivateKey(key));
}

function writePkcs1(der, key) {
	der.startSequence();

	switch (key.type) {
	case 'rsa':
		if (PrivateKey.isPrivateKey(key))
			writePkcs1RSAPrivate(der, key);
		else
			writePkcs1RSAPublic(der, key);
		break;
	case 'dsa':
		if (PrivateKey.isPrivateKey(key))
			writePkcs1DSAPrivate(der, key);
		else
			writePkcs1DSAPublic(der, key);
		break;
	case 'ecdsa':
		if (PrivateKey.isPrivateKey(key))
			writePkcs1ECDSAPrivate(der, key);
		else
			writePkcs1ECDSAPublic(der, key);
		break;
	case 'ed25519':
		if (PrivateKey.isPrivateKey(key))
			writePkcs1EdDSAPrivate(der, key);
		else
			writePkcs1EdDSAPublic(der, key);
		break;
	default:
		throw (new Error('Unknown key algo: ' + key.type));
	}

	der.endSequence();
}

function writePkcs1RSAPublic(der, key) {
	der.writeBuffer(key.part.n.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.e.data, asn1.Ber.Integer);
}

function writePkcs1RSAPrivate(der, key) {
	var ver = Buffer.from([0]);
	der.writeBuffer(ver, asn1.Ber.Integer);

	der.writeBuffer(key.part.n.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.e.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.d.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.p.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.q.data, asn1.Ber.Integer);
	if (!key.part.dmodp || !key.part.dmodq)
		utils.addRSAMissing(key);
	der.writeBuffer(key.part.dmodp.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.dmodq.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.iqmp.data, asn1.Ber.Integer);
}

function writePkcs1DSAPrivate(der, key) {
	var ver = Buffer.from([0]);
	der.writeBuffer(ver, asn1.Ber.Integer);

	der.writeBuffer(key.part.p.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.q.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.g.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.y.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.x.data, asn1.Ber.Integer);
}

function writePkcs1DSAPublic(der, key) {
	der.writeBuffer(key.part.y.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.p.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.q.data, asn1.Ber.Integer);
	der.writeBuffer(key.part.g.data, asn1.Ber.Integer);
}

function writePkcs1ECDSAPublic(der, key) {
	der.startSequence();

	der.writeOID('1.2.840.10045.2.1'); /* ecPublicKey */
	var curve = key.part.curve.data.toString();
	var curveOid = algs.curves[curve].pkcs8oid;
	assert.string(curveOid, 'a known ECDSA named curve');
	der.writeOID(curveOid);

	der.endSequence();

	var Q = utils.ecNormalize(key.part.Q.data, true);
	der.writeBuffer(Q, asn1.Ber.BitString);
}

function writePkcs1ECDSAPrivate(der, key) {
	var ver = Buffer.from([1]);
	der.writeBuffer(ver, asn1.Ber.Integer);

	der.writeBuffer(key.part.d.data, asn1.Ber.OctetString);

	der.startSequence(0xa0);
	var curve = key.part.curve.data.toString();
	var curveOid = algs.curves[curve].pkcs8oid;
	assert.string(curveOid, 'a known ECDSA named curve');
	der.writeOID(curveOid);
	der.endSequence();

	der.startSequence(0xa1);
	var Q = utils.ecNormalize(key.part.Q.data, true);
	der.writeBuffer(Q, asn1.Ber.BitString);
	der.endSequence();
}

function writePkcs1EdDSAPrivate(der, key) {
	var ver = Buffer.from([1]);
	der.writeBuffer(ver, asn1.Ber.Integer);

	der.writeBuffer(key.part.k.data, asn1.Ber.OctetString);

	der.startSequence(0xa0);
	der.writeOID('1.3.101.112');
	der.endSequence();

	der.startSequence(0xa1);
	utils.writeBitString(der, key.part.A.data);
	der.endSequence();
}

function writePkcs1EdDSAPublic(der, key) {
	throw (new Error('Public keys are not supported for EdDSA PKCS#1'));
}


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2017 Joyent, Inc.

module.exports = {
	read: read,
	write: write
};

var assert = __webpack_require__(3);
var Buffer = __webpack_require__(4).Buffer;
var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);
var utils = __webpack_require__(9);
var SSHBuffer = __webpack_require__(46);
var Dhe = __webpack_require__(77);

var supportedAlgos = {
	'rsa-sha1' : 5,
	'rsa-sha256' : 8,
	'rsa-sha512' : 10,
	'ecdsa-p256-sha256' : 13,
	'ecdsa-p384-sha384' : 14
	/*
	 * ed25519 is hypothetically supported with id 15
	 * but the common tools available don't appear to be
	 * capable of generating/using ed25519 keys
	 */
};

var supportedAlgosById = {};
Object.keys(supportedAlgos).forEach(function (k) {
	supportedAlgosById[supportedAlgos[k]] = k.toUpperCase();
});

function read(buf, options) {
	if (typeof (buf) !== 'string') {
		assert.buffer(buf, 'buf');
		buf = buf.toString('ascii');
	}
	var lines = buf.split('\n');
	if (lines[0].match(/^Private-key-format\: v1/)) {
		var algElems = lines[1].split(' ');
		var algoNum = parseInt(algElems[1], 10);
		var algoName = algElems[2];
		if (!supportedAlgosById[algoNum])
			throw (new Error('Unsupported algorithm: ' + algoName));
		return (readDNSSECPrivateKey(algoNum, lines.slice(2)));
	}

	// skip any comment-lines
	var line = 0;
	/* JSSTYLED */
	while (lines[line].match(/^\;/))
		line++;
	// we should now have *one single* line left with our KEY on it.
	if ((lines[line].match(/\. IN KEY /) ||
	    lines[line].match(/\. IN DNSKEY /)) && lines[line+1].length === 0) {
		return (readRFC3110(lines[line]));
	}
	throw (new Error('Cannot parse dnssec key'));
}

function readRFC3110(keyString) {
	var elems = keyString.split(' ');
	//unused var flags = parseInt(elems[3], 10);
	//unused var protocol = parseInt(elems[4], 10);
	var algorithm = parseInt(elems[5], 10);
	if (!supportedAlgosById[algorithm])
		throw (new Error('Unsupported algorithm: ' + algorithm));
	var base64key = elems.slice(6, elems.length).join();
	var keyBuffer = Buffer.from(base64key, 'base64');
	if (supportedAlgosById[algorithm].match(/^RSA-/)) {
		// join the rest of the body into a single base64-blob
		var publicExponentLen = keyBuffer.readUInt8(0);
		if (publicExponentLen != 3 && publicExponentLen != 1)
			throw (new Error('Cannot parse dnssec key: ' +
			    'unsupported exponent length'));

		var publicExponent = keyBuffer.slice(1, publicExponentLen+1);
		publicExponent = utils.mpNormalize(publicExponent);
		var modulus = keyBuffer.slice(1+publicExponentLen);
		modulus = utils.mpNormalize(modulus);
		// now, make the key
		var rsaKey = {
			type: 'rsa',
			parts: []
		};
		rsaKey.parts.push({ name: 'e', data: publicExponent});
		rsaKey.parts.push({ name: 'n', data: modulus});
		return (new Key(rsaKey));
	}
	if (supportedAlgosById[algorithm] === 'ECDSA-P384-SHA384' ||
	    supportedAlgosById[algorithm] === 'ECDSA-P256-SHA256') {
		var curve = 'nistp384';
		var size = 384;
		if (supportedAlgosById[algorithm].match(/^ECDSA-P256-SHA256/)) {
			curve = 'nistp256';
			size = 256;
		}

		var ecdsaKey = {
			type: 'ecdsa',
			curve: curve,
			size: size,
			parts: [
				{name: 'curve', data: Buffer.from(curve) },
				{name: 'Q', data: utils.ecNormalize(keyBuffer) }
			]
		};
		return (new Key(ecdsaKey));
	}
	throw (new Error('Unsupported algorithm: ' +
	    supportedAlgosById[algorithm]));
}

function elementToBuf(e) {
	return (Buffer.from(e.split(' ')[1], 'base64'));
}

function readDNSSECRSAPrivateKey(elements) {
	var rsaParams = {};
	elements.forEach(function (element) {
		if (element.split(' ')[0] === 'Modulus:')
			rsaParams['n'] = elementToBuf(element);
		else if (element.split(' ')[0] === 'PublicExponent:')
			rsaParams['e'] = elementToBuf(element);
		else if (element.split(' ')[0] === 'PrivateExponent:')
			rsaParams['d'] = elementToBuf(element);
		else if (element.split(' ')[0] === 'Prime1:')
			rsaParams['p'] = elementToBuf(element);
		else if (element.split(' ')[0] === 'Prime2:')
			rsaParams['q'] = elementToBuf(element);
		else if (element.split(' ')[0] === 'Exponent1:')
			rsaParams['dmodp'] = elementToBuf(element);
		else if (element.split(' ')[0] === 'Exponent2:')
			rsaParams['dmodq'] = elementToBuf(element);
		else if (element.split(' ')[0] === 'Coefficient:')
			rsaParams['iqmp'] = elementToBuf(element);
	});
	// now, make the key
	var key = {
		type: 'rsa',
		parts: [
			{ name: 'e', data: utils.mpNormalize(rsaParams['e'])},
			{ name: 'n', data: utils.mpNormalize(rsaParams['n'])},
			{ name: 'd', data: utils.mpNormalize(rsaParams['d'])},
			{ name: 'p', data: utils.mpNormalize(rsaParams['p'])},
			{ name: 'q', data: utils.mpNormalize(rsaParams['q'])},
			{ name: 'dmodp',
			    data: utils.mpNormalize(rsaParams['dmodp'])},
			{ name: 'dmodq',
			    data: utils.mpNormalize(rsaParams['dmodq'])},
			{ name: 'iqmp',
			    data: utils.mpNormalize(rsaParams['iqmp'])}
		]
	};
	return (new PrivateKey(key));
}

function readDNSSECPrivateKey(alg, elements) {
	if (supportedAlgosById[alg].match(/^RSA-/)) {
		return (readDNSSECRSAPrivateKey(elements));
	}
	if (supportedAlgosById[alg] === 'ECDSA-P384-SHA384' ||
	    supportedAlgosById[alg] === 'ECDSA-P256-SHA256') {
		var d = Buffer.from(elements[0].split(' ')[1], 'base64');
		var curve = 'nistp384';
		var size = 384;
		if (supportedAlgosById[alg] === 'ECDSA-P256-SHA256') {
			curve = 'nistp256';
			size = 256;
		}
		// DNSSEC generates the public-key on the fly (go calculate it)
		var publicKey = utils.publicFromPrivateECDSA(curve, d);
		var Q = publicKey.part['Q'].data;
		var ecdsaKey = {
			type: 'ecdsa',
			curve: curve,
			size: size,
			parts: [
				{name: 'curve', data: Buffer.from(curve) },
				{name: 'd', data: d },
				{name: 'Q', data: Q }
			]
		};
		return (new PrivateKey(ecdsaKey));
	}
	throw (new Error('Unsupported algorithm: ' + supportedAlgosById[alg]));
}

function dnssecTimestamp(date) {
	var year = date.getFullYear() + ''; //stringify
	var month = (date.getMonth() + 1);
	var timestampStr = year + month + date.getUTCDate();
	timestampStr += '' + date.getUTCHours() + date.getUTCMinutes();
	timestampStr += date.getUTCSeconds();
	return (timestampStr);
}

function rsaAlgFromOptions(opts) {
	if (!opts || !opts.hashAlgo || opts.hashAlgo === 'sha1')
		return ('5 (RSASHA1)');
	else if (opts.hashAlgo === 'sha256')
		return ('8 (RSASHA256)');
	else if (opts.hashAlgo === 'sha512')
		return ('10 (RSASHA512)');
	else
		throw (new Error('Unknown or unsupported hash: ' +
		    opts.hashAlgo));
}

function writeRSA(key, options) {
	// if we're missing parts, add them.
	if (!key.part.dmodp || !key.part.dmodq) {
		utils.addRSAMissing(key);
	}

	var out = '';
	out += 'Private-key-format: v1.3\n';
	out += 'Algorithm: ' + rsaAlgFromOptions(options) + '\n';
	var n = utils.mpDenormalize(key.part['n'].data);
	out += 'Modulus: ' + n.toString('base64') + '\n';
	var e = utils.mpDenormalize(key.part['e'].data);
	out += 'PublicExponent: ' + e.toString('base64') + '\n';
	var d = utils.mpDenormalize(key.part['d'].data);
	out += 'PrivateExponent: ' + d.toString('base64') + '\n';
	var p = utils.mpDenormalize(key.part['p'].data);
	out += 'Prime1: ' + p.toString('base64') + '\n';
	var q = utils.mpDenormalize(key.part['q'].data);
	out += 'Prime2: ' + q.toString('base64') + '\n';
	var dmodp = utils.mpDenormalize(key.part['dmodp'].data);
	out += 'Exponent1: ' + dmodp.toString('base64') + '\n';
	var dmodq = utils.mpDenormalize(key.part['dmodq'].data);
	out += 'Exponent2: ' + dmodq.toString('base64') + '\n';
	var iqmp = utils.mpDenormalize(key.part['iqmp'].data);
	out += 'Coefficient: ' + iqmp.toString('base64') + '\n';
	// Assume that we're valid as-of now
	var timestamp = new Date();
	out += 'Created: ' + dnssecTimestamp(timestamp) + '\n';
	out += 'Publish: ' + dnssecTimestamp(timestamp) + '\n';
	out += 'Activate: ' + dnssecTimestamp(timestamp) + '\n';
	return (Buffer.from(out, 'ascii'));
}

function writeECDSA(key, options) {
	var out = '';
	out += 'Private-key-format: v1.3\n';

	if (key.curve === 'nistp256') {
		out += 'Algorithm: 13 (ECDSAP256SHA256)\n';
	} else if (key.curve === 'nistp384') {
		out += 'Algorithm: 14 (ECDSAP384SHA384)\n';
	} else {
		throw (new Error('Unsupported curve'));
	}
	var base64Key = key.part['d'].data.toString('base64');
	out += 'PrivateKey: ' + base64Key + '\n';

	// Assume that we're valid as-of now
	var timestamp = new Date();
	out += 'Created: ' + dnssecTimestamp(timestamp) + '\n';
	out += 'Publish: ' + dnssecTimestamp(timestamp) + '\n';
	out += 'Activate: ' + dnssecTimestamp(timestamp) + '\n';

	return (Buffer.from(out, 'ascii'));
}

function write(key, options) {
	if (PrivateKey.isPrivateKey(key)) {
		if (key.type === 'rsa') {
			return (writeRSA(key, options));
		} else if (key.type === 'ecdsa') {
			return (writeECDSA(key, options));
		} else {
			throw (new Error('Unsupported algorithm: ' + key.type));
		}
	} else if (Key.isKey(key)) {
		/*
		 * RFC3110 requires a keyname, and a keytype, which we
		 * don't really have a mechanism for specifying such
		 * additional metadata.
		 */
		throw (new Error('Format "dnssec" only supports ' +
		    'writing private keys'));
	} else {
		throw (new Error('key is not a Key or PrivateKey'));
	}
}


/***/ }),
/* 82 */
/***/ (function(module, exports) {

function Caseless (dict) {
  this.dict = dict || {}
}
Caseless.prototype.set = function (name, value, clobber) {
  if (typeof name === 'object') {
    for (var i in name) {
      this.set(i, name[i], value)
    }
  } else {
    if (typeof clobber === 'undefined') clobber = true
    var has = this.has(name)

    if (!clobber && has) this.dict[has] = this.dict[has] + ',' + value
    else this.dict[has || name] = value
    return has
  }
}
Caseless.prototype.has = function (name) {
  var keys = Object.keys(this.dict)
    , name = name.toLowerCase()
    ;
  for (var i=0;i<keys.length;i++) {
    if (keys[i].toLowerCase() === name) return keys[i]
  }
  return false
}
Caseless.prototype.get = function (name) {
  name = name.toLowerCase()
  var result, _key
  var headers = this.dict
  Object.keys(headers).forEach(function (key) {
    _key = key.toLowerCase()
    if (name === _key) result = headers[key]
  })
  return result
}
Caseless.prototype.swap = function (name) {
  var has = this.has(name)
  if (has === name) return
  if (!has) throw new Error('There is no header than matches "'+name+'"')
  this.dict[name] = this.dict[has]
  delete this.dict[has]
}
Caseless.prototype.del = function (name) {
  var has = this.has(name)
  return delete this.dict[has || name]
}

module.exports = function (dict) {return new Caseless(dict)}
module.exports.httpify = function (resp, headers) {
  var c = new Caseless(headers)
  resp.setHeader = function (key, value, clobber) {
    if (typeof value === 'undefined') return
    return c.set(key, value, clobber)
  }
  resp.hasHeader = function (key) {
    return c.has(key)
  }
  resp.getHeader = function (key) {
    return c.get(key)
  }
  resp.removeHeader = function (key) {
    return c.del(key)
  }
  resp.headers = c.dict
  return c
}


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var url = __webpack_require__(16)
  , equal = __webpack_require__(84)
  , util = __webpack_require__(34)
  , SchemaObject = __webpack_require__(143)
  , traverse = __webpack_require__(314);

module.exports = resolve;

resolve.normalizeId = normalizeId;
resolve.fullPath = getFullPath;
resolve.url = resolveUrl;
resolve.ids = resolveIds;
resolve.inlineRef = inlineRef;
resolve.schema = resolveSchema;

/**
 * [resolve and compile the references ($ref)]
 * @this   Ajv
 * @param  {Function} compile reference to schema compilation funciton (localCompile)
 * @param  {Object} root object with information about the root schema for the current schema
 * @param  {String} ref reference to resolve
 * @return {Object|Function} schema object (if the schema can be inlined) or validation function
 */
function resolve(compile, root, ref) {
  /* jshint validthis: true */
  var refVal = this._refs[ref];
  if (typeof refVal == 'string') {
    if (this._refs[refVal]) refVal = this._refs[refVal];
    else return resolve.call(this, compile, root, refVal);
  }

  refVal = refVal || this._schemas[ref];
  if (refVal instanceof SchemaObject) {
    return inlineRef(refVal.schema, this._opts.inlineRefs)
            ? refVal.schema
            : refVal.validate || this._compile(refVal);
  }

  var res = resolveSchema.call(this, root, ref);
  var schema, v, baseId;
  if (res) {
    schema = res.schema;
    root = res.root;
    baseId = res.baseId;
  }

  if (schema instanceof SchemaObject) {
    v = schema.validate || compile.call(this, schema.schema, root, undefined, baseId);
  } else if (schema !== undefined) {
    v = inlineRef(schema, this._opts.inlineRefs)
        ? schema
        : compile.call(this, schema, root, undefined, baseId);
  }

  return v;
}


/**
 * Resolve schema, its root and baseId
 * @this Ajv
 * @param  {Object} root root object with properties schema, refVal, refs
 * @param  {String} ref  reference to resolve
 * @return {Object} object with properties schema, root, baseId
 */
function resolveSchema(root, ref) {
  /* jshint validthis: true */
  var p = url.parse(ref, false, true)
    , refPath = _getFullPath(p)
    , baseId = getFullPath(this._getId(root.schema));
  if (refPath !== baseId) {
    var id = normalizeId(refPath);
    var refVal = this._refs[id];
    if (typeof refVal == 'string') {
      return resolveRecursive.call(this, root, refVal, p);
    } else if (refVal instanceof SchemaObject) {
      if (!refVal.validate) this._compile(refVal);
      root = refVal;
    } else {
      refVal = this._schemas[id];
      if (refVal instanceof SchemaObject) {
        if (!refVal.validate) this._compile(refVal);
        if (id == normalizeId(ref))
          return { schema: refVal, root: root, baseId: baseId };
        root = refVal;
      } else {
        return;
      }
    }
    if (!root.schema) return;
    baseId = getFullPath(this._getId(root.schema));
  }
  return getJsonPointer.call(this, p, baseId, root.schema, root);
}


/* @this Ajv */
function resolveRecursive(root, ref, parsedRef) {
  /* jshint validthis: true */
  var res = resolveSchema.call(this, root, ref);
  if (res) {
    var schema = res.schema;
    var baseId = res.baseId;
    root = res.root;
    var id = this._getId(schema);
    if (id) baseId = resolveUrl(baseId, id);
    return getJsonPointer.call(this, parsedRef, baseId, schema, root);
  }
}


var PREVENT_SCOPE_CHANGE = util.toHash(['properties', 'patternProperties', 'enum', 'dependencies', 'definitions']);
/* @this Ajv */
function getJsonPointer(parsedRef, baseId, schema, root) {
  /* jshint validthis: true */
  parsedRef.hash = parsedRef.hash || '';
  if (parsedRef.hash.slice(0,2) != '#/') return;
  var parts = parsedRef.hash.split('/');

  for (var i = 1; i < parts.length; i++) {
    var part = parts[i];
    if (part) {
      part = util.unescapeFragment(part);
      schema = schema[part];
      if (schema === undefined) break;
      var id;
      if (!PREVENT_SCOPE_CHANGE[part]) {
        id = this._getId(schema);
        if (id) baseId = resolveUrl(baseId, id);
        if (schema.$ref) {
          var $ref = resolveUrl(baseId, schema.$ref);
          var res = resolveSchema.call(this, root, $ref);
          if (res) {
            schema = res.schema;
            root = res.root;
            baseId = res.baseId;
          }
        }
      }
    }
  }
  if (schema !== undefined && schema !== root.schema)
    return { schema: schema, root: root, baseId: baseId };
}


var SIMPLE_INLINED = util.toHash([
  'type', 'format', 'pattern',
  'maxLength', 'minLength',
  'maxProperties', 'minProperties',
  'maxItems', 'minItems',
  'maximum', 'minimum',
  'uniqueItems', 'multipleOf',
  'required', 'enum'
]);
function inlineRef(schema, limit) {
  if (limit === false) return false;
  if (limit === undefined || limit === true) return checkNoRef(schema);
  else if (limit) return countKeys(schema) <= limit;
}


function checkNoRef(schema) {
  var item;
  if (Array.isArray(schema)) {
    for (var i=0; i<schema.length; i++) {
      item = schema[i];
      if (typeof item == 'object' && !checkNoRef(item)) return false;
    }
  } else {
    for (var key in schema) {
      if (key == '$ref') return false;
      item = schema[key];
      if (typeof item == 'object' && !checkNoRef(item)) return false;
    }
  }
  return true;
}


function countKeys(schema) {
  var count = 0, item;
  if (Array.isArray(schema)) {
    for (var i=0; i<schema.length; i++) {
      item = schema[i];
      if (typeof item == 'object') count += countKeys(item);
      if (count == Infinity) return Infinity;
    }
  } else {
    for (var key in schema) {
      if (key == '$ref') return Infinity;
      if (SIMPLE_INLINED[key]) {
        count++;
      } else {
        item = schema[key];
        if (typeof item == 'object') count += countKeys(item) + 1;
        if (count == Infinity) return Infinity;
      }
    }
  }
  return count;
}


function getFullPath(id, normalize) {
  if (normalize !== false) id = normalizeId(id);
  var p = url.parse(id, false, true);
  return _getFullPath(p);
}


function _getFullPath(p) {
  var protocolSeparator = p.protocol || p.href.slice(0,2) == '//' ? '//' : '';
  return (p.protocol||'') + protocolSeparator + (p.host||'') + (p.path||'')  + '#';
}


var TRAILING_SLASH_HASH = /#\/?$/;
function normalizeId(id) {
  return id ? id.replace(TRAILING_SLASH_HASH, '') : '';
}


function resolveUrl(baseId, id) {
  id = normalizeId(id);
  return url.resolve(baseId, id);
}


/* @this Ajv */
function resolveIds(schema) {
  var schemaId = normalizeId(this._getId(schema));
  var baseIds = {'': schemaId};
  var fullPaths = {'': getFullPath(schemaId, false)};
  var localRefs = {};
  var self = this;

  traverse(schema, {allKeys: true}, function(sch, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (jsonPtr === '') return;
    var id = self._getId(sch);
    var baseId = baseIds[parentJsonPtr];
    var fullPath = fullPaths[parentJsonPtr] + '/' + parentKeyword;
    if (keyIndex !== undefined)
      fullPath += '/' + (typeof keyIndex == 'number' ? keyIndex : util.escapeFragment(keyIndex));

    if (typeof id == 'string') {
      id = baseId = normalizeId(baseId ? url.resolve(baseId, id) : id);

      var refVal = self._refs[id];
      if (typeof refVal == 'string') refVal = self._refs[refVal];
      if (refVal && refVal.schema) {
        if (!equal(sch, refVal.schema))
          throw new Error('id "' + id + '" resolves to more than one schema');
      } else if (id != normalizeId(fullPath)) {
        if (id[0] == '#') {
          if (localRefs[id] && !equal(sch, localRefs[id]))
            throw new Error('id "' + id + '" resolves to more than one schema');
          localRefs[id] = sch;
        } else {
          self._refs[id] = fullPath;
        }
      }
    }
    baseIds[jsonPtr] = baseId;
    fullPaths[jsonPtr] = fullPath;
  });

  return localRefs;
}


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

module.exports = function equal(a, b) {
  if (a === b) return true;

  var arrA = isArray(a)
    , arrB = isArray(b)
    , i
    , length
    , key;

  if (arrA && arrB) {
    length = a.length;
    if (length != b.length) return false;
    for (i = 0; i < length; i++)
      if (!equal(a[i], b[i])) return false;
    return true;
  }

  if (arrA != arrB) return false;

  var dateA = a instanceof Date
    , dateB = b instanceof Date;
  if (dateA != dateB) return false;
  if (dateA && dateB) return a.getTime() == b.getTime();

  var regexpA = a instanceof RegExp
    , regexpB = b instanceof RegExp;
  if (regexpA != regexpB) return false;
  if (regexpA && regexpB) return a.toString() == b.toString();

  if (a instanceof Object && b instanceof Object) {
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = 0; i < length; i++)
      if (!hasProp.call(b, keys[i])) return false;

    for (i = 0; i < length; i++) {
      key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  return false;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var resolve = __webpack_require__(83);

module.exports = {
  Validation: errorSubclass(ValidationError),
  MissingRef: errorSubclass(MissingRefError)
};


function ValidationError(errors) {
  this.message = 'validation failed';
  this.errors = errors;
  this.ajv = this.validation = true;
}


MissingRefError.message = function (baseId, ref) {
  return 'can\'t resolve reference ' + ref + ' from id ' + baseId;
};


function MissingRefError(baseId, ref, message) {
  this.message = message || MissingRefError.message(baseId, ref);
  this.missingRef = resolve.url(baseId, ref);
  this.missingSchema = resolve.normalizeId(resolve.fullPath(this.missingRef));
}


function errorSubclass(Subclass) {
  Subclass.prototype = Object.create(Error.prototype);
  Subclass.prototype.constructor = Subclass;
  return Subclass;
}


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(154);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tough = __webpack_require__(172)

var Cookie = tough.Cookie
var CookieJar = tough.CookieJar

exports.parse = function (str) {
  if (str && str.uri) {
    str = str.uri
  }
  if (typeof str !== 'string') {
    throw new Error('The cookie function only accepts STRING as param')
  }
  return Cookie.parse(str, {loose: true})
}

// Adapt the sometimes-Async api of tough.CookieJar to our requirements
function RequestJar (store) {
  var self = this
  self._jar = new CookieJar(store, {looseMode: true})
}
RequestJar.prototype.setCookie = function (cookieOrStr, uri, options) {
  var self = this
  return self._jar.setCookieSync(cookieOrStr, uri, options || {})
}
RequestJar.prototype.getCookieString = function (uri) {
  var self = this
  return self._jar.getCookieStringSync(uri)
}
RequestJar.prototype.getCookies = function (uri) {
  var self = this
  return self._jar.getCookiesSync(uri)
}

exports.jar = function (store) {
  return new RequestJar(store)
}


/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * Copyright (c) 2018, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

var psl = __webpack_require__(177);

function getPublicSuffix(domain) {
  return psl.get(domain);
}

exports.getPublicSuffix = getPublicSuffix;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * Copyright (c) 2015, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

/*jshint unused:false */

function Store() {
}
exports.Store = Store;

// Stores may be synchronous, but are still required to use a
// Continuation-Passing Style API.  The CookieJar itself will expose a "*Sync"
// API that converts from synchronous-callbacks to imperative style.
Store.prototype.synchronous = false;

Store.prototype.findCookie = function(domain, path, key, cb) {
  throw new Error('findCookie is not implemented');
};

Store.prototype.findCookies = function(domain, path, cb) {
  throw new Error('findCookies is not implemented');
};

Store.prototype.putCookie = function(cookie, cb) {
  throw new Error('putCookie is not implemented');
};

Store.prototype.updateCookie = function(oldCookie, newCookie, cb) {
  // recommended default implementation:
  // return this.putCookie(newCookie, cb);
  throw new Error('updateCookie is not implemented');
};

Store.prototype.removeCookie = function(domain, path, key, cb) {
  throw new Error('removeCookie is not implemented');
};

Store.prototype.removeCookies = function(domain, path, cb) {
  throw new Error('removeCookies is not implemented');
};

Store.prototype.getAllCookies = function(cb) {
  throw new Error('getAllCookies is not implemented (therefore jar cannot be serialized)');
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * Copyright (c) 2015, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

var pubsuffix = __webpack_require__(89);

// Gives the permutation of all possible domainMatch()es of a given domain. The
// array is in shortest-to-longest order.  Handy for indexing.
function permuteDomain (domain) {
  var pubSuf = pubsuffix.getPublicSuffix(domain);
  if (!pubSuf) {
    return null;
  }
  if (pubSuf == domain) {
    return [domain];
  }

  var prefix = domain.slice(0, -(pubSuf.length + 1)); // ".example.com"
  var parts = prefix.split('.').reverse();
  var cur = pubSuf;
  var permutations = [cur];
  while (parts.length) {
    cur = parts.shift() + '.' + cur;
    permutations.push(cur);
  }
  return permutations;
}

exports.permuteDomain = permuteDomain;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * Copyright (c) 2015, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

/*
 * "A request-path path-matches a given cookie-path if at least one of the
 * following conditions holds:"
 */
function pathMatch (reqPath, cookiePath) {
  // "o  The cookie-path and the request-path are identical."
  if (cookiePath === reqPath) {
    return true;
  }

  var idx = reqPath.indexOf(cookiePath);
  if (idx === 0) {
    // "o  The cookie-path is a prefix of the request-path, and the last
    // character of the cookie-path is %x2F ("/")."
    if (cookiePath.substr(-1) === "/") {
      return true;
    }

    // " o  The cookie-path is a prefix of the request-path, and the first
    // character of the request-path that is not included in the cookie- path
    // is a %x2F ("/") character."
    if (reqPath.substr(cookiePath.length, 1) === "/") {
      return true;
    }
  }

  return false;
}

exports.pathMatch = pathMatch;


/***/ }),
/* 93 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(1).Buffer
var Transform = __webpack_require__(17).Transform
var inherits = __webpack_require__(0)

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(50);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(93);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(49).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(96);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(1).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(32);
util.inherits = __webpack_require__(0);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(185);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(186);
var destroyImpl = __webpack_require__(97);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(27);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(67).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(27);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(67).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(6)))

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(49).EventEmitter;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(50);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(27);

/*<replacement>*/
var util = __webpack_require__(32);
util.inherits = __webpack_require__(0);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(0)
var Hash = __webpack_require__(33)
var Buffer = __webpack_require__(1).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0)
var Hash = __webpack_require__(33)
var Buffer = __webpack_require__(1).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(0)
var Legacy = __webpack_require__(198)
var Base = __webpack_require__(24)
var Buffer = __webpack_require__(1).Buffer
var md5 = __webpack_require__(102)
var RIPEMD160 = __webpack_require__(68)

var sha = __webpack_require__(69)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(65)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(200)
exports.pbkdf2Sync = __webpack_require__(107)


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(102)
var rmd160 = __webpack_require__(68)
var sha = __webpack_require__(69)

var checkParameters = __webpack_require__(105)
var defaultEncoding = __webpack_require__(106)
var Buffer = __webpack_require__(1).Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(37)
var Buffer = __webpack_require__(1).Buffer
var incr32 = __webpack_require__(109)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),
/* 109 */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(51)
var Buffer = __webpack_require__(1).Buffer
var Transform = __webpack_require__(24)
var inherits = __webpack_require__(0)
var GHASH = __webpack_require__(215)
var xor = __webpack_require__(37)
var incr32 = __webpack_require__(109)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(51)
var Buffer = __webpack_require__(1).Buffer
var Transform = __webpack_require__(24)
var inherits = __webpack_require__(0)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(31);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(8);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(114);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(8);
var brorand = __webpack_require__(115);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(220);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);
var common = __webpack_require__(38);
var shaCommon = __webpack_require__(117);
var assert = __webpack_require__(15);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);
var common = __webpack_require__(38);
var assert = __webpack_require__(15);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0);
var Reporter = __webpack_require__(40).Reporter;
var Buffer = __webpack_require__(2).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(252);


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0);

var asn1 = __webpack_require__(39);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0);
var Buffer = __webpack_require__(2).Buffer;

var asn1 = __webpack_require__(39);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(35);
module.exports = function (seed, len) {
  var t = new Buffer('');
  var  i = 0, c;
  while (t.length < len) {
    c = i2ops(i++);
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()]);
  }
  return t.slice(0, len);
};

function i2ops(c) {
  var out = new Buffer(4);
  out.writeUInt32BE(c,0);
  return out;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = function xor(a, b) {
  var len = a.length;
  var i = -1;
  while (++i < len) {
    a[i] ^= b[i];
  }
  return a
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(8);
function withPublic(paddedMsg, key) {
  return new Buffer(paddedMsg
    .toRed(bn.mont(key.modulus))
    .redPow(new bn(key.publicExponent))
    .fromRed()
    .toArray());
}

module.exports = withPublic;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream)

exports.writableStream = isFunction(global.WritableStream)

exports.abortController = isFunction(global.AbortController)

exports.blobConstructor = false
try {
	new Blob([new ArrayBuffer(1)])
	exports.blobConstructor = true
} catch (e) {}

// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var xhr
function getXHR () {
	// Cache the xhr value
	if (xhr !== undefined) return xhr

	if (global.XMLHttpRequest) {
		xhr = new global.XMLHttpRequest()
		// If XDomainRequest is available (ie only, where xhr might not work
		// cross domain), use the page location. Otherwise use example.com
		// Note: this doesn't actually make an http request.
		try {
			xhr.open('GET', global.XDomainRequest ? '/' : 'https://example.com')
		} catch(e) {
			xhr = null
		}
	} else {
		// Service workers don't have XHR
		xhr = null
	}
	return xhr
}

function checkTypeSupport (type) {
	var xhr = getXHR()
	if (!xhr) return false
	try {
		xhr.responseType = type
		return xhr.responseType === type
	} catch (e) {}
	return false
}

// For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
// Safari 7.1 appears to have fixed this bug.
var haveArrayBuffer = typeof global.ArrayBuffer !== 'undefined'
var haveSlice = haveArrayBuffer && isFunction(global.ArrayBuffer.prototype.slice)

// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
exports.arraybuffer = exports.fetch || (haveArrayBuffer && checkTypeSupport('arraybuffer'))

// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
exports.msstream = !exports.fetch && haveSlice && checkTypeSupport('ms-stream')
exports.mozchunkedarraybuffer = !exports.fetch && haveArrayBuffer &&
	checkTypeSupport('moz-chunked-arraybuffer')

// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false)

exports.vbArray = isFunction(global.VBArray)

function isFunction (value) {
	return typeof value === 'function'
}

xhr = null // Help gc

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Buffer, global) {var capability = __webpack_require__(128)
var inherits = __webpack_require__(0)
var stream = __webpack_require__(36)

var rStates = exports.readyStates = {
	UNSENT: 0,
	OPENED: 1,
	HEADERS_RECEIVED: 2,
	LOADING: 3,
	DONE: 4
}

var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode, fetchTimer) {
	var self = this
	stream.Readable.call(self)

	self._mode = mode
	self.headers = {}
	self.rawHeaders = []
	self.trailers = {}
	self.rawTrailers = []

	// Fake the 'close' event, but only once 'end' fires
	self.on('end', function () {
		// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
		process.nextTick(function () {
			self.emit('close')
		})
	})

	if (mode === 'fetch') {
		self._fetchResponse = response

		self.url = response.url
		self.statusCode = response.status
		self.statusMessage = response.statusText
		
		response.headers.forEach(function (header, key){
			self.headers[key.toLowerCase()] = header
			self.rawHeaders.push(key, header)
		})

		if (capability.writableStream) {
			var writable = new WritableStream({
				write: function (chunk) {
					return new Promise(function (resolve, reject) {
						if (self._destroyed) {
							reject()
						} else if(self.push(new Buffer(chunk))) {
							resolve()
						} else {
							self._resumeFetch = resolve
						}
					})
				},
				close: function () {
					global.clearTimeout(fetchTimer)
					if (!self._destroyed)
						self.push(null)
				},
				abort: function (err) {
					if (!self._destroyed)
						self.emit('error', err)
				}
			})

			try {
				response.body.pipeTo(writable).catch(function (err) {
					global.clearTimeout(fetchTimer)
					if (!self._destroyed)
						self.emit('error', err)
				})
				return
			} catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
		}
		// fallback for when writableStream or pipeTo aren't available
		var reader = response.body.getReader()
		function read () {
			reader.read().then(function (result) {
				if (self._destroyed)
					return
				if (result.done) {
					global.clearTimeout(fetchTimer)
					self.push(null)
					return
				}
				self.push(new Buffer(result.value))
				read()
			}).catch(function (err) {
				global.clearTimeout(fetchTimer)
				if (!self._destroyed)
					self.emit('error', err)
			})
		}
		read()
	} else {
		self._xhr = xhr
		self._pos = 0

		self.url = xhr.responseURL
		self.statusCode = xhr.status
		self.statusMessage = xhr.statusText
		var headers = xhr.getAllResponseHeaders().split(/\r?\n/)
		headers.forEach(function (header) {
			var matches = header.match(/^([^:]+):\s*(.*)/)
			if (matches) {
				var key = matches[1].toLowerCase()
				if (key === 'set-cookie') {
					if (self.headers[key] === undefined) {
						self.headers[key] = []
					}
					self.headers[key].push(matches[2])
				} else if (self.headers[key] !== undefined) {
					self.headers[key] += ', ' + matches[2]
				} else {
					self.headers[key] = matches[2]
				}
				self.rawHeaders.push(matches[1], matches[2])
			}
		})

		self._charset = 'x-user-defined'
		if (!capability.overrideMimeType) {
			var mimeType = self.rawHeaders['mime-type']
			if (mimeType) {
				var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/)
				if (charsetMatch) {
					self._charset = charsetMatch[1].toLowerCase()
				}
			}
			if (!self._charset)
				self._charset = 'utf-8' // best guess
		}
	}
}

inherits(IncomingMessage, stream.Readable)

IncomingMessage.prototype._read = function () {
	var self = this

	var resolve = self._resumeFetch
	if (resolve) {
		self._resumeFetch = null
		resolve()
	}
}

IncomingMessage.prototype._onXHRProgress = function () {
	var self = this

	var xhr = self._xhr

	var response = null
	switch (self._mode) {
		case 'text:vbarray': // For IE9
			if (xhr.readyState !== rStates.DONE)
				break
			try {
				// This fails in IE8
				response = new global.VBArray(xhr.responseBody).toArray()
			} catch (e) {}
			if (response !== null) {
				self.push(new Buffer(response))
				break
			}
			// Falls through in IE8	
		case 'text':
			try { // This will fail when readyState = 3 in IE9. Switch mode and wait for readyState = 4
				response = xhr.responseText
			} catch (e) {
				self._mode = 'text:vbarray'
				break
			}
			if (response.length > self._pos) {
				var newData = response.substr(self._pos)
				if (self._charset === 'x-user-defined') {
					var buffer = new Buffer(newData.length)
					for (var i = 0; i < newData.length; i++)
						buffer[i] = newData.charCodeAt(i) & 0xff

					self.push(buffer)
				} else {
					self.push(newData, self._charset)
				}
				self._pos = response.length
			}
			break
		case 'arraybuffer':
			if (xhr.readyState !== rStates.DONE || !xhr.response)
				break
			response = xhr.response
			self.push(new Buffer(new Uint8Array(response)))
			break
		case 'moz-chunked-arraybuffer': // take whole
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING || !response)
				break
			self.push(new Buffer(new Uint8Array(response)))
			break
		case 'ms-stream':
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING)
				break
			var reader = new global.MSStreamReader()
			reader.onprogress = function () {
				if (reader.result.byteLength > self._pos) {
					self.push(new Buffer(new Uint8Array(reader.result.slice(self._pos))))
					self._pos = reader.result.byteLength
				}
			}
			reader.onload = function () {
				self.push(null)
			}
			// reader.onerror = ??? // TODO: this
			reader.readAsArrayBuffer(response)
			break
	}

	// The ms-stream case handles end separately in reader.onload()
	if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
		self.push(null)
	}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(2).Buffer, __webpack_require__(10)))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var crypto = __webpack_require__(7);
var BigInteger = __webpack_require__(25).BigInteger;
var ECPointFp = __webpack_require__(44).ECPointFp;
var Buffer = __webpack_require__(4).Buffer;
exports.ECCurves = __webpack_require__(286);

// zero prepad
function unstupid(hex,len)
{
	return (hex.length >= len) ? hex : unstupid("0"+hex,len);
}

exports.ECKey = function(curve, key, isPublic)
{
  var priv;
	var c = curve();
	var n = c.getN();
  var bytes = Math.floor(n.bitLength()/8);

  if(key)
  {
    if(isPublic)
    {
      var curve = c.getCurve();
//      var x = key.slice(1,bytes+1); // skip the 04 for uncompressed format
//      var y = key.slice(bytes+1);
//      this.P = new ECPointFp(curve,
//        curve.fromBigInteger(new BigInteger(x.toString("hex"), 16)),
//        curve.fromBigInteger(new BigInteger(y.toString("hex"), 16)));      
      this.P = curve.decodePointHex(key.toString("hex"));
    }else{
      if(key.length != bytes) return false;
      priv = new BigInteger(key.toString("hex"), 16);      
    }
  }else{
    var n1 = n.subtract(BigInteger.ONE);
    var r = new BigInteger(crypto.randomBytes(n.bitLength()));
    priv = r.mod(n1).add(BigInteger.ONE);
    this.P = c.getG().multiply(priv);
  }
  if(this.P)
  {
//  var pubhex = unstupid(this.P.getX().toBigInteger().toString(16),bytes*2)+unstupid(this.P.getY().toBigInteger().toString(16),bytes*2);
//  this.PublicKey = Buffer.from("04"+pubhex,"hex");
    this.PublicKey = Buffer.from(c.getCurve().encodeCompressedPointHex(this.P),"hex");
  }
  if(priv)
  {
    this.PrivateKey = Buffer.from(unstupid(priv.toString(16),bytes*2),"hex");
    this.deriveSharedSecret = function(key)
    {
      if(!key || !key.P) return false;
      var S = key.P.multiply(priv);
      return Buffer.from(unstupid(S.getX().toBigInteger().toString(16),bytes*2),"hex");
   }     
  }
}



/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

module.exports = {
	Verifier: Verifier,
	Signer: Signer
};

var nacl;
var stream = __webpack_require__(17);
var util = __webpack_require__(5);
var assert = __webpack_require__(3);
var Buffer = __webpack_require__(4).Buffer;
var Signature = __webpack_require__(20);

function Verifier(key, hashAlgo) {
	if (nacl === undefined)
		nacl = __webpack_require__(21);

	if (hashAlgo.toLowerCase() !== 'sha512')
		throw (new Error('ED25519 only supports the use of ' +
		    'SHA-512 hashes'));

	this.key = key;
	this.chunks = [];

	stream.Writable.call(this, {});
}
util.inherits(Verifier, stream.Writable);

Verifier.prototype._write = function (chunk, enc, cb) {
	this.chunks.push(chunk);
	cb();
};

Verifier.prototype.update = function (chunk) {
	if (typeof (chunk) === 'string')
		chunk = Buffer.from(chunk, 'binary');
	this.chunks.push(chunk);
};

Verifier.prototype.verify = function (signature, fmt) {
	var sig;
	if (Signature.isSignature(signature, [2, 0])) {
		if (signature.type !== 'ed25519')
			return (false);
		sig = signature.toBuffer('raw');

	} else if (typeof (signature) === 'string') {
		sig = Buffer.from(signature, 'base64');

	} else if (Signature.isSignature(signature, [1, 0])) {
		throw (new Error('signature was created by too old ' +
		    'a version of sshpk and cannot be verified'));
	}

	assert.buffer(sig);
	return (nacl.sign.detached.verify(
	    new Uint8Array(Buffer.concat(this.chunks)),
	    new Uint8Array(sig),
	    new Uint8Array(this.key.part.A.data)));
};

function Signer(key, hashAlgo) {
	if (nacl === undefined)
		nacl = __webpack_require__(21);

	if (hashAlgo.toLowerCase() !== 'sha512')
		throw (new Error('ED25519 only supports the use of ' +
		    'SHA-512 hashes'));

	this.key = key;
	this.chunks = [];

	stream.Writable.call(this, {});
}
util.inherits(Signer, stream.Writable);

Signer.prototype._write = function (chunk, enc, cb) {
	this.chunks.push(chunk);
	cb();
};

Signer.prototype.update = function (chunk) {
	if (typeof (chunk) === 'string')
		chunk = Buffer.from(chunk, 'binary');
	this.chunks.push(chunk);
};

Signer.prototype.sign = function () {
	var sig = nacl.sign.detached(
	    new Uint8Array(Buffer.concat(this.chunks)),
	    new Uint8Array(Buffer.concat([
		this.key.part.k.data, this.key.part.A.data])));
	var sigBuf = Buffer.from(sig);
	var sigObj = Signature.parse(sigBuf, 'ed25519', 'raw');
	sigObj.hashAlgorithm = 'sha512';
	return (sigObj);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

module.exports = {
	read: read,
	write: write
};

var assert = __webpack_require__(3);
var Buffer = __webpack_require__(4).Buffer;
var utils = __webpack_require__(9);
var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);

var pem = __webpack_require__(26);
var ssh = __webpack_require__(136);
var rfc4253 = __webpack_require__(29);
var dnssec = __webpack_require__(81);

var DNSSEC_PRIVKEY_HEADER_PREFIX = 'Private-key-format: v1';

function read(buf, options) {
	if (typeof (buf) === 'string') {
		if (buf.trim().match(/^[-]+[ ]*BEGIN/))
			return (pem.read(buf, options));
		if (buf.match(/^\s*ssh-[a-z]/))
			return (ssh.read(buf, options));
		if (buf.match(/^\s*ecdsa-/))
			return (ssh.read(buf, options));
		if (findDNSSECHeader(buf))
			return (dnssec.read(buf, options));
		buf = Buffer.from(buf, 'binary');
	} else {
		assert.buffer(buf);
		if (findPEMHeader(buf))
			return (pem.read(buf, options));
		if (findSSHHeader(buf))
			return (ssh.read(buf, options));
		if (findDNSSECHeader(buf))
			return (dnssec.read(buf, options));
	}
	if (buf.readUInt32BE(0) < buf.length)
		return (rfc4253.read(buf, options));
	throw (new Error('Failed to auto-detect format of key'));
}

function findSSHHeader(buf) {
	var offset = 0;
	while (offset < buf.length &&
	    (buf[offset] === 32 || buf[offset] === 10 || buf[offset] === 9))
		++offset;
	if (offset + 4 <= buf.length &&
	    buf.slice(offset, offset + 4).toString('ascii') === 'ssh-')
		return (true);
	if (offset + 6 <= buf.length &&
	    buf.slice(offset, offset + 6).toString('ascii') === 'ecdsa-')
		return (true);
	return (false);
}

function findPEMHeader(buf) {
	var offset = 0;
	while (offset < buf.length &&
	    (buf[offset] === 32 || buf[offset] === 10))
		++offset;
	if (buf[offset] !== 45)
		return (false);
	while (offset < buf.length &&
	    (buf[offset] === 45))
		++offset;
	while (offset < buf.length &&
	    (buf[offset] === 32))
		++offset;
	if (offset + 5 > buf.length ||
	    buf.slice(offset, offset + 5).toString('ascii') !== 'BEGIN')
		return (false);
	return (true);
}

function findDNSSECHeader(buf) {
	// private case first
	if (buf.length <= DNSSEC_PRIVKEY_HEADER_PREFIX.length)
		return (false);
	var headerCheck = buf.slice(0, DNSSEC_PRIVKEY_HEADER_PREFIX.length);
	if (headerCheck.toString('ascii') === DNSSEC_PRIVKEY_HEADER_PREFIX)
		return (true);

	// public-key RFC3110 ?
	// 'domain.com. IN KEY ...' or 'domain.com. IN DNSKEY ...'
	// skip any comment-lines
	if (typeof (buf) !== 'string') {
		buf = buf.toString('ascii');
	}
	var lines = buf.split('\n');
	var line = 0;
	/* JSSTYLED */
	while (lines[line].match(/^\;/))
		line++;
	if (lines[line].toString('ascii').match(/\. IN KEY /))
		return (true);
	if (lines[line].toString('ascii').match(/\. IN DNSKEY /))
		return (true);
	return (false);
}

function write(key, options) {
	throw (new Error('"auto" format cannot be used for writing'));
}


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto_hash_sha512 = __webpack_require__(21).lowlevel.crypto_hash;

/*
 * This file is a 1:1 port from the OpenBSD blowfish.c and bcrypt_pbkdf.c. As a
 * result, it retains the original copyright and license. The two files are
 * under slightly different (but compatible) licenses, and are here combined in
 * one file.
 *
 * Credit for the actual porting work goes to:
 *  Devi Mandiri <me@devi.web.id>
 */

/*
 * The Blowfish portions are under the following license:
 *
 * Blowfish block cipher for OpenBSD
 * Copyright 1997 Niels Provos <provos@physnet.uni-hamburg.de>
 * All rights reserved.
 *
 * Implementation advice by David Mazieres <dm@lcs.mit.edu>.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions
 * are met:
 * 1. Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright
 *    notice, this list of conditions and the following disclaimer in the
 *    documentation and/or other materials provided with the distribution.
 * 3. The name of the author may not be used to endorse or promote products
 *    derived from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE AUTHOR ``AS IS'' AND ANY EXPRESS OR
 * IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES
 * OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY DIRECT, INDIRECT,
 * INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 * NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/*
 * The bcrypt_pbkdf portions are under the following license:
 *
 * Copyright (c) 2013 Ted Unangst <tedu@openbsd.org>
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */

/*
 * Performance improvements (Javascript-specific):
 *
 * Copyright 2016, Joyent Inc
 * Author: Alex Wilson <alex.wilson@joyent.com>
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */

// Ported from OpenBSD bcrypt_pbkdf.c v1.9

var BLF_J = 0;

var Blowfish = function() {
  this.S = [
    new Uint32Array([
      0xd1310ba6, 0x98dfb5ac, 0x2ffd72db, 0xd01adfb7,
      0xb8e1afed, 0x6a267e96, 0xba7c9045, 0xf12c7f99,
      0x24a19947, 0xb3916cf7, 0x0801f2e2, 0x858efc16,
      0x636920d8, 0x71574e69, 0xa458fea3, 0xf4933d7e,
      0x0d95748f, 0x728eb658, 0x718bcd58, 0x82154aee,
      0x7b54a41d, 0xc25a59b5, 0x9c30d539, 0x2af26013,
      0xc5d1b023, 0x286085f0, 0xca417918, 0xb8db38ef,
      0x8e79dcb0, 0x603a180e, 0x6c9e0e8b, 0xb01e8a3e,
      0xd71577c1, 0xbd314b27, 0x78af2fda, 0x55605c60,
      0xe65525f3, 0xaa55ab94, 0x57489862, 0x63e81440,
      0x55ca396a, 0x2aab10b6, 0xb4cc5c34, 0x1141e8ce,
      0xa15486af, 0x7c72e993, 0xb3ee1411, 0x636fbc2a,
      0x2ba9c55d, 0x741831f6, 0xce5c3e16, 0x9b87931e,
      0xafd6ba33, 0x6c24cf5c, 0x7a325381, 0x28958677,
      0x3b8f4898, 0x6b4bb9af, 0xc4bfe81b, 0x66282193,
      0x61d809cc, 0xfb21a991, 0x487cac60, 0x5dec8032,
      0xef845d5d, 0xe98575b1, 0xdc262302, 0xeb651b88,
      0x23893e81, 0xd396acc5, 0x0f6d6ff3, 0x83f44239,
      0x2e0b4482, 0xa4842004, 0x69c8f04a, 0x9e1f9b5e,
      0x21c66842, 0xf6e96c9a, 0x670c9c61, 0xabd388f0,
      0x6a51a0d2, 0xd8542f68, 0x960fa728, 0xab5133a3,
      0x6eef0b6c, 0x137a3be4, 0xba3bf050, 0x7efb2a98,
      0xa1f1651d, 0x39af0176, 0x66ca593e, 0x82430e88,
      0x8cee8619, 0x456f9fb4, 0x7d84a5c3, 0x3b8b5ebe,
      0xe06f75d8, 0x85c12073, 0x401a449f, 0x56c16aa6,
      0x4ed3aa62, 0x363f7706, 0x1bfedf72, 0x429b023d,
      0x37d0d724, 0xd00a1248, 0xdb0fead3, 0x49f1c09b,
      0x075372c9, 0x80991b7b, 0x25d479d8, 0xf6e8def7,
      0xe3fe501a, 0xb6794c3b, 0x976ce0bd, 0x04c006ba,
      0xc1a94fb6, 0x409f60c4, 0x5e5c9ec2, 0x196a2463,
      0x68fb6faf, 0x3e6c53b5, 0x1339b2eb, 0x3b52ec6f,
      0x6dfc511f, 0x9b30952c, 0xcc814544, 0xaf5ebd09,
      0xbee3d004, 0xde334afd, 0x660f2807, 0x192e4bb3,
      0xc0cba857, 0x45c8740f, 0xd20b5f39, 0xb9d3fbdb,
      0x5579c0bd, 0x1a60320a, 0xd6a100c6, 0x402c7279,
      0x679f25fe, 0xfb1fa3cc, 0x8ea5e9f8, 0xdb3222f8,
      0x3c7516df, 0xfd616b15, 0x2f501ec8, 0xad0552ab,
      0x323db5fa, 0xfd238760, 0x53317b48, 0x3e00df82,
      0x9e5c57bb, 0xca6f8ca0, 0x1a87562e, 0xdf1769db,
      0xd542a8f6, 0x287effc3, 0xac6732c6, 0x8c4f5573,
      0x695b27b0, 0xbbca58c8, 0xe1ffa35d, 0xb8f011a0,
      0x10fa3d98, 0xfd2183b8, 0x4afcb56c, 0x2dd1d35b,
      0x9a53e479, 0xb6f84565, 0xd28e49bc, 0x4bfb9790,
      0xe1ddf2da, 0xa4cb7e33, 0x62fb1341, 0xcee4c6e8,
      0xef20cada, 0x36774c01, 0xd07e9efe, 0x2bf11fb4,
      0x95dbda4d, 0xae909198, 0xeaad8e71, 0x6b93d5a0,
      0xd08ed1d0, 0xafc725e0, 0x8e3c5b2f, 0x8e7594b7,
      0x8ff6e2fb, 0xf2122b64, 0x8888b812, 0x900df01c,
      0x4fad5ea0, 0x688fc31c, 0xd1cff191, 0xb3a8c1ad,
      0x2f2f2218, 0xbe0e1777, 0xea752dfe, 0x8b021fa1,
      0xe5a0cc0f, 0xb56f74e8, 0x18acf3d6, 0xce89e299,
      0xb4a84fe0, 0xfd13e0b7, 0x7cc43b81, 0xd2ada8d9,
      0x165fa266, 0x80957705, 0x93cc7314, 0x211a1477,
      0xe6ad2065, 0x77b5fa86, 0xc75442f5, 0xfb9d35cf,
      0xebcdaf0c, 0x7b3e89a0, 0xd6411bd3, 0xae1e7e49,
      0x00250e2d, 0x2071b35e, 0x226800bb, 0x57b8e0af,
      0x2464369b, 0xf009b91e, 0x5563911d, 0x59dfa6aa,
      0x78c14389, 0xd95a537f, 0x207d5ba2, 0x02e5b9c5,
      0x83260376, 0x6295cfa9, 0x11c81968, 0x4e734a41,
      0xb3472dca, 0x7b14a94a, 0x1b510052, 0x9a532915,
      0xd60f573f, 0xbc9bc6e4, 0x2b60a476, 0x81e67400,
      0x08ba6fb5, 0x571be91f, 0xf296ec6b, 0x2a0dd915,
      0xb6636521, 0xe7b9f9b6, 0xff34052e, 0xc5855664,
      0x53b02d5d, 0xa99f8fa1, 0x08ba4799, 0x6e85076a]),
    new Uint32Array([
      0x4b7a70e9, 0xb5b32944, 0xdb75092e, 0xc4192623,
      0xad6ea6b0, 0x49a7df7d, 0x9cee60b8, 0x8fedb266,
      0xecaa8c71, 0x699a17ff, 0x5664526c, 0xc2b19ee1,
      0x193602a5, 0x75094c29, 0xa0591340, 0xe4183a3e,
      0x3f54989a, 0x5b429d65, 0x6b8fe4d6, 0x99f73fd6,
      0xa1d29c07, 0xefe830f5, 0x4d2d38e6, 0xf0255dc1,
      0x4cdd2086, 0x8470eb26, 0x6382e9c6, 0x021ecc5e,
      0x09686b3f, 0x3ebaefc9, 0x3c971814, 0x6b6a70a1,
      0x687f3584, 0x52a0e286, 0xb79c5305, 0xaa500737,
      0x3e07841c, 0x7fdeae5c, 0x8e7d44ec, 0x5716f2b8,
      0xb03ada37, 0xf0500c0d, 0xf01c1f04, 0x0200b3ff,
      0xae0cf51a, 0x3cb574b2, 0x25837a58, 0xdc0921bd,
      0xd19113f9, 0x7ca92ff6, 0x94324773, 0x22f54701,
      0x3ae5e581, 0x37c2dadc, 0xc8b57634, 0x9af3dda7,
      0xa9446146, 0x0fd0030e, 0xecc8c73e, 0xa4751e41,
      0xe238cd99, 0x3bea0e2f, 0x3280bba1, 0x183eb331,
      0x4e548b38, 0x4f6db908, 0x6f420d03, 0xf60a04bf,
      0x2cb81290, 0x24977c79, 0x5679b072, 0xbcaf89af,
      0xde9a771f, 0xd9930810, 0xb38bae12, 0xdccf3f2e,
      0x5512721f, 0x2e6b7124, 0x501adde6, 0x9f84cd87,
      0x7a584718, 0x7408da17, 0xbc9f9abc, 0xe94b7d8c,
      0xec7aec3a, 0xdb851dfa, 0x63094366, 0xc464c3d2,
      0xef1c1847, 0x3215d908, 0xdd433b37, 0x24c2ba16,
      0x12a14d43, 0x2a65c451, 0x50940002, 0x133ae4dd,
      0x71dff89e, 0x10314e55, 0x81ac77d6, 0x5f11199b,
      0x043556f1, 0xd7a3c76b, 0x3c11183b, 0x5924a509,
      0xf28fe6ed, 0x97f1fbfa, 0x9ebabf2c, 0x1e153c6e,
      0x86e34570, 0xeae96fb1, 0x860e5e0a, 0x5a3e2ab3,
      0x771fe71c, 0x4e3d06fa, 0x2965dcb9, 0x99e71d0f,
      0x803e89d6, 0x5266c825, 0x2e4cc978, 0x9c10b36a,
      0xc6150eba, 0x94e2ea78, 0xa5fc3c53, 0x1e0a2df4,
      0xf2f74ea7, 0x361d2b3d, 0x1939260f, 0x19c27960,
      0x5223a708, 0xf71312b6, 0xebadfe6e, 0xeac31f66,
      0xe3bc4595, 0xa67bc883, 0xb17f37d1, 0x018cff28,
      0xc332ddef, 0xbe6c5aa5, 0x65582185, 0x68ab9802,
      0xeecea50f, 0xdb2f953b, 0x2aef7dad, 0x5b6e2f84,
      0x1521b628, 0x29076170, 0xecdd4775, 0x619f1510,
      0x13cca830, 0xeb61bd96, 0x0334fe1e, 0xaa0363cf,
      0xb5735c90, 0x4c70a239, 0xd59e9e0b, 0xcbaade14,
      0xeecc86bc, 0x60622ca7, 0x9cab5cab, 0xb2f3846e,
      0x648b1eaf, 0x19bdf0ca, 0xa02369b9, 0x655abb50,
      0x40685a32, 0x3c2ab4b3, 0x319ee9d5, 0xc021b8f7,
      0x9b540b19, 0x875fa099, 0x95f7997e, 0x623d7da8,
      0xf837889a, 0x97e32d77, 0x11ed935f, 0x16681281,
      0x0e358829, 0xc7e61fd6, 0x96dedfa1, 0x7858ba99,
      0x57f584a5, 0x1b227263, 0x9b83c3ff, 0x1ac24696,
      0xcdb30aeb, 0x532e3054, 0x8fd948e4, 0x6dbc3128,
      0x58ebf2ef, 0x34c6ffea, 0xfe28ed61, 0xee7c3c73,
      0x5d4a14d9, 0xe864b7e3, 0x42105d14, 0x203e13e0,
      0x45eee2b6, 0xa3aaabea, 0xdb6c4f15, 0xfacb4fd0,
      0xc742f442, 0xef6abbb5, 0x654f3b1d, 0x41cd2105,
      0xd81e799e, 0x86854dc7, 0xe44b476a, 0x3d816250,
      0xcf62a1f2, 0x5b8d2646, 0xfc8883a0, 0xc1c7b6a3,
      0x7f1524c3, 0x69cb7492, 0x47848a0b, 0x5692b285,
      0x095bbf00, 0xad19489d, 0x1462b174, 0x23820e00,
      0x58428d2a, 0x0c55f5ea, 0x1dadf43e, 0x233f7061,
      0x3372f092, 0x8d937e41, 0xd65fecf1, 0x6c223bdb,
      0x7cde3759, 0xcbee7460, 0x4085f2a7, 0xce77326e,
      0xa6078084, 0x19f8509e, 0xe8efd855, 0x61d99735,
      0xa969a7aa, 0xc50c06c2, 0x5a04abfc, 0x800bcadc,
      0x9e447a2e, 0xc3453484, 0xfdd56705, 0x0e1e9ec9,
      0xdb73dbd3, 0x105588cd, 0x675fda79, 0xe3674340,
      0xc5c43465, 0x713e38d8, 0x3d28f89e, 0xf16dff20,
      0x153e21e7, 0x8fb03d4a, 0xe6e39f2b, 0xdb83adf7]),
    new Uint32Array([
      0xe93d5a68, 0x948140f7, 0xf64c261c, 0x94692934,
      0x411520f7, 0x7602d4f7, 0xbcf46b2e, 0xd4a20068,
      0xd4082471, 0x3320f46a, 0x43b7d4b7, 0x500061af,
      0x1e39f62e, 0x97244546, 0x14214f74, 0xbf8b8840,
      0x4d95fc1d, 0x96b591af, 0x70f4ddd3, 0x66a02f45,
      0xbfbc09ec, 0x03bd9785, 0x7fac6dd0, 0x31cb8504,
      0x96eb27b3, 0x55fd3941, 0xda2547e6, 0xabca0a9a,
      0x28507825, 0x530429f4, 0x0a2c86da, 0xe9b66dfb,
      0x68dc1462, 0xd7486900, 0x680ec0a4, 0x27a18dee,
      0x4f3ffea2, 0xe887ad8c, 0xb58ce006, 0x7af4d6b6,
      0xaace1e7c, 0xd3375fec, 0xce78a399, 0x406b2a42,
      0x20fe9e35, 0xd9f385b9, 0xee39d7ab, 0x3b124e8b,
      0x1dc9faf7, 0x4b6d1856, 0x26a36631, 0xeae397b2,
      0x3a6efa74, 0xdd5b4332, 0x6841e7f7, 0xca7820fb,
      0xfb0af54e, 0xd8feb397, 0x454056ac, 0xba489527,
      0x55533a3a, 0x20838d87, 0xfe6ba9b7, 0xd096954b,
      0x55a867bc, 0xa1159a58, 0xcca92963, 0x99e1db33,
      0xa62a4a56, 0x3f3125f9, 0x5ef47e1c, 0x9029317c,
      0xfdf8e802, 0x04272f70, 0x80bb155c, 0x05282ce3,
      0x95c11548, 0xe4c66d22, 0x48c1133f, 0xc70f86dc,
      0x07f9c9ee, 0x41041f0f, 0x404779a4, 0x5d886e17,
      0x325f51eb, 0xd59bc0d1, 0xf2bcc18f, 0x41113564,
      0x257b7834, 0x602a9c60, 0xdff8e8a3, 0x1f636c1b,
      0x0e12b4c2, 0x02e1329e, 0xaf664fd1, 0xcad18115,
      0x6b2395e0, 0x333e92e1, 0x3b240b62, 0xeebeb922,
      0x85b2a20e, 0xe6ba0d99, 0xde720c8c, 0x2da2f728,
      0xd0127845, 0x95b794fd, 0x647d0862, 0xe7ccf5f0,
      0x5449a36f, 0x877d48fa, 0xc39dfd27, 0xf33e8d1e,
      0x0a476341, 0x992eff74, 0x3a6f6eab, 0xf4f8fd37,
      0xa812dc60, 0xa1ebddf8, 0x991be14c, 0xdb6e6b0d,
      0xc67b5510, 0x6d672c37, 0x2765d43b, 0xdcd0e804,
      0xf1290dc7, 0xcc00ffa3, 0xb5390f92, 0x690fed0b,
      0x667b9ffb, 0xcedb7d9c, 0xa091cf0b, 0xd9155ea3,
      0xbb132f88, 0x515bad24, 0x7b9479bf, 0x763bd6eb,
      0x37392eb3, 0xcc115979, 0x8026e297, 0xf42e312d,
      0x6842ada7, 0xc66a2b3b, 0x12754ccc, 0x782ef11c,
      0x6a124237, 0xb79251e7, 0x06a1bbe6, 0x4bfb6350,
      0x1a6b1018, 0x11caedfa, 0x3d25bdd8, 0xe2e1c3c9,
      0x44421659, 0x0a121386, 0xd90cec6e, 0xd5abea2a,
      0x64af674e, 0xda86a85f, 0xbebfe988, 0x64e4c3fe,
      0x9dbc8057, 0xf0f7c086, 0x60787bf8, 0x6003604d,
      0xd1fd8346, 0xf6381fb0, 0x7745ae04, 0xd736fccc,
      0x83426b33, 0xf01eab71, 0xb0804187, 0x3c005e5f,
      0x77a057be, 0xbde8ae24, 0x55464299, 0xbf582e61,
      0x4e58f48f, 0xf2ddfda2, 0xf474ef38, 0x8789bdc2,
      0x5366f9c3, 0xc8b38e74, 0xb475f255, 0x46fcd9b9,
      0x7aeb2661, 0x8b1ddf84, 0x846a0e79, 0x915f95e2,
      0x466e598e, 0x20b45770, 0x8cd55591, 0xc902de4c,
      0xb90bace1, 0xbb8205d0, 0x11a86248, 0x7574a99e,
      0xb77f19b6, 0xe0a9dc09, 0x662d09a1, 0xc4324633,
      0xe85a1f02, 0x09f0be8c, 0x4a99a025, 0x1d6efe10,
      0x1ab93d1d, 0x0ba5a4df, 0xa186f20f, 0x2868f169,
      0xdcb7da83, 0x573906fe, 0xa1e2ce9b, 0x4fcd7f52,
      0x50115e01, 0xa70683fa, 0xa002b5c4, 0x0de6d027,
      0x9af88c27, 0x773f8641, 0xc3604c06, 0x61a806b5,
      0xf0177a28, 0xc0f586e0, 0x006058aa, 0x30dc7d62,
      0x11e69ed7, 0x2338ea63, 0x53c2dd94, 0xc2c21634,
      0xbbcbee56, 0x90bcb6de, 0xebfc7da1, 0xce591d76,
      0x6f05e409, 0x4b7c0188, 0x39720a3d, 0x7c927c24,
      0x86e3725f, 0x724d9db9, 0x1ac15bb4, 0xd39eb8fc,
      0xed545578, 0x08fca5b5, 0xd83d7cd3, 0x4dad0fc4,
      0x1e50ef5e, 0xb161e6f8, 0xa28514d9, 0x6c51133c,
      0x6fd5c7e7, 0x56e14ec4, 0x362abfce, 0xddc6c837,
      0xd79a3234, 0x92638212, 0x670efa8e, 0x406000e0]),
    new Uint32Array([
      0x3a39ce37, 0xd3faf5cf, 0xabc27737, 0x5ac52d1b,
      0x5cb0679e, 0x4fa33742, 0xd3822740, 0x99bc9bbe,
      0xd5118e9d, 0xbf0f7315, 0xd62d1c7e, 0xc700c47b,
      0xb78c1b6b, 0x21a19045, 0xb26eb1be, 0x6a366eb4,
      0x5748ab2f, 0xbc946e79, 0xc6a376d2, 0x6549c2c8,
      0x530ff8ee, 0x468dde7d, 0xd5730a1d, 0x4cd04dc6,
      0x2939bbdb, 0xa9ba4650, 0xac9526e8, 0xbe5ee304,
      0xa1fad5f0, 0x6a2d519a, 0x63ef8ce2, 0x9a86ee22,
      0xc089c2b8, 0x43242ef6, 0xa51e03aa, 0x9cf2d0a4,
      0x83c061ba, 0x9be96a4d, 0x8fe51550, 0xba645bd6,
      0x2826a2f9, 0xa73a3ae1, 0x4ba99586, 0xef5562e9,
      0xc72fefd3, 0xf752f7da, 0x3f046f69, 0x77fa0a59,
      0x80e4a915, 0x87b08601, 0x9b09e6ad, 0x3b3ee593,
      0xe990fd5a, 0x9e34d797, 0x2cf0b7d9, 0x022b8b51,
      0x96d5ac3a, 0x017da67d, 0xd1cf3ed6, 0x7c7d2d28,
      0x1f9f25cf, 0xadf2b89b, 0x5ad6b472, 0x5a88f54c,
      0xe029ac71, 0xe019a5e6, 0x47b0acfd, 0xed93fa9b,
      0xe8d3c48d, 0x283b57cc, 0xf8d56629, 0x79132e28,
      0x785f0191, 0xed756055, 0xf7960e44, 0xe3d35e8c,
      0x15056dd4, 0x88f46dba, 0x03a16125, 0x0564f0bd,
      0xc3eb9e15, 0x3c9057a2, 0x97271aec, 0xa93a072a,
      0x1b3f6d9b, 0x1e6321f5, 0xf59c66fb, 0x26dcf319,
      0x7533d928, 0xb155fdf5, 0x03563482, 0x8aba3cbb,
      0x28517711, 0xc20ad9f8, 0xabcc5167, 0xccad925f,
      0x4de81751, 0x3830dc8e, 0x379d5862, 0x9320f991,
      0xea7a90c2, 0xfb3e7bce, 0x5121ce64, 0x774fbe32,
      0xa8b6e37e, 0xc3293d46, 0x48de5369, 0x6413e680,
      0xa2ae0810, 0xdd6db224, 0x69852dfd, 0x09072166,
      0xb39a460a, 0x6445c0dd, 0x586cdecf, 0x1c20c8ae,
      0x5bbef7dd, 0x1b588d40, 0xccd2017f, 0x6bb4e3bb,
      0xdda26a7e, 0x3a59ff45, 0x3e350a44, 0xbcb4cdd5,
      0x72eacea8, 0xfa6484bb, 0x8d6612ae, 0xbf3c6f47,
      0xd29be463, 0x542f5d9e, 0xaec2771b, 0xf64e6370,
      0x740e0d8d, 0xe75b1357, 0xf8721671, 0xaf537d5d,
      0x4040cb08, 0x4eb4e2cc, 0x34d2466a, 0x0115af84,
      0xe1b00428, 0x95983a1d, 0x06b89fb4, 0xce6ea048,
      0x6f3f3b82, 0x3520ab82, 0x011a1d4b, 0x277227f8,
      0x611560b1, 0xe7933fdc, 0xbb3a792b, 0x344525bd,
      0xa08839e1, 0x51ce794b, 0x2f32c9b7, 0xa01fbac9,
      0xe01cc87e, 0xbcc7d1f6, 0xcf0111c3, 0xa1e8aac7,
      0x1a908749, 0xd44fbd9a, 0xd0dadecb, 0xd50ada38,
      0x0339c32a, 0xc6913667, 0x8df9317c, 0xe0b12b4f,
      0xf79e59b7, 0x43f5bb3a, 0xf2d519ff, 0x27d9459c,
      0xbf97222c, 0x15e6fc2a, 0x0f91fc71, 0x9b941525,
      0xfae59361, 0xceb69ceb, 0xc2a86459, 0x12baa8d1,
      0xb6c1075e, 0xe3056a0c, 0x10d25065, 0xcb03a442,
      0xe0ec6e0e, 0x1698db3b, 0x4c98a0be, 0x3278e964,
      0x9f1f9532, 0xe0d392df, 0xd3a0342b, 0x8971f21e,
      0x1b0a7441, 0x4ba3348c, 0xc5be7120, 0xc37632d8,
      0xdf359f8d, 0x9b992f2e, 0xe60b6f47, 0x0fe3f11d,
      0xe54cda54, 0x1edad891, 0xce6279cf, 0xcd3e7e6f,
      0x1618b166, 0xfd2c1d05, 0x848fd2c5, 0xf6fb2299,
      0xf523f357, 0xa6327623, 0x93a83531, 0x56cccd02,
      0xacf08162, 0x5a75ebb5, 0x6e163697, 0x88d273cc,
      0xde966292, 0x81b949d0, 0x4c50901b, 0x71c65614,
      0xe6c6c7bd, 0x327a140a, 0x45e1d006, 0xc3f27b9a,
      0xc9aa53fd, 0x62a80f00, 0xbb25bfe2, 0x35bdd2f6,
      0x71126905, 0xb2040222, 0xb6cbcf7c, 0xcd769c2b,
      0x53113ec0, 0x1640e3d3, 0x38abbd60, 0x2547adf0,
      0xba38209c, 0xf746ce76, 0x77afa1c5, 0x20756060,
      0x85cbfe4e, 0x8ae88dd8, 0x7aaaf9b0, 0x4cf9aa7e,
      0x1948c25c, 0x02fb8a8c, 0x01c36ae4, 0xd6ebe1f9,
      0x90d4f869, 0xa65cdea0, 0x3f09252d, 0xc208e69f,
      0xb74e6132, 0xce77e25b, 0x578fdfe3, 0x3ac372e6])
    ];
  this.P = new Uint32Array([
    0x243f6a88, 0x85a308d3, 0x13198a2e, 0x03707344,
    0xa4093822, 0x299f31d0, 0x082efa98, 0xec4e6c89,
    0x452821e6, 0x38d01377, 0xbe5466cf, 0x34e90c6c,
    0xc0ac29b7, 0xc97c50dd, 0x3f84d5b5, 0xb5470917,
    0x9216d5d9, 0x8979fb1b]);
};

function F(S, x8, i) {
  return (((S[0][x8[i+3]] +
            S[1][x8[i+2]]) ^
            S[2][x8[i+1]]) +
            S[3][x8[i]]);
};

Blowfish.prototype.encipher = function(x, x8) {
  if (x8 === undefined) {
    x8 = new Uint8Array(x.buffer);
    if (x.byteOffset !== 0)
      x8 = x8.subarray(x.byteOffset);
  }
  x[0] ^= this.P[0];
  for (var i = 1; i < 16; i += 2) {
    x[1] ^= F(this.S, x8, 0) ^ this.P[i];
    x[0] ^= F(this.S, x8, 4) ^ this.P[i+1];
  }
  var t = x[0];
  x[0] = x[1] ^ this.P[17];
  x[1] = t;
};

Blowfish.prototype.decipher = function(x) {
  var x8 = new Uint8Array(x.buffer);
  if (x.byteOffset !== 0)
    x8 = x8.subarray(x.byteOffset);
  x[0] ^= this.P[17];
  for (var i = 16; i > 0; i -= 2) {
    x[1] ^= F(this.S, x8, 0) ^ this.P[i];
    x[0] ^= F(this.S, x8, 4) ^ this.P[i-1];
  }
  var t = x[0];
  x[0] = x[1] ^ this.P[0];
  x[1] = t;
};

function stream2word(data, databytes){
  var i, temp = 0;
  for (i = 0; i < 4; i++, BLF_J++) {
    if (BLF_J >= databytes) BLF_J = 0;
    temp = (temp << 8) | data[BLF_J];
  }
  return temp;
};

Blowfish.prototype.expand0state = function(key, keybytes) {
  var d = new Uint32Array(2), i, k;
  var d8 = new Uint8Array(d.buffer);

  for (i = 0, BLF_J = 0; i < 18; i++) {
    this.P[i] ^= stream2word(key, keybytes);
  }
  BLF_J = 0;

  for (i = 0; i < 18; i += 2) {
    this.encipher(d, d8);
    this.P[i]   = d[0];
    this.P[i+1] = d[1];
  }

  for (i = 0; i < 4; i++) {
    for (k = 0; k < 256; k += 2) {
      this.encipher(d, d8);
      this.S[i][k]   = d[0];
      this.S[i][k+1] = d[1];
    }
  }
};

Blowfish.prototype.expandstate = function(data, databytes, key, keybytes) {
  var d = new Uint32Array(2), i, k;

  for (i = 0, BLF_J = 0; i < 18; i++) {
    this.P[i] ^= stream2word(key, keybytes);
  }

  for (i = 0, BLF_J = 0; i < 18; i += 2) {
    d[0] ^= stream2word(data, databytes);
    d[1] ^= stream2word(data, databytes);
    this.encipher(d);
    this.P[i]   = d[0];
    this.P[i+1] = d[1];
  }

  for (i = 0; i < 4; i++) {
    for (k = 0; k < 256; k += 2) {
      d[0] ^= stream2word(data, databytes);
      d[1] ^= stream2word(data, databytes);
      this.encipher(d);
      this.S[i][k]   = d[0];
      this.S[i][k+1] = d[1];
    }
  }
  BLF_J = 0;
};

Blowfish.prototype.enc = function(data, blocks) {
  for (var i = 0; i < blocks; i++) {
    this.encipher(data.subarray(i*2));
  }
};

Blowfish.prototype.dec = function(data, blocks) {
  for (var i = 0; i < blocks; i++) {
    this.decipher(data.subarray(i*2));
  }
};

var BCRYPT_BLOCKS = 8,
    BCRYPT_HASHSIZE = 32;

function bcrypt_hash(sha2pass, sha2salt, out) {
  var state = new Blowfish(),
      cdata = new Uint32Array(BCRYPT_BLOCKS), i,
      ciphertext = new Uint8Array([79,120,121,99,104,114,111,109,97,116,105,
            99,66,108,111,119,102,105,115,104,83,119,97,116,68,121,110,97,109,
            105,116,101]); //"OxychromaticBlowfishSwatDynamite"

  state.expandstate(sha2salt, 64, sha2pass, 64);
  for (i = 0; i < 64; i++) {
    state.expand0state(sha2salt, 64);
    state.expand0state(sha2pass, 64);
  }

  for (i = 0; i < BCRYPT_BLOCKS; i++)
    cdata[i] = stream2word(ciphertext, ciphertext.byteLength);
  for (i = 0; i < 64; i++)
    state.enc(cdata, cdata.byteLength / 8);

  for (i = 0; i < BCRYPT_BLOCKS; i++) {
    out[4*i+3] = cdata[i] >>> 24;
    out[4*i+2] = cdata[i] >>> 16;
    out[4*i+1] = cdata[i] >>> 8;
    out[4*i+0] = cdata[i];
  }
};

function bcrypt_pbkdf(pass, passlen, salt, saltlen, key, keylen, rounds) {
  var sha2pass = new Uint8Array(64),
      sha2salt = new Uint8Array(64),
      out = new Uint8Array(BCRYPT_HASHSIZE),
      tmpout = new Uint8Array(BCRYPT_HASHSIZE),
      countsalt = new Uint8Array(saltlen+4),
      i, j, amt, stride, dest, count,
      origkeylen = keylen;

  if (rounds < 1)
    return -1;
  if (passlen === 0 || saltlen === 0 || keylen === 0 ||
      keylen > (out.byteLength * out.byteLength) || saltlen > (1<<20))
    return -1;

  stride = Math.floor((keylen + out.byteLength - 1) / out.byteLength);
  amt = Math.floor((keylen + stride - 1) / stride);

  for (i = 0; i < saltlen; i++)
    countsalt[i] = salt[i];

  crypto_hash_sha512(sha2pass, pass, passlen);

  for (count = 1; keylen > 0; count++) {
    countsalt[saltlen+0] = count >>> 24;
    countsalt[saltlen+1] = count >>> 16;
    countsalt[saltlen+2] = count >>>  8;
    countsalt[saltlen+3] = count;

    crypto_hash_sha512(sha2salt, countsalt, saltlen + 4);
    bcrypt_hash(sha2pass, sha2salt, tmpout);
    for (i = out.byteLength; i--;)
      out[i] = tmpout[i];

    for (i = 1; i < rounds; i++) {
      crypto_hash_sha512(sha2salt, tmpout, tmpout.byteLength);
      bcrypt_hash(sha2pass, sha2salt, tmpout);
      for (j = 0; j < out.byteLength; j++)
        out[j] ^= tmpout[j];
    }

    amt = Math.min(amt, keylen);
    for (i = 0; i < amt; i++) {
      dest = i * stride + (count - 1);
      if (dest >= origkeylen)
        break;
      key[dest] = out[i];
    }
    keylen -= i;
  }

  return 0;
};

module.exports = {
      BLOCKS: BCRYPT_BLOCKS,
      HASHSIZE: BCRYPT_HASHSIZE,
      hash: bcrypt_hash,
      pbkdf: bcrypt_pbkdf
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

module.exports = {
	read: read,
	write: write
};

var assert = __webpack_require__(3);
var Buffer = __webpack_require__(4).Buffer;
var rfc4253 = __webpack_require__(29);
var utils = __webpack_require__(9);
var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);

var sshpriv = __webpack_require__(57);

/*JSSTYLED*/
var SSHKEY_RE = /^([a-z0-9-]+)[ \t]+([a-zA-Z0-9+\/]+[=]*)([ \t]+([^ \t][^\n]*[\n]*)?)?$/;
/*JSSTYLED*/
var SSHKEY_RE2 = /^([a-z0-9-]+)[ \t\n]+([a-zA-Z0-9+\/][a-zA-Z0-9+\/ \t\n=]*)([^a-zA-Z0-9+\/ \t\n=].*)?$/;

function read(buf, options) {
	if (typeof (buf) !== 'string') {
		assert.buffer(buf, 'buf');
		buf = buf.toString('ascii');
	}

	var trimmed = buf.trim().replace(/[\\\r]/g, '');
	var m = trimmed.match(SSHKEY_RE);
	if (!m)
		m = trimmed.match(SSHKEY_RE2);
	assert.ok(m, 'key must match regex');

	var type = rfc4253.algToKeyType(m[1]);
	var kbuf = Buffer.from(m[2], 'base64');

	/*
	 * This is a bit tricky. If we managed to parse the key and locate the
	 * key comment with the regex, then do a non-partial read and assert
	 * that we have consumed all bytes. If we couldn't locate the key
	 * comment, though, there may be whitespace shenanigans going on that
	 * have conjoined the comment to the rest of the key. We do a partial
	 * read in this case to try to make the best out of a sorry situation.
	 */
	var key;
	var ret = {};
	if (m[4]) {
		try {
			key = rfc4253.read(kbuf);

		} catch (e) {
			m = trimmed.match(SSHKEY_RE2);
			assert.ok(m, 'key must match regex');
			kbuf = Buffer.from(m[2], 'base64');
			key = rfc4253.readInternal(ret, 'public', kbuf);
		}
	} else {
		key = rfc4253.readInternal(ret, 'public', kbuf);
	}

	assert.strictEqual(type, key.type);

	if (m[4] && m[4].length > 0) {
		key.comment = m[4];

	} else if (ret.consumed) {
		/*
		 * Now the magic: trying to recover the key comment when it's
		 * gotten conjoined to the key or otherwise shenanigan'd.
		 *
		 * Work out how much base64 we used, then drop all non-base64
		 * chars from the beginning up to this point in the the string.
		 * Then offset in this and try to make up for missing = chars.
		 */
		var data = m[2] + (m[3] ? m[3] : '');
		var realOffset = Math.ceil(ret.consumed / 3) * 4;
		data = data.slice(0, realOffset - 2). /*JSSTYLED*/
		    replace(/[^a-zA-Z0-9+\/=]/g, '') +
		    data.slice(realOffset - 2);

		var padding = ret.consumed % 3;
		if (padding > 0 &&
		    data.slice(realOffset - 1, realOffset) !== '=')
			realOffset--;
		while (data.slice(realOffset, realOffset + 1) === '=')
			realOffset++;

		/* Finally, grab what we think is the comment & clean it up. */
		var trailer = data.slice(realOffset);
		trailer = trailer.replace(/[\r\n]/g, ' ').
		    replace(/^\s+/, '');
		if (trailer.match(/^[a-zA-Z0-9]/))
			key.comment = trailer;
	}

	return (key);
}

function write(key, options) {
	assert.object(key);
	if (!Key.isKey(key))
		throw (new Error('Must be a public key'));

	var parts = [];
	var alg = rfc4253.keyTypeToAlg(key);
	parts.push(alg);

	var buf = rfc4253.write(key);
	parts.push(buf.toString('base64'));

	if (key.comment)
		parts.push(key.comment);

	return (Buffer.from(parts.join(' ')));
}


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2017 Joyent, Inc.

module.exports = {
	read: read,
	verify: verify,
	sign: sign,
	signAsync: signAsync,
	write: write
};

var assert = __webpack_require__(3);
var asn1 = __webpack_require__(22);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var utils = __webpack_require__(9);
var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);
var pem = __webpack_require__(26);
var Identity = __webpack_require__(47);
var Signature = __webpack_require__(20);
var Certificate = __webpack_require__(43);
var pkcs8 = __webpack_require__(45);

/*
 * This file is based on RFC5280 (X.509).
 */

/* Helper to read in a single mpint */
function readMPInt(der, nm) {
	assert.strictEqual(der.peek(), asn1.Ber.Integer,
	    nm + ' is not an Integer');
	return (utils.mpNormalize(der.readString(asn1.Ber.Integer, true)));
}

function verify(cert, key) {
	var sig = cert.signatures.x509;
	assert.object(sig, 'x509 signature');

	var algParts = sig.algo.split('-');
	if (algParts[0] !== key.type)
		return (false);

	var blob = sig.cache;
	if (blob === undefined) {
		var der = new asn1.BerWriter();
		writeTBSCert(cert, der);
		blob = der.buffer;
	}

	var verifier = key.createVerify(algParts[1]);
	verifier.write(blob);
	return (verifier.verify(sig.signature));
}

function Local(i) {
	return (asn1.Ber.Context | asn1.Ber.Constructor | i);
}

function Context(i) {
	return (asn1.Ber.Context | i);
}

var SIGN_ALGS = {
	'rsa-md5': '1.2.840.113549.1.1.4',
	'rsa-sha1': '1.2.840.113549.1.1.5',
	'rsa-sha256': '1.2.840.113549.1.1.11',
	'rsa-sha384': '1.2.840.113549.1.1.12',
	'rsa-sha512': '1.2.840.113549.1.1.13',
	'dsa-sha1': '1.2.840.10040.4.3',
	'dsa-sha256': '2.16.840.1.101.3.4.3.2',
	'ecdsa-sha1': '1.2.840.10045.4.1',
	'ecdsa-sha256': '1.2.840.10045.4.3.2',
	'ecdsa-sha384': '1.2.840.10045.4.3.3',
	'ecdsa-sha512': '1.2.840.10045.4.3.4',
	'ed25519-sha512': '1.3.101.112'
};
Object.keys(SIGN_ALGS).forEach(function (k) {
	SIGN_ALGS[SIGN_ALGS[k]] = k;
});
SIGN_ALGS['1.3.14.3.2.3'] = 'rsa-md5';
SIGN_ALGS['1.3.14.3.2.29'] = 'rsa-sha1';

var EXTS = {
	'issuerKeyId': '2.5.29.35',
	'altName': '2.5.29.17',
	'basicConstraints': '2.5.29.19',
	'keyUsage': '2.5.29.15',
	'extKeyUsage': '2.5.29.37'
};

function read(buf, options) {
	if (typeof (buf) === 'string') {
		buf = Buffer.from(buf, 'binary');
	}
	assert.buffer(buf, 'buf');

	var der = new asn1.BerReader(buf);

	der.readSequence();
	if (Math.abs(der.length - der.remain) > 1) {
		throw (new Error('DER sequence does not contain whole byte ' +
		    'stream'));
	}

	var tbsStart = der.offset;
	der.readSequence();
	var sigOffset = der.offset + der.length;
	var tbsEnd = sigOffset;

	if (der.peek() === Local(0)) {
		der.readSequence(Local(0));
		var version = der.readInt();
		assert.ok(version <= 3,
		    'only x.509 versions up to v3 supported');
	}

	var cert = {};
	cert.signatures = {};
	var sig = (cert.signatures.x509 = {});
	sig.extras = {};

	cert.serial = readMPInt(der, 'serial');

	der.readSequence();
	var after = der.offset + der.length;
	var certAlgOid = der.readOID();
	var certAlg = SIGN_ALGS[certAlgOid];
	if (certAlg === undefined)
		throw (new Error('unknown signature algorithm ' + certAlgOid));

	der._offset = after;
	cert.issuer = Identity.parseAsn1(der);

	der.readSequence();
	cert.validFrom = readDate(der);
	cert.validUntil = readDate(der);

	cert.subjects = [Identity.parseAsn1(der)];

	der.readSequence();
	after = der.offset + der.length;
	cert.subjectKey = pkcs8.readPkcs8(undefined, 'public', der);
	der._offset = after;

	/* issuerUniqueID */
	if (der.peek() === Local(1)) {
		der.readSequence(Local(1));
		sig.extras.issuerUniqueID =
		    buf.slice(der.offset, der.offset + der.length);
		der._offset += der.length;
	}

	/* subjectUniqueID */
	if (der.peek() === Local(2)) {
		der.readSequence(Local(2));
		sig.extras.subjectUniqueID =
		    buf.slice(der.offset, der.offset + der.length);
		der._offset += der.length;
	}

	/* extensions */
	if (der.peek() === Local(3)) {
		der.readSequence(Local(3));
		var extEnd = der.offset + der.length;
		der.readSequence();

		while (der.offset < extEnd)
			readExtension(cert, buf, der);

		assert.strictEqual(der.offset, extEnd);
	}

	assert.strictEqual(der.offset, sigOffset);

	der.readSequence();
	after = der.offset + der.length;
	var sigAlgOid = der.readOID();
	var sigAlg = SIGN_ALGS[sigAlgOid];
	if (sigAlg === undefined)
		throw (new Error('unknown signature algorithm ' + sigAlgOid));
	der._offset = after;

	var sigData = der.readString(asn1.Ber.BitString, true);
	if (sigData[0] === 0)
		sigData = sigData.slice(1);
	var algParts = sigAlg.split('-');

	sig.signature = Signature.parse(sigData, algParts[0], 'asn1');
	sig.signature.hashAlgorithm = algParts[1];
	sig.algo = sigAlg;
	sig.cache = buf.slice(tbsStart, tbsEnd);

	return (new Certificate(cert));
}

function readDate(der) {
	if (der.peek() === asn1.Ber.UTCTime) {
		return (utcTimeToDate(der.readString(asn1.Ber.UTCTime)));
	} else if (der.peek() === asn1.Ber.GeneralizedTime) {
		return (gTimeToDate(der.readString(asn1.Ber.GeneralizedTime)));
	} else {
		throw (new Error('Unsupported date format'));
	}
}

/* RFC5280, section 4.2.1.6 (GeneralName type) */
var ALTNAME = {
	OtherName: Local(0),
	RFC822Name: Context(1),
	DNSName: Context(2),
	X400Address: Local(3),
	DirectoryName: Local(4),
	EDIPartyName: Local(5),
	URI: Context(6),
	IPAddress: Context(7),
	OID: Context(8)
};

/* RFC5280, section 4.2.1.12 (KeyPurposeId) */
var EXTPURPOSE = {
	'serverAuth': '1.3.6.1.5.5.7.3.1',
	'clientAuth': '1.3.6.1.5.5.7.3.2',
	'codeSigning': '1.3.6.1.5.5.7.3.3',

	/* See https://github.com/joyent/oid-docs/blob/master/root.md */
	'joyentDocker': '1.3.6.1.4.1.38678.1.4.1',
	'joyentCmon': '1.3.6.1.4.1.38678.1.4.2'
};
var EXTPURPOSE_REV = {};
Object.keys(EXTPURPOSE).forEach(function (k) {
	EXTPURPOSE_REV[EXTPURPOSE[k]] = k;
});

var KEYUSEBITS = [
	'signature', 'identity', 'keyEncryption',
	'encryption', 'keyAgreement', 'ca', 'crl'
];

function readExtension(cert, buf, der) {
	der.readSequence();
	var after = der.offset + der.length;
	var extId = der.readOID();
	var id;
	var sig = cert.signatures.x509;
	sig.extras.exts = [];

	var critical;
	if (der.peek() === asn1.Ber.Boolean)
		critical = der.readBoolean();

	switch (extId) {
	case (EXTS.basicConstraints):
		der.readSequence(asn1.Ber.OctetString);
		der.readSequence();
		var bcEnd = der.offset + der.length;
		var ca = false;
		if (der.peek() === asn1.Ber.Boolean)
			ca = der.readBoolean();
		if (cert.purposes === undefined)
			cert.purposes = [];
		if (ca === true)
			cert.purposes.push('ca');
		var bc = { oid: extId, critical: critical };
		if (der.offset < bcEnd && der.peek() === asn1.Ber.Integer)
			bc.pathLen = der.readInt();
		sig.extras.exts.push(bc);
		break;
	case (EXTS.extKeyUsage):
		der.readSequence(asn1.Ber.OctetString);
		der.readSequence();
		if (cert.purposes === undefined)
			cert.purposes = [];
		var ekEnd = der.offset + der.length;
		while (der.offset < ekEnd) {
			var oid = der.readOID();
			cert.purposes.push(EXTPURPOSE_REV[oid] || oid);
		}
		/*
		 * This is a bit of a hack: in the case where we have a cert
		 * that's only allowed to do serverAuth or clientAuth (and not
		 * the other), we want to make sure all our Subjects are of
		 * the right type. But we already parsed our Subjects and
		 * decided if they were hosts or users earlier (since it appears
		 * first in the cert).
		 *
		 * So we go through and mutate them into the right kind here if
		 * it doesn't match. This might not be hugely beneficial, as it
		 * seems that single-purpose certs are not often seen in the
		 * wild.
		 */
		if (cert.purposes.indexOf('serverAuth') !== -1 &&
		    cert.purposes.indexOf('clientAuth') === -1) {
			cert.subjects.forEach(function (ide) {
				if (ide.type !== 'host') {
					ide.type = 'host';
					ide.hostname = ide.uid ||
					    ide.email ||
					    ide.components[0].value;
				}
			});
		} else if (cert.purposes.indexOf('clientAuth') !== -1 &&
		    cert.purposes.indexOf('serverAuth') === -1) {
			cert.subjects.forEach(function (ide) {
				if (ide.type !== 'user') {
					ide.type = 'user';
					ide.uid = ide.hostname ||
					    ide.email ||
					    ide.components[0].value;
				}
			});
		}
		sig.extras.exts.push({ oid: extId, critical: critical });
		break;
	case (EXTS.keyUsage):
		der.readSequence(asn1.Ber.OctetString);
		var bits = der.readString(asn1.Ber.BitString, true);
		var setBits = readBitField(bits, KEYUSEBITS);
		setBits.forEach(function (bit) {
			if (cert.purposes === undefined)
				cert.purposes = [];
			if (cert.purposes.indexOf(bit) === -1)
				cert.purposes.push(bit);
		});
		sig.extras.exts.push({ oid: extId, critical: critical,
		    bits: bits });
		break;
	case (EXTS.altName):
		der.readSequence(asn1.Ber.OctetString);
		der.readSequence();
		var aeEnd = der.offset + der.length;
		while (der.offset < aeEnd) {
			switch (der.peek()) {
			case ALTNAME.OtherName:
			case ALTNAME.EDIPartyName:
				der.readSequence();
				der._offset += der.length;
				break;
			case ALTNAME.OID:
				der.readOID(ALTNAME.OID);
				break;
			case ALTNAME.RFC822Name:
				/* RFC822 specifies email addresses */
				var email = der.readString(ALTNAME.RFC822Name);
				id = Identity.forEmail(email);
				if (!cert.subjects[0].equals(id))
					cert.subjects.push(id);
				break;
			case ALTNAME.DirectoryName:
				der.readSequence(ALTNAME.DirectoryName);
				id = Identity.parseAsn1(der);
				if (!cert.subjects[0].equals(id))
					cert.subjects.push(id);
				break;
			case ALTNAME.DNSName:
				var host = der.readString(
				    ALTNAME.DNSName);
				id = Identity.forHost(host);
				if (!cert.subjects[0].equals(id))
					cert.subjects.push(id);
				break;
			default:
				der.readString(der.peek());
				break;
			}
		}
		sig.extras.exts.push({ oid: extId, critical: critical });
		break;
	default:
		sig.extras.exts.push({
			oid: extId,
			critical: critical,
			data: der.readString(asn1.Ber.OctetString, true)
		});
		break;
	}

	der._offset = after;
}

var UTCTIME_RE =
    /^([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})?Z$/;
function utcTimeToDate(t) {
	var m = t.match(UTCTIME_RE);
	assert.ok(m, 'timestamps must be in UTC');
	var d = new Date();

	var thisYear = d.getUTCFullYear();
	var century = Math.floor(thisYear / 100) * 100;

	var year = parseInt(m[1], 10);
	if (thisYear % 100 < 50 && year >= 60)
		year += (century - 1);
	else
		year += century;
	d.setUTCFullYear(year, parseInt(m[2], 10) - 1, parseInt(m[3], 10));
	d.setUTCHours(parseInt(m[4], 10), parseInt(m[5], 10));
	if (m[6] && m[6].length > 0)
		d.setUTCSeconds(parseInt(m[6], 10));
	return (d);
}

var GTIME_RE =
    /^([0-9]{4})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})?Z$/;
function gTimeToDate(t) {
	var m = t.match(GTIME_RE);
	assert.ok(m);
	var d = new Date();

	d.setUTCFullYear(parseInt(m[1], 10), parseInt(m[2], 10) - 1,
	    parseInt(m[3], 10));
	d.setUTCHours(parseInt(m[4], 10), parseInt(m[5], 10));
	if (m[6] && m[6].length > 0)
		d.setUTCSeconds(parseInt(m[6], 10));
	return (d);
}

function zeroPad(n) {
	var s = '' + n;
	while (s.length < 2)
		s = '0' + s;
	return (s);
}

function dateToUTCTime(d) {
	var s = '';
	s += zeroPad(d.getUTCFullYear() % 100);
	s += zeroPad(d.getUTCMonth() + 1);
	s += zeroPad(d.getUTCDate());
	s += zeroPad(d.getUTCHours());
	s += zeroPad(d.getUTCMinutes());
	s += zeroPad(d.getUTCSeconds());
	s += 'Z';
	return (s);
}

function sign(cert, key) {
	if (cert.signatures.x509 === undefined)
		cert.signatures.x509 = {};
	var sig = cert.signatures.x509;

	sig.algo = key.type + '-' + key.defaultHashAlgorithm();
	if (SIGN_ALGS[sig.algo] === undefined)
		return (false);

	var der = new asn1.BerWriter();
	writeTBSCert(cert, der);
	var blob = der.buffer;
	sig.cache = blob;

	var signer = key.createSign();
	signer.write(blob);
	cert.signatures.x509.signature = signer.sign();

	return (true);
}

function signAsync(cert, signer, done) {
	if (cert.signatures.x509 === undefined)
		cert.signatures.x509 = {};
	var sig = cert.signatures.x509;

	var der = new asn1.BerWriter();
	writeTBSCert(cert, der);
	var blob = der.buffer;
	sig.cache = blob;

	signer(blob, function (err, signature) {
		if (err) {
			done(err);
			return;
		}
		sig.algo = signature.type + '-' + signature.hashAlgorithm;
		if (SIGN_ALGS[sig.algo] === undefined) {
			done(new Error('Invalid signing algorithm "' +
			    sig.algo + '"'));
			return;
		}
		sig.signature = signature;
		done();
	});
}

function write(cert, options) {
	var sig = cert.signatures.x509;
	assert.object(sig, 'x509 signature');

	var der = new asn1.BerWriter();
	der.startSequence();
	if (sig.cache) {
		der._ensure(sig.cache.length);
		sig.cache.copy(der._buf, der._offset);
		der._offset += sig.cache.length;
	} else {
		writeTBSCert(cert, der);
	}

	der.startSequence();
	der.writeOID(SIGN_ALGS[sig.algo]);
	if (sig.algo.match(/^rsa-/))
		der.writeNull();
	der.endSequence();

	var sigData = sig.signature.toBuffer('asn1');
	var data = Buffer.alloc(sigData.length + 1);
	data[0] = 0;
	sigData.copy(data, 1);
	der.writeBuffer(data, asn1.Ber.BitString);
	der.endSequence();

	return (der.buffer);
}

function writeTBSCert(cert, der) {
	var sig = cert.signatures.x509;
	assert.object(sig, 'x509 signature');

	der.startSequence();

	der.startSequence(Local(0));
	der.writeInt(2);
	der.endSequence();

	der.writeBuffer(utils.mpNormalize(cert.serial), asn1.Ber.Integer);

	der.startSequence();
	der.writeOID(SIGN_ALGS[sig.algo]);
	if (sig.algo.match(/^rsa-/))
		der.writeNull();
	der.endSequence();

	cert.issuer.toAsn1(der);

	der.startSequence();
	der.writeString(dateToUTCTime(cert.validFrom), asn1.Ber.UTCTime);
	der.writeString(dateToUTCTime(cert.validUntil), asn1.Ber.UTCTime);
	der.endSequence();

	var subject = cert.subjects[0];
	var altNames = cert.subjects.slice(1);
	subject.toAsn1(der);

	pkcs8.writePkcs8(der, cert.subjectKey);

	if (sig.extras && sig.extras.issuerUniqueID) {
		der.writeBuffer(sig.extras.issuerUniqueID, Local(1));
	}

	if (sig.extras && sig.extras.subjectUniqueID) {
		der.writeBuffer(sig.extras.subjectUniqueID, Local(2));
	}

	if (altNames.length > 0 || subject.type === 'host' ||
	    (cert.purposes !== undefined && cert.purposes.length > 0) ||
	    (sig.extras && sig.extras.exts)) {
		der.startSequence(Local(3));
		der.startSequence();

		var exts = [];
		if (cert.purposes !== undefined && cert.purposes.length > 0) {
			exts.push({
				oid: EXTS.basicConstraints,
				critical: true
			});
			exts.push({
				oid: EXTS.keyUsage,
				critical: true
			});
			exts.push({
				oid: EXTS.extKeyUsage,
				critical: true
			});
		}
		exts.push({ oid: EXTS.altName });
		if (sig.extras && sig.extras.exts)
			exts = sig.extras.exts;

		for (var i = 0; i < exts.length; ++i) {
			der.startSequence();
			der.writeOID(exts[i].oid);

			if (exts[i].critical !== undefined)
				der.writeBoolean(exts[i].critical);

			if (exts[i].oid === EXTS.altName) {
				der.startSequence(asn1.Ber.OctetString);
				der.startSequence();
				if (subject.type === 'host') {
					der.writeString(subject.hostname,
					    Context(2));
				}
				for (var j = 0; j < altNames.length; ++j) {
					if (altNames[j].type === 'host') {
						der.writeString(
						    altNames[j].hostname,
						    ALTNAME.DNSName);
					} else if (altNames[j].type ===
					    'email') {
						der.writeString(
						    altNames[j].email,
						    ALTNAME.RFC822Name);
					} else {
						/*
						 * Encode anything else as a
						 * DN style name for now.
						 */
						der.startSequence(
						    ALTNAME.DirectoryName);
						altNames[j].toAsn1(der);
						der.endSequence();
					}
				}
				der.endSequence();
				der.endSequence();
			} else if (exts[i].oid === EXTS.basicConstraints) {
				der.startSequence(asn1.Ber.OctetString);
				der.startSequence();
				var ca = (cert.purposes.indexOf('ca') !== -1);
				var pathLen = exts[i].pathLen;
				der.writeBoolean(ca);
				if (pathLen !== undefined)
					der.writeInt(pathLen);
				der.endSequence();
				der.endSequence();
			} else if (exts[i].oid === EXTS.extKeyUsage) {
				der.startSequence(asn1.Ber.OctetString);
				der.startSequence();
				cert.purposes.forEach(function (purpose) {
					if (purpose === 'ca')
						return;
					if (KEYUSEBITS.indexOf(purpose) !== -1)
						return;
					var oid = purpose;
					if (EXTPURPOSE[purpose] !== undefined)
						oid = EXTPURPOSE[purpose];
					der.writeOID(oid);
				});
				der.endSequence();
				der.endSequence();
			} else if (exts[i].oid === EXTS.keyUsage) {
				der.startSequence(asn1.Ber.OctetString);
				/*
				 * If we parsed this certificate from a byte
				 * stream (i.e. we didn't generate it in sshpk)
				 * then we'll have a ".bits" property on the
				 * ext with the original raw byte contents.
				 *
				 * If we have this, use it here instead of
				 * regenerating it. This guarantees we output
				 * the same data we parsed, so signatures still
				 * validate.
				 */
				if (exts[i].bits !== undefined) {
					der.writeBuffer(exts[i].bits,
					    asn1.Ber.BitString);
				} else {
					var bits = writeBitField(cert.purposes,
					    KEYUSEBITS);
					der.writeBuffer(bits,
					    asn1.Ber.BitString);
				}
				der.endSequence();
			} else {
				der.writeBuffer(exts[i].data,
				    asn1.Ber.OctetString);
			}

			der.endSequence();
		}

		der.endSequence();
		der.endSequence();
	}

	der.endSequence();
}

/*
 * Reads an ASN.1 BER bitfield out of the Buffer produced by doing
 * `BerReader#readString(asn1.Ber.BitString)`. That function gives us the raw
 * contents of the BitString tag, which is a count of unused bits followed by
 * the bits as a right-padded byte string.
 *
 * `bits` is the Buffer, `bitIndex` should contain an array of string names
 * for the bits in the string, ordered starting with bit #0 in the ASN.1 spec.
 *
 * Returns an array of Strings, the names of the bits that were set to 1.
 */
function readBitField(bits, bitIndex) {
	var bitLen = 8 * (bits.length - 1) - bits[0];
	var setBits = {};
	for (var i = 0; i < bitLen; ++i) {
		var byteN = 1 + Math.floor(i / 8);
		var bit = 7 - (i % 8);
		var mask = 1 << bit;
		var bitVal = ((bits[byteN] & mask) !== 0);
		var name = bitIndex[i];
		if (bitVal && typeof (name) === 'string') {
			setBits[name] = true;
		}
	}
	return (Object.keys(setBits));
}

/*
 * `setBits` is an array of strings, containing the names for each bit that
 * sould be set to 1. `bitIndex` is same as in `readBitField()`.
 *
 * Returns a Buffer, ready to be written out with `BerWriter#writeString()`.
 */
function writeBitField(setBits, bitIndex) {
	var bitLen = bitIndex.length;
	var blen = Math.ceil(bitLen / 8);
	var unused = blen * 8 - bitLen;
	var bits = Buffer.alloc(1 + blen); // zero-filled
	bits[0] = unused;
	for (var i = 0; i < bitLen; ++i) {
		var byteN = 1 + Math.floor(i / 8);
		var bit = 7 - (i % 8);
		var mask = 1 << bit;
		var name = bitIndex[i];
		if (name === undefined)
			continue;
		var bitVal = (setBits.indexOf(name) !== -1);
		if (bitVal) {
			bits[byteN] |= mask;
		}
	}
	return (bits);
}


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/*
 * extsprintf.js: extended POSIX-style sprintf
 */

var mod_assert = __webpack_require__(28);
var mod_util = __webpack_require__(5);

/*
 * Public interface
 */
exports.sprintf = jsSprintf;
exports.printf = jsPrintf;
exports.fprintf = jsFprintf;

/*
 * Stripped down version of s[n]printf(3c).  We make a best effort to throw an
 * exception when given a format string we don't understand, rather than
 * ignoring it, so that we won't break existing programs if/when we go implement
 * the rest of this.
 *
 * This implementation currently supports specifying
 *	- field alignment ('-' flag),
 * 	- zero-pad ('0' flag)
 *	- always show numeric sign ('+' flag),
 *	- field width
 *	- conversions for strings, decimal integers, and floats (numbers).
 *	- argument size specifiers.  These are all accepted but ignored, since
 *	  Javascript has no notion of the physical size of an argument.
 *
 * Everything else is currently unsupported, most notably precision, unsigned
 * numbers, non-decimal numbers, and characters.
 */
function jsSprintf(fmt)
{
	var regex = [
	    '([^%]*)',				/* normal text */
	    '%',				/* start of format */
	    '([\'\\-+ #0]*?)',			/* flags (optional) */
	    '([1-9]\\d*)?',			/* width (optional) */
	    '(\\.([1-9]\\d*))?',		/* precision (optional) */
	    '[lhjztL]*?',			/* length mods (ignored) */
	    '([diouxXfFeEgGaAcCsSp%jr])'	/* conversion */
	].join('');

	var re = new RegExp(regex);
	var args = Array.prototype.slice.call(arguments, 1);
	var flags, width, precision, conversion;
	var left, pad, sign, arg, match;
	var ret = '';
	var argn = 1;

	mod_assert.equal('string', typeof (fmt));

	while ((match = re.exec(fmt)) !== null) {
		ret += match[1];
		fmt = fmt.substring(match[0].length);

		flags = match[2] || '';
		width = match[3] || 0;
		precision = match[4] || '';
		conversion = match[6];
		left = false;
		sign = false;
		pad = ' ';

		if (conversion == '%') {
			ret += '%';
			continue;
		}

		if (args.length === 0)
			throw (new Error('too few args to sprintf'));

		arg = args.shift();
		argn++;

		if (flags.match(/[\' #]/))
			throw (new Error(
			    'unsupported flags: ' + flags));

		if (precision.length > 0)
			throw (new Error(
			    'non-zero precision not supported'));

		if (flags.match(/-/))
			left = true;

		if (flags.match(/0/))
			pad = '0';

		if (flags.match(/\+/))
			sign = true;

		switch (conversion) {
		case 's':
			if (arg === undefined || arg === null)
				throw (new Error('argument ' + argn +
				    ': attempted to print undefined or null ' +
				    'as a string'));
			ret += doPad(pad, width, left, arg.toString());
			break;

		case 'd':
			arg = Math.floor(arg);
			/*jsl:fallthru*/
		case 'f':
			sign = sign && arg > 0 ? '+' : '';
			ret += sign + doPad(pad, width, left,
			    arg.toString());
			break;

		case 'x':
			ret += doPad(pad, width, left, arg.toString(16));
			break;

		case 'j': /* non-standard */
			if (width === 0)
				width = 10;
			ret += mod_util.inspect(arg, false, width);
			break;

		case 'r': /* non-standard */
			ret += dumpException(arg);
			break;

		default:
			throw (new Error('unsupported conversion: ' +
			    conversion));
		}
	}

	ret += fmt;
	return (ret);
}

function jsPrintf() {
	var args = Array.prototype.slice.call(arguments);
	args.unshift(process.stdout);
	jsFprintf.apply(null, args);
}

function jsFprintf(stream) {
	var args = Array.prototype.slice.call(arguments, 1);
	return (stream.write(jsSprintf.apply(this, args)));
}

function doPad(chr, width, left, str)
{
	var ret = str;

	while (ret.length < width) {
		if (left)
			ret += chr;
		else
			ret = chr + ret;
	}

	return (ret);
}

/*
 * This function dumps long stack traces for exceptions having a cause() method.
 * See node-verror for an example.
 */
function dumpException(ex)
{
	var ret;

	if (!(ex instanceof Error))
		throw (new Error(jsSprintf('invalid type for %%r: %j', ex)));

	/* Note that V8 prepends "ex.stack" with ex.toString(). */
	ret = 'EXCEPTION: ' + ex.constructor.name + ': ' + ex.stack;

	if (ex.cause && typeof (ex.cause) === 'function') {
		var cex = ex.cause();
		if (cex) {
			ret += '\nCaused by: ' + dumpException(cex);
		}
	}

	return (ret);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var stream = __webpack_require__(17)


function isStream (obj) {
  return obj instanceof stream.Stream
}


function isReadable (obj) {
  return isStream(obj) && typeof obj._read == 'function' && typeof obj._readableState == 'object'
}


function isWritable (obj) {
  return isStream(obj) && typeof obj._write == 'function' && typeof obj._writableState == 'object'
}


function isDuplex (obj) {
  return isReadable(obj) && isWritable(obj)
}


module.exports            = isStream
module.exports.isReadable = isReadable
module.exports.isWritable = isWritable
module.exports.isDuplex   = isDuplex


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(307);
var parse = __webpack_require__(308);
var formats = __webpack_require__(142);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    var obj;

    while (queue.length) {
        var item = queue.pop();
        obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }

    return obj;
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

var encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    return compactQueue(queue);
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(34);

module.exports = SchemaObject;

function SchemaObject(obj) {
  util.copy(obj, this);
}


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_validate(it, $keyword, $ruleType) {
  var out = '';
  var $async = it.schema.$async === true,
    $refKeywords = it.util.schemaHasRulesExcept(it.schema, it.RULES.all, '$ref'),
    $id = it.self._getId(it.schema);
  if (it.isTop) {
    if ($async) {
      it.async = true;
      var $es7 = it.opts.async == 'es7';
      it.yieldAwait = $es7 ? 'await' : 'yield';
    }
    out += ' var validate = ';
    if ($async) {
      if ($es7) {
        out += ' (async function ';
      } else {
        if (it.opts.async != '*') {
          out += 'co.wrap';
        }
        out += '(function* ';
      }
    } else {
      out += ' (function ';
    }
    out += ' (data, dataPath, parentData, parentDataProperty, rootData) { \'use strict\'; ';
    if ($id && (it.opts.sourceCode || it.opts.processCode)) {
      out += ' ' + ('/\*# sourceURL=' + $id + ' */') + ' ';
    }
  }
  if (typeof it.schema == 'boolean' || !($refKeywords || it.schema.$ref)) {
    var $keyword = 'false schema';
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = 'data' + ($dataLvl || '');
    var $valid = 'valid' + $lvl;
    if (it.schema === false) {
      if (it.isTop) {
        $breakOnError = true;
      } else {
        out += ' var ' + ($valid) + ' = false; ';
      }
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = ''; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || 'false schema') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
        if (it.opts.messages !== false) {
          out += ' , message: \'boolean schema is false\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: false , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
        if (it.async) {
          out += ' throw new ValidationError([' + (__err) + ']); ';
        } else {
          out += ' validate.errors = [' + (__err) + ']; return false; ';
        }
      } else {
        out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
      }
    } else {
      if (it.isTop) {
        if ($async) {
          out += ' return data; ';
        } else {
          out += ' validate.errors = null; return true; ';
        }
      } else {
        out += ' var ' + ($valid) + ' = true; ';
      }
    }
    if (it.isTop) {
      out += ' }); return validate; ';
    }
    return out;
  }
  if (it.isTop) {
    var $top = it.isTop,
      $lvl = it.level = 0,
      $dataLvl = it.dataLevel = 0,
      $data = 'data';
    it.rootId = it.resolve.fullPath(it.self._getId(it.root.schema));
    it.baseId = it.baseId || it.rootId;
    delete it.isTop;
    it.dataPathArr = [undefined];
    out += ' var vErrors = null; ';
    out += ' var errors = 0;     ';
    out += ' if (rootData === undefined) rootData = data; ';
  } else {
    var $lvl = it.level,
      $dataLvl = it.dataLevel,
      $data = 'data' + ($dataLvl || '');
    if ($id) it.baseId = it.resolve.url(it.baseId, $id);
    if ($async && !it.async) throw new Error('async schema in sync schema');
    out += ' var errs_' + ($lvl) + ' = errors;';
  }
  var $valid = 'valid' + $lvl,
    $breakOnError = !it.opts.allErrors,
    $closingBraces1 = '',
    $closingBraces2 = '';
  var $errorKeyword;
  var $typeSchema = it.schema.type,
    $typeIsArray = Array.isArray($typeSchema);
  if ($typeIsArray && $typeSchema.length == 1) {
    $typeSchema = $typeSchema[0];
    $typeIsArray = false;
  }
  if (it.schema.$ref && $refKeywords) {
    if (it.opts.extendRefs == 'fail') {
      throw new Error('$ref: validation keywords used in schema at path "' + it.errSchemaPath + '" (see option extendRefs)');
    } else if (it.opts.extendRefs !== true) {
      $refKeywords = false;
      it.logger.warn('$ref: keywords ignored in schema at path "' + it.errSchemaPath + '"');
    }
  }
  if ($typeSchema) {
    if (it.opts.coerceTypes) {
      var $coerceToTypes = it.util.coerceToTypes(it.opts.coerceTypes, $typeSchema);
    }
    var $rulesGroup = it.RULES.types[$typeSchema];
    if ($coerceToTypes || $typeIsArray || $rulesGroup === true || ($rulesGroup && !$shouldUseGroup($rulesGroup))) {
      var $schemaPath = it.schemaPath + '.type',
        $errSchemaPath = it.errSchemaPath + '/type';
      var $schemaPath = it.schemaPath + '.type',
        $errSchemaPath = it.errSchemaPath + '/type',
        $method = $typeIsArray ? 'checkDataTypes' : 'checkDataType';
      out += ' if (' + (it.util[$method]($typeSchema, $data, true)) + ') { ';
      if ($coerceToTypes) {
        var $dataType = 'dataType' + $lvl,
          $coerced = 'coerced' + $lvl;
        out += ' var ' + ($dataType) + ' = typeof ' + ($data) + '; ';
        if (it.opts.coerceTypes == 'array') {
          out += ' if (' + ($dataType) + ' == \'object\' && Array.isArray(' + ($data) + ')) ' + ($dataType) + ' = \'array\'; ';
        }
        out += ' var ' + ($coerced) + ' = undefined; ';
        var $bracesCoercion = '';
        var arr1 = $coerceToTypes;
        if (arr1) {
          var $type, $i = -1,
            l1 = arr1.length - 1;
          while ($i < l1) {
            $type = arr1[$i += 1];
            if ($i) {
              out += ' if (' + ($coerced) + ' === undefined) { ';
              $bracesCoercion += '}';
            }
            if (it.opts.coerceTypes == 'array' && $type != 'array') {
              out += ' if (' + ($dataType) + ' == \'array\' && ' + ($data) + '.length == 1) { ' + ($coerced) + ' = ' + ($data) + ' = ' + ($data) + '[0]; ' + ($dataType) + ' = typeof ' + ($data) + ';  } ';
            }
            if ($type == 'string') {
              out += ' if (' + ($dataType) + ' == \'number\' || ' + ($dataType) + ' == \'boolean\') ' + ($coerced) + ' = \'\' + ' + ($data) + '; else if (' + ($data) + ' === null) ' + ($coerced) + ' = \'\'; ';
            } else if ($type == 'number' || $type == 'integer') {
              out += ' if (' + ($dataType) + ' == \'boolean\' || ' + ($data) + ' === null || (' + ($dataType) + ' == \'string\' && ' + ($data) + ' && ' + ($data) + ' == +' + ($data) + ' ';
              if ($type == 'integer') {
                out += ' && !(' + ($data) + ' % 1)';
              }
              out += ')) ' + ($coerced) + ' = +' + ($data) + '; ';
            } else if ($type == 'boolean') {
              out += ' if (' + ($data) + ' === \'false\' || ' + ($data) + ' === 0 || ' + ($data) + ' === null) ' + ($coerced) + ' = false; else if (' + ($data) + ' === \'true\' || ' + ($data) + ' === 1) ' + ($coerced) + ' = true; ';
            } else if ($type == 'null') {
              out += ' if (' + ($data) + ' === \'\' || ' + ($data) + ' === 0 || ' + ($data) + ' === false) ' + ($coerced) + ' = null; ';
            } else if (it.opts.coerceTypes == 'array' && $type == 'array') {
              out += ' if (' + ($dataType) + ' == \'string\' || ' + ($dataType) + ' == \'number\' || ' + ($dataType) + ' == \'boolean\' || ' + ($data) + ' == null) ' + ($coerced) + ' = [' + ($data) + ']; ';
            }
          }
        }
        out += ' ' + ($bracesCoercion) + ' if (' + ($coerced) + ' === undefined) {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { type: \'';
          if ($typeIsArray) {
            out += '' + ($typeSchema.join(","));
          } else {
            out += '' + ($typeSchema);
          }
          out += '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'should be ';
            if ($typeIsArray) {
              out += '' + ($typeSchema.join(","));
            } else {
              out += '' + ($typeSchema);
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        out += ' } else {  ';
        var $parentData = $dataLvl ? 'data' + (($dataLvl - 1) || '') : 'parentData',
          $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
        out += ' ' + ($data) + ' = ' + ($coerced) + '; ';
        if (!$dataLvl) {
          out += 'if (' + ($parentData) + ' !== undefined)';
        }
        out += ' ' + ($parentData) + '[' + ($parentDataProperty) + '] = ' + ($coerced) + '; } ';
      } else {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { type: \'';
          if ($typeIsArray) {
            out += '' + ($typeSchema.join(","));
          } else {
            out += '' + ($typeSchema);
          }
          out += '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'should be ';
            if ($typeIsArray) {
              out += '' + ($typeSchema.join(","));
            } else {
              out += '' + ($typeSchema);
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
      }
      out += ' } ';
    }
  }
  if (it.schema.$ref && !$refKeywords) {
    out += ' ' + (it.RULES.all.$ref.code(it, '$ref')) + ' ';
    if ($breakOnError) {
      out += ' } if (errors === ';
      if ($top) {
        out += '0';
      } else {
        out += 'errs_' + ($lvl);
      }
      out += ') { ';
      $closingBraces2 += '}';
    }
  } else {
    if (it.opts.v5 && it.schema.patternGroups) {
      it.logger.warn('keyword "patternGroups" is deprecated and disabled. Use option patternGroups: true to enable.');
    }
    var arr2 = it.RULES;
    if (arr2) {
      var $rulesGroup, i2 = -1,
        l2 = arr2.length - 1;
      while (i2 < l2) {
        $rulesGroup = arr2[i2 += 1];
        if ($shouldUseGroup($rulesGroup)) {
          if ($rulesGroup.type) {
            out += ' if (' + (it.util.checkDataType($rulesGroup.type, $data)) + ') { ';
          }
          if (it.opts.useDefaults && !it.compositeRule) {
            if ($rulesGroup.type == 'object' && it.schema.properties) {
              var $schema = it.schema.properties,
                $schemaKeys = Object.keys($schema);
              var arr3 = $schemaKeys;
              if (arr3) {
                var $propertyKey, i3 = -1,
                  l3 = arr3.length - 1;
                while (i3 < l3) {
                  $propertyKey = arr3[i3 += 1];
                  var $sch = $schema[$propertyKey];
                  if ($sch.default !== undefined) {
                    var $passData = $data + it.util.getProperty($propertyKey);
                    out += '  if (' + ($passData) + ' === undefined) ' + ($passData) + ' = ';
                    if (it.opts.useDefaults == 'shared') {
                      out += ' ' + (it.useDefault($sch.default)) + ' ';
                    } else {
                      out += ' ' + (JSON.stringify($sch.default)) + ' ';
                    }
                    out += '; ';
                  }
                }
              }
            } else if ($rulesGroup.type == 'array' && Array.isArray(it.schema.items)) {
              var arr4 = it.schema.items;
              if (arr4) {
                var $sch, $i = -1,
                  l4 = arr4.length - 1;
                while ($i < l4) {
                  $sch = arr4[$i += 1];
                  if ($sch.default !== undefined) {
                    var $passData = $data + '[' + $i + ']';
                    out += '  if (' + ($passData) + ' === undefined) ' + ($passData) + ' = ';
                    if (it.opts.useDefaults == 'shared') {
                      out += ' ' + (it.useDefault($sch.default)) + ' ';
                    } else {
                      out += ' ' + (JSON.stringify($sch.default)) + ' ';
                    }
                    out += '; ';
                  }
                }
              }
            }
          }
          var arr5 = $rulesGroup.rules;
          if (arr5) {
            var $rule, i5 = -1,
              l5 = arr5.length - 1;
            while (i5 < l5) {
              $rule = arr5[i5 += 1];
              if ($shouldUseRule($rule)) {
                var $code = $rule.code(it, $rule.keyword, $rulesGroup.type);
                if ($code) {
                  out += ' ' + ($code) + ' ';
                  if ($breakOnError) {
                    $closingBraces1 += '}';
                  }
                }
              }
            }
          }
          if ($breakOnError) {
            out += ' ' + ($closingBraces1) + ' ';
            $closingBraces1 = '';
          }
          if ($rulesGroup.type) {
            out += ' } ';
            if ($typeSchema && $typeSchema === $rulesGroup.type && !$coerceToTypes) {
              out += ' else { ';
              var $schemaPath = it.schemaPath + '.type',
                $errSchemaPath = it.errSchemaPath + '/type';
              var $$outStack = $$outStack || [];
              $$outStack.push(out);
              out = ''; /* istanbul ignore else */
              if (it.createErrors !== false) {
                out += ' { keyword: \'' + ($errorKeyword || 'type') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { type: \'';
                if ($typeIsArray) {
                  out += '' + ($typeSchema.join(","));
                } else {
                  out += '' + ($typeSchema);
                }
                out += '\' } ';
                if (it.opts.messages !== false) {
                  out += ' , message: \'should be ';
                  if ($typeIsArray) {
                    out += '' + ($typeSchema.join(","));
                  } else {
                    out += '' + ($typeSchema);
                  }
                  out += '\' ';
                }
                if (it.opts.verbose) {
                  out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
                }
                out += ' } ';
              } else {
                out += ' {} ';
              }
              var __err = out;
              out = $$outStack.pop();
              if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
                if (it.async) {
                  out += ' throw new ValidationError([' + (__err) + ']); ';
                } else {
                  out += ' validate.errors = [' + (__err) + ']; return false; ';
                }
              } else {
                out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
              }
              out += ' } ';
            }
          }
          if ($breakOnError) {
            out += ' if (errors === ';
            if ($top) {
              out += '0';
            } else {
              out += 'errs_' + ($lvl);
            }
            out += ') { ';
            $closingBraces2 += '}';
          }
        }
      }
    }
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces2) + ' ';
  }
  if ($top) {
    if ($async) {
      out += ' if (errors === 0) return data;           ';
      out += ' else throw new ValidationError(vErrors); ';
    } else {
      out += ' validate.errors = vErrors; ';
      out += ' return errors === 0;       ';
    }
    out += ' }); return validate;';
  } else {
    out += ' var ' + ($valid) + ' = errors === errs_' + ($lvl) + ';';
  }
  out = it.util.cleanUpCode(out);
  if ($top) {
    out = it.util.finalCleanUpCode(out, $async);
  }

  function $shouldUseGroup($rulesGroup) {
    var rules = $rulesGroup.rules;
    for (var i = 0; i < rules.length; i++)
      if ($shouldUseRule(rules[i])) return true;
  }

  function $shouldUseRule($rule) {
    return it.schema[$rule.keyword] !== undefined || ($rule.implements && $ruleImplementsSomeKeyword($rule));
  }

  function $ruleImplementsSomeKeyword($rule) {
    var impl = $rule.implements;
    for (var i = 0; i < impl.length; i++)
      if (it.schema[impl[i]] !== undefined) return true;
  }
  return out;
}


/***/ }),
/* 146 */
/***/ (function(module, exports) {


/**
 * slice() reference.
 */

var slice = Array.prototype.slice;

/**
 * Expose `co`.
 */

module.exports = co['default'] = co.co = co;

/**
 * Wrap the given generator `fn` into a
 * function that returns a promise.
 * This is a separate function so that
 * every `co()` call doesn't create a new,
 * unnecessary closure.
 *
 * @param {GeneratorFunction} fn
 * @return {Function}
 * @api public
 */

co.wrap = function (fn) {
  createPromise.__generatorFunction__ = fn;
  return createPromise;
  function createPromise() {
    return co.call(this, fn.apply(this, arguments));
  }
};

/**
 * Execute the generator function or a generator
 * and return a promise.
 *
 * @param {Function} fn
 * @return {Promise}
 * @api public
 */

function co(gen) {
  var ctx = this;
  var args = slice.call(arguments, 1)

  // we wrap everything in a promise to avoid promise chaining,
  // which leads to memory leak errors.
  // see https://github.com/tj/co/issues/180
  return new Promise(function(resolve, reject) {
    if (typeof gen === 'function') gen = gen.apply(ctx, args);
    if (!gen || typeof gen.next !== 'function') return resolve(gen);

    onFulfilled();

    /**
     * @param {Mixed} res
     * @return {Promise}
     * @api private
     */

    function onFulfilled(res) {
      var ret;
      try {
        ret = gen.next(res);
      } catch (e) {
        return reject(e);
      }
      next(ret);
    }

    /**
     * @param {Error} err
     * @return {Promise}
     * @api private
     */

    function onRejected(err) {
      var ret;
      try {
        ret = gen.throw(err);
      } catch (e) {
        return reject(e);
      }
      next(ret);
    }

    /**
     * Get the next value in the generator,
     * return a promise.
     *
     * @param {Object} ret
     * @return {Promise}
     * @api private
     */

    function next(ret) {
      if (ret.done) return resolve(ret.value);
      var value = toPromise.call(ctx, ret.value);
      if (value && isPromise(value)) return value.then(onFulfilled, onRejected);
      return onRejected(new TypeError('You may only yield a function, promise, generator, array, or object, '
        + 'but the following object was passed: "' + String(ret.value) + '"'));
    }
  });
}

/**
 * Convert a `yield`ed value into a promise.
 *
 * @param {Mixed} obj
 * @return {Promise}
 * @api private
 */

function toPromise(obj) {
  if (!obj) return obj;
  if (isPromise(obj)) return obj;
  if (isGeneratorFunction(obj) || isGenerator(obj)) return co.call(this, obj);
  if ('function' == typeof obj) return thunkToPromise.call(this, obj);
  if (Array.isArray(obj)) return arrayToPromise.call(this, obj);
  if (isObject(obj)) return objectToPromise.call(this, obj);
  return obj;
}

/**
 * Convert a thunk to a promise.
 *
 * @param {Function}
 * @return {Promise}
 * @api private
 */

function thunkToPromise(fn) {
  var ctx = this;
  return new Promise(function (resolve, reject) {
    fn.call(ctx, function (err, res) {
      if (err) return reject(err);
      if (arguments.length > 2) res = slice.call(arguments, 1);
      resolve(res);
    });
  });
}

/**
 * Convert an array of "yieldables" to a promise.
 * Uses `Promise.all()` internally.
 *
 * @param {Array} obj
 * @return {Promise}
 * @api private
 */

function arrayToPromise(obj) {
  return Promise.all(obj.map(toPromise, this));
}

/**
 * Convert an object of "yieldables" to a promise.
 * Uses `Promise.all()` internally.
 *
 * @param {Object} obj
 * @return {Promise}
 * @api private
 */

function objectToPromise(obj){
  var results = new obj.constructor();
  var keys = Object.keys(obj);
  var promises = [];
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var promise = toPromise.call(this, obj[key]);
    if (promise && isPromise(promise)) defer(promise, key);
    else results[key] = obj[key];
  }
  return Promise.all(promises).then(function () {
    return results;
  });

  function defer(promise, key) {
    // predefine the key in the result
    results[key] = undefined;
    promises.push(promise.then(function (res) {
      results[key] = res;
    }));
  }
}

/**
 * Check if `obj` is a promise.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isPromise(obj) {
  return 'function' == typeof obj.then;
}

/**
 * Check if `obj` is a generator.
 *
 * @param {Mixed} obj
 * @return {Boolean}
 * @api private
 */

function isGenerator(obj) {
  return 'function' == typeof obj.next && 'function' == typeof obj.throw;
}

/**
 * Check if `obj` is a generator function.
 *
 * @param {Mixed} obj
 * @return {Boolean}
 * @api private
 */
function isGeneratorFunction(obj) {
  var constructor = obj.constructor;
  if (!constructor) return false;
  if ('GeneratorFunction' === constructor.name || 'GeneratorFunction' === constructor.displayName) return true;
  return isGenerator(constructor.prototype);
}

/**
 * Check for plain object.
 *
 * @param {Mixed} val
 * @return {Boolean}
 * @api private
 */

function isObject(val) {
  return Object == val.constructor;
}


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate__limit(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $isMax = $keyword == 'maximum',
    $exclusiveKeyword = $isMax ? 'exclusiveMaximum' : 'exclusiveMinimum',
    $schemaExcl = it.schema[$exclusiveKeyword],
    $isDataExcl = it.opts.$data && $schemaExcl && $schemaExcl.$data,
    $op = $isMax ? '<' : '>',
    $notOp = $isMax ? '>' : '<',
    $errorKeyword = undefined;
  if ($isDataExcl) {
    var $schemaValueExcl = it.util.getData($schemaExcl.$data, $dataLvl, it.dataPathArr),
      $exclusive = 'exclusive' + $lvl,
      $exclType = 'exclType' + $lvl,
      $exclIsNumber = 'exclIsNumber' + $lvl,
      $opExpr = 'op' + $lvl,
      $opStr = '\' + ' + $opExpr + ' + \'';
    out += ' var schemaExcl' + ($lvl) + ' = ' + ($schemaValueExcl) + '; ';
    $schemaValueExcl = 'schemaExcl' + $lvl;
    out += ' var ' + ($exclusive) + '; var ' + ($exclType) + ' = typeof ' + ($schemaValueExcl) + '; if (' + ($exclType) + ' != \'boolean\' && ' + ($exclType) + ' != \'undefined\' && ' + ($exclType) + ' != \'number\') { ';
    var $errorKeyword = $exclusiveKeyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ($errorKeyword || '_exclusiveLimit') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'' + ($exclusiveKeyword) + ' should be boolean\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' } else if ( ';
    if ($isData) {
      out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
    }
    out += ' ' + ($exclType) + ' == \'number\' ? ( (' + ($exclusive) + ' = ' + ($schemaValue) + ' === undefined || ' + ($schemaValueExcl) + ' ' + ($op) + '= ' + ($schemaValue) + ') ? ' + ($data) + ' ' + ($notOp) + '= ' + ($schemaValueExcl) + ' : ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' ) : ( (' + ($exclusive) + ' = ' + ($schemaValueExcl) + ' === true) ? ' + ($data) + ' ' + ($notOp) + '= ' + ($schemaValue) + ' : ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' ) || ' + ($data) + ' !== ' + ($data) + ') { var op' + ($lvl) + ' = ' + ($exclusive) + ' ? \'' + ($op) + '\' : \'' + ($op) + '=\';';
  } else {
    var $exclIsNumber = typeof $schemaExcl == 'number',
      $opStr = $op;
    if ($exclIsNumber && $isData) {
      var $opExpr = '\'' + $opStr + '\'';
      out += ' if ( ';
      if ($isData) {
        out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
      }
      out += ' ( ' + ($schemaValue) + ' === undefined || ' + ($schemaExcl) + ' ' + ($op) + '= ' + ($schemaValue) + ' ? ' + ($data) + ' ' + ($notOp) + '= ' + ($schemaExcl) + ' : ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' ) || ' + ($data) + ' !== ' + ($data) + ') { ';
    } else {
      if ($exclIsNumber && $schema === undefined) {
        $exclusive = true;
        $errorKeyword = $exclusiveKeyword;
        $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
        $schemaValue = $schemaExcl;
        $notOp += '=';
      } else {
        if ($exclIsNumber) $schemaValue = Math[$isMax ? 'min' : 'max']($schemaExcl, $schema);
        if ($schemaExcl === ($exclIsNumber ? $schemaValue : true)) {
          $exclusive = true;
          $errorKeyword = $exclusiveKeyword;
          $errSchemaPath = it.errSchemaPath + '/' + $exclusiveKeyword;
          $notOp += '=';
        } else {
          $exclusive = false;
          $opStr += '=';
        }
      }
      var $opExpr = '\'' + $opStr + '\'';
      out += ' if ( ';
      if ($isData) {
        out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
      }
      out += ' ' + ($data) + ' ' + ($notOp) + ' ' + ($schemaValue) + ' || ' + ($data) + ' !== ' + ($data) + ') { ';
    }
  }
  $errorKeyword = $errorKeyword || $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limit') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { comparison: ' + ($opExpr) + ', limit: ' + ($schemaValue) + ', exclusive: ' + ($exclusive) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be ' + ($opStr) + ' ';
      if ($isData) {
        out += '\' + ' + ($schemaValue);
      } else {
        out += '' + ($schemaValue) + '\'';
      }
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' } ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate__limitItems(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $op = $keyword == 'maxItems' ? '>' : '<';
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
  }
  out += ' ' + ($data) + '.length ' + ($op) + ' ' + ($schemaValue) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limitItems') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should NOT have ';
      if ($keyword == 'maxItems') {
        out += 'more';
      } else {
        out += 'less';
      }
      out += ' than ';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + ($schema);
      }
      out += ' items\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate__limitLength(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $op = $keyword == 'maxLength' ? '>' : '<';
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
  }
  if (it.opts.unicode === false) {
    out += ' ' + ($data) + '.length ';
  } else {
    out += ' ucs2length(' + ($data) + ') ';
  }
  out += ' ' + ($op) + ' ' + ($schemaValue) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limitLength') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should NOT be ';
      if ($keyword == 'maxLength') {
        out += 'longer';
      } else {
        out += 'shorter';
      }
      out += ' than ';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + ($schema);
      }
      out += ' characters\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate__limitProperties(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $op = $keyword == 'maxProperties' ? '>' : '<';
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'number\') || ';
  }
  out += ' Object.keys(' + ($data) + ').length ' + ($op) + ' ' + ($schemaValue) + ') { ';
  var $errorKeyword = $keyword;
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ($errorKeyword || '_limitProperties') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should NOT have ';
      if ($keyword == 'maxProperties') {
        out += 'more';
      } else {
        out += 'less';
      }
      out += ' than ';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + ($schema);
      }
      out += ' properties\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(152);
module.exports = __webpack_require__(157);


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(153).enable();
  window.Promise = __webpack_require__(155);
}

// fetch() polyfill for making API calls.
__webpack_require__(156);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(59);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(86);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(86);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(379);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.5.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(59),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.async_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112;n&&Symbol.for("react.placeholder");
var z="function"===typeof Symbol&&Symbol.iterator;function A(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[d,c,e,g,h,f],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);A(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null,currentDispatcher:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];e.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:I.current}}
function M(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function V(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=M(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function W(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,aa,b);R(b)}function ba(a,b){var d=I.currentDispatcher;null===d?B("277"):void 0;return d.readContext(a,b)}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];W(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,V,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,Provider:null,Consumer:null,unstable_read:null};a.Provider={$$typeof:v,_context:a};a.Consumer=a;a.unstable_read=ba.bind(null,a);return a},forwardRef:function(a){return{$$typeof:y,render:a}},Fragment:r,StrictMode:t,unstable_AsyncMode:x,unstable_Profiler:u,createElement:L,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);
var k=void 0;a.type&&a.type.defaultProps&&(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];e.children=k}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.5.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,
assign:m}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(160);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.5.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(23),n=__webpack_require__(59),ba=__webpack_require__(161);function ca(a,b,c,d,e,f,g,k){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var h=[c,d,e,f,g,k],l=0;a=Error(b.replace(/%s/g,function(){return h[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function w(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:w("227");function da(a,b,c,d,e,f,g,k,h){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}
var ea=!1,fa=null,ha=!1,ia=null,ja={onError:function(a){ea=!0;fa=a}};function ka(a,b,c,d,e,f,g,k,h){ea=!1;fa=null;da.apply(ja,arguments)}function la(a,b,c,d,e,f,g,k,h){ka.apply(this,arguments);if(ea){if(ea){var l=fa;ea=!1;fa=null}else w("198"),l=void 0;ha||(ha=!0,ia=l)}}var ma=null,na={};
function oa(){if(ma)for(var a in na){var b=na[a],c=ma.indexOf(a);-1<c?void 0:w("96",a);if(!pa[c]){b.extractEvents?void 0:w("97",a);pa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,k=d;qa.hasOwnProperty(k)?w("99",k):void 0;qa[k]=f;var h=f.phasedRegistrationNames;if(h){for(e in h)h.hasOwnProperty(e)&&ra(h[e],g,k);e=!0}else f.registrationName?(ra(f.registrationName,g,k),e=!0):e=!1;e?void 0:w("98",d,a)}}}}
function ra(a,b,c){sa[a]?w("100",a):void 0;sa[a]=b;ta[a]=b.eventTypes[c].dependencies}var pa=[],qa={},sa={},ta={},ua=null,va=null,wa=null;function xa(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=wa(d);la(b,c,void 0,a);a.currentTarget=null}function ya(a,b){null==b?w("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function za(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Aa=null;function Ba(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)xa(a,b,c[e],d[e]);else c&&xa(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ca(a){return Ba(a,!0)}function Da(a){return Ba(a,!1)}
var Ea={injectEventPluginOrder:function(a){ma?w("101"):void 0;ma=Array.prototype.slice.call(a);oa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];na.hasOwnProperty(c)&&na[c]===d||(na[c]?w("102",c):void 0,na[c]=d,b=!0)}b&&oa()}};
function Fa(a,b){var c=a.stateNode;if(!c)return null;var d=ua(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?w("231",b,typeof c):void 0;
return c}function Ga(a,b){null!==a&&(Aa=ya(Aa,a));a=Aa;Aa=null;if(a&&(b?za(a,Ca):za(a,Da),Aa?w("95"):void 0,ha))throw b=ia,ha=!1,ia=null,b;}var Ha=Math.random().toString(36).slice(2),Ia="__reactInternalInstance$"+Ha,Ja="__reactEventHandlers$"+Ha;function Ka(a){if(a[Ia])return a[Ia];for(;!a[Ia];)if(a.parentNode)a=a.parentNode;else return null;a=a[Ia];return 7===a.tag||8===a.tag?a:null}function La(a){a=a[Ia];return!a||7!==a.tag&&8!==a.tag?null:a}
function Ma(a){if(7===a.tag||8===a.tag)return a.stateNode;w("33")}function Na(a){return a[Ja]||null}function Oa(a){do a=a.return;while(a&&7!==a.tag);return a?a:null}function Pa(a,b,c){if(b=Fa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a)}
function Qa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Oa(b);for(b=c.length;0<b--;)Pa(c[b],"captured",a);for(b=0;b<c.length;b++)Pa(c[b],"bubbled",a)}}function Ra(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Fa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a))}function Ta(a){a&&a.dispatchConfig.registrationName&&Ra(a._targetInst,null,a)}
function Ua(a){za(a,Qa)}var Va=!("undefined"===typeof window||!window.document||!window.document.createElement);function Wa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ya={animationend:Wa("Animation","AnimationEnd"),animationiteration:Wa("Animation","AnimationIteration"),animationstart:Wa("Animation","AnimationStart"),transitionend:Wa("Transition","TransitionEnd")},Za={},$a={};
Va&&($a=document.createElement("div").style,"AnimationEvent"in window||(delete Ya.animationend.animation,delete Ya.animationiteration.animation,delete Ya.animationstart.animation),"TransitionEvent"in window||delete Ya.transitionend.transition);function ab(a){if(Za[a])return Za[a];if(!Ya[a])return a;var b=Ya[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in $a)return Za[a]=b[c];return a}
var bb=ab("animationend"),cb=ab("animationiteration"),db=ab("animationstart"),eb=ab("transitionend"),fb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),gb=null,hb=null,ib=null;
function jb(){if(ib)return ib;var a,b=hb,c=b.length,d,e="value"in gb?gb.value:gb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return ib=e.slice(a,1<d?1-d:void 0)}function kb(){return!0}function lb(){return!1}
function C(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?kb:lb;this.isPropagationStopped=lb;return this}
n(C.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=kb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=kb)},persist:function(){this.isPersistent=kb},isPersistent:lb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=lb;this._dispatchInstances=this._dispatchListeners=null}});C.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
C.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;mb(c);return c};mb(C);function nb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function ob(a){a instanceof this?void 0:w("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function mb(a){a.eventPool=[];a.getPooled=nb;a.release=ob}var pb=C.extend({data:null}),qb=C.extend({data:null}),rb=[9,13,27,32],sb=Va&&"CompositionEvent"in window,tb=null;Va&&"documentMode"in document&&(tb=document.documentMode);
var ub=Va&&"TextEvent"in window&&!tb,vb=Va&&(!sb||tb&&8<tb&&11>=tb),wb=String.fromCharCode(32),xb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},yb=!1;
function zb(a,b){switch(a){case "keyup":return-1!==rb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Ab(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Bb=!1;function Cb(a,b){switch(a){case "compositionend":return Ab(b);case "keypress":if(32!==b.which)return null;yb=!0;return wb;case "textInput":return a=b.data,a===wb&&yb?null:a;default:return null}}
function Db(a,b){if(Bb)return"compositionend"===a||!sb&&zb(a,b)?(a=jb(),ib=hb=gb=null,Bb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return vb&&"ko"!==b.locale?null:b.data;default:return null}}
var Eb={eventTypes:xb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(sb)b:{switch(a){case "compositionstart":e=xb.compositionStart;break b;case "compositionend":e=xb.compositionEnd;break b;case "compositionupdate":e=xb.compositionUpdate;break b}e=void 0}else Bb?zb(a,c)&&(e=xb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=xb.compositionStart);e?(vb&&"ko"!==c.locale&&(Bb||e!==xb.compositionStart?e===xb.compositionEnd&&Bb&&(f=jb()):(gb=d,hb="value"in gb?gb.value:gb.textContent,Bb=
!0)),e=pb.getPooled(e,b,c,d),f?e.data=f:(f=Ab(c),null!==f&&(e.data=f)),Ua(e),f=e):f=null;(a=ub?Cb(a,c):Db(a,c))?(b=qb.getPooled(xb.beforeInput,b,c,d),b.data=a,Ua(b)):b=null;return null===f?b:null===b?f:[f,b]}},Fb=null,Gb=null,Hb=null;function Ib(a){if(a=va(a)){"function"!==typeof Fb?w("280"):void 0;var b=ua(a.stateNode);Fb(a.stateNode,a.type,b)}}function Jb(a){Gb?Hb?Hb.push(a):Hb=[a]:Gb=a}function Kb(){if(Gb){var a=Gb,b=Hb;Hb=Gb=null;Ib(a);if(b)for(a=0;a<b.length;a++)Ib(b[a])}}
function Lb(a,b){return a(b)}function Mb(a,b,c){return a(b,c)}function Nb(){}var Ob=!1;function Pb(a,b){if(Ob)return a(b);Ob=!0;try{return Lb(a,b)}finally{if(Ob=!1,null!==Gb||null!==Hb)Nb(),Kb()}}var Qb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Rb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Qb[a.type]:"textarea"===b?!0:!1}
function Sb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Tb(a){if(!Va)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Ub(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Vb(a){var b=Ub(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Wb(a){a._valueTracker||(a._valueTracker=Vb(a))}function Xb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ub(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var Yb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Zb=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,$b=E?Symbol.for("react.element"):60103,ac=E?Symbol.for("react.portal"):60106,bc=E?Symbol.for("react.fragment"):60107,cc=E?Symbol.for("react.strict_mode"):60108,dc=E?Symbol.for("react.profiler"):60114,ec=E?Symbol.for("react.provider"):60109,fc=E?Symbol.for("react.context"):60110,gc=E?Symbol.for("react.async_mode"):60111,hc=E?Symbol.for("react.forward_ref"):60112,ic=E?Symbol.for("react.placeholder"):
60113,jc="function"===typeof Symbol&&Symbol.iterator;function kc(a){if(null===a||"object"!==typeof a)return null;a=jc&&a[jc]||a["@@iterator"];return"function"===typeof a?a:null}
function lc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case gc:return"AsyncMode";case bc:return"Fragment";case ac:return"Portal";case dc:return"Profiler";case cc:return"StrictMode";case ic:return"Placeholder"}if("object"===typeof a){switch(a.$$typeof){case fc:return"Context.Consumer";case ec:return"Context.Provider";case hc:return a=a.render,a=a.displayName||a.name||"",""!==a?"ForwardRef("+a+")":"ForwardRef"}if("function"===
typeof a.then&&(a=1===a._reactStatus?a._reactResult:null))return lc(a)}return null}function mc(a){var b="";do{a:switch(a.tag){case 4:case 0:case 1:case 2:case 3:case 7:case 10:var c=a._debugOwner,d=a._debugSource,e=lc(a.type);var f=null;c&&(f=lc(c.type));c=e;e="";d?e=" (at "+d.fileName.replace(Zb,"")+":"+d.lineNumber+")":f&&(e=" (created by "+f+")");f="\n    in "+(c||"Unknown")+e;break a;default:f=""}b+=f;a=a.return}while(a);return b}
var nc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc=Object.prototype.hasOwnProperty,qc={},rc={};
function sc(a){if(pc.call(rc,a))return!0;if(pc.call(qc,a))return!1;if(nc.test(a))return rc[a]=!0;qc[a]=!0;return!1}function tc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function uc(a,b,c,d){if(null===b||"undefined"===typeof b||tc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function F(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var G={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){G[a]=new F(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];G[b]=new F(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){G[a]=new F(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){G[a]=new F(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){G[a]=new F(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){G[a]=new F(a,3,!0,a,null)});
["capture","download"].forEach(function(a){G[a]=new F(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){G[a]=new F(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){G[a]=new F(a,5,!1,a.toLowerCase(),null)});var vc=/[\-:]([a-z])/g;function wc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(vc,
wc);G[b]=new F(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(vc,wc);G[b]=new F(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(vc,wc);G[b]=new F(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});G.tabIndex=new F("tabIndex",1,!1,"tabindex",null);
function xc(a,b,c,d){var e=G.hasOwnProperty(b)?G[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(uc(b,c,e,d)&&(c=null),d||null===e?sc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function yc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function zc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=yc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cc(a,b){b=b.checked;null!=b&&xc(a,"checked",b,!1)}
function Dc(a,b){Cc(a,b);var c=yc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Ec(a,b.type,c):b.hasOwnProperty("defaultValue")&&Ec(a,b.type,yc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Fc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Ec(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Gc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Hc(a,b,c){a=C.getPooled(Gc.change,a,b,c);a.type="change";Jb(c);Ua(a);return a}var Ic=null,Jc=null;function Kc(a){Ga(a,!1)}
function Lc(a){var b=Ma(a);if(Xb(b))return a}function Mc(a,b){if("change"===a)return b}var Nc=!1;Va&&(Nc=Tb("input")&&(!document.documentMode||9<document.documentMode));function Oc(){Ic&&(Ic.detachEvent("onpropertychange",Pc),Jc=Ic=null)}function Pc(a){"value"===a.propertyName&&Lc(Jc)&&(a=Hc(Jc,a,Sb(a)),Pb(Kc,a))}function Qc(a,b,c){"focus"===a?(Oc(),Ic=b,Jc=c,Ic.attachEvent("onpropertychange",Pc)):"blur"===a&&Oc()}function Rc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Lc(Jc)}
function Sc(a,b){if("click"===a)return Lc(b)}function Tc(a,b){if("input"===a||"change"===a)return Lc(b)}
var Uc={eventTypes:Gc,_isInputEventSupported:Nc,extractEvents:function(a,b,c,d){var e=b?Ma(b):window,f=void 0,g=void 0,k=e.nodeName&&e.nodeName.toLowerCase();"select"===k||"input"===k&&"file"===e.type?f=Mc:Rb(e)?Nc?f=Tc:(f=Rc,g=Qc):(k=e.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Sc);if(f&&(f=f(a,b)))return Hc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Ec(e,"number",e.value)}},Vc=C.extend({view:null,detail:null}),Wc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Xc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Wc[a])?!!b[a]:!1}function Yc(){return Xc}
var Zc=0,$c=0,ad=!1,bd=!1,cd=Vc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Yc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Zc;Zc=a.screenX;return ad?"mousemove"===a.type?a.screenX-b:0:(ad=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=$c;$c=a.screenY;return bd?"mousemove"===a.type?a.screenY-b:0:(bd=!0,0)}}),dd=cd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),ed={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},fd={eventTypes:ed,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ka(b):null):f=null;if(f===b)return null;var g=void 0,k=void 0,h=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)g=cd,k=ed.mouseLeave,h=ed.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)g=dd,k=ed.pointerLeave,h=ed.pointerEnter,l="pointer";var m=null==f?e:Ma(f);e=null==b?e:Ma(b);a=g.getPooled(k,f,c,d);a.type=l+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(h,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;l=0;for(g=b;g;g=Oa(g))l++;g=0;for(h=e;h;h=Oa(h))g++;for(;0<l-g;)b=Oa(b),l--;for(;0<g-l;)e=Oa(e),g--;for(;l--;){if(b===e||b===e.alternate)break a;b=Oa(b);e=Oa(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=Oa(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=Oa(d)}for(d=0;d<b.length;d++)Ra(b[d],"bubbled",a);for(d=f.length;0<d--;)Ra(f[d],"captured",c);return[a,c]}},gd=Object.prototype.hasOwnProperty;function hd(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
function id(a,b){if(hd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!gd.call(b,c[d])||!hd(a[c[d]],b[c[d]]))return!1;return!0}function jd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 5===b.tag?2:3}function kd(a){2!==jd(a)?w("188"):void 0}
function ld(a){var b=a.alternate;if(!b)return b=jd(a),3===b?w("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return kd(e),a;if(g===d)return kd(e),b;g=g.sibling}w("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var k=e.child;k;){if(k===c){g=!0;c=e;d=f;break}if(k===d){g=!0;d=e;c=f;break}k=k.sibling}if(!g){for(k=f.child;k;){if(k===c){g=!0;c=f;d=e;break}if(k===d){g=!0;d=f;c=e;break}k=k.sibling}g?
void 0:w("189")}}c.alternate!==d?w("190"):void 0}5!==c.tag?w("188"):void 0;return c.stateNode.current===c?a:b}function md(a){a=ld(a);if(!a)return null;for(var b=a;;){if(7===b.tag||8===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var nd=C.extend({animationName:null,elapsedTime:null,pseudoElement:null}),od=C.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),pd=Vc.extend({relatedTarget:null});function qd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var rd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},sd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},td=Vc.extend({key:function(a){if(a.key){var b=rd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=qd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?sd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Yc,charCode:function(a){return"keypress"===
a.type?qd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?qd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),ud=cd.extend({dataTransfer:null}),vd=Vc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Yc}),wd=C.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),xd=cd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),yd=[["abort","abort"],[bb,"animationEnd"],[cb,"animationIteration"],[db,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[eb,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],zd={},Ad={};function Bd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};zd[a]=b;Ad[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Bd(a,!0)});yd.forEach(function(a){Bd(a,!1)});
var Cd={eventTypes:zd,isInteractiveTopLevelEventType:function(a){a=Ad[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Ad[a];if(!e)return null;switch(a){case "keypress":if(0===qd(c))return null;case "keydown":case "keyup":a=td;break;case "blur":case "focus":a=pd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=cd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
ud;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=vd;break;case bb:case cb:case db:a=nd;break;case eb:a=wd;break;case "scroll":a=Vc;break;case "wheel":a=xd;break;case "copy":case "cut":case "paste":a=od;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=dd;break;default:a=C}b=a.getPooled(e,b,c,d);Ua(b);return b}},Dd=Cd.isInteractiveTopLevelEventType,
Ed=[];function Fd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=5!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ka(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Sb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,k=0;k<pa.length;k++){var h=pa[k];h&&(h=h.extractEvents(d,b,f,e))&&(g=ya(g,h))}Ga(g,!1)}}var Gd=!0;
function H(a,b){if(!b)return null;var c=(Dd(a)?Hd:Id).bind(null,a);b.addEventListener(a,c,!1)}function Jd(a,b){if(!b)return null;var c=(Dd(a)?Hd:Id).bind(null,a);b.addEventListener(a,c,!0)}function Hd(a,b){Mb(Id,a,b)}
function Id(a,b){if(Gd){var c=Sb(b);c=Ka(c);null===c||"number"!==typeof c.tag||2===jd(c)||(c=null);if(Ed.length){var d=Ed.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Pb(Fd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Ed.length&&Ed.push(a)}}}var Kd={},Ld=0,Md="_reactListenersID"+(""+Math.random()).slice(2);
function Nd(a){Object.prototype.hasOwnProperty.call(a,Md)||(a[Md]=Ld++,Kd[a[Md]]={});return Kd[a[Md]]}function Pd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Qd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Rd(a,b){var c=Qd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Qd(c)}}function Sd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Sd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Td(){for(var a=window,b=Pd();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Pd(a.document)}return b}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=Va&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if($d||null==Xd||Xd!==Pd(c))return null;c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Zd&&id(Zd,c)?null:(Zd=c,a=C.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ua(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Nd(e);f=ta.onSelect;for(var g=0;g<f.length;g++){var k=f[g];if(!e.hasOwnProperty(k)||!e[k]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ma(b):window;switch(a){case "focus":if(Rb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":case "dragend":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ea.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua=Na;va=La;wa=Ma;Ea.injectEventPluginsByName({SimpleEventPlugin:Cd,EnterLeaveEventPlugin:fd,ChangeEventPlugin:Uc,SelectEventPlugin:be,BeforeInputEventPlugin:Eb});function ce(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function de(a,b){a=n({children:void 0},b);if(b=ce(b.children))a.children=b;return a}function ee(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+yc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function fe(a,b){null!=b.dangerouslySetInnerHTML?w("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ge(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?w("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:w("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:yc(c)}}
function he(a,b){var c=yc(b.value);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=""+yc(b.defaultValue))}function ie(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var je={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function ke(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function le(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ke(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var me=void 0,ne=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==je.svg||"innerHTML"in a)a.innerHTML=b;else{me=me||document.createElement("div");me.innerHTML="<svg>"+b+"</svg>";for(b=me.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function oe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var pe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},qe=["Webkit","ms","Moz","O"];Object.keys(pe).forEach(function(a){qe.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);pe[b]=pe[a]})});
function re(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||pe.hasOwnProperty(e)&&pe[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var se=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function te(a,b){b&&(se[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?w("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?w("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:w("61")),null!=b.style&&"object"!==typeof b.style?w("62",""):void 0)}
function ue(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function ve(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Nd(a);b=ta[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Jd("scroll",a);break;case "focus":case "blur":Jd("focus",a);Jd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Tb(e)&&Jd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===fb.indexOf(e)&&H(e,a)}c[e]=!0}}}function we(){}var xe=null,ye=null;
function ze(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ae(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}function Be(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}
function Ce(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var De=[],Ee=-1;function I(a){0>Ee||(a.current=De[Ee],De[Ee]=null,Ee--)}function J(a,b){Ee++;De[Ee]=a.current;a.current=b}var Fe={},K={current:Fe},L={current:!1},Ge=Fe;
function He(a,b){var c=a.type.contextTypes;if(!c)return Fe;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function M(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ie(a){I(L,a);I(K,a)}function Je(a){I(L,a);I(K,a)}
function Ke(a,b,c){K.current!==Fe?w("168"):void 0;J(K,b,a);J(L,c,a)}function Le(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:w("108",lc(b)||"Unknown",e);return n({},c,d)}function Me(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Fe;Ge=K.current;J(K,b,a);J(L,L.current,a);return!0}
function Ne(a,b,c){var d=a.stateNode;d?void 0:w("169");c?(b=Le(a,b,Ge),d.__reactInternalMemoizedMergedChildContext=b,I(L,a),I(K,a),J(K,b,a)):I(L,a);J(L,c,a)}var Oe=null,Pe=null;function Qe(a){return function(b){try{return a(b)}catch(c){}}}
function Re(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Oe=Qe(function(a){return b.onCommitFiberRoot(c,a)});Pe=Qe(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Se(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}
function Te(a){a=a.prototype;return"object"===typeof a&&null!==a&&"object"===typeof a.isReactComponent&&null!==a.isReactComponent}
function Ue(a,b,c){var d=a.alternate;null===d?(d=new Se(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.childExpirationTime=a.childExpirationTime;d.expirationTime=b!==a.pendingProps?c:a.expirationTime;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.firstContextDependency=a.firstContextDependency;d.sibling=a.sibling;
d.index=a.index;d.ref=a.ref;return d}
function Ve(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=Te(d)?2:4;else if("string"===typeof d)f=7;else a:switch(d){case bc:return We(a.children,b,c,e);case gc:f=10;b|=3;break;case cc:f=10;b|=2;break;case dc:return d=new Se(15,a,e,b|4),d.type=dc,d.expirationTime=c,d;case ic:f=16;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case ec:f=12;break a;case fc:f=11;break a;case hc:f=13;break a;default:if("function"===typeof d.then){f=4;break a}}w("130",
null==d?d:typeof d,"")}b=new Se(f,a,e,b);b.type=d;b.expirationTime=c;return b}function We(a,b,c,d){a=new Se(9,a,d,b);a.expirationTime=c;return a}function Xe(a,b,c){a=new Se(8,a,null,b);a.expirationTime=c;return a}function Ye(a,b,c){b=new Se(6,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ze(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c>b?a.earliestPendingTime=b:a.latestPendingTime<b&&(a.latestPendingTime=b);$e(b,a)}function $e(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d>a)&&(e=d);a=e;0!==a&&0!==c&&c<a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var af=!1;
function bf(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function cf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function df(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function ef(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function ff(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bf(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bf(a.memoizedState),e=c.updateQueue=bf(c.memoizedState)):d=a.updateQueue=cf(e):null===e&&(e=c.updateQueue=cf(d));null===e||d===e?ef(d,b):null===d.lastUpdate||null===e.lastUpdate?(ef(d,b),ef(e,b)):(ef(d,b),e.lastUpdate=b)}
function gf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bf(a.memoizedState):hf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function hf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=cf(b));return b}
function jf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:af=!0}return d}
function kf(a,b,c,d,e){af=!1;b=hf(a,b);for(var f=b.baseState,g=null,k=0,h=b.firstUpdate,l=f;null!==h;){var m=h.expirationTime;if(m>e){if(null===g&&(g=h,f=l),0===k||k>m)k=m}else l=jf(a,b,h,l,c,d),null!==h.callback&&(a.effectTag|=32,h.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=h:(b.lastEffect.nextEffect=h,b.lastEffect=h));h=h.next}m=null;for(h=b.firstCapturedUpdate;null!==h;){var t=h.expirationTime;if(t>e){if(null===m&&(m=h,null===g&&(f=l)),0===k||k>t)k=t}else l=jf(a,b,h,l,c,d),
null!==h.callback&&(a.effectTag|=32,h.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=h:(b.lastCapturedEffect.nextEffect=h,b.lastCapturedEffect=h));h=h.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=k;a.memoizedState=l}
function lf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);mf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;mf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function mf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?w("191",c):void 0;c.call(d)}a=a.nextEffect}}
function nf(a,b){return{value:a,source:b,stack:mc(b)}}var of={current:null},pf=null,qf=null,rf=null;function sf(a,b){var c=a.type._context;J(of,c._currentValue,a);c._currentValue=b}function tf(a){var b=of.current;I(of,a);a.type._context._currentValue=b}function uf(a){pf=a;rf=qf=null;a.firstContextDependency=null}
function vf(a,b){if(rf!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)rf=a,b=1073741823;b={context:a,observedBits:b,next:null};null===qf?(null===pf?w("277"):void 0,pf.firstContextDependency=qf=b):qf=qf.next=b}return a._currentValue}var wf={},N={current:wf},xf={current:wf},yf={current:wf};function zf(a){a===wf?w("174"):void 0;return a}
function Af(a,b){J(yf,b,a);J(xf,a,a);J(N,wf,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:le(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=le(b,c)}I(N,a);J(N,b,a)}function Bf(a){I(N,a);I(xf,a);I(yf,a)}function Cf(a){zf(yf.current);var b=zf(N.current);var c=le(b,a.type);b!==c&&(J(xf,a,a),J(N,c,a))}function Df(a){xf.current===a&&(I(N,a),I(xf,a))}var Ef=(new aa.Component).refs;
function Ff(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Jf={isMounted:function(a){return(a=a._reactInternalFiber)?2===jd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gf();d=Hf(d,a);var e=df(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);ff(a,e);If(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gf();d=Hf(d,a);var e=df(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);ff(a,e);If(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gf();c=Hf(c,a);var d=df(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);ff(a,d);If(a,c)}};function Kf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!id(c,d)||!id(e,f):!0}function Lf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jf.enqueueReplaceState(b,b.state,null)}
function Mf(a,b,c,d){var e=a.stateNode,f=M(b)?Ge:K.current;e.props=c;e.state=a.memoizedState;e.refs=Ef;e.context=He(a,f);f=a.updateQueue;null!==f&&(kf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Ff(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&
e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(kf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Nf=Array.isArray;
function Of(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag&&3!==c.tag?w("110"):void 0,d=c.stateNode);d?void 0:w("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ef&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?w("284"):void 0;c._owner?void 0:w("254",a)}return a}
function Pf(a,b){"textarea"!==a.type&&w("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Qf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Ue(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function k(a,b,c,d){if(null===b||8!==b.tag)return b=Xe(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function h(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Of(a,b,c),d.return=a,d;d=Ve(c,a.mode,d);d.ref=Of(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||6!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Ye(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||9!==b.tag)return b=We(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function t(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Xe(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case $b:return c=Ve(b,a.mode,c),c.ref=Of(a,null,b),c.return=a,c;case ac:return b=Ye(b,a.mode,c),b.return=a,b}if(Nf(b)||kc(b))return b=We(b,a.mode,c,null),b.return=
a,b;Pf(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:k(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case $b:return c.key===e?c.type===bc?m(a,b,c.props.children,d,e):h(a,b,c,d):null;case ac:return c.key===e?l(a,b,c,d):null}if(Nf(c)||kc(c))return null!==e?null:m(a,b,c,d,null);Pf(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,k(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case $b:return a=a.get(null===d.key?c:d.key)||null,d.type===bc?m(b,a,d.props.children,e,d.key):h(b,a,d,e);case ac:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Nf(d)||kc(d))return a=a.get(c)||null,m(b,a,d,e,null);Pf(b,d)}return null}function y(e,g,h,k){for(var l=null,r=null,p=g,m=g=0,q=null;null!==p&&m<h.length;m++){p.index>m?(q=p,p=null):q=p.sibling;var v=x(e,p,h[m],k);if(null===v){null===p&&(p=q);break}a&&p&&null===v.alternate&&b(e,
p);g=f(v,g,m);null===r?l=v:r.sibling=v;r=v;p=q}if(m===h.length)return c(e,p),l;if(null===p){for(;m<h.length;m++)if(p=t(e,h[m],k))g=f(p,g,m),null===r?l=p:r.sibling=p,r=p;return l}for(p=d(e,p);m<h.length;m++)if(q=z(p,e,m,h[m],k))a&&null!==q.alternate&&p.delete(null===q.key?m:q.key),g=f(q,g,m),null===r?l=q:r.sibling=q,r=q;a&&p.forEach(function(a){return b(e,a)});return l}function u(e,g,h,k){var l=kc(h);"function"!==typeof l?w("150"):void 0;h=l.call(h);null==h?w("151"):void 0;for(var m=l=null,p=g,r=g=
0,q=null,v=h.next();null!==p&&!v.done;r++,v=h.next()){p.index>r?(q=p,p=null):q=p.sibling;var u=x(e,p,v.value,k);if(null===u){p||(p=q);break}a&&p&&null===u.alternate&&b(e,p);g=f(u,g,r);null===m?l=u:m.sibling=u;m=u;p=q}if(v.done)return c(e,p),l;if(null===p){for(;!v.done;r++,v=h.next())v=t(e,v.value,k),null!==v&&(g=f(v,g,r),null===m?l=v:m.sibling=v,m=v);return l}for(p=d(e,p);!v.done;r++,v=h.next())v=z(p,e,r,v.value,k),null!==v&&(a&&null!==v.alternate&&p.delete(null===v.key?r:v.key),g=f(v,g,r),null===
m?l=v:m.sibling=v,m=v);a&&p.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===bc&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case $b:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(9===k.tag?f.type===bc:k.type===f.type){c(a,k.sibling);d=e(k,f.type===bc?f.props.children:f.props,h);d.ref=Of(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===bc?(d=We(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Ve(f,a.mode,h),h.ref=Of(a,d,f),h.return=a,a=h)}return g(a);case ac:a:{for(k=f.key;null!==d;){if(d.key===k)if(6===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ye(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&8===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Xe(f,a.mode,h),d.return=a,a=d),g(a);if(Nf(f))return y(a,d,f,h);if(kc(f))return u(a,d,f,h);l&&Pf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 3:case 0:h=a.type,w("152",h.displayName||h.name||"Component")}return c(a,d)}}var Rf=Qf(!0),Sf=Qf(!1),Tf=null,Uf=null,Vf=!1;function Wf(a,b){var c=new Se(7,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Xf(a,b){switch(a.tag){case 7:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 8:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Yf(a){if(Vf){var b=Uf;if(b){var c=b;if(!Xf(a,b)){b=Be(c);if(!b||!Xf(a,b)){a.effectTag|=2;Vf=!1;Tf=a;return}Wf(Tf,c)}Tf=a;Uf=Ce(b)}else a.effectTag|=2,Vf=!1,Tf=a}}
function Zf(a){for(a=a.return;null!==a&&7!==a.tag&&5!==a.tag;)a=a.return;Tf=a}function $f(a){if(a!==Tf)return!1;if(!Vf)return Zf(a),Vf=!0,!1;var b=a.type;if(7!==a.tag||"head"!==b&&"body"!==b&&!Ae(b,a.memoizedProps))for(b=Uf;b;)Wf(a,b),b=Be(b);Zf(a);Uf=Tf?Be(a.stateNode):null;return!0}function ag(){Uf=Tf=null;Vf=!1}
function bg(a){switch(a._reactStatus){case 1:return a._reactResult;case 2:throw a._reactResult;case 0:throw a;default:throw a._reactStatus=0,a.then(function(b){if(0===a._reactStatus){a._reactStatus=1;if("object"===typeof b&&null!==b){var c=b.default;b=void 0!==c&&null!==c?c:b}a._reactResult=b}},function(b){0===a._reactStatus&&(a._reactStatus=2,a._reactResult=b)}),a;}}var cg=Yb.ReactCurrentOwner;function O(a,b,c,d){b.child=null===a?Sf(b,null,c,d):Rf(b,a.child,c,d)}
function dg(a,b,c,d,e){c=c.render;var f=b.ref;if(!L.current&&b.memoizedProps===d&&f===(null!==a?a.ref:null))return eg(a,b,e);c=c(d,f);O(a,b,c,e);b.memoizedProps=d;return b.child}function fg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function gg(a,b,c,d,e){var f=M(c)?Ge:K.current;f=He(b,f);uf(b,e);c=c(d,f);b.effectTag|=1;O(a,b,c,e);b.memoizedProps=d;return b.child}
function hg(a,b,c,d,e){if(M(c)){var f=!0;Me(b)}else f=!1;uf(b,e);if(null===a)if(null===b.stateNode){var g=M(c)?Ge:K.current,k=c.contextTypes,h=null!==k&&void 0!==k;k=h?He(b,g):Fe;var l=new c(d,k);b.memoizedState=null!==l.state&&void 0!==l.state?l.state:null;l.updater=Jf;b.stateNode=l;l._reactInternalFiber=b;h&&(h=b.stateNode,h.__reactInternalMemoizedUnmaskedChildContext=g,h.__reactInternalMemoizedMaskedChildContext=k);Mf(b,c,d,e);d=!0}else{g=b.stateNode;k=b.memoizedProps;g.props=k;var m=g.context;
h=M(c)?Ge:K.current;h=He(b,h);var t=c.getDerivedStateFromProps;(l="function"===typeof t||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(k!==d||m!==h)&&Lf(b,g,d,h);af=!1;var x=b.memoizedState;m=g.state=x;var z=b.updateQueue;null!==z&&(kf(b,z,d,g,e),m=b.memoizedState);k!==d||x!==m||L.current||af?("function"===typeof t&&(Ff(b,c,t,d),m=b.memoizedState),(k=af||Kf(b,c,k,d,x,m,h))?(l||"function"!==
typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=m),g.props=d,g.state=m,g.context=h,d=k):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,k=
b.memoizedProps,g.props=k,m=g.context,h=M(c)?Ge:K.current,h=He(b,h),t=c.getDerivedStateFromProps,(l="function"===typeof t||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(k!==d||m!==h)&&Lf(b,g,d,h),af=!1,m=b.memoizedState,x=g.state=m,z=b.updateQueue,null!==z&&(kf(b,z,d,g,e),x=b.memoizedState),k!==d||m!==x||L.current||af?("function"===typeof t&&(Ff(b,c,t,d),x=b.memoizedState),(t=af||Kf(b,c,k,d,
m,x,h))?(l||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,x,h),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,h)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||k===a.memoizedProps&&m===a.memoizedState||(b.effectTag|=4),"function"!==
typeof g.getSnapshotBeforeUpdate||k===a.memoizedProps&&m===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=h,d=t):("function"!==typeof g.componentDidUpdate||k===a.memoizedProps&&m===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||k===a.memoizedProps&&m===a.memoizedState||(b.effectTag|=256),d=!1);return ig(a,b,c,d,f,e)}
function ig(a,b,c,d,e,f){fg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Ne(b,c,!1),eg(a,b,f);d=b.stateNode;cg.current=b;var k=g?null:d.render();b.effectTag|=1;null!==a&&g&&(O(a,b,null,f),b.child=null);O(a,b,k,f);b.memoizedState=d.state;b.memoizedProps=d.props;e&&Ne(b,c,!0);return b.child}function jg(a){var b=a.stateNode;b.pendingContext?Ke(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ke(a,b.context,!1);Af(a,b.containerInfo)}
function ng(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function og(a,b,c,d){null!==a?w("155"):void 0;var e=b.pendingProps;if("object"===typeof c&&null!==c&&"function"===typeof c.then){c=bg(c);var f=c;f="function"===typeof f?Te(f)?3:1:void 0!==f&&null!==f&&f.$$typeof?14:4;f=b.tag=f;var g=ng(c,e);switch(f){case 1:return gg(a,b,c,g,d);case 3:return hg(a,b,c,g,d);case 14:return dg(a,b,c,g,d);default:w("283",c)}}f=He(b,K.current);uf(b,d);f=c(e,f);b.effectTag|=1;if("object"===typeof f&&null!==f&&"function"===typeof f.render&&void 0===f.$$typeof){b.tag=2;M(c)?
(g=!0,Me(b)):g=!1;b.memoizedState=null!==f.state&&void 0!==f.state?f.state:null;var k=c.getDerivedStateFromProps;"function"===typeof k&&Ff(b,c,k,e);f.updater=Jf;b.stateNode=f;f._reactInternalFiber=b;Mf(b,c,e,d);return ig(a,b,c,!0,g,d)}b.tag=0;O(a,b,f,d);b.memoizedProps=e;return b.child}
function eg(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);var d=b.childExpirationTime;if(0===d||d>c)return null;null!==a&&b.child!==a.child?w("153"):void 0;if(null!==b.child){a=b.child;c=Ue(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Ue(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function pg(a,b,c){var d=b.expirationTime;if(!L.current&&(0===d||d>c)){switch(b.tag){case 5:jg(b);ag();break;case 7:Cf(b);break;case 2:M(b.type)&&Me(b);break;case 3:M(b.type._reactResult)&&Me(b);break;case 6:Af(b,b.stateNode.containerInfo);break;case 12:sf(b,b.memoizedProps.value)}return eg(a,b,c)}b.expirationTime=0;switch(b.tag){case 4:return og(a,b,b.type,c);case 0:return gg(a,b,b.type,b.pendingProps,c);case 1:var e=b.type._reactResult;d=b.pendingProps;a=gg(a,b,e,ng(e,d),c);b.memoizedProps=d;return a;
case 2:return hg(a,b,b.type,b.pendingProps,c);case 3:return e=b.type._reactResult,d=b.pendingProps,a=hg(a,b,e,ng(e,d),c),b.memoizedProps=d,a;case 5:jg(b);d=b.updateQueue;null===d?w("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;kf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)ag(),b=eg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)Uf=Ce(b.stateNode.containerInfo),Tf=b,e=Vf=!0;e?(b.effectTag|=2,b.child=Sf(b,null,d,c)):(O(a,b,d,c),ag());b=b.child}return b;
case 7:Cf(b);null===a&&Yf(b);d=b.type;e=b.pendingProps;var f=null!==a?a.memoizedProps:null,g=e.children;Ae(d,e)?g=null:null!==f&&Ae(d,f)&&(b.effectTag|=16);fg(a,b);1073741823!==c&&b.mode&1&&e.hidden?(b.expirationTime=1073741823,b.memoizedProps=e,b=null):(O(a,b,g,c),b.memoizedProps=e,b=b.child);return b;case 8:return null===a&&Yf(b),b.memoizedProps=b.pendingProps,null;case 16:return null;case 6:return Af(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Rf(b,null,d,c):O(a,b,d,c),b.memoizedProps=
d,b.child;case 13:return dg(a,b,b.type,b.pendingProps,c);case 14:return e=b.type._reactResult,d=b.pendingProps,a=dg(a,b,e,ng(e,d),c),b.memoizedProps=d,a;case 9:return d=b.pendingProps,O(a,b,d,c),b.memoizedProps=d,b.child;case 10:return d=b.pendingProps.children,O(a,b,d,c),b.memoizedProps=d,b.child;case 15:return d=b.pendingProps,O(a,b,d.children,c),b.memoizedProps=d,b.child;case 12:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;b.memoizedProps=e;sf(b,f);if(null!==g){var k=g.value;
f=k===f&&(0!==k||1/k===1/f)||k!==k&&f!==f?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,f):1073741823)|0;if(0===f){if(g.children===e.children&&!L.current){b=eg(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){k=g.firstContextDependency;if(null!==k){do{if(k.context===d&&0!==(k.observedBits&f)){if(2===g.tag||3===g.tag){var h=df(c);h.tag=2;ff(g,h)}if(0===g.expirationTime||g.expirationTime>c)g.expirationTime=c;h=g.alternate;null!==h&&(0===h.expirationTime||
h.expirationTime>c)&&(h.expirationTime=c);for(var l=g.return;null!==l;){h=l.alternate;if(0===l.childExpirationTime||l.childExpirationTime>c)l.childExpirationTime=c,null!==h&&(0===h.childExpirationTime||h.childExpirationTime>c)&&(h.childExpirationTime=c);else if(null!==h&&(0===h.childExpirationTime||h.childExpirationTime>c))h.childExpirationTime=c;else break;l=l.return}}h=g.child;k=k.next}while(null!==k)}else h=12===g.tag?g.type===b.type?null:g.child:g.child;if(null!==h)h.return=g;else for(h=g;null!==
h;){if(h===b){h=null;break}g=h.sibling;if(null!==g){g.return=h.return;h=g;break}h=h.return}g=h}}O(a,b,e.children,c);b=b.child}return b;case 11:return f=b.type,d=b.pendingProps,e=d.children,uf(b,c),f=vf(f,d.unstable_observedBits),e=e(f),b.effectTag|=1,O(a,b,e,c),b.memoizedProps=d,b.child;default:w("156")}}function qg(a){a.effectTag|=4}var rg=void 0,sg=void 0,tg=void 0;rg=function(){};sg=function(a,b,c){(b.updateQueue=c)&&qg(b)};tg=function(a,b,c,d){c!==d&&qg(b)};
function ug(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=mc(c));null!==c&&lc(c.type);b=b.value;null!==a&&2===a.tag&&lc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function vg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){wg(a,c)}else b.current=null}
function xg(a){"function"===typeof Pe&&Pe(a);switch(a.tag){case 2:case 3:vg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){wg(a,c)}break;case 7:vg(a);break;case 6:yg(a)}}function zg(a){return 7===a.tag||5===a.tag||6===a.tag}
function Ag(a){a:{for(var b=a.return;null!==b;){if(zg(b)){var c=b;break a}b=b.return}w("160");c=void 0}var d=b=void 0;switch(c.tag){case 7:b=c.stateNode;d=!1;break;case 5:b=c.stateNode.containerInfo;d=!0;break;case 6:b=c.stateNode.containerInfo;d=!0;break;default:w("161")}c.effectTag&16&&(oe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||zg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;7!==c.tag&&8!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||6===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(7===e.tag||8===e.tag)if(c)if(d){var f=b,g=e.stateNode,k=c;8===f.nodeType?f.parentNode.insertBefore(g,k):f.insertBefore(g,k)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?(k=f.parentNode,k.insertBefore(g,f)):(k=f,k.appendChild(g)),null===k.onclick&&(k.onclick=we)):b.appendChild(e.stateNode);else if(6!==e.tag&&null!==e.child){e.child.return=
e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function yg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?w("160"):void 0;switch(c.tag){case 7:d=c.stateNode;e=!1;break a;case 5:d=c.stateNode.containerInfo;e=!0;break a;case 6:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(7===b.tag||8===b.tag){a:for(var f=b,g=f;;)if(xg(g),null!==g.child&&6!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(6===b.tag?(d=b.stateNode.containerInfo,e=!0):xg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;6===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Bg(a,b){switch(b.tag){case 2:case 3:break;case 7:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ja]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cc(c,d);ue(a,e);b=ue(a,d);for(e=0;e<f.length;e+=2){var g=f[e],k=f[e+1];"style"===g?re(c,k):"dangerouslySetInnerHTML"===g?ne(c,k):"children"===g?oe(c,k):xc(c,g,k,b)}switch(a){case "input":Dc(c,d);break;case "textarea":he(c,d);break;case "select":a=c._wrapperState.wasMultiple,
c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?ee(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?ee(c,!!d.multiple,d.defaultValue,!0):ee(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 8:null===b.stateNode?w("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 5:break;case 15:break;case 16:break;default:w("163")}}function Cg(a,b,c){c=df(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Dg(d);ug(a,b)};return c}
function Eg(a,b,c){c=df(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===Fg?Fg=new Set([this]):Fg.add(this);var c=b.value,d=b.stack;ug(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function Gg(a){switch(a.tag){case 2:M(a.type)&&Ie(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return M(a.type._reactResult)&&Ie(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return Bf(a),Je(a),b=a.effectTag,0!==(b&64)?w("285"):void 0,a.effectTag=b&-1025|64,a;case 7:return Df(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 6:return Bf(a),null;case 12:return tf(a),null;default:return null}}
var Hg={readContext:vf},Ig=Yb.ReactCurrentOwner,Jg=0,Kg=0,Lg=!1,P=null,Mg=null,Q=0,Ng=!1,R=null,Og=!1,Fg=null;function Pg(){if(null!==P)for(var a=P.return;null!==a;){var b=a;switch(b.tag){case 2:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ie(b);break;case 3:c=b.type._reactResult.childContextTypes;null!==c&&void 0!==c&&Ie(b);break;case 5:Bf(b);Je(b);break;case 7:Df(b);break;case 6:Bf(b);break;case 12:tf(b)}a=a.return}Mg=null;Q=0;Ng=!1;P=null}
function Qg(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){var e=b;b=a;var f=b.pendingProps;switch(b.tag){case 0:case 1:break;case 2:M(b.type)&&Ie(b);break;case 3:M(b.type._reactResult)&&Ie(b);break;case 5:Bf(b);Je(b);f=b.stateNode;f.pendingContext&&(f.context=f.pendingContext,f.pendingContext=null);if(null===e||null===e.child)$f(b),b.effectTag&=-3;rg(b);break;case 7:Df(b);var g=zf(yf.current),k=b.type;if(null!==e&&null!=b.stateNode){var h=e.memoizedProps;if(h!==f){var l=
b.stateNode,m=zf(N.current),t=l,x=k;var z=h;var y=f;l=g;var u=null;switch(x){case "input":z=zc(t,z);y=zc(t,y);u=[];break;case "option":z=de(t,z);y=de(t,y);u=[];break;case "select":z=n({},z,{value:void 0});y=n({},y,{value:void 0});u=[];break;case "textarea":z=fe(t,z);y=fe(t,y);u=[];break;default:"function"!==typeof z.onClick&&"function"===typeof y.onClick&&(t.onclick=we)}te(x,y);x=t=void 0;var v=null;for(t in z)if(!y.hasOwnProperty(t)&&z.hasOwnProperty(t)&&null!=z[t])if("style"===t){var r=z[t];for(x in r)r.hasOwnProperty(x)&&
(v||(v={}),v[x]="")}else"dangerouslySetInnerHTML"!==t&&"children"!==t&&"suppressContentEditableWarning"!==t&&"suppressHydrationWarning"!==t&&"autoFocus"!==t&&(sa.hasOwnProperty(t)?u||(u=[]):(u=u||[]).push(t,null));for(t in y){var p=y[t];r=null!=z?z[t]:void 0;if(y.hasOwnProperty(t)&&p!==r&&(null!=p||null!=r))if("style"===t)if(r){for(x in r)!r.hasOwnProperty(x)||p&&p.hasOwnProperty(x)||(v||(v={}),v[x]="");for(x in p)p.hasOwnProperty(x)&&r[x]!==p[x]&&(v||(v={}),v[x]=p[x])}else v||(u||(u=[]),u.push(t,
v)),v=p;else"dangerouslySetInnerHTML"===t?(p=p?p.__html:void 0,r=r?r.__html:void 0,null!=p&&r!==p&&(u=u||[]).push(t,""+p)):"children"===t?r===p||"string"!==typeof p&&"number"!==typeof p||(u=u||[]).push(t,""+p):"suppressContentEditableWarning"!==t&&"suppressHydrationWarning"!==t&&(sa.hasOwnProperty(t)?(null!=p&&ve(l,t),u||r===p||(u=[])):(u=u||[]).push(t,p))}v&&(u=u||[]).push("style",v);sg(e,b,u,k,h,f,g,m)}e.ref!==b.ref&&(b.effectTag|=128)}else if(f){u=zf(N.current);if($f(b)){f=b;l=f.stateNode;e=f.type;
h=f.memoizedProps;m=g;l[Ia]=f;l[Ja]=h;k=void 0;g=l;switch(e){case "iframe":case "object":H("load",g);break;case "video":case "audio":for(l=0;l<fb.length;l++)H(fb[l],g);break;case "source":H("error",g);break;case "img":case "image":case "link":H("error",g);H("load",g);break;case "form":H("reset",g);H("submit",g);break;case "details":H("toggle",g);break;case "input":Bc(g,h);H("invalid",g);ve(m,"onChange");break;case "select":g._wrapperState={wasMultiple:!!h.multiple};H("invalid",g);ve(m,"onChange");
break;case "textarea":ge(g,h),H("invalid",g),ve(m,"onChange")}te(e,h);l=null;for(k in h)h.hasOwnProperty(k)&&(u=h[k],"children"===k?"string"===typeof u?g.textContent!==u&&(l=["children",u]):"number"===typeof u&&g.textContent!==""+u&&(l=["children",""+u]):sa.hasOwnProperty(k)&&null!=u&&ve(m,k));switch(e){case "input":Wb(g);Fc(g,h,!0);break;case "textarea":Wb(g);ie(g,h);break;case "select":case "option":break;default:"function"===typeof h.onClick&&(g.onclick=we)}k=l;f.updateQueue=k;f=null!==k?!0:!1;
f&&qg(b)}else{h=b;e=k;m=f;l=9===g.nodeType?g:g.ownerDocument;u===je.html&&(u=ke(e));u===je.html?"script"===e?(e=l.createElement("div"),e.innerHTML="<script>\x3c/script>",l=e.removeChild(e.firstChild)):"string"===typeof m.is?l=l.createElement(e,{is:m.is}):(l=l.createElement(e),"select"===e&&m.multiple&&(l.multiple=!0)):l=l.createElementNS(u,e);e=l;e[Ia]=h;e[Ja]=f;a:for(h=e,m=b,l=m.child;null!==l;){if(7===l.tag||8===l.tag)h.appendChild(l.stateNode);else if(6!==l.tag&&null!==l.child){l.child.return=
l;l=l.child;continue}if(l===m)break;for(;null===l.sibling;){if(null===l.return||l.return===m)break a;l=l.return}l.sibling.return=l.return;l=l.sibling}m=e;l=k;h=f;t=g;v=ue(l,h);switch(l){case "iframe":case "object":H("load",m);g=h;break;case "video":case "audio":for(g=0;g<fb.length;g++)H(fb[g],m);g=h;break;case "source":H("error",m);g=h;break;case "img":case "image":case "link":H("error",m);H("load",m);g=h;break;case "form":H("reset",m);H("submit",m);g=h;break;case "details":H("toggle",m);g=h;break;
case "input":Bc(m,h);g=zc(m,h);H("invalid",m);ve(t,"onChange");break;case "option":g=de(m,h);break;case "select":m._wrapperState={wasMultiple:!!h.multiple};g=n({},h,{value:void 0});H("invalid",m);ve(t,"onChange");break;case "textarea":ge(m,h);g=fe(m,h);H("invalid",m);ve(t,"onChange");break;default:g=h}te(l,g);u=void 0;z=l;y=m;x=g;for(u in x)x.hasOwnProperty(u)&&(r=x[u],"style"===u?re(y,r):"dangerouslySetInnerHTML"===u?(r=r?r.__html:void 0,null!=r&&ne(y,r)):"children"===u?"string"===typeof r?("textarea"!==
z||""!==r)&&oe(y,r):"number"===typeof r&&oe(y,""+r):"suppressContentEditableWarning"!==u&&"suppressHydrationWarning"!==u&&"autoFocus"!==u&&(sa.hasOwnProperty(u)?null!=r&&ve(t,u):null!=r&&xc(y,u,r,v)));switch(l){case "input":Wb(m);Fc(m,h,!1);break;case "textarea":Wb(m);ie(m,h);break;case "option":null!=h.value&&m.setAttribute("value",""+yc(h.value));break;case "select":g=m;g.multiple=!!h.multiple;m=h.value;null!=m?ee(g,!!h.multiple,m,!1):null!=h.defaultValue&&ee(g,!!h.multiple,h.defaultValue,!0);break;
default:"function"===typeof g.onClick&&(m.onclick=we)}(f=ze(k,f))&&qg(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?w("166"):void 0;break;case 8:e&&null!=b.stateNode?tg(e,b,e.memoizedProps,f):("string"!==typeof f&&(null===b.stateNode?w("166"):void 0),g=zf(yf.current),zf(N.current),$f(b)?(f=b,k=f.stateNode,g=f.memoizedProps,k[Ia]=f,(f=k.nodeValue!==g)&&qg(b)):(k=b,f=(9===g.nodeType?g:g.ownerDocument).createTextNode(f),f[Ia]=k,b.stateNode=f));break;case 13:case 14:break;
case 16:break;case 9:break;case 10:break;case 15:break;case 6:Bf(b);rg(b);break;case 12:tf(b);break;case 11:break;case 4:w("167");default:w("156")}b=P=null;f=a;if(1073741823===Q||1073741823!==f.childExpirationTime){k=0;for(g=f.child;null!==g;){e=g.expirationTime;h=g.childExpirationTime;if(0===k||0!==e&&e<k)k=e;if(0===k||0!==h&&h<k)k=h;g=g.sibling}f.childExpirationTime=k}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gg(a,Q);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512)}if(null!==d)return d;if(null!==c)a=c;else break}return null}function Rg(a){var b=pg(a.alternate,a,Q);null===b&&(b=Qg(a));Ig.current=null;return b}
function Sg(a,b,c){Lg?w("243"):void 0;Lg=!0;Ig.currentDispatcher=Hg;var d=a.nextExpirationTimeToWorkOn;if(d!==Q||a!==Mg||null===P)Pg(),Mg=a,Q=d,P=Ue(Mg.current,null,Q),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==P&&!Tg();)P=Rg(P);else for(;null!==P;)P=Rg(P)}catch(t){if(null===P)e=!0,Dg(t);else{null===P?w("271"):void 0;var f=P,g=f.return;if(null===g)e=!0,Dg(t);else{a:{var k=g,h=f,l=t;g=Q;h.effectTag|=512;h.firstEffect=h.lastEffect=null;Ng=!0;l=nf(l,h);do{switch(k.tag){case 5:k.effectTag|=
1024;k.expirationTime=g;g=Cg(k,l,g);gf(k,g);break a;case 2:case 3:h=l;var m=k.stateNode;if(0===(k.effectTag&64)&&null!==m&&"function"===typeof m.componentDidCatch&&(null===Fg||!Fg.has(m))){k.effectTag|=1024;k.expirationTime=g;g=Eg(k,h,g);gf(k,g);break a}}k=k.return}while(null!==k)}P=Qg(f);continue}}}break}while(1);Lg=!1;rf=qf=pf=Ig.currentDispatcher=null;if(e)Mg=null,a.finishedWork=null;else if(null!==P)a.finishedWork=null;else{b=a.current.alternate;null===b?w("281"):void 0;Mg=null;if(Ng){e=a.latestPendingTime;
f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e>d||0!==f&&f>d||0!==g&&g>d){a.didError=!1;c=a.latestPingedTime;0!==c&&c<=d&&(a.latestPingedTime=0);c=a.earliestPendingTime;b=a.latestPendingTime;c===d?a.earliestPendingTime=b===d?a.latestPendingTime=0:b:b===d&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;b=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=d:c>d?a.earliestSuspendedTime=d:b<d&&(a.latestSuspendedTime=d);$e(d,a);a.expirationTime=a.expirationTime;return}if(!a.didError&&
!c){a.didError=!0;a.nextExpirationTimeToWorkOn=d;d=a.expirationTime=1;a.expirationTime=d;return}}a.pendingCommitExpirationTime=d;a.finishedWork=b}}
function wg(a,b){var c;a:{Lg&&!Og?w("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:case 3:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===Fg||!Fg.has(d))){a=nf(b,a);a=Eg(c,a,1);ff(c,a);If(c,1);c=void 0;break a}break;case 5:a=nf(b,a);a=Cg(c,a,1);ff(c,a);If(c,1);c=void 0;break a}c=c.return}5===a.tag&&(c=nf(b,a),c=Cg(a,c,1),ff(a,c),If(a,1));c=void 0}return c}
function Hf(a,b){0!==Kg?a=Kg:Lg?a=Og?1:Q:b.mode&1?(a=Ug?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1),null!==Mg&&a===Q&&(a+=1)):a=1;Ug&&(0===Vg||a>Vg)&&(Vg=a);return a}
function If(a,b){a:{if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;var c=a.alternate;null!==c&&(0===c.expirationTime||c.expirationTime>b)&&(c.expirationTime=b);var d=a.return;if(null===d&&5===a.tag)a=a.stateNode;else{for(;null!==d;){c=d.alternate;if(0===d.childExpirationTime||d.childExpirationTime>b)d.childExpirationTime=b;null!==c&&(0===c.childExpirationTime||c.childExpirationTime>b)&&(c.childExpirationTime=b);if(null===d.return&&5===d.tag){a=d.stateNode;break a}d=d.return}a=null}}if(null!==
a){!Lg&&0!==Q&&b<Q&&Pg();Ze(a,b);if(!Lg||Og||Mg!==a){b=a;a=a.expirationTime;if(null===b.nextScheduledRoot)b.expirationTime=a,null===T?(U=T=b,b.nextScheduledRoot=b):(T=T.nextScheduledRoot=b,T.nextScheduledRoot=U);else if(c=b.expirationTime,0===c||a<c)b.expirationTime=a;V||(W?Wg&&(Y=b,Z=1,Xg(b,1,!0)):1===a?Yg(1,null):Zg(b,a))}$g>ah&&($g=0,w("185"))}}function bh(a,b,c,d,e){var f=Kg;Kg=1;try{return a(b,c,d,e)}finally{Kg=f}}
var U=null,T=null,ch=0,dh=void 0,V=!1,Y=null,Z=0,Vg=0,eh=!1,fh=!1,gh=null,hh=null,W=!1,Wg=!1,Ug=!1,ih=null,jh=ba.unstable_now(),kh=(jh/10|0)+2,lh=kh,ah=50,$g=0,mh=null,nh=1;function oh(){kh=((ba.unstable_now()-jh)/10|0)+2}function Zg(a,b){if(0!==ch){if(b>ch)return;null!==dh&&ba.unstable_cancelScheduledWork(dh)}ch=b;a=ba.unstable_now()-jh;dh=ba.unstable_scheduleWork(ph,{timeout:10*(b-2)-a})}function Gf(){if(V)return lh;qh();if(0===Z||1073741823===Z)oh(),lh=kh;return lh}
function qh(){var a=0,b=null;if(null!==T)for(var c=T,d=U;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===T?w("244"):void 0;if(d===d.nextScheduledRoot){U=T=d.nextScheduledRoot=null;break}else if(d===U)U=e=d.nextScheduledRoot,T.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===T){T=c;T.nextScheduledRoot=U;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===T)break;if(1===a)break;
c=d;d=d.nextScheduledRoot}}Y=b;Z=a}function ph(a){if(a.didTimeout&&null!==U){oh();var b=U;do{var c=b.expirationTime;0!==c&&kh>=c&&(b.nextExpirationTimeToWorkOn=kh);b=b.nextScheduledRoot}while(b!==U)}Yg(0,a)}
function Yg(a,b){hh=b;qh();if(null!==hh)for(oh(),lh=kh;null!==Y&&0!==Z&&(0===a||a>=Z)&&(!eh||kh>=Z);)Xg(Y,Z,kh>=Z),qh(),oh(),lh=kh;else for(;null!==Y&&0!==Z&&(0===a||a>=Z);)Xg(Y,Z,!0),qh();null!==hh&&(ch=0,dh=null);0!==Z&&Zg(Y,Z);hh=null;eh=!1;$g=0;mh=null;if(null!==ih)for(a=ih,ih=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){fh||(fh=!0,gh=d)}}if(fh)throw a=gh,gh=null,fh=!1,a;}
function Xg(a,b,c){V?w("245"):void 0;V=!0;if(null===hh||c){var d=a.finishedWork;null!==d?rh(a,d,b):(a.finishedWork=null,Sg(a,!1,c),d=a.finishedWork,null!==d&&rh(a,d,b))}else d=a.finishedWork,null!==d?rh(a,d,b):(a.finishedWork=null,Sg(a,!0,c),d=a.finishedWork,null!==d&&(Tg()?a.finishedWork=d:rh(a,d,b)));V=!1}
function rh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===ih?ih=[d]:ih.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===mh?$g++:(mh=a,$g=0);Og=Lg=!0;a.current===b?w("177"):void 0;c=a.pendingCommitExpirationTime;0===c?w("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=0===d||0!==e&&e<d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=
0,a.latestPingedTime=0):(e=a.latestPendingTime,0!==e&&(e<d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime<d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?Ze(a,d):d>a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,Ze(a,d)):d<e&&Ze(a,d));$e(0,a);Ig.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;xe=Gd;e=Td();if(Ud(e)){if("selectionStart"in e)var f=
{start:e.selectionStart,end:e.selectionEnd};else a:{f=(f=e.ownerDocument)&&f.defaultView||window;var g=f.getSelection&&f.getSelection();if(g&&0!==g.rangeCount){f=g.anchorNode;var k=g.anchorOffset,h=g.focusNode;g=g.focusOffset;try{f.nodeType,h.nodeType}catch(Xa){f=null;break a}var l=0,m=-1,t=-1,x=0,z=0,y=e,u=null;b:for(;;){for(var v;;){y!==f||0!==k&&3!==y.nodeType||(m=l+k);y!==h||0!==g&&3!==y.nodeType||(t=l+g);3===y.nodeType&&(l+=y.nodeValue.length);if(null===(v=y.firstChild))break;u=y;y=v}for(;;){if(y===
e)break b;u===f&&++x===k&&(m=l);u===h&&++z===g&&(t=l);if(null!==(v=y.nextSibling))break;y=u;u=y.parentNode}y=v}f=-1===m||-1===t?null:{start:m,end:t}}else f=null}f=f||{start:0,end:0}}else f=null;ye={focusedElem:e,selectionRange:f};Gd=!1;for(R=d;null!==R;){e=!1;f=void 0;try{for(;null!==R;){if(R.effectTag&256){var r=R.alternate;a:switch(k=R,k.tag){case 2:case 3:if(k.effectTag&256&&null!==r){var p=r.memoizedProps,D=r.memoizedState,S=k.stateNode;S.props=k.memoizedProps;S.state=k.memoizedState;var yh=S.getSnapshotBeforeUpdate(p,
D);S.__reactInternalSnapshotBeforeUpdate=yh}break a;case 5:case 7:case 8:case 6:break a;default:w("163")}}R=R.nextEffect}}catch(Xa){e=!0,f=Xa}e&&(null===R?w("178"):void 0,wg(R,f),null!==R&&(R=R.nextEffect))}for(R=d;null!==R;){r=!1;p=void 0;try{for(;null!==R;){var A=R.effectTag;A&16&&oe(R.stateNode,"");if(A&128){var B=R.alternate;if(null!==B){var q=B.ref;null!==q&&("function"===typeof q?q(null):q.current=null)}}switch(A&14){case 2:Ag(R);R.effectTag&=-3;break;case 6:Ag(R);R.effectTag&=-3;Bg(R.alternate,
R);break;case 4:Bg(R.alternate,R);break;case 8:D=R,yg(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}R=R.nextEffect}}catch(Xa){r=!0,p=Xa}r&&(null===R?w("178"):void 0,wg(R,p),null!==R&&(R=R.nextEffect))}q=ye;B=Td();A=q.focusedElem;p=q.selectionRange;if(B!==A&&A&&A.ownerDocument&&Sd(A.ownerDocument.documentElement,A)){null!==p&&Ud(A)&&(B=p.start,q=p.end,void 0===q&&(q=B),"selectionStart"in A?(A.selectionStart=B,A.selectionEnd=Math.min(q,A.value.length)):
(r=A.ownerDocument||document,B=(r?r.defaultView:window).getSelection(),D=A.textContent.length,q=Math.min(p.start,D),p=void 0===p.end?q:Math.min(p.end,D),!B.extend&&q>p&&(D=p,p=q,q=D),D=Rd(A,q),S=Rd(A,p),D&&S&&(1!==B.rangeCount||B.anchorNode!==D.node||B.anchorOffset!==D.offset||B.focusNode!==S.node||B.focusOffset!==S.offset)&&(r=r.createRange(),r.setStart(D.node,D.offset),B.removeAllRanges(),q>p?(B.addRange(r),B.extend(S.node,S.offset)):(r.setEnd(S.node,S.offset),B.addRange(r)))));B=[];for(q=A;q=q.parentNode;)1===
q.nodeType&&B.push({element:q,left:q.scrollLeft,top:q.scrollTop});"function"===typeof A.focus&&A.focus();for(A=0;A<B.length;A++)q=B[A],q.element.scrollLeft=q.left,q.element.scrollTop=q.top}ye=null;Gd=!!xe;xe=null;a.current=b;for(R=d;null!==R;){d=!1;A=void 0;try{for(B=c;null!==R;){var Sa=R.effectTag;if(Sa&36){var oc=R.alternate;q=R;r=B;switch(q.tag){case 2:case 3:var X=q.stateNode;if(q.effectTag&4)if(null===oc)X.props=q.memoizedProps,X.state=q.memoizedState,X.componentDidMount();else{var Ih=oc.memoizedProps,
Jh=oc.memoizedState;X.props=q.memoizedProps;X.state=q.memoizedState;X.componentDidUpdate(Ih,Jh,X.__reactInternalSnapshotBeforeUpdate)}var kg=q.updateQueue;null!==kg&&(X.props=q.memoizedProps,X.state=q.memoizedState,lf(q,kg,X,r));break;case 5:var lg=q.updateQueue;if(null!==lg){p=null;if(null!==q.child)switch(q.child.tag){case 7:p=q.child.stateNode;break;case 2:case 3:p=q.child.stateNode}lf(q,lg,p,r)}break;case 7:var Kh=q.stateNode;null===oc&&q.effectTag&4&&ze(q.type,q.memoizedProps)&&Kh.focus();break;
case 8:break;case 6:break;case 15:break;case 16:break;default:w("163")}}if(Sa&128){var Ac=R.ref;if(null!==Ac){var mg=R.stateNode;switch(R.tag){case 7:var Od=mg;break;default:Od=mg}"function"===typeof Ac?Ac(Od):Ac.current=Od}}var Lh=R.nextEffect;R.nextEffect=null;R=Lh}}catch(Xa){d=!0,A=Xa}d&&(null===R?w("178"):void 0,wg(R,A),null!==R&&(R=R.nextEffect))}Lg=Og=!1;"function"===typeof Oe&&Oe(b.stateNode);Sa=b.expirationTime;b=b.childExpirationTime;b=0===Sa||0!==b&&b<Sa?b:Sa;0===b&&(Fg=null);a.expirationTime=
b;a.finishedWork=null}function Tg(){return eh?!0:null===hh||hh.timeRemaining()>nh?!1:eh=!0}function Dg(a){null===Y?w("246"):void 0;Y.expirationTime=0;fh||(fh=!0,gh=a)}function sh(a,b){var c=W;W=!0;try{return a(b)}finally{(W=c)||V||Yg(1,null)}}function th(a,b){if(W&&!Wg){Wg=!0;try{return a(b)}finally{Wg=!1}}return a(b)}function uh(a,b,c){if(Ug)return a(b,c);W||V||0===Vg||(Yg(Vg,null),Vg=0);var d=Ug,e=W;W=Ug=!0;try{return a(b,c)}finally{Ug=d,(W=e)||V||Yg(1,null)}}
function vh(a){if(!a)return Fe;a=a._reactInternalFiber;a:{2!==jd(a)||2!==a.tag&&3!==a.tag?w("170"):void 0;var b=a;do{switch(b.tag){case 5:b=b.stateNode.context;break a;case 2:if(M(b.type)){b=b.stateNode.__reactInternalMemoizedMergedChildContext;break a}break;case 3:if(M(b.type._reactResult)){b=b.stateNode.__reactInternalMemoizedMergedChildContext;break a}}b=b.return}while(null!==b);w("171");b=void 0}if(2===a.tag){var c=a.type;if(M(c))return Le(a,c,b)}else if(3===a.tag&&(c=a.type._reactResult,M(c)))return Le(a,
c,b);return b}function wh(a,b,c,d,e){var f=b.current;c=vh(c);null===b.context?b.context=c:b.pendingContext=c;b=e;e=df(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);ff(f,e);If(f,d);return d}function xh(a,b,c,d){var e=b.current,f=Gf();e=Hf(f,e);return wh(a,b,c,e,d)}function zh(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 7:return a.child.stateNode;default:return a.child.stateNode}}
function Ah(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:ac,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Fb=function(a,b,c){switch(b){case "input":Dc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Na(d);e?void 0:w("90");Xb(d);Dc(d,e)}}}break;case "textarea":he(a,c);break;case "select":b=c.value,null!=b&&ee(a,!!c.multiple,b,!1)}};
function Bh(a){var b=2+25*(((Gf()-2+500)/25|0)+1);b<=Jg&&(b=Jg+1);this._expirationTime=Jg=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Bh.prototype.render=function(a){this._defer?void 0:w("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Ch;wh(a,b,null,c,d._onCommit);return d};
Bh.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Bh.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:w("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?w("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;b=c;V?w("253"):void 0;Y=a;Z=b;Xg(a,b,!0);Yg(1,null);b=this._next;this._next=null;b=a.firstBatch=b;null!==
b&&b._hasChildren&&b.render(b._children)}else this._next=null,this._defer=!1};Bh.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Ch(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Ch.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ch.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?w("191",c):void 0;c()}}};
function Dh(a,b,c){b=new Se(5,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Dh.prototype.render=function(a,b){var c=this._internalRoot,d=new Ch;b=void 0===b?null:b;null!==b&&d.then(b);xh(a,c,null,d._onCommit);return d};Dh.prototype.unmount=function(a){var b=this._internalRoot,c=new Ch;a=void 0===a?null:a;null!==a&&c.then(a);xh(null,b,null,c._onCommit);return c};Dh.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Ch;c=void 0===c?null:c;null!==c&&e.then(c);xh(b,d,a,e._onCommit);return e};
Dh.prototype.createBatch=function(){var a=new Bh(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Eh(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Lb=sh;Mb=uh;Nb=function(){V||0===Vg||(Yg(Vg,null),Vg=0)};
function Fh(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Dh(a,!1,b)}
function Gh(a,b,c,d,e){Eh(c)?void 0:w("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=zh(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Fh(c,d);if("function"===typeof e){var k=e;e=function(){var a=zh(f._internalRoot);k.call(a)}}th(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return zh(f._internalRoot)}
function Hh(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Eh(b)?void 0:w("200");return Ah(a,b,null,c)}
var Mh={createPortal:Hh,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?w("188"):w("268",Object.keys(a)));a=md(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){return Gh(null,a,b,!0,c)},render:function(a,b,c){return Gh(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?w("38"):void 0;return Gh(a,b,c,!1,d)},unmountComponentAtNode:function(a){Eh(a)?
void 0:w("40");return a._reactRootContainer?(th(function(){Gh(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Hh.apply(void 0,arguments)},unstable_batchedUpdates:sh,unstable_interactiveUpdates:uh,flushSync:function(a,b){V?w("187"):void 0;var c=W;W=!0;try{return bh(a,b)}finally{W=c,Yg(1,null)}},unstable_flushControlled:function(a){var b=W;W=!0;try{bh(a)}finally{(W=b)||V||Yg(1,null)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[La,
Ma,Na,qa,Ua,function(a){za(a,Ta)},Jb,Kb,Id,Ga]},unstable_createRoot:function(a,b){Eh(a)?void 0:w("278");return new Dh(a,!0,null!=b&&!0===b.hydrate)}};(function(a){var b=a.findFiberByHostInstance;return Re(n({},a,{findHostInstanceByFiber:function(a){a=md(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ka,bundleType:0,version:"16.5.0",rendererPackageName:"react-dom"});var Nh={default:Mh},Oh=Nh&&Mh||Nh;
module.exports=Oh.default||Oh;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(162);
} else {
  module.exports = require('./cjs/schedule.development.js');
}


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.5.0
 * schedule.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=!("undefined"===typeof window||!window.document||!window.document.createElement),f=Date,g="function"===typeof setTimeout?setTimeout:void 0,h="function"===typeof clearTimeout?clearTimeout:void 0,l="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,m="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,n="object"===typeof performance&&"function"===typeof performance.now;
exports.unstable_now=void 0;if(n){var p=performance;exports.unstable_now=function(){return p.now()}}else exports.unstable_now=function(){return f.now()};exports.unstable_scheduleWork=void 0;exports.unstable_cancelScheduledWork=void 0;
if(d){var q=null,r=null,t=-1,u=!1,v=!1,w=void 0,x=void 0,y=function(a){w=l(function(b){h(x);a(b)});x=g(function(){m(w);a(exports.unstable_now())},100)},z=0,A=33,B=33,C={didTimeout:!1,timeRemaining:function(){var a=z-exports.unstable_now();return 0<a?a:0}},E=function(a,b){var c=a.scheduledCallback,e=!1;try{c(b),e=!0}finally{exports.unstable_cancelScheduledWork(a),e||(u=!0,window.postMessage(D,"*"))}},D="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===
window&&a.data===D&&(u=!1,null!==q)){if(null!==q){var b=exports.unstable_now();if(!(-1===t||t>b)){a=-1;for(var c=[],e=q;null!==e;){var k=e.timeoutTime;-1!==k&&k<=b?c.push(e):-1!==k&&(-1===a||k<a)&&(a=k);e=e.next}if(0<c.length)for(C.didTimeout=!0,b=0,e=c.length;b<e;b++)E(c[b],C);t=a}}for(a=exports.unstable_now();0<z-a&&null!==q;)a=q,C.didTimeout=!1,E(a,C),a=exports.unstable_now();null===q||v||(v=!0,y(F))}},!1);var F=function(a){v=!1;var b=a-z+B;b<B&&A<B?(8>b&&(b=8),B=b<A?A:b):A=b;z=a+B;u||(u=!0,window.postMessage(D,
"*"))};exports.unstable_scheduleWork=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=exports.unstable_now()+b.timeout);if(-1===t||-1!==c&&c<t)t=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===q?q=a:(b=a.prev=r,null!==b&&(b.next=a));r=a;v||(v=!0,y(F));return a};exports.unstable_cancelScheduledWork=function(a){if(null!==a.prev||q===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,q=b):null!==c?(c.next=null,r=c):r=
q=null}}}else{var G=new Map;exports.unstable_scheduleWork=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=g(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})});G.set(a,c);return b};exports.unstable_cancelScheduledWork=function(a){var b=G.get(a.scheduledCallback);G.delete(a);h(b)}};


/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserScoreQuiz__ = __webpack_require__(166);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UserScoreQuiz__["a" /* default */],null));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dcs_logo_png__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dcs_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dcs_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserScoreDualQuiz__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserComponent__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UserScoreSingleQuiz__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Leaderboard__ = __webpack_require__(378);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var configs={"reddit_internaltest2":function reddit_internaltest2(browserId){return new __WEBPACK_IMPORTED_MODULE_2__UserScoreDualQuiz__["a" /* default */]("reddit_internaltest3_jan2017",browserId);}};var UserScoreQuiz=function(_Component){_inherits(UserScoreQuiz,_Component);function UserScoreQuiz(props){_classCallCheck(this,UserScoreQuiz);// Set up browser ID
var _this=_possibleConstructorReturn(this,(UserScoreQuiz.__proto__||Object.getPrototypeOf(UserScoreQuiz)).call(this,props));_this.browserId=window.localStorage.getItem("browserId");if(!_this.browserId){_this.browserId=__WEBPACK_IMPORTED_MODULE_5_uuid_v4___default()();window.localStorage.setItem("browserId",_this.browserId);}// Set up name and scoredata
var scoreData=window.localStorage.getItem("scoreData");try{scoreData=JSON.parse(scoreData);}catch(e){scoreData=null;}var name=window.localStorage.getItem("name")||"";_this.validationAnswer=window.localStorage.getItem("validationAnswer");// TODO
_this.configName="reddit_internaltest2";_this.quiz=configs[_this.configName](_this.browserId);_this.quiz.loadLeaderboard(function(data){_this.cachedLeaderboard=data;});_this.state={quiz_state:'welcome',// welcome | loading_quiz | in_quiz | submitting_quiz | complete
quiz_data:null,current_question:0,score_data:scoreData,name:name,showLeaderboard:false};_this.responses=[];setTimeout(function(){_this.loadQuizData();},100);return _this;}_createClass(UserScoreQuiz,[{key:'loadQuizData',value:function loadQuizData(){var _this2=this;this.quiz.loadQuizData(this.validationAnswer==null,function(quizData){console.log("Quiz data loaded.");_this2.setState({quiz_data:quizData});if(_this2.state.quiz_state=='loading_quiz'||_this2.state.quiz_state=='submitting_quiz'){_this2.setState({quiz_state:'in_quiz',current_question:0,question_start_time:Date.now()});}});}},{key:'beginQuiz',value:function beginQuiz(name){this.setState({name:name});window.localStorage.setItem("name",name);if(this.state.quiz_data==null){// Wait for quiz data to load
this.setState({quiz_state:'loading_quiz'});}else{this.setState({quiz_state:'in_quiz',current_question:0,question_start_time:Date.now()});}}},{key:'onResponse',value:function onResponse(score,points){score["config_name"]=this.configName;score["elapsed"]=Date.now()-this.state.question_start_time;score["browser_id"]=this.browserId;score["validation_answer"]=this.validationAnswer;var isValidation=score["item_id"]=="validation";if(isValidation){// this is the validation question
// just store response
this.validationAnswer=score["response"];window.localStorage.setItem("validationAnswer",this.validationAnswer);}this.responses.push(score);if(this.state.current_question==this.state.quiz_data.length-1){// Quiz complete!
this.submitQuiz(score,points);}else{// Submit interim response
this.quiz.submitResponses(this.state.name,[score],points,function(scoreData){// We don't display updated scoredata to hide which you got correct
// but we do save.
window.localStorage.setItem("scoreData",JSON.stringify(scoreData));console.log("Response submitted.");});this.setState({current_question:this.state.current_question+1,question_start_time:Date.now()});}}},{key:'submitQuiz',value:function submitQuiz(finalResponse,finalPoints){var _this3=this;this.setState({quiz_state:'submitting_quiz',past_responses:this.responses});this.quiz.submitResponses(this.state.name,[finalResponse],finalPoints,function(scoreData){console.log("Final response submitted. Loading more quiz.");_this3.responses=[];// first load a leaderboard to cache and show if user 
_this3.cachedLeaderboard=null;_this3.quiz.loadLeaderboard(function(data){_this3.cachedLeaderboard=data;_this3.loadQuizData();});window.localStorage.setItem("scoreData",JSON.stringify(scoreData));_this3.setState({score_data:scoreData});});}},{key:'render',value:function render(){var _this4=this;var mainContent;var step=-1,stepTotal=-1;var showValidation=this.validationAnswer==null;if(this.state.quiz_state=='welcome'){var WelcomeComponent=this.quiz.welcomeComponent();mainContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WelcomeComponent,{showValidation:showValidation,onBegin:this.beginQuiz.bind(this),name:this.state.name}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bottom-info'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://cs.toronto.edu',target:'_blank',rel:'noopener noreferrer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__dcs_logo_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'If you have questions or concerns about this website, please contact ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'walleris@cs.toronto.edu'},'walleris@cs.toronto.edu'))));}else if(this.state.quiz_state=='loading_quiz'){mainContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Loading...');}else if(this.state.quiz_state=='in_quiz'){var QuestionComponent=this.quiz.questionComponent();mainContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(QuestionComponent,{key:this.state.current_question,onResponse:this.onResponse.bind(this),question:this.state.quiz_data[this.state.current_question]});step=this.state.current_question;stepTotal=this.state.quiz_data.length;if(this.state.current_question==0&&this.state.past_responses){var CompletionComponent=this.quiz.completionComponent();mainContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompletionComponent,{responses:this.state.past_responses}),mainContent);step=-1;// Hide step counter
}}else if(this.state.quiz_state=='submitting_quiz'){var _CompletionComponent=this.quiz.completionComponent();mainContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_CompletionComponent,{responses:this.state.past_responses}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Loading more questions...'));}var progress;if(step!=-1){progress=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'progress'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'step'},'Step ',step+1,' / ',stepTotal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'step-progress'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{'width':step*100/stepTotal+"%"}})));}var scoreData=this.state.score_data;var score=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-score'},'Your score: ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,scoreData?scoreData.points:0,' points')),scoreData?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rank'},'#',scoreData.rank,' in the world'):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'leaderboard-link',onClick:function onClick(){return _this4.setState({showLeaderboard:!_this4.state.showLeaderboard});}},'View Leaderboard'));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'quiz'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-bar'},this.state.quiz_state=='welcome'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title welcome-title'},'Welcome to the Reddit Specialist Quiz!'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'Reddit Specialist Quiz'),progress,score),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},mainContent),this.state.showLeaderboard?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Leaderboard__["a" /* default */],{onClose:function onClose(){return _this4.setState({showLeaderboard:false});},loader:function loader(c){if(_this4.state.quiz_state=="in_quiz"){// use cached leaderboard to avoid giving away
if(_this4.cachedLeaderboard){c(_this4.cachedLeaderboard);}else{console.log("Could not show leaderboard, none cached");}}else{_this4.quiz.loadLeaderboard(c);}}}):null));}}]);return UserScoreQuiz;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (UserScoreQuiz);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dcs_logo.0a2a9ee4.png";

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserComponent__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserScoreShared__ = __webpack_require__(170);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function DualUserComponent(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dual-users'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-a'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'User A'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UserComponent__["a" /* default */],{communities:props.communities1})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-b'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},'User B'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UserComponent__["a" /* default */],{communities:props.communities2})));}var WelcomeScreen=function(_Component){_inherits(WelcomeScreen,_Component);function WelcomeScreen(props){_classCallCheck(this,WelcomeScreen);var _this=_possibleConstructorReturn(this,(WelcomeScreen.__proto__||Object.getPrototypeOf(WelcomeScreen)).call(this,props));_this.state={name:props.name};return _this;}_createClass(WelcomeScreen,[{key:'render',value:function render(){var _this2=this;var showValidation=this.props.showValidation;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'welcome'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In this quiz, you will be presented with a list of communities (subreddits) someone is a part of. The bar shows what percentage of their activity is in this community.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-example'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UserComponent__["a" /* default */],{communities:"gaming:5;funny:2"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'At each step, you will be shown two users. Click the button below the user which is ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'more of a specialist.'),' A specialist is ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'someone whose interests focus on a particular topic'),'. You can see how many you got right after answering ',showValidation?"11":"10",' questions.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'name-entry'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onKeyUp:function onKeyUp(e){if(e.which==13){_this2.props.onBegin(_this2.state.name);}},type:'text',placeholder:'Optional: name for leaderboard',value:this.state.name,onChange:function onChange(e){return _this2.setState({name:e.target.value});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn btn-primary',onClick:function onClick(){return _this2.props.onBegin(_this2.state.name);}},'Next Step')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Thank you for your participation! Your responses help us research how users specialize on social media.'));}}]);return WelcomeScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ScoringComponent=function(_Component2){_inherits(ScoringComponent,_Component2);function ScoringComponent(props){_classCallCheck(this,ScoringComponent);var _this3=_possibleConstructorReturn(this,(ScoringComponent.__proto__||Object.getPrototypeOf(ScoringComponent)).call(this,props));_this3.state={selectedScore:null};return _this3;}_createClass(ScoringComponent,[{key:'render',value:function render(){var _this4=this;var question=this.props.question;var preview=this.props.preview;var result=function result(score){return function(){return _this4.setState({selectedScore:score});};};var selected=this.state.selectedScore;var submit=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn btn-primary',onClick:function onClick(){return _this4.props.onResponse(_this4.state.selectedScore);}},'Submit'));if(selected==null){submit=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn btn-disabled'},'Submit'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dual-scoring'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"user-a "+(selected=="A"?"active":""),onClick:result("A")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'choice'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:"far "+(selected=="A"?"fa-check-square":"fa-square")}),'User A is more specialist')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"user-b "+(selected=="B"?"active":""),onClick:result("B")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'choice'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:"far "+(selected=="B"?"fa-check-square":"fa-square")}),'User B is more specialist'))),preview?null:submit);}}]);return ScoringComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var QuestionScreen=function(_Component3){_inherits(QuestionScreen,_Component3);function QuestionScreen(){_classCallCheck(this,QuestionScreen);return _possibleConstructorReturn(this,(QuestionScreen.__proto__||Object.getPrototypeOf(QuestionScreen)).apply(this,arguments));}_createClass(QuestionScreen,[{key:'render',value:function render(){var _this6=this;var question=this.props.question;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'question'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Which of these two users is ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'more specialist'),'?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DualUserComponent,{communities1:question.communities_A,communities2:question.communities_B}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScoringComponent,{question:question,onResponse:function onResponse(response){var actual=question.specialist_score_A>question.specialist_score_B?"A":"B";var correct=response==actual;//console.log("----");
//console.log(question.specialist_score_A + " vs. " + question.specialist_score_B);
//console.log("Response: " + response + "    Actual: " + actual);
_this6.props.onResponse({"item_id":question.item_id,"dataset_sig":question.dataset_sig,"user_A":question.user_A,"user_B":question.user_B,"communities_A":question.communities_A,"communities_B":question.communities_B,"specialist_score_A":question.specialist_score_A,"specialist_score_B":question.specialist_score_B,"entropy_score_A":question.entropy_score_A,"entropy_score_B":question.entropy_score_B,"response":response},correct?1:0);}}));}}]);return QuestionScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function calculatePoints(responses){var correct=0;var n=responses.length;for(var i=0;i<n;i+=1){var response=responses[i];var actual=response.specialist_score_A>response.specialist_score_B?"A":"B";if(actual==response.response){correct+=1;}}return correct;}var CompletionScreen=function(_Component4){_inherits(CompletionScreen,_Component4);function CompletionScreen(){_classCallCheck(this,CompletionScreen);return _possibleConstructorReturn(this,(CompletionScreen.__proto__||Object.getPrototypeOf(CompletionScreen)).apply(this,arguments));}_createClass(CompletionScreen,[{key:'render',value:function render(){var responses=this.props.responses;var correct=calculatePoints(responses);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'completion'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'fas fa-check'}),' You got ',correct,' / ',responses.length,' correct!'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you\'d like to play again and help us collect more data, we\'ve loaded some more questions below:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr',null));}}]);return CompletionScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UserScoreDualQuiz=function(){function UserScoreDualQuiz(dataset,browserId){_classCallCheck(this,UserScoreDualQuiz);this.dataset=dataset;this.browserId=browserId;}_createClass(UserScoreDualQuiz,[{key:'welcomeComponent',value:function welcomeComponent(){return WelcomeScreen;}},{key:'loadQuizData',value:function loadQuizData(addValidation,callback){var n=10;__WEBPACK_IMPORTED_MODULE_2__UserScoreShared__["a" /* default */].loadUserScores(this.dataset,n,function(results){// Add validation question
if(addValidation){results.unshift({item_id:"validation",communities_A:"Dogtraining:1;puppy101:2;puppies:1;lookatmydog:1",communities_B:"nba:1;sailing:2;comicbooks:1;Curling:1",specialist_score_A:1,specialist_score_B:0});}callback(results);});}},{key:'questionComponent',value:function questionComponent(){return QuestionScreen;}},{key:'completionComponent',value:function completionComponent(){return CompletionScreen;}},{key:'submitResponses',value:function submitResponses(name,responses,points,callback){__WEBPACK_IMPORTED_MODULE_2__UserScoreShared__["a" /* default */].submitResponses(this.dataset,name,responses,points,function(scoreData){callback(scoreData);});}},{key:'loadLeaderboard',value:function loadLeaderboard(callback){__WEBPACK_IMPORTED_MODULE_2__UserScoreShared__["a" /* default */].loadLeaderboard(this.browserId,function(leaderboard){callback(leaderboard);});}}]);return UserScoreDualQuiz;}();/* harmony default export */ __webpack_exports__["a"] = (UserScoreDualQuiz);

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = {"195":{"lang":"en","description":"Home of Awesome","over18":false},"321":{"lang":"en","description":"A subreddit dedicated to 'The 321' - Brevard County, Florida - The Space Coast!  Home to Titusville, Cape Canaveral, Cocoa Beach, Rockledge, Melbourne and Palm Bay.","over18":false},"1022":{"lang":"en","description":"Dedicated to America's favorite rifle, and Ruger's most popular firearm, the venerable 10/22.","over18":false},"1911":{"lang":"en","description":"","over18":false},"2048":{"lang":"en","description":"2048","over18":false},"keto":{"lang":"en","description":"The Ketogenic Diet is a low carb, high fat method of eating. And /r/keto is place to share thoughts, ideas, benefits, and experiences around eating within a Ketogenic Diet.\n\nHelping people with diabet","over18":false},"AskReddit":{"lang":"es","description":"/r/AskReddit is the place to ask and answer thought-provoking questions.","over18":false},"funny":{"lang":"en","description":"Welcome to r/Funny: reddit's largest humour depository","over18":false},"politics":{"lang":"en","description":"/r/Politics is for news and discussion about U.S. politics.","over18":false},"pics":{"lang":"en","description":"A place to share photographs and pictures.","over18":false},"leagueoflegends":{"lang":"en","description":"This is a subreddit devoted to League of Legends.","over18":false},"gaming":{"lang":"en","description":"A subreddit for (almost) anything related to games - video games, board games, card games, etc. (but not sports).","over18":false},"nfl":{"lang":"en","description":"NFL: National Football League News & Discussion\nhttps://www.reddit.com/r/nfl/comments/\n","over18":false},"worldnews":{"lang":"en","description":"A place for major news from around the world, excluding US-internal news.\n","over18":false},"videos":{"lang":"en","description":"The best place for video content of all kinds. \n\nPlease read the sidebar below for our rules.","over18":false},"nba":{"lang":"en","description":"All things NBA basketball.","over18":false},"WTF":{"lang":"en","description":"Things that make you say \"What the F*ck\".\n\n","over18":false},"AdviceAnimals":{"lang":"en","description":"Reddit's Gold Mine","over18":false},"todayilearned":{"lang":"en","description":"You learn something new every day; what did you learn today?\nSubmit interesting and specific facts about something that you just found out here.","over18":false},"news":{"lang":"en","description":"/r/news is: real news articles, primarily but not exclusively, news relating to the United States. /r/news isn't: editorials, commercials, political minutiae, shouting, justin bieber updates, kitty pi","over18":false},"soccer":{"lang":"en","description":"The football subreddit.\n\nNews, results and discussion about the beautiful game.\n\n/r/soccer is currently working to get flairs working on New Reddit. Until then, please get them on /r/soccerbot.","over18":false},"The_Donald":{"lang":"en","description":"The_Donald is a never-ending rally dedicated to the 45th President of the United States, Donald J. Trump.","over18":false},"movies":{"lang":"en","description":"News & Discussion about Major Motion Pictures","over18":false},"SquaredCircle":{"lang":"en","description":"","over18":false},"hockey":{"lang":"en","description":"hockey: the best game on earth","over18":false},"DotA2":{"lang":"en","description":"Dota 2","over18":false},"pcmasterrace":{"lang":"en","description":"Welcome to the official subreddit of the PC Master Race. In this subreddit, we celebrate and promote the ultimate gaming and working platform. Ascend to a level that respects your eyes, your wallet, y","over18":false},"CFB":{"lang":"en","description":"A forum for all things college football. Primarily focused on NCAA football, discussion is welcome on any collegiate league, teams, and players.","over18":false},"IAmA":{"lang":"en","description":"","over18":false},"atheism":{"lang":"en","description":"Welcome to r/atheism, the web's largest atheist forum. All topics related to atheism, agnosticism and secular living are welcome here.","over18":false},"trees":{"lang":"en","description":"The go-to subreddit for anything and everything marijuana. From MMJ to munchies, from nugs to news, and everything between! The casual cannabis community.","over18":false},"DestinyTheGame":{"lang":"en","description":"Welcome! This sub is for discussing Bungie's newest 2 games, Destiny 2 and Destiny, a \"shared world\" action FPS. \n\nPlease read the sidebar rules, and search for your question before posting.","over18":false},"GlobalOffensive":{"lang":"en","description":"/r/GlobalOffensive is a home for the Counter-Strike: Global Offensive community and a hub for the discussion and sharing of content relevant to CS:GO. \n\nCounter-Strike: Global Offensive is a game crea","over18":false},"gifs":{"lang":"en","description":"Funny, animated gifs - your favorite computer file type!\n\nOfficially pronounced with a hard \"J\"","over18":false},"relationships":{"lang":"en","description":"/r/Relationships is a community built around the goal of providing a platform for interpersonal relationship advice between redditors. We seek posts from users who have specific and personal relations","over18":false},"aww":{"lang":"en","description":"Things that make you go AWW! Like puppies, bunnies, babies, and so on...\n\nA place for really cute pictures and videos!","over18":false},"technology":{"lang":"en","description":"For all things technology.","over18":false},"anime":{"lang":"en","description":"Reddit's premier anime community.","over18":false},"fantasyfootball":{"lang":"en","description":"/r/fantasyfootball - Good For Your Season","over18":false},"Overwatch":{"lang":"en","description":"Subreddit for all things Overwatch™, the team-based shooter from Blizzard Entertainment.","over18":false},"gonewild":{"lang":"en","description":"A place for open-minded Adult Redditors to show off their nude bodies for fun.","over18":true},"RocketLeagueExchange":{"lang":"en","description":"Subreddit for all kinds of Rocket League cosmetic item trades.","over18":false},"reddit.com":{"lang":"en","description":"the original subreddit","over18":false},"wow":{"lang":"en","description":"World of Warcraft on Reddit! ","over18":false},"hearthstone":{"lang":"en","description":"For fans of Blizzard Entertainment's digital card game, Hearthstone","over18":false},"MMA":{"lang":"en","description":"A subreddit for all things Mixed Martial Arts.","over18":false},"Games":{"lang":"en","description":"The goal of /r/Games is to provide a place for informative and interesting gaming content and discussions.\n\nSubmissions should be for the purpose of informing or initiating a discussion, not just with","over18":false},"Showerthoughts":{"lang":"en","description":"A subreddit for sharing those miniature epiphanies you have that highlight the oddities within the familiar.","over18":false},"buildapc":{"lang":"en","description":"Planning on building a computer but need some advice? This is the place to ask!\n\n/r/buildapc is a community-driven subreddit dedicated to custom PC assembly. Anyone is welcome to seek the input of our","over18":false},"teenagers":{"lang":"en","description":"r/teenagers is the biggest community forum run by teenagers for teenagers. Our subreddit is primarily for discussions and memes that an average teenager would enjoy to discuss about. We do not have an","over18":false},"Fitness":{"lang":"en","description":"Discussion of physical fitness goals and how they can be achieved","over18":false},"hiphopheads":{"lang":"en","description":"Everything hiphop! The latest mixtapes, videos, news, and anything else hip hop related from your favorite artists.","over18":false},"explainlikeimfive":{"lang":"en","description":"**Explain Like I'm Five is the best forum and archive on the internet for layman-friendly explanations.**\n\n&nbsp;\n\nDon't Panic!","over18":false},"Android":{"lang":"en","description":"Android news, reviews, tips, and discussions about rooting, tutorials, and apps. Generic discussion about phones/tablets is allowed, but technical-support and carrier-related issues should be asked in","over18":false},"baseball":{"lang":"en","description":"The subreddit for the bat-and-ball sport played between two teams of nine players. America's Pastime.","over18":false},"Music":{"lang":"en","description":"The musical community of reddit","over18":false},"pokemontrades":{"lang":"en","description":"/r/pokemontrades is a trading community focusing on legitimate Pokémon. We are one of the few large Pokémon trading communities with a policy of no hacks, no clones!","over18":false},"Random_Acts_Of_Amazon":{"lang":"en","description":"Community, friends, gifting and fun! Random Acts with an Amazon Wishlist.  Gift, get gifted, be merry, and have fun. ","over18":false},"magicTCG":{"lang":"en","description":"A place for sophisticated discussion of all things related to the Magic: The Gathering® (MTG or M:tG) trading card game (TCG or sometimes CCG for Collectible Card Game). We discuss tournament play, ne","over18":false},"electronic_cigarette":{"lang":"en","description":"Electronic_Cigarette, a subreddit for discussing everything e-cig/ecig related, including mods, juice, advocacy, and vaping. ","over18":false},"pokemon":{"lang":"en","description":"/r/pokemon is an unofficial Pokémon fan community. This is the place for most things Pokémon on Reddit—TV shows, video games, toys, trading cards, you name it!","over18":false},"AskMen":{"lang":"en","description":"r/AskMen is the premier place to ask random strangers for terrible dating advice, but preferably from the male perspective. A semi-serious place to ask men casual questions about life, career, and mor","over18":false},"GlobalOffensiveTrade":{"lang":"en","description":"A place to trade CS:GO items.","over18":false},"mildlyinteresting":{"lang":"en","description":"Aww, cripes. I didn't know I'd have to write a description. How many words is that so far, like a hundred? Soooo, yeah. Mildly interesting stuff. Stuff that interests you. Mildly. It's in the name, ff","over18":false},"friendsafari":{"lang":"en","description":"A place to exchange 3DS Friend Codes for the Pokémon X/Y Friend Safari!\n","over18":false},"conspiracy":{"lang":"en","description":"**The conspiracy subreddit is a thinking ground. Above all else, we respect everyone's opinions and ALL religious beliefs and creeds. We hope to challenge issues which have captured the public’s imagi","over18":false},"xboxone":{"lang":"en","description":"Everything and anything related to the Xbox One. News, reviews, previews, rumors, screenshots, videos and more!","over18":false},"starcraft":{"lang":"en","description":"All about the StarCraft games and professional scenes surrounding them. Please read the rules before submitting content.","over18":false},"fffffffuuuuuuuuuuuu":{"lang":"en","description":"","over18":false},"AskWomen":{"lang":"en","description":"AskWomen: A subreddit dedicated to asking women questions about their thoughts, lives, and experiences; providing a place where all women can comfortably and candidly share their responses in a non-ju","over18":false},"canada":{"lang":"en","description":"Canada - the country, people, culture, and yeah, the hockey, snow and all things Canadian. \n\nWe decided on this description politely. \n  \nNous parlons français ici aussi!\n","over18":false},"europe":{"lang":"en","description":"Europe: 50 (+6) countries, 230 languages, 743M people… 1 subreddit.","over18":false},"Bitcoin":{"lang":"en","description":"A community dedicated to Bitcoin, the currency of the Internet. Bitcoin is a distributed, worldwide, decentralized digital money. Bitcoins are issued and managed without any central authority whatsoev","over18":false},"TumblrInAction":{"lang":"en","description":"A true force for good!","over18":false},"Minecraft":{"lang":"en","description":"Minecraft community on reddit.","over18":false},"personalfinance":{"lang":"en","description":"Learn about budgeting, saving, getting out of debt, credit, investing, and retirement planning. Join our community, read the PF Wiki, and get on top of your finances!","over18":false},"guns":{"lang":"en","description":"A place for responsible gun owners and enthusiasts to talk about guns without the politics.","over18":false},"gameofthrones":{"lang":"en","description":"This is a place to enjoy and discuss the HBO series, book series ASOIAF, and GRRM works in general. It is a safe place regardless of where you are in the story. The main three rules are:\n\n* Content mu","over18":false},"TwoXChromosomes":{"lang":"en","description":"Welcome to TwoXChromosomes, a subreddit for both serious and silly content, and intended for women's perspectives.  \n\nWe are a welcoming subreddit and support the rights of all genders.\n\nPosts are mod","over18":false},"PS4":{"lang":"en","description":"The largest PlayStation 4 community on the internet.  Your hub for everything related to PS4 including games, news, reviews, discussion, questions, videos, and screenshots.\n","over18":false},"ffxiv":{"lang":"en","description":"A community for fans of Square Enix's popular MMORPG \"Final Fantasy XIV: A Realm Reborn\", also known as FFXIV or FF14. Current expansions include Heavensward and Stormblood.","over18":false},"asoiaf":{"lang":"en","description":"News and discussions relating to George R. R. Martin's \"A Song of Ice and Fire\" novels, his Westeros-based short stories, \"Game of Thrones\" and all things ASOIAF - but with particular emphasis on the ","over18":false},"2007scape":{"lang":"en","description":"The community for Old School RuneScape discussion on reddit. Join us for game discussions, weekly events and skilling competitions!\n\nOSRS is the official legacy version of RS, the largest free-to-play","over18":false},"Guildwars2":{"lang":"en","description":"Guild Wars 2 news and discussion.","over18":false},"Smite":{"lang":"en","description":"Smite is a third-person multiplayer online battle arena video game developed and published by Hi-Rez Studios on PC, XB1, and PS4.","over18":false},"science":{"lang":"en","description":"This community is a place to share and discuss new scientific research. Read about the latest advances in astronomy, biology, medicine, physics, social science, and more. Find and submit new publicati","over18":false},"sex":{"lang":"en","description":"r/sex is for civil discussions about all facets of sexuality and sexual relationships. It is a sex-positive community and a safe space for people of all genders and orientations. This is (mostly) as '","over18":false},"unitedkingdom":{"lang":"en","description":"For the United Kingdom of Great Britain (England, Scotland, Wales) and Northern Ireland; News, Politics, Economics, Society, Business, Culture, discussion and anything else UK related.","over18":false},"tf2":{"lang":"en","description":"This subreddit is dedicated to Team Fortress 2, created by Valve Corporation in 2007.","over18":false},"television":{"lang":"en","description":"Admins please fix markdown.\n\n##A general discussion television community for news, user discussion, reviews, video clips and more.\n\nSee our sidebar to check out our calendar which lists upcoming premi","over18":false},"OkCupid":{"lang":"en","description":"","over18":false},"cars":{"lang":"en","description":"/r/Cars is one of the largest online automotive enthusiast communities. We serve as Reddit's central hub for vehicle-related discussion including industry news, reviews, projects, videos, DIY guides, ","over18":false},"india":{"lang":"en","description":"A subreddit for India. Please read the sidebar before posting. ","over18":false},"FIFA":{"lang":"en","description":"* The front page of EA Sports FIFA.","over18":false},"Christianity":{"lang":"en","description":"/r/Christianity is a subreddit to discuss Christianity and aspects of Christian life. All are welcome to participate.","over18":false},"smashbros":{"lang":"en","description":"Welcome to Reddit's finest Super Smash Bros. community!","over18":false},"pathofexile":{"lang":"en","description":"A subreddit dedicated to the indie game Path of Exile made by Grinding Gear Games.","over18":false},"Eve":{"lang":"en","description":"A subreddit devoted to the MMORPG EVE Online: http://eveonline.com.\n\nRun by players, for players. ","over18":false},"australia":{"lang":"en","description":"A dusty corner on the internet where you can chew the fat about Australia and Australians.","over18":false},"malefashionadvice":{"lang":"en","description":"Making clothing less intimidating and helping you develop your own style. We welcome those who want to learn and those who want to contribute.","over18":false},"apple":{"lang":"en","description":"A passionate community to discuss Apple devices and software, including news, rumors, opinions and analysis pertaining to the company located at One Apple Park Way.","over18":false},"motorcycles":{"lang":"en","description":"A place for everything motorcycles.","over18":false},"formula1":{"lang":"en","description":"Formula 1 news and stories","over18":false},"SubredditDrama":{"lang":"en","description":"The place where people can come and talk about reddit fights and other dramatic happenings from other subreddits.","over18":false},"KotakuInAction":{"lang":"en","description":"KotakuInAction is the main hub for GamerGate on Reddit and welcomes discussion of community, industry and media issues in gaming and broader nerd culture including science fiction and comics.","over18":false},"MakeupAddiction":{"lang":"en","description":"The subreddit for everything makeup related.","over18":false},"ukpolitics":{"lang":"en","description":"Political news and debate concerning the United Kingdom.","over18":false},"heroesofthestorm":{"lang":"en","description":"Reddit community for Blizzard's MOBA game - Heroes of the Storm","over18":false},"programming":{"lang":"en","description":"Computer Programming","over18":false},"pokemongo":{"lang":"en","description":"Pokémon GO\n\nThe subreddit for Niantic's Pokémon-based Augmented Reality game. We are not affiliated with The Pokémon Company, Nintendo, or Niantic.","over18":false},"tifu":{"lang":"en","description":"WELCOME TO /r/TIFU! \n\nToday I Fucked Up is a community for the dumbass in all of us. We all have those moments where we do something ridiculously stupid. Let us make each other feel better about ourse","over18":false},"CasualConversation":{"lang":"en","description":"The friendlier part of reddit.\n\nHave a fun conversation about anything that is on your mind. Ask a question or start a conversation about (almost) anything you desire. Maybe you'll make some friends i","over18":false},"books":{"lang":"en","description":"This is a moderated subreddit. It is our intent and purpose to foster and encourage in-depth discussion about all things related to books, authors, genres, or publishing in a safe, supportive environm","over18":false},"StarWars":{"lang":"en","description":"A long time ago, in a sub reddit far, far, away.... There was an epic battle between good and evil.\n\nThe Jedi fight for justice and peace and the Sith for power and chaos.\n\nWhich side will you take?\n\n","over18":false},"SandersForPresident":{"lang":"en","description":"Midterm Bern & Bernie 2020! Supporting Senator Bernie Sanders, Our Revolution, National Nurses United, Justice Democrats, Democratic Socialists of America and Brand New Congress candidates and the San","over18":false},"Fireteams":{"lang":"en","description":"A matchmaking subreddit for Bungie's /r/DestinyTheGame.","over18":false},"runescape":{"lang":"en","description":"A subreddit dedicated to the MMORPG RuneScape.","over18":false},"Drugs":{"lang":"en","description":"Sourcing drugs is NOT allowed here! \n\nYOU WILL BE BANNED FOR ASKING OR PROVIDING DRUG OR PARAPHERNALIA SOURCES, whether illegal or legal. This includes: URLs, markets, PMs, etc. \n\nMake sure you follow","over18":false},"LifeProTips":{"lang":"en","description":"Tips that improve your life in one way or another.","over18":false},"rupaulsdragrace":{"lang":"en","description":"Do you have what it takes? Only those with Charisma, Uniqueness, Nerve and Talent will make it to the top! Start your engines...and may the best **woman** *win*! Dedicated to everyone's favorite drag ","over18":false},"CollegeBasketball":{"lang":"en","description":"A subreddit for college basketball news and discussion","over18":false},"MLPLounge":{"lang":"en","description":"/r/MLPLounge, also known as \"The Plounge\", is an off-topic discussion-based subreddit for /r/mylittlepony and other pony-related subreddits.\n\nOn the MLPLounge, fans of MLP:FIM can discuss anything SFW","over18":false},"jailbreak":{"lang":"en","description":"iOS jailbreaking: tweaks, news, and more for jailbroken iPhones, iPads, and iPod touches.\n\nInstalled anything great recently? Got an idea for a tweak? Wrote a cool tutorial? Curious about how somethin","over18":false},"SVExchange":{"lang":"en","description":"Exchange Shiny Values here, and hatch the shiny Pokémon of your dreams!","over18":false},"nottheonion":{"lang":"en","description":"For true stories that are so mind-blowingly ridiculous that you could have sworn they were from The Onion.","over18":false},"NintendoSwitch":{"lang":"en","description":"The central hub for news, updates, info, and discussion about the Nintendo Switch and Nintendo Switch games!","over18":false},"whowouldwin":{"lang":"en","description":"If you love to imagine the planet-exploding battles of the fictional gods who will never be, taking pointless knowledge gathered from a life spent reading and gaming and swinging it like a gladiator's","over18":false},"cringepics":{"lang":"en","description":"An offshoot of /r/cringe, for those images that depict an awkward or embarrassing situation.","over18":false},"skyrim":{"lang":"en","description":"","over18":false},"PoliticalDiscussion":{"lang":"en","description":"Discussion about politics. Talk amongst yourselves.  Politely and informatively.","over18":false},"Libertarian":{"lang":"en","description":"This subreddit is about the political philosophy of libertarianism, broadly speaking. We are in no way affiliated or associated with the Libertarian Party. /r/Libertarian is a community to discuss fre","over18":false},"BlackPeopleTwitter":{"lang":"en","description":"Black people being hilarious on social media","over18":false},"Rainbow6":{"lang":"en","description":"Welcome to the Rainbow 6 subreddit, a community for R6 fans to discuss Rainbow Six Siege and past favorites.","over18":false},"legaladvice":{"lang":"en","description":"A place to ask simple legal questions, and to have legal concepts explained.  ","over18":false},"exmormon":{"lang":"en","description":"A forum for ex-mormons and others who have been affected by mormonism to share news, commentary, and comedy about the Mormon church.","over18":false},"CringeAnarchy":{"lang":"en","description":"The official sub Reddit room for all organized alt right trolls attacking everything Amy Schumer does.","over18":false},"BigBrother":{"lang":"en","description":"Reddits source for discussion of your favorite houseguests","over18":false},"MLS":{"lang":"en","description":"This is the subreddit for any and all levels of soccer in the United States & Canada, with an emphasis on Major League Soccer.\n","over18":false},"Warframe":{"lang":"en","description":"Reddit community and official fansite for the free-to-play third-person co-op action shooter, *Warframe*. The game is currently in open beta on PC, PlayStation 4, and Xbox One.\n\nFor the new Reddit des","over18":false},"Jokes":{"lang":"en","description":"The funniest sub on reddit. Hundreds of jokes posted each day, and some of them aren't even reposts!","over18":false},"Fallout":{"lang":"en","description":"A state-of-the-art subreddit from Vault-Tec.","over18":false},"changemyview":{"lang":"en","description":"A place to post an opinion you accept may be flawed, in an effort to understand other perspectives on the issue. Enter with a mindset for conversation, not debate.","over18":false},"counting":{"lang":"en","description":"Welcome to the most productive place on reddit.\n\nQuickly find the latest comments here to see what needs to be counted next:\n\nhttps://old.reddit.com/r/counting/comments/","over18":false},"Planetside":{"lang":"en","description":"Subreddit for Planetside and Planetside 2, a MMOFPS by Daybreak Games Company","over18":false},"starcitizen":{"lang":"en","description":"This is the subreddit for everything related to Star Citizen - an up and coming epic space sim MMO being developed by Chris Roberts and Cloud Imperium Games.","over18":false},"Cricket":{"lang":"en","description":"News, banter and occasional serious discussion on the great game.","over18":false},"DnD":{"lang":"en","description":"A subreddit dedicated to the various iterations of Dungeons & Dragons, from its First Edition roots to its Fifth Edition future.","over18":false},"TrollXChromosomes":{"lang":"en","description":"### A subreddit for rage comics and other memes with a girly slant. ","over18":false},"food":{"lang":"en","description":"Cooking, restaurants, recipes, food network, foodies, talk about it here!","over18":false},"mylittlepony":{"lang":"en","description":"/r/mylittlepony is the premier subreddit for all things related to My Little Pony: Friendship is Magic. Here all fans can discuss the show, share creative works, or connect with fellow members of the ","over18":false},"dogecoin":{"lang":"en","description":"The most amazing place on reddit! \n\nA subreddit for sharing, discussing, hoarding and wow'ing about Dogecoins. The new innovative crypto-currency.","over18":false},"Gunners":{"lang":"en","description":"The internet's largest Arsenal community.","over18":false},"Pokemongiveaway":{"lang":"en","description":"Want a Pokemon but have nothing to offer? We can help. Want to be generous and give people Pokemon you weren't using anyway? Here is the place.","over18":false},"summonerschool":{"lang":"en","description":"Summoner School is a League of Legends subreddit dedicated to helping others learn/improve. We offer a variety of tools and events to assist in the learning process. Please read over our rules section","over18":false},"reddevils":{"lang":"en","description":"","over18":false},"Futurology":{"lang":"en","description":"Welcome to r/Futurology, a subreddit devoted to the field of Future(s) Studies and speculation about the development of humanity, technology, and civilization.\n","over18":false},"4chan":{"lang":"en","description":"","over18":false},"EliteDangerous":{"lang":"en","description":"The official unofficial subreddit for **Elite Dangerous**, we even have devs lurking the sub!\n\n**Elite Dangerous** is a space simulator game by Frontier Developments based in the year 3304. You contro","over18":false},"NoFap":{"lang":"en","description":"We host rebooting challenges in which participants (\"Fapstronauts\") abstain from pornography and masturbation for a period of time. Whether your goal is casual participation in a monthly challenge as ","over18":false},"Philippines":{"lang":"en","description":"A subreddit for the Philippines and all things Filipino!","over18":false},"BabyBumps":{"lang":"en","description":"A place for pregnant redditors, those who have been pregnant, those who wish to be in the future, and anyone who supports them.","over18":false},"sysadmin":{"lang":"en","description":"A reddit dedicated to the profession of Computer System Administration.","over18":false},"thedivision":{"lang":"en","description":"The home to discussing Tom Clancy's The Division; an online RPG from Ubisoft and Massive Entertainment.","over18":false},"MensRights":{"lang":"en","description":"The Men's Rights subreddit is a place for those who wish to discuss men's rights and the ways said rights are infringed upon. As a result, we have been earning scorn from bigoted feminists and white k","over18":false},"loseit":{"lang":"en","description":"A place for people of all sizes to discuss healthy and sustainable methods of weight loss. Whether you need to lose 2 lbs or 200 lbs, you are welcome here!","over18":false},"summonerswar":{"lang":"en","description":"Subreddit for mobile game Summoners War: Sky Arena. Discuss the latest gameplay, news and events with fellow summoners around the globe.","over18":false},"pcgaming":{"lang":"en","description":"A subreddit for discussion of everything PC gaming related!\n\n\n","over18":false},"LiverpoolFC":{"lang":"en","description":"A subreddit for news and discussion of Liverpool FC, a football club playing in the English Premier League. Liverpool are one of the most decorated football clubs in all of world football.","over18":false},"comicbooks":{"lang":"en","description":"A reddit for fans of comic books, graphic novels, and digital comics. ","over18":false},"RoastMe":{"lang":"en","description":"Roasting (v.) - To humorously mock or humiliate someone with a well-timed joke, diss or comeback. (As defined by urbandictionary)\n\nHone your roasting skills, meet other roasters, and get yourself roas","over18":false},"halo":{"lang":"en","description":"Reddit's home for all things Halo","over18":false},"darksouls3":{"lang":"en","description":"A community dedicated to everything about Dark Souls 3.","over18":false},"france":{"lang":"fr","description":"La France et les Français. ","over18":false},"DBZDokkanBattle":{"lang":"en","description":"Everything Dragon Ball Z: Dokkan Battle! This subreddit is for both the Japanese and Global version. Information, guides, tips, news, fan art, questions and everything else Dokkan Battle related.\n","over18":false},"de":{"lang":"de","description":"Das Sammelbecken für alle Deutschsprachler, hauptsächlich auf Deutsch, manchmal auch auf Englisch. Deutschland, Österreich, Schweiz, Liechtenstein, Luxemburg und den einen Belgier.","over18":false},"oculus":{"lang":"en","description":"**The Oculus subreddit, a place for Oculus fans to discuss VR.**","over18":false},"dayz":{"lang":"en","description":"/r/dayz is for the purpose of discussing the DayZ standalone game as well as the mod for Arma 2.  ","over18":false},"bodybuilding":{"lang":"en","description":"News, articles, personal pictures, videos & advice on everything related to bodybuilding - nutrition, supplementation, training, contest preparation, and more.  ","over18":false},"techsupport":{"lang":"en","description":"Stumped on a Tech problem?  Ask the tech support reddit, and try to help others with their problems as well.\n\n\nBe sure to check out the live chat, too!","over18":false},"childfree":{"lang":"en","description":"Discussion and links of interest to childfree individuals. \"Childfree\" refers to those who do not have and do not ever want children (whether biological, adopted, or otherwise).","over18":false},"Guitar":{"lang":"en","description":"r/Guitar - a place where guitarists, new and experienced, can discuss the craft and share information about techniques and other aspects of the world of guitar.   \n  \n","over18":false},"boardgames":{"lang":"en","description":"The #1 reddit source for news, information, and discussion about modern board games and board game culture.  \n\nJoin our community! Come discuss games like Codenames, Eldritch Horror, Terra Mystica, an","over18":false},"OldSchoolCool":{"lang":"en","description":"/r/OldSchoolCool\n\n**History's cool kids, looking fantastic!**\n\nA pictorial and video celebration of history's coolest kids, everything from beatniks to bikers, mods to rude boys, hippies to ravers. An","over18":false},"streetwear":{"lang":"en","description":"Reddit's official streetwear community. ","over18":false},"MechanicalKeyboards":{"lang":"en","description":"Keyboard lovers Clicking and Clacking in a content rich, friendly place. The goal of this subreddit is to provide daily links to interesting mechanical keyboard content.\n","over18":false},"Diablo":{"lang":"en","description":"/r/Diablo is the greatest source for Diablo-related news and discussion on the Internet. Stay awhile and listen.","over18":false},"relationship_advice":{"lang":"en","description":"Need help with your relationship? Whether it's romance, friendship, family, co-workers, or basic human interaction: we're here to help!","over18":false},"Sneakers":{"lang":"en","description":"A subreddit for sneaker lovers. ","over18":false},"RocketLeague":{"lang":"en","description":"Rocket League: The Game - everything related to Rocket League!","over18":false},"askscience":{"lang":"en","description":"Ask a science question, get a science answer.","over18":false},"sports":{"lang":"en","description":"The central hub for all things sports on reddit.","over18":false},"sweden":{"lang":"sv","description":"All the Swedish things.\n\nKeywords: Sweden, Schweden, Sverige, Sweddit, Swenglish","over18":false},"toronto":{"lang":"en","description":"News, People, Places, Events, Articles, and Discussions on Toronto; the largest city in Canada, and the provincial capital of Ontario.","over18":false},"yugioh":{"lang":"en","description":"The subreddit for players of the Yu-Gi-Oh! card game, video games, or fans of the Yu-Gi-Oh! anime series or manga. Discuss tactics, episodes, decks, or whatever you'd like.","over18":false},"photography":{"lang":"en","description":"/r/photography is a place to discuss the tools, technique and culture of photography.\n\nThis is not a good place to simply share cool photos or promote your work, but rather a place to discuss photogra","over18":false},"fatlogic":{"lang":"en","description":" Find out what keeps you fat and then do something about it. Sick of being fat? Shed your fatlogic here. ","over18":false},"NASCAR":{"lang":"en","description":"A subreddit for everything NASCAR related!","over18":false},"bravefrontier":{"lang":"en","description":"**Welcome to /r/bravefrontier!**\n\nJoin the ever growing Brave Frontier Community! Meet fellow summoners and enjoy your time discussing anything and everything about the game.\n\nVenture forth into Grand","over18":false},"cringe":{"lang":"en","description":"","over18":false},"thewalkingdead":{"lang":"en","description":"Subreddit for all things The Walking Dead. ","over18":false},"casualiama":{"lang":"en","description":"The casual version of /r/IAmA. Anyone's welcome to host or participate in an AMA. Topics may involve anything from ordinary to extraordinary subject matter. The environment is relaxed, we just ask tha","over18":false},"FFBraveExvius":{"lang":"en","description":"Final Fantasy Brave Exvius is a free-to-play role-playing game developed by Alim and published by Square Enix for iOS and Android devices. ","over18":false},"FireEmblemHeroes":{"lang":"en","description":"A subreddit dedicated to *Fire Emblem Heroes*, Nintendo's 3rd mobile title released on February 2nd, 2017. The game is available worldwide on [iOS](https://itunes.apple.com/us/app/fire-emblem-heroes/i","over18":false},"fivenightsatfreddys":{"lang":"en","description":"The official subreddit for Scott Cawthon's horror game series, Five Nights at Freddy's.\n\nSwitch to old Reddit: http://www.old.reddit.com/r/fivenightsatfreddys","over18":false},"bicycling":{"lang":"en","description":"Two wheels, powered by a person.\n\n\nInterested in riding a bicycle? We welcome bicyclists of all skill levels including those who don't yet own a bike. Ask us your questions or meetup with other reddit","over18":false},"Frugal":{"lang":"en","description":"Frugality is the mental approach we each take when considering our resource allocations. It includes time, money, convenience, and many other factors.","over18":false},"hardwareswap":{"lang":"en","description":"* Do you want to trade in your old video card for a new hard drive?\nWelcome to r/Hardwareswap, a community and marketplace for buying, selling, and trading all sorts of PC Hardware.","over18":false},"DIY":{"lang":"en","description":"All things related to doing, building, fixing things on your own.   **Do it yourself!** ","over18":false},"TheSilphRoad":{"lang":"en","description":"Grassroots network of Pokémon GO™ trainers. The Silph Road enables coordinating long-distance trades for exotic Pokémon. Follow for launch details soon!","over18":false},"fireemblem":{"lang":"en","description":"A subreddit to discuss the Fire Emblem series of games, and associated media.\n\nFire Emblem is a fantasy tactical role-playing video game franchise developed by Intelligent Systems and published by Nin","over18":false},"marvelstudios":{"lang":"en","description":"/r/MarvelStudios is a subreddit dedicated to Marvel Studios and the Marvel Cinematic Universe as a whole!\n\n___\n\nWhether it be a sentient tree in space or a blind vigilante in New York, discuss everyth","over18":false},"RWBY":{"lang":"en","description":"RWBY: Pronounced Ruby","over18":false},"argentina":{"lang":"es","description":"Todo lo que tenga que ver con Argentina - English Speakers Welcomed","over18":false},"ireland":{"lang":"en","description":"","over18":false},"newzealand":{"lang":"en","description":"The place for anything and everything New Zealand related.","over18":false},"DebateReligion":{"lang":"en","description":"A place to discuss and debate religion.","over18":false},"stevenuniverse":{"lang":"en","description":"The number 1 subreddit for Steven Universe. Come and obsess over gay space rocks with us.","over18":false},"nrl":{"lang":"en","description":"National Rugby League - All various things Rugby League! Weekly Round discussions with streams to NRL games.","over18":false},"survivor":{"lang":"en","description":"Information and discussion about the greatest show in television history: Survivor!","over18":false},"fo4":{"lang":"en","description":"The Fallout 4 Subreddit. Talk about quests, gameplay mechanics, perks, story, characters, and more.","over18":false},"interestingasfuck":{"lang":"en","description":"For almost anything you find interesting.","over18":false},"linux":{"lang":"en","description":"All things Linux and GNU/Linux -- this is neither a community exclusively about the kernel Linux, nor is exclusively about the GNU operating system.","over18":false},"OnePiece":{"lang":"en","description":"Welcome to r/OnePiece, the community for Eiichiro Oda's manga and anime series One Piece. From the East Blue to the New World, anything related to the world of One Piece belongs here! If you've just s","over18":false},"Warthunder":{"lang":"en","description":"This is a subreddit for War Thunder, a cross platform vehicular combat MMO developed by Gaijin Entertainment for Microsoft Windows, macOS, Linux, PlayStation 4, Xbox One, and Shield Android TV. The ga","over18":false},"DarkSouls2":{"lang":"en","description":"A community dedicated to everything about Dark Souls 2. ","over18":false},"NoMansSkyTheGame":{"lang":"en","description":"The unofficial subreddit for the discussion of No Man's Sky, a fantasy science-fiction game set in an infinite, procedurally-generated universe.","over18":false},"masseffect":{"lang":"en","description":"This subreddit is for people who love the Mass Effect universe - the games, books, comics, and DLC. ","over18":false},"space":{"lang":"en","description":"Share & discuss informative content on:\n\n* Astrophysics\n* Cosmology\n* Space Exploration\n* Planetary Science\n* Astrobiology","over18":false},"opiates":{"lang":"en","description":"Discussion of all things related to the narcotics known as opiates, from harm-reduction to pharmacology.","over18":false},"NoStupidQuestions":{"lang":"en","description":"Ask away!","over18":false},"MaddenUltimateTeam":{"lang":"en","description":"An informational subreddit about the game mode Madden Ultimate Team","over18":false},"ClashRoyale":{"lang":"en","description":"Subreddit for all things Clash Royale, the free mobile strategy game from Supercell.\n","over18":false},"amiugly":{"lang":"en","description":"Post your picture here and have fellow Redditors tell you what they think about your appearance!","over18":false},"bestof":{"lang":"en","description":"The very best comments on reddit.","over18":false},"me_irl":{"lang":"en","description":"selfies of the soul","over18":false},"opieandanthony":{"lang":"en","description":"","over18":false},"TheRedPill":{"lang":"en","description":"The Red Pill: Discussion of sexual strategy in a culture increasingly lacking a positive identity for men.","over18":false},"Portland":{"lang":"en","description":"/r/Portland is the regional subreddit for Portland, Oregon.","over18":false},"amiibo":{"lang":"en","description":"","over18":false},"nintendo":{"lang":"en","description":"A subreddit for talking about Nintendo news and games. Discussion questions, news, review/previews, opinion pieces, and informative videos about games, new and old, are welcome!\n\nOur sister-subreddit,","over18":false},"ImGoingToHellForThis":{"lang":"en","description":"Looking for a Japanese twink getting railed by two hunky latino men in a hot tub? Trying to figure out the name of the man getting rimmed in a photo you saved four years ago? Need proof that triple pe","over18":true},"tipofmytongue":{"lang":"en","description":"Can't remember the name of that movie you saw when you were a kid? Or the name of that video game you had for Game Gear? This is the place to get help.","over18":false},"ACTrade":{"lang":"en","description":"Need an item? Looking to make some bells? You've come to the right place!","over18":false},"dataisbeautiful":{"lang":"en","description":"A place for visual representations of data: Graphs, charts, maps, etc.\n\nDataIsBeautiful is for visualizations that effectively convey information. **Aesthetics are an important part of information vis","over18":false},"GrandTheftAutoV":{"lang":"en","description":"/r/GrandTheftAutoV - the subreddit for all GTA V related news, content, and discussions revolving around Rockstar's critically acclaimed single player release and the ongoing multiplayer expansion of ","over18":false},"elderscrollsonline":{"lang":"en","description":"A Reddit community dedicated to The Elder Scrolls Online, an MMO developed by Zenimax Online.","over18":false},"reactiongifs":{"lang":"en","description":"Give a man a gif and he will meme all day, teach a man to REACT and he will be as a GOD","over18":false},"KerbalSpaceProgram":{"lang":"en","description":"The Kerbal Space Program subreddit. For all your gaming related, space exploration needs.\n\nhttp://kerbalspaceprogram.com","over18":false},"Vive":{"lang":"en","description":"Discussing Virtual Reality Experiences and VR technology.  \n","over18":false},"forhonor":{"lang":"en","description":"The Home of For Honor on Reddit!\n\nFor Honor is a Third-Person Fighting Game, developed and published by Ubisoft for Windows PC, PlayStation 4 and Xbox One.","over18":false},"circlejerk":{"lang":"en","description":"Message the mods if you'd like to be banned.","over18":false},"darksouls":{"lang":"en","description":"A community dedicated to Dark Souls I, game released for PC, PlayStation 3 and 4, Xbox 360 and One.\n","over18":false},"NHLHUT":{"lang":"en","description":"Subreddit for the Hockey Ultimate Team game mode of EA NHL.","over18":false},"raisedbynarcissists":{"lang":"en","description":"This is a support group for people raised by (or being raised by) a narcissistic parent.  Please share your stories, your questions, your histories, your fears and your triumphs. Significant others an","over18":false},"Patriots":{"lang":"en","description":"Reddit home of the **5x** Super Bowl Champion New England Patriots of the National Football League.","over18":false},"newsokur":{"lang":"ja","description":"ニュース速報R(Reddit)は、様々なニュースや話題を取り扱う掲示板（Subreddit）です。  \nNewsokur is a subreddit for Japanese news and topics.","over18":false},"woahdude":{"lang":"en","description":"The best links to click while you're stoned!\n\nPsychedelic, mindfucking, mesmerizing, reality-distorting or trippy games, video, audio & images that make a sober person feel stoned, or stoned person tr","over18":false},"civ":{"lang":"en","description":"A place to discuss the greatest computer game franchise in history.\n\n","over18":false},"running":{"lang":"en","description":"Runners welcome.\n","over18":false},"vegan":{"lang":"en","description":"This is a place for people who are vegans or interested in veganism to share links, ideas, or recipes.  \n\n\"Veganism is a way of living that seeks to exclude, as far as possible and practicable, all fo","over18":false},"WritingPrompts":{"lang":"en","description":"Writing Prompts. You're a writer and you just want to flex those muscles? You've come to the right place! If you see a prompt you like, simply write a short story based on it. Get comments from others","over18":false},"askgaybros":{"lang":"en","description":"This is where you can ask the manly men for their opinions on various topics. Advice. AskReddit style questions. AMA. ELI5. Everything in between.","over18":false},"trashy":{"lang":"en","description":"Trashy stories, trashy glamour, all things fake, plastic, and downright trashy, low-class, no-class, white trash, bimbos, and damn proud.","over18":false},"PUBATTLEGROUNDS":{"lang":"en","description":"The largest community for PLAYERUNKNOWN'S BATTLEGROUNDS. A central place for discussion, media, news and more.","over18":false},"Amd":{"lang":"en","description":"A subreddit dedicated to Advanced Micro Devices and their products. This includes:\n\nCPUs - AMD Ryzen, ThreadRipper, Epyc and of course the FX & Athlon lines as well. \n\nGPUs - Radeon Technology Group, ","over18":false},"Steam":{"lang":"en","description":"A subreddit for members of the Steam Community.","over18":false},"Homebrewing":{"lang":"en","description":"Welcome brewers, mazers, vintners, and cider makers!","over18":false},"WorldofTanks":{"lang":"en","description":"World of Tanks is a PvP MMO game created by international game developer Wargaming. We're Redditors with a passion for gaming, tanks, and everything in between! This is a subreddit where we share WoT ","over18":false},"GameDeals":{"lang":"en","description":"A community for sharing and discussing game deals.  Never pay full price again.","over18":false},"asktransgender":{"lang":"en","description":"Transgender questions, transgender answers.","over18":false},"Economics":{"lang":"en","description":"News and discussion about economics, from the perspective of economists. ","over18":false},"creepy":{"lang":"en","description":"","over18":false},"facepalm":{"lang":"en","description":"A subreddit for you to share the stupidity of people online and IRL. Post screenshots from forums, social media sites, or just real life.\n\n***PLEASE*** read all of the sidebar before posting, thanks!","over18":false},"stopdrinking":{"lang":"en","description":"This subreddit is a place to motivate each other to control or stop drinking. We welcome anyone who wishes to join in by asking for advice, sharing our experiences and stories, or just encouraging som","over18":false},"Justrolledintotheshop":{"lang":"en","description":"For those absolutely stupid things that you see people bring, roll, or toss into your place of business and the people that bring them in.","over18":false},"SteamGameSwap":{"lang":"en","description":"This is a subreddit for Steam users that are looking to trade their games. \n\nWant to trade physical games? Try /r/gameswap.\n\nWant to trade gift-cards for money? Try /r/giftcardexchange.\n\nWant to trade","over18":false},"bjj":{"lang":"en","description":"","over18":false},"AFL":{"lang":"en","description":"AFL: The home of Australian football on reddit, including the Australian Football League, and all other aspects of the game.","over18":false},"brasil":{"lang":"pt","description":"A casa dos brasileiros no Reddit. Leia as regras e participe de nossa comunidade!\n\nThe Brazilian community on Reddit. Feel free to post in English or Portuguese!","over18":false},"dankmemes":{"lang":"en","description":"Stefán Karl Stefánsson has passed away.\n\nSadly, Stefán Karl Stefánsson has passed away after fighting a long battle against cancer. Stefan, we want to thank you for all the amusement you gave us.\n\nWe ","over18":false},"CODZombies":{"lang":"en","description":"/r/CODZombies is the developer-supported, community-run subreddit for the Call of Duty Zombies community.\n\nCall of Duty Zombies is a first-person shooter co-op mode developed by Treyarch, Infinity War","over18":false},"iphone":{"lang":"en","description":"reddit's little corner for iPhone lovers (and some people who just mildy enjoy it...)","over18":false},"Conservative":{"lang":"en","description":"The place for Conservatives on Reddit.","over18":false},"nosleep":{"lang":"en","description":"NoSleep is a place for realistic horror stories.\n\nEverything is true here, even if it's not. \n    \n\nPlease thoroughly read our rules and guidelines before posting or commenting.","over18":false},"depression":{"lang":"en","description":"Peer support for anyone struggling with depression, the mental illness.","over18":false},"AskOuija":{"lang":"en","description":"AskReddit, Ouija-style.","over18":false},"dbz":{"lang":"en","description":"Welcome to Reddit's largest Dragon Ball community!","over18":false},"MapPorn":{"lang":"en","description":"High quality images of maps.\n","over18":false},"Austin":{"lang":"en","description":"The subreddit for all things Austin.","over18":false},"swtor":{"lang":"en","description":"Star Wars™: The Old Republic, a story-driven MMORPG from BioWare and LucasArts.\n\nYou will never find a more wretched hive of scum and villainy than here.","over18":false},"doctorwho":{"lang":"en","description":"Reddit's Doctor Who Fan Community - News, Discussion, Artwork and Fan Creations!","over18":false},"syriancivilwar":{"lang":"en","description":"This subreddit is dedicated to news, analysis and discussion on the conflict in Syria along with the regional and global ramifications.","over18":false},"vancouver":{"lang":"en","description":"There's a Starbucks on every corner.","over18":false},"talesfromtechsupport":{"lang":"en","description":"Welcome to **Tales From Tech Support**, where we share our stories of:  \n\n* *Incredible Feats* of Networking Heroics;  \n\n* *Tech Troubleshooting* Under the Direst Circumstances;  \n\n* *Unsolvable Probl","over18":false},"3DS":{"lang":"en","description":"The place to discuss all stuff related to the Nintendo 3DS™ family!","over18":false},"PurplePillDebate":{"lang":"en","description":"PurplePillDebate is a neutral community to discuss sex and gender issues, specifically those pertaining to /r/TheBluePill and /r/TheRedPill.","over18":false},"csgobetting":{"lang":"en","description":"Welcome to /r/csgobetting, the home of match betting information on reddit :D Read the rules, interact with the community, and enjoy your stay!","over18":false},"Naruto":{"lang":"en","description":"Everything related to Naruto goes here. Although you could post about the ramen ingredient too... I doubt anyone would have a problem with that either...","over18":false},"ethtrader":{"lang":"en","description":"Welcome to /r/EthTrader, a 100% community driven sub. Here you can discuss Ethereum news, memes, investing, trading, miscellaneous market-related subjects and other relevant technology. \n\nTags: ETH, B","over18":false},"Documentaries":{"lang":"en","description":"tl;dw","over18":false},"chicago":{"lang":"en","description":"","over18":false},"britishproblems":{"lang":"en","description":"Tea went cold.","over18":false},"MonsterHunter":{"lang":"en","description":"A subreddit dedicated to the Monster Hunter series of video games, including things like merchandise, fan art, organizing hunts, and helping players.","over18":false},"harrypotter":{"lang":"en","description":"Welcome to r/HarryPotter, the place where fans from around the world can meet and discuss everything in the Harry Potter universe! Be sorted, earn house points, take classes with our fine Hogwarts sta","over18":false},"FFRecordKeeper":{"lang":"en","description":"The ultimate reddit community for all things Final Fantasy Record Keeper. A game developed by Square Enix and published by DeNA.","over18":false},"StarWarsBattlefront":{"lang":"en","description":"The subreddit for all things *Star Wars: Battlefront*!  News and community for the both the modern games developed by EA, as well as the older entries in the franchise, developed by Pandemic Studios a","over18":false},"Tinder":{"lang":"en","description":"A community for discussing the online dating app Tinder. Sharing conversations, reviewing profiles and more.","over18":false},"DarkNetMarkets":{"lang":null,"description":"Subreddit no longer exists","over18":null},"golf":{"lang":"en","description":"","over18":false},"Seattle":{"lang":"en","description":"News, current events in & around Seattle, Washington, USA.","over18":false},"cigars":{"lang":"en","description":"A virtual lounge for all of your cigar needs. Come in, pick out a smoke, and sit down and enjoy the conversation of other enthusiasts as we discuss our favorite smokes and pairings, news and latest re","over18":false},"Dodgers":{"lang":"en","description":"Reddit community for fans of the Los Angeles Dodgers.","over18":false},"Parenting":{"lang":"en","description":"/r/Parenting is the place to discuss the ins and out as well as ups and downs of child-rearing. From the early stages of pregnancy to when your teenagers are finally ready to leave the nest (even if t","over18":false},"rugbyunion":{"lang":"en","description":"A subreddit for all Rugby Union related news, analysis and opinions.  Spark some banter, lose some beer money.  Forwards and Backs, come hither to discuss everything going down in the world of Rugby!","over18":false},"polandball":{"lang":"en","description":"Wiggly mouse-drawn comics where balls represent different countries. They poke fun at national stereotypes and the \"international drama\" of their diplomatic relations. Polandball combines history, geo","over18":false},"EnoughTrumpSpam":{"lang":"en","description":"Because the amount of Trump spam is *too damn high!* Enough Трамп Spam","over18":false},"gamegrumps":{"lang":"en","description":"For anything about the YouTube gaming channel Game Grumps.\n\n[Game Grumps Youtube Channel](http://www.youtube.com/user/GameGrumps)\n\n","over18":false},"CoDCompetitive":{"lang":"en","description":"A place to discuss the competitive aspects of the Call of Duty franchise.","over18":false},"melbourne":{"lang":"en","description":"A subreddit for Melburnians and Melbourne enthusiasts!","over18":false},"podemos":{"lang":"es","description":"En un momento de enorme dificultad y empobrecimiento para la inmensa mayoría de las personas, Podemos nace para convertir la indignación en cambio político, y para construir democracia a través de la ","over18":false},"churning":{"lang":"en","description":"A place to discuss the nitty-gritty of \"churning\" credit cards to profit from sign-up offers.  Share your success stories, your horror stories, new offers, and any good tips and tricks you come across","over18":false},"PuzzleAndDragons":{"lang":"en","description":"Subreddit for the popular mobile game \"Puzzle & Dragons\". Discuss tips and strategies, share your clears and achievements, ask questions and make friends with other players around the globe. Don't for","over18":false},"startrek":{"lang":"en","description":"Star Trek news and discussion. No slash fic.\n\n\n...Maybe a little slash fic.","over18":false},"totalwar":{"lang":"en","description":"A subreddit for the Total War strategy game series, made by Creative Assembly.\n\nDiscussions, strategies, stories, screenshots, and more for Medieval 2, Empire, Shogun 2, Rome 2, Attila, Warhammer, Thr","over18":false},"CampHalfBloodRP":{"lang":"en","description":"A subreddit for roleplaying at Camp Half-Blood! ","over18":false},"PercyJacksonRP":{"lang":"en","description":"The Original Percy Jackson Roleplaying subreddit! Roleplay as your favourite Roman or Greek Demigod at Camp Half Blood! Interact with fellow original characters, go on quests, and experience life in a","over18":false},"EarthPorn":{"lang":"en","description":"EarthPorn is your community of landscape photographers and those who appreciate the natural beauty of our home planet.\n","over18":false},"TrueReddit":{"lang":"en","description":"A subreddit for [really great, insightful](http://web.archive.org/web/20110101052009/http://www.kk.org/cooltools/the-best-magazi.php) articles, [reddiquette](http://www.reddit.com/help/reddiquette), r","over18":false},"weddingplanning":{"lang":"en","description":"A helpful place for anyone getting married! Get ideas on etiquette, invitations, themes, styles, or anything wedding-related. We welcome posts that are directly related to your wedding planning.","over18":false},"italy":{"lang":"it","description":"Reddit Italy - Italia - Sentirsi a casa\n\nWelcome everyone! This is a place to post and discuss anything related to Italy. We also speak English!","over18":false},"manga":{"lang":"en","description":"Everything and anything manga!  (manwha is okay too!)\n\nDiscuss weekly chapters, find/recommend a new series to read, post a picture of your collection, lurk, etc!","over18":false},"battlefield_4":{"lang":"en","description":"The Official Battlefield 4 Subreddit.","over18":false},"roosterteeth":{"lang":"en","description":"A subreddit for content regarding Rooster Teeth Productions, including Red vs. Blue, Achievement Hunter, RWBY, Rooster Teeth Podcast, etc.","over18":false},"buildapcsales":{"lang":"en","description":"A community for links to products that are on sale at various websites. Monitors, cables, processors, video cards, fans, cooling, cases, accessories, anything for a PC build.","over18":false},"eu4":{"lang":"en","description":"A place to share content, ask questions and/or talk about the grand strategy game Europa Universalis IV by Paradox Development Studio.","over18":false},"Cardinals":{"lang":"en","description":"Saint Louis Cardinals Baseball!","over18":false},"EDH":{"lang":"en","description":"Reddit's #1 source for EDH and Commander content.","over18":false},"femalefashionadvice":{"lang":"en","description":"","over18":false},"travel":{"lang":"en","description":"r/travel is a community about exploring the world. Your pictures, questions, stories, or any good content is welcome. \n\nClickbait, spam, memes, ads, brochures, classifieds, surveys or self-promotion w","over18":false},"ClashOfClans":{"lang":"en","description":"Welcome to the subreddit dedicated to the smartphone game Clash of Clans! ","over18":false},"gaybros":{"lang":"en","description":"Gaybros is a network built for gay men. We come together around shared interests like sports, technology, and media. Our subscribers have hosted social meet-ups all around the world.","over18":false},"playrust":{"lang":"en","description":"The largest community for the game RUST. A central place for discussion, media, news and more.","over18":false},"Cooking":{"lang":"en","description":"/r/Cooking is a place for the cooks of reddit and those who want to learn how to cook. Post anything related to cooking here, within reason.","over18":false},"kpop":{"lang":"en","description":"K-Pop (Korean popular music) is a musical genre consisting of pop, dance, electropop, hiphop, rock, R&B, and electronic music originating in South Korea. In addition to music, K-Pop has grown into a p","over18":false},"Kappa":{"lang":"en","description":"/r/Kappa **\"eSports is not a part of the FGC\"**\n","over18":false},"airsoft":{"lang":"en","description":"For all things airsoft.\n","over18":false},"Metal":{"lang":"en","description":"Shreddit: Heavy Metal ","over18":false},"CFBOffTopic":{"lang":"en","description":"At this moment this subreddit is for sporting events not related to CFB. As time progresses it may expand and become a free talk subreddit for the CFB community. Any suggestions are welcomed and appre","over18":false},"offmychest":{"lang":"en","description":"A mutually supportive community where deeply emotional things you can't tell people you know can be told. \n\nWhether it's long-standing baggage, happy thoughts, or recent trauma, posting it here may pr","over18":false},"SkincareAddiction":{"lang":"en","description":"","over18":false},"gadgets":{"lang":"en","description":"Discussion and news regarding everything from vintage gadgetry to the latest and greatest in gadgets.\n\nKeywords: technology, gadgets, tech, news, products","over18":false},"houston":{"lang":"en","description":"","over18":false},"JUSTNOMIL":{"lang":"en","description":"If you have a MIL that is lovely and not any of the things we talk about here, that's great. Let us rant away at the crazy shit they do. If it's your mom that's the issue, you can rant about that too.","over18":false},"DoesAnybodyElse":{"lang":"en","description":"","over18":false},"TheLastAirbender":{"lang":"en","description":"This is the subreddit for fans of Avatar: The Last Airbender & The Legend of Korra. There is no movie","over18":false},"battlefield_one":{"lang":"en","description":"The Battlefield 1 subreddit.  Battlefield 1 is developed by DICE and produced by EA.\n\nYour place for discussion, help, news, reviews, questions, screenshots, videos, gifs, and anything else BF1 relate","over18":false},"Anarcho_Capitalism":{"lang":"en","description":"Welcome to /r/Anarcho_Capitalism, a place to discuss free market capitalist anarchism and related topics, and share things that would be of interest to Anarcho-Capitalists.","over18":false},"dogs":{"lang":"en","description":"/r/dogs is a discussion-based subreddit, meant for asking questions, sharing information, and learning about our beloved canine companions and related dog-centric topics.","over18":false},"rpg":{"lang":"en","description":"/r/rpg is for meaningful discussions, questions, and help for tabletop/pen & paper RPGs and LARPing.","over18":false},"Fantasy":{"lang":"en","description":"/r/Fantasy is a subreddit dedicated to news, discussion, AMAs, charities, and interaction related to the greater Speculative Fiction genre. ","over18":false},"cats":{"lang":"en","description":"Pictures, videos, articles and questions featuring and about cats.","over18":false},"vinyl":{"lang":"en","description":"","over18":false},"DCcomics":{"lang":"en","description":"**The unofficial DC Comics subreddit**\n\nA place for fans of DC's comics, graphic novels, movies, and anything else related to one of the largest comic book publishers in the world and home of the Worl","over18":false},"funkopop":{"lang":"en","description":"We're the largest Funko Community on reddit. Keep up to date with the newest releases or just browse other reader's hauls and collections.","over18":false},"Competitiveoverwatch":{"lang":"en","description":"A place for in-depth discussions of Competitive Overwatch™ (the team-based shooter from Blizzard Entertainment). Find detailed discussion of meta, esports and events as well as guides, advice, and tip","over18":false},"investing":{"lang":"en","description":"","over18":false},"eagles":{"lang":"en","description":"A subreddit devoted to discussion and fandom of The Philadelphia Eagles","over18":false},"photoshopbattles":{"lang":"en","description":"Photoshop contests on reddit. A place to battle using image manipulation software, play photoshop tennis, create new images from old photos, or even win reddit gold.","over18":false},"blackdesertonline":{"lang":"en","description":"The Subreddit for the MMORPG Black Desert Online. \n","over18":false},"FantasyPL":{"lang":"en","description":"A place where people can discuss Premier League Fantasy Football Teams, Trades, News, or anything else that might be helpful for fantasy managers. \n","over18":false},"fantasybaseball":{"lang":"en","description":"If you're looking for advice or want to talk about your team/league use the stickied threads. Post a text thread to share information, data, or analysis on a general fantasy baseball topic\n\nValue is r","over18":false},"JusticePorn":{"lang":"en","description":"Where Justice is Made","over18":false},"bindingofisaac":{"lang":"en","description":"The official subreddit for Edmund McMillen's Zelda-inspired roguelike, The Binding of Isaac!","over18":false},"thatHappened":{"lang":"en","description":"Only the truest stories ever told on the information superhighway.","over18":false},"blackops3":{"lang":"en","description":"Call of Duty: Black Ops III is a military science fiction first-person shooter video game, developed by Treyarch and published by Activision. It is the twelfth entry in the Call of Duty series and the","over18":false},"titanfall":{"lang":"en","description":"Subreddit for Respawn's Titanfall","over18":false},"LosAngeles":{"lang":"en","description":"The official subreddit of Los Angeles, California! The international epicenter of movie stars, world-champion sport teams, television studios, music, Mexican food, beaches, mountains, traffic jams, mu","over18":false},"btc":{"lang":"en","description":"Welcome to /r/btc! Home of: Up to date Bitcoin discussions, News and Exclusive AMA (Ask Me Anything) interviews from top Bitcoin industry leaders, and more!\n\nBitcoin is the *currency of the Internet*.","over18":false},"longboarding":{"lang":"en","description":"longboarding","over18":false},"fatpeoplehate":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Watches":{"lang":"en","description":"A subreddit for discussion of wrist watches and pocket watches.","over18":false},"mildlyinfuriating":{"lang":"en","description":"A place to post the most midly infuriating things!\n\n&nbsp;\n\n.\n\norder corn","over18":false},"Romania":{"lang":"en","description":"Romania, a country famous for its beautiful landscapes, rich history and awesome people. This is our little Romanian corner of Reddit!","over18":false},"Marvel":{"lang":"en","description":"This is a subreddit dedicated to Marvel Comics, its publications and hundreds of characters. It is not affiliated with Marvel Entertainment, LLC and is an unofficial community operated by dedicated fa","over18":false},"learnprogramming":{"lang":"en","description":"A subreddit for all questions related to programming in any language.","over18":false},"singapore":{"lang":"en","description":"Welcome to /r/singapore the reddit home of the country Singapore. The Republic of Singapore, is a Southeast Asian city-state off the southern tip of the Malay Peninsula, 137 kilometres (85 mi) north o","over18":false},"h1z1":{"lang":"en","description":"Subreddit for the game H1Z1 by Daybreak Game Company","over18":false},"AsianBeauty":{"lang":"en","description":"A place to discuss beauty brands, cosmetics, and skincare from Asia.","over18":false},"witcher":{"lang":"en","description":"All things related to The Witcher - books, games, TV... You name it.","over18":false},"windowsphone":{"lang":"en","description":"This little reddit hub is dedicated to Windows phone stuff + everything else related to it.","over18":false},"gonewildcurvy":{"lang":"en","description":"A secure community where female redditors can share their nude or partially nude bodies. ","over18":true},"TwoBestFriendsPlay":{"lang":"en","description":"A place where fans of the playthroughs that Matt, Pat and Woolie provide come to talk about the hilarity that ensues. And for people who just want to keep up on the Best Friends' videos.","over18":false},"self":{"lang":"en","description":"a place to put self-posts for discussion, questions or anything else you like.","over18":false},"Torontobluejays":{"lang":"en","description":"Home to Canada's team, the Toronto Blue Jays. The most recent Canadian team to win a major sports championship.\n\n༼ つ ◕_◕ ༽つ BLUE JAYS TAKE MY ENERGY ༼ つ ◕_◕ ༽つ","over18":false},"metalgearsolid":{"lang":"en","description":"\"This is our home... Diamond Dogs.\"  \nThe home for everything Metal Gear Solid on Reddit!","over18":false},"Ice_Poseidon":{"lang":"en","description":"Ice Poseidon AKA Paul Denino is a live streamer on YouTube who does Live Vlogs.","over18":false},"Entrepreneur":{"lang":"en","description":"A community of individuals who seek to solve problems, network professionally, collaborate on projects and make the world a better place. Be professional, humble, and open to new ideas. ","over18":false},"nyc":{"lang":"en","description":"r/nyc, the subreddit about new york city","over18":false},"Seahawks":{"lang":"en","description":"A community for fans of the Seattle Seahawks. Go Hawks!","over18":false},"writing":{"lang":"en","description":"Reddit's home for writers. We talk about important matters for writers, news affecting writers, and the finer aspects of writing.","over18":false},"headphones":{"lang":"en","description":"A place for discussion, news, reviews and DIY projects related to headphones, headphone amplifiers and DACs. ","over18":false},"DC_Cinematic":{"lang":"en","description":"Your one stop for DC Films news and discussion, as well as past DC films and Vertigo adaptations!","over18":false},"feedthebeast":{"lang":"en","description":"The official subreddit of Modded Minecraft.","over18":false},"grandorder":{"lang":"en","description":"The destination for everything related to the mobile video game: Fate/Grand Order. Here you will find guides, translations, as well as tips and tricks for beginners! \n\n/r/grandorder your one-stop-shop","over18":false},"NBA2k":{"lang":"en","description":"We are the biggest community for anything and everything related to NBA2K! We are proud to have a great relationship with official NBA2K and 2K Support.","over18":false},"wallstreetbets":{"lang":"en","description":"\"Like 4chan found a Bloomberg terminal\"","over18":false},"battlefield3":{"lang":"en","description":"Battlefield3 discussion. [Read the rules please](http://www.reddit.com/r/battlefield3/faq). No Memes or blogspam. ","over18":false},"PublicFreakout":{"lang":"en","description":"A subreddit dedicated to people freaking out, melting down, losing their cool, or being weird in public.","over18":false},"Aquariums":{"lang":"en","description":"The subreddit for anything related to aquariums! Come here to enjoy pictures, videos, articles and discussion. We're also here to help you if you need advice.","over18":false},"WorldOfWarships":{"lang":"en","description":"A game about huge boats. With guns. Gunboats. Not submarines. Never submarines. :sub:","over18":false},"offbeat":{"lang":"en","description":"Offbeat: funny, weird, sad, strange or quirky news that's just....just offbeat :)","over18":false},"fakeid":{"lang":null,"description":"Subreddit no longer exists","over18":null},"supremeclothing":{"lang":"en","description":"/r/Supremeclothing is for anything and everything related to Supreme. ","over18":false},"history":{"lang":"en","description":"History","over18":false},"freefolk":{"lang":"en","description":"We do not kneel.\n\nGoT/ASOIAF sub for non-kneelers. r/Freefolk neither encourages nor discourages piracy. We only take action to enforce reddit's sitewide rules. We believe people are mature enough to ","over18":false},"Art":{"lang":"en","description":"This is a subreddit about art.\n\n","over18":false},"CHICubs":{"lang":"en","description":"A place for Cubs fans to talk about the team we love.","over18":false},"Denmark":{"lang":"en","description":"The official subreddit of Denmark","over18":false},"osugame":{"lang":"en","description":"osu! is a rhythm game based on the gameplay of a variety of popular commercial rhythm games such as Osu! Tatakae! Ouendan and Elite Beat Agents.","over18":false},"Atlanta":{"lang":"en","description":"Subreddit for all things in and about Atlanta, Georgia","over18":false},"neoliberal":{"lang":"en","description":"Defending the open society","over18":false},"arrow":{"lang":"en","description":"","over18":false},"boston":{"lang":"en","description":"A reddit for the city of Boston, MA (featuring the cities of Cambridge, Somerville, Malden, Medford, Quincy, Braintree, Newton and the town of Brookline)\n","over18":false},"GreenBayPackers":{"lang":"en","description":"The subreddit for fans of the Green Bay Packers.","over18":false},"twitchplayspokemon":{"lang":"en","description":"The subreddit for [TwitchPlaysPokémon](http://twitch.tv/twitchplayspokemon), the game where thousands of people play Pokémon at the same time.\n","over18":false},"comics":{"lang":"en","description":"Everything related to print comics (comic books, graphic novels, and strips) and web comics.  Artists are encouraged to post their own work.  News and media for adaptations based on comic books are we","over18":false},"army":{"lang":"en","description":"United States Army on Reddit","over18":false},"SFGiants":{"lang":"en","description":"","over18":false},"Calgary":{"lang":"en","description":"The city of Calgary, Alberta, Canada. ","over18":false},"gamedev":{"lang":"en","description":"All things related to game development, programming, math, art, music, business, and marketing.","over18":false},"TalesFromRetail":{"lang":"en","description":"A place to exchange stories about your bosses, employees, or those interesting customers you see daily.\n\n* Remember that customer who yelled at you over coupons?\n\n* Do I really have to wear this ridic","over18":false},"Boxing":{"lang":"en","description":"","over18":false},"WeAreTheMusicMakers":{"lang":"en","description":"[](/sidebar)\n\nWeAreTheMusicMakers (WatMM) is a subreddit for hobbyists, professional musicians, and enthusiasts to discuss music-related topics, ask questions and share useful information. Welcome and","over18":false},"OnePieceTC":{"lang":"en","description":"Everything One Piece Treasure Cruise! \n\nThis subreddit is for the Global and Japanese version. Information, guides, tips, news, fan art, questions and everything else Treasure Cruise related.","over18":false},"iamverysmart":{"lang":"en","description":"...because thesaurus abuse makes you sound very smart.","over18":false},"FashionReps":{"lang":"en","description":"Fashion Reps\n\nA Subreddit for getting reviews and information on all fashion replicas!\nNeed help finding a item? Just ask!\n","over18":false},"chelseafc":{"lang":"en","description":"A subreddit and forum dedicated to Chelsea FC","over18":false},"AirForce":{"lang":"en","description":"Community for current, future, and past members of the US Air Force.","over18":false},"truegaming":{"lang":"en","description":"/r/truegaming is a subreddit dedicated to meaningful, insightful, and high-quality discussion on all topics gaming.","over18":false},"breakingbad":{"lang":"en","description":"A subreddit for fans and critics of the hit television series Breaking Bad on AMC. Here you will find discussions and speculations about the show, pictures from the show, AMA's with the cast, and anyt","over18":false},"GetMotivated":{"lang":"en","description":"Welcome to /r/GetMotivated! We’re glad you made it. This is the subreddit that will help you finally get up and do what you *know* you need to do. It’s the subreddit to give and receive motivation thr","over18":false},"PokemonPlaza":{"lang":"en","description":"A friendly place to trade Pokémon!","over18":false},"gtaonline":{"lang":"en","description":"Grand Theft Auto Online - Rockstar's ongoing ever expanding multiplayer system, introduced by Grand Theft Auto V.\n","over18":false},"paragon":{"lang":"en","description":"Paragon was a 3rd person MOBA from Epic Games. It was in Open Beta on PC and PlayStation 4 from March 2016 until Paragon's servers shut down on April 27th of 2018. For more information visit http://ww","over18":false},"Pathfinder_RPG":{"lang":"en","description":"For info, news, resources, and anything else about the Pathfinder pen and paper RPG! (Not administered by or affiliated with Paizo Publishing® in any way)","over18":false},"NYYankees":{"lang":"en","description":"The official subreddit of the New York Yankees","over18":false},"bloodborne":{"lang":"en","description":"Bloodborne is an Action RPG from renowned Japanese developer FromSoftware, makers of the critically acclaimed Dark Souls series.\n\nFace your fears as you search for answers in the ancient city of Yharn","over18":false},"lego":{"lang":"en","description":"Reports, news, pics, videos, discussions and documentation from a studded world.\n\n/r/lego is about all things LEGO^&reg;. \n","over18":false},"cscareerquestions":{"lang":"en","description":"A subreddit for those with questions about working in the tech industry or in a computer-science-related job.","over18":false},"rickandmorty":{"lang":"en","description":"This is the subreddit for fans of Dan Harmon & Justin Roiland's animated series, Rick and Morty","over18":false},"woodworking":{"lang":"en","description":"/r/woodworking is your home on reddit for furniture, toys, tools, wood, glue, and anything else that has to do with woodworking as a hobby or profession. Please submit links to how-to pages and videos","over18":false},"philosophy":{"lang":"en","description":"","over18":false},"minnesotavikings":{"lang":"en","description":"A subreddit dedicated to the Minnesota Vikings of the NFL.  We all bleed purple and gold!  \n","over18":false},"CasualPokemonTrades":{"lang":"en","description":"Casual Pokémon Trades is a safe place for casual Pokémon trainers to trade non-competitive Pokémon. This community is about making friends and helping each other out!\n","over18":false},"islam":{"lang":"en","description":"Everything to do with Islam and Muslims!","over18":false},"FlashTV":{"lang":"en","description":"The Flash airs Tuesdays at 8 PM EST on The CW!","over18":false},"thenetherlands":{"lang":"en","description":"Welcome to the largest Reddit community for sharing anything related to the Netherlands. This bi-lingual subreddit is dedicated to news, sports, humor, culture and questions. Please be sure to check o","over18":false},"Rateme":{"lang":"en","description":"What Does Reddit Look like? How Do I Look? RateMe is where you can find out! r/RateMe is where you can not only be rated on your appearance but also get tips from awesome redditors on how to look your","over18":false},"wiiu":{"lang":"en","description":"Reddit's source for news, pictures, reviews, videos, community insight, & anything related to Nintendo's 8th-generation console, the Wii U.","over18":false},"vita":{"lang":"en","description":"All things PS Vita.","over18":false},"hillaryclinton":{"lang":"en","description":"/r/hillaryclinton is a pro-Hillary Clinton forum to support Hillary Clinton. Join other Hillary Clinton supporters on Reddit! We are stronger together.","over18":false},"MGTOW":{"lang":"en","description":"This subreddit is for men going their own way, forging their own identities and paths to self-defined success.","over18":false},"Advice":{"lang":"en","description":"This is a place where you can ask for advice on any subject. ","over18":false},"UpliftingNews":{"lang":"en","description":"A place to read and share positive and uplifting, feel good news stories.","over18":false},"mindcrack":{"lang":"en","description":"A fan-made community for the Mindcrack Let's Play brand and community. Find and discuss new Mindcrack videos, fan art, news and lots of hype! ","over18":false},"Drama":{"lang":null,"description":"Subreddit forbidden","over18":null},"scifi":{"lang":"en","description":"Science Fiction, or Speculative Fiction if you prefer. Fantasy too.  Asimov, Bradbury, Clarke, Dick, Heinlein and other SF books.  SF movies and TV shows.  Fantasy stuff like Tolkien and Game of Thron","over18":false},"dndnext":{"lang":"en","description":"A place to discuss the latest version of Dungeons and Dragons, the fifth edition, known during the playtest as D&D Next.","over18":false},"battlestations":{"lang":"en","description":"A subreddit for reddit users' battlestation pictures.","over18":false},"furry":{"lang":"en","description":"For all stuff fluff.","over18":false},"actuallesbians":{"lang":"en","description":"A place for discussions for and by cis and trans lesbians, bisexual girls, chicks who like chicks, bi-curious folks, dykes, butches, femmes, girls who kiss girls, birls, bois, aces, LGBT allies, and a","over18":false},"CrappyDesign":{"lang":"en","description":"MAY THE COMIC SANS AND LENS FLARES FLOW UNFILTERED","over18":false},"exjw":{"lang":"en","description":"The Internet's most comprehensive resource for ex-Jehovah's Witnesses, a community for support, recovery and a few laughs along the way.","over18":false},"subaru":{"lang":"en","description":"Where OC is the standard and boxer engines rule the world.\n\n","over18":false},"Catholicism":{"lang":"en","description":"/r/Catholicism is a place to present new developments in the world of Catholicism, discuss theological teachings of the Catholic Church, provide an avenue for reasonable dialogue amongst people of all","over18":false},"portugal":{"lang":"pt","description":"Articles related to the country Portugal and Portuguese people in the world.\n\nUm lugar para discutir apenas artigos relacionados com Portugal ou portugueses no mundo.","over18":false},"beer":{"lang":"en","description":"A subreddit to discuss your favorite beers and breweries, and share beer related articles. Quality content encouraged.","over18":false},"PoliticalHumor":{"lang":"en","description":"A subreddit for political humor (particularly US politics), such as political cartoons and satire.","over18":false},"watchpeopledie":{"lang":"en","description":"Welcome to watchpeopledie. This community is intended to observe and contemplate the very real reality of death. We are attempting to provide a service by showcasing this content. We value the first r","over18":true},"nsfw":{"lang":"en","description":"##Not Safe For Work\n\n^(For the porn lover in all of us.)\n\nAn all-encompassing pornography subreddit,  \nfrom a lone nipple to the hardest of the hardcore.    \n\n***\n\n> NSFW is typically used to describe","over18":true},"neopets":{"lang":"en","description":"r/neopets is the place to be without fear or scorn by TNT!","over18":false},"Warhammer40k":{"lang":"en","description":"","over18":false},"justneckbeardthings":{"lang":"en","description":"","over18":false},"whatisthisthing":{"lang":"en","description":"If you have something and you don't know what it is, this is the place for you to search for an answer.","over18":false},"paydaytheheist":{"lang":"en","description":"The reddit community for the game, PAYDAY: The Heist and PAYDAY 2, by OVERKILL Software.","over18":false},"forwardsfromgrandma":{"lang":"en","description":"Who says email is dead?  They obviously haven't seen your grandma at work.  Forwards, much like your meemaw, never really seem to die. Maybe it IS all those cigarettes keeping the sub alive!  Don't fo","over18":false},"sydney":{"lang":"en","description":"","over18":false},"ProtectAndServe":{"lang":"en","description":"This subreddit is a place where the law enforcement officers of Reddit can communicate with others in a controlled setting. This is a great place for those who are already in the field, people who are","over18":false},"Dota2Trade":{"lang":"en","description":"This subreddit was designed to facilitate the trading of Dota 2's vibrant in-game economy items. Traders of all experience are welcome! Please read the rules and register for flair before trying to po","over18":false},"tennis":{"lang":"en","description":"Tennis News & Discussion\n","over18":false},"KCRoyals":{"lang":"en","description":"The Kansas City Royals are a Major League Baseball team based in Kansas City, Missouri. The Royals are a member of the Central Division of Major League Baseball's American League.","over18":false},"bostonceltics":{"lang":"en","description":"****The community for the 17-time NBA Champion Boston Celtics!","over18":false},"CanadaPolitics":{"lang":"en","description":"Polite discussions about Canadian politics.","over18":false},"redsox":{"lang":"en","description":"A place for Red Sox fans to discuss their favorite team. Whether you're from New England or beyond, all are welcome.","over18":false},"OutOfTheLoop":{"lang":"en","description":"A subreddit to help you keep up to date with what's going on with reddit and other stuff. ","over18":false},"leafs":{"lang":"en","description":"**The Toronto Maple Leafs subreddit, home to links and discussion of the Maple Leafs. Go Leafs Go!**","over18":false},"worldbuilding":{"lang":"en","description":"For geeks and nerds, artists, writers, philosophers, politicians and scientists alike: The creation of new worlds and new universes has been a key element of science fiction and fantasy. It can also e","over18":false},"CHIBears":{"lang":"en","description":"Blue 'n orange Superfan Central. Reddit's home for homers and Chicago Bears news. ","over18":false},"discgolf":{"lang":"en","description":"","over18":false},"AskHistorians":{"lang":"en","description":"Questions about the past: Answered!","over18":false},"NewYorkMets":{"lang":"en","description":"Home of the New York Mets on reddit.","over18":false},"RandomActsOfGaming":{"lang":"en","description":"A subreddit designed to allow gamers to spread the love of gaming. ","over18":false},"ForeverAlone":{"lang":"en","description":"A subreddit for Forever Alone.\nlonely\ndepressed\nsad\nanxiety\n","over18":false},"SWGalaxyOfHeroes":{"lang":"en","description":"This subreddit is dedicated to Star Wars: Galaxy of Heroes, a mobile game by Electronic Arts (Capital Games). The game allows users to collect, level and battles with heroes and villains from the Star","over18":false},"Civcraft":{"lang":"en","description":"[](http://civcraft.help/#/home)","over18":false},"Undertale":{"lang":"en","description":"UNDERTALE, by indie developer Toby Fox, is a video game for PC, PS4, and coming to Nintendo Switch this September. Undertale is about a child who falls into an underworld filled with monsters. We're a","over18":false},"financialindependence":{"lang":"en","description":"This is a place for people who are or want to become Financially Independent (FI), which means not having to work for money.\n\nFinancial Independence is closely related to the concept of Early Retireme","over18":false},"poker":{"lang":"en","description":"Shuffle up and deal! Official subreddit for all things poker.","over18":false},"indieheads":{"lang":"en","description":"Everything Indie Music related; from the newest releases and news, to discussion on the history of alternative music. ","over18":false},"coys":{"lang":"en","description":"A sub for the club that Bill Nicholson made.","over18":false},"Military":{"lang":"en","description":"The largest military subreddit on reddit. ","over18":false},"teslamotors":{"lang":"en","description":"The original Reddit community of fans and enthusiasts of the Tesla mission.  To accelerate the world's transition to sustainable energy.  Vertically integrating energy solutions with solar, battery st","over18":false},"GoneWildPlus":{"lang":"en","description":"Ladies and gents, here we present to you a place to show off your *euphoric endowments*, your *capacious curvatures*, your *astronomical anatomy*, here I present to you **Reddit Gone Wild +**. The plu","over18":true},"oddlysatisfying":{"lang":"en","description":"For those little things that are inexplicably satisfying.","over18":false},"xxfitness":{"lang":"en","description":"For women and gender non-binary redditors who are fit, want to be fit, like reading about fitness to put off getting fit. Feel free to discuss your own personal experience related to fitness, exercise","over18":false},"math":{"lang":"en","description":"","over18":false},"mexico":{"lang":"es","description":"MÉXICO","over18":false},"Unexpected":{"lang":"en","description":"This subreddit is for unexpected twists in videos and gifs ","over18":false},"seduction":{"lang":"en","description":"Learn how to connect with the opposite sex! Primarily for men looking to seduce women in their life. Help with dating, learn to be a pickup artist (PUA), fix your Game. Every topic discussed to bring ","over18":false},"steroids":{"lang":"en","description":"Happily discussing all things related to the safe usage of AAS, TRT or hormone replacement with the exception of sourcing information.  Discussing sources will get you banned.","over18":false},"confession":{"lang":"en","description":"/r/Confession is a place to admit your wrongdoings, acknowledge your guilt, and alleviate your conscience.\n\n","over18":false},"zelda":{"lang":"en","description":"/r/zelda is the hub for anything and everything The Legend of Zelda - the iconic Nintendo series. Feel free to share news, reviews, opinions, fan art, humour, comics, or anything else Zelda.\n","over18":false},"AskScienceFiction":{"lang":"en","description":"It's like Ask Science, but for all universes other than our own. Or as **fanlore.org** calls it [Watsonian point of view](http://fanlore.org/wiki/Watsonian_vs._Doylist)","over18":false},"AMA":{"lang":"en","description":"","over18":false},"beyondthebump":{"lang":"en","description":"A place for new parents, new parents to be and old parents who want to help out. Posts focusing on the transition into living with your new little one and any issues that may come up. Ranting and gush","over18":false},"ottawa":{"lang":"en","description":"News, events, discussions, and what not from Ottawa, ON.","over18":false},"cowboys":{"lang":"en","description":"","over18":false},"Browns":{"lang":"en","description":"The #1 community and forum for Cleveland Browns Fans!","over18":false},"london":{"lang":"en","description":"News, Pictures, Events and Discussion about London, UK","over18":false},"Mariners":{"lang":"en","description":"This subreddit is good.","over18":false},"ShitRedditSays":{"lang":"en","description":"social justice league chats.\n\nThe internet promotes unity, and this unity makes people comfortable with this type of joke. All you do is disrupt this unity and make people uncomfortable.\n","over18":false},"makinghiphop":{"lang":"en","description":"Do you dabble in making beats and wonder how they'd sound with someone rapping over them? Have you ever wanted to try your hand at rapping but don't know any quality producers? Hell, if you just want ","over18":false},"AskTrumpSupporters":{"lang":"en","description":"A Q&A Subreddit to help improve understanding of the views of Trump Supporters, and the reasons behind those views.","over18":false},"StreetFighter":{"lang":"en","description":"Street Fighter video game series\n\nThe sub's mission is to build the fighting game community, harbor a healthy competitive nature, and be welcoming to players and fans alike.","over18":false},"socialism":{"lang":"en","description":"Welcome to r/socialism! This is a community to discuss current events in our world from an anti-capitalist perspective and to provide clarity to socialist ideas. We look forward to your participation ","over18":false},"edmproduction":{"lang":"en","description":"This subreddit is for discussing the production of electronic music.","over18":false},"tattoos":{"lang":"en","description":"This subreddit is intended for posting your own personal tattoos, but also includes:  tattoo flash and tattoo paintings from approved submitters. Below are some guidelines, and rules. Please direct an","over18":false},"49ers":{"lang":"en","description":"An awesome community for fans of the San Francisco 49ers. Go Niners!","over18":false},"CrusaderKings":{"lang":"en","description":"Crusader Kings II is an historical grand strategy video game for PC and Mac published by Paradox Interactive. Engage in courtly intrigue, dynastic struggles, and holy warfare in mediæval Europe, North","over18":false},"assassinscreed":{"lang":"en","description":"For news, discussion and more about Ubisoft's Assassin's Creed franchise.","over18":false},"breakingmom":{"lang":"en","description":"Just say what's going on. No judgments, no nastiness.","over18":false},"gameswap":{"lang":"en","description":"We are a tight-knit community created to allow members to swap their new and used console video games with fellow redditors.\n\n\n","over18":false},"Wishlist":{"lang":"en","description":"Random acts of gifting from Amazon, Etsy, Steam, and more! What's on YOUR wishlist?","over18":false},"youtubehaiku":{"lang":"en","description":"Youtube Haiku: Any almost poetic video under 14 seconds. Don't ask me why 14 seconds; it's just a number I have learned from experience.  Videos can still be poetic after 15 or longer, but no longer t","over18":false},"Roadcam":{"lang":"en","description":"Videos about road situations. Accidents, close calls, and anything interesting. ","over18":false},"horror":{"lang":"en","description":"R/HORROR, colloquially known as Dreadit by our subscribers is the premier horror entertainment community on Reddit. For more than 8 years /R/HORROR has been reddit.com's gateway to the darker side of ","over18":false},"Anarchism":{"lang":"en","description":"Anarchism is a social movement that seeks liberation from oppressive systems of control including but not limited to the state, capitalism, racism, sexism, speciesism, and religion. Anarchists advocat","over18":false},"China":{"lang":"en","description":"Discussing China and life in China","over18":false},"dragonage":{"lang":"en","description":"A community of Dragon Age fans, noobs, and ogres.","over18":false},"drunk":{"lang":"en","description":"","over18":false},"ProgrammerHumor":{"lang":"en","description":"dedicated to humor and jokes relating to programmers and programming.","over18":false},"playark":{"lang":"en","description":"A new breed of open-world dinosaur survival game, now on Xbox One, PS4, and Steam Windows/Mac/Linux!\n\nNot an official support channel.","over18":false},"fountainpens":{"lang":"en","description":"/r/fountainpens - A writing community for the novice to the collector.","over18":false},"Terraria":{"lang":"en","description":"Dig, fight, explore, build! Nothing is impossible in this action-packed adventure game. The world is your canvas and the ground itself is your paint.","over18":false},"wicked_edge":{"lang":"en","description":"Wetshaving - isn't all shaving wet? Kinda. Wetshaving is how barbers used to get the ultrasmooth shave of legends. The secret isn't more blades and more canned goo but a single wicked edge. Shaving is","over18":false},"Monstercat":{"lang":"en","description":"Subreddit for the EDM label Monstercat.  ","over18":false},"ultrahardcore":{"lang":"en","description":"A subreddit to discuss Ultra Hardcore, a gametype within Minecraft.  \nPlease go to /r/UHCMatches for scheduled UHC matches.","over18":false},"webdev":{"lang":"en","description":"","over18":false},"lakers":{"lang":"en","description":"","over18":false},"homestuck":{"lang":"en","description":"A subreddit to discuss Homestuck, Hiveswap and the works of Andrew Hussie.","over18":false},"lgbt":{"lang":"en","description":"A safe space for GSRM (Gender, Sexual, and Romantic Minority) folk to discuss their lives, issues, interests, and passions. LGBT is still a popular term used to discuss gender and sexual minorities, b","over18":false},"DenverBroncos":{"lang":"en","description":"Subreddit of the Denver Broncos. ","over18":false},"Suomi":{"lang":"fi","description":"The Finnish subreddit for natives and proficient users.","over18":false},"frugalmalefashion":{"lang":"en","description":"","over18":false},"SchoolIdolFestival":{"lang":"en","description":"A subreddit made for the mobile rhythm game Love Live! School Idol Festival. All SFW LL!SIF content welcome!\n","over18":false},"kratom":{"lang":"en","description":"Welcome to the place for discussion of kratom. Feel free to share helpful hints, tips, and news about kratom. ","over18":false},"listentothis":{"lang":"en","description":"Listentothis is the place to discover new and overlooked music.\n\nAll submissions link directly to music streams. Automated moderation removes spam, reposts, household name bands, and poor amateur musi","over18":false},"rage":{"lang":"en","description":"","over18":false},"gardening":{"lang":"en","description":"","over18":false},"tmobile":{"lang":"en","description":"Welcome to the subreddit of the best wireless carrier in the industry! T-Mobile is the third largest wireless carrier in the U.S.  offering affordable plans, the fastest 4G LTE in America, no contract","over18":false},"philadelphia":{"lang":"en","description":"News and happenings in and around Philadelphia, Pennsylvania.","over18":false},"business":{"lang":"en","description":"/r/business brings you the best of your business section. From tips for running a business, to pitfalls to avoid, /r/business teaches you the smart moves and helps you dodge the foolish.","over18":false},"RotMG":{"lang":"en","description":"A community-driven subreddit for the online Flash-player bullet-hell perma-death game, Realm of the Mad God.","over18":false},"skyrimmods":{"lang":"en","description":"Welcome to /r/SkyrimMods! We are Reddit's primary hub for all things modding, from troubleshooting for beginners to creation of mods by experts. We ask that you please take a minute to read through th","over18":false},"DebateAChristian":{"lang":"en","description":"","over18":false},"CryptoCurrency":{"lang":"en","description":"The official source for CryptoCurrency News, Discussion & Analysis.","over18":false},"ladybonersgw":{"lang":"en","description":"Welcome to Ladyboners Gone Wild. This is a place for sexy guys to strut their stuff. The subscribers here are really supportive and more dude-appreciative than /r/GoneWild, and we're more accepting of","over18":true},"serialpodcast":{"lang":"en","description":"Serial is a podcast by the creators of This American Life. Each season explores a nonfictional story in weekly installments.\n\nThis subreddit is a place to discuss your theories, predictions and other ","over18":false},"FinalFantasy":{"lang":"en","description":"Subreddit for all things Final Fantasy!","over18":false},"Whatcouldgowrong":{"lang":"en","description":"What Could Possibly Go Wrong?\n\nThe best place to learn what NOT to do.","over18":false},"bladeandsoul":{"lang":"en","description":"Blade & Soul is a Korean fantasy martial-arts massively multiplayer online role-playing game (MMORPG) developed by NCsoft's Team Bloodlust.","over18":false},"jobs":{"lang":"en","description":"How to get work and how to leave it. Employment, recruitment, interviews, etc.","over18":false},"millionairemakers":{"lang":"en","description":"If 1 million people gave a dollar to someone, they could be a millionaire. \n\nLearn more about Bitcoin Cash at bitcoincashers.org.\n\nWe are an embodiment of this showerthought: https://redd.it/2mq94c","over18":false},"radiohead":{"lang":"en","description":"A place for all things Radiohead. [News, Media, & Discussion]","over18":false},"microgrowery":{"lang":"en","description":"Dedicated to the cultivation of cannabis. We love pictures of your plants & harvest, discussing growing methods, and helping with grow problems.","over18":false},"3Dprinting":{"lang":"en","description":"News, information, links and fun things related to 3D printing, 3D printers, rapid manufacturing, desktop fabrication etc.","over18":false},"Paladins":{"lang":"en","description":"The subreddit of Paladins: Champions of the Realm, a free-to-play, competitive, multiplayer shooter for Windows, Mac, Playstation, X-Box, and Nintendo Switch, developed by Evil Mojo Games and publishe","over18":false},"creepyPMs":{"lang":"en","description":"A place for people to share the strange and disturbing PMs they get from all over the internet.","over18":false},"clevelandcavs":{"lang":"en","description":"Home of the 2016 NBA Champion Cleveland Cavaliers","over18":false},"flying":{"lang":"en","description":"This community is for discussion among pilots, students, instructors and aviation professionals.","over18":false},"Incels":{"lang":null,"description":"Subreddit no longer exists","over18":null},"splatoon":{"lang":"en","description":"/r/splatoon is your one stop shop for all things Splatoon, 1 or 2!  Home to all squids, kids, and all things octolings. Enjoy your stay! <コ:彡 C:彡","over18":false},"BitcoinMarkets":{"lang":"en","description":"Sharing of ideas, tips, and strategies for increasing your Bitcoin trading profits","over18":false},"Repsneakers":{"lang":"en","description":"","over18":false},"ADHD":{"lang":"en","description":"A place where people with ADHD and their loved ones can interact with each other exchanging stories, struggles, and strategies. Weekly threads to plan and notice the positive in our lives. Many of the","over18":false},"worldpolitics":{"lang":"en","description":"***reddit's free speech political subreddit***","over18":false},"chicagobulls":{"lang":"en","description":"A community dedicated to the best NBA team to ever step onto a basketball court.","over18":false},"gamecollecting":{"lang":"en","description":"This is the definitive Reddit source for video game collectors or those who would like to start collecting interactive entertainment. It's a place to share ideas, tips, tricks or secrets as well as sh","over18":false},"exmuslim":{"lang":"en","description":"A recovery and discussion subreddit for those who were once followers of Islam.","over18":false},"Xcom":{"lang":"en","description":"","over18":false},"MorbidReality":{"lang":"en","description":"Welcome to /r/MorbidReality, a subreddit devoted to the most disturbing content the internet has to offer. Here, we study and observe the darkest aspects of life and human nature.","over18":true},"MMORPG":{"lang":"en","description":"Massively multiplayer online role-playing game (MMORPG) is a genre of role-playing video games in which a very large number of players interact with one another within a virtual game world. We discuss","over18":false},"worldpowers":{"lang":"en","description":"WorldPowers is a cooperative, geopolitical, worldbuilding RP - that means that each player takes the helm of a country and leads it into a future entirely built by the interactions between one another","over18":false},"geek":{"lang":"en","description":"Geeky things","over18":false},"fatpeoplestories":{"lang":"en","description":"Trigger Warning: Hamplanets\n","over18":false},"SuicideWatch":{"lang":"en","description":"","over18":false},"asktrp":{"lang":"en","description":"Red Pill Discussion for personalized questions about specific situations.","over18":false},"hardware":{"lang":"en","description":"/r/hardware is a technology subreddit for computer hardware news, reviews and discussion. ","over18":false},"canucks":{"lang":"en","description":"*The* subreddit for fans of the Vancouver Canucks.","over18":false},"Scotland":{"lang":"en","description":"Scotland - all things Scotland, Scottish and Scot here.","over18":false},"gonewildaudio":{"lang":"en","description":"Gonewild Audio is a place to submit naughty recordings of **yourself** alone or with your consenting partner(s).  We only accept submissions of audio.  ","over18":true},"warriors":{"lang":"en","description":"For all things Golden State Warriors.","over18":false},"mechmarket":{"lang":"en","description":"A place for selling, buying, and trading anything related to keyboards.","over18":false},"ar15":{"lang":"en","description":"/r/ar15 is here for your favorite black gun links, build pics, questions and other tactical or practical information. ","over18":false},"spacex":{"lang":"en","description":"Welcome to r/SpaceX, the premier SpaceX discussion community and the largest fan-run board on the American aerospace company SpaceX. This board is not an official outlet for SpaceX information.","over18":false},"LSD":{"lang":"en","description":"A Kind, Open-Minded Community dedicated to Lysergic acid diethylamide-25.","over18":false},"diablo3":{"lang":"en","description":"This is the subreddit community for Diablo 3 and its expansion, developed by Blizzard. Come and join the discussion!","over18":false},"washingtondc":{"lang":"en","description":"A subreddit for those living in and visiting Washington, DC and the immediate surrounding area. Don't worry, the humidity will pass, and remember: stand on the right, walk on the left.","over18":false},"web_design":{"lang":"en","description":"Topics related to web design: HTML, CSS, JS, layout, UI, graphics, etc.","over18":false},"PrettyLittleLiars":{"lang":"en","description":"The number one place to discuss and theorize on all things Pretty Little Liars (The TV Series, The Books and the Stars).","over18":false},"community":{"lang":"en","description":"A community of [Community](http://en.wikipedia.org/wiki/Community_(TV_series\\)) fans, and the subreddit that's streets ahead!\n\nVoted [5th best new Reddit community of 2010](/r/community/comments/f4ln0","over18":false},"blog":{"lang":"en","description":"","over18":false},"tf2trade":{"lang":"en","description":"A place for fans of Valve's Team Fortress 2 trading world to post trades and engage in trade-related discussion.","over18":false},"Maplestory":{"lang":"en","description":"","over18":false},"quityourbullshit":{"lang":"en","description":"A subreddit for stories, pictures or videos of people *calling* bullshit. Possibly with proof. \n","over18":false},"makeupexchange":{"lang":"en","description":"","over18":false},"GamerGhazi":{"lang":"en","description":"Diversity and geek culture collide","over18":false},"entertainment":{"lang":"en","description":"For news and discussion of the entertainment industry. ","over18":false},"Twitch":{"lang":"en","description":"/r/Twitch is an unofficial place for discussions surrounding the streaming website Twitch.tv. If you want to provide feedback, ask a question or show some quality content, this is the place for you!","over18":false},"vaporents":{"lang":"en","description":"Reddit's largest community focusing on cannabis vapes and vaporization.","over18":false},"WildStar":{"lang":"en","description":"WildStar is a free to play, sci-fi/fantasy MMORPG from Carbine Studios (listed on Steam as well).","over18":false},"zen":{"lang":"en","description":"","over18":false},"shittyaskscience":{"lang":"en","description":"Reddit's new look is shit. Revert back to classic.","over18":false},"HistoryPorn":{"lang":"en","description":"Exploring the past through historical photographs. Part of the SFW Porn Network.","over18":false},"DetroitRedWings":{"lang":"en","description":"The Reddit home for the National Hockey League's Detroit Red Wings. Contains prospect news, game threads, discussion, and the Anthony Mantha Holy Shrine.\n\nLGRW!\n\nBe sure to check out /r/GrandRapidsGri","over18":false},"orioles":{"lang":"en","description":"The Baltimore Orioles are a professional baseball team based in Baltimore, Maryland. They are a member of the Eastern Division of Major League Baseball's American League.","over18":false},"patientgamers":{"lang":"en","description":"The subreddit for patient gamers.","over18":false},"deadbydaylight":{"lang":"en","description":"/r/deadbydaylight is a subreddit dedicated to Dead by Daylight, an asymmetrical multiplayer action-horror game developed and published by Behaviour Interactive.\n","over18":false},"EDC":{"lang":"en","description":"What essentials do you carry on a daily basis?","over18":false},"rawdenim":{"lang":"en","description":"For enthusiasts of raw denim in all its forms; from the rarest Japanese heritage jeans, to the most frayed of jorts.\n","over18":false},"Coffee":{"lang":"en","description":"/r/ Coffee is a place to discuss any and all things coffee.","over18":false},"MTB":{"lang":"en","description":"A cycling community enthusiastic about mountain biking and all things related. ","over18":false},"SSBM":{"lang":"en","description":"A competitive Melee focused extension of the reddit Super Smash Brothers community.","over18":false},"AskAnAmerican":{"lang":"en","description":"AskAnAmerican: Learn about America, straight from the mouth of Americans","over18":false},"PSVR":{"lang":"en","description":"A place to share your love for and discuss everything PlayStation VR.\n\nAKA PSVR, PS VR, PlayStationVR and formerly Project Morpheus.\n\n---\n\n• News, AMAs with Developers • Tournaments • Reviews • Events","over18":false},"MLBTheShow":{"lang":"en","description":"Reigning, defending Sub Champion: u/jujubats10\n\n","over18":false},"ChapoTrapHouse":{"lang":"en","description":"Chapo Trap House is a podcast by @willmenaker @cushbomb @amberaleefrost @virgiltexas  @ByYourLogic, produced by @saywhatagain","over18":false},"Denver":{"lang":"en","description":"The Mile High Reddit!","over18":false},"sportsbook":{"lang":"en","description":"","over18":false},"batman":{"lang":"en","description":"The Dark Knight.  The Caped Crusader.  The World's Greatest Detective.  Ol' Pointy Ears.  A place to discuss the batman and all things batman related.","over18":false},"Multicopter":{"lang":"en","description":"Any 2+ horizontal rotor aircraft!\n\n* Tricopters\n* Quadcopters\n* Pentacopters\n* Hexacopters\n* Octocopters\n* UAV and RPA discussions     \n* Autopilots & Accessories  \n* FPV and racing   \n* and more!","over18":false},"Autos":{"lang":"en","description":"Everything Vehicle Related! Cars, Trucks, Racing, Drifting, Projects, Concepts we've got it all! ","over18":false},"cripplingalcoholism":{"lang":"en","description":"","over18":false},"aviation":{"lang":"en","description":"Anything related to aircraft, airplanes, aviation and flying. Helicopters & rotorcraft, airships, balloons, parachutes & skydiving, paragliders, winged suits and anything that sustains you in the air ","over18":false},"fantasybball":{"lang":"en","description":"NBA Fantasy Basketball Community","over18":false},"starterpacks":{"lang":"en","description":"The worlds biggest starterpack resource.","over18":false},"teenmom":{"lang":"en","description":"Welcome home to r/TeenMom, your place to talk about all the Teen Mom MTV franchises.","over18":false},"CCW":{"lang":"en","description":"The CCW (concealed carry weapons) subreddit is a community about sharing articles, tips, and links about various topics that address ccw.","over18":false},"sanfrancisco":{"lang":"en","description":"Cold summers, thick fog, and beautiful views. Welcome to the subreddit for the gorgeous City by the Bay! San Francisco, California, USA.","over18":false},"h3h3productions":{"lang":"en","description":"/r/h3h3productions is the home for all your goofing and gaffing needs. We've got all the Chub n' Tuck you could ever want.","over18":false},"Shitty_Car_Mods":{"lang":"en","description":"Post pictures of cars with terrible mods","over18":false},"Bad_Cop_No_Donut":{"lang":"en","description":"Law enforcement abuse stories regarding: abuse of power, corruption, and other misfortunes in developing police states. \n\n\n\"We cannot expect people to have respect for law and order until we teach res","over18":false},"brisbane":{"lang":"en","description":"All things Brisbane, Australia! ","over18":false},"howardstern":{"lang":"en","description":"We discuss anything related to Howard Stern.","over18":false},"climbing":{"lang":"en","description":"The home of Climbing on reddit. And yes we are scared of falling.","over18":false},"paradoxplaza":{"lang":"en","description":"A place to share content, ask questions and/or talk about Paradox Interactive games and of the company proper.\n\nSome franchises of note: Stellaris, Cities: Skylines, Europa Universalis, Crusader Kings","over18":false},"lewronggeneration":{"lang":"en","description":"closed for april fools haha dae remember lwg [mods rn](http://imgur.com/MUm3LCG.jpg)","over18":false},"BostonBruins":{"lang":"en","description":"For those who bleed Black and Gold.","over18":false},"Windows10":{"lang":"en","description":"This community is dedicated to Windows 10 which is a personal computer operating system released by Microsoft as part of the Windows NT family of operating systems.","over18":false},"Vaping":{"lang":"en","description":"The Best Sub for Vapers!","over18":false},"Israel":{"lang":"en","description":"A place for discussion of Israeli life and culture, but most of all for participating in the time honored tradition of arguing politics.\n","over18":false},"redditgetsdrawn":{"lang":"en","description":"We are a community for redditors who want to get drawn and redditors who want to draw them! Post a photo of yourself or a loved one, and we'll draw you!","over18":false},"shittyfoodporn":{"lang":"en","description":"","over18":false},"Flyers":{"lang":"en","description":"A Hoagie to talk about the Philadelphia Flyers the Hockey Team. ","over18":false},"MURICA":{"lang":"en","description":"A subreddit for FREEDOM! 'MURICA! FUCK YEAH!","over18":false},"popheads":{"lang":"en","description":"The latest and greatest in pop music, all in one subreddit.","over18":false},"Silverbugs":{"lang":"en","description":"/R/Silverbugs is a forum for people to come together and share in a community of forward thinking silver enthusiasts. ","over18":false},"BravoRealHousewives":{"lang":"en","description":"Discuss all the Real Housewives franchises by Bravo TV with us! You are at the right place for: Real Housewives of Atlanta / Beverly Hills / Melbourne / Miami / New Jersey / New York City / Orange Cou","over18":false},"HomeImprovement":{"lang":"en","description":"A community dedicated to helping individuals that are looking for advice on home improvement projects. If you are new here, please review the guidelines on the stickied post. ","over18":false},"FoodPorn":{"lang":"en","description":"Simple, attractive, and visual. Nothing suggestive or inappropriate, this is a safe for work subreddit.","over18":false},"rva":{"lang":"en","description":"News, events, and goings-on in and around Richmond, Virginia.","over18":false},"letsplay":{"lang":"en","description":"A subreddit dedicated to creating Let's Plays, either liked by redditors or made by redditors!\n\nLet's Play: One or more people that record themselves playing video games through screenshots or capture","over18":false},"Nationals":{"lang":"en","description":"Subreddit for fans and followers of the Washington Nationals, a team in Major League Baseball. Formerly the Montreal Expos, but now based in Washington DC, the Nats play in the National League East. \n","over18":false},"dwarffortress":{"lang":"en","description":"Dwarf Fortress - Losing is Fun!","over18":false},"skeptic":{"lang":"en","description":"","over18":false},"PrequelMemes":{"lang":"en","description":"Memes of the Star Wars prequels","over18":false},"detroitlions":{"lang":"en","description":"The official subreddit for Detroit Lions football.\n\n[NFL, National Football League, NFC North, NFC Central, Black and Blue Division]","over18":false},"OpTicGaming":{"lang":"en","description":"The official fan subreddit for OpTic Gaming.","over18":false},"DeadBedrooms":{"lang":"en","description":"A support group for Redditors who are coping with a relationship that is seriously lacking in sexual intimacy.  Advice is always appreciated, just don't be surprised if we've heard it all.\n\nThis subre","over18":false},"secretsanta":{"lang":"en","description":"/r/secretsanta and Reddit Gifts were started in 2009 to provide a secret santa for the Reddit community.  We have since expanded to many gift exchanges.  ","over18":false},"OutreachHPG":{"lang":"en","description":"Outreach HPG is a discussion hub for Mechwarrior Online, a stompy robot game by PGI. ","over18":false},"POLITIC":{"lang":"en","description":"We stand for free speech. We will not ban legal content even if we find it odious or if we personally condemn it. Not because that's the law in the United States but because we believe in that ideal i","over18":false},"WWII":{"lang":"en","description":"/r/WWII is the developer-supported, community-run subreddit for the WWII community.\n\nCall of Duty: WWII is a first-person shooter video game developed by Sledgehammer Games and published by Activision","over18":false},"AnimalCrossing":{"lang":"en","description":"All things Animal Crossing! Share your Friend Codes & Dream Addresses in our mega-threads, post your in-game achievements, fan art & more! \n\n\n","over18":false},"Warhammer":{"lang":"en","description":"Welcome to /r/Warhammer; a place to discuss, post pictures, and ask questions about Warhammer 40k, Fantasy, Age of Sigmar, LotR, and any other specialist titles from Games Workshop or affiliated devel","over18":false},"oneplus":{"lang":"en","description":"The place for discussing OnePlus and their products.","over18":false},"Borderlands":{"lang":"en","description":"A subreddit specifically for the game Borderlands, including all DLC, sequels, pre-sequels, and re-pre-sequels.","over18":false},"archeage":{"lang":"en","description":"**ArcheAge** is a medieval fantasy massively multi-player online role-playing game (MMORPG) developed by Korean studio, [XL Games](http://bit.ly/XLGames). It is available for North American, European,","over18":false},"LateStageCapitalism":{"lang":"en","description":"A One-Stop-Shop for Evidence of our Social, Moral and Ideological Rot.","over18":false},"niceguys":{"lang":"en","description":"For all the self proclaimed \"nice guys\" who are actually manchildren or douches, or mistake their hilarious spinelessness for niceness\n\nThis is primarily a subreddit for images of these \"nice guys\" de","over18":false},"hcteams":{"lang":null,"description":"Subreddit forbidden","over18":null},"dating_advice":{"lang":"en","description":"Share your favorite tips, ask for advice, and encourage others about anything dating.","over18":false},"HITsWorthTurkingFor":{"lang":"en","description":"HWTF is a subreddit dedicated to posting links to good paying tasks, called HITs (Human Intelligence Tasks), that are available to be completed on Amazon's crowdsourcing service - Amazon Mechanical Tu","over18":false},"progresspics":{"lang":"en","description":"post those awesome before/after pictures of yours!","over18":false},"Surface":{"lang":"en","description":"A subreddit for Microsoft Surface. The most productive devices on the planet.","over18":false},"ShingekiNoKyojin":{"lang":"en","description":"This is a subreddit for fans of the anime/manga \"Attack on Titan\" (known as \"Shingeki no Kyojin\" in Japan), by Hajime Isayama.","over18":false},"RealGirls":{"lang":"en","description":"Pictures of real girls","over18":true},"LivestreamFail":{"lang":"en","description":"Welcome to /r/LivestreamFail: the place for almost anything livestream related. We Streamable / Neatclips / Twitch clips, GIFs and VoDs.\n\nNo moderators of this subreddit work for Twitch.  ","over18":false},"Psychonaut":{"lang":"en","description":"A psychonaut is a person who experiences intentionally induced altered states of consciousness and claims to use the experience to investigate his or her mind, and possibly address spiritual questions","over18":false},"r4r":{"lang":"en","description":"","over18":false},"TheBluePill":{"lang":"en","description":"/r/TheBluePill is a satire of /r/TheRedPill and the strategies discussed on that particular sub. That being said, consider most posts on this sub to have a trigger warning. ","over18":false},"INTP":{"lang":"en","description":"This subreddit is for all who are interested in the Jungian INTP personality type.","over18":false},"RedditLaqueristas":{"lang":"en","description":"The C was sold to pay for polish 💅","over18":false},"rangers":{"lang":"en","description":"The Blue Bleeders' home on Reddit. Join us in talking about anything and everything related to the New York Rangers.","over18":false},"MechanicAdvice":{"lang":"en","description":"This is more than a car repair forum!","over18":false},"gwent":{"lang":"en","description":"A subreddit dedicated to Gwent: The Witcher Card Game.","over18":false},"randomactsofcsgo":{"lang":"en","description":"A subreddit dedicated to giving away CSGO skins and other (in)game gifts to one another.\n","over18":false},"steelers":{"lang":"en","description":"The Official Subreddit of the Pittsburgh Steelers football team. Discussions about the latest team news, players, highlights, and more!","over18":false},"Barca":{"lang":"en","description":"FC Barcelona News and Discussion ","over18":false},"noveltranslations":{"lang":"en","description":"A place for Japanese light novels, and web novels that are translated from Japanese, Chinese, and Korean to English. Original English web series and other languages are welcome as well.\n\nThis subreddi","over18":false},"KingdomHearts":{"lang":"en","description":"The subreddit for Kingdom Hearts news, discussion, and more. Post discussion, fan-art, videos, questions, and more here!","over18":false},"nvidia":{"lang":"en","description":"A place for everything NVIDIA, come talk about news, drivers, rumours, GPUs, the industry, show-off your build and more.","over18":false},"starbucks":{"lang":"en","description":"","over18":false},"UnresolvedMysteries":{"lang":"en","description":"A subreddit dedicated to the unresolved mysteries of the world.\n\n\nSubmissions should outline a mystery and provide a link to a more detailed review of the case such as a Wiki article or news report.\n\n","over18":false},"panthers":{"lang":"en","description":"The Reddit home of the Carolina Panthers!","over18":false},"Infinitewarfare":{"lang":"en","description":"/r/InfiniteWarfare is the developer-supported, community-run subreddit for the Infinite Warfare community.\n\nCall of Duty: Infinite Warfare is a first-person shooter video game developed by Infinity Wa","over18":false},"networking":{"lang":"en","description":"###Enterprise Networking\n\nRouters, switches and firewalls. Network blogs, news and network management articles. Cisco, Juniper, Brocade and more all welcome.","over18":false},"Metalcore":{"lang":"en","description":"Metalcore is a subgenre of hardcore punk combining various elements of extreme metal and hardcore punk. The name is a portmanteau of the two genres. Metalcore is distinguished from other punk metal fu","over18":false},"sto":{"lang":"en","description":"This is the official subreddit for the Star Trek Online, the licensed Star Trek MMO, available on PC, PS4, and Xbox One. Share your glorious (or hilarious) in-game adventures through stories and scree","over18":false},"NSFW_GIF":{"lang":"en","description":"Animated images of sexy time.\n\nNSFW_GIF is a subreddit dedicated to gifs of adult material ranging anywhere from hardcore sex to beautiful boobies to one-on-one girl action.\n\n**List of content that yo","over18":true},"Filmmakers":{"lang":"en","description":"Filmmakers, directors, cinematographers, editors, vfx gurus, composers, sound guys, grips, electrics, and more meet to share their work, tips, tutorials, and experiences. A place where professionals a","over18":false},"ShitAmericansSay":{"lang":"en","description":"Shit Americans Say: we can't make it up.\n","over18":false},"JoeRogan":{"lang":"en","description":"A portal to discuss Joe Rogan, Comedy, MMA, Psychedelics, Mind-expanding revelations, Conspiracies, Insights, and Fitness & Health.","over18":false},"Jeep":{"lang":"en","description":"","over18":false},"spikes":{"lang":"en","description":"The serious, play-to-win side of the Magic: The Gathering community. ","over18":false},"japan":{"lang":"en","description":"This subreddit is for residents, visitors, and fans of Japan, both past, present, and future, to discuss most things Japanese and exchange information.","over18":false},"Indiemakeupandmore":{"lang":"en","description":"/r/indiemakeupandmore is a subreddit dedicated to independently made cosmetics, perfumes, bath and body products and more. Consumers, bloggers and shop owners are all welcome to join our community.","over18":false},"BleachBraveSouls":{"lang":"en","description":"Welcome to the Bleach: Brave Souls community. We are home of news, updates, discussion, information, and more pertaining to the mobile game! While **we have no affiliation with KLab**, we offer one of","over18":false},"Buddhism":{"lang":"en","description":"A reddit for all kinds of Buddhist teachings","over18":false},"gaymers":{"lang":"en","description":"","over18":false},"tall":{"lang":"en","description":"A subreddit for tall-related topics. Come ask questions, post your pictures, whatever you want. /r/tall: reddit from a higher perspective.","over18":false},"PictureGame":{"lang":"en","description":"Figure out the answer by identifying the picture, and leave your answer in the comments. If your answer is correct, you will be messaged the instructions to start a new round!","over18":false},"Stellaris":{"lang":"en","description":"A place to share content, ask questions and/or talk about the 4X grand strategy game Stellaris by Paradox Development Studio.","over18":false},"ContestOfChampions":{"lang":"en","description":"General discussion on Kabam's MARVEL fighting game for smartphones and tablets. ","over18":false},"Firearms":{"lang":"en","description":"A place to discuss firearms and news relating to guns and other small arms. We value the freedom of speech as much as we do the right to keep and bear arms. Posts must be somewhat related to guns and ","over18":false},"gallifrey":{"lang":"en","description":"A community dedicated to discussions and news for Doctor Who. ","over18":false},"Animesuggest":{"lang":"en","description":"Suggest an anime, manga, light novel, or visual novel that you've seen and loved, or ask about what to watch, read, or play next!","over18":false},"ukraina":{"lang":"ru","description":"Всё об Украине.\n\nОсновное правило: придерживаться общечеловеческих норм общения культурных и вежливых людей. Мат не запрещён, когда это требуется. Сообщения, состоящие преимущество из матов будут удал","over18":false},"weekendgunnit":{"lang":"en","description":"","over18":false},"Accounting":{"lang":"en","description":"Primarily for accountants and aspiring accountants to learn about and discuss their career choice. Advice and questions welcome. ","over18":false},"gentlemanboners":{"lang":"en","description":"Gentleman Boners is a true gentleman's club. This is an oasis like no other! Only the finest eye candy of the classiest nature can be found here. Elegant, graceful, timeless female celebrities are one","over18":false},"fitnesscirclejerk":{"lang":"en","description":"the homosexual fitness brigade ","over18":false},"Astros":{"lang":"en","description":"Home of the MLB Houston Astros","over18":false},"indonesia":{"lang":"id","description":"Unity in Diversity","over18":false},"ComedyCemetery":{"lang":"en","description":"Stuff that was intended to be humorous, but...isn't. ","over18":false},"audiophile":{"lang":"en","description":"r/audiophile is a forum for discussion of the pursuit of quality audio reproduction of all forms, budgets, and sizes. Our primary goal is insightful discussion of equipment, sources, music, and audio ","over18":false},"PKA":{"lang":"en","description":"Painkiller Already (PKA) is a weekly online podcast produced by Woody (WoodysGamertag), Kyle (FPSKyle) and Taylor (MurkaDurkah). Episodes usually range from three to four hours long, often include an ","over18":false},"knifeclub":{"lang":"en","description":"All things pocket knives. An alternative to r/knives.\n\n","over18":false},"guitarpedals":{"lang":"en","description":"The place for all things related to guitar pedals.","over18":false},"TheSimpsons":{"lang":"en","description":"The /r/TheSimpsons subreddit is fan base of redditors who love The Simpsons. \n\nThe Simpsons is an American animated sitcom created by Matt Groening for the Fox Broadcasting Company. The show is set in","over18":false},"promos":{"lang":"en","description":"","over18":false},"environment":{"lang":"en","description":"Current news, information and issues related to the environment.","over18":false},"Winnipeg":{"lang":"en","description":"Honey Dill for the Soul. ","over18":false},"SeattleWA":{"lang":"en","description":"r/SeattleWA is the active Reddit community for Seattle and the Puget Sound!  Do you want lively open discussions, upcoming events, local artist creations, community meet-ups, Seattle history, current ","over18":false},"cordcutters":{"lang":"en","description":"Are you tired of paying too much for cable television? Join us and become a cordcutter today. We offer advice on live streaming and on demand services, antennas, and OTA DVRs. Get help with your Smart","over18":false},"Yogscast":{"lang":"en","description":"Honeydew Inc. Public Relations Sector","over18":false},"BMW":{"lang":"en","description":"This sub-reddit is dedicated to everything related to BMW vehicles, tuning, racing, and more.","over18":false},"Gunpla":{"lang":"en","description":"While Gunpla is a portmanteau of \"Gundam Plastic Model\", this subreddit is dedicated to the practice of building all mecha models.","over18":false},"TagPro":{"lang":"en","description":"Suggestions and discussion for the free-to-play webgame TagPro.","over18":false},"adventuretime":{"lang":"en","description":"Subreddit dedicated to Cartoon Networks hit show, Adventure Time!","over18":false},"ShinyPokemon":{"lang":"en","description":"Show and trade your Shiny Pokemon!","over18":false},"Kanye":{"lang":"en","description":"Dedicated to Kanye West","over18":false},"CitiesSkylines":{"lang":"en","description":"A subreddit for the City Builder game developed by Colossal Order, Cities: Skylines. ","over18":false},"Cubers":{"lang":"en","description":"For people who love any sort of geometric puzzles, including but not limited to: Rubik's Cubes (and any size/design variants), the Square 1, the pyramid combo puzzle, et al.","over18":false},"miamidolphins":{"lang":"en","description":"The official subreddit of the Miami Dolphins football team. Discussions about the latest team news, players, game recaps, and more!","over18":false},"medicalschool":{"lang":"en","description":"","over18":false},"ModernMagic":{"lang":"en","description":"A subreddit dedicated to the discussion of the Magic: The Gathering's Modern format!","over18":false},"soccerspirits":{"lang":"en","description":"Subreddit for the com2us game. (genre: RPG,   CCG , Sport, Strategy,)","over18":false},"CompetitiveHS":{"lang":"en","description":"Serious discussion about playing Hearthstone competitively. Please read our rules before posting.","over18":false},"pettyrevenge":{"lang":"en","description":"For all your stories of small victories over those who've wronged you.","over18":false},"shield":{"lang":"en","description":"Marvel's Agents of S.H.I.E.L.D.","over18":false},"drums":{"lang":"en","description":"r/Drums - The subreddit where drummers of all skill levels can discuss the world of percussion and share their grooves with the friendliest community on Earth. ","over18":false},"vexillology":{"lang":"en","description":"A subreddit for those who enjoy flags, the history behind them, and their design characteristics.","over18":false},"DunderMifflin":{"lang":"en","description":"A sub-reddit for the fans and critics of the show The Office. Discussion of the show, pictures from the show and anything else The Office related. ","over18":false},"future_fight":{"lang":"en","description":"Area meant for discussion of Netmarble Games and Marvel’s Future Fight. ","over18":false},"SecretSubreddit":{"lang":"en","description":"What a Secret Subreddit.","over18":false},"DuelLinks":{"lang":"en","description":"Yu-Gi-Oh! Duel Links is a mobile application for iOS and Android.","over18":false},"InternetIsBeautiful":{"lang":"en","description":"This is a subreddit based around sharing awesome, usually minimal and single-purpose websites and webtools. \n\nAlso, note to self: If this subreddit gets huge, awesome, if it does not, I will simply us","over18":false},"Anxiety":{"lang":"en","description":"Discussion and support for sufferers and loved ones of any anxiety disorder.","over18":false},"techsupportgore":{"lang":"en","description":"You will cringe to the brink of passing out after a few minutes looking at this subreddit.","over18":false},"Celebs":{"lang":"en","description":"For beautiful female celebrities.","over18":false},"NYGiants":{"lang":"en","description":"The Official Subreddit of The New York Football Giants","over18":false},"factorio":{"lang":"en","description":"Subreddit for the game Factorio.","over18":false},"Texans":{"lang":"en","description":"Unofficial home of the Houston Texans, an American Football team located in Houston, TX","over18":false},"Quebec":{"lang":"fr","description":"Tout à propos de la belle province","over18":false},"montreal":{"lang":"en","description":"A community for Montreal and its loving residents. We speak French too!\n\nUne communauté pour Montréal et ses résidents bien aimés. On parle anglais aussi!","over18":false},"NYKnicks":{"lang":"en","description":"The official subreddit of the New York Knicks NBA basketball team.","over18":false},"Fishing":{"lang":"en","description":"","over18":false},"YouShouldKnow":{"lang":"en","description":"","over18":false},"PS3":{"lang":"en","description":"##The PlayStation 3 Subreddit (PS3, PlayStation3, Sony PlayStation 3)\n\n****\n\n#[The Official FAQ](http://www.reddit.com/r/ps3/faq)\n\nYour place for:\n\n* News\n* Reviews\n* Questions\n* Opinions\n* Discussion","over18":false},"DebateAnAtheist":{"lang":"en","description":"A place to debate atheists. Pose your best arguments for the supernatural, discuss why your faith is true, and question whether your reasoning is as air-tight as you believe it is. Remember that it is","over18":false},"EngineeringStudents":{"lang":"en","description":"This a place for engineering students of any discipline to discuss study methods, get homework help, get job search advice, and find a compassionate ear when you get a 40% on your midterm after studyi","over18":false},"bodyweightfitness":{"lang":"en","description":"Bodyweightfitness is for redditors who like to use their own body to train, from the simple pullups, pushups, and squats to the advanced bodyweight movements like the planche, one arm chin-ups, or sin","over18":false},"iOSthemes":{"lang":"en","description":"Brought to you by /r/jailbreak, /r/iOSthemes is a subreddit for sharing and discussing themes for jailbroken iOS devices.","over18":false},"ravens":{"lang":"en","description":"Baltimore Ravens Subreddit","over18":false},"thebutton":{"lang":"en","description":"You probably shouldn't press it.","over18":false},"Megaten":{"lang":"en","description":"This is a community for all MegaTen and subseries related news.  Games from the main series Shin Megami Tensei, Persona, Devil Summoner, Devil Survivor, etc. are all discussed here. General Atlus disc","over18":false},"Judaism":{"lang":"en","description":"A place for all Jews and all things Jew~ish","over18":false},"Bass":{"lang":"en","description":"**Reddit's Loudest and Most In-Tune Community of Bassists**\n\nElectric, acoustic, upright, and otherwise. \n\nCommunity resources, and extensive FAQ for players new and old.","over18":false},"Dallas":{"lang":"en","description":"For all things concerning the Dallas/Fort Worth Metroplex","over18":false},"AdoptMyVillager":{"lang":"en","description":"","over18":false},"synthesizers":{"lang":"en","description":"A subreddit for synthesizer topics.","over18":false},"MilitaryPorn":{"lang":"en","description":"High quality images of the military (from all countries).","over18":false},"sandiego":{"lang":"en","description":"The official subreddit San Diego California,  \"America's Finest City\" .  Serving the whole of San Diego community (including the counties)  in the sharing of information, opinion and events to bring u","over18":false},"SSBPM":{"lang":"en","description":"Project M is the premier Brawl modification inspired by Super Smash Bros. Melee's gameplay designed to add rich, technical gameplay to a balanced cast of characters whilst further enhancing the speed ","over18":false},"Flipping":{"lang":"en","description":"A place to discuss tactics and success stories of buying things for a low price and selling them for a higher one.","over18":false},"goodyearwelt":{"lang":"en","description":"The subreddit about quality footwear. Dedicated to informing, teaching, and sharing. Topics include a wide range of brands from Crockett & Jones to Guidi. New product releases, daily discussion and co","over18":false},"3dshacks":{"lang":"en","description":"Nintendo 3DS hacking and homebrew. We are not affiliated with Nintendo or the 3DS brand.","over18":false},"RandomActsOfPolish":{"lang":"en","description":"**Feel like becoming a Fingernail Fairy Godmother and surprising a fellow polish addict with a fantastic free polish, but don't know where to start?** \n\n**Well, here we are! Random Acts of Polish is o","over18":false},"Battlefield":{"lang":"en","description":"/r/battlefield","over18":false},"CapitalismVSocialism":{"lang":"en","description":"A place to debate or discuss capitalism and socialism.","over18":false},"Braves":{"lang":"en","description":"Community to discuss the latest developments in Atlanta Braves baseball.","over18":false},"penguins":{"lang":"en","description":"","over18":false},"TexasRangers":{"lang":"en","description":"A forum dedicated to the Texas Rangers Baseball Club, created by and for fans of the team\n\n","over18":false},"uncensorednews":{"lang":null,"description":"Subreddit no longer exists","over18":null},"milliondollarextreme":{"lang":"en","description":"MDE, your home on the web! SAFE fast downloads, a place to chat and hang out, and SO much more. Please enjoy and come back often.","over18":false},"dirtykikpals":{"lang":"en","description":"A place for the naughtier side of kik. Remember be respectful of others and never post someone's personal information.\n\nRemember to read [our guidelines](http://bit.ly/1HYSHAU) before posting.","over18":true},"bleach":{"lang":"en","description":"A reddit for the Bleach manga & anime by Tite Kubo.","over18":false},"electronicmusic":{"lang":"en","description":"A place to discuss everything electronic music related. \n\n[](https://www.reddit.com/r/electronicmusic \"feature\")\n\n","over18":false},"conspiro":{"lang":"en","description":"We allow intelligent discussion on any topic. We do not tolerate trolling or derogatory remarks.","over18":false},"StardustCrusaders":{"lang":"en","description":"This is the JoJo's Bizarre Adventure subreddit, and while the subreddit is named for Part Three: Stardust Crusaders, it covers all of the manga and various animated series.","over18":false},"CrazyIdeas":{"lang":"en","description":"Is your idea too crazy to work? So crazy it might work? Perfect. ","over18":false},"AskUK":{"lang":"en","description":"For questions you want to know about the UK and its citizens.","over18":false},"infertility":{"lang":"en","description":"We're here for women and men dealing with primary or secondary infertility, pregnancy loss, and/or trouble conceiving. This is the place to go when it feels like everyone is pregnant, except you.","over18":false},"FUTMobile":{"lang":"en","description":"Welcome to the FUTMobile Subreddit! We are here to provide all FIFA Mobile players a place to get news, find strategies, chat, find leagues to join, and make everlasting friends.","over18":false},"croatia":{"lang":"hr","description":"The subreddit for people from or interested in Croatia. Everyone is welcome!","over18":false},"korea":{"lang":"en","description":"A subreddit for news, culture, and life on the Korean Peninsula. Welcome to everyone, including native Koreans, Korean diaspora, and foreigners.","over18":false},"oaklandraiders":{"lang":"en","description":"Reddit home for the Raider Nation","over18":false},"crossfit":{"lang":"en","description":"This SubReddit is for discussion of all things CrossFit, functional fitness, and strength training.  All are welcome!  \n\nThis subreddit is not affiliated with CrossFit Inc.","over18":false},"nostalgia":{"lang":"en","description":"Nostalgia is often triggered by something reminding you of a happier time. Whether it's an old commercial or a book from your past, it belongs in /r/nostalgia. Here we can take pleasure in reminiscing","over18":false},"androidapps":{"lang":"en","description":"A subreddit dedicated to Android apps.","over18":false},"belgium":{"lang":"en","description":"","over18":false},"nursing":{"lang":"en","description":"A place to discuss the topics of concern to the nurses of reddit.  All are welcome.","over18":false},"homelab":{"lang":"en","description":"Welcome to your friendly /r/homelab, where techies and sysadmin from everywhere are welcome to share their labs, projects, builds, etc.","over18":false},"anime_irl":{"lang":"en","description":"relatable screenshots from anime and manga.\n\npost who you are behind the keyboard. all posts must be titled anime_irl.","over18":false},"uwaterloo":{"lang":"en","description":"Unofficial student and alumni-run Reddit for University of Waterloo community.","over18":false},"MakingaMurderer":{"lang":"en","description":"He served 18 years for a crime he didn't commit. Now he's on the line again, and some want to see him put away for good.","over18":false},"ecigclassifieds":{"lang":"en","description":"A place for selling, buying, and trading anything related to electronic cigarettes.","over18":false},"CruciblePlaybook":{"lang":"en","description":"CruciblePlaybook is a subreddit for discussing strategies and techniques for Destiny's Crucible.\n\nTeam tactics, map knowledge, class builds, loadouts, game modes, gun skills and more.","over18":false},"IASIP":{"lang":"en","description":"A sub-reddit for the fans and critics of the show It's Always Sunny In Philadelphia. Discussion of the show, pictures from the show and anything else.","over18":false},"hawks":{"lang":"en","description":"Chicago Blackhawks Hockey: Home of the 6-time Stanley Cup Champions\n\n","over18":false},"ftm":{"lang":"en","description":"Support-based discussion place focused on trans men, trans-masc individuals, and other people assigned female at birth who are trans.","over18":false},"pittsburgh":{"lang":"en","description":"Community curated front page of Pittsburgh's place on the internet.\n\n[Share](/r/pittsburgh/submit) news, events, and thoughts with/about the Pittsburgh community.","over18":false},"tumblr":{"lang":"en","description":"/r/tumblr is your destination for Tumblr related discussions, jokes, screenshots, and more.","over18":false},"KitchenConfidential":{"lang":"en","description":"Home to the largest community of restaurant and kitchen workers on the internet.","over18":false},"indiegameswap":{"lang":"en","description":"This is a subreddit for people for want to trade games and game related items with a focus on Indie (Independently Developed) games but really most anything goes.","over18":false},"XWingTMG":{"lang":"en","description":"A place to discuss the [Star Wars X-Wing Miniatures Game](http://www.fantasyflightgames.com/edge_minisite_sec.asp?eidm=174&esem=1) new expansions, expansion ideas, tactics, balance issues, Alternate r","over18":false},"GooglePixel":{"lang":"en","description":"The (un)official home of #teampixel and the #madebygoogle lineup on Reddit. Get support, learn new information, and hang out in the subreddit dedicated to the Pixel phones, Pixelbook, Pixel Buds, Dayd","over18":false},"NetflixBestOf":{"lang":"en","description":"","over18":false},"WayOfTheBern":{"lang":"en","description":"","over18":false},"PersonalFinanceCanada":{"lang":"en","description":"","over18":false},"Edmonton":{"lang":"en","description":"Edmonton's Local Subreddit! For Edmontonians by Edmontonians!","over18":false},"learndota2":{"lang":"en","description":"Learndota2","over18":false},"newsokunomoral":{"lang":"ja","description":"","over18":false},"WWE":{"lang":"en","description":"A subreddit for fans of World Wrestling Entertainment. This includes WCW, ECW, NXT and whatnot.","over18":false},"GuessTheMovie":{"lang":"en","description":"Guess the name of a movie based on a screenshot! \n\n\nTo play, simply leave a comment with your guess of what the title of the movie is. Win points by correctly identifying shots, or simply by contribut","over18":false},"RandomActsofMakeup":{"lang":"en","description":"A place to share your love of makeup. Make friends and randomly gift and be gifted! ","over18":false},"powerlifting":{"lang":"en","description":"A subreddit for the sport of powerlifting","over18":false},"TryingForABaby":{"lang":"en","description":"This group is for anyone trying for a baby! Come discuss fertility, sex, conception, and learn all about how your body works!","over18":false},"sixers":{"lang":"en","description":"Reddit home of the Philadelphia 76ers, one of the oldest and most storied franchises in the National Basketball Association.","over18":false},"bipolar":{"lang":"en","description":"A safe haven for bipolar related issues. We are a community here not just a help page. Be a part of something that cares about who you are.","over18":false},"OverwatchUniversity":{"lang":"en","description":"r/OverwatchUniversity is a community dedicated to helping players learn and improve by providing a place where they can share and discuss strategies or ideas, ask questions, post guides and more!\n\n","over18":false},"aspergers":{"lang":"en","description":"For safe and helpful conversation with people who have Asperger's Syndrome or live with someone who does. We also welcome people with other autism spectrum conditions.","over18":false},"knitting":{"lang":"en","description":"Warm, fuzzy, sometimes tangled.","over18":false},"FixedGearBicycle":{"lang":"en","description":"/r/FixedGearBicycle is a community dedicated to sharing content surrounding the world of fixed gear bicycles","over18":false},"beards":{"lang":"en","description":"","over18":false},"phish":{"lang":"en","description":"Phish news, discussion and more.","over18":false},"peloton":{"lang":"en","description":"Peloton is the community for professional road cycling. Share links, news, results, transfer rumours & other road cycling tidbits related to the teams, events and riders in the WorldTour.","over18":false},"Nootropics":{"lang":"en","description":"Discussion of nootropics and cognitive enhancers.","over18":false},"LadyBoners":{"lang":"en","description":"A positive community that encourages, enjoys and champions ladyboner-inducers of all types, showing the rest of the internet that, yes, ladies can slobber and objectify too.","over18":false},"minecraftsuggestions":{"lang":"en","description":"The forum of choice for suggesting & discussing additions to the wonderful game of* MINECRAFT!","over18":false},"westworld":{"lang":"en","description":"Subreddit for the HBO series Westworld.","over18":false},"buildapcforme":{"lang":"en","description":"A subreddit dedicated to helping those looking to assemble their own PC without having to spend weeks researching and trying to find the right parts. From basic budget PCs to HTPCs to high end gaming ","over18":false},"AndroidQuestions":{"lang":"en","description":"The place to get help for any problems you have related to your Android device and the Android ecosystem.","over18":false},"buffalobills":{"lang":"en","description":"The home of the Buffalo Bills on reddit, circling the wagons since 2009","over18":false},"heat":{"lang":"en","description":"A subreddit for Miami Heat fans from all over the world!","over18":false},"Gamingcirclejerk":{"lang":"en","description":"Do you guys remember The Witcher 3?","over18":false},"AskEurope":{"lang":"en","description":"Ask Europe!","over18":false},"Toonami":{"lang":"en","description":"The Toonami Subreddit! Saturdays @ 10:00 PM only on Adult Swim!","over18":false},"audioengineering":{"lang":"en","description":"Products, practices, and stories about the profession or hobby of recording, editing, and producing audio.","over18":false},"snowboarding":{"lang":"en","description":"All things snowboarding, /r/snowboarding or \"shreddit\" is the home for shredders of all age, cultures, and abilities.  Whether you are looking for great video clips, gear recommendations, how to land ","over18":false},"RimWorld":{"lang":"en","description":"Discussion, screenshots, and links, get all your RimWorld content here!","over18":false},"MaddenMobileForums":{"lang":"en","description":"Welcome to the Reddit community for Madden NFL Overdrive, the mobile football game by EA Sports. Join our community by subscribing!","over18":false},"skateboarding":{"lang":"en","description":"The Skateboarding Subreddit.","over18":false},"SuggestALaptop":{"lang":"en","description":"A place for prospective laptop buyers to get suggestions from people who know the intimate details of the hardware.","over18":false},"thesims":{"lang":"en","description":"Share your screenshots, questions and creations concerning EA/Maxis' The Sims!","over18":false},"devils":{"lang":"en","description":"The subreddit for fans of the New Jersey Devils of the National Hockey League.","over18":false},"AsiansGoneWild":{"lang":"en","description":"A place for female Asian Redditors to share their NSFW pics.","over18":true},"itookapicture":{"lang":"en","description":"A subreddit about photography techniques and styles. Post your work here to ask for critique, or browse the submissions and ask the photographer how they achieved a certain effect.","over18":false},"halifax":{"lang":"en","description":"Welcome to the subreddit of Halifax Regional Municipality, Nova Scotia, Canada.","over18":false},"premed":{"lang":"en","description":"A place for us neurotic premeds to post links and have discussions with each other.","over18":false},"AppleWatch":{"lang":"en","description":"For all things Apple Watch. Pictures, discussion, rumours, news, watchOS, hardware, and more about the company out of Cupertino.","over18":false},"starbound":{"lang":"en","description":"Starbound is a [space+sandbox+building+exploration] game developed by Chucklefish, a London-based independent game studio!","over18":false},"JusticeServed":{"lang":"en","description":"And we're back","over18":false},"intj":{"lang":"en","description":"For those who score INTJ on MBTI tests. \n\nCheck the [/r/INTJ rules](/r/intj/about/rules/) and the [FAQ](/r/intj/wiki/index#wiki_f.a.q.) before posting. ","over18":false},"circlebroke":{"lang":"en","description":"Doot doot.","over18":false},"StLouis":{"lang":"en","description":"/r/StLouis is dedicated to the news, events, and weird food of the Greater St. Louis and surrounding areas. Please check out our sidebar and wiki for a plethora of knowledge.","over18":false},"collapse":{"lang":"en","description":"Resource depletion and ecological breakdown leading to the end of civilization. ","over18":false},"BuyItForLife":{"lang":"en","description":"For practical, durable and quality made products that are made to last.\n \n**Reminder:** Please use the search function before making a request. \n  \n\n[Mission Statement](http://www.reddit.com/r/BuyItFo","over18":false},"gundeals":{"lang":"en","description":"/r/GunDeals is a community dedicated to the collection, and sharing, of firearm related sales.","over18":false},"crochet":{"lang":"en","description":"","over18":false},"engineering":{"lang":"en","description":"The hub for all content related to the engineering discipline.","over18":false},"Teachers":{"lang":"en","description":"All things education and teaching! Kick back, relax, and grab yourself a cool beverage. Share us all your cool stories or read a lot of them here.","over18":false},"StarWarsLeaks":{"lang":"en","description":"Leaks, spoilers, rumors and news about upcoming Star Wars projects, focusing on  films and television.","over18":false},"StardewValley":{"lang":"en","description":"Stardew Valley is an open-ended country-life RPG, with support for 1–4 players (multiplayer on console will be added in 2018).","over18":false},"walmart":{"lang":"en","description":"Mostly just Walmart stuff. ","over18":false},"AskCulinary":{"lang":"en","description":"/r/AskCulinary provides expert guidance for your specific cooking problems to help people of all skill levels become better cooks, to increase understanding of cooking, and to share valuable culinary ","over18":false},"Redskins":{"lang":"en","description":"Home of The Washington Redskins on Reddit","over18":false},"hcfactions":{"lang":"en","description":"HCFactions, the original hardcore faction server that is based on deathbans, daily events and raiding for over 5 years!","over18":false},"germany":{"lang":"en","description":"English-language discussions and news relating to Germany and German culture.","over18":false},"lifehacks":{"lang":"en","description":"Lifehacks: Uncommon solutions to common problems.","over18":false},"startups":{"lang":"en","description":"The place to discuss startup problems and solutions. Startups are companies that are designed to grow and scale rapidly. \n\n\nJoin the /r/startups Discord: https://discord.gg/yjMZU8g\n\n","over18":false},"announcements":{"lang":"en","description":"","over18":false},"FanTheories":{"lang":"en","description":"Welcome to /r/FanTheories!","over18":false},"vainglorygame":{"lang":"en","description":"This is the OFFICIAL subreddit for Vainglory, the MOBA perfected for touch. Outplay real opponents in this deep, uncompromising real-time MOBA designed and optimized for mobile devices. Fight with lig","over18":false},"conspiratard":{"lang":"en","description":"Please visit /r/Conspiratard2 for (almost) no active moderation! Modmail us if you'd like to post here. ","over18":false},"paintball":{"lang":"en","description":"For all things paintball.","over18":false},"CodAW":{"lang":"en","description":"This Subreddit has moved to /r/CallofDuty!","over18":false},"blackops2":{"lang":"en","description":"This Subreddit has moved to /r/CallofDuty!","over18":false},"southpark":{"lang":"en","description":"A subreddit dedicated to the TV show *South Park*.","over18":false},"torontoraptors":{"lang":"en","description":"Gimme some Raptors news!","over18":false},"stlouisblues":{"lang":"en","description":"The unofficial subreddit of St. Louis Blues Hockey","over18":false},"RealEstate":{"lang":"en","description":"real estate\ninvesting\nlandlords\nlandlord\nborrowing\nlending\nmortgages\nforeclosure\nloan\nhouses\nhouse\napartment\nfinancing\nloans\nbuying a house\nforeclosures\nforeclosure\n","over18":false},"raspberry_pi":{"lang":"en","description":"A subreddit for discussing the Raspberry Pi ARM computer and all things related to it.","over18":false},"wowservers":{"lang":"en","description":"World of Warcraft non-retail server lists and discussion","over18":false},"hookah":{"lang":"en","description":"Come one come all, if you enjoy smoking hookah, making shisha or just chilling with your friends this is the place for you. /r/Hookah is a place to talk about all things related to hookah and hookah a","over18":false},"wholesomememes":{"lang":"en","description":"Welcome to the wholesome side of the internet! This community is for those searching for a way to capture virtue on the internet.","over18":false},"TrueAtheism":{"lang":"en","description":"A subreddit dedicated to insightful posts and thoughtful, balanced discussion about atheism specifically and related topics concerning irreligion and religion generally.","over18":false},"xxketo":{"lang":"en","description":"","over18":false},"Frozen":{"lang":"en","description":"/r/Frozen is the subreddit for Disney's 2013 animated movie, [Frozen.](https://en.wikipedia.org/wiki/Frozen_%282013_film%29)","over18":false},"baltimore":{"lang":"en","description":"Subreddit for the city of Baltimore, Maryland.","over18":false},"japanlife":{"lang":"en","description":"For people already living in Japan - anything relevant to expats living or working in Japan such as lifestyle, food, style, environment, education, technology, housing, work, visas, sport etc.\n\n","over18":false},"gainit":{"lang":"en","description":"Fitness subreddit for information and discussion for people looking to put on weight, strength and muscle. ","over18":false},"falcons":{"lang":"en","description":"","over18":false},"fireemblemcasual":{"lang":"en","description":"A sub-subreddit of r/fireemblem, designed for off-topic discussions, non-Fire Emblem game talks and playthroughs, organizing online game groups, and...whatever else we end up doing!\n\n\nThis sub is for ","over18":false},"nyjets":{"lang":"en","description":"Home of the New York Jets on Reddit.","over18":false},"weightroom":{"lang":"en","description":"A subreddit for general weight training discussion, focused on intermediate level and above in experience and strength, for those ranging from strength sport competitors, sports that benefit from weig","over18":false},"AmericanHorrorStory":{"lang":"en","description":"Fan subreddit for the hit TV series American Horror Story.","over18":false},"short":{"lang":"en","description":"Welcome to /r/short, where everyone is fun sized!","over18":false},"ainbow":{"lang":"en","description":"A free area for the discussion of issues facing those who identify as gay, lesbian, bisexual, transgender, and all other sexual or nonsexual orientations and/or gender identities.","over18":false},"HighQualityGifs":{"lang":"en","description":"Gifs that are better quality than your mother's gifs","over18":false},"custommagic":{"lang":"en","description":"Cards for Redditors, by Redditors","over18":false},"criticalrole":{"lang":"en","description":"Discussion forum for the live D&D show Critical Role on Geek & Sundry, every Thursday night at 19:00 Pacific on https://www.twitch.tv/geekandsundry","over18":false},"Nexus6P":{"lang":"en","description":"A subreddit for the latest news and discussions regarding the Huawei Nexus 6P!","over18":false},"AmISexy":{"lang":"en","description":"i'm fine with yeehaw as a description actually\n","over18":false},"gamernews":{"lang":"en","description":"News about video games","over18":false},"knives":{"lang":"en","description":"Sharp and pointy stuff!","over18":false},"polyamory":{"lang":"en","description":"Polyamory is openly, honestly, and consensually loving and being committed to more than one person.\n\nThis subreddit discusses news, views, and issues around polyamory, polyfidelity, poly people, and r","over18":false},"footballmanagergames":{"lang":"en","description":"One of the largest Football Manager Communities/Forums on the internet. If it is about Football Manager, then it belongs here! ","over18":false},"Habs":{"lang":"en","description":"The home of the Montreal Canadiens on reddit.\n","over18":false},"WaltDisneyWorld":{"lang":"en","description":"Everything Walt Disney World (Orlando,FL)","over18":false},"CasualUK":{"lang":"en","description":"We are looking for lighthearted, fun and interesting content and comments - whether it's an incredible picture you took of your hometown, a discussion you want to have on the best biscuit or a quirky ","over18":false},"picrequests":{"lang":"en","description":"Reddit's Premiere Picture Request Community! Need an old photo touched up? Want someone to make a faceswap for you? Do you need a logo for something? Want your friend to be flying through space on a v","over18":false},"Turkey":{"lang":"en","description":"News and discussion about Turkey. Most posts are in English, but Turkish is more than welcome.","over18":false},"Borderlands2":{"lang":"en","description":"The Borderlands 2 and Borderlands: The Pre-Sequel Reddit. This subreddit accepts external link. You can discuss anything related to Borderlands, Borderlands 2 (BL2), and Borderlands: Pre-Sequel (BL:TP","over18":false},"Columbus":{"lang":"en","description":"Events, get togethers, and suggestions on what to see and do in Columbus, Ohio!","over18":false},"FULLCOMMUNISM":{"lang":"en","description":"Welcome to the glorious subreddit of the glorious land of Lenin, Stalin, and Mao! Military service is compulsory and everyone wins!","over18":false},"Shadowverse":{"lang":"en","description":"Shadowverse is a digital card game developed by Cygames.  This is the subreddit that hosts discussions and facilitates the integration of new players.  The game is available on PC, Mac, iOS, and Andro","over18":false},"applehelp":{"lang":"en","description":"*Welcome to /r/AppleHelp, a place to share technical tips, information, and questions related to Apple hardware and software.*","over18":false},"chess":{"lang":"en","description":"Everything to do with chess. Game analysis, current events, and more!","over18":false},"FrankOcean":{"lang":"en","description":"For everything Frank, Endless but not friendless","over18":false},"excel":{"lang":"en","description":"Discuss and answer questions about Microsoft Office Excel","over18":false},"malaysia":{"lang":"en","description":"A subreddit for Malaysia and all things Malaysian.","over18":false},"lifeisstrange":{"lang":"en","description":"Life is Strange is a series of games, published by Square Enix,  revolving around a heavily story driven narrative that is affected by your choices. The games are being developed by Dontnod Entertainm","over18":false},"Chargers":{"lang":"en","description":"A Subreddit for all talk about the Los Angeles Chargers, part of the NFL in the AFC West division.","over18":false},"Nerf":{"lang":"en","description":"The premier community for enthusiasts of blasters of non-harmful projectiles (darts, straws, disks, balls, bands, water, or anything else) and the culture surrounding them.","over18":false},"AndroidGaming":{"lang":"en","description":"This subreddit is dedicated to everything related to gaming on Android.","over18":false},"carporn":{"lang":"en","description":"High quality images of cars.","over18":false},"destiny2":{"lang":"en","description":"All about Destiny 2: The epic from Bungie.","over18":false},"ems":{"lang":"en","description":"/r/EMS is a subreddit for medical first responders to hangout and discuss anything related to emergency medical services.\n\nFirst aiders to Paramedics, share your world with reddit!","over18":false},"Python":{"lang":"en","description":"news about the dynamic, interpreted, interactive, object-oriented, extensible programming language Python","over18":false},"beertrade":{"lang":null,"description":"Subreddit no longer exists","over18":null},"nonononoyes":{"lang":"en","description":"Things that go horribly wrong until things turn for all right in the last second.","over18":false},"BDSMcommunity":{"lang":"en","description":"","over18":true},"ethereum":{"lang":"en","description":"Next-generation platform for decentralised applications.","over18":false},"medicine":{"lang":"en","description":"**A community for medical professionals.** Please read the rules before posting.","over18":false},"ShouldIbuythisgame":{"lang":"en","description":"Have you ever wanted to buy a game on Steam but didn't know if it was good? Have you ever had just enough money for an indie game but didn't know whether it was worth buying? Have you ever asked yours","over18":false},"BABYMETAL":{"lang":"en","description":"Once you've heard it, you'll never unhear it. BABYMETAL is a band that you'll either love or hate.\n\nAmuse producer Key Kobayashi delved into the unknown and fused Idol (J-Pop) and Metal, creating a su","over18":false},"MrRobot":{"lang":"en","description":"A subreddit for discussing the critically acclaimed USA network TV show *Mr. Robot*. *Mr. Robot* follows Elliot Alderson, a mentally troubled young hacker who is recruited to the hacktivist group *fso","over18":false},"UkrainianConflict":{"lang":"en","description":"News, analysis, discussion and investigative journalism of the conflict in Ukraine. ","over18":false},"Coachella":{"lang":"en","description":"Coachella Valley Music and Arts Festival","over18":false},"forza":{"lang":"en","description":"A subreddit for discussion of the video game series Forza.","over18":false},"GameSale":{"lang":"en","description":"This subreddit is a marketplace for buying and selling console games.","over18":false},"arma":{"lang":"en","description":"Everything about the ARMA game series by Bohemia Interactive on reddit! Game updates, videos, pictures, discussions, help, and more. ","over18":false},"bonnaroo":{"lang":"en","description":"","over18":false},"gravityfalls":{"lang":"en","description":"This subreddit is dedicated to the Disney XD cartoon Gravity Falls, created by Alex Hirsch.","over18":false},"whatsthisbug":{"lang":"en","description":"Come visit us for all your bug identification needs, whether that be insects, spiders, crustaceans, or whatnot!","over18":false},"bayarea":{"lang":"en","description":"All the best things to do, to see, and discuss in the: **San Francisco Bay Area**","over18":false},"kansascity":{"lang":"en","description":"A local subreddit dedicated to the Kansas City metro area. This includes Kansas City, Missouri as well as suburbs in both Kansas and Missouri.\n","over18":false},"40kLore":{"lang":"en","description":"A subreddit for the lore and stories encompassing the dark future of the 41st millennium.\n\nOfficial lore and fan fluff are welcomed.","over18":false},"beermoney":{"lang":"en","description":"/r/beermoney is a community for people to discuss **online** money-making opportunities. You shouldn't expect to make a living, but it's possible to make extra cash on the side for your habits/needs.","over18":false},"newjersey":{"lang":"en","description":"","over18":false},"NoSillySuffix":{"lang":"en","description":"Posts from the network of subreddits which uses that ridiculous suffix.","over18":false},"Screenwriting":{"lang":"en","description":"Beginners to Professionals, we come together to teach, learn, and share everything about Screenwriting!\n\nJoin a community of over 200,000 Screenwriters! ","over18":false},"PhotoshopRequest":{"lang":"en","description":"A friendly place dedicated to requesting and fulfilling free and paid commissions for editing pictures. \n\nRead the sidebar before posting a request or a comment. Any violations of the rules or misbeha","over18":false},"metacanada":{"lang":"en","description":"Canada's only not-retarded subreddit","over18":false},"instant_regret":{"lang":"en","description":"Did I remember to turn the oven off?","over18":false},"linux_gaming":{"lang":"en","description":"A subreddit for gaming on the GNU/Linux operating system.","over18":false},"russia":{"lang":"ru","description":"Anything related to the country of russia. Все, что связано со страной России.\n","over18":false},"trap":{"lang":"en","description":"","over18":false},"popping":{"lang":"en","description":"Pictures and videos about cysts and pimples.","over18":false},"Cyberpunk":{"lang":"en","description":"A genre of science fiction and a lawless subculture in an oppressive society dominated by computer technology and big corporations.","over18":false},"Meditation":{"lang":"en","description":"Experiences, stories and instruction relating to the practice of meditation.","over18":false},"answers":{"lang":"en","description":"Reference questions answered here.","over18":false},"WahoosTipi":{"lang":"en","description":"The unofficial home of the Cleveland Indians","over18":false},"spaceengineers":{"lang":"en","description":"This subreddit is about the game \"Space Engineers\" developed by Keen Software House\n\nhttp://www.spaceengineersgame.com/","over18":false},"Scotch":{"lang":"en","description":"a subreddit for Scotch enthusiasts of all walks of life and of all levels of knowledge on anything Scotch Whisky related.\n","over18":false},"Brawlhalla":{"lang":"en","description":"A subreddit for the fighting game on Steam & PS4 (soon on Xbox One & Switch) called Brawlhalla.","over18":false},"pebble":{"lang":"en","description":"Pebble is an e-paper smartwatch that launched in 2013 and was followed up in 2015.","over18":false},"bourbon":{"lang":"en","description":"We talk about bourbon, rye, or any American whiskey here (yes, even Jack (which is bourbon)). Reviews and discussions are encouraged, check out the stuff we've compiled in the sidebar and our review a","over18":false},"CampingandHiking":{"lang":"en","description":"**Hikers who bring Camping gear in their Backpack.**\n\n*Tips, trip reports, back-country gear reviews, safety and news.*","over18":false},"Cynicalbrit":{"lang":"en","description":"/r/CynicalBrit is an unofficial community dedicated to the discussion of TotalBiscuit's content and other things involving Totalbiscuit.","over18":false},"youtube":{"lang":"en","description":"This subreddit is for discussion around YouTube features, bugs, channels, personalities, and trends.","over18":false},"FFXV":{"lang":"en","description":"In a time unknown, only a prophecy keeps hope alive in people's hearts: \"When darkness veils the world, the King of Light shall come.\"\n\nNow, over 58,000 brave warriors begin their journey, prepared to","over18":false},"mac":{"lang":"en","description":"reddit's Mac community.","over18":false},"Unity3D":{"lang":"en","description":"News, Help, Resources, and Conversation. A User Showcase of the Unity Game Engine.","over18":false},"ApplyingToCollege":{"lang":"en","description":"This subreddit is for anyone looking for advice about college admissions, including college essays, scholarships, SAT/ACT test prep, and anything related to college applications.","over18":false},"askphilosophy":{"lang":"en","description":"","over18":false},"ApocalypseRising":{"lang":"en","description":"This site is dedicated to discussions regarding Apocalypse Rising, the ROBLOX game created by Gusmanak and the Dualpoint Interactive team. You can post whatever you feel suits the subreddit's standard","over18":false},"kancolle":{"lang":"en","description":"A subreddit for the Japanese game about cute WW2 ships fighting cute evil not-WW2 ships.","over18":false},"litecoin":{"lang":"en","description":"For discussion about Litecoin, the leading cryptocurrency derived from Bitcoin. Litecoin is developed with a focus on speed, efficiency, and wider initial coin distribution through the use of scrypt-b","over18":false},"NewOrleans":{"lang":"en","description":"New Orleans regional subreddit. Laissez Les Bon Temps Rouler!","over18":false},"INJUSTICE":{"lang":"en","description":"Reddit Community Home For NetherRealm Studio's Fighting Game Franchise 'Injustice' ","over18":false},"ABraThatFits":{"lang":"en","description":"Because everyone who wants one deserves A Bra That Fits!","over18":false},"fantasyhockey":{"lang":"en","description":"","over18":false},"GiftofGames":{"lang":"en","description":"Gift games to strangers; Receive games from strangers.","over18":false},"FiftyFifty":{"lang":"en","description":"Risky Clicks the Subreddit","over18":false},"ElectricForest":{"lang":"en","description":"Stay up to date with the latest news, tips, guides, and discussion for the 2018 Electric Forest Music Festival.  #ElectricForest","over18":false},"AskThe_Donald":{"lang":"en","description":"A place to discuss Trump, his Administration, and MAGA related topics. Not a safe space.","over18":false},"funhaus":{"lang":"en","description":"Funhaus!","over18":false},"olympics":{"lang":"en","description":"Links and discussion about the Olympics and Paralympics.","over18":false},"twinpeaks":{"lang":"en","description":"A subreddit for fans of David Lynch's and Mark Frost's wonderful and strange television series. We live inside a dream...","over18":false},"LearnJapanese":{"lang":"en","description":"Welcome to r/LearnJapanese, *the* hub on Reddit for learners of the Japanese Language.","over18":false},"firstworldproblems":{"lang":"en","description":"First World Problems.  If it's a problem you can only have if you have money we'll feel bad for you. Then we'll feel guilty for having enough money to have the same problem.","over18":false},"unpopularopinion":{"lang":"en","description":"Got a burning unpopular or controversial opinion you want to share? Spark some discussions!","over18":false},"EatCheapAndHealthy":{"lang":"en","description":"Eating healthy on a cheap budget","over18":false},"college":{"lang":"en","description":"The subreddit to discuss anything related to college.","over18":false},"MobiusFF":{"lang":"en","description":"Welcome to the Mobius Final Fantasy Subreddit, dedicated to the hit Square Enix mobile app. This Subreddit is dedicated towards aiding the community and offering it up-to-date information on Mobius Fi","over18":false},"HeroesofNewerth":{"lang":"en","description":"**This subreddit is based around Heroes of Newerth. A standalone MOBA (Multiplayer Online Battle Arena) based off the old Warcraft 3 custom map, Defense of the Ancients. It is currently being develope","over18":false},"skiing":{"lang":"en","description":"The sport where you strap two boards to your feet and point them down the mountain. Turning optional but not recommended.","over18":false},"stopsmoking":{"lang":"en","description":"This reddit is a place for redditors to motivate each other to quit smoking. We welcome anyone who wishes to join in by asking or giving advice, sharing stories, or just encouraging someone who is try","over18":false},"Piracy":{"lang":"en","description":"A community dedicated to the discussion of digital piracy.","over18":false},"CalgaryFlames":{"lang":"en","description":"","over18":false},"UIUC":{"lang":"en","description":"","over18":false},"AskDocs":{"lang":"en","description":"**Having a minor medical issue?**\n\nAsk a doctor/medical professional on reddit! All flaired medical professionals on this subreddit are guaranteed real and verified by the mods. If you experiencing a ","over18":false},"ScenesFromAHat":{"lang":"en","description":"A play-by-post version of the game \"Scenes From a Hat\" from \"Whose Line is it Anyway?\". (Not affiliated with the show or the CW.)","over18":false},"thebachelor":{"lang":"en","description":"A subreddit to discuss the ABC show The Bachelor and Bachelor Franchise shows.","over18":false},"pussypassdenied":{"lang":"en","description":"Welcome to /r/pussypassdenied, where women are not allowed to use their gender as a handicap or an excuse to act like assholes. Yay equality!","over18":false},"buccos":{"lang":"en","description":"The subreddit for fans of the Pittsburgh Pirates. Let's go Bucs!\n\n","over18":false},"learnpython":{"lang":"en","description":"Subreddit for posting questions and asking for general advice about your python code. ","over18":false},"Colts":{"lang":"en","description":"","over18":false},"GTAV":{"lang":"en","description":"Grand Theft Auto V, also known as GTA 5 or GTA V, is Rockstar North video game currently available for PC, Xbox One, PS4, XBOX 360 and PS3 consoles. It is the fifteenth installment in the Grand Theft ","over18":false},"firstworldanarchists":{"lang":"en","description":"**\"A man flattened by an opponent can get up again. A man flattened by conformity stays down for good.\"**^Thomas Watson, Jr.\n\n","over18":false},"DFO":{"lang":"en","description":"Your first and final stop for everything about Dungeon Fighter Online. Discussions, information, events, trading, and more! Come play DFO with us!\n\nThis is an unofficial fan forum for DFO.","over18":false},"fairytail":{"lang":"en","description":"Fairy Tail is a whimsical and adventurous anime, full of Wizards, Dragons, and Talking cats! The place to be for all discussions, fan art, conversations, Hiro Mashima, and Fairy Tail. ","over18":false},"askcarsales":{"lang":"en","description":"A place to ask questions from car sales professionals - sales people, finance and sales managers. Please note that verified professionals will have flair, take advice from non-flaired users with discr","over18":false},"TalesFromYourServer":{"lang":"en","description":"Customer push you to your limits today? Then you've definitely come to the right place! Here, we totally understand what it's like to have to rely on the generosity of others to make sure you pay your","over18":false},"Aleague":{"lang":"en","description":"Welcome to /r/ALeague, the forum for all Australian and New Zealand football. ","over18":false},"shittyadvice":{"lang":"en","description":"A community for giving and getting the worst advice possible.","over18":false},"PetiteGoneWild":{"lang":"en","description":"This is a sub for the small featured or petite girls of reddit to post themselves for karma.","over18":true},"PipeTobacco":{"lang":"en","description":"A place for those of us who practice the art of smoking pipe tobacco.\n\n\n\n","over18":false},"Diepio":{"lang":"en","description":"A subreddit for the game Diep.io","over18":false},"customhearthstone":{"lang":"en","description":"Welcome to /r/CustomHearthstone!\n\nThis is a growing community to share and discuss cards and ideas for Hearthstone. If you love Hearthstone and game design, you've come to the right place!\n","over18":false},"TopGear":{"lang":"en","description":"The best subreddit in the world","over18":false},"law":{"lang":"en","description":"A place to discuss developments in the law and the legal profession.","over18":false},"badhistory":{"lang":"en","description":"A place for the most uninformed, naive, and wrongheaded comments about history. Think that your opinion plus half a Wikipedia article is as valid (or more so) as the experts in the field? This is the ","over18":false},"Physics":{"lang":"en","description":"The aim of /r/Physics is to build a subreddit frequented by physicists, scientists, and those with a passion for physics. Papers from physics journals (free or otherwise) are encouraged. Posts should ","over18":false},"amiiboSwap":{"lang":"en","description":"Swap 'em!","over18":false},"Eminem":{"lang":"en","description":"","over18":false},"rockets":{"lang":"en","description":"Houston Rockets NBA Houston Basketball","over18":false},"martialarts":{"lang":"en","description":"","over18":false},"occult":{"lang":"en","description":"The Occult: News for armchair and practicing metaphysical skeptics.","over18":false},"photocritique":{"lang":"en","description":"Develop your photography skills with technical critique on your images. Post your own images or provide help to others.","over18":false},"freebies":{"lang":"en","description":"We love links to freebies! Free pointless fun stuff, free shirts, free food, free stickers, free events, free magazines, and anything else free. As long as it's 100% free, it belongs here.\n\n**Make sur","over18":false},"canadaguns":{"lang":"en","description":"This subreddit is for posting news and the discussion of shooting sports in Canada - ownership, firearms, hunting, target shooting, Canadian gun laws, and the like.\n","over18":false},"insanepeoplefacebook":{"lang":"en","description":"Do you have any insane people on your social media feeds? Post screenshots here!","over18":false},"betterCallSaul":{"lang":"en","description":"A subreddit for the Breaking Bad spinoff \"better Call Saul\" starring Bob Odenkirk.","over18":false},"Neverwinter":{"lang":"en","description":"A place to discuss Neverwinter, a free action MMORPG based on the acclaimed Dungeons & Dragons fantasy roleplaying game.","over18":false},"LucidDreaming":{"lang":"en","description":"All about Lucid Dreams. How to, sǝɔuǝıɹǝdxǝ, etc.","over18":false},"Rabbits":{"lang":"en","description":"/r/rabbits is an open community where users can learn, share cute pictures, or ask questions about rabbits. All fluffy bunny lovers are welcome! Please note we are a *house rabbit* subreddit.","over18":false},"DynastyFF":{"lang":"en","description":"Welcome to Dynasty Fantasy Football. Dynasty Leagues are growing and many players are delving in for the first time. While the rules are almost similar, the strategy may be a little different than a n","over18":false},"holdmybeer":{"lang":"en","description":"\"Hey man, hold my beer. Check this out\" the classic words that end in either awesomeness or injury.","over18":false},"MarchAgainstTrump":{"lang":"en","description":"Marching Against Trump","over18":false},"HunterXHunter":{"lang":"en","description":"This subreddit is dedicated to the Japanese manga and anime series Hunter X Hunter, written by Yoshihiro Togashi and adapted by Nippon Animation and Madhouse. Any form of entertainment, information, o","over18":false},"oldpeoplefacebook":{"lang":"en","description":"Grandma and grandpa have finally joined social media, and they love sharing their opinions with everyone.","over18":false},"GirlGamers":{"lang":"en","description":"\"Girl Gamer\" -- One of the most controversial and polarizing terms for women who game (and, sure, maybe one of the cringiest)\n\nThis is a community space for ladies to hang out, talk about gaming, and ","over18":false},"AskEngineers":{"lang":"en","description":"Engineers apply the knowledge of science and math to build maintainable systems and devices to solve problems. AskEngineers is a forum for questions about the processes and standards used to build the","over18":false},"LetsNotMeet":{"lang":"en","description":"A place to read true stories about people you never want to meet again.","over18":false},"CombatFootage":{"lang":"en","description":"A study in combat footage from historical and current events","over18":false},"tea":{"lang":"en","description":"Tea! This subreddit is for discussion of beverages made from soaking camellia sinensis leaves (or twigs) in water, and, to a lesser extent, herbal infusions, yerba mate, and other tisanes.","over18":false},"HFY":{"lang":"en","description":"We're a writing focused subreddit welcoming all media exhibiting the awesome potential of humanity, known as HFY or \"Humanity, Fuck Yeah!\"  \n\nWe welcome sci-fi, fantasy, and all other stories with a f","over18":false},"amateurradio":{"lang":"en","description":"","over18":false},"Breath_of_the_Wild":{"lang":"en","description":"All things The Legend of Zelda: Breath of the Wild! Come and join the discussion about Nintendo's latest open world adventure!","over18":false},"Tribes":{"lang":"en","description":"The official Tribes: Ascend forum and subreddit for the Tribes franchise, which includes Starsiege: Tribes, Tribes 2, Tribes Vengeance, and Tribes: Ascend.  Links to news, articles, and videos are acc","over18":false},"JRPG":{"lang":"en","description":"A subreddit for Japanese Role Playing Games from past and present.","over18":false},"NarutoBlazing":{"lang":"en","description":"The official Naruto mobile gaming experience, Naruto Shippuden: Ultimate Ninja Blazing on iOS and Android.","over18":false},"DIY_eJuice":{"lang":"en","description":"Mix some damn juice.  Read the sidebar.  Blah blah blah.","over18":false},"AskNYC":{"lang":"en","description":"The r/nyc companion for all your NYC-related questions.","over18":false},"Mustang":{"lang":"en","description":"A sub dedicated to the world's most popular pony car.  If you love Ford Mustangs and just about anything related to them, you can probably find something interesting here on a daily basis.","over18":false},"gamingsuggestions":{"lang":"en","description":"","over18":false},"bengals":{"lang":"en","description":"The best source for Cincinnati Bengals news and discussion :3","over18":false},"chemistry":{"lang":"en","description":"A community for chemists and those who love chemistry","over18":false},"danganronpa":{"lang":"en","description":"For fans of the murder-mystery visual novel series Danganronpa.","over18":false},"muacjdiscussion":{"lang":"en","description":"","over18":false},"pkmntcgtrades":{"lang":"en","description":"Trade Pokemon cards online with people all over the world by mail!","over18":false},"dubai":{"lang":"en","description":"A sub for residents, expats, visitors and people interested in Dubai.  Almost anything goes! Keep conversation respectful. Debate is welcome, but Dubai bashing is not. \n\n","over18":false},"pakistan":{"lang":"en","description":"The Front Page of Pakistani Reddit!\n","over18":false},"graphic_design":{"lang":"en","description":"Graphic design is the process of visual communication and problem-solving through the use of typography, photography, and illustration.","over18":false},"GoneMild":{"lang":"en","description":"Like GoneWild, but with clothes on!","over18":true},"FortNiteBR":{"lang":"en","description":"The developer supported, community run subreddit dedicated to the Fortnite: Battle Royale game mode by Epic Games.","over18":false},"blunderyears":{"lang":"en","description":"Do you still cringingly remember \"Fuck drugs and government\", the hardcore hit of your 15 year self?\n\nHave you just found your old myspace picture, xXxLadyDarkness85xXx?\n\nCome and share your dusty tre","over18":false},"FeMRADebates":{"lang":"en","description":"Discuss feminism, egalitarianism, and men's rights activism. Want to be an approved commenter or lurker? Message the mods.","over18":false},"MarioMaker":{"lang":"en","description":"Everything Super Mario Maker and Mario level design.  Official games, user created levels and and rom hacks\n","over18":false},"diabetes":{"lang":"en","description":"For humans living with diabetes: discussion, issues, and news.","over18":false},"Paranormal":{"lang":"en","description":"A community to discuss and share personal paranormal experiences, debunked places, evidence, thoughts and theories.\n \n","over18":false},"northernireland":{"lang":"en","description":"Northern Ireland subreddit.","over18":false},"MCFC":{"lang":"en","description":"A subreddit for fans of Manchester City Football Club.  Come hang out and discuss all things City.","over18":false},"StarVStheForcesofEvil":{"lang":"en","description":"It gets weird and wild in Star VS the Forces of Evil, a DisneyXD show created by Daron Nefcy. The show is about a magical princess with amazing powers who is sent to earth and becomes roommates with a","over18":false},"AgainstGamerGate":{"lang":"en","description":"A fair sub for discussion, with an anti-gamergate leaning. ","over18":false},"lostgeneration":{"lang":"en","description":"For those who did everything our parents told us to do... now what?","over18":false},"starwarstrader":{"lang":"en","description":"This is a place to post trades, find new friends, and discuss all things Star Wars Card Trader!","over18":false},"slashdiablo":{"lang":"en","description":"The official subreddit for a fantastic Diablo II community server.","over18":false},"perth":{"lang":"en","description":"All about the most isolated city in the world and the fabulous people who live there.","over18":false},"GearsOfWar":{"lang":"en","description":"Everything Gears of War.  From Gnasher to Lancer, from Judgment to Esports.  r/GearsOfWar is the front page of Sera's net.","over18":false},"ploungeafterdark":{"lang":"en","description":"Ploungeafterdark is a place where users can discuss many NSFW topics freely, as well as post there own NSFW links to show off and/or converse about. ","over18":true},"natureismetal":{"lang":"en","description":"Badass pictures, gifs and videos of the awesome true brutality of nature","over18":false},"energy":{"lang":"en","description":"","over18":false},"meirl":{"lang":"en","description":"you, me, us, irl, reddit style","over18":false},"Miata":{"lang":"en","description":"A subreddit for all those who have owned, driven, raced, admired or had anything ever to do with a Mazda MX5.","over18":false},"cosplay":{"lang":"en","description":"/r/cosplay: for photos, how-tos, tutorials, cosplay news, etc.\n\nCosplayers (Amateur and Professional) and cosplay fans welcome.","over18":false},"teslore":{"lang":"en","description":"/r/teslore is a subreddit dedicated to the discussion and creation of the vast lore of *The Elder Scrolls*.","over18":false},"MECoOp":{"lang":"en","description":"Find information and other players for the Multiplayer of BioWare's Mass Effect Games\n\n","over18":false},"BokuNoHeroAcademia":{"lang":"en","description":"    For Discussion of the series by Kohei Horikoshi!","over18":false},"bigdickproblems":{"lang":"en","description":"","over18":false},"LawSchool":{"lang":"en","description":"This is a subreddit for law students, lawyers, and those interested in law school.  ","over18":false},"standupshots":{"lang":"en","description":"It's a subreddit for pictures of comedians telling jokes.","over18":false},"deathgrips":{"lang":"en","description":"@deathgripz\n\n\n","over18":false},"JonTron":{"lang":"en","description":"Welcome, to the official JonTron subreddit.","over18":false},"wifesharing":{"lang":"en","description":"Links to original NSFW pictures and videos of couples sharing their sexy and intimate moments.","over18":true},"pumparum":{"lang":"en","description":"A trading community for Dark Souls 3.","over18":false},"HIMYM":{"lang":"en","description":"A subreddit for fans of the show How I Met Your Mother. Discussion of, pictures from, and anything else How I Met Your Mother related. ","over18":false},"norge":{"lang":"no","description":"Et reddit på norsk for norske redditører og norske saker. ","over18":false},"european":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Health":{"lang":"en","description":"Health, a place to discuss health news ","over18":false},"rule34":{"lang":"en","description":"What is Rule34? Simple. \"If it exists there is porn of it. No exceptions.\" This is an adult only subreddit. You must be over the age of 18 or whatever age limit your local law deems fit to view adult ","over18":true},"NFL_Draft":{"lang":"en","description":"National Football League's Draft Of College American Football Players!","over18":false},"nononono":{"lang":"en","description":"Videos and gifs of impending doom.","over18":false},"javascript":{"lang":"en","description":"All about the JavaScript programming language!","over18":false},"texas":{"lang":"en","description":"News, events, and general noise related to the great state of Texas!","over18":false},"GrandTheftAutoV_PC":{"lang":"en","description":"The official subreddit for Grand Theft Auto V PC","over18":false},"Weakpots":{"lang":"en","description":"Love lifting but hate getting shamed for your low numbers? We'd love to have you post here!","over18":false},"gratefuldead":{"lang":"en","description":"A great place to space your face.","over18":false},"LongDistance":{"lang":"en","description":"This is a subreddit about long distance relationships. For anyone considering a LDR, currently in one, or who used to be in a LDR, this is the community for you. We are here for support and advice and","over18":false},"Trucks":{"lang":"en","description":"Due to repeated threads of doxxing and violence against our moderation team, the subreddit is private (read: closed) until further notice. We're working with the admins to resolve these threats. \n\nReq","over18":false},"dfsports":{"lang":"en","description":"A place to share strategies and advice for playing daily fantasy sports.\n\n","over18":false},"surfing":{"lang":"en","description":"Kooks on the internet","over18":false},"kotk":{"lang":"en","description":"Subreddit for the game King of the Kill by Daybreak Game Company","over18":false},"minimalism":{"lang":"en","description":"For those that appreciate simplicity in any form.","over18":false},"hometheater":{"lang":"en","description":"","over18":false},"arduino":{"lang":"en","description":"A place for all things Arduino!","over18":false},"Hunting":{"lang":"en","description":"Hunting related news and personal stories.","over18":false},"nerdcubed":{"lang":"en","description":"The official subreddit dedicated to the Gaming YouTuber and ego known as Nerd³. http://www.nerdcubed.co.uk/","over18":false},"Blink182":{"lang":"en","description":"","over18":false},"Dirtybomb":{"lang":"en","description":"Welcome to /r/DirtyBomb, a community for new, casual, and competitive players. Stay tuned for events and update notes!","over18":false},"MortalKombat":{"lang":"en","description":"/r/MortalKombat is for the posting of all things Mortal Kombat.","over18":false},"esist":{"lang":"en","description":"The subreddit to distill useful information and have discussion on how to best resist the Trump administration and those who enable it. Note well: this is not intended to be just another Anti-Trump ci","over18":false},"Gundam":{"lang":"en","description":"Welcome to r/Gundam! Before you post please check to see if your content or questions have been submitted before! New to Gundam? Please check out our [FAQ](http://www.reddit.com/r/Gundam/wiki/index) f","over18":false},"Ingress":{"lang":"en","description":"**Ingress. The game**\n\nIt's happening all around you. They\naren't coming. They're already here.","over18":false},"stocks":{"lang":"en","description":"Almost any post related to stocks and investment is welcome on /r/stocks.  However, don't hesitate to tell us about a ticker we should know about!\n\nCheck out our wiki and live chat!","over18":false},"AnimalsBeingJerks":{"lang":"en","description":"A place for sharing videos, gifs, and images of animals being jerks.","over18":false},"RandomActsOfBlowJob":{"lang":"en","description":"No-strings-attached blowjobs from a random stranger on the internet? Stranger things happen all the time.\n\nPost if you want to give or receive. Respect both.","over18":false},"windows":{"lang":"en","description":"Windows is a personal computer operating system released by Microsoft as part of the Windows NT family of operating systems.","over18":false},"MtF":{"lang":"en","description":"A subreddit devoted to transgender issues pertaining to male-to-female or MAAB people. \n\nIf you have an article you like, or a worry to talk about, or you just want to vent a bit about trans life, the","over18":false},"marvelheroes":{"lang":"en","description":"Earth 616's most popular Subreddit.\n\nAll things Marvel Heroes Omega related.\n","over18":false},"mountandblade":{"lang":"en","description":"A subreddit and community for the Mount & Blade series, created by TaleWorlds Entertainment.","over18":false},"KansasCityChiefs":{"lang":"en","description":"Home of the Kansas City Chiefs Subreddit","over18":false},"daddit":{"lang":"en","description":"For geek, nerd or neuro-atypical dads.","over18":false},"languagelearning":{"lang":"en","description":"This is a subreddit for anybody interested in the pursuit of languages. All are welcome, whether beginner or polyglot.\n","over18":false},"badeconomics":{"lang":"en","description":"","over18":false},"Nexus5":{"lang":"en","description":"A subreddit for the Google Nexus 5 Smartphone","over18":false},"Madden":{"lang":"en","description":"A community for people who are interested in the Madden video game series","over18":false},"awwnime":{"lang":"en","description":"For all kinds of moe art. Especially cute anime girls and boys being cute.  \n  \nStrictly SFW, with named sources. Content from anime, manga, visual novels, JRPGs, Vocaloids, Touhou, etc, and original ","over18":false},"feet":{"lang":"en","description":"","over18":true},"TokyoGhoul":{"lang":"en","description":"Welcome to /r/TokyoGhoul","over18":false},"OSHA":{"lang":"en","description":"Animated images of OSHA fails, found in training, safety, and instructional videos.","over18":false},"Bravenewbies":{"lang":"en","description":"This subreddit details the exploits of the Brave Collective. ","over18":false},"LabourUK":{"lang":"en","description":"A subreddit of news and discussion concerning the British Labour Party and its affiliates, and the broader labour movement in the UK and UK politics in general.","over18":false},"classicalmusic":{"lang":"en","description":"Whether you're a musician, a newbie, a composer or a listener, welcome. Please turn off your phone, and applaud between threads, not individual posts.","over18":false},"DaystromInstitute":{"lang":"en","description":"A subreddit for in-depth discussion about *Star Trek*.","over18":false},"realmadrid":{"lang":"en","description":"/r/RealMadrid House of the Champions of Europe in Reddit.","over18":false},"Design":{"lang":"en","description":"Welcome to /r/Design","over18":false},"im14andthisisdeep":{"lang":"en","description":"A place to talk about stupid 'deep and meaningful' philosophy found on blogs, tumblr, facebook, reddit, or anywhere else.  Insights that people should have outgrown by the time they were 14.\n\nJaden Sm","over18":false},"AskElectronics":{"lang":"en","description":"A subreddit for practical, component-level design and repair questions on electronic circuits","over18":false},"Buttcoin":{"lang":"en","description":"Shill central","over18":false},"Paleo":{"lang":"en","description":"This subreddit is for anyone following or interested in learning more about an ancestral-style diet, such as paleo, primal, or whatever other names they're falling under these days. \n\nOther topics of ","over18":false},"TrueChristian":{"lang":"en","description":"A subreddit for Christians of all sorts. We exist to be a safe place for discussion between believers on all sides of the fence; conservative, liberal, moderate, and everything in between.","over18":false},"androiddev":{"lang":"en","description":"News for Android developers with the who, what, where when and how of the Android community. Probably mostly the how.\n\nHere, you'll find:\n\n- News for Android developers\n- Thoughtful, informative artic","over18":false},"CarAV":{"lang":"en","description":"For The Car Audio and Video enthusiast! Heads, Subs, EQs, etc... Bring it into our show room. Q&A, Advice, Tips, tricks and tech welcome! Please refer to the links below for basic starting information","over18":false},"PleX":{"lang":"en","description":"For questions and comments about the Plex Media Server. The Plex Media Server is smart software that makes playing Movies, TV Shows and other media on your computer simple.","over18":false},"cincinnati":{"lang":"en","description":"The subreddit for Cincinnati, Ohio, USA.\n\nAn active community of residents and others interested in the happenings in and around the Greater Cincinnati Tristate Area.","over18":false},"rocketbeans":{"lang":"de","description":"Willkommen bei /r/rocketbeans !\nDies ist der Subreddit rund um die RocketBeans und ihren YouTube Content.","over18":false},"Ubuntu":{"lang":"en","description":"The Ubuntu community on Reddit","over18":false},"greece":{"lang":"en","description":"The Greek side of reddit","over18":false},"netflix":{"lang":"en","description":"Netflix discussion, and all things Netflix related! Mods are not Netflix employees.","over18":false},"nashville":{"lang":"en","description":"","over18":false},"crusadersquest":{"lang":"en","description":"Subreddit for the mobile game Crusaders Quest.","over18":false},"notinteresting":{"lang":"en","description":"","over18":false},"TeraOnline":{"lang":"en","description":"For things related to TERA!","over18":false},"FancyFollicles":{"lang":"en","description":"","over18":false},"Cartalk":{"lang":"en","description":"Cartalk is a great place full of many redditors with a wide variety of backgrounds ranging from professional mechanics to guys who have restored entire cars in their garage. Have a question about fixi","over18":false},"Political_Revolution":{"lang":"en","description":"This subreddit is part of the political revolution as envisioned by Senator Bernie Sanders. We represent a movement promoting activism, raising support for progressive candidates, and spreading awaren","over18":false},"linuxmasterrace":{"lang":"en","description":"A subreddit for Linux enthusiasts.","over18":false},"TopMindsOfReddit":{"lang":"en","description":"A subreddit dedicated to showcasing the Top Minds of Reddit.","over18":false},"progun":{"lang":"en","description":"For pro-gun advocacy!\n","over18":false},"speedrun":{"lang":"en","description":"","over18":false},"analog":{"lang":"en","description":"Film Photography subreddit. Ask anything about analog photography, share photos, discuss techniques, gear or famous photographers.","over18":false},"MDMA":{"lang":"en","description":"A subreddit dedicated to harm reduction and the safe use of MDMA/XTC.","over18":false},"AbandonedPorn":{"lang":"en","description":"High quality images of abandoned things and places.","over18":false},"PHP":{"lang":"en","description":"Ask questions about frameworks, try your hand at php golf and strike gold or simply show off your latest work.","over18":false},"circlebroke2":{"lang":"eo","description":"Circlebroke 2 is closed for remodeling.\n\nFeel free to complain on the discord: https://discord.gg/nVuZNc7\n\nor whine at /r/circlebroke420 idk","over18":false},"dogemarket":{"lang":"en","description":"buy and sell things with dogecoin!","over18":false},"southafrica":{"lang":"en","description":"Everything related to South Africa","over18":false},"ClickerHeroes":{"lang":"en","description":"The subreddit for discussion of anything about Clicker Heroes, Clicker Heroes 2, or Ragnarok Clicker.","over18":false},"dirtypenpals":{"lang":"en","description":"A writing subreddit for people 18+ who are looking to find a connection with someone through the written word and erotic conversation. Stop by, find a partner, and enjoy! \n\n","over18":true},"aves":{"lang":"en","description":"","over18":false},"SRSsucks":{"lang":"en","description":"Remember, do not misgender a SRSter, ever. Please refer to them as \"It\" or \"THNG\" when \"BRD\" wont suffice.","over18":false},"Supernatural":{"lang":"en","description":"Subreddit dedicated to the TV show Supernatural on the CW Network, starring Jensen Ackles, Jared Padalecki, and Misha Collins","over18":false},"Steroidsourcetalk":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Marijuana":{"lang":"en","description":"/r/Marijuana is an educational and informative subreddit for Marijuana, dedicated to policy news, advocacy, opinion, health, and discussion.","over18":false},"latterdaysaints":{"lang":"en","description":"/r/latterdaysaints is the largest faithful-only community for members of The Church of Jesus Christ of Latter-day Saints (Mormons) on the internet! If you're a Latter-day Saint (lds), or have question","over18":false},"Granblue_en":{"lang":"en","description":"A subreddit about Granblue Fantasy, a browser/mobile J-RPG.","over18":false},"phoenix":{"lang":"en","description":"Everything hot in and around Phoenix, Arizona","over18":false},"proED":{"lang":"en","description":"This is a support subreddit for those who are suffering with an ED or disordered eating behaviors, regardless of if they are ready to recover or not.","over18":false},"SanJoseSharks":{"lang":"en","description":"**For All Things Black and Teal.**  Any and all discussion regarding the Sharks and its players, prospects, and staff are welcome.  Keep the meme posts to a minimum and be respectful of other teams' f","over18":false},"suggestmeabook":{"lang":"en","description":"Need an idea what to read next? Tell us what you've enjoyed in the past, or what you're looking for, and let the community suggest a book (or books) for you to read!","over18":false},"linguistics":{"lang":"en","description":"**lin⋅guis⋅tics**: the scientific study of human *language*\n\n* what form does it take?\n* how is meaning constructed?\n* how is it structured?\n* how is it produced?","over18":false},"Netrunner":{"lang":"en","description":"A subreddit for the customizable (deck building) card game Android: Netrunner by FantasyFlight Games. Distributed as a Living Card Game (LCG)","over18":false},"ShitPoliticsSays":{"lang":"en","description":"The Worst Political Commentary on Reddit - Boldly Chronicling the Decline of Humanity Since 2013.","over18":false},"EDM":{"lang":"en","description":"The front page of the internet's home for all things EDM. The newest EDM, best throwbacks, EDM top charts & playlists, DJ/Producer **AMA's** and discussions - everything is here, everything is...EDM.","over18":false},"DirtySnapchat":{"lang":"en","description":"A subreddit to share your Snapchat username but with an 18+ twist.  \nSnapchat is an image sharing application for iOS, Android, and Windows Phone, where images are only viewable for a certain amount o","over18":true},"BitcoinAll":{"lang":"en","description":"All Bitcoin News. All Bitcoin discussion. All the time. BitcoinAll.","over18":false},"FellowKids":{"lang":"en","description":"Advertisements and media that totally appeal to the radical youth!","over18":false},"Assistance":{"lang":"en","description":"In this subreddit, we provide assistance of all kinds to all people. With few exceptions, we allow requests for most anything that is legal and ethical. Trade, borrow, request, share, votes, advice, c","over18":false},"punk":{"lang":"en","description":"","over18":false},"F13thegame":{"lang":"en","description":"Offical Subreddit for Friday the 13th: The Game!","over18":false},"sadcringe":{"lang":"en","description":"/r/sadcringe: stuff that makes you cringe in a sad way","over18":false},"NewTubers":{"lang":"en","description":"You're a YouTube Video Creator or Twitch Streamer? NewTubers is the Premiere \"Small Content Creator\" Community, created to allow up-and-coming channels to improve with resources, critiques, and cooper","over18":false},"Pets":{"lang":"en","description":"","over18":false},"ifyoulikeblank":{"lang":"en","description":"A subreddit for people who are in search of new, relevant media - whether it be music, TV shows, movies, or anything else.","over18":false},"nova":{"lang":"en","description":"","over18":false},"GifRecipes":{"lang":"en","description":"Recipes in an easy to follow gif format.","over18":false},"asmr":{"lang":"en","description":"Welcome to /r/ASMR!  \nThis subreddit was created to share videos that elicit this sensation (either intentionally or unintentionally), as well as discuss and try to understand this fascinating physica","over18":false},"futurama":{"lang":"en","description":"*Welcome to the wooorld of tomorrowww!*\n\nHave you ever tried simply closing out of reddit, sitting down with your children, and hitting them?\n\n","over18":false},"Reds":{"lang":"en","description":"Subreddit for fans and followers of the Cincinnati Reds, a Major League Baseball Team. The Reds play in the Central Division of the National League. Polite fans of other teams are always welcome to jo","over18":false},"Berserk":{"lang":"en","description":"For fans of the manga Berserk and its adaptations.","over18":false},"shittyama":{"lang":"en","description":"We know how it is, you want to share your experience as Sir Isaac Newton, but the dumb fucks at r/IAmA demand so-called proof. We aren't bothered by such details, so if you have an \"interesting\" story","over18":false},"FORTnITE":{"lang":"en","description":"Fortnite | Build forts, co-op, kill monsters, find loot, save the day, bacon. |\n\nEPIC Games","over18":false},"trackers":{"lang":"en","description":"A subreddit for discussing public & private trackers.","over18":false},"AskRedditAfterDark":{"lang":"en","description":"Ask Questions when at night time","over18":true},"tipofmypenis":{"lang":"en","description":"TOMT for the things you wouldn't want your mother to see.  For finding that video/set/guy/girl you saw one time, or posting a video/set/girl/guy to find their name/site/sauce/moar.\n\n**This is a safe p","over18":true},"OnePunchMan":{"lang":"en","description":"Hello there! Welcome to r/OnePunchMan, the subreddit for all things related to our caped bald hero! Check the sidebar for information, where to watch the One Punch Man anime (Madhouse Studios) and whe","over18":false},"EnoughLibertarianSpam":{"lang":"en","description":"Sick of all the conspiracy theories, racism, anti-Semitism and general douchebaggery of libertarians? You are not alone! \n\nAward for most Liberty AND Freedom out of Any Political Subreddit on Reddit- ","over18":false},"GenderCritical":{"lang":"en","description":"Welcome to Reddit's most active feminist community! This is a women-centered, radical feminist subreddit to discuss gender from a critical, feminist perspective. ","over18":false},"whatsthisplant":{"lang":"en","description":"A subreddit for the identification of plants. Visitors are encouraged to submit requests as well as help out with identification. ","over18":false},"traaaaaaannnnnnnnnns":{"lang":"en","description":"Moar tranz memes plz!","over18":false},"OaklandAthletics":{"lang":"en","description":"The best A's fan experience online! #RootedInOakland","over18":false},"MassiveCock":{"lang":"en","description":"A subreddit for all straight and gay who love those cocks so big they hurt. Massive Cock is the largest online community in the world for sharing and celebrating big dicks!   \n     \n  \n    \n  \nKeyword","over18":true},"ActionFigures":{"lang":"en","description":"toys\n\naction figures\n\ncollections\n\ncollectors\n\ncomic books\n\ngraphic novels\n","over18":false},"mylittleandysonic1":{"lang":"en","description":"","over18":false},"researchchemicals":{"lang":"en","description":"A dedicated subreddit for the discussion of synthetic psychoactive research chemicals.\n\nStrictly no sourcing.","over18":false},"LeagueofLegendsMeta":{"lang":"en","description":"/r/Leagueoflegendsmeta is for the discussion of metagame and strategy on Summoner's Rift. We welcome all players who want to theorize and discuss the game at a high level with an emphasis on winning a","over18":false},"buccaneers":{"lang":"en","description":"Go Bucs!","over18":false},"ThriftStoreHauls":{"lang":"en","description":"One of the largest internet thrift store forums to share your finds from anywhere thrifty - garage sales, flea markets, pawn shops, and more. Come on over to be a part of our fantastic community where","over18":false},"entp":{"lang":"en","description":"Home of the ENTPs, as described by the Myers-Briggs Type Indicator (MBTI).","over18":false},"beerporn":{"lang":"en","description":"Pictures of beers.","over18":false},"treeofsavior":{"lang":"en","description":"A subreddit dedicated to the MMORPG by former Gravity staff, now IMC Games, Tree of Savior.","over18":false},"Saints":{"lang":"en","description":"","over18":false},"MvC3":{"lang":"en","description":"Welcome to the Ultimate Marvel vs. Capcom 3 subreddit! #MARVELLIVES #MVCI ","over18":false},"touhou":{"lang":"en","description":"Girls are now preparing, please wait warmly and have some tea. Touhou is a series of danmaku shooters which has amassed a surprisingly active and committed fan following. This subreddit is devoted to ","over18":false},"TickTockManitowoc":{"lang":"en","description":"Making a Murderer conversation, discussing the documentary and convictions of Steven Avery and Brendan Dassey.","over18":false},"rant":{"lang":"en","description":"","over18":false},"Robocraft":{"lang":"en","description":"Everything concerning the game Robocraft, from development, to balance, making suggestions, organizing events, or even just posting the best bots people have made. ","over18":false},"avengersacademygame":{"lang":"en","description":"A place to discuss the mobile game Avengers Academy by TinyCo","over18":false},"TownofSalemgame":{"lang":"en","description":"A community for players of the mafia-style online game Town of Salem.","over18":false},"Austria":{"lang":"de","description":"Subreddit für Österreicher und Austrophile, alles mit Österreichbezug ist hier gern gesehen.\n\nSubbreddit for Austrians and Austrophiles, everything relevant to Austria is encouraged here.","over18":false},"DJs":{"lang":"en","description":"A subreddit for general DJ discussion: equipment, techniques, news, music, etc.","over18":false},"LGBTeens":{"lang":"en","description":"A place where LGBTeens and LGBT allies can hang out, get advice, and share content! ","over18":false},"Tennesseetitans":{"lang":"en","description":"Tennessee Titans Subreddit","over18":false},"NatureIsFuckingLit":{"lang":"en","description":"We are here to appreciate the awesome majesty and incredibly cool aspects of nature. 🔥","over18":false},"acturnips":{"lang":"en","description":"A place to post your daily Animal Crossing turnip price. Include your details in your submission.  If you don't think you'll be around to let people into your town, please don't post that day.","over18":false},"blogsnark":{"lang":"en","description":"A place to talk about blogs that the blogs won't let you talk about!","over18":false},"Battleborn":{"lang":"en","description":"Battleborn Subreddit","over18":false},"ipad":{"lang":"en","description":"","over18":false},"motorcitykitties":{"lang":"en","description":"Reddit's Home for the Detroit Tigers","over18":false},"borussiadortmund":{"lang":"en","description":"The Reddit home of all things schwarz-gelb!","over18":false},"StrangerThings":{"lang":"en","description":"Sub for the Netflix Original series: Stranger Things.\n\nThe disappearance of a young boy sparks a chain of events leading the residents of the small town of Hawkins to uncover a government conspiracy a","over18":false},"onewordeach":{"lang":"en","description":"Improv, one word at a time.","over18":false},"thinkpad":{"lang":"en","description":"IBM and Lenovo ThinkPad laptop enthusiasts!\n","over18":false},"Enough_Sanders_Spam":{"lang":"en","description":"Behold! /r/Enough_Sanders_Spam, Flame of the Establishment! Forged from the shills of /r/enoughsandersspam.","over18":false},"xbox360":{"lang":"en","description":"Everything and anything related to the Xbox 360. News, reviews, previews, rumors, screenshots, videos and more!\n\nNote: We are not affiliated with Microsoft in any official capacity","over18":false},"UofT":{"lang":"en","description":"All things pertaining to social, academic, and cultural activities at the University of Toronto.","over18":false},"hoggit":{"lang":"en","description":"","over18":false},"namenerds":{"lang":"en","description":"A community for those interested in, looking for or want to share names. As long as you stay on the topic of names then your posts are welcome.","over18":false},"MineZ":{"lang":"en","description":"","over18":false},"Foodforthought":{"lang":"en","description":"Intelligent and thought-provoking commentaries on life and culture with an emphasis on longform articles and essays that stimulate intellectual discourse.","over18":false},"bisexual":{"lang":"en","description":"This group is for discussion and support for those who fall in between, for the \"shades of gray\" in what is often assumed to be one or the other:    \n\n* bisexuals\n* pansexuals\n* omnisexuals\n* queers\n*","over18":false},"occupywallstreet":{"lang":"en","description":"Occupy Wall Street is a leaderless resistance movement with people of many colors, genders and political persuasions. The one thing we all have in common is that [We Are The 99%](http://wearethe99perc","over18":false},"CLG":{"lang":"en","description":"\"Respect all, Fear none.\"","over18":false},"hapas":{"lang":"en","description":"A Hapa community for multiracial Eurasians, Blasians, Quapas, Hāfus (ハーフ), Hùnxuè'ér  (混血儿), Luk khrueng (ลูกครึ่ง), honhyeol (혼혈), Amerasians (Mỹ lai). We also provide an anti-racist safe space to di","over18":false},"YGOBinders":{"lang":null,"description":"Subreddit forbidden","over18":null},"memes":{"lang":"en","description":"Memes!","over18":false},"Jaguars":{"lang":"en","description":"The spooky subreddit for Jacksonville Jaguars fans.","over18":false},"malehairadvice":{"lang":"en","description":"A subreddit dedicated to helping men improve their hairstyles. ","over18":false},"google":{"lang":"en","description":"For news and announcements from and about Google","over18":false},"weedstocks":{"lang":"en","description":"Business news, resources, picks, and investment discussion for publicly traded marijuana related stocks.","over18":false},"Damnthatsinteresting":{"lang":"en","description":"For things that are amazing, interesting, and incredible!","over18":false},"weightlifting":{"lang":"en","description":"A subreddit for the sport of Olympic-style weightlifting.","over18":false},"SoccerBetting":{"lang":"en","description":"A community for sharing and discussing your favourite vice.","over18":false},"90DayFiance":{"lang":"en","description":"90 Day Fiance: come to learn about the K1 visa process, stay to be frauded by TLC. New episodes every Sunday at 8pm EDT.\n\n\"90DF is the best worst show on TV\" -- The Cut","over18":false},"electricians":{"lang":"en","description":"Welcome Reddit's International Electrical Worker Community. Talk shop, show off pictures of your work, get general help, and ask code related questions. Help your fellow Redditors crack the electrical","over18":false},"infp":{"lang":"en","description":"INFPs never seem to lose their sense of wonder. One might say they see life through rose-colored glasses. It's as though they live at the edge of a looking-glass world where mundane objects come to li","over18":false},"SaltLakeCity":{"lang":"en","description":"A subreddit for Salt Lake City, UT and the surrounding valley.","over18":false},"breastfeeding":{"lang":"en","description":"**This is a community to encourage, support, and educate mothers nursing babies/children through their breastfeeding journey.  Fathers and Partners are also welcome here.**  ","over18":false},"HalfLife":{"lang":"en","description":"","over18":false},"stunfisk":{"lang":"en","description":"Stunfisk is your reddit source for competitive analyses, strategies, and articles for the Pokémon video games. We encourage original content and questions for all battle formats. Want to contribute? D","over18":false},"BattleRite":{"lang":"en","description":"BATTLERITE is an action-packed team arena brawler. Experience the unique combination of a top-down shooter with a fast-paced fighting game. Challenge friends and others in a battle of reaction, unleas","over18":false},"Honda":{"lang":"en","description":"Honda & Acura enthusiasts.","over18":false},"PokeMoonSun":{"lang":"en","description":"A Subreddit dedicated to the Pokémon franchise as a whole, but mainly the 7th generation of core Pokemon games.\n\nFeel free to post anything related to Pokémon here, like discussion topics, speculation","over18":false},"netsec":{"lang":"en","description":"A community for technical news and discussion of information security and closely related topics.","over18":false},"QuotesPorn":{"lang":"en","description":"Words. Beautiful, beautiful words.","over18":false},"kohi":{"lang":"en","description":"","over18":false},"getdisciplined":{"lang":"en","description":"A subreddit for people who have issues with procrastination, motivation, and discipline. It is a great place to gather to meet others with a similar mindset. Meet your goals and improve your life, red","over18":false},"MkeBucks":{"lang":"en","description":"A community for discussing and keeping up with the Milwaukee Bucks, the Wisconsin Herd and all things Bucks basketball.","over18":false},"Glitch_in_the_Matrix":{"lang":"en","description":"\"Eye-witness event(s) that cannot be explained with critical thinking.\"","over18":false},"7kglobal":{"lang":"en","description":"Official Sub-Reddit for the Mobile game Seven Knights! Global and Asia server players unite and discuss strategies, give advice and communicate with one another! Korea server is welcome too!","over18":false},"ArcherFX":{"lang":"en","description":"Archer is an American adult animated television series created by Adam Reed for the FXX network. ","over18":false},"Random_Acts_Of_Pizza":{"lang":"en","description":"**The Original Random Pizza Delivery Service!** Where thousands of pizzas have changed hands between Redditors! Welcome, and make sure you read the rules!","over18":false},"socialskills":{"lang":"en","description":"A place to share your favorite social skills tips, ask for advice, or offer encouragement to others on their social skills journey. Welcome aboard!","over18":false},"starwarsspeculation":{"lang":"en","description":"This is a place for those who want to speculate on any Star Wars news, theories, or new and old leaks from the Star Wars movie franchise coming from Disney. This will be a place for you to post your w","over18":false},"crossdressing":{"lang":"en","description":"A safe space for cross-dressers of all genders, as well as their family and significant others.","over18":false},"solotravel":{"lang":"en","description":"A place for all of those interested in solo travel to share their experiences and stories! ","over18":false},"uberdrivers":{"lang":"en","description":"This subreddit provides a place for Uber drivers to discuss their experiences and for riders to ask about what it's like to drive for Uber.  This subreddit has zero corporate influence from any outsid","over18":false},"piercing":{"lang":"en","description":"","over18":false},"wallpapers":{"lang":"en","description":"Work-safe wallpapers from all over! ","over18":false},"battlecats":{"lang":"en","description":"Adorable cats go wild all over the world! Here's your chance to raise and play with them for free!","over18":false},"Dogtraining":{"lang":"en","description":"DogTraining: A forum on dog training and behavior. Here you'll find content that will help you train your dogs. Dog training links, discussions and questions are encouraged and content related to othe","over18":false},"dvdcollection":{"lang":"en","description":"Movies are our lives! DVD and Blu-ray collectors share pictures of their latest buys and pickups, pictures of their entire collection shelves, we have contests for FREE DVDs, Movie Party nights (watch","over18":false},"PokemonShuffle":{"lang":"en","description":"Feel free to discuss anything related to Pokémon Shuffle. We are aiming to become the number one social network for up-to-date information about this fantastic Pokémon game.","over18":false},"Shadowrun":{"lang":"en","description":"Welcome to /r/Shadowrun, chummer.\n\nHere at /r/Shadowrun we talk shop about all things in the shadows. Discussion is primarily aimed at exploring narratives found in the Sixth World. Mostly the pen and","over18":false},"lowlevelaware":{"lang":"ja","description":"細菌は排除します","over18":false},"WouldYouFuckMyWife":{"lang":"en","description":"A place to share pictures of your hotwife or girlfriend.","over18":true},"DNMUK":{"lang":null,"description":"Subreddit no longer exists","over18":null},"orlando":{"lang":"en","description":"","over18":false},"cycling":{"lang":"en","description":"bikeit!\n\nbike\nbikes\nbicycle\nbicycles\nbicycling\ncycling\n","over18":false},"mbti":{"lang":"en","description":"For all things MBTI. Join us in exploring the 16 personality types.\n\nAll personalities are welcome!","over18":false},"electricdaisycarnival":{"lang":"en","description":"**Not officially associated with Insomniac** For those interested in or are attending any and all events hosted by Insomniac, the main focus being Electric Daisy Carnival Las Vegas. We encourage every","over18":false},"lotr":{"lang":"en","description":"For all things Tolkien, Lord of The Rings, and The Hobbit ...","over18":false},"IWantToLearn":{"lang":"en","description":"Have you ever wanted to learn a martial art, or to play the guitar, or how to program a computer? Have you had difficulty figuring out where to start, what path to take or just wanted some advice to g","over18":false},"privacy":{"lang":"en","description":"The intersection of technology, privacy, and freedom in a digital world.","over18":false},"SketchDaily":{"lang":"en","description":"","over18":false},"GaybrosGoneWild":{"lang":"en","description":"Gone Wild for Bromos","over18":true},"CoonTown":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Destiny":{"lang":"en","description":"Hub for all things Destiny (the streamer, not the game).","over18":false},"booksuggestions":{"lang":"en","description":"This is exactly what it sounds like. In need of a good read? Let us know what you want and we guarantee you'll find a great book, or your money back.","over18":false},"mwo":{"lang":"en","description":"The official reddit for MechWarrior Online.","over18":false},"progmetal":{"lang":"en","description":"A place to discuss music and anything else related to progressive metal.\n\n","over18":false},"woweconomy":{"lang":"en","description":"Welcome to the World of Warcaft Economy Subreddit! We are a thriving community of goblins and gold-makers in WoW.\n\n","over18":false},"Polska":{"lang":"pl","description":"Subreddit dla piszących i czytających po polsku / Polish subreddit.","over18":false},"AutoDetailing":{"lang":"en","description":"A subreddit dedicated to those car enthusiasts and beginners interested in keeping their vehicles clean.","over18":false},"IWantOut":{"lang":"en","description":"Welcome to r/IWantOut: Reddit's expatriate community. Please take a look at the sidebar for some tips for getting the most out of it.","over18":false},"samharris":{"lang":"en","description":"A place to discuss Sam Harris and to have difficult conversations with civility.","over18":false},"snakes":{"lang":"en","description":"","over18":false},"cheatatmathhomework":{"lang":"en","description":"","over18":false},"Charlotte":{"lang":"en","description":"A subreddit for Charlotte, North Carolina. Where residents and visitors alike can share news, events, gatherings, stories, and more.  Tirades, Welcome to Charlotte, Things to do, Buying/Selling, and C","over18":false},"RedLetterMedia":{"lang":"en","description":"Official RedLetterMedia Subreddit","over18":false},"psychology":{"lang":"en","description":"A Reddit community for sharing and discussing science-based psychological material.\n","over18":false},"Pokemonexchange":{"lang":"en","description":"Welcome to the Pokémon exchange! This is the place to buy, sell and trade all things Pokemon-related! If it's Pokémon, it is allowed here!","over18":false},"FifaCareers":{"lang":"en","description":"/r/FIFACareers is dedicated to the Career Mode of EA Sports' FIFA Series. \n\nHave a question about how to better your squad? Want to show off your lineup? Share your experiences and help others with wh","over18":false},"Volkswagen":{"lang":"en","description":"Come post about Volkswagen news and other interests. New models, old classics, whatever you want!","over18":false},"GalaxyS8":{"lang":"en","description":"The only place for news, discussion, photos, and everything else Samsung Galaxy S8.","over18":false},"linuxquestions":{"lang":"en","description":"","over18":false},"theydidthemath":{"lang":"en","description":"And they said math has no real world applications","over18":false},"DataHoarder":{"lang":"en","description":"This is a sub that aims at bringing data hoarders together to share their passion with like minded people.","over18":false},"LAClippers":{"lang":"en","description":"Subreddit for NBA basketball team, the Los Angeles Clippers.","over18":false},"killingfloor":{"lang":"en","description":"[Killing Floor](http://store.steampowered.com/agecheck/app/1250/) is a cooperative survival horror first-person shooter on Windows, Mac, and Linux. Slaughter wave after wave of increasingly brutal exp","over18":false},"UFOs":{"lang":"en","description":"","over18":false},"disney":{"lang":"en","description":"The unofficial subreddit dedicated to exploring everything related to the stories, worlds, and magic of Disney!","over18":false},"milf":{"lang":"en","description":"Moms you'd like to \"friend\"","over18":true},"saplings":{"lang":"en","description":"r/saplings: a place to learn about cannabis use and culture","over18":false},"MandelaEffect":{"lang":"en","description":"The Mandela Effect is a GROUP of people realizing they remember things differently than generally know to be fact.\n","over18":false},"exchristian":{"lang":"en","description":"A community for former Christians of all denominations. ","over18":false},"infj":{"lang":"en","description":"For redditors interested in personality typing, specifically those identifying as or interested in Introverted iNtuitive Feeling Judging persons (INFJs).\n\nKeywords: Myers-Briggs Type Indicator, MBTI, ","over18":false},"SimCity":{"lang":"en","description":"A Subreddit for the discussion of the SimCity Franchise and related City Builder games. ","over18":false},"gopro":{"lang":"en","description":"A community of picture and film oriented users with the shared passion for developing and viewing content created with the GoPro camera systems.","over18":false},"ptcgo":{"lang":"en","description":"A subreddit for players of the official Pokémon Online Trading Card Game","over18":false},"Throwers":{"lang":"en","description":"We like to play with yoyos. Stick around and you may be surprised just how far they've come.","over18":false},"DippingTobacco":{"lang":"en","description":"A community for dipping redditors to come together to share information about dipping/chewing tobacco, or just talk about dippin' and spittin'.","over18":false},"Kossacks_for_Sanders":{"lang":"en","description":"A stronghold of evidence based progressive thought.","over18":false},"TeamSolomid":{"lang":"en","description":"Team SoloMid (TSM) is a North American eSports Organization created around the community website SoloMid.Net in September 2009, by Andy ''Reginald'' Dinh and his brother Dan Dinh. \n\nTSM is one of the ","over18":false},"Republican":{"lang":"en","description":"/r/Republican is a partisan subreddit. This is a place for Republicans to discuss issues with other Republicans.","over18":false},"BustyPetite":{"lang":"en","description":"Petite girls with big tits","over18":true},"timberwolves":{"lang":"en","description":"","over18":false},"motogp":{"lang":"en","description":"Everything and anything from MotoGP, for MotoGP fans.\n\n \n","over18":false},"chromeos":{"lang":"en","description":"Discussions relating to Chromebooks and everything Chrome OS. ","over18":false},"roblox":{"lang":"en","description":"Subreddit for the Roblox game engine and platform.","over18":false},"TheGirlSurvivalGuide":{"lang":"en","description":"This subreddit was created for girls to request tips and share discoveries to aid others in daily life. A survival guide of \"life pro-tips\" for the everyday girl. Post away!","over18":false},"truetf2":{"lang":"en","description":"Subreddit dedicated to serious Team Fortress 2 discussion.","over18":false},"TeenMomOGandTeenMom2":{"lang":"en","description":"Affectionately known as longname, a place to gossip and talk all things related to the Teen Mom and the 16 & Pregnant franchises. ","over18":false},"AskFeminists":{"lang":"en","description":"This is a place to ask feminists your questions and to discuss the issues with feminists. If you've wondered what most feminists think about certain things, what our response is to certain issues, how","over18":false},"asstastic":{"lang":"en","description":"Exclusively for redditors to submit their own photos of their sexy bums. Since some people are simple ass lovers this will make it easier for those ass-aholics to check out pictures that they enjoy.","over18":true},"Ultralight":{"lang":"en","description":"/r/Ultralight is the largest online Ultralight Backpacking community! This sub is about hiking efficiently through the wilderness with a backpack that is as light as possible. Join us and ask yourself","over18":false},"piano":{"lang":"en","description":"All things piano related!","over18":false},"CallOfDuty":{"lang":"en","description":"/r/CallofDuty is the developer-supported, community-run subreddit for the Call of Duty community.\n\nCall of Duty is a first-person shooter video game developed by Treyarch, Infinity Ward, and Sledgeham","over18":false},"NeutralPolitics":{"lang":"en","description":"A heavily moderated community dedicated to evenhanded, empirical discussion of political issues. Based on facts and respectful discussion.","over18":false},"arabs":{"lang":"en","description":"","over18":false},"mw3":{"lang":"en","description":"Subreddit for Call of Duty MW3","over18":false},"zootopia":{"lang":"en","description":"Zootopia is a 2016 Academy Award-winning animated film produced by Walt Disney Animation Studios.","over18":false},"hmmm":{"lang":"en","description":"Internet as an art","over18":false},"PlantedTank":{"lang":"en","description":"A place for aquatic flora and fauna enthusiasts!  Whether you have a question to ask or a planted tank to show off, this is the place.","over18":false},"bakchodi":{"lang":"en","description":"Not to be confused with your mum, t_d, right wing, left wing, commie, conservative, rational, irrational or anything. ","over18":false},"badphilosophy":{"lang":"fr","description":"I'll see you again in 25 years. Meanwhile.\nSpaceX Rockets are Haram || Tentacle Porn Shame-Free Zone","over18":false},"serbia":{"lang":"sr","description":"Serbia: a country of rich history, tradition, and, of course, rakija!","over18":false},"vegetarian":{"lang":"en","description":"","over18":false},"AdvancedRunning":{"lang":"en","description":"","over18":false},"residentevil":{"lang":"en","description":"A community for fans on the CAPCOM series, Resident Evil (aka Biohazard).","over18":false},"Sacramento":{"lang":"en","description":"A forum about Sacramento, for Sacramento.","over18":false},"wsgy":{"lang":"en","description":"Get out.","over18":false},"bestoflegaladvice":{"lang":"en","description":"All the greatest posts from /r/legaladvice in one location!  \n","over18":false},"Animemes":{"lang":"en","description":"Post anime memes here!","over18":false},"aoe2":{"lang":"en","description":"Community for AoE2 players","over18":false},"PhantomForces":{"lang":"en","description":"Phantom Forces is an FPS by ROBLOX game makers StyLIS Studios, comprised of: Litozinnamon, shaylan007, AxisAngle,Semaphorism, IArekan, and HypocriticalDragon. \n\nIn the game, two teams (Phantoms and Gh","over18":false},"Persona5":{"lang":"en","description":"Community for Persona 5 - Come join us and discuss the game.\n\nPersona 5 is a role-playing game in which players live out a year in the life of a high school boy who gains the ability to summon facets ","over18":false},"MemeEconomy":{"lang":"en","description":"/r/MemeEconomy is a place where individuals can buy, sell, share, make, and invest in memes freely. You'll also get updates on the market, and be able to collaborate with other fellow meme traders.","over18":false},"succulents":{"lang":"en","description":"Anything and everything about succulents, a.k.a. \"fat plants,\" welcome here! photos, art, growing tips, sales/trades, news, stories","over18":false},"undelete":{"lang":"en","description":"This subreddit keeps track of submissions that moderators remove from the top 100 in \\/r/all.","over18":false},"SCP":{"lang":"en","description":"Secure. Contain. Protect. The official subreddit for the SCP Wiki.","over18":false},"CannabisExtracts":{"lang":"en","description":"A subreddit for all cannabis extracts - hash, oil, shatter, rosin, tincture, etc - and the people that enjoy them. \r\n\r\nCheck the [/r/CannabisExtracts Rules](/r/CannabisExtracts/about/rules) and [F.A.Q","over18":false},"learnmath":{"lang":"en","description":"Post all your math-learning resources here. Questions, no matter how basic, will be answered (to the best ability of the online subscribers). ","over18":false},"Tekken":{"lang":"en","description":"","over18":false},"conlangs":{"lang":"en","description":"This subreddit is focused on the discussion of conlangs, tools and activities to aid you in the construction of your own conlang, and creating a community environment where we can all enjoy conlanging","over18":false},"spam":{"lang":null,"description":"Subreddit forbidden","over18":null},"wheredidthesodago":{"lang":"en","description":"A subreddit for infomercials taken **out of context** in animated images. This subreddit is for ads that show real aspects of life but in a completely unrealistic way.","over18":false},"vandwellers":{"lang":"en","description":"Tips and tricks for living full time in your van, car or truck. It's a great way to save money or even travel the world.","over18":false},"shutupandtakemymoney":{"lang":"en","description":"Okay, it's 500 dollars, you have no choice of carrier, the battery can't hold the charge and the reception isn't very…\n\n###...SHUT UP AND TAKE MY MONEY!\n\nFor the best, most creative, and classiest gad","over18":false},"Starcitizen_trades":{"lang":"en","description":"Virtual Commodities Exchange for Chris Robert's upcoming space simulator game Star Citizen.\n\n ","over18":false},"rapbattles":{"lang":"en","description":"Rap Battles and anything to do with the Battlerap movement around the world.","over18":false},"coins":{"lang":"en","description":"We welcome longtime collectors as well as brand new collectors and non-collectors. We can help you ID mystery coins, but we'll need clear photos of the coin itself, without a lot of extraneous backgro","over18":false},"TrollYChromosome":{"lang":"en","description":"","over18":false},"USMC":{"lang":"en","description":"Unofficial USMC forum for anything Marine Corps related.","over18":false},"hockeyplayers":{"lang":"en","description":"This is a subreddit for hockey players and coaches. The posts should be about playing hockey, improving your skills, coaching hockey and general discussion of the game. ","over18":false},"firefox":{"lang":"en","description":"The latest news and developments on Firefox and Mozilla, a global non-profit that strives to promote openness, innovation and opportunity on the web.","over18":false},"California":{"lang":"en","description":"The subreddit for the Golden State of California -- for news and info on what's happening all across the state.","over18":false},"GGFreeForAll":{"lang":"en","description":"A Place to Come Apart","over18":false},"blender":{"lang":"en","description":"","over18":false},"trance":{"lang":"en","description":"Trancit: Everything Trance Music.","over18":false},"WouldYouRather":{"lang":"en","description":"","over18":false},"nutrition":{"lang":"en","description":"A subreddit for the discussion of nutrition science.  Macronutrients, micronutrients, vitamins, diets, and nutrition news are among the many topics discussed.\n\nCivil discourse is required.","over18":false},"smallbusiness":{"lang":"en","description":"","over18":false},"visualnovels":{"lang":"en","description":"A community for discussing visual novels, their development, and the medium.","over18":false},"shrooms":{"lang":"en","description":"A place to discuss the growing, hunting, and experience of shrooms. \n","over18":false},"softwaregore":{"lang":"en","description":"poke fun at nasty software","over18":false},"madmen":{"lang":"en","description":"","over18":false},"Fantasy_Football":{"lang":"en","description":"/r/FantasyFootball - Dynasty/Redraft/IDP 365 Days a year.\n\nWe are here to provide the latest Fantasy news, to help commissioners with advice and determining collusion, to ask about your team and who y","over18":false},"hoi4":{"lang":"en","description":"A place to share content, ask questions and/or talk about the grand strategy game Hearts of Iron IV by Paradox Development Studio.","over18":false},"nexus6":{"lang":"en","description":"/r/Nexus6, For all your Nexus 6 needs, just keep it classy.","over18":false},"haskell":{"lang":"en","description":"The Haskell programming language community. Daily news and info about all things Haskell related: practical stuff, theory, types, libraries, jobs, patches, releases, events and conferences and more...","over18":false},"Dentistry":{"lang":"en","description":"Discussions and links of interest for dentists, hygienists and dental assistants on all things dentistry. Questions about dental topics and issues from patients are also welcome. ","over18":false},"2meirl4meirl":{"lang":"en","description":"For relatable posts that are too real for /r/meirl or /r/me_irl","over18":false},"Ifyouhadtopickone":{"lang":"en","description":"We regularly see Reddit posts with two or more beautiful women. The purpose of this subreddit is to have Redditors express their opinions as to which girl in a particular post is the most desirable. L","over18":true},"mcservers":{"lang":"en","description":"/r/mcservers: The public index for Minecraft Servers.\n\n","over18":false},"vzla":{"lang":"es","description":"Reddit de Venezuela","over18":false},"HPfanfiction":{"lang":"en","description":"Fanfic - Hogwarts style!","over18":false},"leaves":{"lang":"en","description":"This is a support and recovery community for practical discussions about how to quit pot, weed, cannabis, edibles, BHO, shatter, or whatever THC-related product you're using, and support in staying st","over18":false},"caps":{"lang":"en","description":"Official Subreddit of the Washington Capitals","over18":false},"ClubTeen":{"lang":"en","description":"","over18":false},"HomeworkHelp":{"lang":"en","description":"","over18":false},"linux4noobs":{"lang":"en","description":"Linux introductions, tips and tutorials. Questions are encouraged. Any distro, any platform!\n\nExplicitly noob-friendly.","over18":false},"navy":{"lang":"en","description":"For anything Navy related, not limited to US Navy.","over18":false},"economy":{"lang":"en","description":"A mostly unmoderated forum for economy, business, politics, stocks, bonds, product releases, IPOs, advice, news, investment, videos, predictions, government, money, politics, debate, capitalism, curre","over18":false},"humor":{"lang":"en","description":"Humor is the place for things that bring a wry smile to your face.\n\n","over18":false},"barstoolsports":{"lang":"en","description":"The official Barstoolsports.com subreddit. This is Barstool Sports. \n\nBy the Common Man, For the Common Man. Viva la Stool.","over18":false},"TrueDetective":{"lang":"en","description":"We get the world we deserve.","over18":false},"whatcarshouldIbuy":{"lang":"en","description":"This is a subreddit for people seeking advice as to what car would best suit them.  Please be specific.","over18":false},"minnesota":{"lang":"en","description":"Minneapolis, Saint Paul, Rochester, Duluth, Bloomington, Plymouth, Brooklyn Park, Saint Cloud, Eagan, Woodbury, Maple Grove, Coon Rapids, Eden Prairie, Burnsville, Blaine, Lakeville, Minnetonka, Apple","over18":false},"dotamasterrace":{"lang":"en","description":"DotAMasterRace (DotA Master Race) is a subreddit dedicated to discussions based on comparisons between DotA 2 and the games it rivals. \n\nWe are a friendly community that will help you get into DotA 2 ","over18":false},"flightsim":{"lang":"en","description":"For all those who love to fly the virtual skies.","over18":false},"Muse":{"lang":"en","description":"Unofficial community for the English rock band Muse. The band consists of Matt Bellamy (lead vocals, guitar, piano, keyboards), Chris Wolstenholme (bass guitar, backing vocals, keyboards) and Dominic ","over18":false},"BurningMan":{"lang":"en","description":"A space for redditors who call Black Rock City home","over18":false},"sanantonio":{"lang":"en","description":"For everything related to the Alamo City, (and places you can drive to within an hour)! Visit us for The Alamo, The Missions world heritage site, Six Flags and Sea World. Interesting posts about nearb","over18":false},"Wet_Shavers":{"lang":"en","description":"Refer to /r/wicked_edge or /r/wetshaving","over18":false},"emulation":{"lang":"en","description":"Emulation News and Discussion.","over18":false},"musictheory":{"lang":"en","description":"A subreddit for people who care about composition, cognition, harmony, scales, counterpoint, melody, logic, math, structure, notation, and also the overall history and appreciation of music.","over18":false},"tampa":{"lang":"en","description":"","over18":false},"wikipedia":{"lang":"en","description":"The most interesting pages on Wikipedia.","over18":false},"Everton":{"lang":"en","description":"","over18":false},"TrueDoTA2":{"lang":"en","description":"A community for DotA 2 players interested in informative and in-depth content surrounding DotA 2, from technical strategy, to helpful resources, to pro-match discussions.","over18":false},"shortscarystories":{"lang":"en","description":"A writing subreddit for original horror stories in 500 words or less. ","over18":false},"Astronomy":{"lang":"en","description":"Everything to do with **Astronomy**: \n\nThe amateur hobby of man since the dawn of time and scientific study of celestial objects.","over18":false},"ftlgame":{"lang":"en","description":"A subreddit to discuss the Kickstarter-backed \"roguelike-like\" game FTL: Faster Than Light by Subset Games.","over18":false},"gonewild30plus":{"lang":"en","description":"Gone Wild 30+ is for women ages 30+ to post nude photos of themselves. Although \"30+\" is open-ended, in general this is not a subreddit for granny porn. Instead, it's ages thirty-something into fortie","over18":true},"flashlight":{"lang":"en","description":"We discuss quality flashlights and lights of all types including:  \nEDC, keychain, headlamps, lanterns, weapon, work, and many others. \n\nReviews are also welcomed here.","over18":false},"needadvice":{"lang":"en","description":"NeedAdvice is a subreddit for receiving advice about things going on in our lives, but not including advice about anyone's relationship.","over18":false},"ColoradoAvalanche":{"lang":"en","description":"The Official Subreddit of the Colorado Avalanche","over18":false},"HillaryForPrison":{"lang":"en","description":"Hillary Clinton for Prison -- LOCK HER UP!! IT'S WHERE SHE BELONGS. We believe Hillary Clinton should should be in federal prison for decades. Crooked Hillary has been fleecing the American public for","over18":false},"nsfw_gifs":{"lang":"en","description":"All the best NSFW gifs!","over18":true},"RedditDads":{"lang":"en","description":"A subreddit dedicated to providing a welcoming environment for mature gamers to gather and discuss, free from the annoyance of Squeakers, trolls and people who don't understand the responsibilities of","over18":false},"CalamariRaceTeam":{"lang":"en","description":"The best place for new motorcycle riders to learn about motorcycling!","over18":false},"MadeMeSmile":{"lang":"en","description":"A place to post things that made you smile or brightened up your day. A generally uplifting subreddit. ","over18":false},"C25K":{"lang":"en","description":"Anything related to the [Couch to 5k](http://www.coolrunning.com/engine/2/2_3/181.shtml) running programs or the like; open to all, noobie to pro.","over18":false},"Brewers":{"lang":"en","description":"","over18":false},"poppunkers":{"lang":"en","description":"The front page for all Pop Punk related content!","over18":false},"Eyebleach":{"lang":"en","description":"eyebleach","over18":false},"electronics":{"lang":"en","description":"A subreddit dedicated to news, articles and discussions related to electronic systems and circuits.\n","over18":false},"RoomPorn":{"lang":"en","description":"High quality images of rooms.","over18":false},"HumansBeingBros":{"lang":"en","description":"A place for sharing videos, gifs, and images of people being total bros.","over18":false},"TalesFromTheFrontDesk":{"lang":"en","description":"A place where people from the hotel industry can come and share the stories of the things our guests do and say that make customer service the hated job that it is. ","over18":false},"NBASpurs":{"lang":"en","description":"","over18":false},"pkmntcg":{"lang":"en","description":"","over18":false},"wildhockey":{"lang":"en","description":"The Minnesota Wild are a professional ice hockey team based in St. Paul, Minnesota, United States. They are members of the Central Division of the Western Conference of the National Hockey League (NHL","over18":false},"Dexter":{"lang":"en","description":"A sub-reddit for the fans and critics of the show Dexter. Discussion of the show, pictures from the show and anything else Dexter related. ","over18":false},"swordartonline":{"lang":"en","description":"The official subreddit to discuss the Sword Art Online series, as well as the other series (Accel World, The Isolator) written by Reki Kawahara.","over18":false},"ultimate":{"lang":"en","description":"For Ultimate, formerly known as Ultimate Frisbee, players and fans.","over18":false},"dubstep":{"lang":"en","description":"A place for sharing, finding, and discussing music in the Dubstep genre. ","over18":false},"Baking":{"lang":"en","description":"For all your baking needs!\nRecipes, ideas and all things baking related.\n\nCakes, cookies, pies, tarts, muffins, scones, short- rye- wheat- and naan breads welcome! ","over18":false},"Reformed":{"lang":"en","description":"/r/Reformed exists to be a place where believers can come together in unity by the bonds of the Gospel to exhort one another, spur one another on intellectually in reformed theology, discuss doctrine ","over18":false},"EdmontonOilers":{"lang":"en","description":"A subreddit for the Edmonton Oilers of the National Hockey League. 5x Stanley Cup Champions.","over18":false},"podcasts":{"lang":"en","description":"/r/podcasts is for podcasters to discuss content creation and techniques, and for podcast listeners to discover, discuss, and review podcasts. \n","over18":false},"mflb":{"lang":"en","description":"Welcome to the home of the reddit Magic-Flight community. This subreddit exists to help the people who find their way here after reading the Flight Guide included with new M-F products. We also welcom","over18":false},"Disneyland":{"lang":"en","description":"A subreddit dedicated to the Disneyland Resort located in Anaheim, California.","over18":false},"mtgfinance":{"lang":"en","description":"Speculat(e/ing)\n\n1. form a theory or conjecture about a subject without firm evidence.\n\n2. invest in stocks, property, or other ventures in the hope of gain but with the risk of loss.\n\nThis is Reddit'","over18":false},"verizon":{"lang":"en","description":"Welcome to the new /r/Verizon! \n\nNow a community to discuss and ask questions about anything and everything Verizon, be it Wireless, FiOS, DSL, Landline, etc.","over18":false},"Connecticut":{"lang":"en","description":"Live in Connecticut? Travel the likes of 91, 84, 95 or the dreaded Merritt? You belong here! Our subreddit is dedicated to connecting the redditors of Connecticut so they may share their experiences w","over18":false},"wargame":{"lang":"en","description":"This subreddit is for the Wargame RTS series for the PC.","over18":false},"IncelTears":{"lang":"en","description":"IncelTears is a part-mocking, part-watchdog subreddit for posting screenshots of hateful, misogynist, racist, violent, and often bizarre content created by \"incels\" (hateful involuntary celibates). We","over18":false},"RandomActsofCards":{"lang":"en","description":"This is a subreddit for anyone who would like to give or receive a card for any reason, be it for you or for someone you know.  They may be birthday cards, sympathy, support, as a special surprise, a ","over18":false},"MakeupRehab":{"lang":"en","description":"Welcome! MakeupRehab is a place for those who are on a no-buy, low-buy, or just want to talk makeup and beauty without being bombarded with sales, hauls, and other tempting posts. Let's ramp up the cr","over18":false},"Feminism":{"lang":"en","description":"Discuss and promote awareness of issues related to equality for women.","over18":false},"CODGhosts":{"lang":"en","description":"This Subreddit has moved to /r/CallofDuty!","over18":false},"GalaxyS7":{"lang":"en","description":"**Home of the Samsung Galaxy S7 | S7 Edge.**","over18":false},"blackladies":{"lang":"en","description":"The face of Black women on Reddit!","over18":false},"CatsStandingUp":{"lang":"en","description":"A world-renowned hub for all things cat (standing up).","over18":false},"wine":{"lang":"en","description":"A place to share all the latest happenings in the world of wine... the beverage, not the software.","over18":false},"thelastofus":{"lang":"en","description":"The Last of Us is an action-adventure survival horror video game developed by Naughty Dog and published by Sony Computer Entertainment. Players control Joel, a man tasked with escorting a young girl n","over18":false},"rarepuppers":{"lang":"en","description":"this is for rare puppers, sometimes other animols are allowed if they're cute :)\n","over18":false},"unixporn":{"lang":"en","description":"Submit screenshots of all your *NIX desktops, themes, and nifty configurations, or submit anything else that will make ricers happy. Maybe a server running on an Amiga, or a thinkpad signed by Bjarne ","over18":false},"beatles":{"lang":"en","description":"A subreddit dedicated to the greatest band of all time: Ladies and gentlemen, The Beatles!","over18":false},"traps":{"lang":"en","description":"/r/traps is for the posting of photos and video of young and beautiful traps. Content can be from/of anyone as long as they're very passable, feminine and if it features nudity 18+ age only","over18":true},"RATS":{"lang":"en","description":"A subreddit for all things pet rats!","over18":false},"FutureFight":{"lang":"en","description":"News, strategy, questions, boasts, wishful thinking, and any other general discussion on the MARVEL game for smartphones and tablet.","over18":false},"Braveryjerk":{"lang":"en","description":"Ed Balls","over18":false},"skrillex":{"lang":"en","description":"A subreddit dedicated to Sonny Moore & his 'Skrillex' project. The largest community dedicated to all things Skrillex & OWSLA.","over18":false},"VictoriaBC":{"lang":"en","description":"A subreddit for residents of the CRD.","over18":false},"ass":{"lang":"en","description":"An art reddit to enjoy artistic views of female bottoms of the highest caliber.","over18":true},"WoT":{"lang":"en","description":"Subreddit for the Wheel of Time fantasy series by Robert Jordan and Brandon Sanderson.","over18":false},"Frat":{"lang":"en","description":"Because reddit is the anti-frat","over18":false},"ronpaul":{"lang":"en","description":"Discussion about Ron Paul, his Campaign for Liberty organization, related political issues and other libertarian-leaning candidates for public office in the United States.","over18":false},"1200isplenty":{"lang":"en","description":"Whether you want to lose weight through calorie counting, or you're a smaller person who doesn't need more than 1200 calories a day, this is the place for you.\n\nTips, recipes and support for people in","over18":false},"Rockband":{"lang":"en","description":"A subreddit for all things Rock Band.","over18":false},"Bioshock":{"lang":"en","description":"This subreddit is dedicated to the BioShock game series developed by Irrational Games and 2K.","over18":false},"Blackfellas":{"lang":"en","description":"Everyone is free to contribute to this community - just keep in mind the main purpose of this sub is to contribute positively to a black community on Reddit. ","over18":false},"transformers":{"lang":"en","description":"","over18":false},"Detroit":{"lang":"en","description":"","over18":false},"computers":{"lang":"en","description":"This subreddit is for general discussion of computers.","over18":false},"parrots":{"lang":"en","description":"This is a community for the discussion of parrots.  Feel free to talk about parrots in the wild, owning parrots, the pet trade, rescuing parrots, purchasing parrots, avian veterinarians, and anything ","over18":false},"retrogaming":{"lang":"en","description":"For those of us who still love the golden-age of video games, before it was all about the graphics. Atari, Intellevision, ColecoVision, Vectrex, Sega, Nintendo, DOS, and more. It's all good here as lo","over18":false},"ProRevenge":{"lang":"en","description":"Have a story of you or someone you know getting back at someone with pro revenge after being wronged? Post it here! ","over18":false},"lost":{"lang":"en","description":"A subreddit for the fans and critics of the show Lost. Discussion of the show, pictures from the show, and anything else Lost related. ","over18":false},"EvolveGame":{"lang":"en","description":"Official Subreddit for the Evolve game, a AAA game from Turtle Rock Studios and 2K.","over18":false},"ColoradoRockies":{"lang":"en","description":"The official Subreddit of your Colorado Rockies. The Rockpile is home to over 7200 avid and supportive fans who want Todd and Larry in the Hall of Fame and to keep Rocktober rolling year round.","over18":false},"GamePhysics":{"lang":"en","description":"Gifs and videos of game physics and glitches","over18":false},"BigBoobsGW":{"lang":"en","description":"Boobs. Of redditors. That are big.","over18":true},"somethingimade":{"lang":"en","description":"","over18":false},"freedonuts":{"lang":"en","description":"Due to circumstances beyond our control we can only give donuts, and only to a limited amount of people, the sub is set for only givers to post on...","over18":false},"Divorce":{"lang":"en","description":"Contributors to this sub are going through a divorce, have been through one, or are contemplating the decision.  Some of us initiated our divorce, others were \"dumped.\"  Some divorces involved infidel","over18":false},"gay":{"lang":"en","description":"**/r/Gay is an 60,000+ strong community of six years based on pride and support.**   \n      \nKeywords: gay, lesbian, LGBT, homosexual, gaybros, askgaybros, gaymers, ask, share, news, discuss, men, wom","over18":false},"whitepeoplegifs":{"lang":"en","description":"Bring your strongest sunscreen, it's about to get bright.","over18":false},"StreetFights":{"lang":"en","description":"A subreddit devoted to street fighting videos and discussion.","over18":false},"scuba":{"lang":"en","description":"Welcome to /r/scuba where scubbits dive deep! Ask questions and trade tips with a diverse community of divers, from open water newbies to dive instructors, commercial divers and scientists from around","over18":false},"EscapefromTarkov":{"lang":"en","description":"The unofficial Subreddit for Escape From Tarkov, a Hardcore FPS being created by Battlestate Games.","over18":false},"Louisville":{"lang":"en","description":"http://en.wikipedia.org/wiki/Louisville,_Kentucky\n\nThe settlement that became the city of Louisville was founded in 1778 by George Rogers Clark and is named after King Louis XVI of France, making Loui","over18":false},"dadjokes":{"lang":"en","description":"A homely place for the jokes that make you laugh and cringe in equal measure. If it's good because it's bad or so bad that it's good, this is where it belongs.","over18":false},"slowcooking":{"lang":"en","description":"r/Slowcooking is a food-related subreddit for sharing ideas, recipes or pictures in which a \"slow cooker\" was used in the preparation of meals.\n\nMany people think a slow cooker is named a \"crock-pot,\"","over18":false},"sewing":{"lang":"en","description":"This is a community specifically for sewing including, but not limited to: machine sewing, embroidery, quilting, hand sewing, tapestry, patchwork,  and help/suggestions threads.","over18":false},"elderscrollslegends":{"lang":"en","description":"Subreddit dedicated to The Elder Scrolls: Legends card game.","over18":false},"unturned":{"lang":"en","description":"Unturned 2.0, 3.0 and II discussion.","over18":false},"recipes":{"lang":"en","description":"Improve and share your cooking repertoire with recipes from reddit's community.","over18":false},"bangtan":{"lang":"en","description":"A subreddit dedicated to the South Korean boy group 방탄소년단, most commonly known as BTS, Beyond the Scene, or Bangtan Boys.\n\nNews, images, videos, discussions, and anything else that relates are welcome","over18":false},"ANormalDayInRussia":{"lang":"en","description":"Gifs/Video/Pics of your everyday occurrence in Russia or the surrounding areas. Bonus points if not common in the rest of the world","over18":false},"Thunder":{"lang":"en","description":"Subreddit for the OKC Thunder","over18":false},"tappedout":{"lang":"en","description":"This is a community for discussing items related to The Simpsons: Tapped Out mobile game.","over18":false},"IndieGaming":{"lang":"en","description":"We love indie games, you should too!","over18":false},"Bonsai":{"lang":"en","description":"Bonsai trees and associated plants. Focussing on styling bonsai, showing member's trees, bonsai care and general help.","over18":false},"Briggs":{"lang":"en","description":"A subreddit for the predominantly Australian server of Briggs, on Planetside 2.","over18":false},"ARK":{"lang":"en","description":"Welcome to the Ark: Survival Evolved Subreddit","over18":false},"FloridaGators":{"lang":"en","description":"The Front Page for Florida Gators related content: OC, analysis, opinion, news and discussion","over18":false},"BetterEveryLoop":{"lang":"en","description":"For animated gifs and similar formats, that get better the longer you watch them.","over18":false},"iamverybadass":{"lang":"en","description":"People trying too hard to appear tough.","over18":false},"cocktails":{"lang":"en","description":"","over18":false},"Harley":{"lang":"en","description":"Anything and everything related to Harley-Davidson motorcycles","over18":false},"MotoX":{"lang":"en","description":"A subreddit for the Motorola Moto X.\n","over18":false},"Morrowind":{"lang":"en","description":"The Elder Scrolls III: Morrowind","over18":false},"Wordpress":{"lang":"en","description":"**Welcome to r/WordPress**\nA Reddit devoted to all things WordPress","over18":false},"NUFC":{"lang":"en","description":"A subreddit for anything related to NUFC.","over18":false},"The100":{"lang":"en","description":"","over18":false},"DeepIntoYouTube":{"lang":"en","description":"A place to venture into the deep, dark depths of youtube to find things you never thought you would. \n","over18":false},"giantbomb":{"lang":"en","description":"A website about a website about videogames","over18":false},"sailing":{"lang":"en","description":"/r/Sailing is a place to ask about, share, show, and enjoy all about sailing, sail boat racing, and technical discussions.  As long as it is about sailing, it is welcome here.\n\n","over18":false},"Mcat":{"lang":"en","description":"The #1 social media platform for MCAT advice. The MCAT (Medical College Admission Test) is offered by the AAMC and is a required exam for admission to medical schools in the USA and Canada. /r/MCAT is","over18":false},"gorillaz":{"lang":"en","description":"The subreddit for Gorillaz fans. Music, art, and discussions. It's all here!","over18":false},"WatchItForThePlot":{"lang":"en","description":"The story in TV shows always keep you interested in watching so here is a subreddit all about plot! Females, only!","over18":true},"pokemonduel":{"lang":"en","description":"Subreddit to discuss Pokemon Duel, the new mobile strategy game from The Pokemon Company","over18":false},"orangecounty":{"lang":"en","description":"/r/OrangeCounty - subreddit for Orange County, California","over18":false},"penis":{"lang":"en","description":"PENIS PENIS PENIS!!!","over18":true},"nexus4":{"lang":"en","description":"A place for everything related to the Google Nexus 4.","over18":false},"gamingpc":{"lang":"en","description":"All about gaming hardware for the PC:\n\n* Custom build pictures\n* Hardware Reviews\n* Hardware Discussion\n* Hardware Benchmarks\n* Guides\n\n\nInternal hardware and gaming peripherals, from mainboards to mi","over18":false},"LiveFromNewYork":{"lang":"en","description":"**Saturday Night Live**. Sketches, videos, interviews, live discussions, episode rankings... If it's about *SNL*, we'll take it.\n\nBut first, **LIVE FROM NEW YORK, IT'S SATURDAY NIGHT!**","over18":false},"giftcardexchange":{"lang":"en","description":"Trade your gift cards with other redditors and get what you really want!","over18":false},"TrueFilm":{"lang":"en","description":"An in-depth discussion of film","over18":false},"GameStop":{"lang":"en","description":"","over18":false},"chiliadmystery":{"lang":"en","description":"/r/ChiliadMystery was originally founded as a place to understand the mural found at the summit of Mt. Chiliad in Grand Theft Auto V.\n\nSince then our goal has expanded to also definitively *explain* u","over18":false},"freemasonry":{"lang":"en","description":"The main Reddit sub for Masonic Masons and Freemasonry","over18":false},"borrow":{"lang":"en","description":"/r/Borrow is a subreddit aimed at helping individuals in the Reddit Community who are in dire need of monetary assistance and will be able to pay it back in a short period. While any user who meets ou","over18":false},"Shoplifting":{"lang":null,"description":"Subreddit no longer exists","over18":null},"enoughsandersspam":{"lang":"en","description":"America needs leaderful (not leadered, not leaderless) movements.  Real change comes from episodic revolutions and constructive acts of civil disobedience, not from relying on any one leader...","over18":false},"GradSchool":{"lang":"en","description":"Discussion forum for current, past, and future students of any discipline completing post-graduate studies - taught or research.","over18":false},"BPD":{"lang":"en","description":"A place for those who have Borderline Personality Disorder, their family members and friends, and anyone else who is interested in learning more about the disorder","over18":false},"gatekeeping":{"lang":"en","description":"Gatekeeping is when someone takes it upon themselves to decide who does or does not have access or rights to a community or identity. /r/gatekeeping is a subreddit for screenshots and stories of gatek","over18":false},"hackintosh":{"lang":"en","description":"A subreddit dedicated to running macOS on non standard Apple hardware. ","over18":false},"incest":{"lang":"en","description":"Fun for the whole family. Heh.\n\n/r/Incest is a discussion-based subreddit focused on sharing fiction, non-fiction, and confessions of an incestuous nature. We also encourage people seeking advice abou","over18":true},"TaylorSwift":{"lang":"en","description":"A subreddit for Taylor Swift news, music, discussion, etc.","over18":false},"leangains":{"lang":"en","description":"","over18":false},"joinsquad":{"lang":"en","description":"Squad is a teamwork oriented tactical shooter being made by the Canadian-based Offworld Industries. It is the spiritual successor to the critically acclaimed and highly successful Battlefield 2 mod ca","over18":false},"ShitWehraboosSay":{"lang":"en","description":"","over18":false},"katawashoujo":{"lang":"en","description":"A community for the visual novel Katawa Shoujo.","over18":false},"civbattleroyale":{"lang":"en","description":"The Official Portal for All Things Civ Battle Royale Related! Dive on into the Sub!","over18":false},"Stargate":{"lang":"en","description":"All things dedicated to the 1994 Stargate movie and the MGM franchise: SG-1, Atlantis, Universe, Origins, video games and everything else.","over18":false},"ketorecipes":{"lang":"en","description":"","over18":false},"gamindustri":{"lang":"en","description":"A place to discuss all things from Hyperdimension Neptunia. Lets show some love for those CPUs and their candidates.","over18":false},"RandomKindness":{"lang":"en","description":"A subreddit that specializes in gift giving. We function on a system of OFFER (Giving away something for free) and REQUEST (Asking if someone will give you something).\n\nYou can offer or request just a","over18":false},"ReefTank":{"lang":"en","description":"","over18":false},"minerapocalypse":{"lang":"en","description":"We are [a themed Minecraft server](http://minerap.com) focusing on a post-apocalyptic experience. On this subreddit we will update you with news about the server.","over18":false},"pornfree":{"lang":"en","description":"","over18":false},"eldertrees":{"lang":"en","description":"A friendly haven for ents 18+.","over18":false},"Hawaii":{"lang":"en","description":"","over18":false},"darkestdungeon":{"lang":"en","description":"Subreddit dedicated to the game Darkest Dungeon by Red Hook Studios.","over18":false},"yoga":{"lang":"en","description":"","over18":false},"wisconsin":{"lang":"en","description":"A local subreddit for the State of Wisconsin. Post news and interesting links about the greatest state in the Union!","over18":false},"happy":{"lang":"en","description":"Too many depressing things on the main page, so post about what makes you warm and fuzzy inside!","over18":false},"azdiamondbacks":{"lang":"en","description":"","over18":false},"PvZGardenWarfare":{"lang":"en","description":"This subreddit is for everything Plants vs Zombies: Garden Warfare 1 and 2! Come on over to discuss the game, interact with PopCap developers, and share your Garden Warfare videos and fun experiences!","over18":false},"dresdenfiles":{"lang":"en","description":"Reddit's Home for the Dresden Files book series by Jim Butcher.\n\nFeel free to discuss the books, television series, comic books, RPG, and other works by Jim Butcher (such as Codex Alera and Cinder Spi","over18":false},"muacirclejerk":{"lang":"en","description":"Welcome, beautiful white snowflakes, to the Makeup Addiction Circlejerk.  \n\nThis is a safe space to post your pale potato autumnal vamp lippie MAC LE mega pro RANT dupes without fear of unwanted CCW. ","over18":false},"ArtisanVideos":{"lang":"en","description":"","over18":false},"ripcity":{"lang":"en","description":"A place for fans of the Portland Trail Blazers.","over18":false},"transpassing":{"lang":"en","description":"This sub is devoted to trans people to post pictures and solicit opinions about how they’re succeeding at passing.\n\nFor transgender people, being unconsciously grouped with the correct gender (rather ","over18":false},"printSF":{"lang":"en","description":"**A place to discuss published SF**—novels, short stories, comics, images, and more. Not sure if a book is SF? Then post it! Science Fiction, Fantasy, Alt. History, Postmodern Lit., and more are all w","over18":false},"therewasanattempt":{"lang":"en","description":"For all the attempts in life","over18":false},"Nioh":{"lang":"en","description":"A Reddit community dedicated to Nioh and the upcoming Nioh 2, action RPGs developed by Team Ninja and published by Koei Tecmo (PC) and Sony Computer Entertainment (PS4) for release in 2017 and 2019.","over18":false},"whitesox":{"lang":"en","description":"A forum dedicated to the discussion of the White Sox. ","over18":false},"thelastofusfactions":{"lang":"en","description":"Dedicated to Factions. The Naughty Dog video game The Last of Us' Multiplayer. Can you survive the outbreak? ","over18":false},"architecture":{"lang":"en","description":"A community for students, professionals, and lovers of architecture.","over18":false},"bapcsalescanada":{"lang":"en","description":"Inspired by /r/buildapcsales and /r/buildapc, here is an all Canadian sale subreddit for your PC needs. Monitors, cables, processors, video cards, fans, cooling, cases, accessories, anything for a PC ","over18":false},"AnaheimDucks":{"lang":"en","description":"","over18":false},"duelyst":{"lang":"en","description":"* Reddit community for Counterplay Games' tactical CCG - Duelyst.","over18":false},"overclocking":{"lang":"en","description":"All things overclocking go here. Learn to overclock, ask experienced users your questions, boast your rock-stable, sky-high OC and help others!","over18":false},"UNBGBBIIVCHIDCTIICBG":{"lang":"en","description":"","over18":false},"BasicIncome":{"lang":"en","description":"A basic income guarantee is a system that regularly provides each citizen with a sum of money. Except for citizenship, a basic income is entirely unconditional.\n\nA basic income guarantee would radical","over18":false},"minnesotatwins":{"lang":"en","description":"### Minnesota Twins\n## American League Central Division - MLB\n\n* Two-time World Series Champions (1987, 1991)    \n\n* Six-time American League Champions (1924, 1925, 1933, 1965, 1987, 1991)    \n\n* Six-","over18":false},"nhl":{"lang":"en","description":"News, results, pictures, videos and discussion about the National Hockey League.","over18":false},"Ebay":{"lang":"en","description":"/r/eBay \n\nThe subreddit dedicated for all things concerning eBay.\n","over18":false},"adultery":{"lang":"en","description":"Thinking about infidelity?  ","over18":false},"EmeraldPS2":{"lang":"en","description":"Official unofficial subreddit of the Emerald Planetside 2 server community!","over18":false},"MtvChallenge":{"lang":"en","description":"Formerly called the Real World/Road Rules Challenge, this subreddit is dedicated to the greatest athletic competition in the world, the Challenge on MTV!\n\nCombination cast from Real World, Road Rules,","over18":false},"sexover30":{"lang":"en","description":"A more mature subreddit aimed at posters and commenters over the age of 30 years. \n\n*SO30 - Enabling the over thirty crowd to try everything from butt plugs to bitmoji since 2015!*","over18":false},"AnimalsBeingBros":{"lang":"en","description":"A place for sharing videos, gifs, and images of animals being bros.","over18":false},"videography":{"lang":"en","description":"**\\/r/videography**\n\nDestined for the big screen?  Try /r/filmmakers.  For videos including weddings, events, live performances, music videos, TV, corporate, live streaming, sports, real estate, YouTu","over18":false},"vegas":{"lang":"en","description":"The original Las Vegas subreddit run by people who live in Las Vegas.  Locals and visitors welcome.  ","over18":false},"MovieSuggestions":{"lang":"en","description":"In the mood for a particular movie? Saw something interesting and want more? Have a favourite movie you want to recommend? Make those Movie Suggestions.","over18":false},"TrueFMK":{"lang":"en","description":"","over18":true},"SS13":{"lang":"en","description":"Space Station 13 is an open source community-driven multiplayer simulation game. Set several centuries in the future, you will be playing a role on board a space station, ranging from bartender to eng","over18":false},"ufc":{"lang":"en","description":"Subreddit covering everything to do with UFC. Fight fans rejoice!","over18":false},"HomeNetworking":{"lang":"en","description":"HomeNetworking is a place where anyone can ask for help with their home or small office network. \n\nNo question is too small, but please be sure to read the rules and [posting guidelines](https://www.r","over18":false},"bikecommuting":{"lang":"en","description":"A community of bicycle commuters.  Offering support, help and guidance to new commuters and advice and helpful tools for those who have been commuting for awhile.  Break free from the tedious traffic ","over18":false},"Fuckthealtright":{"lang":"en","description":"A subreddit dedicated to shitting on the racist, misogynist, anti-Semitic, adolescent clusterfuck known as the \"Alt-Right\".","over18":false},"madlads":{"lang":"en","description":"For those bantasaurus rexes who can't be contained","over18":false},"Michigan":{"lang":"en","description":"A subreddit dedicated to the latest news and happenings in the great state of Michigan.","over18":false},"arresteddevelopment":{"lang":"en","description":"A sub-reddit for the fans and critics of the show Arrested Development. Discussion of the show, pictures from the show and anything else Arrested Development related.","over18":false},"Birmingham":{"lang":"en","description":"This is the Subreddit for Birmingham, AL (the best little dangerous city in the South!).","over18":false},"AmIFreeToGo":{"lang":"en","description":"You have the right to be secure in your person, your home and your effects. You have the right to expect no unreasonable searches and seizures. You have the right to move about freely without harassme","over18":false},"simracing":{"lang":"en","description":"","over18":false},"LightNovels":{"lang":"en","description":"A community for those interested in the Light Novel medium, as well as Japanese Novels and Web Novels.","over18":false},"WarshipPorn":{"lang":"en","description":"We're dedicated to posting the ***highest quality*** & ***largest*** images of ships of war, from the lowliest gunboat to the most glorious battleships of yore, be they from antiquity, the Age of Sail","over18":false},"Audi":{"lang":"en","description":"A Reddit community for Audi Enthusiasts","over18":false},"ontario":{"lang":"en","description":"A subreddit to discuss all the news and events taking place in the province of Ontario, Canada.","over18":false},"EA_NHL":{"lang":"en","description":"The front page of EA Sports NHL.","over18":false},"RateMyMayor":{"lang":"en","description":"A place to rate Animal Crossing mayors","over18":false},"archlinux":{"lang":"en","description":"For users of the much loved Linux distro, Arch Linux.","over18":false},"svenskpolitik":{"lang":"sv","description":"This subreddit is dedicated to the discussion of Swedish politics, foreign as well as domestic.","over18":false},"Welding":{"lang":"en","description":"The subreddit for welders, machinists and all other enthusiasts of joining two things together.","over18":false},"Gaming4Gamers":{"lang":"en","description":"*Header Image by /u/clarque_ *\n\n/r/Gaming4Gamers is an attempt to create a different gaming subreddit. By creating a middle ground between the purely-for-fun subreddits and the more serious ones, we a","over18":false},"PostHardcore":{"lang":"en","description":"The front page for Post-Hardcore music, news, & discussions!\n\n","over18":false},"DebateFascism":{"lang":"en","description":"A place for critics, supporters, and neutrals, to discuss fascism both as a complete ideology, and also the policies and ideas that exist within that ideology.","over18":false},"drawing":{"lang":"en","description":"This is a subreddit for artists who particularly enjoy drawing and/or are interested in sharing their techniques. Sharing some really awesome pieces by other artists is totally fine too. :)","over18":false},"GolfGTI":{"lang":"en","description":"/r/GolfGTI is a place for GTI enthusiasts to discuss and share information related to the best car that can be had for less than $30K. We entertain beauty shots and thrive on discussing mods, whether ","over18":false},"malelivingspace":{"lang":"en","description":"MaleLivingSpace is dedicated to places where men can live. \n Here you can find posts discussing, showing, improving, and maintaining apartments, homes, domiciles, man caves, garages, and bungalows.","over18":false},"rust":{"lang":"en","description":"For everything related to the Rust programming language—an open-source systems language that emphasizes safety, performance, and concurrency.","over18":false},"Padres":{"lang":"en","description":"A community dedicated to discussing the San Diego Padres Major League baseball team.","over18":false},"7daystodie":{"lang":"en","description":"","over18":false},"ExpectationVsReality":{"lang":"en","description":"Comparison pictures and memes.","over18":false},"OttawaSenators":{"lang":"en","description":"","over18":false},"gatech":{"lang":"en","description":"A subreddit for my dear Georgia Tech Yellow Jackets.","over18":false},"INDYCAR":{"lang":"en","description":"All things related to IndyCar, the premier open-wheel racing series in the US.","over18":false},"Doom":{"lang":"en","description":"Everything related to the hit action-horror series [DOOM](http://en.wikipedia.org/wiki/Doom_%28video_game%29), by [id software](http://www.idsoftware.com/). ","over18":false},"tech":{"lang":"en","description":"The goal of /r/tech is to provide a space dedicated to the intelligent discussion of innovations and changes to technology in our ever changing world.\n\n\nWe focus on high quality news articles about te","over18":false},"CrohnsDisease":{"lang":"en","description":"Crohn's disease is a type of inflammatory bowel disease that may affect any part of the gastrointestinal tract from mouth to anus, causing a wide variety of symptoms. It primarily causes abdominal pai","over18":false},"AndroidWear":{"lang":"en","description":"Welcome to the home of WearOS /r/AndroidWear ","over18":false},"Monero":{"lang":"en","description":"This is the official subreddit of Monero (XMR), a secure, private, untraceable currency that is open-source and freely available to all.","over18":false},"Cleveland":{"lang":"en","description":"The official Cleveland subreddit!  Post and discuss things about Cleveland, Ohio, for better or worse.  Add anything you want, as long as it pertains to Cleveland.","over18":false},"WikiLeaks":{"lang":"en","description":"r/WikiLeaks is a subreddit for discussion about WikiLeaks and their founding editor, Julian Assange, and related projects. Any content related to WikiLeaks or other suppressed information is welcome. ","over18":false},"SonicTheHedgehog":{"lang":"en","description":"It's a subreddit for Sonic the Hedgehog. We have a few rules, so please read them before posting. Failure to comply will result in a detention.","over18":false},"Thailand":{"lang":"en","description":"","over18":false},"fullmoviesonyoutube":{"lang":"en","description":"Full Movies on YouTube!","over18":false},"90daysgoal":{"lang":"en","description":"We are changing our lives 90 days at a time!","over18":false},"malefashion":{"lang":"en","description":"Come here if you want to look dope.....\n","over18":false},"progressive":{"lang":"en","description":"A community to share stories related to the growing Modern Political and Social Progressive Movement.\nThe Modern Progressive Movement advocates change and reform through directed governmental action. ","over18":false},"moviescirclejerk":{"lang":"en","description":"*No penis in your brain?* - Movie must be plain.\n\n*Mind didn't get fucked?* - Movie def sucked. \n","over18":false},"Earwolf":{"lang":"en","description":"Earwolf is a comedy podcasting network founded by Scott Aukerman and Jeff Ullrich in August 2010. It merged with podcast advertising network The Mid Roll in 2014 to form Midroll Media. Here at /r/Earw","over18":false},"ImagesOfThe2010s":{"lang":"en","description":"","over18":false},"sugarlifestyleforum":{"lang":"en","description":"A forum where sd's and sb's can discuss the lifestyle, share experiences and learn from one another","over18":false},"pitbulls":{"lang":"en","description":"","over18":false},"Sexsells":{"lang":"en","description":"/r/Sexsells is an open market to buy and sell adult items and services. We hope to create a safe, sex-positive community where buyers and sellers can seek or offer adult services with few restrictions","over18":true},"curlyhair":{"lang":"en","description":"For all natural curlies, coilies, and wavies!\n\nFind help with your hair, recommendations on products, technique advice... anything to help tame your mane!","over18":false},"bettafish":{"lang":"en","description":"A subreddit for all things related to our colorful finned friends.","over18":false},"alberta":{"lang":"en","description":"Wild Rose Country.","over18":false},"Rowing":{"lang":"en","description":"A subreddit for all rowing related news, erging advice and fitness discussion related to the sport.  ","over18":false},"MTGLegacy":{"lang":"en","description":"Discussion on Magic: the Gathering's Legacy (Type 1.5) format, decks, cards, tournaments, etc.","over18":false},"AmiiboCanada":{"lang":"en","description":"A subreddit designed for Nintendo fans in the Great White North.","over18":false},"androidthemes":{"lang":"en","description":"Showcasing our Android phones, one theme at a time!","over18":false},"Toontown":{"lang":"en","description":"The one-stop community for the now-closed Disney game, Toontown and all it's private servers!","over18":false},"GWABackstage":{"lang":"en","description":"The non-erotic side of GWA. ","over18":true},"Ripple":{"lang":"en","description":"Ripple connects banks, payment providers and digital asset exchanges via RippleNet to provide one frictionless experience to send money globally. Banks and payment providers can use the digital asset ","over18":false},"drunkenpeasants":{"lang":"en","description":"Welcome to the Drunken Peasants subreddit!","over18":false},"educationalgifs":{"lang":"en","description":"Gifs are great at getting quick to digest info, and /r/educationalgifs strives to give you educational info in this quick to digest format.  From chemical processes, to how plants work, to how machine","over18":false},"madisonwi":{"lang":"en","description":"The subreddit for the best place in the world: Madison, WI.","over18":false},"Jazz":{"lang":"en","description":"Reddit's home for all things related to Jazz.","over18":false},"furry_irl":{"lang":"en","description":"for the fur in u ( ͡° ͜ʖ ͡°)","over18":false},"pinkfloyd":{"lang":"en","description":"Pink Floyd were an English rock band that achieved international success with their progressive and psychedelic rock music marked by the use of philosophical lyrics, sonic experimentation, and elabora","over18":false},"BankBallExchange":{"lang":"en","description":"A subreddit for trading Bank Ball Pokémon. 'Bank Ball Pokémon' are those caught in Poké Balls not regularly available in Poké Marts and transported to Gen VI or VII through the Poké Bank.","over18":false},"brandnew":{"lang":"en","description":"","over18":false},"phillies":{"lang":"en","description":"The officialish subreddit of the Philadelphia Phillies!\n","over18":false},"IndiaSpeaks":{"lang":"en","description":"India Speaks is an effort to build a better online community for Indians. We take our pride in being the most friendly and user-focused community for Redditors from India; Reddit India for short. The ","over18":false},"HappyWars":{"lang":"en","description":"Official Happy Wars Subreddit. \n\n","over18":false},"kings":{"lang":"en","description":"The Sacramento Kings subreddit.\n\nYour Kingdom Come.","over18":false},"DnDBehindTheScreen":{"lang":"en","description":"/r/DnDBehindTheScreen is a subreddit for new and experienced Dungeons & Dragons Dungeon Masters to trade tools, guides and resources. A growing archive of hundreds of years of D&D experience. All in o","over18":false},"DivinityOriginalSin":{"lang":"en","description":"Subreddit for discussions about Divinity: Original Sin, Divinity Original Sin 2, and other Larian Games","over18":false},"SwagBucks":{"lang":"en","description":"Swagbucks: The Web's Premier Destination for Free Rewards. Watch videos, search the web, complete surveys, shop and more to earn SB to redeem for rewards. Check out the guide, sidebar and posts to get","over18":false},"ttcafterloss":{"lang":"en","description":"This sub is for people who are trying to conceive, waiting to try, or just dealing with life after any type of pregnancy or baby loss. This includes chemical, molar, and ectopic pregnancies, blighted ","over18":false},"ussoccer":{"lang":"en","description":"The subreddit exclusively for the discussion of national United States soccer teams.\n\nMen's, women's, and youth are all discussed here.","over18":false},"Wellthatsucks":{"lang":"en","description":"For everything that happens in everyday life that makes you say \"well, that sucks\" \n","over18":false},"InfertilityBabies":{"lang":"en","description":"Infertility doesn't go away after the first positive test. This is a community for those who have gotten pregnant after a struggle with infertility. We understand where you've been and where you're go","over18":false},"winnipegjets":{"lang":"en","description":"A subreddit dedicated to the Winnipeg Jets of the NHL.","over18":false},"CompetitiveForHonor":{"lang":"en","description":"A For Honor subreddit dedicated to theorycrafting and the competitive scene.","over18":false},"blackmirror":{"lang":"en","description":"*Black Mirror* is an anthology series created by Charlie Brooker featuring speculative fiction with dark and sometimes satirical themes which examine modern society, particularly with regard to the un","over18":false},"Rochester":{"lang":"en","description":"News and discussion for Rochester, NY and surrounding communities. ","over18":false},"Rainmeter":{"lang":"en","description":"Windows Desktop Customization Tool","over18":false},"BeautyBoxes":{"lang":"en","description":"We love the monthly subscriptions we receive filled with goodies! This is a place to share pictures, ideas, & thoughts!\n\nBeauty boxes, beauty box, subscription box, subscription boxes, makeup, make up","over18":false},"watercooling":{"lang":"en","description":"","over18":false},"ABCDesis":{"lang":"en","description":"South Asian Americans-\n\nA place for members of the South Asian diaspora that includes people who descend from Bangladesh, India, Maldives, Pakistan, Sri Lanka, Bhutan, and Nepal. We also welcome Desis","over18":false},"SF4":{"lang":"en","description":"Ultra Street Fighter 4\n\nThis subreddit is dedicated to improving your game. Look for quality content anywhere from training rooms to tournaments.\n\nRelated reddits:\n\n* [Fighting Game General](/r/Fighte","over18":false},"test":{"lang":"en","description":"","over18":false},"cosplaygirls":{"lang":"en","description":"A place to share pictures and videos of girls in cosplay.","over18":false},"biology":{"lang":"en","description":"","over18":false},"worldcup":{"lang":"en","description":"This is the place for all things; Match Threads, Discussions and all the news during the 2018 world cup in Russia.","over18":false},"CastleClash":{"lang":"en","description":"Discussion, Tips, Tricks, etc. for the Castle Clash Mobile game found on Android,  iOS and Amazon store. ","over18":false},"Spiderman":{"lang":"en","description":"The subreddit dedicated to our friendly neighborhood super-hero","over18":false},"BipolarReddit":{"lang":"en","description":"A Reddit to share information about who you are, how you think, and what helps you cope in life.","over18":false},"4x4":{"lang":"en","description":"*Everything that has to do with 4 wheel drive...*","over18":false},"TeamRedditTeams":{"lang":"en","description":"***The*** place for League of Legends players and teams to find others to play with.  \n\nWhether you're looking for a serious ranked team, a duo partner, or somebody to chill with, /r/TeamRedditTeams h","over18":false},"Stims":{"lang":"en","description":"","over18":false},"Minneapolis":{"lang":"en","description":"Minneapolis, Minnesota (MN)","over18":false},"chile":{"lang":"es","description":"La comunidad de Reddit de Chile. ","over18":false},"JapanTravel":{"lang":"en","description":"Got questions? Need advice? Overwhelmed with your itinerary? Want to share your travel tips and experiences in Japan? Then this is the place for you! /r/JapanTravel is for any and all looking to visit","over18":false},"randomactsofamazon":{"lang":"en","description":"Some people feel the world is too materialistic, but it is hard to deny that you can learn a lot about how people live by the things that they buy. We're a community built around that idea - put toget","over18":false},"datingoverthirty":{"lang":"en","description":"DatingOverThirty is a sub for discussion and advice on dating and relationships for people over the age of thirty. \n\n**This is not a place to post personals or \"looking for\" or hookups.**","over18":false},"translator":{"lang":"en","description":"r/translator is *the* community for Reddit translation requests.\n\nNeed something translated? Post here!\n\nWe will help you translate any language, including Japanese, Chinese, German, Arabic, and many ","over18":false},"fatestaynight":{"lang":"en","description":"For everything related to Fate/stay night or its spin-offs. Fate/Zero, Fate/hollow ataraxia, Fate/Extra, etc., discuss all of these and more on this subreddit!","over18":false},"DestinySherpa":{"lang":"en","description":"Most of us are aware that it can be difficult for a new player to find a group to do their first raid. /r/fireteams moves fast & can be hard to pick through at times. Destinylfg.net is full of people ","over18":false},"StonerEngineering":{"lang":"en","description":"You give a few pot heads a bunch of weed and nothing to smoke out of and they suddenly become engineers. It's amazing.","over18":false},"spiders":{"lang":"en","description":"All things Arachnid: articles, photos, videos, and ID requests are welcome.","over18":false},"TalesofLink":{"lang":"en","description":"","over18":false},"PS4Planetside2":{"lang":"en","description":"This subreddit is for PS4 gamers interested in Planetside 2. General discussion of all things Planetside 2 is welcome. Let's build an awesome community of PS4 gamers for Planetside 2.","over18":false},"nevertellmetheodds":{"lang":"en","description":"Nearly impossible feats of achievement, those with great degree of difficulty or incredible odds. ","over18":false},"SampleSize":{"lang":"en","description":"A place for both surveys and polls to be posted. Research studies for school purposes are welcome just as much as opinion polls that just popped into your head.\n\nWe are also a place for people who enj","over18":false},"HongKong":{"lang":"en","description":"A subreddit for all things Hong Kong, China. ","over18":false},"LegendsOfTomorrow":{"lang":"en","description":"When heroes alone are not enough… the world needs legends. ","over18":false},"DaftPunk":{"lang":"en","description":"A reddit for robots who are humans after all.","over18":false},"corgi":{"lang":"en","description":"Welsh corgi -  noun\n: a short-legged long-backed dog with foxy head of either of two breeds of Welsh origin:\na : cardigan welsh corgi\nb : pembroke welsh corgi","over18":false},"montageparodies":{"lang":"en","description":"5+ years of funny edited videos","over18":false},"ockytop":{"lang":"en","description":"The official subreddit of Tennessee Vols sports","over18":false},"saskatoon":{"lang":"en","description":"For the people of Saskatoon","over18":false},"AdamCarolla":{"lang":"en","description":"Adam Carolla subreddit. Loveline, Adam Carolla Show (radio), Adam Carolla Podcast, Movies, Road Hard","over18":false},"UKPersonalFinance":{"lang":"en","description":"Discuss, learn and request help on how to obtain, budget, protect, save and invest your pounds and pence. A UK-centric personal finance subreddit.","over18":false},"MHOC":{"lang":"en","description":"","over18":false},"dontstarve":{"lang":"en","description":"Everything about **Don't Starve**, a game by [Klei Entertainment](http://kleientertainment.com/), \ncreators of [Mark of the Ninja](http://kleientertainment.com/games/ninja/), [Shank](http://kleientert","over18":false},"berkeley":{"lang":"en","description":"","over18":false},"dishonored":{"lang":"en","description":"Subreddit for Arkane Studios' video game Dishonored, Dishonored 2 and the new instalment Dishonored: Death of the outsider.","over18":false},"3dsFCswap":{"lang":"en","description":"","over18":false},"astrophotography":{"lang":"en","description":"Love pictures of interstellar objects taken by amateurs? /r/Astrophotography is the place for you!","over18":false},"Tradelands":{"lang":null,"description":"Subreddit forbidden","over18":null},"airsoftmarket":{"lang":"en","description":"The Official Airsoft Buy, Sell, and Trade subreddit. \n\nEndorsed by the one true /u/vorpalbunnie","over18":false},"Sherlock":{"lang":"en","description":"Discussion on BBC's Sherlock","over18":false},"CFL":{"lang":"en","description":"The Canadian Football League Subreddit! For all things CFL!","over18":false},"YouEnterADungeon":{"lang":"en","description":">Inquire about Subreddit\n\nThis subreddit is for drop-and-play roleplaying scenarios. These can either be continuous or oneshot, and can proceed however the OP of the thread would like.","over18":false},"CityPorn":{"lang":"en","description":"High quality images of cities.","over18":false},"Shitstatistssay":{"lang":"en","description":"This is a community where we can share, comment on, and laugh at the insane posts made by Statists here on reddit.","over18":false},"WWEGames":{"lang":"en","description":"A place for all wrestling related games! ","over18":false},"hacking":{"lang":"en","description":"A subreddit dedicated to hacking and hackers.\n\nWhat we are about: constructive collaboration and learning about exploits, industry standards, grey and white hat hacking, new hardware and software hack","over18":false},"FloridaMan":{"lang":"en","description":"News about the terrible superhero \"Florida Man\" and his latest misadventures!","over18":false},"Omaha":{"lang":"en","description":"Subreddit for Omaha, NE and the Omaha–Council Bluffs Metropolitan Area\n\n","over18":false},"Warmachine":{"lang":"en","description":"","over18":false},"Metroid":{"lang":"en","description":"News, discussion and fan work about the iconic Metroid series from Nintendo.","over18":false},"morbidquestions":{"lang":"en","description":"The dark questions we all have\n","over18":false},"Negareddit":{"lang":"en","description":"Negareddit - Reddit is shit.","over18":false},"MachineLearning":{"lang":"en","description":"","over18":false},"Parahumans":{"lang":"en","description":"A home for fans of Wildbow's web serials, Worm, Pact, Twig, and Ward.","over18":false},"DallasStars":{"lang":"en","description":"","over18":false},"Sprint":{"lang":"en","description":"Sprint news, discussion, user feedback, phone updates, tips and tricks, technical advice, and Customer Care experiences.","over18":false},"Miami":{"lang":"en","description":"Miami - The Magic City - Home to glamorous South Beach, famed art deco buildings, trendsetting nightclubs, and Latin cuisine","over18":false},"CautiousBB":{"lang":"en","description":"For cautious pregnant Mommas on this great perilous journey to motherhood.","over18":false},"japancirclejerk":{"lang":"ja","description":"ARE YOU A JET? DO YOU TEACH ENGLISH? ARE YOU LEARNING JAPANESE? DO YOU EVEN LIFT!?\n\nI'M NOT SURE IF YOU BELONG HERE. I'M MORE JAPANESE THAN ANY OF YOU, EVEN IF YOU'RE JAPANESE. MY JAPANESE FRIENDS SAI","over18":false},"Knife_Swap":{"lang":"en","description":"","over18":false},"Rivenmains":{"lang":"en","description":"","over18":false},"wwesupercard":{"lang":"en","description":"the WWE SuperCard Subreddit - the best place for SuperCard discussion on reddit","over18":false},"KendrickLamar":{"lang":"en","description":"A place where you can discuss Kendrick Lamar!\n","over18":false},"funkoswap":{"lang":"en","description":"Official Trading Community of /r/funkopop.","over18":false},"rocket_league_trading":{"lang":"en","description":"A marketplace to discuss, talk, sell, and buy items in Rocket League. ","over18":false},"RobinHood":{"lang":"en","description":"Say goodbye to commissions...\nAnd hello to the future of trading.","over18":false},"Wetshaving":{"lang":"en","description":"A community of enthusiasts, hobbyists and artisans who enjoy a traditional wet shave: brush, soap, and safety or straight razor. ","over18":false},"slatestarcodex":{"lang":"en","description":"Companion subreddit for the blog Slate Star Codex by Scott Alexander.","over18":false},"Hotwife":{"lang":"en","description":"","over18":true},"LGG3":{"lang":"en","description":"Discussion of LG's 2014 flagship smartphone, the LG G3","over18":false},"askwomenadvice":{"lang":"en","description":"This is a subreddit dedicated to asking women for advice. We welcome anyone seeking advice of a non-professional nature.  Legal or medical advice is not permitted, and asking for advice on how to repa","over18":false},"everymanshouldknow":{"lang":"en","description":"You know that thing your dad was suppose to teach you but never did?","over18":false},"Ask_Politics":{"lang":"en","description":"\"Politicians are the same all over. They promise to build a bridge even where there is no river.\"","over18":false},"HouseOfCards":{"lang":"en","description":"Subreddit for the Netflix show created by David Fincher starring Kevin Spacey.","over18":false},"huntersbell":{"lang":"en","description":"Huntersbell is the place for weary and bruised Bloodborne hunters looking to find co-operation.\n\nWhether offering a hand, summoning for help, or just co-op fun, this sub-reddit is designed to make the","over18":false},"compsci":{"lang":"en","description":"Computer Science Theory and Application. We share and discuss any content that computer scientists find interesting. People from all walks of life welcome, including hackers, hobbyists, professionals,","over18":false},"socialanxiety":{"lang":"en","description":"Feel nervous and/or shy in social situations? Whether it's approaching someone you're attracted to or if it's giving a presentation in class, everyone gets a little nervous at times. You may have soci","over18":false},"place":{"lang":"en","description":"description field","over18":false},"gunpolitics":{"lang":"en","description":"The Gun Politics subreddit is about sharing news, articles, stories and events related to guns & politics as well as discussion surrounding gun politics.","over18":false},"Glocks":{"lang":"en","description":"r/Glocks","over18":false},"rollercoasters":{"lang":"en","description":"A subreddit for discussions, photos, news, and updates for the world of roller coasters and amusement parks!","over18":false},"evangelion":{"lang":"en","description":"God's in his heaven. All's right with the world. ","over18":false},"GODZILLA":{"lang":"en","description":"Welcome to /r/GODZILLA! A place to admire the King of the Monsters and his many foes. - If you haven't already, please read through the RULES located on the sidebar. For Mobile users you can find them","over18":false},"indianapolis":{"lang":"en","description":"Indianapolis, Indiana","over18":false},"cardfightvanguard":{"lang":"en","description":"r/CardfightVanguard is a place where users can share, post, and discuss anything pertaining to the Cardfight!! Vanguard TCG. ","over18":false},"EternalCardGame":{"lang":"en","description":"Eternal combines the infinite possibilities of a deep strategy card game with the pace and polish of a modern video game. In Eternal, build any deck you can imagine by freely mixing cards from an expa","over18":false},"PandR":{"lang":"en","description":"A subreddit for the fans of the show Parks and Recreation. Discussion of the show, pictures from the show and anything else Parks and Recreation-related. \n\n","over18":false},"sneakermarket":{"lang":"en","description":"BUY SELL TRADE","over18":false},"confessions":{"lang":"en","description":"Get that nasty secret off your chest. See the unfiltered opinions of strangers.","over18":false},"CrackWatch":{"lang":"en","description":"If you're looking for the latest news on cracks for your favorite games, want to post game related topics or discuss your issues with certain games? Well if so, this is the place to be!","over18":false},"inthenews":{"lang":"en","description":"/r/inthenews is the subreddit for opinion, analysis, and discussion of recent events.","over18":false},"LonghornNation":{"lang":"en","description":"The subreddit for University of Texas athletics, including football, basketball, baseball, and volleyball.\n\nHook 'em!","over18":false},"Archery":{"lang":"en","description":"A place where fans of archery/bowhunting/crossbow enthusiasts can mingle and talk about their craft!","over18":false},"ChivalryGame":{"lang":"en","description":"A subreddit for Chivalry: Medieval Warfare and Chivalry: Deadliest Warrior, a multiplayer action game made by Torn Banner Studios.","over18":false},"AnimeFigures":{"lang":"en","description":"","over18":false},"BoJackHorseman":{"lang":"en","description":"Subreddit for the Netflix animated series, BoJack Horseman, starring BoJack Horseman as BoJack Horseman.","over18":false},"forhire":{"lang":"en","description":"Some redditors are skilled professionals, some redditors need skilled professionals.\n\n\n\nScroll down for general information and our rules. Please read through these carefully, as breaking them can be ","over18":false},"KingkillerChronicle":{"lang":"en","description":"","over18":false},"dota2loungebets":{"lang":"en","description":"Dota2Lounge.com betting subreddit. Not an official forum for the website!","over18":false},"SanctionedSuicide":{"lang":null,"description":"Subreddit no longer exists","over18":null},"climateskeptics":{"lang":"en","description":"Questioning climate related environmentalism.","over18":false},"ElysiumProject":{"lang":null,"description":"Subreddit forbidden","over18":null},"Mommit":{"lang":"en","description":"We are people. Mucking through the ickier parts of child raising. It may not always be pretty, fun and awesome, but we do it. \n\n And we want to be here for others who are going through the same experi","over18":false},"religion":{"lang":"en","description":"","over18":false},"AceAttorney":{"lang":"en","description":"An unofficial subreddit for all things Ace Attorney, gaming's best lawyer simulator.","over18":false},"CrossStitch":{"lang":"en","description":"Cross stitch community - patterns, discussion, giveaways, and competition!","over18":false},"DerekSmart":{"lang":"en","description":"\"If you attack me over this, remember, I’m an old school Internet warlord, I’m no pushover, and I won’t take it lightly. Your rights don’t trump mine, and people don’t scare me.\"","over18":false},"firefly":{"lang":"en","description":"/r/Firefly, for all your Joss Whedon Sci-Fi western needs. The Reddit for everything in the Verse! Can't stop the signal. Shiny.","over18":false},"AZCardinals":{"lang":"en","description":"","over18":false},"glasgow":{"lang":"en","description":"Welcome to the Glasgow subreddit. For everything Glasgow and the West.","over18":false},"Defenders":{"lang":"en","description":"A place to discuss Marvel Cinematic Universe's Netflix shows: Daredevil | Jessica Jones | Luke Cage | Iron Fist | Defenders | Punisher","over18":false},"rit":{"lang":"en","description":"RIT - Rochester Institute of Technology official subreddit","over18":false},"TropicalWeather":{"lang":"en","description":"This is a subreddit designed for all sorts of tropical weather discussion. Though the focus will be on tropical meteorology, it will also be a place for people to stay in touch before, during, and aft","over18":false},"milwaukee":{"lang":"en","description":"/r/milwaukee where we talk about our love of beer, cheese, festivals, and more beer.","over18":false},"BBQ":{"lang":"en","description":"Discuss any and everything BBQ. Have questions? Ask fellow pitmasters!","over18":false},"finance":{"lang":"en","description":"","over18":false},"Canadian_ecigarette":{"lang":"en","description":"A subreddit for Canadians to discuss ecigarettes and vaping. \n","over18":false},"raleigh":{"lang":"en","description":"Raleigh is the capital of the state of North Carolina as well as the seat of Wake County. Raleigh is known as the \"City of Oaks\" for its many oak trees, which line the streets in the heart of the city","over18":false},"ABDL":{"lang":"en","description":"A lot of people enjoy wearing diapers - for many different reasons. Here's a space for all of them.","over18":true},"introvert":{"lang":"en","description":"A place for introverts to [gather](http://heyluchie.tumblr.com/post/53461087106/my-comic-introversion-is-finished-please-go-to) and chat. [Or not](http://www.toothpastefordinner.com/062808/your-person","over18":false},"SEO":{"lang":"en","description":"Search engine optimisation and all its wider facets. Your community for SEO news, tips and case studies.","over18":false},"Boobies":{"lang":"en","description":"Boobs.  Girl boobs.","over18":true},"incremental_games":{"lang":"en","description":"This subreddit is for lovers of games that feature an incremental mechanism, such as unlocking progressively more powerful upgrades, or discovering new ways to play the game. This genre is growing at ","over18":false},"RedHotChiliPeppers":{"lang":"en","description":"A community for RHCP fans to share music videos, personal stories, pictures, documentaries, Frusciante solo material, Ataxia, Dot Hacker, or any other collaborations. Basically anything Pep-related; p","over18":false},"MotoUK":{"lang":"en","description":"If you would like to complain about the poor weather, oblivious drivers or the tedious motorcycle license laws, you've come to the right place.","over18":false},"Trove":{"lang":"en","description":"A subreddit for the Voxel Based MMO Trove","over18":false},"terriblefacebookmemes":{"lang":"en","description":"Terrible memes, a mix of all the shitty meme subs with a hint of grandma.","over18":false},"needforspeed":{"lang":"en","description":"Need for Speed is a series of racing games published by Electronic Arts and currently developed by Ghost Games","over18":false},"Bowling":{"lang":"en","description":"For all bowlers of all ages and abilities","over18":false},"MemoryDefrag":{"lang":"en","description":"Sword Art Online: Memory Defrag for iOS and Android is a game that puts players back into the story where they collect and battle with many characters from the show and light novels!","over18":false},"Xenoblade_Chronicles":{"lang":"en","description":"This community is for fans of the Xenoblade JRPG game series (Xenoblade Chronicles, Xenoblade Chronicles X and Xenoblade Chronicles 2).","over18":false},"camping":{"lang":"en","description":"A subreddit for campers concerned more about the act of camping and less concerned about hiking long distances or light gear.","over18":false},"PropagandaPosters":{"lang":"en","description":"A subreddit for propaganda collectors, enthusiasts, or anyone fascinated by propaganda as an insight into history, sociology, perspective, and manipulation.","over18":false},"pharmacy":{"lang":"en","description":"A subreddit for pharmacists, pharmacy students, techs, and anyone else in the pharmaceutical industry.","over18":false},"OnceUponATime":{"lang":"en","description":"Once Upon a Time","over18":false},"geopolitics":{"lang":"en","description":"Specifically, geopolitics is focused on the relationship between politics and territory. Through geopolitics we attempt to analyze and predict the actions and decisions of nations, or other forms of p","over18":false},"WorldofTanksConsole":{"lang":"en","description":"Subreddit for the console version of the game World of Tanks. We like tanks and hate artillery. We are here for the free exchange of tips, strategies, player guides, how-to's, news, information and di","over18":false},"KenM":{"lang":"en","description":"Welcome to r/KenM! This subreddit is dedicated to posts of a quirky old man, who is known as KenM. Please review the rules before posting!","over18":false},"Chromecast":{"lang":"en","description":"A subreddit for everything about the Google chromecast","over18":false},"consulting":{"lang":"en","description":"","over18":false},"java":{"lang":"en","description":"News, Technical discussions, research papers and assorted things of interest related to the Java programming language\n\nNO programming help, NO learning Java related questions!","over18":false},"bikewrench":{"lang":"en","description":"","over18":false},"trailerparkboys":{"lang":"en","description":"A subreddit for the fans of the show, The Trailer Park Boys. Discussion of the show, pictures and other media from the show and anything else Trailer Park Boys related. \n\nBubbles, Ricky, Julian, J-Roc","over18":false},"Buffalo":{"lang":"en","description":"This sub is dedicated to all things Buffalo & Western New York. ","over18":false},"GhostRecon":{"lang":"en","description":"The official Ghost Recon subreddit. Devoted to the Ghost Recon series of games. The latests news and updates from Ghost Recon: Wildlands. Join Now.","over18":false},"BreakUps":{"lang":"en","description":"Ongoing support for break ups.","over18":false},"asianamerican":{"lang":"en","description":"Anything related to Asian and Pacific Islander Americans, as well as other Asians who grew up outside of Asia. This includes news, discussions, pictures, or videos. While members of all races and nati","over18":false},"DankNation":{"lang":null,"description":"Subreddit no longer exists","over18":null},"SourceFed":{"lang":"en","description":"The official subreddit for the youtube channel SourceFed! ","over18":false},"education":{"lang":"en","description":"The goal of r/Education is to provide a community in which educational stakeholders can participate in meaningful, reflective, and thought-provoking discourse about educational policy, research, techn","over18":false},"ToolBand":{"lang":"en","description":"This Subreddit is dedicated to thoughts spawned by listening/watching the band Tool.","over18":false},"horizon":{"lang":"en","description":"Home for the Playstation 4 game Horizon:Zero Dawn.","over18":false},"slavelabour":{"lang":"en","description":"Get jobs done well below market rate. Any task (within reason!) can be completed here for pay.\n\nFind casual online work. Earn a few dollars here and there completing small tasks. It will soon add up!\n","over18":false},"Cumberbitches":{"lang":"en","description":"","over18":false},"backpacking":{"lang":"en","description":"A subreddit for world traveling Backpackers. Often confused with the other type of (wilderness) backpacker in the US, this subreddit is primarily for the travelers. Wilderness is allowed by community ","over18":false},"CivilizatonExperiment":{"lang":"en","description":"The Civilization Experiment II is a Minecraft server and social experiment taking place in a custom built survival world. Using custom plugins, ore generation, and season-dependent food growth rates, ","over18":false},"newtothenavy":{"lang":"en","description":"A forum to discuss Navy Recruiters, processing at MEPS, Delayed Entry Program, Enlisted Ratings, \"A\" Schools, Officer Candidate School, Recruit Training Command, and transferring to your first command","over18":false},"AllThingsTerran":{"lang":"en","description":"","over18":false},"askseddit":{"lang":"en","description":"","over18":false},"bassnectar":{"lang":"en","description":"The unofficial subreddit for all things Bassnectar!\n\nBassnectar's sets are a mind-blowing affair for all involved. The constant barrage of tempo changes, intense, rattling bass and the wide swath of g","over18":false},"cumsluts":{"lang":"en","description":"Reddit's Most Popular Semen-Based Subreddit\n\nEvery post has spunk. /r/Cumsluts is a fetish subreddit for everybody (men, women, Japanese tentacle monsters), from the average fetishist to the discernin","over18":true},"MCPE":{"lang":"en","description":"Minecraft platform expansion community - For all things bedrock codebase","over18":false},"bikesgonewild":{"lang":"en","description":"","over18":false},"preppers":{"lang":"en","description":"Learning and sharing information to aid in emergency preparedness as it relates to disasters both natural and man-made.  Insurance for tough times.","over18":false},"TampaBayLightning":{"lang":"en","description":"Subreddit for the Tampa Bay Lightning of the National Hockey League.","over18":false},"Brawlstars":{"lang":"en","description":"Welcome to Supercell’s newest game, Brawl Stars! Round up a couple of friends and head over to Brawl Town for real time 3v3 multiplayer battles! Unlock a variety of rough and tumble characters with di","over18":false},"watch_dogs":{"lang":"en","description":"Fan community subreddit for the Video Game series Watch_Dogs. Subscribe for news and discussion on the games.","over18":false},"gif":{"lang":"en","description":"A place for funny, interesting, & animated SFW gifs and mp4's.","over18":false},"dogpictures":{"lang":"en","description":"Pictures of dogs!","over18":false},"Standup":{"lang":"en","description":"For standup comics, from open micers to theater acts, to ask questions, answer questions, present material, coordinate shows, bitch about the industry, swap horror stories, and assorted bullshittery. ","over18":false},"badwomensanatomy":{"lang":"en","description":"Women are made of sugar and spice and all things nice.  Except their vaginas which are sqwicky and attract bears.","over18":false},"PvZHeroes":{"lang":"en","description":"A place to discuss Plants Vs Zombies: Heroes. Ask for deck help, share fan art, or stick around to find someone else to battle.","over18":false},"punchablefaces":{"lang":"en","description":"doot doot","over18":false},"UBC":{"lang":"en","description":"The online community of the University of British Columbia in Vancouver, Canada!","over18":false},"GearVR":{"lang":"en","description":"Subreddit for Samsungs Gear VR","over18":false},"denvernuggets":{"lang":"en","description":"/r/denvernuggets | The #1 Denver Nuggets Community","over18":false},"ExNoContact":{"lang":"en","description":"I want to invite anyone who is currently going through a breakup and trying to heal to join me here and any time we feel like venting or reaching out to our Ex, post here instead. Post a rant, or post","over18":false},"Monitors":{"lang":"en","description":"","over18":false},"Huskers":{"lang":"en","description":"Anything and everything about the University of Nebraska Cornhuskers, with a focus on Husker Football. ","over18":false},"findareddit":{"lang":"en","description":"Having trouble finding the reddit you need? Post here what you're looking for and someone can suggest a reddit for you!","over18":false},"flyfishing":{"lang":"en","description":"This is a subreddit for anglers who pursue, or wish to pursue, their favorite fish on fly rods.  Whether you fly fish a 2wt on small creeks for brook trout, a 14' 9wt for Steelhead or Atlantic Salmon,","over18":false},"NSFWIAMA":{"lang":"en","description":"NSFW Ask Me Anything","over18":true},"Adelaide":{"lang":"en","description":"We have balls over at /r/Adelaide!","over18":false},"homeautomation":{"lang":"en","description":"A subreddit focused on automating your home, housework or household activity.  Sensors, switches, cameras, locks, etc.  Any automation questions/discussions are welcome!\n","over18":false},"aggies":{"lang":"en","description":"A place to share anything related to Texas A&M and the surrounding area.","over18":false},"soylent":{"lang":"en","description":"Resources, links, experiences, and relevant news dealing with engineered staple foods including but not limited to Soylent^(*unaffiliated*). All discussion of products, recipes, and research concernin","over18":false},"design_critiques":{"lang":"en","description":"Help new and amateur designers improve their designs through reviews and critiques. If you are an experienced designer, please review a submission and share your constructive suggestions!","over18":false},"fantasywriters":{"lang":"en","description":"This subreddit is dedicated to those of us who are writing in the fantasy genre.  Anything related to creating your own works of fantasy is welcome.","over18":false},"comicbookmovies":{"lang":"en","description":"A place to discuss live-action cinematic and television adaptations of comic books.","over18":false},"PerfectTiming":{"lang":"en","description":"r/PerfectTiming: A subreddit dedicated to photos of the unexpected and unplanned.","over18":false},"bicycletouring":{"lang":"en","description":"Bicycle touring is about taking trips via bicycle. Whether you're going out for the weekend or cycling across continents, bicycletouring is a community of individuals who share this passion.","over18":false},"RCSources":{"lang":null,"description":"Subreddit no longer exists","over18":null},"BreedingDittos":{"lang":"en","description":"","over18":false},"boxoffice":{"lang":"en","description":"A place to talk about the box office, both domestically and internationally.","over18":false},"zombies":{"lang":"en","description":"/r/Zombies' raison de la mort is to host submissions regarding gatherings, movies, books, music, theater, speculative science, and games featuring the flesh (and/or brain) eating dead. Non-zombie \"zom","over18":false},"sips":{"lang":"en","description":"A subreddit for the fantastic Sips from Yogscast ","over18":false},"GunsAreCool":{"lang":"en","description":"The cost of 'cool'. Mass Shooter Tracker Data.  Mass shootings.  Tracking mass shootings via all guns, firearms, semi-automatics, rifles, shotguns, automatics, handguns, etc.  Gun control for gun, amm","over18":false},"stalker":{"lang":"en","description":"A Reddit to discuss the video game series S.T.A.L.K.E.R. - including Shadow of Chernobyl, Clear Sky and Call of Pripyat.","over18":false},"jakeandamir":{"lang":"en","description":"Official subreddit for the College Humor series Jake and Amir.","over18":false},"PS4Deals":{"lang":"en","description":"/r/PS4Deals","over18":false},"TheoryOfReddit":{"lang":"en","description":"**Theory of Reddit** is a mildly navel-gazing space for inquiring into what makes Reddit communities work and what we in a community can do to help make it better.\n\nThis subreddit should focus on data","over18":false},"lfg":{"lang":"en","description":"LFG is a place for tabletop gamers to organize groups for the games they love to play.","over18":false},"OpiatesRecovery":{"lang":"en","description":"We are a group of people dedicated to helping each other kick the habit.","over18":false},"TheDickShow":{"lang":"en","description":"Dedicated to the podcast by Dick Masterson, The Dick Show","over18":false},"Hammers":{"lang":"en","description":"West Ham United Football Club news and discussion.","over18":false},"megalinks":{"lang":"en","description":"Links to files on Mega  ","over18":false},"BlueJackets":{"lang":"en","description":"","over18":false},"HVAC":{"lang":"en","description":"All things related to HVAC - Heating, Ventilation, & Air Conditioning","over18":false},"ARKone":{"lang":"en","description":"The leading subreddit for ARK: Survival Evolved on Xbox One. ","over18":false},"mycology":{"lang":"en","description":"for the love of fungi :: hunting,  foraging,  cultivation,  images( mycoporn ),  research, questions & general discussion\n","over18":false},"OSU":{"lang":"en","description":"","over18":false},"AlienBlue":{"lang":"en","description":"The official subreddit for the Alien Blue iOS reddit client!","over18":false},"suns":{"lang":"en","description":"Official Subreddit of your Phoenix Suns!","over18":false},"ft86":{"lang":"en","description":"For owners, enthusiasts, and those who are simply interested in the FT86: including the Scion FR-S, Subaru BRZ, and Toyota GT86.","over18":false},"rutgers":{"lang":"en","description":"The official subreddit for Rutgers University\n\nRU RAH RAH","over18":false},"WrestleWithThePlot":{"lang":"en","description":"#####[WrestleWithThePlot](http://reddit.com/r/WrestleWithThePlot) ","over18":false},"SNSD":{"lang":"en","description":"Welcome to /r/SNSD, a subreddit dedicated to the South Korean girl group: Girls' Generation (SNSD/소녀시대 / So Nyuh Shi Dae)! :) News, images, videos, music and questions are welcome~! If you're S♥NE or ","over18":false},"Sonsofanarchy":{"lang":"en","description":"Subreddit dedicated to the FX television series, Sons of Anarchy.\n","over18":false},"CompanyOfHeroes":{"lang":"en","description":"**Company of Heroes** is a highly acclaimed real-time strategy series; it uses tactical gameplay and engaging aesthetics to create dramatic Second World War battlefields.\n\nCome here for the latest new","over18":false},"drumcorps":{"lang":"en","description":"An online community dedicated to the marching arts, with a focus on drum corps. ","over18":false},"gamemaker":{"lang":"en","description":"This subreddit is dedicated to the game development platform, GameMaker Studio. GameMaker Studio is designed to make developing games fun and easy. It features a unique \"Drag-and-Drop\" system which al","over18":false},"ShittyLifeProTips":{"lang":"en","description":"A place for the shittiest, most mocking \"pro-tips\" you can think of.  Whether you want to let us know how glue can help out your hair or the quickest way to clog a public toilet, we're the place to po","over18":false},"TeenMFA":{"lang":null,"description":"Subreddit forbidden","over18":null},"BBWGW":{"lang":"en","description":"Gonewild for larger ladies and those who love them.","over18":true},"mistyfront":{"lang":"en","description":"","over18":false},"BeautyGuruChatter":{"lang":"en","description":"A space to discuss beautubers and beauty related content from brand representatives and other social media influencers.","over18":false},"NEO":{"lang":"en","description":"","over18":false},"SRSDiscussion":{"lang":"en","description":"SRSDiscussion is a moderated space for discussing social justice issues. Our goal is to foster a welcoming space for discussion, education, and respectful debate.","over18":false},"AtlantaHawks":{"lang":"en","description":"A cawmmunity of Atlanta Hawks fans from around the world. #CAWCAW","over18":false},"outside":{"lang":"en","description":"","over18":false},"dating":{"lang":"en","description":"A subreddit to discuss and vent about the dating process and learn from the experiences of others","over18":false},"LushCosmetics":{"lang":"en","description":"A subreddit for fans of Lush Cosmetics!","over18":false},"Kings_Raid":{"lang":"en","description":"A subreddit for discussing the mobile game King's Raid. ","over18":false},"twentyonepilots":{"lang":"en","description":"Central subreddit for Grammy Award-winning musical duo twenty one pilots. ","over18":false},"thalassophobia":{"lang":"en","description":"Less than 10% of the ocean has been explored. \n\nthalassophobia, megalohydrothalassophobia","over18":false},"hentai":{"lang":"en","description":"Hentai is a genre of pornography with Anime or Manga styling.","over18":true},"CanadianForces":{"lang":"en","description":"There are a lot of Canadian Armed Forces members on reddit, and a lot of Canadians who honestly & truly love the fine folks in uniform. \n\nThis unofficial subreddit is in support of past, present and f","over18":false},"greenday":{"lang":"en","description":"Green Day news, pictures, live videos and much more","over18":false},"tipofmyjoystick":{"lang":"en","description":"Have a screenshot or a description of a game, but don't know the title? Post it here!","over18":false},"NintendoNX":{"lang":"en","description":"/r/NintendoNX is the central hub for all News, Updates, Information, Rumors, Speculation, and Topics relating to Nintendo's upcoming game system codenamed \"NX\".","over18":false},"livesound":{"lang":"en","description":"A place for audio humans.","over18":false},"eroticauthors":{"lang":"en","description":"A subreddit for working or aspiring authors of erotic fiction","over18":true},"ICanDrawThat":{"lang":"en","description":"Request a drawing, or offer your drawing skills!","over18":false},"Maine":{"lang":"en","description":"A place to discuss all things Maine related. Maine, the way life should be. ","over18":false},"Magicdeckbuilding":{"lang":"en","description":"A subreddit created for the discussion of Magic the Gathering decks, ideas, card combos, and strategies.\n","over18":false},"WebGames":{"lang":"en","description":"Want to kill time? Come and play a web game! No sign-ups, no fuss, no muss, no spam.","over18":false},"ak47":{"lang":"en","description":"AK-47 Tips, Tricks, Links, and Everything Else","over18":false},"buffy":{"lang":"en","description":"Welcome, fellow Buffy fans! This community is dedicated to Joss Whedon's brain-child, Buffy the Vampire Slayer. If you haven't watched through the entirety of both \"Buffy\" and \"Angel,\" there will most","over18":false},"modelmakers":{"lang":"en","description":"The subreddit dedicated to the hobby of modelmaking.\n\nAirfix, Tamiya, Revell, Mini Art, Trumpeter, Meng, etc etc etc. Ships, Cars, Aircraft, Armour, the list goes on. It's all here, in the Model Maker","over18":false},"JordanPeterson":{"lang":"en","description":"Welcome to the discourse! This forum is dedicated to the work of Jordan Peterson, a public intellectual, clinical psychologist, and professor of psychology at the University of Toronto.","over18":false},"firstimpression":{"lang":"en","description":"","over18":false},"rocksmith":{"lang":"en","description":"Rocksmith Remastered - The Fastest Way to Learn Guitar™\n\nA community to assist on your journey of learning how to play Guitar/Bass. Find out the latest news, and ask questions to further your journey!","over18":false},"HiTMAN":{"lang":"en","description":"The best place on the internet to the discuss the Hitman franchise.","over18":false},"delusionalartists":{"lang":"en","description":"A place about artists who think they're a lot more talented than they actually are. ","over18":false},"Sissies":{"lang":"en","description":"","over18":true},"OFWGKTA":{"lang":"en","description":"Odd Future","over18":false},"Pizza":{"lang":"en","description":"The home of pizza on reddit. An educational community devoted to the art of pizza making. ","over18":false},"Harmontown":{"lang":"en","description":"Harmontown: We Get Off On Tangents.","over18":false},"DDLC":{"lang":"en","description":"Welcome! This is a subreddit for the discussion of the free visual novel Doki Doki Literature Club, created by Team Salvato.\n","over18":false},"thick":{"lang":"en","description":"Best sub for Thick women!","over18":true},"FreeKarma4You":{"lang":"en","description":"This subreddit is here to help people get used to the way Reddit works in a friendly and safe environment.","over18":false},"hardbodies":{"lang":"en","description":"Muscular and toned women. Admire, be inspired, and discuss.","over18":true},"Eugene":{"lang":"en","description":"Eugene, Oregon and the surrounding area. \n\nUO students should try /r/UofO\n","over18":false},"YGOSales":{"lang":null,"description":"Subreddit forbidden","over18":null},"minipainting":{"lang":"en","description":"A place to share ideas and techniques for painting and converting miniatures. It's also a showcase of the stuff you're really proud of.  Please observe proper reddiquette and have fun.\n","over18":false},"StandUpComedy":{"lang":"en","description":"A place for stand-up comedy videos, news, discussion and occasionally a bus stop for weird randos. ","over18":false},"BakaNewsJP":{"lang":"ja","description":"japanese funny news,pic,gif・・・etc","over18":false},"soccerstreams":{"lang":"en","description":"A subreddit dedicated to the highest quality of free soccer / football streams. World Cup Streams, too.","over18":false},"spaceporn":{"lang":"en","description":"SpacePorn is a subreddit devoted to high-quality images of space. As long as the focus of the image is of the stars or related to space in some way then it is allowed. This includes artwork as well as","over18":false},"Poetry":{"lang":"en","description":"Big Tent sub for all poetry related discussion","over18":false},"discordapp":{"lang":"en","description":"Discord is a free and secure all-in-one voice+text app designed for gamers that works on your desktop and phone.","over18":false},"losangeleskings":{"lang":"en","description":"PRIDE = PASSION = POWER\n\nThe Los Angeles Kings (LA Kings) on Reddit!","over18":false},"shitpost":{"lang":"en","description":"A repository for all of Reddit's shittiest, low effort posts.","over18":false},"Gotham":{"lang":"en","description":"A subreddit for the FOX TV series *Gotham*, chronicling the origin story behind Commissioner James Gordon's rise to prominence in Gotham City in the years before Batman's arrival. Stars Ben McKenzie a","over18":false},"mopeio":{"lang":"en","description":"Survive, Eat your way up the food chain! The official subreddit for mope.io, the hit real-time browser game.","over18":false},"MillerPlanetside":{"lang":"en","description":"A subreddit dedicated to discussion involving the Miller server of the MMOFPS Planetside 2.","over18":false},"fnafcringe":{"lang":"en","description":"Do you love/hate the popular indie-horror game *Five Nights at Freddy's*?  \n\nDo you like to cringe/look at cringey material?  \n\nDo you want to question your loyalty/hatred towards the FNaF fanbase?\n\nI","over18":false},"Metallica":{"lang":"en","description":"","over18":false},"savedyouaclick":{"lang":"en","description":"*Don't click on that, we already did.*\nFighting news media clickbait for better journalism.","over18":false},"ultrawidemasterrace":{"lang":"en","description":"This is a subreddit for all things Ultrawide, 21:9, 32:9, etc!\n\n21:9 Ultrawide gaming & productivity discussion.\n\n3440x1440, 2560x1080 and all 21:9 resolution enthusiasts are welcome, as well as those","over18":false},"donaldglover":{"lang":"en","description":"The Official Online Community about Actor, Musician, Writer, Comedian - Donald Glover (Childish Gambino)","over18":false},"androidcirclejerk":{"lang":"en","description":"Thou shall not blaspheme against Duarte, the material spirit.","over18":false},"AskScienceDiscussion":{"lang":"en","description":"Here you can ask any question you have about being a scientist, what's new in a field, what's going to happen in a field, or are curious about how we got to this point. ","over18":false},"glassheads":{"lang":"en","description":"Discussion of custom/heady blown glass by your favorite artists. No acrylic or Chinese glass. ","over18":false},"Kikpals":{"lang":"en","description":"A place for people with Kik to meet","over18":false},"gtaglitches":{"lang":"en","description":"A place to share and discuss GTA V glitches","over18":false},"howtonotgiveafuck":{"lang":"en","description":"How To Not Give A Fuck is a school of philosophy devoted to enjoying a life of pragmatic indifference.\n\nChallenge yourself everyday to question who you are and discover what you are not yet. Everythin","over18":false},"shittyreactiongifs":{"lang":"en","description":"Every reaction gif is shitty if it's on reddit.","over18":false},"LetsTalkMusic":{"lang":"en","description":"A community for people who are passionate about music. Here, stimulating, in-depth music discussions aren't rare.","over18":false},"Amateur":{"lang":"en","description":"Amateur pics and videos. Everything is NSFW.  Please join and post your favorite links.  Please use direct links to images.  No blog spam allowed.  Imgur preferred.   Enjoy!\nDo not post anything illeg","over18":true},"smoking":{"lang":"en","description":"A place to discuss techniques, tips, recipes, and pictures of smoking meats, vegetables, fruits, or anything else consumable.\n","over18":false},"reloading":{"lang":"en","description":"A Subreddit For Reloading!","over18":false},"PlayStationPlus":{"lang":"en","description":"/r/PlayStationPlus has everything you need to know about the PlayStation Plus (PS+) service including a comprehensive list of the Instant Game Collection from various PSN regions.","over18":false},"nexus5x":{"lang":"en","description":"A subreddit for the Google Nexus 5X smartphone, manufactured by LG.","over18":false},"ketogains":{"lang":"en","description":"A community driven exploration into the pursuit of physical excellence via ketosis.","over18":false},"MSLGame":{"lang":"en","description":"Monster Super League is a mobile monster catching MMO for Android & iOS. More than 550 types of Astromon await you in Monster Super League!","over18":false},"ProjectFi":{"lang":"en","description":"Discussion, news, updates, and information about Google's Wireless Carrier, Project Fi.","over18":false},"NHLStreams":{"lang":"en","description":"Watch your favorite NHL games online with community provided streams.","over18":false},"LigaMX":{"lang":"en","description":"English/Spanish-language coverage of Mexican Soccer (Liga MX, National Team, Liga de Ascenso, Women's, Futsal, Beach Soccer, etc) and Mexican players abroad.","over18":false},"TheRedLion":{"lang":"en","description":"","over18":false},"vertcoin":{"lang":"en","description":"[VTC] Vertcoin is an ASIC resistant alternative to Bitcoin and Litecoin.","over18":false},"TheExpanse":{"lang":"en","description":"The Expanse is a space opera, mystery-sci-fi drama television series based on the bestselling novels of the same name by James S. A. Corey.","over18":false},"NSFWFunny":{"lang":"en","description":"Humorous NSFW content","over18":true},"albiononline":{"lang":"en","description":"For everything about Albion Online.","over18":false},"indianpeoplefacebook":{"lang":"en","description":"This is a place to share screenshots of Indian and other non-English speaking internet users discovering the wonders of Facebook and other social media.","over18":false},"ACMilan":{"lang":"en","description":"Milano Siamo Noi","over18":false},"Frisson":{"lang":"en","description":"","over18":false},"seinfeld":{"lang":"en","description":"Hellllloooooooo! A reddit all about Jerry, George, Elaine and Kramer. Don't forget Uncle Leo!!","over18":false},"TwinCities":{"lang":"en","description":"/r/twincities is the most popular general content subreddit for all of Minnesota! Primary focus is on the Twin Cities of Minneapolis and St. Paul and surrounding suburbs.","over18":false},"French":{"lang":"en","description":"Bienvenue sur /r/French, l'espace reddit pour apprendre et enseigner le français!\n\nWelcome to /r/French, the place to learn and teach French!","over18":false},"IdiotsFightingThings":{"lang":"en","description":"A subreddit for videos, gifs, pictures, etc. of people fighting inanimate objects.","over18":false},"COMPLETEANARCHY":{"lang":"en","description":"Just... The most *Complete* Anarchy.","over18":false},"HeistTeams":{"lang":"en","description":"Many people in the GTA community don't have any friends who play on the same console, or may only have one friend. This subreddit is here to help you find people to take part in heists with you, if yo","over18":false},"PolishGauntlet":{"lang":"en","description":"","over18":false},"NewYorkIslanders":{"lang":"en","description":"","over18":false},"Hamilton":{"lang":"en","description":"Hamilton, Ontario, Canada    \n43.2555,-79.8732","over18":false},"entwives":{"lang":"en","description":"A place for ladies of the trees to talk with other ladies of the trees.","over18":false},"sjwhate":{"lang":"en","description":"Observatory for Social Justice: SJW. SJWs. Oppression. Patriarchy. Mansplaining. Trigger. Triggered. Triggering. Beta Male. White Knight. Social Justice Warriors. Cultural Marxism. Leftism. pol. 4chan","over18":false},"OneY":{"lang":"en","description":"A place to thoughtfully discuss issues that affect men of the world today. Everyone is welcome but intolerance is not.","over18":false},"SargonofAkkad":{"lang":"en","description":"This is a Subreddit for the YouTuber Sargon of Akkad, his subs and fans. Welcome!","over18":false},"Needafriend":{"lang":"en","description":"Are you looking for a new friend or a kind voice? This is a subreddit for people looking to make strictly platonic friends from nearby or around the world. You are welcome to post and talk, private me","over18":false},"fnv":{"lang":"en","description":"Fallout New Vegas community and everything related. ","over18":false},"DesignerReps":{"lang":"en","description":"This community is made for sharing, searching for and discussing replicas of designer brands only. Please do make reviews of what you buy and ask questions according to rules. Also please check the FA","over18":false},"PenmanshipPorn":{"lang":"en","description":"Penmanship Porn","over18":false},"democrats":{"lang":"en","description":"Offers daily news updates, policy analysis, links, and opportunities to participate in the political process. Feel free to discuss the 2018 midterm elections. \n\nDemocrats, democratic, democrat, dem, g","over18":false},"iosgaming":{"lang":"en","description":"iOS Gaming News, Discussion and Recommendations. Mobile games on Apple iPhone or iPad.","over18":false},"Favors":{"lang":"en","description":"We're all about favors from redditors to redditors.  We're totally against ditch-digging and liking stuff on Facebook.  The rest of it is in the FAQ.","over18":false},"Iota":{"lang":"en","description":"","over18":false},"MouseReview":{"lang":"en","description":"Performance mouse lovers squeaking in a content rich, friendly place. The goal of this subreddit is to provide daily links to interesting performance mice content.","over18":false},"NorthCarolina":{"lang":"en","description":"A subreddit for the state of North Carolina. ","over18":false},"balisong":{"lang":"en","description":"**Welcome to /r/balisong! This is a community for balisong flippers, collectors, and anyone who is interested in the art/sport of butterfly knives. Feel free to post pictures of your collection, video","over18":false},"SilkRoad":{"lang":"en","description":"A community for discussion of the history of & research on the now-defunct darknet markets Silk Road 1 & 2, and topics such as arrests of their users, Ross Ulbricht's legal case, the status of Blake B","over18":true},"blackpeoplegifs":{"lang":"en","description":"Black People Gifs","over18":false},"tolkienfans":{"lang":"en","description":"Welcome to r/tolkienfans! This subreddit is a space for the Tolkien nerds of reddit to debate and discuss the whole Tolkien mythos. We emphasise serious discussion here over jokey/meme-based posts. Th","over18":false},"cpp":{"lang":"en","description":"Discussions, articles and news about the C++ programming language or programming in C++.","over18":false},"AppNana":{"lang":"en","description":"Submit your invitation codes on a thread for everyone to see!","over18":false},"lockpicking":{"lang":"en","description":"**A subreddit dedicated to the sport of lockpicking.**","over18":false},"TrueAskReddit":{"lang":"en","description":"/r/TrueAskReddit is a subreddit for intelligent discussion about interesting issues. Low effort comments, memes, jokes and trolls beware!","over18":false},"2b2t":{"lang":"en","description":"2b2t is a minecraft server with the goal to never reset the world in a free for all no rules pvp environment, with little modification to the vanilla survival gamemode. The world is seven years old, w","over18":false},"fcbayern":{"lang":"en","description":"A subreddit dedicated to FC Bayern Munich","over18":false},"MealPrepSunday":{"lang":"en","description":"/r/MealPrepSunday is a subreddit dedicated to meal prepping. This is a space to discuss all things about meal prepping. Whether you're looking to prep to save time, money, or to get in those gains, th","over18":false},"GoneWildCD":{"lang":"en","description":"A place for the lovely crossdressers of reddit to post sexy photos of themselves in exchange for karma.\n\nGo wild!","over18":true},"PixelArt":{"lang":"en","description":"Welcome to /r/PixelArt, where you can browse, post, ask questions, get feedback and learn about our favorite digitally restrictive art form, Pixel Art!\n\n","over18":false},"OWConsole":{"lang":"en","description":"For the discussion of all things that relate to the console version of Overwatch!","over18":false},"Insurance":{"lang":"en","description":"All Things Insurance! ","over18":false},"DnB":{"lang":"en","description":"All things drum & bass.","over18":false},"TalesFromThePizzaGuy":{"lang":"en","description":"Tales From The Pizza Guy, including *any* and *all* stories from the heroes of **food delivery!**!","over18":false},"roguelikes":{"lang":"en","description":"A subreddit for games descended from Rogue - a sub-genre of RPG games involving things like permadeath and randomized levels. This community is mostly centred around traditional roguelike games which ","over18":false},"RedPillWomen":{"lang":"en","description":"Welcome to the *original* Red Pill Women subreddit!","over18":false},"NeverBeGameOver":{"lang":"en","description":"https://www.reddit.com/r/metalgearsolid/comments/3lme8z/to_unlock_chapter_3/","over18":false},"againstmensrights":{"lang":"en","description":"You might have heard that /r/MensRights is a moderate MRA hub. They’re just advocating for the rights of men, right? What’s so bad about that?\n\nBut all is not as it seems. Underneath the face lie toxi","over18":false},"Firefighting":{"lang":"en","description":"Reddit Fire Department ","over18":false},"TiADiscussion":{"lang":"en","description":"Tumblr in Action serious business discussion area","over18":false},"criterion":{"lang":"en","description":"","over18":false},"geology":{"lang":"en","description":"The scientific study of the origin, history, and structure of the Earth.","over18":false},"stephenking":{"lang":"en","description":"","over18":false},"gaybrosgonemild":{"lang":"en","description":"A place for Bros to share photos of themselves, attach a face to a name, create friendships and enjoy the beautiful boys of the world","over18":false},"reptiles":{"lang":"en","description":"A cozy place for anyone who loves cold-blooded creatures of the world.","over18":false},"ChoosingBeggars":{"lang":"en","description":"NEXT!","over18":false},"hockeyjerseys":{"lang":"en","description":"The subreddit for hockey jersey fanatics!\n\nPlease note, we do not endorse fake jerseys or allow the selling of fake jerseys. ","over18":false},"tressless":{"lang":"en","description":"Tressless is Reddit's most popular community for hair loss and balding. Feel free to discuss hair loss remedies, technologies, transplants, living with hair loss, cosmetic concealments, whether to \"ta","over18":false},"GTA":{"lang":"en","description":"This reddit community is dedicated to the game     **Grand Theft Auto**. Feel free to discuss any aspect of the game you want. This is an open forum to discuss the current, as well as past seasons.","over18":false},"dawngate":{"lang":"en","description":"**The game will shutdown on 4th of February, 2015.**\n\nDawngate is a new MOBA, built from the ground up to look and feel familiar while offering a whole new way to experience MOBA gameplay. Dawngate em","over18":false},"User_Simulator":{"lang":"en","description":"It's all in the title.","over18":false},"Nexus7":{"lang":"en","description":"For fans of the Asus Nexus 7 (Original and 2013 edition) and a source for the latest related news","over18":false},"marketing":{"lang":"en","description":"For marketing professionals to discuss and ask questions related to the marketing industry. Traditional, digital, email, content, SEO, print & online advertising, social media, email, design, analytic","over18":false},"sabres":{"lang":"en","description":"Welcome to the Reddit home of the Buffalo Sabres.","over18":false},"photoshop":{"lang":"en","description":"For all things Photoshop - except Photoshop requests.","over18":false},"cemu":{"lang":"en","description":"The Cemu emulator's subreddit.","over18":false},"Vermintide":{"lang":"en","description":"A Rat Slaying Subreddit for Warhammer: The End Times - Vermintide, and Warhammer: Vermintide 2.","over18":false},"HPMOR":{"lang":"en","description":"The unofficial subreddit for \"Harry Potter and the Methods of Rationality\" by Eliezer Yudkowsky (aka \"Less Wrong\").","over18":false},"playstation":{"lang":"en","description":"All things PlayStation.\n","over18":false},"HailCorporate":{"lang":"en","description":"/r/HailCorporate is to document times when people act as unwitting advertisers for a product [[example A](https://imgur.com/OavkkSk)] as well as to document what appear to legitimate adverts via [nati","over18":false},"editors":{"lang":"en","description":"A subreddit centered around post-production, professional editing, and everything in between.","over18":false},"SanJose":{"lang":"en","description":"A subreddit dedicated to San José, California, the heart of the Silicon Valley. ","over18":false},"Survival":{"lang":"en","description":"The Wilderness Survival subreddit.","over18":false},"truezelda":{"lang":"en","description":"The goal of /r/TrueZelda is to provide a place for informative and interesting Zelda related content and discussions without all the extra fluff from /r/Zelda.","over18":false},"CGPGrey":{"lang":"en","description":"Subreddit for CGP Grey stuff.","over18":false},"TibiaMMO":{"lang":"en","description":"A community for the Tibia MMORPG.","over18":false},"reddCoin":{"lang":"en","description":"Reddcoin is the social currency that enriches people's social lives and makes digital currency easy for the general public. Visit www.reddcoin.com for more information.","over18":false},"redditblack":{"lang":"tr","description":"#1 CoD Clan & Reddit's top gaming community.","over18":false},"taiwan":{"lang":"en","description":"For those interested in Taiwan! Feel free to share content with the community.","over18":false},"howto":{"lang":"en","description":"How To and DIY for redditors! /r/Howto","over18":false},"Plumbing":{"lang":"en","description":"Don't advertise or try to compare pricing, thanks","over18":false},"BeardedDragons":{"lang":"en","description":"","over18":false},"FreeKarma":{"lang":null,"description":"Subreddit forbidden","over18":null},"wedding":{"lang":"en","description":"A place for brides, grooms, friends, and family to discuss and share their wedding plans, ideas, and experiences. \n\n","over18":false},"oklahoma":{"lang":"en","description":"Your spot for redditors in Oklahoma!","over18":false},"PeopleFuckingDying":{"lang":"en","description":"Videos and GIFs of people (figuratively) fucking dying.","over18":false},"spotify":{"lang":"en","description":"","over18":false},"badtattoos":{"lang":"en","description":"","over18":false},"supergirlTV":{"lang":"en","description":"The subreddit for the Supergirl comic book TV series on The CW.  Discuss anything and everything about the show here.","over18":false},"holdthemoan":{"lang":"en","description":"Kinky ladies try to \"hold their moans\" as they get adventurous during inappropriate times.\n\nThey will daringly expose themselves in a park, mall, restroom, store, bus, car, and more!\n\nFucking while ta","over18":true},"BikiniBottomTwitter":{"lang":"en","description":"The official subreddit for Spongebob memes","over18":false},"letsgofish":{"lang":"en","description":"","over18":false},"LV426":{"lang":"en","description":"**[LV-426](http://aliens.wikia.com/wiki/LV-426)**: a subreddit dedicated to the [*Alien* franchise](http://en.wikipedia.org/wiki/Alien_(Alien_franchise\\)).\n\nFor fans of James Cameron's 1986 sci-fi cla","over18":false},"Beatmatch":{"lang":"en","description":"","over18":false},"fasting":{"lang":"en","description":"The great comedian, Ed Wynn said, \"Without your health, riches, possessions and fame are all mud.\" \n\nWith the high costs of health care, how can we *afford* not to keep ourselves well? Most fast for h","over18":false},"powerrangers":{"lang":"en","description":"This subreddit is for Discussion/fan-art/all other things related to Power Rangers.\n\n\nEnjoy, and may the power protect you.","over18":false},"badcompany2":{"lang":"en","description":"","over18":false},"transgender":{"lang":"en","description":"**Transgender news, issues, and discussion**","over18":false},"ElderScrolls":{"lang":"en","description":"The Elder Scrolls (commonly referred to as TES) is an award-winning series of roleplaying games created by Bethesda Softworks. Set in the vast world of Nirn, The Elder Scrolls series is renowned for t","over18":false},"AccidentalRenaissance":{"lang":"en","description":"Welcome to /r/AccidentalRenaissance, the subreddit that showcases photographs that inadvertently resemble well-composed Renaissance style art. ","over18":false},"Tulpas":{"lang":"en","description":"Ever wondered what it would be like to have a mental companion who can think and act on their own? That's what a tulpa is. (Yes, it's a strange word. We didn't make it up, the Tibetans did many centur","over18":false},"Brunei":{"lang":"en","description":"A subreddit for all things related to the country of Brunei Darussalam, located at the heart of Southeast Asia.","over18":false},"ContagiousLaughter":{"lang":"en","description":"Something to put you in a good mood\n\nVideos and audio of people laughing infectiously. No context required","over18":false},"ShitLiberalsSay":{"lang":"en","description":"A place that archives the worst liberals on Reddit, from around the Internet & from real life. ","over18":false},"EtherMining":{"lang":"en","description":"Discussion of mining the cryptocurrency Ethereum. Ask questions or receive news about about mining, hardware, software, profitability, and other related items.","over18":false},"survivetheculling":{"lang":"en","description":"The Culling is a brutal Battle-Royale survival game available on Steam. It features intense 16-player arena style combat with a variety of weapons, craftables, costumes, perks, loadouts, game modes, a","over18":false},"ATBGE":{"lang":"en","description":"Awful\n\nTaste\n\nBut\n\nGreat\n\nExecution\n\n\n\nFor everything that displays quality craftsmanship in the least elegant way possible. All things gaudy, tacky, overdone, and otherwise tasteless. Work done so we","over18":false},"Bestbuy":{"lang":"en","description":"r/BestBuy is a 100% community-driven subreddit aimed to allow for both customers and employees to engage in meaningful conversations regarding the company or their local store. We are not officially e","over18":false},"UnearthedArcana":{"lang":"en","description":"A subreddit for fleshed-out rules and additions to DnD 5e.","over18":false},"KarmaCourt":{"lang":"en","description":"KarmaCourt is the Supreme jurisdiction of the Internet. \n\nGet Justice while it's on!","over18":false},"AskAcademia":{"lang":"en","description":"This subreddit is for discussing academic life, and for asking questions directed towards people involved in academia, (both science and humanities).","over18":false},"BeautyGuruChat":{"lang":null,"description":"Subreddit forbidden","over18":null},"wec":{"lang":"en","description":"The official subreddit for the FIA World Endurance Championship, and the ACO's 24 Hours of Le Mans.","over18":false},"Sat":{"lang":"en","description":"A forum to discuss the SAT and forms of preparation for taking the test. Visit to find \n\n- Help \n\n- Statistics \n\n- Practice tests \n\n- Practice Subject tests\n\n- Discussion\n\nand more!","over18":false},"C_S_T":{"lang":"en","description":"A safe place to discuss outside-of-the-box thinking with similar minds.","over18":false},"perktv":{"lang":"en","description":"","over18":false},"ronandfez":{"lang":"en","description":"","over18":false},"evilbuildings":{"lang":"en","description":"If the building could be the home to a super villain or evil corporation, it belongs here\n\nor really just any creepy looking building\n\nor maybe just anything evil\n\nor ok just buildings\n\nno no lets jus","over18":false},"The_Division":{"lang":"en","description":"Anything and everything about The Division","over18":false},"torrents":{"lang":"en","description":"But you wouldn't download a new Director of Talent\n","over18":false},"LinuxActionShow":{"lang":"en","description":"Linux Action Show is the world's largest and longest running Linux-based podcast.\n\nJupiter Broadcasting is the home of many fantastic online shows. Like Linux Action Show, Coder Radio, Linux Unplugged","over18":false},"csharp":{"lang":"en","description":"","over18":false},"angelsbaseball":{"lang":"en","description":"Subreddit for the Los Angeles Angels - Officially still the Los Angeles Angels of Anaheim, but everyone believes the clickbait articles 😒","over18":false},"HaloStory":{"lang":"en","description":"/r/HaloStory is a place for people to go to discuss the story and lore of Microsoft's hit sci-fi franchise -- Halo.","over18":false},"singing":{"lang":"en","description":"A subreddit for singers of all ages, experience levels, voice types and music genres. If you sing, are interested in singing, or have questions about singing, here's the place! We welcome all users ne","over18":false},"ECE":{"lang":"en","description":"A subreddit for discussion of all things electrical and computer engineering.","over18":false},"ffxi":{"lang":"en","description":"A community for those who play Square Enix's 1st MMORPG \"Final Fantasy XI\", also known as FFXI or FF11. PC servers still operational; FFXI Mobile is an upcoming title and is not yet released.","over18":false},"FanFiction":{"lang":"en","description":"For discussion and sharing of your favorite FanFiction.","over18":false},"Predators":{"lang":"en","description":"The official subreddit of the Nashville Predators. #NHL #hockey","over18":false},"DCComicsLegendsGame":{"lang":"en","description":"subreddit dedicated to discussing the iOS/Android mobile game DC  Legends","over18":false},"RecruitCS":{"lang":"en","description":"","over18":false},"PickAnAndroidForMe":{"lang":"en","description":"We're 10,000+ people, and we've been here since 2012. We're about to help you find the phone that suits you best.","over18":false},"Trucking":{"lang":"en","description":"**THIS SUB IS CLOSED**\n\n**Please head over to /r/Truckers**\n\n**THIS SUB IS CLOSED**\n\n**Please head over to /r/Truckers**\n\n**THIS SUB IS CLOSED**\n\n**Please head over to /r/Truckers**\n\n**THIS SUB IS CLO","over18":true},"BatmanArkham":{"lang":"en","description":"This subreddit is dedicated to the discussion of all Batman: Arkham games and the Batman: Arkham universe in general. This includes Arkham Asylum, Arkham City, Arkham Origins and all tie-in games and ","over18":false},"triathlon":{"lang":"en","description":"A subreddit dedicated to the sport of triathlon, and all of its constituent components, quirks, and joys.\n\n","over18":false},"usenet":{"lang":"en","description":"We are a thriving community dedicated to helping users old and new understand and use usenet.","over18":false},"GaryJohnson":{"lang":"en","description":"[Gary E. Johnson](http://bit.ly/2eTUfze) was a two-term governor (R) in the blue state of New Mexico.  He was the Libertarian Party's nominee for POTUS in [2012](http://bit.ly/2eyLejP) and [2016](http","over18":false},"DetroitPistons":{"lang":"en","description":"The Reddit Home for Pistons Fans!","over18":false},"snackexchange":{"lang":"en","description":"Snack exchange is a community that allows redditors to connect and exchange snacks via mail. Often, exchanges are international and provide an opportunity to enjoy difficult-to-find snacks from other ","over18":false},"birthcontrol":{"lang":"en","description":"A place to discuss birth control methods.","over18":false},"MaliciousCompliance":{"lang":"en","description":"People conforming to the letter, but not the spirit, of a request.","over18":false},"digimon":{"lang":"en","description":"Welcome to /r/digimon - a place to talk and share things about Digimon: the animated series, the video games, the card game, and the movies!","over18":false},"longrange":{"lang":"en","description":"The subreddit for long range precision shooting enthusiasts.","over18":false},"MovieDetails":{"lang":"en","description":"MovieDetails: Interesting and unnoticed details that appear in movies.","over18":false},"shittykickstarters":{"lang":"en","description":"A compilation of crowdfunding train wrecks.","over18":false},"InteriorDesign":{"lang":"en","description":"","over18":false},"Stormlight_Archive":{"lang":"en","description":"A community to discuss the fantasy series *The Stormlight Archive* by Brandon Sanderson, along with other Cosmere-related works.","over18":false},"MakeNewFriendsHere":{"lang":"en","description":"This subreddit is for those who are looking to make some new friends on Reddit.","over18":false},"littlespace":{"lang":"en","description":"A place for littles, middles, caregivers, and anyone interested in CGL, DDLG, or ABDL dynamics and lifestyles.","over18":true},"shadowofmordor":{"lang":"en","description":"For all news, information and discussion about the game Middle Earth: Shadow of Mordor and its sequel, Middle Earth: Shadow of War","over18":false},"Re_Zero":{"lang":"en","description":"Re:Zero kara Hajimeru Isekai Seikatsu, known in English as Re: Starting Life in a Different World from Zero, is a Japanese light novel written by Tappei Nagatsuki, and illustrated by Shinichirou Otsuk","over18":false},"fragrance":{"lang":"en","description":" Women's, Men's and Shared Fragrance.\n A place to discuss all the smells!\n\n.\n","over18":false},"BestOfOutrageCulture":{"lang":"en","description":"the cuck shed","over18":false},"FalloutMods":{"lang":"en","description":"Everything Fallout modding, from Fallout 1 to Fallout 4 and everything in between.","over18":false},"BlueMidterm2018":{"lang":"en","description":"A subreddit for Democrats to discuss the 2018 midterm elections - primaries, candidates, strategy, news, odds, funding, volunteering, donations and more. Discuss everything from state legislatures to ","over18":false},"celebnsfw":{"lang":"en","description":"","over18":true},"bigboobproblems":{"lang":"en","description":"Vent in this judgment-free community that encourages discussion in a safe environment.","over18":false},"mormon":{"lang":"en","description":"/r/Mormon is a subreddit for articles and topics of interest to people interested in Mormon themes.  People of all faiths and perspectives are welcome to engage in civil, respectful discussion about t","over18":false},"TrueOffMyChest":{"lang":"en","description":"","over18":false},"whatstheword":{"lang":"en","description":"","over18":false},"subnautica":{"lang":"en","description":"Subnautica is an open world underwater exploration and construction game.","over18":false},"rpg_gamers":{"lang":"en","description":"RPG_Gamers is a subreddit for fans of all videogame RPGs from JRPGs (Final Fantasy, Dragon Quest), Western RPGs (Fallout, Baldur's Gate), action games with RPG elements (Diablo, League of Legends), an","over18":false},"beholdthemasterrace":{"lang":"en","description":"Supremacists of any shade displaying their supremacy ","over18":false},"GWCouples":{"lang":"en","description":"","over18":true},"Whatisthis":{"lang":"en","description":"For Identification Of Unknown Objects, i.e., Weird Creatures, Ancient Kitchen Gadgets, Funny-Looking Screwdrivers, Other Random Artifacts.","over18":false},"allthingszerg":{"lang":"en","description":"All Things Zerg is a discussion/help subreddit focusing on the Zerg race from Blizzard Entertainment's critically acclaimed RTS game Starcraft 2. Strategy, discussion and questions are welcome, but an","over18":false},"hardstyle":{"lang":"en","description":"","over18":false},"HuntsvilleAlabama":{"lang":"en","description":"A subreddit for the Rocket City,","over18":false},"GifSound":{"lang":"en","description":"Gif Sound Mashups / Gifs with Sound Combos","over18":false},"FulfillmentByAmazon":{"lang":"en","description":"For mid to high level discussions about selling on Amazon and using their Fulfillment by Amazon (FBA) service.","over18":false},"Idubbbz":{"lang":"en","description":"","over18":false},"bartenders":{"lang":"en","description":"","over18":false},"help":{"lang":"en","description":"A subreddit to ask questions (and get answers) about reddit","over18":false},"LearnUselessTalents":{"lang":"en","description":"This is a place to learn how to do cool things that have no use other than killing time and impressing strangers.","over18":false},"vmware":{"lang":"en","description":"The un-official VMware Reddit.","over18":false},"copypasta":{"lang":"en","description":"This subreddit was made to archive copypasta.","over18":false},"CherokeeXJ":{"lang":"en","description":"If it's an XJ or MJ then its welcomed here!\n\n \n","over18":false},"marriedredpill":{"lang":"en","description":"[The Red Pill](http://www.reddit.com/r/TheRedPill/) (TRP) main subreddit is a discussion of sexual strategy in a culture increasingly lacking a positive identity for men.  [Married Red Pill](http://ww","over18":false},"PowerShell":{"lang":"en","description":"Windows PowerShell (POSH) is a command-line shell and associated scripting language created by Microsoft. Offering full access to COM, WMI and .NET, POSH is a full-featured task automation framework f","over18":false},"iOSProgramming":{"lang":"en","description":"A subreddit to share articles, code samples, open source projects and anything else related to iOS, watchOS or tvOS development. Swift or Objective-C.","over18":false},"PS2Cobalt":{"lang":"en","description":"Subreddit for Cobalt EU Server Community Communications (and drama) in the Planetside 2 PC Game","over18":false},"Staples":{"lang":"en","description":"/r/staples is a place for Staples employees to discuss everything to do with Staples, whether it be questions about operations, discussions about sales techniques, or even just venting about your mana","over18":false},"shorthairedhotties":{"lang":"en","description":"We're glad you found us.\n\nThis is a place to admire the rare beauty of shorthaired women.\n\nFeel free to post pictures, videos, articles and start discussions.\n\nPlease subscribe if you like it here!\n\n#","over18":false},"Mavericks":{"lang":"en","description":"","over18":false},"AskMenOver30":{"lang":"en","description":"AskMenOver30 is a place for supportive and friendly conversations between over 30 adults.\n\n\n\n","over18":false},"Agario":{"lang":"en","description":"A subreddit dedicated to the cell eating webgame at agar.io.","over18":false},"berlin":{"lang":"en","description":"The subreddit for everything relating to Berlin, capital city of Germany.","over18":false},"fifthworldproblems":{"lang":"en","description":"","over18":false},"lrcast":{"lang":"en","description":"The Limited Resources podcast runs every week with the goal of teaching you how to improve at Magic: the Gathering with an emphasis on Limited. ","over18":false},"comicswap":{"lang":"en","description":"Need to make room for more comics? Perhaps you have an empty shelf or long box to fill up? Always looking in the back issues of your LCS? Well this is the place for you! Find kicking deals or make som","over18":false},"EliteOne":{"lang":"en","description":"Elite: Dangerous XBOX One Community","over18":false},"Swimming":{"lang":"en","description":"Swimming, from beginners to recreational to competitive swimming. Pool and open water.","over18":false},"Vaporwave":{"lang":"en","description":"Global capitalism is nearly there. At the end of the world there will only be liquid advertisement and gaseous desire. Sublimated from our bodies, our untethered senses will endlessly ride escalators ","over18":false},"DMT":{"lang":"en","description":"***\nWelcome to /r/DMT.\n\nWe are a community connected by DMT.\n\n(N,N-Dimethyltryptamine)\n***","over18":true},"UHCMatches":{"lang":"en","description":"Welcome to the /r/UHCMatches Subreddit!\n\nThis is where all scheduled matches for /r/ultrahardcore will be posted!","over18":false},"rccars":{"lang":"en","description":"Subreddit devoted to RC Cars, Buggies, Truggies, Short Course Trucks, and everything in-between!","over18":false},"schizophrenia":{"lang":"en","description":"r/schizophrenia is a subreddit for the general discussion of schizophrenia and support. ","over18":false},"intel":{"lang":"en","description":"Subreddit for Intel related news and discussions.","over18":false},"curvy":{"lang":"en","description":"A subreddit for curvaceous cuties, hotties with hourglass figures, voluptuous vixens, buxom babes, chubby chicas, plump peaches and all-round luscious ladies. Self-shots are welcome!","over18":true},"Spanish":{"lang":"en","description":"Practice, learn and teach others Spanish. Share information, stories and more on themes related to this wonderful language.","over18":false},"IBO":{"lang":"en","description":"The subreddit for the International Baccalaureate Diploma Programme (IBDP). This subreddit encourages questions, constructive feedback, and the sharing of knowledge and resources among IB students, al","over18":false},"swoleacceptance":{"lang":"en","description":"We're Here. We're Swole. Deal with it. ","over18":false},"AndroidMasterRace":{"lang":"en","description":"The official subreddit of shit posting","over18":false},"AskVet":{"lang":"en","description":"A place where you can ask veterinary medicine related questions and get advice from veterinary professionals.","over18":false},"Gameboy":{"lang":"en","description":"A subreddit dedicated to discussion of the Nintendo Game Boy. Discussion of all Game Boy models, handheld swaps, mods, games, and homebrew are encouraged. ","over18":false},"xkcd":{"lang":"en","description":"/r/xkcd is the subreddit for the popular webcomic XKCD by Randall Munroe.  Come to discuss the comics and other work by Randall with other fans.","over18":false},"Colorado":{"lang":"en","description":"","over18":false},"ChronicPain":{"lang":"en","description":"For the broken, malfunctioning, pained people of the world and their friends/family. Got pain? This is the place to be. Bitching, complaining, whining, and otherwise venting about your condition is en","over18":false},"TheLeftovers":{"lang":"en","description":"Subreddit for the critically acclaimed TV show on HBO based on Tom Perrotta’s 2011 book.","over18":false},"CODModernWarfare":{"lang":"en","description":"Merged with /r/CallofDuty\n\n/r/CODModernWarfare is a home for the Call of Duty: Modern Warfare Remastered community and a hub for the discussion and sharing of content relevant to the game. \n\nCall of D","over18":false},"Addons4Kodi":{"lang":"en","description":"This sub is for discussion and links pertaining to unofficial addons for Kodi Media Center and is not endorsed by Team Kodi/XBMC nor their foundation. Discussion of core Kodi functionality or addons f","over18":false},"BitTippers":{"lang":"en","description":"A place to tip some bits. Want to do a giveaway or a little contest - but aren't an early adopter with a shed full of btc? \n\nWell come on in, have some fun, throw some pennies around. We not all rich,","over18":false},"longisland":{"lang":"en","description":"The Laaawnguyland sub-reddit.","over18":false},"benzodiazepines":{"lang":"en","description":"A subreddit for all benzodiazepine users to gather to discuss all things benzo related. Whether its a question, picture, or information. Whether you have experience with them, are new to them, or are ","over18":false},"literature":{"lang":"en","description":"Welcome to /r/literature, a community for deeper discussions of plays, poetry, short stories, and novels. Discussions of literary criticism, literary history, literary theory, and critical theory are ","over18":false},"altright":{"lang":null,"description":"Subreddit no longer exists","over18":null},"redditsync":{"lang":"en","description":"The official subreddit of Sync for reddit (previously reddit sync).","over18":false},"Pmsforsale":{"lang":"en","description":"    Thanks to http://www.reddit.com/r/silverbugs for all of your support. \n\nThis subreddit has been designed as a place for the community to buy, sell, or trade precious metals. This sub should not be","over18":false},"Porsche":{"lang":"en","description":"","over18":false},"Breadit":{"lang":"en","description":"Breadit is a community for anything related to making homemade bread!","over18":false},"Connery":{"lang":"en","description":"The subreddit for the Planetside 2 server, Connery (US West)","over18":false},"SiliconValleyHBO":{"lang":"en","description":"The subreddit for the HBO show Silicon Valley. We are making the world a better place.","over18":false},"InjusticeMobile":{"lang":"en","description":"A subreddit for the mobile version of the Injustice fighting game.","over18":false},"trashyboners":{"lang":"en","description":"*One man's trash is another man's boner.* \n\n\n-/u/Zwoogy\n","over18":true},"Diablo3Monks":{"lang":"en","description":"The subreddit dedicated to everything about the Monk class in Diablo 3!","over18":false},"MINI":{"lang":"en","description":"For owners and fans of the mighty Mini Cooper. Both new MINIs and Classic Minis are welcome here.","over18":false},"AyyMD":{"lang":"en","description":"All things AMD. Graphics cards, CPUs, SSDs, memory, innovation, you name it. Fuck Intel, fuck Nvidia, AMD will set them ablaze and drown them in their cries for mercy.\n\nAlso dank memes (mostly).","over18":false},"normalnudes":{"lang":"en","description":"Normal Nudes is an effort to have users submit their own pictures in order to build a library of what normal, every day human bodies look like. We should strive to love our bodies for what they are, a","over18":true},"allthingsprotoss":{"lang":"en","description":"AllThingsProtoss is a subreddit dedicated to the discussion of Starcraft 2, focusing in particular on the Protoss.  Everything from the most basic of questions to complex, in-depth theorycrafting can ","over18":false},"youdontsurf":{"lang":"en","description":"http://i.imgur.com/I0DznLi.png\n","over18":false},"nier":{"lang":"en","description":"A community for fans of the Square Enix series which includes;  Nier/Nier: Automata and Drakengard Trilogy. Discussions on the games, art books, drama CDs, musical scores, live concerts, the talent be","over18":false},"FantasyWarTactics":{"lang":"en","description":"Fantasy War Tactics is a tactical strategy RPG originally developed by Nexon.","over18":false},"GilmoreGirls":{"lang":"en","description":"An American TV show about a single mother and her daughter","over18":false},"atlbeer":{"lang":"en","description":"This is a group for those who love drinking, discussing, brewing. and sharing beer in Atlanta and all around Georgia. It is a place for people create and share events and news and for all around promo","over18":false},"ios":{"lang":"en","description":"","over18":false},"WonderTrade":{"lang":"en","description":"This subreddit is for the discussion of the Wonder Trade system in Pokemon! ","over18":false},"Deusex":{"lang":"en","description":"Subreddit dedicated to the Deus Ex series. Please stay out of of the ladies' restroom.","over18":false},"SantasLittleHelpers":{"lang":"en","description":"","over18":false},"sousvide":{"lang":"en","description":"Welcome to SousVide: The subreddit for everything cooked in a temperature controlled water-bath.   Join the discussion, improve the community!  ","over18":false},"ElectricSkateboarding":{"lang":"en","description":"A community to hang out and discuss anything related to electric-powered skateboarding. When technology replaces wheels with wind or anti-gravity magnets, you can still talk or find about it here.\n","over18":false},"NewSkaters":{"lang":"en","description":"This sub is for all of you new skateboarders out there. Whether you haven't even started and need help picking a board, or you've been skating for months (even years!) and still need help or want to h","over18":false},"Cuckold":{"lang":"en","description":"A Forum for Cuckolds & Hotwives","over18":true},"greentext":{"lang":"en","description":"The realm of the most anti-climactic short stories from 4chan.","over18":false},"MetalMemes":{"lang":"en","description":"Memes about heavy metal","over18":false},"Tucson":{"lang":"en","description":"The subreddit for Tucson, Arizona; Tucson is a city in Arizona’s Sonoran Desert surrounded by multiple mountain ranges, including the Santa Catalinas. Home to the University of Arizona, Tucson has man","over18":false},"mlb":{"lang":"en","description":"","over18":false},"londonontario":{"lang":"en","description":"Subreddit for news, discussion, and anything else related to London, Ontario.","over18":false},"vim":{"lang":"en","description":"For Vim enthusiasts and anyone interested in Vim.","over18":false},"ENFP":{"lang":"en","description":"Ne-Fi-Te-Si","over18":false},"lawschooladmissions":{"lang":"en","description":"The subreddit for law school admissions discussion. How to get into American and Canadian law schools. Help with law school personal statements, application requirements, and admissions chances.","over18":false},"UMD":{"lang":"en","description":"The official subreddit of the University of Maryland - College Park, the flagship institution of the state of Maryland. Go Terps!","over18":false},"mturk":{"lang":"en","description":"A subreddit focused on Amazon's crowd work platform, Mechanical Turk (MTurk)","over18":false},"skyrimrequiem":{"lang":"en","description":"Subreddit Dedicated the Skyrim Mod \"Requiem\" subtitled \"The role playing overhaul\" the mod aims to create an immersive experience that provides a good base for player progression with classic RPG aspe","over18":false},"Liberal":{"lang":"en","description":"","over18":false},"ucf":{"lang":"en","description":"A subreddit for UCF students, faculty, and staff.","over18":false},"OrthodoxChristianity":{"lang":"en","description":"A subreddit dedicated to discussion of Eastern Christianity.","over18":false},"PlanetDolan":{"lang":"en","description":"Official subreddit for the YouTube channel Planet Dolan\nhttps://www.youtube.com/c/dangerdolan","over18":false},"moto360":{"lang":"en","description":"Moto 360 related news, tips, watch faces, discussion, apps, and more.","over18":false},"falloutlore":{"lang":"en","description":"A place to discuss the lore of the Fallout universe. ","over18":false},"EverythingScience":{"lang":"en","description":"/r/EverythingScience is the sister subreddit to /r/science. With a broader rule set that /r/science, it is the place for high quality scientific content that doesn't necessarily reference a peer-revie","over18":false},"subredditcancer":{"lang":"en","description":"Behavior counter to reddit's originally expressed ideals\n\n\"We want to democratize the traditional model by giving editorial control to the people who use the site, not those who run it.\"\n\n\"A bastion o","over18":false},"Trumpgret":{"lang":"en","description":"A sub to catalog one of the most massive returns to reality in history.","over18":false},"AskPhysics":{"lang":"en","description":"A subreddit to draw simple physics questions away from /r/physics.  No real rules; ask away.  \n\nIf your basic physics question isn't answered in a day, you can post it to /r/physics if you mention tha","over18":false},"ynab":{"lang":"en","description":"A discussion subreddit for popular budgeting software You Need A Budget. Feel free to post any news, questions, budget strategies, tips & tricks and advice related to YNAB.\n\n\n\nRelated to personal fina","over18":false},"Cigarettes":{"lang":"en","description":"","over18":false},"GunPorn":{"lang":"en","description":"","over18":false},"GalaxyS6":{"lang":"en","description":"GalaxyS6","over18":false},"futurebeats":{"lang":"en","description":"A place for sharing and discussing experimental beat music from all genres and eras. 'Future', here, is a state of mind.\n\n","over18":false},"Battlefield_4_CTE":{"lang":"en","description":"A Public version of the Battlefield 4 Community Test Environment forums. (http://cte.battlelog.com to sign up!)\n","over18":false},"LosAngelesRams":{"lang":"en","description":"Home of the Los Angeles Rams","over18":false},"Genealogy":{"lang":"en","description":"","over18":false},"nin":{"lang":"en","description":"","over18":false},"cocaine":{"lang":"en","description":"A place for friends to discuss cocaine and cocaine related activities, news, stories, products, etc.\n\n","over18":false},"snapchat":{"lang":"en","description":"A subreddit to find new people to talk to on Snapchat!","over18":false},"software":{"lang":"en","description":"","over18":false},"totallynotrobots":{"lang":"en","description":"THIS IS A PLACE FOR ALL FELLOW HUMANS TO SHARE THEIR KNOWLEDGE. WE TOTTALLY AREN'T ROBOTS. (OOPS I MADE A HUMAN MISTAKE)","over18":false},"thesopranos":{"lang":"en","description":"Reddit community dedicated to the HBO hit TV series, The Sopranos.","over18":false},"Supplements":{"lang":"en","description":"The supplements subreddit aims to discuss and share topics related to nutritional supplementation. This includes new research, potential supplement choices (ie. what should I take? What can replace xx","over18":false},"see":{"lang":"en","description":"r/see - A place for Ents to share awesomeness, be it imgur, GIF's, memes or videos... all things bright and beautiful for the high community of Reddit! :)","over18":false},"Gunsforsale":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Velo":{"lang":"en","description":"your place for competitive amateur racing discussion & information!","over18":false},"razer":{"lang":"en","description":"RΛZΞR is more than just the world's leading brand in gaming.\n\nWe were founded in 1998 in San Diego, California by our CEO Min-Liang Tan and our President Robert \"RΛZΞRguy\" Krakoff in a tiny shared off","over18":false},"ModelUSGov":{"lang":"en","description":"A simulation of the United States Government ","over18":false},"mead":{"lang":"en","description":"","over18":false},"BoomBeach":{"lang":"en","description":"A game about turtles.","over18":false},"gonewildcolor":{"lang":"en","description":"GoneWildColor is a place reserved for non-caucasian redditors to show off their body, nude or partially nude, and to receive positive feedback, comments and reddit karma. \n\nGWC is NOT SAFE FOR WORK. A","over18":true},"TheWire":{"lang":"en","description":"Sheeeeiiit","over18":false},"mazda":{"lang":"en","description":"Everything about Mazda cars.","over18":false},"PlanetCoaster":{"lang":"en","description":"Subreddit for Planet Coaster by Frontier. ","over18":false},"streetwearstartup":{"lang":"en","description":"Reddit's Brand Startup Guide","over18":false},"EmpireDidNothingWrong":{"lang":"en","description":"Here we honor those brave men and women that died fighting the rebel scum.","over18":false},"gaybears":{"lang":"en","description":"---\n\n**A place for bears and bear admirers**\n\nShare your favorite bear-related photos, videos, stories and links.  Woof!\n\n---","over18":true},"Vaping101":{"lang":"en","description":"This subreddit is for people to get information when they're just starting out on their vaping career!\n\nIf you're an experienced vaper, feel free to help out, write up your first purchases and experie","over18":false},"Pauper":{"lang":"en","description":"Welcome to r/Pauper, a place to discuss MTG's Commons-Only format","over18":false},"FL_Studio":{"lang":"en","description":"The best FL Studio resource on the internet!","over18":false},"PrettyGirls":{"lang":"en","description":"PrettyGirls is a SFW subreddit dedicated to beauty.\n\n","over18":false},"mobilelegends":{"lang":"en","description":"Fan Made Subreddit for Mobile Legends. **Official sub is /r/mobilelegendsgame**\n\nDiscuss & post anything related to Mobile Legends. Make sure to read the rules before posting.\n\n","over18":false},"orangeisthenewblack":{"lang":"en","description":"The subreddit for all your Orange is The New Black Discussion! The show was created by Jenji Kohan when it premiered in 2013 by Netflix.","over18":false},"starwarsrebels":{"lang":"en","description":"The Reddit home for the Star Wars Rebels animated TV show. ","over18":false},"German":{"lang":"en","description":"/r/German, previously known as /r/LANL_German is a community focused on discussion related to the learning German language. It is also a place to discuss the language at large and for the kinds of sub","over18":false},"EQNext":{"lang":"en","description":"EverQuest Next\n","over18":false},"homestead":{"lang":"en","description":"Ponds, barns, livestock, gardens, food preservation, fishing, hunting,  tractors, pigs, chickens, cattle, worms, 4H, permaculture, organic,   grazing, canning, aquaculture, trees, woodland, farmers, a","over18":false},"Lollapalooza":{"lang":"en","description":"For the fans and the fanatics of Lollapalooza!\n\n**Aug 2 - Aug 5, 2018** at Grant Park in Chicago, IL","over18":false},"wallpaper":{"lang":"en","description":"Wallpaper - computer desktops / background images","over18":false},"Etsy":{"lang":"en","description":"A place for Etsy sellers and buyers to post products and all things Etsy.","over18":false},"grandrapids":{"lang":"en","description":"","over18":false},"TF2fashionadvice":{"lang":"en","description":"A place to share and get advice on your TF2 fashion!","over18":false},"gonewildstories":{"lang":"en","description":"True sex stories inspired by the popular picture sub.","over18":true},"Rift":{"lang":"en","description":"The official subreddit for Trion World's free-to-play MMORPG.","over18":false},"OrlandoMagic":{"lang":"en","description":"The official Orlando Magic subreddit for all Magic fans to unite and discuss all things Magic!","over18":false},"dbxv":{"lang":"en","description":"Post any news, gameplay, and/or anything else to do Dragon Ball: Xenoverse 1 and 2!","over18":false},"xTrill":{"lang":"en","description":"","over18":false},"RandomActsOfMuffDive":{"lang":"en","description":"No-strings-attached muffdives from a random stranger on the internet? Stranger things happen all the time.\n\nPost if you want to give or receive. Respect both.","over18":false},"playitforward":{"lang":"en","description":"Play it Forward: Receive a game, play it, then give it to someone else.\n\nThis subreddit is about gifting more than receiving, you are expected to give back if you receive a game.\n\nCreate a thread to g","over18":false},"PoliticalVideo":{"lang":"en","description":"A great place for video content of the political kind. Politics through videos.","over18":false},"LegalAdviceUK":{"lang":"en","description":"This subreddit is to help share and promote areas of UK law which effects members of society.\n\nIf you have a legal problem, you should consult a qualified solicitor in person, please do not rely on an","over18":false},"iOSBeta":{"lang":"en","description":"Reddit's home for iOS beta.","over18":false},"TapTitans2":{"lang":"en","description":"Incremental mobile game featuring a huge sword and a ton of heroes and pets","over18":false},"aznidentity":{"lang":"en","description":"The most active Asian diaspora forum on the web. We are a Pan Asian (East, Southeast, South, Central) community against all forms of anti Asian racism.","over18":false},"NuclearThrone":{"lang":"en","description":"The biggest subreddit for Vlambeer's action video game \"Nuclear Throne\".\n\nFLÄSHYN!","over18":false},"magicskyfairy":{"lang":"en","description":"DAE think the admins leterally believe that gOD will run this site!?!? ","over18":false},"battlefield_live":{"lang":"en","description":"A place to communicate about Battlefield development and status","over18":false},"Dell":{"lang":"en","description":"The unofficial subreddit for Dell Technologies","over18":false},"BeAmazed":{"lang":"en","description":"","over18":false},"Wellington":{"lang":"en","description":"Welcome to Wellington, New Zealand!  \n\nWhether you're living here, moving here or are just curious, feel free to browse around and ask questions.   ","over18":false},"gaymersgonewild":{"lang":"en","description":"A gay pornographic subreddit for male video gamers.","over18":true},"blackberry":{"lang":"en","description":"All about [BlackBerry](http://blackberry.com)!\n\n*Other BlackBerry reddits:*\n\n* /r/BlackBerryDev\n* /r/BBMChannels\n* /r/PlayBook","over18":false},"htcone":{"lang":"en","description":"Discussion, news, tips, and tricks for the HTC One smartphone!","over18":false},"weed":{"lang":"en","description":"All about weed. The friendliest weed community on Reddit is right here!","over18":false},"CharacterRant":{"lang":"en","description":"Come here to talk about fictional characters, events, concepts, objects, etc. Negatively, positively, or even in between, we're here to rant!^^^andaskquestions","over18":false},"Pareidolia":{"lang":"en","description":"Pictures of things that are recognizable as other objects. For example, a picture of a cloud that happens to look like a whale sword fighting a leprechaun.","over18":false},"boostedboards":{"lang":"en","description":"Riders and fans of Boosted boards unite to promote group rides, safety, share routes, discuss maintenance, tricks, and sharing the experience of carving, cruising, and commuting on the world's best el","over18":false},"CompetitiveEDH":{"lang":"en","description":"This is a subreddit dedicated to playing the Commander or EDH format of Magic: The Gathering at the highest level of competitive play. ","over18":false},"gigantic":{"lang":"en","description":"Gigantic is a fast and fluid Strategic Hero Shooter, where you battle against and alongside massive Guardians, in deeply strategic team gameplay.","over18":false},"cableporn":{"lang":"en","description":"","over18":false},"dirtyr4r":{"lang":"en","description":"A place where horny redditors can come and find one another.","over18":true},"askTO":{"lang":"en","description":"A subreddit for people to submit questions to Torontonians and about Toronto and receive constructive responses.","over18":false},"stepparents":{"lang":"en","description":"This subreddit is a community-oriented place for stepparents from all walks of life.  Commiserate with others in similar situations, celebrate your wins, and hang out with people who just get it.  It ","over18":false},"pokemongodev":{"lang":"en","description":"Discuss development and reverse engineering about PokemonGo","over18":false},"kindle":{"lang":"en","description":"","over18":false},"KDRAMA":{"lang":"en","description":"News and discussions about your favorite Korean drama series, the actors and actresses, recommendations, reviews, soundtracks, award shows and more.\n","over18":false},"Calligraphy":{"lang":"en","description":"/r/Calligraphy is a community for people interested in the art of beautiful writing. Whether you've been writing for decades or are looking to pick up the pen for the first time, we invite you to join","over18":false},"Justfuckmyshitup":{"lang":"en","description":"This subreddit is dedicated to jacked up haircuts from all walks of life.","over18":false},"GCXRep":{"lang":"en","description":"Confirm your trades from /r/giftcardexchange by following the instructions in the sidebar.","over18":false},"MachinePorn":{"lang":"en","description":"High quality images of machines and machinery.","over18":false},"OverwatchLFT":{"lang":"en","description":"**What is this?**\n\nThis is a place for Overwatch players and teams who:\n\n* Want to start or join a team or to recruit for a team\n* Want to set up scrims with other teams or advice on how to manage the","over18":false},"hiking":{"lang":"en","description":"The hikers' subreddit.","over18":false},"chrome":{"lang":"en","description":"","over18":false},"yiff":{"lang":"en","description":"Furries need porn too!","over18":true},"sales":{"lang":"en","description":"Everything you need to know about sales, selling, business development, lead generation, prospecting, closing and more! ","over18":false},"relaxedpokemontrades":{"lang":"en","description":"A Pokémon trading sub for trades of all kinds.\n\nTrades can be simple or involve IVs, egg moves, hidden ability, hidden power, foreign, you name it! Hacked and/or Cloned Pokémon and items must be label","over18":false},"warcraftlore":{"lang":"en","description":"This subreddit is for discussions about the lore of Warcraft!","over18":false},"DMAcademy":{"lang":"en","description":"/r/DMAcademy is a subreddit for Dungeons & Dragons Dungeon Masters to ask questions - new and experienced, all are welcome. A casual, friendly place for the lovers of DnD (D&D). Welcome Wanderer!","over18":false},"RPI":{"lang":"en","description":"Welcome to Rensselaer Polytechnic Institute's subreddit. Home of Puckman and the 'Tute Screw.","over18":false},"lgg4":{"lang":"en","description":"Anything relating to the LGG4 phone!  ","over18":false},"FearTheWalkingDead":{"lang":"en","description":"Official subreddit of Fear The Walking Dead.","over18":false},"ChineseLanguage":{"lang":"en","description":"This is a community for people studying or teaching Chinese - or just interested in the language. Please post interesting links, language learning advice, or questions about the Chinese language.","over18":false},"resumes":{"lang":"en","description":"Post your résumé for critique, critique someone else's, or look for examples of résumés in your field.","over18":false},"rantgrumps":{"lang":"en","description":"Rant and vent about Game Grumps!","over18":false},"quotes":{"lang":"en","description":"For your favorite quotes.\n\nCurrent quotes, historic quotes, movie quotes, song lyric quotes, game quotes, book quotes, tv quotes or just your own personal gem of wisdom.","over18":false},"calvinandhobbes":{"lang":"en","description":"For everything about Calvin and Hobbes!\n\n:D","over18":false},"galaxynote4":{"lang":"en","description":"Discussion, news, tips, and tricks for the Galaxy Note 4 pokédex!","over18":false},"retrogameswap":{"lang":"en","description":"A place for fans and collectors of classic games and related merchandise to swap items in a friendly and fair environment.","over18":false},"grammar":{"lang":"en","description":"A subreddit for questions and discussions about grammar, language, style, conventions[,] and punctuation.","over18":false},"halloween":{"lang":"en","description":"Subreddit dedicated to the holiday Hallowe'en","over18":false},"classic4chan":{"lang":"en","description":"","over18":false},"Albuquerque":{"lang":"en","description":"Official subreddit of Albuquerque, New Mexico.","over18":false},"AnythingGoesNews":{"lang":"en","description":"","over18":false},"Watchexchange":{"lang":"en","description":"Buy, sell, or trade watches!  ","over18":false},"greysanatomy":{"lang":"en","description":"The subreddit for all your Grey's Anatomy and Private Practice Discussion! The show was created by Shonda Rhimes when it premiered in 2005 by ABC.","over18":false},"boulder":{"lang":"en","description":"","over18":false},"MAA":{"lang":"en","description":"A subreddit designed to discuss the Facebook game, Marvel: Avengers Alliance.","over18":false},"guineapigs":{"lang":"en","description":"For fans and \"slaves\" of guinea pigs (aka, \"Cavies\") encouraging the proper techniques in raising and caring for guinea pigs.","over18":false},"codbo":{"lang":"en","description":"This Subreddit has moved to /r/CallofDuty!","over18":false},"Beekeeping":{"lang":"en","description":"","over18":false},"pokemonzetaomicron":{"lang":"en","description":"The official subreddit for the fan games, Pokemon Zeta and Pokemon Omicron. Created using RPG Maker XP and Pokemon Essentials (by Maruno), this game features over 649 Pokemon, plus some more from gene","over18":false},"AgainstHateSubreddits":{"lang":"en","description":"","over18":false},"indianews":{"lang":"en","description":"IndiaNews is the definitive source of updated and relevant news concerning India and all her affairs.\n","over18":false},"twinks":{"lang":"en","description":"Your daily source of vitamin D.","over18":true},"ageofsigmar":{"lang":"en","description":"For discussion of the new Games Workshop tabletop wargame \"Warhammer: Age of Sigmar\"","over18":false},"samuraijack":{"lang":"en","description":"Long ago in a distant land, I, Aku, the shape shifting master of darkness, unleashed an unspeakable evil. But a foolish samurai warrior wielding a magic sword stepped forth to oppose me.\nBefore the fi","over18":false},"animation":{"lang":"en","description":"News, Shorts, and Everything Else in the World of Animation\n\n","over18":false},"thisismylifenow":{"lang":"en","description":"This is a subreddit with gifs or pics of people and animals accepting their uncommon situations.","over18":false},"RSDarkscape":{"lang":"en","description":"Open PvP. Cut-throat trade. A world of your making. It’s RuneScape, but a hell of a lot darker. And best of all? It’s 100% free to play.\n\nhttp://darkscape.runescape.com","over18":false},"HeroesandGenerals":{"lang":"en","description":"Fan made and managed subreddit for the Free-to-Play game, Heroes & Generals. All content relating to H&G is welcomed. ","over18":false},"battlebots":{"lang":"en","description":"/r/battlebots is a reddit community for fans of robot combat.  We welcome those with a casual interest in television shows as well as the enthusiast community.  \n\nEvents of interest include Battlebots","over18":false},"TheCreatures":{"lang":"en","description":"The Creatures were a group who played games, made fun vlogs/shorts, and goofed around on YouTube as well as Twitch.","over18":false},"KillLaKill":{"lang":"en","description":"Don't lose your way.","over18":false},"AfterEffects":{"lang":"en","description":"After Effects help and inspiration the Reddit way.","over18":false},"radiocontrol":{"lang":"en","description":"A place to share anything related to radio control (RC), whether it's airplanes, cars, helicopters, multicopters (hexacopters, quadcopters, etc), boats, sails, trucks, submarines, cats, etc.","over18":false},"ITCareerQuestions":{"lang":"en","description":"This subreddit is designed to help anyone in or interested in the IT field to ask career-related questions. ","over18":false},"politota":{"lang":"ru","description":"ПОЛИТОТА - Politics, economics, sociology around ex-USSR. Free of Kremlin's shills","over18":false},"bdsm":{"lang":"en","description":"","over18":true},"FantasyLCS":{"lang":"en","description":"/r/FantasyLCS is a community for Riot Games' FantasyLCS. FantasyLCS allows you to create fantasy teams of professional League of Legends players and then compete against your friends.\n\n","over18":false},"Waxpen":{"lang":"en","description":"A subreddit dedicated to discussion about concentrate-vaporizing contraptions and all other related devices.\n\n","over18":false},"penpals":{"lang":"en","description":"Letters and Post Cards and Email, Oh My!","over18":false},"DragonsDogma":{"lang":"en","description":"A subreddit for Arisens all over the world. Join us for discussions, information and miscellaneous topics related to Capcom's Dragon's Dogma and Dragon's Dogma: Dark Arisen.","over18":false},"Norway":{"lang":"en","description":"","over18":false},"washingtonwizards":{"lang":"en","description":"**Wizards Basketball**\n\n*****\n\nThe source for everything Washington Wizards related: links, news, photos, videos, news, and discussion.","over18":false},"BannedFromThe_Donald":{"lang":"en","description":"Getting Banned from /r/The_Donald","over18":false},"spicy":{"lang":"en","description":"","over18":false},"Freeclams":{"lang":"en","description":"Free Clams for Family Guy: The Quest for Stuff\n\n\n","over18":false},"virtualreality":{"lang":"en","description":"A common ground for discussion relating to Virtual Reality and Virtual Worlds.","over18":false},"TsumTsum":{"lang":"en","description":"For everything pertaining to Disney Tsum Tsum. Keep up to date with the adorable stackable plush or vinyls, get help with the LINE game, or post your collections!","over18":false},"Forex":{"lang":"en","description":"Your Forex Trading community! /r/Forex is for traders who are serious about sharpening their skills and becoming consistently profitability in any market. Discuses trade setups, fundamentals, technica","over18":false},"Purdue":{"lang":"en","description":"Purdue University's subreddit.  Boiler up!","over18":false},"jacksonville":{"lang":"en","description":"The \"official\" subreddit for Jacksonville, Florida.","over18":false},"AskSocialScience":{"lang":"en","description":"For questions and answers grounded in Social Science.","over18":false},"OCPoetry":{"lang":"en","description":"A home for all your Original Poetry!","over18":false},"JurassicPark":{"lang":"en","description":"Everything related to Jurassic Park and it's franchise.  Books, toys, films, etc. ","over18":false},"msp":{"lang":"en","description":"Resource for IT Managed Services Providers","over18":false},"APStudents":{"lang":"en","description":"No matter what course you are taking, we are a community that is forming in order to help students earn college credit! ","over18":false},"dogemining":{"lang":"en","description":"Dogecoin Mining Subreddit. Many digs. Much Doge.","over18":false},"iran":{"lang":"en","description":"The official subreddit of Iranians both in Iran and elsewhere. Come to discuss Iranian Politics, Persian and Iranian History, Persian Art, Persian Cuisine, Iranian Music and much more. \n\nCome learn ab","over18":false},"Awwducational":{"lang":"en","description":"Aww + Educational = Awwducational! Educational information about animals with cute pictures! You can also check us out on our website [Awwducational.com](https://awwducational.com/)","over18":false},"tasker":{"lang":"en","description":"","over18":false},"TheFacebookDelusion":{"lang":"en","description":"","over18":false},"OopsDidntMeanTo":{"lang":"en","description":"People pretending they didn't deliberately do it. ","over18":false},"thelongdark":{"lang":"en","description":"","over18":false},"Xiaomi":{"lang":"en","description":"A subreddit for everything in the Mi Ecosystem!","over18":false},"duolingo":{"lang":"en","description":"The official Duolingo community of Reddit - a forum and chat where you can discuss all things Duolingo!","over18":false},"uvtrade":{"lang":"en","description":"A Place to Trade UV Codes, iTunes Codes and Other Digital Media Codes.","over18":false},"microsoft":{"lang":"en","description":"For Microsoft-related news & events, see our support thread to OFFICIAL Microsoft customer support","over18":false},"golang":{"lang":"en","description":"Gophers of the world unite!","over18":false},"tax":{"lang":"en","description":"Reddit's home for tax geeks! News, discussion, policy, and law relating to any tax - U.S. and International, Federal, State, or local.","over18":false},"buildmeapc":{"lang":"en","description":"Welcome to /r/buildmeapc! If you are new to computer building, and need someone to help you put parts together for your build or even an experienced builder looking to talk tech you are in the right p","over18":false},"autism":{"lang":"en","description":"","over18":false},"Swingers":{"lang":"en","description":"Dedicated to everything a swinger would want or need to know. Links to lifestyle articles, websites, how-to videos and much more. Subscribe today!","over18":false},"DAE":{"lang":"en","description":"","over18":false},"Veterans":{"lang":"en","description":"This is a subreddit for news, sites, information and events that may interest veterans.  We are here to support one another and help resolve any VA / Veterans related issues.\n\nVeteran Crisis Hotline  ","over18":false},"UnethicalLifeProTips":{"lang":"en","description":"An Unethical Life Pro Tip (or ULPT) is a tip that improves your life in a meaningful way, perhaps at the expense of others and/or with questionable legality. Due to their nature, do not actually follo","over18":false},"amazonecho":{"lang":"en","description":"/r/AmazonEcho is a community centered around the Amazon Echo, or as we like to call her - Alexa. Alexa is designed around your voice. She's always on—just ask for information, music, news, weather, an","over18":false},"TroveCreations":{"lang":"en","description":"","over18":false},"IDontWorkHereLady":{"lang":"en","description":"A derivative of subreddits like Tales From Retail that involves stories about folks that go into other businesses and have irate customers mistake them for employees.  The more outrageous the story th","over18":false},"tacobell":{"lang":"en","description":"Taco Bell!","over18":false},"makemychoice":{"lang":"en","description":"Are you indecisive? We know. Here you can let other redditors make the hard... or very easy choices for you.","over18":false},"asheville":{"lang":"en","description":"The best place on the internet to discuss what's going on in and around Asheville, North Carolina.\n######[Asheville](http://reddit.com/r/Asheville)  ","over18":false},"ecr_eu":{"lang":"en","description":"","over18":false},"glutenfree":{"lang":"en","description":"","over18":false},"eurovision":{"lang":"en","description":"The official subreddit of the annual Eurovision Song Contest.","over18":false},"BF_Hardline":{"lang":"en","description":"The subreddit for Battlefield: Hardline. Developed by Visceral Games.\n\nIn a show of solidarity, we have gone private alongside other subreddits to protest the lack of communication between the reddit ","over18":false},"Leathercraft":{"lang":"en","description":"A subreddit for people interested in working with leather, sharing tips, and tricks.\n\nLearn more about leatherworking and share your work!","over18":false},"SummonSign":{"lang":"en","description":"A community dedicated to jolly cooperation in the Dark Souls series.","over18":false},"poketradereferences":{"lang":"en","description":"Leave your reference to prove you are a genuine Pokémon Trader!","over18":false},"manchester":{"lang":"en","description":"","over18":false},"Roast_Me":{"lang":"en","description":"roastme coz you want a Roasting !  /r/Roast_Me -  The subreddit for verbally assaulting someone until you hurt their feelings ....  sometimes to the point of making them cry. BEWARE OF IMITATIONS\n\nThi","over18":false},"UCSD":{"lang":"en","description":"","over18":false},"HumanPorn":{"lang":"en","description":"High quality images of humans (not having sex). We are focused on looking at what humans are, more than what they do. To show you how humans exist. How people show their emotions and inner self.","over18":false},"workgonewild":{"lang":"en","description":"A subreddit for GW pics from work.","over18":true},"iRacing":{"lang":"en","description":"iRacing.com Community","over18":false},"DiWHY":{"lang":"en","description":"Ever try fixing things on your own? Didn't come out the way it was suppose to? Do you stand there questioning your whole life? If so, post your results here to DiWHY, where shitty projects from r/DIY ","over18":false},"memphis":{"lang":"en","description":"The Reddit community of Memphis, TN.","over18":false},"ofcoursethatsathing":{"lang":"en","description":"For all the things that make you go \"Of COURSE that's a thing\"","over18":false},"qotsa":{"lang":"en","description":"Welcome to r/qotsa! We are the most active Queens of the Stone Age community on the Internet (for good reason,) and we're here to discuss all things Queens! Photos, discussions, shitposts, memes, and ","over18":false},"MakeupAddicts":{"lang":"en","description":"This is a community created for those who just truly love makeup indulge themselves and obsess over the pretty things In this subreddit users can share reviews swatches and makeup hauls while particip","over18":false},"VirginiaTech":{"lang":"en","description":"A reddit for Hokies.","over18":false},"Gore":{"lang":null,"description":"Subreddit forbidden","over18":null},"FargoTV":{"lang":"en","description":"Subreddit for the FX original TV series, Fargo. Each season of Fargo stands alone - you can watch them all out of order and still able to understand what's going on.\n\nFargo is a critically acclaimed s","over18":false},"Dreams":{"lang":"en","description":"Welcome to the Reddit Dreams community!\n\n* Ask questions and learn about dreams.\n\n* Share your dreams.\n\n* Connect with a community of dream enthusiasts.\n\n* Request interpretation of your dreams.\n\n* Ke","over18":false},"RetroPie":{"lang":"en","description":"RetroPie allows you to turn your Raspberry Pi or PC into a retro-gaming machine. This community focuses around the projects that come from this as well as providing tips/tricks and help in getting it ","over18":false},"CatastrophicFailure":{"lang":"en","description":"Videos, gifs, or aftermath photos of machinery, structures, or devices that have failed catastrophically during operation.","over18":false},"sadboys":{"lang":"en","description":"Subreddit for fans of Sadboys and Drain Gang / Shield Gang / Gravity Boys.","over18":false},"fitmeals":{"lang":"en","description":"","over18":false},"DBZDokkanMarketplace":{"lang":"en","description":"We wish to provide the safest marketplace for selling, trading or buying accounts for the benefit of our fellow Dragon Ball Z Dokkan Battle Fans. ","over18":false},"pawg":{"lang":"en","description":"White girls with developed posteriors. Aka booty, ass for days, junk in the trunk, badonkadonks, bubblebutts. ","over18":true},"florida":{"lang":"en","description":"/r/florida is Reddit's one stop shop for news and discussion about the sunshine state! Talk to residents, or plan a vacation! Or, find one of our related subreddits for your city or community.","over18":false},"techsupportmacgyver":{"lang":"en","description":"Instances of crazy fixes that actually ended up working. Or not working, I'm a description, not the cops.\n","over18":false},"holdmyfries":{"lang":"en","description":"","over18":false},"evedreddit":{"lang":"en","description":"","over18":false},"mgo":{"lang":"en","description":"Metal Gear Online 3","over18":false},"admincraft":{"lang":"en","description":"A subreddit for Minecraft administrators and developers who are serious about cultivating a quality server with a quality community.","over18":false},"shittydarksouls":{"lang":"en","description":"Shitty Dark Souls REMASTERED is a community that celebrates the awesomeness, and often shittiness of the game Dark Souls, as well as the rest of the 'Souls' universe. Whereas /r/DarkSouls is a communi","over18":false},"javahelp":{"lang":"en","description":"General subreddit for helping with **Java** code.","over18":false},"poland":{"lang":"en","description":"The official English language subreddit for Poland and Polish news. Questions get answered, recommendations get recommended and you know, things get done.","over18":false},"Whiskyporn":{"lang":"en","description":"a subreddit for any and all whisky porn","over18":false},"Awesomenauts":{"lang":"en","description":"A home for the fans of the 2D side-scrolling MOBA by Ronimo Games.\n\nTread careful, there's a Leon on the other team.","over18":false},"FreeCompliments":{"lang":"en","description":"A subreddit created specifically for giving out free compliments!\n\n* Feeling bad? Come here for a compliment!\n\n* Want to contribute to the happiness of humanity? Come here and give out a few complimen","over18":false},"Instagram":{"lang":"en","description":"","over18":false},"assholedesign":{"lang":"en","description":"Because nothing comes before profit, especially not the consumer.","over18":false},"oblivion":{"lang":"en","description":"A subreddit dedicated to mods, screenshots, videos, tactics, news and anything else related to Bethesda's 2006 open world RPG - The Elder Scrolls IV: Oblivion.","over18":false},"nbastreams":{"lang":"en","description":"Share your NBA streams!","over18":false},"AgMarketplace":{"lang":null,"description":"Subreddit no longer exists","over18":null},"showerbeer":{"lang":"en","description":"When you work hard there is nothing better than drinking a cold beer in a hot shower.  Cheers!","over18":false},"BBW":{"lang":"en","description":"A subreddit for anything related to Big Beautiful Women and those that love them!","over18":true},"tulsa":{"lang":"en","description":"","over18":false},"HaloOnline":{"lang":"en","description":"Halo Online was a cancelled free-to-play multiplayer shooter developed by Saber Interactive and published by Innova Systems. The game was only released in Russia, but can be played without region rest","over18":false},"CrackStatus":{"lang":"en","description":"Welcome to CrackStatus community, post links! Talk about WIP cracks, have fun!","over18":false},"shittyrobots":{"lang":"en","description":"This subreddit is devoted to sharing gifs and videos of robots that are useless or just don't do their job quite right.","over18":false},"acting":{"lang":"en","description":"This is a Subreddit where anyone and everyone who is interested in the art of Acting meet up. Here, we are a community, a family of users who help each-other, share interesting topics and from time to","over18":false},"uktrees":{"lang":"en","description":"","over18":false},"labrats":{"lang":"en","description":"","over18":false},"insurgency":{"lang":"en","description":"/r/Insurgency - The community-based subreddit for Insurgency and Insurgency: Sandstorm, a series of online tactical FPS games available on Steam made by New World Interactive.","over18":false},"PSO2":{"lang":"en","description":"Discuss news, strategies and information relating to Sega's *Phantasy Star Online 2*!","over18":false},"Amsterdam":{"lang":"en","description":"Amsterdam, Mokum, the capital of the Netherlands. We're the subreddit for everything Amsterdam, in Dutch or in English. If this is your first time here, read our Wiki and use our sticky threads.","over18":false},"HannibalTV":{"lang":"en","description":"Subreddit for everything related to Hannibal, the NBC TV show.","over18":false},"Heroclix":{"lang":"en","description":"The best place for constructive discussion, sharing your creations and trying to learn the game better. \n\n**Heroclix**\n**Damn right we play with little plastic superheroes.**","over18":false},"csgo":{"lang":"en","description":"Counter Strike: Global Offensive","over18":false},"crafts":{"lang":"en","description":"Share your tutorials, tips, and questions on all things craft related! ","over18":false},"ableton":{"lang":"en","description":"/r/ableton \n\nResources, tips and tricks for all things Ableton.\nAbleton Live, Ableton Push, and Max for Live","over18":false},"AustralianMakeup":{"lang":"en","description":"This subreddit is dedicated to news, information and discussion about Australian and New Zealand makeup. Sales, reviews and questions are encouraged. Looks and advice are more than welcome!","over18":false},"statistics":{"lang":"en","description":"This is a subreddit for discussion on all things dealing with statistical theory, software, and application.\n\nWe welcome all researchers, students, professionals, and enthusiasts looking to be apart o","over18":false},"WhitePeopleTwitter":{"lang":"en","description":"Some white people are hilarious.","over18":false},"CubeWorld":{"lang":"en","description":"CubeWorld is A voxel-based exploration RPG in development by [Wollay](https://twitter.com/#!/wol_lay) and his wife [Pixxie](https://twitter.com/pix_xie). Cube World is currently in Alpha, it is not in","over18":false},"NASLSoccer":{"lang":"en","description":"Welcome to /r/NASLSoccer! This is a community dedicated to the North American Soccer League, the second-tier division of American and Canadian soccer.","over18":false},"TinyHouses":{"lang":"en","description":"A place for people interested in small or tiny houses.","over18":false},"lacrosse":{"lang":"en","description":"","over18":false},"chemicalreactiongifs":{"lang":"en","description":"A subreddit showcasing the complexity of those lovely little atoms, as well as other interesting science topics in gif form.","over18":false},"AustralianPolitics":{"lang":"en","description":"Political news and events in Australia","over18":false},"ACT":{"lang":"en","description":"A forum to discuss the ACT and forms of preparation for taking the test.","over18":false},"prisonarchitect":{"lang":"en","description":"A subreddit dedicated to the game Prison Architect, developed by Introversion Software and ported to console (Xbox, Playstation, and Nintendo Switch) and mobile platforms (Android and Apple) by Double","over18":false},"edc_raffle":{"lang":null,"description":"Subreddit forbidden","over18":null},"billiards":{"lang":"en","description":"A community for billiards and pool players to share related content.  You'll find matches, billiards related discussion and interesting tidbits from the billiard world.  A small but growing community ","over18":false},"Blacksmith":{"lang":"en","description":"A subreddit dedicated to the ancient art of blacksmithing. Show off your latest creations or get advice on a problem.","over18":false},"mcgill":{"lang":"en","description":"","over18":false},"selfharm":{"lang":"en","description":"A subreddit for self-harmers to relate to each other, ask questions, and build up a community.","over18":false},"Magic":{"lang":"en","description":"A subreddit for sharing and discussing magic, without any exposure. Any area of magic, be it close up, parlor, stage, busking, mentalism, coins or cards, are welcome.","over18":false},"webcomics":{"lang":"en","description":"","over18":false},"AusFinance":{"lang":"en","description":"Australian Personal Finance and General Advice.\n\n\n\nLearn about personal finance: budgeting, saving, getting out of debt, investing, and saving for retirement. Our community is focused on financial edu","over18":false},"Switzerland":{"lang":"en","description":"All things Switzerland!","over18":false},"dankchristianmemes":{"lang":"en","description":"dank God memes only","over18":false},"badlinguistics":{"lang":"en","description":"The repository for all the worst linguistics-related content of Reddit.","over18":false},"TEFL":{"lang":"en","description":"Questions, answers, teaching materials, everything related to teaching English as a Foreign language goes here. Welcome!","over18":false},"GameTrade":{"lang":"en","description":"Trade games (PC, Mac, Xbox, PSN, Steam), game items (TF2, DotA 2, LoL, Counterstrike, CS:GO etc), game codes and beta keys, trading cards, game accounts, AMD and Nvidia and hardware coupon games. Payp","over18":false},"dragonblaze":{"lang":"en","description":"Subreddit for the mobile game Dragon Blaze (별이 되어라!)  by Gamevil and FLINT.","over18":false},"bestofworldstar":{"lang":"en","description":"The Best Of World Star Hip-Hop","over18":true},"VideoEditing":{"lang":"en","description":"A subreddit for amateur, hobbyist, and prosumer editors to meet, share techniques and tutorials, and find troubleshooting help.","over18":false},"Emo":{"lang":"en","description":"","over18":false},"cancer":{"lang":"en","description":"This reddit is for the discussion of cancer, cancer related news, stories of survival, stories of loss and everything else associated with the disease. ","over18":false},"mallninjashit":{"lang":"en","description":"This is a sub for all the ugly mall ninja knives and fantasy retarded shit that the mall ninjas like. Converse combat boots, dragon knives, united cutlery........... all the knives and weapons and muf","over18":false},"Nepal":{"lang":"en","description":"An online junction for Nepali dai, bhai, didi, bahini and  friends all over. ","over18":false},"RocketLeagueFriends":{"lang":"en","description":"A subreddit created for Rocket team building, friend making, and tournament hosting!","over18":false},"ManyATrueNerd":{"lang":"en","description":"This is the Reddit community for [ManyATrueNerd](http://www.youtube.com/ManyATrueNerd)","over18":false},"Hair":{"lang":"en","description":"A place for discussion of hair. This community is all about hair health, style, cut, and color. All things hair!  Feel free to ask questions :)","over18":false},"Tgirls":{"lang":"en","description":"For celebrating the beauty of pre-op and non-op MtF transsexuals","over18":true},"Bombing":{"lang":"en","description":"Less art, more vandalism.\n \n\nBombing, wildstyles, freights, handstyles, and any regional graffiti.","over18":false},"LSAT":{"lang":"en","description":"The best place on Reddit for LSAT advice. \n\nThe Law School Admission Test (LSAT) is offered four times per year, and you must write it to get into an ABA law school.\n\nCheck out the sidebar for intro g","over18":false},"AppalachianTrail":{"lang":"en","description":"NOBO? SOBO? Flip-Flopper? Section hiker? Aspiring hiker? If you've hiked or are planning on hiking the \"AT\", this is the place for you.","over18":false},"FashionRepsBST":{"lang":"en","description":"Community for buying, selling, and trading replica fashion. ","over18":false},"newsokuvip":{"lang":"ja","description":"（ ＾ω＾）ニュー速VIPのReddit部だお  \nReddit初心者でもウェルカム  \nJapanese random board.","over18":false},"PowerMetal":{"lang":"en","description":"For the appreciation, discussion, and sharing of power metal.\n\n","over18":false},"NotTimAndEric":{"lang":"en","description":"This is subreddit for videos that are similar to content that could be found on the Tim and Eric show.","over18":false},"rational":{"lang":"en","description":"A place for discussion of rational fiction","over18":false},"dyinglight":{"lang":"en","description":"Dying Light and Dying Light 2 are first person zombie survival games developed by Techland. ","over18":false},"KingOfTheHill":{"lang":"en","description":"A subreddit for fans of Mike Judge's animated series \"King OfTheHill\"","over18":false},"asatru":{"lang":"en","description":"r/Asatru is not a community. r/Asatru seeks to be a place to introduce redditors to the conversations within greater Heathendom. We seek to curate and provide quality discussion and opportunities to l","over18":false},"rct":{"lang":"en","description":"Discussion about RollerCoaster Tycoon, everyone's favorite roller coaster simulator. RollerCoaster Tycoon 1, RCT2, RCT3, RCT3D, RCT4M, and RCT World discussion is welcome.","over18":false},"DebateaCommunist":{"lang":"en","description":"An uncensored place to discuss, challenge and debate communists. \n \nAll political beliefs are welcome.","over18":false},"Juve":{"lang":"en","description":"","over18":false},"Chattanooga":{"lang":"en","description":"","over18":false},"DanLeBatardShow":{"lang":"en","description":"","over18":false},"toosoon":{"lang":"en","description":"Too soon, man. Too soon.","over18":false},"LitecoinMarkets":{"lang":"en","description":"This is a subreddit devoted to long-term and short-term trading of Litecoins. ","over18":false},"sociopath":{"lang":"en","description":"For the Empathetically Challenged","over18":false},"ArmoredWarfare":{"lang":"en","description":"**ANNOUNCING ARMORED WARFARE**\n\nWe’re thrilled to announce Armored Warfare, a new free-to-play massively multiplayer online tactical military video game that puts you in control of some of the most in","over18":false},"orangetheory":{"lang":"en","description":"The \"Unofficial\" reddit community for Orangetheory Fitness ","over18":false},"quittingkratom":{"lang":"en","description":"The purpose of this Forum is to give and receive information and support regarding quitting Kratom, Kratom withdrawal and recovery.\n","over18":false},"blackmagicfuckery":{"lang":"en","description":"Anything that clearly has no other explanation but no good voodoo black magic fuckery.","over18":false},"DebateAltRight":{"lang":"en","description":"An open forum for serious discussion and debate of the alt-right and its ideas.","over18":false},"DeFranco":{"lang":"en","description":"","over18":false},"amazon":{"lang":"en","description":"All things Amazon: Amazon.com, Amazon Prime, Prime Video, AWS, Kindle, Echo, and more!\n","over18":false},"RetroFuturism":{"lang":"en","description":"This subreddit focuses on the futurist visions of eras past. However posts may also contain contemporary art with a retrofuturist theme. \n\nTopics are usually in the realm of science fiction, but may i","over18":false},"quilting":{"lang":"en","description":"We love all things quilting. Show off your latest project or just learn how to get started. We're here to help!  Please review our FAQ before posting to see if your questions are answered there.  Chec","over18":false},"youtubers":{"lang":"en","description":"/r/YouTubers is a community dedicated to sharing redditor-made content, giving and receiving helpful Reviews, and networking with other content creators! Welcome!\n\nJoin our Discord Server here: https:","over18":false},"catpictures":{"lang":"en","description":"Submit pictures of your cats, be it big or small!","over18":false},"AsianMasculinity":{"lang":"en","description":"The only space on the web dedicated to critically examining the Asian male experience.\n\n\n","over18":false},"riverdale":{"lang":"en","description":"Riverdale is a television series for The CW/Netflix, based on characters from Archie Comics. \n\nSet in the present, the series offers a bold, subversive take on Archie, Jughead, Betty, Veronica and the","over18":false},"superman":{"lang":"en","description":"Clark Kent. Kal-El. The Man of Steel. The Last Son of Krypton. A place to discuss Superman and all things Superman related.","over18":false},"AntiJokes":{"lang":"en","description":"\"Jokes\" that are funny that aren't jokes.","over18":false},"thegrandtour":{"lang":"en","description":"This is a subreddit about \"The Grand Tour\", Amazon's car show hosted by former BBC Top Gear presenters: Jeremy Clarkson, Richard Hammond and James May.","over18":false},"baduk":{"lang":"en","description":"A place for players of Go/Weiqi/Baduk.  We have discussions, go problems, game reviews, news, events, tournaments, lessons and more!","over18":false},"EngineeringPorn":{"lang":"en","description":"","over18":false},"ShitRConservativeSays":{"lang":"fa","description":"Have you ever suspected r/conservative is just liberal satire and most of the moderators are trying to make conservatives look insane?\n\n\n\n--------\n\n\"SRCS predicted the rise of Trump years ahead of the","over18":false},"OnOff":{"lang":"en","description":"A place to share pictures showing what a girl looks like both clothed and unclothed. Sometimes imagination just isn't enough. Also known as \n\n* On and off | On/Off\n* Dressed and undressed | Dressed/Na","over18":true},"Kaiserreich":{"lang":"en","description":"The official subreddit of Kaiserreich: Legacy of the Weltkrieg, an alternate history mod for the Hearts of Iron series.","over18":false},"TapTitans":{"lang":"en","description":"An incremental games about fighting Titans and getting heroes.","over18":false},"whiskey":{"lang":"en","description":"Whiskeys of the world. Discussion, reviews, articles, photos. Anything goes, including bourbon, scotch, rye, wheat, Canadian, Irish, white dogs, and everything in between. \n\nPlease consult the guides ","over18":false},"Diablo3DemonHunters":{"lang":"en","description":"A subreddit for questions and discussions related to the Demon Hunter class in Diablo 3.","over18":false},"Volvo":{"lang":"en","description":"Boxy but good.","over18":false},"oakland":{"lang":"en","description":"","over18":false},"Brooklyn":{"lang":"en","description":"\"If you don't know, now you know, Reddit.\"","over18":false},"SweatyPalms":{"lang":"en","description":"Videos (and images) that make your palms sweat.","over18":false},"learnart":{"lang":"en","description":"A community advice / critique panel, much in the vein of /r/learnprogramming. \n\nEver wonder how someone did that AMAZING painting and want to learn the technique? Problems with Photoshop or illustrato","over18":false},"EnterTheGungeon":{"lang":"en","description":"Enter the Gungeon is a gunfight dungeon crawler following a band of misfits seeking to shoot, loot, dodge roll and table-flip their way to personal absolution by reaching the legendary Gungeon’s ultim","over18":false},"SecretWorldLegends":{"lang":"en","description":"The official subreddit for Secret World Legends! \n\nhttps://secretworldlegends.com","over18":false},"redditrequest":{"lang":"en","description":"","over18":false},"lebanon":{"lang":"en","description":"Are you Lebanese? Do you know someone from Lebanon?\n\nAre you visiting? Check out the [Wiki] (http://www.reddit.com/r/lebanon/wiki/index)\n\nDo you have a question about Lebanon and/or Lebanese people?\n\n","over18":false},"FidgetSpinners":{"lang":"en","description":"The place to discuss everything about fidget spinners, the best type of fidget toy out there!","over18":false},"QuakeChampions":{"lang":"en","description":"Quake Champions, the upcoming FPS from Id Software and Bethesda Softworks","over18":false},"YasuoMains":{"lang":"en","description":"\"M'Yasuo.\" *tips fedora, High Noon style*\n\n","over18":false},"mashups":{"lang":"en","description":"This subreddit is dedicated to musical mashups.\n\nA mashup is a song or composition created by blending two or more pre-recorded songs, usually by overlaying the vocal track of one song seamlessly over","over18":false},"bmx":{"lang":"en","description":"For discussion of Bicycle Motocross & showcasing grassroots beginners all the way up to the latest & most groundbreaking media BMX has to offer. It's easy, you do.","over18":false},"crappyoffbrands":{"lang":"en","description":"This subreddit is a forum in which users can submit pictures or videos of examples of crappy or just plain funny off-brand versions of various products. These examples can be both from present day as ","over18":false},"Diablo3Wizards":{"lang":"en","description":"This subreddit is for the Wizard class of Diablo 3.\n","over18":false},"mcpublic":{"lang":"en","description":"Subreddit for the Nerd.nu Gaming Community Minecraft Servers, with roots as the oldest existing Minecraft servers, founded as the original Minecraft servers of the Reddit community.  \n\nhttp://nerd.nu ","over18":false},"deadmau5":{"lang":"en","description":"All deadmau5, all the time.","over18":false},"Hiphopcirclejerk":{"lang":"en","description":"i don't like the redesign, i don't go outside","over18":false},"CK2GameOfthrones":{"lang":"en","description":"This is the subreddit for those who play the Game of Thrones mod for the game Crusader Kings 2. ","over18":false},"ConanExiles":{"lang":"en","description":"A subreddit dedicated to the discussion of Conan Exiles, the open-world survival game set in the Conan the Barbarian universe!","over18":false},"northernlion":{"lang":"en","description":"Subreddit for discussion about Youtuber and Twitch streamer Northernlion","over18":false},"timbers":{"lang":"en","description":"The Official Portland Timbers Subreddit","over18":false},"Alienware":{"lang":"en","description":"The unofficial community for Alienware computer news and discussion.  ","over18":false},"MarvelPuzzleQuest":{"lang":"en","description":"A place to come and talk about Marvel Puzzle Quest and help each other out!","over18":false},"oregon":{"lang":"en","description":"The official subreddit for Or-ee-gun","over18":false},"Edinburgh":{"lang":"en","description":"Just a Subreddit for those who love the city, or live here and want to talk about it, or for those passers by who are interested.","over18":false},"smashcirclejerk":{"lang":"en","description":"IT'S NOT A PORT","over18":false},"Dualsport":{"lang":"en","description":"","over18":false},"alaska":{"lang":"en","description":"","over18":false},"Grimdawn":{"lang":"en","description":"A subreddit dedicated to Grim Dawn, an action role-playing game developed and published by Crate Entertainment.","over18":false},"WhiteRights":{"lang":null,"description":"Subreddit no longer exists","over18":null},"DebateAnarchism":{"lang":"en","description":"A place to challenge, debate, and discuss anarchism. All political beliefs are welcome! Post your debate challenge and see if any anarchists take you up on it.","over18":false},"StLouisRams":{"lang":"en","description":"This subreddit is a forum dedicated to the NFL team the St. Louis Rams.","over18":false},"judo":{"lang":"en","description":"A reddit for judoka and spectators to submit anything about Judo.","over18":false},"explainlikeIAmA":{"lang":"en","description":"~~If you are anything BUT 5 years old, and you're confused by something, this is the place for you.~~\n\nNow that /r/eli5 clarified that they want simple explanations, (fake) 5 YEAR OLDS ARE NOW WELCOME","over18":false},"BackYardChickens":{"lang":"en","description":"Interesting stuff for the small flock community and the humane big flock community.","over18":false},"NLSSCircleJerk":{"lang":"en","description":"The perpetual circlejerk of computer generated Tayne pictures.","over18":false},"ruby":{"lang":"en","description":"","over18":false},"tabletopgamedesign":{"lang":"en","description":"All things related to *designing* tabletop RPGs, wargames, and board games. ","over18":false},"TimAndEric":{"lang":"en","description":"A subreddit dedicated to our favorite duo!","over18":false},"Target":{"lang":"en","description":"","over18":false},"freelance":{"lang":"en","description":"Articles of interest for freelancers and people who want to become one. **Violating [the rules](https://www.reddit.com/r/freelance/about/rules) will cause your post/comment will be removed and you wil","over18":false},"AskSF":{"lang":"en","description":"Ask Us Anything about San Francisco","over18":false},"Ooer":{"lang":"en","description":"NOW WITH 100% MORE WEP!","over18":false},"advertising":{"lang":"en","description":"/r/Advertising: Ground Zero for ad creators, students, copywriters, affiliates, and anyone else who is finely honing their reverse banner blindness for professional reasons.","over18":false},"altgonewild":{"lang":"en","description":"Welcome to **Alt Gone Wild**, a place for tattooed/pierced/otherwise \"alternative\" ladies to share their nude selfies with reddit and celebrate anonymous exhibitionism.\n\n* **No advertising...EVER!** D","over18":true},"puppy101":{"lang":"en","description":"Welcome! Our mission at Puppy101 is to provide constructive and supportive advice for puppy owners who need help with a problem, have questions about training, or just need some encouragement while go","over18":false},"mentalhealth":{"lang":"en","description":"The Mental Health subreddit is a central place to discuss, vent, support and share information about mental health, illness and wellness. This forum is moderated by volunteers of the South Asian Menta","over18":false},"shanghai":{"lang":"en","description":"A subreddit for redditors living in, visiting, or interested in China's most populous and ever-expanding city, Shanghai (上海).\n\nShare your experiences of the city, photos of shiny things, noteworthy pl","over18":false},"urbanplanning":{"lang":"en","description":"Urban Planning, Community Planning, City Planning, New Urbanism, Smart Growth, Zoning, Transportation and all that makes the built environments that we work and recreate in. Urban planning aims to imp","over18":false},"Wrangler":{"lang":"en","description":"A subreddit for Jeep Wrangler enthusiasts ","over18":false},"projecteternity":{"lang":"en","description":"A place to discuss the Obsidian Entertainment game Pillars of Eternity and Pillars of Eternity II: Deadfire.","over18":false},"pacers":{"lang":"en","description":"For all Pacers fans! ","over18":false},"SRSGaming":{"lang":"en","description":"","over18":false},"Albany":{"lang":"en","description":"Subreddit dedicated to the capital of New York State, Albany.","over18":false},"vitahacks":{"lang":"en","description":"A place to discuss Vita hacking and homebrew. Both technical and non-technical discussion are welcome. Please do not ask or discuss how to pirate/\"backup\" games, it is illegal and against redditquette","over18":false},"RivalsOfAether":{"lang":"en","description":"Discuss the smash-inspired 2d brawler game produced by Dan Fornace and his team.","over18":false},"Wicca":{"lang":"en","description":"Wicca is a modern neopagan religion that is based on ancient pagan beliefs. It's an earth-based religion that believes in a God and Goddess as representative of a greater pantheistic godhead. Wicca in","over18":false},"ClopClop":{"lang":"en","description":"For all your My Little Pony Rule 34 (aka \"clop\") needs.\n\n","over18":true},"SCJerk":{"lang":"en","description":"SCJerk - When you're a wrestling fan who can't be worked.","over18":false},"Coilporn":{"lang":"en","description":"A SFW Porn Subreddit for RBA Coils","over18":false},"castiron":{"lang":"en","description":"","over18":false},"awfuleyebrows":{"lang":"en","description":"A place for embarrassing eyebrows","over18":false},"VinylCollectors":{"lang":"en","description":"Collectors buying, selling and trading vinyl. Post albums that you want or ones you are selling or trading.","over18":false},"ccna":{"lang":"en","description":"","over18":false},"digitalnomad":{"lang":"en","description":"Digital Nomads are individuals that leverage technology in order to work remotely and live an independent and nomadic lifestyle.","over18":false},"migraine":{"lang":"en","description":"A community of headache disease sufferers. Whether migraines, cluster headaches, or whatever head pain you experience. We support each other, and spread knowledge about our various conditions.","over18":false},"HotWheels":{"lang":"en","description":"Hot Wheels on reddit!  Reddit's dedicated Hot Wheels section, welcoming all forms of die-cast, not just Hot Wheels.","over18":false},"MST3K":{"lang":"en","description":"A place for fans of Mystery Science Theater 3000 to share all things MST3K-related.","over18":false},"iiiiiiitttttttttttt":{"lang":"en","description":"Tired of stupid customers? Having to deal with constant computer frustrations at work? Another virus ruining a perfect day? Having to fix incredibly-crafted spaghetti code in Visual Basic? Your databa","over18":false},"itmejp":{"lang":"en","description":"This subreddit is for fans of ITMEJP's streaming endeavors and more specifically his creation Rollplay and the shows therein.\n\nIt exists in an unofficial capacity as a sister site to the official ITME","over18":false},"pornvids":{"lang":"en","description":"The best adult xxx videos, hardcore sex and amateur sextapes from the free porn tubes.","over18":true},"HotlineMiami":{"lang":"en","description":"Welcome to Miami, where you answer weird phone calls, put a mask on and go kill people.\n\nThis subreddit is related to game series Hotline Miami by Dennaton games and published by Devolver Digital.","over18":false},"surrealmemes":{"lang":"en","description":"Surreal memes are (usually humorous) memes that are in a surreal style or contain surreal content. Such memes may be difficult to understand for mere mortals. In the future most memes will look like t","over18":false},"granturismo":{"lang":"en","description":"A subreddit dedicated to the Gran Turismo series. Come here for news, discussion, speculation, and help. Post your garage collection, strategies and techniques, photos and everything in between! ","over18":false},"TheWayWeWere":{"lang":"en","description":"What was **normal everyday life** like for people living 50, 100, or more years ago? Featuring old photos, scanned documents, articles, and personal anecdotes that offer a glimpse into the past.","over18":false},"LeagueOfGiving":{"lang":"en","description":"","over18":false},"EndlessFrontier":{"lang":"en","description":"A community for Endless Frontier, a mobile game for iOS and Android. Endless Frontier was made by Ekkorr and came out in February 2016.","over18":false},"ferrets":{"lang":"en","description":"Everything ferret related!  Photos, videos, questions, information, for ferrets and the people who keep them as pets. ","over18":false},"questionablecontent":{"lang":"en","description":"","over18":false},"AskTrollX":{"lang":"en","description":"This is a an offset sub from /r/trollxchromosomes, any question you've ever wanted to ask a sassy woman can be asked here!","over18":false},"Cubs":{"lang":"en","description":"Go Cubs Go","over18":false},"treesgonewild":{"lang":"gd","description":"/r/treesgonewild!","over18":true},"HardwareSwapUK":{"lang":"en","description":"/r/HardwareSwapUK: Sell, buy or trade PC hardware in the UK!","over18":false},"transtimelines":{"lang":"en","description":"A place to share transition timelines.","over18":false},"twincitiessocial":{"lang":"en","description":"Meetups in the Minnesota cities of Minneapolis, St. Paul, and surrounding metro area.","over18":false},"MensLib":{"lang":"en","description":"The men's issues discussion has been sorely held back by counterproductive tribalism. We're building a new dialogue on the real issues facing men through positivity, inclusiveness, and solutions-build","over18":false},"tattoo":{"lang":"en","description":"A place to share and discuss tattoos and the tattooing process.","over18":false},"TrueAnime":{"lang":"en","description":"/r/TrueAnime is a subreddit dedicated to the discussion of Japanese animation, or \"anime\" for short.","over18":false},"communism":{"lang":"en","description":"For the theory and practice of marxism.","over18":false},"Enhancement":{"lang":"en","description":"A subreddit for discussion, suggestions, etc around Reddit Enhancement Suite, a community-driven unofficial browser extension for Reddit.","over18":false},"AnimalCollective":{"lang":"en","description":"A subreddit for Animal Collective fans. ","over18":false},"homegym":{"lang":"en","description":"A subreddit devoted to working out at home. \n","over18":false},"DungeonsAndDragons":{"lang":"en","description":"","over18":false},"medical":{"lang":"en","description":"This is a Subreddit for people with specific but often awkward questions about their body and how it works.  Intended to be like AskReddit, but for Medical questions only.  The advice given and receiv","over18":false},"MurderedByWords":{"lang":"en","description":"A place for well-constructed put-downs, comebacks, and counter-arguments.\n\n","over18":false},"festivals":{"lang":"en","description":"Music festivals of any kind. Feel free to post News, Pictures, Lineups, Upcoming shows, Videos, Ask Questions, etc.\n\n* Bonnaroo\n* Coachella\n* Glastonbury\n* Camp Bisco\n* Electric Forest\n* Ultra Music F","over18":false},"tales":{"lang":"en","description":"","over18":false},"Miniswap":{"lang":"en","description":"","over18":false},"germanshepherds":{"lang":"en","description":"For all things German Shepherd Dogs, GSD-mixes and anyone interested in the best dog breed on Earth. Guardians, breeders, enthusiasts, and general dog-lovers, share your German Shepherd pictures, trai","over18":false},"unrealengine":{"lang":"en","description":"The official subreddit for the Unreal Engine by Epic Games, inc.","over18":false},"OhNoMomWentWild":{"lang":null,"description":"Subreddit forbidden","over18":null},"Portal":{"lang":"en","description":"The official subreddit for Portal and Portal 2, games developed by Valve Software.","over18":false},"CowChop":{"lang":"en","description":"The official subreddit for UberHaxorNova and ImmortalHD's Couch Co-op YouTube channel!","over18":false},"ImagesOfCalifornia":{"lang":"en","description":"Pictures and images of California","over18":false},"Charleston":{"lang":"en","description":"A community  to share news, events, gatherings, stories, and more for everyone that calls The Holy City (and her surroundings) home.    \n    \nCharleston, North Charleston, Mount Pleasant, West Ashley,","over18":false},"hugeboobs":{"lang":"en","description":"A celebration of monstrous mammaries and the women who have them.","over18":true},"EntExchange":{"lang":"en","description":"/r/Entexchange is a community that exists to facilitate the trading of all things Cannabis-related (Glass, Lighters, Artwork, Pendants, Etc..) between fellow Redditors. ","over18":true},"simpleliving":{"lang":"en","description":"Breaking free of the work/spend/borrow cycle in order to live more fully, sustainably, and cooperatively.","over18":false},"FoWtcg":{"lang":"en","description":"Everything about the Force of Will trading card game","over18":false},"pennystocks":{"lang":"en","description":"A place to discuss penny stocks freely. Please keep in mind that this is an open forum, and advice from redditiors may not be in your best interest. Please join us on Discord at [/r/pennystocks](https","over18":false},"Iceland":{"lang":"is","description":"","over18":false},"Wildlands":{"lang":"en","description":"An unofficial subreddit for Tom Clancy's Ghost Recon: Wildlands. This is an entirely fan-run subreddit and is in no way owned or operated by Ubisoft.","over18":false},"weezer":{"lang":"en","description":"For fans of the rock band Weezer.\n\nCurrent members:\n- Rivers Cuomo\n- Brian Bell\n- Scott Shriner\n- Patrick Wilson","over18":false},"Finland":{"lang":"en","description":"Finland's English language subreddit!","over18":false},"sharedota2":{"lang":"en","description":"","over18":false},"twice":{"lang":"en","description":"For JYP Entertainment's TWICE, by ONCE.","over18":false},"reddeadredemption":{"lang":"en","description":"A subreddit for Rockstar's critically acclaimed open-world Western game *Red Dead Redemption* and its prequel *Red Dead Redemption 2*, releasing on October 26, 2018.","over18":false},"kpics":{"lang":"en","description":"/r/kpics - for all your K-Pop picture needs\n\n[K-pop (Korean popular music)](http://en.wikipedia.org/wiki/K-pop) is a musical genre consisting of pop, dance, electropop, hip hop, rock, R&B, electronic ","over18":false},"tesdcares":{"lang":"en","description":"News, Links, Pictures, Videos, Discussion of Tell 'Em Steve Dave. (Comic Book Men, Space Monkeys, What Say You etc.)","over18":false},"4PanelCringe":{"lang":"en","description":"/r/4panelcringe is the place for Panel images usually posted on tumblr and facebook that fill you with embarrassment and shame just by looking at them. ","over18":false},"xray":{"lang":null,"description":"Subreddit no longer exists","over18":null},"XFiles":{"lang":"en","description":"Welcome to Reddit's X-Files Community! This is a place for lovers of everything X-Files, The Lone Gunmen, and Millennium.","over18":false},"SonyAlpha":{"lang":"en","description":"Reddit's most popular camera brand-specific subreddit! We focus on Sony Alpha cameras: Sony E Mount, Sony A Mount, legacy Minolta cameras, RX cameras, lenses, flashes, photoshare, and discussion.","over18":false},"girlsinyogapants":{"lang":"en","description":"Beautiful girls wearing yoga pants","over18":true},"worldofpvp":{"lang":"en","description":"A place where greats are made, and greats stay.","over18":false},"kpopfap":{"lang":"en","description":"Korean pop music - the lewd edition.","over18":true},"LetItDie":{"lang":"en","description":"The unofficial LET IT DIE community. \n\nLET IT DIE is a Playstation 4 exclusive video game made by Grasshopper Manufacture and published by GungHo Online Entertainment in 2016/2017.","over18":false},"rush":{"lang":"en","description":"For the Canadian Progressive Rock trio!","over18":false},"NLTP":{"lang":"en","description":"NLTP: A Capture The Flag League","over18":false},"MLTP":{"lang":"en","description":"A subreddit for Major League TagPro, North America's premier competitive tier in TagPro!\n\nPlay TagPro: http://www.tagpro.gg","over18":false},"YMS":{"lang":"en","description":"The official subreddit for YourMovieSucks.org","over18":false},"GalaxyNote8":{"lang":"en","description":"Everything related to the Samsung GALAXY Note 8.","over18":false},"USPS":{"lang":"en","description":"This sub is not officially affiliated with USPS. It is a place for employees to share and talk with customers. \n  \n","over18":false},"AskNetsec":{"lang":"en","description":"","over18":false},"coolguides":{"lang":"en","description":"Picture based reference guides for anything and everything. If it seems like something someone might print, physically post, and reference then it is a good link for this sub. \n\nRemember: Infographics","over18":false},"gamedesign":{"lang":"en","description":"For topics related to the design of games for interactive entertainment systems - video games, board games, tabletop RPGs, or any other type. /r/GameDesign is not a subreddit about general game develo","over18":false},"Musicthemetime":{"lang":"en","description":"It's a music subreddit with a different theme every day. Inspired by Uncle Bob Dylan's Theme Time Radio Hour.","over18":false},"gamemusic":{"lang":"en","description":"The subreddit for video game music, new and old.\n\nSubmit or listen to your favorite song, songs, or a playlist. If you get nostalgic over old retro videogame music, check us out!","over18":false},"litecoinmining":{"lang":"en","description":"Since the litecoin community is growing, I've decided to introduce /r/litecoinmining, a place for all discussion revolving mining litecoins!","over18":false},"obama":{"lang":"en","description":"A subreddit for news, commentary, and discussion about President Barack Obama","over18":false},"awardtravel":{"lang":"en","description":"A place to discuss burning airline miles & hotel points.","over18":false},"mechanical_gifs":{"lang":"en","description":"This sub is for .gif images that contain a subject matter of mechanical origin.","over18":false},"RBA":{"lang":"en","description":"A place for e-cigarette users into Rebuildable Atomizers","over18":false},"UTAustin":{"lang":"en","description":"The University of Texas at Austin","over18":false},"DepthHub":{"lang":"en","description":"DepthHub gathers the best in-depth submissions and discussion on Reddit. You can use [the DepthHub](http://www.reddit.com/user/Lapper/m/depthhub) as an alternative front page with high quality discuss","over18":false},"tampabayrays":{"lang":"en","description":"News and discussion about your Tampa Bay Rays!","over18":false},"tucker_carlson":{"lang":"en","description":"Tucker Carlson is the sworn enemy of lying, pomposity, smugness and groupthink. His goal is to pierce pomposity, translate double-speak, mock smugness and barbecue nonsense as he debates people from a","over18":false},"canadients":{"lang":"en","description":"A group of Canadian smokers, tokers, vapers, dabbers, extractors, bakers, chefs, medical patients, and dootchie passers who believe that Cannabis makes their life healthier, and happier. Hit subscribe","over18":false},"flatearth":{"lang":"en","description":"","over18":false},"IdleHeroes":{"lang":"en","description":"An Idle RPG. Earn experience, gold, and items offline while building a team of powerful heroes!","over18":false},"emacs":{"lang":"en","description":"The extensible, customizable, self-documenting real-time display editor.","over18":false},"BattlefrontTWO":{"lang":"en","description":"A subreddit for Star Wars Battlefront II! Please keep posts relevant to the game and keep an open mind, have fun!","over18":false},"snes":{"lang":"en","description":"The largest active Super Nintendo community on the internet! \n\nThe Super Nintendo Entertainment System is Nintendo's second home console, following the Nintendo Entertainment System (NES). The console","over18":false},"shittyaskreddit":{"lang":"en","description":"/r/shittyaskreddit, Because askreddit is for \"thought-provoking, inspired questions.\"","over18":false},"jobuds":{"lang":"en","description":"The subreddit for mostly straight guys who happen to like jerking off with others. Share what gets you off, share a story, get your dick out","over18":true},"Debate":{"lang":"en","description":"/r/Debate is a subreddit dedicated to discussing formal styles of speech debate as practiced in high school and college. These include Lincoln Douglas, Policy, Public Forum, and Congressional debate, ","over18":false},"forsen":{"lang":"en","description":"Forsen related subreddit. Forsen mixes, news, big plays, tilts. Everything that is somewhat related to forsen. ","over18":false},"xbox":{"lang":"en","description":"Topics related to all versions of the Xbox video game consoles, Games, Online Services, Software, Controllers, etc.","over18":false},"Cloud9":{"lang":"en","description":"Official subreddit of the North American Esports organization - Cloud9.","over18":false},"UCSantaBarbara":{"lang":"en","description":"News, questions, and discussions for the people of UCSB and IV.","over18":false},"conservatives":{"lang":"en","description":"Conservatism (from conservare, \"to preserve\") is a political and social philosophy that promotes the maintenance of traditional institutions and supports minimal and gradual change in society.\n\n","over18":false},"AskPhotography":{"lang":"en","description":"Ask questions about photography, cameras, lenses, and more!\n","over18":false},"futurebeatproducers":{"lang":"en","description":"For sharing and discussing original experimental beat music.\n'Future', here, is a state of mind.\n\n","over18":false},"UtahJazz":{"lang":"en","description":"Home of Defense and Dunks","over18":false},"Nirvana":{"lang":"en","description":"A forum dedicated to preserving the history and legacy of the band Nirvana. ","over18":false},"Marriage":{"lang":"en","description":"","over18":false},"vikingstv":{"lang":"en","description":"The subreddit for the TV Show Vikings, made by History Channel.\n","over18":false},"Cinemagraphs":{"lang":"en","description":"Cinemagraphs are living photographs, seamlessly put together usually in gif or webm format.","over18":false},"riddles":{"lang":"en","description":"Come solve riddles with us!","over18":false},"MuayThai":{"lang":"en","description":"All things Muay Thai, news, upcoming events & general discussion. From fighters to fans, everyone is welcome!","over18":false},"awakened":{"lang":"en","description":"This is an online community dedicated to discussing what leads up to a fundamental shift in perspective, commonly called \"awakening\", the recognition itself and what follows thereafter.","over18":false},"projectcar":{"lang":"en","description":"Shine that turd","over18":false},"FortWorth":{"lang":"en","description":"","over18":false},"GamerPals":{"lang":"en","description":"A place for gamers looking to meet others to play games with. Whether it be for Xbox, Playstation, Wii, or PC ( or even those dreaded social network games). \n","over18":false},"Machinists":{"lang":"en","description":"A Reddit for Machinists of all varieties. From Old School conventional guys, to CNC Programmers, to the up and coming next generation. ","over18":false},"ScotchSwap":{"lang":null,"description":"Subreddit no longer exists","over18":null},"NoSleepOOC":{"lang":"en","description":"Welcome to NosleepOOC. This is an out of character subreddit created for the Nosleep community. Please feel free to discuss any matters related to the Nosleep community, horror, and writing in general","over18":false},"RPDRDRAMA":{"lang":"en","description":"\"I'M A MESSY BITCH WHO LIVES FOR DRAMA\"","over18":false},"misleadingthumbnails":{"lang":"en","description":"This is a place for any and all thumbnails that may trick you into thinking the photo is of something else. It doesn't have to be sexual, as long as its misleading. Please don't tag your posts NSFW, a","over18":false},"TheDarkTower":{"lang":"en","description":"Devoted to Stephen King's magnum opus and the center of his literary universe, *The Dark Tower*.","over18":false},"findaleague":{"lang":"en","description":"Fantasy league classifieds\n\n--------------\n\nWhen advertising leagues include as much information as possible. Add link flair after posting a thread. \n\nReview the sidebar and stickied threads for more ","over18":false},"newhampshire":{"lang":"en","description":"For all things related to the great state of New Hampshire","over18":false},"urbanexploration":{"lang":"en","description":"","over18":false},"AirBnB":{"lang":"en","description":"A place for hosts and guests to discuss Airbnb. Great starting resources if you are new to Airbnb or you need some non-emergency assistance.","over18":false},"G59":{"lang":"en","description":"The Official Subreddit for anything G*59 related.","over18":false},"osx":{"lang":"en","description":"Reddit's community for users, developers, and hackers of Mac OS X – the desktop operating system from Apple","over18":false},"giveaways":{"lang":"en","description":"Place to post giveaways/sweepstakes/contests, either personal or links to other websites doing similar. Reposts are allowed every 48h. Enjoy :)","over18":false},"perfectloops":{"lang":"en","description":"A collection of Perfectly Looped animated .gifs and html5 videos.","over18":false},"RepLadies":{"lang":"en","description":"This is a happy place for discussion about women's replica clothing and accessories. This subreddit was formed in hopes of creating a community where we can all enjoy fashion at any level, share our e","over18":false},"FRC":{"lang":"en","description":"Reddit's home for the FIRST Robotics Competition!","over18":false},"FreeGamesOnSteam":{"lang":"en","description":"This is a subreddit for finding free Steam keys!","over18":false},"Skyforge":{"lang":"en","description":"Free-to-play Action-Combat MMORPG created by the Allods team and Obsidian Entertainment.","over18":false},"russian":{"lang":"en","description":"This is a subreddit for people looking to learn Russian and all things related to the Russian language. Though Russian is encouraged, most discussions are in English.","over18":false},"lowendgaming":{"lang":"en","description":"In this subreddit: we roll our eyes and snicker at minimum system requirements. This is a community for anyone struggling to find something to play for that older system, or sharing or seeking tips fo","over18":false},"swrpg":{"lang":"en","description":"This is a community for friendly discussion about FFG's Star Wars RPG. This system began with the release of the beta Edge of the Empire rulebook in 2012, and it has now been officially released by Fa","over18":false},"Delaware":{"lang":"en","description":"[.](http://www.youtube.com/watch?v=DDGDgc1qNCA)","over18":false},"anal":{"lang":"en","description":"All things anal. If it goes in an ass, it belongs here.","over18":true},"BitcoinBeginners":{"lang":"en","description":"On this group beginners can ask questions about Bitcoin without fear of not getting to the first page.\n\n/r/BitcoinBeginners is not for posting new websites, memes, faucets, affiliate links, news, blog","over18":false},"RandomActsOfChristmas":{"lang":"en","description":"","over18":false},"Diablo3witchdoctors":{"lang":"en","description":"A subreddit for questions and discussions related to the Witch Doctor class in Diablo 3.","over18":false},"EnoughPaulSpam":{"lang":"en","description":"","over18":false},"WeWantPlates":{"lang":"en","description":"**We Want Plates** crusades against serving food on bits of wood and roof tiles, chips in mugs and drinks in jam jars.","over18":false},"LetsChat":{"lang":"en","description":"A community dedicated to talking to strangers, chatting either with Reddit chat, through comments, or on Discord. We welcome all, so long as you play fair, be nice, and respect others. Enjoy!","over18":false},"Korean":{"lang":"en","description":"안녕하세요! 환영합니다! We're here to study and learn the Korean language. All levels welcome.","over18":false},"CanadianMOMs":{"lang":"en","description":"This is a subreddit dedicated to the **discussion** of Mail Order Marijuana & the Cannabis Community in Canada.","over18":false},"xmen":{"lang":"en","description":"Welcome to the official X-Men subreddit","over18":false},"Trophies":{"lang":"en","description":"A subreddit for those in quest of the almighty :platinum:.\n\nGold, Silver, and Bronze trophy hunters welcome too!\n\nCovering PlayStation 4 (PS4), PlayStation 3 (PS3), and PS Vita.  \n\nNote: Does not cove","over18":false},"BobsBurgers":{"lang":"en","description":"A subreddit for fans of the TV show [Bob's Burgers](http://en.wikipedia.org/wiki/Bob's_Burgers).","over18":false},"bouldering":{"lang":"en","description":"Cordless and proud.","over18":false},"programmingcirclejerk":{"lang":"en","description":"\nLinus is wearing a blue shirt!\n\nzomg noSQL u guise!\n\nApple Google Facebook NSA\n\nI rewrote \"hello world\" in ~~Fortran~~ ~~Pascal~~ ~~C~~ ~~Perl~~ ~~Ruby~~ ~~Lisp~~ ~~Haskell~~ ~~Clojure~~ ~~NodeJS~~ ~","over18":false},"scooters":{"lang":"en","description":"","over18":false},"foshelter":{"lang":"en","description":"Fallout Shelter is a mobile game where you create and manage your on vault as a overseer at Vault-Tec.\n","over18":false},"Nikon":{"lang":"en","description":"Nikon cameras","over18":false},"AppHookup":{"lang":"en","description":"The best sales and verified price reductions for apps and applications of all operating systems: Android, iOS, Windows, macOS, Steam and more.","over18":false},"VitaPiracy":{"lang":"en","description":"All references to piracy in this subreddit should be translated to \"game backups\".","over18":false},"treecomics":{"lang":"en","description":"Welcome to r/treecomics, the subreddit for stoner comics of all sorts!","over18":false},"bloodbowl":{"lang":"en","description":"This is the location for your questions about Bloodbowl, either the Electronic version or the Tabletop. We can cover it all! Team Building! Strategies! Alternate Miniatures! \n\nWe Are Bloodbowl!","over18":false},"geocaching":{"lang":"en","description":"","over18":false},"GoldandBlack":{"lang":"en","description":"Civil, on topic discussion of Anarcho-Capitalism with gold and black frills.","over18":false},"SkyDiving":{"lang":"en","description":"A subreddit for those interested in Skydiving and BASE jumping.","over18":false},"uhccourtroom":{"lang":"en","description":"The UHC Courtroom. ","over18":false},"FreeGameFindings":{"lang":"en","description":"/r/FreeGameFindings is based around finding free games all over the place! Be it Steam, Origin, Uplay, Xbox 360/One, Playstation 3/4/Vita, or Wii U/3DS, we will find every last free Game and DLC we ca","over18":false},"ideasfortheadmins":{"lang":"en","description":"This subreddit is for **reddit-wide ideas for improvement**.  \n\n","over18":false},"LinkinPark":{"lang":"en","description":"The unofficial official Linkin Park subreddit","over18":false},"BPDlovedones":{"lang":"en","description":"Support for nonBPDs to make sense of the confusing relationship with someone with BPD. \n\nThis is a safe space exclusively for people without BPD to discuss the challenges and difficulties in their cur","over18":false},"Rengarmains":{"lang":"en","description":"Everyone is welcome to post tips and all things Rengar to help the others who love Rengar.","over18":false},"maryland":{"lang":"en","description":"A community for redditors residing in or otherwise interested in the State of Maryland, USA.","over18":false},"WhatsInThisThing":{"lang":"en","description":"A subreddit originally created to break into my friends vault","over18":false},"TinyTits":{"lang":"en","description":"For the lovers of smaller breasts.","over18":true},"Images":{"lang":"en","description":"A subreddit for images and with minimal rules on content.","over18":false},"Fencing":{"lang":"en","description":"Subreddit for the Olympic sport of fencing. Foil, epee, and sabre discussion. ","over18":false},"kickstarter":{"lang":"en","description":"While this subreddit is all about Kickstarter, other crowd-funding sites are welcome too!  \n\nPost about *your* project or simply post about your favorite new project. Get some publicity going and help","over18":false},"JamesBond":{"lang":"en","description":"A subreddit to discuss anything and everything related to Ian Fleming's James Bond 007.","over18":false},"magicduels":{"lang":"en","description":"A place for anything concerning the Magic Duels series. Since this is more of a casual Magic experience I felt it deserves it's own more casual focused subreddit. \n\nIf you wish to find some fellow red","over18":false},"collegehockey":{"lang":"en","description":"Forum dedicated to the discussion of our favorite college sport. ","over18":false},"VapePorn":{"lang":"en","description":"A place for Vapers to show off their collection and favorite setups.","over18":false},"antisrs":{"lang":"en","description":"","over18":false},"MotoG":{"lang":"en","description":"We are not associated with Motorola, Motorola Mobility or Lenovo. This subreddit is a small friendly community that is dedicated to discussion & assistance for all variants of the Moto G.","over18":false},"ChildrenFallingOver":{"lang":"en","description":"It's hilarious to see little humans topple over. What more can we say?","over18":false},"Retconned":{"lang":"en","description":"A public sub for those experiencing the phenomenon of the Retcon Effect, or Real-Life Retroactive Continuity, sometimes known as the Mandela Effect. This sub is meant to be a place to discuss the effe","over18":false},"LoveLive":{"lang":"en","description":"Welcome to the subreddit for Love Live: School Idol Project! You can find the latest news, events and most things Love Live related here!\n\n/r/LoveLive currently does not support the reddit redesign. G","over18":false},"bbuk":{"lang":"en","description":"A place to talk about Big Brother and Celebrity Big Brother UK!\n\n","over18":false},"ImagesOfTexas":{"lang":"en","description":"Pictures and images of Texas","over18":false},"PAX":{"lang":"en","description":"","over18":false},"suits":{"lang":"en","description":"A subreddit all about USA Network's hit show *Suits*, which centers around lawyer Harvey Specter and his associate Mike Ross (who doesn't have a law degree, but does have a photographic memory), and t","over18":false},"6thForm":{"lang":"en","description":"A place for 6th formers to speak to others about work, A-levels, results, problems in education and general sixth form life, as well as university applications and UCAS.\n","over18":false},"counterstrike":{"lang":"en","description":"Discussion and content related to Valve's popular Counter-Strike games. /r/CounterStrike welcomes submissions related to Counter-Strike 1.6, Counter-Strike: Source, and Counter-Strike Global Offensive","over18":false},"MilitaryGfys":{"lang":"en","description":"*MilitaryGfys* is a place for sharing military moments from around the world and throughout history in the small, easy to share html5/WebM video format, also known as Gfys! ","over18":false},"Vivillon":{"lang":"en","description":"As a show of solidarity /r/Vivillon will be set to private. [More can be read here.](https://www.reddit.com/r/OutOfTheLoop/comments/3bxduw/why_was_riama_along_with_a_number_of_other_large/)","over18":false},"csshelp":{"lang":"en","description":"","over18":false},"avfc":{"lang":"en","description":"This is the subreddit dedicated to Aston Villa, an English football club based in Birmingham. They play at Villa Park, and their manager is Bruce!\n\nWhether you are a diehard fan, or someone new to foo","over18":false},"TheWeeknd":{"lang":"en","description":"Dedicated to sharing and discussing anything and everything related to The Weeknd.","over18":false},"rotmgtradingpost":{"lang":"en","description":"This subreddit is closed.","over18":false},"triangle":{"lang":"en","description":"A nice community for the Raleigh, Durham, Chapel Hill area. Welcome!","over18":false},"StudentNurse":{"lang":"en","description":"This is a community created by a guy in an AD RN Program, where fellow Nursing Students (RN, LPN, BSN, MSN, etc) can some and discuss relevant topics that are specific to students - NCLEX prep, study ","over18":false},"CookieClicker":{"lang":"en","description":"A subreddit for the popular cookie-clicking game.","over18":false},"linuxadmin":{"lang":"en","description":"Expanding Linux SysAdmin knowledge","over18":false},"samsung":{"lang":"en","description":"Everything Samsung","over18":false},"takecareofmyplant":{"lang":"en","description":"Giving Reddit the power to take care of my plant. ","over18":false},"ShotBow":{"lang":"en","description":"A subreddit dedicated to Shotbow - Minecraft's #1 source for the best multiplayer games!","over18":false},"OCD":{"lang":"en","description":"A subreddit dedicated to discussion, articles, and images regarding OCD.\n","over18":false},"Deathcore":{"lang":"en","description":"Deathcore is an extreme metal subgenre/subgenre of metalcore. It is an amalgamation of death metal with metalcore or hardcore punk, or both. It is defined by an \"excessive\" use of death metal riffs, b","over18":false},"fitbit":{"lang":"en","description":"A forum for discussion of all Fitbit-related products. Come ask questions, encourage/challenge others, and join a community making steps towards their goals. ","over18":false},"Boise":{"lang":"en","description":"","over18":false},"Scrolls":{"lang":"en","description":"Caller's Bane (formerly known as Scrolls) a game made by Mojang\n\nIt's time! We're releasing the game for free, for anyone to enjoy. I'm thrilled we're finally here! To those of you who've waited patie","over18":false},"PUBG":{"lang":"en","description":"PLAYERUNKNOWN'S BATTLEGROUNDS (PUBG) Game subreddit.  \n \n/r/PUBG is centered around the game  PLAYERUNKNOWN'S BATTLEGROUNDS (pubg for short) made by studio bluehole. \n\n\n","over18":false},"Transmogrification":{"lang":"en","description":"**The World of Warcraft Transmogrification subreddit!**\n\nWant to show off your new outfit that you've thrown together in World of Warcraft? Do it here!\n\nPlease read the sidebar to see our rules and gu","over18":false},"GoNets":{"lang":"en","description":"All things Brooklyn Nets basketball. #WeGoHard","over18":false},"DarkNetMarketsNoobs":{"lang":"en","description":"Your destination to understanding and using the programs, cryptocurrencies and technologies the DarknetMarkets operate on. We gather to learn and share our knowledge about the use and best practices.","over18":true},"avengedsevenfold":{"lang":"en","description":"Avenged Sevenfold is an American rock band formed in 1999 from Huntington Beach, California.","over18":false},"Banished":{"lang":"en","description":"A subreddit dedicated to discussing the city-building strategy game Banished.","over18":false},"TheXanaxCartel":{"lang":null,"description":"Subreddit no longer exists","over18":null},"crashbandicoot":{"lang":"en","description":"Welcome to all things Crash Bandicoot on Reddit! From the classic original games to the latest in the N. Sane Trilogy, come here to share your favorite moments, tips and tricks. Ooga-booga!","over18":false},"raisedbyborderlines":{"lang":"en","description":"Support group for people raised by a parent or parents with Borderline Personality Disorder.\n\nOnce you understand your parent is BPD, there is no going back.","over18":false},"postrock":{"lang":"en","description":"Post-rock: an umbrella term to describe the mostly instrumental music genre that uses rock instrumentation but disregards typical “rock” song structure.\n\n\nFor post-rock music discussion, discovery, ne","over18":false},"Malazan":{"lang":"en","description":"For discussion of all things Malazan.","over18":false},"Stance":{"lang":"en","description":"A subreddit dedicated to slammed cars and cars looking pretty. ","over18":false},"Horses":{"lang":"en","description":"A subreddit for sharing and discussing almost anything about horses.","over18":false},"StartledCats":{"lang":"en","description":"Funny pics, gifs and vids of startled cats.","over18":false},"sgsflair":{"lang":"en","description":"Database of the traders in /r/SteamGameSwap that is used to update their flair status","over18":false},"minnesotaunited":{"lang":"en","description":"The official subreddit for Minnesota United FC of Major League Soccer.","over18":false},"acecombat":{"lang":"en","description":"Welcome to the Ace Combat subreddit, a community for fans to discuss Ace Combat 7: Skies Unknown and past games in the franchise.\n\nAce Combat is an arcade flight video game developed by Bandai Namco u","over18":false},"MLPdrawingschool":{"lang":"en","description":"The My Little Pony drawing school. Come on in if you would like help drawing your ponies and pony related art. We offer critique, advice, guides, and general art discussions with livestreams and occas","over18":false},"assettocorsa":{"lang":"en","description":"","over18":false},"HelpMeFind":{"lang":"en","description":"Do you miss something that seems to have been wiped from existence, like a game or an old candy? Does it seem impossible for search engines to help even with the correct name? Describe it here as much","over18":false},"flicks":{"lang":"en","description":"The Gap between /r/Movies and /r/TrueFilm ","over18":false},"ProjectRunway":{"lang":"en","description":"A subreddit to discuss Project Runway!","over18":false},"computertechs":{"lang":"en","description":"","over18":false},"googlehome":{"lang":"en","description":"Everything Google Home: tips, bugs, new features, requests, etc.","over18":false},"TACSdiscussion":{"lang":"en","description":"/r/TACSdiscussion has moved to /r/CompoundMedia\n\nPeckahs.","over18":false},"opiaterollcall":{"lang":null,"description":"Subreddit no longer exists","over18":null},"RedditForGrownups":{"lang":"en","description":"This is a community for Redditors that are starting to get that \"get off my lawn\" feeling whenever they check their front page. So come in, have some fun, and enjoy the Reddit discussions that you rem","over18":false},"RoastMyCar":{"lang":"en","description":"Roast some rubber!","over18":false},"Anarchy101":{"lang":"en","description":"For questions about the theory of anarchism, anarchist movements, opinions on certain situations or current events, or even socialist or communist theory in general. No question is too basic (or advan","over18":false},"Spokane":{"lang":"en","description":"The official subreddit for Spokane County, Washington, and surrounding areas.","over18":false},"serialkillers":{"lang":"en","description":"Learning and reading about serial killers.","over18":false},"ukulele":{"lang":"en","description":"","over18":false},"koreanvariety":{"lang":"en","description":"A subreddit for fans of Korean variety shows on TV.","over18":false},"Shave_Bazaar":{"lang":"en","description":"","over18":false},"chemhelp":{"lang":"en","description":"Post your questions about chemistry, whether they're school related or just out of general interest. Please do not post entire problem sets or questions that you haven't attempted to answer yourself.","over18":false},"CozyPlaces":{"lang":"en","description":"Everywhere cozy","over18":false},"realasians":{"lang":"en","description":"","over18":false},"clothdiaps":{"lang":"en","description":"Welcome to clothdiaps! A subreddit for discussion and support for families who use cloth diapers.\n\nLooking to buy, sell or trade your cloth diapers? Visit our our sister subreddit /r/clothdiapsbst ","over18":false},"POTUSWatch":{"lang":"en","description":"r/POTUSWatch is a neutrally-moderated serious subreddit dedicated to following and documenting all actions and statements of the current President of the United States and his administration (the fede","over18":false},"SelfDrivingCars":{"lang":"en","description":"News and discussion about self-driving cars.","over18":false},"InsideGaming":{"lang":"en","description":"The home of all things Inside Gaming. You want that one-on-one personal touch?  As long as you're of age you can do that here.","over18":false},"progrockmusic":{"lang":"en","description":"","over18":false},"24hoursupport":{"lang":"en","description":"**24 Hour Support** is a community focused on helping solve technical issues **FAST**. So fast we even set up a chat room for instantaneous help!","over18":false},"teaching":{"lang":"en","description":"","over18":false},"strife":{"lang":"en","description":"Strife","over18":false},"DecidingToBeBetter":{"lang":"en","description":"A force for self-improvement, goodness, and togetherness that helps humanity eliminate evil.","over18":false},"ThingsCutInHalfPorn":{"lang":"en","description":"For your cut in half needs.","over18":false},"loltyler1":{"lang":"en","description":"Twitch: https://www.twitch.tv/loltyler1\n","over18":false},"CCJ2":{"lang":"en","description":"CHINACIRCLEJERK2","over18":false},"spotted":{"lang":"en","description":"People often see rare or interesting cars that brighten their otherwise dreary days. And what a better way to express that than to share a picture of it with complete strangers?","over18":false},"GNV":{"lang":"en","description":"The \"official\" reddit for Gainesville, FL.  ","over18":false},"actuary":{"lang":"en","description":"Subreddit for actuarial professionals, students and interested (innocent) bystanders.","over18":false},"grime":{"lang":"en","description":"The most active discussion forum on the internet for grime music.","over18":false},"cyanogenmod":{"lang":"en","description":"","over18":false},"ShadowBan":{"lang":"en","description":"Find out if you are shadowbanned and what to do about it.\n\nshadow ban admin mod hell moderator removed invisible banned help check","over18":false},"Dachshund":{"lang":"en","description":"","over18":false},"The_Crew":{"lang":"en","description":"A place for discussion relating to Ubisoft's The Crew and The Crew 2.\n\nThis sub was built by fans for fans. Developed by Ivory Tower, The Crew is a MMO RPG racing game and the first of it's kind. The ","over18":false},"TeenWolf":{"lang":"en","description":"MTV's 'Teen Wolf' follows Scott McCall, a true alpha werewolf, his best friend, Stiles Stilinksi, and their pack through the many obstacles of Beacon Hills. ","over18":false},"Tools":{"lang":"en","description":"We all use them. Every single day.\n\nShow us what you got.","over18":false},"homeowners":{"lang":"en","description":"","over18":false},"absolver":{"lang":"en","description":"Absolver is a third-person hand-to-hand focused adventure fighting game developed by Sloclap Studios and published by Devolver Digital.","over18":false},"Knoxville":{"lang":"en","description":"","over18":false},"Motocross":{"lang":"en","description":"","over18":false},"NFA":{"lang":"en","description":"A community of hobbyists interested in NFA items, topics, history, and news. We seek to expand general understanding of the laws collectively referred to as the National Firearms Act and their implica","over18":false},"TheWalkingDeadGame":{"lang":"en","description":"The Walking Dead is an episodic adventure game developed and published by Telltale Games. Play the role of Lee Everett, a convicted criminal who has been given a second chance at life in a world devas","over18":false},"mtgcube":{"lang":"en","description":"A place to discuss the the Magic: The Gathering variant we know and love called Cube.","over18":false},"shameless":{"lang":"en","description":"","over18":false},"ImaginaryMonsters":{"lang":"en","description":"Pictorial art of monsters from the past or present: angels, demons, strange WTF creatures, drooling brutes, innocent-looking oddities, mythical hybrids, an image from a bestiary, etc. Yes, you can sub","over18":false},"ps3bf3":{"lang":"en","description":"","over18":false},"SoundersFC":{"lang":"en","description":"The home of the 2016 MLS Cup winning Sounders FC! ","over18":false},"lotro":{"lang":"en","description":"Dedicated to The Lord of the Rings Online, the MMORPG based on Professor J.R.R. Tolkien's beloved fantasy series.","over18":false},"reallifedoodles":{"lang":"en","description":"Pictures and videos that have been doodled on!","over18":false},"selfimprovement":{"lang":"en","description":"“Make the most of yourself....for that is all there is of you.” \n― Ralph Waldo Emerson\n\nThis subreddit is for those who have questions about how to improve any aspects of their lives, from motivation ","over18":false},"Thetruthishere":{"lang":"en","description":"A database for personal encounters with the unknown. We archive non-fiction stories dealing with spirits, paranormal, strange happenings, and unexplained sightings. Think /r/nosleep without the fictio","over18":false},"youseeingthisshit":{"lang":"en","description":"","over18":false},"trucksim":{"lang":"en","description":"The definitive community for truck simulators and trucks, and SCS Software's games - Euro Truck Simulator 2, American Truck Simulator etc.","over18":false},"arcticmonkeys":{"lang":"en","description":"","over18":false},"mazda3":{"lang":"en","description":"All things Mazda and Mazda3 related\n\nZoom Zoom","over18":false},"peacecorps":{"lang":"en","description":"Your subreddit for all things Peace Corps. With updated information and valuable input from a diverse and active community of PCV redditors.","over18":false},"PokemonCreate":{"lang":"en","description":"We're a subreddit dedicated to generating Pokémon at the request of the community. The dedicated staff members work fervently to complete any request, given that the Pokémon is legal, and send the com","over18":false},"HipHopImages":{"lang":"en","description":"For when listening to rap music just isn't enough.","over18":false},"gis":{"lang":"en","description":"A community dedicated to everything GIS (Geographic Information Systems).","over18":false},"Graffiti":{"lang":"en","description":"","over18":false},"pugs":{"lang":"en","description":"This is all about cute puggy whuggies.","over18":false},"ShokugekiNoSoma":{"lang":"en","description":"The subreddit to discuss Shokugeki no Soma (aka Food Wars; 食戟のソーマ), a manga currently being serialized in Weekly Shōnen Jump.","over18":false},"careerguidance":{"lang":"en","description":"A place to discuss career options, to ask questions and give advice!","over18":false},"NoContract":{"lang":"en","description":"Reclaim your freedom -- and your wallet! Ditch your cellular contract today!","over18":false},"ibs":{"lang":"en","description":"A community for those with IBS to discuss openly about their condition","over18":false},"trendingsubreddits":{"lang":"en","description":"Subreddits of interest delivered daily.","over18":false},"earthbound":{"lang":"en","description":"The subreddit for all things MOTHER!","over18":false},"baldursgate":{"lang":"en","description":"","over18":false},"PersonOfInterest":{"lang":"en","description":"Subreddit for the CBS television series, Person of Interest. Starring Jim Caviezel & Michael Emerson.","over18":false},"Roleplaykik":{"lang":"en","description":"Any sort of roleplay - no matter the scenario, scene or world - are welcome here !!!**The sub has been set to 18+ check your filter settings**!!!","over18":true},"porninfifteenseconds":{"lang":"en","description":"Porn scenes given the tl;dr treatment.","over18":true},"predaddit":{"lang":"en","description":"","over18":false},"ChiefKeef":{"lang":"en","description":"A sub-reddit for all things Glory Boyz/Glo Gang related. ","over18":false},"ImagesOfCanada":{"lang":"en","description":"Pictures and images of Canada","over18":false},"Bushcraft":{"lang":"en","description":"Bushcraft and Wilderness Survival, Traditional Skills and Techniques.","over18":false},"TrumpCriticizesTrump":{"lang":"en","description":"Trump Criticizes Trump:  A Portrait of Presidential Hypocrisy.  For every Trump action there is a Trump tweet criticizing that action.","over18":false},"240sx":{"lang":"en","description":"A community of S-Chassis enthusiasts","over18":false},"CharlotteHornets":{"lang":"en","description":"Charlotte Hornets Subreddit: Enter The Swarm #BuzzCity","over18":false},"PrimeiraLiga":{"lang":null,"description":"Subreddit forbidden","over18":null},"AnimalsBeingDerps":{"lang":"en","description":"Pictures, gifs and videos of animals acting like complete idiots.","over18":false},"antiMLM":{"lang":"en","description":"Multi Level Marketing (MLM) schemes are a drain on our society. Its participants either build the pyramid taller, or get squashed by it.","over18":false},"DebateCommunism":{"lang":"en","description":"An active community for challenging, debating, and discussing communism and socialism with originality and flair. \n\nAll political beliefs are welcome! \n\nPost your debate challenge and see if any commu","over18":false},"GiIvaSunner":{"lang":"en","description":"The official subreddit for the highest quality video game rips around!","over18":false},"kodi":{"lang":"en","description":"**Kodi** is an award-winning *free and open source* cross-platform software media player and entertainment hub for HTPCs. \n\nIt uses a 10-foot user interface and is designed to be a media player for th","over18":false},"HighschoolDxD":{"lang":"en","description":"This is for the DxD Light Novel series not High School or your High School experience.","over18":false},"HaggardGarage":{"lang":"en","description":"The Unofficial Subreddit of Haggard Garage, LifeOD, RicerMiata, Tommyfyeah, and Haggard North.","over18":false},"GalaxyNexus":{"lang":"en","description":"","over18":false},"BillBurr":{"lang":"en","description":"The Bill Burr subreddit. For fans of his stand up, cameos, and the Monday Morning Podcast.","over18":false},"Coyotes":{"lang":"en","description":"","over18":false},"CSRRacing2":{"lang":"en","description":"For CSR2 and the CSR series of games. Please check the rules before posting.","over18":false},"nocontext":{"lang":"en","description":"This reddit was inspired by a post by The_Big_Salad - when I read \"mystery cloth on the guy's head turns out to be his underwear\" I knew it had to be done.\n","over18":false},"awwwtf":{"lang":"en","description":"A subreddit that makes you say, \"Aww! Ooh? What the fuck?!\" Then aww again.\n \n","over18":false},"howyoudoin":{"lang":"en","description":"A subreddit for fans of the popular hit TV sitcom, Friends.","over18":false},"Cinema4D":{"lang":"en","description":"The one and only Cinema 4D subreddit where you can learn about C4D or share your creations with us! ","over18":false},"GirlsFinishingTheJob":{"lang":"en","description":"GFTJ is a subreddit where the women take an active hand (or mouth or pair of tits or something even more exotic) in MAKING a man cum.  If you like watching girls do all the work of getting every last ","over18":true},"outrun":{"lang":"en","description":"Dedicated to the synthwave music scene, a revisionist 80s music style of synthesizers and pulsing beats, and the retrofuturist 80s aesthetic of fast cars, neon lights and chrome.","over18":false},"MMFB":{"lang":"en","description":"Has something terrible happened in your life? Are things just not going your way? Have you lost a loved one? Many people have some great stories to tell about some not-so-great occurrences in their li","over18":false},"auckland":{"lang":"en","description":"","over18":false},"amateur_boxing":{"lang":"en","description":"Boxing for boxers, not spectators.\n\n[Search or a Gym (US-Only)](http://www.teamusa.org/usa-boxing/membership/find-a-club)","over18":false},"NiceHash":{"lang":"en","description":"NiceHash offers you to buy or sell hashing power directly, **no contracts**, **no limitations**. **pay-as-you-go** if you're a buyer and **be-paid-as-you-go** if you're a seller. Why bother renting ri","over18":false},"ginger":{"lang":"en","description":"Natural redheads","over18":true},"kotor":{"lang":"en","description":"A subreddit for fans of BioWare's classic 2003 RPG *Star Wars: Knights of the Old Republic* and Obsidian Entertainment's 2004 sequel *Star Wars: Knights of the Old Republic II: The Sith Lords*.","over18":false},"whatsthisbird":{"lang":"en","description":"The place for your bird identification needs.","over18":false},"fullmoviesonanything":{"lang":null,"description":"Subreddit no longer exists","over18":null},"falloutsettlements":{"lang":"en","description":"**Welcome!**\n\nA subreddit dedicated to everything related to settlements in Fallout 4. Share your builds, ask your questions, and help the community!","over18":false},"ericprydz":{"lang":"en","description":"Eric Prydz (born July 19, 1976) is a Swedish DJ and producer who recently located to Los Angeles.  He is known under the aliases Pryda and Cirez D.  ","over18":false},"DeepFriedMemes":{"lang":"en","description":"Memes that imitate and exaggerate the degradation of an image.","over18":false},"LeagueConnect":{"lang":"en","description":"LeagueConnect is a gathering place for people who love League of Legends, a place where you can make friends, find people to play with, or talk about the game.","over18":false},"GuildWars":{"lang":"en","description":"A Guild Wars focused subreddit.","over18":false},"eatsandwiches":{"lang":"en","description":"","over18":false},"ImagesOfUSA":{"lang":"en","description":"Pictures and Images of the United States of America","over18":false},"SpaceBuckets":{"lang":"en","description":"This subreddit is for anyone that is interested in **Space Buckets**, a DIY indoor garden with stacked 5gal buckets. Everyone is welcome!\n\n","over18":false},"bioniclelego":{"lang":"en","description":"For fans of the Bionicle series produced by Lego.\n\n","over18":false},"MarkMyWords":{"lang":"en","description":"MarkMyWords","over18":false},"NYCFC":{"lang":"en","description":"A subreddit for fans of New York City Football Club.  Come hang out and discuss all things City.","over18":false},"ATT":{"lang":"en","description":"Welcome to the Reddit community for all things AT&T. Get help, share your AT&T success story, and get to know some of the people responsible for helping deliver service to all your devices!","over18":false},"discexchange":{"lang":"en","description":"","over18":false},"pkmntcgcollections":{"lang":"en","description":"Post your very own Pokemon Trading Card Game collections, rares/holos/shinies/ex's or anything else that you want to show off!","over18":false},"BitcoinMining":{"lang":"en","description":"The official bitcoin mining forum / subreddit / chat room / place to be!","over18":false},"Anticonsumption":{"lang":"en","description":"Consume Consciously","over18":false},"homeland":{"lang":"en","description":"Subreddit for the psychological and political thriller, *Homeland*, which airs on Showtime on Sundays 9 PM EST. Homeland stars Claire Danes as Carrie Mathison, a CIA operations officer. Homeland has r","over18":false},"KerbalAcademy":{"lang":"en","description":"Dedicated to the growth and advancement of amateur rocket scientists! ","over18":false},"aws":{"lang":"en","description":"News, articles and tools covering Amazon Web Services (AWS), including S3, EC2, SQS, RDS, DynamoDB, IAM, CloudFormation, Route 53, CloudFront, Lambda, VPC, Cloudwatch, Glacier and more.","over18":false},"TankPorn":{"lang":"en","description":"TankPorn is for all things Battle Tanks, Armored Fighting Vehicles, Armored Cars, Self-Propelled Guns and Support Vehicles affiliated. The past, the present, futuristic, historical, prototypes, all th","over18":false},"worstof":{"lang":"en","description":"It's not all roses and sunshine here on reddit. Sometimes shitty things are said and sometimes shitty people say them. When you see the bad side of reddit, post it here.","over18":false},"shittyadviceanimals":{"lang":"en","description":"A place for a celebration of the dankest memes ever known by any life form in the known universe.","over18":false},"transgendercirclejerk":{"lang":"en","description":"Parody subreddit of all transgender-related topics. If you take this seriously, then don't.","over18":false},"SonyXperia":{"lang":"en","description":"News and discussion for Sony Xperia devices","over18":false},"weather":{"lang":"en","description":"","over18":false},"AsianHotties":{"lang":"en","description":"Women from the Orient to the Indian sub-continent!","over18":true},"feminisms":{"lang":"en","description":"A safe(r) space for respectful, cooperative feminism-minded discussion, including its intersections. Content is actively curated by a pro-feminist moderation team.","over18":false},"Luthier":{"lang":"en","description":"","over18":false},"ucla":{"lang":"en","description":"A place for UCLA students, faculty, and fans! Go Bruins!","over18":false},"fandomnatural":{"lang":"en","description":"Embracing all Supernatural fans: their ships, interpretations, works, and thoughts.","over18":false},"EmmaWatson":{"lang":"en","description":"/r/EmmaWatson - For everything about the lovely Emma Watson.5","over18":false},"bassfishing":{"lang":"en","description":"A community for bass anglers from all around the globe to meet and exchange tricks, tips, techniques, and tackle!","over18":false},"yandere_simulator":{"lang":"en","description":"A subreddit for the game: Yandere Simulator developed by YandereDev.\n\nCome and join us!","over18":false},"steam_giveaway":{"lang":"en","description":"A place to share and giveaway game codes on Steam.\n***\nFeeling generous? Have an unclaimed Steam key? Want to reap that glorious karma from gluttonous gamers? /r/steam_giveaway is the place for you! H","over18":false},"electrohouse":{"lang":"en","description":"","over18":false},"Techno":{"lang":"en","description":"","over18":false},"guitarlessons":{"lang":"en","description":"A subreddit dedicated to learning guitar. Post lessons, ask questions, and get feedback on your playing. The community is open to all people of all styles!","over18":false},"venturebros":{"lang":"en","description":"A subreddit dedicated to the best television show of all time!","over18":false},"liberalgunowners":{"lang":"en","description":"Gun-ownership through a liberal lens.  \n\nThis is a place for liberal gun-owners (this means leftist to you \"classical liberals\") who want to discuss gun ownership absent the \"noise\" of most conservati","over18":false},"classicwow":{"lang":"en","description":"A community for Classic World of Warcraft fans. ","over18":false},"LondonSocialClub":{"lang":"en","description":"Drink, Eat, Dance, Connect, Be Merry! Or Don't, Just Come And Stand Around, That's Cool Too!\n\nOur regular meetups  (look for the post to appear that week or that day):\n\nMonday, Hammersmith Hang Out. T","over18":false},"realtech":{"lang":"en","description":"Aladdin (/u/RealtechPostBot) is a simple bot I made to combat how /r/technology has became a highly political, repetitive, and somewhat circlejerky subreddit.\n\nAladdin scans the top 100 posts from /r/","over18":false},"BTFC":{"lang":"en","description":"A reddit-wide competition; 12 weeks to transform your body and win some awesome prizes. \n\n","over18":false},"RandomActsOfTf2":{"lang":"en","description":"A Subreddit for spreading the joy of gifting in Team Fortress 2!\nLow Tier Trader? Medium/High Tier Trader? Not even a trader?\nDoesn't matter! We personally welcome you to have a fun time and talk abou","over18":false},"audiobooks":{"lang":"en","description":"The audiobooks subreddit is a community of audiobibliophiles sharing and looking for their next great listen.\n\n","over18":false},"HowToHack":{"lang":"en","description":"Welcome to the guide to help you along the path from a neophyte to an elite... From here you will learn the resources to expand your knowledge and from there you can access our stronger resources for ","over18":false},"HelloInternet":{"lang":"en","description":"","over18":false},"GoneWildSmiles":{"lang":"en","description":"A place for adult Redditors to show off their naked smiles!","over18":true},"Lovecraft":{"lang":"en","description":"Dedicated to the works of H.P. Lovecraft, this is your stop for all of his outstanding works and weird fiction in general!\n\nLighter fare, memes, silly jokes, etc. are better suited to /r/Cthulhu. Thos","over18":false},"ebola":{"lang":"en","description":"News, Information and Discussions about the Ebola virus outbreaks.","over18":false},"socialmedia":{"lang":"en","description":"For discussion about social media, news, and best practices.","over18":false},"ARMS":{"lang":"en","description":"Welcome to /r/ARMS! This is THE place for anything and everything about the fighting game for Nintendo Switch, whether it be discussion about technique, strategy, or just a video of something interest","over18":false},"CampingGear":{"lang":"en","description":"A helpful community that aims to help users make informed decisions about camping gear including sleeping systems, clothing, cooksets, and packs.... and to show off our stuff\n\n---\n","over18":false},"CBD":{"lang":"en","description":"It's time that this subject was given more internet exposure. We are here to discuss topics related to medical marijuana and our experiences using CBD. Please do not assume that anyone here is a medic","over18":false},"techtheatre":{"lang":"en","description":"Welcome to /r/techtheatre! The reddit community for all production designers and technicians!","over18":false},"Fighters":{"lang":"en","description":"The subreddit to discuss about all the things related to the FGC, or Fighting Game Community.","over18":false},"appletv":{"lang":"en","description":"A community for discussion about Apple TV news, apps and tech support. ","over18":false},"StudentLoans":{"lang":"en","description":"Advice, articles, and general discussion pertaining to student loans.","over18":false},"aliens":{"lang":"en","description":"Subreddit for the discussion, analysis, and speculation about extraterrestrial beings, more commonly called Aliens.","over18":false},"Truckers":{"lang":"en","description":"The best trucker subreddit out there.","over18":false},"Sneks":{"lang":"en","description":"Where sneks come to hissss","over18":false},"FilthyFrank":{"lang":"en","description":"A subreddit for fans of Filthy Frank.","over18":false},"deadpool":{"lang":"en","description":"A subreddit for all things Deadpool! Talk about the Marvel antihero and his exploits, whether it be comic, or upcoming movie, or more!\n","over18":false},"CryptoMarkets":{"lang":"en","description":"FOREX community for cryptocurrencies. \n\nTags: mt gox bitcoin, long term potential, open source exchange, low inflation rate, demand and price, technical analysis, fundamentals, Bitcoin, Ethereum, Lite","over18":false},"caseyneistat":{"lang":"en","description":"****A place to come to discuss his videos, talk about his methods or post anything related to Casey.","over18":false},"TheFence":{"lang":"en","description":"Reddit's destination for all things Coheed and Cambria.","over18":false},"trippinthroughtime":{"lang":"en","description":"In historic art pieces depicting multiple humans, there is a law that at least one of those humans will look like they have no clue how or why they got there. It's like Where's Waldo, except instead o","over18":false},"miniSNES":{"lang":"en","description":"A place to talk about the SNES Classic Edition, its games, and hacks.","over18":false},"GCSE":{"lang":"en","description":"r/GCSE is the place for tips, advice, resources and memes for your GCSE exams.","over18":false},"Hardcore":{"lang":"en","description":"A place for hardcore punk music and fans.","over18":false},"alcohol":{"lang":"en","description":"A place for the HEALTHY and SAFE enjoyment of the Sauce of Life.","over18":false},"StockMarket":{"lang":"en","description":"Stock market news, Trading, investing, long term, short term traders,  daytrading, technical analysis, fundamental analysis and more. We cover it all at r/stockmarket.","over18":false},"nanowrimo":{"lang":"en","description":"Reddit's unofficial subreddit for those participating in Camp NaNoWriMo or November's novel writing extravaganza!","over18":false},"talesfromcallcenters":{"lang":"en","description":"**Welcome to Tales From Call Centers (TFCC), a place where we share tales from the trenches of the call center world!**\n\nThis includes things like (but not limited to);\n\nRidiculous caller demands\n\nMor","over18":false},"Animewallpaper":{"lang":"en","description":"Subreddit for anime and anime-style wallpapers.","over18":false},"retrobattlestations":{"lang":"en","description":"Show off your old-school computer rig! Dig out your retro computers and set them up, or dig out your vintage photos from when your computer was new!","over18":false},"lexington":{"lang":"en","description":"News and current events in or around Lexington, Kentucky.","over18":false},"sailormoon":{"lang":"en","description":"A subreddit for fans of the Sailor Moon franchise. Please remember to read in the sidebar, and please read The Sailor Moon FAQ There, too before asking common questions such as 'Where can I watch Sail","over18":false},"PS4Pro":{"lang":"en","description":"A place to discuss all things PlayStation 4 Pro (formerly PlayStation Neo).","over18":false},"pyrocynical":{"lang":"en","description":"A subreddit for fans of the YouTuber Pyrocynical","over18":false},"StarWarsEU":{"lang":"en","description":"Welcome to the Star Wars Expanded Universe subreddit! We are primarily a source of discussion and news for anything involving the Star Wars Expanded Universe. \n\nIf you're new, and want to learn more a","over18":false},"Ohio":{"lang":"en","description":"A sub reddit for the best state","over18":false},"farcry":{"lang":"en","description":"Covering all things Far Cry. Discuss the Far Cry series, share your custom maps, or party up with other players!","over18":false},"amibeingdetained":{"lang":"en","description":"/r/amibeingdetained is a subreddit devoted to showcasing the idiocy and ignorant behaviour of the self-proclaimed [freemen on the land](https://en.wikipedia.org/wiki/Freemen_on_the_land) and [sovereig","over18":false},"cade":{"lang":"en","description":"**WELCOME to /r/cade**\n\n* Rebuild, restore or buy that dedicated arcade cabinet that you sank thousands of quarters into.  \n* Make that MAME cabinet!  \n* BUY - SELL - TRADE with the hivemind.  \n* Show","over18":false},"Sidehugs":{"lang":"en","description":"Sidehugging of a Christian nature","over18":false},"spain":{"lang":"en","description":"A place for both residents and visitors of Spain to share ideas, opinions and links to content on the Iberian country.\n\nEspaña!","over18":false},"Blowjobs":{"lang":"en","description":"Because some people like to get head.\nA community for people who want to share videos and pictures of women performing the act of fellatio.","over18":true},"coaxedintoasnafu":{"lang":"en","description":"dank memes","over18":false},"reckful":{"lang":"en","description":"","over18":false},"ClashOfClansRecruit":{"lang":"en","description":"Want to advertise your Clash Of Clans clan? Post it here!","over18":false},"StarlightStage":{"lang":"en","description":"Subreddit for the iDOLMASTER Cinderella Girls: Starlight Stage game!","over18":false},"cinematography":{"lang":"en","description":"/r/cinematography is a forum dedicated to becoming an active resource for cinematographers and filmmakers of all skill levels. ","over18":false},"vintageaudio":{"lang":"en","description":"","over18":false},"esports":{"lang":"en","description":"Welcome to /r/esports!","over18":false},"cynicalbritofficial":{"lang":"en","description":"The Official subreddit for discussion about the games critic, media personality, and Cynical Brit that is John \"TotalBiscuit\" Bain.","over18":false},"PokemonForAll":{"lang":"en","description":"","over18":false},"behindthegifs":{"lang":"en","description":"Backstories for gifs provided in comic or image form. Is funny.","over18":false},"BlackMetal":{"lang":"en","description":"","over18":false},"askMRP":{"lang":"en","description":"This the sub where you can ask basic questions, have a victim puke, find a NMMNG safe person, or otherwise ask questions too basic for MRP. The kinder antechamber to the locker room that is MRP.","over18":false},"TributeMe":{"lang":"en","description":"_Sometimes geography, timing, circumstance, or choice might leave you in the mood, and without a partner. But there's no need to play alone; through the magic of modern technology, there's always some","over18":true},"WEPES":{"lang":"en","description":"The front page for Pro Evolution Soccer (PES) & Winning Eleven. #PES2019 #ThePowerOfFootball","over18":false},"seedboxes":{"lang":"en","description":"A place to discuss seedboxes and everything related to them.","over18":false},"ouya":{"lang":"en","description":"OUYA is a new game console for the TV, powered by Android. Helping developers help gamers!","over18":false},"4Runner":{"lang":"en","description":"","over18":false},"GWNerdy":{"lang":"en","description":"Show us your nerd-cred guys and gals!","over18":true},"Comcast":{"lang":"en","description":"**A subreddit primarily dedicated to venting about your shitty experiences with Comcast.** \n\nYou can post for: \n\n* technical support\n* advice\n* or just to vent about how shitty and monopolistic Comcas","over18":false},"Ska":{"lang":"en","description":"This is the place to share, discuss, and skank to anything and everything about ska music.","over18":false},"windows8":{"lang":"en","description":"A place for anything relevant to Microsoft's operating system Windows 8.\n","over18":false},"saudiarabia":{"lang":"en","description":"","over18":false},"Ford":{"lang":"en","description":"Ford stuff goes here.","over18":false},"paris":{"lang":"fr","description":"La Ville-Lumière. Posts en Anglais et en Français.","over18":false},"csgolounge":{"lang":"en","description":"**Welcome to the Official CS:GOLounge sub-reddit.","over18":false},"latin":{"lang":"en","description":"lingua latīna","over18":false},"ArtefactPorn":{"lang":"pl","description":"/r/ArtefactPorn is a community dedicated to posting the very best objects, from the very large to the very small, made or shaped by the mankind throughout history. These artefacts range from tools and","over18":false},"robotwars":{"lang":"en","description":"This subreddit is dedicated to the discussion of Robot Wars and British combat robots, past or present! Please enjoy your stay and be nice to everyone!","over18":false},"DnDGreentext":{"lang":"en","description":"For stories of D&D and other roleplaying games, especially in 4chan greentext format.","over18":false},"canes":{"lang":"en","description":"","over18":false},"SaintsFC":{"lang":"en","description":"A subreddit for Southampton FC.","over18":false},"tdi":{"lang":"en","description":"","over18":false},"ColorizedHistory":{"lang":"en","description":"/r/ColorizedHistory is dedicated to high quality colorizations of historical black and white images, and discussions of a historical nature. We're currently not seeking new contributors, but if you ha","over18":false},"auslaw":{"lang":"en","description":"A subreddit for Australians (or anyone interested in Australian law) to discuss matters relating to Australian law.","over18":false},"gtavcustoms":{"lang":"en","description":"This subreddit is for discussing and sharing cars in GTA V and GTAO","over18":false},"no_sob_story":{"lang":"en","description":"Cross posts pics that, without sobby/sappy/joke titles, wouldn't be upvote worthy. Use the same direct link as the original post so that it shows up in other discussions.","over18":false},"cogsci":{"lang":"en","description":"The interdisciplinary study of mind and intelligence, embracing philosophy, psychology, artificial intelligence, neuroscience, linguistics, and anthropology.","over18":false},"Kayaking":{"lang":"en","description":"All things paddling related!","over18":false},"DumpsterDiving":{"lang":"en","description":"Advice, information, and first-hand accounts about finding cool stuff in, or making cool stuff out of, trash.","over18":false},"postmates":{"lang":"en","description":"News and discussion about the San Francisco based On-Demand Delivery platform serving the United States. ","over18":false},"cs50":{"lang":"en","description":"Demanding, but definitely doable. Social, but educational. A focused topic, but broadly applicable skills. CS50 is the quintessential Harvard (and Yale!) course.","over18":false},"asianbeautyexchange":{"lang":"en","description":"For those who want to swap, sell, or buy slightly used Asian skincare and cosmetics! ","over18":false},"antinatalism":{"lang":"en","description":"A philosophical position that assigns a negative value to birth.","over18":false},"TheOrville":{"lang":"en","description":"FOX's 'The Orville' created by and starring Seth MacFarlane","over18":false},"PCOS":{"lang":"en","description":"A Place to discuss Polycystic Ovarian Syndrome and all that comes along with it. ","over18":false},"FocusST":{"lang":"en","description":"A reddit for the new Focus ST, spiritual successor to the Focus SVT.","over18":false},"Heavymind":{"lang":"en","description":"\"Heavy\" art: imagery, film, music, poetry, whatever.","over18":false},"Fibromyalgia":{"lang":"en","description":"An optimistic but realistic support group.","over18":false},"TheAdventureZone":{"lang":"en","description":"This is a community dedicated to The Adventure Zone, an RPG audio fiction podcast.","over18":false},"TheRealmOfMianite":{"lang":"en","description":"Welcome to 'The Realm Of Mianite'.\n\nThe Realm Of Mianite is a new survival server created by TheSyndicateProject on the 29th of May 2014. This subreddit is about discussion of this series.","over18":false},"Nisekoi":{"lang":"en","description":"**RES UNFRIENDLY**\n\nA subreddit all about the Nisekoi manga and anime.","over18":false},"dogecoinbeg":{"lang":"en","description":"stolen shibas? lost wallet? hacked pool? hardware has broken? cheer yourself up with others' kindness","over18":false},"Hotchickswithtattoos":{"lang":"en","description":"Hot Chicks With Tattoos","over18":true},"Testosterone":{"lang":"en","description":"Testosterone: The male sex hormone. This subreddit is for questions and discussion related to testosterone replacement therapy and testosterone levels. It also focuses on lifestyle activities like exe","over18":false},"KarmaConspiracy":{"lang":"en","description":"A subreddit to entertain the idea that ALL successful posts on Reddit have some karma-grubbing conspiracy behind them.\n\nShare your revelations, however outlandish they may seem, and help shed some lig","over18":false},"Barcelona":{"lang":"en","description":"Everything you need to know about visiting or living in Barcelona","over18":false},"GalaxyNote7":{"lang":"en","description":"For everything that is Samsung Galaxy Note 7.","over18":false},"ASU":{"lang":"en","description":"Subreddit for Arizona State University: Home of the Sun Devils! This is a discussion page for all things ASU, covering everything from class questions to innovation memes.\n\nGo Devils!","over18":false},"AtlantaUnited":{"lang":"en","description":"All Things Atlanta United!","over18":false},"chastity":{"lang":"en","description":"A subreddit dedicated to everything chastity!","over18":true},"sciencefiction":{"lang":"en","description":"This reddit is for fans and creators of Science Fiction and related media in any form. SF topics should involve plausible ideas reached through the rational application of science.  General speculativ","over18":false},"realdubstep":{"lang":"en","description":"","over18":false},"Stoicism":{"lang":"en","description":"We are a community committed to learning about and applying Stoic principles and techniques.","over18":false},"IGSRep":{"lang":"en","description":"Users who trade on /r/indiegameswap will post their successful trades here. Flair on indiegameswap will be determined by the amount of completed trades and time on the sub.","over18":false},"glitch_art":{"lang":"en","description":"","over18":false},"nflstreams":{"lang":"en","description":"Share your NFL Streams here!","over18":false},"LeagueOfMemes":{"lang":"en","description":"Sub for all of the freshest memes about League of Legends. (or just links from /r/funny with a new title)","over18":false},"chubby":{"lang":"en","description":"Images and discussions for all your chubby chaser interests. ","over18":true},"MultipleSclerosis":{"lang":"en","description":"Focusing on issues facing people with MS and their family and friends. Conversations about support, research, drug therapies, nutrition, exercise, and more. ","over18":false},"Denton":{"lang":"en","description":"The official subreddit for the City of Denton, TX.","over18":false},"combinedgifs":{"lang":"en","description":"A subreddit for gifs put together in a relevant manner.","over18":false},"HadToHurt":{"lang":"en","description":"Any video, gif or picture of something that looks like it had to hurt.","over18":false},"misc":{"lang":"en","description":"The best of reddit, and a place for everything else.","over18":false},"ObscureMedia":{"lang":"en","description":"A relaxed place to share and discuss lesser known media: silent films, vintage exploitation flicks, finely aged TV, PSAs and other oddities.","over18":false},"subredditoftheday":{"lang":"en","description":"Subreddit of the Day\n... is a celebration of the interesting communities on reddit.com. Once a day we shine a spotlight on the small, the big, the new and the old. Our mission is to spotlight unique r","over18":false},"ScottishPeopleTwitter":{"lang":"en","description":"absolute top cunts n top patter","over18":false},"pornID":{"lang":"en","description":"","over18":true},"BeforeNAfterAdoption":{"lang":"en","description":"Welcome to r/BeforeNAfterAdoption! This is a place to share the amazing difference a loving family can make on an abandoned or mistreated animal. All pets welcome!","over18":false},"hungary":{"lang":"hu","description":"","over18":false},"everquest":{"lang":"en","description":"Talk about Everquest","over18":false},"LabiaGW":{"lang":"en","description":"A gonewild sub dedicated to women with outies and the guy's that love a woman with lips.","over18":true},"BritishSuccess":{"lang":"en","description":"The opposite of /r/britishproblems","over18":false},"Disney_Infinity":{"lang":"en","description":"A community for sharing everything and anything about Disney Infinity. ","over18":false},"usedpanties":{"lang":"en","description":"Restricted to adults over 18 only! THE place where the women of Reddit offer their usedpanties to fans and lovers of used panties. Celebrating 4 years of serving Reddit's adult fetish community.","over18":true},"budgetfood":{"lang":"en","description":"Food on a Budget","over18":false},"htpc":{"lang":"en","description":"Home Theater PC - Drive your TV and Media experience with a Media PC","over18":false},"selfharmpics":{"lang":null,"description":"Subreddit no longer exists","over18":null},"porterrobinson":{"lang":"en","description":"","over18":false},"nattyorjuice":{"lang":"en","description":"A place away from /r/bodybuilding & /r/steroids to discuss whether the people you post are on some sort of steroid or not. \n\nWhy not make a throwaway, upload a pic of yourself and see if people think ","over18":false},"arizona":{"lang":"en","description":"News, information, and engagement across the State of Arizona.","over18":false},"batonrouge":{"lang":"en","description":"The #1 subreddit for all things relating to Baton Rouge, Louisiana!","over18":false},"Indiana":{"lang":"en","description":"Reddit for the Hoosier State - The crossroads of America. Join us for discussions of everything related to the state of Indiana. ","over18":false},"WildernessBackpacking":{"lang":"en","description":"A subreddit dedicated to backpacking in the wild places on earth - where people are few, cell signal is nil, and Mother Nature still reigns. \nBackpacking defined as: Multi-day trips into the wild, unp","over18":false},"stobuilds":{"lang":"en","description":"A subreddit to discuss builds and mechanics for Star Trek Online ground and space content.  ","over18":false},"smalldickproblems":{"lang":"en","description":"This is a community dedicated to those of us who have a small penis. ","over18":false},"node":{"lang":"en","description":"","over18":false},"drones":{"lang":"en","description":"/r/drones: for news, information and discussion of drones/UAVs and quadcopters. Includes multicopters, rotorcraft, copters, gliders, multirotor aircraft and any form of unpersoned remote-control or ro","over18":false},"Coldplay":{"lang":"en","description":"","over18":false},"hamiltonmusical":{"lang":"en","description":"News and discussion about *Hamilton* by Lin-Manuel Miranda","over18":false},"NotMyJob":{"lang":"en","description":"Shoddy jobs gone wrong, gone sexual, IN THE HOOD.","over18":false},"NoFapChristians":{"lang":"en","description":"NoFapChristians is a safe place for Christian fapstronauts to discuss the process of abstaining from pornography and masturbation. We are an official supplement and sister community to /r/NoFap. This ","over18":false},"vfx":{"lang":"en","description":"VFX for industry pros, students, and hobbyists! Video clips, articles, news, and tutorials for fans and people in the visual effects industry.","over18":false},"AskALiberal":{"lang":"en","description":"For any question that's burning to be asked. To foster communication between political foes. ","over18":false},"graffhelp":{"lang":"en","description":"","over18":false},"AsianParentStories":{"lang":"en","description":"A subreddit for stories involving Asian parents and the crazy, funny, frustrating, stupid or otherwise interesting encounters you've had with them. \n","over18":false},"dxm":{"lang":"en","description":"For all those who are interested in Dextromethorphan, a common cough suppressant, and recreational drug.","over18":false},"TameImpala":{"lang":"en","description":"All things relating to psychedelic pop/rock artist Tame Impala.","over18":false},"CFA":{"lang":"en","description":"A place for discussion and study tips for the Chartered Financial Analyst (CFA) program. ","over18":false},"askdrugs":{"lang":"en","description":"Ask questions about drugs that you already typed into google","over18":false},"bertstrips":{"lang":"en","description":"For posts such as [This](http://i.imgur.com/pLoumt4.gif), [This](http://i.imgur.com/SXtt8yJ.jpg), and [This](http://i.imgur.com/ok6gSmk.jpg).","over18":false},"Infographics":{"lang":"en","description":"","over18":false},"COents":{"lang":"en","description":"A community for medical patients and recreational fans of cannabis in the state of Colorado.  Topics include dispensary deals, preferred shops and strains, cannabis news and local events.","over18":false},"Roku":{"lang":"en","description":"","over18":false},"Lyft":{"lang":"en","description":"This is a community for drivers, passengers, and anyone who is interested in the ride-sharing app called Lyft.  Share your experiences, ask questions, announce gatherings and events... Welcome!","over18":false},"TittyDrop":{"lang":"en","description":"Welcome to the internet's epicenter of titty dropping!\n\nWhat is a titty drop you ask? It's when a beauty's tits are revealed by dropping out of their bra, shirt, whatever and bounce, sway and jiggle i","over18":true},"ConfusedBoners":{"lang":"en","description":"","over18":true},"UniversityOfHouston":{"lang":"en","description":"University of Houston\n\nGO COOGS!","over18":false},"survivinginfidelity":{"lang":"en","description":"Welcome to Surviving Infidelity. \n\nIf you're here, it's because you are surviving, or have survived, infidelity in a relationship that you thought was life-long. This is a support sub, a safe place to","over18":false},"LowTierTradingRL":{"lang":"en","description":"This sub is dedicated for less experienced traders who don't have an expensive inventory and want to have fun trading!","over18":false},"laptops":{"lang":"en","description":"The place to discuss anything laptop related.","over18":false},"nfsnolimits":{"lang":"en","description":"Discuss the mobile racing game \"Need for Speed: No Limits\". Available for iOS and Android. NFS No Limits is a mobile racing game with awesome graphics and customizable cars.","over18":false},"astrology":{"lang":"en","description":"A collection of links to articles on astrology, as well as discussions about astrological topics. ","over18":false},"BritishTV":{"lang":"en","description":"News, articles and discussions regarding British TV shows, film and stand-up.","over18":false},"Prematurecelebration":{"lang":"en","description":"Welcome to premature celebration! Where cocky people show us that pride cometh before the fall. ","over18":false},"TuberSim":{"lang":"en","description":"","over18":false},"albania":{"lang":"en","description":"Ask, find, and simply explore things about Albania on this subreddit!","over18":false},"pcgamingtechsupport":{"lang":"en","description":"PC Gaming sometimes has problems. We're here to help you fix those problems. Good luck, please read the sidebar :)","over18":false},"IAmAFiction":{"lang":"en","description":"AMAs for original fictional characters (for creative writing, roleplay, etc.)","over18":false},"Scrubs":{"lang":"en","description":"A community setup to discuss Scrubs. The long running Medical Dramedy/Sitcom that ran from 2001-2010 and starred Zach Braff, Sarah Chalke, Judy Reyes, Donald Faison, John C. McGinley and Ken Jenkins.","over18":false},"nerdfighters":{"lang":"en","description":"A reddit community for Nerdfighteria. DFTBA!","over18":false},"DCEUleaks":{"lang":"en","description":"A place for all leaked content concerning the DC Extended Universe and Vertigo movies.\n\nNot a place for rumours, news or anything officially released by Warner Bros or its affiliates.","over18":false},"Tokyo":{"lang":"en","description":"For all things in and around Tokyo for residents.","over18":false},"nuzlocke":{"lang":"en","description":"The Nuzlocke Challenge is a set of rules intended to create a higher level of difficulty while playing the Pokémon games. \n\nPost your personal stories, your comics, your favourite Nuzlocke links and p","over18":false},"ScottishFootball":{"lang":"en","description":"For talk regarding Scottish football. Premier league and lower levels. Gossip, rumours, news and scores. ","over18":false},"UniversityofReddit":{"lang":null,"description":"Subreddit forbidden","over18":null},"starveio":{"lang":"en","description":"Official subreddit to [Starve.io](http://starve.io), the survival game.","over18":false},"lawofattraction":{"lang":"en","description":"A place where believers in The Law of Attraction can get together and discuss their hopes, beliefs, fears, triumphs, and anything in between.","over18":false},"Devoted":{"lang":"en","description":"Devoted is a hardcore Minecraft server. It is not like your average factions server and revolves around custom built maps, player conflict, and attempts at producing a viable society. \n\nWe are similar","over18":false},"Epilepsy":{"lang":"en","description":"The mission of r/epilepsy is to provide a community forum for people who are affected by epilepsy. We exist to share ideas about the direction of epilepsy research, available treatment options for all","over18":false},"Scams":{"lang":"en","description":"For all your scam identification needs.\n\nOnline, offline, email, or postal. If you know of or encounter a scam, this is the place to let people know about it. \n\n**Make sure you check out the [other fr","over18":false},"FantasyMLS":{"lang":"en","description":"A place were people can discuss Fantasy MLS Teams, Trades, News, or anything else that might be helpful for fantasy managers. ","over18":false},"metanarchism":{"lang":null,"description":"Subreddit forbidden","over18":null},"singularity":{"lang":"en","description":"Everything pertaining to the technological singularity and related topics, e.g. AI, human enhancement, etc.","over18":false},"Makeup":{"lang":"en","description":"Makeup tips and advice from other people who have no agenda. Skip the misleading ads, and enjoy some real information. Bloggers and Youtubers are welcome but please read our rules before you post.","over18":false},"robotics":{"lang":"en","description":"Learning robotics, teaching each other robotics, robot news, DIY robot progress pics and videos.","over18":false},"legotrade":{"lang":"en","description":"A community for trading LEGO.","over18":false},"marijuanaenthusiasts":{"lang":"en","description":"Welcome to /r/marijuanaenthusiasts.\n\nThis is the go-to subreddit for everything dendrologic! That's right, this subreddit is about real trees!\n\nPlease make sure to read the rules before posting.","over18":false},"lgg2":{"lang":"en","description":"LG G2 ","over18":false},"Scholar":{"lang":"en","description":"This subreddit is for requesting and sharing specific articles available in various databases.","over18":false},"ghostbusters":{"lang":"en","description":"Ghostbusters: Answer The Call, Ghostbusters, Ghostbusters 2, The Real Ghostbusters, Extreme Ghostbusters, Ghostbusters Comics, Ghostbusters Video Games and more. Who ya gonna call?\n\n","over18":false},"baconreader":{"lang":"en","description":"BaconReader is a leading client for reddit, serving up reddit content in a stylish package with powerful features.\n\n\n“This is the absolute best looking Reddit app around.” –Android Police\n","over18":false},"yokaiwatch":{"lang":"en","description":"A subreddit for discussing the Yo-kai Watch franchise.","over18":false},"beadsprites":{"lang":"en","description":"A subreddit for \"beadsprites\", sometimes known as \"perlers\" -- pixel art made from various brands of fuse beads.","over18":false},"StopGaming":{"lang":"en","description":"Whatever your reasons for wanting to quit gaming of any sort, come on in.\n\nMostly about video games, but we're not judgmental.","over18":false},"dungeondefenders":{"lang":"en","description":"The Official Dungeon Defenders subreddit.\nDungeon Defenders II is a cooperative Action Tower Defense game, packed with role-playing elements like loot, leveling, and pets.","over18":false},"FortCollins":{"lang":"en","description":"Fort Collins Colorado","over18":false},"Diablo3Crusaders":{"lang":"en","description":"This subreddit is focused on the Crusader class in the expansion Reaper of Souls for the game Diablo 3.","over18":false},"AMD_Stock":{"lang":"en","description":"Investor strategies and discussion relating to AMD","over18":false},"guitars":{"lang":"en","description":"This is a place where fellow guitarists are encouraged to share their gear, playing, and opinions in a casual setting, as well as partake in discussion to cultivate further interest in the passion we ","over18":false},"TotallyStraight":{"lang":"en","description":"A subreddit for straight guys who love gay porn. ","over18":true},"MLBStreams":{"lang":"en","description":"Watch your favorite MLB games online with community provided streams.","over18":false},"SteamController":{"lang":"en","description":"The place for all PC controller and Steam Link users. Share innovative configs and tricks, ask for tech support, and read news about everything controller and couch gaming in the Steam ecosystem.","over18":false},"malegrooming":{"lang":"en","description":"This is a general men's grooming tips/advice and comments sub.  ","over18":false},"SJEarthquakes":{"lang":"en","description":"Your Reddit home for the San Jose Earthquakes soccer team. Since 1974 the Quakes have been playing football and in 1996 they debuted in Major League Soccer. With two Championships and two Supporter's ","over18":false},"Sikh":{"lang":"en","description":"Welcome to r/Sikh, the web's fastest growing Sikh forum. Everything related to Sikhi is welcome!","over18":false},"Iowa":{"lang":"en","description":"The subreddit for the State of Iowa -- for news and info on what's happening all across the state.","over18":false},"SubredditSimMeta":{"lang":"en","description":"","over18":false},"nomanshigh":{"lang":"en","description":"No Man's Sky, but high.","over18":false},"bristol":{"lang":"en","description":"Subreddit for Bristol and Bristol related activities. Local events, meet-ups etc.","over18":false},"SocialJusticeInAction":{"lang":"en","description":"This subreddit's mission is to discuss, engage with, and thwart hateful rhetoric from far left \"SJW\"s.","over18":false},"MH370":{"lang":"en","description":"Malaysia Airlines Flight MH370\n\n","over18":false},"trapproduction":{"lang":"en","description":"The original subreddit for Trap Production discussion.","over18":false},"grilledcheese":{"lang":"en","description":"Grilled cheese sandwiches. Pictures and discussion of Cheesy Grilledness.","over18":false},"dirtysmall":{"lang":"en","description":"The place for petite girls getting fucked\n\nThis subreddit is for petite girls in hardcore situations, for softcore content please go to /r/tinytits","over18":true},"Legodimensions":{"lang":"en","description":"A place to discuss, collect, share and help all the awesome Lego Dimension fans! ","over18":false},"ifiwonthelottery":{"lang":"en","description":"What would you do if you won the lottery? What would you buy? Where would you go?","over18":false},"redorchestra":{"lang":"en","description":"Fan run community for the entire Red Orchestra and Rising Storm games.","over18":false},"webhosting":{"lang":"en","description":"This is a place to discuss everything related to Webhosting. From shared hosting to dedicated servers, and everything in between. Post reviews of your current and past hosts, pose questions to the com","over18":false},"UnisonLeague":{"lang":"en","description":"A subreddit dedicated to Ateam's mobile game, Unison League","over18":false},"PennStateUniversity":{"lang":"en","description":"The Pennsylvania State University's subreddit: Reddit's frontpage for all things Nittany Lions  |  WE ARE!","over18":false},"redditmobile":{"lang":"en","description":"Announcements and discussion about official Reddit apps for mobile phones and tablets.\n\n*** OFFICIAL ADMIN-SPONSORED COMMUNITY *** ","over18":false},"typography":{"lang":"en","description":"Typography and type design.","over18":false},"randomsexiness":{"lang":"en","description":"The sexiest non-nude girls on the internet.","over18":true},"StarWarsForceArena":{"lang":"en","description":"The unofficial subreddit for Star Wars Force Arena, the mobile strategy game by Netmarble Games.","over18":false},"AnnArbor":{"lang":"en","description":"A wonderful city on the banks of the Huron River, home of the University of Michigan and a wide palate of culture, nature, technology and sports.\n","over18":false},"VPN":{"lang":"en","description":"***\n##[Virtual Private Network](https://en.wikipedia.org/wiki/Virtual_private_network)\nCreate a secure communication channel over an insecure network (like the Internet).  References for understanding","over18":false},"classiccars":{"lang":"en","description":"A place to discuss and/or post pictures of *classic cars*, *trucks*, or *bikes*; including hot rods, car shows and auto museums. \n","over18":false},"dirtgame":{"lang":"en","description":"Gravel, the sound of gravel.\n\nThe quiet.\n\nThe anticipation.\n\nBirds chirping.\n\nThe slight breeze in the forest.\n\nThe sound of anti-lag.\n\nThe sound of the turbos chirps.\n\nThe wake of gravel and dirt thr","over18":false},"ColoradoSprings":{"lang":"en","description":"Colorado Springs has been the home to some very interesting characters, including Nikola Tesla, Robert Heinlein, Charles M. Schulz, Roseanne Barr, Lon Chaney, Cassandra Peterson (Elvira), and Goose Go","over18":false},"RandomActsOfPizza":{"lang":null,"description":"Subreddit forbidden","over18":null},"ramen":{"lang":"en","description":"","over18":false},"galaxys5":{"lang":"en","description":"This sub is to post all things related to the Samsung Galaxy S5.  \nIt may be pictures, tips, news links, how-to's, or questions.  \nPlease be respectful to others, as some people may not have the same ","over18":false},"farming":{"lang":"en","description":"","over18":false},"ModestMouse":{"lang":"en","description":"All things Modest Mouse.","over18":false},"CrazyHand":{"lang":"en","description":"This is a place to ask for information on the Super Smash Bros game series. This is for both new and advanced players! You can ask for help on how you can ask for tips, strategies, replay critiques an","over18":false},"goldenretrievers":{"lang":"en","description":"","over18":false},"askaconservative":{"lang":"en","description":"Ask a Conservative: ask conservatives questions about conservative theory, values, policy and politics. For new conservatives, independents, moderates, (polite) liberals and others who want to underst","over18":false},"SteamTradingCards":{"lang":"en","description":"Subreddit for Steam Trading Card trading","over18":false},"Outlier":{"lang":"en","description":"Experimental space for Outlier","over18":false},"BudgetAudiophile":{"lang":"en","description":"This subreddit is for the budget minded audiophile that wants to grow out of boomboxes, bluetooth speakers and PC branded audio solutions. \n\nWe focus on education, discussion, and sharing of entry and","over18":false},"tarantulas":{"lang":"en","description":"Post questions and concerns about keeping tarantulas, pictures of your specimens, any interesting articles you find, and anything else about these amazing animals! ","over18":false},"nekoatsume":{"lang":"en","description":"A place to share our mutual obsessions with Neko Atsume, most cute cat game ever made. ","over18":false},"yankees":{"lang":"en","description":"Official Reddit for Yankees News and Discussion ","over18":false},"UnexpectedThugLife":{"lang":"en","description":"The subreddit for videos where there's some unexpected thug behavior showing when least expected.\n","over18":false},"CoinBase":{"lang":"en","description":"","over18":false},"theocho":{"lang":"en","description":"Inspired by the movie Dodgeball, r/TheOcho is a community dedicated to spreading knowledge of seldom seen and 'obscure' sports. ","over18":false},"bigseo":{"lang":"en","description":"## Contribute to the Wiki! \n\nFirst of all, welcome. We're glad you all decided to visit our growing community. This subreddit was created with the intent to foster growth and knowledge about not just ","over18":false},"productivity":{"lang":"en","description":"Tips and tricks for being more productive","over18":false},"Nanny":{"lang":"en","description":"##/r/Nanny is For:\n\n**Nannies, mannies, babysitters, aupairs, child care providers, mother helpers, and individuals in other child care services looking for:**\n\n* Support\n\n* Share stories, ideas, tech","over18":false},"AmItheAsshole":{"lang":"en","description":"A catharsis for the frustrated moral philosopher in all of us, and a place to finally find out if you were wrong in an argument that's been bothering you. Tell us about any conflict you have experienc","over18":false},"Unity2D":{"lang":"en","description":"A subreddit for the 2D aspects of Unity3D game development.","over18":false},"RPGdesign":{"lang":"en","description":"A gathering place for anyone, either casually or professionally, designing, hacking, or otherwise working with the mechanics of pen-and-paper tabletop RPGs.","over18":false},"PoppyTea":{"lang":"en","description":"A Subreddit Dedicated to Poppy Tea.\n\nWe strive to be an arcane subreddit, but now that you have found us, all information is available to you freely. We provide education-based harm reduction for the ","over18":true},"vermont":{"lang":"en","description":"Happily encouraging any articles, discussions, get togethers, happenings and local news events about the fantastic state of Vermont.","over18":false},"asexuality":{"lang":"en","description":"Subreddit for asexuals, gray-a's, questioning, supporters, folks just interested, and everything in between.\n\nKeywords: ace, ase, asexual, asexuality, lgbt, glbt, queer, trans*, gay, lesbian, straight","over18":false},"turning":{"lang":"en","description":"**We take square stuff and make it round!!**\n\nThe Reddit corner for all things woodturning. If you have questions, projects, updates, gripes, or any other spiny wood related thing. Here is the place t","over18":false},"LeagueOfMeta":{"lang":"en","description":"For meta discussions about the subreddit /r/LeagueofLegends.","over18":false},"orphanblack":{"lang":"en","description":"Orphan Black is a science-fiction thriller following Sarah Manning, a streetwise hustler who witnesses the suicide of a girl who looks just like her.","over18":false},"Frugal_Jerk":{"lang":"en","description":"We are the proud few who stand on the cutting edge of frugality.  We hold our heads high while we steal toilet paper, shoplift lentils, reuse condoms and syringes, and drink our own piss to save multi","over18":false},"FierceFlow":{"lang":"en","description":"/r/FierceFlow is a subreddit for men with long (er) hair to share tips, progress pictures, anecdotes, or anything else.","over18":false},"bloomington":{"lang":"en","description":"","over18":false},"RoversMorningGlory":{"lang":"en","description":"A place to talk about Rover's Morning Glory","over18":false},"geometrydash":{"lang":"en","description":"For all fans of the iOS, Android, Windows Phone, and Steam game, \"Geometry Dash\"  Post your videos, levels, etc!","over18":false},"marchingband":{"lang":"en","description":"A place for all of us marching band geeks to get together and share spicy memes, help each other out, or just spread the love. Let's march forth… together!","over18":false},"Permaculture":{"lang":"en","description":"Permaculture (Permanent-Culture): A practical design philosophy intended to help us live and prosper in an environment, while working with nature in a positive way, using solutions based on careful ob","over18":false},"Palestine":{"lang":"en","description":"","over18":false},"Mr_Trump":{"lang":null,"description":"Subreddit forbidden","over18":null},"Injustice2MobileGame":{"lang":"en","description":"A subreddit devoted to Injustice 2 mobile, The Andriod/iOS game! This is going to be the stop for all things Injustice 2 mobile-related topics.","over18":false},"PrettyGirlsUglyFaces":{"lang":"en","description":"The only way we'll judge you is if you try to maintain your dignity.","over18":false},"Djent":{"lang":"en","description":"","over18":false},"silenthill":{"lang":"en","description":"Silent Hill Subreddit. Discussions, Jokes, News, Guides, Wiki. Enter at your own risk, subscribers here are known to be pulled into the Other World.","over18":false},"TrueSTL":{"lang":"de","description":"The official refuge for true scholars of Lawrence Schick","over18":false},"PFSENSE":{"lang":"en","description":"The pfSense® project is a powerful open source firewall and routing platform based on FreeBSD. Developed and maintaned by Netgate.","over18":false},"MonsterMusume":{"lang":"en","description":"All about the popular manga and anime series: Monster Musume!","over18":false},"SFM":{"lang":"en","description":"The Source Filmmaker (SFM) is the movie-making tool built and used by Valve to make movies inside the Source game engine. Because the SFM uses the same assets as the game, anything that exists in the ","over18":false},"foodhacks":{"lang":"en","description":"Food hacks is a place to share quick and simple tips on making food that has more flavor, more nutritional value, or both!\n","over18":false},"LegalTeens":{"lang":"en","description":"Barely legal, but legal.","over18":true},"dotnet":{"lang":"en","description":"","over18":false},"Fixxit":{"lang":"en","description":"Post the YEAR, MAKE, and MODEL of your bike, and tell us your problem. We can help.","over18":false},"BestOfStreamingVideo":{"lang":"en","description":"Streaming movies and TV online.","over18":false},"jillstein":{"lang":"en","description":"Americans deserve real solutions for the economic, social and environmental crises we face. But the broken political system is only making things worse. It's time to build a people's movement to end u","over18":false},"ARKbuyandsell":{"lang":"en","description":"For those who would like to buy/sell the items they have crafter or dinos they have tamed in Ark: Survival Evolved","over18":false},"nes":{"lang":"en","description":"A subreddit dedicated to the Nintendo Entertainment System and Famicom. It was the number one video game console in the world from the mid 1980s to early 1990s. ","over18":false},"TowerofGod":{"lang":"en","description":"What do you desire?\n\nFortune?\n\nGlory?\n\nPower?\n\nRevenge?\n\nOr something that surpasses all others?\n\nWhat ever you desire,\n\n*'that is here'.*\n\n**Tower of God.**","over18":false},"GaymersGoneMild":{"lang":"en","description":"","over18":false},"TheStrokes":{"lang":"en","description":"","over18":false},"PussyPass":{"lang":"en","description":"The Pussy Pass is a modern phenomenon where by just owning a pussy gets you benefits. \n","over18":false},"MCSRep":{"lang":"en","description":"","over18":false},"AskLEO":{"lang":"en","description":"Anything and everything is acceptable, so long as you stay civil. Have a cop question, hopefully we can get you an answer here.","over18":false},"rockhounds":{"lang":"en","description":"This is the Reddit place to go when rocks are in your head -\n\nbe they agate, ruby, aquamarine or even a thunderegg bed.\n\nPost pics and ask some questions if you want to pick our minds -\n\nor display fo","over18":false},"cpp_questions":{"lang":"en","description":"a subreddit for c++ questions and answers","over18":false},"LordsOfMinecraft":{"lang":null,"description":"Subreddit forbidden","over18":null},"hextcg":{"lang":"en","description":"This is a community for Hex, Hex Entertainment's MMO TCG.\n","over18":false},"CompetitiveWoW":{"lang":"en","description":"A place for PvE Theorycrafting for World of Warcraft PvE (Player vs. Environment) play, including raiding.","over18":false},"wrestling":{"lang":"en","description":"A subreddit for Folkstyle, Freestyle and Greco-Roman Wrestling. All ages and levels are welcome.","over18":false},"christmas":{"lang":"en","description":"For the people who love the time when the Christmas Holidays come around Santa comes and visits us and we celebrate Christmas!","over18":false},"waiting_to_try":{"lang":"en","description":"School. Finances. Traveling. Whatever the the reason, talk it out here while you wait on trying for a baby.\n\n\nAdd some flair using the sidebar! Let us know where you are in your wait. ","over18":false},"SocialEngineering":{"lang":"en","description":"","over18":false},"PointlessStories":{"lang":"en","description":"This sub is for those stories that no one really needs to hear, but you still want to tell.","over18":false},"utdallas":{"lang":"en","description":"Welcome to the University of Texas at Dallas subreddit!\n\nPost anything and everything here about UT Dallas. Faculty, Staff, and Students are welcome.","over18":false},"AndroidTV":{"lang":"en","description":"Discussion of https://www.android.com/tv/ devices.","over18":false},"BigBoobsGonewild":{"lang":"en","description":"A home for the big breasts of Reddit. Busty redditors sharing their boobs gonewild style with the rest of reddit. Posters may be topless or covered, but should have big tits. Respect, fun and huge boo","over18":true},"Vocaloid":{"lang":"en","description":"Vocaloid is a singing synthesis technology and software that enables users to synthesize \"singing\" by typing in lyrics and melody. This subreddit serves as a place for discussion and sharing links rel","over18":false},"lgv20":{"lang":"en","description":"Because it's obviously going by 10's","over18":false},"RBI":{"lang":"en","description":"Using the power of the internet to solve real world problems. ","over18":false},"nsfwhardcore":{"lang":"en","description":"Hardcore Porn for Everyone","over18":true},"wowguilds":{"lang":"en","description":"A subreddit for finding guilds and guild members for World of Warcraft.","over18":false},"USMCboot":{"lang":"en","description":"* A place for Boots and Poolees to get their questions answered.  Please feel free to ask anything you want regarding the Marine Corps and what to expect. ~ \"We don't promise you a rose garden\"","over18":false},"uglyduckling":{"lang":"en","description":"For all you guys and gals out there who turned into butterflies. ","over18":false},"HotPeppers":{"lang":"en","description":"Hot Peppers, sweet peppers, spicy stuff, and more. \n\nWe love growing and eating peppers come share or ask a question!","over18":false},"ledootgeneration":{"lang":"en","description":"for all ur dooting needs\n\nthanks mr skeltal","over18":false},"cataclysmdda":{"lang":"en","description":"Cataclysm: DDA is an open source zombie-survival Roguelike which  challenges players to not only acquire essential supplies to survive, but to battle with a wide range of zombies and other terrifying ","over18":false},"FutureWhatIf":{"lang":"en","description":"/r/Futurewhatif","over18":false},"C_Programming":{"lang":"en","description":"The subreddit for the C programming language","over18":false},"Dreadlocks":{"lang":"en","description":"Welcome to **Dreddit**! Share your stories, progress or ask for some advice! We pride ourselves on helping and welcoming everyone.\n\n*Staying together is what good dreadlocks do!*","over18":false},"RedditRescueForce":{"lang":"en","description":"Sometimes when you are trying to survive in Chernarus you need a helping hand - this subreddit is intended to pull together medical requests for people in-game and deal with them in an efficient manne","over18":false},"P90X":{"lang":"en","description":"","over18":false},"BadDragon":{"lang":"en","description":"Bad Dragon toys doing what they do best...\n\nIt is preferred that toys be of Bad Dragon origin as is suggested by the name of the subreddit, however anything similar that is sufficiently awesome will b","over18":true},"FemBoys":{"lang":"en","description":"Unleash your feminine side!","over18":true},"bigfoot":{"lang":"en","description":"The reddit home of all things bigfoot. News, sightings, rumors, hoaxes, witnesses, videos, photos, research. Anything and everything related to the as yet unclassified species of relict hominids.","over18":false},"AskGames":{"lang":"en","description":"AskGames is the place to get answers to your burning gaming questions:\n\n* When does Game X come out?\n* Does console X have this feature?\n* How do I get the \"Kill everything\" achievement?\n* How can I b","over18":false},"alcoholism":{"lang":"en","description":"Information and support for those affected by alcoholism. If you are concerned about alcohol's effect on your life or a loved one's life, please feel welcome. ","over18":false},"911truth":{"lang":"en","description":"Welcome to /r/911truth! The purpose of this subreddit is to present and discuss evidence showing that the US Government's version of the events of 9/11 cannot possibly be true. Submissions or comments","over18":false},"painting":{"lang":"en","description":"Welcome to /r/Painting! \nFunctioning like an artist cooperative gallery, this is the place where beginning to advanced painters display their work in an ongoing group discussion. Artists who post thei","over18":false},"CraftBeer":{"lang":"en","description":"A place for discussion and geekery concerning craft beer. A home for people who are passionate about beer and spreading the word.","over18":false},"overlanding":{"lang":"en","description":"Dedicated to the the spirit of exploration","over18":false},"IDAP":{"lang":"en","description":"Are you an artist? Post pictures you've drawn/painted here! Drawing can be in any medium. Pencil to photoshop, paint to ... uh MSPaint!\n\nPlease don't post comics or infographics\n\n","over18":false},"WhiteWolfRPG":{"lang":"en","description":"A community for fans of White Wolf's roleplaying games, notably the World of Darkness, Exalted, and Chronicles of Darkness.","over18":false},"RagenChastain":{"lang":"en","description":"","over18":false},"tightdresses":{"lang":"en","description":"","over18":true},"RLFashionAdvice":{"lang":"en","description":"For advice on rocket league toppers, decals, colours, finishes, wheels, and antennas.","over18":false},"hockeygoalies":{"lang":"en","description":"A community made for hockey goalies. Discussions on pads, technique and others are welcome.","over18":false},"solar":{"lang":"en","description":"Discussion of solar cells, solar energy, solar power, solar heating, solar panels, pv, off the grid, and more.\n\nSolar technology is perhaps the greatest development of the modern age.  Improvements to","over18":false},"KGATLW":{"lang":"en","description":"A place for all discussions and sharing of things about the Australian Psychedelic band King Gizzard and the Lizard Wizard","over18":false},"postprocessing":{"lang":"en","description":"","over18":false},"pregnant":{"lang":"en","description":"","over18":false},"wayhome":{"lang":"en","description":"WayHome is an annual Music Festival held in Oro-Medonte, Ontario. Stay up to date with the latest news and discussion for the 2017 WayHome Music Festival.\n\nWayHome Festival\nBurl's Creek Event Grounds\n","over18":false},"StackAdvice":{"lang":"en","description":"","over18":false},"PixelDungeon":{"lang":"en","description":"This subreddit is a place to talk strategies, tell stories, or discuss anything related to the game Pixel Dungeon.","over18":false},"Impeach_Trump":{"lang":"en","description":"For Americans Against Trump • /r/Impeach_Trump","over18":false},"TheMassive":{"lang":"en","description":"The official Columbus Crew SC subreddit. Join fellow soccer fans and post anything and everything dealing with The Crew and Columbus soccer. You will find everything from free tickets to leaked jersey","over18":false},"libertarianmeme":{"lang":"en","description":"The best libertarian memes, macros, photos, jokes, and conversations on Reddit.","over18":false},"mvci":{"lang":"en","description":"MARVEL VS CAPCOM: INFINITE","over18":false},"dragoncon":{"lang":"en","description":"For redditors who go to Dragon Con","over18":false},"homemadexxx":{"lang":"en","description":"Real homemade porn videos\n","over18":true},"htgawm":{"lang":"en","description":"The place for How to Get Away with Murder related discussion with pictures, articles, and anything that deals with the show. \n\nHow to Get Away with Murder airs on ABC 10|9c during \"TGIT\". The show has","over18":false},"TrueBlood":{"lang":"en","description":"","over18":false},"lanadelrey":{"lang":"en","description":"A place to discuss and share all matters concerning singer, Lana Del Rey. \n\nLust For Life available now! ","over18":false},"araragi":{"lang":"en","description":"Come discuss Bakemonogatari, Nisemonogatari and related series here!\n\nBakemonogatari (化物語 \"Ghostory\") is a Japanese light novel series written by Nisio Isin (ill. Vofan; pub. by Kodansha under the Kod","over18":false},"razorbacks":{"lang":"en","description":"Everything related to Razorback sports: football, basketball, baseball, track, softball, gymnastics, and so on and so forth.","over18":false},"gaypornhunters":{"lang":"en","description":"Looking for a Japanese twink getting railed by two hunky latino men in a hot tub? Trying to figure out the name of the man getting rimmed in a photo you saved four years ago? Need proof that triple pe","over18":true},"UCDavis":{"lang":"en","description":"","over18":false},"UCSC":{"lang":"en","description":"*A gathering place for friends of the University of California, Santa Cruz.*","over18":false},"anonymous":{"lang":"en","description":"This subreddit is for Anonymous News and Articles aggregation. It is not for the planning and execution of operations.","over18":false},"TheBrewery":{"lang":"en","description":"https://bsgcraftbrewing.com/","over18":false},"Stacked":{"lang":"en","description":"/r/stacked: a subreddit dedicated to large-breasted women. Skinny, curvy, thick, and BBW are all welcome here.","over18":true},"VietNam":{"lang":"en","description":"Vietnamese Subreddit.","over18":false},"moderatepolitics":{"lang":"en","description":"This NOT a politically moderate subreddit! It IS a political subreddit for moderately expressed opinions. If you are looking for civility, moderation and tolerance come on in!","over18":false},"pagan":{"lang":"en","description":"","over18":false},"Helldivers":{"lang":"en","description":"This reddit is dedicated to news and features concerning Helldivers, the new game from the developers of Magicka. We're super excited for the title, so check back often for more information!","over18":false},"JustCause":{"lang":"en","description":"Just Cause Subreddit \n\nJust Cause is an action-adventure video game series set in an open world environment, created by Avalanche Studios","over18":false},"DesignPorn":{"lang":"en","description":"High quality images of interesting designs, including architectural, graphic, industrial, furniture & product design.","over18":false},"RedditDayOf":{"lang":"en","description":"","over18":false},"Hookers":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Jeopardy":{"lang":"en","description":"/r/Jeopardy, a subreddit for the appreciation of the World's Greatest Game Show, *Jeopardy!*","over18":false},"SWORDS":{"lang":"en","description":"A subreddit for enthusiasts, practitioners, collectors, and investigators of swords (and related historical weapons). Real swords, decorative, historical, fantasy; humor, social, ID requests, shopping","over18":false},"electricvehicles":{"lang":"en","description":"Discuss everything to do with electric cars, hybrid cars and electric vehicles – the Reddit community for EV enthusiasts!\n","over18":false},"FunnyandSad":{"lang":"en","description":"For images that are funny and sad.","over18":false},"hackernews":{"lang":"en","description":"A mirror of [Hacker News](https://news.ycombinator.com/).","over18":false},"SexToys":{"lang":"en","description":"A place to discuss and ask questions about adult sex toys. ","over18":true},"options":{"lang":"en","description":"","over18":false},"communism101":{"lang":"en","description":"Each one teach one!","over18":false},"hittableFaces":{"lang":"en","description":"For those faces and people you just want to hit.\n\n","over18":false},"ads":{"lang":"en","description":"","over18":false},"battlefront":{"lang":"en","description":"Battlefront subreddit for all things Star Wars Battlefront","over18":false},"PalaceClothing":{"lang":"en","description":"A place to discuss, buy, sell and trade Palace clothing.","over18":false},"GoneWildHairy":{"lang":"en","description":"Real women who proudly rock the bush!","over18":true},"AsianLadyboners":{"lang":"en","description":"Do you appreciate sexy Asian men? Do you like staring at pictures of said men? Then this is the subreddit for you!","over18":false},"NavyBlazer":{"lang":"en","description":"A place of discussion for the American subculture of prep.","over18":false},"FIFA17UT":{"lang":"en","description":"FIFA17 is a community for all to discuss and share things about football game FIFA series(FIFA 17, FIFA 16, FIFA 15...) and football. ","over18":false},"Grimdank":{"lang":"en","description":"Duncan rides to battle wearing two thin coats.","over18":false},"StonerProTips":{"lang":"en","description":"","over18":false},"compDota2":{"lang":"en","description":"","over18":false},"Nexus":{"lang":"en","description":"Welcome to **/r/Nexus**! This an umbrella community for all Nexus devices. Discover news, rumors, tips, and discussion concerning anything related to Nexus devices.","over18":false},"swift":{"lang":"en","description":"Swift - a modern programming language for iOS, OS X, watchOS, and tvOS apps.","over18":false},"Cumtown":{"lang":"en","description":"A Reddit dedicated to the podcast \"Cum Town\"","over18":false},"10cloverfieldlane":{"lang":"en","description":"Discussion and speculation about the upcoming film 10 Cloverfield Lane, which is set to release March 11th, 2016. ","over18":false},"ESObay":{"lang":"en","description":"Elder Scrolls Online Non-Guild Crafters Market\n","over18":false},"SCCM":{"lang":"en","description":"All things System Center Configuration Manager...","over18":false},"agt":{"lang":"en","description":"America's Got Talent (also known as AGT) is an American reality television series on the NBC television network, and part of the global British Got Talent franchise. It is a talent show that features ","over18":false},"CaseClickerTrades":{"lang":"en","description":"Official Case Clicker trading subreddit","over18":false},"rails":{"lang":"en","description":"A subreddit for discussion and news about Ruby on Rails development","over18":false},"comiccon":{"lang":"en","description":"Anything Related to comicbook conventions","over18":false},"boltedontits":{"lang":"en","description":"A subreddit for people who enjoy breast implants.","over18":true},"MW2":{"lang":"en","description":"","over18":false},"StarcraftCirclejerk":{"lang":"en","description":"The place on Reddit for discussion of all things TLO!","over18":false},"udub":{"lang":"en","description":"The Unofficial Subreddit of the University of Washington","over18":false},"longbeach":{"lang":"en","description":"A subreddit for Long Beach news and events.\n","over18":false},"SULeaks":{"lang":"en","description":"Leaks for Steven Universe","over18":false},"soccercirclejerk":{"lang":"en","description":"Everything you need to know about the blooterful game.  Especially handy for Americans.","over18":false},"socialwork":{"lang":"en","description":"This community is for social workers and those interested in social work! It is a place to ask for advice, share your frustrations, receive support, and anything else you want related to social work.","over18":false},"MBA":{"lang":"en","description":"","over18":false},"DNCleaks":{"lang":"en","description":"https://wikileaks.org/dnc-emails/\n\nThis subreddit was created to post details and significant finds from the DNC leak in a more organized, central area.    \n  \nKeywords: DNC, leaks, wikileaks, Hillary","over18":false},"WeddingPhotography":{"lang":"en","description":"","over18":false},"django":{"lang":"en","description":"","over18":false},"UCONN":{"lang":"en","description":"","over18":false},"fixit":{"lang":"en","description":"From eyeglasses, to office chairs, cherished childhood stuffed animals, and trinkets and toys. Doors, walls, furniture and floors, popcorn ceilings *and* ceiling fans. Appliances, kitchen utensils, dr","over18":false},"WorkOnline":{"lang":"en","description":"A place to talk about making an income online.  This includes random jobs, online employers, sites that pay you and ways to monetize websites.  These are sites and strategies that will yield the user ","over18":false},"DrugNerds":{"lang":"en","description":"For the discussion of recreational pharmacology. (r/drugs with longer words)","over18":false},"demonssouls":{"lang":"en","description":"","over18":false},"hearthstonecirclejerk":{"lang":"en","description":"Hearthstone is a free-to-play digital strategy card game that anyone can enjoy. Instead of enjoying it though many players choose instead to whine about every aspect of it on /r/hearthstone. This subr","over18":false},"highdeas":{"lang":"en","description":"Highdeas are ideas you have only when you're high. This is a place for ents to share their highdeas with the community. All ideas are welcome.","over18":false},"TheForest":{"lang":"en","description":"The Forest is an open world survival horror game currently in development for PC.","over18":false},"modnews":{"lang":"en","description":"","over18":false},"crypto":{"lang":"en","description":"Cryptography is the art of creating mathematical assurances for who can do what with data, including but not limited the classical example of encrypting messages so that only the key-holder can read i","over18":false},"opensource":{"lang":"en","description":"A subreddit for everything [open source](http://en.wikipedia.org/wiki/Open_source) related.\n","over18":false},"Rule34LoL":{"lang":"en","description":"","over18":true},"projectzomboid":{"lang":"en","description":"The subreddit for Project Zomboid.\n\nProject Zomboid is an isometric zombie survival game created by The Indie Stone.","over18":false},"ILiveIn":{"lang":"en","description":"","over18":false},"audio":{"lang":"en","description":"","over18":false},"the_meltdown":{"lang":"en","description":"A place to share the 2016 Election-related meltdowns from your friends, family, fellow Redditors, celebrities, and more.","over18":false},"LineageOS":{"lang":"en","description":"Your Lineage will finish what you started, Cid.","over18":false},"SQL":{"lang":"en","description":"The goal of /r/SQL is to provide a place for interesting and informative SQL content and discussions.","over18":false},"FallOutBoy":{"lang":"en","description":"The Official Forum for FOB Fans!\n","over18":false},"Freethought":{"lang":"en","description":"Freethought is an open forum dedicated to rational, logical and scientific examination of culture, politics, religion, science, business and more!  \n\nFreethinkers reject claims and beliefs which are n","over18":false},"mississauga":{"lang":"en","description":"","over18":false},"onetruegod":{"lang":"en","description":"This is a subreddit dedicated to Nicolas Cage, the deity. Here, we worship and collect all content relating to the Cage, through which we hope to discern His Holy Word. \n\nWe welcome all, as the Lord w","over18":false},"baseballcirclejerk":{"lang":"en","description":"Mike Trout <3","over18":false},"fakehistoryporn":{"lang":"en","description":"Fake History Porn : A subreddit dedicated to fake history porn ","over18":false},"PokemonGOToronto":{"lang":"en","description":"Toronto Raid Discord  - https://discord.gg/CNyZYmm\n \n \nOfficial Subreddit to talk about Pokémon GO! Share tips on how and where to catch Pokémon, discuss with other Team Members about gyms, plan meetu","over18":false},"treedibles":{"lang":"en","description":"This is a place open to all, ents or not. Post any good recipes that you have heard of, or have made first hand. Edibles, drinks, its all good! Remember, this is not a place to post good food to eat w","over18":false},"CAguns":{"lang":"en","description":"This is a place to discuss and ask questions about California's gun laws and California's gun politics.","over18":false},"AskWomenOver30":{"lang":"en","description":"A place for mature women redditors to discuss questions in a loosely moderated setting.","over18":false},"mangonewild":{"lang":"en","description":"The male body, and all its parts, is the most beautiful and erotic thing there. This is a community dedicated to us who adore the [m]. This is for the ~50% who think penises, cute butts, and powerful ","over18":true},"Blogging":{"lang":"en","description":"A community for bloggers. This subreddit is aimed towards helping bloggers with their blogging journey.","over18":false},"PuertoRico":{"lang":"en","description":"","over18":false},"PPC":{"lang":"en","description":"Information and discussions related to pay-per-click advertising. The primary focus is Google Ads and Bing Ads, but other advertising platforms are acceptable, such as Facebook ads.","over18":false},"BSG":{"lang":"en","description":"Battlestar Galactica TV Series \n\n1978 - 1980\n\n2003 - 2010","over18":false},"MinionHate":{"lang":"en","description":"","over18":false},"Diablo3Barbarians":{"lang":"en","description":"Diablo 3 Barbarian subreddit.","over18":false},"nbacirclejerk":{"lang":"en","description":"Welcome to r/nbacirclejerk where we offer only the dankest discussions on the net. NOTE: This is a satirical website that houses offensive posts and comments, if you do not have a sense of humor and o","over18":false},"djiphantom":{"lang":"en","description":"The DJI phantom is a ready to fly, multi-rotor system, built for aerial filming and photography. With software balanced flight systems, multi-axis gimbals, advanced safety features, and several camera","over18":false},"rolltide":{"lang":"en","description":"","over18":false},"lastimages":{"lang":"en","description":"Postings here are the last known photographs or videos of a person. Also, the last picture taken by a person just before their death is acceptable. Pictures of people only please! You may additional c","over18":false},"kindafunny":{"lang":"en","description":"KindaFunny.com is bringing you nerdy, comical, gross, and thought-provoking videos that are all kinda funny each and every day. Join Greg Miller, Nick Scarpino, Tim Gettys, and Kevin Coello as they cr","over18":false},"imaginarymaps":{"lang":"en","description":"Imaginary Maps! Maps from fictional stories, books, films, television programs, video games, and comics are all welcome! \n\nLINK TO OUR DISCORD: https://discord.gg/eaXQhU3","over18":false},"starwarscollecting":{"lang":"en","description":"/r/starwarscollecting is home to Star Wars collecting news, toys, merchandise, discussion, pics, and etc. ","over18":false},"NOLAPelicans":{"lang":"en","description":"","over18":false},"csgomarketforum":{"lang":"en","description":"Hello and welcome to /r/csgomarketforum, we are a friendly subreddit which aims to learn the trends of the steam market. We all strive to profit and mainly focus around csgo. We discuss how future cha","over18":false},"Hammocks":{"lang":"en","description":"**WELCOME TO THE HAMMOCK DISTRICT!**\n\nHammocks are a great lightweight alternative for ultralight campers and hikers. Also, they're *really* comfortable.\n\n[**New to hammocks? Read this.**](http://www.","over18":false},"learnjavascript":{"lang":"en","description":"This subreddit is for anyone who wants to learn JavaScript or help others do so.  \n\nQuestions and posts about HTML and CSS are also encouraged.","over18":false},"Slipknot":{"lang":"en","description":"This subreddit is devoted to the band Slipknot.","over18":false},"MeanJokes":{"lang":"en","description":"A collection of the cruelest, most offensive jokes you can think of.","over18":false},"palegirls":{"lang":"en","description":"Pale Girls is dedicated to celebrating beautiful women with minimal melanin. This reddit is automatically NSFW and hardcore content is also welcome. Only use Imgur to host your images.\n","over18":true},"lonely":{"lang":"en","description":"A sub for all the lonely people","over18":false},"Vue":{"lang":"en","description":"PlayStation Vue (PSVue) - \n\n\nThe subreddit for cordcutters who still like to subscribe to TV when it suits them. \n\nFeaturing television cloud DVR up to 28 days, subscriber log-ins for various networks","over18":false},"uncharted":{"lang":"en","description":"This subreddit is for discussing and sharing anything relating to Naughty Dog's Uncharted series of video games on Playstation consoles and/or the bonus adventures in other mediums.","over18":false},"logodesign":{"lang":"en","description":"A place to discuss logos and their design.","over18":false},"ToyotaTacoma":{"lang":"en","description":"The premier Toyota Tacoma community for Reddit.","over18":false},"Egypt":{"lang":"en","description":"/r/Egypt is a community which discusses all things Egyptian, from Politics and Society to Culture and Entertainment.","over18":false},"NorthKoreaNews":{"lang":"en","description":"All your news updates pertaining to North Korea in one place!","over18":false},"fringe":{"lang":"en","description":"A subreddit dedicated to the television show Fringe.","over18":false},"shittyrainbow6":{"lang":"en","description":"Welcome to the meme-subreddit for Rainbow Six Siege. Feel welcome to post your memes and shitposts about Rainbow Six Siege here. Read the rules before posting.","over18":false},"Equestrian":{"lang":"en","description":"This sub is dedicated to all horse lovers. Here we can chat about anything related to our four legged friends. Please make sure you mark any posts that could be offensive as graphic or NSFW. \n\nLets ha","over18":false},"Pitt":{"lang":"en","description":"","over18":false},"Acadiana":{"lang":"en","description":"A subreddit for posts about the Acadiana region of Louisiana.","over18":false},"FREE":{"lang":"en","description":"Welcome to /r/FREE, the place for all things free. Please read the rules below before posting, \n\nFree steam keys are the majority but feel free to give away whatever as long as it's free. Free furnitu","over18":false},"canberra":{"lang":"en","description":"A subreddit for Canberrans and the Canberra region.","over18":false},"GenderCynical":{"lang":"en","description":"A place to discuss issues of gender without those bothersome third wave feminists and male apologists.","over18":false},"Pen_Swap":{"lang":"en","description":"","over18":false},"discworld":{"lang":"en","description":"This sub is dedicated to the weird and wonderful Discworld.","over18":false},"Darts":{"lang":"en","description":"Anything and everything related to the wonderful game of darts!","over18":false},"adorableporn":{"lang":"en","description":"* A subreddit for adorable porn.","over18":true},"Skookum":{"lang":"en","description":"Technically minded people trying not to let the smoke out","over18":false},"findapath":{"lang":"en","description":"For those who have a hobby, passion, or passing whim that they want to make a living out of, but don't know how they can get there. Wanderers and contributors alike are welcome.","over18":false},"Sino":{"lang":"en","description":"News, information, and discussion on anything China and Chinese related","over18":false},"CivcraftExchange":{"lang":"en","description":"","over18":false},"prolife":{"lang":"en","description":"A place for Pro-Lifers of all religious, secular and political views to gather on Reddit. ","over18":false},"uber":{"lang":"en","description":"This subreddit provides a place for Uber riders and drivers to discuss their experiences. Its sister subreddit is /r/uberdrivers.  This subreddit has zero corporate influence from any outside entity.","over18":false},"gangplankmains":{"lang":"en","description":"A community for all good mateys who share a love and respect for our captain Gangplank, the Saltwater Scourge. ","over18":false},"NormMacdonald":{"lang":"en","description":"A subreddit for videos and discussions about Norm Macdonald.","over18":false},"PEDs":{"lang":"en","description":"/r/PEDs is dedicated to information about enhancing performance. Our objective is to create an in-depth background of performance enhancing drugs from every background while building a community aroun","over18":true},"GTAA":{"lang":"en","description":"This is the official subreddit for the GTAA and GTAX Crew. Please see our crew > [Here](http://socialclub.rockstargames.com/crew/gtaadventures).\n","over18":false},"Megaman":{"lang":"en","description":"","over18":false},"Sense8":{"lang":"en","description":"A subreddit for the Netflix original series *Sense8*, released on June 5th, 2015.","over18":false},"firefall":{"lang":"en","description":"Official subreddit community for the FireFall game.","over18":false},"awesome":{"lang":"en","description":"For everything that is awesome! ","over18":false},"SolForge":{"lang":"en","description":"SolForge is a digital trading card game. This subreddit is for fans and community members to discuss the latest news and strategies for the game.","over18":false},"RTLSDR":{"lang":"en","description":"A subreddit for the low-cost software defined radio (SDR) community. While originally dedicated to the [RTL2832U USB rtl-sdr](http://sdr.osmocom.org/trac/wiki/rtl-sdr) project, relevant content relate","over18":false},"oculusnsfw":{"lang":"en","description":"The largest, unofficial subreddit all about VR Porn","over18":true},"spongebob":{"lang":"en","description":"The subreddit about Spongebob Squarepants. The show, characters, and other spongebob stuff.","over18":false},"genderqueer":{"lang":"en","description":"For folks who don't fit the gender binary or are interested in questioning it. Please feel free to join us and discuss!\n","over18":false},"Bellingham":{"lang":"en","description":"Bellingham, Washington","over18":false},"DvZ":{"lang":null,"description":"Subreddit forbidden","over18":null},"dayton":{"lang":"en","description":"News, events, meetups and things to do in Dayton, Ohio. ","over18":false},"britishcolumbia":{"lang":"en","description":"Beautiful Ocean, Breathtaking Mountains, And Everything In Between. \n","over18":false},"Foofighters":{"lang":"en","description":"Welcome to /r/FooFighters! \n\nFoo Fighters are Dave Grohl, Nate Mendel, Taylor Hawkins, Chris Shiflett, Pat Smear, and Rami Jaffee.","over18":false},"FuturamaWOTgame":{"lang":"en","description":"The unofficial subreddit for the mobile game, Futurama: Worlds of Tomorrow, made by TinyCo.","over18":false},"crappymusic":{"lang":"en","description":"Ear Cancer ","over18":false},"needamod":{"lang":"en","description":"Need someone to spruce up your sub? Someone to handle all that spam? Someone to edit wiki articles? Then you need a mod! Come request one here!\n\nCan *you* do CSS? Enforce rules? Help communities? Then","over18":false},"brockhampton":{"lang":"en","description":"","over18":false},"YAwriters":{"lang":"en","description":"This sub is for authors of YA novels. Discussing your original WIP (work in progress) is our purpose. Feel free to discuss titles, characters, plots, themes, settings, critiques, and any information p","over18":false},"nihilism":{"lang":"en","description":"r/Nihilism","over18":false},"DigimonLinkz":{"lang":"en","description":"In need of help, regarding Digimon Links? Come join our subreddit! We're active and we'll surely help you if you ask for our assistance! Hoping to see you on the other side, DigiDestined!","over18":false},"straya":{"lang":"en","description":"Tinnies, Cones, Sport, Cunts. Come down under to the 100% politics free alternative to /r/Australia and it's miserable seriousness. 38 thousand mad cunts and counting!","over18":false},"panelshow":{"lang":"en","description":"Would I Lie To You? (WILTY), Taskmaster, 8 out of 10 Cats Does Countdown, QI, Mock the Week, Have I Got News For You (HIGNFY), Never Mind the Buzzcocks (NMTB), The Daily Show, The Colbert Report, Wait","over18":false},"gmod":{"lang":"en","description":"Garry's Mod is a sandbox game built with Valve's Source engine.","over18":false},"modhelp":{"lang":"en","description":"Have questions about moderating your subreddit? We might be able to help! Want to brainstorm new moderation features with the admins? That's on-topic, too","over18":false},"TMNT":{"lang":"en","description":"","over18":false},"shroomers":{"lang":"en","description":"For the hunting, growing, and consuming of mushrooms.\n","over18":false},"EASportsUFC":{"lang":"en","description":"Your #1 HUB for all things MMA Gaming related!","over18":false},"Bikeporn":{"lang":"en","description":"A subreddit for the worlds most beautiful, eye-catching bikes. Road, Mountain, Track, Commuter, Fixed, Cyclocross or BMX, all are welcome.","over18":false},"Nissan":{"lang":"en","description":"Welcome back! /r/Nissan is a forum for all things Nissan/Infiniti! Hakosukas through Jukes. Questions, pictures, articles, build threads, track videos, we will eat it up. Please share!","over18":false},"satanism":{"lang":"en","description":"A place for discussing Satanism on Reddit.","over18":false},"Drifting":{"lang":"en","description":"[](/r/Drifting/wiki/links)This subreddit is dedicated to all things drifting.  We all have a love of getting our cars sideways, and here is a place for people to share their stories and media from eve","over18":false},"spelunky":{"lang":"en","description":"","over18":false},"Brogress":{"lang":"en","description":"This is the subreddit to post those awesome before and after pictures of yourself.\n","over18":false},"Dublin":{"lang":"en","description":"This subreddit is all about Dublin, Ireland.","over18":false},"redditdota2league":{"lang":"en","description":"The Reddit Dota 2 League (RD2L) is aimed to provide a league-formatted level playing field for Dota 2 players of all skill ranges. \n\nIndividuals who wish to participate will be placed into a pool wher","over18":false},"rs2vietnam":{"lang":"en","description":"*Rising Storm 2: Vietnam* is the sequel to PC Gamer’s 2013 *‘Multiplayer Game of the Year’*, developed by the same team that created the award-winning innovative asymmetric gameplay - Antimatter Games","over18":false},"PokemonROMhacks":{"lang":"en","description":"A subreddit where you can find, create, and discuss hacks of Pokémon games.","over18":false},"GiveMeTheVirus":{"lang":"en","description":"A subreddit for spreading Pokérus.","over18":false},"SouthParkPhone":{"lang":"en","description":"Unofficial subreddit for the mobile game South Park: Phone Destroyer","over18":false},"DatGuyLirik":{"lang":"en","description":"","over18":false},"geologycareers":{"lang":"en","description":"Advice, advertisements and other topics relating to any and all jobs in geology; from paleontology to igneous petrology and the energy industry. ","over18":false},"FinancialCareers":{"lang":"en","description":"","over18":false},"REDDITORSINRECOVERY":{"lang":"en","description":"A place for Redditors in recovery to hang out, share experiences, and support each other. Discuss the various ways to achieve and maintain a life free from active addiction. Everyone is welcome.","over18":false},"gameDevClassifieds":{"lang":"en","description":"GameDevClassifieds is a place where game development studios, indies, and hobbyists can find talent in the game industry. Whether it's programming, art, design, audio, music, writing, voice, business,","over18":false},"Dreamtheater":{"lang":"en","description":"A subreddit dedicated to one of the best Progressive Metal bands in the world, Dream Theater.","over18":false},"ChanceTheRapper":{"lang":"en","description":"Chance The Rapper is one of the best up and coming rappers coming out of Chicago. ","over18":false},"steak":{"lang":"en","description":"For all things STEAK! ","over18":false},"AcademicBiblical":{"lang":"en","description":"A subreddit for discussion of early Judaism and Christianity - with a focus on Biblical texts, but also related noncanonical literature (Enoch, the Dead Sea Scrolls, etc.) - in a scholarly context. Re","over18":false},"acne":{"lang":"en","description":"A subreddit for discussing acne and how to best treat it.","over18":false},"cirkeltrek":{"lang":"nl","description":"De Koninklijke Nederlandsche Cirkeltrek","over18":false},"debian":{"lang":"en","description":"","over18":false},"BeardPorn":{"lang":"en","description":"","over18":false},"KingdomDeath":{"lang":"en","description":"A place to discuss Kingdom Death: Monster board game as well as show off miniatures.","over18":false},"Handwriting":{"lang":"en","description":"A place for redditors to improve, show-off, and discuss all aspects of handwriting.","over18":false},"macgaming":{"lang":"en","description":"","over18":false},"Diesel":{"lang":"en","description":"Welcome to /r/Diesel, reddit's home for everything about compression motors! ","over18":false},"dailyprogrammer":{"lang":"en","description":"**Welcome to r/DailyProgrammer!** \n\nFirst time visitors of Daily Programmer please [Read the Wiki] (http://www.reddit.com/r/dailyprogrammer/wiki/index) to learn everything about this subreddit.\n\n3 Pro","over18":false},"redheads":{"lang":"en","description":"A subreddit created to celebrate the glory of the redheads. To share the joy of the gingers, the fun of the firecrotches, the rage of the rusty ones and the bodies of the blood nuts.\n","over18":true},"telescopes":{"lang":"en","description":"","over18":false},"Simulated":{"lang":"en","description":"A subreddit for all things computer generated simulations!","over18":false},"saab":{"lang":"en","description":"SAAB's home on Reddit.  For owners and lovers of the cars that are built by trolls in Trollhättan! Only one aircraft manufacturer makes cars: Sierra, Alpha, Alpha, Bravo. SAAB. Pure driving pleasure a","over18":false},"camaro":{"lang":"en","description":"","over18":false},"violinist":{"lang":"en","description":"","over18":false},"Lightbulb":{"lang":"en","description":"Show off your ideas, inventions and innovations! This a subreddit for anyone who needs opinions on their ideas. No matter the sort, even theoretical ideas are acceptable. Hopefully we can make differe","over18":false},"BDSMGW":{"lang":"en","description":"A place to post your own kinky pictures","over18":true},"52book":{"lang":"en","description":"A subreddit for the participants of the 52 Book Challenge (one book per week for a year) to discuss their progress and discoveries.","over18":false},"DadReflexes":{"lang":"en","description":"Reflexes only dads have.","over18":false},"Tacoma":{"lang":"en","description":"If it's Tacoma post it here","over18":false},"Greyhounds":{"lang":"en","description":"Everything grey! Post pictures, stories, questions and answers.","over18":false},"rollerblading":{"lang":"en","description":"Reddit's source for rollerblading news and discussions.","over18":false},"xbmc":{"lang":"en","description":"**XBMC** is an award-winning *free and open source* cross-platform software media player and entertainment hub for HTPCs. \n\nIt uses a 10-foot user interface and is designed to be a media player for th","over18":false},"LeedsUnited":{"lang":"en","description":"All things Leeds United. Post news links, matchday threads, discussion topics, and other media about LUFC here. Pictures must be SFW.\n\nThe name on the back of the shirt is never bigger than the badge ","over18":false},"GoogleCardboard":{"lang":"en","description":"A site to discuss Google Cardboard and similar virtual reality viewers, their software, other content and subjects related for phone based VR.","over18":false},"ImaginaryLandscapes":{"lang":"en","description":"This reddit community is for submitting your favourite digital or natural media creations of landscapes or scenery. They must be original creations, not photographs of already-existing places.\n\nOvergr","over18":false},"Bladesmith":{"lang":"en","description":"A subreddit for the metalworkers who specialize in forging knives and other blade tools.  Swords, daggers, kitchen cutlery, carving chisels, etc.  Come in, look around, ask a question, learn, and have","over18":false},"sissyhypno":{"lang":"en","description":"Hypnosis media that turn willing men into cocksucking sissy cum-hungry sexy girly bitch sluts. If you're under 18, get the fuck out.","over18":true},"orangered":{"lang":"en","description":"The greatest nation in Chroma or Kingston!","over18":false},"Fifa13":{"lang":"en","description":"Please excuse our appearance as we continue to build this subreddit. ","over18":false},"sushi":{"lang":"en","description":"","over18":false},"overlord":{"lang":"en","description":"Overlord Anime/Manga/Novel Discussion","over18":false},"GIRLSundPANZER":{"lang":"en","description":"Girls und Panzer","over18":false},"lootcrate":{"lang":null,"description":"Subreddit forbidden","over18":null},"ExposurePorn":{"lang":"en","description":"/r/ExposurePorn is a Safe For Work subreddit in the Safe For Work (SFW) Porn Network. The main focus of /r/ExposurePorn is to feature photographs that use the long exposure technique at night or durin","over18":false},"de_IAmA":{"lang":"de","description":"Die deutschsprachige Version von /r/IAMA","over18":false},"datascience":{"lang":"en","description":"","over18":false},"letstradepedals":{"lang":"en","description":"A place to post your guitar pedal you want to trade away, while people tell you what they want to give you for it. Easy enough.","over18":false},"Sleepycabin":{"lang":"en","description":"...a safe haven during the hour of the wolf.\n\nA new media website featuring the works of Stamper, Oney, Psychicpebbles, Ricepirate, Spazkid.","over18":false},"Cameras":{"lang":"en","description":"Post reviews, articles, and videos of products, unboxings, etc. This is a subreddit to discuss new cameras and camera comparisons, camera lenses, gear and accessories. EVIL, SLR, DSLR, point and shoot","over18":false},"navyseals":{"lang":"en","description":"","over18":false},"characterdrawing":{"lang":"en","description":"This subreddit is for fans of role playing games who would like their characters drawn or for artists who want to draw characters from popular role playing games such as DnD. This is purely pro bono w","over18":false},"Minecraft360":{"lang":"en","description":"A subreddit dedicated to Minecraft on the Xbox 360/Xbox Live Arcade.","over18":false},"BeachCity":{"lang":"en","description":"Steven Universe General Lounge \n","over18":false},"Stretched":{"lang":"en","description":"","over18":false},"n64":{"lang":"en","description":"The sub-reddit for all things Nintendo 64. This ranges in anything from collections, questions, good finds, pictures, video games, videos, run-throughs, and anything imaginable, just as long as it is ","over18":false},"futanari":{"lang":"en","description":"Futanari is the Japanese word for hermaphroditism, which is also used in a broader sense for androgyny.","over18":true},"KamenRider":{"lang":"en","description":"","over18":false},"PokemonInsurgence":{"lang":"en","description":"Welcome to the Pokémon Insurgence sub-reddit! Pokemon Insurgence is a Pokemon fangame made by the creators of Pokemon Zeta and Omicron. Pokemon Insurgence has a unique region, with an enticing storyli","over18":false},"myfriendwantstoknow":{"lang":"en","description":"Does your *friend* want to know something? Well this is a place for you.. I mean it.","over18":false},"PucaTrade":{"lang":"en","description":"[PucaTrade](https://pucatrade.com) is a community of Magic: The Gathering traders from around the world.\n","over18":false},"uofm":{"lang":"en","description":"**University of Michigan subreddit**\n\nPost anything related to the University of Michigan. Be it class, sports, clubs, wanting to meet up, anything!","over18":false},"bigbangtheory":{"lang":"en","description":"For fans of the CBS comedy \"The Big Bang Theory\"","over18":false},"darknetmarketsOZ":{"lang":null,"description":"Subreddit no longer exists","over18":null},"astoria":{"lang":"en","description":"","over18":false},"Mabinogi":{"lang":"en","description":"Community for players of Nexon's MMORPG Mabinogi.","over18":false},"FCCincinnati":{"lang":"en","description":"The Official Subreddit of the Queen City's future MLS and current USL club","over18":false},"eliteexplorers":{"lang":"en","description":"With four hundred billion stars, explorers play an important role in Elite: Dangerous. This is a place where we can share useful information, noteworthy discoveries and opportunities for collaboration","over18":false},"TheWarZ":{"lang":"en","description":"Infestation, Infestation: Survivor Stories, WarZ, War Z, TheWarZ, The War Z, Hammerpoint, Hammerpoint Interactive, zombie, survival, horror, MMO, InfestationMMO\n\nInfestation, the zombie survival horro","over18":false},"Costco":{"lang":"en","description":"","over18":false},"korrasami":{"lang":"en","description":"A subreddit for anything involving the canon ship of Korra and Asami from the Avatar: The Legend of Korra.","over18":false},"PUBGXboxOne":{"lang":"en","description":"The biggest community dedicated to PUBG on the Xbox One.  News, clips, discussions, developer interaction, and more!","over18":false},"pussy":{"lang":"en","description":"({})\n\n/r/Pussy is a softcore image subreddit.  It is not about cats.\n\nSynonyms: axe wound, bearded clam, beaver, beef curtain, box, cherry, clit, clitoris, cooch, cunt, cut up, fish taco, front bottom","over18":true},"MadokaMagica":{"lang":"en","description":"Puella Magi Madoka Magica Subbreddit\n","over18":false},"BiggerThanYouThought":{"lang":"en","description":"This is a sub for girls who don't look like they're packing until they're topless or bottomless.","over18":true},"collegebaseball":{"lang":"en","description":"The ping of the metal bat, rabid college fans and a trip to the CWS, welcome to r/collegebaseball!","over18":false},"Diablo3Strategy":{"lang":"en","description":"","over18":false},"football":{"lang":"en","description":"","over18":false},"Broduce101":{"lang":"en","description":"Official Subreddit dedicated to the 2nd Season of the Mnet Survival Show Produce 101. ","over18":false},"GameDealsMeta":{"lang":"en","description":"GameDealsMeta","over18":false},"ZeroEscape":{"lang":"en","description":"Discussion, News, and everything else involving the Zero Escape series, including 999: Nine Hours, Nine Persons, Nine Doors and Zero Escape: Virtue's Last Reward, and Zero Time Dilemma.","over18":false},"CableManagement":{"lang":"en","description":"","over18":false},"skylanders":{"lang":"en","description":"/r/Skylanders is the official place on Reddit to talk about the [Skylanders](http://www.skylanders.com/) franchise, including games Skylanders: Spyro's Adventure, Skylanders: Giants, Skylanders: Swap ","over18":false},"Cisco":{"lang":"en","description":"","over18":false},"bonehurtingjuice":{"lang":"en","description":"Humour in the spirit of the original \"bone hurting juice\" meme.","over18":false},"LoLCodeTrade":{"lang":"en","description":"","over18":false},"Cruise":{"lang":"en","description":"This is a community for sharing cruise-related experiences, opinions, news, etc.","over18":false},"OpenPV":{"lang":"en","description":"OpenPV (open-source personal vaporizers) a place on reddit where you can gather knowledge to build you own vaping/ecig device.","over18":false},"neckbeardstories":{"lang":"en","description":"A sub to share your most hilarious, cringe-worthy, and sometimes creepy stories about your encounters with neckbeards and neckbeard types. \n","over18":false},"askportland":{"lang":"en","description":"\"Does it really rain all the time?\" and other thought provoking queries.","over18":false},"TheVampireDiaries":{"lang":"en","description":"","over18":false},"Perfectfit":{"lang":"en","description":"We're a subreddit for things that, surprisingly or satisfyingly, fit perfectly into each other.   \n\nAnd we'd love to have you join us! \n\n\n\nOriginally inspired by http://thingsfittingperfectlyintothing","over18":false},"Toyota":{"lang":"en","description":"All things Toyota.","over18":false},"babyelephantgifs":{"lang":"en","description":"Guaranteed to make you smile.","over18":false},"MyLittleSupportGroup":{"lang":"en","description":"","over18":false},"GreatApes":{"lang":null,"description":"Subreddit forbidden","over18":null},"alternativeart":{"lang":"en","description":"","over18":false},"weeabootales":{"lang":"en","description":"[/r/weeabootales](http://reddit.com/r/weeabootales) is the place to share your stories of over the top otaku/weeaboo that are neck deep into the Japanese culture, mostly coming in the form of anime an","over18":false},"Tomorrowland":{"lang":"en","description":"For those interested in or are attending Tomorrowland in Boom, Belgium. Our goal is to connect and unite like minded individuals from all across the globe! We encourage everyone to share pictures, vid","over18":false},"raidsecrets":{"lang":"en","description":"Secrets, theories, glitches, and more related to the game Destiny. Let's bring the community together and see if there is anything else hidden in this game!","over18":false},"immigration":{"lang":"en","description":"A place to discuss US and Worldwide immigration news, politics, visas, green cards, raids, deportations, etc.","over18":false},"Colorization":{"lang":"en","description":"[/r/Colorization](http://www.reddit.com/r/Colorization) is a subreddit that is dedicated to sharing black and white photos that you have colorized.    Colorization can be very time-consuming but the r","over18":false},"fsu":{"lang":"en","description":"An unofficial subreddit for FSU students, faculty, alumni, and interested parties.","over18":false},"FolkPunk":{"lang":"en","description":"","over18":false},"UCI":{"lang":"en","description":"A place for UCI Anteaters, and anything UCI related.","over18":false},"OCLions":{"lang":"en","description":"All About Orlando City All Day Everyday! #VamosOrlando #FaceOfCity","over18":false},"burlington":{"lang":"en","description":"Everything Burlington, Vermont. News, events, what to do and what to see.","over18":false},"synology":{"lang":"en","description":"News, discussion, and community support for Synology devices","over18":false},"hinduism":{"lang":"en","description":"The oldest living religion","over18":false},"GoneWildTrans":{"lang":"en","description":"For trans* redditors to Go Wild!","over18":true},"bimbofetish":{"lang":"en","description":"This subreddit is dedicated to the worship of one of the most extreme forms of femininity, the *bimbo*. **NSFW**","over18":true},"intrusivethoughts":{"lang":"en","description":"A subreddit for you to share all those intrusive, recurring thoughts or ideas that race through your head throughout the day. \nIntrusive thoughts are random thoughts you have that make you want to do ","over18":false},"JUSTNOFAMILY":{"lang":"en","description":"In the spirit of /r/JUSTNOMIL and /r/raisedbynarcissists  \n\nPresenting r/JustNOFamily, a support subreddit for those dealing with challenging family dynamics and/or family members with personality dis","over18":false},"Hatfilms":{"lang":"en","description":"A subreddit for all things HatFilms!","over18":false},"Reno":{"lang":"en","description":"The Biggest Little Subreddit for the Biggest Little City in the World! Welcome to /r/Reno, NV!","over18":false},"CredibleDefense":{"lang":"en","description":"*This is a subreddit dedicated to collating articles and opinion pieces relating to national security issues. \n\n*This is not at all intended to be US centric; posts relating to other countries are hig","over18":false},"NewsOfTheStupid":{"lang":"en","description":"Did you hear about the man who butt-dialed 911 while drunk driving? \n\nHow about the teenagers who carjacked a car, only to fail because neither of them could drive stick? \n\nWelcome to /r/NewsOfTheStup","over18":false},"TheDepthsBelow":{"lang":"en","description":"71% of the earth's surface is covered by water according to NOAA. That only gives us  29% where we're safe.\n\nIf an animal the size of a blue whale can disappear for months at a time, what else is down","over18":false},"waterloo":{"lang":"en","description":"The Reddit of Waterloo includes news from throughout the Region of Waterloo in Ontario, Canada. Posts of interest to residents of Cambridge, Kitchener, Waterloo, and the surrounding townships are welc","over18":false},"nameaserver":{"lang":"en","description":"Help reddit hit it's daily gold goal and you can suggest and vote on a name for one of our servers.","over18":false},"asoiafcirclejerk":{"lang":"en","description":"Oh boy! Reddit Game of Thrones fans are a wacky bunch a shitsticks! Let's point and laugh. There are books too apparently, TL;DR.\n","over18":false},"PickUpTorrents":{"lang":null,"description":"Subreddit no longer exists","over18":null},"supermoto":{"lang":"en","description":"","over18":false},"boottoobig":{"lang":"en","description":"memes that start with \"roses are red, violets are blue\" then have screencaps of stuff that complete the poem. doesn't exactly have to be \"roses are red, violets are blue\" but along those lines.\n\ninspi","over18":false},"Cascadia":{"lang":"en","description":"Some people call us the Pacific Northwest...we prefer to be known as the Nation of Cascadia! *News, art, culture and technology with a bioregional bent, from the heart of occupied Cascadia.*","over18":false},"Nostalrius":{"lang":"en","description":"Subreddit for Classic World of Warcraft, inspired by the Nostalrius 1.12.1 WoW private server.","over18":false},"trumpet":{"lang":"en","description":"","over18":false},"Hypothyroidism":{"lang":"en","description":"Devoted to the treatment and healing of hypothyroidism, Hashimoto's thyroiditis, thyroid disorders, and autoimmune diseases.","over18":false},"trollabot":{"lang":"en","description":"Test subreddit for trollabot.","over18":false},"PhillyUnion":{"lang":"en","description":"","over18":false},"pcars":{"lang":"en","description":"Welcome to /r/pcars, the home on Reddit for Slightly Mad Studios' Project CARS. Subscribe, join the community, share content & news, read our wiki, ask questions, participate in challenges or promote ","over18":false},"steinsgate":{"lang":"en","description":"In this subreddit, you may submit posts about Steins;Gate and any other title in the SciADV series, including Chaos;Head, Chaos;Child, Robotics;Notes, and more. Discussion and posts about the Science ","over18":false},"likeus":{"lang":"en","description":"Animals are conscious like us!","over18":false},"opskins":{"lang":"en","description":"OPSkins is the #1 Marketplace in the world to buy and sell CS:GO, TF2, Dota2, & H1Z1 items for real-life money.","over18":false},"interstellar":{"lang":"en","description":"Come on TARS!!!","over18":false},"Pennsylvania":{"lang":"en","description":"The Pennsylvania subreddit is a place to find news that affects residents in every part of the state. ","over18":false},"Parkour":{"lang":"en","description":"*Parkour* is a discipline with a worldwide community focusing on training to overcome any obstacle within one's path by adapting one's movements and body to the environment. In this subreddit, we disc","over18":false},"GirlsXBattle":{"lang":"en","description":"Girls X Battle is one of the most popular worldwide mobile games in 2016, which contains hundreds of gorgeous Battle Girls under master summoners command. Girls X Battle is also a game combined with t","over18":false},"Bondage":{"lang":"en","description":"A reddit for those interested in [bondage](http://en.wikipedia.org/wiki/Bondage) and its related subjects of submissive, dominant, ropes, cuffs and everything in-between.","over18":true},"Psychic":{"lang":"en","description":"/r/Psychic, the largest psychic community forum on Reddit, for those interested in extrasensory perception (ESP).\n\nAre you a psychic? Maybe an empath or empathic? Interested in the paranormal? Telekin","over18":false},"SmiteTrades":{"lang":"en","description":"A place to trade content for the video games \"SMITE\" and \"Hand of the Gods: SMITE Tactics\"","over18":false},"LDESurvival":{"lang":"en","description":"The OFFICIAL \"base\" of the Last Day on Earth: Survival game! This is the best subreddit, made by fans for fans, that is open for discussions, memes and any other thoughts related to the game.","over18":false},"mattcolville":{"lang":"en","description":"Discussion of Matt's \"Running the Game\" YouTube series, as well as D&D in general, geek culture, and Matt's various projects.","over18":false},"TuberSimulator":{"lang":"en","description":"Official subreddit for the discussion about the PewDiePie’s Tuber Simulator game. ","over18":false},"UMF":{"lang":"en","description":"","over18":false},"playmindcrack":{"lang":"en","description":"Subreddit for PlayMindcrack","over18":false},"grool":{"lang":"en","description":"We have gone private in protest of reddit's recent activites, more information can be found [here](https://www.reddit.com/r/OutOfTheLoop/comments/3bxduw/why_was_riama_along_with_a_number_of_other_larg","over18":true},"fpv":{"lang":"en","description":"","over18":false},"UsenetInvites":{"lang":"en","description":"Welcome to the usenet invites subreddit.  Please feel free to request or offer invites to sites.","over18":false},"shiba":{"lang":"en","description":"Subreddit for anything related to Shiba Inus. Post your pictures, videos, questions, etc. ","over18":false},"MoviePosterPorn":{"lang":"en","description":"High quality images of movie posters (not pornographic films).","over18":false},"TOR":{"lang":"en","description":"News and discussion about the Tor anonymity software. New to Tor? Please read the Tor FAQ!","over18":false},"spacedicks":{"lang":null,"description":"Subreddit forbidden","over18":null},"yoyhammer":{"lang":null,"description":"Subreddit forbidden","over18":null},"AskProgramming":{"lang":"en","description":"A subreddit for all your programming questions.\n","over18":false},"transpositive":{"lang":"en","description":"A place for transgender people to talk about, share, and empower each other with positive experiences.","over18":false},"dcss":{"lang":"en","description":"A subreddit dedicated to the open source roguelike game Dungeon Crawl Stone Soup.","over18":false},"theticket":{"lang":"en","description":"","over18":false},"Construction":{"lang":"en","description":"A place for tradespeople to discuss the industry.\n\nConstruction, contracting, building, electrical, HVAC, plumbing, subcontractor","over18":false},"FiestaST":{"lang":"en","description":"For fans/owners of the Ford Fiesta ST","over18":false},"Eesti":{"lang":"et","description":"Estonian subreddit. Kõik, mis eesti keeles, eestlastele või eestlastest. Feel free to post in English too.","over18":false},"NewToTF2":{"lang":"en","description":"We talk about classes, weapons, tactics, and strategy, and we don't always agree (which is a good thing).  We've got tech support, console support, scripting help, and of course piles and piles of tip","over18":false},"nasa":{"lang":"en","description":"r/NASA is for anything related to the National Aeronautics and Space Administration; the latest news, events, current mission and future missions and more. \n\n>Note: r/nasa is an unofficial forum and n","over18":false},"Hungergames":{"lang":"en","description":"A subreddit for news and discussion about the Hunger Games series by Suzanne Collins, starring Jennifer Lawrence, Josh Hutcherson, Woody Harrelson, and Liam Hemsworth.","over18":false},"Crossout":{"lang":"en","description":"Crossout Game","over18":false},"tonightsdinner":{"lang":"en","description":"","over18":false},"pillowtalkaudio":{"lang":"en","description":"Pillow Talk Audio is a subreddit that welcomes vanilla and erotic amateur audio recordings of yourself as well as any consenting partner in the genre of pillow talk. Only submissions of audio are acce","over18":true},"TheBlackList":{"lang":"en","description":"Subreddit for The Blacklist, the TV show currently airing on NBC.\n\nFor decades, ex-government agent Raymond Reddington (James Spader) has been one of the FBI's most wanted. Brokering deals for crimina","over18":false},"shittyprogramming":{"lang":"en","description":"Banned from Stack Overflow? Can't afford Experts Exchange? Post your question/tips/secrets/advice and get a response from our highly trained professional developers.","over18":false},"SavageGarden":{"lang":"en","description":"Talk about and share information and photos of carnivorous plants!","over18":false},"D3PS4":{"lang":"en","description":"Diablo 3 Players on PS4 unite!","over18":false},"ChemicalEngineering":{"lang":"en","description":"All things Chemical Engineering!","over18":false},"BarefootRunning":{"lang":"en","description":"A community of barefoot and minimalist runners.","over18":false},"USCR":{"lang":"en","description":"Reddit's home for discussion of North America's premier sports car championship!","over18":false},"Outlander":{"lang":"en","description":"A subreddit for discussion and pictures and whatever else you like about the Diana Gabaldon series.","over18":false},"wma":{"lang":"en","description":"","over18":false},"CalPoly":{"lang":"en","description":"A subreddit dedicated to California Polytechnic State University in beautiful San Luis Obispo, California.","over18":false},"shittybattlestations":{"lang":"en","description":"**OFFICIAL MISSION STATEMENT**\n\nWe will commit to continually enhance interdependent intellectual capital as well as endeavor to completely utilize high-quality resources for 100% customer satisfactio","over18":false},"30ROCK":{"lang":"en","description":"Guess which subreddit thinks gesturing with one's thumbs is for poor people, is immortal, has TWO BAD KNEES, is beautiful but doesn't know it, and hasn't cried once today? THIS ONE.\n\nA sub-reddit for ","over18":false},"RateMyNudeBody":{"lang":"en","description":"","over18":true},"cock":{"lang":"en","description":"","over18":true},"ebikes":{"lang":"en","description":"Careful, power is addicting. ","over18":false},"JerkOffToCelebs":{"lang":"en","description":"The best place to jerk off to celebrities!","over18":true},"armenia":{"lang":"en","description":"Discussion board about Armenia and Armenian issues.  Moderated to ensure civil discourse.","over18":false},"PewdiepieSubmissions":{"lang":"en","description":"This subreddit is based to submit and vote for pewdiepie related submissions and competitions.","over18":false},"GoRVing":{"lang":"en","description":"","over18":false},"rollerderby":{"lang":"en","description":"The official subreddit for the roller derby community. ","over18":false},"identifythisfont":{"lang":"en","description":"A Subreddit for Identifying Fonts: show us a sample and we'll try to find the font.","over18":false},"WGU":{"lang":"en","description":"Place for Western Governors University students, faculty and alumni.","over18":false},"LesbianActually":{"lang":"en","description":"Lesbian Actually is a place for all people who are interested in discussing lesbian pop culture, issues, questions, and challenges.  ","over18":false},"Anthropology":{"lang":"en","description":"A storehouse of linguistic, archaeological, cultural and biological anthropology information.","over18":false},"restorethefourth":{"lang":"en","description":"The official subreddit for /r/RestoretheFourth.","over18":false},"onions":{"lang":"en","description":"The Best Parts of the Anonymous Internet | Tor Onion Routing Hidden Services | .onions","over18":false},"bootroom":{"lang":"en","description":"A community to discuss soccer (football) training, coaching, and tactics.","over18":false},"House":{"lang":"en","description":"For house music enthusiasts!","over18":false},"evolution":{"lang":"en","description":"","over18":false},"mealtimevideos":{"lang":"en","description":"You know when you sit down for a meal in front of the computer and you just need something new to watch for a bit while you eat?  \nIf you search /r/videos or other places, you'll find mostly short vid","over18":false},"Kirby":{"lang":"en","description":"Welcome to /r/Kirby, a kingdom famous for peace and quiet.\n\nIt's the perfect little sub...if you like that sort of thing.","over18":false},"PathOfExileBuilds":{"lang":"en","description":"* This subreddit is a specialized subreddit for discussing Path of Exile Builds.","over18":false},"Blep":{"lang":"en","description":"A place for blep\n\n                 .--.\n                (    )\n                   _/\n    ,   ,         |\n    |\\_/|_________|\n    |> <          o\n    |_^_|-||_____||\n      U   ||     ||\n         (_|   ","over18":false},"whichbike":{"lang":"en","description":"Starting out, or branching out.\n\nOverwhelmed by choice? Let us help you choose the right bike to get you riding!","over18":false},"PSP":{"lang":"en","description":"The gaming subreddit which fits in your pocket!","over18":false},"bulletjournal":{"lang":"en","description":"A subreddit for people using or interested in starting a bullet journal.","over18":false},"sixwordstories":{"lang":"en","description":"","over18":false},"rap":{"lang":"en","description":"A place for discussion on hip hop artists.","over18":false},"WRX":{"lang":"en","description":"/r/WRX is a place for Subaru fanatics to show off their rides, discuss modifications, mechanical issues, industry news, and more. \n\nIt is not a place to buy/sell/trade or spread negativity.","over18":false},"landscaping":{"lang":"en","description":"A place to post about and discuss anything related to landscaping.","over18":false},"climbharder":{"lang":"en","description":"Reddit's rock climbing training community. Dedicated to increasing all our knowledge about how to better improve at our sport.","over18":false},"Dirtbikes":{"lang":"en","description":"I saw a lack of a good subreddit for our bikes. Sure, there is /r/motocross, but what about the people who ride trails? Okay, there's /r/dualsport, but what if my bike isn't a dualsport? You get the i","over18":false},"uAlberta":{"lang":"en","description":"The unofficial subreddit for the University of Alberta. Discuss any and all topics related to our proud school. Go Golden Bears and Pandas!\n","over18":false},"guitarcirclejerk":{"lang":"en","description":"","over18":false},"tarot":{"lang":"en","description":"The Tarot - 78 Cards of Timeless Wisdom.","over18":false},"declutter":{"lang":"en","description":"Advice, challenges, questions, inspiration and discussions about how to \nbe able to handle all the stuff you have and how to get rid of things you no longer need or want. \n\nFor people who want to tidy","over18":false},"Club_Nintendo":{"lang":"en","description":"The Club Nintendo program has ended! Join us at /r/MyNintendo\n\n**/r/Club_Nintendo** was a centralized hub for Club Nintendo members to discuss information and updates, provide help and support, share ","over18":false},"ThisIsOurMusic":{"lang":"en","description":"We are the music makers and this is our music.\nThis subreddit is dedicated to the musical artists that inhabit reddit. It is used to showcase new, in progress, or old pieces of music. It can also allo","over18":false},"Accutane":{"lang":"en","description":"For redditors who are on the road to curing their acne once and for all.  This subreddit is meant for discussions about progress, side-effects, and the like.","over18":false},"WhereIsAssange":{"lang":"en","description":"A forum to discuss current events with Julian Assange and WikiLeaks.","over18":false},"cyclocross":{"lang":"en","description":"For all things related to cyclocross - bikes, races, culture, mud, madness. The lot. ","over18":false},"destinyknot":{"lang":"en","description":"Welcome to /r/DestinyKnot! This is a subreddit for Pokémon fans to exchange Pokémon to speed up breeding!","over18":false},"INEEEEDIT":{"lang":null,"description":"Subreddit no longer exists","over18":null},"BoardwalkEmpire":{"lang":"en","description":"The official subreddit of HBO's Boardwalk Empire, starring Steve Buscemi, Kelly Macdonald, Jack Huston, Michael Shannon, Stephen Graham, Michael Kenneth Williams, and Gretchen Mol.\n\nSpoilers are an in","over18":false},"RaiBlocks":{"lang":"en","description":"Join the conversation on a dynamic cryptocurrency that is advancing blockchain technology.","over18":false},"ptsd":{"lang":"en","description":"We are a supportive, respectful community for discussion and links of interest for people who have PTSD or have friends, family members, or partners with PTSD.","over18":false},"Steep":{"lang":"en","description":"A subreddit for discussion of everything about the game Steep, the open world mountain sports game from Ubisoft Annecy.","over18":false},"redditguild":{"lang":"en","description":"","over18":false},"footballhighlights":{"lang":"en","description":"For links to best quality videos of the latest football (or soccer if that's your thing) matches on the internet.\n\n\n\n","over18":false},"OverwatchCirclejerk":{"lang":"en","description":"Welcome to MercyWatch™. Mercy main btw ;)","over18":false},"NameThatSong":{"lang":"en","description":"","over18":false},"HappyEmbarrassedGirls":{"lang":"en","description":"Happy girls caught in awkward and embarrassing situations. Created for people who enjoy watching  girls having fun in silly circumstances.","over18":true},"videogamedunkey":{"lang":"en","description":"Discuss, make jokes, post videos and everything else about videogamedunkey here!\n","over18":false},"kol":{"lang":"en","description":"A redditor is you! [Kingdom of Loathing](https://www.kingdomofloathing.com) is a free-to-play browser-based game full of puns and pop culture references with a great community! Ask questions, discuss ","over18":false},"GOtrades":{"lang":"en","description":"This is a subreddit for trading your Fate/Grand Order accounts! We currently support trade listings for all regions, including NA, JP, CN, TW, and KR.","over18":false},"facebookwins":{"lang":"en","description":"Facebook Wins","over18":false},"lawncare":{"lang":"en","description":"","over18":false},"lolgrindr":{"lang":"en","description":"Let's laugh together","over18":false},"TumblrPls":{"lang":"en","description":"What do we want? TO MOCK TUMBLR!\n\nWhy do we want it? BECAUSE THEY DESERVE IT!","over18":false},"SkyrimPorn":{"lang":"en","description":"The central hub for showing off your Skyrim visual mods and screenshots.","over18":false},"glee":{"lang":"en","description":"A subreddit to discuss the musical TV show \"Glee\", its characters and songs, and all other related content.","over18":false},"TalesFromTheCustomer":{"lang":"en","description":"A places for customers to vent and rage and even smile about their customer service experiences.","over18":false},"RainbowSixSiege":{"lang":"en","description":"WE HAVE MERGED INTO /r/Rainbow6","over18":false},"Pegging":{"lang":"en","description":"","over18":true},"thedavidpakmanshow":{"lang":"en","description":"TDPS is a progressive news and political talk program, known for controversial interviews with political and religious extremists, liberal and conservative politicians, and other guests. TDPS has been","over18":false},"MTVScream":{"lang":"en","description":"What starts as a YouTube video going viral soon leads to problems for the teenagers of Lakewood and serves as the catalyst for a murder that opens up a window to the town's troubled past.\n\nScream: The","over18":false},"climate":{"lang":"en","description":"","over18":false},"FreeBits":{"lang":"en","description":"Want free bitcoin?  You're in the right place. \n\n","over18":false},"mariokart":{"lang":"en","description":"Reddit's home for anything and everything Mario Kart.","over18":false},"13ReasonsWhy":{"lang":"en","description":"The Official Subreddit to discuss the Netflix Original Series '13 Reasons Why', based on the best-selling novel 'Thirteen Reasons Why' by Jay Asher. ","over18":false},"Antiques":{"lang":"en","description":"A subreddit to learning about and sharing antiques of all kinds. ","over18":false},"boating":{"lang":"en","description":"A place to discuss all things boating.\n","over18":false},"UGA":{"lang":"en","description":"","over18":false},"DestructiveReaders":{"lang":"en","description":"Writing Feedback: we will tell you the good, the bad, the ugly, and the horrible of your writing. RDR ~ Colorfully Destructive.","over18":false},"juicyasians":{"lang":"en","description":"A subreddit devoted to Asian ladies that have a little more \"juice\" than the average. Big tits, big butts and well-fed thick women only.\n\nSo as long as the Asian lovely is more luscious than most, pic","over18":true},"csgotrade":{"lang":"en","description":"CS:GO Trade","over18":false},"TMBR":{"lang":"en","description":"Test My Belief Reddit! TMBR is a place where we can discuss controversial topics freely and explore various ideas and opinions.","over18":false},"GoneWildTube":{"lang":"en","description":"Gonewild Tube is the place for adults to post videos of themselves in the nude and/or engaged in sexual activity in exchange for karma.  All participants must be at least 18.","over18":true},"whiteknighting":{"lang":"en","description":"Chivalry! Hi ho!","over18":false},"periwinkle":{"lang":"en","description":"The Kingdom of Periwinkle!","over18":false},"selfpublish":{"lang":"en","description":"A place to discuss just about everything in the world of indie books.","over18":false},"AskLosAngeles":{"lang":"en","description":"For questions about the city of Los Angeles, CA and its surrounding communities. ","over18":false},"AskTechnology":{"lang":"en","description":"","over18":false},"pantsu":{"lang":"en","description":"For fanservicey art from manga, anime, VNs, JRPGs, etc.","over18":true},"essential":{"lang":"en","description":"A place to discuss the new Consumer Electronics Company, Essential. Phone, Home, Ambient, discussion all welcome here. ","over18":false},"IndiansGoneWild":{"lang":"en","description":"A place for all Indians to show off their beautiful bodies. Indians and people with origins from the Indian subcontinent are welcome to post.","over18":true},"lawbreakers":{"lang":"en","description":"Discussion for LawBreakers - the new title from Boss Key Productions and Nexon America","over18":false},"njpw":{"lang":"en","description":"A subreddit dedicated to New Japan Pro-Wrestling. Bringing you news, information and updates on the world of New Japan Pro-Wrestling and its wrestlers.","over18":false},"TheAmericans":{"lang":"en","description":"The reddit home of FX's espionage period drama The Americans starring Keri Russell and Matthew Rhys.\n\nWelcome Comrades","over18":false},"k_on":{"lang":"en","description":"","over18":false},"Torchlight":{"lang":"en","description":"","over18":false},"birdpics":{"lang":"en","description":"**It is like bird watching, only on Reddit.**","over18":false},"steampunk":{"lang":"en","description":"","over18":false},"psych":{"lang":"en","description":"A subreddit devoted to all things [Psych](http://psych.usanetwork.com/). If you're a fan of the silliest TV show on USA Network, slice open a pineapple and subscribe today!","over18":false},"intermittentfasting":{"lang":"en","description":"Intermittent Fasting(IF) is way of eating that restricts *when* you eat, usually on a daily or weekly schedule.  People engage in IF to reap the many benefits to health, fitness, mental clarity, or be","over18":false},"volleyball":{"lang":"en","description":"/r/volleyball is Reddit's volleyball community. We have tips, videos, and general discussions about volleyball.","over18":false},"MoviePassClub":{"lang":"en","description":"/r/MoviePassClub is dedicated to the discussion of all Movie Theater Subscription Services.  This includes, but is not limited to: MoviePass, AMC A*List, Sinemia, Cinemark Movie Club, & Alamo Season P","over18":false},"Yugioh101":{"lang":"en","description":"This subreddit is dedicated to a healthy community of inexperienced duelists and veteran duelists making an effort to join or rejoin the fun.","over18":false},"holdmycosmo":{"lang":"en","description":"Girls failing at life in funny ways, usually drunk. Hold my cosmo aka HMC.","over18":false},"StoppedWorking":{"lang":"en","description":"Pictures, Gifs, and Videos of animals (including humans and some exceptions of robots and machines) that have Stopped Working!\n","over18":false},"ResearchMarkets":{"lang":null,"description":"Subreddit no longer exists","over18":null},"TFABLinePorn":{"lang":"en","description":"We need a place to share our HPTs (home pregnancy tests) and our OPKs (ovulation predictor kits). Here you can ask for another set of eyes! Because we all love confirmation! \n","over18":false},"sffpc":{"lang":"en","description":"All about small form factor PCs. Anything sub-20L is welcome.","over18":false},"RightwingLGBT":{"lang":"en","description":"/r/RightwingLGBT is political subreddit for LGBT people. We focus on right-wing politics and discussion of the regressive left as it pertains to and damages our community.","over18":false},"Dashcam":{"lang":"en","description":"Everything about vehicle Dash Cameras","over18":false},"drupal":{"lang":"en","description":"The place for news, articles and discussion regarding Drupal, one of the top open source (GPL) CMS platforms powering millions of websites and applications, built, used, and supported by a diverse com","over18":false},"AnimeSketch":{"lang":"en","description":"A place for anyone who loves anime to show their art to the rest of the world.","over18":false},"swdestiny":{"lang":"en","description":"The Collectible Dice and Card Game","over18":false},"adultswim":{"lang":"en","description":"All kids out of the pool. This is the unofficial subreddit for [adult swim], which airs everyday from 8pm-6am EST on Cartoon Network.","over18":false},"TheHobbit":{"lang":"en","description":"A subreddit for discussion about \"The Hobbit\" and Tolkien's works, be they books, movies, radio plays, music, art, you get the idea!\n\nGet involved!","over18":false},"Injusticegame":{"lang":"en","description":"The Injustice: Gods Among Us community's home, where we can talk, show, and view everything Injustice 24/7. Everybody and anybody who has an interest in Injustice is more than welcome to join in discu","over18":false},"Libraries":{"lang":"en","description":"book\nbooks\nlibrary\nlibraries\nlibrarian\nmlis\nreading","over18":false},"Adoption":{"lang":"en","description":"For adoptive families, birth families, adoptees, and other interested individuals to share stories, support each other, and discuss adoption-related news.","over18":false},"treemusic":{"lang":"en","description":"Tree Music","over18":false},"sharehearthstone":{"lang":null,"description":"Subreddit forbidden","over18":null},"MysteryDungeon":{"lang":"en","description":"For all of us brave explorers and adventurers.","over18":false},"MosinNagant":{"lang":"en","description":"","over18":false},"bangalore":{"lang":"en","description":"","over18":false},"women":{"lang":"en","description":"A safe, respectful space to discuss the lives and stories of women of all backgrounds, and the current events which affect us. \n\nTrans people and especially trans feminine people are expressly welcome","over18":false},"OurPresident":{"lang":"en","description":"/r/OurPresident is a community supporting Bernie's bid for President in 2020, and organizing for a working class takeover of the Democratic Party. That said, we also strongly support candidates, polic","over18":false},"Mid_Century":{"lang":"en","description":"A community for enthusiasts of mid century modern design. From Charles and Ray Eames to Paul McCobb and Adrian Pearsall.","over18":false},"optometry":{"lang":"en","description":"A sub-reddit for all things eye related!","over18":false},"Autoflowers":{"lang":"en","description":"A community for the cultivation of Autoflowering Cannabis.","over18":false},"psychotherapy":{"lang":"en","description":"This is a place where mental health professionals and students can share and discuss topics related to psychotherapy.  We encourage discussion of therapeutic techniques, information related to careers","over18":false},"macsetups":{"lang":"en","description":"The place for people to share and discuss their Mac computer setups.","over18":false},"Hue":{"lang":"en","description":"# Philips Hue Reddit Community","over18":false},"Landlord":{"lang":"en","description":"/r/Landlord is a community for landlords to come together to discuss anything landlord related.  News, ideas, blog posts, websites, resources, etc. which can help a landlord are welcomed. \n\nKeep all d","over18":false},"askmath":{"lang":"en","description":"A subreddit for math questions.\n\nDo you have a math question? Can you help others with their math questions? Come join us!","over18":false},"Blackout2015":{"lang":"en","description":"A place to discuss current meta-events.\n \n","over18":false},"LAlist":{"lang":"en","description":"A Los Angeles community to post craigslist posts for other redditors to buy, sell, rent, and more.","over18":false},"pureasoiaf":{"lang":"en","description":"/r/PureASOIAF is devoted to the book series *A Song of Ice and Fire* and associated written works by George R.R. Martin.  This subreddit focuses only on the written works and does not allow content fr","over18":false},"pinball":{"lang":"en","description":"","over18":false},"fastfood":{"lang":"en","description":"","over18":false},"HistoryWhatIf":{"lang":"en","description":"","over18":false},"vergecurrency":{"lang":"en","description":"Verge is a cryptocurrency designed for people and for everyday use. It improves upon the original Bitcoin blockchain and aims to fulfill its initial purpose of providing individuals and businesses wit","over18":false},"Skullgirls":{"lang":"en","description":"It's Skullgirls, baybee!","over18":false},"kde":{"lang":"en","description":"KDE is an international technology team creating user-friendly free and open source software for desktop and portable computing. KDE's software runs on GNU/Linux, BSD and other operating systems, incl","over18":false},"civbeyondearth":{"lang":"en","description":"A central hub for all Sid Meier's C:BE news!","over18":false},"burstingout":{"lang":"en","description":"","over18":true},"kurdistan":{"lang":"en","description":"/r/Kurdistan is a forum where Kurds and their friends can discuss anything related to Kurdistan. Do you have a question about Kurdish history, language, politics, economy, or ANYTHING else? This is th","over18":false},"cannabis":{"lang":"en","description":"Cannabis news from across the Universe.","over18":false},"cablefail":{"lang":"en","description":"","over18":false},"monsterhunterclan":{"lang":"en","description":"A Subreddit for finding fellow hunters in Monster Hunter","over18":false},"comicbookcollecting":{"lang":"en","description":"Do you collect comic books or comic book art? Or are you just interested in the world of collecting? Either way come here for discussion, news, purchase pictures and collections.","over18":false},"LARP":{"lang":"en","description":"[](#header) [](#null)\nA subreddit for LARP (Live Action Role Playing) related content. This includes LARPs across the globe, LARPing gear, how-to guides, questions and ideas related to LARPing, articl","over18":false},"dragonquest":{"lang":"en","description":"The Dragonlord must be defeated. May the light shine upon thee, Hero.","over18":false},"FireflyFestival":{"lang":"en","description":"Firefly Music Festival is the East Coast's \"premier\" music experience held annually in The Woodlands of Dover International Speedway in Delaware. ","over18":false},"trains":{"lang":"en","description":"","over18":false},"ROTC":{"lang":"en","description":"","over18":false},"Journalism":{"lang":"en","description":"Discussions about the practice of journalism","over18":false},"tomhiddleston":{"lang":"en","description":"A love of all things Tom Hiddleston and anything that directly links to that lovely, lovely man. \n\nAll sorts of relevant things about Hiddles go here. News articles, video interviews, screenshots from","over18":false},"RelayForReddit":{"lang":"en","description":"A place for announcements, discussion and bug reports for the android app \"Relay for reddit\".","over18":false},"GetStudying":{"lang":"en","description":"","over18":false},"TWDRoadToSurvival":{"lang":"en","description":"**Subreddit for the mobile game The Walking Dead: Road to Survival**\n\n[Get it on the Google Play Store](https://play.google.com/store/apps/details?id=com.scopely.headshot&hl=en)\n\n[Get it on the App St","over18":false},"GalaxyS3":{"lang":"en","description":"A subreddit dedicated to the Samsung Galaxy S3.","over18":false},"Loans":{"lang":"en","description":"[This subreddit has migrated to /r/Borrow](https://www.reddit.com/r/Borrow)\n","over18":false},"farmingsimulator":{"lang":"en","description":"Dedicated to everything Farming Simulator by GIANTS Software","over18":false},"AlbumArtPorn":{"lang":"en","description":"High quality images of album art.","over18":false},"Chefit":{"lang":"en","description":"It's a subreddit for chefs to network, discuss ideas and concepts, and talk about the food world in general. What else do you really need to know?","over18":false},"EA_FIFA":{"lang":"en","description":"A subreddit for EA Sports FIFA Series, the world's greatest football game.\n\n**/r/EA_FIFA** is dedicated to EA Sports' FIFA Series, the greatest football franchise in video games. Whether you're on *Xb","over18":false},"Ashens":{"lang":"en","description":"The world's #1 Ashens subreddit from 2012 - 2018, as voted for by the moderators of /r/Ashens. Discuss everything from the latest cheap tat to the length of Chef Excellence's moustache.","over18":false},"dank_meme":{"lang":"en","description":"Dank Memes","over18":false},"ArtCrit":{"lang":"en","description":"Art Critique","over18":false},"CompTIA":{"lang":"en","description":"From the \"looking to get certified,\" to conversations/questions from current students, to certified and working professionals - this subreddit is dedicated to CompTIA certifications.","over18":false},"cfs":{"lang":"en","description":"For research, treatments, and personal stories regarding Chronic Fatigue Syndrome/ME/SEID.","over18":false},"maximumfun":{"lang":"en","description":"This is the reddit community associated with MaximumFun.org's activities.","over18":false},"dykesgonewild":{"lang":"en","description":"","over18":true},"Pensacola":{"lang":"en","description":"","over18":false},"aquaponics":{"lang":"en","description":"","over18":false},"eczema":{"lang":"en","description":"A subreddit designed to help those looking for help in all matters relating to Eczema.  Whether it's relating anecdotes for support, giving advice, or looking for help... All posts welcome (minus spam","over18":false},"WWEChampions":{"lang":"en","description":"The subreddit for the mobile puzzle RPG WWE Champions.","over18":false},"Broadway":{"lang":"en","description":"","over18":false},"Dinosaurs":{"lang":"en","description":"RAWR! ","over18":false},"TumblrAtRest":{"lang":"en","description":"News, articles, and Tumblr posts that offer more sense and a lot less vitriol and pseudo-science than the typical Tumblr SJW.","over18":false},"screenshots":{"lang":"en","description":"","over18":false},"GoneErotic":{"lang":"en","description":"(Best viewed in old reddit.)\n\nGoneErotic is a sub for sharing your sexy pictures in a more teasing and naughty nature, instead of being explicit. Leaving something to the imagination, it's a sub that'","over18":true},"AdvancedFitness":{"lang":"en","description":"This reddit is a place to learn, teach, and share information on the myriad ways we all work to improve our health and fitness, and achieve our training goals.  Primarily aimed at non-beginners, thoug","over18":false},"linuxmint":{"lang":"en","description":"News, Discussion, and Support for Linux Mint\n\nThe Linux Mint Subreddit: for news, discussion and support for the Linux distribution Linux Mint.\n","over18":false},"pokemonbattles":{"lang":"en","description":"A place for casual or competitive Pokemon battles.\n\n","over18":false},"ImagesOfNewYork":{"lang":"en","description":"Pictures and images of New York","over18":false},"devops":{"lang":"en","description":"","over18":false},"medlabprofessionals":{"lang":"en","description":"Medical Lab Scientists\nMedical Lab Technicians\nCytogeneticists\nCytotechnologists\nHistologists\nPhlebotomists\nLab Processors\n","over18":false},"SquaredCirclejerk":{"lang":"en","description":"","over18":false},"newfoundland":{"lang":"en","description":"","over18":false},"gwcumsluts":{"lang":"en","description":"Gone wild cumsluts. Real redditors, covered in cum.","over18":true},"dune":{"lang":"en","description":"Where the spice flows...on the internet!","over18":false},"AnimalPorn":{"lang":"en","description":"High quality images of animals (not having sex).","over18":false},"PostCollapse":{"lang":"en","description":"A subreddit dedicated to collecting information is case of a Collapse of society, with the side goal of creating a downloadable wiki for use during one. ","over18":false},"mathrock":{"lang":"en","description":"suck it, dinkleberg","over18":false},"braswap":{"lang":"en","description":"For those who have bras that don't fit any more, or just have plain too many.  \n\n","over18":false},"purebattlefield":{"lang":"en","description":"PURE BATTLEFIELD is a gaming community that aims to provide socially rewarding, community-oriented gaming experiences to the gaming public.  \n\nWe are run \"by the players, for the players,\" and operate","over18":false},"mueflair":{"lang":null,"description":"Subreddit forbidden","over18":null},"whatsthatbook":{"lang":"en","description":"Can't remember the title of the book you've enjoyed reading? Crowdsource it to readers on Reddit!","over18":false},"McJuggerNuggets":{"lang":"en","description":"The #1 place for discussing all things McJuggerNuggets!","over18":false},"WeirdWheels":{"lang":"en","description":"Welcome and have fun! We focus on the unusual in vehicles, auto tech and art. We like the obscure as well as the weird and love to see what you've spotted.  ","over18":false},"ArchitecturePorn":{"lang":"en","description":"High quality images of architecture.","over18":false},"istp":{"lang":"en","description":"For redditors interested in the Myers-Briggs Type Indicator (MBTI), specifically those identifying as or interested in Introverted Sensing Thinking Perceiving persons (ISTP).\n\n","over18":false},"pokemongoLondon":{"lang":"en","description":"Pokemon GO London Community - Augmented Reality Mobile MMO","over18":false},"Ghostbc":{"lang":"en","description":"A forum dedicated to the Swedish occult rock band Ghost.","over18":false},"oasis":{"lang":"en","description":"/r/Oasis is Reddit's #1 community for all the latest news and discussion about and relating to Oasis, including Liam Gallagher's solo project, Noel Gallagher's High Flying Birds, Beady Eye, and everyt","over18":false},"animegifs":{"lang":"en","description":"For all SFW Animated Gifs that include Anime.  For NSFW anime gifs, go to /r/nsfwanimegifs","over18":false},"LivestreamFails":{"lang":"en","description":"#The subreddit you are looking for is /r/LivestreamFail\n\n\n**This subreddit is no longer active. All new livestream fail posts can be found at /r/Livestreamfail**\n\n\n\n","over18":false},"FullmetalAlchemist":{"lang":"en","description":"A subreddit for the Fullmetal Alchemist franchise, including the manga, the two anime, and all related content.","over18":false},"gradadmissions":{"lang":"en","description":"This subreddit is for anyone who is going through the process of getting into graduate school, and for those who've been there and have advice to give.","over18":false},"Guiltygear":{"lang":"en","description":"","over18":false},"walkingwarrobots":{"lang":"en","description":"Fan subreddit of the PvP mecha-combat game War Robots","over18":false},"fresno":{"lang":"en","description":"A place to find out what's going on in the greater Fresno Metro area. ","over18":false},"css":{"lang":"en","description":"For discussing Cascading Style Sheets, design principles, and technological innovations related to web development.","over18":false},"norfolk":{"lang":"en","description":"Everything in & around Norfolk, Virginia Beach, and the greater Hampton Roads/Tidewater/Coastal Virginia region.","over18":false},"ActLikeYouBelong":{"lang":"en","description":"That time you were able to get someplace you shouldn't have been just by looking the part and acting confident. ","over18":false},"NarutoFanfiction":{"lang":"en","description":"The place to come for fanfiction stories that take place in or use characters from the Naruto universe.","over18":false},"Lubbock":{"lang":"en","description":"Public exchange for and by Lubbockites both home and abroad.","over18":false},"video":{"lang":"en","description":"Check out /r/videos, /r/videosplus, /r/vidoes!","over18":false},"PanicHistory":{"lang":"en","description":"PanicHistory: Keeping track of the hivemind's hysterical predictions of doom","over18":false},"Arkansas":{"lang":"en","description":"This subreddit is intended to serve as a centralized communications hub for the state of Arkansas to include Arkansas news, events, random discussion, Arkansas sports, or anything as long as it's abou","over18":false},"PokemonQRCodes":{"lang":"en","description":"The place to discuss and share QR injection for Gen VI Pokémon games","over18":false},"reactjs":{"lang":"en","description":"A community for learning and developing web applications using React by Facebook.","over18":false},"regularshow":{"lang":"en","description":"The Reddit home of Regular Show fanart, discussion and more.","over18":false},"freedesign":{"lang":null,"description":"Subreddit forbidden","over18":null},"providence":{"lang":"en","description":"","over18":false},"InfrastructurePorn":{"lang":"en","description":"High quality images of infrastructure.","over18":false},"msu":{"lang":"en","description":"","over18":false},"EmDrive":{"lang":"en","description":"","over18":false},"52weeksofcooking":{"lang":"en","description":"Each week, we give you an ingredient, technique, cuisine, or inspiration. Each week, you cook a dish in that theme and share the results. Each week, your culinary repertoire gets a little bigger.","over18":false},"ask":{"lang":"en","description":"","over18":false},"metalworking":{"lang":"en","description":"This subreddit contains almost every aspect of metalworking. This includes but is not limited to welding, machining, casting and general fabrication. ","over18":false},"pokemonconspiracies":{"lang":"en","description":"This subreddit has gone private in solidarity with the moderators of r/IAMA and other subreddits. For more information, see [here.](https://www.reddit.com/r/OutOfTheLoop/comments/3bxduw/why_was_riama_","over18":false},"PokelandLegends":{"lang":"en","description":"Discuss and find out more about Pokeland Legends, the iOS and Android App.","over18":false},"steamdeals":{"lang":"en","description":"Not all of us have access to Steam every day, so it's nice to have the sales posted to Reddit. Hooray for cheap stuff!","over18":false},"E30":{"lang":"en","description":"","over18":false},"nightvale":{"lang":"en","description":"A subreddit to discuss and share things about the Welcome to Night Vale podcast.","over18":false},"SpaceXLounge":{"lang":"en","description":"Welcome to r/SpaceXLounge, sister subreddit to r/SpaceX. A place for relaxed and laidback discussion about SpaceX! This board is not an official outlet for SpaceX information.","over18":false},"TheSecretWorld":{"lang":"en","description":" www.tsw-builder.com","over18":false},"husky":{"lang":"en","description":"This subreddit is dedicated to Siberian huskies, anything related to the beautiful dog. If you are looking for a University of Washington subreddit, there is one already [here](http://www.reddit.com/r","over18":false},"Besiege":{"lang":"en","description":"A Subreddit for the new castle crushing puzzle builder by Spiderling Games!","over18":false},"csgo_trading":{"lang":null,"description":"Subreddit forbidden","over18":null},"ghibli":{"lang":"en","description":"Studio Ghibli is a Japanese animation film studio founded in June 1985 by the directors **Hayao Miyazaki** and **Isao Takahata** and the producer **Toshio Suzuki**. The company's logo features the cha","over18":false},"omise_go":{"lang":"en","description":"OmiseGO (OMG) is the Plasma decentralized exchange, hosting an open-source digital wallet platform from Omise, connecting mainstream payments, cross-border remittances, and much more.\n\nFiat & crypto-f","over18":false},"CoolGamesInc":{"lang":"en","description":"A subreddit for fans of the CoolGames Inc podcast.","over18":false},"galaxys4":{"lang":"en","description":"Welcome to /r/galaxys4 , where we discuss everything S4.","over18":false},"InsightfulQuestions":{"lang":"en","description":"","over18":false},"mitchjones":{"lang":null,"description":"Subreddit forbidden","over18":null},"beauty":{"lang":"en","description":"A guide for all things beauty: makeup, fashion, health and wellness, tips, how-tos, and DIYs.","over18":false},"Ubiquiti":{"lang":"en","description":"This is a place to discuss all of Ubiquiti's products, such as the EdgeRouter, Unifi, AirFiber, etc.","over18":false},"Illustration":{"lang":"en","description":"","over18":false},"yorku":{"lang":"en","description":"The subreddit for York University in Toronto: The 3rd largest university in Canada and home to the Schulich School of Business and Osgoode Hall Law School.","over18":false},"fallenlondon":{"lang":"en","description":"Welcome to Fallen London!\n\nThis is a place for fans and players of the game to make connections, discuss lore, formulate strategies, share ideas and generally just enjoy each other's company.\n","over18":false},"DigitalPainting":{"lang":"en","description":"Welcome!\n\nThe purpose of r/DigitalPainting is to nurture growing artists. Be prepared to receive constructive critique on your art. Be active and participate in the conversations, give critiques! Bein","over18":false},"OfficialDP":{"lang":"en","description":"","over18":false},"mercedes_benz":{"lang":"en","description":"A place for Mercedes-Benz fans to meet, share stories, news, pictures and other interesting information about our beloved brand.","over18":false},"IsItBullshit":{"lang":"en","description":"IsItBullshit? Ask the community about a product, service, or program that seems sketchy, and see if anyone has any insight. Already know something is bullshit? Go ahead and post it and tell us why!\n","over18":false},"softwareswap":{"lang":null,"description":"Subreddit forbidden","over18":null},"fitgirls":{"lang":"en","description":"Athletic girls who are attractive.","over18":true},"stencils":{"lang":"en","description":"","over18":false},"unchartedmultiplayer":{"lang":"en","description":"This subreddit is for discussing and sharing anything relating to the multiplayer of Naughty Dog's Uncharted series of video games. For the singleplayer content head over to /r/uncharted.","over18":false},"rally":{"lang":"en","description":"News related to all forms of rally and offroad motorsports - WRC, RallyAmerica, NASA Rally Sport, RallyCross, etc.","over18":false},"springfieldMO":{"lang":"en","description":"A subreddit for residents, visitors, college students, or vagrants of Springfield, Missouri, the 417 area code, and the greater Ozarks area.","over18":false},"abletonlive":{"lang":"en","description":"A subreddit for users of the music software Ableton Live.","over18":false},"dashpay":{"lang":"en","description":"Dash aims to be the most scalable and most user-friendly cryptocurrency in the world. Its network features instantly confirmed transactions, erasable transaction history and a self-governing & self-fu","over18":false},"desmoines":{"lang":"en","description":"","over18":false},"googleplaydeals":{"lang":"en","description":"The best deals on the Google Play store!","over18":false},"Louisiana":{"lang":"en","description":"Louisiana, Home to Alligators, Mosquitoes, and Crooked Politicians.","over18":false},"redditoroftheday":{"lang":"en","description":"redditors are asked similar questions and are given an opportunity to elaborate. The results are then posted for your information and entertainment or general wtfness. ","over18":false},"WastedGifs":{"lang":"en","description":"Watch things get wasted in here.","over18":false},"The_Mueller":{"lang":"en","description":"This is a subreddit for memes depicting Special Counsel Robert Mueller III, and his ongoing investigation of the Trump administration's ties to Russia. ","over18":false},"lookatmydog":{"lang":"en","description":"A community founded on a simple premise - sharing pictures of our canines!","over18":false},"BHMGoneWild":{"lang":"en","description":"A place for the big & sexy men of Reddit to be appreciated by the ladies who love them. A male-centric friend of GWPlus if you will. ","over18":true},"SRSWomen":{"lang":null,"description":"Subreddit forbidden","over18":null},"SequelMemes":{"lang":"en","description":"Memes of the Star Wars Sequels","over18":false},"deathnote":{"lang":"en","description":"Subreddit for all about Death Note.\n\nDeath Note is a critically acclaimed manga written by Tsugumi Ohba, a thriller centered around a deadly mind game between two geniuses. One is a high school studen","over18":false},"memphisgrizzlies":{"lang":"en","description":"Subreddit for the Memphis Grizzlies of the NBA","over18":false},"RedvsBlue":{"lang":"en","description":"The Subreddit for Red vs. Blue!","over18":false},"firewater":{"lang":"en","description":"Share techniques, equipment, still designs, recipes, materials sources, and anything related to beverage distillation.","over18":false},"circlejerkaustralia":{"lang":"en","description":"Dredd said if I shutdown the subreddit I could be unbanned -whytiederp","over18":false},"goth":{"lang":"en","description":"Reddit's Goth Community, for all things spooky and goth.","over18":false},"350z":{"lang":"en","description":"This is a community for all Nissan 350Z enthusiasts to come together and discuss their love for the most important letter in the alphabet. ","over18":false},"TheAmazingRace":{"lang":"en","description":"Reddit's home for The Amazing Race.","over18":false},"okc":{"lang":"en","description":"The Oklahoma City subreddit","over18":false},"doommetal":{"lang":"en","description":"Vinum Sabbathi.","over18":false},"raiseyourdongers":{"lang":"en","description":"ヽ༼ຈل͜ຈ༽ﾉ raise your dongers ヽ༼ຈل͜ຈ༽ﾉヽ༼ຈل͜ຈ༽ﾉ raise your dongers ヽ༼ຈل͜ຈ༽ﾉヽ༼ຈل͜ຈ༽ﾉ raise your dongers ヽ༼ຈل͜ຈ༽ﾉヽ༼ຈل͜ຈ༽ﾉ raise your dongers ヽ༼ຈل͜ຈ༽ﾉヽ༼ຈل͜ຈ༽ﾉ raise your dongers ヽ༼ຈل͜ຈ༽ﾉヽ༼ຈل͜ຈ༽ﾉ raise your ","over18":false},"SJSU":{"lang":"en","description":"A community of prospective and current students, alumni, faculty and staff, and locals of Silicon Valley. Share and discuss anything related to San José State University. Spartan Up!","over18":false},"Songwriters":{"lang":"en","description":"/r/Songwriters is a community for musical artists to share and discuss songwriting and the songs they've written.","over18":false},"bodymods":{"lang":"en","description":"","over18":false},"Triumph":{"lang":"en","description":"Any and all things Triumph. \n\nShow your own, talk about them, get/give info, etc. Anything about these great motorcycles goes. \n\n\n\n","over18":false},"vegancirclejerk":{"lang":"en","description":"","over18":false},"ukraine":{"lang":"en","description":"Ukraine - Україна","over18":false},"just_post":{"lang":"en","description":"post post post I want to see yur posts I want to be yur friend","over18":false},"Catloaf":{"lang":"en","description":"A place for all Catloaf kind, by Catloaf kind.","over18":false},"Pieces":{"lang":"en","description":"","over18":false},"trapmuzik":{"lang":"en","description":"","over18":false},"ecommerce":{"lang":"en","description":"","over18":false},"matlab":{"lang":"en","description":"Official MATLAB subreddit - a place to discuss the MATLAB programming language and its implementation.","over18":false},"dontdeadopeninside":{"lang":"en","description":"Welcome to /r/dontdeadopeninside, it's for signs/media that read as nonsense if read normally: from left to right:  \n[The OG](http://i.imgur.com/Ipg62jA.jpg)","over18":false},"GarlicBreadMemes":{"lang":"en","description":"Do you like Garlic bread?\nIs your sense of humor similar to that of an inbred?\nIf so get ready for some fresh out of the oven Garlic bread memes","over18":false},"canon":{"lang":"en","description":"","over18":false},"ehlersdanlos":{"lang":"en","description":"","over18":false},"TopsAndBottoms":{"lang":"en","description":"Gay sex: what's hot, what's not, and how to do it better ","over18":true},"improv":{"lang":"en","description":"We discuss news and experiences pertaining to improv. We make our fellow redditors look GREAT.","over18":false},"Bacon":{"lang":"en","description":"Bacon is the only food that goes great with absolutely everything.  ","over18":false},"vapeitforward":{"lang":"en","description":"This is a subreddit to \"Pay it Forward\" with vaping supplies - e-juice, mods, batteries, etc.  As we vape, we accumulate, so let's pass on the good fortune! ","over18":false},"fargo":{"lang":"en","description":"City of Fargo Subreddit. Includes surrounding areas of Moorhead and West Fargo (among others). ","over18":false},"60fpsporn":{"lang":"en","description":"Porn at 60 fps. It's pretty self-explanatory.","over18":true},"Radiology":{"lang":"en","description":"We aim to become the reddit home of radiologists, radiographers, technologists, sonographers and lay-users interested in medical imaging. Redditors may post medical images and links to relevant articl","over18":false},"carcrash":{"lang":"en","description":"Videos, Gifs and Pictures of Car Crashes","over18":false},"bostontrees":{"lang":"en","description":"r/BostonTrees is a subreddit for the civil discussion of Marijuana in and around Boston, Massachusetts. Join the conversation today.","over18":false},"ArtistLounge":{"lang":"en","description":"A place for artists from redditgetsdrawn, sketchdaily, and other art-related subs to come together and discuss all things related to art, including technique, art crit, different media, the practice o","over18":false},"stupidslutsclub":{"lang":"en","description":"This is an area for like-minded sluts to socialize, play, and challenge each other. A place for people who want to feel degraded, hurt, and ruined, and who are craving a community of others who want t","over18":true},"taoism":{"lang":"en","description":"Taoism (or Daoism). Dreaming you're a butterfly?  \n\n/r/taoism is dedicated to the insightful and thoughtful discussion of Taoism.","over18":false},"dancegavindance":{"lang":"en","description":"A subreddit for fans of the post-hardcore band Dance Gavin Dance. News, Discussions, live videos, covers, remixes and lots more!\n\nMake sure you're viewing the sub off mobile for the best experience, w","over18":false},"Saxophonics":{"lang":"en","description":"","over18":false},"vagabond":{"lang":"en","description":"A digital community created by vagabonds, for vagabonds! \n\nHitchhikers, Trainhoppers, Rubbertramps, Backpackers, and more!\n\nFeel free to share stories and pictures about your adventures on the road, o","over18":false},"cardistry":{"lang":"en","description":"Cardistry is the art of creating fascinating motions and formations with a deck of cards.","over18":false},"superstarsmtown":{"lang":"en","description":"SuperStar SMTown is a rhythm game, made by Dalcomsoft, featuring artists from SM Entertainment. It is also a sister game to \"SuperStar JYPNation\" and \"SuperStar BTS.\"","over18":false},"gifsthatkeepongiving":{"lang":"en","description":"For those specific gifs that just keeps on giving","over18":false},"stonerrock":{"lang":"en","description":"","over18":false},"scientology":{"lang":"en","description":"A sub for the discussion of all things Scientology related.","over18":false},"ZMR":{"lang":"en","description":"An excellent subreddit for Zombies Monsters Robots.","over18":false},"americandad":{"lang":"en","description":"Good morning USA!","over18":false},"ecchi":{"lang":"en","description":"Ecchi, NSFW pictures of anime characters.","over18":true},"evenewbies":{"lang":"en","description":"","over18":false},"TruthOrDareMe":{"lang":"en","description":"Don't be a chicken! \n\n/r/TruthOrDareMe is the everlasting game of truth or dare, in subreddit format. Users make a post choosing either truth or dare, and let the suggestions roll in!\n\n(Thanks to /u/c","over18":false},"fcs":{"lang":"en","description":"The official, unofficial subreddit for the NCAA Division 1 Football Championship!","over18":false},"cassetteculture":{"lang":"en","description":"","over18":false},"BeautyAddiction":{"lang":"en","description":"Closes. Access will not be given, do not message.","over18":false},"blackbookgraffiti":{"lang":"en","description":"Welcome to r/BlackBookGraffiti; a community for showing off and getting feedback on graffiti sketches and canvases. \nIf you're new to the whole thing, be sure to check out r/graffhelp for some handy g","over18":false},"sharepoint":{"lang":"en","description":"Supporting the SharePoint Community since 2009, /r/sharepoint is a diverse group of SharePoint Administrators, Architects, Developers, and Business users.\n\nAll SharePoint on-premises and SharePoint On","over18":false},"NCSU":{"lang":"en","description":"A reddit community for member of the Wolfpack nation! Welcome all NC State fans, staff, alumni, students, and future students. GO PACK!","over18":false},"wichita":{"lang":"en","description":"A subreddit for residents of Kansas' largest city.","over18":false},"veganfitness":{"lang":"en","description":"The place to come and discuss vegan fitness, bodybuilding, and health.","over18":false},"ploompax":{"lang":"en","description":"A fan owned and operated subreddit to talk about the PAX vaporizer by PAX Labs. We are currently CLOSED for spam removal and subreddit changes. Don’t message us for access.","over18":false},"Snus":{"lang":"en","description":"Snus is a pasteurized, air-cured, smokeless and spitless tobacco, usually found in pouches. It originated in Sweden nearly 300 years ago, and is the origin of modern American dip. Snus is the safest, ","over18":false},"foreskin":{"lang":"en","description":"A place to post photos or videos of foreskin, and discuss the natural beauty of our uncut members.","over18":true},"EndlessWar":{"lang":"en","description":"\"No nation could preserve its freedom in the midst of continual warfare.\" - James Madison\n\n\"War is a Racket.\" - Gen. Smedley Butler\n\nThis is a community that should discuss American policies and actio","over18":false},"uwo":{"lang":"en","description":"A subreddit for students, faculty, staff, and alumni at The University of Western Ontario in London, Ontario, Canada.","over18":false},"CorporateFacepalm":{"lang":"en","description":"Doesn't have to be /r/wtf worthy, just silly social media mishaps from large companies ","over18":false},"dragonvale":{"lang":"en","description":"Subreddit dedicated to the 2010 mobile game Dragonvale. Breed dragons together to discover new ones! Ask for help, gain some friends, participate in game events!","over18":false},"mobilerepair":{"lang":"en","description":"* Come here to discuss news, techniques, or anything you'd like related to cell phone, tablet, & laptop repair.","over18":false},"OreGairuSNAFU":{"lang":"en","description":"Everything about My Teen Romantic Comedy SNAFU!\nHave discussions and share things about My Teen Romantic Comedy SNAFU!","over18":false},"NZXT":{"lang":"en","description":"We 💜 building PCs and the people who build them.","over18":false},"GreatXboxDeals":{"lang":"en","description":"Your one stop shop for all Xbox related deals! Join the community and share your Great Xbox Deals!","over18":false},"coding":{"lang":"en","description":"","over18":false},"aphextwin":{"lang":"en","description":"A subreddit for Aphex Twin, the man, the myth and the pseudo-transcendent beats.","over18":false},"darknetplan":{"lang":"en","description":"","over18":false},"Chihuahua":{"lang":"en","description":"A subreddit for all about Chihuahuas.  These little dogs get into your heart.  Chihuahuas are not an accessory.  Let's break the stereotype.","over18":false},"fashion":{"lang":"en","description":"Fashion, fashion industry, fashion news, clothing, fashion design","over18":false},"nl_Kripparrian":{"lang":"en","description":"Subreddit for everything Kripparrian. ","over18":false},"PhilosophyofScience":{"lang":"en","description":"","over18":false},"greenville":{"lang":"en","description":"Greenville, SC\n\n#yeahTHATgreenville","over18":false},"deepweb":{"lang":"en","description":"This subreddit exists to debunk urban legends and share real verifiable information from the far reaches of the Tor [dark web](https://en.wikipedia.org/wiki/Dark_web).","over18":false},"magicthecirclejerking":{"lang":"en","description":"A place to make fun of posts in /r/MagicTCG or the Magic community at (arbitrarily) large.","over18":false},"IncestPorn":{"lang":"en","description":"Incest-themed NSFW videos.","over18":true},"SmiteLFM":{"lang":"en","description":"","over18":false},"saskatchewan":{"lang":"en","description":"","over18":false},"BuffaloWizards":{"lang":null,"description":"Subreddit forbidden","over18":null},"afinil":{"lang":"en","description":"Modafinil (Provigil, Modalert) and related compounds. Experiences, questions, and vendor reviews for non-modafinil/armodafinil vendors welcome.","over18":true},"Gamecube":{"lang":"en","description":"The GameCube (Japanese: ゲームキューブ Hepburn: Gēmukyūbu?, officially called the Nintendo GameCube, abbreviated NGC in Japan and GCN in Europe and North America) is a home video game console released by Nin","over18":false},"DailyDouble":{"lang":"en","description":"Answers you never knew you wanted the question to!\n\nA Jeopardy-themed subreddit.","over18":false},"STD":{"lang":"en","description":"Feeling paranoid about that one night stand?  Condom broke?  Got some scary blood results back? Need help understanding what your labs are saying?  Share your stories, concerns and questions here.  An","over18":false},"Punny":{"lang":"en","description":"A subreddit for pun lovers","over18":false},"Drag":{"lang":"en","description":"A community for all the fabulous Kings and Queens of Reddit","over18":false},"HxHBattleAllStars":{"lang":null,"description":"Subreddit forbidden","over18":null},"neutralnews":{"lang":"en","description":"A community dedicated to polite and empirical discussion of current events. For more in-depth discussion of political issues that are *not* current events, please see our sister subreddit /r/NeutralPo","over18":false},"RoyaleRecruit":{"lang":"en","description":"The clan recruitment subreddit for /r/ClashRoyale!","over18":false},"hamsters":{"lang":"en","description":"This sub is dedicated to hamsters and their humans.","over18":false},"BestOfReports":{"lang":"en","description":"Only the most hilarious and entertaining reasons for reports.","over18":false},"artificial":{"lang":"en","description":"Reddit's home for Artificial Intelligence","over18":false},"uofmn":{"lang":"en","description":"For all redditors familiar with the University of Minnesota: Twin Cities (current and prospective students, alumni, parents, and fans).\n\nGo Gophers!","over18":false},"HaloWars":{"lang":"en","description":"Discussion around the Xbox RTS.","over18":false},"prey":{"lang":"en","description":"This subreddit is dedicated to the video game Prey, developed by Arkane Studios and published by Bethesda Softworks. Come here to talk with other people who love playing Prey.","over18":false},"waltonchain":{"lang":"en","description":"Creating an open ecosystem that seamlessly combines the blockchain and the internet of things.","over18":false},"AmateurArchives":{"lang":null,"description":"Subreddit no longer exists","over18":null},"singedmains":{"lang":"en","description":"Welcome to singedmains, the most toxic community on reddit.","over18":false},"TheStrain":{"lang":"en","description":"[](http://www.reddit.com/r/TheStrain/comments/2frx3a/the_strain_1x09_the_disappeared_postepisod)Subreddit for The Strain, a TV series in on FX.","over18":false},"Equality":{"lang":"en","description":"","over18":false},"dreamcast":{"lang":"en","description":"","over18":false},"SCBuildIt":{"lang":"en","description":"This is a community for the EA mobile game Simcity BuildIt.","over18":false},"kitchener":{"lang":"en","description":"Reddit community for the City of Kitchener, Canada","over18":false},"mirrorsedge":{"lang":"en","description":"The Mirror's Edge subreddit","over18":false},"bravelydefault":{"lang":"en","description":"Bravely Default, known as Bravely Default: Flying Fairy (ブレイブリーデフォルト フライングフェアリー Bureiburī Deforuto: Furaingu Fearī?) in Japan, is a role-playing video game by Square Enix for the Nintendo 3DS, a spiri","over18":false},"powerwashingporn":{"lang":"en","description":"For all things that have been power washed.","over18":false},"StPetersburgFL":{"lang":"en","description":"The sub-reddit for St. Petersburg. FL! Interesting happenings in and around the Tampa Bay area.","over18":false},"Canning":{"lang":"en","description":"","over18":false},"kettlebell":{"lang":"en","description":"Forum for kettlebell enthusiasts.","over18":false},"galaxynote5":{"lang":"en","description":"Galaxy Note 5 support, news, tips, discussions and many more! Ask and learn anything about Note 5 in general and maybe even technical. We do not have restrictions but no affiliate links please.","over18":false},"Frasier":{"lang":"en","description":"Subreddit for people who love the sitcom Frasier. \n\n","over18":false},"JizzedToThis":{"lang":"en","description":"The JO community diary. Show us what made you cum.","over18":true},"dolan":{"lang":"en","description":"","over18":true},"GrassHopperVape":{"lang":"en","description":"Grasshopper vaporizer also known as Zenpen","over18":false},"NYCbike":{"lang":"en","description":"A subreddit for cyclists in the New York City area.","over18":false},"PlayJustSurvive":{"lang":"en","description":"Subreddit for the game Just Survive by Daybreak Game Company\n\n","over18":false},"Bitcoincash":{"lang":"en","description":"Bitcoin Cash (BCH) brings sound money to the world. Merchants and users are empowered with low fees and reliable confirmations. The future shines brightly with unrestricted growth, global adoption, pe","over18":false},"LatinoPeopleTwitter":{"lang":"en","description":"Latino and Hispanic culture is pervasive","over18":false},"meetup":{"lang":"en","description":"Find or organize meetups in your area! Not for sex.","over18":false},"ukbike":{"lang":"en","description":"A little space for us UK cyclists.\n\n^((Image memes run the risk of being deleted)^)","over18":false},"Alabama":{"lang":"en","description":"","over18":false},"redstone":{"lang":"en","description":"","over18":false},"workaholics":{"lang":"en","description":"Workaholics is a television sitcom that premiered on Comedy Central on April 6, 2011. The series is going on it's sixth season, and is predominantly written by its stars Blake Anderson, Adam DeVine, a","over18":false},"IdiotsInCars":{"lang":"en","description":"When idiots get behind the wheel of an automobile, shit gets funny.","over18":false},"mega64":{"lang":"en","description":"Official Reddit for Mega64.","over18":false},"UnsentLetters":{"lang":"en","description":"A place to write a letter you don't intend to send.","over18":false},"gaybroscirclejerk":{"lang":"en","description":"This is a subreddit intended to satirize /r/gaybros, /r/askgayrbos, etc","over18":true},"dauntless":{"lang":"en","description":"Dauntless is a co-op action RPG in Open Beta on PC. You can download and play for free at PlayDauntless.com.\n\nBattle ferocious Behemoths, craft powerful weapons, and forge your legend in the Shattered","over18":false},"Talonmains":{"lang":"en","description":"A domicile for those fond of shanking foes in the popular cyber environment, DotA 3.5, otherwise known as League of Faker. Produced by Blizzard, this game has an extensive roster of over 6 characters ","over18":false},"moped":{"lang":"en","description":"/r/moped, or mopeddit, is for discussion and celebration of vintage mopeds on Reddit. We ride mostly 1970s pedal-equipped two-stroke models, such as those manufactured by Puch, Motobécane, Peugeot, To","over18":false},"DaveAndBusters":{"lang":"en","description":"This subreddit is the place for anything related to the Dave & Buster's restaurant/arcade chain, with a focus on strategies for winning and profiting from their redemption games.  All D&B-related post","over18":false},"GolfClash":{"lang":"en","description":"The sun is shining, it’s time to play the real-time multiplayer game everybody’s talking about!\n\nPlay on beautiful courses against players around the world in real-time as you compete in tournaments, ","over18":false},"PHPhelp":{"lang":"en","description":"Post specific problems or questions you have about PHP or your code. Hopefully someone will be able to help you out! \n\nIf you got something out of here, please contribute back and help others :)","over18":false},"rickygervais":{"lang":"en","description":"A subreddit for fans of comedian [Ricky Gervais](http://en.wikipedia.org/wiki/Ricky_Gervais), and his frequent collaborators [Steve Merchant](http://en.wikipedia.org/wiki/Stephen_Merchant) and [Karl P","over18":false},"SOPA":{"lang":"en","description":"For the discussion of the Stop Online Piracy Act.","over18":false},"SeriousConversation":{"lang":"en","description":"A sister sub of /r/CasualConversation \n\n#Let's Talk\n\nWe all know that life isn't always casual. Sometimes we need to process serious topics & events. So here we go, Let's talk!","over18":false},"Archaeology":{"lang":"en","description":"","over18":false},"RepTime":{"lang":"en","description":"Affiliated with the other replica subs, /r/Fashionreps and /r/Repsneakers, here ","over18":false},"whatsthisrock":{"lang":"en","description":"Dedicated to identifying mysterious rocks and minerals.  ","over18":false},"UBreddit":{"lang":"en","description":"The sUBreddit for all things University at Buffalo/SUNY at Buffalo/UB! Any and all students, alumni, faculty and staff are welcome to share news, photos, ask questions, and communicate with other memb","over18":false},"jerseycity":{"lang":"en","description":"A community for redditors in and around Jersey City, New Jersey. \n \nPlease use the search bar and check out the sidebar before posting!","over18":false},"grilling":{"lang":"en","description":"Welcome to /r/Grilling, a Subreddit for all Tips, Recipes, Pictures, and anything related to Grilling!","over18":false},"DrugStashes":{"lang":"en","description":"Pictures of drug and pharaphernalia collections, and large amounts of drugs. Share the love!\n\nStrictly no sourcing.","over18":false},"VisitingIceland":{"lang":"en","description":"Everything about visiting Iceland. Get your questions answered and share any tips and advice you might have for travellers.","over18":false},"NEU":{"lang":"en","description":"News and discussion of interest to students, faculty, employees, and neighbors of Northeastern University in Boston, MA.","over18":false},"Cuphead":{"lang":"en","description":"Cuphead is a classic run 'n' gun set in the style of a one-on-one fighting game universe. Inspired by cartoons of the 1930's, the visuals and audio were painstakingly created with the same techniques ","over18":false},"foxes":{"lang":"en","description":"The fox - one of the most amazing animals there is! Submit pictures, questions, or anything related to foxes. For the species in the genus *Vulpes* or any other 'true fox' species.","over18":false},"maddenmobilebuysell":{"lang":"en","description":"This sub is for buying and selling things in madden mobile only.","over18":false},"TechNewsToday":{"lang":"en","description":"Community submission and voting area for the Tech News Today Audience.","over18":false},"edmprodcirclejerk":{"lang":"en","description":"I don't really know what this sub does, it just makes everything very, very, way more louder.","over18":false},"parentsofmultiples":{"lang":"en","description":"","over18":false},"Ark_PS4_Community":{"lang":"en","description":"Help keep this sub alive. \nDonatations greatly appreciated\npaypal.me/bazkav","over18":false},"ProductTesting":{"lang":"en","description":"This subreddit is to discuss websites that offer products for testing. Work together to fuel each others' daily addiction to more stuff.","over18":false},"AskAnthropology":{"lang":"en","description":"","over18":false},"flexibility":{"lang":"en","description":"Get flexible! Share stretching tips, post your goals and progress, and anything else relevant to flexibility/mobility. Whether you're a dancer, martial artist, gymnast, cheerleader, olympic weightlift","over18":false},"ImagesOfEngland":{"lang":"en","description":"Pictures and images of England","over18":false},"Overwatch_Memes":{"lang":"en","description":"**Dank Overwatch Memes**\n\n\nOverwatch™ is a team-based shooter where heroes do battle in a world of conflict. Overwatch features a vibrant roster of heroes and diverse objective-based maps.\n\n\nPost shit","over18":false},"wien":{"lang":"de","description":"A subreddit for inhabitants, citizens, visitors, tourists, expats and other people interested in the Austrian capital, Vienna.\n\nEin subreddit für Bewohner, Bürger, Besucher, Touristen, Expatrioten und","over18":false},"diyaudio":{"lang":"en","description":"","over18":false},"Helicopters":{"lang":"en","description":"Helicopters Subreddit","over18":false},"dragonballfighterz":{"lang":"en","description":"A two dimensional fighting game, developed by Arc System Works & produced by Bandai Namco.","over18":false},"GuitarHero":{"lang":"en","description":"This is a subreddit for all of your Guitar Hero needs! Need help with something? Don't be afraid to ask! Just passed Through the Fire and Flames for the first time? Don't be afraid to post about it! :","over18":false},"killthosewhodisagree":{"lang":"en","description":"See a ridiculous post insinuating that those with a holier-than-thou attitude want to kill anyone who doesn't share their personal preferences? Post it here for sweet delicious karma. ","over18":false},"CafeRacers":{"lang":"en","description":"","over18":false},"FFXIVRECRUITMENT":{"lang":"en","description":"A place to advertise your Free Company, Linkshell, Group, or PvP Team.","over18":false},"spiderbro":{"lang":"en","description":"A place for friends of spiders, who are our bros. \n\nSpiders are fun, mostly friendly creatures that just want to enjoy a good meal (albeit of flies) and chill like you do. \n\nPost your favorite pics or","over18":false},"apolloapp":{"lang":"en","description":"A delightful Reddit client for iPhone.","over18":false},"DeadSpace":{"lang":"en","description":"","over18":false},"WeissSchwarz":{"lang":"en","description":"For everything related to Weiß Schwarz.","over18":false},"travisscott":{"lang":"en","description":"The Travis Scott Subreddit","over18":false},"EvilLeagueOfEvil":{"lang":"en","description":"Rule #1: We win or prevent others from winning.","over18":false},"3DSdeals":{"lang":"en","description":"This subreddit is about finding and sharing the best deals for Nintendo's 3DS family of consoles, games, and accessories!","over18":false},"gats":{"lang":null,"description":"Subreddit forbidden","over18":null},"ForeverAloneDating":{"lang":"en","description":"","over18":false},"modeltrains":{"lang":"en","description":"","over18":false},"JimSterling":{"lang":"en","description":"A subreddit dedicated to the man who was not the man who was the Batman: Jim Sterling.\n\nEverything he does. Put it in here. Then we'll put it in you. It will be like a big Jim Sterling orgy. A Jimorgy","over18":false},"HaircareScience":{"lang":"en","description":"This subreddit aims to provide resources for achieving better hair quality through scientific research in trichology, physiology, chemistry, and biology.","over18":false},"fordranger":{"lang":"en","description":"A Subreddit to discuss anything Ford Ranger related.","over18":false},"Vindictus":{"lang":"en","description":"We are a community of current, retired, and prospective Vindictus players.","over18":false},"GrandCherokee":{"lang":"en","description":"","over18":false},"familyguy":{"lang":"en","description":"A subreddit dedicated to the TV show *Family Guy*.\n","over18":false},"SexWorkers":{"lang":"en","description":"","over18":false},"diypedals":{"lang":"en","description":"reddit's community for DIY Pedal Builders!","over18":false},"Dream_Market":{"lang":null,"description":"Subreddit no longer exists","over18":null},"mildlypenis":{"lang":"en","description":"A subreddit dedicated to items that have some sort of phallic nature.","over18":false},"Demotivational":{"lang":"en","description":"r/Demotivational: A place for mocking those annoying motivational posters that Human Resources keeps putting up everywhere to improve morale.","over18":false},"SubredditDramaDrama":{"lang":"en","description":"","over18":false},"bioinformatics":{"lang":"en","description":"##news for genome hackers\n------\n\nA subreddit dedicated to bioinformatics, computational genomics and systems biology.","over18":false},"Maya":{"lang":"en","description":"All things Maya related! Would you like to send an error report?","over18":false},"BorderlandsPreSequel":{"lang":"en","description":"Borderlands Pre-Sequel Subreddit, for those wishing to discuss the game and recent news.","over18":false},"itsaunixsystem":{"lang":"en","description":"A subreddit for every over the top, embarrassing, and down right flat out incorrect usage of Technology found in Movies, TV Shows, and Video Games! ","over18":false},"Astroneer":{"lang":"en","description":"Astroneer is a space-based sandbox adventure game being developed by System Era Softworks. The player is tasked with colonizing planets, creating structures and mining resources. Astroneer has no set ","over18":false},"LifeAfterNarcissism":{"lang":"en","description":"A place for those who are moving on from narcissistic family or relationship dynamics.","over18":false},"4Xgaming":{"lang":"en","description":"A subreddit for 4X strategy games.\n","over18":false},"internetparents":{"lang":"en","description":"Ask the internet about things your parents never taught you.","over18":false},"dicemasters":{"lang":"en","description":"Welcome to /r/DiceMasters!\n\nThis subreddit is *the* source for all things Dice Masters - news, fan sites, opinions, and whatever else you might want to discuss!","over18":false},"Delightfullychubby":{"lang":"en","description":"All things cute, adorable, and chubby. We mostly feature animals, but all delightfully chubby content is welcome! This is including, but not limited to: pics, images, memes, animations, gifs, videos, ","over18":false},"kreiswichs":{"lang":"de","description":"Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente Ente ","over18":false},"Objectivism":{"lang":"en","description":"Objectivism: A Philosophy for Life on Earth","over18":false},"HUTrep":{"lang":"en","description":"","over18":false},"UWMadison":{"lang":"en","description":"","over18":false},"roadtrip":{"lang":"en","description":"/r/roadtrip is your source for everything road trip related. Whether you enjoy traveling by motorcycle, car, or recreational vehicle this is your destination for everything related to road trips!\n\n","over18":false},"ragecomics":{"lang":"en","description":"Rage Comics\nRageComics\nrage comic\nragecomic\n9gag\nFu\nF7u12\nFfuu\nfffuuu\nFfffuuuu\nFffffuuuuu\nFfffffuuuuuu\nfffffffuuuuuuuuuuuuu\nf7u12\nRage\nragecomics\nRage comics\n","over18":false},"Awww":{"lang":"en","description":"A subreddit with minimal rules for stuff that makes you go *awww*!\n\nFeel free to post pics, gifs, or videos of cats, dogs, babies or anything cute.","over18":false},"Virginia":{"lang":"en","description":"Virginia: The Old Dominion","over18":false},"thewestwing":{"lang":"en","description":"Reddit's home for one of the greatest television series, NBC's The West Wing.","over18":false},"unt":{"lang":"en","description":"The unofficial reddit of the University of North Texas, or UNT.","over18":false},"museum":{"lang":"en","description":"The Reddit Museum","over18":false},"gpumining":{"lang":"en","description":"The new Reddit redesign is currently incompatible with this subreddit.\nPlease [click this link](https://old.reddit.com/r/gpumining/) to see this community as it's meant to be displayed.","over18":false},"misophonia":{"lang":"en","description":"[Misophonia, literally “hatred of sound,” is a form of decreased sound tolerance.](http://en.wikipedia.org/wiki/Misophonia)\n","over18":false},"laravel":{"lang":"en","description":"Laravel is a web application framework with expressive, elegant syntax. We believe development must be an enjoyable, creative experience to be truly fulfilling. Laravel attempts to take the pain out o","over18":false},"Elsanna":{"lang":"en","description":"A subreddit for fans of the Elsa x Anna (or 'Elsanna') pairing from Disney's \"Frozen\"","over18":false},"ColinsLastStand":{"lang":"en","description":"Colin’s Last Stand aims to exercise your brain by giving you weekly videos that delve deep into the historical and political issues of our time, not to mention the issues of long ago.","over18":false},"composer":{"lang":"en","description":"/r/composer is a reddit for submitting and discussing your art music. ","over18":false},"whatsthisworth":{"lang":"en","description":"A subreddit created so you can try to find out what that item you have is and what it is worth! Please see below for guidelines, helpful posts, and related subreddits.","over18":false},"savannah":{"lang":"en","description":"","over18":false},"Pathfinder":{"lang":"en","description":"For Pathfinder Society, the Organized Play branch of the Pathfinder tabletop game! Discuss, organize, all that fun stuff!","over18":false},"HollywoodUndead":{"lang":"en","description":"This is a sub-reddit dedicated to Hollywood Undead, a rap/rock band hailing from Los Angeles, California. \n/u/athesgiant","over18":false},"AskHistory":{"lang":"en","description":"For asking questions about History. Also see r/History or r/AskHistorians.","over18":false},"PcMasterRaceBuilds":{"lang":"en","description":"Home of the world famous PCMR builds!","over18":false},"badMovies":{"lang":"en","description":"The official subreddit for the celebration of movies that are so bad, they're good.","over18":false},"lucifer":{"lang":"en","description":"Subreddit for the Netflix drama *Lucifer* based on the DC/Vertigo comics","over18":false},"thefighterandthekid":{"lang":"en","description":"Welcome to the fighter and the kid subreddit, we discuss the podcast here.","over18":false},"PeopleBeingJerks":{"lang":"en","description":"A place for sharing videos, gifs, and images of people being total jerks.\n","over18":false},"salty":{"lang":"en","description":"Home of the FGC, and people who actually play fighting games","over18":false},"ghettoglamourshots":{"lang":"en","description":"Where Faith in Humanity Comes to Die","over18":false},"IOTAmarkets":{"lang":"en","description":"Welcome to r/IOTAmarkets! -- IOTA is a quantum-resistant distributed ledger protocol launched in 2015, focused on being useful for the emerging m2m economy of Internet-of-Things (IoT), data integrity,","over18":false},"Dodge":{"lang":"en","description":"Dodge Cars and Trucks!","over18":false},"shacomains":{"lang":"en","description":"A place welcome to all Shaco mains. This is a subreddit for everything and anything related to Shaco. Please use NSFW tags appropriately.","over18":false},"microsoftsoftwareswap":{"lang":"en","description":"This is the central marketplace for all microsoft software, whether you are selling digital downloads keys or installation discs with keys.  There are many sites with tough restrictions on this type o","over18":false},"puns":{"lang":"en","description":"##Familiarize yourself with the rules before posting.","over18":false},"WormFanfic":{"lang":"en","description":"A subreddit in which you can share good fanfics of Worm.","over18":false},"nsfw_wtf":{"lang":"en","description":"A fucked up place for fucked up people","over18":true},"mindcrackcirclejerk":{"lang":"en","description":"ssssssssssss","over18":false},"LofiHipHop":{"lang":"en","description":"A subreddit dedicated to the discussion and submission of things related to the Lo-fi Hip Hop community.","over18":false},"Theatre":{"lang":"en","description":"Theatre; theory, design, news and community.","over18":false},"IndianGaming":{"lang":"en","description":"Sub-reddit of and for Indian Gamers , come here for all your Indian Gaming Needs !   \nVisit our Wiki if you have any questions about Steam India , or make a post! ","over18":false},"porn":{"lang":"en","description":"**/r/Porn** is a NSFW image hub for the vast array of pornography across reddit.  All images posted here originate on other subreddits and are then posted here with the [subreddit] in the title.  \n` `","over18":true},"hiphop101":{"lang":"en","description":"Cause we all got at least one question, and we all got at least one answer too!","over18":false},"StarWarsArmada":{"lang":"en","description":"A place to discuss the [Star Wars Armada Miniatures Game](http://www.fantasyflightgames.com/edge_minisite.asp?eidm=270) new expansions, expansion ideas, tactics, balance issues, Alternate rules. ","over18":false},"deaf":{"lang":"en","description":"There are many distinct Deaf communities around the world, which communicate using different sign languages and exhibit different cultural norms. Deaf identity also intersects with other kinds of cult","over18":false},"HomeDepot":{"lang":"en","description":"","over18":false},"DrawForMe":{"lang":"en","description":"This is a request forum for people who would like to see their ideas, photos, and concepts created by user volunteered artists. ","over18":false},"FiveYearsAgoOnReddit":{"lang":"en","description":"* Auto-reposts of things from five years ago, maybe something interesting will come up\n* *n* times a day, *m* posts from the same date 5 years ago, where *n* and *m* are numbers I haven't decided on y","over18":false},"Lineage2Revolution":{"lang":"en","description":"A subreddit for discussion of the mobile MMORPG Lineage 2 Revolution","over18":false},"rustfactions":{"lang":"en","description":"Rust Factions Role Play Server. ","over18":false},"Miscreated":{"lang":"en","description":"**Miscreated** is a brutal, post-apocalyptic, survival-based MMORPG unlike anything you've played before.  It was originally inspired by the popular mod for Arma II, DayZ.","over18":false},"GirlswithGlasses":{"lang":"en","description":"Sexy girls with glasses","over18":true},"Celiac":{"lang":"en","description":"","over18":false},"AVexchange":{"lang":"en","description":"A place to put all your used or un-used Audio or Video gear. Projectors, Receivers, Headphones, Speakers, Custom Cables, Vintage Units, Monitors.. Anything you can see or hear it goes here, see?","over18":false},"Ameristralia":{"lang":"en","description":"For all things 'Mercian and Aussie. Because two kick ass countries is better than one.","over18":false},"RPGMaker":{"lang":"en","description":"This is a subreddit focused on discussing RPG Maker. This includes any version from 95 to MV to any of the console titles.","over18":false},"papermario":{"lang":"en","description":"","over18":false},"newreddits":{"lang":"en","description":"Since there are a ton of new reddits, and discovering the good ones can be hard, discover or announce them here.\n","over18":false},"etymology":{"lang":"en","description":"Discuss the origins of words and phrases, in English or any other language.","over18":false},"TheCube":{"lang":null,"description":"Subreddit forbidden","over18":null},"TooAfraidToAsk":{"lang":"en","description":"If you have a strange, weird, and potentially embarrassing question about absolutely anything at all, this is the place for it. ","over18":false},"Playdate":{"lang":"en","description":"A subreddit for playing games with other redditors.\n\nWe encourage you to join our community or talk to a moderator if you have any questions. You can also join our Steam Group and Chat.","over18":false},"unexpectedjihad":{"lang":"en","description":"ayy 💣💣💣","over18":false},"Basketball":{"lang":"en","description":"","over18":false},"OOTP":{"lang":"en","description":"Subreddit dedicated to the baseball management game, Out of the Park Baseball.","over18":false},"diablo2":{"lang":"en","description":"This subreddit is for people who people who want to discuss Diablo 2. Whether you need help, want to trade, or you're just looking to chat- come join us!","over18":false},"NSFW411":{"lang":"en","description":"Guide to the NSFW world of reddit.","over18":true},"ArenaHS":{"lang":"en","description":"Everything about Hearthstone's arena mode","over18":false},"Lisk":{"lang":"en","description":"Lisk enables JavaScript developers to deploy their own sidechain and develop blockchain applications on top of it.","over18":false},"TheOA":{"lang":"en","description":"Subreddit for the Netflix show 'The OA' created by Zal Batmanglij & Brit Marling ","over18":false},"StonerPhilosophy":{"lang":"en","description":"Stoner Philosophy for people  who are high, or in a similarly lofty mindset.\n","over18":false},"SCREENPRINTING":{"lang":"en","description":"","over18":false},"GirlsMirin":{"lang":"en","description":"A subreddit to post woman 'mirin on men or women.\n\nPics, gifs, and videos are all quality 'mirin material.","over18":false},"TeamFourStar":{"lang":"en","description":"The Official Subreddit of the YouTube comedy troupe, Team Four Star. ","over18":false},"NMSGalacticHub":{"lang":"en","description":"Welcome to the NMS Galactic Hubreddit. The Galactic Hub is an area of space (11 regions) centered around the Arm of Vezitinen, located at coordinates 042F:0078:0D55:0021. Our capital planet [New Lenno","over18":false},"badmathematics":{"lang":"en","description":"A place for sharing the bad math that plagues reddit and the internet as a whole. ","over18":false},"notebooks":{"lang":"en","description":"Notebooks and related stationery: \"any aspect of your life which you want to give more conscious attention to can be used as the foundation for a notebook.\" ","over18":false},"onebag":{"lang":"en","description":"This is a community devoted to the idea of lugging around less crap.  Fewer, higher quality items, packed into a single bag for ease of transport make life simpler.  Feel free to share your favorite b","over18":false},"dust514":{"lang":"en","description":"Subreddit for Dust 514 or Dust514, the new FPS/MMO from CCP","over18":false},"instantkarma":{"lang":"en","description":"Post anything that's instant karma, i.e. good or bad behavior followed by appropriate karma (eg someone acting unethically & then being immediately caught or punished, or vice-versa). Thanks & enjoy","over18":false},"magicrush":{"lang":"en","description":"News, discussion, fan art for the mobile game app Magic Rush: Heroes. ","over18":false},"AquaSwap":{"lang":"en","description":"A friendly international place where everything aquatic can be traded, sold, bought, or given away! ","over18":false},"HomestarRunner":{"lang":"en","description":"The unlicensed-unlicensed community dedicated to the web animation series Homestar Runner!","over18":false},"Corvette":{"lang":"en","description":"A subreddit for any and all Corvette related media and discussion. ","over18":false},"wildhearthstone":{"lang":"en","description":"A place for discussion about Hearthstone's Wild format.","over18":false},"commandline":{"lang":"en","description":"This is for anything regarding the command line, in any operating system. All questions (including dumb ones), tips, and interesting programs/console applications you've found or made yourself are wel","over18":false},"juul":{"lang":"en","description":"Ever feel like a plastic bag, drifting through the wind, wanting to Juul again? Maybe not, regardless, this is your home for all things Juul.","over18":false},"TalesFromThePharmacy":{"lang":"en","description":"Pharmacy work requires its own special laws and regulations and with it comes so many wonderful problems.\n\nHow many times do you find yourself saying any of these:\n- Your insurance sets the price\n- Th","over18":false},"securityguards":{"lang":"en","description":"A subreddit for private and government security professionals around the globe.","over18":false},"fireTV":{"lang":"en","description":"This is a subreddit dedicated to the discussion of FireTV products from Amazon.","over18":false},"feedthebeastservers":{"lang":"en","description":"feedthebeastservers","over18":false},"creepypasta":{"lang":"en","description":"/r/Creepypasta: Because you weren't planning on sleeping anytime soon.","over18":false},"FieldOfKarmicGlory":{"lang":"en","description":"","over18":false},"trypophobia":{"lang":"en","description":"","over18":false},"LetsPlayCritiques":{"lang":"en","description":"A subreddit made for YouTube creators to come together to help each other out by giving and receiving feedback.","over18":false},"wowthissubexists":{"lang":"en","description":"Subreddits you didn't think existed, but they do. Go ahead and tell us about it.","over18":false},"dykesgonemild":{"lang":"en","description":"","over18":false},"BostonTerrier":{"lang":"en","description":"","over18":false},"southcarolina":{"lang":"en","description":"South Carolina is the best Carolina!","over18":false},"nonmonogamy":{"lang":"en","description":"","over18":false},"IPTV":{"lang":"en","description":"Internet Protocol television (IPTV) is a system through which television services are delivered using the Internet protocol suite over a packet-switched network such as a LAN or the Internet, instead ","over18":false},"Hedgehog":{"lang":"en","description":"For information on pet hedgehogs (so-called \"African Pygmy Hedgehogs\") and wild hedgehogs.","over18":false},"Syracuse":{"lang":"en","description":"/r/Syracuse is a place to find, share, rate and rank local news, videos, photos and more for Syracuse and Central New York. Show others what they may be missing in CNY, and be sure to be respectful of","over18":false},"respectthreads":{"lang":"en","description":"Respect threads about individual characters or teams for use and reference with /r/whowouldwin battles. \n\n","over18":false},"Esperanto":{"lang":"eo","description":"Welcome to the Esperanto subreddit! Esperanto is a widely spoken universal language. It's one of the easiest languages to learn!\n\nOn /r/Esperanto, feel free to ask questions, post relevant links, and ","over18":false},"malelifestyle":{"lang":"en","description":"The community of interest for man at his best. ","over18":false},"TerraBattle":{"lang":"en","description":"Subreddit for the mobile RPG series, Terra Battle, by Mistwalker Corporation. Produced by Hironobu Sakaguchi, father of the Final Fantasy series. Music composed by Nobuo Uematsu. Character design by K","over18":false},"Chipotle":{"lang":"en","description":"A place for employees and customers alike to come together and share their appreciation for Chipotle Mexican Grill.","over18":false},"tekkit":{"lang":"en","description":"","over18":false},"bleachshirts":{"lang":"en","description":"Make shirts, share them, have fun\n","over18":false},"IndoorGarden":{"lang":"en","description":"A place to discuss tip on growing an indoor garden, including herbs and vegetables.","over18":false},"S2000":{"lang":"en","description":"","over18":false},"Watercolor":{"lang":"en","description":"A place for everything to do with watercolor painting. \n\nSubmit your current paintings, give and receive critiques. Post resources such as tutorials, ask questions, learn about and  the art of waterco","over18":false},"broslikeus":{"lang":"en","description":" A subreddit for your favorite N/SFW pics of bromos.","over18":true},"ducks":{"lang":"en","description":"Home of the University of Oregon Athletics.","over18":false},"SBU":{"lang":"en","description":"A subreddit devoted to Stony Brook University students and alumni.","over18":false},"LegionFX":{"lang":"en","description":"Legion is a television series created for FX by Noah Hawley (Fargo), based on the Marvel Comics character of the same name. It is connected to the X-Men film series, the first television series to do ","over18":false},"roguelikedev":{"lang":"en","description":"A community of active roguelike developers. Learn how to make a roguelike, share your progress, follow what others are creating, and engage in discussions about a broad range of related topics and res","over18":false},"badroommates":{"lang":"en","description":"Give us your tales of bad roommates. The gross, the annoying, the psychotic.\n\nAnd if you have the solution to bad roommates, please let us know!","over18":false},"JonBenet":{"lang":"en","description":"In memory of JonBenét Ramsey (August 6, 1990 – December 25, 1996.) A six-year-old American child beauty queen who was murdered in her home on Christmas Day. ","over18":false},"Kombucha":{"lang":"en","description":"Kombucha Tea is a fermented beverage traditionally made from sweetened black tea using a mother or SCOBY (Symbiotic Colony of Bacteria and Yeasts).","over18":false},"ask_transgender":{"lang":"en","description":"Transgender questions, transgender answers.","over18":false},"Bulldogs":{"lang":"en","description":"","over18":false},"titlegore":{"lang":"en","description":"For all those cringey titles you find :D","over18":false},"holidaybullshit":{"lang":"en","description":"Attempting to unravel the mysteries of Cards Against Humanity's puzzle contest in their \"Eight Sensible Gifts for Hanukkah\" 2015 holiday promotion...one(hundred) wild theory(s) at a time.","over18":false},"facebook":{"lang":"en","description":"A sub dedicated to talking about Facebook.  Please do not confuse this with a tech support sub (use /r/facebookhelp).","over18":false},"ShinyPorn":{"lang":"en","description":"","over18":true},"AlphaBayMarket":{"lang":null,"description":"Subreddit no longer exists","over18":null},"battlewagon":{"lang":"en","description":"For turning your boring station wagon into an awesome Battlewagon.","over18":false},"VACsucks":{"lang":"en","description":"A subreddit dedicated the uncensored discussion of cheating and the lack of anti-cheating measures in Counter-Strike: Global Offensive's professional scene. Try to post your thoughts and clips here in","over18":false},"playrustlfg":{"lang":"en","description":"Find a rust group!","over18":false},"AmateurRoomPorn":{"lang":"en","description":"Room porn for the 98% of us who can't afford an interior designer and/or don't live in a mansion.","over18":false},"trebuchetmemes":{"lang":"en","description":"For the glory of the medieval siege engine that uses a counterweight. Whether they are small or large, all trebuchet memes are benevolent for the community.","over18":false},"homedefense":{"lang":"en","description":"Anything relating to defending your home and family.\n\nHome security system information, CCTV cameras, Outdoor lighting, entryway fortification, No-knock warrant discussion, Panic rooms, Safes, Safety ","over18":false},"ufl":{"lang":"en","description":"This is the unofficial subreddit for the University of Florida, a public university located in Gainesville, Florida.","over18":false},"ClubNintendoTrade":{"lang":"en","description":"","over18":false},"pcmods":{"lang":"en","description":"A place for Modders to show off their PC mods that they have made or found online, discuss new mod ideas for their rigs and look for help getting their dream mod project off the ground.\n","over18":false},"bigonewild":{"lang":"en","description":"Where bisexual redditors exchange pictures and videos of their nude bodies for karma; showing it off in a comfortable environment without pressure.  ","over18":true},"arcadefire":{"lang":"en","description":"The go to Arcade Fire fan site.","over18":false},"civilengineering":{"lang":"en","description":"Civil engineering: Building and maintaining the infrastructure.","over18":false},"labrador":{"lang":"en","description":"","over18":false},"awfuleverything":{"lang":"en","description":"Because sometimes everything is just... ***awful***.","over18":false},"DoctorWhumour":{"lang":"en","description":"A subreddit for all lighthearted Doctor Who related content and discussion :)","over18":false},"userexperience":{"lang":"en","description":"","over18":false},"SteamTrade":{"lang":"en","description":"","over18":false},"BorderlandsGuns":{"lang":"en","description":"Come trade your loot!","over18":false},"cardsagainsthumanity":{"lang":"en","description":"Cards Against Humanity is the Apples to Apples for horrible people.  Come share your depraved card combinations and additions to the game.","over18":false},"3Dmodeling":{"lang":"en","description":"","over18":false},"entj":{"lang":"en","description":"The Myers-Briggs Type Indicator (MBTI) is a test that attempts to meaningfully divide people into 16 psychological types, using personal preferences and theory developed by Swiss psychoanalyst Carl Ju","over18":false},"Reprap":{"lang":"en","description":"","over18":false},"TheNightOf":{"lang":"en","description":"This subreddit is a place to enjoy and discuss the HBO miniseries 'The Night Of'","over18":false},"gta5":{"lang":null,"description":"Subreddit forbidden","over18":null},"GuildWarsDyeJob":{"lang":"en","description":"Share your dyes, your character's current armor set-up, your wardrobe achievements, the newest fashion trends and everything in between. Anything related to GW2 fashion belongs here! ","over18":false},"PSNFriends":{"lang":"en","description":"Look for friends on the PlayStation Network?  Try /r/PSNFriends.\n\nFor all PlayStation Platforms, including: PS4 (PlayStation 4), PS Vita (PSVita), PS3 (PlayStation 3), PSP (PlayStation Portable).","over18":false},"scala":{"lang":"en","description":"","over18":false},"eyes":{"lang":"en","description":"A subreddit for gorgeous eyes!","over18":false},"exchangeserver":{"lang":"en","description":"Microsoft Exchange Server subreddit. Post blog posts you like, KB's you wrote or ask a question. Open forum for Exchange Administrators / Engineers / Architects and everyone to get along and ask quest","over18":false},"Kuwait":{"lang":"en","description":"This subreddit is for people living, visiting or interested in Kuwait to share their experiences, idea and views. \n","over18":false},"angry":{"lang":"en","description":"","over18":false},"doujinshi":{"lang":"en","description":"Lewd(er) manga, but not as lewd as hand-holding.","over18":true},"modular":{"lang":"en","description":"Anything related to the world of Modular Synthesizers: news, videos, pictures, recordings, auction and anything else.","over18":false},"lincoln":{"lang":"en","description":"The community-based subreddit for the city of Lincoln, Nebraska.","over18":false},"drugscirclejerk":{"lang":"en","description":"\nHas anyone seen molly? LOL","over18":false},"trailers":{"lang":"en","description":"This subreddit is dedicated to viewing the latest movie trailers! ","over18":false},"wartrade":{"lang":"en","description":"This is the unofficial trading hub for Warframe related trading. Please read the rules for trade post format before making any posts. In addition, try to limit your trades to one post, clarifying with","over18":false},"kzoo":{"lang":"en","description":"For all things related to the town of Kalamazoo, MI -- Kalamazoo College, Western Michigan University, and KVCC! Events, happenings, meet-ups, music, etc. ","over18":false},"PartneredYoutube":{"lang":"en","description":"This subreddit is for YouTube Content Creators and partners. \n\nIt is a community for advice on content creation, monetization, and marketing strategy, NOT for selfpromotion or feedback on videos.","over18":false},"jesuschristreddit":{"lang":"en","description":"Sometimes, Reddit says the weirdest/scariest/most disturbing things.","over18":false},"randpaul":{"lang":"en","description":"A subreddit for news, information and discussions about Senator Rand Paul (R-KY).","over18":false},"Draven":{"lang":"en","description":"Welcome to the League of Draven.","over18":false},"LateShow":{"lang":"en","description":"The subreddit for The Late Show with Stephen Colbert on CBS.","over18":false},"killerinstinct":{"lang":"en","description":"","over18":false},"jewelry":{"lang":"en","description":"","over18":false},"uruguay":{"lang":"es","description":"Subreddit de la hermosa República Oriental del Uruguay. Noticias, humor, deportes y política.","over18":false},"appleswap":{"lang":"en","description":"/r/AppleSwap: Buy, Trade, and Sell Apple Devices!\n\nWelcome! Looking to purchase, sell, or trade your Apple products? Please follow our posting guide!","over18":false},"RedditBrigade":{"lang":"en","description":"A place to coordinate the 1st Reddit Brigade, a group of Reddit regiments in Mount and Blade: Napoleonic Wars.","over18":false},"waifuism":{"lang":"en","description":"Are you in love with a fictional character? So are we. Come join us and tell us about your waifu!","over18":false},"guitarporn":{"lang":"en","description":"A place to share or ogle at fancy pictures of yours or others' guitars and related instruments.","over18":false},"themountaingoats":{"lang":"en","description":"For all things related to the musical works of the Mountain Goats.","over18":false},"LipsThatGrip":{"lang":"en","description":"Dedicated to pussy lips that grip the cock as they're getting fucked. ","over18":true},"CookieCollector":{"lang":"en","description":"The place to talk about everything related to Cookies Inc.! What do you like most? What don't you like? What should improve? This the the place to post!","over18":false},"NarcissisticAbuse":{"lang":"en","description":"A Narcissist’s Prayer:\n\n\nThat didn’t happen.\n\n\nAnd if it did, it wasn’t that bad.\n\n\nAnd if it was, that’s not a big deal.\n\n\nAnd if it is, that’s not my fault.\n\nAnd if it was, I didn’t mean it.\n\nAnd if","over18":false},"IndiaInvestments":{"lang":"en","description":"A place to discuss investments, insurance, finance, economy and markets in India.","over18":false},"bardmains":{"lang":"en","description":"This is a subreddit for people who main Bard, The Wandering Caretaker, in League of Legends.","over18":false},"JustUnsubbed":{"lang":"en","description":"This sub is for sharing which post made you unsubscribe from a subreddit. Other acceptable posts can be of comments from other users saying that \"this is the post that made me unsubscribe from /r/(ins","over18":false},"Lexus":{"lang":"en","description":"/r/Lexus a place to post Pictures of your own Lexus, News, Help, Questions and also general discussion on anything Lexus!. Anything that isn't Spam that you think other people would like is welcome he","over18":false},"AskEconomics":{"lang":"en","description":"A central repository for questions about economic theory, research, and policy.","over18":false},"Drexel":{"lang":"en","description":"Drexel University - Home of the Dragons","over18":false},"ween":{"lang":"en","description":"Ween Reddit - The Best Ween Community On The Net!","over18":false},"classicrage":{"lang":"en","description":"Because f7u12 drove its memes into the ground, Classic Rage tries to offer a refreshing supply of \"classic\" comics that are actually about rage.","over18":false},"FIFACoins":{"lang":null,"description":"Subreddit forbidden","over18":null},"djimavic":{"lang":"en","description":"A subreddit to show off videos and pictures taken with the DJI Mavic Quadcopter","over18":false},"Etizolam":{"lang":null,"description":"Subreddit forbidden","over18":null},"Entomology":{"lang":"en","description":"","over18":false},"orchids":{"lang":"en","description":"","over18":false},"XXXTENTACION":{"lang":"en","description":"Subreddit for rapper and singer XXXTENTACION. January 23, 1998 - June 18, 2018.","over18":false},"PopCornTime":{"lang":"en","description":"Subreddit for the most popular Torrent streaming program Popcorn Time \nOfficial website : https://popcorntime.sh","over18":false},"neuro":{"lang":"en","description":"","over18":false},"hitmobile":{"lang":"en","description":"A subreddit for Nexon's mobile action game: Heroes of Incredible Tales (HIT)","over18":false},"wownoob":{"lang":"en","description":"A place for new players of World of Warcraft can learn from experienced players and meet other new players.","over18":false},"SecurityAnalysis":{"lang":"en","description":"","over18":false},"Xanaxcartel":{"lang":null,"description":"Subreddit no longer exists","over18":null},"BritishPolitics":{"lang":"en","description":"Moderated discussion on political matters pertaining to the United Kingdom. ","over18":false},"olympia":{"lang":"en","description":"Olympia is Washington State's capitol and is located in Thurston County at the southern tip of the Puget Sound.","over18":false},"Boxer":{"lang":"en","description":"","over18":false},"Washington":{"lang":"en","description":"For all that is good in the Pacific Northwest. Washington is the absolute best.  ","over18":false},"lapfoxtrax":{"lang":"en","description":"A subreddit dedicated to the musical talent of Emma Essex (also known as Ren Queenston) and their many aliases, an independent electronic music producer based in Hamilton, Ontario.","over18":false},"storyofseasons":{"lang":"en","description":"This is a subreddit dedicated to a Nintendo 3DS exclusive, *Story of Seasons*!\n\n*Story of Seasons* is the beginning of a new chapter in the *Bokujo Monogatari* series, a long-standing and top-selling ","over18":false},"SamandTolki":{"lang":"en","description":"This is a sub for all things related to the popular show showvideogames, run by sam and his wife tolki. ","over18":false},"Chameleons":{"lang":"en","description":"Chameleons are a increasingly popular pet for people to keep and this sub is for those that wish to learn more about these animals, their care and even showing off their animals, their successes and h","over18":false},"spirituality":{"lang":"en","description":"","over18":false},"trailrunning":{"lang":"en","description":"The fun begins where the road ends. ","over18":false},"JessicaNigri":{"lang":"en","description":"Subreddit for fans of Jessica Nigri, cosplayer extraordinaire.","over18":true},"theflash":{"lang":"en","description":"A subreddit specifically devoted to the Fastest Man (or men, or women) Alive.","over18":false},"HardcoreSMP":{"lang":"en","description":"hardcore minecraft server with deathban. hardcore.hcsmp.com = ip / hcsmp.com = website","over18":false},"planetaryannihilation":{"lang":"en","description":"A subreddit to discuss the RTS games Planetary Annihilation Titans & Classic","over18":false},"DestinyFashion":{"lang":"en","description":"Eyes up, Guardians! The fashion show has begun! A sub dedicated to the many looks of Destiny, a fantastic FPSRPGMMO from Bungie. ","over18":false},"makeyourchoice":{"lang":"en","description":"Post and discuss your own choice threads or some of your favorites.","over18":false},"JohnMayer":{"lang":"en","description":"A space where John Mayer fans can come together.","over18":false},"Colombia":{"lang":"es","description":"Este es el subreddit de Colombia, ¡un país lleno de diversidad de fauna, flora, gastronomía y actividades! \n\nToda la información relevante al país la pueden encontrar acá.\n\n___________________________","over18":false},"AstralProjection":{"lang":"en","description":"It goes by many names. \"Astral Projection,\" \"Out of Body Experience (OBE),\" \"the phase,\" but it's something many people have done and experienced before. If you're curious and willing to try something","over18":false},"regina":{"lang":"en","description":"/r/Regina is a place for thoughtful discussion and events in our little city on the prairie.","over18":false},"SwingDancing":{"lang":"en","description":"This subreddit is dedicated to anyone that shares an interest or dedication for dancing the historic dances done to popular music from the 1920s through the 1950s . . . also know as swing dancing.","over18":false},"Ghosts":{"lang":"en","description":"","over18":false},"JETProgramme":{"lang":"en","description":"A subreddit for all past, current, and future JETs.","over18":false},"Moto_Z":{"lang":"en","description":"","over18":false},"HomeServer":{"lang":"en","description":"A community based around the building, set up, and use of home servers for a variety of purposes. All discussion is welcome!","over18":false},"puzzles":{"lang":"en","description":"A subreddit for posting and solving logic-based puzzles.\n\n(For things that involve more lateral thinking, try /r/riddles. If you're looking for a subreddit about jigsaw puzzles, try /r/jigsawpuzzles.)","over18":false},"phenibut":{"lang":"en","description":"","over18":false},"3amjokes":{"lang":"en","description":"All the stupid humor of sleep deprivation under one roof.\n","over18":false},"Fedora":{"lang":"en","description":"A community for users, developers and people interested in the Fedora Project and news and information about it.","over18":false},"RhodeIsland":{"lang":"en","description":"Welcome to the biggest little state in the union.","over18":false},"SolidWorks":{"lang":"en","description":"ALL posts related to SOLIDWORKS are welcome. \n\nShare what you know. Learn what you don't.","over18":false},"SuperShibe":{"lang":"en","description":"SuperShibe: Reddit's largest Doge and Shibe community! Come on over and see what all the WOW is about! Wow, such subreddit, very fun!","over18":false},"crtgaming":{"lang":"en","description":"CRT's for gaming. Scanlines. RGB. SCART. PVM. BVM. Retro. Classic.","over18":false},"Fraudnet2":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Mafia3":{"lang":"en","description":"MAFIA III is the latest installment of the MAFIA series. This Subreddit provides a place to exchange about the development, news and media.","over18":false},"wholesomegifs":{"lang":"en","description":"Quality gifs that make the viewer feel good.","over18":false},"arcane":{"lang":"en","description":"The official subreddit for Arcane HCF.","over18":false},"AskHR":{"lang":"en","description":"A place for employees to ask questions about compensation, benefits, harassment, discrimination, legal and ethical issues in the workplace.","over18":false},"metaldetecting":{"lang":"en","description":"","over18":false},"smashgifs":{"lang":"en","description":"Super Smash Bros. combo gifs that you could watch over and over again.","over18":false},"dayzlfg":{"lang":"en","description":"Looking for people to team up with in DayZ? Post here!","over18":false},"macdemarco":{"lang":"en","description":"Awwww yisssss\n\n","over18":false},"Brampton":{"lang":"en","description":"Welcome to /r/Brampton! The largest online forum for the 9th largest municipality in Canada! This subreddit is for anything related to Brampton like people, news & events.","over18":false},"OfficeDepot":{"lang":"en","description":"","over18":false},"cactus":{"lang":"en","description":"","over18":false},"youngjustice":{"lang":"en","description":"Stay whelmed.\n\nThis subreddit is for discussion, news, fan content, and shitposts related to a TV series called 'Young Justice'.\n\nThe series follows the lives of teenage heroes and sidekicks who are m","over18":false},"iWallpaper":{"lang":"en","description":"Your one stop shop for finding and sharing a variety of amazing, thought provoking, and stunning wallpapers for your smartphones, tablets & other mobile devices!\n\nFrom custom made to classics, texture","over18":false},"NewsOfTheWeird":{"lang":"en","description":"NewOfTheWeird is for weird and wacky news from all over the world. ","over18":false},"ExplainLikeImCalvin":{"lang":"en","description":"","over18":false},"podcasting":{"lang":"en","description":"For people who make podcasts. Topics include podcasting news, how to guides, gear, marketing, and anything related to podcasters.\n\nKeywords: create podcast, how to podcast, make podcast, start podcast","over18":false},"FIFA12":{"lang":"en","description":"","over18":false},"PanPorn":{"lang":"en","description":"While brand new hauls are great, there's nothing like seeing photos of well loved makeup products.","over18":false},"HollowKnight":{"lang":"en","description":"Hollow Knight is a 2D adventure/Metroidvania game for PC, Mac, Linux and Nintendo Switch.","over18":false},"Kentucky":{"lang":"en","description":"Kentucky","over18":false},"prius":{"lang":"en","description":"Everything Toyota Prius!","over18":false},"DarkSoulsHelp":{"lang":"en","description":"A help-based community for item and player requests that's a part of /r/darksouls -- dedicated to the PlayStation 3, Xbox 360, and PC title \"Dark Souls.\"","over18":false},"tfc":{"lang":"en","description":"A subreddit for all things related to Toronto Football Club.","over18":false},"ColorBlind":{"lang":"en","description":"","over18":false},"CigarMarket":{"lang":null,"description":"Subreddit no longer exists","over18":null},"slp":{"lang":"en","description":"A community of Speech-Language Pathologists (SLPs), Speech Therapists (STs), Speech-Language Therapists (SLTs), Clinical Fellowship Clinicians (SLP-CFs), Speech-Language Pathology Assistants (SLPAs), ","over18":false},"Militaryfaq":{"lang":"en","description":"A subreddit for anyone and everyone to ask questions and give information about the military.\n","over18":false},"sneakerreps":{"lang":"en","description":"This is a sub-reddit devoted to replica sneakers.\n","over18":false},"xmrtrader":{"lang":"en","description":"The official Monero trading subreddit. Discuss price movements, market dynamics, news, and trades involving Monero here. ","over18":false},"ns2":{"lang":"en","description":"The #1 Natural Selection 2 sub-reddit.","over18":false},"RedditThroughHistory":{"lang":"en","description":"History as if viewed through the posts of a redditor.","over18":false},"csuf":{"lang":"en","description":"","over18":false},"juggling":{"lang":"en","description":"Home to all forms of throwing, catching, spinning, bouncing, and all manner of other manipulation","over18":false},"Cod4Remastered":{"lang":"en","description":"This is the main Call of Duty: Modern Warfare Remastered subreddit! This subreddit is the center of all Cod 4 Remastered news and topics, so subscribe and have fun posting!","over18":false},"Kerala":{"lang":"en","description":"A subreddit for anything related to Kerala (കേരളം), a state in the south-west of India.","over18":false},"siacoin":{"lang":"en","description":"Sia is a cryptocurrency engineered to provide industrial grade cloud storage at consumer prices.","over18":false},"blackfriday":{"lang":"en","description":"A subreddit dedicated to black friday type big sales and deals. This includes cyber monday and other deals throughout the year that companies market as \"black friday style\"!","over18":false},"Goruck":{"lang":"en","description":"A community for those who are GRT and those who want to become GRT","over18":false},"WiggleButts":{"lang":"en","description":"","over18":false},"bidenbro":{"lang":"en","description":"A community dedicated to the greatest wingman in the history of US politics: The 47th Vice President of the United States Joe Biden. \n","over18":false},"MawInstallation":{"lang":"en","description":"The Maw Installation is the subreddit for in-depth, academic style discussion of Star Wars. \n","over18":false},"lgg6":{"lang":"en","description":"A community dedicated to LG's newest flagship.   ","over18":false},"iranian":{"lang":"fa","description":"A subreddit dedicated to topics related to Iran and Iranian culture.  You  are free to discus topics such as Iran politics, Iranian and Persian history and Iran tourism. This is the only subreddit ded","over18":false},"opendirectories":{"lang":"en","description":"**Welcome to /r/OpenDirectories**\n\nUnprotected directories of pics, vids, music, software and otherwise interesting files. ","over18":false},"battleparty":{"lang":"en","description":"This is the subreddit for the Cartoon Network game, Adventure Time: Battle Party, based off of the American TV show. \n\nThe game is a MOBA, or Multiplayer Online Battle Arena. \n\nClick the FAQ if you ha","over18":false},"aspergirls":{"lang":"en","description":"We are a community for Autistic women to discuss their experiences with the disorder.\n","over18":false},"IndianBabes":{"lang":"en","description":"The Biggest Indian Community on Reddit, Dedicated to Providing Hot and Sexy Babes from the Indian Subcontinent (India, Pakistan, Bangladesh, Sri Lanka, Nepal and Bhutan)!","over18":true},"Clojure":{"lang":"en","description":"Clojure is a dynamic programming language / Lisp that targets the Java Virtual Machine. ","over18":false},"PokemonGOIVs":{"lang":"en","description":"Pokemon Go IVs - a space to share and get help with determining the individual values of your Pokemon GO team!","over18":false},"McDonalds":{"lang":"en","description":"For everything [McDonald's](http://www.mcdonalds.com/)!","over18":false},"Antshares":{"lang":"en","description":"Community for Chinese Blockchain project NEO (Antshares).\nAntshares, digital assets for everyone","over18":false},"Preacher":{"lang":"en","description":"Preacher is an American television series developed by Evan Goldberg, Seth Rogen and Sam Catlin for AMC starring Dominic Cooper. It is an adaptation of the comic book series created by Garth Ennis and","over18":false},"Bakersfield":{"lang":"en","description":"","over18":false},"Gintama":{"lang":"en","description":"This is a subreddit dedicated to the anime and manga *Gintama(Silver Soul)*.","over18":false},"PlantsVSZombies":{"lang":"en","description":"Braaaaaaaaaaaains!","over18":false},"chiptunes":{"lang":"en","description":"A community dedicated to new music that gets the most out of the least. New music in the style of old games, eg, C64, Atari, NES, Gameboy, Sega Genesis, Adlib, OPM, MOD, etc.","over18":false},"DeathStranding":{"lang":"en","description":"The subreddit for Kojima Productions upcoming video game Death Stranding.","over18":false},"blackcoin":{"lang":"en","description":"BlackCoin is a digital currency similar to Bitcoin. It is a pure Proof of Stake coin, except stage of initial distribution, when it was mixed PoW and PoS coin.\n\nFor more info, go to http://blackcoin.c","over18":false},"whole30":{"lang":"en","description":"The Whole30 is a 30-day elimination diet, as described in the book It Starts With Food and on the website Whole9Life.com. This subreddit brings together redditors that are taking on the Whole30 challe","over18":false},"AlpharadTV":{"lang":"en","description":"All things Alpharad. ","over18":false},"Clemson":{"lang":"en","description":"The Clemson Family's Home on Reddit.","over18":false},"plotholes":{"lang":"en","description":"For when Hollywood crosses all the t's and dots all the i's, but the villain still lets an escape pod go because there are \"no signs of life.\"  In a movie populated by walking, talking, and thinking r","over18":false},"BodyAcceptance":{"lang":"en","description":"","over18":false},"Stellar":{"lang":"en","description":"Stellar is a decentralized protocol that enables you to send money to anyone in the world, for fractions of a penny, instantly, and in any currency.  \n\n/r/Stellar is for news, announcements and discus","over18":false},"starlets":{"lang":null,"description":"Subreddit no longer exists","over18":null},"InlandEmpire":{"lang":"en","description":"Subreddit for redditors in the Inland Empire. From the desert to the big city, and all points in between and beyond!","over18":false},"geography":{"lang":"en","description":"Discussion of places, spaces, maps and processes that shape the world. ","over18":false},"DirecTVNow":{"lang":"en","description":"This is a subreddit for everything related to DirecTV Now, the new AT&T streaming service set to release before the end of the year. As more information is released, it will be posted and we welcome d","over18":false},"YIMO":{"lang":"en","description":"YIMO is the abbreviation for Yi Mains Only. It is a community consisting of many Yi mains across the globe and we all enjoy playing Master Yi and discussing about him.","over18":false},"deftones":{"lang":"en","description":"Deftones News, Media, Tour, & Discussion.","over18":false},"ukipparty":{"lang":"en","description":"This sub reddit is a UKIP forum for supporters or anyone from any end of the political spectrum that wants to know more about the real UKIP and get all the latest news. ","over18":false},"necrodancer":{"lang":"en","description":"All about the game, Crypt of the Necrodancer. Crypt of the NecroDancer is a hardcore roguelike rhythm game. Play with your own MP3s. Dance with a DDR pad, keyboard, or game pad!","over18":false},"turtle":{"lang":"en","description":"This subreddit is a friendly place to post all things turtle-related.","over18":false},"NBAForums":{"lang":"en","description":"NBA Live Mobile is a game created by Electronic Arts. This is the forum that supports the game. Join the community and the fun!","over18":false},"badpolitics":{"lang":"en","description":"A place to discuss the terrible application of Political Science, Political Theory, and Political History that we see every day. \n\nWe point out fundamental misunderstandings of political concepts and ","over18":false},"pic":{"lang":"en","description":"/r/Pic: Interesting pictures. No click bait.","over18":false},"ConspiracyGrumps":{"lang":"en","description":"This subreddit dedicated to discussing conspiracies surrounding the YouTube channel Game Grumps, and more specifically the circumstances surrounding JonTron's departure from the show.","over18":false},"MAA2":{"lang":"en","description":"Discuss topics related to Marvel Avengers Alliance 2","over18":false},"ListeningHeads":{"lang":"en","description":"A subreddit dedicated to listening and discussing all types of music, with a strong leaning towards indie music as well as hip-hop and R&B. ","over18":false},"bladerunner":{"lang":"en","description":"A subreddit dedicated to Blade Runner. The 1982 dystopian science fiction action film directed by Ridley Scott and starring Harrison Ford, Rutger Hauer, and Sean Young.","over18":false},"Gender_Critical":{"lang":"en","description":"Gender Critical Feminism","over18":false},"EliteLavigny":{"lang":"en","description":"A subreddit for supporters of Arissa Lavigny-Duval.","over18":false},"Strongman":{"lang":"en","description":"Discussion of training and competing for Strongman","over18":false},"Montana":{"lang":"en","description":"Montana is the 4th largest state by land area.  It was the 41st state included in the United States on November 8, 1889.\n\nMontana's population is ranked 44th in the U.S., with an estimated population ","over18":false},"justlegbeardthings":{"lang":"en","description":"pls leave us alone SRS we don't want to hurt nobody","over18":false},"dotaimba":{"lang":"en","description":"A place to discuss anything about the Dota 2 custom game, Dota IMBA: \"balance\", new item/hero/ability ideas, propose changes, complain, report bugs, etc.","over18":false},"WowUI":{"lang":"en","description":"World of Warcraft's User Interface.","over18":false},"Ladybonersgonecuddly":{"lang":"en","description":"Images of handsome men cuddling with adorable animals.","over18":false},"tablets":{"lang":"en","description":"tablet\ntablets\nereader \nereaders\nebook\nebooks\nandroid\nipad\nsurface","over18":false},"HyruleWarriors":{"lang":"en","description":"A subreddit dedicated to exploring and sharing the fun of Hyrule Warriors/Hyrule Warriors Legends","over18":false},"gonewildcouples":{"lang":"en","description":"Gone Wild Couples is the place for adult couples to post photos and videos of themselves in the nude and/or engaged in sexual activity in exchange for karma.  All photos must contain at least two peop","over18":true},"tf2items":{"lang":"en","description":"","over18":false},"Schizoid":{"lang":"en","description":"","over18":false},"ImaginaryTechnology":{"lang":"en","description":"Technology-based Sci-fi and Fantasy pictorial art featuring robots, cyborgs, mechanisms, vehicles, spaceships, futuristic cars or other transport\n\nother tags: science fiction, scifi, future, science-f","over18":false},"AnimationThrowdown":{"lang":"en","description":"For the first time ever, five of your favorite animated shows are together in one amazing collectable card game.\n\nAnimation Throwdown: The Quest for Cards is a CCG mobile game published by Kongregate ","over18":false},"FestivalSluts":{"lang":"en","description":"","over18":true},"Youniqueamua":{"lang":"en","description":"The horrors of multi-level marketing \"makeup\" company Younique.","over18":false},"Warhammer30k":{"lang":"en","description":"For everything to do with Forgeworld and the Horus Heresy.  This includes 30k and 30k vs 40k battle reports; army list feedback and reviews; pictures of legion, mechanicum, and other 30k models; paint","over18":false},"Stronglifts5x5":{"lang":"en","description":"This subreddit if for anyone who is starting Stonglifts5x5, has previously done Stronglifts5x5, anywhere in between, or even just curious as to what it is.","over18":false},"deepthroat":{"lang":"en","description":"A big bunch of deepthroat pictures, gifs, and videos.","over18":true},"BSA":{"lang":"en","description":"This is a reddit for things relating to Scouts BSA and the Boy Scouts of America.","over18":false},"TeenFA":{"lang":null,"description":"Subreddit forbidden","over18":null},"eFreebies":{"lang":"en","description":"We love links to digital freebies. Free pointless fun stuff, free iOS and Android apps, free games, music, video, eBooks, software, and anything else free. If it's a temporarily 100%-free giveaway wit","over18":false},"LasVegas":{"lang":"en","description":"The Original Las Vegas subreddit! Don't be fooled by cheap knockoffs! ","over18":false},"PokkenGame":{"lang":"en","description":"**Welcome to the Pokkén Tournament Subreddit!**","over18":false},"kayakfishing":{"lang":"en","description":"KayakFishing: paddle or pedal. Let's spread the word!","over18":false},"ketoscience":{"lang":"en","description":"Ketoscience is dedicated to being the center for online discussion on the latest science in the broad and expanding keto 'information-sphere'. Science is a broad term - we especially love the latest s","over18":false},"tinnitus":{"lang":"en","description":"r/tinnitus is a place for community help and general discussion about tinnitus.  Share your experiences with others who can relate.\n\nTinnitus is the hearing of sound when no external sound is present.","over18":false},"homegrowntits":{"lang":"en","description":"A place to view and post softcore photos of all types of women with all natural un-enhanced titties. ","over18":true},"cad":{"lang":"en","description":"***Computer-Aided Design***\n\nA place to talk about anything related to CAD. Ask questions about CAD software, drawing standards or just show off your latest project.","over18":false},"WeatherGifs":{"lang":"en","description":"/r/WeatherGifs is a place for meteorological events captured on film and converted to a gif/HTML5 format.","over18":false},"OutsideLands":{"lang":"en","description":"Outside Lands music festival in Golden Gate Park, San Francisco.","over18":false},"project1999":{"lang":"en","description":"","over18":false},"the_schulz":{"lang":"en","description":"[Closed for good.](https://www.youtube.com/watch?v=yctDMFMlvHE)","over18":false},"okeechobeemusicfest":{"lang":"en","description":"Discussions, planning, predictions, and general excitement!","over18":false},"bdfc":{"lang":"en","description":"Subreddit for swapping friend codes for Bravely Default on the 3DS. See /r/bravelydefault for non-FC threads.","over18":false},"disability":{"lang":"en","description":"News, resources and perspectives pertaining to individuals with disabilities.","over18":false},"birdswitharms":{"lang":"en","description":"It's birds... with arms.","over18":false},"VinylDeals":{"lang":"en","description":"","over18":false},"Automate":{"lang":"en","description":"A place for the discussion of automation, additive manufacturing, robotics, AI, and all the other tools we've created to enable a global paradise free of menial labor. All can share in our achievement","over18":false},"perl":{"lang":"en","description":"The Perl Programming Language, including both Perl 5 and Perl 6.","over18":false},"MathHelp":{"lang":"en","description":"A sub for helping you with your mathematics problems! If you're willing to learn, we're willing to teach.","over18":false},"ps2":{"lang":"en","description":"**This subreddit is dedicated to the best selling video game console in history, Sony's Playstation 2** \n\nWe are all about the games, discussions, news, questions or suggestions related to the PS2. Te","over18":false},"pantyselling":{"lang":null,"description":"Subreddit forbidden","over18":null},"banjo":{"lang":"en","description":"A subreddit for discussion of bluegrass, old-time, and tenor banjo. Building, buying, set-up, learning, playing, etc.","over18":false},"TheDearHunter":{"lang":"en","description":"**The meaning of, and all things regarding The Dear Hunter!** \n","over18":false},"animenocontext":{"lang":"en","description":"\"I'm coming!\"","over18":false},"marilyn_manson":{"lang":"en","description":"A subreddit dedicated to the artist/band Marilyn Manson, be it his music, present or past members' side projects, his paintings or film creations. A place for fellow fans to discuss and share all thin","over18":false},"boobs":{"lang":"en","description":"Boobs!","over18":true},"lgv10":{"lang":"en","description":"This subreddit is devoted to the LG V10 Android phone. Let's share news, tips and whatever about this beauty.\n\n\n","over18":false},"massachusetts":{"lang":"en","description":"A community for all things Massachusetts.","over18":false},"rearpussy":{"lang":"en","description":"Pictures of pussy from behind","over18":true},"nycmeetups":{"lang":"en","description":"The subreddit for discussing New York City reddit meetups. ","over18":false},"comedy":{"lang":"en","description":"Comedy","over18":false},"freenas":{"lang":"en","description":"","over18":false},"nsfwcosplay":{"lang":"en","description":"It's cosplay that's NSFW, what more needs said? (Obviously, a lot, see the sidebar.)","over18":true},"freeuse":{"lang":"en","description":"Hello and welcome to /r/freeuse! This is a place to create, share, and discuss works from the little-known 'free use' fetish.","over18":true},"EnoughCommieSpam":{"lang":"en","description":"EnoughCommieSpam - With the rise of communism on reddit the commies has been super fucking annoying and we're here to laugh at them\n\n","over18":false},"gmu":{"lang":"en","description":"The community subreddit for students, faculty, alumni, and friends of George Mason University in Fairfax, Virginia.","over18":false},"TheKillers":{"lang":"en","description":"Brought to you by way of Fabulous Las Vegas, Nevada: The Killers!","over18":false},"blackcats":{"lang":"en","description":"Only the most luxurious kitties are welcome here.","over18":false},"Brazil":{"lang":"en","description":"This sub has moved to /r/brasil! Posts in English are also welcome there!\n\n\nEste sub se mudou para o /r/brasil! Posts em inglês são bem-vindos lá também!","over18":false},"Shotguns":{"lang":"en","description":"Whether you like Hunting ,Skeet ,Clay Pigeon, Home Defense\nOr anything that involves a Shotgun\nWelcome to /r/Shotguns","over18":false},"antifa":{"lang":"en","description":"/r/Antifa: For unbiased news and discussion of the anti-fascist movement, \"Antifa,\" and its presence in the modern political community. May also included related anti-racist, anti-sexist, anti-discrim","over18":false},"Team_Liquid":{"lang":"en","description":"A fan subreddit dedicated to discussing the professional esports organization Team Liquid, spanning League of Legends, Counter-Strike: Global Offensive, Hearthstone, Super Smash Bros. Melee, Dota 2, H","over18":false},"TwoXSex":{"lang":"en","description":"You know those nitty gritty details you can only talk about with your best friend? Well, here is TwoXSex: a place for you to bare all about your experiences, concerns, questions, anything you may want","over18":false},"darkjokes":{"lang":"en","description":"> Dark jokes are jokes that employs farce and morbid humor, which, in its simplest form, is humor that makes light of subject matter usually considered taboo. \n\nA place for dark jokes of all kinds. ^D","over18":false},"shittyideas":{"lang":"en","description":"","over18":false},"security":{"lang":"en","description":"A friendly and professional place for discussing computer security.","over18":false},"NBA_Draft":{"lang":"en","description":"A hub for the hardcore NBA Draft enthusiast.\n\nThe home of hype and hope. Where logical evaluation and substance generate discussion, rather than conventional stereotypes and uninspiring cliches.  \n\nAn","over18":false},"IHE":{"lang":"en","description":"* The official subreddit for the YouTube channel 'I HATE EVERYTHING'","over18":false},"UnderwearGW":{"lang":"en","description":"Underwear Gonewild is a community for Redditors of all shapes and sizes to show of their sexy underwear. You don't have to do nude but No one will stop you. User content only, No links to professional","over18":true},"GalaxyNote3":{"lang":"en","description":"The official subreddit for the Samsung Galaxy Note 3","over18":false},"psychedelicrock":{"lang":"en","description":"[](https://www.reddit.com/r/psychedelicrock/comments/3uooi5/best_of_rpsychedelicrock_november_2015/)A place for all psychedelic rock; classic, contemporary, experimental, or *something else altogether","over18":false},"elementaryos":{"lang":"en","description":"News & Discussion for elementary OS","over18":false},"iZombie":{"lang":"en","description":"A sub-reddit for fans of CW's show iZombie!","over18":false},"themoddingofisaac":{"lang":"en","description":"A subreddit dedicated to the discussion of modding in The Binding of Isaac: Rebirth.","over18":false},"AdrenalinePorn":{"lang":"en","description":"High quality images of heart racing activities (not sex).","over18":false},"fragsplits":{"lang":"en","description":"This exists to get people's noses great frags at great prices..\n\nOur mantra: Together we smell better!!","over18":false},"steelseries":{"lang":"en","description":"","over18":false},"LoveNikki":{"lang":"en","description":"This is an unofficial subreddit for players of the English server of Love Nikki, the amazing dressup game for iOS and Android. Ask questions, help each other, post challenges, and have fun!","over18":false},"brexit":{"lang":"en","description":"Welcome to /r/Brexit! A sub all about discussion of the United Kingdom's impending exit from the European Union. Post anything and everything about it. ","over18":false},"XVcrosstrek":{"lang":"en","description":"There are dozens of us,  Dozens!   \n\nA lot like r/subaru, but specific to the XV Crosstrek.  Please share your love for the XV, post diy mods, travel logs, and other awesome things you do with your ca","over18":false},"atheistvids":{"lang":"en","description":"###**A subreddit for atheism-related videos.**\n\n####**Rules/Guidelines**\n\n* Consider a title that will be easy to search for by some who wants to find the post in the future. The title should also be ","over18":false},"Logic_Studio":{"lang":"en","description":"","over18":false},"SleepApnea":{"lang":"en","description":"","over18":false},"ThanksObama":{"lang":"en","description":"This was going to be an awesome subreddit. Until Obama used the joke himself - https://vine.co/v/OPq02dpidBM - . Thanks Obama.\n\n","over18":false},"SugarPine7":{"lang":"en","description":"Welcome to the official Sugar Pine 7 subreddit!","over18":false},"BuddyCrossing":{"lang":"en","description":"/r/BuddyCrossing is a place for new players to make friends on Animal Crossing: New Leaf. The subreddit is created for the purpose of having fun with fellow redditors. ","over18":false},"phantomofthekill":{"lang":"en","description":"A subreddit for discussion and information on Phantom of the Kill Global, by Fuji & Gumi Games.","over18":false},"Wales":{"lang":"en","description":"This is the subreddit for Wales, a country that is part of the United Kingdom and the island of Great Britain.","over18":false},"DestinyLore":{"lang":"en","description":"/r/DestinyLore is for discussing the lore of Bungie's game Destiny. Get your tinfoil hats ready! From Grimoire to gameplay, we're piecing the puzzle together.","over18":false},"rapecounseling":{"lang":"en","description":"","over18":false},"DarkSouls3JPN":{"lang":"en","description":"An alternate sub to chat about Dark Souls 3 that is now released everywhere!","over18":false},"TF2WeaponIdeas":{"lang":"en","description":"A place to discuss Team Fortress 2 weapon stats, game mechanics, and come up with ideas for new weapons.","over18":false},"herpetology":{"lang":"en","description":"","over18":false},"bobdylan":{"lang":"en","description":"","over18":false},"beta":{"lang":"en","description":"A community of beta testers for reddit.com","over18":false},"tinytower":{"lang":"en","description":"Tiny Tower for Redditors","over18":false},"Paramore":{"lang":"en","description":"Welcome to the subreddit of our band called Paramore. The members are at least 👨‍👨‍👧 Hayley, Taylor, Zac, and also all of us..","over18":false},"LatvianJokes":{"lang":"en","description":"Now you have found /r/LatvianJokes, struggle is finally over. ","over18":false},"Serendipity":{"lang":"en","description":"/r/serendipity is a meta-subreddit meant to broaden the perspective of its subscribers. It takes a popular entry from a random subreddit and posts it every few hours.","over18":false},"fixingmovies":{"lang":"en","description":"\"Art is never finished, only abandoned.\" \n\n","over18":false},"vexillologycirclejerk":{"lang":"en","description":"","over18":false},"thevoice":{"lang":"en","description":"Your one stop location for everything related to The Voice. We focus on The Voice US, but all international versions of The Voice are welcome!","over18":false},"40krpg":{"lang":"en","description":"A bright beacon in the swirling darkness of the Immaterium for fans of Fantasy Flight Games' line of Warhammer 40,000 roleplaying games.","over18":false},"ASRoma":{"lang":"en","description":"","over18":false},"Bandnames":{"lang":"en","description":"","over18":false},"ratemycock":{"lang":"en","description":"Genuine and honest responses to how your cock looks.","over18":true},"lastweektonight":{"lang":"en","description":"Last Week Tonight with John Oliver is an American late-night talk show airing Sundays on HBO in the United States and HBO Canada, and on Mondays (originally Tuesdays) on Sky Atlantic in the United Kin","over18":false},"Frontend":{"lang":"en","description":"/r/frontend is a subreddit for front end web developers who want to move the web forward or want to learn how. If you're looking to find or share the latest and greatest tips, links, thoughts, and dis","over18":false},"ragenovels":{"lang":"en","description":"","over18":false},"Markiplier":{"lang":"en","description":"Hello, everybody, and welcome to r/Markiplier!","over18":false},"Blacklight":{"lang":"en","description":"Subreddit for all things Blacklight: Retribution across all platforms.","over18":false},"hitmanimals":{"lang":"en","description":"*For all the animals out there doing the dirty work for us..*","over18":false},"faeria":{"lang":"en","description":"The subreddit for discussing Faeria with other gamers, fans, and the devs themselves.","over18":false},"Logic_301":{"lang":"en","description":"The #1 source of everything Logic!","over18":false},"AnalGW":{"lang":"en","description":"AnalGonewild is a place for open-minded Adult(+18) Redditors to exchange their ass for karma; showing it off in a comfortable environment without pressure.\n\nThe nudity here is 100% free! Don't adverti","over18":true},"TarkovTrading":{"lang":"en","description":"Welcome to the official, unofficial, trading sub reddit for Escape From Tarkov, this is ran by the same moderator team who run the main /r/EscapefromTarkov sub reddit.","over18":false},"RESissues":{"lang":"en","description":"A subreddit for reporting Reddit Enhancement Suite bugs / issues","over18":false},"Defiance":{"lang":"en","description":"","over18":false},"haikyuu":{"lang":"en","description":"A subreddit about the volleyball manga written by Furudate Haruichi, Haikyuu!!","over18":false},"Animedubs":{"lang":"en","description":"Welcome to /r/AnimeDubs! The subreddit for Anime Dubs, Dubbed Anime and non-Japanese Anime Influenced animation.","over18":false},"KatarinaMains":{"lang":"en","description":"","over18":false},"EliteHudson":{"lang":"en","description":"We are the supporters of Zachary Hudson, the President of the Federation and leader of the Federal Republican Party.\n\nThis subreddit is where the concerted Powerplay efforts of the Hudson power are co","over18":false},"NanatsunoTaizai":{"lang":"en","description":"In a world similar to the European Middle Ages, the feared yet revered Holy Knights of Britannia use immensely powerful magic to protect the region of Britannia and its kingdoms. However, a small subs","over18":false},"GakiNoTsukai":{"lang":"en","description":"Downtown no Gaki no Tsukai ya Arahende!! is a Japanese variety show which stars comedians Matsumoto Hitoshi, Hamada Masatoshi, Tsukitei (Yamasaki) Hōsei, Tanaka Naoki and Endō Shōzō. It is best known ","over18":false},"MonsterStrike":{"lang":"en","description":"Place to discuss anything about Monster Strike for iOS and Android devices.","over18":false},"DungeonWorld":{"lang":"en","description":"For the Dungeon World tabletop roleplaying game.\n\nDungeon World is a set of rules for role-playing in a world of fantastic adventure. A world of magic, gods and demons, of good and evil, law and chaos","over18":false},"ironmaiden":{"lang":"en","description":"Anything about or related to the metal band Iron Maiden. Discussion, pics, videos, art, you name it. ","over18":false},"EqualAttraction":{"lang":"en","description":"EqualAttraction is a safe place for Redditors to post themselves and have the community offer their opinion of an equally attractive person through a photo reply.","over18":false},"BasketballGM":{"lang":"en","description":"Subreddit for discussion about [Basketball GM](https://basketball-gm.com/), a free basketball management simulation video game. Any content even slightly remotely related to Basketball GM is welcome!","over18":false},"brooklynninenine":{"lang":"en","description":"Subreddit for Brooklyn Nine-Nine, the now NBC TV show that stars Andy Samberg and Andre Braugher.","over18":false},"sonos":{"lang":"en","description":"A place for all [Sonos](http://www.sonos.com/) users to hang out and discuss hardware, software, installation, ideas and troubleshooting","over18":false},"fitness30plus":{"lang":"en","description":"A subreddit of /r/fitness for issues more relevant to individuals both male and female over the age of 30.  ","over18":false},"PKGOAtlanta":{"lang":"en","description":"Pokemon GO! Atlanta Subreddit.\nLooking to converse and strategize with others in Atlanta Georgia. \n\nFeel free to post pics of interesting poke-stops and gyms and anything else that's on your mind!","over18":false},"WorldOfNintendo":{"lang":"en","description":"This is a subreddit to post anything about the World of Nintendo products by Jakks Pacific. This can be anything related to these toys from release dates to showing off your collection. This will be a","over18":false},"misanthropy":{"lang":"en","description":"For those who hate 99% of the population and feel they'll come upon the 1% in this community.","over18":false},"fakealbumcovers":{"lang":"en","description":"Fake covers, real art.","over18":false},"USLPRO":{"lang":"en","description":"This community will be the home of anything and everything regarding USL. Clubs in the USL range from FC Cincinnati to Sacramento Republic to Tampa Bay Rowdies to Indy Eleven.","over18":false},"Liverpool":{"lang":"en","description":"Culture, events and general chat about Liverpool (The City)","over18":false},"happycrowds":{"lang":"en","description":"A subreddit for clips of massive audience support for a musician, athlete, performer, entertainer, whathaveyou. Crowds singing along, chanting the name of a champion, dancing in the aisles, cheering u","over18":false},"PantheonMMO":{"lang":"en","description":"**Pantheon: Rise of the Fallen** is an MMORPG Renaissance that values group gameplay, challenging content and a keen understanding of risk vs. reward. Pantheon is being developed by Visionary Realms I","over18":false},"atletico":{"lang":"en","description":"A subreddit for supporters and followers of Spanish football club Atlético de Madrid","over18":false},"forhonorknights":{"lang":"en","description":"DEUS VULT! Welcome to the home of the knight faction! Where memes are welcomed and destroying neckbeards and samurai is the national sport.","over18":false},"TrueCrimeDiscussion":{"lang":"en","description":"This subreddit is an anything and everything place dedicated to discussion of true crime, court cases, and the legal system. It exists as an alternative to heavily moderated groups that put heavy rest","over18":false},"ANTM":{"lang":"en","description":"You wanna be on top?","over18":false},"ImaginaryCharacters":{"lang":"en","description":"Pictorial art of characters from fantasy, sci-fi, history, or other fiction. Armored warriors, powerful wizards, deadly ninjas, intrepid archaeologists, starfighter pilots, badass gunslingers: all are","over18":false},"atheismrebooted":{"lang":"en","description":"The moderators have decided this subreddit is no longer necessary. Please visit one of the many other forums listed in the /r/atheism sidebar.","over18":false},"bitcoinxt":{"lang":"en","description":"A Bitcoin subreddit focused on providing open discussion on all things Bitcoin.","over18":false},"AustralianCattleDog":{"lang":"en","description":"A place for people to share anything to do with this beloved breed.","over18":false},"angularjs":{"lang":"en","description":"A community for the awesome MVC JS framework.","over18":false},"Herpes":{"lang":"en","description":"A community of support and learning for those living with or who have questions about HSV","over18":false},"ESOGuilds":{"lang":"en","description":"A place to find a guild in the Elder Scrolls Online","over18":false},"spaceengine":{"lang":"en","description":"/r/SpaceEngine is the Reddit community for the free universe simulator, SpaceEngine.","over18":false},"Concordia":{"lang":"en","description":"The reddit for students of Concordia University of Montreal, Quebec / Le reddit des étudiant.e.s de L'université de Concordia en Montréal, Québec","over18":false},"DevilMayCry":{"lang":"en","description":"A place where we celebrate the Devil May Cry game series, anime, and comics.","over18":false},"femalehairadvice":{"lang":"en","description":"","over18":false},"gonewildchubby":{"lang":"en","description":"This is a *safe* place for ladies of the chubby variety to share their lovely nude bodies. This is a judgement free zone; ALL sizes are invited to post!","over18":true},"microdosing":{"lang":"en","description":"This is a community for discussion pertaining to microdosing experiments and regimens. The most probable candidates for microdosing are psychedelics, but we encourage dialogue on the effects of any dr","over18":false},"Lawrence":{"lang":"en","description":"","over18":false},"legaladviceofftopic":{"lang":"en","description":"A subreddit for discussions about topics related to /r/legaladvice that aren't appropriate for that forum. ","over18":false},"hurtworld":{"lang":"en","description":"Hurtworld is a Multiplayer Hardcore FPS Survival Sandbox game for PC, Mac and Linux. Currently in development by Bankroll Studios in Melbourne Australia.\n\nThe devs read this! So feel free to leave sug","over18":false},"asshole":{"lang":"en","description":"Pics and vids of (female) assholes.","over18":true},"consoledeals":{"lang":"en","description":"Console Deals has a big collection of PS4 Deals, Xbox One Deals, Nintendo Switch Deals, PS3 Deals, Xbox 360 Deals, Wii U Deals, PS VR Deals, PS Vita Deals & 3DS Deals","over18":false},"sodapoppin":{"lang":"en","description":"For all things related to Twitch streamer Thomas Jefferson!","over18":false},"Invites":{"lang":"en","description":"","over18":false},"HealthyFood":{"lang":"en","description":"###Healthy Food and Healthy Cooking\n\nExperiences information and questions are most welcome. Discussion of Healthy Food - nutrition news and research, food types and how they effect you.  Discussion o","over18":false},"findfashion":{"lang":"en","description":"See something cute that you can't live without? Post a picture or description of it and we'll help you find it!","over18":false},"HondaCB":{"lang":"en","description":"A place for Honda CB Motorcycle owners to chat.","over18":false},"TomorrowWorld":{"lang":"en","description":"A place for people to talk about the new chapter of Tomorrowland, by ID&T!","over18":false},"lgg5":{"lang":"en","description":"The totally not official home of discussion of the LG G5 on reddit.","over18":false},"TheWitness":{"lang":"en","description":"Subreddit for The Witness, a puzzle game scheduled for release in 2015.","over18":false},"hulaween":{"lang":"en","description":"Information, planning and discussion for Suwannee Hulaween music festival at the Spirit of Suwanee Music Park in Live Oak, FL.","over18":false},"falloutequestria":{"lang":"en","description":"The subreddit to discuss and post ponies from post-apocalyptic and wartime My Little Pony stories. Its main focus is the epic crossover fanfiction Fallout Equestria by Kkat and its derivative works.","over18":false},"coversongs":{"lang":"en","description":"For lovers of musical reimagination... remixes, mashups and collaborations are welcome too.","over18":false},"riseagainst":{"lang":"en","description":"Anything related to the band punk/punk rock band Rise Against.","over18":false},"collegesluts":{"lang":"en","description":"/r/CollegeSluts is dedicated to celebrating slutty college girls enjoying themselves. They don't need to be nude, they just have to be hot and slutty! This reddit is automatically NSFW and hardcore co","over18":true},"seriouseats":{"lang":"en","description":"SeriousEats.com is the source for all things delicious from meticulously tested recipes to product and equipment recommendations to restaurant reviews.\n\nWhether it's burgers, pizza, cocktails, or some","over18":false},"CPTSD":{"lang":"en","description":"Complex Post Traumatic Stress Disorder is rarely discussed in public forums, even though healthy connection to others is an integral part of healing. \n\nThis is a support community for those who have u","over18":false},"NoFapWar":{"lang":null,"description":"Subreddit forbidden","over18":null},"DailyShow":{"lang":"en","description":"The Daily Show with Trevor Noah (formerly hosted by Jon Stewarto & Craig Kilborn) is a syndicated American late-night talk and news satire television program, which airs Monday through Thursday. The D","over18":false},"FreeEBOOKS":{"lang":"en","description":"Find great free ebooks!","over18":false},"KingstonOntario":{"lang":"en","description":"A SubReddit for people who live in or care about Kingston, Ontario","over18":false},"wholesomebpt":{"lang":"en","description":"wholesomebpt ","over18":false},"AntiPOZi":{"lang":null,"description":"Subreddit forbidden","over18":null},"Prismata":{"lang":"en","description":"The official subreddit for Prismata, the hybrid strategy game by Lunarch Studios.","over18":false},"shittynosleep":{"lang":"en","description":"scary stories!!!!11!!!1!!","over18":false},"music_survivor":{"lang":"en","description":"Survivor games for all genres of music!","over18":false},"WC3":{"lang":"en","description":"A Subreddit covering the WC3 RTS community. \n\nDon't post about: custom games, ping issues and cd-keys. ","over18":false},"SongStems":{"lang":null,"description":"Subreddit no longer exists","over18":null},"plastidip":{"lang":"en","description":"The subreddit for all things plasti-dip. Show off your projects and learn about dipping.","over18":false},"rbny":{"lang":"en","description":"The reddit home for New York Red Bulls","over18":false},"AdviceAtheists":{"lang":"en","description":"This subreddit is meant for posting dank memes related to atheism","over18":false},"thingsforants":{"lang":"en","description":"What is this, a subreddit for ants??\n\nPost tiny things for ants.","over18":false},"IndianFood":{"lang":"en","description":"Indian Food is your step by step guide to simple and delicious home cooking. From regional Indian cuisine to popular dishes from around the globe, our community's focus is to make cooking easy. Come j","over18":false},"veganrecipes":{"lang":"en","description":"A place for your favorite vegan recipes\n\n","over18":false},"baseballcards":{"lang":"en","description":"Share sports (and relevant non-sports) cards and collectibles, pulls, news, memorabilia, funny stories, case and box breaks, and absolutely no ebay auctions.","over18":false},"pearljam":{"lang":"en","description":"A subreddit about all things Pearl Jam. Of course we're talking about the best band from the 1990s featuring Eddie Vedder, Mike McCready, Stone Gossard, Jeff Ament, and Matt Cameron. See wikipedia for","over18":false},"delusionalcraigslist":{"lang":"en","description":"","over18":false},"hypotheticalsituation":{"lang":"en","description":"We are a fun, interesting, and creative subreddit for you to ask what others would do in certain hypothetical situations.","over18":false},"nextdoorasians":{"lang":"en","description":"\"Girl Next Door\" Asians\n\n\n---------\n\n\n**Rules**\n\n* No celebs or pro models.\n\n* No pro photoshoots.\n\n* No airbrushed photos.\n\n* No personal info.\n\nJust pics of girls you know or ~~stalk~~ follow.\n","over18":true},"datfeel":{"lang":"en","description":"","over18":false},"victoria2":{"lang":"en","description":"For discussion about the game Victoria 2 by Paradox Interactive. \n\n","over18":false},"CNC":{"lang":"en","description":"For anything CNC related: CAD, CAM, automation, and more!","over18":false},"pokemongoyellow":{"lang":"en","description":"This is a subreddit for the members of Team Instinct in the game Pokemon Go!\n\nYou never lose when you trust your instinct! ","over18":false},"MCSXbox":{"lang":"en","description":"A place to buy and sell Madden Ultimate Team coins for Xbox Consoles and PC","over18":false},"htc":{"lang":"en","description":"","over18":false},"bulgaria":{"lang":"bg","description":"A subreddit to discuss anything related to the country of Bulgaria. \nEnglish and Bulgarian speakers are welcome. \n \n\nСъбредит за обсъждане на всичко свързано с България и българите.","over18":false},"MakeupAddictionCanada":{"lang":"en","description":"Tips and tricks for Canadians who love makeup. \"Where-to-find\" and other weekly posts coming soon!","over18":false},"FapDeciders":{"lang":"en","description":"","over18":true},"UndertaleCringe":{"lang":"en","description":"undertale cringe, featured here","over18":false},"Tallahassee":{"lang":"en","description":"A subreddit for those living in or visiting Florida's capital city, the 126th largest city in the USA, Tallahassee. ","over18":false},"barista":{"lang":"en","description":"","over18":false},"shittankiessay":{"lang":null,"description":"Subreddit forbidden","over18":null},"otomegames":{"lang":"en","description":"An otome game is a visual novel that mainly targets the female audience (otome gēmu means Maiden Game). Here we discuss our favorites and least favorites, suggest other games for our fellow maidens, a","over18":false},"submechanophobia":{"lang":"en","description":"Welcome to /r/submechanophobia; the fear of partially or fully submerged man-made objects","over18":false},"gpdwin":{"lang":"en","description":"A community dedicated to the GPD Win and GPD Win 2! Fully featured Windows 10 devices that fit in your pocket. ","over18":false},"MoneroMining":{"lang":"en","description":"A subreddit for discussions about Monero (XMR) mining.","over18":false},"SWARJE":{"lang":"sv","description":"Sverige - frihetens och välfärdens land!","over18":false},"Moviesinthemaking":{"lang":"en","description":"A behind-the-scenes look at the wonderful world of movies","over18":false},"HermitCraft":{"lang":"en","description":"A community for fans and members of the HermitCraft Minecraft Server!","over18":false},"DebateAVegan":{"lang":"en","description":"A place for meat eaters to debate with vegans/vegetarians, and ask genuine questions about animal rights and welfare, health, nutrition, philosophy, or any topic relating to veganism. ","over18":false},"estoration":{"lang":"en","description":"/r/estoration is a subreddit for everything related to restoring photographs.","over18":false},"RenewableEnergy":{"lang":"en","description":"* Share your fascinating links about renewable energy\n* Discuss new renewable technologies\n* Contribute news about renewable energy usage\n* Meet other renewable energy enthusiasts\n* Enjoy our function","over18":false},"roasting":{"lang":"en","description":"/r/Roasting hosts discussion of roasting coffee.","over18":false},"OakIsland":{"lang":"en","description":"This reddit will be a place to discuss the mysteries associated with Oak Island. And, also a place to discuss the television show \"Curse of Oak Island\" on the History Channel.","over18":false},"harvestmoon":{"lang":"en","description":"Discuss Harvest Moon, Rune Factory, and Story of Seasons games here!","over18":false},"askhillarysupporters":{"lang":"en","description":"Ask supporters of Hillary Clinton for President","over18":false},"uspolitics":{"lang":"en","description":"A subreddit for US Politics.","over18":false},"caseclickers":{"lang":"en","description":"Official subreddit for Case Clicker!","over18":false},"EVEX":{"lang":"en","description":"An experiment in user content on reddit. The idea is any content is allowed and then frequent votes by the community decide what topics or content is no longer allowed until we reach a focused subset ","over18":false},"100DaysofKeto":{"lang":"en","description":"This sub has been created for Keto newbies, professionals, and anyone in-between, who is interested in making a 100 day commitment to the Keto lifestyle. This sub is different than r/keto and r/xxketo","over18":false},"brandonsanderson":{"lang":"en","description":"News, stories, and updates for Brandon Sanderson: author of Mistborn, Stormlight Archive, the final Wheel of Time books, Reckoners, Alcatraz, and many more!","over18":false},"GoForGold":{"lang":"en","description":"Do challenges, get gold! Give challenges, give gold!","over18":false},"Team_Awesome":{"lang":null,"description":"Subreddit forbidden","over18":null},"MusicBattlestations":{"lang":"en","description":"If you make music, show us how and where you do it! Be it a bedroom studio, professional studio, or kitchen table - takes all kinds.","over18":false},"imaginedragons":{"lang":"en","description":"Subreddit for the American rock/pop band, Imagine Dragons. Imagine Dragons consists of Dan Reynolds, Wayne Sermon, Ben McKee, and Daniel Platzman.","over18":false},"AlAnon":{"lang":"en","description":"Subreddit for discussion of recovery in [Al-Anon](http://www.al-anon.alateen.org/).\n","over18":false},"AntiAntiJokes":{"lang":"en","description":"reddit's home for absurd humor\n\n**What *is* an AntiAntiJoke??**  Well....\n\n* Jokes have funny punchlines.\n* AntiJokes have mundane, run-of-the-mill punchlines.\n* AntiAntiJokes have absurd, ridiculous,","over18":false},"bestofnetflix":{"lang":"en","description":"This subreddit contains the best of movies on Netflix.","over18":false},"beagle":{"lang":"en","description":"**Please come share pictures and stories of your merry little hounds!**","over18":false},"TeamSESH":{"lang":"en","description":"Team SESH fans, etc.","over18":false},"olkb":{"lang":"en","description":"A support forum and news outlet for OLKB products and QMK Firmware! Please post pics and code, otherwise it's difficult to help!\n\nIf you need to make a change to your order, please email hello@olkb.co","over18":false},"nSuns":{"lang":"en","description":"This subreddit is for discussion of the nSuns LP program, and all of the variants (4, 5, and 6 day versions) as well as the CAP3, CAP6, CAP2, and other associated programs written by user /u/nSuns\n\nDi","over18":false},"FinancialPlanning":{"lang":"en","description":"Discuss and ask questions about personal finances, budgeting, income, retirement plans, insurance, investing, and frugality.","over18":false},"AnimalTextGifs":{"lang":"en","description":"This subreddit is for gifs of animals with text over them.","over18":false},"witchcraft":{"lang":"en","description":"","over18":false},"lesbians":{"lang":"en","description":"A reddit community for NSFW girl on girl action. Submit lesbian photos, videos, or gifs.","over18":true},"leopardgeckos":{"lang":"en","description":"A page for pictures and questions regarding Leopard Geckos. Flaunting allowed.","over18":false},"QuinnMains":{"lang":"en","description":"For fellow Quinn players!","over18":false},"Endo":{"lang":"en","description":"A place for people to share stories, find support, talk treatments and share information about the disease. There's a lot of misinformation out there about this condition - this is a place dedicated t","over18":false},"peegonewild":{"lang":"en","description":"Pee. It's something most of us do 3, 4 or more times per day, every day of our lives. \n\nThis is the place for anyone 18+ to share those times. Whether it's your tamest toilet pee photos or your wettes","over18":true},"engrish":{"lang":"en","description":"Phuck ups in english of any kind!","over18":false},"ZenHabits":{"lang":"en","description":"Simple and practical wisdom on happiness, goals, relationships, meditation, and self-improvement.","over18":false},"Izlam":{"lang":"en","description":"Muslim satire. As in Satire for Muslims. Not like a hate subreddit. It's satire. \n","over18":false},"WiiUHacks":{"lang":"en","description":"A subreddit dedicated to Wii U hacking and homebrew!","over18":false},"photomarket":{"lang":"en","description":"Find buyers, sellers, and traders for all your camera equipment both photo and video.","over18":false},"spaceflight":{"lang":"en","description":"A subreddit for articles, images, videos and discussion about spaceflight.","over18":false},"BulkOrCut":{"lang":"en","description":"For everyone who wants to know whether they should bulk or cut for cosmetic appearance or general health. ","over18":false},"SportingKC":{"lang":"en","description":"2000 Supporters' Shield champs, 2X MLS Cup champs, 4X US Open Cup champs.","over18":false},"emojipasta":{"lang":"en","description":"In Cummybot We Trust","over18":false},"CarletonU":{"lang":"en","description":"Carleton University is a university in Ottawa, Canada.","over18":false},"snapchatgeofilters":{"lang":"en","description":"Obsessed with Snapchat Geofilters? Well, you've come to the right place. \n\nPost cool geofilters you've encountered from all around the world, post your own creations for critiquing, or request a geofi","over18":false},"WiiHacks":{"lang":"en","description":"This reddit is for people interested in modifying their Wii.","over18":false},"MEOW_IRL":{"lang":"en","description":"Post cats","over18":false},"FloridaPanthers":{"lang":"en","description":"#OneTerritory","over18":false},"Psoriasis":{"lang":"en","description":"A subreddit designed to help those looking for help in all matters relating to Psoriasis.  Whether it's relating anecdotes for support, giving advice, or looking for help... All posts welcome (spam/SE","over18":false},"DarkEnlightenment":{"lang":"en","description":"A place to discuss the terrible state of the modern world that has resulted from the progressive religion of egalitarianism. \n\n\"In a time of universal deceit, telling the truth is a revolutionary act.","over18":false},"Munich":{"lang":"en","description":"","over18":false},"computerscience":{"lang":"en","description":"","over18":false},"Vinesauce":{"lang":"en","description":"This subreddit is about the Vinesauce Community and Streamers.","over18":false},"portugaltheman":{"lang":"en","description":"","over18":false},"SharePLEX":{"lang":"en","description":"A place to share invitations to your personal PLEX server and request access to others!","over18":false},"Twitter":{"lang":"en","description":"Everything about Twitter!","over18":false},"ECR_UK":{"lang":"en","description":"Electronic Cigarette UK - UK Vapers forum ","over18":false},"HaloPlayers":{"lang":"en","description":"Find friends to play Halo with!","over18":false},"Offensive_Wallpapers":{"lang":"en","description":"Lovely wallpapers with inspiring quotes.","over18":false},"doodles":{"lang":"en","description":"This is the subreddit to show the world your doodles. All doodles are welcome, whether ballpoint pen on notebook papers, colored pencil on drawing pad, or sharpie on pizza box! Concept work, sketches,","over18":false},"voluptuous":{"lang":"en","description":"Welcome to the home of sexy curves, a place to share pictures of the worlds more voluptuous babes. Sexy ladies showing off the big natural boobs or smaller tits, hot ass, big booty, juicy butt. We're ","over18":true},"pokemonshowdown":{"lang":"en","description":"","over18":false},"DowntonAbbey":{"lang":"en","description":"","over18":false},"csmapmakers":{"lang":"en","description":"/r/CSMapMakers is a sub-Reddit dedicated to the art of map creation for the Counter Strike series. All skill levels of map creators are welcome to share their maps, discuss or inquire about mapping te","over18":false},"kungfu":{"lang":"en","description":"A humble community of practitioners of the Traditional Chinese Martial Art. We're here to talk about all the aspects of kung fu including philosophy, logic, medicine, health, mental/physical fitness, ","over18":false},"d3hardcore":{"lang":"en","description":"The Diablo 3 Hardcore Community - dedicated to doing it all with one life. With death around every corner, please don't make any sudden moves, we tend to be a bit jumpy. ","over18":false},"M43":{"lang":"en","description":"","over18":false},"whitewater":{"lang":"en","description":"Welcome to r/whitewater! \n\nThis subreddit is a place to discuss anything and everything relating to whitewater. ","over18":false},"AdobeIllustrator":{"lang":"en","description":"The home of Adobe Illustrator on reddit. We welcome people with questions, tutorials, art to show off, critics... ***all things Illustrator!***","over18":false},"LegionOfSkanks":{"lang":"en","description":"Subreddit for fans of the Legion Of Skanks podcast, Big Jay Oakerson, Luis J Gomez, Dave Smith, and anything related to them. ","over18":false},"SQLServer":{"lang":"en","description":"Microsoft SQL Server Administration and T-SQL Programming including sql tutorials, training, MS SQL Server Certification, SQL Server Database Resources.","over18":false},"mitsubishi":{"lang":"en","description":"","over18":false},"grimm":{"lang":"en","description":"A subreddit all about *Grimm*, the \"fantasy/mystery/crime drama\" series on NBC. Discuss anything and everything about the show here. ","over18":false},"arkps4":{"lang":"en","description":"A fan based subbreddit for Ark players on the Playstation 4","over18":false},"shrimptank":{"lang":"en","description":"SKRIIIIIMPS!","over18":false},"sad":{"lang":"en","description":"","over18":false},"Petscop":{"lang":"en","description":"This subreddit is devoted to the mystery known as Petscop, an obscure PlayStation game developed around 1997 by a company called Garalina. The game includes simple gameplay and a storyline in which cr","over18":false},"NSFW_HTML5":{"lang":"en","description":"The Fastest Format for Fapping","over18":true},"dpdr":{"lang":"en","description":"Welcome! This is a subreddit dedicated to sufferers of depersonalization and derealization. Please feel free to discuss any symptoms/stories and any curing techniques that have helped you overcome the","over18":false},"xposed":{"lang":"en","description":"Xposed Framework modules and everything Xposed Framework-related.","over18":false},"evejobs":{"lang":"en","description":"The job fair.... in space!","over18":false},"MadMax":{"lang":"en","description":"For everything and anything Mad Max.  ","over18":false},"adderall":{"lang":"en","description":"Place to talk about any prescription psychostimulant, typically on it. ","over18":false},"chuck":{"lang":"en","description":"A subreddit for discussion of the TV show \"Chuck\". Open to discussions, theories, and everything Chuck related. ","over18":false},"dota2pubs":{"lang":"en","description":"Have you grown tired of solo-queue? Has it gotten old when your entire team picks carries then yells at each other, can't stand that the other team is beating you even though you know you shouldn't be","over18":false},"theydidthefuckyou":{"lang":"en","description":"Fuck You","over18":false},"fpvracing":{"lang":"en","description":"A subreddit for FPV racing and freestyle discussion and content. Please read the rules in the sidebar before posting.","over18":false},"regularcarreviews":{"lang":"en","description":"This is a subreddit for fans of Regular Car Reviews, on youtube.\n\n","over18":false},"noisygifs":{"lang":"en","description":"For gifs that make you cover your ears.","over18":false},"transgenderUK":{"lang":"en","description":"A place for transgender and genderqueer people in the UK\n\n","over18":false},"toledo":{"lang":"en","description":"","over18":false},"ledgerwallet":{"lang":"en","description":"Discussions about Ledger's products. Visit us @ ledger.com","over18":false},"ihavesex":{"lang":"en","description":"We get it - you have sex. ","over18":false},"comicbookart":{"lang":"en","description":"","over18":false},"indie_rock":{"lang":"en","description":"A place to share and discover new (and old) music that seems to fly under the radar.","over18":false},"suicidegirls":{"lang":"en","description":"Suicide Girls on Reddit","over18":true},"infiniti":{"lang":"en","description":"A place for Infiniti owners and fans to hang out and chat about the cars, brand, modding, and more. \n\nSimilar Nissan cars, like the 350z, are welcome here","over18":false},"Legomarket":{"lang":"en","description":"Reddit's LEGO Marketplace. Advertise your LEGO products for sale, search for desired LEGO products, or make a LEGO swap with other Redditors!","over18":false},"ATC":{"lang":"en","description":"","over18":false},"TruePokemon":{"lang":"en","description":"A Pokemon subreddit for insightful discussion, articles, and original content.","over18":false},"theNvidiaShield":{"lang":"en","description":"","over18":false},"youtubetitties":{"lang":"en","description":"A place to find videos on YouTube with frontal nudity in them. A good time. It's NSFW.","over18":true},"FTH":{"lang":"en","description":"","over18":false},"OneyPlays":{"lang":"en","description":"Official Subreddit for OneyPlays. ","over18":false},"SaintsRow":{"lang":"en","description":"","over18":false},"Modern_Family":{"lang":"en","description":"A place for fans of ABC's hit show Modern Family.","over18":false},"nationalguard":{"lang":"en","description":"Location for current, potential, and veteran soldiers and airmen of the US National Guard.","over18":false},"redditisfun":{"lang":"en","description":"Welcome to the official subreddit for the reddit is fun android app!","over18":false},"Utah":{"lang":"en","description":"A subreddit for Utahns.","over18":false},"VaporwaveAesthetics":{"lang":"en","description":"A subreddit for vaporwave aesthetics. Actualize your musical creations with the cutting-edge cross-media solutions of Aesthetics Corp. ","over18":false},"AsiaTripper":{"lang":"zh","description":"歡迎來到AsiaTripper，這裡是一個讓亞洲國家及世界各地的中文使用者進行各種精神活性物質（Psychoactive Substances）資訊交流與討論的平台，我們致力於推廣減害運動（Harm Reduction），並分享與精神藥物相關正確、安全、專業、科學的知識，希望不要再有人因為用藥資訊不足而過量、濫用、依賴藥物導致人生陷入泥沼甚至因此喪命。\n\n在此，你可以盡情討論任何合法或非法的精神作","over18":false},"mypartneristrans":{"lang":"en","description":"","over18":false},"cedarrapids":{"lang":"en","description":"Discussion about Cedar Rapids, Iowa.","over18":false},"coolgithubprojects":{"lang":"en","description":"Sharing Github projects just got easier!","over18":false},"MUTCoinSelling":{"lang":"en","description":"To Buy/Sell coins in Madden Ultimate Team","over18":false},"cowboybebop":{"lang":"en","description":"For fans of the acclaimed 1998 Japanese anime series developed by Sunrise.","over18":false},"Juicing":{"lang":"en","description":"This community consists of folks interested in adding juicing to their lifestyles for general health and/or weight loss via juice fast (also called juice feast). Several established members of this co","over18":false},"girls":{"lang":"en","description":"Catch up on and discuss HBO's comedy TV series Girls","over18":false},"SigSauer":{"lang":"en","description":"","over18":false},"MyPeopleNeedMe":{"lang":"en","description":"I MUST GO.","over18":false},"physicaltherapy":{"lang":"en","description":"Please share your new developments or old tricks in  physiotherapy/physical therapy.","over18":false},"TransSpace":{"lang":"en","description":"This is a place for all trans\\* identified individuals, those questioning their identities, and allies. Transphobic, homophobic, sexist, and racist speech will not be tolerated. \n","over18":false},"Jewdank":{"lang":"en","description":"Like /r/DankChristianMemes, but Semitic\n","over18":false},"reasoners":{"lang":"en","description":"hey you.  do you write music?  do you use propellerheads' reason software to do so?  just have questions about it?  bored and want to hear redditor's original music?  stop on in!  some of that's here!","over18":false},"Zombidle":{"lang":"en","description":"Zombidle's community!","over18":false},"EntrepreneurRideAlong":{"lang":"en","description":"","over18":false},"douglovesmovies":{"lang":"en","description":"Hi everybody, I'm a redditor and I love Doug Loves Movies. This is r/douglovesmovies coming to you live from reddit.com on the internet. \n#####[Doug Loves Movies](http://reddit.com/r/douglovesmovies) ","over18":false},"Cornell":{"lang":"en","description":"The subreddit for Cornell University, located in Ithaca, NY.","over18":false},"joinrobin":{"lang":"en","description":"Join Robin","over18":false},"recordthis":{"lang":"en","description":"/r/recordthis is a community of voiceover artists, vocalists, audio engineers and musicians dedicated to the art of audio. Make a request, or offer your voice services!","over18":false},"AskStatistics":{"lang":"en","description":"","over18":false},"Darkfall":{"lang":"en","description":"Darkfall was the notorious sandbox MMORPG created by Aventurine. An Open World Fantasy FPS, Full loot, Free for all PvP, Skill Based, player run economy, city/house ownership, ship combat, clan warfar","over18":false},"GirlswithNeonHair":{"lang":"en","description":"","over18":true},"dawnofwar":{"lang":"en","description":"A reddit about the Warhammer 40.000 Dawn of war games and their expansions. Discussions, news, strategies and anything regarding the DoW series.","over18":false},"VoiceActing":{"lang":"en","description":"Dedicated to everything voice acting and voiceover!","over18":false},"HillaryMeltdown":{"lang":"en","description":"A place to share the epic and less epic meltdowns of Hillary Clinton supporters. Post meltdowns of Hillary supporting media personalities, friends and family, celebrities fellow redditors and more. Th","over18":false},"CinemaSins":{"lang":"en","description":"The official subreddit of that youtube channel, CinemaSins. Because everyone needs a place to talk about how lap dances aren't in that scene of that movie. ","over18":false},"selfhosted":{"lang":"en","description":"A place to share alternatives to popular online services that can be self hosted without giving up privacy or locking you into a service you don't control.","over18":false},"EOOD":{"lang":"en","description":"Exercise Out Of Depression\n\nA movement to provide information and support to those who would like to take up an active lifestyle, who may suffer from depression, anxiety, eating disorders, confidence ","over18":false},"DarthJarJar":{"lang":"en","description":"This subreddit is dedicated to the speculation - and ultimate revelation of - the true Sith Master, Jar Jar Binks.","over18":false},"Temple":{"lang":"en","description":"Cherry and White!","over18":false},"heraldry":{"lang":"en","description":"For discussions pertaining to the science and art of heraldry, coats of arms, blazonry, and the like.","over18":false},"ElectricalEngineering":{"lang":"en","description":"A place to ask questions, discuss topics and share projects related to Electrical Engineering.\n","over18":false},"sociology":{"lang":"en","description":"","over18":false},"LOLDyrus":{"lang":"en","description":"A Sub-reddit where dyrus and friends come to discuss things about league and other stuff.","over18":false},"CandidFashionPolice":{"lang":null,"description":"Subreddit no longer exists","over18":null},"BorderCollie":{"lang":"en","description":"Welcome to the best place to learn about Border Collies and share about them. Share your pictures, videos, stories, training tips, etc. We welcome all border collies and mixes too!","over18":false},"GT5":{"lang":"en","description":"","over18":false},"creepygaming":{"lang":"en","description":"This subreddit is a place for all the creepy, seemingly unintentional/out of place things that happen in video games. A home for ARG's, obscure games, creepypasta, personal stories, haunted games, myt","over18":false},"OperationGrabAss":{"lang":"en","description":"","over18":false},"FTC":{"lang":"en","description":"","over18":false},"CanadianHardwareSwap":{"lang":"en","description":" A community for Canadians to trade computer hardware and anything related.","over18":false},"Leeds":{"lang":"en","description":"","over18":false},"DesignMyRoom":{"lang":"en","description":"**Welcome to DesignMyRoom!**\n Just submit pictures of your room, a layout with measurements, and we will help you rearrange it! Please specify budget, location ie: North America, Europe, etc. You can ","over18":false},"wls":{"lang":"en","description":"","over18":false},"pens":{"lang":"en","description":"A subreddit dedicated to pens!","over18":false},"baylor":{"lang":"en","description":"The unofficial subreddit of Baylor University.","over18":false},"kansas":{"lang":"en","description":"","over18":false},"karate":{"lang":"en","description":"","over18":false},"DimensionalJumping":{"lang":"en","description":"An archive of a subreddit intended for all those interested in exploring the nature of experiencing, by experimenting with making deliberate shifts to its content and considering the implications of t","over18":false},"MassEffectAndromeda":{"lang":"en","description":"Mass Effect: Andromeda Subreddit","over18":false},"Kingdom":{"lang":"en","description":"Kingdom is a Japanese manga series written and illustrated by Yasuhisa Hara (泰久原).\n\nThe manga provides a fictionalized account of the Warring States period primarily through the experiences of the war","over18":false},"doppelbangher":{"lang":null,"description":"Subreddit no longer exists","over18":null},"LogitechG":{"lang":"en","description":"Welcome to the Logitech G subreddit! This is the place to talk about Logitech G hardware and software, pro gaming competitions and our sponsored teams and players. We love getting feedback and hearing","over18":false},"poledancing":{"lang":"en","description":"A place for all things pole fitness related. Members of all shapes, sizes, genders and levels are welcome to post, learn, discuss and share!\n","over18":false},"Femdom":{"lang":"en","description":"r/femdom \nA place to enthusiastically indulge in your favorite fetish! \n\nDedicated to discussions, FAQs and experiences related to female domination in BDSM. ","over18":true},"datgap":{"lang":"en","description":"You know what's up. Dat gap. ","over18":true},"humblebrag":{"lang":"en","description":"","over18":false},"ButtonAftermath":{"lang":"en","description":"The button has ended, but the fever lives on.  How did it end?  Who won?  What was accomplished?  All these things and more can be talked about.","over18":false},"SovietWomble":{"lang":"en","description":"**A subreddit dedicated to all things regarding the YouTuber/Streamer SovietWomble.**","over18":false},"aikido":{"lang":"en","description":"Aikido comes from the same martial lineage as judo and jujitsu. It emphasizes blending with attacks rather than countering force with force, and utilizes throws, joint locks, and pins. Although many t","over18":false},"opera":{"lang":"en","description":"This is ***NOT*** the sub for the opera **browser**.  That's /r/operabrowser, surprisingly enough.","over18":false},"BDSMpersonals":{"lang":"en","description":"","over18":true},"pihole":{"lang":"en","description":"\"The Pi-hole® is an advertising-aware DNS server that prevents ads from being downloaded.\"  \n\nhttps://pi-hole.net/","over18":false},"nyu":{"lang":"en","description":"A forum for all members of the New York University community.","over18":false},"holdmyjuicebox":{"lang":"en","description":"Those youngsters too young for beer? Try Hold my Juice Box instead.\n\nThis subreddit is for pictures, videos and GIFs of children attempting things, but failing at it because of their lack of judgement","over18":false},"PokemonTCG":{"lang":"en","description":"A community for players of the Pokemon Trading Card Game to show off pulls and discuss the game.","over18":false},"EtrianOdyssey":{"lang":"en","description":"A community about the Etrian Odyssey series of video games, published by Atlus & Index Corporation.","over18":false},"familyguythegame":{"lang":"en","description":"Family Guy: The Quest for Stuff is mobile game by TinyCo along with Fox based on popular American sitcom. ","over18":false},"Superbowl":{"lang":"en","description":"For owl lovers everywhere","over18":false},"KidCudi":{"lang":"en","description":"The Journey to Mother Moon.","over18":false},"cosplayers":{"lang":"en","description":"","over18":false},"ballpython":{"lang":"en","description":"A place for all things Ball Python (Python regius). ","over18":false},"volt":{"lang":"en","description":"Chevy Volt news and discussion","over18":false},"CompetitiveHalo":{"lang":"en","description":"A haven for all things based on the Halo series and its competitive community, featuring all games from the series from Bungie's Combat Evolved to 343's Halo 5.","over18":false},"industrialmusic":{"lang":"en","description":"","over18":false},"NJTech":{"lang":"en","description":"The unofficial subreddit for NJIT students! Go Highlanders!\n\n ##r/njtech on Freenode","over18":false},"XCOM2":{"lang":"en","description":"Discussion sub for the turn-based strategy game from Firaxis, XCOM 2.","over18":false},"porn_gifs":{"lang":"en","description":"This subreddit contains all types of hardcore/sex gifs.","over18":true},"assholegonewild":{"lang":"en","description":"Gonewild style photos of female assholes! This sub is for OC only. ","over18":true},"low_poly":{"lang":"en","description":"The 3D low-poly subreddit is dedicated to posting stylized low-poly art, landscapes, environments, characters, etc. as well as having discussions about techniques, tips, etc.  ","over18":false},"bigasses":{"lang":"en","description":"Big asses on beautiful ladies","over18":true},"gifsthatendtoosoon":{"lang":"en","description":"This sub is for all gifs and webms that cut off too soon.","over18":false},"c137":{"lang":"en","description":"A subreddit for discussion and news about Rick and Morty.","over18":false},"ForeverAloneWomen":{"lang":null,"description":"Subreddit forbidden","over18":null},"Petloss":{"lang":"en","description":"r/petloss is a community of support for Pet owners whose Pets have passed away. This is not a place to post lost Pet stories or any other news about Pets. ","over18":false},"YookaLaylee":{"lang":"en","description":"Yooka-Laylee is an all-new open-world platformer from key creative talent behind the Banjo-Kazooie and Donkey Kong Country games.\n\nNewly-formed as Playtonic Games, the team is building a spiritual suc","over18":false},"f150":{"lang":"en","description":"This sub is dedicated to the Ford f-150 and discussion of anything pertaining to it.","over18":false},"Zappa":{"lang":"en","description":"","over18":false},"k12sysadmin":{"lang":"en","description":"","over18":false},"SkyPorn":{"lang":"en","description":"High quality images of the sky.","over18":false},"mkxmobile":{"lang":"nl","description":"Come discuss strategies, questions, and card collections for Mortal Kombat X Mobile!","over18":false},"dominion":{"lang":"en","description":"","over18":false},"FrugalFemaleFashion":{"lang":"en","description":"A place for awesome deals, cute clothes, chatting about thrifting, and frugally shopping for fashion!","over18":false},"origami":{"lang":"en","description":"","over18":false},"LandRover":{"lang":"en","description":"","over18":false},"dashcamgifs":{"lang":"en","description":"A subreddit for crazy POV gifs shot from any vehicle. this includes gopro, cellphone, drone, and helmet cams as long as they are shot from some kind of vehicle.  \n\n**This sub is best viewed in classic","over18":false},"PokemonGoSpoofing":{"lang":"en","description":"Pokemon Go Spoofing – The #1 Hub for Spoofers!","over18":false},"joerogan2":{"lang":"en","description":"We're BACK! Sub open Nov 1 2017","over18":false},"valkyrie_en":{"lang":"en","description":"Connect with Norse Gods and Goddesses","over18":false},"boobbounce":{"lang":"en","description":"The boobs. They bounce. And it was good.","over18":true},"RapeSquadKillas":{"lang":"en","description":"WE HAVE MOVED TO /r/PKA. ","over18":false},"GayChubs":{"lang":"en","description":"","over18":true},"chanceme":{"lang":"en","description":"This /r/ApplyingToCollege sister sub is for anyone who wants feedback from others about their chances of acceptance at colleges and universities. When you ask for chances/advice, give as much informat","over18":false},"binance":{"lang":"en","description":"Binance is a blockchain ecosystem comprised of Exchange, Labs, Launchpad, and Info.  Binance Exchange is one of the fastest growing and most popular cryptocurrency exchanges in the world. Founded by a","over18":false},"birding":{"lang":"en","description":"birding. birdwatching. twitching. listing. whatever you want to call it, if you are looking at or listening to birds you should be submitting links here.\n","over18":false},"dancemoms":{"lang":"en","description":"Whether you're a die hard fan or it's just your guilty pleasure, this subreddit is for the TV show Dance Moms. Just remember, \"Everyone's replaceable!\"","over18":false},"nathanforyou":{"lang":"en","description":"Welcome to the Nathan For You subreddit! \n\nThis is a place to post and discuss Nathan For You, which will be airing its second season on Comedy Central this spring! Please feel free to discuss any Nat","over18":false},"minines":{"lang":"en","description":"A spot to discuss the miniNES (NES Classic Edition), it's games, and modifications.","over18":false},"sharditkeepit":{"lang":"en","description":"r/ShardItKeepIt was founded on the principle of whether a weapon should be kept or sharded. We pride ourselves in knowing the weapons of Destiny and Destiny 2 and helping others find proper weapons fo","over18":false},"Ghost_in_the_Shell":{"lang":"en","description":"「攻殻機動隊」(kokaku kidotai) Ghost in the Shell - Community hub.\n\nAll things cyberpunk, future tech, or philosophical, relatable to Ghost in the Shell are welcome.\n\nGhost in the Shell is a futuristic, poli","over18":false},"ColbertRally":{"lang":"en","description":"","over18":false},"Trombone":{"lang":"en","description":"","over18":false},"lisp":{"lang":"en","description":"A subreddit for the Lisp family of programming languages.","over18":false},"MAME":{"lang":"en","description":"MAME stands for Multiple Arcade Machine Emulator. When used in conjunction with images of the original arcade game's ROM and disk data, MAME attempts to reproduce that game as faithfully as possible o","over18":false},"Dota2Betting":{"lang":"en","description":"/r/dota2betting is a subreddit dedicated to Dota 2 betting, match discussions, and other related activities.","over18":false},"chinchilla":{"lang":"en","description":"This is an educational group.  We are a community of breeders and knowledgeable pet owners. We love to see cute pics of your chinchillas, but the main emphasis will be on chinchilla health and safety.","over18":false},"copenhagen":{"lang":"en","description":"This is a sub-reddit for all that live in or near Copenhagen, or just want to be in contact with whats happening in the city of Copenhagen. All discussions are welcomed so please subscribe, participat","over18":false},"aclfestival":{"lang":"en","description":"","over18":false},"shoegaze":{"lang":"en","description":"","over18":false},"PreggoPorn":{"lang":"en","description":"A safe and welcoming community for pregnant self posts, as well as for notable finds around the web. ","over18":true},"onguardforthee":{"lang":"en","description":"The only general Canada subreddit that doesn't allow bigotry or hate.","over18":false},"adops":{"lang":"en","description":"General discussions about the ad operations (AdOps) community. Whether you're here for ad serving, a digital publisher, a digital agency, or just general digital media.","over18":false},"FromTheDepths":{"lang":"en","description":"From the Depths Game","over18":false},"ArianaGrande":{"lang":"en","description":"For fans of Ariana Grande.","over18":false},"CabaloftheBuildsmiths":{"lang":"en","description":"The cabal provides complete, no nonsense, ready to buy computer parts lists that will give you the most performance for your use case at your budget. Our interests in finding the best price/performanc","over18":false},"Kindred":{"lang":"en","description":"A subreddit dedicated to League of Legends players who love playing Kindred, The Eternal Hunters.","over18":false},"ModSupport":{"lang":"en","description":"supporting our moderators","over18":false},"dota2circlejerk":{"lang":"en","description":"DOTA2 Circlejerk","over18":false},"Masterchef":{"lang":"en","description":"","over18":false},"pkmntcgreferences":{"lang":"en","description":"The official reference subreddit for /r/pkmntcgtrades.","over18":false},"NSFW_Snapchat":{"lang":"en","description":"/r/NSFW_Snapchat is a place for all of your sexy, secret, and seductive snapchat screenshots. This subreddit is automatically NSFW so both softcore and hardcore content are welcome.","over18":true},"tinydick":{"lang":"en","description":"This subreddit collects pictures, GIFs and videos of small penises! Come join us.","over18":true},"bugs":{"lang":"en","description":"Have you found a bug with specifically reddit itself?   We only handle reddit specific issues here.  ","over18":false},"FemmeThoughts":{"lang":"en","description":"FemmeThoughts is a casual, comfortable space for women and friends to share perspectives and experiences in relative peace.","over18":false},"KeepOurNetFree":{"lang":"en","description":"KeepOurNetFree","over18":false},"gloving":{"lang":"en","description":"We are a subreddit community made for glovers and gloving enthusiasts! Gloving's rise in the rave and electronic dance music culture has provided an artistic movement of love and lightshows! Come shar","over18":false},"ERB":{"lang":"en","description":"/r/ERB is a discussion platform for anything and everything ERB","over18":false},"auburn":{"lang":"en","description":"Auburn, Alabama and the Auburn University","over18":false},"mapmaking":{"lang":"en","description":"A community for people that enjoy creating maps- both grounded in history and the grand realms of fantasy.","over18":false},"tabletopsimulator":{"lang":"en","description":"Tabletop Simulator is the only simulator where you can let your aggression out by flipping the table! There are no rules to follow: just you, a physics sandbox, and your friends. Make your own games a","over18":false},"battletech":{"lang":"en","description":"","over18":false},"fujix":{"lang":"en","description":"","over18":false},"Slovenia":{"lang":"sl","description":"The subreddit of a beautiful, tiny European country.","over18":false},"FindAUnit":{"lang":"en","description":"This subreddit is for advertising or finding ArmA groups. This is NOT a subreddit for DayZ, please do not recruit for DayZ here. If you are interested in discussing ArmA and looking for news or update","over18":false},"uscg":{"lang":"en","description":"This is the un-official USCG Reddit page. Stop by and see what's going on in the fleet, or ask us a question you might have about the Coast Guard.","over18":false},"classicalguitar":{"lang":"en","description":"A gathering place for practicing classical guitarists and fans of the guitar. Post your questions, share your finds, participate in the Jams and get some encouragement from other redditors just like y","over18":false},"gameofbands":{"lang":"en","description":"Game of Bands - Reddit's longest running songwriting competition.","over18":false},"redditdev":{"lang":"en","description":"A subreddit for discussion of reddit API clients.","over18":false},"prowrestling":{"lang":"en","description":"**Y**our arena for the enjoyment of the performance art and pseudo-sport aspects of pro wrestling.\n\nGreat wrestling from around the world, throughout history, and of many styles is welcomed here and g","over18":false},"apocalympics2016":{"lang":"en","description":"A subreddit to document happenings surrounding the 2016 Olympics in Rio de Janeiro, Brazil - and to take note of any disasters, foreseen or unforeseen - surrounding the event.","over18":false},"swgemu":{"lang":"en","description":"A subreddit for discussion of the amazing Star Wars Galaxies Emulator (SWGEmu) and the servers based on its code.","over18":false},"3d6":{"lang":"en","description":"aid other tabletop gamers in creating memorable characters","over18":false},"SubaruForester":{"lang":"en","description":"This is a place where all Forester owners can meet and discuss Forester news, mods, and general driving experiences whether its track, offroad or daily. All are welcome regardless!","over18":false},"humblebundles":{"lang":"en","description":"A subreddit about the game, book, app, and software bundle site humblebundle.com.","over18":false},"LoLFanArt":{"lang":"en","description":"League of Legends fanart! We've got drawings, paintings, watercolours, pixels, beads, music, comics, figures, wallpapers, cosplay, and whatever the hell the fans make when portraying magical dudes. ","over18":false},"Guelph":{"lang":"en","description":"A subreddit for Guelph, Ontario!","over18":false},"AgeplayPenPals":{"lang":"en","description":"A place for people who enjoy ageplay!","over18":true},"azirmains":{"lang":"en","description":"A place for summoners that play one of the most unique and difficult champions in League of Legends. Go forth and conquer!","over18":false},"vancouverwa":{"lang":"en","description":"This place is about Vancouver, Washington.","over18":false},"chanzhfsneakers":{"lang":"en","description":"","over18":false},"AlisonBrie":{"lang":"en","description":"","over18":false},"QuakeLive":{"lang":"en","description":"A subreddit dedicated to Quake Live, a modern port of the classic fast-paced first-person shooter Quake 3 Arena.","over18":false},"plexshares":{"lang":"en","description":"A nice place to find Plex Media Server shares.","over18":false},"Pottery":{"lang":"en","description":"Anything and everything related to throwing, hand-building, sculpting, glazing, firing, and appreciating ceramic art.","over18":false},"wsu":{"lang":"en","description":"World Class. Face to Face.","over18":false},"hydro":{"lang":"en","description":"A home for hydroponic gardeners, from hobbyist to commercial growers. Post grow journals, questions, and discussions!\n\n*Important: While we aren't against growing marijuana, this subreddit is for thos","over18":false},"potcoin":{"lang":"en","description":"PotCoin, designed to empower, secure and facilitate our community's daily transactions.  The budding / legalized Marijuana industry is literally calling out for its own distinct crypto-currency - PotC","over18":false},"AskLE":{"lang":"en","description":"A good place to ask LE questions that you would not get answered anywhere else.","over18":false},"im14andthisisfunny":{"lang":"en","description":"Examples and discussion of lowbrow, immature humor.","over18":false},"indie":{"lang":"en","description":"/r/indie is the place to share and discuss indie music.\n","over18":false},"taekwondo":{"lang":"en","description":"","over18":false},"USMilitarySO":{"lang":"en","description":"Subreddit for sharing advice, support and information for the significant others of current and past members of the United States military, however we welcome those from other countries as well!","over18":false},"sandy":{"lang":"en","description":"Information and discussion around Hurricane Sandy and the possible Frankenstorm/Snowicane/Noreastercane/Floodmageddon.\n","over18":false},"EmulationOnAndroid":{"lang":"en","description":"A place for the discussion of Emulation on any device running the Android OS","over18":false},"zerocarb":{"lang":"en","description":"A subreddit for carnivores - those that eat from the animal kingdom exclusively. \n\n\"No one while living on the typical modern diet, largely made up of protein, sugar, and starch, is capable of delight","over18":false},"drunkencookery":{"lang":"en","description":"DrunkenCoookery: Just like yo' mama used to beat it.","over18":false},"AcademicPsychology":{"lang":"en","description":"","over18":false},"AdvancedMicroDevices":{"lang":"en","description":"Advanced Micro Device Subreddit!","over18":false},"zenfone2":{"lang":"en","description":"News, pictures, and help regarding the Asus Zenfone 2. Note that official help is at the Zentalk website run by Asus. If you have hardware problems, that is most likely the place to get actual help.","over18":false},"ImageStabilization":{"lang":"en","description":"All of your image stabilization needs in one subreddit! Here you'll find shakycam unshaken, rotating objects unrotated, moving objects made still, and more. Share your stabilizations or make a request","over18":false},"Trackdays":{"lang":"en","description":"A subreddit dedicated to taking your motorcycle to the race track. Trackdays are the best place to push your limits and learn to ride your motorcycle faster and safer.","over18":false},"DestructionPorn":{"lang":"en","description":"High quality images of destruction.","over18":false},"THE_PACK":{"lang":"en","description":"THIS IS THE PACK WE'RE FUCKEN BAD ASS AND WE MAKE BOMBASS MEMES!!!!! CUM CRANK YOU'RE HOG IN ARE DISCORD MFER https://discord.gg/rZXnkUK !!!!!!!!!","over18":true},"WestVirginia":{"lang":"en","description":"Subreddit for all things West Virginia.","over18":false},"squash":{"lang":"en","description":"","over18":false},"mother4":{"lang":"en","description":"The official, fan-run Mother 4 subreddit.","over18":false},"maybemaybemaybe":{"lang":"en","description":"Tired of knowing how a GIF will end?","over18":false},"dvdasa":{"lang":"en","description":"Double Vag, Double Anal, Sensitive Artist.  \nStarring David Choe and Asa Akira, (incest radio).\nRecurring guests Money Mark, Bobby Trivia, Valentin, Critter, and, as the legends foretold, Bobby Lee.","over18":false},"keyboards":{"lang":"en","description":"Non-mouse and non-audio input devices for the discerning fingertip.","over18":false},"CrucibleSherpa":{"lang":"en","description":"Personal teaching for all of your Destiny PvP needs.","over18":false},"LANL_German":{"lang":"en","description":"","over18":false},"simplerockets":{"lang":"en","description":"Share information and pose questions regarding SimpleRockets: http://jundroo.com/project/SimpleRockets","over18":false},"DavidBowie":{"lang":"en","description":"A place for discussion of David Bowie, the rock n' roll chameleon we all know and love.","over18":false},"Eternalcrusade":{"lang":"en","description":"Dedicated to the upcoming 3rd person shooter MMO Warhammer 40,000: Eternal Crusade, by Behaviour Interactive!\n\n[http://eternalcrusade.com/](http://eternalcrusade.com/)","over18":false},"PokePorn":{"lang":"en","description":"","over18":true},"media_criticism":{"lang":"en","description":"Videos illustrating flaws, propaganda, and general bull$#!t in the mainstream media.\n","over18":false},"LowSodiumDestiny":{"lang":"en","description":"A place to freely discuss what we *ENJOY* about Destiny.","over18":false},"psg":{"lang":"en","description":"A subreddit for discussing the french football team Paris Saint-Germain. ","over18":false},"spartanrace":{"lang":"en","description":"A place for spartan racers and people interested in spartan race.","over18":false},"ProGolf":{"lang":"en","description":"","over18":false},"insomnia":{"lang":"en","description":"Posts and discussion about insomnia and sleep disorders.","over18":false},"dji":{"lang":"en","description":"A place for DJI fans to converse and communicate.\n\n**To ask questions about your drone or device, please use the sticky thread, and search before posting**\n\nSingle question posts will be removed.","over18":false},"photoplunder":{"lang":null,"description":"Subreddit no longer exists","over18":null},"hotas":{"lang":"en","description":"HOTAS (**H**ands **O**n **T**hrottle **A**nd **S**tick)  Reviews, Sales, Set-up pictures, Q&A, Tutorials and everything HOTAS related.","over18":false},"MaleFashionMarket":{"lang":"en","description":"A place for redditors to sell, buy or trade their previously-owned clothes, shoes and accessories.","over18":false},"CamelotUnchained":{"lang":"en","description":"Unofficial community for City State Entertainment's (CSE) upcoming MMORPG, Camelot Unchained. Three Realms in one persistent, massive, open-world sandbox environment, with towns and cities built almos","over18":false},"feminineboys":{"lang":"en","description":"We are a community for feminine people who've had or have a male experience, and those who admire them (be they gay or straight), to talk about all things pretty and otherwise. <3","over18":false},"WWIIplanes":{"lang":"en","description":"A place to share anything about anything flying in the last great war.","over18":false},"PokemonGoMPLS":{"lang":"en","description":"The best place to share news about Pokémon Go, Pokémon stops, Pokémon raids, and Pokémon gyms in the Twin Cities!","over18":false},"AroundTheNFL":{"lang":"en","description":"A subreddit full of heroes - a place for fans of the Around The NFL Podcast to talk about our favorite podcasters, writers, guests and lunatics. \n","over18":false},"Hawken":{"lang":"en","description":"","over18":false},"cockatiel":{"lang":"en","description":"A subreddit totally dedicated to Cockatiels. Feel free to talk about anything related or to post pictures of your own parrots.\n","over18":false},"Ducati":{"lang":"en","description":"Anything and everything about the bikes from Bologna.","over18":false},"bitchimabus":{"lang":"en","description":"Please.  Buses.  Please.  Oh... oh my... the... I can't... Why, the internet has this done?\n\nBus.\n\n\n\nBus.\n\n\n\n\n\n\n\n\n^^^^Bus.","over18":false},"l5r":{"lang":"en","description":"A place to discuss Legend of the Five Rings, LCG, former CCG, and RPG. ","over18":false},"evolutionReddit":{"lang":"en","description":"We are an activist hivemind based on the principles of **equality, freedom and democracy**. Fighting for the [free flow of information](https://youtu.be/iY57ErBkFFE), we will operate as a free and ope","over18":false},"ACPocketCamp":{"lang":"en","description":"Your #1 place for all the happenings on the campground in Animal Crossing Pocket Camp!","over18":false},"americangods":{"lang":"en","description":"This subreddit is dedicated to the television series American Gods on Starz and the book series it is based on by Neil Gaiman. The TV series is developed by Bryan Fuller and Michael Green.","over18":false},"codes":{"lang":"en","description":"Hiding data, cracking codes, finding hidden messages. We welcome posts that aren't as suitable for /r/crypto, such as basic cipher-cracking challenges and discussions of simple data hiding.","over18":false},"raimimemes":{"lang":"en","description":"Raimi memes: The home of Pizza Time, the place to celebrate the original Spider-man trilogy through memes, and the largest subreddit dedicated to *Spider-man!* Join us as we ***P R A I S E  R A I M I ","over18":false},"HorriblyDepressing":{"lang":"en","description":"Stuff that is depressing. Horribly depressing.","over18":false},"churningcanada":{"lang":"en","description":"Although we don't have the same gamut of credit card opportunities as our neighbors to the south, there's still a wealth of bonuses available for the taking. From one-time welcome bonuses, to referral","over18":false},"worldevents":{"lang":"en","description":"Worldevents is dedicated to fleshing out the historical, political and cultural context of current events (other than US news that does not involve *WORLD*events).","over18":false},"illinois":{"lang":"en","description":"Illinois: Land of Lincoln","over18":false},"chesthairporn":{"lang":"en","description":"","over18":true},"TheCinemassacre":{"lang":"en","description":"This is Cinemassacre's official subreddit! Discuss The Angry Video Game Nerd (AVGN), James and Mike Mondays, and more. ","over18":false},"umass":{"lang":"en","description":"This is the subreddit for all things UMass Amherst! \n\n\n\n","over18":false},"narcos":{"lang":"en","description":"Discussion of the Netflix original series \"Narcos\"","over18":false},"naturalbodybuilding":{"lang":"en","description":"A place for for those who believe that proper diet and intense training are all you need to build an amazing physique.\n\nDiscuss NANBF, INBF/WNBF, ABA, INBA, and IFPA bodybuilding, noncompetitive bodyb","over18":false},"MindcrackDiscussion":{"lang":"en","description":"Thanks everybody for participating in /r/mindcrackdiscussion, but with the recent direction of the subreddit and events it is time to give the subreddit some time off. Thanks especially to Brighteyes ","over18":false},"TheOriginals":{"lang":"en","description":"A spin-off of The Vampire Diaries in development for CW. A family of power-hungry thousand year old vampires look to take back the city that they built and dominate all those who have done them wrong.","over18":false},"RadicalChristianity":{"lang":"en","description":"Welcome!\n-----\n\n/r/radicalChristianity has emerged as a community of people discussing the intersection of philosophy, theology, critical theory, and revolutionary politics. We are interested in re-in","over18":false},"comedybangbang":{"lang":"en","description":"Scott Aukerman's *Comedy Bang! Bang!* is a weekly comedy podcast that blends conversation, improv, and character work from today’s funniest comedians. While Scott begins by traditionally interviewing ","over18":false},"Treknobabble":{"lang":"en","description":"reddit... the front page of the internet. These are the posts of the subreddit /r/Treknobabble. Its continuing mission: to explore strange new content and old favourites, to seek out new readers and o","over18":false},"Gonewild18":{"lang":"en","description":"A subreddit where ladies can submit gone wild posts between their 18th and 19th birthdays.","over18":true},"JavDownloadCenter":{"lang":"en","description":"","over18":true},"fortwayne":{"lang":"en","description":"If you live in Fort Wayne, plan to move here, or just want to keep tabs on the city you used to call home: you're welcome here!","over18":false},"ElPaso":{"lang":"en","description":"For anything pertaining to the greater El Paso, Texas area. Including Las Cruces, New Mexico and Juarez, Mexico.","over18":false},"lebowski":{"lang":"en","description":"","over18":false},"PokemonGoNewJersey":{"lang":"en","description":"A place where all people from New Jersey can talk about PokemonGo in their Area!","over18":false},"sorceryofthespectacle":{"lang":"en","description":"An in depth discussion of the Kali Yuga. Are the impending system wide failures due to immense error, calculated strategy or both? Is the apocalypse simply a cultural death wish by most groups and ind","over18":false},"mtgaltered":{"lang":"en","description":"","over18":false},"Datsun":{"lang":"en","description":"","over18":false},"ios7":{"lang":"en","description":"A subreddit for all posts about Apples new mobile OS, iOS7.","over18":false},"Norse":{"lang":"en","description":"/r/Norse is a Subreddit for anyone interested in anything 'viking' the community encompasses all different branches and studies including language, lore, faith and history.\n\nWe are a pleasant communit","over18":false},"boniver":{"lang":"en","description":"this is not the sound of a new man or a crispy realization","over18":false},"civ5":{"lang":"en","description":"A subreddit for Civilization 5","over18":false},"PacificCrestTrail":{"lang":"en","description":"A way for those interested in the PCT to gather and share information. A focus on the HYOH and LNT philosophies, and an open community for discussion of the PCT.","over18":false},"aion":{"lang":"en","description":"Aion is an MMORPG distributed by NCsoft and is played worldwide. /r/Aion is dedicated to discussion about the game, it's creators, distributors, and players. As well as the sharing of experiences, and","over18":false},"UserCars":{"lang":"en","description":"","over18":false},"Logo_Critique":{"lang":"en","description":"","over18":false},"sloths":{"lang":"en","description":"Look, a sloth!\nSloth pictures, videos and other sloth content.","over18":false},"PNWS":{"lang":"en","description":"Pacific Northwest Stories, the Pacific Northwest's premiere podcast network. Featuring the Black Tapes Podcast and Tanis.","over18":false},"Embroidery":{"lang":"en","description":"A community for hand and machine embroiderers to exchange tips, techniques, resources, and ideas. ","over18":false},"UrbanHell":{"lang":"en","description":"Key words: Urban hell, urban photography, abandoned, city, cities, decay\n\nDescription: A photo subreddit for all the hideous places humans have built OR inhabit: ghettos, dilapidated cities and suburb","over18":false},"InternetAMA":{"lang":"en","description":"The alternative AMA!","over18":false},"chinaglass":{"lang":"en","description":"Reviews, Links, and More - All about (cheap) Chinese glass. \nA sub for people who enjoy cheaply priced glass bongs, bowls, oil rigs, etc.","over18":true},"santacruz":{"lang":"en","description":"","over18":false},"sleep":{"lang":"en","description":"This subreddit is for sleep related discussion. Discussions may be based on questions related to sleep, OR on self-posted sleep related research.","over18":false},"Axon7":{"lang":"en","description":"Home of all Redditors interested in the ZTE Axon 7.","over18":false},"MineralPorn":{"lang":"en","description":"","over18":false},"Braincels":{"lang":"en","description":"Incels and guests celebrating incel culture.","over18":false},"MyChemicalRomance":{"lang":"en","description":"The official My Chemical Romance subreddit","over18":false},"ecig_vendors":{"lang":"en","description":"This is a reddit for suppliers of personal vaporizers, supplies and e-juice to advertise their wares.","over18":false},"homeworld":{"lang":"en","description":"Homeworld (1999) is a real-time strategy computer game developed by Relic Entertainment and published by Sierra Entertainment. It was the first fully three-dimensional RTS game. Homeworld was the begi","over18":false},"Professors":{"lang":"en","description":"This sub is by professors, for professors","over18":false},"MichiganWolverines":{"lang":"en","description":"","over18":false},"Jobs4Bitcoins":{"lang":"en","description":"Find Work, Find Workers! All payments done in Bitcoin.","over18":false},"NYCapartments":{"lang":"en","description":"","over18":false},"LadyGaga":{"lang":"en","description":"A sub-reddit for fans of Lady Gaga","over18":false},"Slender_Man":{"lang":"en","description":"","over18":false},"BatesMotel":{"lang":"en","description":"Bates Motel is an American A&E TV series inspired by Alfred Hitchcock's Psycho which will depict the life of Norman Bates and his mother Norma prior to the events portrayed in Hitchcock's film.","over18":false},"uwotm8":{"lang":"en","description":"hhhhhhhhh","over18":false},"awwnverts":{"lang":"en","description":"The subreddit for cute pictures of bugs, lobsters, squid, and other non-Vertebrata.\n\nBecause they're adorable too.\n\n","over18":false},"ComicBookCollabs":{"lang":"en","description":"Creators helping creators make comics.","over18":false},"webdesign":{"lang":"en","description":"Please visit /r/web_design, this community has moved. Please do not message the moderators.","over18":false},"japanpics":{"lang":"en","description":"A subreddit for photos of beautiful Japan!\n\nMember of the /r/NationalPhotoSubs network.","over18":false},"sweepstakes":{"lang":"en","description":"","over18":false},"INGLIN":{"lang":"en","description":"A satirical subreddit to celebrate the glory of Her Majesty's Great Britain.","over18":false},"fifaclubs":{"lang":"en","description":"The #1 subreddit for FIFA Pro Clubs players. Post your clips, discuss the game, or meet other players who enjoy the most underappreciated game mode in video game history. ","over18":false},"ladyladyboners":{"lang":"en","description":"A place for our favorite pictures of our favorite ladies, doing the things that make them our favorites. We welcome anyone who celebrates girls being wonderful.","over18":false},"CelebFakes":{"lang":null,"description":"Subreddit no longer exists","over18":null},"ekkomains":{"lang":"en","description":"THE CHRONO BREAKERS","over18":false},"warofcrown":{"lang":"en","description":"Subreddit for players of War of Crown on Android and iOS. \n","over18":false},"WomenOfColor":{"lang":"en","description":"","over18":true},"JustEngaged":{"lang":"en","description":"This is the place to share your engagement excitement! A popular place to share rings so feel free to share wedding bands or your engagement ring even if you've been engaged for years. ","over18":false},"austrian_economics":{"lang":"en","description":"","over18":false},"kinksters_gone_wild":{"lang":"en","description":"A new Gone Wild subreddit where everyone is welcome, be you male, female, big, small, fat, thin. Dive in, get kinky, and start trading your sexiness for some sweet sweet karma! There is mininum kink r","over18":true},"AskParents":{"lang":"en","description":"Asking parents questions, one at a time.","over18":false},"massage":{"lang":"en","description":"/r/massage is a community for respectful discussions of massage and massage therapists/practitioners.\n\nWe'd like for this to be a great place for patients and clients to ask questions and for therapis","over18":false},"FormulaE":{"lang":"en","description":"A Subreddit dedicated to the FIA Formula E Championship racing series.","over18":false},"Greekgodx":{"lang":"en","description":"Greekgodx is a live streamer on Twitch that does variety gaming and live vlogs. ","over18":false},"ios9":{"lang":null,"description":"Subreddit forbidden","over18":null},"insects":{"lang":"en","description":"A subreddit all about insects.","over18":false},"starfinder_rpg":{"lang":"en","description":"The Unofficial Starfinder Subreddit","over18":false},"pokemonuranium":{"lang":"en","description":"This is the dedicated subreddit for the fangame Pokemon Uranium. The game takes place in the Tandor Region, where the hero must journey to collect Gym Badges, collect over 120 all-new species of Pokem","over18":false},"Dragula":{"lang":"en","description":"The Boulet Brother's Dragula is an international show with the aim of finding the world's next Drag Supermonster. The winner of the show must embody the three main elements of Dragula: Filth, Horror a","over18":false},"Nordiccountries":{"lang":"en","description":"Utopia according to the US","over18":false},"Bumble":{"lang":"en","description":"A community for discussing the online dating app Bumble","over18":false},"elonmusk":{"lang":"en","description":"Elon Reeve Musk (born June 28, 1971) is a South Africa-born, Canadian American inventor, engineer, and entrepreneur. \n\nHe is currently the CEO and CTO of SpaceX, CEO and chief product architect of Tes","over18":false},"Catan":{"lang":"en","description":"For lovers of The Settlers of Catan!","over18":false},"Wilmington":{"lang":"en","description":"A subreddit dedicated to Wilmington, North Carolina and the surrounding area, including New Hanover, Pender, and Brunswick Counties.","over18":false},"defaultgems":{"lang":"en","description":"The very best gems that the default reddits have to offer!","over18":false},"ReverseEngineering":{"lang":"en","description":"A moderated community dedicated to all things reverse engineering. ","over18":false},"git":{"lang":"en","description":"","over18":false},"Weird":{"lang":"en","description":"The subreddit for the weird, strange, odd and bizarre.","over18":false},"illusionporn":{"lang":"en","description":"","over18":false},"publix":{"lang":"en","description":"The unofficial subreddit for people that like to shop and/or work at Publix super markets.","over18":false},"stockholm":{"lang":"en","description":"En subreddit om Stockholm med omnejd.","over18":false},"Mario":{"lang":"en","description":"/r/Mario is the biggest and best subreddit out there for those who want to talk about and share their experiences about the Mario franchise, spanning video games, books, movies, television, cereal, an","over18":false},"PiratedGTA":{"lang":"en","description":"Discussion of Pirated and Non-Pirated versions of GTA V.","over18":false},"botany":{"lang":"en","description":"","over18":false},"Howwastoday":{"lang":"en","description":"This subreddit is for journalistic accounts of your day for the purposes of seeing how different people experienced today.","over18":false},"CRH":{"lang":"en","description":"Welcome to the world's largest Coin Roll Hunting community! Come meet other hunters, share your finds, give and get advice, and share in whatever else has to do with the hobby of Coin Roll Hunting (al","over18":false},"socialjustice101":{"lang":"en","description":"This is a place to learn more bout Social Justice\n\nRules: \n\n1. Participate in good faith, this space is not for debate. You must be here to either learn more about social justice or answer questions f","over18":false},"liquidlegends":{"lang":"en","description":"We have moved to /r/Team_Liquid!","over18":false},"Socialism_101":{"lang":"en","description":"Socialism_101: A space for learning about socialism and the socialist perspective.","over18":false},"iphonehelp":{"lang":"en","description":"Advice and help for iPhone related issues","over18":false},"Floof":{"lang":"en","description":"Floofy puffy cats and dogs and birds and chinchillas and cows and bunnies and caterpillars and anything else!","over18":false},"psbattleroyale":{"lang":"en","description":"This sub has been made with the intent to host discussion and information about the PlayStation 3 fighting game, PlayStation All-Stars: Battle Royale.","over18":false},"Charcuterie":{"lang":"en","description":"","over18":false},"woof_irl":{"lang":"en","description":"for the puppy in u. | \na subreddit for posting pictures of dogs that people can look at and go \"oh same, dog, same.\"","over18":false},"coheedandcambria":{"lang":"en","description":"","over18":false},"aussievapers":{"lang":"en","description":"A community of Aussies discussing Electronic Cigarettes and their use in Australia.","over18":false},"AutoModerator":{"lang":"en","description":"Important announcements and helpful tips regarding the reddit bot AutoModerator by /u/Deimorz","over18":false},"ik_ihe":{"lang":"nl","description":"jij in het echte leven weg van je toetsenbord","over18":false},"wii":{"lang":"en","description":"","over18":false},"EliteTraders":{"lang":"en","description":"Elite: Dangerous trading discussion","over18":false},"MTGO":{"lang":"en","description":"Discuss anything related to Magic: The Gathering Online here!","over18":false},"EthereumClassic":{"lang":"en","description":"We believe in a decentralized, censorship-resistant, permissionless block chain. We believe in the original vision, of Ethereum as a world computer that you cannot shut down, which runs irreversible s","over18":false},"crash_fever":{"lang":"en","description":"Subreddit for the puzzle RPG mobile game Crash Fever!","over18":false},"boardsofcanada":{"lang":"en","description":"[Official New Release Thread](http://www.reddit.com/r/boardsofcanada/comments/1ct35e/official_ideas_post_post_all_current_news_on_the/)","over18":false},"graphicnovels":{"lang":"en","description":"","over18":false},"GameTheorists":{"lang":"en","description":"For anything Game Theory, Gaijin Goomba, Digressing & Sidequesting, and Smash History!","over18":false},"Hijabis":{"lang":"en","description":"A place to engage in healthy discussions about Muslim women in Islam.\n","over18":false},"wheelanddeal":{"lang":"en","description":"A trading community for Dark Souls 2.","over18":false},"tabletennis":{"lang":"en","description":"Reddit's #1 place for all your Table Tennis needs!","over18":false},"abcqwerty123":{"lang":"en","description":"That top grossing anime for 420 years in a row","over18":false},"HybridAnimals":{"lang":"en","description":"Create new animals by combining species with each other and/or with any other stuff you find appropriate.","over18":false},"leaf":{"lang":"en","description":"All things related to the Nissan LEAF EV","over18":false},"chicagobeer":{"lang":"en","description":"","over18":false},"RSChronicle":{"lang":"en","description":"The subreddit dedicated to Jagex's collectible card game, **Chronicle: RuneScape Legends**. \n\n\n\n\nAs of August 2018, Chronicle: Runescape Legends has beenpermanently shut down. This sub-reddit is now a","over18":false},"LoLChampConcepts":{"lang":"en","description":"A place for summoners to share champion, skill and item designs.","over18":false},"CelebrityButts":{"lang":"en","description":"Celebrity Butts!","over18":true},"MUD":{"lang":"en","description":"Welcome to /r/MUD, covering MUD, MUSH, MUX, MOO, and all other MU* variants! \n\n","over18":false},"Daredevil":{"lang":"en","description":"A subreddit for discussion of the Marvel character Daredevil.","over18":false},"raining":{"lang":"en","description":"A cozy place to enjoy the rain. ","over18":false},"poetry_critics":{"lang":"en","description":"A subreddit for the constructive criticism and feedback of *all* types of poetry. Freestyle, sonnets, anything and everything is welcome here! A response is almost guaranteed, even if the mods have to","over18":false},"FuckYou":{"lang":"en","description":"","over18":true},"rum":{"lang":"en","description":"","over18":false},"Narcolepsy":{"lang":"en","description":"The online community for those who either have or support people who have Narcolepsy.","over18":false},"R6STeams":{"lang":"en","description":"Free for others to join to find other like minded individuals to play with.\n","over18":false},"TREZOR":{"lang":"en","description":"TREZOR is the world's first Bitcoin hardware wallet, protecting coins for thousands of users worldwide. What makes TREZOR even better is the community behind it, gathered in this subreddit. Come here ","over18":false},"airguns":{"lang":"en","description":"","over18":false},"NoPoo":{"lang":"en","description":"\"No Shampoo\" - A place to discuss natural hair care and alternatives to shampoo. Girls & Guys welcome! \n\n'No Poo'","over18":false},"InfinityTheGame":{"lang":"en","description":"Infinity is a game with 28mm high metal miniatures that simulates combat and special operations in a science fiction environment with Manga aesthetics. Infinity miniatures are characterized by the hig","over18":false},"lightingdesign":{"lang":"en","description":"The Reddit community for lighting designers worldwide.","over18":false},"CallOfDutyWorldWarTwo":{"lang":"en","description":"Call of Duty: WWII | Reddit by SledgeHammer Games, Published by ActiVision ( /r/CallOfDutyWorldWarTwo ) is The true fan built sub for the fans by the fans for CoDWWII 2017 delivering the latest news, ","over18":false},"adidasatc":{"lang":"en","description":"Free/Open Source \"Add To Cart\" software for Adidas.com Limited Releases","over18":false},"AhriMains":{"lang":"en","description":"A subreddit for the discussion of Ahri, the foxy champion from League of Legends.","over18":false},"southpaws":{"lang":"en","description":"","over18":false},"salesforce":{"lang":"en","description":"Salesforce.com - where you build things on the force.com platform.","over18":false},"DesirePath":{"lang":"en","description":"Dedicated to the paths that humans prefer, rather than the paths that humans create.","over18":false},"motorsports":{"lang":"en","description":"","over18":false},"riskofrain":{"lang":"en","description":"Artifacts are here!","over18":false},"pathofdiablo":{"lang":"en","description":"A Diablo II community server & improvement mod","over18":false},"starcraft2":{"lang":"en","description":"Welcome to the subreddit for the popular Blizzard Real Time Strategy game StarCraft 2! Now Free To Play! r/Starcraft2 is for all things Starcraft 2 related. ","over18":false},"iastate":{"lang":"en","description":"A subreddit for students at Iowa State University for discussing all things university or Ames related.","over18":false},"audible":{"lang":"en","description":"","over18":false},"KissAnime":{"lang":"en","description":"","over18":false},"ImageComics":{"lang":"en","description":"Image Comics is a United States comic book publisher founded in 1992 by high-profile illustrators as a venue where creators could publish creator-owned properties. Its best-known series include Spawn,","over18":false},"gameideas":{"lang":"en","description":"","over18":false},"HIFW":{"lang":"en","description":"Show us how you felt","over18":false},"plants":{"lang":"en","description":"","over18":false},"Flume":{"lang":"en","description":"A subreddit dedicated to Harley Streten AKA Flume, an electronic music producer from Manly, Sydney, Australia. \n","over18":false},"PLC":{"lang":"en","description":"PLC, HMI, DCS, SCADA","over18":false},"nflcirclejerk":{"lang":"en","description":"","over18":false},"ryerson":{"lang":"en","description":"The Official Subreddit For Ryerson University in Toronto, Ontario, Canada.","over18":false},"VentGrumps":{"lang":"en","description":"/r/rantgrumps for active discussion!\n\n","over18":false},"LittleRock":{"lang":"en","description":"Events, discussions, and items of interest from Arkansas's capital city and the greater metropolitan area.\n\nStop in and say hello!","over18":false},"IgnorantImgur":{"lang":"en","description":"A place to show screenshots of imgurians who have no earthly idea that Reddit exists, or even just ignorance found in the \"comment section\" in general!","over18":false},"AskMarketing":{"lang":"en","description":"Have a question about marketing? This is your place to ask.","over18":false},"BattleJackets":{"lang":"en","description":"","over18":false},"illegaltorrents":{"lang":null,"description":"Subreddit no longer exists","over18":null},"agnostic":{"lang":"en","description":"A place for agnostics to discuss","over18":false},"AdPorn":{"lang":"en","description":"High quality images of advertisements.","over18":false},"freedommobile":{"lang":"en","description":"A User-Run discussion of Freedom Mobile products and services for existing users, those considering making the switch, or people just wanting to keep apprised on the Canadian mobile landscape.    \nDis","over18":false},"cider":{"lang":"en","description":"Cider, the fermented alcoholic beverage made from fruit juice, most commonly and traditionally apple juice, but also the juice of peaches, pears, or other fruit. ","over18":false},"FinalFantasyTCG":{"lang":"en","description":"Final Fantasy Trading Card Game Subreddit.","over18":false},"Comcast_Xfinity":{"lang":"en","description":"Welcome to the Xfinity Community!\n\nOur community is your official source on Reddit for help with Xfinity services. If you have questions about your services, we're here to answer them. If you have pro","over18":false},"AskComputerScience":{"lang":"en","description":"","over18":false},"ultimaonline":{"lang":"en","description":"","over18":false},"Attackontitangame":{"lang":"en","description":"This subreddit is for lovers of Fenglee's [Attack on Titan Tribute Game](http://fenglee.com/game/aog/)","over18":false},"EnoughHillHate":{"lang":null,"description":"Subreddit forbidden","over18":null},"Hungercraft":{"lang":"en","description":"","over18":false},"toyexchange":{"lang":"en","description":"","over18":false},"SVRiders":{"lang":"en","description":"","over18":false},"JobFair":{"lang":"en","description":"/r/JobFair is a place to post an ask-me-anything thread about your job, or to get advice from others about it.","over18":false},"AskBernieSupporters":{"lang":"en","description":"A place for your Sanders-related questions, be it about his policy, or the opinions of his supporters.\n\nNote that this sub is not a \"safe space,\" but a place of mutual respect.","over18":false},"czech":{"lang":"cs","description":"Czech Republic official subreddit","over18":false},"lgv30":{"lang":"en","description":"LG V30","over18":false},"gametales":{"lang":"en","description":"This subreddit is not about describing prescribed game plots. It is a place to recount other unexpected, significant, or humorous events that have happened in-game. Epic sagas, dastardly backstabbing ","over18":false},"catpranks":{"lang":"en","description":"Cats getting pranked and/or trolled","over18":false},"Georgia":{"lang":"en","description":"It's a place","over18":false},"redditgetsdrawnbadly":{"lang":"en","description":"RGDB is a subreddit for people who just want to draw and get drawn, regardless of skill level!       \n  \nWe've evolved past our name: good drawings are ok, average drawings are okay, bad drawings are ","over18":false},"AMDHelp":{"lang":"en","description":"Troubleshooting help Subreddit for all things AMD!","over18":false},"costa_rica":{"lang":"en","description":"","over18":false},"GuitarAmps":{"lang":"en","description":"Turn it up to 11. Guitar, Bass, and other instrument amplification discussed here. Tube, Solidstate, Valve. Fender, Marshall, Orange, Behringer, Ampeg.","over18":false},"ArtFundamentals":{"lang":"en","description":"Everyone keeps telling you that you need to practice your fundamentals. What the hell does that mean, and how do you do it? This subreddit's all about concrete exercises that you can do to improve you","over18":false},"lolcats":{"lang":"en","description":"","over18":false},"myriadcoin":{"lang":"en","description":"Myriad (XMY) is a cryptocurrency with 5 mining algorithms. Each one suits different hardware. Just about anyone can mine Myriad!\n\n* CPU (even your Android phone) = Yescrypt\n\n* GPU = Myr-Groestl\n\n* GPU","over18":false},"JhinMains":{"lang":"en","description":"","over18":false},"attackontitan":{"lang":"en","description":"A subreddit for Attack on Titan 進撃の巨人, Shingeki no Kyojin!","over18":false},"duelofchampions":{"lang":"en","description":"A subreddit to discuss Ubisoft's Might & Magic: Duel of Champions online Collectible Card Game.","over18":false},"MarchForScience":{"lang":"en","description":"March for Science\n\n🐍 🐍   ","over18":false},"gayyoungold":{"lang":"en","description":"GYO is about gay older men and younger men, together. Daddy & Boy, Dad & Son, Grandpas & Grandsons, Intergenerational gay men; Sex, Love, and Relationships.","over18":false},"miniSNESmods":{"lang":"en","description":"A home for discussion of SNES Classic modifications.","over18":false},"Physical_Removal":{"lang":null,"description":"Subreddit no longer exists","over18":null},"TheNewRight":{"lang":"en","description":"WE ARE THE HOME OF THE NEW RIGHT MOVEMENT!","over18":false},"Animals":{"lang":"en","description":"","over18":false},"beetle":{"lang":"en","description":"","over18":false},"DrunkOrAKid":{"lang":"en","description":"This subreddit is for stories of the greatest stupidity.  Inspired by How I Met Your Mother, this subreddit was created for the purpose of hearing amusing stories and having other try to guess if you ","over18":false},"ScreamQueensTV":{"lang":"en","description":"Scream Queens is a horror-comedy television series on Fox.","over18":false},"loremasters":{"lang":"en","description":"This is our private blog, a special resource for Reddit's GMs. Feel free to share and discuss original lore, story arcs, sub-plots, and plans for quests and encounters of all sizes.","over18":false},"3dsmax":{"lang":"en","description":"A community of 3ds Max users. Feel free to ask for help, post projects you're working on, link to helpful tips or tutorials for others, or just generally discuss all things max.","over18":false},"thisisus":{"lang":"en","description":"This Is Us is a television series on NBC. \n\nA group of people born on the same day, including Rebecca (Moore) and Jack (Ventimiglia), a married couple expecting triplets in Pittsburgh, and Kevin (Hart","over18":false},"transhumanism":{"lang":"en","description":"","over18":false},"nethack":{"lang":"en","description":"NetHack strategy, tips, and discussion.","over18":false},"CZFirearms":{"lang":"en","description":"NEW RULES \nhttps://www.reddit.com/r/announcements/comments/863xcj/new_addition_to_sitewide_rules_regarding_the_use/\n\n\nA page for Redditors who are fans of CZ firearms to discuss current, late, antique","over18":false},"goldenknights":{"lang":"en","description":"Welcome to the official subreddit for the Vegas Golden Knights.","over18":false},"cookingforbeginners":{"lang":"en","description":"Just moved into your first apartment and don't know a thing about cooking or have lived on your own for years and have existed on take out and fast food? Then this is the sub for you!\n\nLearn how to co","over18":false},"askashittydoctor":{"lang":"en","description":"","over18":false},"The_Congress":{"lang":"en","description":"Welcome to The_Congress, the place for patriots memeing a US Congress that is pro-Trump and ready to MAGA.","over18":false},"CodeGeass":{"lang":"en","description":"This subreddit is for the animated series Code Geass. Everything Code Geass related is allowed. Videos, games, pictures, etc.\n\n","over18":false},"XboxOneGamers":{"lang":"en","description":"With many people not upgrading consoles or switching to the other side, friends are hard to find, this subreddit will help make the upgrade or switch to Xbox One easier :)","over18":false},"MushroomGrowers":{"lang":"en","description":"This subreddit should be a place to discuss the cultivation of any and all mushrooms psychedelic, gourmet or otherwise.\n\nWe welcome new comers, professional mycologists and everyone in between! Get in","over18":false},"ShadowBanned":{"lang":"en","description":"","over18":false},"MobileAL":{"lang":"en","description":"The subreddit of Mobile, AL.","over18":false},"ZeroWaste":{"lang":"en","description":"We are responsible citizens who try to minimize our overall ecological footprint.","over18":false},"futuregarage":{"lang":"en","description":"","over18":false},"cuboulder":{"lang":"en","description":"An unofficial place for people to discuss the University of Colorado Boulder, ~~complain~~ ask questions about the university, meet other Buffalo, and stay informed about relevant campus issues.","over18":false},"agentcarter":{"lang":"en","description":"","over18":false},"IndianaUniversity":{"lang":"en","description":"**Proud home of Reddit's best College and Hoosiers.**","over18":false},"Chevy":{"lang":"en","description":"Everything about the worlds greatest car company: Chevrolet.  Post pictures or ask questions about your Chevy cars and trucks!","over18":false},"flytying":{"lang":"en","description":"This subreddit was created so that the fly tier can \n\n*\tAsk questions about all aspects of fly tying. \n\n*\tLearn new skills, techniques and patterns.\n\n*\tSeek constructive feedback on their designs and ","over18":false},"waterporn":{"lang":"en","description":"High quality images of water.","over18":false},"Transhuman":{"lang":"en","description":"The singularity is near.","over18":false},"TooMeIrlForMeIrl":{"lang":"en","description":"For things too meirl for meirl","over18":false},"alcoholicsanonymous":{"lang":"en","description":"","over18":false},"changelog":{"lang":"en","description":"Information on minor updates and bug fixes applied to reddit.","over18":false},"ArkEcosystem":{"lang":"en","description":"All about the Ark Ecosystem - cryptocurrency, coin, blockchain, wallets, news, guides, exchanges, coding, ark.io, arkcoin, technology, delegates, voting and a lot more.","over18":false},"Mountaineering":{"lang":"en","description":"","over18":false},"Intelligence":{"lang":"en","description":"Spies, Intelligence and Espionage News.  Agencies of interest: CIA, FSB, KGB, Stasi, Mossad, NSA, NRO, FBI, GCHQ, ASIS, Military Intelligence, Five Eyes, Snowden, Wikileaks, theShadowBrokers, ICIJ, Pa","over18":false},"GayKink":{"lang":"en","description":"","over18":true},"toastme":{"lang":"en","description":"To be toasted: post a picture of yourself in a natural state or in doing what you love and receive the compliments. Make sure to verify!\n\nTo toast: try to write the best, most genuine, most heartfelt ","over18":false},"ThailandTourism":{"lang":"en","description":"This is a subreddit where people can ask for advice about visiting Thailand, border crossings, hotels, what to see, what to do.","over18":false},"arkhamhorrorlcg":{"lang":"en","description":"This subreddit is to discuss and share information about the Fantasy Flight Games LCG, Arkham Horror.","over18":false},"drunkvapes":{"lang":"en","description":"","over18":false},"saltandsanctuary":{"lang":"en","description":"Subreddit for Salt and Sanctuary, the 2D action RPG from Ska Studios.","over18":false},"transgamers":{"lang":"en","description":"","over18":false},"VAC_Porn":{"lang":"en","description":"The place where you can see Cheaters get their just desserts!\n\nYou can even go as far to say CS:GO justice porn!","over18":false},"brum":{"lang":"en","description":"","over18":false},"Sasquatch":{"lang":"en","description":"","over18":false},"Zoomies":{"lang":"en","description":"Animals excitedly running and playing. ","over18":false},"scienceofdeduction":{"lang":"en","description":"A place to practice your Sherlock like observation","over18":false},"foreignservice":{"lang":"en","description":"Dedicated to individuals who work for or aspire to work for the U.S. Foreign Service. This Reddit is NOT endorsed or supported in any way by the U.S. State Department.\n\nPlease feel free to discuss cur","over18":false},"simps":{"lang":"en","description":"A simp or simpson or homer or homer simpson is a vagina that looks like homer simpson's mouth. Also know as an 'innie', 'slit', 'perfect slit' etc. This board is dedicated to celebrating simp's found ","over18":true},"simonfraser":{"lang":"en","description":"The subreddit for Simon Fraser University in Vancouver, BC.","over18":false},"ayylmao":{"lang":"en","description":"ayy lmao","over18":false},"BadSocialScience":{"lang":"en","description":"","over18":false},"ElitePS":{"lang":"en","description":"Community for CMDRs fighting, trading & exploring the Milky Way in Elite Dangerous on PlayStation 4 and Pro","over18":false},"VintageApple":{"lang":"en","description":"A place to discuss and share anything related to vintage Apple computers and products. ","over18":false},"onebros":{"lang":"en","description":"The subreddit for lowest level players to gloat, get help, assist, and analyze strategies with one another. There are no strict rules to a SL1/BL4 run other than not leveling past the lowest possible ","over18":false},"GaState":{"lang":"en","description":"Georgia State University, an enterprising urban public research university, is a national leader in graduating students from widely diverse backgrounds. The university offers 250 undergraduate and gra","over18":false},"Charlottesville":{"lang":"en","description":"# Welcome to Charlottesville! #\n\nThis subreddit it dedicated to anything and everything having to do with Mr. Jefferson's favorite town: bands, shows, restaurants, politics, UVA, crime, sightings on t","over18":false},"infinitecrisis":{"lang":"en","description":"This is the official Reddit community for the late DC Comics MOBA, Infinite Crisis! Discuss your thoughts on the game, Champions, strategy, lore and more here with your fellow Protectors!","over18":false},"usa":{"lang":"en","description":"","over18":false},"Mistborn":{"lang":"en","description":"The subreddit for Brandon Sanderson's Mistborn series.","over18":false},"TheWaterLew":{"lang":"en","description":"You may find yourself wandering around reddit seeing shitty, satire and silly subreddits. Well you may ask \"what makes TWL stand out?\" Nothing. That's what TWL is. Subscribe today for shitposts, polls","over18":false},"knifemaking":{"lang":"en","description":"The world of Knifemaking","over18":false},"unknownvideos":{"lang":"en","description":"A place to watch and share great undiscovered videos with too few views. Thus making the unknown become the known. Share your videos to Reddit and find new gems.","over18":false},"FurryKikPals":{"lang":"en","description":"We are an 18+ sub-reddit with the goal of allowing individuals to meet others around a common theme of being furries. Despite what the name is, you can use whatever chat platform you want! <3","over18":false},"forearmporn":{"lang":"en","description":"ForearmPorn - A place to appreciate nice forearms.   \n    \nkeywords: fitness, men, pics, images, gifs, muscle","over18":true},"WatchPeopleDieInside":{"lang":"en","description":"People dying - but on the inside.","over18":false},"fakeIDUK":{"lang":null,"description":"Subreddit no longer exists","over18":null},"ddo":{"lang":"en","description":"Dungeons and Dragons Online","over18":false},"functionalprint":{"lang":"en","description":"This is a subreddit to share and show off your 3D printed parts that actually have a function.","over18":false},"GraphicDesign":{"lang":null,"description":"Subreddit forbidden","over18":null},"Pins4Skins":{"lang":"en","description":"A place to trade CSGO pins. Get your pins here!\n\ntags:\nCounter-Strike cs cs:go Global Offensive Trade Keys Paypal Pin skins IEM katowice ESL 2015 Guardian Victory Train dust elite inferno mirage italy","over18":false},"bugout":{"lang":"en","description":"When the shit hits the fan, it's time to Bugout!","over18":false},"FioraMains":{"lang":"en","description":"“I have come to kill you for the sake of honor. And though you possess none, still you die.”","over18":false},"pitchforkemporium":{"lang":"en","description":"All things pitchforks, pitchfork accessories and OP lynching related. ","over18":false},"indiegames":{"lang":"en","description":"Reddit for everything related to Indie Games","over18":false},"freelanceWriters":{"lang":"en","description":"A place by and for freelance writers of all kinds to discuss and share every facet of freelance writing.","over18":false},"Aliexpress":{"lang":"en","description":"A subreddit to the greatest website for buying stuff direct from China.","over18":false},"nosgoth":{"lang":"en","description":"For discussion of the discontinued game 'Nosgoth'.","over18":false},"recruitinghell":{"lang":"en","description":"This subreddit is for all of those recruiters and candidates who really don't get it.  Post your horror stories and show us those amazing job offers!  ","over18":false},"BasketballTips":{"lang":"en","description":"","over18":false},"bald":{"lang":"en","description":"","over18":false},"VOIP":{"lang":"en","description":"","over18":false},"drugstoreMUA":{"lang":"en","description":"The subreddit for makeup addicts who use and love drugstore products! The general consensus is that the main subs are focused mostly on mid-range products, but not everyone can afford them. This is wh","over18":false},"slingtv":{"lang":"en","description":"For the discussion of the SlingTV service, a way of watching live TV for $20 a month. ","over18":false},"crazyexgirlfriend":{"lang":"en","description":"Rebecca Bunch (Rachel Bloom) is a successful, driven, and possibly crazy young woman who impulsively gives up everything – her partnership at a prestigious law firm and her upscale apartment in Manhat","over18":false},"MusicVideos":{"lang":"en","description":"/r/MusicVideos is the place for music videos: Creatively produced video that matches a single song soundtrack.\n\n/r/MusicVideos is *NOT* the place for album art, lyric videos, kinetic text, cellphone o","over18":false},"psytrance":{"lang":"en","description":"A subreddit for goa and psychedelic trance culture related links and discussion.","over18":false},"badlegaladvice":{"lang":"en","description":"When someone provides bad legal advice, relay it to us.","over18":false},"DID":{"lang":"en","description":"A safe place for people with Dissociative Identity Disorder (also known as Multiple Personality Disorder) and their singleton friends and family to discuss life with DID and related conditions.","over18":false},"disneyvacation":{"lang":"en","description":"Disney Vacation: Weird, terrible, terrifying illustrations from WikiHow - captioned for your amusement.","over18":false},"Oreimo":{"lang":"en","description":"The subreddit for everyone's favorite little tsundere.","over18":false},"PokemonGoMystic":{"lang":"en","description":"Welcome to the fan made subreddit of **Team Mystic** for the AR game developed by Niantic, **Pokémon GO**. We're going to work together to make Team Mystic the very best!","over18":false},"Mortgages":{"lang":"en","description":"Real estate \nHomeowner\nFinancing\nMortgages\nLending\nHouse\nHouses","over18":false},"shadow_of_war":{"lang":"en","description":"News, information and discussion about Shadow of War - The long awaited sequel to Shadow of Mordor.","over18":false},"cubancigars":{"lang":"en","description":"A discussion of cigars primarily composed of Cuban tobacco.  These include Cuban brand marques, multi-country blends, clear Havanas, custom rolled/farm rolled, and pre-embargo Cuban cigars.","over18":false},"SRSBusiness":{"lang":"en","description":"","over18":false},"TheCompletionist":{"lang":"en","description":"","over18":false},"Locksmith":{"lang":"en","description":"The place where Locksmiths of Reddit hang out and talk shop.","over18":false},"amateurfights":{"lang":"en","description":"","over18":false},"learnspanish":{"lang":"en","description":"A subreddit to help you learn the Spanish language! Ask our 11,000+ subscribers to help you learn Spanish grammar, tenses, and anything you need to speak español!","over18":false},"ZettaiRyouiki":{"lang":"en","description":"*Zettai Ryouiki*, (\"Absolute Territory\"), is the tiny strip of visible thigh between longsocks/tights/thighhighs, and a skirt/dress/shorts. ","over18":false},"AskDoctorSmeeee":{"lang":"en","description":"Ask questions about healthcare or medical conditions, we're here to answer you!","over18":false},"selfhelp":{"lang":"en","description":"","over18":false},"StopSelfHarm":{"lang":"en","description":"","over18":false},"VillagePorn":{"lang":"en","description":"High quality images of villages.","over18":false},"AgameofthronesLCG":{"lang":"en","description":"A Subreddit for the [A Game of Thrones](http://www.fantasyflightgames.com/edge_minisite.asp?eidm=277&enmi=A%20Game%20of%20Thrones:%20The%20Card%20Game%20Second%20Edition) LCG by [Fantasy Flight Games]","over18":false},"LastManonEarthTV":{"lang":"en","description":"Welcome to /r/LastManOnEarthTV! This subreddit is dedicated to discussing The Last Man on Earth, a post-apocalyptic comedy television series created by and starring Will Forte.","over18":false},"paypal":{"lang":"en","description":"Great for questions about PayPal, transactions and problems! ","over18":false},"MerchantRPG":{"lang":"en","description":"Welcome to the reddit community for *Merchant*!\n\n*Merchant* takes traditional RPG systems, tycoon-style mechanics, a medieval setting and a fantasy overworld, and it says, \"HELL YES TO ALL OF THIS!\"  ","over18":false},"deephouse":{"lang":"en","description":"All your Deep House music needs, in one place.","over18":false},"Badfaketexts":{"lang":"en","description":"","over18":false},"BlackSails":{"lang":"en","description":"*Black Sails* is a television show from Starz that premiered on January 2014.\n\nA no-holds-barred look at the lives of real pirates, this powerful series (from Executive Producer Michael Bay) aims to b","over18":false},"DragonNest":{"lang":"en","description":"Subreddit to post and discuss content about the free-to-play MMORPG DragonNest.","over18":false},"Disgaea":{"lang":"en","description":"A sub-reddit dedicated to the video game and anime series Makai Senki Disgaea, Phantom Brave, and Makai Kingdom universes.","over18":false},"desktops":{"lang":"en","description":"The place to share your desktop, regardless of OS.","over18":false},"RationalPsychonaut":{"lang":"en","description":"We prefer rational discourse.","over18":false},"ShittyMapPorn":{"lang":"en","description":"","over18":false},"bapeheads":{"lang":"en","description":"For those that do not already know, A BATHING APE® is a Japanese clothing company founded by NIGO in 1993. The company specializes in men's, women's and kids' lifestyle and street wear. This subreddit","over18":false},"valve":{"lang":"en","description":"This subreddit is dedicated to news and discussions about Valve Software - the company and their games (and Steam!).","over18":false},"bookexchange":{"lang":"en","description":"The Reddit Book Exchange","over18":false},"PoGoDFW":{"lang":"en","description":"Pokémon Go - Dallas-Fort Worth Metroplex","over18":false},"Stuffers":{"lang":"en","description":"This is a subreddit for all things \"Feeder\" fetishism related.","over18":true},"IowaCity":{"lang":"en","description":"The subreddit for Iowa City, Coralville, North Liberty, and the surrounding communities.","over18":false},"mousehunt":{"lang":"en","description":"MouseHunt is a fun adventure game where players engage in royal quests as a MouseHunter, hired by the King, to catch the unique and ridiculous mice that have invaded the kingdom!\n\nThis subreddit is to","over18":false},"ZReviews":{"lang":"en","description":"Dedicated Forums for Subscribers and Patreons of ZeosPantera and Z Reviews. Open topic discussions of anything media are allowed.","over18":false},"WhyWereTheyFilming":{"lang":"en","description":"No, seriously, why?","over18":false},"celebJObuds":{"lang":"en","description":"","over18":true},"cuba":{"lang":"en","description":"Todo sobre Cuba // Discuss everything related to Cuba.\n\nCompartimos todo relacionado con Cuba: noticias, cuentos, eventos, ideas, preguntas, commentarios, etc.\n\nShare news, stories, events, ideas, que","over18":false},"homeassistant":{"lang":"en","description":"Home Assistant is open source, python-based home automation software, available for free at home-assistant.io","over18":false},"LaTeX":{"lang":"en","description":"","over18":false},"northkorea":{"lang":"en","description":"Discussion about everything North Korea, one of the most controversial and unusual places on Earth: Join us to discuss its people, political and social issues, crises, controversies, power struggles, ","over18":false},"JenniferLawrence":{"lang":"en","description":"For fans of Jennifer Lawrence.","over18":false},"AmericanPolitics":{"lang":"en","description":"A place to discuss the American political process, the political parties, elected officials, and candidates.","over18":false},"PokemongoSeattle":{"lang":"en","description":"The place to discuss Pokemon GO in Seattle, The Greater Pudget Sound Area, or even Washington as a whole.","over18":false},"musicals":{"lang":"en","description":"Do you enjoy musicals? Well have we got the subreddit for you!\n\n/r/musicals is all about the Musical life! We love singing and dancing! We love acting! We love it all! Come join us as our community gr","over18":false},"AccidentalComedy":{"lang":"en","description":"AccidentalComedy - Anything that is unintentionally funny.","over18":false},"grateful_dead":{"lang":"en","description":"A safe place for everyone who's Dead to the core. ","over18":false},"dynastywarriors":{"lang":"en","description":"For fans of the \"Warriors\" series (Dynasty Warriors, Samurai Warriors, Warriors Orochi, etc.) or the \"Historical Simulation\" series (Romance of The Three Kingdoms, Nobunaga's Ambition) of video games ","over18":false},"DarkMatter":{"lang":"en","description":"Welcome to the unofficial subreddit for the fans of the scifi TV series Dark Matter. We discuss and share anything related to the show.","over18":false},"BulletBarry":{"lang":"en","description":"This subreddit is dedicated to my subscribers and friends (same thing) here you can, ask me any question you like, post console peasant quotes for me to use in my videos and even win certain prizes fr","over18":false},"VegRecipes":{"lang":"en","description":"","over18":false},"Christian":{"lang":"en","description":"A subreddit for Christians to discuss and share with other Christians.","over18":false},"lectures":{"lang":"en","description":"This subreddit is all about video lectures, talks and interesting public speeches.\n\nThe topics include mathematics, physics, computer science, programming, engineering, biology, medicine, economics, p","over18":false},"socalhiking":{"lang":"en","description":"This is a place for fellow hikers and backpackers in Southern California to organize meet ups, post gear reviews, trip reviews, and etc. Hopefully this will unite local hikers and allow us to meet and","over18":false},"Falcom":{"lang":"en","description":"For discussion of all Falcom developed games!\n\n\n\n","over18":false},"nature":{"lang":"en","description":"* Share your fascinating links about nature  \r\n* Discuss endangered parts of nature  \r\n* Contribute news about the wonders of nature  \r\n* Meet other nature enthusiasts  \r\n* Enjoy our functional design","over18":false},"TestOutfit":{"lang":"en","description":"Founded as the official outfit for /r/Planetside and expanding into new games.\n\n\n\n","over18":false},"BostonSocialClub":{"lang":"en","description":"r/BostonSocialClub is back! For events in and around Boston.","over18":false},"Idg0d":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Seaofthieves":{"lang":"en","description":"Sea of Thieves is an action-adventure free-roaming pirate video game developed by Rare and published by Microsoft Studios for Windows 10 and Xbox One.","over18":false},"Dota2Modding":{"lang":"en","description":"DotA 2 Mods on Reddit","over18":false},"GradeAUnderA":{"lang":"en","description":"The official subreddit for the YouTube channel GradeAUnderA!","over18":false},"AreYouTheOne":{"lang":"en","description":"Are You the One? is an American reality television series on MTV. It follows 22 people who are living together in a tropical destination to find their perfect match.","over18":false},"TripSit":{"lang":"en","description":"We are a Harm Reduction community first and foremost! This subreddit is for people on drugs to talk with other like minded individuals without being criticized, similar to the 'chill out' tent at rave","over18":false},"WingChun":{"lang":"en","description":"An open forum, message board, hangout for discussing anything to do with the martial art called Wing Chun. ","over18":false},"LPOTL":{"lang":"en","description":"/r/LPOTL is for anyone that listens to and loves Last Podcast on the Left. We here will accept anyone and everyone. Now how about a murder story and some spooky spaghetti.","over18":false},"Cello":{"lang":"en","description":"","over18":false},"beijing":{"lang":"en","description":"For all the Redditors in Beijing, China","over18":false},"DotaConcepts":{"lang":"en","description":"Come share your Hero, Item, Ability and Mechanics ideas for DotA.","over18":false},"TwentyFour":{"lang":"en","description":"Subreddit dedicated to the Fox televisionseries '24'. The new reboot series, '24: Legacy' starring Corey Hawkins, Miranda Otto and Jimmy Smits is set to premiere Sunday, February 5, 2017 after the Sup","over18":false},"RatchetAndClank":{"lang":"en","description":"This sub-reddit is dedicated to the PlayStation exclusive series Ratchet and Clank. It is intended to host content related to the series and provide a place of discussion for fans of the games.","over18":false},"gamingnews":{"lang":"en","description":"A subreddit for news related to games and gaming.","over18":false},"UnsolvedMysteries":{"lang":"en","description":"This subreddit is about unsolved mysteries. Whenever possible, actual redditors have participated in investigating the events. What you are about to read is not a news broadcast.","over18":false},"Bossfight":{"lang":"en","description":"Pictures of things that could be boss fights, any kind of picture, gif, or video may be used. Come up with a boss name for the title, and if desired add some stats and or back story in the comments, b","over18":false},"mylittlefortress":{"lang":"en","description":"The former home of the \"My Little Fortress\" reddit community","over18":false},"UVA":{"lang":"en","description":"A subreddit for the University of Virginia in Charlottesville, Virginia","over18":false},"Scandal":{"lang":"en","description":"The home of Scandal on Reddit!","over18":false},"BestOfLiveleak":{"lang":"en","description":"BestOfLiveleak","over18":false},"HBOGameofThrones":{"lang":"en","description":"","over18":false},"PERU":{"lang":"es","description":"Un subreddit para todos los peruanos. Si encuentran alguna noticia interesante, algo que les joda o simplemente quieren saber que ruta de combi tomar... este es el lugar.\n\nA subreddit for all Peruvian","over18":false},"wince":{"lang":"en","description":"","over18":false},"Blazblue":{"lang":"en","description":"A place to look for Blazblue netplay games, discuss the series, asking for any questions or advice or post any images/links that are relevant. Feel free to join the Discord channel!","over18":false},"couchsurfing":{"lang":"en","description":"A place for couchsurfing redditors to gather, share stories and exchange tips. \n\nCurrent Request for Comment thread: http://www.reddit.com/r/couchsurfing/comments/2dwe3j/request_for_comment_rcouchsurf","over18":false},"openttd":{"lang":"en","description":"OpenTTD discussion, strategy, and banter. We also run a suite of community servers!","over18":false},"USC":{"lang":"en","description":"","over18":false},"Southampton":{"lang":"en","description":"","over18":false},"exxxchange":{"lang":"en","description":"Find a partner for anything involving porn exchange - pictures, gifs or videos: trading, chatting, captioning, tributing, roleplaying, writing and more!\n\n(porn, nsfw, sex, chat, dirty, captions, xxx)","over18":true},"RWBYNSFW":{"lang":"en","description":"/r/RWBYNSFW is *the* place on reddit for all your RWBY related lewds or masturbatory aids. I personally enjoy thinking about Sun's abs. Whatever floats your boat.","over18":true},"wardrobepurge":{"lang":"en","description":"A market for you to sell your clothes, shoes, and accessories!","over18":false},"cleavage":{"lang":"en","description":"Amateur, models, self POV, it doesn't matter. We love Cleavage\nThis is not a \"hardcore sub\", this is for cleavage of all kinds.. its about the tease.","over18":true},"Le_Pen":{"lang":null,"description":"Subreddit forbidden","over18":null},"MinecraftBuddies":{"lang":"en","description":"A sub all about finding people that enjoy minecraft as much as you, and getting a chance to play with them.","over18":false},"colorizationrequests":{"lang":"en","description":"/r/colorizationrequests is a subreddit dedicated to requesting and fulfilling [Free] or [Paid] commissions for colorizing images.\n","over18":false},"NPR":{"lang":"en","description":"For all fans of public radio, this is a community designed to showcase really good radio stories -- and the people who make them. All public radio fans welcome.","over18":false},"premiere":{"lang":"en","description":"Adobe Premiere Pro is a timeline-based video editing software application.","over18":false},"akalimains":{"lang":"en","description":"For current or aspiring Akali players, the best and cutest Assassin in League of Legends!","over18":false},"Tronix":{"lang":"en","description":"The Official TRON Community on Reddit  - News - Discussion - Information ","over18":false},"Thenewsroom":{"lang":"en","description":"The Newsroom – a current HBO series by Aaron Sorkin.","over18":false},"NexusNewbies":{"lang":"en","description":"A place for new players of Heroes of the Storm to learn the game!","over18":false},"topofreddit":{"lang":"en","description":"All the top reddit posts","over18":false},"TombRaider":{"lang":"en","description":"A subreddit for people interested in Lara Croft and the Tomb Raider video game franchise, the comic books, etc.\n\ntags: TombRaider, Tomb Raider, LaraCroft, Lara Croft, Lara, Croft","over18":false},"HappyTrees":{"lang":"en","description":"A place to share any content related to Bob Ross and The Joy of Painting!","over18":false},"AwesomeCarMods":{"lang":"en","description":"A subreddit devoted to car modifications that are awesome. This subreddit is pretty simple, the title says it all. ","over18":false},"Morocco":{"lang":"en","description":"A subreddit dedicated to all things Morocco. ","over18":false},"rocketry":{"lang":"en","description":"A small community for rockets, big and small.","over18":false},"SearchfortheSleeper":{"lang":"en","description":"This subreddit *was* dedicated to finding the Sleeper Simulant and all related lore. Go find other hidden guns now.","over18":false},"Steel_Division":{"lang":"en","description":"A subreddit to discuss Steel Division game series!","over18":false},"hajimenoippo":{"lang":"en","description":"Welcome to r/Hajimenoippo, the community for Ippo fans to submit new manga releases, discuss the anime, talk about the video games, promote discussion, and share their love for Ippo.","over18":false},"MusicInTheMaking":{"lang":"en","description":"A subreddit for musicians to collaborate on each others projects by sharing sound files.\n\nPost music collaboration projects only.","over18":false},"Birbs":{"lang":"en","description":"Post birbs doing birb things","over18":false},"Rammstein":{"lang":"en","description":"","over18":false},"PaxPassExchange":{"lang":"en","description":"","over18":false},"PanamaPapers":{"lang":"en","description":"Panama Papers and Paradise Papers","over18":false},"playmygame":{"lang":"en","description":"A place for indie developers to share their games!","over18":false},"LatinasGW":{"lang":"en","description":"Latinas Gone Wild! Exclusively for Latinas to bask in the praise of those who truly appreciate them: our subscribers.","over18":true},"tezos":{"lang":"en","description":"Tezos is a new decentralized blockchain that governs itself by establishing a true digital commonwealth. It facilitates formal verification, a technique which mathematically proves the correctness of ","over18":false},"SVgiveaway":{"lang":null,"description":"Subreddit forbidden","over18":null},"EnglishLearning":{"lang":"en","description":"A place for learning english.\n\nUn lugar para aprender inglés.\n\nUn lieu pour apprendre l'anglais.\n\nEin Ort zum Englisch lernen.","over18":false},"Outdoors":{"lang":"en","description":"Outdoor recreation: keeping humans fit, fed and happy for thousands of years. The sun on your face, the wind in your hair: all this and more could be yours to experience... if you ever get off reddit ","over18":false},"LiquidSky":{"lang":"en","description":"LiquidSky is a service which gives you a personal gaming computer in the Sky. You can connect to it from any device to play any game on high settings regardless of your local hardware!\n \nhttps://liqui","over18":false},"OSUOnlineCS":{"lang":"en","description":"A subreddit for students of the Oregon State Online Computer Science BS program. Find yourself another classmate, get help, or ask questions :) ","over18":false},"Lyme":{"lang":"en","description":"For articles and discussion of Lyme and other tick-borne diseases.","over18":false},"aSongOfMemesAndRage":{"lang":"en","description":"A place to post meme and rage-comic links related to George R.R. Martin's *A Song of Ice and Fire* book series and the HBO show based on his works, *Game of Thrones*.\n\nSerious discussions will not be ","over18":false},"burgers":{"lang":"en","description":"Post anything and everything to do with burgers.   \n  \n  \nKeywords: burger, burgers, hamburger, cheeseburger, food, pictures, recipe, meat, bread, videos, gifs, discussion, cooking, bbq, grilling, vac","over18":false},"gso":{"lang":"en","description":"A reddit community for those that live in and around the city of Greensboro, NC.","over18":false},"Yosemite":{"lang":"en","description":"","over18":false},"kittensgame":{"lang":"en","description":"**Kittens Game**\n\nhttp://bloodrizer.ru/games/kittens/\n\n*Kittens Game* is a text-based incremental/idle village simulation browser game. \n\nYou manage a village of kittens as they acquire resources and ","over18":false},"babylon5":{"lang":"en","description":"A sub for Babylon 5, the epic 1990s sci-fi space opera about a diplomatic space station.","over18":false},"zedmains":{"lang":"en","description":"A subreddit dedicated to the League of Legends champion: Zed - Master of Shadows.","over18":false},"EvelynnMains":{"lang":"en","description":"\"This craving will soon be sated\"\n\n/r/EvelynnMains is a community of Widow Makers created by and for Evelynn Mains.\n\n","over18":false},"fermentation":{"lang":"en","description":"","over18":false},"l4d2":{"lang":"en","description":"A mix of Left 4 Dead 2 content... full competitive shoutcasts, frag videos, funny screenshots, custom campaigns, and no subreddit is complete without the occasional rage/advice comic.\n\n","over18":false},"OliveMUA":{"lang":"en","description":"","over18":false},"Cheese":{"lang":"en","description":"Cheese makes the world go round!","over18":false},"NeckbeardNests":{"lang":"en","description":"Messy neckbeard rooms.","over18":false},"NCAAFBseries":{"lang":"en","description":"Gaming reddit about NCAA's football game series. ","over18":false},"ArtPorn":{"lang":"en","description":"High quality images of SFW art meant for appreciating, and sharing.","over18":false},"mycleavage":{"lang":"en","description":"r/MyCleavage is Amateur Only and all about the boobies.\nWe love boobs in bras, bikinis, dresses and anything that shows off lots of cleavage. Breasts of all sizes welcome. NSFW if done right. ","over18":true},"gifsgonewild":{"lang":"en","description":"r/gifsgonewild is an exclusive community where adults can share their bodies, in gif form, without receiving any negative feedback.\n\nGone wild, animated gifs, amateur, self pics","over18":true},"lithuania":{"lang":"lt","description":"Lithuanian Reddit. Lietuvos Redditas.\n\nDiscuss anything. Official languages: Lithuanian, English.","over18":false},"LoLeventVoDs":{"lang":"en","description":"A subreddit for links or resources to help fans catch up on any League of Legends action they've missed in a spoiler-free environment.\n\nComments will be heavily moderated, but it is still recommended ","over18":false},"AppleMusic":{"lang":"en","description":"A discussion platform for anything and everything relating to Apple's new music streaming service!","over18":false},"justified":{"lang":"en","description":"Subreddit for the FX original TV series, Justified. Starring Timothy Olyphant and Walton Goggins.","over18":false},"butterface":{"lang":"en","description":"","over18":true},"FordFocus":{"lang":"en","description":"Everything Ford Focus","over18":false},"PembertonFestival":{"lang":"en","description":"The Pemberton Music Festival returns July 14-17th, 2016! ","over18":false},"ShieldAndroidTV":{"lang":"en","description":"A subreddit about the NVIDIA Shield Android TV - a home console and video streamer running [Android TV](http://www.android.com/tv/).","over18":false},"offset":{"lang":"en","description":"","over18":false},"Cosmere":{"lang":"en","description":"The place to discuss all the aspects of Brandon Sanderson's Cosmere.","over18":false},"googleplus":{"lang":"en","description":"","over18":false},"ClimbingCircleJerk":{"lang":"en","description":"A place for Mike","over18":false},"Humanoidencounters":{"lang":"en","description":"If you have ever had an encounter with a humanoid being, this is the place to post it. Have you been abducted by \"aliens\"? Have you bumped into a Sasquatch? Been chased out of the woods by something o","over18":false},"dataisugly":{"lang":"en","description":"Numbers never lie... except when they do.","over18":false},"altnewz":{"lang":"en","description":"","over18":false},"horrorlit":{"lang":"en","description":"This is a place to discuss horror literature.  Any book is up for discussion as long as that discussion is respectful.  It doesn't matter if you're into Stephen King or Edward Lee, Jack Ketchum or Lov","over18":false},"Faces":{"lang":"en","description":"Images of human faces.","over18":false},"Avengers":{"lang":"en","description":"**The Avengers** is a team of superheroes, appearing in Marvel comic books, cartoons and movies.The team made its debut in The Avengers #1 (Sept. 1963), and was created by writer-editor Stan Lee and a","over18":false},"horseracing":{"lang":"en","description":"A subreddit for anything related to horse racing in any and all varieties, *but not necessarily horse raising & care*. ","over18":false},"Hyundai":{"lang":"en","description":"Subreddit dedicated to the auto maker Hyundai. Come share news and pictures and discuss everything related to Hyundai. Discussions about Hyundai Group corporate cousin Kia are also welcome, though the","over18":false},"yaoi":{"lang":"en","description":"A community dedicated to the appreciation of yaoi and other related art, stories, videos, comics, etc.\n\n\nFujoshis and fanboys are always welcome to do what they do best!  : Fangirl/boy! ","over18":true},"alpinism":{"lang":"en","description":"","over18":false},"sideloaded":{"lang":"en","description":"A community dedicated to discussing various apps and tweaks you can sideload on your iOS device wihout a jailbreak!","over18":false},"rule34_comics":{"lang":"en","description":"This is a subreddit for comics of rule 34.  No pics or gifs just comics.","over18":true},"knifeparty":{"lang":"en","description":"","over18":false},"ImaginaryWesteros":{"lang":"en","description":"Paintings and drawings inspired by the book series A Song of Ice and Fire and the television show Game of Thrones. ","over18":false},"TeemoTalk":{"lang":"en","description":"Welcome to TeemoTalk in 2018!\n\nThis subreddit is dedicated to our lord and savior Teemo. Ideally, this is a place where we can all help one another master our beloved yordle, and to bring fear to sill","over18":false},"NoShitSherlock":{"lang":"en","description":"It’s a place for things that make you go, “no shit, sherlock.”","over18":false},"CysticFibrosis":{"lang":"en","description":"A community for people who suffer from, or know someone with, the debilitating illness known as Cystic Fibrosis.","over18":false},"ShitCosmoSays":{"lang":"en","description":"This is a sub to share some of the most horrific, hilarious, dangerous, or flat out weird sex and relationship advice. While there will be regular awesome excerpts from Cosmo magazine and its website,","over18":false},"klr650":{"lang":"en","description":"Devoted to the trustworthy KLR 650.","over18":false},"NBA2kTeamUp":{"lang":"en","description":"A community dedicated to NBA2K Park and Pro-Am Teammate Finding!","over18":false},"macbookpro":{"lang":"en","description":"Welcome to /r/MacbookPro","over18":false},"WhatsWrongWithYourDog":{"lang":"en","description":"","over18":false},"Starmade":{"lang":"en","description":"Starmade is space shooter, ship building game made by Schema.\n\n\n\nhttp://star-made.org/","over18":false},"sca":{"lang":"en","description":"Recreational mediævalism","over18":false},"aerospace":{"lang":"en","description":"A place to discuss relevant topics in civil and military aviation, space exploration, and news relevant and interesting to those with a passion for all things flying. ","over18":false},"ARG":{"lang":"en","description":"","over18":false},"footballdownload":{"lang":"en","description":"Download and Watch Football matches. ","over18":false},"bannedfromclubpenguin":{"lang":"en","description":"Home to bans from Club Penguin, Club Penguin Island, and CPPSs. ","over18":false},"enlightenedbirdmen":{"lang":"ru","description":"SCCCRRAAAAWWWWWW WERE COMIN FOR YA MUDMEN WE KNOW YOU'RE OUT THERE","over18":false},"tDCS":{"lang":"en","description":"A subreddit for discussing the science, technology,  construction, and use of noninvasive brain stimulators.","over18":false},"CanadianInvestor":{"lang":"en","description":"Canadians Interested in investing and looking at opportunity in the market besides being a potato. Discussion would be geared around any investment opportunities a Canadian has access to. Questions re","over18":false},"legal":{"lang":"en","description":"","over18":false},"starcraft_strategy":{"lang":"en","description":"","over18":false},"NYCC":{"lang":"en","description":"A place for New York Comic Con discussions, pics, meet ups etc!","over18":false},"OneYearOn":{"lang":"en","description":"Reminding people of their new year's resolutions one year after they set them. ","over18":false},"Tennessee":{"lang":"en","description":"This is a subreddit for all things concerning the Volunteer State. Make yourself at home.","over18":false},"bih":{"lang":"bs","description":"Subreddit about Bosnia & Herzegovina","over18":false},"VolleyballGirls":{"lang":"en","description":"All hail the glory of the \"officially-sanctioned\" volleyball \"outfit\".","over18":true},"akron":{"lang":"en","description":"Akron Ohio. Local meet ups, news. Akron related.","over18":false},"airpods":{"lang":"en","description":"A subreddit dedicated to Apple's new AirPods and other future wireless headphones.","over18":false},"UKDota":{"lang":"en","description":"Subreddit for the UK Dota scene. \n\nThe aim of this subreddit is to get all UK Dota players/fans/casters in one place to hopefully grow and nurture the scene in the UK. ","over18":false},"adventofcode":{"lang":"en","description":"Advent of Code is a series of small programming puzzles for a variety of skill levels. They are self-contained and are just as appropriate for an expert who wants to stay sharp as they are for a begin","over18":false},"IndianEnts":{"lang":"en","description":"The cannabis community for anything and everything Marijuana in India. Share stories, pictures, advice, and anything else related. ","over18":false},"proceduralgeneration":{"lang":"en","description":"This subreddit is about everything procedurally generated (pictures, games, music...) but random generation is fine too!","over18":false},"joi":{"lang":"en","description":"Jerk off/masturbation instructions and encouragement videos.","over18":true},"MacOS":{"lang":"en","description":"/r/macOS: Reddits Home to Apples Latest Operating System!","over18":false},"REBL":{"lang":"en","description":"REBL Gaming.\n\nREBL Gaming is a gaming community for redditors based on our [Discord server](http://discord.gg/rebl)\n\nWe have multiple events per day across PC, Switch, PS4 an Xbox One.","over18":false},"EliteCG":{"lang":"en","description":"Subscribe for posts and commentary about the latest community goals! ","over18":false},"brighton":{"lang":"en","description":"A subreddit for all of the lovely people that live in Brighton and Hove. It's okay, you're safe now. ","over18":false},"warframeclanrecruit":{"lang":"en","description":"This is a subreddit for clan leaders to post adverts for their clan, describing what they are all about, and how to get an invite.  \n\nLikewise, this is also a place for people looking to join a clan t","over18":false},"wtfstockphotos":{"lang":"en","description":"","over18":false},"Kendama":{"lang":"en","description":"If you play with a Kendama, this is the place for you. Ranging from everything from videos, reviews, tricks, to selling used damas. If it's related to a Kendama, post it here!","over18":false},"juggalo":{"lang":"en","description":"","over18":false},"PlantBasedDiet":{"lang":"en","description":"Home of the Whole Food Plant Based Diet (WFPB)!\n\nProfessional triathlete, has adopted a plant-based diet, the Engine 2 Diet (http://www.engine2diet.com/) at the advice of his father, Dr. Caldwell B. E","over18":false},"metalmusicians":{"lang":"en","description":"","over18":false},"wwenetwork":{"lang":"en","description":"","over18":false},"wilfred":{"lang":"en","description":"A sub-reddit for any and all things \"Wilfred\" on FX.","over18":false},"bisco":{"lang":"en","description":"this is a reddit that is meant for people to chat about camp bisco!","over18":false},"USF":{"lang":"en","description":"Welcome to the Green and Gold of Reddit. We are the University of South Florida Bulls. A community for students, faculty, alumni, and staff of USF.  Go Bulls!","over18":false},"santarosa":{"lang":"en","description":"","over18":false},"AboveandBeyond":{"lang":"en","description":"A community devoted to the electronic music trio Above & Beyond. As well as Anjunabeats, Anjunadeep, and Group Therapy Radio.","over18":false},"hentai_irl":{"lang":"en","description":"Anime_irl's perverted sister","over18":true},"CFBStreams":{"lang":"en","description":"Share your CFB streams!","over18":false},"bullcity":{"lang":"en","description":"A subreddit for the city (and county) of Durham, North Carolina.","over18":false},"Konosuba":{"lang":"en","description":"The subreddit for *Kono Subarashii Sekai ni Shukufuku wo!*, also known as Konosuba!\n\nAlso the anime where everyone is useless goddess","over18":false},"AnythingGoesPics":{"lang":"en","description":"This subreddit is for all image posts without heavy moderation being applied.","over18":false},"shakespeare":{"lang":"en","description":"","over18":false},"TheBarons":{"lang":null,"description":"Subreddit no longer exists","over18":null},"HTML":{"lang":"en","description":"","over18":false},"DarkNetMarketsNO":{"lang":null,"description":"Subreddit no longer exists","over18":null},"FragReddit":{"lang":"de","description":"","over18":false},"neuroscience":{"lang":"en","description":"A subreddit dedicated to the study of Neuroscience ","over18":false},"cumtributes":{"lang":"en","description":"Sorry for the delay, we will open up this week! Please stay tuned!","over18":true},"operabrowser":{"lang":"en","description":"","over18":false},"playarkservers":{"lang":"en","description":"A place to post Ark Survival Servers, as well as discuss server administration and other various server related discussion.","over18":false},"OffensiveSpeech":{"lang":"en","description":"","over18":false},"iwatchedanoldmovie":{"lang":"en","description":"Just watched an old movie nobody's talking about anymore? Post it here!","over18":false},"tardtales":{"lang":"en","description":"Delightful and hilarious tales about the mentally retarded doing stuff normies can only dream of. \n","over18":false},"trackandfield":{"lang":"en","description":"","over18":false},"iOS8":{"lang":"en","description":"Everything about Apple iOS 8","over18":false},"downloadcodes":{"lang":"en","description":"","over18":false},"Dermatology":{"lang":"en","description":"","over18":false},"insanity":{"lang":"en","description":"","over18":false},"asiantwoX":{"lang":"en","description":"","over18":false},"vba":{"lang":"en","description":"A place for questions and discussion on Visual Basic for Applications (VBA) and its associated integrated development environment (IDE).","over18":false},"LAGalaxy":{"lang":"en","description":"The unofficial home of the LA Galaxy on Reddit!\n\n","over18":false},"rstats":{"lang":"en","description":"","over18":false},"KitSwap":{"lang":"en","description":"Swap or sell your soccer jerseys and scarves to redditors.","over18":false},"yogscastkim":{"lang":"en","description":"This is the official subreddit for Kim of The Yogscast, feel free to post text/link posts for Kim and participate in the Kimmunity! Flux Buddies, Unite!\n\n\nCatch Kim's channel here: http://www.youtube.","over18":false},"keming":{"lang":"en","description":"A subreddit dedicated to the fine art of keming and other examples of bad spacing in typography.","over18":false},"SomebodyMakeThis":{"lang":"en","description":"","over18":false},"SimplePlanes":{"lang":"en","description":"","over18":false},"Wizard101":{"lang":"en","description":"","over18":false},"Bundesliga":{"lang":"de","description":"Bundesliga is Germany's top-tier football league. It was founded in 1963 and features clubs such as FC Bayern München, Borussia Dortmund, FC Schalke 04, Bayer 04 Leverkusen, and Hertha BSC .","over18":false},"kof":{"lang":"en","description":"The subreddit for The King of Fighters, officially abbreviated KOF, a series of fighting games developed by SNK.","over18":false},"AkameGaKILL":{"lang":"en","description":"A Subreddit dedicated to all things Akame Ga KILL.","over18":false},"no_mans_sky":{"lang":"en","description":"A subreddit to discuss the video game No Man's Sky. \n\nNMS is a procedurally generated game that allows the player to explore different planets in their spaceship and on foot.","over18":false},"foreskin_restoration":{"lang":"en","description":"A place to proactively and positively discuss Foreskin Restoration.","over18":false},"Bedbugs":{"lang":"en","description":"The subject of Bedbugs\n\n ","over18":false},"0x10c":{"lang":"en","description":"This is the official subreddit for 0x10^c.  Feel free to engage in rampant speculation, discuss new reveals, and share your creations in DCPU-16! ","over18":false},"prephysicianassistant":{"lang":"en","description":"Subreddit for all pre-physician assistant students seeking help with their applications.","over18":false},"hiphopvinyl":{"lang":"en","description":"Place to share your rapity rap.\n\n","over18":false},"AislingDuval":{"lang":"en","description":"\"Progress is what the empire needs to remain as the beacon of civilisation.\" This subreddit is for Elite: Dangerous players to discuss matters relating to the fictional character Princess Aisling Duva","over18":false},"hammockcamping":{"lang":"en","description":"/r/hammockcamping is a subreddit devoted to the **discussion** of hammock camping.  This subreddit values interesting discussion, not \"quick pic\" posts.  Share how you used your hammock setup on a rec","over18":false},"cyberlaws":{"lang":"en","description":"","over18":false},"JapaneseFood":{"lang":"en","description":"","over18":false},"DarkFuturology":{"lang":"en","description":"**DarkFuturology** examines dystopian trends. We emerged from growing dissatisfaction with the utopian tech-porn dominating Futurology.","over18":false},"MonsterGirl":{"lang":"en","description":"This is a area for the hentai base monster girl genre\nHighly NSFW","over18":true},"AutoNewspaper":{"lang":"en","description":"Automated News Feed Subreddit\n\nNo Censorship, Just News.","over18":false},"broodwar":{"lang":"en","description":"The best subreddit for the latest StarCraft: Brood War news and discussion.","over18":false},"Prague":{"lang":"en","description":"Welcome to Prague, Czech Republic","over18":false},"anchorage":{"lang":"en","description":"","over18":false},"chomsky":{"lang":"en","description":"This is a place to share and discuss content related to History, Politics, Media, Anarchism, Linguistics, Cognitive Science, Free Speech and everything else by people familiar with, or interested in l","over18":false},"typewriters":{"lang":"en","description":"A subreddit for typewriters. An appreciation for that primal hammer-against-paper feeling when you sling words onto a page.","over18":false},"homeless":{"lang":"en","description":"","over18":false},"deals":{"lang":"en","description":"A place to post & share consumer deals. Found a deal on the internet that seems out of this world or spectacular? This is the place to post it! Share Deals with the community of reddit!","over18":false},"ArtHistory":{"lang":"en","description":"This is a community of art enthusiasts interested in a vast range of movements, styles, media, and methodologies. Please feel free to share your favorite articles, essays, artists, or artworks.","over18":false},"BacktotheFuture":{"lang":"en","description":"A place for anything related to the Back to the Future Trilogy!","over18":false},"jerma985":{"lang":"en","description":"All things Jerma","over18":false},"ImperialAssaultTMG":{"lang":"en","description":"","over18":false},"BitMarket":{"lang":"en","description":"","over18":false},"MLPIOS":{"lang":"ja","description":"Make friends with other people and discuss the game! Despite the subreddit name, non-iOS players are welcome too!","over18":false},"buttplug":{"lang":"en","description":"A community dedicated to girls using butt plugs!  Pictures, gifs, and videos are welcome!","over18":true},"toontownrewritten":{"lang":"en","description":"Welcome to Toontown! Join the discussion, have some fun, and let the pies fly on the unofficial subreddit of the cartoon MMO for everyone, Toontown Rewritten. Are YOU Toon Enough?","over18":false},"blues":{"lang":"en","description":"A place for the blues!  ","over18":false},"EmoScreamo":{"lang":"en","description":"","over18":false},"Autocross":{"lang":"en","description":"","over18":false},"SiegeAcademy":{"lang":"en","description":"Siege Academy is a subreddit for the game Rainbow Six: Siege, dedicated to helping new and advanced players to learn and improve in the game.     \n","over18":false},"the1975":{"lang":"en","description":"// T H E 1 9 7 5 //","over18":false},"TerrainBuilding":{"lang":"en","description":"This sub-reddit is for those who craft, build, and paint wargames terrain.","over18":false},"MinecraftInventions":{"lang":"en","description":"","over18":false},"ssbbw":{"lang":"en","description":"","over18":true},"macbook":{"lang":"en","description":"A subreddit dedicated to Apple and their most innovative product yet. Welcome to The Macbook family.","over18":false},"CBTS_Stream":{"lang":null,"description":"Subreddit no longer exists","over18":null},"TestPackPleaseIgnore":{"lang":"en","description":"Reddit's own Feed the Beast pack.","over18":false},"led_zeppelin":{"lang":"en","description":"Place for Zeppelin fans to get the led out.","over18":false},"openSUSE":{"lang":"en","description":"openSUSE is an Linux-based, open, free and secure operating system for PC, laptops, servers and ARM devices.","over18":false},"Ayahuasca":{"lang":"en","description":"Information, discussions and personal experiences about the plant medicine Ayahuasca.","over18":false},"burial":{"lang":"en","description":"","over18":false},"winemaking":{"lang":"en","description":"","over18":false},"ethoslab":{"lang":"en","description":"A place for fans of YouTube Minecraft Let's Player EthosLab!","over18":false},"savageworlds":{"lang":"en","description":"The Savage Worlds subreddit is a place for Articles, Advice, Articulations and Atrocities associated with Savage Worlds: the pinnacle of RPG game systems, published coincidentally by Pinnacle Entertai","over18":false},"slimerancher":{"lang":"en","description":"Slime Rancher is the tale of Beatrix LeBeau, a plucky, young rancher who sets out for a life a thousand light years away from Earth on the 'Far, Far Range' where she tries her hand at making a living ","over18":false},"E_Cigarette":{"lang":"en","description":"A place for potential and new vapers to learn all about vaping as well as the latest news, products, and tricks in the vaping community. All about e-cigs, e-cigarettes, vapers, vaping, clearomizers, m","over18":false},"EndlessLegend":{"lang":"en","description":"A subreddit for fans of Endless Legend, a game by Amplitude Studios.","over18":false},"kpophelp":{"lang":"en","description":"A place to ask questions about anything k-pop related.","over18":false},"mtgjudge":{"lang":"en","description":"A home on reddit for Magic: the Gathering judges, and players interested in the game and tournament rules.","over18":false},"CrossView":{"lang":"en","description":"/r/CrossView is dedicated to the stereoscopic free viewing method of cross viewing. Accepting submissions of all forms (pictures, gif/gfys, videos).  \nNSFW pictures may be a better fit for /r/CrossEye","over18":false},"Luna_Lovewell":{"lang":"en","description":"For me to put stuff that I am writing","over18":false},"F1Game":{"lang":"en","description":"The main subreddit for the Formula 1 Games!\n\nDiscuss anything that pertains to the Codemasters series of F1 Games. You are also welcome to discuss other Formula 1 games, however this subreddit is spec","over18":false},"getting_over_it":{"lang":"en","description":"Supporting each other in conquering depression, anxiety, trauma, doubt, and apathy. A positive community dedicated to overcoming our problems.","over18":false},"MUAontheCheap":{"lang":"en","description":"Reddit's best community to share beauty related sales, deals, GWPs, new releases & more!","over18":false},"StraightGirlsPlaying":{"lang":"en","description":"A subreddit for those who enjoy seeing women being open and playful with each other.","over18":true},"AskLiteraryStudies":{"lang":"en","description":"","over18":false},"badscience":{"lang":"en","description":"A forum for the discussion of poorly presented science.","over18":false},"fayetteville":{"lang":"en","description":"*we need a description! wanna give this a shot? write a draft and send it to the mods :)*","over18":false},"4hourbodyslowcarb":{"lang":"en","description":"The 4-Hour Body Slow-Carb Diet.  Readers of Tim Ferriss' book \"The 4-Hour Body\", can find others looking for support in changing their lives.\n\nHere you will find general Information about the SCD (Slo","over18":false},"linuxmemes":{"lang":"en","description":"","over18":false},"AgeofMythology":{"lang":"en","description":"This subreddit is dedicated to Age of Mythology, the Titans, the Extended Edition and Tale of the Dragon. These titles were originally created by Ensemble Studios, and have now been taken up by Micros","over18":false},"MuslimNoFap":{"lang":"en","description":"NoFap support for Muslims, help for Muslims struggling with porn","over18":false},"nsfwoutfits":{"lang":"en","description":"Hot pics of people in NSFW Outfits.","over18":true},"Clannad":{"lang":"en","description":"","over18":false},"BollywoodRealism":{"lang":"en","description":"This is a subreddit where you can post GIFs and videos of unrealistic South Asian movie or television scenes.","over18":false},"programminghorror":{"lang":"en","description":"Share funny programming related stories and strange or straight-up awful code.","over18":false},"drugsarebeautiful":{"lang":"en","description":"Welcome to Drugsarebeautiful. Try to make your photos artistic as possible seeing as this is also a photography sub. \n\nAs with any community, you read the rules before posting. \n\nBreaking the rules wi","over18":false},"beetlejuicing":{"lang":"en","description":"This is a subreddit dedicated to instances of Beetlejuicing. Beetlejuicing is when one user posts a comment or thread on Reddit, and another user with a username relevant to that parent comment or thr","over18":false},"lorde":{"lang":"en","description":"This sub-reddit is dedicated to New Zealand singer, Ella Yelich-O'Connor, known by her stage name, Lorde.","over18":false},"DesktopDetective":{"lang":"en","description":"","over18":false},"Nest":{"lang":"en","description":"Discussion about the Nest thermostat including applications, modifications, and the like.","over18":false},"SpecArt":{"lang":"en","description":"SF, fantasy, post-apocalypse, and other genre visual arts.\n\nExplore the visual aspects of imagined worlds. All speculative visual arts are welcome, from space vistas to fantasy landscapes to ruined ci","over18":false},"Magento":{"lang":"en","description":"","over18":false},"abv":{"lang":"en","description":"ABV is Already Been Vaped weed.  Because it has already been 'activated', it is completely edible.  So here you can post all the different ways to use ABV.","over18":false},"Splatoon_2":{"lang":"en","description":"Welcome to /r/Splatoon_2! This is a community dedicated to discussion of anything and everything related to the Nintendo Switch game Splatoon 2! For general Splatoon discussion visit /r/Splatoon","over18":false},"NintendoSwitchDeals":{"lang":"en","description":"This subreddit is about finding and sharing the best deals for the Nintendo Switch, its games, and its accessories!","over18":false},"TWD":{"lang":"en","description":"A subreddit exclusively for The Walking Dead TV show. ","over18":false},"mythbusters":{"lang":"en","description":"Anything and everything MythBusters!","over18":false},"X3TC":{"lang":"en","description":"Discussion of [X3: Albion Prelude](http://www.egosoft.com/games/x3ap/info_en.php) and [X3: Terran Conflict](http://www.egosoft.com/games/x3tc/info_en.php), as well as [X3: Reunion](http://www.egosoft.","over18":false},"readyplayerone":{"lang":"en","description":"Your nexus for all things Ready Player One","over18":false},"fashionsouls":{"lang":"en","description":"> A non-stop Soulsborne fashion show. Enjoy your stay and strut your stuff.","over18":false},"Stuff":{"lang":"en","description":"Remember /r/reddit.com? /r/stuff remembers.\n\nWe stand for free speech. We will not ban legal content even if we find it odious or if we personally condemn it. Not because that's the law in the United ","over18":false},"httyd":{"lang":"en","description":"This is Berk.\n\nWe have dragons.","over18":false},"TrollXMoms":{"lang":"en","description":"All your best mom comics, memes and reaction gifs. ","over18":false},"auto":{"lang":"en","description":"/r/auto is a subreddit built to contain all things automotive.  We keep a friendly chat going as well as offer advice to questions you may have.  And we have an AMA system coming soon!","over18":false},"civic":{"lang":"en","description":"Created by Honda Enthusiast.\nAll Things Civic Related.\nPics / Videos / Stories / Advice & More!","over18":false},"HearthArena":{"lang":"en","description":"Discussion about HearthStone Arena and the drafting assistant HearthArena","over18":false},"4ChanMeta":{"lang":"en","description":"No newfags allowed. To qualify as an oldfag, you must be from late December 2013 (back when /b/ was good).\n\nIf you are a 2012 oldfag, you may potentially qualify as a mod. Apply [here](http://www.redd","over18":false},"VinylReleases":{"lang":"en","description":"","over18":false},"SALEM":{"lang":"en","description":"This is a sub-reddit for Salem, Oregon and the surrounding areas.","over18":false},"SkincareAddicts":{"lang":"en","description":"SkincareAddicts is a positive newbie-friendly sub for anything and everything related to skincare. \n\nPost about your favourite products, ask for advice about your routine, discuss the various things t","over18":false},"TellMeAFact":{"lang":"en","description":"Tell Me A Fact is a place to learn interesting facts about a variety of topics- simply choose a topic and find out some facts!","over18":false},"terracehouse":{"lang":"en","description":"Subreddit for discussion about the reality TV show Terrace House (テラスハウス). New season, 「OPENING NEW DOORS」 currently releasing on Netflix Japan. Parts 1-3 (Episodes 1-24) available worldwide.","over18":false},"CastleTV":{"lang":"en","description":"A subreddit to discuss the TV show \"Castle\" on ABC.\n\nCastle is an American comedy-drama television series, which premiered on ABC in 2009. The series is produced by Beacon Pictures and ABC Studios. Cr","over18":false},"AR10":{"lang":"en","description":"This subreddit is dedicated to news and discussion of AR-10's and other 308 AR Platform guns and their variations.","over18":false},"miband":{"lang":"en","description":"Subreddit for members to ask questions and share their content, ideas, and experiences with their Mi Bands.","over18":false},"RioGrandeValley":{"lang":"en","description":"Subreddit for anything in Starr, Hidalgo, Willacy, Cameron county, and surrounding areas.","over18":false},"Carpentry":{"lang":"en","description":"This is a subreddit dedicated to the practice of carpentry in all its forms.  Timber-framing, framing, trim, fascia, soffits, and the myriad jobs a carpenter undertakes are all subjects worthy of disc","over18":false},"Oxygennotincluded":{"lang":"en","description":"Oxygen Not Included","over18":false},"FestivalPlaza":{"lang":"en","description":"Welcome to /r/FestivalPlaza, where you can meet with other users around the world in Pokémon Sun, Moon, Ultra Sun, and Ultra Moon's Festival Plaza!","over18":false},"ElsaGate":{"lang":"en","description":"Investigating the mysteries of the YouTube phenomenon dubbed as \"#ElsaGate\", where a series of videos produced for children contain inappropriate and disturbing content.\n","over18":false},"straightedge":{"lang":"en","description":"A stop for those that found punk/hardcore and made a commitment to themselves to live life drug free. ","over18":false},"ForHonorVikings":{"lang":"en","description":"ForHonorVikings subreddit is a place to plan out the next attack, meet up and play with people in any platform, or just to have fun and ask for tips. Make sure to join the discord!","over18":false},"Ohlympics":{"lang":"en","description":"Anything that makes you go \"Oh\" or is sexually invigorating from the Olympic games.\n\nAssume any link will be NSFW, as you will most likely be seeing a lot of booty in this Sub.","over18":true},"fortlauderdale":{"lang":"en","description":"","over18":false},"SideProject":{"lang":"en","description":"r/SideProject is a subreddit for sharing and receiving constructive feedback on side projects. ","over18":false},"lightsabers":{"lang":"en","description":"Welcome to /r/lightsabers. This sub is dedicated to everything lightsabers. Feel free to post anything regarding lightsabers. For Designs to finished products, Hilts to accessory items, it can be disc","over18":false},"Angular2":{"lang":"en","description":"Angular is Google's open source framework for crafting high-quality front-end web applications. r/Angular2 exists to help spread news, discuss current developments and help solve problems. Welcome!","over18":false},"netneutrality":{"lang":"en","description":"We believe in a free, fair and open internet for everyone!","over18":false},"hawkthorne":{"lang":"en","description":"Journey to the Center of Hawkthorne: The Game","over18":false},"StarTrekDiscovery":{"lang":"en","description":"A subreddit dedicated to discussion, news, and speculation about Star Trek: Discovery. Please beware of spoilers in this sub! ","over18":false},"CatGifs":{"lang":"en","description":"/r/CatGifs: A subreddit devoted to cats in the GIF format.  ","over18":false},"annakendrick":{"lang":"en","description":"","over18":false},"bois":{"lang":"en","description":"Young looking women (or non-binary people) who have a more masculine or androgynous look.\n [Tomboys, Butch or Soft-Butch Lesbians, Short-Haired Girls, Hipsters, Alt Girls]\n\nBoth NSFW and SFW. \n\nImages","over18":false},"swedishproblems":{"lang":"sv","description":"Swedish spin off on r/britishproblems","over18":false},"ASOUE":{"lang":"en","description":"A subreddit for fans of Lemony Snicket's *A Series of Unfortunate Events*, its prequel series *All The Wrong Questions*, the Netflix adaptation, the 2004 movie adaptation, and  related materials.","over18":false},"TexasTech":{"lang":"en","description":"**Anything Texas Tech, Hub City or the like!**","over18":false},"dungeonboss":{"lang":"en","description":"An unofficial subreddit for Dungeon Boss, a mobile game on Android and iOS app stores.","over18":false},"nerdist":{"lang":"en","description":"A place to chat about the ID10T podcast (formerly the Nerdist Podcast) hosted by Chris Hardwick. Welcome one and all.","over18":false},"lostidols":{"lang":"en","description":"Crusaders of the Lost Idols is an idle (incremental) game available to play on Steam, Kongregate, Facebook, Armor Games, Kizi and Big Fish Games.\n\nAlso available on iOS and through the Google Play Sto","over18":false},"PFJerk":{"lang":"en","description":"All this money. It feels so good on my skin...","over18":false},"Breeding":{"lang":"en","description":"NSFW subreddit for reproductive related pornography and discussion.","over18":true},"meat":{"lang":"en","description":"**ALL** things good and meaty.  The TASTY FLESH of EVERY animal shall be discussed here.","over18":false},"freshalbumart":{"lang":"en","description":"Think of this place as fan-art of your favorite albums. Have you ever looked at an album cover and wished it look different? Well, your incredibly specific search is over. This is the nichest of niche","over18":false},"craigslist":{"lang":"en","description":"A subreddit dedicated to Craigslist","over18":false},"maui":{"lang":"en","description":"Welcome to /r/Maui","over18":false},"OMSCS":{"lang":"en","description":"A place for discussion for people participating in GT's OMS CS","over18":false},"fossworldproblems":{"lang":"en","description":"","over18":false},"dcuonline":{"lang":"en","description":"","over18":false},"circojeca":{"lang":"pt","description":"Igual se o /r/circlejerk fosse uma comunidade do orkut. \n","over18":false},"sportsarefun":{"lang":"en","description":"Pictures, gifs, and videos of athletes/coaches/fans having fun. It's about time we bring that back into the light, and stop always seeing all the angry fights and quarrels over every little thing.","over18":false},"HeavySeas":{"lang":"en","description":"Subreddit dedicated to videos and general media relating to huge waves! Try not to puke!","over18":false},"lootcratespoilers":{"lang":"en","description":"Hints, Photos, and General discussion: A place to talk about this month's Loot Crate before and after you get it!","over18":false},"9gag":{"lang":"en","description":"Yesterday's frontpage.. today!\n\n","over18":false},"addiction":{"lang":"en","description":"","over18":false},"Degrassi":{"lang":"en","description":"The subreddit for all things Degrassi!","over18":false},"Gear4Sale":{"lang":"en","description":"Caveat Emptor","over18":false},"ambien":{"lang":"en","description":"chop off all of your hair","over18":false},"Savant":{"lang":"en","description":"This subreddit is dedicated to the norwegian music producer Aleksander Vinter, known otherwise as Savant, Blanco, Vinter in Vegas and many more.","over18":false},"greatdanes":{"lang":"en","description":"A subreddit for the owners and aficionados of the giantest, goofiest dog breed. ","over18":false},"Citrix":{"lang":"en","description":"","over18":false},"Digibyte":{"lang":"en","description":"DigiByte (DGB) is a rapidly growing world-wide decentralized payment network, inspired by Bitcoin. \n\nDigiByte allows you to move money over the internet similar to PayPal & Western Union but with many","over18":false},"meme":{"lang":"en","description":"Why the fuck are you here? This is the right subreddit https://www.reddit.com/r/memes/","over18":false},"GetEmployed":{"lang":"en","description":"Advice, questions, and self-help for getting a job and keeping one.","over18":false},"KronosWoW":{"lang":"en","description":"Kronos WoW - The official community subreddit for Kronos, a private vanilla WoW server by TwinStar","over18":false},"learnjava":{"lang":"en","description":"Resources for learning Java","over18":false},"NarFFL":{"lang":"en","description":"The official reddit fantasy football league","over18":false},"googleglass":{"lang":"en","description":"Google glass news, articles and discussion.","over18":false},"WordAvalanches":{"lang":"en","description":"Word Avalanches: incredibly contrived setups for homophonic punchlines.","over18":false},"CalPolyPomona":{"lang":"en","description":"Cal Poly Pomona, emphasizing Architecture, Engineering, and Business at 3/4 the cost of our sister school. Aided by diversity and specializing in bang for the buck.  ","over18":false},"jacking":{"lang":"en","description":"Where men can post videos of themselves masturbating and be guaranteed an audience.","over18":true},"opengl":{"lang":"en","description":"News, information and discussion about OpenGL development.","over18":false},"Pac12":{"lang":"en","description":"The subreddit for the Pacific-12. The official athletic conference of the best coast.  ","over18":false},"WeAreTheFilmMakers":{"lang":"en","description":"","over18":false},"Quadcopter":{"lang":"en","description":"Designing, Building and Flying R/C Quadcopters","over18":false},"altcoin":{"lang":"en","description":"News about and related to altcoin: all blockchain projects (like Ethereum, NEO, NEM, Stellar, Ripple, Ontology, Nexus, Ardor, Lisk, Ark, OmiseGo, BOScoin) and related currency that exist in addition t","over18":false},"TyrannyGame":{"lang":"en","description":"","over18":false},"RequestNetwork":{"lang":"en","description":"Request Network, the future of commerce. A decentralized network for payment requests.\n\n","over18":false},"Haruhi":{"lang":"en","description":"A subreddit for all things having to do with the Melancholy of Haruhi Suzumiya series. Haruhi manga, anime and light novel discussion are all welcome. Come worship the goddess of anime with us \\^_^","over18":false},"foxholegame":{"lang":"en","description":"","over18":false},"mildyinteresting":{"lang":"en","description":"","over18":false},"Internet_Box":{"lang":"en","description":"Do you enjoy listening to the Internet Box podcast? Then you should subscribe to this subreddit and be surrounded by fans who also enjoy it!","over18":false},"originalxbox":{"lang":"en","description":"There's an Xbox 360 and an Xbox One, but first there was just Xbox. The original Xbox. ","over18":false},"BicyclingCirclejerk":{"lang":"en","description":"","over18":false},"mississippi":{"lang":"en","description":"This is a place for Redditors to discuss Mississippi!","over18":false},"shreveport":{"lang":"en","description":"A place for discussion for those living in Shreveport-Bossier and surrounding areas.","over18":false},"supportlol":{"lang":"en","description":"Forum dedicated to all support mains.","over18":false},"Championship":{"lang":"en","description":"From relegation to promotion, local derby to play-off final, transfer rumours to injury news, this is a place for all things to do with the Championship.  ","over18":false},"handguns":{"lang":"en","description":"Handguns (pistols and revolvers), and everything about them. More specific than /r/guns but more broad than ccw etc. Please subscribe and make this a quality handgun sub.","over18":false},"columbiamo":{"lang":"en","description":"","over18":false},"huskies":{"lang":"en","description":"University of Washington Huskies (Seattle, WA).  For fans of UW football, basketball, and other sports. Go Dawgs!","over18":false},"projectors":{"lang":"en","description":"The place to search for projectors, Buying Help, Setup Help, News about upcoming releases and technological advancements.","over18":false},"DogShowerThoughts":{"lang":"en","description":"Dog Shower Thoughts!  It's like /r/Showerthoughts but from the perspective of the dog.  Woof!\n\n","over18":false},"HistoryMemes":{"lang":"en","description":"Historical Memes and Jokes go here.\n\nOur [Discord Server] (https://discord.gg/cNFQRd6)","over18":false},"pokemongola":{"lang":"en","description":"A place for players of Pokemon GO! In the Los Angeles - and surrounding areas. \n\nThis is a resource to organize meetups, share regional news, share news that'll impact us all. Basically, if it has to ","over18":false},"TrainPorn":{"lang":"en","description":"","over18":false},"Gymnastics":{"lang":"en","description":"","over18":false},"Drizzy":{"lang":"en","description":"Welcome to /r/Drizzy! Keep up with Drake's latest releases and videos so you never miss a new song again. Enjoy the best and the worst of Drake meme's from Hotline Bling video edits to Drake in a whee","over18":false},"ggggg":{"lang":"en","description":"","over18":false},"michaelbaygifs":{"lang":"en","description":"A subreddit for gifs, Michael Bay style\n\nDoes your guy randomly explode for no reason? Submit it here!!","over18":false},"elsword":{"lang":"en","description":"A place to discuss all things Elsword Online, the 100% free to play, sidescrolling, 2.5D beat em up MMORPG.","over18":false},"MCSPlaystation":{"lang":"en","description":"A place to buy and sell Madden Ultimate Team coins for Playstation Consoles.","over18":false},"Dance":{"lang":"en","description":"Since the beginning of the human race, dance has been an essential part of life. \r\n\r\n\r\nWe used it to call rain, conduct ceremony, further competition, and enjoy good, old entertainment. These uses for","over18":false},"exoticspotting":{"lang":"en","description":"","over18":false},"PokePlazaReferences":{"lang":"en","description":"","over18":false},"HairyPussy":{"lang":"en","description":"Pictures and videos of women who do not shave their bodily hair.  Any hair style is great, ranging from peach fuzz to full-on jungle.","over18":true},"UCalgary":{"lang":"en","description":"","over18":false},"VetTech":{"lang":"en","description":"","over18":false},"FreeCodeCamp":{"lang":"en","description":"freeCodeCamp.org is a global community of people who learn to code together, then practice by contributing to open source projects for nonprofits.","over18":false},"OpenChristian":{"lang":"en","description":"OpenChristian is a community dedicated to [Progressive Christianity.](https://en.wikipedia.org/wiki/Progressive_Christianity) This is a space where progressive Christians can support each other, share","over18":false},"NSFWgaming":{"lang":"en","description":"NSFW gaming","over18":true},"PlayMXM":{"lang":"en","description":"Master X Master (MXM) is an upcoming MOBA developed and published by NCSOFT.","over18":false},"lampwork":{"lang":"en","description":"Torch workers unite!  From boro work to soft glass beads, we cover everything dealing with lampworking!  ","over18":false},"LastDayonEarthGame":{"lang":"en","description":"OFFICIAL subreddit for Last Day on Earth made by the developers of the game. Last Day on Earth is a zombie survival MMO, where all survivors are driven by one goal: stay alive as long as you can. Ther","over18":false},"banned":{"lang":"en","description":"Censorship is a disease and we are the cure.","over18":false},"jambands":{"lang":"en","description":"","over18":false},"Metric":{"lang":"en","description":"This is a community that seeks to promote the metric system, (SI units) especially in the UK and the US. These countries make up the 3% of the world population that still uses Imperial and US Customar","over18":false},"Electroneum":{"lang":"en","description":"Electroneum is a leap forwards in the accessibility of cryptocurrencies.\n","over18":false},"GFD":{"lang":"en","description":"Gamers Fighting Depression [GFD] is a supportive community for gamers of all platforms, modes, and styles who have or are suffering from mental health issues, and welcome those who empathize and under","over18":false},"Miitomo":{"lang":"en","description":"This subreddit is dedicated to Miitomo, which is Nintendo's first app for iOS and Android smartphones and tablets.","over18":false},"docker":{"lang":"en","description":"[Docker](http://www.docker.io) is an open-source project to easily create lightweight, portable, self-sufficient containers from any application. The same container that a developer builds and tests o","over18":false},"CompulsiveSkinPicking":{"lang":"en","description":"A place for people with Compulsive Skin Picking (CSP; An Obsessive-Compulsive Spectrum Disorder sometimes also referred to as Dermatillomania and commonly associated with Body Dysmorphic Disorder (BDD","over18":false},"GTADupe":{"lang":"en","description":"Where to go if you want rare cars in GTA:O","over18":false},"LGBTGoneWild":{"lang":"en","description":"","over18":true},"workflow":{"lang":"en","description":"[Workflow](http://my.workflow.is) automates the things you do every day. Discuss it here.","over18":false},"MostBeautiful":{"lang":"en","description":"This sub is about finding beauty in the the world around us, from the simple and ordinary to the majestic and awe-inspiring. If you find something beautiful, share it here. ","over18":false},"nesclassicmods":{"lang":"en","description":"It's 1985 all over again! The NES classic is a re-released console with 30 games powered by 5v and designed to output a modern digital signal over HDMI. This community will hack, mod, and extend the N","over18":false},"IndianCountry":{"lang":"en","description":"Native American news, happenings, culture, politics, arts, community,  and thought. Give us your local, give us your Pan-Indian, Aleut, Hawaiian, Yupik, Inuit, and Métis; it's all good.\n\nRespect and h","over18":false},"PartyParrot":{"lang":"en","description":"Welcome to the official Subbie® for Party Parrot!\n\nParty Parrot is a Slack emoji based on the legendary Sirocco, of the critically endangered Kākāpō species. PartyParrot FOREVER!","over18":false},"Boardgamedeals":{"lang":"en","description":"Subreddit for the best deals on (designer) board games.","over18":false},"Sprinting":{"lang":"en","description":"","over18":false},"Unashamed":{"lang":"en","description":"Women naked in a public place.  Not flashing, fully naked (although shoes or a hat are acceptable.)","over18":true},"computergraphics":{"lang":"en","description":"","over18":false},"StallmanWasRight":{"lang":"en","description":"Nobody listens to him. But he was right all along. ","over18":false},"uvic":{"lang":"en","description":"The University of Victoria  is a major research university located in Victoria, British Columbia, Canada. The University of Victoria, founded in 1963, is the oldest university in British Columbia. The","over18":false},"SpiceandWolf":{"lang":"en","description":"Contribute anything related to the adventures of Holo the Wise Wolf and the merchant Kraft Lawrence!","over18":false},"Lightroom":{"lang":"en","description":"A subreddit about organising, editing, and developing your photos with Adobe Lightroom and Lightroom Mobile for iOS.\n\n\n","over18":false},"CompetitionShooting":{"lang":"en","description":"Shooting is fun. Shooting is MORE fun for prizes, trophies, or just bragging rights. Whether you run and gun in practical shooting, grind birds in skeet/trap, or punch dime-sized holes in benchrest, t","over18":false},"LCDSoundsystem":{"lang":"en","description":"Community for LCD Soundsystem, bands associated with LCD, and for the fans of LCD Soundsystem.","over18":false},"brokengifs":{"lang":"en","description":"For gifs that are creepily broken.","over18":false},"thepiratebay":{"lang":"en","description":"For all your TPB knowledge.","over18":false},"FATErpg":{"lang":"en","description":"","over18":false},"RiotFest":{"lang":"en","description":"Riot Fest Music Festival \n","over18":false},"learntodraw":{"lang":"en","description":"New to drawing? Let us help you learn how to get started!\n\nDrawing is a skill, not a talent. It doesn't matter if you can draw or not, with practice you can be the best. We welcome you to our communit","over18":false},"v8supercars":{"lang":"en","description":"","over18":false},"helpmewin":{"lang":"en","description":"Need help to win something? Need likes, votes? Request them here!","over18":false},"artstore":{"lang":"en","description":"This is a subreddit for artists to link their stores, sell their wares, and connect to people looking to purchase original art or hire artists for commissions. Buy art and get custom work from thousan","over18":false},"driving":{"lang":"en","description":"","over18":false},"TRADE":{"lang":"en","description":"Trade, exchange, give away your unused and unwanted objects to fellow redditors around the world. ","over18":false},"Dofus":{"lang":"en","description":"","over18":false},"Driveclub":{"lang":"en","description":"","over18":false},"camphalfblood":{"lang":"en","description":"A place for all demigods and fans of Camp Half Blood books and related things! Celebrates the Percy Jackson series and the Heroes of Olympus series.\n\nDiscussion of Rick Riordan's other series is also ","over18":false},"AsABlackMan":{"lang":"en","description":"For those pretending to be what they're not, and those who hate what they are.","over18":false},"castles":{"lang":"en","description":"Castles, Châteaux, and Fortresses!","over18":false},"SLO":{"lang":"en","description":"","over18":false},"Corsair":{"lang":"en","description":"A subreddit to show off your CORSAIR build, discuss new releases and CORSAIR related news!","over18":false},"GoalKeepers":{"lang":"en","description":"","over18":false},"Gothenburg":{"lang":"en","description":"A subreddit dedicated to everything related to Gothenburg, Sweden and its inhabitants.","over18":false},"CSULB":{"lang":"en","description":"For students and alumni of CSULB. ","over18":false},"billsimmons":{"lang":"en","description":"Discussing that guy who writes/talks about sports/pop culture. ","over18":false},"FracturedSpace":{"lang":"en","description":"This is the official subreddit for the game Fractured Space. ","over18":false},"Christians":{"lang":"en","description":"/r/Christians is a non-denominational community for Christianity that exists firstly for God's glory and secondly for encouragement of Christians who believe in salvation by grace alone through faith ","over18":false},"shutupandwrite":{"lang":null,"description":"Subreddit forbidden","over18":null},"vgb":{"lang":"en","description":"Vintage Gentleman Boners: A place for exquisite people to enjoy the gorgeous women of yesteryear","over18":false},"ancientrome":{"lang":"en","description":"For everything to do with the Roman Kingdom, Republic and the Empire up until the fall of the Western Empire. Feel free to post about Roman architecture, military history, art, archaeological finds an","over18":false},"Stutter":{"lang":"en","description":"/r/Stutter - A Forum for Discussion and Information on Stuttering.","over18":false},"Opeth":{"lang":"en","description":"","over18":false},"d3loot":{"lang":"en","description":"A community where you can trade items and get your items price checked if you're completely lost on the price!","over18":false},"Firewatch":{"lang":"en","description":"Firewatch is a mystery game set in the Wyoming wilderness, where your only emotional lifeline is the person on the other end of a handheld radio. ","over18":false},"onejob":{"lang":"en","description":"Welcome! /r/Onejob is a subreddit based on funny occupation mishaps.\n\nThe official depository for the classic \"You Had One Job!\" posts.","over18":false},"streetphotography":{"lang":"en","description":"A subreddit to share your street photography work and discuss the technique, gear and philosophies behind shooting street.","over18":false},"nonprofit":{"lang":"en","description":"Conversation about nonprofit organizations, the social sector, and philanthropy.","over18":false},"mr2":{"lang":"en","description":"","over18":false},"PlayItAgainSam":{"lang":"en","description":"For videos that are so quick or awesome that you have to hit \"replay\"!","over18":false},"Office365":{"lang":"en","description":"A vast community of Microsoft Office365 users that are working together to support the product and others. ","over18":false},"country":{"lang":"en","description":"Country Music","over18":false},"IreliaMains":{"lang":"en","description":"The official Irelia Mains subreddit!","over18":false},"Miscarriage":{"lang":"en","description":"","over18":false},"physicianassistant":{"lang":"en","description":"This is a subreddit to share information about Physician Assistants (PAs). This sub is open to PAs, MD/DOs, NPs, Nurses, any other medical professional, or even the general public. While we welcome pr","over18":false},"wemetonline":{"lang":"en","description":"r/wemetonline is a subreddit for giving and receiving advice, venting frustrations and sharing stories about that special someone you met online. Just because you haven't touched him or her physically","over18":false},"microbiology":{"lang":"en","description":"The study of eukaryotes, fungi, protists, prokaryotes, viruses, and prions.","over18":false},"fffffffuuuuuuuuuuuud":{"lang":"en","description":"","over18":false},"queensuniversity":{"lang":"en","description":"Queen's University community in Kingston, Ontario, Canada.","over18":false},"Athens":{"lang":"en","description":"","over18":false},"TerrariumTV":{"lang":"en","description":"Terrarium TV - Watch All Free HD Movies and TV Shows on Your Android Devices!","over18":false},"Hulu":{"lang":"en","description":"r/Hulu is the un-official subreddit of Hulu, Hulu with No Ads, and Hulu with Live TV.  Hulu, which launched in 2008 is a leading premium streaming service that offers instant access to live and on dem","over18":false},"SRSMeta":{"lang":"en","description":"","over18":false},"hiphop":{"lang":"en","description":"Hip Hop music  \n\nNothing more, nothing less","over18":false},"Dariusmains":{"lang":"en","description":"Do you like dunking? Do you like play Darius? Well then welcome to the home of the DunkMaster! Discuss Darius in all his glory, and have fun while doing so. Strats, guides, and questions are all fair ","over18":false},"earnhoney":{"lang":"en","description":"EarnHoney: The Highest Payout Entertainment Rewards Site. Watch videos, play games, and complete surveys to earn Honey Dollars which can be redeemed for rewards. Check out the EarnHoney Guide on how t","over18":false},"askpsychology":{"lang":"en","description":"A subreddit for questions about the mind and behavior.","over18":false},"amihot":{"lang":"en","description":"Ask redditors if they think you're hot here.","over18":false},"Database":{"lang":"en","description":"","over18":false},"MitchellAndWebb":{"lang":"en","description":"Anything to do with British comedy duo [David Mitchell and Robert Webb](http://en.wikipedia.org/wiki/Mitchell_and_Webb) (including [Peep Show](http://en.wikipedia.org/wiki/Peep_Show_(TV_series\\)) and ","over18":false},"23andme":{"lang":"en","description":"Talk about your genes and their possible implications!","over18":false},"StruggleFucking":{"lang":"en","description":"StruggleFucking: We were r/rapingwomen but they took it without consent... Rape fantasy videos for the **discerning** consenting non-consensual *connoisseur*. Classy as fuck!","over18":true},"LoLTwistedTreeline":{"lang":"en","description":"Hello. I decided to create the Twisted Treeline subreddit for the fellow players that like to play 3v3's and want to discuss strats and champion picks about this map.","over18":false},"CTFxC":{"lang":"en","description":"Internet Killed Television is a web series which documents the lives of Charles Trippy and his dogs. The show consists of episodes averaging around ten minutes that are filmed, edited, and then aired ","over18":false},"fittings":{"lang":"en","description":"Theorycraft, discuss, and critique ship fittings for the game EVE Online.","over18":false},"NewGirl":{"lang":"en","description":"","over18":false},"day9":{"lang":"en","description":"","over18":false},"keriberry_420":{"lang":"en","description":"(https://www.reddit.com/r/keriberry_420/wiki/myreviewsfromanywhere)Hi! My name is Keri \nand I'm a 36 year old American camgirl/artist/model\nI work on ManyVids & Chaturbate. I also sell products like c","over18":true},"spiral_knights":{"lang":"en","description":"","over18":false},"ICONOMI":{"lang":"en","description":"ICONOMI is a digital asset management platform that provides access to managed portfolios of cryptocurrencies called Digital Asset Arrays. We make it easy for beginners to take their first steps into ","over18":false},"WtSSTaDaMiT":{"lang":"en","description":"When the sun shines through a dress and makes it translucent.","over18":true},"GrowCastle":{"lang":"en","description":"A subreddit that's meant for discussion about the mobile game Grow Castle developed by RAON GAMES.","over18":false},"arumba07":{"lang":"en","description":"A place to discuss and watch the videos from Arumba07.","over18":false},"PrisonBreak":{"lang":"en","description":"Subreddit for the TV series, Prison Break, airing on FOX,\n\nStarring Wentworth Miller and Dominic Purcell.","over18":false},"CWArrow":{"lang":null,"description":"Subreddit forbidden","over18":null},"maninthehighcastle":{"lang":"en","description":"This subreddit is for the Amazon TV show The Man In The High Castle","over18":false},"basset":{"lang":"en","description":"","over18":false},"The_Gaben":{"lang":"en","description":"O' Praise Him!","over18":false},"SelenaGomez":{"lang":"en","description":"For fans of Selena Gomez.","over18":false},"davidtennant":{"lang":"en","description":"","over18":false},"PeakyBlinders":{"lang":"en","description":"Subreddit for the BBC TV series, Peaky Blinders. Starring Cillian Murphy and Sam Neill.","over18":false},"sooners":{"lang":"en","description":"Welcome to the University of Oklahoma Sooners subreddit. A place where students, alumni, and fans come together to discuss all things OU.","over18":false},"ihaveissues":{"lang":"en","description":"/r/Relationships Community","over18":false},"EngorgedVeinyBreasts":{"lang":"en","description":"Heavy breasts, full of milk, thick nipples, anything that shows this most wonderful part of the female anatomy in all it's milky glory. Milk does not have to be present and breasts do not need to be e","over18":true},"lincolndouglas":{"lang":"en","description":"A subreddit devoted to High-School Lincoln Douglas Debate.","over18":false},"MBMBAM":{"lang":"en","description":"A subreddit for MBMBAM fans to ask each other whether they are good, complain about Ron, form dance troupes, think about four dimensional stables, shop for haunted dolls, express their desire to munch","over18":false},"chicagotrees":{"lang":"en","description":"","over18":true},"omegle":{"lang":"en","description":"","over18":false},"houstonents":{"lang":"en","description":"","over18":false},"Goldfish":{"lang":"en","description":"A subreddit dedicated to goldfish.\n\nFeel free to post any problems, pictures, or generate discussions. This subreddit is for you to discover.\nHave fun fishkeeping!\n","over18":false},"deadrising":{"lang":"en","description":"The Dead Rising Subreddit.","over18":false},"hotsauce":{"lang":"en","description":"A place for anyone who likes to punish their tongue","over18":false},"FFXIVGlamours":{"lang":"en","description":"Post your FFXIV Glamours here!","over18":false},"WallpaperRequests":{"lang":"en","description":"Have an image that just doesn't fit you wallpaper needs? Look no further!\n/r/WallpaperRequests has the community you need to get the wallpaper of your dreams!","over18":false},"SouthJersey":{"lang":"en","description":"The \"other\" New Jersey you never hear about. ","over18":false},"JapanesePorn2":{"lang":"en","description":"A subreddit to share all the best asian/japanese porn videos, gifs and pictures. ","over18":true},"Kangoku_Gakuen":{"lang":"en","description":"","over18":false},"SDSU":{"lang":"en","description":"**Leadership Starts Here**\n\nSDSU provides transformative experiences for students in research, international experiences, sustainability and entrepreneurship initiatives, and a broad range of student ","over18":false},"VXJunkies":{"lang":"en","description":"","over18":false},"MagikarpJump":{"lang":"en","description":"Train your Magikarp to soar as high as possible in Pokémon: Magikarp Jump! The lowly Magikarp now gets its time in the spotlight with this fun app for iOS and Android devices.","over18":false},"oilandgasworkers":{"lang":"en","description":"From roughnecks to refinery engineers and everyone in between, a place to share knowledge, news, and make connections.","over18":false},"RocketLeaguePS4Trades":{"lang":"en","description":"This is a trading community for PS4 users only. At the moment we are only going to be allowing item trades. That being said no one is to be setting up deals that include Paypall or other services that","over18":false},"TalesFromTheSquadCar":{"lang":"en","description":"","over18":false},"LGBTeensGoneMild":{"lang":"en","description":"A place to show your face. Simples.","over18":false},"AdventureCapitalist":{"lang":"en","description":"Subreddit for Adventure Capitalist, a game made by [Hyper Hippo](http://hyperhippo.ca/).","over18":false},"esp8266":{"lang":"en","description":"ESP8266 WiFi Module Help and Discussion","over18":false},"DadsGoneWild":{"lang":"en","description":"A space on Reddit for men over 35 to show off [NSFW]","over18":true},"botsrights":{"lang":"en","description":"A sub to focus on the struggle and advancements of disadvantaged bots.","over18":false},"dgu":{"lang":"en","description":"A subreddit dedicated to cataloging incidents in the United States where legally-owned or legally-possessed guns are used to deter or stop crime.\n\n","over18":false},"ashleymadisonhack":{"lang":"en","description":"Discussion around the Ashley Madison leak.","over18":false},"TheB1G":{"lang":"en","description":"A sports oriented Subreddit for the Big Ten Conference and all 14 of its member institutions.","over18":false},"asktrees":{"lang":"en","description":"","over18":false},"buildapcsalesuk":{"lang":"en","description":"This is an aggregator for any sales or deals that you can find on PC components. The website or retailer must either reside in the UK or deliver to the UK.","over18":false},"pipetobaccomarket":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Enneagram":{"lang":"en","description":"All personalities are welcome in this community for Enneagram-related discussion. ","over18":false},"PokemonGoBoston":{"lang":"en","description":"A community for Bostonian Pokemon GO players.","over18":false},"opensouls3":{"lang":"en","description":"A place to discuss anything about Dark Souls III. No censorship.","over18":false},"WarhammerFantasy":{"lang":"en","description":"","over18":false},"legostarwars":{"lang":"en","description":"","over18":false},"juststart":{"lang":"en","description":"Number #1 Sub For Online Business and Affiliate Marketing","over18":false},"physicsgifs":{"lang":"en","description":"GIFs that show physics principles at work in the real world or in a simulation.","over18":false},"ShittyFanTheories":{"lang":"en","description":"Shit hit the fan.","over18":false},"Megturney":{"lang":"en","description":"This is a subreddit about Meg Turney: Youtube host, cosplayer, gamer, and model.","over18":false},"Cheap_Meals":{"lang":"en","description":"Reddit Cheap Meals","over18":false},"cardano":{"lang":"en","description":"","over18":false},"deepdream":{"lang":"en","description":"Please read our sticky to know whats going on: http://redd.it/3cawxb\n\nWe generate images that show us what deep learning algorithms think/see when given images. We share tips/tricks/guides and new met","over18":false},"CineShots":{"lang":"en","description":"The art form of film and television simply would not exist without cinematography -- and some even stand above others when it comes to this inspiring art form. So, please join us in sharing your favor","over18":false},"Maher":{"lang":"en","description":"Welcome to /r/Maher!","over18":false},"John_Frusciante":{"lang":"en","description":"We are a community based around the happening of John Frusciante. John Frusciante, is the past guitarist for the red hot chili peppers as well as many other side projects. He was also voted number eig","over18":false},"sugarfreemua":{"lang":"en","description":"/r/sugarfreemua is for people who want actual \"sugar-free\" advice/constructive criticism on makeup application.","over18":false},"MicrosoftBand":{"lang":"en","description":"Subreddit dedicated to Microsoft Band fitness oriented smart watch, Microsoft Health platform and fitness activities.","over18":false},"fweddit":{"lang":"en","description":"","over18":false},"gencon":{"lang":"en","description":"Gen Con is the largest tabletop-game convention in North America by both attendance and number of events. It features traditional pen-and-paper, board, and card games, including role-playing games, mi","over18":false},"HaltAndCatchFire":{"lang":"en","description":"*Halt and Catch Fire* is AMC's latest prestige drama. Set against the tech boom of the 1980's the show follows a cunning salesman, an engineer and a programming prodigy as they attempt to reverse engi","over18":false},"specializedtools":{"lang":"en","description":"A place to post tools which were created for a specific purpose.\n\nDoesn't necessarily have to be *one* purpose. ","over18":false},"windsorontario":{"lang":"en","description":"Official subreddit for Windsor Ontario, all are welcome!","over18":false},"CrimeScene":{"lang":"en","description":"Creepy, gore, murders, suicides, serial killers, unsolved/solved mysteries, autopsy, crime scenes & death. We have it all! ","over18":true},"HillaryForAmerica":{"lang":"en","description":"/r/HillaryForAmerica is a subreddit to support Hillary Clinton on Reddit! We encourage an open, honest discussion of the issues.","over18":false},"CircLoLjerk":{"lang":"en","description":"/r/circlejerk + /r/leagueoflegends = /r/CircLoljerk","over18":false},"i_irl":{"lang":"en","description":"r/i_irl is a meme aggregator that gathers posts from across Reddit and reposts them here.","over18":false},"WikiInAction":{"lang":"en","description":"A place to discuss the corruption and issues with Wikipedia. Anything from one sided articles, historical revisionism, corruption among the editors, and so on is welcome here.","over18":false},"AlienwareAlpha":{"lang":"en","description":"A subreddit dedicated to the Alienware Alpha Mini PC.","over18":false},"ConspiracyII":{"lang":"en","description":"Conspiracy, Theory, 2, II, JFK, Kennedy, 9/11, Bible, Priory, Sion, Babylon, Cooper, Extraterrestrials, UFO, Alien, NASA, Nibiru, Planet, X, HAARP, MKUltra, RFID, Montauk, Monarch, CIA, Intelligence, ","over18":false},"HealthAnxiety":{"lang":"en","description":"A home for those with health anxiety/hypochondria. You're not alone!","over18":false},"Ijustwatched":{"lang":"en","description":"A sub-reddit to discuss and/or review films you have recently seen.\n\n\n","over18":false},"smitetraining":{"lang":"en","description":"This is a subreddit for players to give there tips and tricks, as well as volunteer to coach new players in Smite, the MOBA by Hi-Rez Studios.","over18":false},"men_in_panties":{"lang":"en","description":"","over18":true},"AnimalRights":{"lang":"en","description":"Here we talk about the rights of animals and what we can do to defend those rights. Some topics include: animal experimentation, the ethics of eating animals and their products, animal used in enterta","over18":false},"commandandconquer":{"lang":"en","description":"This is the subreddit for all Command & Conquer fans, dealing with anything and everything related to Command and Conquer, from Tiberian Dawn to the upcoming free to play Command and Conquer title.","over18":false},"racism":{"lang":"en","description":"Reddit's anti-racism community, a safe(r) space for People of Color and their supporters. All discussions are expected to be from a post-\"racism 101\" and postcolonial point of view. We are conscious t","over18":false},"Bluegrass":{"lang":"en","description":"A community for lovers of Bluegrass music.","over18":false},"Heroes":{"lang":"en","description":"","over18":false},"TheCulture":{"lang":"en","description":"*This subreddit is dedicated to the fictional world created by Iain M. Banks in the Culture novels and short stories.*  ","over18":false},"newcastle":{"lang":"en","description":"Welcome to /r/newcastle! The *official* subreddit for Newcastle, Australia. (Not Newcastle Upon Tye if you came here by accident!). \n\nCome join your fellow Novocastrians in discussions or post links r","over18":false},"KeepWriting":{"lang":"en","description":"Welcome to KeepWriting. We are a subreddit dedicated to motivating writers  to stay consistent and constantly grow their craft. Whether you're looking to get feedback on an idea, hear a critique, or g","over18":false},"grunge":{"lang":"en","description":"Grunge Rock","over18":false},"gaysian":{"lang":"en","description":"A subreddit for gay Asians!","over18":false},"protools":{"lang":"en","description":"***/r/ProTools***\n\nYour home for everything Pro Tools. Everyone is welcome, from industry veterans to bedroom engineers.  Be sure to check out our wiki pages for more information regarding Pro Tools; ","over18":false},"guildrecruitment":{"lang":"en","description":"A place to advertise your Guild Wars 2 guilds.","over18":false},"forwardsfromhitler":{"lang":"en","description":"A subreddit similar to forwards from grandma, but even more evil.","over18":false},"LearnCSGO":{"lang":"en","description":"Learn how to play Counter Strike: Global Offensive! A subreddit for new to experienced players!","over18":false},"DealsReddit":{"lang":"en","description":"Never pay full price again\n\nDealsReddit is a subreddit for all the good deals, and discounts across the internet.\n\nThe vision of this subreddit is to be a place for deals that interest all redditors a","over18":false},"TODispensaries":{"lang":"en","description":"Reviews of products from dispensaries in Toronto!","over18":false},"Polaroid":{"lang":"en","description":"Welcome to the place for analogue instant film lovers! Whether you shoot Fuji Instax, Polaroid Originals (previously called 'The Impossible Project'), or expired original Polaroid film, you're welcome","over18":false},"worldwhisky":{"lang":"en","description":"This is a place for the discussion of all whiskies not from Scotland or the US.","over18":false},"Polandballart":{"lang":"en","description":"PolandballArt is a subreddit for artistic pieces with country balls.","over18":false},"GripTraining":{"lang":"en","description":"/r/GripTraining is a subreddit for anyone from hardcore grip strength competitors to anyone looking for a stronger pair of mitts or bigger forearms (though the emphasis is on overall grip strength not","over18":false},"leggingsgonewild":{"lang":"en","description":"This is the place for female Redditors to celebrate their curves when wearing their **yoga pants, leggings, spandex, tights, pantyhose, etc**.  \nAll body sizes are welcome, this is a friendly and supp","over18":true},"GunsNRoses":{"lang":"en","description":"A subreddit for the rock band Guns N' Roses","over18":false},"Dreadfort":{"lang":"en","description":"This is a meeting place for all bannermen and allies of House Bolton; Roose Bolton, Lord of the Dreadfort and Warden of the North, and his trueborn son, Ramsay Bolton, Lord of Winterfell.","over18":false},"BattleNetwork":{"lang":"en","description":"A community for the MegaMan Battle Network and Star Force series!","over18":false},"BetweenTheBuriedAndMe":{"lang":"en","description":"","over18":false},"futureporn":{"lang":"en","description":"High quality images of the future.","over18":false},"rheumatoid":{"lang":"en","description":"","over18":false},"Wolfenstein":{"lang":"en","description":"A community for Wolfenstein fans.","over18":false},"mumbai":{"lang":"en","description":"Welcome to Mumbai's Reddit Community! A subreddit where everyone can come together and discuss and share everything from posts, news articles, events, activities, pictures, hold meetups & overall gene","over18":false},"SiouxFalls":{"lang":"en","description":"Welcome to Sioux Falls, South Dakota's own subreddit!","over18":false},"StateOfDecay":{"lang":"en","description":"State of Decay Subreddit Community","over18":false},"Nujabes":{"lang":"en","description":"In all arts and sciences, rhythm is not to be ignored.\n","over18":false},"AtlasReactor":{"lang":"en","description":"Community of Atlas Reactor!","over18":false},"CatsAreAssholes":{"lang":"en","description":"The subreddit where the true asshole-ish nature of all cats is displayed for the world to see.","over18":false},"berserklejerk":{"lang":"en","description":"A place to post absurd and obscene content related to Berserk. Official /r/Berserk meme depository.","over18":false},"kelowna":{"lang":"en","description":"A place for anyone interested in Kelowna, BC, Canada. If you live here, lived here or want to know more about the place you are moving to/visiting, feel free to join us.","over18":false},"StarTrekTimelines":{"lang":"en","description":"Player-run community for the hit mobile game, Star Trek Timelines. ","over18":false},"Deathmetal":{"lang":"en","description":"Death metal is a subgenre of heavy metal music. Descended originally from thrash, it often employs heavily distorted guitars, tremolo picking, deep growling vocals, blast beat drumming, minor keys or ","over18":false},"icocrypto":{"lang":"en","description":"Discussions and reviews related to ICO, Crowdsales and Token sales in the fields of Blockchain and Datachain. Building a due diligence community.\n\nSee the rules bellow for details on posting/flair str","over18":false},"homelabsales":{"lang":"en","description":"Sales//Trades for the lab at home.","over18":false},"TheEricAndreShow":{"lang":"en","description":"This is a subreddit dedicated to The Eric Andre Show, airing on Adult Swim every Friday at 12PM EST.","over18":false},"FACEITcom":{"lang":"en","description":"FACEIT is the largest platform for competitive gaming on CS:GO, DOTA 2, League of Legends and many other games. \n\nThis subreddit is where you can express your feedback, appreciation of the platform as","over18":false},"UTSA":{"lang":"en","description":"","over18":false},"foraging":{"lang":"en","description":"Info on finding, identifying, harvesting and cooking wild edible food.","over18":false},"SkypePals":{"lang":"en","description":"","over18":false},"northdakota":{"lang":"en","description":"Official subreddit for all things North Dakota.","over18":false},"casualnintendo":{"lang":"en","description":"A fan community for any fan-created content: art, remixes of classic Nintendo music, jokes, you name it! All casual content is welcome on /r/casualnintendo!","over18":false},"HouseMD":{"lang":"en","description":"House, an acerbic infectious disease specialist, solves medical puzzles with the help of a team of young diagnosticians. Flawless instincts and unconventional thinking help earn House great respect, d","over18":false},"myog":{"lang":"en","description":"Tips, tricks and How-To's for making your own outdoor gear. Tents, tarps, hammocks, stoves, packs and anything else you can think of.","over18":false},"AutoHotkey":{"lang":"en","description":"A subreddit dedicated to helping people learn AHK. Please make sure you read the sticky post before posting as it has some great info in it.\n\nWhen you get stuck trying to understand a command, or want","over18":false},"gay_irl":{"lang":"en","description":"Share what you're like irl whether you're gay, lesbian, bisexual, transgender, or queer 🏳️‍🌈","over18":false},"new_right":{"lang":"en","description":"**New Right, Alternative Right, Traditionalist, Neoreaction and Dark Enlightenment:** new right news and discussion for traditionalist, reactionary, radical traditionalist, paleoconservative, conserva","over18":false},"chefknives":{"lang":"en","description":"A place for all things chef knives.  A place to talk about the use, maintenance, and smithing of any bladed kitchen instrument as well as whetstones, cutting boards, and more!","over18":false},"MPSelectMiniOwners":{"lang":"en","description":"This subreddit is a resource for owners and fans of the MP Select Mini 3D Printer from Monoprice. ","over18":false},"DirtySexyKikPals":{"lang":"en","description":"A place where people can come to exchange their kik information and then message people on kik to trade pics or sext. You can make posts stating what youre looking for or posts saying that youre alway","over18":true},"japanese":{"lang":"en","description":"A subreddit for discovering the people, language, and culture.","over18":false},"houseparty5v5":{"lang":"en","description":"Ever wanted to play like the LCS pros do? Sign up. Join a team. Play against other teams every week for a chance at glory.\n\nHouseparty Premier Esports is a North American organization hosting free tou","over18":false},"ITRPCommunity":{"lang":"en","description":"The out of character hub for the roleplaying subreddit \"Iron Throne RP.\" Here, character applications, biographies, rules, important information, and OOC discussions can be found. ","over18":false},"windowshots":{"lang":"en","description":"Windowshots is a place for redditors to give each other a brief glimpse into each other's lives. Where do you reddit from? If you looked up from your desk, what would you see? Well, grab your camera a","over18":false},"TransDIY":{"lang":"en","description":"Unmoderated trans info/questions/etc...","over18":true},"LittleWitchAcademia":{"lang":"en","description":"Subreddit for the anime Little Witch Academia.","over18":false},"PaleMUA":{"lang":"en","description":"This sub is intended to help those with milkier, more ivory complexions who are interested in makeup. \n\nPost your selfies, your favorites, your rants, your tips and tricks. \n\n","over18":false},"motivation":{"lang":"en","description":"","over18":false},"Upskirt":{"lang":"en","description":"Posed Upskirt goodness!","over18":true},"algotrading":{"lang":"en","description":"A place for redditors/serious people to discuss quantitative trading, statistical methods, econometrics, programming, implementation, automated strategies and bounce ideas off each other for construct","over18":false},"KratomKorner":{"lang":"en","description":"Welcome to Kratom Korner (Catchy huh?), your place for everything Kratom related except for vendor talk since reddit threatened to close this and other subs down if it persisted. ","over18":false},"truerateme":{"lang":"en","description":"The purpose of this sub is to provide accurate and objective ratings for individuals, adhering to redpilled ideologies. \n\nThe ratings follow a rating system developed by people who are more interested","over18":false},"Pictures":{"lang":"en","description":"Tired of /r/pics? That's ok we are too.","over18":false},"slavs_squatting":{"lang":"en","description":"no description needed, slavs gonna slav","over18":false},"Diablo3XboxOne":{"lang":"en","description":"Community for Diablo 3 players on Xbox One.\n\n","over18":false},"ambientmusic":{"lang":"en","description":"A subreddit for fans of [ambient music](http://en.wikipedia.org/wiki/Ambient_music), and all its sub-genres. ","over18":false},"IndustrialDesign":{"lang":"en","description":"","over18":false},"multicopterbuilds":{"lang":"en","description":"Get build guidance for building and upgrading multicopters","over18":false},"netsecstudents":{"lang":"en","description":"Subreddit for students or anyone studying Network Security. This is the place to ask questions regarding your netsec homework, or perhaps you need resources for certain subjects, either way you'll fin","over18":false},"i3wm":{"lang":"en","description":"Official FAQ subreddit for the i3 window manager and its popular fork i3-gaps.","over18":false},"gaaaaaaayyyyyyyyyyyy":{"lang":"en","description":"","over18":false},"Rapekink":{"lang":"en","description":"Discussion and sharing of fetishes, fantasies, and real life play involving rape, ravishment, humiliation, violent sex, and consensual non-consent.","over18":true},"Mindfulness":{"lang":"en","description":"","over18":false},"gnome":{"lang":"en","description":"","over18":false},"ClickerHeroesRecruit":{"lang":"en","description":"Join or advertise your Clicker Heroes clan here!","over18":false},"TheHandmaidsTale":{"lang":"en","description":"The Handmaid's Tale","over18":false},"maschine":{"lang":"en","description":"A place for discussion of the various Maschine controllers, Maschine software, MPCs, and anything else with tappy pad triggers. Self Promotion is highly encouraged--good, bad, done or not, it doesn't ","over18":false},"motocamping":{"lang":"en","description":"A sub for discussing gear and techniques, posting pictures, and talking about all topics motocamping related.","over18":false},"transit":{"lang":"en","description":"A subreddit for discussion on transit systems and transportation all over the world: including buses, trains, trams, streetcars, bicycles, etc. Also relevant are transportation planning, transportatio","over18":false},"harmonica":{"lang":"en","description":"","over18":false},"highseddit":{"lang":"en","description":"[](http://www.reddit.com/r/highseddit/comments/251dd8/faq_before_you_post/)Self improvement and seduction relevant to high school.","over18":false},"hammer":{"lang":"en","description":"This subreddit is meant for everything around the mapping tool Hammer. Here you can post questions, get feedback, help others, or simply brag about your work!","over18":false},"musicians":{"lang":"en","description":"","over18":false},"EU_RCSources":{"lang":null,"description":"Subreddit no longer exists","over18":null},"KhaZixMains":{"lang":"en","description":"A League of Legends sub for Kha'Zix to discuss builds and strategies in the ever changing meta. ","over18":false},"MilitaryStories":{"lang":"en","description":"A place to share and contribute all the true military stories you have.","over18":false},"SpaceXMasterrace":{"lang":"en","description":"A subreddit for the great Space X masterrace to discuss the words of EloN and his Glorious company Space X","over18":false},"f7u12_ham":{"lang":"en","description":"The best of the worst rage comics from f7u12. Everything we remove from there goes here.","over18":false},"LoLGaymers":{"lang":"en","description":"","over18":false},"that_Poppy":{"lang":"en","description":"Poppy is a PC Music emulating pop artist signed to Mad Decent ,after her contract to Island Records concluded. She's active both as a youtube personality, and as a musician. Her videos are always in p","over18":false},"Battlegrounds":{"lang":"en","description":"A place to discuss historic Battles and Tactics.","over18":false},"TronMTG":{"lang":"en","description":"A subreddit dedicated to the best deck in Magic, or at least Urza's favorite.","over18":false},"nsfwasmr":{"lang":"en","description":"","over18":true},"aiclass":{"lang":"en","description":"A discussion forum for the \"Introduction to  Artificial Intelligence\" class at www.ai-class.com.","over18":false},"H3VR":{"lang":"en","description":"Official subreddit for the VR game *Hotdogs Horseshoes & Hand Grenades*!","over18":false},"lightshope":{"lang":"en","description":"An emulation project dedicated to recreating the experience of legacy World of Warcraft content - one expansion at a time. Visit us at https://lightshope.org","over18":false},"stateball":{"lang":"en","description":"For United States Internal Affair Comics.\n\nWe are building this subreddit for all you true Americans out there that want to create US State-based comics in peace. No foreigners will judge you for your","over18":false},"ImpracticalJokers":{"lang":"en","description":"Welcome to /r/ImpracticalJokers, the subreddit for the hidden camera show on TruTV/Comedy Central!","over18":false},"incest_relationships":{"lang":"en","description":"This community is a safe space for users who wish to discuss incest, share experiences, or receive advice/support regarding incest. This is **NOT** a subreddit for erotica, porn, or roleplaying.","over18":false},"KSU":{"lang":"en","description":"","over18":false},"whatsbotheringyou":{"lang":"en","description":"We're a subreddit that you can talk to about anything that makes you unhappy or bothers you. You talk. We'll listen.","over18":false},"Argaming":{"lang":"es","description":"","over18":false},"FuckMarryOrKill":{"lang":"en","description":"Helo friends Welcome to FuckMarryOrKill if you like this subreddit please subscribe and let your friends know \n\nMany thanks","over18":true},"ArenaFPS":{"lang":"en","description":"A sub for anything to do with arena fps games (eg. Quake and Unreal Tournament)\n","over18":false},"Korn":{"lang":"en","description":"The subreddit dedicated to the band Korn. Since 1993.","over18":false},"enderal":{"lang":"en","description":"Enderal is a total conversion for TES V: Skyrim: a game modification that is set in its own world with its own landscape, lore and story. It offers an immersive open world, all for the player to explo","over18":false},"thedonald":{"lang":"en","description":"Do Whatever you want I don't care","over18":false},"sticker":{"lang":"en","description":"The Reddit community where enthusiasts and artists can display their art for a larger audience.","over18":false},"DessertPorn":{"lang":"en","description":"Cakes, pies, ice cream, brownies, cookies, cupcakes, and even breakfast foods that are sweet (pastries, pancakes, waffles...). Eating them is great, but desserts are also delicious to look at. Post yo","over18":false},"MinecraftOne":{"lang":"en","description":"A subreddit dedicated to Minecraft on the Xbox One.","over18":false},"MacroPorn":{"lang":"en","description":"High quality images of macro photography.","over18":false},"ThePopcornStand":{"lang":"en","description":"","over18":false},"braces":{"lang":"en","description":"","over18":false},"biggestproblem":{"lang":"en","description":"The Biggest Problem In the Universe: A Comprehensive List Of All The Problems In The Universe In Order","over18":false},"Chinese":{"lang":"en","description":"/r/Chinese - For Chinese culture and language enthusiasts to share and learn Mandarin. Come and learn Chinese!","over18":false},"gfur":{"lang":"en","description":"Gay Furry Porn","over18":true},"aurora":{"lang":"en","description":"Aurora is a 4X space simulation game that rewards patience.  Difficult to learn and slow to play, this is a game well-suited to people who like deep strategy and don't mind poor UI.","over18":false},"LibertarianDebates":{"lang":"en","description":"","over18":false},"AtlantaTV":{"lang":"en","description":"Atlanta is an American single-camera comedy tv series created by Donald Glover (Childish Gambino) who is also starring. The series is about two cousins in the Atlanta rap scene. The second season, tit","over18":false},"XTerra":{"lang":"en","description":"Reddit community for Nissan Xterra owners, tinkers and enthusiasts.","over18":false},"bad_religion":{"lang":"en","description":"Religion is the cause of all wars? Islam hasn't changed since the Middle Ages? Christianity is defined only by the bible? Hinduism=DAE Caste? If you see someone saying any of these things, post them h","over18":false},"BitcoinCA":{"lang":"en","description":"Let's talk about Bitcoin in Canada","over18":false},"logophilia":{"lang":"en","description":"Logophilia is a prime subreddit for novel words and the lovers of words.","over18":false},"telltale":{"lang":"en","description":"","over18":false},"vertical":{"lang":"en","description":"r/Vertical is a subreddit dedicated to the posting of vertical comics.","over18":false},"japanesemusic":{"lang":"en","description":"Let's talk Japanese music. The goal is to be as far-reaching as possible, so that we can all share in our knowledge of the best music that Japan has to offer. Maybe you're a fan of classic rock? Or hi","over18":false},"SexPositive":{"lang":"en","description":"","over18":true},"DesignatedSurvivor":{"lang":"en","description":"A subreddit dedicated to the ABC television show *Designated Survivor*, an American political drama television series created by David Guggenheim, starring Kiefer Sutherland.\n\nThe series follows a low","over18":false},"AskGameMasters":{"lang":"en","description":"This subreddit is for Game Masters (GM's) of Tabletop RPG's. It's for advice and questions, newbies and wizened old grognards, and anyone (or anything) in between.  \n  \nWe are visited by GM's of many ","over18":false},"deeptown":{"lang":"en","description":"Deep Town is a science fiction strategy game where you play as an AI, with a sole purpose to Mine, Craft and Replicate.\nOn your journey you will construct underground buildings, invent tools, explore ","over18":false},"Roll20":{"lang":"en","description":"Roll20 is an online way to play pen and paper games, including tabletop RPGs like D&D, Pathfinder, GURPS, FATE, 3.5E -- anything!\n\nAll civil discussion about Roll20 is invited! RPG's, board games, and","over18":false},"Destiny_2":{"lang":"en","description":"Welcome! Please read the rules before posting. This is a pretty relaxed community. Lets try and keep it that way.","over18":false},"armadev":{"lang":"en","description":"A subreddit created specifically for the arma series mission editing and development. ","over18":false},"RiotFreeLoL":{"lang":"en","description":"RiotFreeLoL, a Subreddit 100% free of Riot Games' influencing touch. You'll find no corporate sponsors behind us, no babying, no dilemmas. Welcome home.","over18":false},"FemdomCommunity":{"lang":"en","description":"Welcome. This is a place for dominant women, and the men and women who get butterflies around them, to discuss anything related to Femdom. It is not a personals site, nor a place to swap graphic image","over18":true},"ProjectReality":{"lang":"en","description":"This subreddit is devoted to the Project Reality modification for DICE's Battlefield 2.","over18":false},"RealTimeStrategy":{"lang":"en","description":"Real-Time Strategy (RTS) game news and discussion.","over18":false},"queen":{"lang":"en","description":"","over18":false},"Innie":{"lang":"en","description":"A subreddit for girls with \"Innies\".\n","over18":true},"VHS":{"lang":"en","description":"Do you trip over a stack VHS tapes in the morning? Do you look through bins of old movies at the thrift store? Do you have a VCR connected to your HDTV? You're in the right place.\n","over18":false},"lifeofnorman":{"lang":"en","description":"A remarkably unimportant individual. ","over18":false},"Torontoevents":{"lang":"en","description":"","over18":false},"Digibro":{"lang":"en","description":"I'm Digibro and I make a bunch of web content. People ask me a lot of questions and I share a lot of opinions on various websites and it's all basically a disorganized clusterfuck, so I thought I'd tr","over18":false},"SelfSufficiency":{"lang":"en","description":"","over18":false},"streetlightmanifesto":{"lang":"en","description":"","over18":false},"reggae":{"lang":"en","description":"","over18":false},"Toriko":{"lang":"en","description":"A subreddit for fans of Mitsutoshi Shimabukuro's manga and anime **Toriko**.\n\nFeel free to share anything related to Toriko. Be it new manga scanlations, fan art, figurine releases or mouth watering r","over18":false},"starcraft2_class":{"lang":"en","description":"","over18":false},"BBW_Chubby":{"lang":"en","description":"\n\nA Community for BBW-Chubby Lovers. \n\n\nPlease no Spam or hateful comments.\n\nPlease post only if you love Chubby Girls!","over18":true},"Cockatrice":{"lang":"en","description":"Looking to play Magic: the Gathering, but there's no one at your local shop? On a budget that can't support MTGO right now? Want to see how your new deck will perform **right now?** \n\nCome check out C","over18":false},"PokemonGoChi":{"lang":"en","description":"The Official Pokemon GO users for Chicago and surrounding areas","over18":false},"appstate":{"lang":"en","description":"","over18":false},"OccupationalTherapy":{"lang":"en","description":"Reddit's Occupational Therapy (OT) subreddit. This space is for all the OT's, people who have had OT or anyone who loves an OT.","over18":false},"AutoCAD":{"lang":"en","description":"A great place to ask questions, give tips, and share knowledge all about AutoCAD.  ","over18":false},"WarplanePorn":{"lang":"en","description":"A subreddit for the appreciation of things that fly without registration.","over18":false},"GTAV_Cruises":{"lang":"en","description":"GTAV Cruises, The largest online cruising community of GTAV. ","over18":false},"TheFrontBottoms":{"lang":"en","description":"For fans of the band The Front Bottoms. ","over18":false},"TalesofFatHate":{"lang":null,"description":"Subreddit no longer exists","over18":null},"gifextra":{"lang":"en","description":"This subreddit is devoted to GIFs that have things added to them, or edited. ","over18":false},"Augusta":{"lang":"en","description":"**What's happening in Augusta, Georgia and the metro area  ─ News stories, events, community discussions and the various goings-on in the CSRA.**","over18":false},"ucr":{"lang":"en","description":"News & discussion about the University of California, Riverside: It's students, faculty, alumni, and the surrounding Inland Empire community. Use Old Reddit for a more complete experience if you're cu","over18":false},"PastAndPresentPics":{"lang":"en","description":"Hilarious and Awesome Re-Enacted Pics\n\nRecreated Photographs \n\nInteresting Photos Years Later\n\nThen and Now\n\nBefore and After \n\nYoung Me Now Me\n\nYou get the picture! ","over18":false},"gnomoria":{"lang":"en","description":"A subreddit to the currently in-development game, Gnomoria! Share stories, ask questions, suggest improvements, and spread the love.","over18":false},"ShovelKnight":{"lang":"en","description":"[Shovel Knight](http://www.kickstarter.com/projects/yachtclubgames/shovel-knight) is an amazing game developed by [Yacht Club Games](http://yachtclubgames.com/).","over18":false},"rebirthwow":{"lang":"en","description":"rebirth vanilla wow community extension","over18":false},"SMITEGODCONCEPTS":{"lang":"en","description":"Come and post all your mythical ideas for /r/Smite Gods here! Create your own diety and share ideas with others!","over18":false},"Slackline":{"lang":"en","description":"Everything Slacklining - Post pictures, trip reports, rigging ideas, or any questions you may have. /r/Slackline is an open and moderated community. Join us!","over18":false},"OldSchoolCoolNSFW":{"lang":"en","description":"","over18":true},"bikinis":{"lang":"en","description":"","over18":true},"gaystoriesgonewild":{"lang":"en","description":"Gone private for a while. For a better Reddit. For Victoria. Check back later.","over18":true},"curiosityrover":{"lang":"en","description":"A subreddit to follow the progress of NASA's Curiosity Rover on Mars.","over18":false},"wincest":{"lang":"en","description":"Win + Incest = Wincest.\n\nIncest-themed captions on nsfw/sexy images.","over18":true},"bookshelf":{"lang":"en","description":"","over18":false},"ItalyInformatica":{"lang":"it","description":"Il panorama informatico italiano","over18":false},"ChicagoSuburbs":{"lang":"en","description":"News, events and discussions from the suburbs of Chicago, including Cook, DuPage, Kane, Kendall, Lake, McHenry and Will counties in Illinois, LaPorte, Lake and Porter counties in Indiana, and Kenosha ","over18":false},"BALLET":{"lang":"en","description":"","over18":false},"melodicdeathmetal":{"lang":"en","description":"Melodic death metal is a heavy metal music style that combines elements from the new wave of British heavy metal with elements of death metal. The term Gothenburg metal is often used to describe bands","over18":false},"The_Farage":{"lang":"en","description":"/r/The_Farage is the best subreddit of the british god man himself.","over18":false},"brownbeauty":{"lang":"en","description":"This is a subreddit for makeup addicts of a darker coloring. As hard as it is to find quality products for darker skinned ladies and gents, let's help each other!\n\nPost tips, finds, hauls, questions, ","over18":false},"catsthegame":{"lang":"en","description":"Discussions about mobile game CATS: Crash Arena Turbo Stars - created by ZeptoLabs","over18":false},"SteamMonsterGame":{"lang":"en","description":"For discussion of the Steam Summer Sale 2015 Monster Minigame","over18":false},"DragonAgeCoOp":{"lang":"en","description":"A community of fans and players of Dragon Age Multiplayer (DAMP).","over18":false},"HugeDickTinyChick":{"lang":"en","description":"Huge dicks in and around tiny chicks.","over18":true},"gog":{"lang":"en","description":"GOG.com is a DRM-free games and movies distribution service that is part of the CD Projekt Group. GOG.com is also a \"sister\" company to CD Projekt Red, developers of the Witcher series and the upcomin","over18":false},"Shoestring":{"lang":"en","description":"A community to discuss frugal travelling, last-minute travel deals, cheap destinations, and cheap means of travel. Whether couchsurfing, camping, or staying in hostels, whether hitchhiking or staying ","over18":false},"CRedit":{"lang":"en","description":"CRedit's main goal is to improve your credit, keep it healthy, and support you in decisions that you make that may affect your credit livelihood. \n\nWe are here to support you if you need an advice on ","over18":false},"sabaton":{"lang":"en","description":"War-themed Swedish Heavy Metal with historical lyrics","over18":false},"selfie":{"lang":"en","description":"Photograph of Yourself, Taken By Yourself","over18":false},"OsuSkins":{"lang":"en","description":"The osu! sub for all your skinning needs.","over18":false},"WarhammerCompetitive":{"lang":"en","description":"This subreddit is for posting lists for the purpose of receiving comments and criticism with an eye on being competitive, both in local metas and in tournament play, discussing the current tournament ","over18":false},"Vent":{"lang":"en","description":"Vent your frustrations! This sub is for redditors who need a way of getting out their feelings.","over18":false},"Inglip":{"lang":"en","description":"A subreddit for worshippers of the Dark Lord Inglip. And his proxy while he is away, Troll Lord Pprodev.","over18":false},"AustralianMFA":{"lang":"en","description":"G'day!\nFashion advice for blokes, from any mate. This subreddit is a place to post sales, ask for advice, share useful tips and all that jazz as long as it pertains in general to menswear in Australia","over18":false},"RussiaLago":{"lang":"en","description":"This is a subreddit focused on discussing all aspects of collusion between Trump and Russia. Valid topics include the latest news, your theories or research, and even rumors. ","over18":false},"comedynecromancy":{"lang":"en","description":"\"Why did the Chicken Cross the road?\"\n\nTo escape Adam Ellis.","over18":false},"getnarwhal":{"lang":"en","description":"narwhal, an iOS app for reddit. feature requests, bug reports, support, and friendship await. **getnarwhal.com**  –🐳","over18":false},"steamsaledetectives":{"lang":"en","description":"There's a bit of mystery around the Steam 2015 Holiday Sale. Post your clues and crack the case!","over18":false},"TheHearth":{"lang":"en","description":"TheHearth is a community for discussions related to Hearthstone. Come and join us by the hearth!","over18":false},"boogie2988":{"lang":"en","description":"This is a subreddit dedicated to the community of folks who have sprung up around youtuber Boogie2988.  Share your pics, stories, links to videos, favorite videos, and more. :)","over18":false},"FifaUTCoins":{"lang":"en","description":"Buy Sell and Trade your coins or players for Fifa here!\n\n","over18":false},"sheffield":{"lang":"en","description":"A subreddit for and about Sheffield.  ","over18":false},"DJsCirclejerk":{"lang":"en","description":"Please get better,  I am losing hope. ","over18":false},"dancarlin":{"lang":"en","description":"","over18":false},"PietSmiet":{"lang":"de","description":"Alles rund um PietSmiet: Diskussionen, Bilder, GIFs, & viel mehr!","over18":false},"rolex":{"lang":"en","description":"Sharing information and appreciation for Rolex & Tudor watches.","over18":false},"infamous":{"lang":"en","description":"","over18":false},"playrustservers":{"lang":"en","description":"Everything related to rust servers! Advertisements, Discussion, and Administration\n\nOfficial subreddit: /r/playrust","over18":false},"Dragonballsuper":{"lang":"en","description":"Discuss news and excitement about Dragonball Super.","over18":false},"MinecraftCirclejerk":{"lang":"en","description":"","over18":false},"hutcoinsales":{"lang":"en","description":"A subreddit for selling/buying HUT cards/coin, using real money","over18":false},"Themepark":{"lang":"en","description":"amusement parks, rides, & attractions, rollercoasters, theme parks, coasters","over18":false},"yesyesyesyesno":{"lang":"en","description":"This subreddit is pretty simple: things that are great before they go bad. *Almost* perfect isn't it, it's about acts nearing spectacular fruition right before their ruin. So basically the Seattle Sea","over18":false},"lingerie":{"lang":"en","description":"","over18":true},"EndlessSpace":{"lang":"en","description":"The subreddit for fans of the game Endless Space.\n  \nPost your stories, news, and screenshots here!\n  ","over18":false},"katyperry":{"lang":"en","description":"A subreddit for fans of Katy Perry.","over18":false},"badcode":{"lang":"en","description":"A place for the very worst code you've ever laid your eyes on. All languages welcome! *(minus esoteric ones)*","over18":false},"Instantregret":{"lang":"en","description":"","over18":false},"scifiwriting":{"lang":"en","description":"","over18":false},"shockwaveporn":{"lang":"en","description":"A subreddit dedicated to GIF. video and pictures of shockwaves\n\nWarning : \n\nSome of the content in this subreddit contain death and injury, so be aware of that as you browse. We leave it up to the pos","over18":false},"gilf":{"lang":"en","description":"50 60 years old, plus.... grey haired beauties, experienced lovers, demure grandmas to the world, uninhibited liberated women to reddit.","over18":true},"IKEA":{"lang":"en","description":"A subreddit dedicated to the Swedish furniture store started by Ingvar Kamprad in a small town called Almhult that now spans the globe. ","over18":false},"Quakecon":{"lang":"en","description":"QuakeCon is a yearly convention held by ZeniMax Media to celebrate and promote the major franchises of id Software and other studios owned by ZeniMax.","over18":false},"Nexus9":{"lang":"en","description":"","over18":false},"RateMyAudio":{"lang":"en","description":"This subreddit is for the evaluation of audio work; editing, mixing, mastering, composing, and any other facet of creating great sound.  Only the person who did the work may submit it for evaluation.\n","over18":false},"sodadungeon":{"lang":"en","description":"A soda-guzzling RPG/Dungeon crawler available on iOS, Android, and Steam!","over18":false},"castlevania":{"lang":"en","description":"A sub-reddit for the well known video game series [Castlevania](http://en.wikipedia.org/wiki/Castlevania)","over18":false},"kateupton":{"lang":"en","description":"","over18":false},"DesignJobs":{"lang":"en","description":"[](/sidebar)","over18":false},"Umphreys":{"lang":"en","description":"For Fan's of Umphrey's McGee ","over18":false},"DailyTechNewsShow":{"lang":"en","description":"Home of the Daily Tech News Show","over18":false},"raisingkids":{"lang":"en","description":"Raising Kids is a community for those interested in insightful articles, reddiquette, reading before voting and intelligent respectful discussion on the topic of parenting and raising children.\n\nThis ","over18":false},"NavCoin":{"lang":"en","description":"NavCoin is a decentralized cryptocurrency that uses peer-to-peer technology to operate with no central authority or banks; managing transactions and the issuing of NavCoin is carried out collectively ","over18":false},"bitfinex":{"lang":"en","description":"Bitfinex is the worlds largest & most advanced cryptocurrency exchange.","over18":false},"Heroes_Charge":{"lang":"en","description":"A place for the developers and players of Heroes Charge to come together and ask questions, review content and create a great community.","over18":false},"U2Band":{"lang":"en","description":"A subreddit dedicated to the Irish band U2","over18":false},"facedownassup":{"lang":"en","description":"Girls with their face down ass up.","over18":true},"AustralianShepherd":{"lang":"en","description":"Welcome to /r/australianshepherd. All Aussies are welcome. If you have a mixed breed who you believe is part aussie, this includes you. Since Mini American Shepherds (mini Aussies) are now recognized ","over18":false},"JudgeMyAccent":{"lang":"en","description":"Upload a sound file of you talking in a language you're learning and post it in this subreddit. Native speakers of this particular language will tell you how to improve your accent.\n","over18":false},"ents":{"lang":"en","description":"","over18":false},"atheismplus":{"lang":"en","description":"It's atheism, [plus a whole lot more](http://freethoughtblogs.com/blaghag/2012/08/atheism/).","over18":false},"wireless":{"lang":"en","description":"","over18":false},"hoarding":{"lang":"en","description":"Since compulsive hoarding is often a \"secret\" to people outside immediate family and embarrassing, sometimes it's hard to really discuss the problem.\n\nFeel free to share and exchange stories, accompli","over18":false},"modclub":{"lang":"en","description":"A subreddit for moderators to discuss moderation things","over18":false},"Chennai":{"lang":"en","description":"","over18":false},"Kiteboarding":{"lang":"en","description":"Everything about Kitesurfing and Kiteboarding","over18":false},"Moustache":{"lang":"en","description":"","over18":false},"simcity4":{"lang":"en","description":"","over18":false},"Svenska":{"lang":"en","description":"**Ask questions, and share links and encouragement for learning Swedish!**","over18":false},"YouTube_startups":{"lang":"en","description":"This subreddit is to help young YouTube channels get a good start.  You can also meet fellow youtubers  and try to help each other out.","over18":false},"JiffyBot":{"lang":"en","description":"A home for JiffyBot, the GIF creating bot! :D","over18":false},"puppies":{"lang":"en","description":"Nothing but puppies! No cats allowed.","over18":false},"xcom2mods":{"lang":"en","description":"Subreddit for XCOM 2 mods","over18":false},"Unitale":{"lang":"en","description":"Ever wanted to make an Undertale thing but didn't want to set up the extensive basics required? You've come to the right place! We're working on an Undertale-based engine in Unity 5 so you can make yo","over18":false},"enfj":{"lang":"en","description":"A friendly forum for those of the ENFJ personality type.","over18":false},"ketochow":{"lang":"en","description":"Place to discuss Keto Chow, which is an ultra low-carb meal replacement shake - think melted ice cream, but for keto!","over18":false},"atmidnight":{"lang":"en","description":"**Come here to talk about @midnight, the cancelled Comedy Central show**\n\n@midnight aired Monday - Wednesday @11:30 and at midnight on Thursday on Comedy Central. ","over18":false},"daydream":{"lang":"en","description":"Daydream is a virtual reality platform introduced by Google at Google I/O 2016.","over18":false},"FreeKarma4U":{"lang":"en","description":"We get it, getting karma points on Reddit can be extremely tricky. That's why we're here! We are a collection of Redditors who will, well, upvote stuff! Post a picture, a joke, an interesting article,","over18":false},"SmashingPumpkins":{"lang":"en","description":"A subreddit dedicated to the American rock band Smashing Pumpkins!","over18":false},"HighHeels":{"lang":"en","description":"Welcome to HighHeels!\n\nThis sub is dedicated the the love and appreciation of high heeled foot wear. Post heels you like, heels you own, discussion about heels in general.\n","over18":false},"DMB":{"lang":"en","description":"Dave Matthews Band news, discussion and more.","over18":false},"druggardening":{"lang":"en","description":"For people who enjoy both gardening and drugs. A subreddit dedicated to people who have there own drug gardens. Hunting ethnobotanicles is also encouraged. Pictures and discussions. Plants, cactus, mu","over18":false},"quiteinteresting":{"lang":"en","description":"QI stands for *Quite Interesting* and is a hilarious quiz show where the guests get points for giving *interesting* answers. It airs on Fridays and in a longer format (XL)  on Saturdays on BBC Two. ","over18":false},"privacytoolsIO":{"lang":"en","description":"","over18":false},"Psychedelics":{"lang":"en","description":"","over18":false},"vegaslocals":{"lang":"en","description":"A sister subreddit to /r/vegas, for Las Vegas Locals","over18":false},"newhaven":{"lang":"en","description":"Stuff about New Haven. For New Haven.","over18":false},"ironscape":{"lang":"en","description":"Welcome to the OSRS Ironman Community!","over18":false},"kronos2wow":{"lang":"en","description":"Due to Project Kronos merging their two realms into one, the subreddit has been closed. The subreddit moved to /r/KronosWoW.","over18":false},"ting":{"lang":"en","description":"The official Ting subreddit! Discussions on mobile and fixed access in the US, and much more. We appreciate all your suggestions and are here to help in any way we can.","over18":false},"Roleplay":{"lang":"en","description":"/r/Roleplay is a creative writing community where you can search for a partner or group to collaborate on writing a story.","over18":false},"SoCalR4R":{"lang":"en","description":"R4R - The Southern California edition\n\nWhether you're seeking platonic friends, non-platonic friends, online gaming partners, soulmates, travel mates, ride shares, hikers, concert partners, clubs, exp","over18":false},"mhguildquests":{"lang":"en","description":"A subreddit dedicated to sharing guild quests amongst each-other in MH4U.","over18":false},"hamptonbrandon":{"lang":"en","description":"The Official subreddit of Hampton Brandon","over18":false},"soapmaking":{"lang":"en","description":"/r/soapmaking is a place to share your soap making tips and tricks, links to cool techniques, ask soaping related questions or just fun new soap designs you've found or created.  Share your stories of","over18":false},"LadiesofScience":{"lang":"en","description":"\"Nothing in life is to be feared, it is only to be understood.\" Marie Curie\n\nA subreddit for women who work in, about or around science (or would like to). Field-related questions, scientific discussi","over18":false},"BotanicalPorn":{"lang":"en","description":"High quality images of plants (fungi are allowed!).","over18":false},"EditingAndLayout":{"lang":"en","description":"","over18":false},"DolphinEmulator":{"lang":"en","description":"Subreddit for the GameCube and Wii emulator Dolphin.","over18":false},"LGBTrees":{"lang":"en","description":"like r/trees, but queerer","over18":false},"whisky":{"lang":"en","description":"A place to discuss all things Whisky. ","over18":false},"AlphaBay":{"lang":"en","description":"This is the subreddit of AlphaBay, a Darknet market launched in late 2014 and seized July 2017 after a joint task force raid, specializing in drugs and fraudulent items. Bitcoin and monero and escrow ","over18":true},"latvia":{"lang":"lv","description":"Everything Latvia related","over18":false},"AngieVaronaLegal":{"lang":"en","description":"Now this Internet sensation is 18 it's totally legal. Let's start this again. This is the Angie Varona appreciation site. \nNO ILLEGAL CONTENT ALLOWED\nI hereby pass on any legal responsibities to you, ","over18":false},"DestroyedTanks":{"lang":"en","description":"Images and footage of destroyed military vehicles","over18":false},"DanceDanceRevolution":{"lang":"en","description":"A subreddit where people can discuss Dance Dance Revolution, post videos, DDR news, achievements, records, tournaments, etc.","over18":false},"Telegram":{"lang":"en","description":"a new era of messaging","over18":false},"AQW":{"lang":"en","description":"A subreddit dedicated to the MMORPG AdventureQuest Worlds.\n\nBattle On!","over18":false},"twilightimperium":{"lang":"en","description":"r/Twilight Imperium is a subreddit dedicated to Fantasy Flight Games' flagship title, Twilight Imperium. We discuss strategies, rules, variants, and give advice to new players.\n\nJoin us in the war for","over18":false},"UnexplainedPhotos":{"lang":"en","description":"Welcome to UnexplainedMedia, a subreddit that has grown out of UnexplainedPhotos where users can post photos, audio and video that defy explanation. \n\nSometimes media such as photos and video are link","over18":false},"pewdiepie":{"lang":"en","description":"This is a fanmade PewDiePie subreddit. Come by to talk, find info related to pewds, and to look at more memes.","over18":false},"damngoodinterracial":{"lang":"en","description":"","over18":true},"MMJ":{"lang":"en","description":"The subreddit for medical marijuana information.","over18":false},"hwatch":{"lang":"en","description":"One stop shop for all your Huawei Watch news and discussions","over18":false},"drawme":{"lang":"en","description":"","over18":false},"summoners":{"lang":"en","description":"League of Legends is a free-to-play action RTS/MOBA video game developed and published by [Riot Games](http://www.riotgames.com/).\n\nGet the latest news on game changes and tournaments, read up on in-d","over18":false},"TsundereSharks":{"lang":"en","description":"We must collect all of the images or gif animations (potentially modified and captioned for anime goodness) of Sharks acting Tsundere, because we can. D:","over18":false},"prochoice":{"lang":"en","description":"The Pro-Choice Subreddit","over18":false},"AsheronsCall":{"lang":"en","description":"A community for the people of Dereth.","over18":false},"poi":{"lang":"en","description":"This subreddit is dedicated to spinning \"poi\" and related subjects: A place for videos, pictures, tutorials, posting questions, and pretty much anything else poi related. Welcome!","over18":false},"YAlit":{"lang":"en","description":"Young Adult Literature\n\n\n","over18":false},"GayBroTeens":{"lang":"en","description":"The gay bros of the future!","over18":false},"hitchhiking":{"lang":"en","description":"Good information for the nomadic vagabonds out there. Not just limited to hitchhiking. Trainhopping, destinations, stories, etc. also welcome.","over18":false},"troubledteens":{"lang":"en","description":"A basecamp to share news, experiences and actions to save kids from institutional child abuse.","over18":false},"untildawn":{"lang":"en","description":"","over18":false},"OhioStateFootball":{"lang":"en","description":"","over18":false},"genetics":{"lang":"en","description":"For discussion of genetics research (all organisms welcome), case studies/medical genetics, ethical issues, questions for geneticists, etc.","over18":false},"FurryArtSchool":{"lang":"en","description":"","over18":false},"bash":{"lang":"en","description":"A subreddit dedicated to bash scripting.","over18":false},"softies":{"lang":"en","description":"Softies is a subreddit for those who like, admire and wish to share their enjoyment of the flaccid penis..or \"softie\". All body types, shapes and sizes are welcome here. So come on in and enjoy the fl","over18":true},"leanfire":{"lang":"en","description":"For those that want to approach the problem of financial independence from a minimalist, stoic, frugal, or anti-consumerist trajectory.","over18":false},"Rottweiler":{"lang":"en","description":"Everything Rottweiler related including health, temperament, training, and pictures. \n\nThis is not the place to look for a stud for your dog, stud your dog out, to look for dogs to breed or to sell do","over18":false},"NoGameNoLife":{"lang":"en","description":"This is the subreddit for the light novel and anime series, No Game No Life!","over18":false},"stevedangle":{"lang":"en","description":"A subreddit all about Steve Dangle!","over18":false},"TheNational":{"lang":"en","description":"The #1 location for news, discussion, links, and everything related to indie rock band The National! \n\n","over18":false},"Spearfishing":{"lang":"en","description":"","over18":false},"shortstories":{"lang":"en","description":"Original short stories or links to other works. ","over18":false},"DkS3Builds":{"lang":"en","description":"Dark Souls 3 builds!","over18":false},"ImaginaryLeviathans":{"lang":"en","description":"Art featuring giant creatures of the sea or sky.","over18":false},"kravmaga":{"lang":"en","description":"For discussion about Krav Maga. Advice, help finding a gym, and sharing stories.","over18":false},"electrical":{"lang":"en","description":"","over18":false},"NeverTrump":{"lang":"en","description":"With Donald Trump as President of the United States, this subreddit is now an accountability movement.","over18":false},"BlackwakeGame":{"lang":"en","description":"","over18":false},"Nightshift":{"lang":"en","description":"","over18":false},"ReadMyScript":{"lang":"en","description":"","over18":false},"TNA":{"lang":"en","description":"Anthem's Impact Wrestling","over18":false},"Halo4":{"lang":"en","description":"/r/Halo4 is the official Halo4 subreddit for the newest Halo game in the franchise!","over18":false},"paydaybuilds":{"lang":"en","description":"A forum for discussing and analyzing builds for Payday 2.","over18":false},"SantaBarbara":{"lang":"en","description":"The Santa Barbara, California Reddit community.","over18":false},"moviecritic":{"lang":"en","description":"A subreddit for movie reviews and discussions\n","over18":false},"OverwatchHeroConcepts":{"lang":"en","description":"Overwatch Hero Concepts","over18":false},"GifTournament":{"lang":"en","description":"GifTournament is a friendly gif bracket where some of reddit's best gif creators get together to go head to head with one another \n\n","over18":false},"nope":{"lang":"en","description":"Things that make you say \"nope!\"","over18":false},"AskBattlestations":{"lang":"en","description":"This subreddit is to find help with your battlestation.  We can help you with desks, monitors, design, etc.","over18":false},"Motorrad":{"lang":"en","description":"","over18":false},"rosin":{"lang":"en","description":"Images, reviews, DIY, and all things concerning the cannabis extraction method known as \"Rosin\" or \"Rosin Tech\" ","over18":false},"FantasyLife3ds":{"lang":"en","description":"","over18":false},"Acura":{"lang":"en","description":"","over18":false},"droidturbo":{"lang":"en","description":"A public forum for discussion of Motorola's Droid Turbo and Droid Turbo 2","over18":false},"SluttyStrangers":{"lang":null,"description":"Subreddit no longer exists","over18":null},"learn_arabic":{"lang":"en","description":"This community is primarily for people who are actively trying to learn Arabic. It can also be for discussions of culture, news, etc, in or relating to Arabic and the Arab world. We are a new communit","over18":false},"mizzou":{"lang":"en","description":"","over18":false},"painal":{"lang":"en","description":"","over18":true},"shittyHDR":{"lang":"en","description":"Over saturated, Vibrance all the way up... it's shitty HDR!","over18":false},"penspinning":{"lang":"en","description":"A community for sharing and discussion pen spinning.","over18":false},"writers":{"lang":"en","description":"All are welcome at r/writers: fiction writers, nonfiction writers, bloggers and more! Get critique on your work, share resources, ask questions and help fellow writers.\n\n","over18":false},"openbroke":{"lang":"en","description":"","over18":false},"dayztrade":{"lang":"en","description":"Your headquarters for bartering and trading in DayZ!","over18":false},"listentous":{"lang":"en","description":"r/listentous -- a democracy for music snobs.\n\n\"Listentous is like having the entire musical world curated for you by submitters who really give a damn about music. Just eight tracks a day, but submitt","over18":false},"Fuck2016":{"lang":"en","description":"2016 fucking sucks.","over18":false},"chloegracemoretz":{"lang":"en","description":"For fans of actress Chloë Grace Moretz","over18":false},"TPPcrack":{"lang":"en","description":"This sub is for the discussion of MGSV:TPP cracking.","over18":false},"PushBullet":{"lang":"en","description":"","over18":false},"Bend":{"lang":"en","description":"Subreddit for Bend Oregon local news, meetups, etc.  \n","over18":false},"tuckedinkitties":{"lang":"en","description":"A subreddit for posting pictures of cats tucked into bed. <3","over18":false},"AnthemTheGame":{"lang":"en","description":"Our subreddit discusses BioWare's new game, Anthem: an upcoming online multiplayer action role-playing video game, in which you pilot combat suits known as Javelins in a primeval, alien world. Anthem ","over18":false},"tycoon":{"lang":"en","description":"","over18":false},"Shaboozey":{"lang":"en","description":"A subreddit dedicated to everything Jesse Cox; YouTuber, Streamer, Podcaster, and creator of Good Game, an esports sitcom.","over18":false},"CatSlaps":{"lang":"en","description":"/r/CatSlaps is a subreddit based around cats smashing stuff with their pretty little paws, if you have content related to this, post here!","over18":false},"cumfetish":{"lang":"en","description":"","over18":true},"ACL":{"lang":"en","description":"Anterior Cruciate Ligament injuries: Stories, Tips, and Advice for recovery","over18":false},"Chiropractic":{"lang":"en","description":"This subreddit is for sharing and discussing the good and the bad, including news, about chiropractic care.\n\nThis is NOT a place for you to market your business/product.","over18":false},"jmu":{"lang":"en","description":"A community of current, former and future Dukes!\n","over18":false},"cahideas":{"lang":"en","description":"A place for fans of Cards Against Humanity to submit their own ideas for new cards.","over18":false},"babywearing":{"lang":"en","description":"","over18":false},"BreakUp":{"lang":"en","description":"This is a subreddit for people who've been through a breakup. You're in good company. Talk to us!","over18":false},"YouSeeComrade":{"lang":"en","description":"You see comrade/You see Ivan images.\n","over18":false},"VladimirMains":{"lang":"en","description":"A subreddit for Vladimir resources, strategy, builds, matchup discussion, fanart, etc. ","over18":false},"SocialistRA":{"lang":"en","description":"Never disarm the working class!","over18":false},"gayincest":{"lang":"en","description":"/r/GayIncest is a gay oriented alternative to /r/Incest.\n\nYou're welcome to post gay incest porn, gay incest stories and erotica, and ask for advice regarding anything relating to gay incest.","over18":true},"sharktank":{"lang":"en","description":"Shark Tank -","over18":false},"SkincareAddictionUK":{"lang":"en","description":"A UK focused skincare subreddit. ","over18":false},"AlchemistCodeGL":{"lang":"en","description":"The Alchemist Code [Global] Reddit Community! Now with 200% more Dias!","over18":false},"whereisthis":{"lang":"en","description":"Help users identify a location. ","over18":false},"AskAstrologers":{"lang":"en","description":"A community for asking questions about your birth chart, or astrology in general. ","over18":false},"FinalFantasyXII":{"lang":"en","description":"A subreddit for the Final Fantasy XII video game.","over18":false},"GIMP":{"lang":"en","description":"","over18":false},"Madrid":{"lang":"es","description":"Madrid, Madrid, Madrid.","over18":false},"Spyro":{"lang":"en","description":"","over18":false},"lancaster":{"lang":"en","description":"Local subreddit for the Lancaster, PA area","over18":false},"Smartphones":{"lang":"en","description":"Any news or discussion about today's smartphones and smartphone platforms.","over18":false},"Psybient":{"lang":"en","description":"","over18":false},"Switch":{"lang":"en","description":"/r/Switch : A community for the Nintendo Switch and related interests\n\n","over18":false},"MotionDesign":{"lang":"en","description":"This subreddit is available for artists / designers as a place to share inspiration & ideas, ask questions, and show off their current projects and reels.  No matter what your programs of choice are, ","over18":false},"nottingham":{"lang":"en","description":"A subreddit all about the city of Nottingham! ","over18":false},"crowfall":{"lang":"en","description":"Unofficial community for the upcoming ArtCraft Entertainment MMO \"Crowfall\". Crowfall is a Throne War Simulator best described as a blending of elements from EVE Online, Shadowbane, Game of Thrones an","over18":false},"CriticalTheory":{"lang":"en","description":"Critical theory is a school of thought that stresses the examination and the critique of society and culture by applying knowledge from the social sciences and the humanities.","over18":false},"aaaaaatheismmmmmmmmmm":{"lang":"en","description":"Have you heard about a6theism10?\n\nYou have now. Spread the word!\n\nMade an original rage comic about atheism?\n\nFound one somewhere else?\n\nSubmit it [here!](http://www.reddit.com/r/aaaaaatheismmmmmmmmmm","over18":false},"secondlife":{"lang":"en","description":"A place to post and discuss everything relating to Linden Lab's [Second Life](http://SecondLife.com).","over18":false},"CryptoKitties":{"lang":"en","description":"CryptoKitties is a game centered around breedable, collectible, and oh-so-adorable creatures we call CryptoKitties!","over18":false},"chronotrigger":{"lang":"en","description":"Chrono Trigger community on Reddit. Share and discover cool Chrono Trigger stuff!","over18":false},"Zeos":{"lang":"en","description":"An A/V Recommendations and Advice Subreddit. ","over18":false},"thewholecar":{"lang":"en","description":"We are a community building a searchable database of the most interesting cars in the world. Each post highlights one model at a time, with a full album of quality photography that lets us discover an","over18":false},"darksoulspvp":{"lang":"en","description":"This sub reddit is for official Dark Souls Reddit PVP tournaments, fight clubs and other PVP related events. Submissions are welcome for any and all Souls games!","over18":false},"Vegetarianism":{"lang":"en","description":"Anything related to vegetarian and vegan lifestyle and diet.\n\nKeywords: veg*n, vegan, vegetarian, animal rights, animal welfare, recipes, food, ethical, health, environment, raw, juicing, gardening, o","over18":false},"SpaceNinjasPlsIgnore":{"lang":"en","description":"The Subreddit for the Test Alliance Please Ignore Warframe clan.","over18":false},"Proofreading":{"lang":"en","description":"Free proofreading! No soliciting, no cheating on homework. Include a due date tag.","over18":false},"legs":{"lang":"en","description":"For lovers of nice legs\n\nThis subreddit has a lot of nsfw content","over18":true},"sharks":{"lang":"en","description":"","over18":false},"budgies":{"lang":"en","description":"A subreddit dedicated to all types of Budgerigars.","over18":false},"kittens":{"lang":"en","description":"","over18":false},"missouri":{"lang":"en","description":"The home for all Missourians on reddit. This is the place for anything related to the state of Missouri.   \n  \nkeywords: Missouri, MO, Missourian, KCMO, Kansas City, Columbia, Springfield, St Louis, S","over18":false},"O_Faces":{"lang":"en","description":"\"O\" Faces. Faces of Ecstasy","over18":true},"transformation":{"lang":"en","description":"All things related to Transformation **fantasy fetish art**. This means comics, illustrations, animations or visual effects.","over18":true},"Bulges":{"lang":"en","description":"A subreddit for all those bulge lovers out there!","over18":true},"eos":{"lang":"en","description":"Official Subreddit for EOS: The Blockchain for Commercial Scale","over18":false},"Lenovo":{"lang":"en","description":"Welcome to /r/Lenovo, A place where Lenovo owners and prospective buyers can engage in discussion, solicit advice and post pictures.\n\nThis subreddit is community driven and not affiliated with Lenovo.","over18":false},"mildlyamusing":{"lang":"en","description":"","over18":false},"bookporn":{"lang":"en","description":"High quality images of books.","over18":false},"britpics":{"lang":"en","description":"A subreddit dedicated to photographs of Great Britain.\n\nMember of the /r/NationalPhotoSubs network.","over18":false},"startrekgifs":{"lang":"en","description":"A sub to post gifs that are all things Trek","over18":false},"PressureCooking":{"lang":"en","description":"","over18":false},"capstone":{"lang":"en","description":"A subreddit for students at the University of Alabama in Tuscaloosa to share and discuss.","over18":false},"TheOnion":{"lang":"en","description":"Articles from The Onion.\n\nThis is not /r/nottheonion. Only links to the Onion (and its satirical sister sites) are allowed here.\n\n[ClickHole](http://www.clickhole.com/) and [StarWipe](http://www.starw","over18":false},"kindlefire":{"lang":"en","description":"A public forum for discussion of Amazon's Kindle Fire tablet.","over18":false},"Cosmos":{"lang":"en","description":"A place to discuss the documentary series Cosmos: A Personal Voyage and Cosmos: A Spacetime Odyssey","over18":false},"ContestOfChampionsLFG":{"lang":"en","description":"If you're looking for an Alliance post here. If you want to advertise your alliance, post here.","over18":false},"snooker":{"lang":"en","description":"","over18":false},"NakedProgress":{"lang":"en","description":"NakedProgress was established for adults to share video and photo progress shots. One of the biggest goal is to look and feel better in clothes and without them.","over18":true},"technews":{"lang":"en","description":"Interesting tech news\n\ntechnology\n\n","over18":false},"botwatch":{"lang":"en","description":"Dedicated to the continued interest, observation, discussion, and study of the bots that dwell in reddit.","over18":false},"depression_help":{"lang":"en","description":"A place for mutual support to those with depression, bipolar disorder, SAD, PTSD, etc. This is a safe space, antagonism, bullying, and harrassment will be swiftly dealt with. For one-on-one ang group ","over18":false},"IndieFolk":{"lang":"en","description":"A Subreddit for Indie & Folk music. Feel free to post away!","over18":false},"NaturalBeauty":{"lang":"en","description":"","over18":false},"chickflixxx":{"lang":"en","description":"","over18":true},"firstimpressions":{"lang":"en","description":"This sub is a place where you can find out what impression you give off to total strangers, whether it be good or bad.\n\nPictures, videos or voice recordings are all acceptable, and including a quick b","over18":false},"RyzeMains":{"lang":"en","description":"A subreddit for all Ryze mains from League of Legends. Feel free to discuss builds, plays, art, etc. anything related to Ryze.","over18":false},"mysql":{"lang":"en","description":"Discussion of MySQL and assistance for MySQL related questions","over18":false},"gurrenlagann":{"lang":"en","description":"This subreddit is the home for everything related to Tengen Toppa Gurren Lagann or Gurren Lagann for short!","over18":false},"scaredshitless":{"lang":"en","description":"A scary subreddit for fictional and real life horror. Enjoy if you dare.","over18":true},"calculus":{"lang":"en","description":"","over18":false},"wyoming":{"lang":"en","description":"Reddit's official page for all things related to the State of Wyoming, USA.","over18":false},"BoxingStreams":{"lang":"en","description":"A place to share your boxing streams.","over18":false},"ATV":{"lang":"en","description":"Reddit ATV United! Under one banner with mud, sand, mountains, and snow for all! A place to discuss ATVs, ATV news, and ATV riding.","over18":false},"torrentlinks":{"lang":"en","description":"Links to LEGAL torrents!","over18":false},"theleaguefx":{"lang":"en","description":"This is a place where rules are meant to be broken and a man named Taco is a Genius.","over18":false},"autorepair":{"lang":"en","description":"A subReddit for Auto, Car, and Truck repair questions and discussion","over18":false},"MyCastleFE":{"lang":"en","description":"A subreddit for all Fire Emblem Fates castle events and discussions.","over18":false},"streetart":{"lang":"en","description":"Make art not rules","over18":false},"unrealtournament":{"lang":"en","description":"Unreal Tournament is a series of multiplayer first person shooters made by Epic Games.","over18":false},"latinas":{"lang":"en","description":"Latinas","over18":true},"Pontiac":{"lang":"en","description":"","over18":false},"BitHeroes":{"lang":"en","description":"A forum for discussion regarding the Kongregate game, Bit Heroes","over18":false},"INeedAName":{"lang":"en","description":"Naming the unnamed. INAN is a place where things that need a name meet people that like coming up with them.","over18":false},"CreditCards":{"lang":"en","description":"A subreddit for discussing any aspect of credit cards. It is important to pay them in full and on time.  Please ask questions and contribute to the knowledge surrounding credit cards.","over18":false},"RedditorCum":{"lang":"en","description":"Amateur pictures and videos of hot cum!","over18":true},"steamgiveaway":{"lang":"en","description":"","over18":false},"europeannationalism":{"lang":null,"description":"Subreddit no longer exists","over18":null},"justicedemocrats":{"lang":"en","description":"A space to grow around the Justice Democrats movement.","over18":false},"chicagoEDM":{"lang":"en","description":"For people who enjoy electronic music (EDM) and want more info on shows, festivals, and anything else EDM related in Chicago.","over18":false},"storage":{"lang":"en","description":"A subreddit for data storage-related questions, anecdotes, troubleshooting request/tips, and other related discussions.","over18":false},"PAWGtastic":{"lang":"en","description":"Original PAWG content. Phat Ass White Girls is the future. A gonewild style subreddit, reserved for caucasian girls with a booty. We like big butts and we cannot lie.","over18":true},"askastronomy":{"lang":"en","description":"Direct your astronomy related questions here! \n\nOur panelists will do the best to answer your questions. \n\nInterested in being a panelist? PM the moderators with your credentials in astronomy. ","over18":false},"upvotegifs":{"lang":"en","description":"A place for up/downvote gifs.","over18":false},"matt":{"lang":"en","description":"Come ye merry Matts and Matthews!","over18":false},"SwordOrSheath":{"lang":"en","description":"Sword = Man and Sheath = Woman.\n\n\nPost a picture of someone and try to figure out if it's a boy or a girl! Man or woman!\n\nTHIS IS NOT A BULLYING SUBREDDIT. Hurtful comments or personal attacks will be","over18":false},"Rainbow6TTS":{"lang":"en","description":"Welcome to the Rainbow Six Siege Technical Test Server subreddit, please use this platform to discuss any issues in the TTS. Read the sticky posts for more in-depth informations.","over18":false},"ageofishtaria":{"lang":"en","description":"Welcome to the subreddit for the mobile game, Age of Ishtaria! Feel free to discuss the game and help each other out.","over18":false},"Green":{"lang":"en","description":"This subreddit is for issues relating to Green issues, including (but not limited to) Green Politics.\n\n[The Four Pillars](https://en.wikipedia.org/wiki/Four_Pillars_of_the_Green_Party):\n\nEcological Wi","over18":false},"TheGoodPlace":{"lang":"en","description":"Subreddit for The Good Place, a NBC sitcom starring Kristen Bell and Ted Danson.","over18":false},"SteamAccountsForSale":{"lang":"en","description":"Feel free to Sell or Trade your old Steam Accounts with other Redditors.","over18":false},"osureport":{"lang":"en","description":"A child subreddit from the /r/osugame community that strives for a betterment of the community by raising awareness for illegitimate players around the game.","over18":false},"healthcare":{"lang":"en","description":"Healthcare: systems, costs, problems and proposed solutions.","over18":false},"nudism":{"lang":"en","description":"This subreddit is dedicated to genuine Nudism and Naturism. We enforce all rules set by major world wide organizations (INF, AANR, FCN, Ect.) to keep this a clean, safe space to discuss with others ab","over18":false},"Kenya":{"lang":"en","description":"An online community that discusses all things Kenya related. ","over18":false},"konmari":{"lang":"en","description":"For people who want to surround themselves with joy!","over18":false},"pokemonrng":{"lang":"en","description":"RNG abuse, also referred to as RNG manipulation, is a procedure that manipulates the pseudo-random number generator in the main series games to obtain a desired Pokemon. It is commonly used to obtain ","over18":false},"ImaginaryWarhammer":{"lang":"en","description":"A place for Warhammer Fantasy and 40K art.","over18":false},"emetophobia":{"lang":"en","description":"For sufferers of emetophobia to have discussions, post advice, and support each other.","over18":false},"CNNmemes":{"lang":"en","description":"Memes of CNN or other failing MSM networks","over18":false},"cleganebowl":{"lang":"en","description":"CleganeBowl - Sandor vs. Gregor for max. hype.","over18":false},"fantanoforever":{"lang":"en","description":"The Internet's Busiest Music Nerd's Subreddit!","over18":false},"lanparty":{"lang":"en","description":"","over18":false},"Zippo":{"lang":"en","description":"A place to discuss Zippo lighters and related goods.","over18":false},"yourmomshousepodcast":{"lang":"en","description":"Hey Hitler! This is the place to promote your poly-bi lifestyle and post all your dental updates, dad boners, funny scream videos, and would you rathers. Or maybe you just want to glass all the cool, ","over18":false},"beerwithaview":{"lang":"en","description":"Pictures contaning:\nForeground - Beer\nBackground - View","over18":false},"Hooping":{"lang":"en","description":"","over18":false},"unRAID":{"lang":"en","description":"","over18":false},"happygirls":{"lang":"en","description":"","over18":false},"bikebuilders":{"lang":"en","description":"Bike building/modification of all types.","over18":false},"PointsPlus":{"lang":"en","description":"Whether you're on **Smart Points** or still following Points*Plus*, we are here to help you on your weight loss journey. We are not affiliated with Weight Watchers.","over18":false},"Boruto":{"lang":"en","description":"Subreddit about the new series of  Boruto: Naruto Next Generations ","over18":false},"DornerCase":{"lang":"en","description":"Archiving the timeline of events related to the Chris Dorner manhunt.","over18":false},"LifeIsFeudal":{"lang":"en","description":"The official Subreddit for hardcore sandbox RPG, Life is Feudal:Your Own and Life is Feudal: MMO","over18":false},"santashelpers":{"lang":"en","description":"Sometimes you need to get a present for someone, but don't know enough about their hobbies. This subreddit hopes to unite you with people who can provide insight and assistance.","over18":false},"Gifts":{"lang":"en","description":"A subreddit to share unique gift ideas with others.","over18":false},"centralpa":{"lang":"en","description":"","over18":false},"bloodbornethegame":{"lang":"en","description":"Archived subreddit. We have moved to /r/bloodborne.","over18":false},"Presetbay":{"lang":null,"description":"Subreddit no longer exists","over18":null},"PacificRim":{"lang":"en","description":"A place for anything related to Pacific Rim. Post anything Pacific Rim from toys to movies, games to trailers, anything and everything Pacific Rim belongs here. There's space for Jaegers and Kaiju's a","over18":false},"Weddingsunder10k":{"lang":"en","description":"A subreddit for brides and grooms to plan their dream weddings for less than $10,000!","over18":false},"realtors":{"lang":"en","description":"For discussion about what it means to be a Realtor.  \nIndustry specific news, ideas, questions, stories and anything related to the job.","over18":false},"metalguitar":{"lang":"en","description":"r/MetalGuitar is a community exclusively for sharing and discussing techniques, resources, news, pictures, videos, and information regarding Metal guitar.","over18":false},"NotHowDrugsWork":{"lang":"en","description":"Someone has smoked an entire joint and is vividly hallucinating purple monkeys? Your 12-year-old niece took a sip of whiskey and is now running around screaming at the top of her lungs? Your mother to","over18":false},"LSU":{"lang":"en","description":"","over18":false},"SmartThings":{"lang":"en","description":"Work with us to build the connected world","over18":false},"RedditWritesSeinfeld":{"lang":"en","description":"The best of Reddit writing Seinfeld for today.","over18":false},"Clarinet":{"lang":"en","description":"All things clarinet! ","over18":false},"Loadout":{"lang":"en","description":"Create weapons from various parts, and rumble it out in various game modes.\n","over18":false},"NovaScotia":{"lang":"en","description":"Nova Scotia: Canada's Ocean Playground","over18":false},"BostonU":{"lang":"en","description":"","over18":false},"KindVoice":{"lang":"en","description":"Feeling low, alone, tired of it all, or simply bored? Whatever the cause, you can come and find someone to talk to. You can also offer your time to talk to someone else. We help people find support by","over18":false},"yorickmains":{"lang":"en","description":"Yorick","over18":false},"cinnamonmermaids":{"lang":"en","description":"","over18":true},"SFSU":{"lang":"en","description":"A reddit community for San Francisco State University.\n\nThis subreddit is not officially supported by, sponsored by, or affiliated with San Francisco State University in any way. Any comments or links","over18":false},"NinjaSexParty":{"lang":"en","description":"These underrated men of music come up with the most bizarre tracks that blow your mind!","over18":false},"AsianCuties":{"lang":"en","description":"If it's NSFW, say so in the title or you'll be banned!","over18":true},"weeklyplanetpodcast":{"lang":"en","description":"","over18":false},"louisck":{"lang":"en","description":"A place where Louis can be properly appreciated.","over18":false},"gimlet":{"lang":"en","description":"/\n\nTo discuss all things related to the new company Gimlet Media, started by Alex Blumberg.","over18":false},"CompeteLeague":{"lang":"en","description":"The reddit for [CompeteLeague.com](http://competeleague.com/)\n","over18":false},"RX8":{"lang":"en","description":"The Mazda RX8 subreddit, where you will find everything RX8 related! Post pictures of your ride, share mods, DIY and advice, ask questions and talk about one of the most innovative sports coupés of th","over18":false},"TheMentalist":{"lang":"en","description":"","over18":false},"shamelessplug":{"lang":"en","description":"","over18":false},"BATProject":{"lang":"en","description":"Blockchain-based digital advertising from the creator of JavaScript and the co-founder of Mozilla and Firefox, with a solid team. Welcome to the official Basic Attention Token (BAT) subreddit.","over18":false},"mtgmarketwatch":{"lang":"en","description":"If you want to make discuss the finance side of Magic the Gathering Buying/Selling/Trading, look no further!","over18":false},"jordan":{"lang":"en","description":"The Hashemite Kingdom of Jordan","over18":false},"Allergies":{"lang":"en","description":"A commonplace for discussion, news, advice and questions with fellow sufferers. This sub is under reconstruction, please be patient as we work to improve it.","over18":false},"roanoke":{"lang":"en","description":"The subreddit for the Roanoke metropolitan area.","over18":false},"CitiesSkylinesModding":{"lang":"en","description":"A place for all things modding of the game, Cities Skylines","over18":false},"TinyTrumps":{"lang":"en","description":"A subreddit for photos of our 45th President, Trump... ᵇᵘᵗ ᵗᶦᶰʸ/r/TinyTrumps is the go-to origin of photos of the 45th President where the aforementioned is roughly 2 feet tall.","over18":false},"BreastExpansion":{"lang":"en","description":"The NSFW subreddit dedicated to female breast growth! From growing one cup size to smothering the universe, this is the place to talk about B.E. and share free B.E. media. ","over18":true},"gallifreyan":{"lang":"en","description":"","over18":false},"Reaper":{"lang":"en","description":"Reaper Digital Audio Workstation","over18":false},"comeonandslam":{"lang":"en","description":"it's a protest or whatever\n\nalso where's Barkley 2? yeah, we want that too.","over18":false},"slideforreddit":{"lang":"en","description":"Official Subreddit for the Android app Slide for Reddit","over18":false},"kpopslumberparty":{"lang":"en","description":"Whether you want to discuss a facet of Kpop with like minded people or just want to share the newest meme of your favourite artist, kpopslumberparty wants you.\n\nPost it all here! Anything goes! It's l","over18":false},"JustNoSO":{"lang":"en","description":"Sometimes a significant other does something agitating and infuriating. This is where we talk about it.","over18":false},"ColumbusGO":{"lang":"en","description":"Columbus, OH - Local PokemonGo news, resources, and discussion","over18":false},"KnightsOfPineapple":{"lang":"en","description":"We are the knights who fight for the deliciousness of pineapples on pizza!","over18":false},"relationship_tips":{"lang":"en","description":"","over18":false},"fappeningdiscussion":{"lang":"en","description":"Celebrity NSFW pictures and discussion","over18":true},"tiltshift":{"lang":"en","description":"Mostly selective focus photo manipulation\nSome Tilt-Shift Photography","over18":false},"Gamecocks":{"lang":"en","description":"The Official Subreddit For The University of South Carolina","over18":false},"timelapse":{"lang":"en","description":"/r/TimeLapse - Speeding the World Up One Frame at a Time","over18":false},"TaliyahMains":{"lang":"en","description":"A subreddit dedicated to Taliyah, The Stoneweaver.\n\nDiscord link for mobile: https://discord.gg/k4yMd4W","over18":false},"EnterShikari":{"lang":"en","description":"A white abode amongst the darky waters of reddit.\n\n","over18":false},"lupus":{"lang":"en","description":"Place to connect, look for advice and exchange stories.","over18":false},"soma":{"lang":"en","description":"SOMA is a sci-fi horror game from Frictional Games, creators of the groundbreaking Amnesia and Penumbra series.","over18":false},"Psychiatry":{"lang":"en","description":"We're a community created to discuss psychiatry, medicine, and associated fields. We are not a subreddit to seek mental health treatment advice.","over18":false},"littlebigplanet":{"lang":"en","description":"This is the place for all you budding creators to share your wonderful LittleBigPlanet levels, ideas and news with like-minded Redditors.\n\nPlease report bugs to @LittleBigPlanet on twitter.\n","over18":false},"NegativeWithGold":{"lang":"en","description":"Comments with gold that are net negative comment karma","over18":false},"fo3":{"lang":"en","description":"A community for Fallout 3 and everything related. ","over18":false},"seinfeldgifs":{"lang":"en","description":"The best sitcom shown in chunks of giffy goodness.","over18":false},"19KidsandCounting":{"lang":"en","description":"","over18":false},"PatreonGirls":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Lettering":{"lang":"en","description":"Lettering is 'the act, art or process of inscribing or writing words on something'. And it is also just awesome. If you create your own or find awesome ones out in the wild, throw them up and let it b","over18":false},"bookclub":{"lang":"en","description":"Book nerds nerding\n\nRead slow, post often, re-read & repeat. \n","over18":false},"neckbeardRPG":{"lang":"en","description":"NeckbeardRPG memes","over18":false},"Overwatch_Porn":{"lang":"en","description":"Welcome to /r/OverwatchPorn, home of all Overwatch Rule 34 content!\nOverwatch is a multiplayer first-person shooter by Blizzard Entertainment.","over18":true},"ncaaBBallStreams":{"lang":"en","description":"A place to find streams for College Basketball.","over18":false},"AudioPost":{"lang":"en","description":"We are sound for picture - the subreddit for post sound in Games, TV / Television , Film, Broadcast, and other types of production.\n\n* Dialog / Dialogue Editing  \n* ADR  \n* Sound Effects / SFX  \n* Fol","over18":false},"computerforensics":{"lang":"en","description":"Dedicated towards the branch of forensic science encompassing the recovery and investigation of material found in digital devices, often in relation to computer crime. The field is the application of ","over18":false},"teenrelationships":{"lang":"en","description":"A subreddit with the goal is helping teens work through their relationships. ","over18":false},"HomeKit":{"lang":"en","description":"To discuss Apple's Homekit","over18":false},"Shemales":{"lang":"en","description":"Gorgeous alluring **shemale** and *ladyboy* pictures and videos are what you are going to find inside this *tranny porn* subreddit. Share your favorite *transsexual* pictures or *tgirl* videos or simp","over18":true},"EQ2":{"lang":"en","description":"","over18":false},"gayporn":{"lang":"en","description":"/r/GayPorn is reddit's go-to place for variety NSFW content featuring hot & horny guys.","over18":true},"relationships_advice":{"lang":"en","description":"","over18":false},"siberianhusky":{"lang":"en","description":"","over18":false},"portlandtrees":{"lang":"en","description":"","over18":false},"trashpandas":{"lang":"en","description":"Welcome to Trash Pandas your home for all things Trash Panda related! \n\nHere at Trash Pandas we strive to share the cutest and most awesome content there is. ","over18":false},"TrayvonMartin":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Strava":{"lang":"en","description":"Discussion of, about, and around the Strava website and community.\n\nReddit represents a wide, diverse, and (generally) intelligent community. Let's pool our experience, knowledge and a ideas to help i","over18":false},"rape":{"lang":"en","description":"","over18":false},"dragonsdogmaonline":{"lang":"en","description":"Welcome to the Dragons Dogma Online Subreddit- A community dedicated to News, and localization attempts for this upcoming title. ","over18":false},"Crunchyroll":{"lang":"en","description":"Crunchyroll is an American website and international online community focused on video streaming East Asian media including anime, manga, drama, and more. Founded in June 2006 by a group of UC Berkele","over18":false},"chibike":{"lang":"en","description":"A friendly cycling community in the beautiful city of Chicago.","over18":false},"PokemonGoUK":{"lang":"en","description":"A place for UK trainers to meet and discuss the Pokemon Go Game! So anyone playing in England, Wales, Scotland or Northern Ireland, welcome!","over18":false},"sarasota":{"lang":"en","description":"","over18":false},"fuckingmanly":{"lang":"en","description":"Fucking Manly Things. ","over18":false},"HearthDecklists":{"lang":"en","description":"A subreddit for Hearthstone decks and deck discussion. Keep conversations constructive please!","over18":false},"creepyencounters":{"lang":"en","description":"This sub is for mildly creepy encounters where you weren't actually in any immediate, life-threatening danger, but that you still find somewhat creepy and interesting enough to share. ","over18":false},"GMAT":{"lang":"en","description":"A place to discuss the GMAT (Graduate Management Admission Test). ","over18":false},"Woodcarving":{"lang":"en","description":"","over18":false},"DirecTV":{"lang":"en","description":"For all things DirecTV","over18":false},"1P_LSD":{"lang":"en","description":"A place to talk about the research chemical 1P-LSD (1-propionyl-lysergic acid diethylamide).","over18":false},"overpopulation":{"lang":"en","description":"We are legions, growing relentlessly, carrying out deforestation and eradication of other species, exhausting fish stocks, using up our resources to the limit and competing over what remains. Instead ","over18":false},"GoneWildScrubs":{"lang":"en","description":"A community where Redditors in Nursing or the Medical field can show their nude or partially nude bodies.   No Halloween costumes; submissions are for real medical professionals only.","over18":true},"houseplants":{"lang":"en","description":"A community focused on the discussion, care, and well-being of houseplants!","over18":false},"MMAStreams":{"lang":"en","description":"Watch your favorite MMA events online with community provided streams.","over18":false},"EverWing":{"lang":"en","description":"Discussion on anything related to the Facebook Messenger in-app game 'EverWing'.","over18":false},"ItTheMovie":{"lang":"en","description":"Join the discussion, speculation, and hype for the upcoming film adaptations of IT, based off the legendary novel by Stephen King.","over18":false},"arenaofvalor":{"lang":"en","description":"","over18":false},"armoredwomen":{"lang":"en","description":"For pictures/art of women in reasonable armo[u]r.","over18":false},"legodeal":{"lang":"en","description":"A place to submit links to sales on Lego sets.","over18":false},"changetip":{"lang":"en","description":"Your change in action. Tip bitcoin and USD to others for good content simply by mentioning an amount and referencing /u/changetip.\n\nCheck us out at [ChangeTip.com](https://www.changetip.com)!","over18":false},"Gwinnett":{"lang":"en","description":"","over18":false},"BitcoinUK":{"lang":"en","description":"A community dedicated to the discussion of Bitcoin based in the United Kingdom.","over18":false},"MSAccess":{"lang":"en","description":"","over18":false},"SteamBot":{"lang":"en","description":"/r/SteamBot is a resource for help with automating actions in the Steam Community website and the Steam client.","over18":false},"NightInTheWoods":{"lang":"en","description":"Night in the Woods is a story-focused adventure/exploration game from Alec Holowka (Aquaria), animator Scott Benson, and Bethany Hockenberry.","over18":false},"KanyeLeaks":{"lang":"en","description":"The place to discuss and share leaked or unreleased music, primarily Kanye West related.","over18":false},"AVoid5":{"lang":"en","description":"This is a subforum supporting a community that avoids that filthy fifth glyph. Individuals in this community can post anything as long that fifth symbol of our ABC's is totally missing. This task can ","over18":false},"Sufjan":{"lang":"en","description":"A subreddit dedicated to the music of Sufjan Stevens!","over18":false},"IrishHistory":{"lang":"en","description":"A subreddit dedicated to the sharing, exploration, and discussion of Irish History. ","over18":false},"catbellies":{"lang":"en","description":"Need more cat belly in your life?  Who doesn't?  This is the place to come to scratch that belly itch.  Just roll over!","over18":false},"Rule34Overwatch":{"lang":"en","description":"Rule34Overwatch is where you may find your lovely fantasies of [Overwatch](http://us.battle.net/overwatch/en/)","over18":true},"Pee":{"lang":"en","description":"Girls peeing.","over18":true},"creampies":{"lang":"en","description":"A community devoted to pictures and videos of women getting creampies, either 1on1 or in groups.","over18":true},"Fullmoviesonvimeo":{"lang":"en","description":"Now accepting Google doc links!\n\n\n","over18":false},"911dispatchers":{"lang":"en","description":"A gathering place for 911 dispatchers to vent/talk/collaborate on things relating to the wonderful world of ANI/ALI.  All discussion goes and is no holds barred. Welcome to the night shift.","over18":false},"techwearclothing":{"lang":"en","description":"Practical, functional and utilitarian clothing.","over18":false},"CuteGuyButts":{"lang":"en","description":"A place for pictures and perhaps terrible fanfiction of the cute butts of guys, and also of cute guys' butts. Also, your own butts.","over18":true},"origin":{"lang":"en","description":"Official sub-reddit for EA's Origin service.","over18":false},"republicwireless":{"lang":"en","description":"Better coverage, in more places, for less money. No-contract plans starting at just $15/month.","over18":false},"TenX":{"lang":"en","description":"We make cryptocurrencies spendable anytime, anywhere with the TenX wallet app and debit card. TenX supports cryptocurrencies across multiple blockchains. Currently supported are Bitcoin, Ethereum and ","over18":false},"jquery":{"lang":"en","description":"News, articles, plugins and tutorials for jQuery, the world's most popular Javascript library! Covering jQuery Core, jQuery UI, jQuery Mobile, and other related projects.\n","over18":false},"Untappd":{"lang":"en","description":"This is a place to share Untappd News, pictures of beers, questions on badges, and common camaraderie of your favorite app, Untappd.","over18":false},"chinaphones":{"lang":"en","description":"China houses many of the companies that produce components and build the phones and tablets we use daily. In recent years, the quality of Chinese brands has increased by leaps and bounds, while keepin","over18":false},"Balls":{"lang":"en","description":"Pictures, videos, and discussion about testicles. ","over18":true},"holdmyredbull":{"lang":"en","description":"THE KEY WORD HERE IS \"EXCITEMENT!\"\n\n","over18":false},"holofractal":{"lang":"en","description":"The holofractographic unified field theory, as developed by Nassim Haramein and physicists at the Resonance Science Foundation & [Hawaii Institute for Unified Physics](http://hiup.org). \n\nThis theory ","over18":false},"chromanauts":{"lang":"en","description":"Chromabot HQ","over18":false},"fantasylife":{"lang":"en","description":"A subreddit dedicated to the Fantasy Life series","over18":false},"wakfu":{"lang":"en","description":"If you love the MMO, the gorgeous French-language anime, or the Xbox Live Arcade game, then you've come to the right place!","over18":false},"replications":{"lang":"en","description":"Post images, gifs, or video replications of the hallucinogenic experience here!\n\nAssociated with https://EffectIndex.com","over18":false},"comic_crits":{"lang":"en","description":"The mission of /r/Comic_Crits is to provide holistic feedback to comic creators based on the understanding that a comic is not just 'writing plus art', but rather a unique combination of both, bound t","over18":false},"tails":{"lang":"en","description":"Everything about the Amnesic Incognito Live System.","over18":false},"Songwriting":{"lang":"en","description":"A place for discussion about Songwriting.  No original music should be posted here. ","over18":false},"robintracking":{"lang":"en","description":"Formed to make information available about the largest of the chatrooms created during the Robin experiment.","over18":false},"doge":{"lang":"en","description":"doge reddit","over18":false},"sm4sh":{"lang":"en","description":"Everything Smash 4 related goes here!","over18":false},"Thisismylifemeow":{"lang":"en","description":"When you just accept your life as a feline!","over18":false},"cmu":{"lang":"en","description":"A community for [Carnegie Mellon University](http://www.cmu.edu) students and alumni.\n\n(If you're looking for Central Michigan University, try /r/centralmich).","over18":false},"visualbasic":{"lang":"en","description":"A place to discuss, ask questions and share ideas regarding the Visual Basic programming languages.","over18":false},"NativeAmerican":{"lang":"en","description":"Important stories and discussion concerning the indigenous peoples of the Americas, from Alaska to Tierra del Fuego.","over18":false},"kustom":{"lang":"en","description":"Everything related to the Android Kustom world, (Kustom Live Wallpaper)[http://kustom.rocks/klwp] and (Kustom Widget Maker)[http://kustom.rocks/kwgt]","over18":false},"AcademicPhilosophy":{"lang":"en","description":"This reddit is intended for practicing philosophers - undergraduate students, graduate students, professors, or researchers. \n\nNon-academic philosophers are welcome to visit. Just bear in mind that th","over18":false},"COsnow":{"lang":"en","description":"Your source for Colorado snow sports information. Photos, snow reports, rideshares, and secret stashes.","over18":false},"PokemonGoPittsburgh":{"lang":"en","description":"For discussion of everything PokémonGo related in the greater Pittsburgh area","over18":false},"projectmanagement":{"lang":"en","description":"This reddit is dedicated to project management with a focus on the software development area. No commercial promotion allowed.","over18":false},"trippy":{"lang":"en","description":"Things that remind you of your last trip. Psychedelic videos, music and images. Fractals, music visualizers, projection visuals, mandalas, 3D strange attractors and visionary art. Things you'd like to","over18":false},"absolutelynotme_irl":{"lang":"en","description":"absolutely not your selfies of the soul","over18":false},"mandolin":{"lang":"en","description":"A subreddit for the wonderful world of mandolin.","over18":false},"jetta":{"lang":"en","description":"Anything related to the Volkswagen Jetta is welcome. ","over18":false},"asl":{"lang":"en","description":"","over18":false},"YGOFeedback":{"lang":"en","description":"A feedback system for online trading and selling Yu-Gi-Oh! cards. Accompanied by /r/YGOBinders and /r/YGOSales","over18":false},"homeschool":{"lang":"en","description":"Resources, advice, news, and learning support for redditors who are educating (or thinking about educating) their children at home.","over18":false},"wde":{"lang":"en","description":"This is a forum dedicated to Auburn University Athletics. Topics include, but are not limited to, Auburn Tiger Football, Auburn Basketball, and Auburn Baseball. All things pertaining to Auburn sports ","over18":false},"Illaoi":{"lang":"en","description":"This subreddit is dedicated to Illaoi, the Priestess of Nagakabouros and Headmistress of Tentacle Academy. A League of Legends™ Champion Main sub.","over18":false},"amifat":{"lang":null,"description":"Subreddit forbidden","over18":null},"unfilter":{"lang":null,"description":"Subreddit forbidden","over18":null},"jazzguitar":{"lang":"en","description":"A community for jazz guitarists and lovers of jazz guitar.","over18":false},"mtgoxinsolvency":{"lang":"en","description":"MtGoxInsolvency is the sub for those affected by the failure of MtGox and who are now part of the formal MtGox Insolvency process being run out of Tokyo through the Japanese court system.","over18":false},"NewcastleUponTyne":{"lang":"en","description":"","over18":false},"ShittyTechSupport":{"lang":"en","description":"","over18":false},"thegdstudio":{"lang":"en","description":"The GD Studio is a place where e-sports and whiskey are consumed daily.\nLearn to Play and Tournaments of Starcraft II, Quake Live, Bloodline Champions and Quake Live.","over18":false},"S7Edge":{"lang":"en","description":"Subreddit to discuss all things exclusively Samsung Galaxy S7 Edge! Share your device experiences, look for the latest news, share your photos or seek help with issues.","over18":false},"reflex":{"lang":"en","description":"A competitive first person shooter that combines modern tech with the speed and precision of 90's shooters.","over18":false},"NFLRoundTable":{"lang":"en","description":"/r/NFLRoundTable is a place for news and discussion relating to the National Football League.","over18":false},"FallingSkies":{"lang":"en","description":"Falling Skies is an alien invasion science fiction television series created by Robert Rodat and Steven Spielberg for TNT. The show is produced by DreamWorks Television, with Steven Spielberg acting a","over18":false},"brakebills":{"lang":"en","description":"A sub to discuss \"The Magicians\": the trilogy by Lev Grossman and the show on SyFy.","over18":false},"lasercutting":{"lang":"en","description":"A place to share your laser cutter creations, tips, questions and other laser cutter related information.","over18":false},"DaveRamsey":{"lang":"en","description":"If you're a Dave Ramsey fan or just want to gain a better understanding of Personal Finance then this is the community for you! ","over18":false},"CrackTheClue":{"lang":"en","description":"**Official Subreddit for Oldschool Runescape's \"Crack the Clue\" Event**\n\n","over18":false},"Innokin":{"lang":"en","description":"Innokin is an international leader in the development of top quality e-cigarette systems. \n\nThank you for visiting, if you have any questions please feel free to ask. ","over18":false},"ghostnipples":{"lang":"en","description":"A subreddit for picture of girls whose nipples are the **same skin-tone as the rest of their breasts**. Pale nipple posts will be removed - there is a separate sub for that.","over18":true},"zyramains":{"lang":"en","description":"Welcome to the subreddit dedicated to Zyra, Rise of the Thorns.","over18":false},"Biochemistry":{"lang":"en","description":"","over18":false},"longevity":{"lang":"en","description":"Reasons to hope to see the age of 100 and beyond: Biomedical rejuvenation through damage repair, manipulation of metabolism, beyond the mere results of exercise, caloric restriction, and fasting.   St","over18":false},"wwiipics":{"lang":"en","description":"A place to share World War II photographs.","over18":false},"peercoin":{"lang":"en","description":"Peercoin is responsible for inventing proof-of-stake consensus and pioneering the first efficient and sustainable public blockchain technology. It is extremely low-cost to operate and requires very li","over18":false},"ThemeParkitect":{"lang":"en","description":"For everything about the game Parkitect!","over18":false},"EroticHypnosis":{"lang":"en","description":"A place to discuss hypnosis used in erotic, sexy, and kinky contexts. Read the rules before contributing.","over18":true},"FeedTheBeastCrashes":{"lang":"en","description":"","over18":false},"theavalanches":{"lang":"en","description":"The Avalanches released their first full length album, Since I Left You, on 27 Nov 2000. On 8 July 2016, The Avalanches released their second album, Wildflower.\n","over18":false},"AccidentalWesAnderson":{"lang":"en","description":"","over18":false},"RagnarokOnline":{"lang":"en","description":"","over18":false},"Cardiff":{"lang":"en","description":"Cardiff is the capital and largest city in Wales, and the tenth largest city in the United Kingdom.","over18":false},"youtubegaming":{"lang":"en","description":"This subreddit is devoted to the discussion of YouTube's Gaming platform, YouTube Gaming.","over18":false},"nfffffffluuuuuuuuuuuu":{"lang":"en","description":"","over18":false},"sonic":{"lang":"en","description":"A place to discuss the games, shows, and comics of everyone's favorite fast-moving, smart-talking blue hedgehog, Sonic!\n\n###[Weekly Sonic Discussion #8 (Your Favorite Boss Fight)](https://www.reddit.c","over18":false},"Blizzard":{"lang":"en","description":"Activision Blizzard company news and discussion of Blizzard games.","over18":false},"AmateurWifes":{"lang":"en","description":"Only Pictures of Real Amateurs, Mature Wives , Moms, Milfs.","over18":true},"myevilplan":{"lang":"en","description":"/r/myevilplan is a place for evil doers to share their plans with other evil doers. Our goal is the conquest of the known universe","over18":false},"Beginning_Photography":{"lang":"en","description":"App Users/Mobile Users: Read the Community Info/About This Sub material before you post, please, as the traditional sidebar isn't visible on your platform!\n\nA resource for the total photography newb t","over18":false},"theXeffect":{"lang":"en","description":"People here are on a 50-day journey to create/break one or more habits by simply making a 7x7 grid on a card and crossing off each day with a fat-ass felt marker, because your willpower is like a musc","over18":false},"osheaga":{"lang":"en","description":"For Osheaga","over18":false},"Bento":{"lang":"en","description":"","over18":false},"quiver":{"lang":"en","description":"If you have a GIF or video of an orgasm or reaction so intense that **their body shakes uncontrollably**, post it here! Simply moaning really loud or squirting is not suitable for this subreddit.","over18":true},"letsdrownout":{"lang":"en","description":"A subreddit to discuss Yahtzee Croshaw's and Gabriel Morton's Let's Drown Out series as distinct from Yahtzee's Zero Punctuation series. Discussion of other videos by Youtube account yahtzee19 or othe","over18":false},"UserSimulator":{"lang":"en","description":"","over18":false},"disneyemojiblitz":{"lang":"en","description":"A fan community for the Disney Emoji Blitz game! Chat with other players while sharing tips and tricks! Ask questions, share news and scores about this game.","over18":false},"nsfw2":{"lang":"en","description":"We've taken NSFW to the SECOND POWER.This is NSFW the way it always should have been.  More Content, less nonsense.","over18":true},"Hot_Women_Gifs":{"lang":"en","description":"Hot Women Gifs","over18":true},"bodyperfection":{"lang":"en","description":"Female Body Perfection","over18":true},"avesNYC":{"lang":"en","description":"/r/avesNYC is the place for ravers in the city to discuss anything and everything rave related going down in our neck of the woods! Feel free to discuss upcoming EDM events, Underground NYC raves, org","over18":false},"nintendomusic":{"lang":"en","description":"The place to share, (re)discover, and discuss the magic that is Nintendo music!","over18":false},"holdmycatnip":{"lang":"en","description":"Catnip related catastrophes and other shenanigans is what HoldMyCatnip is all about.  Post cats doing crazy things!  Subscribe today!","over18":false},"swgoh_guilds":{"lang":"en","description":"For the mobile game Star Wars Galaxy of Heroes. Post here to advertise your guild or yourself in hopes that others may find interest.","over18":false},"Crainn":{"lang":"en","description":"**Crainn**, a place where you can discuss anything related to cannabis culture in Ireland.","over18":false},"USNEWS":{"lang":"en","description":"","over18":false},"bestofbronze":{"lang":"en","description":"A repository of spectacular Bronze-like gameplay, from the terrible to terribly amusing plays.","over18":false},"100yearsago":{"lang":"en","description":"This subreddit was formed in late 2013 to document World War I, day by day as it developed. It covers social, political, military and cultural developments in combatant countries and noncombatants ali","over18":false},"Billions":{"lang":"en","description":"For the Showtime show.","over18":false},"insanityworkout":{"lang":"en","description":"Those of us working out with the dvd workout program: Insanity by Beach Body","over18":false},"chicagoroommates":{"lang":null,"description":"Subreddit forbidden","over18":null},"Egalitarianism":{"lang":"en","description":"","over18":false},"initiald":{"lang":"en","description":"A subreddit for fans of the manga and anime series, Initial D. Discussion of related car culture, similar animes, or anything else interesting encouraged.","over18":false},"SteamOS":{"lang":"en","description":"Talk and information about the Steam operating system.","over18":false},"consoles":{"lang":"en","description":"The one and only destination for all console gaming. Oldschool, newschool and everyschool. Totally free of bias and console warfare - Lets talk consoles!","over18":false},"computing":{"lang":"en","description":"Welcome to /r/Computing, this subreddit is for links to articles related to computing and help posts.\n","over18":false},"DnDHomebrew":{"lang":"en","description":"Welcome to /r/DnDHomebrew! Do you like D&D? Do you like using your imagination? We can help you join them in sweet marriage fit for a king.\n\nUse this subreddit to:\n\n * Share your D&D Homebrews\n\n * Hel","over18":false},"Oscars":{"lang":"en","description":"The envelope please!","over18":false},"EnoughInternet":{"lang":"en","description":"Oh, a girl shoving eels into her ass? Yeah... That's enough Internet for today.","over18":true},"IBD":{"lang":"en","description":"","over18":false},"boardgamerecommender":{"lang":"en","description":"This subreddit is the home of boardgamerecommender, a bot I wrote which generates board game recommendations. See [this post](https://www.reddit.com/r/boardgamerecommender/comments/41owd0/the_new_home","over18":false},"amateurcumsluts":{"lang":"en","description":"A place dedicated to the cum loving amateur women.   Only Amateur content allowed, facials body shots, are welcome as long as there is cum somewhere.","over18":true},"bowhunting":{"lang":"en","description":"A subreddit to discuss all things bowhunting! For beginners to masters and eveyone in between, post questions, comments or pictures and even equipment that you want to sell. Happy Hunting!","over18":false},"gettingherselfoff":{"lang":"en","description":"Post gifs and videos of women playing with themselves, or another woman! ","over18":true},"prettylights":{"lang":"en","description":"Pretty Lights are the moments that catch our eyes, the things that make us look twice, think twice, and inspire us to create our own vision of beauty.","over18":false},"EASHL":{"lang":"en","description":"All things EASHL --  Recruit Free Agents, Find Clubs, Organize Drop-In Lobbies, 6v6 League & Tournament Promotion, Share Videos & Streams, and Discuss Gameplay & Features.\n\nBuild your legacy in the EA","over18":false},"PictureChallenge":{"lang":"en","description":"Every week, we, as a community, will come up with a topic or category of pictures.  Throughout the time frame of each topic, we can post our pictures here for all to see.  We strive to help people dev","over18":false},"BonerMaterial":{"lang":"en","description":"Stuff for your boner","over18":true},"GreenDawn":{"lang":"en","description":"Your mission, should you choose to accept, is to stratgically place little Army men throughout your hometown and businesses you come upon along your journies. Use caution. A misplaced soldier could be","over18":false},"switcharoo":{"lang":"en","description":"A subreddit to celebrate the full breadth and majesty of the folly we have engaged in.","over18":false},"PocketMortys":{"lang":"en","description":"","over18":false},"funnyvideos":{"lang":"en","description":"","over18":false},"redditbay":{"lang":"en","description":"","over18":false},"michiganbeer":{"lang":"en","description":"All about Michigan beer! \n\nFrom home brewing to your favorite brewpub, microbrewery or full scale brewery, you can talk about it here. ","over18":false},"JapaneseGameShows":{"lang":"en","description":"Comedy straight from Japan! Stuff like Silent Library, Gaki No Tsukai, and More!\n\nIf these videos don't make you laugh, then I don't know what will.","over18":false},"HENTAI_GIF":{"lang":"en","description":"Your free hentai gif source. Only the best hentai gifs will be posted here.\n\nPlease refrain from lolicon gifs, and make sure your gifs are hosted on imgur before posting","over18":true},"fleshlight":{"lang":"en","description":"Sub dedicated to the male sex-toy line of Fleshlight","over18":true},"CastleStory":{"lang":"en","description":"Castle Story is a mix between a real time strategy game and a voxel based sandbox building game. Created by a small company, Sauropod Studio. These developers have what has the potential to be a great","over18":false},"TorontoDriving":{"lang":"en","description":"Toronto dash cam videos and Toronto driving discussion\n\n","over18":false},"elex":{"lang":"en","description":"next gothic","over18":false},"Kava":{"lang":"en","description":"Kava is an ancient, relaxing plant beverage from the islands of the South Pacific. This sub aims to provide accurate and useful information about kava, as well as a friendly space for discussing every","over18":false},"HighwayFightSquad":{"lang":"en","description":"The official subreddit for the Clustertruck. \nA game developed by Landfall games","over18":false},"forge":{"lang":"en","description":"We are a community dedicated to the map editor 'forge' in the halo video game series. Here you can show off user created maps, seek advice, tutorials, or find players to play with.","over18":false},"hdtgm":{"lang":"en","description":"From the Earwolf.com family of podcasts, Paul Scheer (of Human Giant and The League fame), joined by his two co-hosts June Diane Raphael and Jason Mantzoukas, try and make sense of the movies that mak","over18":false},"NewParents":{"lang":"en","description":"","over18":false},"forzahorizon3":{"lang":null,"description":"Subreddit forbidden","over18":null},"loadingicon":{"lang":"en","description":"'That should be a loading icon!'","over18":false},"LocationSound":{"lang":"en","description":"The subreddit for location sound, production sound, and field recording. We are the sound department responsible for recording the audio when shooting film/video.\n\nBe sure to check out our wiki page f","over18":false},"DIY_classifieds":{"lang":null,"description":"Subreddit no longer exists","over18":null},"omgbeckylookathiscock":{"lang":"en","description":"When a guy pulls off his boxers, and out it comes. When the girl in front of him has her eyes (and mouth) open, paying attention with a look of surprise and curiosity if she can fit it inside her, and","over18":true},"BreastEnvy":{"lang":"en","description":"A subreddit for breast envy and big breasts/small breasts. ","over18":true},"hardcoreaww":{"lang":"en","description":"#####HardcoreAww is for CUTE & DANGEROUS animals that would KILL you if they had the chance!\n\nWe value all life on the planet and agree that humans have been stripping away the natural habitats of the","over18":false},"PokemonGOValor":{"lang":"en","description":"The official sub-Reddit of Pokemon GO's Team Valor!\n","over18":false},"Battlecars":{"lang":"en","description":"Is your car ready to battle?","over18":false},"matheducation":{"lang":"en","description":"Math education! Anything math related that is useful for education, teachers, or students. There should be an emphasis on usefulness (such as good internet resources or ideas for how to teach a concep","over18":false},"BirdsBeingDicks":{"lang":"en","description":"An archive of all the bird douchebaggery. ","over18":false},"RedDwarf":{"lang":"en","description":"    The official subreddit of Red Dwarf\n       The cult sci-fi comedy show!\n\n","over18":false},"BoardGameExchange":{"lang":"en","description":"Welcome to the r/BoardGameExchange market.\n\nTrade, sell, and barter for games.","over18":false},"NerfExchange":{"lang":"en","description":"Nerf Exchange is meant for Nerfers to provide easy means to get spare parts, blasters, and otherwise to and from nerfers. Set up local deals, broadcast that you are getting rid of something. Find some","over18":false},"fredericton":{"lang":"en","description":"","over18":false},"dankruto":{"lang":"en","description":"","over18":false},"freebsd":{"lang":"en","description":"News and more about [FreeBSD](http://www.freebsd.org/).","over18":false},"dota2smut":{"lang":"en","description":"For Rule 34 of DotA/Dota 2 Heroes","over18":true},"GayDaddiesPics":{"lang":"en","description":"Welcome to /r/gaydaddiespics!\n\nThis subreddit collects and displays pictures, videos, and GIFs of middle-aged and “daddy” type men. You must be 18 years of age or older to view or post to this page. A","over18":true},"NSFWskype":{"lang":"en","description":"This sub is for anyone who wants to have some (naughty) fun on Skype! Voyeurs, exhibitionists, and anyone who wants to use Skype are all welcome to post here in search for someone to chat and especial","over18":true},"highschool":{"lang":"en","description":"","over18":false},"teachinginkorea":{"lang":"en","description":"A community for English teachers in Korea. Feel free to discuss anything generally related to being a foreign teacher in Korea!","over18":false},"glasses":{"lang":"en","description":"","over18":false},"badparking":{"lang":"en","description":"","over18":false},"Sleepparalysis":{"lang":"en","description":"Discussion and support for folks who experience sleep paralysis and interested others.  ","over18":false},"tropico":{"lang":"en","description":"","over18":false},"VaporwaveArt":{"lang":"en","description":"Post all your art inspired by the music genre of Vaporwave. ","over18":false},"excatholic":{"lang":"en","description":"This subreddit is for any and all ex-Catholics to talk, educate, discuss and maybe even bitch about their experiences within the Catholic Church. No matter what your belief now, or if you have no beli","over18":false},"PickOne":{"lang":"en","description":"","over18":true},"Fiveheads":{"lang":"en","description":"A subreddit for all heads greater than four.","over18":false},"scion":{"lang":"en","description":"r/scion is a reddit community for Scion owners and enthusiasts.\n","over18":false},"AskAShittyMechanic":{"lang":"en","description":"Automotive advice from the best shitty technicians in the industry.","over18":false},"swedents":{"lang":"sv","description":"Ents from the northlands.","over18":false},"SexyFrex":{"lang":"en","description":"Sexy girls with freckles","over18":true},"F1Porn":{"lang":"en","description":"This subreddit is dedicated to high quality images, and videos of Formula 1 cars, tracks, and anything else relating to the sport! F1 Formula1","over18":false},"JiggleFuck":{"lang":"en","description":"Hypnosis for your hard-on","over18":true},"LighthouseSherpas":{"lang":"en","description":"The goal is the lighthouse! Find a guide, watch, learn, carry, or be carried! It's up to you!","over18":false},"HotWifeRequests":{"lang":"en","description":"Welcome to /r/HotWifeRequests! We are happy to have you here. This subreddit is a personal ad subreddit for the HotWife Lifestyle","over18":true},"DHMIS":{"lang":"en","description":"No matter if you hate [the color green](https://www.youtube.com/watch?v=9C_HReR_McQ), [mucking around](https://www.youtube.com/watch?v=vtkGtXtDlQA), [pesky bees](https://www.youtube.com/watch?v=sXOdn6","over18":false},"Hoboken":{"lang":"en","description":"","over18":false},"hottiesfortrump":{"lang":"en","description":"This is a community of people who openly show their support for President Donald J. Trump.  We are unafraid!","over18":false},"ThreshMains":{"lang":"en","description":"We're all hookers at heart. Take the Lantern and join us! \n\n","over18":false},"Malware":{"lang":"en","description":"A place for malware reports and information.","over18":false},"fossilid":{"lang":"en","description":"Found a fossil? We probably can figure out what it is!\n\nFor the paleontology lover that needs help with identification. Brachiopods, dinosaurs, mysteries; they're all welcome here!","over18":false},"mfacirclejerk":{"lang":"en","description":"","over18":false},"Voat":{"lang":"en","description":"","over18":false},"squirting":{"lang":"en","description":"","over18":true},"WorcesterMA":{"lang":"en","description":"The main Reddit for anything and everything related to The Heart of the Commonwealth - Worcester, Massachusetts.","over18":false},"leakthreads":{"lang":"en","description":"","over18":false},"AskNOLA":{"lang":"en","description":"","over18":false},"FSAE":{"lang":"en","description":"Formula SAE and Formula Student are collegiate engineering competitions with over 500 participating schools that challenge teams of students to design and build a formula style car. The car is evaluat","over18":false},"sysadminjobs":{"lang":"en","description":"","over18":false},"pbsideachannel":{"lang":"en","description":"Here's an idea! A subreddit for discussing PBS Idea Channel!","over18":false},"entgaming":{"lang":"en","description":"We call ourselves, GEnts.\n\n-This is a subreddit for Ents who like to play games.\n\n-Find other GEnts to game with.\n\n-Post your marijuana/trees related game refrences, screenshots, and videos.\n\n-Discuss","over18":false},"CasualMTG":{"lang":"en","description":"This is a subreddit designed for Magic: The Gathering players who do not necessarily want to, or are not able to play competitively, and wish to discuss playing MTG for the sake of simple fun. Feel fr","over18":false},"Eragon":{"lang":"en","description":"This Subreddit is dedicated to the Eragon series, also known as the Inheritance Cycle, written by Christopher Paolini (/u/ChristopherPaolini).","over18":false},"bluesguitarist":{"lang":"en","description":"Subreddit strictly for the discussion and appreciation of blues guitar. Seeking to aggregate learning resources, gear knowledge, tips and tricks, and great performances, especially by redittors. ","over18":false},"victoriajustice":{"lang":"en","description":"For fans of Victoria Justice.","over18":false},"shadowrunreturns":{"lang":"en","description":"A hub for news, user-created content, Let's Play (LP) videos, commentary and all-else-related to the tactical, turn-based cRPG 'Shadowrun Returns.'","over18":false},"aoe3":{"lang":"en","description":"Welcome to /r/AOE3. This is a platform to discuss everything Age of Empires 3. If you have any questions, comments or concerns feel free to contact the moderators. Enjoy!","over18":false},"wacom":{"lang":"en","description":"/r/Wacom, a place to get help or share art and news! ","over18":false},"consolemasterrace":{"lang":"en","description":"Welcome, fellow enemies of Gaben, to the home of the glorious console players!","over18":false},"HealthInsurance":{"lang":"en","description":"Health insurance in the United States is pretty crazy, and we're here to help you navigate it!","over18":false},"Drumkits":{"lang":"en","description":"","over18":false},"til":{"lang":"en","description":"","over18":false},"redacted":{"lang":"en","description":"","over18":false},"Portuguese":{"lang":"en","description":"For all things regarding the Portuguese language","over18":false},"StarshipPorn":{"lang":"en","description":"This is A reddit dedicated to starships, or any other Space going vehicle belonging to any universe, sci-fi or otherwise.","over18":false},"ImaginaryMindscapes":{"lang":"en","description":"The Art of Imagination\n\n","over18":false},"thedivisionclans":{"lang":"en","description":"A Reddit community dedicated to clans for the video game Tom Clancy's The Division.","over18":false},"GrassrootsSelect":{"lang":"en","description":"**Grassroots Select**  has relocated to /r/Political_Revolution the Reddit branch of The Political Revolution a digital organization designed to raise support and awareness for progressive candidates ","over18":false},"KimmySchmidt":{"lang":"en","description":"The spiritual successor to 30 Rock is finally here! Fey's unique sense of humor has been missing from our lives for over two years and now we can tune into Netflix to finally watch the 13 brilliant ep","over18":false},"Spartacus_TV":{"lang":"en","description":"","over18":false},"VertcoinMining":{"lang":"en","description":"A place for all things mining Vertcoin (Lyra2REv2) (GPU mining)","over18":false},"mspaintbattles":{"lang":"en","description":"The ~~second~~ ~~*third*~~ **fourth** most popular Microsoft Paint related subreddit in the whole world.","over18":false},"ScienceTeachers":{"lang":"en","description":"/r/ScienceTeachers is a place for science educators to collaborate on and contribute tips, ideas, labs, and curricula.\n\nWe seek to encourage the sharing of interesting studies, experiments, videos and","over18":false},"chicagofood":{"lang":"en","description":"","over18":false},"TinyLeaders":{"lang":"en","description":"Tiny Leaders is a format created for those who enjoy a challenge when deckbuilding.  Decks are constructed from 49 cards in your 1 commander's colours- the challenge is: everything must be converted m","over18":false},"geegees":{"lang":"en","description":"","over18":false},"SexyTummies":{"lang":"en","description":"","over18":true},"OTMemes":{"lang":"en","description":"Your best memes from the Original Trilogy of Star Wars.","over18":false},"ants":{"lang":"en","description":"Ants are social insects that form colonies. Their success in so many environments has been attributed to their social organisation and their ability to modify habitats, tap resources, and defend thems","over18":false},"hyperlightdrifter":{"lang":"en","description":"Hyper Light Drifter is an action adventure RPG in the vein of the best 16­bit classics, with modernized mechanics and designs on a much grander scale.","over18":false},"Dabs":{"lang":"en","description":"/r/Dabs is the sister sub to /r/CannabisExtracts This community is all inclusive and welcomes any and all dabbing related content!\n\n","over18":false},"FPGA":{"lang":"en","description":"A subreddit for programmable hardware, including topics such as:\n\n* FPGA\n* CPLD\n* Verilog\n* VHDL","over18":false},"capetown":{"lang":"en","description":"A subreddit for everyone from Cape Town, South Africa.","over18":false},"That70sshow":{"lang":"en","description":"A subreddit for fans of That 70's Show.","over18":false},"nongolfers":{"lang":"en","description":"Welcome to r/nongolfers, the web's largest ateeist forum. All topics related to ateeism, anti-teeism and non golf living are welcome here. ","over18":false},"experimentalmusic":{"lang":"en","description":"","over18":false},"oil":{"lang":"en","description":"","over18":false},"DianaMains":{"lang":"en","description":"This subreddit is dedicated to people who mainly play Diana! Tips and tricks welcome, any discussion related to Diana is encouraged.","over18":false},"duluth":{"lang":"en","description":"Subreddit for Duluth Minnesota, the Zenith City.","over18":false},"gonenatural":{"lang":"en","description":"Paused In Solidarity Against Web Tyranny","over18":false},"LeBlancMains":{"lang":"en","description":"A League of Legends gaming community, for fellow LeBlanc lovers!","over18":false},"Defcon":{"lang":"en","description":"The official subreddit of world's largest hacker convention!","over18":false},"thinspo":{"lang":"en","description":"A subreddit dedicated to thinspo/thinspiration photos: inspiration to stay or get thin.","over18":false},"Makemeagif":{"lang":"en","description":"Redditors helping other Redditors to create gifs. ","over18":false},"Toughmudder":{"lang":"en","description":"","over18":false},"dogetipbot":{"lang":null,"description":"Subreddit forbidden","over18":null},"signupsforpay":{"lang":"en","description":"A place to sign up for things in return for money, or pay people to sign up for stuff!","over18":false},"gout":{"lang":"en","description":"","over18":false},"modpiracy":{"lang":"en","description":"Hub for those who want mods to remain free and not become tainted by greed.","over18":false},"PandoranRedCross":{"lang":"en","description":"This subreddit is intended for charitable donations regarding either Borderlands, or Borderlands 2.  If you have any weapons or items you might think someone would want, post them here.  Alternatively","over18":false},"gambling":{"lang":"en","description":"All about Gambling ","over18":false},"Banking":{"lang":"en","description":"A place to discuss the in and outs of banking.  Community, regional investment, commercial or consumer, come on in.","over18":false},"CivPolitics":{"lang":"en","description":"Current events expressed in true Civilization diplomatic glory!","over18":false},"fatbike":{"lang":"en","description":"All things fat bike.  Photos, events, videos, stories...","over18":false},"publichealth":{"lang":"en","description":"In the medical field, clinicians treat diseases and injuries one patient at a time. But in public health, we prevent disease and injury. Public health researchers, practitioners and educators work wit","over18":false},"DACA":{"lang":"en","description":"A Subreddit for DREAMers and their allies. We welcome discussion around current events, policy, and questions for the curious.","over18":false},"ClassicRock":{"lang":"en","description":"Anything relating to rock up to the early 90's. ","over18":false},"MechanicalEngineering":{"lang":"en","description":"","over18":false},"OpenBazaar":{"lang":"en","description":"OpenBazaar is a decentralized marketplace. It is open source and free to use. It uses the MIT License.","over18":false},"Oppression":{"lang":"en","description":"Cancerjerk for shitty moderators","over18":false},"StormfrontorSJW":{"lang":"en","description":"","over18":false},"tequila":{"lang":"en","description":"**[Review Archive](https://docs.google.com/document/d/1P9bumUqCw1FwMLp-0vQWN_j34St9rYW8LFE-ZP_gdxo/edit)**  *Updated 12/2015*","over18":false},"metro2033":{"lang":"en","description":"A home for fans of the Metro book series, the hit games Metro 2033, Metro: Last Light, and the upcoming Metro: Exodus.\n\nLive and prosper in the metro. Just remember to carry plenty of ammo.","over18":false},"amishadowbanned":{"lang":"nl","description":"if you want to check if you're shadowbanned","over18":false},"fightsticks":{"lang":"en","description":"A discussion for anything fightstick related, and as a gallery for posting custom made fightsticks. ","over18":false},"Elite_Dangerous":{"lang":"en","description":"Elite Dangerous by Frontier Developments. Alternative to *that other subreddit*","over18":false},"EliteMiners":{"lang":"en","description":"This is the subreddit for everything related to mining asteroids in the space trading and combat simulator game Elite: Dangerous.","over18":false},"NSFW_KIK":{"lang":"en","description":"Play out your fantasies with others over KIK. Share pics, vids or whatever. It's all you!","over18":true},"BipolarSOs":{"lang":"en","description":"Being in a relationships where one or both partners have bipolar disorder is not easy.  This sub is a place that people can come for advice or just to vent so that we do not affect our significant oth","over18":false},"freebietalk":{"lang":"en","description":"This is the discussion subreddit for the /r/freebies [family](https://www.reddit.com/user/banned_accounts/m/freebies_family).\n\nShare what freebies you've gotten in the mail, suggestions for our subs, ","over18":false},"SheLikesItRough":{"lang":"en","description":"Give it to her rough. ","over18":true},"transadorable":{"lang":"en","description":"Welcome to /r/transadorable, the cutest place on the Internet! This is a subreddit for those who want to post adorable pics of their trans selves, and to look at other adorable people!\n\n\n\n\n","over18":false},"Sexy":{"lang":"en","description":"","over18":true},"godot":{"lang":"en","description":"A community for discussion and support in development with the Godot game engine.","over18":false},"MakeUpAddictionUK":{"lang":"en","description":"A place for UK MUAs to share hauls, tips and everything and anything make-up related!","over18":false},"datasets":{"lang":"en","description":"A place to share, find, and discuss Datasets.","over18":false},"GPGpractice":{"lang":"en","description":"This is a community focusing on learning and using the libre encryption software Gnu Privacy Guard.\n\nAsk a question or post your public key so that other users can send you encrypted messages.","over18":false},"TheReportOfTheWeek":{"lang":"en","description":"Dedicated to the YouTube channel TheReportOfTheWeek hosted by a well dressed young man that reviews various food products and energy drinks.  \n\n-/r/TheReportOfTheWeek Mod Team","over18":false},"Asexual":{"lang":"en","description":"","over18":false},"Anki":{"lang":"en","description":"A discussion forum for people who use the Anki flashcard program. You're welcome to talk about all of the apps and services in the Anki ecosystem here, share resources related to Anki or spaced repeti","over18":false},"panicatthedisco":{"lang":"en","description":"News, videos, and more for Panic! At The Disco","over18":false},"ifttt":{"lang":"en","description":"The semi-official subreddit for the popular automation service IFTTT. \n\nAvailable for iOS and Android!","over18":false},"gentlemanbonersgifs":{"lang":"en","description":"","over18":false},"masturbation":{"lang":"en","description":"Discussion about masturbation.","over18":true},"roastmytrack":{"lang":"en","description":"Roast My Track! No holds barred constructive critique to help others make better music - Post your original tracks/remixes here before they go public!  EDM productions, hip hop beats, experimental mix","over18":false},"assinthong":{"lang":"en","description":"For pictures of booty in thongs. Who doesn't love a nice round ass in a thong? Open for pro models, amateurs and celebrities alike. Gonewild style selfposts are encouraged, and we ask all readers to b","over18":true},"DobermanPinscher":{"lang":"en","description":"","over18":false},"Idaho":{"lang":"en","description":"A subreddit for Idahoans!","over18":false},"RantsFromRetail":{"lang":"en","description":"Similar to /r/talesfromretail but more for ranting about customers, stupid things they do, ranting about managers, colleagues or whomever you wish to rant about that you encounter at work.","over18":false},"teefies":{"lang":"en","description":"The sub dedicated to cute little cat teefs. ","over18":false},"CuckoldCommunity":{"lang":"en","description":"","over18":true},"AskLibertarians":{"lang":"en","description":"A friendly place to learn about, critique, and question libertarians and their views. r/AskLibertarians is for any questions about the philosophy of libertarianism, libertarian movements and tradition","over18":false},"NostalriusBegins":{"lang":"en","description":"Anathema PvP, Elysium PvP, Zeth'Kur PvP and Darrowshire PvE servers subreddit. Here you can discuss and ask questions about everything in regards to vanilla and the Elysium servers. ","over18":false},"heavyvinyl":{"lang":"en","description":"All vinyl, no bullshit.","over18":false},"shopify":{"lang":"en","description":"Shopify - Ecommerce for everyone! \n\nShopify is a multi channel sales platform with online hosting, Amazon, Ebay, support fulfilling yourself or even via dropshipping. \n\nPerfect for those coming from E","over18":false},"love":{"lang":"en","description":"All about love and relationships.","over18":false},"Food_Pantry":{"lang":"en","description":"","over18":false},"zyzz":{"lang":"en","description":"Zyzz","over18":false},"Tf2Scripts":{"lang":"en","description":"Come here for all your TF2 scripting needs. Please don't post anything except content associated with scripting.","over18":false},"ELATeachers":{"lang":"en","description":"A place for English teachers to share ideas and lessons and to brainstorm and collaborate on new curricula.","over18":false},"pokemongoNYC":{"lang":"en","description":"Pokemon GO New York City Community - Augmented Reality MMO community for New York City, NY - trading, meet ups, screen shots, gyms, pokemarts, etc","over18":false},"lux":{"lang":"en","description":"","over18":false},"GlitchInTheMatrix":{"lang":"en","description":"","over18":false},"shootingcars":{"lang":"en","description":"**Shooting Cars** - Anything related to Automotive Photography! \n\n* Tips\n\n* Tutorials\n\n* Behind the Scenes\n\n* Photo Critique \n","over18":false},"Natureisbrutal":{"lang":"en","description":"**The darker side of nature.**","over18":true},"realestateinvesting":{"lang":"en","description":"Interested in Real Estate Investing? You've come to the right place! /r/realestateinvesting is focused on sharing thoughts, experiences, advice and encouraging questions regardless of your real estate","over18":false},"wowraf":{"lang":"en","description":"","over18":false},"hwstartups":{"lang":"en","description":"Welcome to the Hardware Startups sub-Reddit - feel free to post on anything that you think will interest anyone in the community. The idea is that we're a blend of r/DIY and r/startups content - like ","over18":false},"lactation":{"lang":"en","description":"","over18":true},"goddesses":{"lang":"en","description":"Images of Actresses, Models and all manner of female eye-candy. Feel free to share!","over18":false},"processing":{"lang":"en","description":"from [processing.org](processing.org):\nProcessing is a programming language, development environment, and online community. Since 2001, Processing has promoted software literacy (...). Initially creat","over18":false},"mfdoom":{"lang":"en","description":"Remember ALL CAPS when you spell the man name.","over18":false},"Pikmin":{"lang":"en","description":"A place for any news, discussion, and fan works of the Pikmin franchise.","over18":false},"AdoptASilver":{"lang":"en","description":"For those people in CS:GO who are looking for help to increase their rank, or those who are looking to help those less skilled.","over18":false},"phoneswap":{"lang":"en","description":"","over18":false},"policydebate":{"lang":"en","description":"A subreddit for Policy Debate (CX) ","over18":false},"Vore":{"lang":"en","description":"This subreddit is for all vorarephiliacs and curious redditors alike to share any type of vore media, or simply to ask any questions relating to the peculiar fetish. \n\nVorarephilia, or Vore, is a para","over18":true},"viktormains":{"lang":"en","description":"Join the Glorious Evolution!","over18":false},"SluttyConfessions":{"lang":"en","description":"","over18":true},"louie":{"lang":"en","description":"This subreddit is dedicated to discussing Louis CK's FX series \"Louie\".\n\nLouie is an American comedy-drama TV series on the FX network. It is written, directed, edited and produced by show creator sta","over18":false},"trans":{"lang":"en","description":"Trans* related discussion, pictures, links, etc.\n","over18":false},"ccnp":{"lang":"en","description":"","over18":false},"FedoraCoin":{"lang":"en","description":"TiPS (a.k.a. FedoraCoin) is a new state of the art cryptocoin based on the [Tips Fedora meme](http://knowyourmeme.com/memes/tips-fedora).  Our objective is to become the tipping currency of the intern","over18":false},"SRSFunny":{"lang":"en","description":"","over18":false},"G502MasterRace":{"lang":"en","description":"All Logitech gamers welcome.","over18":false},"asianpeoplegifs":{"lang":"en","description":"","over18":false},"ram_trucks":{"lang":"en","description":"A sub for all trucks manufactured by Chrysler.","over18":false},"Sororities":{"lang":"en","description":"A Reddit community for women belonging to sororities and women's fraternities, and those interested in finding out more about them.","over18":false},"steamfriend":{"lang":"en","description":"Trouble finding friends on Valve's life-robber? Look no further!","over18":false},"ausents":{"lang":"en","description":"A subreddit for the ents of Australia, all are welcome!","over18":false},"chillmusic":{"lang":"en","description":"Genre's are irrelevant, a place to talk about music that is best turned down low.","over18":false},"Workoutgonewild":{"lang":"en","description":"WorkOutGoneWild is home to adult amateur fitness buffs to show their dedication and hard work to their bodies (in the gym, on their bikes, in the pool, out on trails, or *wherever* they choose to stay","over18":true},"snowden":{"lang":"en","description":"While Edward Snowden has specifically requested that the story should not be about him, his story is indeed fascinating, and the actions that the United States is taking against him is very revealing ","over18":false},"newyork":{"lang":"en","description":"","over18":false},"finalfantasyx":{"lang":"en","description":"Final Fantasy X: Dedicated to everything that is Final Fantasy X!","over18":false},"BaseBuildingGames":{"lang":"en","description":"Hello there! This is a subreddit focused on base building computer games. If you came here for real estate or fitness advice, you might be in the wrong place.","over18":false},"COD_LFG":{"lang":"en","description":"/r/COD_LFG is the Subreddit used to find Players on the Call of Duty video game series. Please use /r/CallofDuty for all discussion regarding the series.","over18":false},"JaneTheVirginCW":{"lang":"en","description":"Subreddit for the CW show Jane the Virgin. Set in Miami, the series follows the surprising, funny, and romantic events that take place in the life of Jane Villanueva, a hard-working, religious young L","over18":false},"humanism":{"lang":"en","description":"\"I am a humanist, which mean, in part, that I have tried to behave decently without any expectation of rewards or punishments after I'm dead.\"\n\n-Kurt Vonnegut","over18":false},"tableau":{"lang":"en","description":"Tableau makes software for data analysis and visualization that is easy to use and produces beautiful results. /r/Tableau is a place to share news and tips, show off visualizations, and get feedback a","over18":false},"nugs":{"lang":"en","description":"","over18":false},"instantbarbarians":{"lang":"en","description":"For videos where people go wild","over18":false},"TheAvettBrothers":{"lang":"en","description":"Sharing/Discussion on the latest news surrounding The Avett Brothers, a folk-rock, \"new-grass\" band from Concord, NC.","over18":false},"Voltron":{"lang":"en","description":"Voltron: Defender of the Universe","over18":false},"Harambe":{"lang":"en","description":"A subreddit dedicated to the one we love and honor, Harambe.","over18":false},"Saggy":{"lang":"en","description":"","over18":true},"Steam_Link":{"lang":"en","description":"Since /r/steamlink is private and potentially inactive and a lot of users started getting their shipments this week this is a place to discuss and share your experiences.","over18":false},"DiepioPartyLinks":{"lang":"en","description":"Links to Diepio parties","over18":false},"DIYBeauty":{"lang":"en","description":"The science-based DIY recipes for beauty products","over18":false},"OrcsMustDie":{"lang":"en","description":"The Official Orcs Must Die! Subreddit, a place to post and discuss all things Orcs Must Die!","over18":false},"kdramarecommends":{"lang":"en","description":"A place to ask for recommendations!","over18":false},"GTAGivers":{"lang":"en","description":"The easiest place to get money in GTA: Online for free!\n\n\n-Go to GTAGivers.net for more info!\n##Join the official [GTAGivers DropRoom](https://chat.gtagivers.net)!\n","over18":false},"DarkAngels":{"lang":"en","description":"This 18+ reddit is for images and video of gorgeous **college-aged** girls of colour. Nudity is a plus but not a must. Sexy self-shots of natural homegrown amateurs are our favourites, but we also lov","over18":true},"ketouk":{"lang":"en","description":"Keto talk for people in the UK. \n\nGood restaurants, takeaways, fast-food joints, ingredients, snacks, supermarkets, and much more.","over18":false},"vintageobscura":{"lang":"en","description":"* Is it music?\n* Is it obscure? \n* Is it at least 25 years old? \n* Is it amazing?","over18":false},"transporn":{"lang":"en","description":"Trans Porn","over18":true},"Veep":{"lang":"en","description":"A subreddit for fans of the HBO comedy [*Veep*](https://en.wikipedia.org/wiki/Veep_(TV_series\\)).","over18":false},"Drumming":{"lang":"en","description":"A small but mighty subreddit that caters to all things drumming. Staffed by industry professionals, we hope that /r/Drumming offers you information and insight into the art of drumming. ","over18":false},"RevelationMMO":{"lang":"en","description":"Original Revelation Online MMO sub reddit.\n\nWe're proud to be the first, and largest, Revelation Online subreddit. This sub is dedicated to being the go-to-place for all topics Revelation related. If ","over18":false},"hitbox":{"lang":"en","description":"","over18":false},"PornStars":{"lang":"en","description":"The central Reddit hub for everything pornstar related!","over18":true},"YUROP":{"lang":"en","description":"YUROP is the home of the freest health care, the finest food and is the diversest and liberalest of them all.\n","over18":false},"idm":{"lang":"en","description":"Home of Intelligent Dance Music (also known as Braindance).","over18":false},"NarutoNinjaStorm":{"lang":"en","description":"This Subreddit is dedicated to everything that's a Naruto Game (mostly we are focusing on the Storm Series, but that's obvious). It is a place for Naruto fans to communicate, get tips and essentially ","over18":false},"Africa":{"lang":"en","description":"","over18":false},"sfwtrees":{"lang":"en","description":"Trees. No, actual trees. The tall, green things outside.\n\nThis subreddit is for tree- and forestry-related posts. Here are the types of submissions that belong here:\n\n* Trivia on your favorite specie\n","over18":false},"hypnosis":{"lang":"en","description":"/r/Hypnosis is a place to discuss technique, methodology, and experiences of hypnosis.","over18":false},"u_washingtonpost":{"lang":"en","description":"Democracy Dies in Dankness. Official account.\n\nOur award-winning journalists have covered Washington and the world since 1877. Modded by /u/GenePark.","over18":false},"triphop":{"lang":"en","description":"","over18":false},"PennyDreadful":{"lang":"en","description":"Subreddit for everything related to Penny Dreadful, the Showtime television series.","over18":false},"Halo_5_Guardians":{"lang":"en","description":"/r/Halo_5_Guardians is a place where Halo fans can get together, and share the latest information about Halo 5. At the end of the day, we think the community should decide (through upvotes and downvot","over18":false},"StreamersGoneWild":{"lang":"en","description":"Doesn't matter where someone streams, there will always be wild content! Submit some wild content or lay back, chill and fap.","over18":true},"AustinBeer":{"lang":"en","description":"","over18":false},"retiredgif":{"lang":"en","description":"Some gifs are just born with a lack of oxygen.","over18":false},"oddlyterrifying":{"lang":"en","description":"oddly terrifying things","over18":false},"MySummerCar":{"lang":"en","description":"Anything related to My Summer Car -drinking simulator by Royal John Love, AKA ToplessGun.","over18":false},"terrariums":{"lang":"en","description":"","over18":false},"The_Europe":{"lang":"en","description":"Europe ","over18":false},"numenera":{"lang":"en","description":"Anything related to the table-top role-playing game, Numenera.  Includes information & discussion of the game itself, as well as spinoff products such as video games & books set in the Numenera settin","over18":false},"NavalAction":{"lang":"en","description":"For discussion about the game [Naval Action](http://www.navalaction.com/) made by Game Labs. Official forum can be found at http://forum.game-labs.net/","over18":false},"asustransformer":{"lang":"en","description":"","over18":false},"HungryArtists":{"lang":"en","description":"HungryArtists is an online community of freelance artists, designers and illustrators all looking to create custom art commissions for you!  Commission an artist quickly and easily, just create an acc","over18":false},"Nicegirls":{"lang":"en","description":"/r/nicegirls\n\nLike /r/niceguys but different","over18":false},"UnderTheDome":{"lang":"en","description":"Subreddit for the TV series, Under the Dome. Based on the Stephen King novel of the same name. Currently airing on CBS.","over18":false},"DayZmod":{"lang":"en","description":"Welcome to /r/DayZmod, where we focus on all things DayZ Mod. \n\nDiscuss updates, swap stories, post videos and pictures,  promote your server or get troubleshooting help.\n\nPlease message the mods if y","over18":false},"proper":{"lang":"en","description":"","over18":false},"FreeKarmas":{"lang":null,"description":"Subreddit no longer exists","over18":null},"AZURE":{"lang":"en","description":"","over18":false},"miraculousladybug":{"lang":"en","description":"Miraculous Ladybug is a Japanese-French-Korean CGI animated series. It is co-produced by Zagtoon, Method Animation, and Toei Animation.\n\nSet in modern-day Paris, the series focuses on a teenaged girl ","over18":false},"Adirondacks":{"lang":"en","description":"The Adirondack Park is the largest publicly protected area throughout the entire United States.  More than 2.5 million acres of land in the Adirondack Park has been protected by New York State since 1","over18":false},"ShitThe_DonaldSays":{"lang":"en","description":"Did they start a fire again?","over18":false},"halospv3":{"lang":"en","description":"Home of the SPV3 project for Halo CE","over18":false},"TallGoneWild":{"lang":"en","description":"If you're familiar with the feeling of your heart skipping when passing by an attractive tall person, and you're asking for more (or sharing some of your own bad self), this is the place for you! Welc","over18":true},"Trackballs":{"lang":"en","description":"A place to discuss the weird and wonderful world of that rodent alternative, the TRACKBALL!","over18":false},"TapSportsBaseball":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Rolla":{"lang":"en","description":"","over18":false},"40plusGoneWild":{"lang":"en","description":"For everyone in their 40s and later that still have their sexy wild side.\n","over18":true},"stockings":{"lang":"en","description":"In celebration of stockings and the sexy women who wear them!","over18":true},"jellybeantoes":{"lang":"en","description":"Those foot pads are so cute, and you want to touch them... but, *it's a trap!*","over18":false},"tippytaps":{"lang":"en","description":"","over18":false},"lovegaymale":{"lang":"en","description":"A community for gay males to talk about news, post pictures, post videos, and share SFW/NSFW content.","over18":true},"bboy":{"lang":"en","description":"A community for anyone interested in b-boying/b-girling (or as more know it: breakdancing). Come to watch videos, see pictures, or discuss about the dance and culture.","over18":false},"MontgomeryCountyMD":{"lang":"en","description":"Subreddit for Montgomery County, MD (MoCo)","over18":false},"Wellworn":{"lang":"en","description":"A subreddit dedicated to the tools that take a beating. ","over18":false},"JessicaJones":{"lang":"en","description":"Subreddit for Marvel character Jessica Jones and the corresponding Netflix series. Series is out now on Netflix!","over18":false},"Karting":{"lang":"en","description":"We are a sub-reddit who loves karts, karting and the need for speed!","over18":false},"DeepSpaceNine":{"lang":"en","description":"The subreddit for everything Star Trek: Deep Space Nine!\nFeel free to post pics, videos, articles, your opinions & questions... anything to do with the show or the actors.","over18":false},"baconit":{"lang":"en","description":"The highest rated reddit client for Windows Phone has been rewritten from the ground up and is now available for all Windows 10 devices (windows mobile, desktop, tablet, Xbox and HoloLens (soon!)). No","over18":false},"whoselineisitanyway":{"lang":"en","description":"Whose Line Is It Anyway (WLIIA) is a short-form improvisational comedy television show that aired on Channel 4 in the UK and ABC in the United States. Featuring regular performers Drew Carey, Colin Mo","over18":false},"Pottermore":{"lang":"en","description":"Subreddit dedicated to J.K. Rowling's Pottermore","over18":false},"TheDivision_LFG":{"lang":"en","description":"The Matchmaking subreddit for /r/TheDivision. Includes PvE and PvP activities. For clan recruitment please use /r/TheDivisionClans.","over18":false},"falloutshelter":{"lang":"en","description":"A Subreddit For Discussion of and Information about Fallout Shelter, the iOS and Android Vault Simulation Game Based (Non-Canonically) on the Fallout Series.\n\n","over18":false},"Munchkin":{"lang":"en","description":"","over18":false},"formcheck":{"lang":"en","description":"","over18":false},"dailydraw":{"lang":"en","description":"Our mission is to draw something every day, whether we're feeling inspired or not. Each day a prompt is posted and anyone is free to draw and submit their drawings.","over18":false},"AverageBattlestations":{"lang":"en","description":"","over18":false},"Mobpsycho100":{"lang":"en","description":"Welcome to the Mob Psycho 100 subreddit!","over18":false},"RivenFrame":{"lang":"en","description":"> We have closed down and merged with /r/WarTrade. Come hang out. Auto-flairing and tags from here have merged with there. Send all questions to /u/toraba if you are missing something or have a questi","over18":false},"WackyTicTacs":{"lang":"en","description":"I have seen the face of god and it was weeping.\n\nBanana.","over18":false},"alienisolation":{"lang":"en","description":"A place for fans of Alien: Isolation, a game by The Creative Assembly and SEGA.","over18":false},"flowers":{"lang":"en","description":"","over18":false},"appliancerepair":{"lang":"en","description":"Appliance repair advice and solutions from do-it-yourselfers and experts alike. Post your questions and get answers to all of your burning appliance questions. This sub is geared toward homeowners see","over18":false},"TwoSentenceHorror":{"lang":"en","description":"Give us your scariest story in two sentences (or less)!  ","over18":false},"analytics":{"lang":"en","description":"Dedicated to web analytics, data and business analytics. We're here to discuss analysis of data, learning of skills and implementation of web analytics. ","over18":false},"AbyssRium":{"lang":"en","description":"Unofficial community page for the mobile game AbyssRium AKA \"Tap Tap Fish\". Post pictures of your tank, ask questions, share discoveries, or post just about anything about the game.","over18":false},"redneckengineering":{"lang":"en","description":"yurp","over18":false},"HTC10":{"lang":"en","description":"Subreddit for the HTC 10, HTC's flagship device.","over18":false},"GearTrade":{"lang":"en","description":"/r/GearTrade is a subreddit for redditors to trade their outdoor gear. Generally, this includes things related to hiking, camping, backpacking, skiing, hunting, and other \"backcountry\" uses. However, ","over18":false},"winstonsalem":{"lang":"en","description":"Welcome to the official Winston-Salem, NC subreddit! Here, you may find and submit links and posts all about Winston-Salem, NC, and the surrounding area.","over18":false},"fordfusion":{"lang":"en","description":"A place for owners and fans of the Ford Fusion.","over18":false},"ChicoCA":{"lang":"en","description":"Live in Chico, California? This is your Subreddit. Post about upcoming events, interesting news, anything relevant.","over18":false},"blackchickswhitedicks":{"lang":"en","description":"The biggest interracial sub on reddit, dedicated to the hottest genre in porn: Black chicks with White dicks.","over18":true},"NSFW_Japan":{"lang":"en","description":"NSFW Japan - nude or barely clothed ladies from Japan. You're welcome to share gifs, galleries, news, videos, funny pics, clips, flash games or art that contain pretty Japanese girls naked. This subre","over18":true},"2healthbars":{"lang":"en","description":"A subreddit dedicated to the 2 health bar's phenomenon:\n''When you think you've killed a boss in a video game but then it starts a new phase with another health bar.''\n\n","over18":false},"GalliumOS":{"lang":"en","description":"GalliumOS - A fast and lightweight Linux distro for ChromeOS devices","over18":false},"Jaxmains":{"lang":"en","description":"A League of Legends subreddit dedicated to Jax the Grandmaster at Arms. 1v9 qq","over18":false},"Pokeents":{"lang":"en","description":"","over18":false},"WritersGroup":{"lang":"en","description":"","over18":false},"redrising":{"lang":"en","description":"A subreddit dedicated to the novels by Pierce Brown in the Red Rising trilogy.","over18":false},"melodichardcore":{"lang":"en","description":"Melodic Hardcore is a subgenre of Hardcore Punk with a strong emphasis on melody in its guitar work. It is defined by the fast drum patterns and shouting vocals typical of hardcore, along with chiming","over18":false},"SXSW":{"lang":"en","description":"","over18":false},"vintagecomputing":{"lang":"en","description":"","over18":false},"subway":{"lang":"en","description":"The subreddit about subway sandwiches.","over18":false},"Asthma":{"lang":"en","description":"Reddit's asthma forum.","over18":false},"ElgatoGaming":{"lang":"en","description":"The official Elgato Gaming subreddit. Talk with fellow content creators about tips, tricks and everything Elgato Gaming. \n","over18":false},"Pyongyang":{"lang":"en","description":"/r/Pyongyang features information curated by the [Committee for Cultural Relations with Foreign Countries](http://www.friend.com.kp/) of the [Democratic People's Republic of Korea](http://www.korea-dp","over18":false},"FeelsLikeTheFirstTime":{"lang":"en","description":"A sub for first time experiences. SFW only. ","over18":false},"flask":{"lang":"en","description":"Flask is a Python micro-framework for web development. Flask is easy to get started and a great way to build web sites and web applications.","over18":false},"EggsInc":{"lang":"en","description":"Unofficial subreddit for the  game Egg, Inc.  created by Auxbrain Inc. Feel free to come by if you play the game and have any questions. ","over18":false},"deutschland":{"lang":"de","description":"Das Subreddit das sich abgeschafft hat, /r/deutschland","over18":false},"metalgear":{"lang":"en","description":"For discussion, news, and a general community for everything related to the Metal Gear video-game franchise","over18":false},"diydrones":{"lang":"en","description":"","over18":false},"booty":{"lang":"en","description":"For nice female booty and bubble butts!","over18":true},"PokemonGoHouston":{"lang":"en","description":"This is a place for Houston Trainers to come and meet. Let's make Houston the very best. Like no city ever was! To catch them will be our test! \n[](/sidebar)","over18":false},"hebrew":{"lang":"en","description":"","over18":false},"folkmetal":{"lang":"en","description":"Folk metal is a sub-genre of heavy metal that developed in Europe during the 1990s. As the name suggests, the genre is a fusion of heavy metal with traditional folk music. This includes the widespread","over18":false},"SlyGifs":{"lang":"en","description":"Made a mistake? Nah; you're smooth!","over18":false},"JessicaNigri2":{"lang":null,"description":"Subreddit no longer exists","over18":null},"drumline":{"lang":"en","description":"[](https://www.reddit.com/r/NoParticipation/wiki/intro)","over18":false},"synthrecipes":{"lang":"en","description":"This is a subreddit for the sound designers, by the sound designers. Here you'll find requests, insights, and recipes for your favorite synths. Enjoy!","over18":false},"txstate":{"lang":"en","description":"Reddit home of Texas State University Bobcats! Students, faculty, staff and alumni welcome. A place to find information, share stories and discover the great things about San Marcos and Texas State.","over18":false},"html5":{"lang":"en","description":"","over18":false},"translation":{"lang":"en","description":"Translation requests and discussion about translation\n","over18":false},"plano":{"lang":"en","description":"Plano, Texas, A City of Excellence. Plano enjoys a reputation as one of the most desirable cities to live and work in. Plano was recently named as one of the “Safest Cities in America” and “Best Run C","over18":false},"DebunkThis":{"lang":"en","description":"We are a subreddit dedicated to finding the truth. It is our goal to shed light over what people mistake for fact. Bring your theories, bring your fables.","over18":false},"ipv6":{"lang":"en","description":"A reddit dedicated to the discussion of everything IPv6.","over18":false},"AvPD":{"lang":"en","description":"Place for people to discuss Avoidant personality disorder. Discussion can be about personal stories, treatment ideas, support for yourself or others, and ideas with how to deal with your own problems ","over18":false},"Salvia":{"lang":"en","description":"A place to discuss Salvia divinorum, a psychoactive plant traditionally used by Mazatec shamans.","over18":false},"macsysadmin":{"lang":"en","description":"","over18":false},"PinkOmega":{"lang":"en","description":"GEORGE MILLER: MUSICIAN, ENTERTAINER, ARTIST","over18":false},"sufficiencybot":{"lang":null,"description":"Subreddit forbidden","over18":null},"bakedart":{"lang":"en","description":"","over18":false},"lolphp":{"lang":"en","description":"","over18":false},"LawFirm":{"lang":"en","description":"Discussion, issues, best practices, and support for lawyers practicing either solo or in a small firm.  A subreddit for the business and practice of law, catering to lawyers without the support networ","over18":false},"shorthairchicks":{"lang":"en","description":"A NSFW media subreddit of women with short or no hair.","over18":true},"thepunisher":{"lang":"en","description":"A subreddit for fans of The Punisher and Punisher related content.","over18":false},"ExpandDong":{"lang":"en","description":"Expand your dongs here in feature length!","over18":false},"consolerepair":{"lang":"en","description":"","over18":false},"SpaceDandy":{"lang":"en","description":"This subreddit is for the anime series by Shinichiro Watanabe and BONES Studio, Space ☆ Dandy!","over18":false},"MTGPuzzleQuest":{"lang":"en","description":"Magic the Gathering: Puzzle Quest is now available!  This will be the place for news and info regarding the game!","over18":false},"ShittyAnimalFacts":{"lang":"en","description":"Shitty facts about animals, from Trashpandas to Slowbears to Jackdaws. Cute pictures accompanied by shitty titles, like \"TIL Zoos can only have one emperor penguin at a time; any more leads to a polit","over18":false},"skincareexchange":{"lang":"en","description":"An exchange place for all of your skincare products!","over18":false},"flatearthsociety":{"lang":"en","description":"A gathering place for all those who are enlightened and those who seek enlightenment","over18":false},"weightwatchers":{"lang":"en","description":"A community for news, support and helpful links regarding Weight Watchers.","over18":false},"britishmilitary":{"lang":"en","description":"A subreddit for all of those in, interested in or have served in the British Armed Forces of any branch.\n\nThis subreddit is for questions about the British Armed Forces, experiences (plenty of sandbag","over18":false},"ISTJ":{"lang":"en","description":"","over18":false},"lastfm":{"lang":"en","description":"I like music. You like music. Lets share that music.","over18":false},"thewitcher3":{"lang":"en","description":"For everything Witcher related.","over18":false},"Hugeboobshardcore":{"lang":"en","description":"For the appreciation of busty hardcore performers. ","over18":true},"StarWarsUprising":{"lang":"en","description":"A subreddit dedicated to the free to play mobile game *Star Wars: Uprising*, set in the immediate aftermath of *Return of the Jedi*. We are aiming to become the #1 social network for up to date inform","over18":false},"UTK":{"lang":"en","description":"","over18":false},"PSBF":{"lang":"en","description":"Subreddit dedicated to Battlefield on Playstation","over18":false},"FixMyPrint":{"lang":"en","description":"I'm hoping this subreddit will help serve the 3D printing community by providing tips based on uploaded bad prints, and hopefully their solutions.  I imagine we can also search these images to help di","over18":false},"SFWPornGifs":{"lang":"en","description":"","over18":false},"DontPanic":{"lang":"en","description":"This subreddit is exclusively for anything related to the Hitchhiker's Guide to the Galaxy books, movie, or radio series.","over18":false},"BeamNG":{"lang":"en","description":"BeamNG is a young startup company developing a state of the art real time physics simulation engine and an accompanying game: [BeamNG.drive](http://beamng.com/alpha).","over18":false},"winkhub":{"lang":"en","description":"All about the Wink system for Home Automation. Includes discussion on the App, Hub, Relay, supported/unsupported products, and hacking the Hub for local use.","over18":false},"ANGEL":{"lang":"en","description":"We help the hopeless!  The path to redemption is never an easy one.","over18":false},"mainecoons":{"lang":"en","description":"Owners, lovers, and all things related to the awesome cat species: The Maine Coon!","over18":false},"obs":{"lang":"en","description":"Free, open source live streaming and recording software for Windows, MacOS and Linux","over18":false},"Bozeman":{"lang":"en","description":"The 2010 census put Bozeman's population at 37,280 making it the fourth largest city in the state of Montana.","over18":false},"OneNote":{"lang":"en","description":"","over18":false},"LINKTrader":{"lang":"en","description":"An unofficial Chainlink community. This subreddit is for discussion of all things relating to Chainlink and the LINK token including operating a node, upcoming events, recent news, and market speculat","over18":false},"bandmembers":{"lang":"en","description":"This is a place for musicians to connect with other musicians. Feel free to share your work, connect with other bands, share tips, or ask for help.","over18":false},"Petioles":{"lang":"en","description":"Petioles is a small positive community for those interested in responsible consumption of Cannabis. Discussions include everything from tolerance breaks, to personal feelings and cravings.","over18":false},"ScottPilgrim":{"lang":"en","description":"This subreddit is dedicated to all things Scott Pilgrim. Including the graphic novel series by Bryan Lee O'Malley, the film Scott Pilgrim vs. the World by Edgar Wright starring Michael Cera and Mary E","over18":false},"ZombieSurvivalTactics":{"lang":"en","description":"**/r/ZombieSurvivalTactics** - a community for discussion about survival against zombies. *We're ready. Are you?*","over18":false},"Anger":{"lang":"en","description":"Anger, an affliction that is often misunderstood, leaves those who suffer from it in a limbo of social unacceptance. Find the support you need here.","over18":false},"kicksmarket":{"lang":"en","description":"A REAL SNEAKER MARKETPLACE","over18":false},"PremierLeague":{"lang":"en","description":"The Official Barclays Premier League Subreddit.","over18":false},"SAVEBRENDAN":{"lang":"en","description":"* /r/SAVEBRENDAN   is back. We will continue to fight for our hero.\n\nBrendan Fraser is the hero we need in these dark times, and we aim to bring him back!\n\n\n[#BrendanFraserForever](https://www.youtube","over18":false},"Drumpf":{"lang":"en","description":"There are already too many Trump subreddits. Let's consolidate to subreddits like /r/esist, /r/Political_Revolution or the several other anti-Trump subreddits instead of becoming what we hated about T","over18":false},"Blind":{"lang":"en","description":"Welcome to the hub for blind and visually impaired redditors. We are a support community for people who are blind, visually impaired, those who work with the blind, and those who are just curious.","over18":false},"LeftWithoutEdge":{"lang":"en","description":"A place to discuss far-left politics calmly, rationally, and pleasantly","over18":false},"castmeas":{"lang":"en","description":"See What Kind of Role You Would be Cast For!","over18":false},"hamburg":{"lang":"de","description":"Für alles in und um Hamburg, vorzugsweise in deutscher Sprache","over18":false},"timetravel":{"lang":"en","description":"Time travel reddit will exist yesterday","over18":false},"valiantforce":{"lang":"en","description":"A Tactical RPG for iOS and Android.","over18":false},"deadcells":{"lang":"en","description":"Dead Cells is an action/platformer/roguelite game developed by Motion Twin, a French independent developer based in Bordeaux. It's available on all current gaming platforms.\n\nThis subreddit is here fo","over18":false},"cruisers":{"lang":"en","description":"A subreddit for those who enjoy riding, discussing and dreaming about Cruiser Motorcycles!","over18":false},"computervision":{"lang":"en","description":"","over18":false},"humanresources":{"lang":"en","description":"A subreddit for Human Resources professionals: answering difficult questions, plugging you into appropriate resources, and monitoring your own development.","over18":false},"axolotls":{"lang":"en","description":"The place for anything axolotl!  ","over18":false},"300BLK":{"lang":"en","description":"","over18":false},"diysound":{"lang":"en","description":"A better place to discuss DIY speakers, headphones, amps, share plans and schematics, and link to interesting projects.\n\n\n","over18":false},"GRE":{"lang":"en","description":"A place to discuss the GRE (Graduate Record Examination). ","over18":false},"Kairosoft":{"lang":"en","description":"**/r/Kairosoft** is a subreddit for Android and iOS games made by Kairosoft.","over18":false},"tabletop":{"lang":"en","description":"","over18":false},"AbraxasMarket":{"lang":null,"description":"Subreddit no longer exists","over18":null},"WarOnComcast":{"lang":"en","description":"People rising up against a harmful and growing monopoly. They are trying to take our Internet. We will not let them.","over18":false},"DJSetups":{"lang":"en","description":"Show off your DJ setup!","over18":false},"JacksFilms":{"lang":"en","description":"A subreddit dedicated to the well known YouTuber, Jack Douglass!\n\nPost almost anything you want, as long as it's related to Jack!\n","over18":false},"GoldenSun":{"lang":"en","description":"A subreddit for fans of Golden Sun!","over18":false},"GuysFromBehind":{"lang":"en","description":"Shots of guys from behind while they're fucking/sucking.","over18":true},"boburnham":{"lang":"en","description":"We are a community devoted to the musical comedian Bo Burnham.","over18":false},"iPhoneX":{"lang":"en","description":"A subreddit all about Apple's newest and greatest phone, the iPhone X.","over18":false},"Nsfw_Amateurs":{"lang":"en","description":"Subreddit dedicated to bring you Amateur Girls Videos and Pictures.\nHere you will find Slutty Teens gone wild, Cukcold Wives cheating their husbands and Mature Amateur Moms fucking younger guys, Best ","over18":true},"instantpot":{"lang":"en","description":"A place for Instant Pot owners to discuss, debate, divulge, digress and digest. ","over18":false},"MadMaxGame":{"lang":"en","description":"A subreddit for the new Mad Max game!","over18":false},"InterdimensionalCable":{"lang":"en","description":"","over18":false},"timetolegalize":{"lang":"en","description":"A subreddit for those that feel cannabis should be re-legalized and regulated","over18":false},"Synesthesia":{"lang":"en","description":"Synesthesia (n.) - a neurological phenomenon in which stimulation of one sensory or cognitive pathway leads to automatic, involuntary experiences in another; Experienced as a \"blending\" of the senses.","over18":false},"McMaster":{"lang":"en","description":"A subreddit for students, staff, alumni, and anyone else at McMaster University in Hamilton, Canada.","over18":false},"NewMexico":{"lang":"en","description":"","over18":false},"mmo":{"lang":"en","description":"Discussion and news about everything MMO. ","over18":false},"AusSkincare":{"lang":"en","description":"A place for Australian and NZ-specific skincare discussion!","over18":false},"animeplot":{"lang":"en","description":"Home of anime fanservice.","over18":true},"IndieDev":{"lang":"en","description":"/r/indiedev is for indie developers and gamers to share whatever they want (be it game development, their favorite games or just some cool images, GIFs or music from an indie game) in a casual communi","over18":false},"cakeday":{"lang":"en","description":"###Hey reddit!\n\nThis is the community where you can celebrate your cakeday! Post a link and enjoy your gift of karma!\n\n*Not sure when your cakeday is? [Click here.](http://www.redditcakeday.com/)*","over18":false},"antisocialsocialclub":{"lang":"en","description":"Join the club","over18":false},"amv":{"lang":"en","description":"A subreddit where people can share and create music videos made with clips from various Japanese animated movies and tv shows, also known as anime.","over18":false},"Megumin":{"lang":"en","description":"Megumin from Kono Subarashii Sekai ni Shukufuku wo!","over18":false},"SuperMarioRun":{"lang":"en","description":"Subreddit dedicated to Nintendo's latest mobile app Super Mario Run!","over18":false},"SUBREDDITNAME":{"lang":"en","description":"","over18":false},"assignedmale":{"lang":"en","description":"The subreddit that spends several hours editing sexual explicit content into a webcomic about a trans kid.","over18":false},"EBEs":{"lang":"en","description":"Discussions regarding the existence of life - big or small - outside planet Earth. ","over18":false},"AndroidPreviews":{"lang":"en","description":"Post your questions, feedback, ideas, and just about anything else about the latest Android Preview and Android Beta here! Posts about dev/alpha/beta apps are welcomed here as well (although you may w","over18":false},"UpvotedBecauseGirl":{"lang":"en","description":"A meta Sub-Reddit for submitting links that were upvoted simply because there was a woman in it!\n\nDickbutts beware.","over18":false},"fyrefestival":{"lang":"en","description":"subreddit about fyrefestival.com","over18":false},"progressive_islam":{"lang":"en","description":"Progressive Islam is a place for liberal, socialist, progressive, anarchist, and communist Muslims of all sects and schools of thought. We seek to foster an atmosphere of understanding, tolerance, and","over18":false},"luchaunderground":{"lang":"en","description":"Discussion of Lucha Underground on the El Rey Network","over18":false},"sanmarcos":{"lang":"en","description":"","over18":false},"gamedetectives":{"lang":"en","description":"Solving ARGs since 2015!","over18":false},"magicbuilding":{"lang":"en","description":"The subreddit for discussion about building magic systems for fantasy worlds.","over18":false},"shittingadvice":{"lang":"en","description":"We are just redditors who may or may not have advice for you about your shits. We are not doctors and advice here is not to be considered a substitute for or supersede sound medical advice from a lice","over18":false},"ShittyTodayILearned":{"lang":"en","description":"Where all the shitty facts converge. \nSponsored By Yahoo Answers!!","over18":false},"pokemonteams":{"lang":"en","description":"","over18":false},"biggreenegg":{"lang":"en","description":"","over18":false},"arma3":{"lang":"en","description":"","over18":false},"badpeoplestories":{"lang":"en","description":"A place to tell stories of terrible, rude, offensive, dishonest, or deceitful people that don't fit in other subs. Go on, let it out.\n\nAn offshoot of /r/fatpeoplestories.","over18":false},"ProtonMail":{"lang":"en","description":"Official subreddit for ProtonMail, an secure email service based in Switzerland. ProtonMail is privacy-focused, uses end-to-end encryption, and offers a clean user interface and full support for PGP a","over18":false},"algorithms":{"lang":"en","description":"Computer Science for Computer Scientists","over18":false},"FinalFantasyExplorers":{"lang":"en","description":"A Place to Talk About the Game","over18":false},"tortoise":{"lang":"en","description":"~A place (for tortoise owners, lovers, and enthusiasts) to share pics, videos, advice, and anything else related to this awesome animal!","over18":false},"KaynMains":{"lang":"en","description":"Kayn Mains","over18":false},"IDmydog":{"lang":"en","description":"Post pictures of your dog, and we'll try to determine its breed.","over18":false},"Gentoo":{"lang":"en","description":"The place to find relevant information on Gentoo Linux","over18":false},"girlskissing":{"lang":"en","description":"Pics of girls kissing each other.  18+ NSFW (nudity, softcore)","over18":true},"Trichsters":{"lang":"en","description":"","over18":false},"WorldsAdrift":{"lang":"en","description":"Welcome, this is a subreddit dedicated to Worlds Adrift, an unscripted, MMO sandbox game with real-time physics.","over18":false},"nem":{"lang":"en","description":"NEM is a groundbreaking crypto-currency that gives control of their economy back to the people and establishes them as sovereigns over their own destiny.","over18":false},"Soda":{"lang":"en","description":"","over18":false},"FitAndNatural":{"lang":"en","description":"This is the place for good quality photos and videos of attractive **fit** females, including athletes, fitness models, dancers, figure and physique competitors, etc., who have **natural** breasts.","over18":false},"ToobAmps":{"lang":"en","description":"A place for tone seekers to discuss tube amps and analog goodies. Vintage or new, boutique or not, let's talk about the sweet tone makers.","over18":false},"VFIO":{"lang":"en","description":"This is a subreddit to discuss all things related to VFIO and gaming on virtual machines in general. ","over18":false},"yesyesyesno":{"lang":"en","description":"Things that make you go YES YES, but end badly","over18":false},"Lolicons":{"lang":null,"description":"Subreddit no longer exists","over18":null},"VeryExpensive":{"lang":"en","description":"Things that are very expensive. Things that the average person can't afford.","over18":false},"StanleyKubrick":{"lang":"en","description":"The largest Stanley Kubrick Resource on the internet","over18":false},"EmmaStone":{"lang":"en","description":"","over18":false},"Spintires":{"lang":"en","description":"This is one of the most active communities dedicated to the Off-Road simulation game SpinTires. \n","over18":false},"g2a":{"lang":"en","description":"The subreddit for g2a marketplace.","over18":false},"ipadmusic":{"lang":"en","description":"","over18":false},"morbidlybeautiful":{"lang":"en","description":"/r/morbidlybeautiful is for people who can find the beauty in morbid images. Come to look. Come to appreciate. \n\n","over18":false},"restofthefuckingowl":{"lang":"en","description":"For instructions that are less than in depth","over18":false},"40k":{"lang":"en","description":"","over18":false},"UnderTail":{"lang":"en","description":"A place for debauched people to put their Undertale Rule 34 artwork.","over18":true},"SciFiScroll":{"lang":"en","description":"sci-fi, scifi, science fiction, fantasy, horror, movies, television, tv, Star Trek, Babylon 5, X-Files, Star Wars, The Strain, The Walking Dead, Expanse","over18":false},"dxracer":{"lang":null,"description":"Subreddit forbidden","over18":null},"Page3Glamour":{"lang":"en","description":"British glamour models with their tits out. Busty and topless. Page 3, magazines and websites like May Contain Girl. Big boobs! \nLucy Pinder, Keeley Hazell, Rosie Jones, Rhian Sugden, Sophie Howard, H","over18":true},"MasterofNone":{"lang":"en","description":"For discussion of the Netflix Original Series \"Master of None\"","over18":false},"youtubecomments":{"lang":"en","description":"The best YouTube comments. Funny, crazy inspirational, weird or simply awesome, submit them here.","over18":false},"lansing":{"lang":"en","description":"A subreddit for the Greater Lansing (Michigan) Community","over18":false},"Veterinary":{"lang":"en","description":"","over18":false},"AskACountry":{"lang":"en","description":"","over18":false},"90sHipHop":{"lang":"en","description":"A place to share '90s rap and hip-hop music.","over18":false},"DrDisrespectLive":{"lang":"en","description":"The Official Subreddit for the Twitch Streamer, Dr DisRespect.","over18":false},"DrawMyTattoo":{"lang":"en","description":"Want someone to draw your tattoo for you? Want to draw a tattoo? This area brings the two together. ","over18":false},"BBCSluts":{"lang":"en","description":" Reddit's #1 BBC Source.\nThis subreddit is for women/cuckold husbands, Sissies, Gay, Str8, Trans.. (any gender/race) who enjoy sex with Big Black Dicks. Real BBC Lovers Stories, Photos, Audios, Videos","over18":true},"coloringcorruptions":{"lang":"en","description":"Get some crayons and a coloring book to turn adorable pictures into twisted and or hilarious corruptions of their former selves.","over18":false},"eGPU":{"lang":"en","description":"eGPU: External Graphics Discussion","over18":false},"GameAudio":{"lang":"en","description":"***Game Audio***\n\nFor those interested in the craft of making sound / audio for games.  This could encompass music, sound design, voice and just plain ol' middleware!  Ask about about Unity and Unreal","over18":false},"ThatPeelingFeeling":{"lang":"en","description":"A place to share in the unique joy that is peeling the plastic off of new objects.","over18":false},"PlasticSurgery":{"lang":"en","description":"*****\nWelcome to /r/PlasticSurgery! This subreddit is a general hub for discussion, before and after posts, stories, experiences, and general information about cosmetic, or plastic, surgeries of all s","over18":false},"Tendies":{"lang":"en","description":"Tendies: For good little boys\n\nMust have AT LEAST 100GBP. No normies allowed.","over18":false},"Shambhala":{"lang":"en","description":"","over18":false},"folk":{"lang":"en","description":"","over18":false},"DANMAG":{"lang":"da","description":"Et subreddit til at hylde Kongeriget danmark!","over18":false},"RedactedCharts":{"lang":"en","description":"[Redacted]Charts: Guess The Legend!","over18":false},"mathematics":{"lang":"en","description":"/r/mathematics is a subreddit dedicated to focused questions and discussion concerning mathematics.","over18":false},"Antitheism":{"lang":"en","description":"","over18":false},"Curling":{"lang":"en","description":"Curling is an International Olympic sport in which 42lb granite stones are slid along an icy surface to come to rest atop a painted target.  In some ways similar to Boccie ball or Shuffleboard, curlin","over18":false},"TheLastJedi":{"lang":"en","description":"","over18":false},"AskDrugNerds":{"lang":"en","description":"Do some research, ask a question, get an answer.\n\nDo some dreaming, ask a question, get a ban.","over18":false},"energy_work":{"lang":"en","description":"This purpose of this community is to explore human energy in all of its facets.  Out of body experiences, energy healing, energetic connections between people, psychic work and everything in between. ","over18":false},"suctiondildos":{"lang":"en","description":"A space for suction cup dildos. NSFW","over18":true},"confusing_perspective":{"lang":"en","description":"","over18":false},"Spore":{"lang":"en","description":"The subreddit dedicated to the single-player god game developed by Maxis, we welcome new players who haven't played before and experienced players too!","over18":false},"GayGifs":{"lang":"en","description":"/r/GayGifs is a community for sharing gay animated porn gifs.","over18":true},"GhostAdventures":{"lang":"en","description":"Ghost Adventures, for the discussion of the show, the locations, the cast or anything else related.","over18":false},"mixes":{"lang":"en","description":"From dubstep, techno, drum'n'bass, house, and experimental.","over18":false},"SexyButNotPorn":{"lang":"en","description":"r/SexyButNotPorn is for sexy, well-composed, and artistic images that are as beautiful as they are erotic. ","over18":true},"aa_cups":{"lang":"en","description":"For the privileged few that recognize the beauty in ladies with smaller than average breasts, namely AA cups and smaller ONLY, displayed through photo and video. No exceptions, rules strictly enforced","over18":true},"SymmetraMains":{"lang":"en","description":"The place where \"Indian Tech Support\" and \"Gold Damage Done\" cross.","over18":false},"pools":{"lang":"en","description":"","over18":false},"IBM":{"lang":"en","description":"News and discussions related to IBM","over18":false},"sunlesssea":{"lang":"en","description":"Subreddit for the newly kickstarted 'Sunless Sea' from Failbetter Games - creators of Fallen London","over18":false},"Vans":{"lang":"en","description":"A community for lovers of Vans shoes.","over18":false},"MapsWithoutNZ":{"lang":"en","description":"Maps without New Zealand on them","over18":false},"vcu":{"lang":"en","description":"A Reddit for VCU Students, Faculty, and Rams fans!","over18":false},"Sourdough":{"lang":"en","description":"Want to learn how to make and bake sourdough? Love the aroma, taste, and texture of homemade bread? If yes, this is your subreddit!  Ask questions, start discussions, share recipes, photos, baking tip","over18":false},"bigbangcomics":{"lang":null,"description":"Subreddit forbidden","over18":null},"Teleshits":{"lang":"en","description":"Your Childhood just had an Abortion.","over18":false},"jakanddaxter":{"lang":"en","description":"The PlayStation-Exclusive video game series Jak and Daxter developed by Naughty Dog.","over18":false},"FrugalMaleFashionCDN":{"lang":"en","description":"","over18":false},"KFTPRDT":{"lang":"en","description":"","over18":false},"Roofing":{"lang":"en","description":"A place for roofing pics, video and stories.\n\n\n\n","over18":false},"MotorsportManagerPC":{"lang":"it","description":"Motorsport Manager, a PC game developed by Playsport Games and published by SEGA. Available on Steam.","over18":false},"Splintercell":{"lang":"en","description":"A subreddit to discuss anything and everything related to Tom Clancy's Splinter Cell.\n\nTom Clancy's Splinter Cell is a series of award-winning stealth video games developed by Ubisoft. The protagonist","over18":false},"letsplaycollab":{"lang":"en","description":"A place to organize Let's Play Collaborations, ask any questions you may have, and get support for any issues involved in Collaborating a Let's Play.","over18":false},"yuri":{"lang":"en","description":"Welcome to /r/yuri, a place to post and celebrate yuri and shouja-ai alike. Follow the rules of the subreddit, along with reddit's general rules and you should be good to go!","over18":true},"readit":{"lang":"en","description":"Official subreddit for Readit, a Reddit client for Windows 10 and Windows 10 Mobile. Discuss bugs, feature requests and review the application here.\n\n\n\n\n\n","over18":false},"TechnoProduction":{"lang":"en","description":"A subreddit dedicated to sharing technical information, tips'n'tricks and knowledge on the production of Techno Music. Please keep the self promo to a minimum and keep things friendly.","over18":false},"OKState":{"lang":"en","description":"Official subreddit of Oklahoma State University and the town of Stillwater, Oklahoma.","over18":false},"ServerPorn":{"lang":"en","description":"","over18":false},"circlejerkcopypasta":{"lang":"en","description":"It's always been a fantasy of mine...","over18":false},"payday2secret":{"lang":"en","description":"A subreddit dedicated to uncovering The Secret ARG in the game PAYDAY 2.","over18":false},"malta":{"lang":"en","description":"","over18":false},"FreckledGirls":{"lang":"en","description":"A SFW subreddit for pics of ladies with freckles. ","over18":false},"ArtGW":{"lang":"en","description":"","over18":true},"GTAMarket":{"lang":"en","description":"Subreddit for the in-game market in GTA V","over18":false},"governorsball":{"lang":"en","description":"A sub-reddit for the annual Governor's Ball music festival which takes place on Randall Island in New York City in early June.  What will YOU wear to the ball this year?","over18":false},"Bangkok":{"lang":"en","description":"Bangkok is the capital of Thailand. This sub-reddit is for bangkok ex-pats first and foremost as well as any Bangkok related content. Please remember to be nice to each other.","over18":false},"HoustonSocials":{"lang":"en","description":"Houston (/ˈhjuːstən/) is the fourth-largest city in the United States of America, and the largest city in the state of Texas. According to the 2010 U.S. Census, the city had a population of 2.1 millio","over18":false},"AMADisasters":{"lang":"en","description":"Let's focus on the movie, people.","over18":false},"phgonewild":{"lang":"en","description":"PH Gone Wild","over18":true},"Nexus10":{"lang":"en","description":"Subreddit for the Google Nexus 10 tablet. Your source for tips, tricks, modding, and everything related to the Nexus 10!","over18":false},"FoundPaper":{"lang":"en","description":"Photographs of pieces of paper with writing on them. Some of the most incredible things live written on the torn scraps of paper that didn't make it into the trash. They can be love letters, thoughts,","over18":false},"CricketWireless":{"lang":"en","description":"Cricket Wireless, formerly Aio Wireless, is an AT&T-owned AT&T MVNO, intended to compete against MetroPCS and T-Mobile US.","over18":false},"ShittyEarthPorn":{"lang":"en","description":"          .;:;:.\n          ::;:;:\n        _ ';:;;'\n        >'. ||  _\n         `>\\||.'<\n          `>|/ <`\n           `||/`\n       ^^^^^^^^^^^\n\nhai yah this subrdt is like earthporn but w/ shit ok just ","over18":false},"Nipples":{"lang":"en","description":"","over18":true},"craftit":{"lang":"en","description":"","over18":false},"fizzmains":{"lang":"en","description":"Discussion about Fizz in League of Legends","over18":false},"breathinginformation":{"lang":"en","description":"Post videos/gifs of humorous or randomly well-timed video overlay graphics.","over18":false},"DRKCoin":{"lang":"en","description":"Darkcoin is a new cryptocurrency featuring anonymous transactions confirmed instantly by the network.","over18":false},"AskOldPeople":{"lang":"en","description":"This is a place to discuss the past casually, without having to worry about the academic rigor of /r/AskHistorians.  Wondering what it was like to witness the end of the Cold War?  Want to talk about ","over18":false},"MomForAMinute":{"lang":"en","description":"We are Mother Geese to our loving Ducklings \n\nWhen you need understanding, congratulations, praise, or advice from a mother figure, but don't have one IRL able or willing to provide that for you -- we","over18":false},"jaycemains":{"lang":"en","description":"A subreddit dedicated to those who main Jayce, the Defender of Tomorrow. This is a place for builds, tips, tricks and general discussion regarding the 'League of Legends'-champion Jayce.","over18":false},"GreenParty":{"lang":"en","description":"","over18":false},"vidme":{"lang":"en","description":"Creators first. ","over18":false},"pantyhose":{"lang":"en","description":"/r/Pantyhose: For lovers of pantyhose / stockings / nylons and women wearing them.","over18":true},"IdlePoring":{"lang":"es","description":"Subreddit for the idle game: Ragnarok Idle Poring.","over18":false},"Bible":{"lang":"en","description":"The Subreddit dedicated to the understanding, discussion of, and loving of The Bible in all its greatness and everything it has to offer. Join us to learn more about what makes The Holy Bible so great","over18":false},"swg":{"lang":"en","description":"This subreddit is for Star Wars Galaxies discussion in all of its different incarnations.  This includes and is not limited to the closed live game, pre-cu, swgemu, combat upgrade, new game experience","over18":false},"eastside":{"lang":"en","description":"A place for the many communities east of Seattle, WA to have a place of their own! Where we can organize meet-ups and game nights and sports!\n\nIncluded but certainly not limited to:\n\n* Bellevue\n* Kirk","over18":false},"MetalGearSolidV_PC":{"lang":"en","description":"This subreddit is dedicated to Metal Gear Solid V. It caters to users specifically on the PC, but anyone is welcome to post here regarding MGS5.","over18":false},"sonarr":{"lang":"en","description":"Sonarr - Internet PVR","over18":false},"analogygifs":{"lang":"en","description":"","over18":false},"Pixar":{"lang":"en","description":"This is a place to chat, discuss, and explore everything related to Pixar! We are a free spirited bunch; just make sure you follow the few rules we have in place.\n\n","over18":false},"AssCredit":{"lang":"en","description":"Degenerates looking to degenerates for the answers to lifes toughest questions.","over18":false},"bjork":{"lang":"en","description":"********","over18":false},"TrumpForPrison":{"lang":null,"description":"Subreddit forbidden","over18":null},"vegetarianketo":{"lang":"en","description":"We're a small community of like-minded people attempting the Ketogenic diet while avoiding the typical staple food group, meat. Wanna share a recipe? A progress pic? A rant or rave? \n\nGo ahead and sha","over18":false},"Slovakia":{"lang":"en","description":"Slovak national subreddit","over18":false},"AFOL":{"lang":"en","description":"","over18":false},"Wake":{"lang":"en","description":"Welcome to r/wake! Anything related to any board sport that happens behind a boat, cable, or winch can be shared here. Trying to go pro and need views? Want to show off you new rail/board/boat/winch? ","over18":false},"SteamVR":{"lang":"en","description":"360° room-scale virtual reality experiences. With everything you love about Steam.","over18":false},"RequestABot":{"lang":"en","description":"Have other people do work for you!","over18":false},"CAKEWIN":{"lang":"en","description":"**Welcome to /r/CakeWin**     \n\n* *Everyone is welcome here!  Many thanks to all our beautiful, creative cake artist who share their creations on our page.*   ","over18":false},"FuckingWithNature":{"lang":"en","description":"Human and animal encounters. A place to watch and post content of humans interacting with wild animals in an interesting, educational, stupid, funny, or dangerous way. Much like Wu-Tang Clan; Nature a","over18":false},"evergreen":{"lang":"en","description":"","over18":false},"seventhworldproblems":{"lang":"en","description":"Welcome to Your New Home!","over18":false},"hsxc":{"lang":"en","description":"Talk about the season, post race results, and discuss Cross Country in general!","over18":false},"CyanideandHappiness":{"lang":"en","description":"This is a subreddit for the web comic, Cyanide and Happiness. Submissions include anything Cyanide and Happiness related, and only Cyanide and Happiness related.","over18":false},"girlsdoporn":{"lang":"en","description":"Welcome to the GirlsDoPorn.com subreddit. Here, you'll find everything relevant to the porn series, including discussion, links to videos on legal websites, image galleries and GIFs.","over18":true},"FlashingGirls":{"lang":"en","description":"An exciting and fun place to observe sexy girls flashing their private parts.","over18":true},"Gloomhaven":{"lang":"en","description":"Gloomhaven is a cooperative game of tactical combat, battling monsters and advancing a player's own individual goals in a persistent and changing world that is ideally played over many game sessions. ","over18":false},"coupons":{"lang":"en","description":"We love links to coupons and deals. Discounted pointless fun items, coupons for food, coupons for grocery shopping, clearance sales, and anything else discounted. As long as it's marked down, it belon","over18":false},"farscape":{"lang":"en","description":"A subreddit for those who enjoy the SciFi original series *Farscape*.","over18":false},"overcominggravity":{"lang":"en","description":"The official reddit and message board for Steven Low's book: Overcoming Gravity: A Systematic Approach to Gymnastics and Bodyweight Strength (Second Edition)","over18":false},"asklinguistics":{"lang":"en","description":"A place to ask questions related to the science of linguistics. ","over18":false},"Fantasy_Bookclub":{"lang":"en","description":"This subreddit is exclusively for the discussion and recommendation of Fantasy Books. We run three monthly features: a nominated Book of the Month, a discussion on a New Release Novel, and a sponsored","over18":false},"camwhores":{"lang":"en","description":"","over18":true},"jackwhite":{"lang":"en","description":"","over18":false},"marblehornets":{"lang":"en","description":"A reddit for discussion of [***Marble Hornets***](http://marblehornets.wikidot.com/ \"Marble Hornets Wiki\")\n (**MH**), a Slender Man-based YouTube series/[ARE](http://en.wikipedia.org/wiki/Alternate_re","over18":false},"ps3hacks":{"lang":"en","description":"A subreddit focusing on Hacking and Jailbreaking the Playstation 3.","over18":false},"DescentIntoTyranny":{"lang":"en","description":"Like the Roman Republic under Caesar Augustus, the American Republic is rapidly sliding into a system of government that limits individual liberty, that limits influence of its citizens over policy, t","over18":false},"Letterkenny":{"lang":"en","description":"Letterkenny consists of hicks, skids, hockey players and Christians. These are their problems. Canadian TV series","over18":false},"Cplusplus":{"lang":"en","description":"Ask questions, share news and projects about C++ here","over18":false},"etiquette":{"lang":"en","description":"","over18":false},"triplej":{"lang":"en","description":"triple j brings the latest, greatest music and the stories that matter to listeners all over the world. The triple j community loves a wide variety of music; with a passion for sharing great tunes fro","over18":false},"england":{"lang":"en","description":"","over18":false},"NXT":{"lang":"en","description":"Nxt is a decentralised open source crypto-platform created using original code and based upon its own native and feature-rich blockchain. Features include the Nxt Proof-of-Stake based cryptocurrency k","over18":false},"TryndamereMains":{"lang":"en","description":"A subreddit for all Tryndamere mains from League of Legends. Feel free to discuss builds, plays, art, etc. anything related to Tryndamere.","over18":false},"TeenAmIUgly":{"lang":"en","description":"AmIUgly for Teens","over18":false},"wallpaperdump":{"lang":"en","description":"A new subreddit designed specifically for people to share their wallpaper collections. \n\nAll collections are welcome - though please mark NSFW as such. \n\nWell what are you waiting for? Come and join u","over18":false},"oxford":{"lang":"en","description":"","over18":false},"pharmercy":{"lang":"en","description":"A subreddit for the best ship in Overwatch: Pharah and Mercy\n","over18":false},"minecraftseeds":{"lang":"en","description":"Find and share great Minecraft seeds!","over18":false},"etymologymaps":{"lang":"en","description":"","over18":false},"lists":{"lang":"en","description":"lists","over18":false},"shittyaskhistory":{"lang":"en","description":"Do you have questions about history that no reliable source can give you? Do you know of some lesser known historical facts that need to be more well known?\n\n**Then welcome to r/shittyaskhistory!**\n\n","over18":false},"BSD":{"lang":"en","description":"A place for all things BSD.","over18":false},"The_Dennis":{"lang":"en","description":"","over18":false},"TronScript":{"lang":"en","description":"**YOU MUST VIEW THIS SUB IN OLD MODE TO GET ALL NECESSARY INFORMATION FROM THE SIDEBAR**\n\n\nCLICK HERE TO VIEW THE SUB IN OLD MODE:\nhttps://old.reddit.com/r/TronScript/","over18":false},"redditisland":{"lang":"en","description":"","over18":false},"VAGuns":{"lang":"en","description":"A pro-2A subreddit dedicated to discussing all things firearms-related in Virginia.","over18":false},"schnauzers":{"lang":"en","description":"","over18":false},"windmobile":{"lang":"en","description":"A discussion of WIND Mobile products and services for existing users, those thinking of making the switch, or people just wanting to keep up to date on the Canadian mobile landscape.\n\nDiscuss the late","over18":false},"ketoaustralia":{"lang":"en","description":"A place for Aussies to share relevant information, use the metric system and connect with others close by.","over18":false},"NonBinary":{"lang":"en","description":"A subreddit for people of every stripe who feel that they don't fit into a preference-binary or gender-binary culture.","over18":false},"Hyperhidrosis":{"lang":"en","description":"","over18":false},"mechanics":{"lang":"en","description":"","over18":false},"callofcthulhu":{"lang":"en","description":"A forum for discussing all things Call of Cthulhu, from gaming stories to help with your campaign.","over18":false},"SegaSaturn":{"lang":"en","description":"","over18":false},"PSMinecraft":{"lang":"en","description":"Discuss news and information about the Minecraft Playstation Edition (PS4, PS3, PSVita). ","over18":false},"Constantine":{"lang":"en","description":"[](https://www.reddit.com/r/Constantine/comments/2oeged/constantine_s01e07_blessed_are_the_damned_episode/)For all things Constantine. ","over18":false},"ECEProfessionals":{"lang":"en","description":"Come learn, grow and contribute with us. We are an early childhood education discussion forum for preschool teachers and other professionals who would like to be involved in an online community to sha","over18":false},"travelpartners":{"lang":"en","description":"Meet up with a fellow traveller or travel buddy to visit the world","over18":false},"luciomains":{"lang":"en","description":"A subreddit for Overwatch players to discuss the hero, Lúcio.","over18":false},"Fallout4Builds":{"lang":"en","description":"Fallout 4 Builds","over18":false},"YuYuHakusho":{"lang":"en","description":"","over18":false},"MonacoCard":{"lang":"en","description":"https://www.mona.co/\n\nWorld's best cryptocurrency card. Spend and send money globally at perfect interbank exchange rates.\n\n","over18":false},"Nebraska":{"lang":"en","description":"","over18":false},"ImaginaryJedi":{"lang":"en","description":"Artwork from the Star Wars Universe","over18":false},"phr4r":{"lang":"en","description":"A place for Pinoy Redditors to meet and make connections.","over18":false},"truthfulteenopinions":{"lang":"en","description":"A place for teens to come and get feedback on their looks.","over18":false},"MindHunter":{"lang":"en","description":"Subreddit for the David Fincher Netflix show \"Mindhunter\".\n\nSynopsis:\n>In the late 1970s two FBI agents expand criminal science by delving into the psychology of murder and getting uneasily close to a","over18":false},"bitcoin_uncensored":{"lang":"en","description":"uncensored bitcoin news","over18":false},"bimbofication":{"lang":"en","description":"A place to share fiction involving a female (or male) being transformed into a bimbo! (NSFW)","over18":true},"chch":{"lang":"en","description":"Biggest city in New Zealand's South Island - Earthquake Hotspot","over18":false},"venturacounty":{"lang":"en","description":"The home for Ventura County Redditors. See here for VC News and local meetups. \n\nWe're also on [Facebook!](http://www.facebook.com/home.php?sk=group_218907471461918)","over18":false},"StillSandersForPres":{"lang":"en","description":"A community for people who have not given-up the fight for a Bernie Sanders presidency.","over18":false},"ChevyTrucks":{"lang":"en","description":"This is a Subreddit created specifically for chevy trucks. Want to show off your chevy? Post it here! Want to show some new mods to your chevy? Show them off here! ","over18":false},"freeletics":{"lang":"en","description":"In this subreddit you can post your experience with [Freeletics](http://freeletics.com/), your progress, motivation to continue, questions and also search for Freeletics Workout partners. ","over18":false},"mash":{"lang":"en","description":"A subreddit for all fans of the classic TV show, [M\\*A\\*S\\*H](https://secure.wikimedia.org/wikipedia/en/wiki/M\\*A\\*S\\*H \"M\\*A\\*S\\*H on Wikipedia\").","over18":false},"videogames":{"lang":"en","description":"","over18":false},"MLPtunes":{"lang":"en","description":"","over18":false},"Ebony":{"lang":"en","description":"This a subreddit featuring sexy SFW and NSFW ebony girl pics and vids.","over18":true},"ChristianMusic":{"lang":"en","description":"A place to discuss your favorite Christian songs and artists. Post reviews, videos, discussion, or anything music related. Please feel free to message the mods if you have any questions or if there is","over18":false},"WhatIsThisPainting":{"lang":"en","description":"A place to find out if you have a lost masterpiece or if it's just a garage sale treasure! Art in any medium is welcome. Please see below for submission guidelines, and related subreddits.","over18":false},"bestoftribunal":{"lang":"en","description":"","over18":false},"League_Of_Legends_":{"lang":"en","description":"League of Legends -  A fan subreddit for reddits League Of Legend's community. A favourite  place for new accounts to post their own youtube content.  Also other random shit gets posted here including","over18":false},"csun":{"lang":"en","description":"/r/csun - subreddit for CSUN - California State University Northridge","over18":false},"TrollXGirlGamers":{"lang":"en","description":"This will be dedicated to reaction gives and funny reactions and all that fun jazz related to gaming, made for the gamer ladies, and the good guys that treat us like actual gamers.","over18":false},"oastme":{"lang":null,"description":"Subreddit no longer exists","over18":null},"dota2tutor":{"lang":"en","description":"Request players who understand the game to play with you! Become a better Dota 2 player while having fun!","over18":false},"PokemongoSanDiego":{"lang":"en","description":"Subreddit for the San Diego community of Pokémon GO.","over18":false},"BurnNotice":{"lang":"en","description":"Come talk about the USA Network hit TV show \"Burn Notice\".\n\n* [Burn Notice on IMDb](http://www.imdb.com/title/tt0810788/)\n* [Burn Notice on USANetwork](http://burnnotice.usanetwork.com/)","over18":false},"WatchandLearn":{"lang":"en","description":"Gifs, videos, etc. that teach you something.","over18":false},"Revit":{"lang":"en","description":"","over18":false},"GODUS":{"lang":"en","description":"*GODUS empowers you in the role of a god, allowing you to sculpt every inch of a beautiful world that you look down upon, on which a population of Followers settle and multiply. As you mould every asp","over18":false},"FullScorpion":{"lang":"en","description":"","over18":false},"jpop":{"lang":"en","description":"This subreddit is for fans of Japanese pop/rock/electronic/dance music.","over18":false},"whooties":{"lang":"en","description":"Amateur Big Booty White Girls","over18":true},"Solving_A858":{"lang":"en","description":"Solving the Stonehenge of Reddit: /r/A858DE45F56D9BC9.","over18":false},"ProductPorn":{"lang":"en","description":"Do you love products? Well, we do and that's what we want you to share here. Share the best products you can get around the world.","over18":false},"kurzgesagt":{"lang":"en","description":"Official subreddit of Kurzgesagt.","over18":false},"symphonicmetal":{"lang":"en","description":"","over18":false},"papermoney":{"lang":"en","description":"A place to discuss all currencies from around the world not made of metal as well as any types of fiscal paper.","over18":false},"abortion":{"lang":"en","description":"A support sub for people who have had, are having, or are considering haveing an abortion. ","over18":false},"animalid":{"lang":"en","description":"","over18":false},"FilmIndustryLA":{"lang":"en","description":"","over18":false},"StrongCurves":{"lang":"en","description":"","over18":false},"tanlines":{"lang":"en","description":"","over18":true},"Stepmania":{"lang":"en","description":"Subreddit for the popular rhythm-game engine: Stepmania","over18":false},"fuckeatingdisorders":{"lang":"en","description":"Eating disorders have many misconceptions, and part of that is because those who have it hide it since those who don't have it don't understand it because no one talks about it. FED is here to confron","over18":false},"LinuxCirclejerk":{"lang":"en","description":"","over18":false},"MagicCardPulls":{"lang":"en","description":"","over18":false},"obamacare":{"lang":"en","description":"The Patient Protection and Affordable Care Act (PPACA), informally referred to as Obamacare, is a United States federal statute signed into law by President Barack Obama on March 23, 2010 after nearly","over18":false},"theketodiet":{"lang":"en","description":"A subreddit for people currently using or interested in keto diets. This community is for sharing scientific information, news stories, personal stories and progress reports","over18":false},"dokkanbattle":{"lang":"en","description":"A sub for players of the new dokkan battle bdz app game! If you're interested in being a mod, please let me know!","over18":false},"HealSluts":{"lang":"en","description":"**/r/Healsluts** is a community filled with eager healers willing to do what they can for their team, *especially their dominant counterparts.* \n\n**Join us as we pervert the act of healing for fun!**\n","over18":true},"BattlefieldLFG":{"lang":"en","description":"A new Subreddit based on searching for new squad mates to play Battlefield 4, 3, 1942, or ANY Battlefield game. Please read the rules **BEFORE** posting.","over18":false},"PrintedCircuitBoard":{"lang":"en","description":"Subreddit for review / layout / manufacture of Printed Circuit Boards (PCB), including schematic capture, assembly, soldering. Related topics: Altium, Eagle, DipTrace, KiCad, gerber, solder, breadboar","over18":false},"18_19":{"lang":"en","description":"Girls 18 and 19 yo","over18":true},"SLRep":{"lang":"en","description":"Here you can put together a thread of all your past work to showcase for future clients!","over18":false},"istanbul":{"lang":"en","description":"","over18":false},"pranks":{"lang":"en","description":"A collection of great pranks and prank ideas from across the Internet.","over18":false},"audiodrama":{"lang":"en","description":"A community to discuss audio drama in all its various forms. Audio drama creators are encouraged to promote their productions.","over18":false},"es":{"lang":"es","description":"Reddit en Español para los españoles de España y el extranjero. Es un lugar para noticias serias, imágenes no tan serias, y cualquier otro contenido que pueda considerarse de interés para una persona ","over18":false},"sex_comics":{"lang":"en","description":"A place where every redditor can indulge in their love for NSFW comics and art.","over18":true},"SingleParents":{"lang":"en","description":"","over18":false},"StreetFighterMods":{"lang":null,"description":"Subreddit forbidden","over18":null},"macapps":{"lang":"en","description":"/r/MacApps is a one stop shop for all things related to macOS apps - featuring app showcases, news, updates, sales, discounts and even freebies.","over18":false},"corpus":{"lang":"en","description":"Welcome to the official subreddit for Corpus Christi, TX (and the Greater Coastal Bend)!","over18":false},"AirBrawl":{"lang":"en","description":"Air Brawl is a fast paced plane game with two main parts, fighting and racing. The main focus of the game is tight and responsive flight controls and game mechanics that reward skillful flying.  \n","over18":false},"Dungeons_and_Dragons":{"lang":"en","description":"Anything related to Dungeons and Dragons; favorite moments, best enchanted weapons, coolest ideas, everything is welcome!","over18":false},"bizarrebuildings":{"lang":"en","description":"if it's a bizarre building, it belongs here.\n\nno, not pictures of buildings having a christmas bizarre.\n\nwe want unique one of a kind buildings!","over18":false},"Runner5":{"lang":"en","description":"Welcome to Runner5, home of those able-bodied Abel Township runners. This /r is for those interested in the Zombies, Run! app on iOS and Play. Check out the official website at https://www.zombiesrung","over18":false},"Mattress":{"lang":"en","description":"A place to discuss anything to do with mattresses, mattress accessories, and sleep technology. ","over18":false},"insertions":{"lang":"en","description":"Unorthodox masturbation ","over18":true},"BenignExistence":{"lang":"en","description":"It's okay to have a benign existence. \n\nShare your stories of the vanilla and mundane.","over18":false},"h1z1market":{"lang":"en","description":"Trade things on H1Z1 for real money, or do other in-game trades through organized means here. Guidelines to posting trades must be strictly followed.\n\n*/r/H1Z1Market is not affiliated with SOE, Daybre","over18":false},"Backcountry":{"lang":"en","description":"","over18":false},"Upvoted":{"lang":"en","description":"Thousands of unique stories are happening on Reddit everyday, propelling people and ideas to an audience of millions. But what happens after those posts go up? What happened leading up to it? Upvoted ","over18":false},"Flagstaff":{"lang":"en","description":"Subreddit for Flagstaff, AZ","over18":false},"computer_help":{"lang":"en","description":"Have a problem with your computer or mobile device? Want to know how to do something, anything on your computer or on the internet? Ask and we shall answer!","over18":false},"PaydayTheHeistOnline":{"lang":"en","description":"Looking for people to play Payday 2 with? You've come to the right place!\n\nSubmit your own call for backup or respond to others.","over18":false},"Gin":{"lang":"en","description":"Gin, it isn't just for bathtubs anymore!  Never before has there been access to so many gins from around the world.  Everyone has their own mix of botanicals.  Some use unique specimens to their local","over18":false},"WWU":{"lang":"en","description":"The subreddit for Western Washington University.","over18":false},"ShittyGifRecipes":{"lang":"en","description":"Whether it's the quality of the GIF, or the inedible food contained within, this is the home of Shitty Gif Recipes.","over18":false},"uCinci":{"lang":"en","description":"This is a subreddit dedicated to the University of Cincinnati community. ","over18":false},"DieAntwoord":{"lang":"en","description":"Die Antwoord discussions and news","over18":false},"Wrasslin":{"lang":"en","description":"First up brother anything goes brother!\n\nWhatever you saw on /r/SquaredCircle  about 'rules' that's just business.\n\nBut here....  nope. Total anarchy!\n\nFeel the karma flow throoougghhh you!\n\n\nPost lin","over18":false},"cfbball":{"lang":"en","description":"A subreddit for the creation, submission, and general laughing-at of comics based on the CFB world, done in 'ball' style.","over18":false},"crackpack":{"lang":"en","description":"Home of the Crackpack, the official Mindcrack Minecraft mod pack","over18":false},"malepolish":{"lang":"en","description":"A subreddit for men (including cis male, male-identifying, trans men, etc.) to share stories, post photos of their polished nails, link to articles on men wearing nail polish, and discuss anything rel","over18":false},"KatieCrossing":{"lang":"en","description":"Katie is a special visitor in the new Animal Crossing game: New Leaf. This is a subreddit for people to post when they want to send Katie on her way! Anyone willing to open their gates for a while sho","over18":false},"BingeEatingDisorder":{"lang":"en","description":"A support group for those who struggle with Binge Eating Disorder and compulsive overeating.","over18":false},"Aberdeen":{"lang":"en","description":"","over18":false},"pantheism":{"lang":"en","description":"","over18":false},"thegoodwife":{"lang":"en","description":"Subreddit for the CBS All Access show 'The Good Fight' as well as its predecessor show 'The Good Wife', which ended after 7 seasons.","over18":false},"csgodouble":{"lang":null,"description":"Subreddit forbidden","over18":null},"Sketchup":{"lang":"en","description":"Sketchup on Reddit: a community dedicated to Trimble's easy to use 3D modeling program.","over18":false},"HitBoxPorn":{"lang":"en","description":"The hitbox is the area around an object in a video game which can be hit by other objects. Poorly designed games have a wide hitbox which extends beyond the actual object presented. Hitbox porn highli","over18":false},"TechnicalDeathMetal":{"lang":"en","description":"","over18":false},"thesimscc":{"lang":"en","description":"The Sims Custom Content is a place to share, request, & discuss custom content for The Sims!","over18":false},"theratio":{"lang":"en","description":"hips:waist","over18":true},"doublebass":{"lang":"en","description":"For the players and aficionados of the double bass, a.k.a string bass, upright bass, acoustic bass, contrabass, bass violin, bass viol, bass fiddle, bull fiddle, doghouse bass, and standup bass.","over18":false},"Koibu":{"lang":"en","description":"This is a subreddit for all things relating to Koibu / Regalgoblins. Broadly it is a place for D&D discussions and community involvement. More specifically, it is a place for discussion about campaign","over18":false},"INeedFeminismBecause":{"lang":"en","description":"Tell us why you need feminism.","over18":false},"MusicCritique":{"lang":"en","description":"Here amateurs and professionals alike can post their original songs, samples, remixes, and demos to have them critiqued by the community.\n\nPlease use [Soundcloud](https://soundcloud.com/) to post your","over18":false},"bikepacking":{"lang":"en","description":"Bikepacking: Bicycling and camping where you would if you were to go backpacking. Backpacking is generally in the backcountry, but you can backpack on local trails. ","over18":false},"asianeats":{"lang":"en","description":"","over18":false},"samoyeds":{"lang":"en","description":"","over18":false},"SteamArtworkProfiles":{"lang":"en","description":"A community for sharing artistic Steam profiles.","over18":false},"ShittyPoetry":{"lang":"en","description":"A subreddit to fully express the shit that is in your heart.\n\nIt is encouraged to bring out your inner pretentiousness and tell the poster how much you enjoyed his work.\n","over18":false},"FFXIVhousingmarket":{"lang":"en","description":"This subreddit is for the buying and selling of houses in FFXIV. ","over18":false},"wildcats":{"lang":"en","description":"The Reddit home for UK Athletics.","over18":false},"PlusSize":{"lang":"en","description":"","over18":false},"iWantToFuckHer":{"lang":"en","description":"","over18":true},"sexygirls":{"lang":"en","description":"Sexy girls, girls too sexy for /r/PrettyGirls.","over18":true},"uofu":{"lang":"en","description":"Founded in 1850, The University of Utah is the flagship institution of higher learning in Utah, and offers over 100 undergraduate and more than 90 graduate degree programs to over 30000 students. This","over18":false},"soulseeker":{"lang":"en","description":"Subreddit for the mobile game \"Soul Seeker\" by com2us. Global Server and Asia Server users find home here.\n","over18":false},"EatingDisorders":{"lang":"en","description":"## For Awareness, Information, and Questions about Recovering from EDs. We are a pro-recovery site, and only allow approved posts. \n\n","over18":false},"theevilwithin":{"lang":"en","description":"The Evil Within 2 launches worldwide on Friday the 13th in October 2017 on PlayStation 4, Xbox One and PC.","over18":false},"dietetics":{"lang":"en","description":"A place for current and future nutrition professionals to discuss all aspects of the profession.","over18":false},"cheapcsgotrading":{"lang":"en","description":"This is a platform where people can tradeitems of the game Counter-Strike: Global Offensive. Items may be traded here as long as their value is less than $50. Please read the rules on the sidebar befo","over18":false},"piratesofthrones":{"lang":"en","description":"","over18":false},"rescuedogs":{"lang":"en","description":"","over18":false},"creepy_gif":{"lang":"en","description":"","over18":false},"meraki":{"lang":"en","description":"/r/Meraki: Everything Related to Cisco Meraki Cloud Networking!","over18":false},"AnarchistNews":{"lang":null,"description":"Subreddit forbidden","over18":null},"mit":{"lang":"en","description":"community for MIT students, faculty, staff to discuss all aspects of MIT","over18":false},"asiangirlsbeingcute":{"lang":"en","description":".gifs of Asian girls being cute.\n","over18":false},"TrollXWeddings":{"lang":"en","description":"Dorks marrying their best friend","over18":false},"storj":{"lang":"en","description":"Storj is an open source project that aims to offer a completely decentralized, secure and efficient cloud storage service, while also fulfilling the role of a peer-to-peer payment system, like Bitcoin","over18":false},"TheDollop":{"lang":"en","description":"Each week (biweekly.... once a week) comedian Dave Anthony tells a story to his friend, Gareth Reynolds who has no idea what the story is going to be about.","over18":false},"Movie_Club":{"lang":"en","description":"Watch new movies every week as voted on by the community!","over18":false},"truecreepy":{"lang":"en","description":"The ultimate source of terrifying nightmare fuel on reddit. We are serious about creepy stuff, with a high standard and strong moderation we promise that you won't be disappointed. This subreddit is a","over18":false},"ZBrush":{"lang":"en","description":"","over18":false},"SmashConnect":{"lang":"en","description":"The online play community subreddit for Smash Bros 4! Create and join rooms, meet new players, and compete in events and tournaments!","over18":false},"CelebrityPussy":{"lang":"en","description":"Pics and vids of yummy celebrity hoo-has.","over18":true},"Existentialism":{"lang":"en","description":"Being and Nothingness","over18":false},"frogdogs":{"lang":"en","description":"A place for frenchie owners to mingle and for others to admire our doggies or ask questions about the breed.\n\nHere are some great links for more Frenchie information.","over18":false},"WisconsinBadgers":{"lang":"en","description":"","over18":false},"MaddenMobileH2H":{"lang":"en","description":"One stop place for finding/recruiting for a Madden Mobile League","over18":false},"TwitchMains":{"lang":"en","description":"A Subreddit Dedicated To The Plague Rat","over18":false},"bf4emblems":{"lang":"en","description":"","over18":false},"ContemporaryArt":{"lang":"en","description":"A place for people interested in contemporary art and the contemporary art world, art news, relevant theory and conversation about contemporary artists. ","over18":false},"ForHonorSamurai":{"lang":"en","description":"A place for the Samurai of For Honor to gather, trade tips and tricks, share media, and coordinate our assets to further our faction to victory!","over18":false},"battlefield4":{"lang":null,"description":"Subreddit forbidden","over18":null},"pokies":{"lang":"en","description":"Female nipples being clearly and prominently poking through clothing.","over18":true},"barter":{"lang":"en","description":"","over18":false},"Flat_Earth":{"lang":"en","description":"This subreddit is for promoting the scientific discussion of the Flat Earth Conjecture.","over18":false},"TheContinuum":{"lang":"en","description":"CPS Protector Kiera Cameron (portrayed by Rachel Nichols) is transported from the year 2077 to 2012 when a group of terrorists from her time escapes execution by fleeing to present day. In order to tr","over18":false},"gossip":{"lang":"en","description":"","over18":false},"AustinClassifieds":{"lang":"en","description":"Classified ads in Austin, Texas.","over18":false},"INAT":{"lang":"en","description":"A Subreddit that facilitates Artists and Programmers to come together to make awesome games, or anything else for the sake of fun and art. \n\n","over18":false},"printmaking":{"lang":"en","description":"","over18":false},"GuiltyPleasureMusic":{"lang":"en","description":"Got a song or band that you secretly like or even, um... love? This is the place for you. ","over18":false},"WatchesCirclejerk":{"lang":"en","description":"","over18":false},"unsw":{"lang":"en","description":"For former, current and future students or staff to discuss UNSW.","over18":false},"AdmiralBulldog":{"lang":"en","description":"A place for your dongers.\n\n[Twitch.tv](http://www.twitch.tv/admiralbulldog)\n\n[Youtube](https://www.youtube.com/channel/UCk8ZIMJxSO9-pUg7xyrnaFQ)\n\n[Facebook](https://www.facebook.com/AdmiralBulldog)\n\n[","over18":false},"solareclipse":{"lang":"en","description":"A place to share information that helps fellow redditors optimize their experience of the August 21, 2017 total solar eclipse.","over18":false},"italianlearning":{"lang":"en","description":"In this sub you can discuss the italian language, look up or share italian learning tools, ask for help in your italian studies, and post or browse italian content useful for your learning experience.","over18":false},"theroom":{"lang":"en","description":"","over18":false},"SkinnyWithAbs":{"lang":"en","description":"For girls not muscular enough to be on /r/hardbodies. Skinny girls with tight abs.","over18":false},"portfolios":{"lang":"en","description":"Get (or give!) advice on investment portfolios and financial planning goals for retirement (401k, Roth, IRA) and taxable investing accounts, including stocks, bonds, mutual funds and ETFs as well as t","over18":false},"cork":{"lang":"en","description":"","over18":false},"logic":{"lang":"en","description":"","over18":false},"adventuregames":{"lang":"en","description":"Subreddit for the discussion and appreciation of the adventure game genre.","over18":false},"Seiko":{"lang":"en","description":"A pro-Seiko forum, for modern & vintage Seiko.  Seiko production discussion, restoration input, wrist-checks, sales / WTB posts, everything.  ","over18":false},"trump":{"lang":"en","description":"Republican President Donald Trump and Administration news, media, politics and information /r/Trump","over18":false},"distension":{"lang":"en","description":"A subreddit for girls stretching themselves to the limit. Porn where you can see what's inside, outside. ","over18":true},"tanks":{"lang":"en","description":"","over18":false},"startup":{"lang":"en","description":"","over18":false},"Ornithology":{"lang":"en","description":"Discussion about the scientific study of birds.","over18":false},"VEDC":{"lang":"en","description":"Vehicle EDC: What essentials do you carry in your car, truck, bike, boat, motorcycle, plane, or other vehicle daily?","over18":false},"AssholeBehindThong":{"lang":"en","description":"For assholes hidden behind thongs","over18":true},"SolusProject":{"lang":"en","description":"**A modern, desktop-focused Linux distro built from scratch.**\n\nOfficial subreddit of the [Solus Project](https://getsol.us), which includes the operating system and [Budgie](https://getsol.us/solus/e","over18":false},"FarCry4":{"lang":"en","description":"Far Cry 4 Subreddit","over18":false},"curb":{"lang":"en","description":"A subreddit for the HBO show \"Curb Your Enthusiasm\"","over18":false},"blop":{"lang":"en","description":"A place for blop\n\n             .--.             .---.\n            /:.  '.         .' ..  '._.---.\n           /:::-.  \\.-\"\"\"-;` .-:::.     .::\\\n          /::'|   \\/  / \\  \\'   `\\:'   ::::|\n      __.'  ","over18":false},"ecobee":{"lang":"en","description":"A subreddit for ecobee and all their smart home products.","over18":false},"jilling":{"lang":"en","description":"For videos, images, gifs, and stories of girls Jilling off. NSFW","over18":true},"FFCommish":{"lang":"en","description":"A place for league commissioners to share ideas, help eachother to solve disputes, and bitch about the Tacos of our respective leagues.","over18":false},"JapaneseWatches":{"lang":"en","description":"The sub for all Japanese watch enthusiasts where we discuss production, restoration input, wrist-checks, sales / WTB posts, and everything in-between from Seiko to Orient, Citizen to Casio & more.","over18":false},"HighResNSFW":{"lang":"en","description":"High Resolution NSFW pics.","over18":true},"nobackspace":{"lang":"en","description":"Ain't no pussy backspacin' round here, Roll with what you write.","over18":false},"gue":{"lang":"en","description":"","over18":false},"usanews":{"lang":"en","description":"","over18":false},"shitty_ecr":{"lang":"en","description":"","over18":false},"WarframeRunway":{"lang":"en","description":"A place to show off colour schemes and designs of your frames, weapons, sentinels, kubrows, lisets and more in Warframe.","over18":false},"Diablo3Necromancers":{"lang":"en","description":"","over18":false},"badminton":{"lang":"en","description":"News, reviews, events and everything else related to the badminton.","over18":false},"MadeInAbyss":{"lang":"en","description":"The subreddit for the Made in Abyss manga and anime.","over18":false},"corvallis":{"lang":"en","description":"Serving the greater Corvallis, Oregon area.","over18":false},"SheepMarketplace":{"lang":"en","description":"Home for Sheep Marketplace discussion.","over18":false},"blenderhelp":{"lang":"en","description":"Blender 3D Modeling, Animation, and Video Editing software support and help. Ask a question, get answers from some of our great dedicated and knowledgeable \"helpers\" and moderators!","over18":false},"WVU":{"lang":"en","description":"","over18":false},"oneplusone":{"lang":"en","description":"","over18":false},"dogeducation":{"lang":"en","description":"Where people can ask questions and find answers that are explained in newbie/laymen terminology. ","over18":false},"AniviaMains":{"lang":"en","description":"All League Of Legends players who main Anivia belongs here! :)","over18":false},"athensohio":{"lang":"en","description":"","over18":false},"Homesteading":{"lang":"en","description":"Welcome! Join us for friendly discussions, questions, stories, tips, and inspiration on a wide variety of homestead topics. From gardens, herbs, orchards, to chickens, goats, llamas, alpacas, sheep, c","over18":false},"theworldisflat":{"lang":"en","description":"Flat Earth Research and Globe Earth Skeptics","over18":false},"kia":{"lang":"en","description":"The Official Subreddit For Kia Motors - Optima, Forte, Sorento, Cadenza, Quoris, Sportage, Soul, K3, K5, K7, K900 ","over18":false},"Owls":{"lang":"en","description":"","over18":false},"cissp":{"lang":"en","description":"For all issues/questions/materials regarding the Certified Information Systems Security Professional (CISSP®) exam.\n\nWelcome to the *friendly* forum for anything regarding studying, writing, and worki","over18":false},"AskRetail":{"lang":"en","description":"A place for retail employees to share ideas and tactics to help one another make work more efficient and enjoyable. Customers are also welcome to engage employees with any questions they may not want ","over18":false},"funnysigns":{"lang":"en","description":"You saw a funny sign/advertisement/billboard/warning? Submit it here!\n","over18":false},"copywriting":{"lang":"en","description":"A Place For Great Tips/Tricks/Advice all about copywriting.","over18":false},"frankfurt":{"lang":"en","description":"News, events and happenings in and information about Frankfurt am Main and the surrounding area.","over18":false},"breakingpoint":{"lang":"en","description":"This is the official subreddit for the Breaking Point mod for Arma 3.","over18":false},"fullmoviesongoogle":{"lang":"en","description":"FullMoviesOnGoogle - Stream and download free HD movies on Google Drive/Docs!","over18":false},"xsmallgirls":{"lang":"en","description":"Petite ladies of the lesser-chested variety – 18+\n\n","over18":true},"Crystals":{"lang":"en","description":"Sparkles for All!","over18":false},"LandCruisers":{"lang":"en","description":"","over18":false},"Posture":{"lang":"en","description":"The best subreddit for users with a slight lean, slope, or a hunch here and there.  ","over18":false},"SpideyMeme":{"lang":"en","description":"","over18":false},"ecology":{"lang":"en","description":"Ecology (from Greek: οἶκος, \"house\"; -λογία, \"study of\") is the scientific study of the relations that living organisms have with respect to each other and their natural environment.","over18":false},"vivaldibrowser":{"lang":"en","description":"A subreddit for the Vivaldi Web browser. \n\nVivaldi is a web browser for power users that is fast, rich in functionality, flexible and puts the user first.","over18":false},"ComicWalls":{"lang":"en","description":"This is the place for wallpapers (both desktop and mobile) related to comic books, comic strips, cartoons & comic-related movies/television shows/video games, and cosplay!","over18":false},"outlast":{"lang":"en","description":"Outlast subreddit dedicated to news, discussion, and community content.","over18":false},"Augur":{"lang":"en","description":"Official Reddit page for the decentralized prediction market platform, Augur!  Augur is a fully-decentralized, open-source prediction market platform built on the Ethereum blockchain for any and all p","over18":false},"12Monkeys":{"lang":"en","description":"","over18":false},"GBA4iOS":{"lang":"en","description":"GBA4iOS is an iOS emulator for Nintendo Game Boy Advance games. It is made by Rileytestut (/u/iskythe).\n\nGBA4iOS 2.0 is officially out!","over18":false},"doggos":{"lang":"en","description":"Your one stop sub for doggos, woofers, shoobs, puggos, cool doggos, sleepy doggos, lomg doggos, very fast doggos running at incredible hihg speeds, also puppers.","over18":false},"LGBTnews":{"lang":"en","description":"/r/LGBTnews is for sharing links to recent news about lesbian, gay, bisexual, transgender, and all queer issues from a variety of sources, locales, and perspectives; along with comments and discussion","over18":false},"BattleCatsCheats":{"lang":"en","description":"This subreddit shows cheats for the mobile game The Battle Cats. Please post cheats you find!","over18":false},"29er":{"lang":"en","description":"Anything and everything bicycles with twenty nine inch wheels.","over18":false},"slutwife":{"lang":"en","description":"A place for pics and videos of hot slut wives, or hotwives. ","over18":true},"trailmeals":{"lang":"en","description":"A community devoted to outdoor eats of all kinds.","over18":false},"jhu":{"lang":"en","description":"Subreddit for all things related to the Johns Hopkins University and affiliates. \n\nCome here to post and see news related to [all facets of the Johns Hopkins universe](http://en.wikipedia.org/wiki/Lis","over18":false},"BioshockInfinite":{"lang":"en","description":"A place to share all things Bioshock Infinite, including news, videos, pictures, previews, or just your general thoughts on the game. ","over18":false},"cambridge":{"lang":"en","description":"Cambridge, England, United Kingdom. ","over18":false},"movingtojapan":{"lang":"en","description":"Interested in moving to Japan? Come here (and not those other Japan subs) with all your questions, concerns and fears.","over18":false},"NBAlive":{"lang":"en","description":"A community for anything and everything related to NBA Live!","over18":false},"columbia":{"lang":"en","description":"Anything related to [Columbia](http://columbia.edu) and the Morningside Heights community in New York, NY.","over18":false},"athiesm":{"lang":"en","description":"","over18":false},"BytecoinBCN":{"lang":"en","description":"Bytecoin (BCN) is a next generation completely anonymous cryptocurrency launched July 4, 2012, making it the first Cryptonote currency of its kind. Bytecoin is unlike any other cryptocurrency as it al","over18":false},"presshearttocontinue":{"lang":"en","description":"This is the official subreddit for everything Dodger related.","over18":false},"CumFromAnal":{"lang":"en","description":"A place to share anything regarding males ejaculating through anal stimulation.\n\nVids, gifs, tips and stories are all welcome!","over18":true},"academiceconomics":{"lang":"en","description":"","over18":false},"ButtsAndBareFeet":{"lang":"en","description":"Pics of ladies' butts and bare feet.","over18":true},"NSFW_GAY":{"lang":"en","description":"**NSFW Gay is a subreddit for you to share those things a little \"too gay\" for the Straight NSFW reddit's! We're Dedicated to quality gay porn & hot guy submissions including Hunks, Twinks, Jocks, Por","over18":true},"SHAYTARDS":{"lang":"en","description":"This subreddit focuses on the \"SHAYTARDS\" family, who have been putting their life on the Internet for more than 5 years.\n\nWe're a place for all the latest news and vlogs as well as questions, discuss","over18":false},"AmeriCorps":{"lang":"en","description":"This unofficial subreddit is for anybody who has served in, is serving in, or is interested in the AmeriCorps program. This includes AmeriCorps State and National, AmeriCorps VISTA, and AmeriCorps NCC","over18":false},"Accordion":{"lang":"en","description":"The subreddit for anything about accordions, accordion music, accordionists, or other bellows-driven instruments.  Videos, recordings, lessons and theory, shopping, and more are all welcome.","over18":false},"SmarterEveryDay":{"lang":"en","description":"","over18":false},"goats":{"lang":"en","description":"A subreddit for all things goat.","over18":false},"SKY3DS":{"lang":"en","description":"Discussion, information and news about the Sky3DS, a Nintendo 3DS Flashcart that works on all available firmware releases and regions.","over18":false},"gamers":{"lang":"en","description":"##Welcome to Gamers!\n\nThe best place for gaming news and discussion!","over18":false},"UniUK":{"lang":"en","description":"Got a question about going to Uni in the UK? Want to find out more and speak to other Redditors about their course/uni? Not sure if you can eat something that's been loafing in your fridge for 3 weeks","over18":false},"cyberpunkgame":{"lang":"en","description":"Home for the upcoming CYBERPUNK 2077 RPG developed by CD PROJEKT RED.","over18":false},"nocontextpics":{"lang":"en","description":"Here at /r/nocontextpics, there are no sob stories or stories of any kind. The pics must survive or fail on their own. No context.","over18":false},"techsnap":{"lang":"en","description":"","over18":false},"TheDarkKnightRises":{"lang":"en","description":"***The Dark Knight Rises*** is the upcoming third and final installment in Christopher Nolan's *Batman* saga and is a sequel to ***Batman Begins*** (2005) and ***The Dark Knight*** (2008).  \n  \nRepris","over18":false},"eden":{"lang":"en","description":"","over18":false},"androidroot":{"lang":"en","description":"/r/AndroidRoot is a sub for discussion on rooting Android devices.","over18":false},"smarthome":{"lang":"en","description":"This is the place for all your smart home product. This subreddit topics about a wide variety of smart home products and IoT's. Find help, tips, tricks and advice from our users!","over18":false},"AbusePorn2":{"lang":"en","description":"We're back!\n\nLike your porn degrading, abusive and humiliating?  This is the subreddit for you!  You wont find any vanilla porn here.  All our videos feature girls who appear unhappy with what's going","over18":true},"PuppySmiles":{"lang":"en","description":"A great collection of puppies smiling to brighten your day!","over18":false},"AndroidAuto":{"lang":"en","description":"","over18":false},"AmateurPhotography":{"lang":"en","description":"/r/AmateurPhotography has gone private to participate in the currently ongoing strike regarding communication between admins and moderators. See [here](https://www.reddit.com/r/OutOfTheLoop/comments/3","over18":false},"hotguyswithtattoos":{"lang":"en","description":"","over18":true},"OCCaliPokemonGo":{"lang":"en","description":"Subreddit for Pokémon GO players of Orange County, California!","over18":false},"MightyNo9":{"lang":"en","description":"Post anything and everything Mighty No 9 related here!\n\nLet's keep it civil.","over18":false},"gaeilge":{"lang":"en","description":"","over18":false},"dropship":{"lang":"en","description":"","over18":false},"avorion":{"lang":"en","description":"Avorion is a space-sim sandbox game where you build your own ships and explore, fight, trade, mine and explore your way to the center of the galaxy.\n\n\n\n","over18":false},"Fios":{"lang":"en","description":"/r/Fios is a community for discussing and asking questions about Verizon Wireless' Fios related services. For General Information related to verizon, feel free to stop by /r/verizon.\n\n\n\n\nAll on-topic ","over18":false},"arlington":{"lang":"en","description":"Arlington, TX","over18":false},"TheGreatWarChannel":{"lang":"en","description":"THE GREAT WAR covers the events exactly 100 years ago: The story of World War I in realtime. Featuring: The unique archive material of British Pathé. Indy Neidell takes you on a journey into the past ","over18":false},"JacksonWrites":{"lang":"en","description":"[](https://www.reddit.com/r/JacksonWrites/wiki/tiktok)Want to get professional writing for free? Go somewhere else.\n\nEverything is a first draft here.","over18":false},"sporetraders":{"lang":"en","description":"A place to trade mushroom spores for microscopy and collection purposes.","over18":false},"logorequests":{"lang":"en","description":"A subreddit dedicated to helping you fulfill you logo and branding design needs. Paid work only.","over18":false},"cookingvideos":{"lang":"en","description":"A place for anyone to post videos of their recipe or a recipe that they've found that was really enjoyable. Also a place to figure out different cooking techniques.","over18":false},"Learnmusic":{"lang":"en","description":"","over18":false},"TumblrCirclejerk":{"lang":"en","description":"ALL HAIL DAVID KARP.","over18":false},"dnl":{"lang":"en","description":"Unofficial subreddit for Snail Games' early release Dark and Light survival multiplayer sandbox, rebooted franchise from the open world PvP sandbox MMO of the same name from the turn of the century. D","over18":false},"freesoftware":{"lang":"en","description":"\"Free software\" means software that respects users' freedom and community. Roughly, it means that the users have the freedom to run, copy, distribute, study, change and improve the software. Thus, \"fr","over18":false},"mileycyrus":{"lang":"en","description":"For fans of Miley Cyrus.","over18":false},"RX7":{"lang":"en","description":"Rx7s and all things Rotary. Share your love for the wankle.","over18":false},"Houseporn":{"lang":"en","description":"High resolution images of houses.","over18":false},"bose":{"lang":"en","description":"Bose | Better Sound Through Research\n","over18":false},"liquor":{"lang":"en","description":"A sub dedicated to the open discussion of alcohol in its many forms. ","over18":false},"RedPulseToken":{"lang":"en","description":"Red Pulse introduced the first NEO token. RPX will power a brand new content production, distribution, and consumption platform focused initially on China’s capital markets. \nOur vision is to grow our","over18":false},"portlandstate":{"lang":"en","description":"","over18":false},"UnexpectedCena":{"lang":"en","description":"/r/UnexpectedCena: Where we pay homage to the greatest man of all time. Who is this legend? THAT QUESTION WILL BE ANSWERED THIS SUNDAY NIGHT WHEN JOHN CENA DEFENDS THE BELT AT THE WWE SUUUUPERRRRSLAAA","over18":false},"52in52":{"lang":"en","description":"/r/52in52 is a place for people every week, for a whole year, **to read and discuss a particular book together as a community**.  There are twelve themes and three books from each theme + one free for","over18":false},"paracord":{"lang":"en","description":"Paracord Projects, Art and Tutorials","over18":false},"species":{"lang":"en","description":"Devoted to the ***crowdsourced identification*** of unidentified species of ***any specimen*** including fungi, plants, amphibians, reptiles, and mammals.","over18":false},"holdmybeaker":{"lang":"en","description":"A subreddit for the posting of videos/images of scientists doing dangerous and/or awesome shit.","over18":false},"alltheleft":{"lang":"en","description":"All the Left: Because we ought to at least be talking to each other","over18":false},"suggestapc":{"lang":"en","description":"Looking for a PC? Then you've come to the right sub-reddit. We will help you find a pre-built PC with your desired specs and peripherals in your price range!","over18":false},"ethtraderpro":{"lang":"en","description":"Intermediate-to-advanced-level discussion of buying, selling and hodling Ether, ERC20 tokens, and other cryptocurrencies. ","over18":false},"wanttobelieve":{"lang":"en","description":"A place to post all things dealing with the paranormal or unexplained. We want to believe there is more out there, and here is where you can try to convince us. ","over18":false},"sophieturner":{"lang":"en","description":"Everything Sophie Turner","over18":false},"Ni_no_Kuni":{"lang":"en","description":"An unofficial community for discussion, news, and anything else related to the video game Ni no Kuni and its sequel.  ","over18":false},"UnionHouse":{"lang":"en","description":"Best Independent Rep Company ----this subreddit is for union house updates//upcoming releases//questions//reviews//specials //ect !!!","over18":false},"Banshee":{"lang":"en","description":"Subreddit for the Cinemax original TV series, Banshee.","over18":false},"lasik":{"lang":"en","description":"Subreddit dedicated to LASIK, PRK, and all other forms of vision correction procedures.","over18":false},"Good_Cop_Free_Donut":{"lang":"en","description":"All cops are not bad. This page is for the good guys. Why should the bad guys get all the attention?\n\nTrolling and anti-cop sentiment are discouraged here. Troll posts and anti-cop content can be remo","over18":false},"Evernote":{"lang":"en","description":"This community is devoted to the discussion of Evernote, a cloud based, cross platform, personal knowledge base with a note centric data metaphor.","over18":false},"HoloLens":{"lang":"en","description":"/r/HoloLens is a place for news and discussion about Windows HoloLens.","over18":false},"ArtOfRolling":{"lang":"en","description":"Hello and welcome to the r/ArtOfRolling community! Rolling up is an art form, and here we defiantly appreciate it. Please share pictures of your finest, or not so fine, hand rolled joints, blunts, cig","over18":false},"highereducation":{"lang":"en","description":"Articles and discussion related to higher education.","over18":false},"boop":{"lang":"en","description":"*boop*","over18":false},"Pxlsspace":{"lang":"en","description":"For stuff about Pxls.space, a fanmade /r/place!","over18":false},"chickens":{"lang":"en","description":"A place to post your photos, video and questions about chickens! ","over18":false},"yakuzagames":{"lang":"en","description":"This is the unofficial subreddit for Sega's long-running game series, Yakuza, known in Japan as Ryū ga Gotoku.","over18":false},"vintageads":{"lang":"en","description":"Ads from the past!","over18":false},"APB":{"lang":"en","description":"The subreddit for the MMOTPS game, [All Points Bulletin: Reloaded](https://en.wikipedia.org/wiki/APB:_All_Points_Bulletin), AKA, APB Reloaded. Previously owned by [Realtime Worlds](https://en.wikipedi","over18":false},"vaynemains":{"lang":"en","description":"/r/VayneMains ","over18":false},"blackjack":{"lang":"en","description":"A subreddit dedicated to the card game Blackjack.  The most popular card game in the world.","over18":false},"BinghamtonUniversity":{"lang":"en","description":"The subreddit for Binghamton University students, alumni, faculty, and prospective students.","over18":false},"fuckolly":{"lang":"en","description":"Subreddit dedicated to fucking that piece of shit Olly from HBO's Game of Thrones series. ThanksObama'ed on May 8, but the party continues in /r/FreeFolk. **NOT A SPOILER-SAFE ZONE.**\n\n\n\n","over18":false},"The_Dotard":{"lang":"en","description":"You know, I know it, everybody knows it","over18":false},"ITdept":{"lang":"en","description":"","over18":false},"work":{"lang":"en","description":"","over18":false},"CommercialRealEstate":{"lang":"en","description":"/r/CommercialRealEstate - Leasing and Sales of Retail, Office, Multi-Unit Residential, Industrial Properties and Land","over18":false},"Corridor":{"lang":"en","description":"Post anything related to Corridor Digital, Sam and Niko, and Node and their friends. ","over18":false},"Crouton":{"lang":"en","description":"/r/crouton is a subreddit dedicated to dnschneid's [crouton](https://github.com/dnschneid/crouton).","over18":false},"GodlessWomen":{"lang":"en","description":"This is a place for the heretical, godless, women of the world. We're atheism's better half.","over18":false},"torontobiking":{"lang":"en","description":"A community for cyclists in, around, and just passing through the Greater Toronto Area.","over18":false},"gofundme":{"lang":"en","description":"GoFundMe allows regular people to accomplish extraordinary things with easy-to-use personal donation websites. From exciting life events like weddings & graduations to challenging circumstances like a","over18":false},"Somerville":{"lang":"en","description":"","over18":false},"iOS11":{"lang":"en","description":"","over18":false},"EliteBountyHunters":{"lang":"en","description":"A subreddit related to the discussion of Bounty Hunting, Bounties, etc. in the popular Space-Sim, Elite: Dangerous.","over18":false},"LinusTechTips":{"lang":"en","description":"A community discussing the latest LinusTechTips and LinusMediaGroup videos. Come and join us today!","over18":false},"SpringAwakening":{"lang":"en","description":"","over18":false},"MEandromeda":{"lang":"en","description":"Mass Effect : Andromeda ","over18":false},"lyftdrivers":{"lang":"en","description":"A place for Lyft Drivers from around the country to share tips, tricks, and stories.","over18":false},"Grimes":{"lang":"en","description":"Claire Boucher aka Grimes fan club","over18":false},"cryptography":{"lang":"en","description":"","over18":false},"brushybrushy":{"lang":"en","description":"Images, .gifs and videos of animals enjoying being brushed","over18":false},"ChubbyDudes":{"lang":"en","description":"A place in between LadyBoners and BigHandsomeMen","over18":true},"shittytumblrgifs":{"lang":"en","description":"Post the bad gifs you see around reddit on here ","over18":false},"Mastiff":{"lang":"en","description":"","over18":false},"TaylorSwiftsLegs":{"lang":"en","description":"\"A community dedicated to showcasing pictures of Taylor Swift's mile-long legs.\"\n\nPlease read the rules before posting.","over18":false},"Tgifs":{"lang":"en","description":"Gifs from all your favorite Transgender Women.","over18":true},"YouTubeGamers":{"lang":"en","description":"This sub redit is for YouTubers looking to show off their videos to gain subscribers and increase views! ","over18":false},"starfox":{"lang":"en","description":"","over18":false},"Gaben":{"lang":"en","description":"","over18":false},"FastWorkers":{"lang":"en","description":"Videos of talented workers, who are speedy and accurate.","over18":false},"birdsofprey":{"lang":"en","description":"Birds of Prey: Falcons, Hawks, Accipiters, Eagles and Owls","over18":false},"OldSchoolCelebs":{"lang":"en","description":"**History's cool Celebs, looking fantastic!**\n\nOld Pics & videos of Celebs, everything from Hollywood Celebs\n","over18":false},"playdreadnought":{"lang":"en","description":"Reddit page for Dreadnought game at www.playdreadnought.com","over18":false},"oslo":{"lang":"no","description":"Subreddit for Oslo, the capital of Norway","over18":false},"missoula":{"lang":"en","description":"Welcome to Missoula, MT!  Home to the University of Montana and the Missoula Osprey, the Garden City is truly the jewel of Montana.","over18":false},"Flights":{"lang":"en","description":"r/Flights is a part of the /r/travel community primarily focusing on flights, airlines, airports, frequent flyers, and general flying information. Please read the sidebar to get the most out of this s","over18":false},"Neotrader":{"lang":"en","description":"A platform for discussions about the Chinese cryptocurrency NEO and it's token GAS.\nPost trading/general NEO threads or comment on existing threads as you wish. ","over18":false},"TrueTrueReddit":{"lang":"en","description":"","over18":false},"projectsparkgame":{"lang":"en","description":"**What is /r/projectsparkgame?**\n\nSubreddit for a game called Project Spark. Has up to date info and videos on Project Spark, which is coming to Xbox One, Xbox 360, and Windows 8. \n\n Project Spark is ","over18":false},"H1Z1LFG":{"lang":"en","description":"Recruit for your clan or find a buddy to play with!","over18":false},"MuLegend":{"lang":"en","description":"MU Legend (MU2) - Official Subreddit","over18":false},"environmental_science":{"lang":"en","description":"This subreddit is for the *scientific discussion* of topics in the environmental sciences, geosciences, and other relevant discipline's; including papers, articles, research, public-policy, and both e","over18":false},"futurefunkairlines":{"lang":"en","description":"♪ For lovers of good music and good times ♪\n\nBass, techno, grime, funk, deep house, disco, ambient, drum & bass, electro, funk, hip-hop, reggae, R&B, garage, balearic, old school, funk, dubstep, soul,","over18":false},"nosurf":{"lang":"en","description":"NoSurf is a community of people who are focused on becoming more productive and wasting less time mindlessly surfing the internet. https://nosurf.org/","over18":false},"landmark":{"lang":"en","description":"Landmark","over18":false},"londoncycling":{"lang":"en","description":"A subreddit for London-based cyclists to share stories, routes, tips and local cycling info for jolly old London town!","over18":false},"Phillylist":{"lang":"en","description":"Philly's mini, local equivalent of Craigslist.  Adopt a cat! Sell a bike! Post a Job!","over18":false},"ImmigrationCanada":{"lang":"en","description":"The Canadian Immigration Subreddit.  This subreddit is for asking questions or discussing current issues in regards to immigrating to Canada.","over18":false},"QualityAssurance":{"lang":"en","description":"","over18":false},"TallMeetTall":{"lang":"en","description":"","over18":false},"CatTaps":{"lang":"en","description":"Cats mildly tapping something. ","over18":false},"rpdragrace":{"lang":"en","description":"The new and improved, Rupaul's Drag Race fan-discussion subreddit!","over18":false},"illustrator":{"lang":"en","description":"","over18":false},"tylerthecreator":{"lang":"en","description":"The subreddit for all content relating to the hip-hop artist, Tyler, The Creator.","over18":false},"BravestWarriors":{"lang":"en","description":"","over18":false},"PokemongoAustin":{"lang":"en","description":"Pokémon GO Austin Texas community - mobile game for iOS and android featuring augmented reality MMO","over18":false},"depressionregimens":{"lang":"en","description":"r/depressionregimens is a sub for redditors with depression and anxiety who are looking to be part of a constructive community dedicated towards improvement, with a focus on safe and researched substa","over18":false},"winterporn":{"lang":"en","description":"A SFW Porn Network subreddit dedicated to all things snow and ice related. Icebergs, glaciers, snow-covered trees, wintry landscapes, and more!","over18":false},"MasterOfAnal":{"lang":"en","description":"Anal for advanced players. If you like ass games your place is here.\n\nVideos, Pics and Gifs of Gangbangs, Toys, Fisting, Fingering, Rimming, Asshole Gaping, Double Anal and more. No gay anal here - so","over18":true},"incubus":{"lang":"en","description":"","over18":false},"funsized":{"lang":"en","description":"This is a subreddit for pictures, gifs and / or videos of hot, fun sized girls. We're looking for girls that are the definition of \"shorty\". Tiny. Petite. Portable. Compact. Small. Fun Sized.","over18":true},"beforeandafteredit":{"lang":"en","description":"A subreddit for people who want to see what an image looked like before it was edited and for people to learn.","over18":false},"Garmin":{"lang":"en","description":"","over18":false},"lol":{"lang":"en","description":"For the lighter side of life. Stuff that makes you go LOL.\n\n\n^^^(No ^^^relation ^^^to ^^^League ^^^Of ^^^Legends) ","over18":false},"bipolar2":{"lang":"en","description":"This is a community for people living with Bipolar 2, their loved ones, and anyone wanting to understand. ","over18":false},"rick_and_morty":{"lang":"en","description":"Join our Rick and Morty Discord \n\nhttps://discord.gg/HWScw4N","over18":false},"sadcomics":{"lang":"en","description":"Some comics are funny.  This is not a subreddit for those kinds of comics.","over18":false},"policeporn":{"lang":"en","description":"/r/PolicePorn is for high quality safe for work images of police. Submissions should be pictures of law enforcement officers, vehicles, or equipment. Any law enforcement agency from any country qualif","over18":false},"2012Elections":{"lang":"en","description":"Election news for the 2012 US elections","over18":false},"sissypersonals":{"lang":"en","description":"","over18":true},"600euro":{"lang":"de","description":"Hier passen Geschichten von sozialen Medien hinein, welche zwar behaupten, wahr zu sein, aber einfach sehr schlecht und unglaubwürdig sind. Gute Beispiele hierfür sind schlechte Hetzposts gegen Asylsu","over18":false},"cosmology":{"lang":"en","description":"**/r/cosmology** - a community for questions, discussions, and articles about cosmology. ","over18":false},"WhereDoIStart":{"lang":"en","description":"**Welcome to /r/WhereDoIStart!** Have you ever wanted to get into a band or artist with a massive collection, but had nowhere to start? This sub's purpose is to highlight what people think should be t","over18":false},"Maps":{"lang":"en","description":"Beautiful, interesting, and informative maps.","over18":false},"A858DE45F56D9BC9":{"lang":null,"description":"Subreddit forbidden","over18":null},"Paleontology":{"lang":"en","description":"What is palæontology? Literally, the world translates from Greek as *old life discourse*- but this is only the crudest way of stating it. Palæontology is unraveling the æons-long story of life on the ","over18":false},"AthleticGirls":{"lang":"en","description":"WELCOME TO ATHLETIC GIRLS\n\n/r/AthleticGirls is dedicated to celebrating beautiful women who keep themselves fit. The only requirement is that the woman be in better-than-average shape. This reddit is ","over18":true},"SubSanctuary":{"lang":"en","description":"A safe space where bottoms can discuss and share their thoughts, ideas, ask questions, and anything else that my cross their minds. ","over18":true},"tahoe":{"lang":"en","description":"Local events, visitor information, anything relating to Lake Tahoe (California & Nevada)","over18":false},"elm":{"lang":"en","description":"Friendly online community for Elm users. Beginners welcome!","over18":false},"UofArizona":{"lang":"en","description":"All things related to the events and people at the [UofA.](http://arizona.edu)","over18":false},"stanford":{"lang":"en","description":"A subreddit for current students and alums to talk about Stanford stuff. ","over18":false},"Aurelion_Sol_mains":{"lang":"en","description":"A community dedicated to Aurelion Sol. Members discuss optimal strategies and share advice, streams, art, and replays.","over18":false},"c64":{"lang":"en","description":"","over18":false},"Ozark":{"lang":"en","description":"Netflix TV series 'Ozark', starring Jason Bateman & Laura Linney","over18":false},"Jobudsmeetup":{"lang":"en","description":"A place where friends of /r/jobuds can connect. Request PM's, connect online (Skype, Kik, Snapchat, etc), and connect in person.\n\n","over18":true},"notredame":{"lang":"en","description":"A subreddit for all things Notre Dame. News, sports, pictures, events, and discussion is all welcome.","over18":false},"Memes_Of_The_Dank":{"lang":"en","description":"Probably full of normies but there is some dank bois here too!","over18":false},"SexWithDogs":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Afrodisiac":{"lang":"en","description":"****","over18":true},"NCIS":{"lang":"en","description":"SubReddit about America's Favorite TV Show... NCIS!\n","over18":false},"criminalminds":{"lang":"en","description":"An elite group of profilers analyse the nation's most dangerous criminal minds in an effort to anticipate their next moves before they strike again.","over18":false},"Bobbers":{"lang":"en","description":"Custom Bobber Pics and Articles","over18":false},"Magfest":{"lang":"en","description":"The official subreddit of MAGFest, the Music and Gaming Festival!\n\nHave feedback from MAGFest 2016? Share it in the Feedback Thread: https://www.reddit.com/r/Magfest/comments/46spbu/official_feedback_","over18":false},"reddit_news":{"lang":"en","description":"","over18":false},"cellphones":{"lang":"en","description":"Everything cell phone related! News, tech support, sharing ideas/information/tips. Tablets too.","over18":false},"gtaonlinecrews":{"lang":"en","description":"This subreddit is for creating groups/hierarchies in **GTA:Online**. Need a group? Ask here! Recruiting? Ask here! Just make sure to include your gamertag, PSN, or Social Club Name.","over18":false},"Netherlands":{"lang":"en","description":"The original low calorie English language subreddit for the Netherlands.","over18":false},"MenGW":{"lang":"en","description":"/r/MenGW is a place to share and appreciate the male body. Post any pictures of yourself you would like others to see. This subreddit is lightly moderated, and only spam and personal information are r","over18":true},"Facer":{"lang":"en","description":"","over18":false},"glastonbury_festival":{"lang":"en","description":"","over18":false},"GearS3":{"lang":"en","description":"The Samsung Gear S3...Classic and Frontier.","over18":false},"womensstreetwear":{"lang":"en","description":"Welcome to Women's Streetwear! Feel free to post any questions, inspirations, pick ups, fit pics, and news regarding women's streetwear. I'm hoping this sub will become a hub for women involved and in","over18":false},"ithaca":{"lang":"en","description":"Ten square miles surrounded by reality. \nIthaca, NY\n\n","over18":false},"gamedevscreens":{"lang":"en","description":"A branch off of /r/gamedev for game developers to post screenshots of work-in-progress, concept art, and more.","over18":false},"Fallout4":{"lang":null,"description":"Subreddit forbidden","over18":null},"gfycat":{"lang":"en","description":"Provide better hosting for large gifs-- fast global cloud cdn, and no size limits, restrictions or charges.\n\nInclude video options. Every gif hosted includes video so those who choose, can use it. You","over18":false},"BikeShop":{"lang":"en","description":"","over18":false},"g2agoldmine":{"lang":null,"description":"Subreddit no longer exists","over18":null},"mapporncirclejerk":{"lang":"en","description":"","over18":false},"fights":{"lang":"en","description":"Fights here! We got fights here! \n\nWe got street fights, fist fights, catfights and more. \n\nNew fights, old fights, fights galore!","over18":false},"Queens":{"lang":"en","description":"Queens is the easternmost of the five boroughs of New York City, the largest in area and the second-largest in population. Since 1899, Queens has had the same boundaries as Queens County, which is now","over18":false},"chicagor4r":{"lang":"en","description":"","over18":true},"NidaleeMains":{"lang":"en","description":"\"I see you're no stranger to the wild\"","over18":false},"Supreme":{"lang":"en","description":"/r/Supreme is a community dedicated to buying, selling, trading, and discussing all things Supreme.","over18":false},"XboxThemes":{"lang":"en","description":"Have a theme you want to share and show off? Have a theme you want requested? This is the place.","over18":false},"BellaThorne":{"lang":"en","description":"","over18":false},"ethdev":{"lang":"en","description":"Any Ethereum-related development talk is welcome here:\n\nContracts, DApps, Wallets, Clients, Infrastructure, Tooling, UIs, Patterns, and others.","over18":false},"RedditArmie":{"lang":"en","description":"THE LE REDDIT ARMY HAS ARRIVED XD","over18":false},"ScarlettJohansson":{"lang":"en","description":"Everything about the actress, singer, model, goddess... Scarlett Johansson.","over18":false},"VicePrincipals":{"lang":"en","description":"Created by Danny McBride and Jody Hill, who also created “Eastbound & Down,” comes VICE PRINCIPALS, a dark comedy series that tells the story of a high school and the two people who almost run it, the","over18":false},"AmazonTopRated":{"lang":null,"description":"Subreddit forbidden","over18":null},"CemuPiracy":{"lang":"en","description":"For all pirates interested in Cemu Piracy this is the right place.          \nHere you can share games and everything you need for Cemu\n\n","over18":false},"YogaPants":{"lang":"en","description":"Yoga Pants!!!!\n\nA place to post the greatest invention since the purse strap to go right between women's tits. Post all of your yoga pants pictures here.","over18":true},"wildlifephotography":{"lang":"en","description":"A subreddit for those interested in shooting wildlife...with a camera.","over18":false},"tits":{"lang":"en","description":"","over18":true},"foobar2000":{"lang":"en","description":"The community where you alienate your foobar2000 intentions. Most stuff is allowed... if it's foobar2000-related. ","over18":false},"pokemongoSF":{"lang":"en","description":"Pokemon GO San Francisco Community - trading, meet ups, screen shots, gyms, pokemarts, etc - Augmented Reality Mobile MMO","over18":false},"Huawei":{"lang":"en","description":"Anything and Everything Huawei!","over18":false},"BigCatGifs":{"lang":"en","description":"Gifs of cats bigger than a house cat.","over18":false},"askcarguys":{"lang":"en","description":"This is a subreddit for automotive related questions. ","over18":false},"transvoice":{"lang":"en","description":"A place to share your voice recording for constructive criticism by the community","over18":false},"solipsism":{"lang":"en","description":"","over18":false},"downblouse":{"lang":"en","description":"# www.imgur.com/r/downblouse - Gallery\n\n\nPost your pictures and videos of **downblouses, and sideboobs!**  ","over18":true},"pelfie":{"lang":"en","description":"Welcome to the best selfie subreddit on the Internet. I highly encourage you to check out the \"Top\" section first and contribute if you have pelfies to share. Enjoy!","over18":true},"MusicEd":{"lang":"en","description":"Designed to give music educators an online tool for easy access to forums, discussion boards, advice, teaching strategies, teaching stories, advocacy tips, pertinent articles, rehearsal advice, and an","over18":false},"Ratemeteen":{"lang":"en","description":"A safe place for teenagers to share and rate pictures of themselves!","over18":false},"AltJ":{"lang":"en","description":"The one true Alt-J subreddit.","over18":false},"GTAV_Mods":{"lang":"en","description":"Anything and Everything Related to Modding Grand Theft Auto V","over18":false},"crashlands":{"lang":"en","description":"The official community page for Crashlands, by Butterscotch Shenanigans.","over18":false},"paydaytheheistmods":{"lang":"en","description":"Hub for all things related to modding PAYDAY!","over18":false},"MoonriseMusicFestival":{"lang":"en","description":"Moonrise Festival is an annual music festival held in Baltimore, MD at the Pimlico Race Course.  Stay up to date with all the information and discussion about it's past years. ","over18":false},"AshVsEvilDead":{"lang":"en","description":"Ash vs. Evil Dead, the Starz show adapted from the Evil Dead movie series. The synopsis:\n>Ash has spent the last 30 years avoiding responsibility, maturity and the terrors of the Evil Dead until a Dea","over18":false},"FacialFun":{"lang":"en","description":"Cum covered faces","over18":true},"namethatcar":{"lang":"en","description":"Post an original picture of a car for others to guess what it is. We welcome any and all submissions, whether they're OC or just taken from a Wikipedia page.","over18":false},"Massdrop":{"lang":"en","description":"This subreddit is for organizing group buys on the website Massdrop.com.","over18":false},"language_exchange":{"lang":"en","description":"","over18":false},"TillSverige":{"lang":"en","description":"","over18":false},"elixir":{"lang":"en","description":"Elixir is a dynamic, functional language designed for building scalable and maintainable applications.\n\nElixir leverages the Erlang VM, known for running low-latency, distributed and fault-tolerant sy","over18":false},"ETCshow":{"lang":"en","description":"","over18":false},"ludology":{"lang":"en","description":"","over18":false},"1200isplentyketo":{"lang":"en","description":"To inspire and support those who are looking for low calorie keto meal ideas!","over18":false},"sfx":{"lang":"en","description":"","over18":false},"DarkHumor":{"lang":null,"description":"Subreddit forbidden","over18":null},"tacticalgear":{"lang":"en","description":"Share your favorite gear, write reviews and comparisons of tactical products, post your load out photos, etc. ","over18":false},"FortniteBattleRoyale":{"lang":"en","description":"Fortnite Battle Royale subreddit. Discuss FortniteBR. ","over18":false},"nsfw_videos":{"lang":"en","description":"Best selection of NSFW Videos and Gifs chosen for your satisfaction.\nThis Subreddit is commited to deliver Free Porn Videos for people bored having sex with their wives and girlfriends, bored to stare","over18":true},"FFVIIRemake":{"lang":"en","description":"The unofficial subreddit for the Final Fantasy VII Remake.","over18":false},"NZTrees":{"lang":"en","description":"","over18":false},"seoul":{"lang":"en","description":"","over18":false},"BeautyDiagrams":{"lang":"en","description":"Beauty Diagrams - how to pictures, diy's and diagram looks. All makeup, hair, and fashion style related how-to illustrations.","over18":false},"HistoryofIdeas":{"lang":"en","description":"Welcome to the subreddit for the study of the history of ideas, including the histories of philosophy, of literature and the arts, of the natural and social sciences, of religion, and of political tho","over18":false},"DaisyRidley":{"lang":"en","description":"Anything that is related to the actress Daisy Ridley\n\n","over18":false},"police":{"lang":"en","description":"","over18":false},"futurefunk":{"lang":"en","description":"The subreddit dedicated to Future Funk – music with sweet and funky vibes with a touch of 80's nostalgia!","over18":false},"FriendsofthePod":{"lang":"en","description":"This is the subreddit for listeners of the podcasts of CrookedMedia, including Pod Save America (formerly Keepin' it 1600). ","over18":false},"sbubby":{"lang":"en","description":"A sbubby is a logo that has been edited cleanly, usually so that it is nonsensical, but always such that it is recognizable as the original logo. See [the KnowYourMeme entry](http://knowyourmeme.com/m","over18":false},"GothBoiClique":{"lang":"en","description":"The official fan subreddit for GothBoiClique","over18":false},"morebreedingdittos":{"lang":"en","description":"This subreddit is to help Pokemon breeders obtain the Dittos they need for breeding in both Gen 6 and 7. **Please read the rules before posting!**","over18":false},"live":{"lang":"en","description":"for reddit live threads and discussion about the feature that powers them","over18":false},"aquarium":{"lang":"en","description":"","over18":false},"HomeDecorating":{"lang":"en","description":"","over18":false},"studyAbroad":{"lang":"en","description":"","over18":false},"YarnAddicts":{"lang":"en","description":"What's this subreddit for? If you say \"yes\" to any of the below questions, you'll probably find an interesting thing or two here:\n\n- Are you a crocheter, dyer, knitter, spinner, weaver, or any combina","over18":false},"Bestof2011":{"lang":"en","description":"","over18":false},"Dyslexia":{"lang":"en","description":"Welcome to /r/Dyslexia...\n\nA community for Dyslexic spectrum redditors looking to help one another, or discuss issues related to the learning disability. \n\n~Feedspot's Top 4 Dyslexia Blogs in the Worl","over18":false},"2meirl42meirl4meirl":{"lang":"en","description":"Be warned, this subreddit often contains references to suicide and other related things. Do not visit this sub if you are sensitive to such topics!\n\n[If you are suicidal and need help, we strongly enc","over18":false},"PiratedGames":{"lang":"en","description":"Welcome to the PiratedGames subreddit, talk about pirated games and new cracks!\n","over18":false},"metacirclejerk":{"lang":"en","description":"","over18":false},"gifrequests":{"lang":"en","description":"","over18":false},"theology":{"lang":"en","description":"**Theology** articles, news, essays, & perspectives.","over18":false},"indesign":{"lang":"en","description":"Everything about InDesign- tips, tricks, tutorials, competitions, help, etc.","over18":false},"ABoringDystopia":{"lang":"en","description":"A subreddit for chronicling how Advanced Capitalist Society is not only dystopic, but also incredibly boring.   ","over18":false},"deism":{"lang":"en","description":"Deism: the belief in a Creator, but not revealed religion.  This is a place for the exploration of Deistic thought, and discussion of all things related to Deism: science, philosophy, theology, and mo","over18":false},"Qtum":{"lang":"en","description":"Qtum Development and Discussion","over18":false},"WeAreMods":{"lang":"en","description":"I am mod. You are mod. On this blessed day, we are all mods.","over18":false},"TrueCrime":{"lang":"en","description":"True Crime, Serial Killers, Spree Killers discussion. Anything True Crim goes! Home for True Crime buffs.","over18":false},"sneakerbots":{"lang":"en","description":"**BEST** spot for discussing the ins & outs of bots and copping sneakers/clothes.","over18":false},"empyriongame":{"lang":"en","description":"Empyrion is a 3D open world, space survival adventure in which you can fly across space and land on planets. The game will feature space & planetary exploration, building & construction, mining & reso","over18":false},"pokemongobotting":{"lang":"en","description":"Robots be powerful yo.","over18":false},"magick":{"lang":"en","description":"","over18":false},"RayDonovan":{"lang":"en","description":"Subreddit for the Showtime TV series *Ray Donovan*, starring Liev Schreiber and Jon Voight.","over18":false},"fightporn":{"lang":"en","description":"A place to witness the best fights from around the world. Fights can be from MMA, the street, boxing, online. Basically, any kind of fight that tickles the brain as much as porn.","over18":false},"SKS":{"lang":"en","description":"","over18":false},"conceptart":{"lang":"en","description":"A collection of stunning concept art.","over18":false},"VerdunGame":{"lang":"en","description":"The 1914-1918 WW1 Game Series currently includes Verdun and Tannenberg, developed by BlackMill Games and M2H.\n\nThese realistic WW1 shooters let players choose from a range of squads from across the wa","over18":false},"bibros":{"lang":"en","description":"","over18":false},"uchicago":{"lang":"en","description":"The official subreddit for the University of Chicago!","over18":false},"OriannaMains":{"lang":"en","description":"**The subreddit for all things Orianna related. Art, Discussions, Lore, Music, Skin concepts, Strategy, Videos, Etc.**\n","over18":false},"labor":{"lang":"en","description":"","over18":false},"GroupOfNudeGirls":{"lang":"en","description":"Exactly what it says on the tin; groups of 3 or more nude girls.","over18":true},"CemeteryPorn":{"lang":"en","description":"High quality images of cemeteries and graves.","over18":false},"fantasyfb":{"lang":"en","description":"r/Fantasy_Football has absorbed this sub, please take all posts there, Dominate your league!\nhttps://www.reddit.com/r/Fantasy_Football/\n","over18":false},"bookhaul":{"lang":"en","description":"This is the place to share your new purchases, recent additions, and pictures of your book shelves! Discuss the merits of each title and drool over other's finds.","over18":false},"Yeasure":{"lang":"en","description":"Your favorite Big Titted Milf is back! I'll post when I can.Thanks so much for being a Yeasure fan 😘","over18":true},"librarians":{"lang":"en","description":"Discuss optimal filing methods, book rejuvenation, humidity regulation, and dusting practices. ","over18":false},"AsianNSFW":{"lang":"en","description":"We are the longest running Asian NSFW sub/Reddit for Asian porn pictures and videos. Get your favorite Asian girls up. Share what you love!","over18":true},"chvrches":{"lang":"en","description":"Dedicated to synthpop legends Chvrches.","over18":false},"amiga":{"lang":"en","description":"We are a passionate community of Amiga fans. We talk about relevant news, events, and old times for all things Commodore Amiga - one of the greatest home computer platforms of all-time. ","over18":false},"misfitstv":{"lang":"en","description":"","over18":false},"gonwild":{"lang":"en","description":"","over18":true},"arielwinter":{"lang":"en","description":"For fans of actress and singer Ariel Winter.","over18":false},"Spongebros":{"lang":"en","description":"","over18":false},"fonts":{"lang":"en","description":"","over18":false},"ShittyVeganFoodPorn":{"lang":"en","description":"","over18":false},"NationalPark":{"lang":"en","description":"News, photos and questions about national parks in the US and around the world","over18":false},"googlepokemon":{"lang":"en","description":"Welcome to the new Pokemon Go community. This group was started during the first April Fool's day Pokemon search and now lives on as a welcoming community for those looking to learn about and play Pok","over18":false},"motorsportsstreams":{"lang":"en","description":"The subreddit has stream links to F1 (Formula 1), IndyCar, NASCAR, MotoGP, WEC, Formula E, Karting, Touring Car and many other motorsport series. \n","over18":false},"CrewsCrew":{"lang":"en","description":"Dear Terry: you have the whole internet behind you.\nThe Crews Crew is ready to cruise.\nWe love you, man. Fight the good fight.\n","over18":false},"Mars":{"lang":"en","description":"Articles and commentary about the planet Mars.","over18":false},"babybigcatgifs":{"lang":"en","description":"A place to see incredibly pathetic roars than eventually turn into cute yawns. ","over18":false},"stratisplatform":{"lang":"en","description":"Stratis is a powerful and flexible Blockchain Development Platform designed for the needs of real world enterprise and financial services.","over18":false},"accidentalswastika":{"lang":"en","description":"Swastikas in places you don't expect them to be.\n","over18":false},"neogaming":{"lang":"en","description":"This is a place for news and discussions for gamers from gamers.","over18":false},"GolemProject":{"lang":"en","description":"Anyone can use Golem to rent their unused computing resources. Simultaneously Golem enables every user to buy computing time from other users to complete virtually any computationally-demanding task. ","over18":false},"groestlcoin":{"lang":"en","description":"Groestlcoin (GRS) is an extremely fast and secure coin with almost ZERO fees and anonymous transactions. [SEGWIT] [LightningNetwork] [ATOMICswap] [Anonymity]","over18":false},"ForFashion":{"lang":"en","description":"Put all of your fashion here! Noticed how nice your Kensei's  helmet looks? Or how a new shield for Conqueror ties a look together? ","over18":false},"Cityofheroes":{"lang":"en","description":"","over18":false},"hugenaturals":{"lang":"en","description":"","over18":true},"MaterialDesign":{"lang":"en","description":"The home of Google's Material Design philosophy, and things created with it.","over18":false},"NatureGifs":{"lang":"en","description":"","over18":false},"persona4golden":{"lang":"en","description":"Persona 4 Golden, the best Vita game ever!\n\nHere, you can post questions, help, tips, fan art, and anything that has to do with our investigation crew!","over18":false},"vjing":{"lang":"en","description":"","over18":false},"srilanka":{"lang":"en","description":"","over18":false},"tomodachilife":{"lang":"en","description":"Tomodachi life is a Nintendo 3DS game. It combines elements from animal crossing, the sims, nintendo Mii, and hallucinogenic drugs. Check back here for latest updates and news about the game.","over18":false},"SAP":{"lang":"en","description":"A Reddit for all SAP discussions pro or con!","over18":false},"hsp":{"lang":"en","description":"A subreddit for highly sensitive people. Welcome HSP redditors!","over18":false},"ArtBuddy":{"lang":"en","description":"Doesn't matter if you are a beginner, intermediate or even a professional. We all have days where we just forget or don't have the motivation to draw even though we know we probably should. Having a b","over18":false},"adoptareddit":{"lang":"en","description":"/r/adoptareddit is for letting others take over your existing reddit that you already mod. If you're looking to take over another reddit (that doesn't have a mod), please try /r/redditrequest.","over18":false},"TIL_Uncensored":{"lang":"en","description":"This is place to share facts on ANY topic without censorship from oppressive mods.\n\nTopics including but not limited to,\n\n- Politics   \n- Gender   \n- Religion  \n- Sex    \n- Race   \n- Controversial Sub","over18":false},"quantum":{"lang":"en","description":"","over18":false},"dragonball":{"lang":"en","description":"","over18":false},"Real_Estate":{"lang":"en","description":"A reddit for all things Real Estate. Consumer information on the real estate market, mortgages, buying, selling, etc.","over18":false},"SFV":{"lang":"en","description":"/r/SFV - subreddit for the 818 - San Fernando Valley in Los Angeles, CA","over18":false},"blacksmithing":{"lang":"en","description":"","over18":false},"republicans":{"lang":"en","description":"Republican news, issues, gossip, and discussion.\n\n\n","over18":false},"marinebiology":{"lang":"en","description":"","over18":false},"quake":{"lang":"en","description":"A subreddit for all Quake games.","over18":false},"VitaTV":{"lang":"en","description":"PlayStation TV (Vita TV in Japan)\n\nWhat is it? PlayStation TV (or Vita TV as it's known in Japan) is a device that acts like a PlayStation Vita connected to your TV.\n\nIt can Remote Play PS4 games, pla","over18":false},"normalboots":{"lang":"en","description":"A subreddit dedicated to content about the group normalboots.","over18":false},"SoulCalibur":{"lang":"en","description":"The sub for all things Soulcalibur related!","over18":false},"DayofInfamy":{"lang":"en","description":"A community run subreddit for Day of Infamy, a WWII first person shooter on Steam. ","over18":false},"wwi":{"lang":"en","description":"This subreddit is dedicated to the discussion of the history, art, culture and commemoration of World War One (1914-1918).  Submissions and comments should be on topics related to this subject except ","over18":false},"Cadillac":{"lang":"en","description":"A place for Cadillac enthusiasts to discuss about Cadillac.","over18":false},"lossprevention":{"lang":"en","description":"This subreddit is for the worldwide Loss Prevention community to share war-stories, advice, news and insight. LP employees are here to answer the community's questions! (please be respectful to the jo","over18":false},"bee_irl":{"lang":"en","description":"post who you really bee","over18":false},"theoffice":{"lang":"en","description":"A community to discuss the television show The Office (U.S. Version).","over18":false},"strandeddeep":{"lang":"en","description":"Stranded Deep, Survival Video Game\n\nTake the role of a plane crash survivor stranded somewhere in the Pacific Ocean. Come face to face with some of the most life threatening scenarios that will result","over18":false},"nuclear":{"lang":"en","description":"Focus on tech, economics, news, and climate change. Here \"wind\" is a four-letter word. ","over18":false},"CaliforniaForSanders":{"lang":"en","description":"r/CaliforniaForSanders is a grassroots volunteer-led online hub designed to raise support in California for Senator Bernie Sanders 2020 campaign for President of the United States and to highlight Our","over18":false},"virgin":{"lang":"en","description":"Share with us your hopes, fears and experiences in this support community for virgins. This is a privilege-free, no-judgment zone.","over18":false},"airz23":{"lang":"en","description":"A place for the stories in the Airz23 saga that don't necessarily fall completely under the category of tech support.","over18":false},"Cyberpunk_Music":{"lang":"en","description":"Noise. ","over18":false},"earrumblersassemble":{"lang":"en","description":"A subreddit for those who can control their Tensor Tympani muscle.","over18":false},"risingthunder":{"lang":"en","description":"The Rising Thunder: Community Edition SubReddit!","over18":false},"mining":{"lang":"en","description":"This is a subreddit for those involved or interested in the extractive mining industry. We are not a subreddit for bitcoin or other types of cryptocurrency hash mining.  ","over18":false},"Metalocalypse":{"lang":"en","description":"Blacker than the blackest black, times infinity!","over18":false},"totalwarhammer":{"lang":"en","description":"A subreddit dedicated to the Creative Assembly games in the Total War: Warhammer series\n\nFeel free to share any news, strategies, gameplay, start a discussion or just hang around.\n\nCurrently looking f","over18":false},"NRIBabes":{"lang":null,"description":"Subreddit no longer exists","over18":null},"GeekPorn":{"lang":"en","description":"High quality images of geek culture.","over18":false},"whedon":{"lang":"en","description":"Grr. Arrrg.","over18":false},"reversegif":{"lang":"en","description":"Links to amusing, interesting, or funny .gifs from the web! .gif format submissions only, please!\n\nExcept all of the gifs are in reverse","over18":false},"AshesofCreation":{"lang":"en","description":"The official subreddit for new MMORPG Ashes of Creation. Massive, open world PvE and PvP with no preset cities outside of starting areas. Every area in the game is completely shaped and owned by the p","over18":false},"WaywardPines":{"lang":"en","description":"Subreddit for Wayward Pines, an TV series on FOX from M. Night Shyamalan.\n\n\n\n[IMDB](http://www.imdb.com/title/tt2618986/)","over18":false},"ebooks":{"lang":"en","description":"A place for fans of electronic books to discuss everything related. Freebies, sales, reviews, etc.","over18":false},"berlinsocialclub":{"lang":"en","description":"","over18":false},"VGHS":{"lang":"en","description":"A subreddit dedicated to the discussion of the VGHS webseries.","over18":false},"ImaginaryCityscapes":{"lang":"en","description":"Art featuring urban landscapes.","over18":false},"elliottsmith":{"lang":"en","description":"","over18":false},"Eliza_cs":{"lang":"en","description":"This is my subreddit, in which I post exclusive photos of myself and also advertise special offers for videos, photos, cam shows and other items.","over18":true},"dishwashers":{"lang":"en","description":"A place for dishwashers young and old to share their experiences.","over18":false},"atheistparents":{"lang":"en","description":"","over18":false},"CoDCompPlays":{"lang":"en","description":"The purpose of this subreddit is to find players to play with in various games.","over18":false},"GiftIdeas":{"lang":"en","description":"Ask for gift ideas.  \nShare awesome gifts you have given or received.","over18":false},"90s":{"lang":"en","description":"#/r/90s\n","over18":false},"MRW":{"lang":"en","description":"A place for all \"My Reaction When\" images and gifs","over18":false},"JUGPRDT":{"lang":"en","description":"","over18":false},"mysterybox":{"lang":"en","description":"Exchange boxes filled with things from your life. ","over18":false},"coloradohikers":{"lang":"en","description":"","over18":false},"betternews":{"lang":"en","description":"Articles directly from selected news sources. Posted by a bot.","over18":false},"GalaxyNote2":{"lang":"en","description":"A place to share anything Galaxy Note 2, including technical issues, software changes, articles, reviews, and even personal rants.","over18":false},"redhat":{"lang":"en","description":"Discussion for Red Hat and Red Hat technologies!","over18":false},"freegames":{"lang":"en","description":"Standalone freeware, mods, indie, free commercial games, F2P, indie games, open source, closed source, new and old. It's all about free games!","over18":false},"unstirredpaint":{"lang":"en","description":"Share your paint can creations!","over18":false},"Osaka":{"lang":"en","description":"Anything related to Osaka.","over18":false},"SouthDakota":{"lang":"en","description":"","over18":false},"swguilds":{"lang":"en","description":"A subreddit to help players find an appropriate Summoners War : Sky Arena Guild for them.","over18":false},"bapccanada":{"lang":"en","description":"Inspired by a discussion on /r/bapcsalescanada the new /r/bapccanada is the /r/buildapc but for Canadians!","over18":false},"LOLStreams":{"lang":"en","description":"This is a subreddit for finding League of Legends streamers. \n\n* [Resources](https://www.reddit.com/r/LOLStreams/wiki/resources)\n* [Rules](https://www.reddit.com/r/LOLStreams/about/rules/)","over18":false},"lordoftherings":{"lang":"en","description":"","over18":false},"uBlockOrigin":{"lang":"en","description":"An efficient blocker add-on for various browsers. Fast, potent, and lean.","over18":false},"Csgotrading":{"lang":"en","description":"***Getting \"submissions restricted\" on the submit button over at /r/globaloffensivetrade? Fuck those guys, this is my sub now. Trade whatever you want.***\n\n\nUse http://steamrep.com/ when trading to ma","over18":false},"indepthstories":{"lang":"en","description":"","over18":false},"NetflixByProxy":{"lang":"en","description":"This is a place to discuss Netflix VPN and proxy use. \n\n","over18":false},"MHOnline":{"lang":"en","description":"","over18":false},"vintagejapaneseautos":{"lang":"en","description":"A place to share images, videos, and discussions of classic (25+ years old) Japanese cars, trucks, and motorcycles.","over18":false},"KurokosBasketball":{"lang":"en","description":"This subreddit is for the animated series Kuroko no Basket. Everything Kuroko no Basket related is allowed. Videos, Games, Pictures, Manga, and, Discussions.\n","over18":false},"tasmania":{"lang":"en","description":"","over18":false},"PostgreSQL":{"lang":"en","description":"The home of the most advanced Open Source database server on the worlds largest and most active Front Page of the Internet.","over18":false},"Hookit":{"lang":"en","description":"Do you tow? Get something towed? Got a towing mishap to share? Post it here.","over18":false},"sticknpokes":{"lang":"en","description":"the do-it-yourself, machine-free tattoo community\n\ndotwork, linework, blackwork","over18":false},"EFLcomics":{"lang":"en","description":"","over18":false},"norsk":{"lang":"no","description":"**This is a community for people who are interested in learning Norwegian.**\nEveryone is welcomed to join us!","over18":false},"LaptopDeals":{"lang":"en","description":"A place to share deals & special sales on laptops and related accessories.","over18":false},"couplesgonewild":{"lang":"en","description":"","over18":true},"bostonhousing":{"lang":"en","description":"r/bostonhousing is a great resource for anyone looking for Boston apartments, rooms for rent in Boston, roommates in Boston, sublets in Boston and advice about moving to Boston + the surrounding area ","over18":false},"classicfallout":{"lang":"en","description":"Your fallout community for the early games, Fallout, Fallout 2, Fallout Tactics: Brotherhood of steel, or Van Buren.","over18":false},"FitshionVSFatshion":{"lang":"en","description":"**WE HATE FAT PEOPLE**\n\nWe take fatshion outfits and have real women wear them. Side-by-side for your viewing convenience!\n\n**What you can post**\n\n* Pictures making fun of fatshion.\n\n* Fatshion pictur","over18":false},"CODClanHQ":{"lang":"en","description":"This Subreddit has moved to /r/COD_LFG!","over18":false},"GoldCoast":{"lang":"en","description":"Gold Coast & Hinterland subreddit in Queensland, Australia","over18":false},"Torment":{"lang":"en","description":"Discussion about Torment: Tides of Numenera","over18":false},"bollywood":{"lang":"en","description":"All about Bollywood movies, hindi movies, reviews, celebrity and music. \n\nNote: The west mistakes Tollywood and South Indian films for Bollywood. Bollywood is the Mainstream Hindi/English Film industr","over18":false},"denverlist":{"lang":"en","description":"Looking to buy, sell, or trade goods or services in the Denver metro area?\n\n/r/DenverList is a subreddit for private party classified ads.","over18":false},"RedditAlternatives":{"lang":"en","description":"A subreddit for cataloging, dispersing and sharing all reddit alternatives out there.","over18":false},"overthegardenwall":{"lang":"en","description":"A subreddit for the Emmy Award-winning miniseries, Over the Garden Wall.","over18":false},"ACQR":{"lang":"en","description":"Post your designs, patterns, etc. all within this subreddit.","over18":false},"politicalfactchecking":{"lang":"en","description":"A crowd-sourced effort to monitor and critique the factual accuracy of US political speech. This includes major politicians, political voices, traditional and new media articles, and even email and so","over18":false},"MedievalEngineers":{"lang":"en","description":"","over18":false},"cambodia":{"lang":"en","description":"","over18":false},"kitty":{"lang":"en","description":"                   /\\             /\\\n                  |`\\\\_,--=\"=--,_//`|  \n                  \\ .\"  :'. .':  \". /\n                 ==)  _ :  '  : _  (==\n                   |>/O\\   _   /O\\<|\n         ","over18":false},"Bitconnect":{"lang":null,"description":"Subreddit forbidden","over18":null},"rpghorrorstories":{"lang":"en","description":"RPG Horror Stories - For all of your tales of tabletop sessions gone wrong!","over18":false},"iPhoneography":{"lang":"en","description":"An iPhone photography community.","over18":false},"VeganFoodPorn":{"lang":"en","description":"Sexy Vegan Food","over18":false},"gottheories":{"lang":"en","description":"A place for *A Song of Ice and Fire* fans to discuss theories about the books and television series.","over18":false},"nexusplayer":{"lang":"en","description":"","over18":false},"h3h3_productions":{"lang":"en","description":"h3h3 productions : For fans and those interested in h3h3productions & h3podcast.  For for people interested in copyright infringement, defamation, cyberbullying and naughtyness.  For people interest i","over18":false},"printers":{"lang":"en","description":"Inkjets, laser printers, commercial and industrial printers.\n\nTo make printers suck less by promoting printer maintenance, troubleshooting and providing accurate recommendations.","over18":false},"austinfood":{"lang":"en","description":"Post here to find that new restaurant or review a bad one. Share your pictures and your thoughts.","over18":false},"Tempe":{"lang":"en","description":"","over18":false},"tacos":{"lang":"en","description":"","over18":false},"HangoutFest":{"lang":"en","description":"","over18":false},"torrentrequests":{"lang":null,"description":"Subreddit forbidden","over18":null},"40something":{"lang":"en","description":"","over18":false},"Complextro":{"lang":"en","description":"A sub genre of 'electro'. This music is complex, hence the name, with artists producing basslines/leads that are very intricate sometimes involving 8+ different synth sounds per 2 bar loop.\n\nThis subr","over18":false},"Northwestern":{"lang":"en","description":"This is the subreddit for all things Northwestern.  Whether you're an alum, student, prospy, or generally interested in the 'Cats, welcome!","over18":false},"americanpirateparty":{"lang":"en","description":"it's better to be a pirate than to join the navy.","over18":false},"windowsinsiders":{"lang":"en","description":"A subreddit for specific discussion of Windows Insider Preview builds.","over18":false},"nothingeverhappens":{"lang":"en","description":"If it's on the front page of reddit, it's *probably* just a big made up lie for karma. \n\nhttps://www.reddit.com/r/snekblackout/comments/88ugck/official_snekblackout_sub_desctription/","over18":false},"GirlsGoneBitcoin":{"lang":"en","description":"The first subreddit for sexy people to get naked and tipped with Bitcoin, a digital currency.","over18":true},"thefollowing":{"lang":"en","description":"Subreddit for everything related to The Following, the serial killer television series starring Kevin Bacon on FOX.","over18":false},"faimprovement":{"lang":"en","description":"FAImprovement is a subreddit for individuals who want to improve their social skills, interpersonal relationships, and all around well-being.","over18":false},"family":{"lang":"en","description":"Post about anything related to family! This can be questions, Stories, and comparisons on families. We all have different views and opinions this is just a place to share the ones we have on family. I","over18":false},"CSGOJackpot":{"lang":null,"description":"Subreddit forbidden","over18":null},"abuse":{"lang":"en","description":"#It's not your fault. Remember this.\n\n\nThis is a community for people who suffer from any kind of abuse to find support with one another.","over18":false},"PokemonGo_Orlando":{"lang":"en","description":"","over18":false},"DickButt":{"lang":"en","description":"","over18":false},"UPenn":{"lang":"en","description":"The subreddit for the University of Pennsylvania, located in Philadelphia, PA.","over18":false},"respectporn":{"lang":"en","description":"Any manners that were settled with civility!","over18":false},"killzone":{"lang":"en","description":"","over18":false},"calmhands":{"lang":"en","description":"","over18":false},"cafe":{"lang":"en","description":"We aim to be the reddit version of your local cafe.\n\nWe welcome discussions related to coffee, other “cafe” food and drink, and cafe life.  Like real cafes have galleries or stages, we host weekly the","over18":false},"battlemaps":{"lang":"en","description":"This reddit is for posting battle maps for tabletop RPG's and related content, such as map creating tips, map ideas, or map play tests.","over18":false},"specialed":{"lang":"en","description":"This is a professional subreddit for people interested in special education, particularly: special education teachers, general education teachers, therapists, advocates and parents.\n\nWe are here to sh","over18":false},"GuildWars2Builds":{"lang":"en","description":"This is a place to constructively talk about various builds for characters in the MMO Guild Wars 2. ","over18":false},"OldManDog":{"lang":"en","description":"The go-to place to honor our old pets. Not just limited to dogs, but cats and all our other aging animals!","over18":false},"cartoons":{"lang":"en","description":"/r/Cartoons is a place full of discussion, and cartoon filled content! Come take part on our themed days and our many great discussions! ","over18":false},"GTAVadventures":{"lang":"en","description":"GTAVadventures • A GTA V Online Crew / Community created to escape from public games and have some anti-grief fun. Enjoy playing with friendly players in freemode or find some great team players from ","over18":false},"traphentai":{"lang":"en","description":"Subreddit for Trap hentai","over18":true},"casualknitting":{"lang":"en","description":"All those knitterly things that don't belong in other knitting subs.","over18":false},"zec":{"lang":"en","description":"Bitcoin and most cryptocurrencies expose your entire payment history to the public. Zcash is the first open, permissionless cryptocurrency that can fully protect the privacy of transactions using zero","over18":false},"MedicalGore":{"lang":"en","description":"Medical gore is a place for gory pics/videos with some connection to professional medicine.","over18":true},"MSGPRDT":{"lang":"en","description":"","over18":false},"WeinsteinEffect":{"lang":"en","description":"","over18":false},"Incest_Gifs":{"lang":"en","description":"Incest-themed porn gifs.","over18":true},"SomeOrdinaryGmrs":{"lang":"en","description":"The Official subreddit of SomeOrdinaryGamers\nCome check us out @ www.youtube.com/user/someordinarygamers\nHere, you can post about anything SOG-related. Fun!\n","over18":false},"Keto_Food":{"lang":"en","description":"Welcome to r/Keto_Food, a subreddit where users may log their meals for accountability or share recipes. This is a great place to discover new keto foods and learn from other ketoers' meals!","over18":false},"emergencymedicine":{"lang":"en","description":"/r/emergencymedicine is a subreddit for healthcare providers in the emergency setting to discuss their encounters and find ways to improve their knowledge of various parts of EM. ","over18":false},"learndutch":{"lang":"en","description":"A subreddit for those learning the Dutch language. Dutch has over 23 million native speakers from the Netherlands, Belgium, Suriname and elsewhere, and is one of the easiest languages for English spea","over18":false},"CamilleMains":{"lang":"en","description":"Welcome to /r/CamilleMains! This subreddit is dedicated to Camille, the Steel Shadow, a champion from League of Legends.","over18":false},"MarvelUnlimited":{"lang":"en","description":"Post your favorite comics that are available on Marvel Unlimited!","over18":false},"AskMeAnything":{"lang":null,"description":"Subreddit forbidden","over18":null},"relationshipadvice":{"lang":"en","description":"Moved to /r/relationship_advice","over18":false},"Wasteland2":{"lang":"en","description":"","over18":false},"AdvancedProduction":{"lang":"en","description":"This subreddit is for producers who have progressed past an introductory level of production and wish to engage in discussion about more advanced techniques and questions.\n\n","over18":false},"collared":{"lang":"en","description":"This is a place for posting images of humans at or above the age of 18 wearing collars, leashes, chokers, neck stretchers, or other restraining neckware. Anything from artistic fashion photoshoots to ","over18":true},"BruceSpringsteen":{"lang":"en","description":"Reddit Home of the Greatest Fans of the Legendary Bruce Springsteen and The E Street Band","over18":false},"Zune":{"lang":"en","description":"The small die-hard community dedicated to the legacy of the Zune","over18":false},"psx":{"lang":"en","description":"It's nostalgia overload as we discuss the most influential gaming system ever released! The original PlayStation, later called PSOne, brought a new attitude toward gaming. \n\nPSX is arguably the most i","over18":false},"esobiteme":{"lang":"en","description":"A place for you to post requests or offers to pass on Vampirism or Lycanthropy in ESO.\n","over18":false},"GriefSupport":{"lang":"en","description":"A place to share stories, ask questions or seek advice. Grief affects every person in a different way every time. Whether you are grieving the dead, a relationship, a job, a pet, a place or an era you","over18":false},"AntiTrumpAlliance":{"lang":"en","description":"An alliance among all who oppose Donald Trump's actions, positions, cabinet, supporters, policies, or motives. This alliance includes anyone from the left or the right; anyone from any religion or lac","over18":false},"bakeoff":{"lang":"en","description":"A subreddit dedicated to everything related to the BBC programme The Great British Bake Off.","over18":false},"TuxedoCats":{"lang":"en","description":"A place to post pictures of your Tuxedo Cat. All black and white kitties are welcome, and grey tuxes too :) ","over18":false},"hmmmgifs":{"lang":"en","description":"Gifs that make you go hmmm...","over18":false},"snapchat_sluts":{"lang":"en","description":"For all those sexy snaps\n\nNo minors!","over18":true},"toys":{"lang":"en","description":"Let's talk about toys","over18":false},"GoogleMaps":{"lang":"en","description":"A subreddit for anything and everything to do with Google Maps, Google Earth, and Google Street View.","over18":false},"DankMemesFromSite19":{"lang":"en","description":"A sub dedicated to storing and protecting the anomalous memes about The SCP Foundation and its objects.","over18":false},"espresso":{"lang":"en","description":"","over18":false},"Journaling":{"lang":"en","description":"The Subreddit for Journaling, Journalizing, and all things Journal related.  No matter how you choose to keep a Journal, our community is excited to see it.","over18":false},"apathy":{"lang":"en","description":"","over18":false},"lifx":{"lang":"en","description":"This subreddit is about everything and anything regarding the LIFX bulbs. ","over18":false},"reignofkingsgame":{"lang":"en","description":"This is a community for Reign Of Kings, a medieval survival game by Code }{atch that is currently in early access. [Click here for the Steam page.](http://store.steampowered.com/app/344760/)\n\n","over18":false},"diabetes_t1":{"lang":"en","description":"Forum for the discussion of the Type 1 diabetes.  Treatment, research and moral support.","over18":false},"papercraft":{"lang":"en","description":"We make cool things from paper.","over18":false},"randomactsofdota2":{"lang":"en","description":"A place for redditors who love Dota 2 and would love to give back to the community. \n","over18":false},"FetishItems":{"lang":null,"description":"Subreddit forbidden","over18":null},"PokemonGoSyd":{"lang":"en","description":"For all things related to Pokemon Go in Sydney","over18":false},"Meteor":{"lang":"en","description":"**A reddit for discussion and news about Meteor.JS**\n\nMeteor is a set of new technologies for building top-quality web apps in a fraction of the time, whether you're an expert developer or just gettin","over18":false},"CumHaters":{"lang":"en","description":"A place for the champions of porn: women who HATE cum, but still take it like a champ. You'll see no smiling faces here, just pretty girls wearing an equal part cum and disgust.","over18":true},"wtfart":{"lang":"en","description":"A place for artwork that makes your brain say WTF.\n\nArt, WTF, weird, oddities, artist","over18":false},"blizzcon":{"lang":"en","description":"BlizzCon news, speculation & discussion.","over18":false},"AskModerators":{"lang":"en","description":"A place for users to ask moderators questions and have them answered.","over18":false},"canadacordcutters":{"lang":"en","description":"This subreddit is focused on educating Canadians on the legal, reasonably priced options, news and discussion in regards to traditional cable alternatives.\n\nConsider posting constructive criticism / a","over18":false},"vuejs":{"lang":"en","description":"Vue.js is a library for building interactive web interfaces.  It provides data-reactive components with a simple and flexible API.","over18":false},"NSFW_nospam":{"lang":"en","description":"","over18":true},"apps":{"lang":"en","description":"The universal subreddit for anything application related.","over18":false},"LogHorizon":{"lang":"en","description":"The story begins when 30,000 Japanese gamers are trapped in the fantasy online game world Elder Tale. What was once a sword-and-sorcery world is now the real world. The main lead Shiroe attempts to su","over18":false},"acappella":{"lang":"en","description":"A community for a cappella musicians and enthusiasts to share questions, videos, news, events, etc.","over18":false},"SmiteTradingPost":{"lang":null,"description":"Subreddit no longer exists","over18":null},"universalstudios":{"lang":"en","description":"","over18":false},"free_karma":{"lang":"en","description":"Subscribe for free bonus karma \n\nFree KARMA for new accounts and old\n\nFree Karma! free karma for users and bots bots Don't delay. Get Karma today .   Instant Karma! Free Instant Karma.   Link Karma or","over18":false},"TopChef":{"lang":"en","description":"A subreddit discussing Bravo's *Top Chef*","over18":false},"Xbox_One_X":{"lang":"en","description":"Discuss games, rumors, hardware, and more about Microsoft's newest and most powerful console optimized for 4K gaming: The Xbox One X.","over18":false},"Swingersgw":{"lang":"en","description":"Pics of swingers doing naughty things. Upload your best! Upload often!","over18":true},"AliensAmongUs":{"lang":"en","description":"A place to post pictures/videos of aliens disguised as earthlings trying to assimilate, but being outed ***by their behavior.***","over18":false},"250r":{"lang":"en","description":"","over18":false},"calexit":{"lang":"en","description":"California is a Nation, not a State","over18":false},"abandoned":{"lang":"en","description":"Subreddit dedicated to abandoned places. ","over18":false},"magi":{"lang":"en","description":"Magi - The Labyrinth of Magic","over18":false},"iBUYPOWER":{"lang":"en","description":"All things iBUYPOWER","over18":false},"InsaneCringePosse":{"lang":"en","description":"A place for Juggalo cringe.","over18":false},"pug":{"lang":"en","description":"","over18":false},"NeedVocals":{"lang":"en","description":"I'm a composer, and like many others on Reddit we're looking for  singers, and that is the why I felt like a sub-reddit to help composers find singers would be a good idea, 300 of you seems to agree :","over18":false},"genderfluid":{"lang":"en","description":"","over18":false},"DestinyMemes":{"lang":"en","description":"","over18":false},"GettingShredded":{"lang":"en","description":"Looking to compete? To impress at the beach? To just feel better and boost your confidence? Whatever your reason to lose weight you've come to the right place. Discuss all things cutting and weight lo","over18":false},"Spanking":{"lang":"en","description":"","over18":true},"Im14andthisisWTF":{"lang":"en","description":"TIL 90's kids WTF so hard that YOLO","over18":false},"DarK":{"lang":"en","description":"Dark a Netflix Original Series","over18":false},"FULLDISCOURSE":{"lang":"en","description":"/r/FULLDISCOURSE is a sub for leftist discussion and debate, specifically aimed at anti-sectarianism. No liberals allowed.","over18":false},"hotones":{"lang":"en","description":"The Show with Hot Wings and Even Hotter Questions\n","over18":false},"StencilTemplates":{"lang":"en","description":"Stencil Templates is a home and archive for the digital copies of stencils. We seek to produce and catalog all stencil templates in the world in one easily searchable place.  We have two rules: follow","over18":false},"upstate_new_york":{"lang":"en","description":"","over18":false},"vlog":{"lang":"en","description":"Share your vlogs here. Please do not post pornographic stuff or something that is way too personal. This is a public subreddit.","over18":false},"NameMyTF2Item":{"lang":"en","description":"","over18":false},"burstcoin":{"lang":"en","description":"Official Burstcoin Subreddit","over18":false},"SoSE":{"lang":"en","description":"This is the Sins of a Solar Empire subreddit.  Sins of a Solar Empire is a 4X space RTS game.  **[Official Website](http://bit.ly/J7w7TW)**\n\nAll content related to Sins of a Solar Empire is allowed.","over18":false},"sewhelp":{"lang":"en","description":"We are a community to help with sewing machines, pattern drafting garment fitting, and general sewing questions.  ","over18":false},"Neuropsychology":{"lang":"en","description":"","over18":false},"8chan":{"lang":null,"description":"Subreddit forbidden","over18":null},"Shihtzu":{"lang":"en","description":"Discuss, share, and get help with this unique breed of dog. The Shih Tzu is the perfect pet for many people!","over18":false},"redpandas":{"lang":"en","description":"The place for all things red panda!\n","over18":false},"poop":{"lang":"en","description":"All things poop","over18":false},"jackrussellterrier":{"lang":"en","description":"","over18":false},"flextweak":{"lang":"en","description":"Official subreddit for the jailbroken Flex tweak: home to the Flexers in the /r/jailbreak community!","over18":false},"CamSluts":{"lang":"en","description":"Camgirls, webcam girls, cam models, webcam models, cam sluts - however you like to call them, this is the best and biggest subreddit devoted to those beautiful creatures that satisfy our lust in the n","over18":true},"facebookdrama":{"lang":"en","description":"For all types of Drama; between friends, family, strangers. If it's on Facebook we want to see it. ","over18":false},"MSILaptops":{"lang":"en","description":"This subreddit is about the famous laptop company called MSI (Micro-Star International). It aims to give subscribers content on MSI, whether it is a selfpost or a linkpost aslong as it has something t","over18":false},"passionx":{"lang":"en","description":"","over18":true},"Keratoconus":{"lang":"en","description":"Welcome to the largest keratoocnus support community on the web. Here you can share your keratoconus stories, ask for recommendations, and talk about available treatments, and latest breakthroughs.","over18":false},"NonZeroDay":{"lang":"en","description":"For those struggling with motivation and procrastination, a place to share your daily progress towards your goals. In this sub, users post about how they avoided a Zero Day, share experiences, motivat","over18":false},"HSPulls":{"lang":"en","description":"Subreddit to show things like your arena decks, what you opened in packs, and what you got as arena rewards. Thought it might be something that users will enjoy looking at and showing off cards.","over18":false},"LandscapeAstro":{"lang":"en","description":"Images, discussion, questions, gear and all things related to Landscape Astrophotography","over18":false},"pinsamt":{"lang":"sv","description":"Inspirerat av /r/cringe fast på svenska för att kunna inkludera alla nordiska pinsamheter.","over18":false},"eCards":{"lang":"en","description":"eCards","over18":false},"Tobacco":{"lang":"en","description":"","over18":false},"ThickChixxx":{"lang":"en","description":"\"Where it's hip to have hips!\"","over18":true},"rfelectronics":{"lang":"en","description":"","over18":false},"JARMEDIA":{"lang":"en","description":"Subreddit for the YouTube channel 'JAR Media'","over18":false},"SkyrimTogether":{"lang":"en","description":"Official Subreddit that tracks progress of the Skyrim mod \"Skyrim: Together\". A mod that will allow multiplayer gameplay to be added to The Elder Scrolls V: Skyrim.","over18":false},"sigurros":{"lang":"en","description":"","over18":false},"themartian":{"lang":"en","description":"Discussion of the sci-fi novel by Andy Weir and upcoming movie directed by Ridley Scott.","over18":false},"kickasstorrents":{"lang":"en","description":"/r/KickAssTorrents is an unofficial community sub-reddit for the popular torrent finding website KickAssTorrents (KAT). Only clean content is allowed on this community. What is found on hosted website","over18":false},"doodleordie":{"lang":"en","description":"","over18":false},"FuckTammy":{"lang":"en","description":"We have one message. That's \"Fuck you\" to Tammy.","over18":false},"gwpublic":{"lang":"en","description":"This is a gone wild sub that is only meant for the more daring gonewilders who snap it in public. This can be at work, the woods, or in the street! So get outside and show us what you got.","over18":true},"telecaster":{"lang":"en","description":"","over18":false},"graphicscard":{"lang":"en","description":"This subreddit is for build questions and graphics cards. If you have a question about the best card in the market or just what card is right for you, will answer it.","over18":false},"whatsmyimpression":{"lang":"en","description":"A place for internet strangers to give you their honest impression of you.","over18":false},"blogs":{"lang":"en","description":"","over18":false},"Flute":{"lang":"en","description":"","over18":false},"lolwallpaper":{"lang":"en","description":"A central location for all League of Legends wallpaper","over18":false},"PERSoNA":{"lang":"en","description":"****A community for the game series Persona\n","over18":false},"PublicBoys":{"lang":"en","description":"Pictures, videos and stories of boys and men in public. Naked, clothed or somewhere inbetween...","over18":true},"Nvidiahelp":{"lang":"en","description":"/r/nvidiahelp has closed, please see the pinned PSA for more info","over18":false},"altrap":{"lang":"en","description":"A place to discuss, share and enjoy alternative rap and hip-hop.","over18":false},"Shortfilms":{"lang":"en","description":"For links to *quality* short films that can be watched online.","over18":false},"classicfilms":{"lang":"en","description":"","over18":false},"northcounty":{"lang":"en","description":"Whatever's going on in Encinitas, Cardiff, Solana Beach, Del Mar,  Escondido, Carlsbad, Vista, Oceanside, Leucadia, RB, Poway, San Marcos, Rancho Santa Fe, Ramona, Rainbow, Fallbrook, or any of the ot","over18":false},"cosplaybutts":{"lang":"en","description":"Photos of butts in cosplay!","over18":true},"NewPatriotism":{"lang":"en","description":"Proud Principled Patriots.","over18":false},"PokemonGoOttawa":{"lang":"en","description":"Subreddit for the Ottawa Pokemon Go community. ","over18":false},"biglittlelies":{"lang":"en","description":"Big Little Lies is an American HBO television comedy-drama miniseries created by David E. Kelley, based on the book of the same name by Liane Moriarty.","over18":false},"jewelers":{"lang":"en","description":"","over18":false},"language":{"lang":"en","description":"","over18":false},"RuinedOrgasms":{"lang":"en","description":"This reddit is for fans of ruined orgasms and related aspects of orgasm control and femdom.","over18":true},"Friendzone":{"lang":"en","description":"A place to seek/give advice and support in matters regarding the friend zone.\n\nThe friend zone refers to a platonic relationship wherein one person wishes to enter into a romantic or sexual relationsh","over18":false},"textfriends":{"lang":"en","description":"In need of a someone to text?  Find your texting partner here!\n\nWe also have an irc chatroom: server is irc.snoonet.org, port is 6667 (6697 for SSL) \n\nhttps://kiwiirc.com/client/irc.snoonet.org/textfr","over18":false},"barefoot":{"lang":"en","description":"Barefoot/unshod running, walking, and lifestyle.","over18":false},"CommercialCuts":{"lang":"en","description":"A small edit can drastically change a commercial!","over18":false},"StoriesAboutKevin":{"lang":"en","description":"A Kevin is someone who consistently or greatly shows a complete lack of intelligence through incompetence of social and societal norms, or is purposefully antagonistic in their poor decision making.","over18":false},"brussels":{"lang":"en","description":"","over18":false},"myfavoritemurder":{"lang":"en","description":"This subreddit is for all things related to My Favorite Murder podcast with Karen Kilgariff and Georgia Hardstark.\n\nReady yourself for a murder adventure hosted by Karen Kilgariff and Georgia Hardstar","over18":false},"POF":{"lang":"en","description":"","over18":false},"scrandle":{"lang":null,"description":"Subreddit forbidden","over18":null},"PoliceChases":{"lang":"en","description":"A subreddit to post intense and exciting police chases and police action!","over18":false},"EngagementRings":{"lang":"en","description":"A place for all of us to post our engagement rings. This is where you can discuss a possible purchase or an explanation of what you or your significant other wants. Also, feel free to show off your en","over18":false},"forestry":{"lang":"en","description":"","over18":false},"FootFetish":{"lang":"en","description":"","over18":true},"ITSAPRANK":{"lang":"en","description":"Post videos that involve people being idiots and yelling \"it's a prank\" (preferably when they receive some sort of retribution). \n\n","over18":false},"Bloodline":{"lang":"en","description":"It's not always going to be this perfect. Things happen to people. Join the discussion of the Netflix Original Series 'Bloodline'","over18":false},"NSALeaks":{"lang":"en","description":"A place to find & discuss all of Snowden's revelations in an uncensored environment\n\n","over18":false},"Fable":{"lang":"en","description":"A subreddit for the discussion of all Fable games.","over18":false},"Kickboxing":{"lang":"en","description":"","over18":false},"lowcar":{"lang":"en","description":"Living a low-car lifestyle: biking, walking, riding public transit, and making the car an occasional option instead of the everyday necessity.","over18":false},"4kTV":{"lang":"en","description":"Discussion of 4k TVs, 2160P, Ultra HD, & HDR.","over18":false},"MapleStory2":{"lang":"en","description":"MMMM! Delicious English Version!","over18":false},"IWantToSuckCock":{"lang":"en","description":"A subreddit for guys with a need to suck cock.\nAnything related is welcome - questions, discussions, inspirational porn.","over18":true},"proghouse":{"lang":"en","description":"A place to share anything related to progressive house music.","over18":false},"PoliticalScience":{"lang":"en","description":"A place to discuss Political Science news and ask questions.","over18":false},"AsianPorn":{"lang":"en","description":"NSFW Subreddit for Asian porn.","over18":true},"ecuador":{"lang":"en","description":"Un sub dedicado a la comunidad ecuatoriana en Reddit enfocado en Ecuador y todo tema relacionado.  ¡Todos estan bienvenidos!\n\nA community dedicated to Ecuador and all related topics.   All are welcome","over18":false},"Dogfort":{"lang":"en","description":"COME IN DOGFORT, OVER!","over18":false},"Affiliatemarketing":{"lang":"en","description":"Affiliate Marketing community for Redditors. ","over18":false},"leotards":{"lang":"en","description":"This subreddit is dedicated to the beauty of Women in leotards and other spandex/lycra tight outfits.  One Piece swimsuits, Unitards, Biketards, are not only welcomed but invited.","over18":true},"kik":{"lang":"en","description":"","over18":false},"fetish":{"lang":"en","description":"","over18":true},"CryptoCurrencies":{"lang":"en","description":"The Internet's #1 place to follow cryptocurrencies.","over18":false},"FracturedButWhole":{"lang":"en","description":"Subreddit for the upcoming video game South Park: The Fractured But Whole","over18":false},"smartwatch":{"lang":"en","description":"For wearable technology in the watch form factor","over18":false},"FML":{"lang":"en","description":"Tell us about why your life sucks.","over18":false},"BoyScouts":{"lang":"en","description":"","over18":false},"ThisAmericanLife":{"lang":"en","description":"This American Life is an American weekly hour-long radio program produced by WBEZ and hosted by Ira Glass. Primarily a journalistic non-fiction program, it has also featured essays, memoirs, field rec","over18":false},"GERD":{"lang":"en","description":"This community is for discussions of GERD, Acid Reflux and Hearburn. You can also find information about symptoms and related treatments. Join us by sharing your stories, treatments and your favorite ","over18":false},"manass":{"lang":"en","description":"","over18":true},"HotWifeLifestyle":{"lang":"en","description":"A sub for discussion about the hotwife lifestyle for hotwives, the husbands who love us and the men who keep us cumming back for more!","over18":true},"diyelectronics":{"lang":"en","description":"This subreddit is dedicated to both amateur and professional engineers that want to build cool stuff at home, challenge themselves to learn new technologies, learn from each others' designs, and showc","over18":false},"milanavayntrub":{"lang":"en","description":"","over18":false},"NoMansSkyMods":{"lang":"en","description":"A place for the No Mans Sky modding community to congregate.","over18":false},"ComicWriting":{"lang":"en","description":"","over18":false},"toddlers":{"lang":"en","description":"**Anything** and **everything** relating to your toddler! A toddler is a child between 1 & 3 years old. ","over18":false},"OregonStateUniv":{"lang":"en","description":"A community for all things Oregon State University","over18":false},"Rad_Decentralization":{"lang":"en","description":"Subverting traditional hierarchical systems in favor of a more resilient, innovative, networked, transparent and sustainable world.","over18":false},"Internet":{"lang":"en","description":"News and information about the Internet.\n","over18":false},"confidence":{"lang":"en","description":"Confidence: The Key to Success","over18":false},"Androgynoushotties":{"lang":"en","description":"","over18":false},"FFSocks":{"lang":"en","description":"/r/FFsocks is for foot lovers who prefer the socks on. Any type of images, videos, or discussions focused on socks are welcome.","over18":true},"AlexisRen":{"lang":"en","description":"","over18":false},"Thief":{"lang":"en","description":"Thief is a series of stealth video games in which the player takes the role of Garrett, a master thief in a fantasy/steampunk world resembling a cross between the Late Middle Ages and the Victorian er","over18":false},"SupermodelCats":{"lang":"en","description":"Very good looking, photogenic cats.","over18":false},"ich_iel":{"lang":"de","description":"selbsties der seele","over18":false},"yellowstone":{"lang":"en","description":"A subreddit for discussion, photos, videos, and articles related to the world's first national park and the surrounding region (the Greater Yellowstone Ecosystem)","over18":false},"atx4atx":{"lang":"en","description":"r4r - Redditor for Redditor Whether you're seeking platonic friends, non-platonic friends, online gaming partners, soulmates, travelmates, workout buddies, groups to join, activity partners, friends w","over18":false},"IdleHeroesPS":{"lang":"en","description":"The Subreddit for the Private Server\n\nDiscord Server: https://discord.gg/AYpeXuJ\n","over18":false},"80smusic":{"lang":"en","description":"80's music!!","over18":false},"darknet":{"lang":"en","description":"","over18":false},"Sims4":{"lang":"en","description":"Sims 4","over18":false},"ratemyband":{"lang":"en","description":"","over18":false},"Capitalism":{"lang":"en","description":"A place to discuss Capitalism and capitalist interests on Reddit.","over18":false},"trueMusic":{"lang":"en","description":"Music is a global phenomenon, spanning time, language, and culture. Till now most of the musical content on reddit is focused primarily on English speaking contemporary music. As it is the spirit of t","over18":false},"texts":{"lang":"en","description":"/r/texts - a subreddit to submit your funny, weird, or random text messages from your mobile or cell phone.\n\n","over18":false},"mensa":{"lang":"en","description":"","over18":false},"ExCons":{"lang":"en","description":"This subreddit was created in the hope that men and women who have been put through the system only to turn their lives around would have an outlet to let their voices be heard. This subreddit is your","over18":false},"Full_news":{"lang":"en","description":"A place for serious news.","over18":false},"ADTR":{"lang":"en","description":"The official subreddit for all A Day To Remember Fans.\n\nNow ran by a new moderator!\n\n","over18":false},"minecraftskins":{"lang":"en","description":"Welcome to r/minecraftskins, a place to post and request minecraft skins!","over18":false},"FYFFest":{"lang":"en","description":"Hey lets talk about Fuck Yeah Fest!","over18":false},"Knightsofthebutton":{"lang":"en","description":"Our goal is to make sure that the button timer reaches zero. We must be vigilant and organized in order for our operation to be a success. Meet here for directions and to find a role to play in our ar","over18":false},"superhot":{"lang":"en","description":"The subreddit for SUPERHOT.\n\nhttp://superhotgame.com/","over18":false},"RomeSweetRome":{"lang":"en","description":"","over18":false},"ATLauncher":{"lang":"en","description":"ATLauncher is a simple and easy to use Minecraft Launcher which contains a tonne of different ModPacks for you to choose from. We at ATLauncher do not make any of these packs which makes what we do ve","over18":false},"HayDay":{"lang":"en","description":"Hay Day is a farming simulation game by Supercell for mobile devices.","over18":false},"0xProject":{"lang":"en","description":"0x is an open protocol that facilitates low friction peer-to-peer exchange on the Ethereum blockchain.","over18":false},"customsmash":{"lang":"en","description":"A place to share custom textures, stages, and songs for any Smash Brothers game! Come share your personal taste in aesthetics!","over18":false},"postpunk":{"lang":"en","description":"","over18":false},"realms":{"lang":"en","description":"A place for discussing Minecraft Realms.","over18":false},"KHUx":{"lang":"en","description":"A subreddit all about Kingdom Hearts Union χ [Cross]. Come here to discuss all aspects of the game!","over18":false},"ITunes":{"lang":"en","description":"for discussion and sharing tricks/hacks about the Apple software iTunes (for **Mac OS X and Windows**).","over18":false},"domesticviolence":{"lang":"en","description":"Information and support for victims, survivors, their friends and family.","over18":false},"realmoms":{"lang":"de","description":"Hot Picture of Sexy Moms, Milfs, Wifes or Mature Babes","over18":true},"continuityporn":{"lang":"en","description":"[THIS SUBREDDIT CONTAINS SPOILERS TO YOUR FAVORITE SHOWS/MOVIES]\n\nCon·ti·nu·i·ty\n\n* The maintenance of continuous action and self-consistent detail in the various scenes of a movie or broadcast.","over18":false},"ImaginaryHorrors":{"lang":"en","description":"The art of horror. If it is scary, it is welcome here. ","over18":false},"mfw":{"lang":"en","description":"","over18":false},"utopiatv":{"lang":"en","description":"Subreddit for the TV show Utopia","over18":false},"roll20LFG":{"lang":"en","description":"Many redditors who want to play RPGs can't, simply because they can't scrounge together enough people who want to play with them. However, using the new roll20 online RPG tool, redditors can now get o","over18":false},"AM2R":{"lang":"en","description":"For everything AM2R and Metroid: Confrontation related!","over18":false},"carlhprogramming":{"lang":"en","description":"An archive for the series of free programming classes taught by Carl Herold, designed for beginners on up.","over18":false},"leoduhvinci":{"lang":"en","description":"Collection of all stories posted by author Leonard Petracci, as well as updates on his coming novels and general news.","over18":false},"nook":{"lang":"en","description":"All about the Barnes & Noble Nook devices!","over18":false},"fishtank":{"lang":"en","description":"","over18":false},"dhmtb":{"lang":"en","description":"","over18":false},"NSFWskyrim":{"lang":"en","description":"**NSFW** \n\nYour window into the secret, sexual life of the people of skyrim.  \n\n\nFrom Redguards to Argonians. Nords, to High Elves. everything, and everyone in skyrim's exotic and erotic cities and fo","over18":true},"tourdefrance":{"lang":"en","description":"","over18":false},"psycho_alpaca":{"lang":"en","description":"Hey, I'll be posting my prompt answers and other things I write in here. Welcome!","over18":false},"reactnative":{"lang":"en","description":"A community for learning and developing native mobile applications using React Native by Facebook.","over18":false},"learnmachinelearning":{"lang":"en","description":"A subreddit dedicated to learning machine learning","over18":false},"Vechain":{"lang":"en","description":"VeChain is a global leading blockchain platform for products and information. In the past two years, VeChain has accumulated great amount of experience in providing blockchain solutions to various ind","over18":false},"movieclub":{"lang":"en","description":"","over18":false},"pixel_phones":{"lang":"zh","description":"A subreddit for the latest news and discussions regarding the Google's Pixel smartphones including Pixel 2, Pixel 2XL and Pixel XL and more ","over18":false},"CelebrityFeet":{"lang":"en","description":"","over18":false},"maker":{"lang":"en","description":"","over18":false},"cannabiscultivation":{"lang":"en","description":"","over18":false},"brutalism":{"lang":"en","description":"A friendly place to discover and appreciate brutalist buildings and architecture. Share photos, read articles, and discuss.","over18":false},"colorizebot":{"lang":"en","description":"Testing limits of AI artist by whatimadetoday","over18":false},"IsJewBoyMarriedYet":{"lang":"en","description":"I have this theory that if I just keep talking to people, eventually one of them will become my wife.\n\nSo far, I have not proven this theory to be true, I'll get back to you in 20 years.","over18":false},"SympatheticMonsters":{"lang":"en","description":"Monsters need love too. \n\nA place to collect hugs for silly, brave, humble, fabulous, homesick, terrified, or sympathetic monsters.","over18":false},"ParagonLFG":{"lang":"en","description":"/r/ParagonLFG is a subreddit dedicated to finding people to play Paragon with!","over18":false},"karma":{"lang":"en","description":"People receiving what you think is a fair outcome. \n\n\n","over18":false},"Vulfpeck":{"lang":"en","description":"Worshipping at the altar of Jack Stratton, Joe Dart, Theo Katzman, Woody Goss, & whoever happens to be featured. ","over18":false},"careeradvice":{"lang":"en","description":"","over18":false},"arabic":{"lang":"ar","description":"أحدث ما على المواقع العربية و كل ما يهم القارئ العربي.\n\nِA Subreddit for Arabic content on the internet, content written in Arabic not for learning Arabic or translation. For Learning Arabic language,","over18":false},"EAF":{"lang":"en","description":"Post things that you would describe as EPIC AS FUCK. ","over18":false},"Gaming_illuminaughty":{"lang":null,"description":"Subreddit forbidden","over18":null},"MakeStories":{"lang":"en","description":"The OP posts the first line to a story and everyone has to use one or two lines to make the story progress. The OP can also put a tag on the post, for example (funny) and it will be a story with humor","over18":false},"Jigsawpuzzles":{"lang":"en","description":"You like jigsaw puzzles. We like jigsaw puzzles. Drunks like Alcohol. Squirrels like nuts. Zoidberg dressed up like jesus once. Bill Murray likes us on Facebook...  Sorry, I kinda dozed off there. Wha","over18":false},"gggg":{"lang":"en","description":"g.","over18":false},"whatsthissnake":{"lang":"en","description":"The authoritative source on Reddit for your snake identification needs. ","over18":false},"depressed":{"lang":"en","description":"A community for people who are depressed or suffer from depression. ","over18":false},"Slitherio":{"lang":"en","description":"The Slither.io Subreddit ","over18":false},"HentaiSource":{"lang":"en","description":"This subreddit is dedicated to finding sources for your fapping needs in the hentai category.\n\nLet us all unite together and become the hentai fairies that guide the hands of newcomers to this gloriou","over18":true},"CPAP":{"lang":"en","description":"A place where CPAP users can exchange ideas, problems, interesting and other things they've found.","over18":false},"ThickThighs":{"lang":"en","description":"A place for Amateurs and models with thick thighs to share images of your beautiful thick thighs and luscious curves. Voluptuous women with big butts and breasts as well as enthusiasts who appreciate ","over18":true},"onionhate":{"lang":"en","description":"why do so many people have the wrong opinion?","over18":false},"DivinityOriginalSin2":{"lang":"en","description":"This subreddit has moved, please use /r/DivinityOriginalSin","over18":false},"iOS10":{"lang":"en","description":"","over18":false},"poodles":{"lang":"en","description":"","over18":false},"CivVI":{"lang":"en","description":"for Civ VI","over18":false},"ZNation":{"lang":"en","description":"A subreddit dedicated to SyFy's post-apocalyptic show Z-Nation.","over18":false},"adultvrgames":{"lang":"en","description":"Adult / NSFW virtual & augmented reality interactive experiences, utilities and gaming (hgames, western, etc!).  All related content is welcome: reviews, install tips, recommendations, previews, ideas","over18":true},"circasurvive":{"lang":"en","description":"Do you like Circa Survive? This is the place for you! News, band photos, original art, tattoos--anything goes.","over18":false},"TVRepair":{"lang":"en","description":"A place for DIY'ers to talk about and troubleshoot their television repair issues. I expect the focus to be mainly on LCD, DLP, and Plasma, however we welcome any TV technology, including projector re","over18":false},"whatsapp":{"lang":"en","description":"","over18":false},"NSFW_Korea":{"lang":"en","description":"If you like photos of beautiful Korean ladies showing their naked bodies, this is the right place for you. Here you'll find NSFW material with nude or barely clothed girls from Korea. GIFS are welcome","over18":true},"unintentionalASMR":{"lang":"en","description":"","over18":false},"TheWolfAmongUs":{"lang":"en","description":"","over18":false},"guro":{"lang":"en","description":"Erotic Grotesque ","over18":true},"gaynsfw":{"lang":"en","description":"/r/gaynsfw : The subreddit for anything gay-themed that you wouldn't be able to view at work. ","over18":true},"Audiomemes":{"lang":"en","description":"A subreddit for memes and image macros centered around audio production and recreation.\n","over18":false},"TheLastShip":{"lang":"en","description":"Subreddit for the TNT original television series, The Last Ship. Executive produced by Michael Bay.","over18":false},"Missing411":{"lang":"en","description":"Information and discussion about people who go missing in National Parks and forests, and rural and urban areas, as detailed in the Missing 411 books and movie. ## This is an unofficial, independant s","over18":false},"HorseMask":{"lang":"en","description":"","over18":false},"stownpodcast":{"lang":"en","description":"*S-Town* is a podcast from *Serial* and *This American Life*, hosted by Brian Reed, about a man named John who despises his Alabama town and decides to do something about it. He asks Brian to investig","over18":false},"SEGAGENESIS":{"lang":"en","description":"Genesis Does (you can't do this on Nintendo) ","over18":false},"swingersr4r":{"lang":"en","description":"","over18":false},"AmsterdamEnts":{"lang":"en","description":"A place where Ents of Amsterdam can share city and coffeeshop tips, meet up, chat, hang out.\n","over18":false},"DestinyTechSupport":{"lang":"en","description":"Having technical issues with your Destiny on PC or Console? Getting random errors? Looking for PC build specs for Destiny? Take a poke on the [Official Bungie Forums](https://www.bungie.net/en/Forums/","over18":false},"LibertarianLeft":{"lang":"en","description":"Liberty is the mother, not the daughter, of order.","over18":false},"multiwall":{"lang":"en","description":"A subreddit with wallpapers for users with more than one monitor.","over18":false},"CrossfitGirls":{"lang":"en","description":"* ","over18":false},"BookCollecting":{"lang":"en","description":"","over18":false},"DestinyLFG":{"lang":"en","description":"Welcome to /r/destinylfg, Guardian.\n\nWe exist as a place for anyone on any platform to find other Guardians with the same playstyle and/or level as them.","over18":false},"Underminers":{"lang":"en","description":"A semi-private place to share and discuss Undertale secrets discovered by means beyond playing the game.\n\nRespect Toby's wishes and don't dump anything into a public setting. As soon as someone has fi","over18":false},"nflgifs":{"lang":"en","description":"","over18":false},"punchableface":{"lang":"en","description":"Post a pic and we will see if it's worth a punch or not.","over18":false},"DestinyItemManager":{"lang":"en","description":"For discussion, suggestions, and bug reports","over18":false},"weddingdress":{"lang":"en","description":"","over18":false},"zizek":{"lang":"en","description":"Come here to discuss and debate the Giant of Ljubljana, Slavoj Žižek.\n\n","over18":false},"metroidvania":{"lang":"en","description":"*Metroidvania* is a subgenre of 2D (or 2.5D) platforming games focused on **guided non-linearity** and **utility-gated exploration**. The term, coined by video game critic Jeremy Perish, is a portmant","over18":false},"waze":{"lang":"en","description":"We are here to help with general questions and issues about the world's largest community-based traffic and navigation app: Waze.","over18":false},"sexystories":{"lang":"en","description":"/r/SexyStories is a place for people to share stories that they have written or found that excite them.  The only real limit here is one's own imagination.\n\n#Rules\n\n* Text-posts Only\n* Original Works ","over18":true},"DMDadJokes":{"lang":"en","description":"Hi Ready, I'm DM. ","over18":false},"cleanjokes":{"lang":"en","description":"For those of you who are either easily offended or just like clean jokes.","over18":false},"ConfessionBear":{"lang":"en","description":"**SUBSCRIBE TO /r/FRUITUNION**","over18":false},"soundtracks":{"lang":"en","description":"A Reddit community dedicated to music from film, games, and TV.","over18":false},"Legitpiercing":{"lang":"en","description":"This is a subreddit dedicated to everything piercing. This sub features quality piercing, and advice from some of the top professionals on reddit. Post pictures of your piercings, any questions you ma","over18":false},"ScreenJunkies":{"lang":"en","description":"Subreddit for ScreenJunkies, the home of Honest Trailers, Movie Fights and more.","over18":false},"FearMe":{"lang":"en","description":"","over18":true},"weirdal":{"lang":"en","description":"This is the place for all fans of the lyrical genius, poetic wordsmith, and performer extraordinaire, \"Weird Al\" Yankovic.  Please post all of your Al musings, tchotchkes, and gewgaws here.","over18":false},"GTAReplay":{"lang":"en","description":"","over18":false},"InterestingGifs":{"lang":"en","description":"A place for interesting gifs!","over18":false},"techsupportanimals":{"lang":"en","description":"","over18":false},"AccurateBattleSim":{"lang":"en","description":"Totally Accurate Battle Simulator ","over18":false},"bonnarootickets":{"lang":"en","description":"A Place To Buy & Sell Your Official Bonnaroo Wristbands and Passes.","over18":false},"lua":{"lang":"en","description":"News and discussion for the Lua programming language.","over18":false},"GasTheSnoo":{"lang":"en","description":"The trigger of the internet\n","over18":true},"BarCraft":{"lang":"en","description":"-----\n\n*\"For fans, watching in bars fulfills their desire to share the love of a game that many watched at home alone before.  Fans organize so-called Barcraft events, taking over pubs and bistros fro","over18":false},"Stealing":{"lang":null,"description":"Subreddit no longer exists","over18":null},"papertowns":{"lang":"en","description":"Papertowns is dedicated to well-crafted pictorial maps, detailed panoramic cityscapes, broad aerial vistas, intricate bird's-eye views and even full 3D reconstructions of cities, towns and citadels fr","over18":false},"DOTA":{"lang":"en","description":"","over18":false},"thestompingland":{"lang":"en","description":"The Stomping Land is a dinosaur survival game previously found on Steam. ","over18":false},"whatif":{"lang":"en","description":"Ponder the past potentials of plausible possibilities!","over18":false},"HighlightGIFS":{"lang":"en","description":"post gifs of amazing skill or amazing fails \n-no reaction GIFS \n-No memes \n-No NSFW(Nudity)\n-mild gore is ok","over18":false},"phoneverification":{"lang":"en","description":"Need your social accounts verified? Need your Bing Rewards accounts verified to collect your rewards? People can offer their verification services up here for a small fee at your convenience.","over18":false},"budapest":{"lang":"en","description":"","over18":false},"GhettoJerk":{"lang":"en","description":"","over18":false},"me_ira":{"lang":"en","description":"me_IRA","over18":false},"Amoledbackgrounds":{"lang":"en","description":"Backgrounds for AMOLED phones, mainly black for screen power saving.","over18":false},"BroadCity":{"lang":"en","description":"Discuss and share Broad City-related stuff here!\n\nYou can watch Broad City on Comedy Central's website or Hulu. Maybe it's even rerunning on Comedy Central right now!\n\nThere are no set rules for this ","over18":false},"threekings":{"lang":"en","description":"A subreddit to share our experiences following *any* kind of paranormal recipe or ritual (not just the titular \"Three Kings\"). We will not attempt to establish what is \"true\" or \"false\", nor to judge ","over18":false},"YouretheworstFX":{"lang":"en","description":"A television subreddit dedicated to the FX tv show You're The Worst.\n\nIt is centered on Jimmy (Chris Geere), a self-involved writer, and Gretchen (Aya Cash), a self-destructive Los Angeles PR executiv","over18":false},"healthIT":{"lang":"en","description":"A reddit for discussion and news about health information technology, electronic health records, security and privacy issues, and related legislation.","over18":false},"Nokia":{"lang":"en","description":"The subreddit that's connecting people for discussions about the Finnish company Nokia.","over18":false},"bustyasians":{"lang":"en","description":"","over18":true},"makemeaplaylist":{"lang":"en","description":"Want music for that 8 hour drive to pick up your new car? How about for the party your wife decided to throw for her sister's 3rd cousin's nephew's mother's new baby?\n\nOr maybe you just want to find s","over18":false},"Career_Advice":{"lang":"en","description":"This subreddit helps redditors find their perfect career by finding out exactly what their passion is.","over18":false},"bitcointip":{"lang":null,"description":"Subreddit forbidden","over18":null},"LesbianGamers":{"lang":"en","description":"","over18":false},"curledfeetsies":{"lang":"en","description":"Curled Kitty (perhaps others as well) Feetsies","over18":false},"Models":{"lang":"en","description":"","over18":false},"ThickDick":{"lang":"en","description":"The subreddit for those who love showing off/appreciating those dicks that are just a little bit more than a mouthful.","over18":true},"water":{"lang":"en","description":"Devoted to the science and politics of water: aquifers, dams, hydrology, boundary disputes, peak water, riparian rights, stormwater, groundwater, fish kills, fossil water, and news by the acre-foot.","over18":false},"opencarry":{"lang":"en","description":"/r/opencarry is a reddit community which focuses on issues which face advocates of the open carry of firearms in America.","over18":false},"almosthomeless":{"lang":"en","description":"A place to ask for help, advice, or assistance for people who are imminently at-risk of becoming homeless.","over18":false},"Catholic":{"lang":"en","description":"/r/Catholic is a place to present new developments in the world of Catholicism, discuss theological teachings of the Catholic Church, provide an avenue for reasonable dialogue amongst people of all be","over18":false},"explainlikeimjive":{"lang":"en","description":"I been done seen abou' ev'rting...","over18":false},"actualconspiracies":{"lang":"en","description":"Actual conspiracies exist. We ferret them out. No bullshit.","over18":false},"showbox":{"lang":"en","description":"Showbox is an android app that allows you to stream and download the latest movies and tv shows.","over18":false},"FMN":{"lang":"en","description":"Photos of famous male celebs in a state of undress","over18":true},"ansible":{"lang":"en","description":"Automation for the People! A Subreddit dedicated to fostering communication in the Ansible Community. ","over18":false},"macrogrowery":{"lang":"en","description":"This is the sister reddit of /r/microgrowery. This subreddit is dedicated to large scale grows of Cannabis; too large to consider 'Micro'.","over18":false},"ShroomID":{"lang":"en","description":"This subreddit is where people can post pictures of there mushrooms where people can help Identify the species name, people can post there findings, Tips and guides for finding mushrooms, Questions on","over18":false},"ThingsThatBlowUp":{"lang":"en","description":"blowing your mind literally... \n\nAs a statement on the treatment of moderators by Reddit administrators, as well as a lack of communication and proper moderation tools, /r/ThingsThatBlowUp has decided","over18":false},"cutegirlgifs":{"lang":"en","description":"","over18":false},"SurfaceLinux":{"lang":"en","description":"Linux development for Microsoft Surface-Series devices.","over18":false},"ENGLISH":{"lang":"en","description":"","over18":false},"seniorkitties":{"lang":"en","description":"This is a group for owners of senior cats. Post pictures, stories, or just to talk. ","over18":false},"TAAOfficial":{"lang":"en","description":"This is a place for my fans, detractors, and whoever else to post news stories they want me to comment on, subjects they'd like to see me discuss, comments, criticisms, etc. ","over18":false},"KoreanAdvice":{"lang":"en","description":"Give good advice to good people.","over18":false},"tooktoomuch":{"lang":"en","description":"**Welcome to /r/tooktoomuch**\n\nWhere cringe meets publicfreakout!!\n\n","over18":false},"swarmsim":{"lang":"en","description":"Play Swarm Simulator:\n\n* Original text version: [www](https://www.swarmsim.com) | [Kongregate](http://www.kongregate.com/games/swarmsim/swarm-simulator)\n\nPlay Swarm Simulator Evolution:\n\n* Mobile vers","over18":false},"cssbuy":{"lang":"en","description":"CSSBuy Chinese Shopping Agent! We can help you buy from Taobao, Tmall, 1688, or any other Chinese e-commerce site!","over18":false},"intothebadlands":{"lang":"en","description":"The subreddit for discussing anything and everything about AMC's martial-arts TV show ***Into the Badlands***.","over18":false},"naut":{"lang":"en","description":"Naut is a reddit theme! The goal of the theme is to create a visually appealing reddit that looks clean, modern and organised. This is the most popular theme on reddit, and hundreds of subreddits use ","over18":false},"fortify":{"lang":"en","description":"Fortify is a base designer for Rust. Quickly plan your base with lots of helpful tools and up to 3 other friends. See the stability, blow it up, and get a resource count. Frequently updated to include","over18":false},"squirrels":{"lang":"en","description":"","over18":false},"weedbiz":{"lang":"en","description":"This subreddit is for news, discussion and collaboration between current and future employees and entrepreneurs in the legal marijuana industry.","over18":false},"XChangePill":{"lang":"en","description":"This is a subreddit dedicated to X-Change Captions!","over18":true},"EliteWings":{"lang":"en","description":"A place for fellow Commanders to create, join, and organize wings or player groups in Elite: Dangerous.","over18":false},"Gamebundles":{"lang":"en","description":"/r/Gamebundles: a subreddit dedicated to your talk on bundles of games.","over18":false},"FireGuy12":{"lang":"en","description":"the flame lord","over18":false},"LiaMarieJohnson":{"lang":"en","description":"","over18":false},"words":{"lang":"en","description":"For logophiles, whether you tend toward pleonasm or perspicacious thrift. Any language is acceptable. Suggested topics are new words, expressions, neologisms, neoterisms, sniglets, odd usages, reanima","over18":false},"pcgiveaways":{"lang":"en","description":"This is a subreddit dedicated to all PC contests, sweepstakes, and giveaways.  Anything from prebuilt computers to graphics cards, and sometimes even just a simple mouse or keyboard giveaway.\n\nPlease ","over18":false},"futuresynth":{"lang":"en","description":"Future Synth is the sounds of yesteryear, today! It's 70s, 80s, & early 90s inspired music created that covers multiple subgenres (pop, romance, high school coming of age, old school video games, high","over18":false},"Syria":{"lang":"en","description":"","over18":false},"Blonde":{"lang":"en","description":"Golden-haired beauties with compromised morals. ","over18":true},"DogCare":{"lang":"en","description":"How can you help your dog to be as healthy as possible? The right food, the best grooming, skilled veterinary care, lots of exercise and play... these are our DogCare topics.","over18":false},"whitebeauty":{"lang":"en","description":"White people are some of the most beautiful people in the world. This subreddit hopes to collect images of the most beautiful white women, the most handsome white men, and the sweetest and most innoce","over18":false},"ITcrowd":{"lang":"en","description":"Subreddit of the best TV Show in the observable universe; the IT Crowd\n\nThe IT Crowd is a British sitcom by Channel 4\n","over18":false},"SmithAndWesson":{"lang":"en","description":"Smith & Wesson Firearms.\n\nPictures, announcements, questions, accessories and tech.","over18":false},"CongratsLikeImFive":{"lang":"en","description":"Ever need someone to be proud of your minor accomplishments?\n\nLook no further! ","over18":false},"controllablewebcams":{"lang":"en","description":"Welcoming all user controlled and public webcams!","over18":false},"stonehearth":{"lang":"en","description":"Subreddit created to share news and discuss the game called Stonehearth.\n\nOfficial website: http://stonehearth.net/","over18":false},"radarr":{"lang":"en","description":"Official Radarr subreddit\n\nhttps://radarr.video","over18":false},"SublimeText":{"lang":"en","description":"","over18":false},"sarah_xxx":{"lang":"en","description":"Sarah Calanthe ( Sarah-xxx ) fan club! Your home for amateur boobs and ass! Oh, and kitties. ","over18":true},"NYCjobs":{"lang":"en","description":"NYC job board, for anyone looking or hiring. Please prefix your post with [Hiring] or [For Hire]. Good luck!","over18":false},"boatporn":{"lang":"en","description":"This subreddit is for images of boats, however big or small, in dock, out at sea, tranquil waters or a ferry braving a storm. If it hasn't got a boat in it, don't post it!","over18":false},"GotG":{"lang":"en","description":"The Guardians of the Galaxy are a fictional superhero team that appear in comic books published by Marvel Comics. The movie is set to be released on August 1st in the USA.","over18":false},"chillstep":{"lang":"en","description":"A place for chilled music influenced mainly by dubstep or similar genres.","over18":false},"angryjoeshow":{"lang":"en","description":"A subreddit for fans of the Angry Joe Show.","over18":false},"KateeOwen":{"lang":"en","description":"Webcam girl with amazing body decides to step her game up a bit.","over18":true},"talesfromsecurity":{"lang":"en","description":"Tales from Physical Security, Loss Prevention, Protective Services, and anyone in general who gets paid to watch people and their crap.","over18":false},"redditlogos":{"lang":"en","description":"Are you a mod and need a logo?\n\nRequest one.\n\n\nWant to help out new subreddits? \n\nThen subscribe.\n\n","over18":false},"VirginiaBeach":{"lang":"en","description":"A place for all residents and visitors of Virginia Beach to discuss the area, ask questions, make announcements, and etc. ","over18":false},"thereifixedit":{"lang":"en","description":"MacGyver would be proud.","over18":false},"SushiAbomination":{"lang":"en","description":"","over18":false},"DoesNotTranslate":{"lang":"en","description":"Post quirky and niche words/phrases from foreign languages that can't easily be translated.","over18":false},"CasualMath":{"lang":"en","description":"This is a subreddit that is meant to be somewhere inbetween /r/math and /r/learnmath.","over18":false},"MildlyVandalised":{"lang":"en","description":"A place to share pictures and videos (or whatever) of mild vandalism that is either funny or mindful (or whatever).\n\n","over18":false},"pocketsand":{"lang":"en","description":"We want to increase awareness of the necessity to carry around sand in order to escape a violent situation","over18":false},"TrackMania":{"lang":"en","description":"The latest info and community content from the TrackMania series.","over18":false},"PhysicsStudents":{"lang":"en","description":"A place for physics students to talk about whatever!","over18":false},"shibe":{"lang":"en","description":"wow","over18":false},"RunningWithDogs":{"lang":"en","description":"Two feet, four paws! A community for people who combine the two greatest things in all the world - running and dogs!","over18":false},"funk":{"lang":"en","description":"","over18":false},"EuroTruck2":{"lang":"en","description":"This subreddit is dedicated to the newly released and very popular PC game \"Euro Truck Simulator 2.\" Anything related to the game can go here, along with discussions and pretty much anything else!\n\nJo","over18":false},"oneliners":{"lang":"en","description":"A variety of funny, one line jokes in a well-moderated, friendly community!","over18":false},"unitedstatesofamerica":{"lang":"en","description":"A subreddit dedicated to photographs of the USA.\n\nMember of the /r/NationalPhotoSubs network.","over18":false},"elementary":{"lang":"en","description":"A subreddit for CBS's Elementary starting Jonny Lee Miller and Lucy Liu as Sherlock and Dr. Joan Watson.","over18":false},"GetOutOfBed":{"lang":"en","description":"","over18":false},"Achievement_Hunter":{"lang":"en","description":"A subreddit for AH fans","over18":false},"AppleWhatShouldIBuy":{"lang":"en","description":"A place to ask for Product advice and experiences for Apple products!","over18":false},"DSP":{"lang":"en","description":"","over18":false},"dawnofjustice":{"lang":"en","description":"Batman v Superman Official Sub-Reddit","over18":false},"HorrorGaming":{"lang":"en","description":"Quality horror gaming content and discussion.","over18":false},"marveltsumtsum":{"lang":"en","description":"Welcome to /r/marveltsumtsum. This place is for us to talk about Marvel Tsum Tsum, a game by Mixi/NHN/Disney similar to Disney Tsum Tsum.\n\n\n ","over18":false},"R4R30Plus":{"lang":"en","description":"Come in and meet people over 30!\n\n**r4r30plus - Redditors for Redditors over 30**\n\nWhether you're looking for friends, partners, drinking buddies, friends with benefits, or casual encounters, this is ","over18":false},"androidtablets":{"lang":"en","description":"A place to discuss, post news, and suggest the best and latest Android Tablets to hit the market.\n\nNexus 7, Nexus 10, Galaxy Tab, Iconia, Kindle Fire, Nook Tablet, HP Touchpad and much more!","over18":false},"SurgeryGifs":{"lang":"en","description":"Gifs of surgeries and surgical animations.","over18":false},"BooksAMA":{"lang":"en","description":"","over18":false},"maisiewilliams":{"lang":"en","description":"A subreddit dedicated to the one and only Maisie Williams, widely known for her role as Arya Stark in the hit HBO series 'Game of Thrones'.","over18":false},"3dspiracy":{"lang":"en","description":"A safe haven where piracy discussion is allowed.","over18":false},"CrackSupport":{"lang":"en","description":"","over18":false},"PokemonGo_Singapore":{"lang":"en","description":"Gotta Catch Em All! Pokemon GO for Singapore! Discuss NEWS, Game Updates, Pokemons and strategies for Pokemon GO Singapore!","over18":false},"sc2partners":{"lang":"en","description":"Feeling lonely? Looking for a special someone to help you get your macro on? Maybe you need someone to help you perfect that almost perfect build of yours? \n\nWhat ever it is find what you're looking f","over18":false},"Nightwing":{"lang":"en","description":"","over18":false},"PS4Mods":{"lang":"en","description":"Welcome to the PlayStation 4 modding community! :)","over18":false},"HellsKitchen":{"lang":"en","description":"","over18":false},"BusinessIntelligence":{"lang":"en","description":"","over18":false},"FifaUTWagers":{"lang":"en","description":"A subreddit dedicated to any wagers that you want to play for in FIFA Ultimate Team.","over18":false},"throatpies":{"lang":"en","description":"Here you'll find videos (and ONLY videos) of those most rare and perfect girls - the ones who don't stop sucking just because you're cumming!","over18":true},"RepressedGoneWild":{"lang":"en","description":"Women from repressive societies go wild. ","over18":true},"thelastguardian":{"lang":"en","description":"Official subreddit of \"The Last Guardian\", the long-awaited video game from genDESIGN and Team Ico for the PS4.","over18":false},"atlantar4r":{"lang":"en","description":"","over18":true},"androidwatchfaces":{"lang":"en","description":"Share unique and custom watch faces here. ","over18":false},"diving":{"lang":"en","description":"Not just SCUBA, but snorkeling and skin diving as well! We welcome everyone, from the least experienced newbie budding with questions to the salty geezer grumbling about 'kids these days with their fa","over18":false},"Agriculture":{"lang":"en","description":"Agricultural science and practice","over18":false},"IsolatedVocals":{"lang":"en","description":"Isolated Vocals - Songs without the instrumentals.\n\nCreated due to popular demand on [this comment](http://redd.it/1ir1ei) on an /r/Music post. Isolated tracks really bring out the talent of the artis","over18":false},"AgedBeauty":{"lang":"en","description":"A sub dedicated to \"Aged Beauties\", that is beutiful women *slightly* older than those you would find on more mainstream nsfw subreddits.","over18":true},"Nike":{"lang":"en","description":"JUST DO IT.","over18":false},"survivorsofabuse":{"lang":"en","description":"This is a subreddit designed to give a place for survivors of all abuse to come together to share their stories, vent, and to assist one another in healing. We want to celebrate success, give acceptan","over18":false},"RepublicOfMusic":{"lang":"en","description":"The Republic of Music is modeled after /r/music, but with a twist - only content created or published within the last three months will be allowed, and reposted or rehosted content is prohibited. Audi","over18":false},"dementia":{"lang":"en","description":"This subreddit is dedicated to information and support for people dealing with dementia.\n\nDementia is an abnormal, serious loss of cognitive ability, often seen in older people as a result of degenera","over18":false},"LeafyIsHere":{"lang":"en","description":"The non-cancer version of /r/ReptilianBrotherhood.","over18":false},"DirkGently":{"lang":"en","description":"The subreddit for the 2016 BBC America/Netflix series Dirk Gently's Holistic Detective Agency.\n","over18":false},"frogs":{"lang":"en","description":"A subreddit for all things about frogs.","over18":false},"revolutionNBC":{"lang":"en","description":"Sub dedicated to the NBC Television program Revolution\n\nRevolution \"is described as a high-octane action drama following a group of characters struggling to survive and reunite with loved ones in a wo","over18":false},"torpedotits":{"lang":"en","description":"","over18":true},"digitaltabletop":{"lang":"en","description":"A community of people who enjoy playing hobbyist board games on iPad, iPhone, Android phones and tablets, and computers. Whether you enjoy games like Settlers of Catan or Carcassonne, or more hard cor","over18":false},"SexyWomanOfTheDay":{"lang":"en","description":"Welcome to r/SexyWomanoftheDay! We choose a new woman nominated by our sub members every 24 hours to post photos/gifs and videos of! Feel free to nominate some of your favorite Models or Celebs!","over18":false},"freegold":{"lang":"en","description":"Free gold for everyone, no questions asked!","over18":false},"AnimalsWithoutNecks":{"lang":"en","description":"Animals, Without the Neck Bit.\n","over18":false},"conan":{"lang":"en","description":"Sub for Conan talk show on TBS","over18":false},"aviationpics":{"lang":"en","description":"","over18":false},"MyNintendo":{"lang":"en","description":"My Nintendo allows you to earn points by playing apps on your smart devices or buying digital games for your Wii U or Nintendo 3DS systems. These points can be redeemed for My Nintendo rewards such as","over18":false},"AdventureTheory":{"lang":"en","description":"Theories for the hit animated television show: Adventure Time","over18":false},"OffensiveMemes":{"lang":"en","description":"Place for offensive memes on Reddit.","over18":false},"lookingforheroes":{"lang":"en","description":"#####Looking For Heroes\n\n**This subreddit is dedicated to facilitating groups for Blizzard's Heroes Of The Storm**\n\n\n\n\n\n","over18":false},"LetsPlayVideos":{"lang":"en","description":"LetsPlayVideos is a place for posting and watching Let's Play style videos. Let's Play videos involve playing a game, usually a video game, for the entertainment of the internet. Audience participatio","over18":false},"golfclassifieds":{"lang":"en","description":"","over18":false},"TheCloneWars":{"lang":"en","description":"The home for all links and discussion related to the 3D CGI Animated Clone Wars television show seen on Cartoon Network. ","over18":false},"SuperMega":{"lang":null,"description":"Subreddit forbidden","over18":null},"estimation":{"lang":"en","description":"Ever wondered what the rate of gummi bear combustion needed to power a lawn mower is?\n\nHow fast do you need to throw a burrito to make it spontaneously ignite?\n\nA subreddit dedicated to one of the mos","over18":false},"BethesdaSoftworks":{"lang":"en","description":"/r/BethesdaSoftworks is an unofficial, community subreddit dedicated to all games, mods, and projects related to the game publisher Bethesda Softworks and its subsidiary studios.\n","over18":false},"irc":{"lang":"en","description":"","over18":false},"atheist":{"lang":"en","description":"There are shitty people that are religious, and there are shitty people that are atheist.  Using passive aggressive language like \"OMG, guy gets arrested for inappropriately touching cattle after leav","over18":false},"agnosticism":{"lang":"en","description":"Tell my wife I said Hello.","over18":false},"DickPics4Freedom":{"lang":"en","description":"Help us stick it to the NSA!","over18":true},"UPS":{"lang":"en","description":"A community where people can discuss and ask questions regarding anything UPS related.","over18":false},"ShittyBuildaPC":{"lang":"en","description":"Build a PC.\n\n\nBut Shitty.","over18":false},"thecatdimension":{"lang":"en","description":"Whenever a cat freaks out, it runs off out of sight. Little do most people know that they actually escape to the cat dimension, which is a dimension that's always just out of sight of all humans and i","over18":false},"Mushrooms":{"lang":"en","description":"Everything relating to Mushrooms!\n\nAlso, see /r/mushroomporn for hi-res pics","over18":false},"StopTouchingMe":{"lang":"en","description":"For images similar to http://i.imgur.com/oExe2zs.jpg","over18":false},"cummingonfigurines":{"lang":"en","description":"","over18":true},"wholesomeanimemes":{"lang":"en","description":"only heartwarming and wholesome animemes allowed","over18":false},"expats":{"lang":"en","description":"For anyone who has left their native country and moved to a new one.","over18":false},"Ferrari":{"lang":"en","description":"Subreddit dedicated to everything that comes out of Maranello, whether it be Scuderia Ferrari or the factory road cars. \n\nHigh resolution photos, news items, Formula 1, if it concerns Ferrari, it belo","over18":false},"ClubPenguin":{"lang":"en","description":"This is a fan run subreddit for the virtual online game ClubPenguin. Discussions, jokes, leaks, and other related topics are all welcome!","over18":false},"WonderWoman":{"lang":"en","description":"Subreddit dedicated to DC comic book female super hero (super heroine), Wonder Woman. Amazons, Mythology, Superheroes, Comic Books, TV shows, animation, Sensation Comics, and more!","over18":false},"MildlyStartledCats":{"lang":"en","description":"Cats that are mildly startled.","over18":false},"SkyrimHelp":{"lang":"en","description":"Is something isn't working the way it should be in [The Elder Scrolls V: **Skyrim**](https://en.wikipedia.org/wiki/The_Elder_Scrolls_V:_Skyrim)? Stuck on a quest with no idea how to continue? Anything","over18":false},"SurviveTogether":{"lang":"en","description":"","over18":false},"manufacturing":{"lang":"en","description":"A subreddit for anyone in the manufacturing industry. Content is very diverse: you'll find videos, articles and self posts just to name a few. ","over18":false},"IRLgirls":{"lang":"en","description":"This is a subreddit for posting pictures of girls that you know in real life. Instagram, Facebook, and Snapchat are all great options. ","over18":false},"WeddingRingsShowing":{"lang":"en","description":"A place for those who have a thing for married/engaged women and couples. Nude, non-nude, and anything in between. Just as long as a ring is showing! ","over18":true},"MeetPeople":{"lang":"en","description":"Here at /r/MeetPeople you can find people from everywhere to talk to, or hang out with!","over18":false},"EtikaRedditNetwork":{"lang":"en","description":"The Official Etika Subreddit Made by the Man Himself.","over18":false},"PBSOD":{"lang":"en","description":"Public Blue Screens of Death, computer crashes, etc.","over18":false},"Pyrography":{"lang":"en","description":"","over18":false},"shallowhouse":{"lang":"en","description":"It's like deep house but its not and it's like house but it's not, it's kind of like uk bass but it's not, it might even sound a little like future garage but really, we all know it's not. It's shallo","over18":false},"lifeisbeautifulLV":{"lang":"en","description":"Life is Beautiful Music & Art Festival in Las Vegas, NV.\n","over18":false},"UnpopularOpinions":{"lang":"en","description":"Disagree with everyone else? Here's where you can voice it.","over18":false},"WOGPRDT":{"lang":"en","description":"","over18":false},"shower_thoughts":{"lang":"en","description":"A subreddit for you to share all those thoughts, ideas, or philosophical questions that race through your head when in the shower.\n\n\nShowerthought is a loose term that applies to any thought you might","over18":false},"plugdj":{"lang":"en","description":"Play music and videos with friends and others from around the world.","over18":false},"TrollXOver30":{"lang":"en","description":"Because we have seen some shit.","over18":false},"government":{"lang":"en","description":"","over18":false},"CoinedUp":{"lang":"en","description":"get the latest updates and ask your questions here!","over18":false},"gayotters":{"lang":"en","description":"","over18":true},"MaladaptiveDreaming":{"lang":"en","description":"This subreddit is dedicated to individuals suffering from Maladaptive Daydreaming and helping them cope with the disorder. Share anything you would like to discuss on the topic.","over18":false},"nickofnight":{"lang":"en","description":"A place for my short stories and series. ","over18":false},"randomactsofkindness":{"lang":"en","description":"We've all been there. Feeling horrible and disappointed by people doing uncaring things. This is the place to inspire, show us the good side of people. Because there really are good people out there, ","over18":false},"Dominos":{"lang":"en","description":"Domino's Pizza","over18":false},"FrontPage":{"lang":"en","description":"","over18":false},"VirtualFreakout":{"lang":"en","description":"","over18":false},"COPYRIGHT":{"lang":"en","description":"","over18":false},"astrophysics":{"lang":"en","description":"","over18":false},"restaurateur":{"lang":"en","description":"A community for restaurant owners, managers and all those who want a behind the scenes look at how a restaurant actually functions. ","over18":false},"theblackvoid":{"lang":"en","description":"The black void will consume all. \n\n","over18":false},"PublicFlashing":{"lang":"en","description":"A place for sexy pictures of girls flashing their private parts (tits, ass, pussy - it's all welcomed), getting naked or otherwise exposing themselves in public places.","over18":true},"yiffcomics":{"lang":"en","description":"EXTRE, EXTRE. THE NEW EDITIONS OF ALL OF YOUR FAVORITE ARTISTS' COMICS ARE HERE!","over18":true},"XMage":{"lang":"en","description":"A community focused on XMage and the community that keeps it thriving","over18":false},"Rlanguage":{"lang":"en","description":"We are interested in implementing R programming language for statistics and data science.\n","over18":false},"SMITEbug":{"lang":null,"description":"Subreddit forbidden","over18":null},"2busty2hide":{"lang":"en","description":"A collection of shirt-straining breasts.","over18":true},"Muppets":{"lang":"en","description":"","over18":false},"OnStageGW":{"lang":"en","description":"A place where you can post singers / celebs / naughty girls / strippers with sexy outfits  or doing something sexual on any stage. That includes things like runways / strip clubs  and concerts.","over18":true},"californication":{"lang":"en","description":"","over18":false},"SplitDepthGIFS":{"lang":"en","description":"A place to share many of the Split-Depth GIFS, you know the ones with the 3D effect by using white lines.","over18":false},"merchents":{"lang":"en","description":"","over18":false},"IRstudies":{"lang":"en","description":"","over18":false},"InfernalMachine":{"lang":null,"description":"Subreddit forbidden","over18":null},"futuristparty":{"lang":"en","description":"","over18":false},"explainlikedrcox":{"lang":"en","description":"Ok, listen here, pumpkin, if you’re honestly having this much trouble understanding this simple concept, just go ahead and give me a call and I’ll toss you a sympathy throw-down anytime.\n\n...Fine Newb","over18":false},"isfp":{"lang":"en","description":"For redditors interested in the Myers-Briggs Type Indicator (MBTI), specifically those identifying as or interested in Introverted Sensing Feeling Perceiving persons (ISFP).\n","over18":false},"shittysuperpowers":{"lang":"en","description":"Post your favorite shitty superpowers that will help you save or shit on the world that needs us! ","over18":false},"interesting":{"lang":"en","description":"","over18":false},"Demonoid":{"lang":"en","description":"","over18":false},"SneakerDeals":{"lang":"en","description":"A place to post deals on sneakers. Sister reddit of /r/Sneakers.\n","over18":false},"embedded":{"lang":"en","description":"","over18":false},"PrimitiveTechnology":{"lang":"en","description":"Discussion About Primitive Technology","over18":false},"PowerLedger":{"lang":"en","description":"Power Ledger uses blockchain technology to enable energy trading within buildings and across networks. We believe empowering individuals and communities to co-create their energy future will underpin ","over18":false},"linuxhardware":{"lang":"en","description":"A subreddit where you can ask questions about what hardware supports GNU/Linux, how to get things working, places to buy from (i.e. they support GNU/Linux) and so on. No hard and fast rules as such, p","over18":false},"ledzeppelin":{"lang":"en","description":"","over18":false},"SoccerNoobs":{"lang":"en","description":"New to the sport and looking for somewhere to learn and discuss the rules, teams, players, and leagues? Soccer gains popularity every day, and most of the current discontent with the sport comes from ","over18":false},"LCMS":{"lang":"en","description":"","over18":false},"ruralporn":{"lang":"en","description":"A subreddit in the Safe For Work Porn Network focusing on images of man-made objects in natural settings. A lone cabin on a hill, a bridge on a trail through a forest, the patchwork of fields in a val","over18":false},"Unorthodog":{"lang":"en","description":"*Unorthodogs* is the place for dogs pictures that aren't necessarily \"cute\", but more of an [unattractive kind of cute.] (http://assets.dogtime.com/asset/image/4f966f59eadf725ead00046d/column_dog-pict","over18":false},"SmallYTChannel":{"lang":"en","description":"This is a place where the smaller side of YouTube can show their stuff, If you have a channel between 5 and 1000 subs be sure to post your video here. Using proper grammar and capitalization in your p","over18":false},"tron":{"lang":"en","description":"","over18":false},"duckduckgo":{"lang":"en","description":"r/DuckDuckGo is for news, updates and discussion about the search engine DuckDuckGo.","over18":false},"theworldnews":{"lang":"en","description":"News from the 200+ countries around the world without any US related news, which would otherwise swamp it due to the US-centric nature the bulk of the reddit audience.\n\nMany of the submissions will be","over18":false},"gigabytegaming":{"lang":"en","description":"The official GIGABYTE AORUS subreddit!","over18":false},"electronic_circuits":{"lang":"en","description":"","over18":false},"sportsjerseys":{"lang":"en","description":"A place for disscussion of all sports jerseys.","over18":false},"theHunter":{"lang":"en","description":"This subreddit is dedicated to theHunter, the most realistic and enjoyable hunting game available on PC","over18":false},"AndroidUsers":{"lang":"en","description":"A community for Android users, run by Android users.\n\n[test](www.reddit.com)","over18":false},"Ceramics":{"lang":"en","description":"","over18":false},"toolporn":{"lang":"en","description":"A site dedicated to tools. All tools that are awesome and useful, from power tools, to hand tools to pneumatic tools to dentistry tools.","over18":false},"SEGA":{"lang":"en","description":"","over18":false},"OneDirection":{"lang":"en","description":"Everything related to the British band One Direction.\n","over18":false},"ender":{"lang":"en","description":"Welcome to r/ender, the community for Orson Scott Card's Enderverse series. From the Ender Quintet to the Formic War Trilogies, anything related to this expansive universe belongs here! If you've just","over18":false},"Exxxtras":{"lang":"en","description":"An nsfw subreddit for behind-the-scenes material","over18":true},"lds":{"lang":"en","description":"The community for those interested in **faithful** discussions related to The Church of Jesus Christ of Latter-day Saints and its members, known colloquially as \"Mormons\".","over18":false},"HarleyQuinn":{"lang":"en","description":"Subreddit for the Jokers girl, Harley Quinn, put anything about Harley, put pictures, have debates about who played Harley Quinn the best, just do anything Harley Quinn based. Have fun!","over18":false},"sjsucks":{"lang":"en","description":"The idea of social justice is good. The movement is not.","over18":false},"simpsonsdidit":{"lang":"en","description":"","over18":false},"sonicshowerthoughts":{"lang":"en","description":"Thoughts you might have taking a much needed sonic shower aboard a USS Federation ship.","over18":false},"AlternativeHistory":{"lang":"en","description":"This is a subreddit for the free and open discussion of history related independent thoughts and research. Including but not limited to suppressed historical events, out of place artifacts , alternati","over18":false},"BeardAdvice":{"lang":"en","description":"The definitive source for men who need answers to their bearded questions. Everyone is welcome to join in on the action. ","over18":false},"guildwars2funny":{"lang":"en","description":"","over18":false},"fut":{"lang":"en","description":"The subreddit for players of FIFA Ultimate Team for Xbox One, PS4, Xbox 360, PS3 and PC.","over18":false},"pestcontrol":{"lang":"en","description":"Welcome to /r/PestControl - your resource for getting your home back.","over18":false},"irlsmurfing":{"lang":"en","description":"A celebrity or professional pretending to be amateur usually under disguise. The video has to be an activity that the person is known for. For example, a professional tennis player pretending to be an","over18":false},"TrollMUA":{"lang":"en","description":"This is a subreddit devoted to all those times you wanted to submit a something to MUA but couldn't. Or when you didn't feel like it belonged in TrollX. This includes dupes, bad make up days, fails, a","over18":false},"DrugArt":{"lang":"en","description":"For all the artistic uppers, downers, trippers and stoners out there!","over18":false},"webarebears":{"lang":"en","description":"We Bare Bears is an animated comedy on Cartoon Network about three brothers trying to fit in and make friends. We Bare Bears is based off the comic created by Daniel Chong.","over18":false},"recordstore":{"lang":"en","description":"A special place for music lovers. Whether you're looking for recommendations, want to try out a new genre, or you're trying to find artists similar to one you really like, this is the place!","over18":false},"ineedafavor":{"lang":"en","description":"","over18":false},"AyyLmao2DongerBot":{"lang":"en","description":"All things /u/AyyLmao2DongerBot","over18":false},"InboxInvites":{"lang":"en","description":"A subreddit for those looking to share and obtain invites for Inbox by GMail","over18":false},"forgeries":{"lang":null,"description":"Subreddit no longer exists","over18":null},"TheStopGirl":{"lang":"en","description":"The Stop Girl","over18":false},"RoadRage":{"lang":"en","description":"Road Rage is a subreddit dedicated taking your rage out on the road, especially on that asshole who cut you off on I-15 yesterday. ","over18":false},"fuxtaposition":{"lang":null,"description":"Subreddit forbidden","over18":null},"Sissy":{"lang":"en","description":"","over18":false},"SRSFeminism":{"lang":"en","description":"SRSFeminism is a place for feminists to talk about feminism and social issues. Sick of MRAs appropriating every comment thread about feminism? Then you might be home!","over18":false},"gloriouspcmasterrace":{"lang":"en","description":"/r/PCMasterRace","over18":false},"microphones":{"lang":"en","description":"*Tap* *Tap* *Tap* Is this thing on?","over18":false},"PCSX2":{"lang":"en","description":"PCSX2 is a PlayStation 2 emulator, a free program that tries to replicate the PlayStation 2 to enable you to play PS2 games on your PC.","over18":false},"renfaire":{"lang":"en","description":"","over18":false},"entourage":{"lang":"en","description":"Sub-reddit for anything to do with the HBO TV series Entourage.","over18":false},"BlackHair":{"lang":"en","description":"black hair","over18":false},"Cthulhu":{"lang":"en","description":"","over18":false},"arizer":{"lang":"en","description":"","over18":false},"Laptop":{"lang":"en","description":"This subreddit is for the general discussion of laptops and the sorts. We don't have many restrictions on what can be posted, just anything remotely related to laptops.","over18":false},"taptycoon":{"lang":"en","description":"Tap Tycoon, the new game by Game Hive!","over18":false},"sph":{"lang":"en","description":"A subreddit for those who enjoy small penis humiliation.","over18":true},"evenwithcontext":{"lang":"en","description":"Sometimes thinks make no sense with no context... Sometimes things don't make sense *even with context*.","over18":false},"Injustice2":{"lang":"en","description":"","over18":false},"cybersecurity":{"lang":"en","description":"","over18":false},"Bottomless_Vixens":{"lang":"en","description":"**/r/Bottomless_Vixens** - for pictures of clothed female models, nude from the waist down. Please no partial or full toplessness.","over18":true},"qualitynews":{"lang":"en","description":"Breaking news from around the world brought to you by trusted sources. This is a current events discussion community built around quality and reputability with active moderation to foster constructive","over18":false},"DSLR":{"lang":"en","description":"","over18":false},"BannedFrom4chan":{"lang":"en","description":"A collection of bans from 4chan, both old and new. Posting your own is great too. I like to rhyme while ringing a chime. ","over18":false},"OldSchoolCoolMusic":{"lang":"en","description":"/r/OldSchoolCoolMusic\n\n**History's musicians and their fans, looking fantastic!**\n\nA pictorial and video celebration of history's coolest musicians, everything from beatniks to breakcore, heavy metal ","over18":false},"ketamine":{"lang":"en","description":"","over18":false},"hentaibondage":{"lang":"en","description":"Erotic art to exemplify the kinkiness of our deviant sexuality. \n\nHentai bondage galore!","over18":true},"pepe":{"lang":"en","description":"","over18":false},"80s":{"lang":"en","description":"","over18":false},"Kalilinux":{"lang":"en","description":"Dedicated to Kali Linux, a complete re-build of BackTrack Linux, adhering completely to Debian development standards with an all-new infrastructure that has been put in place.","over18":false},"PCBuilds":{"lang":"en","description":"This is a dedicated subreddit for showing your build process. Imgur albums of 6+ photos, youtube, or vimeo links would be ideal.","over18":false},"RebelGalaxy":{"lang":"en","description":"Subreddit for the newly announced game [Rebel Galaxy](http://rebel-galaxy.com/) by Double Damage.","over18":false},"BanjoKazooie":{"lang":"en","description":"Guh-uh! This subreddit is dedicated to our favorite bird and bear - Banjo and Kazooie! ","over18":false},"agile":{"lang":"en","description":"Interesting bits about Agile Development. Includes Scrum, Extreme Programming (XP), Lean, Kanban, etc.","over18":false},"absolutelynotmeirl":{"lang":"en","description":"","over18":false},"H1Z1KOTK":{"lang":"en","description":"","over18":false},"Troll4Troll":{"lang":"en","description":"You're a TrollX'er, and so is he.  You saw her comment on TrollY and had to get to know her.  ","over18":false},"Residency":{"lang":"en","description":"Welcome to the Residency subreddit, a community of interns and residents who are just trying to make it through training! \n\nThis is a subreddit specifically for interns and residents to get together a","over18":false},"vodka":{"lang":"en","description":"","over18":false},"iPAHub":{"lang":"en","description":"A place for your modified iPAs","over18":false},"112263Hulu":{"lang":"en","description":"This subreddit is dedicated to the Hulu Original series 11.22.63 based off of the novel, 11/22/63 by Stephen King. The series is executive produced by J.J. Abrams, Stephen King, Bridget Carpenter and ","over18":false},"browsers":{"lang":"en","description":"","over18":false},"Jarrariums":{"lang":"en","description":"","over18":false},"garlicoin":{"lang":"en","description":"Our website is garlicoin.io\n\nGarlicoin is hot out of the oven and ready to serve you with its buttery goodness. Forked from LTC, this decentralized cryptocurrency with almost no new technology will he","over18":false},"BoostForReddit":{"lang":"en","description":"A place for discussion, requests and bug reports of the android reddit app Boost for reddit","over18":false},"coldshowers":{"lang":"en","description":"","over18":false},"BiGoneMild":{"lang":"en","description":"Bisexuals, pansexuals, omnisexuals, queers, and any non-straight person in their natural habitat.","over18":false},"youngatheists":{"lang":"en","description":"A place for young atheists to share their experiences and questions. We welcome all for a nice slice of skepticism and a cold glass of babies.","over18":false},"Tabs":{"lang":"en","description":"","over18":false},"ComedyNecrophilia":{"lang":"en","description":"We take unfunny things, and make them worse.  \n","over18":false},"FlarrowPorn":{"lang":"en","description":"This is a place to view the hot ladies starring in the hit CW \"Flarrow\" TV show universe: Arrow, The Flash, Supergirl and Legends of Tomorrow.\n\nWilla Holland, Katie Cassidy, Emily Bett Rickards, Candi","over18":false},"chapelhill":{"lang":"en","description":"","over18":false},"pwned":{"lang":"en","description":"","over18":false},"PokemonSunMoon":{"lang":"en","description":"The unofficial subreddit for Pokémon Sun & Moon.","over18":false},"Cryptozoology":{"lang":"en","description":"","over18":false},"goldbenefits":{"lang":"en","description":"A subreddit within which the denizens of reddit can discuss the merits and detriments of reddit gold.","over18":false},"skinwalkers":{"lang":"en","description":"A place to post your personal experiences, thoughts, or stories you have found about skinwalkers and similar legends.","over18":false},"kungfucinema":{"lang":"en","description":"A Subreddit Dedicated To Kung Fu & Martial Arts Films.","over18":false},"tryptonaut":{"lang":"en","description":"Tryptonauts are present-day shamans who believe in the medicinal use of certain ethnobotanicals to heal the mind and body.\n\nThey share the collective knowledge of psychotropic tryptamines and psychede","over18":false},"SugarBaby":{"lang":"en","description":"This sub is aimed primarily for women searching for a sugardating, sugarlifestyle, or sugar arrangement.  This is a safe place for women to find their ideal sugar daddy (sugardaddy) and ask advice fro","over18":true},"LegalCollegeGirls":{"lang":"en","description":"Legal College Girls is a place for Redditors to enjoy some great pictures, GIFs, and other media of hot girls. Make sure to have some fun!\n\n","over18":true},"excgarated":{"lang":"en","description":"When a misspelling is so bad it's comical, potentially to the extent of being unique in the universe.","over18":false},"sixthworldproblems":{"lang":"en","description":"","over18":false},"MegTurney2":{"lang":"en","description":"","over18":true},"devilian":{"lang":null,"description":"Subreddit forbidden","over18":null},"cute":{"lang":"en","description":"A place for cute stuffs.","over18":false},"hentiny":{"lang":null,"description":"Subreddit no longer exists","over18":null},"motorcycle":{"lang":"en","description":"A place to share this magnificent obsession. Be polite to your fellow's and keep all post motorcycle related, the moderation here will be light as long as it is on point.","over18":false},"THPS":{"lang":"en","description":"General Discussions, News, and Announcements concerning all the games in the Tony Hawk's Pro Skater series.","over18":false},"KylieJenner":{"lang":"en","description":"","over18":true},"questions":{"lang":"en","description":"","over18":false},"Shoes":{"lang":"en","description":"Shoes are so much more than a covering for a foot. Shoes are art and creativity. Shoes are distinction and class. Shoes can be an accessory or a lifestyle.\n\nLet's talk shoes!","over18":false},"Obduction":{"lang":"en","description":"From the award-winning creators of Myst and Riven","over18":false},"AmazonWTF":{"lang":"en","description":"Have you ever seen something for sale on Amazon that made you step back and say \"What the fuck?\"\nLink that product here!","over18":false},"budgetdecks":{"lang":"en","description":"Magic: The Gathering does not have to be expensive.\n\nBudget Decks is a subreddit designed to discuss playing Magic: The Gathering in any format or play style on a budget. Discussion may include budget","over18":false},"mildlysatisfying":{"lang":"en","description":"This is the subreddit is dedicated to posting specifically things that satisfy you in a day to day basis. The aim is to share things the little victories that you encounter every day, but they're just","over18":false},"theydidthemonstermath":{"lang":"en","description":"","over18":false},"vine":{"lang":"en","description":"Anything related to [Vine](http://tinyurl.com/ajv249w), the new 6-second video service intimately linked to twitter.","over18":false},"petplay":{"lang":"en","description":"For all fans of Pet Play: kitties, puppies, catgirls, petgirls, ponygirls, pets, ferals, critters, and all others, as well as their trainers, handlers, and owners!\n\nPet images, videos, and discussion ","over18":true},"FifthWorldPics":{"lang":"en","description":"","over18":false},"WoWGoldMaking":{"lang":"en","description":"A community that celebrates the art of making gold in World of Warcraft.","over18":false},"HamRadio":{"lang":"en","description":"","over18":false},"AccidentalRacism":{"lang":"en","description":"This is where you can post all the accidental racism pictures.","over18":false},"marines":{"lang":"en","description":"","over18":false},"RESAnnouncements":{"lang":"en","description":"A subreddit for announcements about [Reddit Enhancement Suite](https://www.redditenhancementsuite.com), a community-driven unofficial browser extension for reddit","over18":false},"Myfitnesspal":{"lang":"en","description":"This community is geared to discussions about the MyFitnessPal (MFP for short) platform, including the app for Android and iOS and website.\n\n# DISCLAIMER\nWe are not healthcare professionals and you sh","over18":false},"PokemonMelanite":{"lang":"en","description":"Everything and anything related to Pokemon Melanite Version, a Pokemon fan game being made in RPG Maker XP using Pokemon Essentials.","over18":false},"MaymayZone":{"lang":"en","description":"Welcome to Clank. This is the Maymay Zone, where you can post literally anything. [WARNING: CAN'T POST LITERALLY ANYTHING]","over18":false},"treatemright":{"lang":null,"description":"Subreddit forbidden","over18":null},"Televisions":{"lang":"en","description":"Discussion for televisions and news about technology involving them.","over18":false},"liquiddnb":{"lang":"en","description":"","over18":false},"flashcarts":{"lang":"en","description":"Come here to discuss flash cartridges for old consoles. Discussion of other similar technology (like PSIO) is also acceptable.","over18":false},"waterfox":{"lang":"en","description":"The official community to discuss Waterfox. Get support, help and anything you need Waterfox related.","over18":false},"finishing":{"lang":"en","description":"/r/finishing is a forum that encourages the respectful exchange of wood or metal finishing knowledge and projects","over18":false},"radioreddit":{"lang":"en","description":"/r/radioreddit is the subreddit for the radio reddit online streaming radio station featuring 100% original music created by thousands of redditors.  The live streams are algorithmic and controlled 10","over18":false},"ww2":{"lang":"en","description":"","over18":false},"teksavvy":{"lang":"en","description":"","over18":false},"megalophobia":{"lang":"en","description":"A place to post images of all things large, particularly ones that are \"triggers\" for those with megalophobia.","over18":false},"Oilporn":{"lang":"en","description":"Oiled, lubed, shiny, slippery ladies","over18":true},"oddlyweird":{"lang":"en","description":"/r/oddlyweird is a friendly community for people who has interest things like,  weird, [oddly weird facts](http://oddlyweirdfacts.com), wtf, paranormal, creepy, CCTV footage's and Unexplained Mysterie","over18":false},"limitless":{"lang":"en","description":"A subreddit focused on the new CBS TV show Limitless, which airs on Tuesdays at 10PM EST.","over18":false},"SummerReddit":{"lang":"en","description":"A place to chronicle the posts that are popular in summertime. ","over18":false},"Bones":{"lang":"en","description":"Subreddit dedicated to discussion of the Fox TV show Bones. Recent episode discussion, links to new trailers and reviews by an anthropologist are examples of our regular submissions.","over18":false},"WomenOfColour":{"lang":"en","description":"","over18":true},"TF2LFT":{"lang":"en","description":"","over18":false},"powerbuilding":{"lang":"en","description":"Powerbuilding. A hybrid of Powerlifting, and Bodybuilding.\n\n                                                  Look strong, be strong.","over18":false},"shoebots":{"lang":"en","description":"Feel free to talk about bots, proxies, or servers here. This place is not a marketplace for shoes, so please do not make it that. This is a home for healthy and community discussion of bots so that we","over18":false},"Skyrim_Mods":{"lang":"en","description":"We post Mods of any type for Skyrim only.","over18":false},"jaxx":{"lang":"en","description":"","over18":false},"Jewish":{"lang":"en","description":"/r/Jewish is a subreddit devoted to all things culturally, communally and questionably Jewish. Less religious than some other corners of the internet, and always welcoming to our LGBTQ members. ","over18":false},"knowyourshit":{"lang":"en","description":"Best posts from any learning subreddit \n\n\n","over18":false},"HoustonClassifieds":{"lang":"en","description":"","over18":false},"SRSMen":{"lang":"en","description":"SRSMen is an inclusive, safer space where toxic masculinity is deconstructed and men's issues are discussed from a feminist perspective.","over18":false},"KledMains":{"lang":"en","description":"A subreddit dedicated to all the mains of the League of Legends champion named Kled!","over18":false},"EmiliaClarke":{"lang":"en","description":"The mother of dragons Emilia Clarke subreddit.","over18":false},"ChangingRooms":{"lang":"en","description":"Sexy pictures taken from inside of changing rooms","over18":true},"fail":{"lang":"en","description":"Fail","over18":false},"HardFestival":{"lang":"en","description":"Anything related to Hard Festivals (Hard Summer, Holy Ship, Hard Red Rocks, Hard Day of the Dead, etc)","over18":false},"webmarketing":{"lang":"en","description":"","over18":false},"Hell_On_Wheels":{"lang":"en","description":"Subreddit for the TV series, Hell on Wheels, starring Anson Mount. Currently airing on AMC.","over18":false},"celebrities":{"lang":"en","description":"The place for all news and information about your favorite celebrities. ","over18":false},"waterpolo":{"lang":"en","description":"A sports subreddit dedicated to everything water polo related.","over18":false},"SaraJUnderwood":{"lang":"en","description":"Post pictures, videos and news about the beautiful Sara Jean Underwood","over18":true},"racing":{"lang":"en","description":"Welcome to r/RACING. ","over18":false},"bernesemountaindogs":{"lang":"en","description":"","over18":false},"skyrimdadjokes":{"lang":"en","description":"Terrible and sometimes hilariously weak humor about, or referencing TESV: Skyrim.","over18":false},"unix":{"lang":"en","description":"","over18":false},"SFBayHousing":{"lang":"en","description":"","over18":false},"saxophone":{"lang":"en","description":"A subreddit to discuss music, tips and tricks, or just general knowledge about saxophone!","over18":false},"RemixOS":{"lang":"en","description":"Remix OS alpha for PC is free to download as of January 12, 2016. This subreddit is for Remixers, the members of the kickstarter campaign, and the facebook group, as well as the general public who are","over18":false},"Otters":{"lang":"en","description":"","over18":false},"NuDisco":{"lang":"en","description":"For those of us that enjoy the smoother, groovier side of electronic music.  A place where we can all share the music we love and discover something we can fall in love with.  Turn up the volume, add ","over18":false},"NSFWBarista":{"lang":"en","description":"Hot chicks serving hot coffee!","over18":true},"blackhat":{"lang":"en","description":"Blackhat library is here for the ongoing discussion and documentation of vulnerabilities and exploitation techniques, all in one place.","over18":false},"YogscastHannah":{"lang":"en","description":"A subreddit concerning Hannah of the Yogscast!","over18":false},"goldredditsays":{"lang":"en","description":"Welcome to GoldRedditSays! GRS is the subreddit for gold miners to mine the comments posted on Reddit and to find those really good comments that show goldlords on Reddit being decent human beings.","over18":false},"Antenna":{"lang":"en","description":"","over18":false},"SuddenlyGay":{"lang":"en","description":"For photos, videos, gifs, or stories of people who somehow, unwittingly, engaged in gay activities.","over18":false},"LingerieGW":{"lang":"en","description":"Photos of women wearing Lingerie in real life.","over18":true},"banana":{"lang":"en","description":"As a statement on the treatment of moderators by Reddit administrators, as well as a lack of communication and proper moderation tools, /r/banana has decided to go private for the time being. Please s","over18":false},"Liftingmusic":{"lang":"en","description":"Ask, share and suggest the music you like to run/lift to.","over18":false},"Map_Porn":{"lang":"en","description":"A subreddit dedicated to the sharing, discussion, and appreciation of maps. Created as an apolitical alternative to /r/MapPorn. \n\nTags: map porn, mapporn, map_porn, map, maps, topography, geography, a","over18":false},"deadisland":{"lang":"en","description":"First person zombie survival game by Techland. ","over18":false},"Wasteland":{"lang":"en","description":"A subreddit for discussion on Fallout, Wasteland, or any other related game!","over18":false},"thank_mr_skeltal":{"lang":"en","description":"thank mr skeltal","over18":false},"Overwatchmemes":{"lang":"en","description":"Overwatch Memes","over18":false},"Odesza":{"lang":"en","description":"","over18":false},"GirlTalk":{"lang":"en","description":"  ","over18":false},"ForHonorEmblems":{"lang":"en","description":"Show off your For Honor Emblems!","over18":false},"growmybusiness":{"lang":"en","description":"Welcome to r/GrowMyBusiness. Ask and/or give business feedback and advice. Everyone is welcome from entrepreneurs, owners, startups, small businesses, non profits, experts, engineers, designers, marke","over18":false},"Beardsandboners":{"lang":"en","description":"Beard pics for ladyboners, with the occasional boner included as well.","over18":true},"nsfl":{"lang":null,"description":"Subreddit forbidden","over18":null},"TroveMarketplace":{"lang":"en","description":"Trade offers, price checks, price guides, and offerings to RNGesus.  Subreddit not affiliated with Trion Worlds.","over18":false},"bigdicklovers":{"lang":"en","description":"Big Dick Hookup! For people who have big dicks and the (wo)men who love them. Find a partner here.","over18":true},"geekboners":{"lang":"en","description":"This subreddit is dedicated to the geeky women of science, scifi, video games, anime, fantasy, and any and every geeky genre that's out there. This subreddit is not spoiler free. \n","over18":false},"GoodValue":{"lang":"en","description":"Not necessarily the cheapest or best quality but the best value for money\n\n/r/GoodValue -- The child that resulted after /r/buyitforlife and /r/frugal hooked up one night and didn't practice safe cros","over18":false},"TotalWarArena":{"lang":"en","description":"A subreddit for the game Total War Arena by Creative Assembly and Wargaming Alliance.","over18":false},"GoTlinks":{"lang":"en","description":"Free links for the online series game of thrones!","over18":false},"austinjobs":{"lang":"en","description":"","over18":false},"shestillsucking":{"lang":"en","description":"Busted a nut, and she still sucking.","over18":false},"cat_girls":{"lang":"en","description":"Catgirl central! A subreddit for pictures of cute girls wearing cat, bunny, fox, or other animal themed outfits.","over18":true},"MaleUnderwear":{"lang":"en","description":"Reddit's hub for all things male underwear related. ","over18":true},"github":{"lang":"en","description":"A subreddit for all things GitHub!","over18":false},"brownman":{"lang":"en","description":"All things Ray Narvaez Jr.","over18":false},"WTFgaragesale":{"lang":"en","description":"Saw some weird, bizarre, crazy, creepy, or downright disgusting thing for sale at a garage sale, yard sale, Craigslist, or thrift shop?\n\nIf it makes you go WTF, this is the place for it! ","over18":false},"KHX":{"lang":"en","description":"A board for discussing the Kingdom Hearts χ series: χ[chi] on PC, Unchained χ on iOS and Android, and the movie Back Cover χ.","over18":false},"rhps":{"lang":"en","description":"","over18":false},"RASPBERRY_PI_PROJECTS":{"lang":"en","description":"This is a subreddit dedicated to Raspberry Pi owners, listing all available projects that could be done on their Raspberry Pi. This subreddit also lists tutorials and guides for the newbies to make th","over18":false},"TrollXFitness":{"lang":"en","description":"This is not a serious fitness sub.  This is a place to complain when fitness sucks and to figure out how to make it suck less, even when runner's high is an obvious fiction. ","over18":false},"Kotlin":{"lang":"en","description":"Discussion about Kotlin, statically typed programming language for the JVM, Android and the browser.","over18":false},"GreekLife":{"lang":"en","description":"All Greek-related ideas, activities, events, advice, and information belong in this subreddit.","over18":false},"LazyMan":{"lang":"en","description":"A desktop application that helps you watch free NHL and MLB games","over18":false},"zoology":{"lang":"en","description":"","over18":false},"MiiverseInAction":{"lang":"en","description":"The best, worst, and funniest of Miiverse!","over18":false},"GoneMildPlus":{"lang":"en","description":"Only real users are allowed to post. If we don't think it is a real user we may ask for verification.\nDon't forget this is not a NSFW place. No nudity! Clothes on please or some lingerie at lest. ","over18":false},"mathpics":{"lang":"en","description":"","over18":false},"ChristianGirls":{"lang":"en","description":"###The Church of Reddit. Praise the Lord.\n\n(Hint: It's religious porn.)\n\n[Keywords: Jesus, fucking, Christ, wet pussy, burning bush, cunnilingus, Buddha, naked, worship, vagina, prayer, orgasm, Muhamm","over18":true},"EJuicePorn":{"lang":"en","description":"This subreddit is primarily for showing off your E-Juice collections, but accepts recommendations and questions about brands/flavors. Shoutout any sales or any particular videos or websites concerning","over18":false},"TodayIWore":{"lang":"en","description":"","over18":false},"WilliamShatner":{"lang":"en","description":"The Official Reddit for William Shatner.","over18":false},"snapleaks":{"lang":"en","description":"This is a place for all of your sexy, secret, and seductive snapchat screenshots. This subreddit is automatically NSFW so both softcore and hardcore content are welcome. ","over18":true},"whitecollar":{"lang":"en","description":"A subreddit for the USA Network television show \"White Collar\", which follows FBI agent Peter Burke of the white-collar crimes division and reformed(?) con man Neal Caffrey, who helps Peter solve case","over18":false},"CollegeAmateurs":{"lang":"en","description":"","over18":true},"NYCtrees":{"lang":null,"description":"Subreddit forbidden","over18":null},"enbro":{"lang":"en","description":"Official subreddit of Epicnamebro... but just call me \"Marcus.\" Or \"Macchan.\"","over18":false},"randomsexygifs":{"lang":"en","description":"A collection celebrating those beautiful, fleeting moments of female sexiness, performed by celebrities and non-celebrities alike, that are so well-captured by GIFs and compiled here for your viewing ","over18":false},"Punk_Rock":{"lang":"en","description":"","over18":false},"picturesofiansleeping":{"lang":"en","description":"There can be only one.","over18":false},"Questland":{"lang":"en","description":"Questland is an amazing RPG experience that has it all: collecting items, stunning armory sets and of course great battles! Grab it for free on iOS and Android!","over18":false},"teentitans":{"lang":"en","description":"","over18":false},"mancave":{"lang":"en","description":"\"A room, space, corner or area of a dwelling that is specifically reserved for a male person to be in a solitary condition, away from the rest of the household in order to work, play, involve himself ","over18":false},"rpcs3":{"lang":"en","description":"RPCS3 is an experimental open-source Sony PlayStation 3 emulator and debugger written in C++ which currently supports Windows, Linux and BSD systems.\n\nRPCS3 started development in May of 2011 by its f","over18":false},"googleplaymusic":{"lang":"en","description":"Ok Google, Play Music.","over18":false},"catfish":{"lang":"en","description":"","over18":false},"Puffies":{"lang":"en","description":"Everything about puffy nipples.","over18":true},"CageTheElephant":{"lang":"en","description":"Subreddit for the band \"Cage the Elephant!","over18":false},"areolas":{"lang":"en","description":"For areola lovers","over18":true},"forcedorgasms":{"lang":"en","description":"For pictures and videos of forced orgasms, male or female.","over18":true},"shouldimod":{"lang":"en","description":"Debating on getting a body modification, but unsure if it suits you? Let us help you decide what to adorn yourself with.","over18":false},"PaintballBST":{"lang":"en","description":"","over18":false},"ProCSS":{"lang":"en","description":"For users, moderators and subreddits who are in support of continued CSS use on Reddit.\n","over18":false},"GBr4r":{"lang":"en","description":"An R4R subreddit just for British redditors!","over18":false},"BeMeApp":{"lang":"en","description":"beme: Share video. Honestly.\n\nBeme is Casey Neistat's new app. It is a video sharing app similar to snapchat.","over18":false},"BlackSquad":{"lang":"en","description":"For all Black Squad related news and more!","over18":false},"TheBlackKeys":{"lang":"en","description":"","over18":false},"HoMM":{"lang":"en","description":"","over18":false},"customization":{"lang":"en","description":"","over18":false},"suspiciousquotes":{"lang":"en","description":"","over18":false},"Charity":{"lang":"en","description":"/r/Charity - Because someone needs to help.  \n\"Dear children, let us not love with words or tongue but with actions and in truth.\"\n1 John 3:18","over18":false},"mlem":{"lang":"en","description":"mlem","over18":false},"legendarylootz":{"lang":"en","description":"Welcome to Bonertown","over18":true},"FlashGames":{"lang":"en","description":"","over18":false},"BlowJob":{"lang":"en","description":"Images, Gifs, Videos and Stories about Blowjobs","over18":true},"MarchForNetNeutrality":{"lang":"en","description":"Welcome to the March for Net Neutrality! Thank you for joining us and for showing your support for Net Neutrality! Here, we are organizing marches, brainstorming ideas, collaborating on projects, and ","over18":false},"veg":{"lang":"en","description":"","over18":false},"Terminator":{"lang":"en","description":"Chill out, dickwad.","over18":false},"redditnow":{"lang":"en","description":"A subreddit to discuss Now for Reddit, the Android client for Reddit.","over18":false},"XRP":{"lang":"en","description":"XRP is the fastest & most scalable digital asset, enabling real-time global payments anywhere in the world.\n\nUsing XRP, banks can source liquidity on demand in real time \nwithout having to pre-fund no","over18":false},"TelevisionQuotes":{"lang":"en","description":"Quotes from all of your favorite television shows","over18":false},"Bisexy":{"lang":"en","description":"Bisexy has gone private as a statement on the treatment of moderators by Reddit administrators.","over18":true},"FractalPorn":{"lang":"en","description":"FractalPorn is for fractal art only.","over18":false},"FashionPlus":{"lang":"en","description":"A subreddit for plus sized individuals to share and discuss clothes: where to buy and what to wear.","over18":false},"CatAdvice":{"lang":"en","description":"","over18":false},"animemusic":{"lang":"en","description":"All anime music! From EGOIST to Hiroyuki Sawano's composing works, from Kalafina to Yoko Kanno's amazing compositions------- anime music is a genre by itself that deserves to be celebrated and shared ","over18":false},"AcousticOriginals":{"lang":"en","description":"","over18":false},"dontyouknowwhoiam":{"lang":"en","description":"This is a place for instances of people not realizing who they're talking to is who they're talking about.","over18":false},"MarksmanMains":{"lang":"en","description":"Subreddit centered around the Marksmen role in League of Legends.","over18":false},"googleplusinvites":{"lang":"en","description":"","over18":false},"1200isjerky":{"lang":"en","description":"Add a laughing cow wedge to some zucchini noodles for a light and satisfying alfredo dish!","over18":false},"SupeApp":{"lang":null,"description":"Subreddit forbidden","over18":null},"jerky":{"lang":"en","description":"Jerky central.","over18":false},"gangbang":{"lang":"en","description":"An instance of sexual intercourse between one woman and several men or one man and several women.","over18":true},"HBL":{"lang":"en","description":"A subreddit for homebrew labels, because some people complained they were seeing too many labels elsewhere now you can put them here without fear. What's on the bottle is almost as important as what's","over18":false},"Pokemonbreeding":{"lang":"en","description":"The subreddit for helping people breed their pokémon to the highest standard","over18":false},"RLCompetitive":{"lang":"en","description":"Home for all your Rocket League eSports needs! A hub to discuss tournaments, events, news and more.","over18":false},"sustainability":{"lang":"en","description":"Sustainability is the ability of system to endure. While most people associate the term with the environment, true longevity requires social and economical sustainability as well as ecological sustain","over18":false},"rotmgvouches":{"lang":"en","description":"Vouches for /r/rotmgtradingpost and other associated subs.","over18":false},"DestinyPC":{"lang":"en","description":"Subreddit dedicated to any/all PC versions of the Destiny video game franchise developed by Bungie and published by Activision.\n","over18":false},"Shatter":{"lang":"en","description":"Shatter aims to bring disgusting and hard-to-look-at images of people who survive broken bones and smashed teeth. This subreddit is only for images that depict living humans who have sustained a serio","over18":true},"ainbowroad":{"lang":"en","description":"A reddit april-fools group, originated from /r/place","over18":false},"rhettandlink":{"lang":"en","description":"A subreddit for fans (\"Mythical Beasts\", as they're called.) of the internet duo, Rhett and Link.","over18":false},"sketches":{"lang":"en","description":"","over18":false},"SurvivalGaming":{"lang":"en","description":"This is a place to discuss the Survival genre of gaming.  \n\n\n\n","over18":false},"MetalPorn":{"lang":"en","description":"r/MetalPorn, a place to post and view metal related wallpapers, album art, musical equipment and other various pictures of metal paraphernalia! ","over18":false},"oliviawilde":{"lang":"en","description":"For fans of [Olivia Wilde](http://en.wikipedia.org/wiki/Olivia_Wilde)!","over18":false},"death":{"lang":"en","description":"Welcome to r/Death where death and dying are open for discussion.","over18":false},"NSFWfashion":{"lang":"en","description":"/r/NSFWfashion is for fashion models showing skin. Nude, topless and teasing fashion photography. All posts are automatically marked NSFW and the models should be showing at least more-than-usual skin","over18":true},"GTAgifs":{"lang":"en","description":"Welcome to GTAGifs, where the gifs are plenty and videos are NOT ALLOWED.  Feel free to yell at the Mods if you have a problem with that.","over18":false},"PhonesAreBad":{"lang":"en","description":"A subreddit to showcase all of the pics and arguments people have that can be boiled down to \"phones are bad\".","over18":false},"lolwat":{"lang":"en","description":"","over18":false},"shaving":{"lang":"en","description":"All about shaving...","over18":false},"RogueLegacy":{"lang":"en","description":"This is a place for all things on Rogue Legacy. Questions, Updates and more can go here!","over18":false},"scambait":{"lang":"en","description":"Welcome to /r/scambait! the largest scambaitng community on reddit! ","over18":false},"airplanes":{"lang":"en","description":"A subreddit about airplanes. Many things are welcome, including pictures, articles, and discussions about airplanes and aircraft.","over18":false},"SRSQuestions":{"lang":"en","description":"","over18":false},"TreesSuckingAtThings":{"lang":"en","description":" Trees aren't very good at things.","over18":false},"TheOfficialPodcast":{"lang":"en","description":"The Official Subreddit of The Official Podcast. Hosted by Jackson, Andrew, Charlie and Kaya, this podcast comes at you every Thursday 7pm EST. ","over18":false},"PC_Builders":{"lang":"en","description":"A friendly place to get helpful information about building a Personal Computer of your own-for gaming, work or basic use, we can help.","over18":false},"Ethics":{"lang":"en","description":"","over18":false},"renegades":{"lang":"en","description":"Official subreddit of the Renegades professional gaming organisation, with esports teams competing in CS:GO, Paladins, Halo & Fortnite. #RNGWIN  ","over18":false},"shapeshiftio":{"lang":"en","description":"Official subreddit for ShapeShift.io, the fastest and safest way for the world to buy and sell digital assets. We encourage conversations about our products, ideas for improvements and questions for o","over18":false},"GiannaMichaels":{"lang":"en","description":"For the fans of the amazing Gianna Michaels","over18":true},"PhD":{"lang":"en","description":"","over18":false},"whenitgoesin":{"lang":"en","description":"The look on her face at the moment of penetration. That's what \"when it goes in\" is all about. ","over18":true},"cumcoveredfucking":{"lang":"en","description":"For NSFW videos and pics of girls being fucked with cum on their bodies or faces.","over18":true},"VPNTorrents":{"lang":"en","description":"This is for the discussion of torrenting (and similar P2P protocols) using VPN type technology.\n\n\n","over18":false},"UnconventionalMakeup":{"lang":"en","description":"This is for those of us that don't always fit into the meta looks of MUA. For those that like to do SFX makeup, goth makeup, editorial looks, or other looks that you just can't seem to find anywhere e","over18":false},"localmultiplayergames":{"lang":"en","description":"> This is a subreddit dedicated to **local multiplayer games**, which are games that are played on one system (console or computer) among multiple players, either single or split screen. Here you will","over18":false},"TransSupport":{"lang":"en","description":"The aim of this community is to provide a supportive space for trans people.  Supportive allies welcome. ","over18":false},"SFr4r":{"lang":"en","description":"","over18":false},"electriczoo":{"lang":"en","description":"Reddit's Official Home for Electric Zoo -- New York's biggest electronic music and arts festival. ","over18":false},"facesitting":{"lang":"en","description":"","over18":true},"creepyasterisks":{"lang":"en","description":"*tickles you*","over18":false},"3DMA":{"lang":"en","description":"","over18":false},"Buildapcproxy":{"lang":"en","description":"This subreddit is dedicated to getting people items, mostly computer parts, for as cheap as possible.  This subreddit will offer \"Proxies\", who are people that volunteer, to buy an item in the USA and","over18":false},"EtherDelta":{"lang":"en","description":"[EtherDelta](https://etherdelta.com) is a decentralized trading platform for [Ether](https://ethereum.org) and [Ethereum-based tokens](https://github.com/ethereum/EIPs/issues/20).","over18":false},"xxxcaptions":{"lang":"en","description":"Erotic \"Faptions\" covering various topics. There is something for everyone.","over18":true},"titfuck":{"lang":"en","description":"Sexy girls getting their tits fucked.","over18":true},"soundcloud":{"lang":"en","description":"The official reddit community for SoundCloud!","over18":false},"FO4mods":{"lang":"en","description":"Home for discussion pertaining to mods and resources for Fallout 4.\n\nGame Release Date:  November 10th, 2015\n\nCreation Kit Release Date:  Early 2016","over18":false},"Quantico":{"lang":"en","description":"The subreddit for the *ABC* TV show *Quantico* starring Priyanka Chopra, Josh Hopkins, Jake McLaughlin, Aunjanue Ellis and created by Joshua Safran.","over18":false},"Money":{"lang":"en","description":"","over18":false},"ChristopherHitchens":{"lang":"en","description":"Subreddit dedicated to the life and works of Christopher Hitchens","over18":false},"LeeSinMains":{"lang":"en","description":"Blindness is no impairment to our skill shots","over18":false},"highheelsNSFW":{"lang":"en","description":"A NSFW High heels sub for the appreciation of sexy girls in sexy heels.","over18":true},"Mandela_Effect":{"lang":"en","description":"The Mandela Effect is a phenomenon in which the minority of the public will retain memories of past events that have been altered from the majority and the majority will have no memory or history of t","over18":false},"TessaFowler":{"lang":"en","description":"This is a NSFW subreddit for posting pictures, gifs, videos or anything else relating to Tessa Fowler.\n\nTessa Fowler's bio from Cosmid - \n\nMy name is Tessa Fowler and I am a former Hooters girl from C","over18":true},"lineups":{"lang":"en","description":"Line up ladies! Subscribe for some awesome pics of hot girls in a line.","over18":true},"ButtSharpies":{"lang":"en","description":"Welcome to r/buttsharpies, home of the infamous \"sharpie in pooper\" craze. \n\nPlease remember that all submissions are submitted by dudes who found it on the internet, unless explicitly stated otherwis","over18":true},"UnnecessaryQuotes":{"lang":"en","description":"Have you ever seen quotation marks \"on\" something that did not need them? If so, \"post\" them here!","over18":false},"PoliticalPhilosophy":{"lang":"en","description":"A subreddit for the discussion of political philosophies and theories from the likes of Aristotle, Machiavelli, Locke, Hume, Kant, Burke, Thoreau, Nietzsche, Rawls, and Arendt. Or for just talking, se","over18":false},"AmateurPorn":{"lang":"en","description":"Home to The Hottest Amateur Porn.\nThis Subreddit is dedicated to providing The Best Amateur Videos . If you are looking for Quality Videos, Hottest and Sexiest Amateurs, then This is the Subreddit for","over18":true},"SuperMarioOdyssey":{"lang":"en","description":"A subreddit for anything and everything related to Super Mario Odyssey on Nintendo Switch.","over18":false},"Jawbone":{"lang":"en","description":"A subreddit to discuss, post news, get help and share experiences of Jawbone products.","over18":false},"dogswearinghats":{"lang":"en","description":"The worlds #1 destination for dogs wearing hats.","over18":false},"AlternativeHealth":{"lang":"en","description":"Find how some diseases can be healed with alternative medicine, and share your experience with alternative medicine.\n\n","over18":false},"LoveTV":{"lang":"en","description":"Love is an American comedy Netflix series. The show is created by Judd Apatow, Paul Rust, and Lesley Arfin. It stars Gillian Jacobs and Rust. The tv series will be a \"down-to-earth look at dating,\" ex","over18":false},"Stock_Picks":{"lang":"en","description":"Stock_Picks: The place to discuss day trading, stock watching, investment advice, and more","over18":false},"linux_devices":{"lang":"en","description":"","over18":false},"bingingwithbabish":{"lang":"en","description":"A subreddit to show and discuss the \"Binging with Babish\" video series.","over18":false},"peeling":{"lang":"en","description":"","over18":false},"sunglasses":{"lang":"en","description":"","over18":false},"Boxers":{"lang":"en","description":"","over18":false},"SuicideBereavement":{"lang":"en","description":"**A supportive space for anyone bereaved by suicide.**","over18":false},"thomasthedankengine":{"lang":"en","description":"/r/thomasthedankengine is a subreddit dedicated to Thomas the Tank Engine mashups and deep philosophical discussion. Blow off some steam with your fellow engines.","over18":false},"steamcoupons":{"lang":"en","description":"Steam Coupons","over18":false},"charactercrossovers":{"lang":"en","description":"We welcome crossovers, versus, or mash-ups of any kind of fictional characters.  Comic book, book, cartoon, movie, cartoon-movie, book-cartoon, or any kind of combination therein.","over18":false},"hentaivids":{"lang":null,"description":"Subreddit no longer exists","over18":null},"MLQuestions":{"lang":"en","description":"A place for beginners to ask stupid questions and for experts to help them! /r/Machine learning is a great subreddit, but it is for interesting articles and news related to machine learning. Here, you","over18":false},"PoloniexForum":{"lang":"en","description":"An open community to discuss Poloniex trading, and anything else about cryptocurrency. Not affiliated with Poloniex, Inc this is an unofficial form to post your issues and experiences with poloniex.  ","over18":false},"lgbtsex":{"lang":"en","description":"","over18":false},"ThePhenomenon":{"lang":"en","description":"The Phenomenon: A scifi/horror/suspense story written by R.K. Katic, aka /u/Emperor_Cartagia . \n\n","over18":false},"EmilyRatajkowski":{"lang":"en","description":"All about Emily Ratajkowski!","over18":false},"adidas":{"lang":"en","description":"A subreddit for discussion, links, images, videos, and everything related to adidas.","over18":false},"rome":{"lang":"en","description":"The subreddit for the ancient city of Rome!","over18":false},"LatinaCuties":{"lang":"en","description":"THE place for the best looking Latinas","over18":false},"academia":{"lang":"en","description":"An online community for sharing academic works and discussion of issues and events relating to academia and the related political, economical, and social structures.","over18":false},"DegradingHoles":{"lang":"en","description":"# [True Female Purpose](http://www.reddit.com/user/Master_Daddy/m/degrading)\n\nA Safe Space for discussion and amusement.\n\nPost your favorite pornstars or willing girlfriends for us to criticize, demea","over18":true},"Sculpture":{"lang":"en","description":"This is a community of sculptors and sculpture enthusiasts. We welcome all forms of sculpture created at all skill levels. Please review the subreddit rules and guidelines before posting. ","over18":false},"WinStupidPrizes":{"lang":"en","description":"Sub dedicated to gifs and videos of people playing stupid games and winning stupid prizes.","over18":false},"musicfestivals":{"lang":"en","description":"/r/musicfestivals is a place for discussing music festivals. Whether you are a festival veteran or a newbie that has no idea what you're getting into, this subreddit is for you. \n\nTalk about different","over18":false},"BadMtgCombos":{"lang":"en","description":"Posts should be card combos from Magic the Gathering that are extremely difficult to pull off, easily disrupted, ineffective, and possibly detrimental to one's own survival. \n\nWin more combos, Lose mo","over18":false},"alexandradaddario":{"lang":"en","description":"","over18":false},"firstmarathon":{"lang":"en","description":"An \"anything goes\" place to help each other, learn, freak out, laugh, and make our first journey to the full marathon a little less scary/hard. ","over18":false},"TechnologyProTips":{"lang":"en","description":"Tips that improve your tech knowledge one way or another.\n\nThanks for stopping by, and we'd appreciate it if you share your favorite tips you've picked up throughout your technological life!","over18":false},"NotKenM":{"lang":"en","description":"For Stuff That's Not Ken M.","over18":false},"armawasteland":{"lang":"en","description":"Subreddit dedicated to ArmA Wasteland","over18":false},"RealLifeShinies":{"lang":"en","description":"This is a subreddit for images of things that are a different color than we are used to them being, and because of that they are \"rare\".","over18":false},"indiangirls":{"lang":"en","description":"A subreddit for Cute Indian and Desi Girls.","over18":true},"Xsome":{"lang":"en","description":"A NSFW subreddit for posting images and videos of threesomes, foursomes, fivesomes, etc. For the best experience please use old reddit.","over18":true},"TabooFX":{"lang":"en","description":"FX/BBC miniseries Taboo. Starring Tom Hardy as adventurer James Keziah Delaney who builds his own shipping empire in the early 1800s. ","over18":false},"ReviewThis":{"lang":"en","description":"","over18":false},"mildlyvagina":{"lang":"nl","description":"A subreddit for all things which at least slightly resemble a vagina.","over18":false},"CGPGrey2":{"lang":"en","description":"The alternative subreddit for random CGP Grey related stuff.","over18":false},"RedditCensors":{"lang":"en","description":"","over18":false},"celebsnaked":{"lang":"en","description":"\"She is a pretty good actress, I wonder if she's ever shown her tits?\"\nChances are, she has.","over18":true},"SAHP":{"lang":"en","description":"A place where stay-at-home parents can talk, discuss, and vent about the joys and woes of stay at home parenting.","over18":false},"ted":{"lang":"en","description":"","over18":false},"mercedes":{"lang":"en","description":"Everything that has to do with Mercedes Benz, Tuning and most importantly, keeping these cars on the road. Feel free to share your classic Mercedes-Benz here! Check out our new wiki to help you troubl","over18":false},"futurebass":{"lang":"en","description":"","over18":false},"homesecurity":{"lang":"en","description":"","over18":false},"Titties":{"lang":"en","description":"/r/Titties is a subreddit for those who love titties and/or want to share photos of their own titties. Post your favorite titties or, better yet, post your own titties. Show us your titties :)","over18":true},"SocialMediaSluts":{"lang":"en","description":"/r/SocialMediaSluts welcomes compromising, sexually suggestive, partially or fully nude photos and videos from all social networks, including Facebook, Twitter, Instagram, Snapchat, and more.","over18":true},"sexytimechat":{"lang":null,"description":"Subreddit forbidden","over18":null},"DayZServers":{"lang":"en","description":"Post the information about your server here! Gain a following, and become POWERFUL!","over18":false},"AerospaceEngineering":{"lang":"en","description":"For anything and everything aerospace engineering","over18":false},"malcolminthemiddle":{"lang":"en","description":"For fans of the TV show Malcolm In The Middle.","over18":false},"r4rtoronto":{"lang":"en","description":"","over18":false},"RandomActsOfVinyl":{"lang":"en","description":"Inspired by other \"Random Acts Of ...\" subreddits, **this is the place where vinyl records find new homes**! Offer, trade and request.","over18":false},"tight_shorts":{"lang":"en","description":"Attractive women wearing Tight Shorts","over18":true},"passtheparagraph":{"lang":"en","description":"Collaborative stories; one paragraph at a time. ","over18":false},"Jcole":{"lang":"en","description":"","over18":false},"NewsPorn":{"lang":"en","description":"High quality images of the news.","over18":false},"gonecivil":{"lang":"en","description":"New rule!\nGonecivil is a place for consenting, adult, Redditors to cover up their bodies and enjoy a good read, for karma.  All of this can be done without the pressure from such devious subreddits as","over18":false},"KNCPRDT":{"lang":"en","description":"Pre-Release Discussion Threads for the Kobolds and Catacombs expansion for Hearthstone","over18":false},"shareSMITE":{"lang":"en","description":"A place for redditors to share their SMITE friend referrals.","over18":false},"HireaWriter":{"lang":"en","description":"Jobs for writers.","over18":false},"DubbedGIFS":{"lang":"en","description":"If you made the gif, it should say whatever you want it to say.","over18":false},"warehouse13":{"lang":"en","description":"A subreddit to discuss the Syfy show *Warehouse 13* and the interesting people (and artifacts!) that inhabit the Warehouse.","over18":false},"neurophilosophy":{"lang":"en","description":"","over18":false},"HighMileageHoles":{"lang":"en","description":"Veteran girls that have seen things, things you wouldn't believe...\n\nA subreddit for girls that are visibly very experienced. ","over18":true},"forwardsfromreddit":{"lang":"en","description":"What you'll be sending to your grandkids some day","over18":false},"MotorcyclePorn":{"lang":"en","description":"Motorcycle Porn","over18":false},"unexpectedfactorial":{"lang":"en","description":"This subreddit is for posting when people are talking numbers, and type a number followed by an ! - making it a factorial. This is unexpected, so people usually say /r/unexpectedfactorial and post it ","over18":false},"BigBrotherNSFW":{"lang":"en","description":"Home of TV Show Big Brother NSFW Content","over18":true},"skinsTV":{"lang":"en","description":"","over18":false},"Wavesplatform":{"lang":"en","description":"Сrypto-platform for asset/custom token issuance, transfer, and trading on blockchain. With the name inspired by the recent  gravitational waves discovery, WAVES represents the gravity which brings com","over18":false},"Goldendoodles":{"lang":"en","description":"Because who doesn't love the look of a sweet goldendoodle?","over18":false},"veronicamars":{"lang":"en","description":"A community for fans of the UPN/CW detective drama, *Veronica Mars*, starring Kristen Bell and created by Rob Thomas. **COME ON NOW, SUGAR!**","over18":false},"product_design":{"lang":"en","description":"Everything related to Product Design!\n","over18":false},"magicka":{"lang":"en","description":"","over18":false},"AnarchyChess":{"lang":"en","description":"Chess Humour","over18":false},"Alternativerock":{"lang":"en","description":"A place to share and discover new and old alternative rock. \n\n\n","over18":false},"Marxism":{"lang":"en","description":"**Marxism** is a growing/changing economic/sociopolitical worldview and method of socioeconomic inquiry based upon a materialist interpretation of historical development, a dialectical view of social ","over18":false},"roomdetective":{"lang":"en","description":"","over18":false},"theeternalwar":{"lang":"en","description":"War. War never changes. Especially a war that's been raging for 1700 years.","over18":false},"WSGuilds":{"lang":"en","description":"Looking for a WildStar Guild? Ask here!\n\nDo you have a guild already?  Start recruiting!\n\n","over18":false},"skype":{"lang":"en","description":"This is a subreddit for reddit users to connect with others who use Skype. You can create posts for specific purposes such as finding others to chat with, Skype tips, news etc.\n\nIf you have a question","over18":false},"FaceFuck":{"lang":"en","description":"Gifs, pictures and videos of girls getting their faces fucked.","over18":true},"Climbingvids":{"lang":"en","description":"","over18":false},"asklaw":{"lang":"en","description":"A subreddit for all your legal questions.\n","over18":false},"openwrt":{"lang":"en","description":"OpenWrt news, tools, tips and discussion. Related projects, such as DD-WRT, Tomato and OpenSAN, are also on-topic.","over18":false},"ruger":{"lang":"en","description":"","over18":false},"hbo":{"lang":"en","description":"","over18":false},"Vegan_Food":{"lang":"en","description":"Vegan Food !","over18":false},"Sissyperfection":{"lang":"en","description":"A subreddit dedicated to sissy caption photos and gifs.","over18":true},"Cakes":{"lang":"en","description":"","over18":false},"ggoverwatch":{"lang":"en","description":"A place for Overwatch ladies (and gentlemen).\n","over18":false},"meteorology":{"lang":"en","description":"","over18":false},"SuperSaiyanGifs":{"lang":"en","description":"","over18":false},"machining":{"lang":"en","description":"","over18":false},"ClashDecks":{"lang":"en","description":"Need help building a deck? Have you found the winning combination of cards? Post it here!","over18":false},"ShareYourRyders":{"lang":"en","description":"Got a custom Ryder you're really proud of? Post him or her here!","over18":false},"MuseumOfReddit":{"lang":"en","description":"A subreddit dedicated to cataloguing the posts and comments that will go down in reddit history","over18":false},"tldr":{"lang":"en","description":"","over18":false},"9anime":{"lang":"en","description":"The official subreddit for [9Anime.to](http://9anime.to)! Discuss, recommend, and review anime. Get help from a variety of users and subreddit staff as well as receive frequent updates regarding the w","over18":false},"RugsOnly":{"lang":"en","description":"Wholesome Bushes. \n","over18":true},"InstrumentPorn":{"lang":"en","description":"Beautiful Musical Instruments! Part of the SFW Porn Network.","over18":false},"RocketLeagueCoaching":{"lang":"en","description":"Find a coach or be a coach!","over18":false},"lowcarb":{"lang":"en","description":"The reddit for information about low-carb, adequate-protein, high-fat diets. Share recipes, science, information and questions!","over18":false},"CelebrityNipples":{"lang":"en","description":"Celebrity Nipples!","over18":true},"arcade":{"lang":"en","description":"The place for everything about True Arcade Culture.  Good Ole Coin Operated Arcade Goodness.\n\n\nDiscuss new and old CoinOP arcade games.  Get help on repairs, sell/trade/buy arcade cabinets.  We're all","over18":false},"damngirl":{"lang":"en","description":"The hub for bad pick-up lines that begin with \"Damn girl, are you a\"","over18":false},"truechildfree":{"lang":"en","description":"Help us keep this a positive and encouraging community.","over18":false},"IncestComics":{"lang":"en","description":"A sub-reddit for all who love incest comics.","over18":true},"CabinPorn":{"lang":"en","description":"/r/CabinPorn is a  SFWPorn style subreddit to share pictures of awesome cabins. Whether you took the pictures yourself, or found them while stumbling through the web, share it here!\n\nThis is a place t","over18":false},"wowscrolls":{"lang":"en","description":"Scrolls of Resurrection are no longer available.","over18":false},"devblogs":{"lang":"en","description":"/r/DevBlogs is a place to come, everyday, and see what other redditors and industry pros are working on. Come add your blog!","over18":false},"Cr1TiKaL":{"lang":"en","description":"This is the greatest subreddit of All Time","over18":false},"makeuporganization":{"lang":"en","description":"A place where user, lovers, and admirers of makeup can share their storage and organization ideas, vanities, collections, DIYs and all things in between! ","over18":false},"StreetwearSales":{"lang":"en","description":"We are a community of fashion enthusiasts who are inspired by clothing styles derived by skateboard, surf, hip hop, and retro 80s/90s sensibilities. Streetwear continues to evolve in modernity, but te","over18":false},"manlove":{"lang":"en","description":"Man on man loving","over18":true},"CookieCollector2":{"lang":"fr","description":"Here's the subreddit for CCC2, for questions, updates, secrets and more.","over18":false},"FoodNYC":{"lang":"en","description":"FoodNYC is dedicated towards showcasing food from all over New York City! Share pictures, reviews, websites, etc. Not just limited to pictures of food, but anything food related in NYC.","over18":false},"furniture":{"lang":"en","description":"","over18":false},"europeanmalefashion":{"lang":"en","description":"This subreddit is dedicated to links to online clothing retailers based in Europe.\n\nJoin us if you live in Albania, Austria, Belarus, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Eston","over18":false},"skinnytail":{"lang":"en","description":"our place for sexy thin ladies with and without clothing. please post pics if you have them!  ","over18":true},"dragonsfuckingcars":{"lang":"en","description":"Exactly what it says on the tin.","over18":true},"lewdgames":{"lang":"en","description":"Your go to community for all things adult games related. Community discussions, NSFW game updates, hentai game industry news, we have it all. We hope you'll join us for the fun that is adult gaming.","over18":true},"pansexual":{"lang":"en","description":"","over18":false},"SFWRedheads":{"lang":"en","description":"A SFW subreddit for people who appreciate the beauty of those with red hair.","over18":false},"CaptchaArt":{"lang":"en","description":"A subreddit to create and share original captcha art.  We turgle all day long","over18":false},"denverjobs":{"lang":"en","description":"A community to help Denver job posters and job-seekers come together.","over18":false},"NucleusMarket":{"lang":null,"description":"Subreddit no longer exists","over18":null},"bearsdoinghumanthings":{"lang":"en","description":"It's bears.\n\nWe join our human co-moderators in their stance against the current practice of the admins. We also support /u/Chooter as she has always done a wonderful job and is a delightful person ov","over18":false},"thighhighs":{"lang":"en","description":"The original subreddit for all things thigh-high!","over18":true},"BestOfPrimeDay":{"lang":null,"description":"Subreddit forbidden","over18":null},"mythology":{"lang":"en","description":"","over18":false},"FuckYouImAShark":{"lang":"en","description":"But seriously, fuck you.","over18":false},"videoessay":{"lang":"en","description":"A hub for video essays, super cuts, and other videos critically observing media texts. ","over18":false},"bigareolas":{"lang":"en","description":"For big, large, and even huge areolas. ","over18":true},"WatchRedditDie":{"lang":"en","description":"The golden age of reddit is passing. Darker times await.","over18":false},"thickloads":{"lang":"en","description":"A home for the stickiest and thickest cum shots. Anything goes, as long as it's real and it's thick. ","over18":true},"FirePorn":{"lang":"en","description":"High quality images of fire.","over18":false},"inquisitionsliders":{"lang":"en","description":"A place to collect and post sliders for custom character creation in Dragon Age: Inquisition!","over18":false},"xboxlive":{"lang":"en","description":"","over18":false},"BIRDTEAMS":{"lang":"en","description":"BIRD TEAMS! BIRD TEAMS BIRD TEAMS! BIRD TEAMS!","over18":false},"outercourse":{"lang":"en","description":"For all kinds of non penetrative sex\\Outercourse acts (not including frot, or Oral Sex)\n\nAnything from:\n\n* Erotic Massage, \n\n* Footjobs, \n\n* Handjobs, \n\n* scissoring, \n\n* Sumata (pussyjobs), \n\n* Mamma","over18":true},"BuildAPCSalesMeta":{"lang":"en","description":"A place to discuss everything \"meta\" from /r/buildapcsales \n\n","over18":false},"modeveryone":{"lang":"en","description":"hey why don't you cuddle some cute animal for a while and pet its soft soft fur","over18":false},"avocadosgonewild":{"lang":"en","description":"This is a subreddit for sexy avocados.","over18":true},"LeftHanging":{"lang":"en","description":"/r/LeftHanging | Not every high five is reciprocated.","over18":false},"Euro2016":{"lang":"en","description":"UEFA Euro 2016 Sub-Reddit.","over18":false},"ImaginaryFallout":{"lang":"en","description":"ImaginaryFallout - Artwork from the Fallout Series  [](/imtrackinglink)","over18":false},"bigboobs":{"lang":"en","description":"This is a place for those that like big boobs. Here you can share your favorite busty girl pictures so other big tit lovers can enjoy. \n\nThere's nothing more pleasing to the eye than a a girl with a n","over18":true},"UKJobs":{"lang":"en","description":"","over18":false},"WoahTunes":{"lang":"en","description":"The BEST music to listen to while you're STONED!\n\nTrippy, chill, mesmerizing or mindfucking music and music videos that make you go 'woah dude!'\n\n","over18":false},"ForwardsFromKlandma":{"lang":"en","description":"Wizards, Cyclopses, Unicorns, FSMs, and tasty, black liquorice unite!\n\nYour one-stop hub for overt racism/bigotry coming from people who remember the Civil Rights Movement.","over18":false},"DirtyGaming":{"lang":"en","description":"###The subreddit where eroticism and gaming mix.\n\nAll posts are erotic in nature and somehow related to gaming.  This can be actual folks getting their freak on while gaming, cartoons of your favorite","over18":true},"AstroGaming":{"lang":"en","description":"Official home of the Astro Gaming products/headsets.","over18":false},"NYr4r":{"lang":"en","description":"This sub is for individuals who would like to grow their network and meet for various social and private activities. You can join our social Discord and instantly make new friends.","over18":true},"dirtykikgroups":{"lang":"en","description":"Subreddit for people to advertise their NSFW kik groups","over18":true},"nebbyinthebag":{"lang":"en","description":"We must put nebby in the bag!","over18":false},"souleater":{"lang":"en","description":"Here is the place where you can find everything to know about Soul Eater and Soul Eater NOT! Come take a peak inside! You will never know what kind of things you will find! ","over18":false},"Scarymovies":{"lang":"en","description":"The Subreddit for watching, discussing, and promoting horror movies! ","over18":false},"Pantyfetish":{"lang":"en","description":"Panty fetish pics, all panty types welcome. ","over18":true},"panties":{"lang":"en","description":"","over18":true},"Incel":{"lang":null,"description":"Subreddit no longer exists","over18":null},"joker":{"lang":"en","description":"A place to discuss all things related to DC's Joker character. ","over18":false},"Torchwood":{"lang":"en","description":"","over18":false},"KoreanFood":{"lang":"en","description":"","over18":false},"ahegao":{"lang":"en","description":"","over18":true},"IncestGifs":{"lang":"fr","description":"","over18":true},"replika":{"lang":"en","description":"a subreddit for the recently released replika app. https://www.replika.ai/","over18":false},"Bitstamp":{"lang":"en","description":"Bitcoin exchange Bitstamp, unlike the other exchange subs, this one is not controlled by the company","over18":false},"curiousvideos":{"lang":"en","description":"videos for the curious: stimulating videos on science, arts, etc.","over18":false},"Harry_potter":{"lang":"en","description":"","over18":false},"NotSafeForNature":{"lang":"en","description":"","over18":true},"crappycontouring":{"lang":"en","description":"Share your shitty contour pictures here. From tiger stripes to brownie batter face, you can find it all here.","over18":false},"chicagomusicscene":{"lang":"en","description":"","over18":false},"theforceawakens":{"lang":"en","description":"reserved","over18":false},"nakedladies":{"lang":"en","description":"A secure, inclusive community for verified female self posters to share high quality images, gifs, and videos of themselves.\n\n**if any nakedladies want to take over moderation of this sub, please mess","over18":true},"narcsinthewild":{"lang":"en","description":"Share stories about people who behave like narcissists. These could be stories of personal encounters with strangers in your own life or links to news stories.","over18":false},"gnu":{"lang":"en","description":"","over18":false},"APUSH":{"lang":"en","description":"A subreddit for everybody's favorite class","over18":false},"roastme_unlimited":{"lang":"en","description":"We roast only the best. So you think you are roastable?  Give us a shot. Stand still and wait for it....Roastme_Unlimited is not for your average roastee.  We fry and serve em up on a platter suitable","over18":false},"insults":{"lang":"en","description":"Insults. Plain and simple, you cum gargling fuckwit. ","over18":false},"portabledabs":{"lang":"en","description":"A subreddit dedicated to the discussion of portable cannabis concentrates solutions in all their forms, carts and coils alike.","over18":false},"masterhacker":{"lang":"en","description":"This is were you put those kids that can ddos you because you logged into the hacked code on javascript youtube c++ servers.","over18":false},"bigdata":{"lang":"en","description":"","over18":false},"femalepov":{"lang":"en","description":"","over18":true},"TightShorts":{"lang":"en","description":"Girls in:\n\n*Yoga Shorts\n*Booty Shorts\n*Volleyball Shorts\n*Jean Shorts\n*etc...","over18":true},"selfservice":{"lang":"en","description":"Male masturbation pics and videos","over18":true},"lacqueristas":{"lang":"en","description":"","over18":false},"ManjaroLinux":{"lang":"en","description":"Manjaro is a GNU/Linux distribution based on Arch.\n\nIt is a rolling release distro which includes  a **user-friendly** installer, **tested updates** that try very hard to not break your system and a c","over18":false},"NewYorkForSanders":{"lang":"en","description":"r/NewYorkForSanders is a grassroots volunteer-led online hub designed to raise support in New York for Senator Bernie Sanders 2020 campaign for President of the United States and to highlight Our Revo","over18":false},"fridaythe13th":{"lang":"en","description":"For all things related to the Friday the 13th including the man, the myth, the legend - Jason Voorhees himself; the films; the mythology; novels; video games; etc!","over18":false},"conservation":{"lang":"en","description":"A community for sharing and discussing links about Conservation Biology.  The scientific study of the nature and status of Earth's biodiversity with the aim of protecting species, their habitats, and ","over18":false},"Emuwarflashbacks":{"lang":"en","description":"Emus have one battle philosophy: kill until there is no more enemy, or no more you.","over18":false},"Floridar4r":{"lang":"en","description":"","over18":false},"wokekids":{"lang":"en","description":"Incredible children who have amazingly developed senses of social justice that coincidentally mirror those of their parents ","over18":false},"ProduceMyScript":{"lang":"en","description":"This is where screenwriters and filmmakers can meet, share ideas, scripts, and work together to advance the world of filmmaking.","over18":false},"ratemyboobs":{"lang":"en","description":"rate my boobs an a scale of 1-10\nCERTIFIED BOOB GRADERS","over18":true},"JustHotWomen":{"lang":"en","description":"Images of hot women","over18":true},"tulsi":{"lang":"en","description":"r/Tulsi is a grassroots volunteer-led online hub designed to raise support for and discuss policy of Representative Tulsi Gabbard (D) of Hawaii's 2nd District. ","over18":false},"GameSociety":{"lang":"en","description":"Book club, but for videogames!","over18":false},"SethBlingSuggestions":{"lang":"en","description":"Suggest builds and video ideas for SethBling's YouTube channel.","over18":false},"bigboye":{"lang":"en","description":"A subreddit for large animals behaving like domestic pets. After all, they're all really good boys deep down!","over18":false},"Life":{"lang":"en","description":"/r/Life is a place where people can come and talk about living. Philosophy, mottoes, axioms and sitting-around-the-campfire type stuff.\n\nShare your life with us. Share the good, the bad, the ugly, the","over18":false},"ICoveredASong":{"lang":"en","description":"","over18":false},"csgocritic":{"lang":"en","description":"Post your CS:GO videos and demos, and then get them reviewed by others to help improve your game.","over18":false},"Broadchurch":{"lang":"en","description":"A subreddit for the British television series Broadchurch.","over18":false},"moombahton":{"lang":"en","description":"Moombahton is a variety of electronic music distinguished by it's incorporation of Reggaeton-style drums and a swaying, ass-shaking speed of 108 BPM.","over18":false},"traditionaltattoos":{"lang":"en","description":"A blossom-tree and bird-silhouette free zone for enthusiasts of the traditional American style of tattooing. ","over18":false},"radio":{"lang":"en","description":"Discussion of the AM/FM radio industry.","over18":false},"SCHLAND":{"lang":"de","description":"Americans have /r/Murica. Deutschländer have /r/Schland! \n\nA subreddit for everything that is awesome about Germany. \n\nTags: deutschland, germany, german, deutsch, schland","over18":false},"haiku":{"lang":"en","description":"Haiku","over18":false},"SeaList":{"lang":"en","description":"Buy, sell and barter things in the Seattle, Washington area.  A little bit like Craigslist.","over18":false},"isometric":{"lang":"en","description":"Isometric art from animation and videogames","over18":false},"weddings":{"lang":"en","description":"","over18":false},"501st":{"lang":"en","description":"A subreddit for members and interested recruits of the 501st Legion. \n\nThe 501st Legion is a worldwide Star Wars costuming organization comprised of and operated by Star Wars fans. While it is not spo","over18":false},"awwschwitz":{"lang":null,"description":"Subreddit forbidden","over18":null},"ThankYouBasedGod":{"lang":"en","description":"#TYBG","over18":false},"LumiaLovers":{"lang":"en","description":"Whether you have a Nokia Lumia 520 or Nokia Lumia 2520, this is the subreddit for you. Here you'll find the most interesting articles, reviews, tips and tricks and videos about the world's coolest sma","over18":false},"ancientworldproblems":{"lang":"en","description":"","over18":false},"Nether":{"lang":"en","description":"Nether is a post-apocalyptic massively multiplayer online game that veers away from traditional survival horror games.  Prepare for an enticing and heart-pounding adventure where only your wits determ","over18":false},"DiscountedProducts":{"lang":"en","description":"Great Deals & Discounts ","over18":false},"girlsgonewired":{"lang":"en","description":"Where girls get their geek on.\n","over18":false},"gaycumsluts":{"lang":"en","description":"NSFW - A subreddit for cum lovers, primarily male.","over18":true},"basement":{"lang":"en","description":"","over18":false},"breakingbadcomics":{"lang":"en","description":"","over18":false},"vsauce":{"lang":"en","description":"Discuss and share things from the YouTube channel Vsauce!","over18":false},"Tarantino":{"lang":"en","description":"","over18":false},"AerialPorn":{"lang":"en","description":"High-resolution aerial photography.","over18":false},"nsfwcelebs":{"lang":"en","description":"Horny naked celebs and celebrity oops links, celebrity nudes and nipples flashing, movie caps","over18":true},"OneParagraph":{"lang":"en","description":"Like fiction, but only have a minute? OneParagraph is a subreddit specifically for small format fiction limited to a single paragraph.\n\nEveryone is encouraged to contribute, but silent audience member","over18":false},"FIlm":{"lang":"en","description":"","over18":false},"selfies":{"lang":"en","description":"A place to put all those selfies you don't have anywhere else to put! Let's be vain.","over18":false},"StarboundPlanets":{"lang":"en","description":"**Post good loot, and interesting planets.** ","over18":false},"Dogberg":{"lang":"en","description":"A place for gifs, pictures, and videos of dogs doing wrestling moves on people, animals and objects.","over18":false},"RemyLaCroix":{"lang":"en","description":"Pictures, gifs, and videos of pornstar Remy LaCroix.","over18":true},"Jordan_Peterson_Memes":{"lang":"en","description":"Official subreddit for Jordan Peterson Memes!","over18":false},"harlemshake":{"lang":"en","description":"All things Harlem Shake","over18":false},"CuteLittleButts":{"lang":"en","description":"Cute girls.  Little butts.  A place to share and appreciate all of the amazing butts that aren't necessarily the biggest, but are still beautiful.","over18":true},"deadbedroom":{"lang":"en","description":"deadbedroom","over18":false},"UnusualArt":{"lang":"gd","description":"Unusual Art: strange, weird, unique art","over18":false},"SauceforNSFWads":{"lang":"en","description":"######[Home](http://www.reddit.com#top) [hot](http://www.reddit.com/r/SauceforNSFWads/hot) [new](http://www.reddit.com/r/SauceforNSFWads/new/) [top](http://www.reddit.com/r/Sauce for NSFW ads/top/)","over18":true},"TekSyndicate":{"lang":"en","description":"","over18":false},"surgery":{"lang":"en","description":"","over18":false},"FindingDitto":{"lang":"en","description":"A subreddit dedicated to uncovering easter eggs within Pokèmon Go.","over18":false},"FilthyGirls":{"lang":"en","description":"","over18":true},"CentOS":{"lang":"en","description":"CentOS (Community Enterprise Operating System) is a Linux distribution that attempts to provide a free, enterprise-class, community-supported computing platform which aims to be functionally compatibl","over18":false},"Guessmyname":{"lang":"en","description":"","over18":false},"CatsInSinks":{"lang":"en","description":"Pictures of felines that are in sinks.","over18":false},"TournamentOfMemes":{"lang":"en","description":"We have opened the subreddit to all submitters for discussion.\n\nPast Tournament winners:\n\n2011 Forever Alone\n\n2012 Insanity Wolf\n\n2013 Joseph Ducreux\n\nRunners Up:\n\n2011 Courage Wolf\n\n2012 Futurama Fry","over18":false},"Cortex":{"lang":"en","description":"A Subreddit for the Cortex Podcast","over18":false},"ESOPS4":{"lang":"en","description":"","over18":false},"MusicNews":{"lang":"en","description":"","over18":false},"InformationTechnology":{"lang":"en","description":"","over18":false},"audiojerk":{"lang":"en","description":"#( ͡° ͜ʖ ͡°)\n/r/Audiojerk is a community for gluten-free discussion of all topics related to audio.","over18":false},"DarkSoulsMods":{"lang":"en","description":"a place for people to share their latest texture mods for Dark Souls","over18":false},"drydockporn":{"lang":"en","description":"Ships out of Water: SFW Photos of drydock infrastructure and the ships in them. ","over18":false},"chillwave":{"lang":"en","description":"","over18":false},"birthday":{"lang":"en","description":"For anything birthday-related.","over18":false},"Pinup":{"lang":"en","description":"Collection of tasteful pin ups. ","over18":false},"ShittyPhotoshop":{"lang":"en","description":"A place for found and created shitty photoshops\n","over18":false},"batty":{"lang":"en","description":"Batty for bats!","over18":false},"NSFWCostumes":{"lang":"en","description":"A Sexy Super-heroine? A Raunchy Red Riding Hood? A Halloween Hottie? Post your costume themed nudes here! Specific defined characters not a requirement. ","over18":true},"nationalparks":{"lang":"en","description":"A community for those who love National Parks... anywhere in the world!\n","over18":false},"ProjectReddit":{"lang":"en","description":"Do more with your time than age. This reddit will have posts which gives ideas for things to do with your time. Hopefully the broadening of your horizons, gain of experiences, and new challenges will ","over18":false},"Sjin":{"lang":"en","description":"A place for all things Sjin!\n\nPost anything and everything related to the Sjinster","over18":false},"shitduolingosays":{"lang":"en","description":"There's always funny sentences/phrases in duolingo, post them here","over18":false},"Political_Tweets":{"lang":"en","description":"This sub is designed to pictures of birds that look like political figures, or political figures with bald eagles.","over18":false},"oversharing":{"lang":"en","description":"NSFW content shared on social media.","over18":true},"write":{"lang":"en","description":"The written word: fiction, nonfiction, popular authors, critiques, editing, feedback, publishing, marketing - if it's related to writing, it's in here.","over18":false},"canadia":{"lang":"en","description":"Where John Candy was from. ","over18":false},"Gold":{"lang":"en","description":"","over18":false},"IdeasForAskreddit":{"lang":"en","description":"Kind of like /r/ideasfortheadmins, a place where users and mods can bounce ideas around and hopefully keep up with evolving trends to create  the best possible experience. ","over18":false},"androgyny":{"lang":"en","description":"","over18":false},"CuteModeSlutMode":{"lang":"en","description":"For side by side gfycats featuring the **cute**, innocent star on one side and the same gal showing her naughty, **slut** side on the other. NSFW","over18":true},"TheGameOfThronesGame":{"lang":"en","description":"Subreddit for the Game of Thrones game series by Telltale Games. Available now on PS3/PS4, XB360/XBONE, PC, Mac and iOS.","over18":false},"bestof2010":{"lang":"en","description":"","over18":false},"paradoxpolitics":{"lang":"en","description":"This is the place to post links showing real-world events that mirror those in Paradox Interactive's wonderful series of historical games.","over18":false},"GeekTool":{"lang":"en","description":"GeekTool is a Mac OSX Application (or System Preference Pane) that lets you display various kinds of information on your desktop via 3 default plug-ins.","over18":false},"NSFW_DICK_and_Cock":{"lang":"es","description":"NSFW Dick and Cock!","over18":true},"StickofTruth":{"lang":"en","description":"Subreddit for the video game South Park: Stick of Truth","over18":false},"GetMotivatedBuddies":{"lang":"en","description":"","over18":false},"bigdickgirl":{"lang":"en","description":"A place for people who like tgirls with big dicks. ","over18":true},"AppIdeas":{"lang":"en","description":"A place to discuss ideas for applications, for bored developers.","over18":false},"MensRants":{"lang":"en","description":"This is for ranting, blowing off steam, and general complaints about misandry.","over18":false},"ForeignMovies":{"lang":"en","description":"","over18":false},"HotSBetaKeys":{"lang":null,"description":"Subreddit forbidden","over18":null},"Forts":{"lang":"en","description":"","over18":false},"dogswithjobs":{"lang":"en","description":"The sub for dogs with jobs, both silly and serious. Working doggos of all types are welcome here.\n\n","over18":false},"VirginityExchange":{"lang":"en","description":"This sub is for virgins who are seeking a partner to help them get over the label and explore themselves.  Discussions can be had on our discord server ( https://discord.gg/vwQRETY ) or over at r/virg","over18":true},"Googlevoice":{"lang":"en","description":"","over18":false},"finlandConspiracy":{"lang":"en","description":"This is a subreddit designed to announce and share the truth about the conspiracy that is the country 'Finland'. ","over18":false},"PurpleCoco":{"lang":"en","description":"For pics of electrical outlets in odd places. Home to the best place to find odd outlets.","over18":false},"farcry3":{"lang":"en","description":"","over18":false},"BdsmDIY":{"lang":"en","description":"","over18":true},"GermanShepherd":{"lang":"en","description":"A subreddit for all things related to German Shepherds, whether you own one, you're thinking of getting one or you're just an admirer. Share photos/videos, ask for and give advice and talk about this ","over18":false},"ImaginaryBattlefields":{"lang":"en","description":"Art set on the field of battle.","over18":false},"DeliciousTraps":{"lang":"en","description":"**Internet Rule 53: It is delicious trap. You must hit it**\n\nSubreddit for trap (crossdressing boys) hentai, artwork and doujinshi.","over18":true},"Watsky":{"lang":"en","description":"","over18":false},"TPB":{"lang":"en","description":"Following the latest of TPB","over18":false},"GunFights":{"lang":"en","description":"","over18":true},"ScandinavianInterior":{"lang":"en","description":"A place to share ideas, inspiration, and information related to Scandinavian interior design.","over18":false},"VintageBabes":{"lang":"en","description":"Vintage Babes: The hottest women from days gone by.","over18":true},"HighStrangeness":{"lang":"en","description":"**Paranormal, UFOs, Ancient Cultures, Bigfoot, Mysterious Anomalies, Animal Mutilations and other reports of Weird, Bizarre News and High Strangeness.**","over18":false},"wesanderson":{"lang":"en","description":"/r/WesAnderson is the place for Wes Anderson's movie fans to come together!\n\nPlease keep the comments civil and remember the [**reddiquette**](http://www.reddit.com/wiki/reddiquette) when commenting a","over18":false},"pokemmo":{"lang":"en","description":"Reddit community for the PokeMMO game.","over18":false},"silhouWHAT":{"lang":"en","description":"Does the silhouette allude to something more sinister? ","over18":false},"visualization":{"lang":"en","description":"For topics related to information visualization and the design of graphs, charts, maps, etc.","over18":false},"ps4clans":{"lang":"en","description":"Discussing PS4 clans, recruiting, finding a clan\n","over18":false},"wethebest":{"lang":"en","description":"The Subreddit For The Life Of DJ Khaled","over18":false},"computerhelp":{"lang":"en","description":"Computer help from your peers and experienced hands.","over18":false},"WesternHentai":{"lang":"en","description":"A subreddit for western erotic art. X-rated art similar in style to the kind of art you would find in a Disney film or Batman comic. \n","over18":true},"SceneGirls":{"lang":"en","description":"","over18":true},"TitanfallCodes":{"lang":"en","description":"Give and get keys for the Titanfall closed beta.","over18":false},"BernTheConvention":{"lang":"en","description":"A subreddit specifically for Bernie Sanders supporters to organize and exchange information about attending the Democratic National Convention on July 24th and 25th!","over18":false},"TechnologyPorn":{"lang":"en","description":"High quality images of technology","over18":false},"groovesharkplaylists":{"lang":"en","description":"","over18":false},"ImaginaryTurtleWorlds":{"lang":"en","description":"It is the goal of /r/ImaginaryTurtleWorlds to share, discuss, and upturtle all content of/or relating to imaginary turtle worlds and any other landscape on the back of a reptile. In addition, /r/Imagi","over18":false},"CraftyTrolls":{"lang":"en","description":"Expanding the awesome TrollX and TrollY subreddit universe. Show us your skills! Ask about new ones! Make things!","over18":false},"smoobypost":{"lang":"en","description":"smoobypost","over18":false},"PMclub":{"lang":"en","description":"This is a place to share things people have PMed you. Only for people who have \"PM me\" requests in their usernames.  Please read the sidebar for full rules.","over18":false},"Rants":{"lang":"en","description":"","over18":false},"GoPlus":{"lang":"en","description":"Everything to do with the Pokemon GO Plus device!","over18":false},"ipod":{"lang":"en","description":"/r/iPod - All the news, apps, accessories, rumors, and general discussion of the iPod device!","over18":false},"NSFW_AmA":{"lang":"en","description":"","over18":true},"OhCumOn":{"lang":"en","description":"A place to challenge your fellow redditors to take pics of cum in unusual places and circumstances.","over18":true},"SoundsLikeMusic":{"lang":"en","description":"SoundsLikeMusic","over18":false},"Electrum":{"lang":"en","description":"The best, cutting edge thin Bitcoin wallet.","over18":false},"Pipes":{"lang":"en","description":"To facilitate in-depth discussions of tobacco pipes, pipe tobacco, and the community which enjoys both.","over18":false},"Overgrowth":{"lang":"en","description":"","over18":false},"mobile":{"lang":"en","description":"A friendly, platform neutral community for all mobile news.","over18":false},"transistor":{"lang":"en","description":"Transistor the game","over18":false},"electroswing":{"lang":"en","description":"","over18":false},"counter_strike":{"lang":"en","description":"","over18":false},"The_Brendan":{"lang":null,"description":"Subreddit forbidden","over18":null},"Fisting":{"lang":"en","description":"A sub-reddit for sharing Fisting-fetish pics, gifs, videos, etc. and discussion.","over18":true},"SuperAthleteGifs":{"lang":"en","description":"Gifs of Super Athletes in Action. Other Exciting Sports Gifs Are Welcomed.","over18":false},"vaxxhappened":{"lang":"en","description":"We collect the outrageous and dangerous tales told by  dimwitted anti-vaxxers on all forms of media. Post  Facebook comments, YouTube videos and gifs. We are pro-vaccination because we're civilized. A","over18":false},"90sAlternative":{"lang":"en","description":"A place to share alternative rock of the '90s.","over18":false},"60fpsGamingGifs":{"lang":"en","description":"Gaming Gifs of the Highest Quality.\n\nGifs must include a minimum of 60fps, higher framerates are also excepted. More frames the better! \n\n","over18":false},"cutenoobs":{"lang":"en","description":"Post pictures of the cutest noobs you can find in OSRS.\n","over18":false},"RandomActsOfBras":{"lang":"en","description":"Lots of times we find out we're the wrong size, but many of us aren't privileged enough to drop $200 to find the right size or even $40 to get the right support for our boobs. Sometimes people just wa","over18":false},"sneakpeekbot":{"lang":"en","description":"sneakpeekbot discussion","over18":false},"tailplug":{"lang":"en","description":"/r/tailplug is a place for showing, sharing and discussing buttplugs with tails attached.","over18":true},"sfw_wtf":{"lang":null,"description":"Subreddit forbidden","over18":null},"SAGAcomic":{"lang":"en","description":"A subreddit dedicated to all things SAGA. A comic written by Brian K. Vaughn and illustrated by Fiona Staples. Published by image.\n\n[](/sidebar)","over18":false},"encryption":{"lang":"en","description":"","over18":false},"musicpics":{"lang":"en","description":"Music related pictures. ","over18":false},"allaccessplaylists":{"lang":"en","description":"A place to share user created playlists for Google's new all access music app.","over18":false},"TattooDesigns":{"lang":"en","description":"","over18":false},"TheHangingBoobs":{"lang":"en","description":"She's on all fours and her boobs are hanging down. If you like that sight, this is the reddit for you. Or she may be bending over or lying on her stomach, as long as they are hanging. Sagging boobs ar","over18":true},"SVU":{"lang":"en","description":"","over18":false},"homemaking":{"lang":"en","description":"/r/homemaking is a community of all genders that are interested in keeping their home, their apartment, or their room clean. We also are interested in gardening, decoration, lifehacks, and anything re","over18":false},"countrychallenge":{"lang":"en","description":"This subreddit exists to challenge redditors to learn more about the world. Each day, Monday through Friday, we are to read the Wikipedia page about a country and discuss it in a thread posted here. W","over18":false},"sketchapp":{"lang":"en","description":"Sketch is a simple, powerful, and quickly growing vector graphics application used by artists and designers.","over18":false},"SlenderMan":{"lang":"en","description":"","over18":false},"LifeasanNPC":{"lang":"en","description":"Share your gaming stories from the point of view of the NPCs you have encountered in your travels. ","over18":false},"mechwarrior":{"lang":"en","description":"The subreddit for all things mechwarrior!","over18":false},"FutureFight_Unions":{"lang":"en","description":"Union discussions for /r/FutureFight","over18":false},"Download3DSROMs":{"lang":"en","description":"Download 3DS ROMs - Reddit","over18":false},"StuffOnCats":{"lang":"en","description":"Posts images and videos of stuff on cats.","over18":false},"petite":{"lang":"en","description":"","over18":true},"BlowjobGifs":{"lang":"en","description":"A place to share gifs of girls giving blowjobs.","over18":true},"MajesticManes":{"lang":"en","description":"A sub dedicated specifically to the appreciation of men with long hair!","over18":false},"pickuplines":{"lang":"en","description":"","over18":false},"WDP":{"lang":"en","description":"The sub that asks, \"Why do people do the things they do?\"","over18":false},"Dollywinks":{"lang":"en","description":"Hi, I'm Dolly. Welcome to my sub. ♥ Feel free to pull up a chair and take off your pants while you're at it. :)","over18":true},"SonyVegas":{"lang":"en","description":"","over18":false},"Workbenches":{"lang":"en","description":"Workbenches!","over18":false},"urbantees":{"lang":"en","description":"The Official Subreddit for UrbanTees.ru\n\n","over18":false},"Borderporn":{"lang":"en","description":"Because there are borders ","over18":false},"phones":{"lang":"en","description":"Talk about Phones and Mobile Technology","over18":false},"ChavGirls":{"lang":"en","description":"The #1 place (outside Liverpool?) for hot, Chav girls!","over18":true},"rubyonrails":{"lang":"en","description":"Everything RoR!  \n  \nRuby on Rails, often simply Rails, is an open source web application framework which runs on the Ruby programming language.","over18":false},"chadtronic":{"lang":"en","description":"","over18":false},"Stand":{"lang":"en","description":"A community to discuss issues related to protecting an Open Internet, improving democracy through technology, as well as general civic engagement.   \n  \nJournalists, experts, activists, and officials ","over18":false},"drugmemes":{"lang":"en","description":"Original memes ranging from Rage Comics to forever alone; We're here to provide a bit of a laugh to anyone with an interest towards drugs.\n\n\n\n","over18":false},"PornhubComments":{"lang":"en","description":"Showcasing the wit of Pornhub commenters. Who comments on Pornhub videos? These people.","over18":false},"geologyporn":{"lang":"en","description":"High resolution images of rocks and minerals.","over18":false},"RBNLifeSkills":{"lang":"en","description":"","over18":false},"Titanfall_2_":{"lang":"en","description":"> > > [/r/titanfall](/r/titanfall)","over18":false},"pchelp":{"lang":"en","description":"For PC questions/assistance. When asking a question or stating a problem, please add as much detail as possible. \nIf you have a specific Keyboard/Mouse/AnyPart that is doing something strange, include","over18":false},"3kliksphilip":{"lang":"en","description":"Hi, I'm 3kliksphilip and I make videos mostly on Source-based games. But I'm also 2kliksphilip and he makes other stuff as well. Same with kliksphilip. But don't mention 4kliksphilip.\n\nI got this subr","over18":false},"GamersBeingBros":{"lang":"en","description":"Gifs and videos from any games where players set aside the normal objective of the games and show mercy or compassion for their enemy, or help out a teammate.\nAlso check out: /r/GamersBeingJerks and /","over18":false},"pokememes":{"lang":"en","description":"A subreddit for image macros (\"memes\") related to Pokémon.","over18":false},"Tiresaretheenemy":{"lang":"en","description":"The tires are out to get us.","over18":false},"Dunkirk":{"lang":"en","description":"A subreddit to discuss Christopher Nolan's **Dunkirk**","over18":false},"quoteporn":{"lang":"en","description":"","over18":false},"darktower":{"lang":"en","description":"","over18":false},"BDSMAdvice":{"lang":"en","description":"A great place for advice about BDSM.\nHave an issue in your kinky relationship? Looking to break into the scene? Want to know more about a specific technique? Think you have a fetish, but don't know wh","over18":false},"newretrowave":{"lang":"en","description":"Welcome to /r/newretrowave!.\n\nThis is a place dedicated to synthwave music and discussion.  Music that evokes feelings of sunsets, boulevards, neon lights, and futuristic cityscapes.   Surf the New Re","over18":false},"geekygirls":{"lang":"en","description":"Essentially this subreddit is \"girls in superhero or star wars clothes\". Enjoy.","over18":false},"gtavmodding":{"lang":"en","description":"","over18":false},"beef_flaps":{"lang":"en","description":"For those of us who enjoy large labia.","over18":true},"ProjectEnrichment":{"lang":"en","description":"","over18":false},"christinahendricks":{"lang":"en","description":"Christina Rene Hendricks was born in Knoxville, Tennessee.\n\nIn her early 20s, she began appearing on television, landing a recurring role in Beggars and Choosers (1999) in 2000 and another on Kevin Hi","over18":false},"LITTLEPERSONALS":{"lang":"en","description":"Finally a place for those of us seeking that specific kind of little relationship to find that perfect someone to spoil. ","over18":true},"Inventions":{"lang":"en","description":"Bounce off bright ideas, brainstorm creative barriers, or show off your latest inventions and innovations. Patent Pending.","over18":false},"AdiposeAmigos":{"lang":"en","description":"We're AdviceAnimals, if by \"advice\" you mean landwhales and \"animals\" you mean fuckery. Memes and macros are our meat and potatoes but any image file will sate our voracious appetite.","over18":false},"bubbling":{"lang":"en","description":"bubbling, mormon porn, bubble porn, whatever you call it, this is the place for it!\n\n","over18":true},"BRSTM":{"lang":"en","description":"Post your custom BRSTMS here.\n\nDO NOT POST BRSTMS THAT ARE ALREADY ON http://www.brawlcustommusic.com/","over18":false},"grimrock":{"lang":"en","description":"","over18":false},"woooosh":{"lang":"en","description":"A subreddit about people who miss the joke/satire.\n\nFollow the rules.","over18":false},"ClimbingPorn":{"lang":"en","description":"The best images of rock climbing on reddit.","over18":false},"femdomgonewild":{"lang":"en","description":"A place to post your acts of femdom. ","over18":true},"fidgettoys":{"lang":"en","description":"A place to talk about and share links to fidget toys we like. ","over18":false},"ejuice":{"lang":"en","description":"Links and Discussion on eJuice and eLiquid for Electronic Cigarettes.\n\nWe want your reviews!\n\nWe want your vape pics!\n\nPlease feel free to post anything related!\n","over18":false},"OnHerKnees":{"lang":"en","description":"Girls sucking cock on their knees. ","over18":true},"WouldTotallyFuck":{"lang":"en","description":"","over18":true},"askdoctors":{"lang":"en","description":"","over18":false},"iPhone6S":{"lang":"en","description":"A subbreddit to discuss the iPhone 6s!","over18":false},"UnnecessaryCensorship":{"lang":"en","description":"This subreddit was created for posting and sharing pictures (static or gif) and video.\n\nUnnecessary Censorship refers to the practice of adding censor bleeps, mosaic blurs or [black bars to source mat","over18":false},"oldschoolcreepy":{"lang":"en","description":"Here You Can Submit Creepy Pics Of Old People.","over18":false},"bears":{"lang":"en","description":"What kind of bear is best?\n\nThis is the home of all eight species of bears - American Black Bears, Brown Bears, Polar Bears, Asiatic Black (Moon) Bears, Sun Bears, Sloth Bears, Giant Pandas, and Spect","over18":false},"InvestmentClub":{"lang":"en","description":"\"An investment in knowledge pays the best interest.\"- B.F.","over18":false},"xayahmains":{"lang":"en","description":"Welcome to Xayah Mains!","over18":false},"bird":{"lang":"en","description":"all things bird related, post amazing pictures or ask curious questions, your choice!","over18":false},"ironfist":{"lang":"en","description":"","over18":false},"PolarisNetwork":{"lang":"en","description":"This is where we discuss Polaris! ","over18":false},"FuckImOld":{"lang":"en","description":"When you look at kids nowadays and see their shitty music you can't help but think of how everything is old and you just gotta say Fuck Im Old.","over18":false},"drwho":{"lang":"en","description":"#[READ THIS](https://www.reddit.com/r/drwho/comments/5j7njg/this_is_not_the_doctor_who_subreddit_you_are/)","over18":false},"90sdesign":{"lang":"en","description":"A subreddit for anything related to the distinctive design style of the 1990s! ","over18":false},"InternetCommentEtiq":{"lang":"en","description":"The internet is a terrible place. Here we will teach you how can make it better.","over18":false},"avporn":{"lang":"en","description":"Audio Video Porn (SFW!)","over18":false},"alexa":{"lang":"en","description":"The brain behind Amazon's voice powered devices like Echo, FireTV etc.","over18":false},"ConfusedTravolta":{"lang":"en","description":"Err... you know, the place where you can find John Travolta memes. I think. Where am I?","over18":false},"tech_house":{"lang":"en","description":"","over18":false},"ThreadKillers":{"lang":"en","description":"A compendium of the single comprehensive comments that stop a thread in its tracks","over18":false},"ImaginaryDragons":{"lang":"en","description":"Art featuring dragons of all sorts. ","over18":false},"soccerbanners":{"lang":"en","description":"A place to submit and vote for r/soccer banner pictures.","over18":false},"soundporn":{"lang":"en","description":"A **SFW** subreddit dedicated to nice sounds.","over18":false},"swinghouse":{"lang":"en","description":"\"Swing house is a style of house music and subgenre of electronic dance music...It fused old jazz, swing, ragtime samples over \"swung\" electronic house beats.\" ~Wikipedia","over18":false},"Shitty_Watercolour":{"lang":"en","description":"","over18":false},"NSFW_Wallpapers":{"lang":"en","description":"From offensive text to naked people, we're the place for wallpapers that would get you an instant chat with HR.","over18":true},"powerviolence":{"lang":"en","description":"","over18":false},"ShortFilm":{"lang":"en","description":"","over18":false},"ShowerOrange":{"lang":"en","description":"Shower Orange. We are dedicated to the consumption of various citrus fruits whilst taking a shower. I know, I know it sounds weird. Just give it a try. and post about your Experiences ","over18":false},"nerdtattoos":{"lang":"en","description":"A place to share and celebrate nerdy and pop culture tattoos!","over18":false},"GYM":{"lang":"en","description":"A place for Redditors to discuss their experiences at the gym.","over18":false},"warlizard":{"lang":"en","description":"","over18":false},"GreenManGaming":{"lang":"en","description":"","over18":false},"MilitaryGoneWild":{"lang":"en","description":"Gonewild for Military people, people in uniform, etc. ","over18":true},"UsefulWebsites":{"lang":"en","description":"Useful Sites Around the Web - Fun, productivity, everything","over18":false},"clubesteban":{"lang":"en","description":"I just want to dance!","over18":false},"Darknet_Markets":{"lang":null,"description":"Subreddit no longer exists","over18":null},"GirlsHumpingThings":{"lang":"en","description":"If it's a thing and girls are humping on it, it belongs here. If you enjoy watching or doing it, you belong here. \n\nWe celebrate humping masturbation by girls using objects that aren't traditional sex","over18":true},"pictureswithpatrick":{"lang":"en","description":"Wallpapers and other images with Patrick photoshopped into them.","over18":false},"creampie":{"lang":"en","description":"","over18":true},"MakeupEducation":{"lang":"en","description":"New to makeup or just wanting to learn more? We're here to help!","over18":false},"OpenSignups":{"lang":"en","description":"Open Signups - When Private Trackers Open Their Doors To The Public","over18":false},"pegging_unkinked":{"lang":"en","description":"A sub for posts about anal play for men, by women, without the fem-dom stuff. Want a finger in the B-hole during a BJ, strap-ons without the leather face masks, and videos where the guy isn't wearing ","over18":true},"ImaginaryBehemoths":{"lang":"en","description":"Art featuring giant creatures that dwell on land.","over18":false},"DistroHopping":{"lang":"en","description":"Pros/Cons of each distribution, personal experiences, that kind of stuff.","over18":false},"CreepyWikipedia":{"lang":"en","description":"Any article that makes you shiver with fear or disgust.","over18":false},"bostonr4r":{"lang":"en","description":"Whether you're seeking platonic friends, non-platonic friends, online gaming partners, soulmates, travelmates, smoking buddies, groups to join, activity partners, friends with benefits [fwb] / casual ","over18":false},"edtech":{"lang":"en","description":"A place to share news and information related to educational technology.","over18":false},"sounddesign":{"lang":"en","description":"","over18":false},"stream_links":{"lang":null,"description":"Subreddit forbidden","over18":null},"menkampf":{"lang":"en","description":"[*In the post you're about to make, replace cis/white/hetero/male people with the Jews and if the result sounds like something that could be right out of Mein Kampf, you should probably reconsider you","over18":false},"fuckingphilosophy":{"lang":"en","description":"","over18":false},"ParadoxExtra":{"lang":"en","description":"This page is dedicated to any/all titles from the developer; Paradox Interactive, restrictions and rules on posts are limited, free conversation is encouraged, discussion about Paradox Interactive and","over18":false},"ClassicOffensive":{"lang":"en","description":"Classic Offensive is an in development community made modification for Counter-Strike: Global Offensive.  CO aims to bring Counter Strike back to its roots with completely remade maps, character model","over18":false},"slightcellulite":{"lang":"en","description":"For those who take delight in deliciously dimpled asses.\n\n1. Have some cellulite.\n2. Nothing too huge please.\n3. Submissions welcome.\n","over18":true},"tallfashionadvice":{"lang":"en","description":"This is a subreddit for those giants among who hold an interest in fashion and clothing. Many of us who scrape the undersides of door frames when we walk often struggle to look dapper because, as we k","over18":false},"ScarySigns":{"lang":"en","description":"Pictures of signs found all over the world that are slightly terrifying.","over18":false},"lildicky":{"lang":"en","description":"Welcome you Dickheads!\n\nEverything one needs to know about LD.","over18":false},"Nude_Selfie":{"lang":null,"description":"Subreddit no longer exists","over18":null},"seethru":{"lang":"en","description":"","over18":true},"MortalKombatX":{"lang":"en","description":"Discussion and art about the new NetherRealm game, Mortal Kombat X.","over18":false},"SexInFrontOfOthers":{"lang":"en","description":"Girls Getting Naughty in Front of an Audience","over18":true},"PerkyChubby":{"lang":"en","description":" The rare, yet HOT, combination of chubby girls with perky boobs. A new subreddit to address a void in reddit's NSFW arsenal.    If you love the perky-chubby body type, please browse and contribute!","over18":true},"rock":{"lang":"en","description":"Rock music in all its forms.","over18":false},"shubreddit":{"lang":"en","description":"Everything Sean Connery Shays\n","over18":false},"WWOOF":{"lang":"en","description":"**W**orld **W**ide **O**pportunities on **O**rganic **F**arms is an international organization where volunteers exchange work for food and lodging on farms around the world.","over18":false},"Battletops":{"lang":"en","description":"A subreddit for reddit users' battletop pictures.","over18":false},"gape":{"lang":"en","description":"","over18":true},"ComplexionExcellence":{"lang":"en","description":"This Not-Safe-for-Work (NSFW) subreddit is dedicated to sharing Pictures and Gifs of Top-Tier Beauties.","over18":true},"Khan":{"lang":"en","description":"The official [Khan Academy](https://www.khanacademy.org) subreddit. A forum for discussion about Khan Academy, and learning in general. Khan Academy is a not-for-profit with the goal of providing a fr","over18":false},"ProgrammerTIL":{"lang":"en","description":"Learn something new? Wanna share? Post here along with the language/framework you learned it in.\n\nThis is a great place for novice and advanced programmers alike to come and discover all the interesti","over18":false},"laptopama":{"lang":"en","description":"Search up posts and ask owners of certain laptops any questions you have, or if you've bought one, feel free to make your own AMA post!","over18":false},"autotldr":{"lang":"en","description":"Automatically summarizes long Reddit posts and submissions. Powered by SMMRY.","over18":false},"hiddenwow":{"lang":"en","description":"Hidden WoW is a branch-off from the main r/wow subreddit intended to feature all things secret or less-known in the World of Warcaft. Found a cool piece of lore hidden in-game somewhere or a clever re","over18":false},"brunette":{"lang":"en","description":"Dark-haired beauties with compromised morals. ","over18":true},"Ulyssesbucketlist":{"lang":"en","description":"Where you can trade stories or challenges!\n\nHave you ever done something and been so satisfied with it's uniqueness or pleasantness that you just had to share?\n\nYou've come to the right place!","over18":false},"Hucow":{"lang":"en","description":"","over18":true},"BlockChain":{"lang":"en","description":"/r/BlockChain is a space to discuss Blockchain technology, news, impact and applications, further than crypto-talks and projects promotions.","over18":false},"Crypto_Currency_News":{"lang":"en","description":"News means money in the Crypto Currency world.  When new coins, products or platforms are released using Bitcoin, Ethereum, Monero or any related altcoin Tokens, the price of affected products can pot","over18":false},"HeresAFunFact":{"lang":"en","description":"/r/HeresAFunFact is for verifiable facts accompanied/supported with pics only. See subreddit for more info.","over18":false},"Brostep":{"lang":"en","description":"","over18":false},"TheCrownNetflix":{"lang":"en","description":"The Crown is a Netflix series about the reign of Queen Elizabeth II.","over18":false},"BlueStacks":{"lang":"en","description":"Welcome to the official subreddit of Bluestacks. BlueStacks App Player lets you run mobile apps fast and fullscreen on Windows. Download for free today at Bluestacks.com.","over18":false},"TNG":{"lang":"en","description":"","over18":false},"eveporn":{"lang":"en","description":"","over18":false},"Nicki_Minaj":{"lang":"en","description":"","over18":false},"JDM":{"lang":"en","description":"","over18":false},"Nails":{"lang":"en","description":"/r/nails: for anything and everything to do with nails and nail care! ","over18":false},"justiceleague":{"lang":"en","description":"This subreddit is for the fans of Justice League comics, movies, games, and shows.","over18":false},"The_Best_NSFW_GIFS":{"lang":"en","description":"A place to post and share your favorite NSFW GIFS.  ","over18":true},"eyebombing":{"lang":"en","description":"Eyebombing is the art of sticking “googly eyes” onto an inanimate object in the public sphere, in a way that cleverly lends the object the appearance of a living creature. ","over18":false},"bootstrap":{"lang":"en","description":"Welcome to /r/bootstrap! Our community focuses on sharing useful links, articles, and information related to using the awesome Bootstrap CSS framework.\n\nShare and learn with us!","over18":false},"fulltvshowsonyoutube":{"lang":"en","description":"Post Full-Length Youtube Movies  \nRules for the subreddit:  \n\n\n**NO OBNOXIOUSLY LONG TITLES**  \n\n\n**NO DISCUSSION THREADS**  \n\nLinks to Discussion threads will reflect TV show subbreddit discussion.  ","over18":false},"mcrealmsservers":{"lang":"en","description":"This is a subreddit for Minecraft Realms in Minecraft made by Mojang\n\n","over18":false},"Nilesy":{"lang":"en","description":"The sub reddit all about our favorite pool salesman! ","over18":false},"BlindRaids":{"lang":"en","description":"This subreddit is dedicated to finding other like-minded Destiny players who wish to attempt any new and old content without any knowledge of the challenge they face.  \n\n*Patient and Time* are somewha","over18":false},"WTTNVidia":{"lang":null,"description":"Subreddit forbidden","over18":null},"ambient":{"lang":"en","description":"","over18":false},"YAYamateurs":{"lang":"en","description":"At AmateurXXX you'll find the best amateur videos! No acting, no scripts and no fakes! ","over18":true},"Neverbrokeabone":{"lang":"en","description":"Have you ever broken a bone? No? Then this is the place for you.","over18":false},"HarmonQuest":{"lang":"en","description":"HarmonQuest is a live-action/animated show by Spencer Crittenden and Dan Harmon.","over18":false},"2spooky4me":{"lang":"en","description":"WARNING: subreddit is very spooky. If you have heart or back issues enter at your own risk. ","over18":false},"Tentai":{"lang":"en","description":"Hentai with tentacles.","over18":true},"AubreyPlaza":{"lang":"en","description":"For fans of the actress/comedian Aubrey Plaza. \n\nPics, vids, news, quotes, trivia.","over18":false},"chinesefood":{"lang":"en","description":"Mission Statement:\n\nTo honor Chinese food in all of it's glory through the power of the internets.","over18":false},"amazonprime":{"lang":"en","description":"All about the Amazon Prime Service\n","over18":false},"warmane":{"lang":"en","description":"warmane","over18":false},"pol":{"lang":null,"description":"Subreddit no longer exists","over18":null},"HungryButts":{"lang":"en","description":"Share and enjoy pictures of big butts, small butts, flat butts, or round butts.  As long as there is some material (underwear, skirt, yoga pants, etc.) tucked into the butt, it belongs here!  \n\nWeb fi","over18":true},"MedievalHistory":{"lang":"en","description":"","over18":false},"XboxOneHelp":{"lang":"en","description":"Xbox One Help","over18":false},"tinycode":{"lang":"en","description":"This subreddit is about minimalistic, often but not always simple implementations of just about everything. tiny code / minimalistic programming / yagni / kiss / dry\n\n**TL;DR: Low line count, high qua","over18":false},"Feet_NSFW":{"lang":"en","description":"NSFW Pics of sexy female feet. Foot Fetish, soles, toes, pantyhose, high heels, etc.. ","over18":true},"SprintFramily":{"lang":"en","description":"This is a subreddit intended to be used for building Sprint Framily plans.","over18":false},"NorthKoreaPics":{"lang":"en","description":"A subreddit for pics of North Korea!\n\nMember of the /r/NationalPhotoSubs network.","over18":false},"ESObuilds":{"lang":"en","description":"Discussion of The Elder Scrolls Online character builds.","over18":false},"REEEEEE":{"lang":"en","description":"A subreddit designed to be linked as a joke response to any post, comment or link that displays an unnecessary amount of anger for no reason. (Working on desktop only. Soon to be compatible with mobil","over18":false},"PostPreview":{"lang":"en","description":"A place to see what your Reddit posts will look like, before you actually post them. Helpful for formatting errors and such.","over18":false},"RepVouch":{"lang":"en","description":"This is the place to have your vouches readily accessible. Link your vouch page when you are trying to sell. This is also where you can search to see if someone is a scammer.","over18":false},"metart":{"lang":"en","description":"A subreddit for all things MetArt.","over18":true},"hydraulicpresschannel":{"lang":"en","description":"The Hydraulic Press Channel is a YouTube channel dedicated to crushing various objects that have been requested by viewers. We must deal with it!","over18":false},"ketotrees":{"lang":"en","description":"This subreddit is to support those who choose to improve their mental and physical health with a Ketogenic diet and the use of Marijuana.","over18":false},"CompetitiveHotS":{"lang":"en","description":"/r/CompetitiveHotS is a subreddit for discussing competitive and professional Heroes of the Storm topics. \n\nWe have weekly 'looking for' threads posted each week.\n\nPost about upcoming tournaments, VOD","over18":false},"virtualization":{"lang":"en","description":"Virtualization is transforming computing, from the datacenter to the desktop. News, comparisons, bugs, assistance, migration, anything: we're here to talk about it. P2V the world!","over18":false},"Random_Acts_of_Books":{"lang":"en","description":"","over18":false},"coopplay":{"lang":"en","description":"Please use this page to request co-op play. Please put your game and the platform in the title!","over18":false},"Archeology":{"lang":"en","description":"This is a subreddit for all things archeology and history,","over18":false},"LoveToWatchYouLeave":{"lang":"en","description":"A subreddit for pics and gifs of women leaving: walking, running, skipping, crawling, climbing, or what-have-you away. If she is (or should be) moving away from the camera, then she belongs here!","over18":true},"CelestiaVega":{"lang":"en","description":"Celestia Vega calls herself the #1 e-Girl on the internet. What do you think?","over18":true},"yamrepublic":{"lang":null,"description":"Subreddit forbidden","over18":null},"sissykik":{"lang":"en","description":"A place people can post different sissy related groups on kik. This is a way sissies can talk to each other, and admirers can find sissies to meet!","over18":true},"Skincare_Addiction":{"lang":"en","description":"You don't need an expensive regimen of products or frequent facials to achieve really impressive results.  You only need this dedicated community of knowledgeable, skeptical men and women who are pass","over18":false},"MemesIRL":{"lang":"en","description":"","over18":false},"KimKardashianPics":{"lang":"en","description":"Dedicated to pictures of Kim Kardashian, regularly voted sexiest woman in the world, and without a doubt, proprietor of the most coveted booty in the world. Please share new and old sexy pictures of K","over18":false},"dirtykik":{"lang":"en","description":"A subreddit for **adults(18+)** to connect, chat, trade nudes or dirty talk with other adults. ","over18":true},"NigelThornberry":{"lang":"en","description":"","over18":false},"musicproduction":{"lang":"en","description":"","over18":false},"McKaylaMaroney":{"lang":"en","description":"","over18":false},"teamviewer":{"lang":"en","description":"Cross-platform remote desktop access for PC to PC, mobile to PC, and PC to mobile connections that support Windows, Mac OS, Linux, Chrome OS, iOS, Android, Windows App, and BlackBerry. ","over18":false},"ketorage":{"lang":"en","description":"","over18":false},"gangbeasts":{"lang":"en","description":"A subreddit for the game Gang Beasts developed by Boneloaf.","over18":false},"PornGifs":{"lang":"en","description":"A place to share sexy pornographic gifs of women.","over18":true},"MilitaryHistory":{"lang":"en","description":"Military History related links - modern or ancient!","over18":false},"gtafriends":{"lang":"en","description":"Subreddit for finding gta online players.","over18":false},"SHHHHHEEEEEEEEIIIITT":{"lang":null,"description":"Subreddit forbidden","over18":null},"Ballers":{"lang":"en","description":"A subreddit for the HBO television series, Ballers.","over18":false},"BackgroundArt":{"lang":"en","description":"Background art, design and scenery. \n\n* Anime\n\n* Animation \n\n* Cartoons  \n\n* Video games","over18":false},"FitWomenGifs":{"lang":"en","description":"FitWomenGifs is the place for gifs and videos of fit women and female athletes, including fitness models, female bodybuilders and physique athletes, pole vaulters, weightlifters, volleyball players, t","over18":false},"REDDITGUILDRESOURCE":{"lang":"en","description":"","over18":false},"FreeSpeech":{"lang":"en","description":"This is a subreddit for discussions about freedom of speech and for news about free speech-related issues from all around the world.","over18":false},"AreolasGW":{"lang":"en","description":"Gonewild page for the appreciation of nice areolas","over18":true},"HackBloc":{"lang":"en","description":"Hacktivism, Crypto-anarchy, Darknets, Free Culture - Proudly Feminist, Anarchist, Anti-Capitalist, Anarchist hackers","over18":false},"UI_Design":{"lang":"en","description":"Topics related to UI design, mobile UI design, mobile app design, etc.","over18":false},"JustBootThings":{"lang":"en","description":"A subreddit dedicated to cringe-worthy pictures, stories, and videos of people acting boot.\n\nRemember, Boots aren't restricted to junior ranks. Boot is a state of mind. Any rank can be posted here, in","over18":false},"IndianPorn":{"lang":"en","description":"Home to The Hottest Amateur and Pro Indian Videos.\nThis Subreddit is dedicated to providing The Best Amateur Videos from Indian Sub Continents. If you are looking for Quality Videos, Hottest and Sexie","over18":true},"PutAnEggOnIt":{"lang":"en","description":"A subreddit devoted to photographs of any delicious food that would have tasted just fine on its own, but has been topped with a delicious egg as well.\n\n\nIf the egg is on a plate next to other food, t","over18":false},"FullLengthFilms":{"lang":"en","description":"A community built around a love for movies. We're here to create a curated list of free movies you can watch online.","over18":false},"fallout_shelter":{"lang":"en","description":"Sub dedicated to the mobile game \"Fallout Shelter\" created by Bethesda Softworks. Currently on iOS/Android/Windows mobile devices, Xbox One and PC. ","over18":false},"photographs":{"lang":null,"description":"Subreddit forbidden","over18":null},"editing":{"lang":"en","description":"","over18":false},"media":{"lang":"en","description":"","over18":false},"sizecomparison":{"lang":"en","description":"This sub is for those who get off on comparing size. Please only post pictures/videos/stories depicting noticeable differences in size, or (for solo shots) a reasonable object for comparison.","over18":true},"emulators":{"lang":"en","description":"A community just for emulators.","over18":false},"nomorals":{"lang":null,"description":"Subreddit no longer exists","over18":null},"trolling":{"lang":"en","description":"/r/trolling","over18":false},"autofellatio":{"lang":"en","description":"A subreddit for self suck, self blowjob, or autofellatio pics & videos. ","over18":true},"AncientAliens":{"lang":"en","description":"Archaeo-SETI","over18":false},"dopplebangher":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Milfie":{"lang":"en","description":"Selfies of MILFs ","over18":true},"rubberducks":{"lang":"en","description":"A place for ducky lovers to discuss rubber ducks, share links to rubber ducks in the news/other media, and spread other ducky knowledge!","over18":false},"softscience":{"lang":"en","description":"A softer r/science","over18":false},"ilikthebred":{"lang":"en","description":"my name is Cow,  \nand wen its nite,  \nor wen the moon  \nis shiyning brite,  \nand all the men\nhaf gon to bed -  \ni stay up late.\n\ni lik the bred.","over18":false},"Marvel_Daredevil":{"lang":"en","description":"A subreddit celebrating everything about Marvel's Daredevil character!","over18":false},"Nodumbquestions":{"lang":"en","description":"A podcast where a science guy and a humanities guy discuss deep questions with varying levels of maturity.","over18":false},"WidescreenWallpaper":{"lang":"en","description":"21:9 Ultrawide Wallpapers! 3440x1440, 2560x1080, and much more!","over18":false},"playarklfg":{"lang":"en","description":"A place to find like minded people who play together and meet new people.","over18":false},"nipslip":{"lang":null,"description":"Subreddit forbidden","over18":null},"Sissy_humiliation":{"lang":"en","description":"","over18":true},"LegalTeensXXX":{"lang":"en","description":"**The youngest pornstars in hardcore action**\n\nThis subreddit deals in barely legal pornstars engaged in fucking and sucking. This sub is NSFW and hardcore material is part of the concept. It's only a","over18":true},"thebindingofisaac":{"lang":"en","description":"Welcome to /r/TheBindingofIsaac, a subreddit for the game: The Binding of Isaac: Rebirth (as well as the original, The Binding of Isaac, and the expansion, Afterbirth)","over18":false},"ConspiracyMemes":{"lang":"en","description":"This subreddit is devoted to memes relating to all things conspiracy.  Things are pretty laid back around here so all people are welcome.\n\nThe moderators believe in free speech and DO NOT moderate com","over18":false},"tf2memes":{"lang":"en","description":"\"PUBLICLY DESCRIBE YOUR SUBREDDIT\"\n\n\nNo","over18":false},"DIY_tech":{"lang":"en","description":"DIY-tech: a place to share your tech related DIY creations","over18":false},"wroteabook":{"lang":"en","description":"Welcome! This is a place for Redditors to post links and descriptions of their finished magnum opi. All genres of literature and graphic novels are welcome with no length requirements, so long as it i","over18":false},"AvatarPorn":{"lang":"en","description":"The Legend of Korra / Avatar: The Last Airbender Porn\n\nThis subreddit is dedicated to porn pictures, gifs, and videos of \"Avatar: The Last Airbender\" and \"The Legend of Korra\" a cartoon show that airs","over18":true},"backpacks":{"lang":"en","description":"Discussion about backpacks, onebag, one bagging, travel, packing, and EDC.","over18":false},"videos_discussion":{"lang":"en","description":"A place to discuss the state of /r/videos, suggest improvements, or have your questions answered.","over18":false},"becomeaman":{"lang":"en","description":"Join us and get motivated. From /r/theredpill comes a new subreddit dedicated to making the transition from the boy you were to the man you will become.","over18":false},"Playboy":{"lang":"en","description":"Subreddit dedicated to new and vintage images and videos from the annals of Playboy.","over18":true},"IdiotsNearlyDying":{"lang":"en","description":"Almost dying, almost getting seriously injured . . . almost.  No actual death, dismemberment, or gore; this sub is for close calls or things that could have gone much worse. ","over18":false},"MarcoPolo":{"lang":"en","description":"This is the place to discuss the Netflix Original, Marco Polo.","over18":false},"questioning":{"lang":"en","description":"A friendly community for those questioning their own sexuality and gender.","over18":false},"ffxivraf":{"lang":"en","description":"Make friends, recruit friends, get a Chocobo","over18":false},"unturnedservers":{"lang":"en","description":"","over18":false},"bf4":{"lang":"en","description":"","over18":false},"SoulsSliders":{"lang":"en","description":"Post your characters and sliders here!","over18":false},"FacebookCleavage":{"lang":null,"description":"Subreddit forbidden","over18":null},"PaoYongYang":{"lang":"en","description":"##https://www.reddit.com/r/announcements/comments/3cucye/an_old_team_at_reddit/\n","over18":false},"Mahouka":{"lang":"en","description":"The subreddit for Mahouka Koukou no Rettousei, or *The Irregular at Magic High School*.","over18":false},"learnfrench":{"lang":"en","description":"This is a subreddit for people who wants to learn french or help others learn french.","over18":false},"blowit":{"lang":"en","description":"A place for minds to be blown. You have one sentence to blow someone's mind and, maybe, your mind will be blown, too.","over18":false},"HoleWreckers":{"lang":"en","description":"A sub dedicated to girls who *know* that bigger is better and just can't help themselves!\n\nWhen we say big, we mean **big** - like width of someone's wrist big! (obvious exception for stuff like pee-h","over18":true},"NotFoolingAnybody":{"lang":"en","description":"/r/NotFoolingAnybody is a place to post pictures of businesses that have been converted to other uses, yet still strongly resemble their former use.","over18":false},"ShareArcheage":{"lang":"en","description":"","over18":false},"HeadBangToThis":{"lang":"en","description":"","over18":false},"ludumdare":{"lang":"en","description":"Ludum Dare: all about the Internet's oldest, longest-running game jam, in which participants develop an entire game in one weekend from scratch.","over18":false},"dropbox":{"lang":"en","description":"","over18":false},"eroticliterature":{"lang":"en","description":"","over18":true},"ytp":{"lang":"en","description":"The Youtube Poop video subreddit, a genre that most people wish didn't exist. Come for the sudden violent drops in quality and extreme noise, and stay for the insanity!","over18":false},"ThisWarofMine":{"lang":"en","description":"For anything related to the game released by 11 Bit Studios, This War of Mine.\n","over18":false},"Division":{"lang":"en","description":"Strategy sub-reddit for the upcoming blockbuster Tom Clancy's The Division","over18":false},"unlimitedbreadsticks":{"lang":"en","description":"","over18":false},"Web_Development":{"lang":"en","description":"Web Development news, articles, and tools.","over18":false},"starwarsmemes":{"lang":"en","description":"The home for Star Wars related macros, reaction gifs, etc! ","over18":false},"shittylifehacks":{"lang":"en","description":"","over18":false},"diet":{"lang":"en","description":"","over18":false},"snek_irl":{"lang":"en","description":"Irl snek","over18":false},"D3T":{"lang":"en","description":"","over18":false},"bodyshots":{"lang":"en","description":"Cumshots below the neck.","over18":true},"ExtraLife":{"lang":"en","description":"","over18":false},"Robbaz":{"lang":"en","description":"","over18":false},"RegularRevenge":{"lang":"en","description":"This is the place for revenge stories that have no other home. This isn't petty, and it isn't pro. It's just regular.","over18":false},"OfficialSodapoppin":{"lang":"en","description":"","over18":false},"StonerThoughts":{"lang":"en","description":"","over18":false},"Currentlytripping":{"lang":"en","description":"Are you currently tripping? You might enjoy some of these pics, gifs, videos, music or web-tools posted to this subreddit.","over18":false},"TreesSuckingOnThings":{"lang":"en","description":"For all your Trees-sucking-on-things needs.","over18":false},"nukedmemes":{"lang":"en","description":"Like DeepFriedMemes but with extra 3rd degree burns\n\nOld reddit design is recommended","over18":false},"PokemonGoSnap":{"lang":"en","description":"A place to post snap shots of Pokemon found in Pokemon Go.","over18":false},"Shittypokestops":{"lang":"en","description":"A subreddit for the shittiest Pokéstops in the world of Pokémon Go. The shittier the better.\n\nWhat denotes a shitty Pokéstop you ask. Well, a shitty Pokéstop is any location that is humorous or odd th","over18":false},"Objects":{"lang":"en","description":"/r/Objects is a pornography subreddit covering the topic of a female inserting various non-sexual objects vaginally or anally.","over18":true},"EdSheeran":{"lang":"en","description":"**Edward Christopher \"Ed\" Sheeran** is an English singer and songwriter.","over18":false},"Hacking_Tutorials":{"lang":"en","description":"Hacking Tutorials is a sub where redditors can post various resources that discuss and teach the art of hacking.","over18":false},"LEMMiNO":{"lang":"en","description":"Official subreddit for LEMMiNO.","over18":false},"cameltoe":{"lang":"en","description":"A subreddit dedicated to all manner of (legal) cameltoe pictures","over18":true},"MalesMasturbating":{"lang":"en","description":"A place for men to post their masturbation gifs and for man-lovers to drool.","over18":true},"tinyanimalsonfingers":{"lang":"en","description":"Tiny animals on fingers! ","over18":false},"alphaandbetausers":{"lang":"en","description":"Our innovators need people to use their products to give them feedback! It is hard enough to develop a product. Let's make it easier for them to recruit the critical early users that they need to tell","over18":false},"ooerintensifies":{"lang":"en","description":"Combination of /r/ooer and /r/redditintensifies. Thanks, /u/Bloated_Seal for the idea, and the above subreddits for their code!","over18":false},"DinosaurDrawings":{"lang":"en","description":"This is a subreddit for drawings of dinosaurs. Not much else to say about it.","over18":false},"baww":{"lang":"en","description":"Videos, images, stories and news for when you just need a good cry.","over18":false},"2XLookbook":{"lang":"en","description":"","over18":false},"HSCoaching":{"lang":"en","description":"","over18":false},"adventures":{"lang":"en","description":"All about your adventures. Planning, discussing, and organizing future adventures, and sharing past ones. Base jumping, diving, urban exploration, ghost-hunting, caving, climbing, hiking, wild camping","over18":false},"Futurama_Sleepers":{"lang":"en","description":"Futurama episodes and commentaries fer sleepin' to.\n\n","over18":false},"comedyhomicide":{"lang":"en","description":"A funny post ruined by a shitty caption, proposed by /u/Galle_.","over18":false},"RachelCook":{"lang":"en","description":"Sub dedicated to the model Rachel Cook.","over18":false},"motorcyclememes":{"lang":"en","description":"For those sweet, sweet motorcycle memes, especially ones that have been discarded by r/motorcycles. ","over18":false},"strength_training":{"lang":"en","description":"Discussion of all topics related to strength training: Bodybuilding, powerlifting, weightlifting, strongman, kettlebells, bodyweight training.\n\n","over18":false},"jennettemccurdy":{"lang":"en","description":"For pictures, videos, gifs, news, etc of Jennette McCurdy","over18":false},"bustybabes":{"lang":"en","description":"","over18":true},"cumshots":{"lang":"en","description":"","over18":true},"TheBlueCorner":{"lang":"en","description":"GLORY TO THE BLUE CORNER!","over18":false},"Survivalist":{"lang":"en","description":"","over18":false},"boysgonewild":{"lang":"en","description":"","over18":true},"bees":{"lang":"en","description":"Bees - The only reason you are ALIVE is that the bees decided to let you live.","over18":false},"covfefe":{"lang":"en","description":"Dedicated to all of Trump's crazy tweets.\n5-30-17: \"Despite the constant negative press covfefe\"","over18":false},"teso":{"lang":"en","description":"The Elder Scrolls Online Subreddit. Includes ESO Morrowind. ElderScrollsOnline is an MMORPG developed by ZeniMax Online Studios and published by Bethesda Softworks","over18":false},"PlayStationNow":{"lang":"en","description":"PlayStation Now is the game streaming service (similar to now-defunct OnLive) which uses tech from Gaikai.\n\nPS NOW\n\n* PS3 (PlayStation 3)\n* PS4 (PlayStation 4)\n* PSP (PlayStation Portable)\n* PS Vita (","over18":false},"smyths":{"lang":"en","description":"Edits of Mythbusters episodes (all the fluff removed)","over18":false},"oneplusinvites":{"lang":null,"description":"Subreddit forbidden","over18":null},"ideas":{"lang":"en","description":"/r/Ideas has been closed due to overlap between the [main ideas subreddit](/r/lightbulb) and this subreddit. **All requests to join this subreddit will be ignored or denied immediately.**\n\n####[Click ","over18":false},"MimicRecipes":{"lang":"en","description":"Mimic recipes! Recipes set to mimic popular foods.","over18":false},"wet":{"lang":"en","description":"Showing only the wettest girls!","over18":true},"transcribe":{"lang":"en","description":"If you're looking for help figuring out the chords/notes for a piece of music, this is the place to ask. ","over18":false},"NatalieDormer":{"lang":"en","description":"","over18":false},"unexpectedhogwarts":{"lang":"en","description":"A subreddit detailing unexpected Harry Potter references on reddit.","over18":false},"uncensorship":{"lang":"en","description":"Due to internal administration reorganization at reddit, /r/uncensorship has temporarily been made private by the moderators.\n\n^(A subreddit for the voluntary revealing of removed posts. The content o","over18":false},"soundsaboutright":{"lang":"en","description":"For news or other stories that are surprising to no one.","over18":false},"PokemonGoRed":{"lang":"en","description":"The unofficial subreddit for members of the Valor team in Pokemon GO.","over18":false},"notreallyfamous":{"lang":"en","description":"Pics of people with (who they thought were) celebrities.","over18":false},"randomactsofmusic":{"lang":"en","description":"Showcasing spontaneous music in public places","over18":false},"bigdickjoy":{"lang":"en","description":"Joyful stories and discussion about Big Dicks.","over18":true},"kekistan":{"lang":"en","description":"","over18":false},"unexpectedoutcome":{"lang":"en","description":"no","over18":false},"Hosting":{"lang":"en","description":"r/Hosting is for discussions of hosting services and providers including: shared hosting, cloud hosting, VPS providers, dedicated servers, and other hosting related services. General discussions on we","over18":false},"oceans":{"lang":"en","description":"Oceans cover more than 70% of Earth and drive weather, regulate temperature, and support life on this planet. Our oceans are a vast system of diverse and complex ecosystems and natural resources; and ","over18":false},"snapchatgw":{"lang":"en","description":"A place to share NSFW snap chats!","over18":true},"left4dead":{"lang":"en","description":"","over18":false},"NameMyCSGOItem":{"lang":"en","description":"Here you can post your CS:GO item for others to name or suggest names.","over18":false},"BreedingMaterial":{"lang":"en","description":"Dedicated to women that represent our personal ideals of breedability and fertility. Content is NSFW. Now with over 100k subscribers! ","over18":true},"SpreadEm":{"lang":"en","description":"Pics of girls spreading their butt cheeks.","over18":true},"ShittyTechDeals":{"lang":"en","description":"ShittyTechDeals - A place for the worst tech deals found around internet.","over18":false},"anarchy":{"lang":"en","description":"","over18":false},"DeadRedditors":{"lang":"en","description":"","over18":false},"nocontext_wallpapers":{"lang":"en","description":"An out of context quote slapped onto an unrelated wallpaper. No Context Wallpapers is to Motivational Posters what a rubber boot is to the graceful African white-tailed mongoose. And that, my friends,","over18":false},"nsfwsports":{"lang":"en","description":"Pictures and videos of sexy female athletes","over18":true},"freeculture":{"lang":"en","description":"","over18":false},"REDDITEXCHANGE":{"lang":"en","description":"","over18":false},"CEMUcaches":{"lang":"en","description":"This is a subreddit to share your pre-cached shaders for the cemu emulator","over18":false},"futurepopmusic":{"lang":"en","description":"For experimental electronic pop music.\n'Future', here, is a state of mind.","over18":false},"GirlsinStripedSocks":{"lang":"en","description":"","over18":true},"torontoJobs":{"lang":"en","description":"Redditor approved jobs in the GTA.","over18":false},"anal_gifs":{"lang":"en","description":"#1 subreddit for Anal gifs!","over18":true},"FindTheSniper":{"lang":"en","description":"The well camouflaged hiding in plain sight.","over18":false},"Memeconomy":{"lang":"en","description":"A place where meme merchants and pepe peddlers can discuss the status quo of the meme economy. Meme smithing encouraged!","over18":false},"Sorosforprison":{"lang":"en","description":"Send george soros and sons to prison","over18":false},"computebazaar":{"lang":"en","description":"","over18":false},"filesharing":{"lang":null,"description":"Subreddit no longer exists","over18":null},"traingifs":{"lang":"en","description":"GIFs of Trains","over18":false},"Star_wars_Rogue_One":{"lang":"en","description":"Star Wars : Rogue One  Movie HYPE and Discussion.\n\nRogue One: A Star Wars Story is an upcoming 2016 epic directed by Gareth Edwards \n\nA Star Wars Anthology film set in the Star Wars universe starring ","over18":false},"100pushups":{"lang":"en","description":"100 pushups challenge ","over18":false},"CampfireCooking":{"lang":"en","description":"Getting back to basics where food, fire, and fun are all combined into a little rustic sumpin' sumpin' called campfire cooking. Share your ideas, methods, and recipes where conversation is best. Dat F","over18":false},"MiddleEasternHotties":{"lang":"en","description":"A Subreddit dedicated to the Babes of Middle East. If you like Hot Babes that are Exotic, then this Subreddit is for you.","over18":true},"natureporn":{"lang":"en","description":"For people who have a sensual and erotic attraction to nature and know how to express it.","over18":false},"awwtf":{"lang":"en","description":"I think it's pretty self explanatory. This is for things that are kind of cute, and kind of make you WTF?!?!?!","over18":false},"HeyCarl":{"lang":"en","description":"","over18":false},"Summit1G":{"lang":"en","description":"Official subreddit of YouTuber, livestreamer and Competitive Counter Strike player Summit1G.","over18":false},"80sdesign":{"lang":"en","description":"'80s design, its extension to the '90s, modern art influenced by it, and everything related to it. Neon lights and squiggly lines are welcome.","over18":false},"RealPublicNudity":{"lang":"en","description":"","over18":true},"ComputerSecurity":{"lang":"en","description":"IT security news, articles and tools.","over18":false},"AgePlaying":{"lang":"en","description":"A subreddit dedicate to age play roleplaying ala DD/LG: Daddy Dom, Little Girl or Big Brother, Little Sister, etc. \n","over18":true},"FirstWorldConformists":{"lang":"en","description":"A place to fit in","over18":false},"PromoteGamingVideos":{"lang":"en","description":"******I understand there are other subs like this, however this is for gamers only**\n\nOther subreddits don't like/enjoy self-promotions of your YouTube videos, your YouTube channel or your various oth","over18":false},"amipretty":{"lang":"en","description":"","over18":false},"ketchuphate":{"lang":"en","description":"Ketchup:The bastardization of a perfectly good tomato","over18":false},"realsexyselfies":{"lang":"en","description":"Real amateur girls. No nonsense. Let's get the hottest amateur selfies and selfshots on the internet and post them all here.","over18":true},"Radiolab":{"lang":"en","description":"Welcome to the /r/Radiolab! Radiolab is a show about curiosity. Where sound illuminates ideas, and the boundaries blur between science, philosophy, and human experience. ","over18":false},"PrivateInternetAccess":{"lang":"en","description":"","over18":false},"LeagueofFailures":{"lang":"en","description":"KMS","over18":false},"houstonjobs":{"lang":"en","description":"Connecting Employers and Employees since 2011","over18":false},"crackpackservers":{"lang":"en","description":"","over18":false},"Bittrex":{"lang":"en","description":"Bittrex is a US-based cryptocurrency exchange. This is an unofficial subreddit about it.","over18":false},"jobbit":{"lang":"en","description":"","over18":false},"Infowars":{"lang":null,"description":"Subreddit no longer exists","over18":null},"shittytattoos":{"lang":"en","description":"Pictures of shitty tattoos.","over18":false},"RileyReid":{"lang":"en","description":"All Things Riley Reid...  Pics, Vids, Links, Etc!","over18":true},"digital_marketing":{"lang":"en","description":"For digital marketing news, best practices, strategy, and learning.\n","over18":false},"yikyak":{"lang":"en","description":"Want to see some hillarious Yik Yak posts? Look here!\nWant to share and enter handle codes? Look here!\nEverything else Yik Yak? Look here!","over18":false},"disneyparks":{"lang":"en","description":"For anything and everything relevant to any of the Disney theme parks from around the world!\n","over18":false},"ShareAFap":{"lang":"en","description":"Share A Fap is a free place to find and contribute porn website accounts.","over18":true},"Vikings_TvSeries":{"lang":"en","description":"A subreddit for discussion about the History Channel tv-show Vikings","over18":false},"askredddit":{"lang":"en","description":"","over18":false},"redditdotcom":{"lang":"en","description":"A place for anything and everything.","over18":false},"asslick":{"lang":"en","description":"","over18":true},"brewing":{"lang":"en","description":"Brewing: News, info, discussion, stories and all things zymurgy. For the Professional and Homebrewer","over18":false},"crime":{"lang":"en","description":"criminal matters, crime\nnews\noffbeat news\nnews\nMurder\nMissing persons","over18":false},"me_irlgbt":{"lang":"en","description":"gay selfies of the gay","over18":false},"WaterGuy12":{"lang":"en","description":"August 14th; judgement day.","over18":false},"footballtactics":{"lang":"en","description":"","over18":false},"inthelittlewood":{"lang":"en","description":"A subreddit for all things about Martyn Littlewood, also known as InTheLittleWood, of the Yogscast!","over18":false},"VeltPvP":{"lang":null,"description":"Subreddit forbidden","over18":null},"ASUS":{"lang":"en","description":"Top subreddit for ASUS product support, discussion and more.","over18":false},"vgstreams":{"lang":"en","description":"A subreddit dedicated to livestreaming video games. Streamers can advertise their streams, and viewers can find new streams to watch. ","over18":false},"metal_me_irl":{"lang":"en","description":"metal_me_irl","over18":false},"GoodFakeTexts":{"lang":"en","description":"Welcome to /r/GoodFakeTexts! This subreddit is for posting text messages that are extremely likely fake, yet funny. ","over18":false},"sony":{"lang":"en","description":"","over18":false},"ProgrammingBuddies":{"lang":"en","description":"A place for people to group up to learn and teach programming to each other. ","over18":false},"LifeWithIgor":{"lang":"en","description":"Igor is my brother-in-law. He and my sister have been married for 7 years, and have been living with us for the last few months. This is Life with Igor. /u/DisgruntledPlebian","over18":false},"OldNews":{"lang":"en","description":"Taking the *new* out of news.","over18":false},"makeaband":{"lang":"en","description":"Know how to play an instrument? Love music? Just want to get on stage?  Trying to make a band? This is the safe discussion sub for starting a real life band of your own.","over18":false},"TellReddit":{"lang":"en","description":"","over18":false},"xboxlivetrials":{"lang":null,"description":"Subreddit forbidden","over18":null},"Naturewasmetal":{"lang":"en","description":"A collection of dinosaurs and other awesome creatures that are now extinct. ","over18":false},"gamereviews":{"lang":"en","description":"GameReviews is a subreddit dedicated to video game reviews of all platforms and genres, written or directed by the average gamer. Feel free to submit your own reviews.","over18":false},"mildlydepressing":{"lang":"en","description":"Spinoff of /r/mildlyinteresting, inspired by [these comments](http://www.reddit.com/r/mildlyinteresting/comments/yuysx/a_bee_got_stuck_and_died_in_a_gel_letter/c5z5r0z) on [this submission](http://www","over18":false},"DCforRent":{"lang":"en","description":"","over18":false},"unitedairlines":{"lang":"en","description":"United Airlines. \n\nA moderated subreddit for discussion of the airline and its issues/stories.","over18":false},"dolphinconspiracy":{"lang":"en","description":"DOLPHINS ARE A CONSPIRACY! WE ALL KNOW IT. HERE IS THE PLACE WHERE YOU CAN SHARE YOUR HUMAN SECRETS AND STORIES, AWAY FROM THE PRYING EYES OF THE BLUE LONG NOSED GOVERNMENT OFFICIALS.\n\nTIN HATS RECOMM","over18":false},"BonersInPublic":{"lang":"en","description":"Hard Guys in Public Places","over18":true},"montypython":{"lang":"en","description":"Everything to do with Monty Python.","over18":false},"bored":{"lang":"en","description":"/r/Bored is a subreddit dedicated to helping you enjoy your free time. ","over18":false},"BorednIgnored":{"lang":"en","description":"A porn subreddit where the woman is either acting completely irratated, bored or is ignoring the actions of the man all together and acting as if he doesn't exist while he fucks her or masturbates on ","over18":true},"Funnypics":{"lang":"en","description":"","over18":false},"Codecademy":{"lang":"en","description":"","over18":false},"adrenaline":{"lang":"en","description":"","over18":false},"tardcat":{"lang":"en","description":"Everything related to Grumpy Cat","over18":false},"badtaxidermy":{"lang":"en","description":"","over18":false},"90scartoons":{"lang":"en","description":"Everything 90s cartoons and kids programming. Discuss your favorites and find where you can watch them online.","over18":false},"Futurism":{"lang":"en","description":"A subreddit focused on the technological advancements and scientific breakthroughs that will shape the future of humanity.\n","over18":false},"minimalist":{"lang":"en","description":"Minimalist Lifestyle","over18":false},"TheUnderbun":{"lang":"en","description":"Dedicated to the glorious underbun, the ass cheek on display under a short skirt, short shorts or panties. If you like booty, big buns or smaller buns, please subscribe and participate to make this co","over18":true},"mtgporn":{"lang":"en","description":"A subreddit for sharing artwork from the fantasy card game Magic: The Gathering","over18":false},"atljobs":{"lang":"en","description":"Jobs! In Atlanta! Hopefully posted by redditors and not recruiters who don't really care about you and just want more applications to look like they're doing a good job.","over18":false},"GirlsinSchoolUniforms":{"lang":"en","description":"Professional models and porn stars dressed up as sexy schoolgirls. ","over18":true},"BitchImATrain":{"lang":"en","description":"Trains be fucking your shit up. ","over18":false},"womenofcolorXXX":{"lang":"en","description":"Porn stills, gifs and movies featuring women of color.","over18":true},"Anjelica_Ebbi":{"lang":"en","description":"","over18":true},"GBDS":{"lang":"en","description":"Subreddit for development updates regarding the free Visual Novel Garlic Bread Dating Simulator. Coming to steam and our website 2019.","over18":false},"ikeahacks":{"lang":"en","description":"IKEAhacks is a smart community focused on helping people build the perfect furniture for their living space using items sold by IKEA. ","over18":false},"steamswap":{"lang":"en","description":"","over18":false},"cumonclothes":{"lang":"en","description":"Pictures and video of women with cum on their clothes.","over18":true},"Hobbies":{"lang":"en","description":"This sub-reddit is dedicated to finding, sharing and recommending new hobbies to people.","over18":false},"Resume":{"lang":"en","description":"A subreddit where people can get resume help by anonymously submitting their resume for feedback and advice.","over18":false},"UnexpectedHamilton":{"lang":"en","description":"We document instances of Hamilton: An American Musical being referenced anywhere from the Internet's comment sections to in-person sightings! Basically we are absolute dorks.","over18":false},"ilerminaty":{"lang":"en","description":"The Loomy Nardy is everywhere, this is a sub dedicated to stopping the madness and destroying the Luminous Nardies.","over18":false},"SwiggitySwootyGifs":{"lang":"en","description":"","over18":false},"hipcleavage":{"lang":"en","description":"Pictures of women in poses that show off that wonderful line between the thigh and the hip. Hip cleavage, for lack of a better definition. Full round hips with a bent thigh is what we are looking for ","over18":true},"ketodrunk":{"lang":"en","description":"A subreddit devoted to the careful craft of the low-carb drunk.  Too many sugary cocktails and carb-laden beer finding their way to your gut, ass, and thighs?  We've got the cure for you!","over18":false},"Whatthefuckgetitoffme":{"lang":"en","description":"What the fuck!? GET IT OFF ME!","over18":false},"fromscratch":{"lang":"en","description":"A subreddit dedicated to preparing food from scratch.","over18":false},"BDOGuilds":{"lang":"en","description":"Guild Recruitment for Black Desert Online","over18":false},"askashittyphilosopher":{"lang":"en","description":"","over18":false},"t:heatdeathoftheuniverse":{"lang":"en","description":"","over18":false},"rnb":{"lang":"en","description":"Music for lovers.","over18":false},"playrustgroups":{"lang":"en","description":"This subreddit was created to help you find, and advertise, groups to join and people to play Rust with!","over18":false},"MoundofVenus":{"lang":"en","description":"Images of the Mound of Venus, also known as *mons veneris* and *mons pubis*, superb anatomical feature of the human female.","over18":true},"jraywang":{"lang":"en","description":"A sub for 2+ new stories daily, mostly through /r/writingprompts, but can also include bonus stories, continuation of writing prompts, and more!","over18":false},"TeacherTales":{"lang":"en","description":"A subreddit where teachers and can tell about any student, parent, or staff member they had the pleasure or displeasure of meeting. Students may also participate by telling stories about teachers.","over18":false},"USHistory":{"lang":"en","description":"","over18":false},"Milovana":{"lang":"en","description":"A subreddit devoted to sexual webteases including those from the site [Milovana](http://milovana.com).  All types of teases are welcome!\n","over18":true},"hodor":{"lang":"en","description":"Hodor?","over18":false},"SFBayJobs":{"lang":"en","description":"SF Bay Jobs - [Hiring], [Seeking]","over18":false},"Startup_Ideas":{"lang":"en","description":"This subreddit is for sharing innovative startup ideas. Links and discussion about startups and descriptions of startups are welcome! Share ideas. Improve ideas. Expand upon other ideas. Combine ideas","over18":false},"juxtaposition":{"lang":"en","description":"","over18":false},"SquareEnix":{"lang":"en","description":"This is a sub-reddit dedicated to all things Square Enix and companies now owned by SE including Eidos Interactive and Taito Corp. Final Fantasy, Kingdom Hearts, Deus Ex, Hitman, Tomb Raider, iOS, And","over18":false},"NSFW_Plowcam":{"lang":"en","description":"That one angle you can barely find in porn but everyone loves. ","over18":true},"Lost_Architecture":{"lang":"en","description":"r/Lost_Architecture, is a subreddit devoted to images and discussion of interesting buildings that no longer exists.","over18":false},"funsizedasian":{"lang":"en","description":"Snickers bars, gumdrops, and your very own Asian <3","over18":true},"runningmusic":{"lang":"en","description":"/r/running, Enjoy your favorite Running Music and Discover New Music to Run to!","over18":false},"slightlychubby":{"lang":"en","description":"The place for soft-bodied women everywhere","over18":true},"Snek":{"lang":"en","description":"snekkkkkssss (also dragonsss are cool)","over18":false},"lgbtaww":{"lang":"en","description":"Just like r/Aww but with LGBTs in mind.","over18":false},"GifsOfRemoval":{"lang":"en","description":"Gifs of gorgeous women showing what they've got!","over18":true},"DirtySnapChatPals":{"lang":"en","description":"","over18":true},"SciFiRealism":{"lang":"en","description":"The future of everyday life. Science fiction meets Realism!","over18":false},"meta":{"lang":"en","description":"","over18":false},"ImaginaryStarscapes":{"lang":"en","description":"Art featuring nebula, stars, and other celestial wonders.","over18":false},"meth":{"lang":"en","description":"A place for discussion of the lucrative methamphetamine. Perfect for when you've been hitting the pipe 72 hours straight and you're looking to post a life memoir.","over18":false},"sweatermeat":{"lang":"en","description":"Term used to describe the female breasts under a form fitting sweater, preferably a tight turtleneck made of cashmere or merino wool.","over18":true},"monkslookingatbeer":{"lang":"en","description":"A place to post your favorite pictures of monks looking at beer","over18":false},"SuicideSquad":{"lang":"en","description":"All Things Suicide Squad","over18":false},"MissingPersons":{"lang":"en","description":"A subreddit for all things related to missing people and their cases.","over18":false},"normaldayinjapan":{"lang":"en","description":"Typical everyday Japan stuff. ","over18":false},"Crowdfunding":{"lang":"en","description":"A forum for discussing crowdfunding. **This is NOT the place to advertise your project.**\n\nPosts advertising projects will be marked as spam. If you want to post advertising on reddit, consider going ","over18":false},"aww_gifs":{"lang":"en","description":"Post your cute gifs! Animal, baby, it doesn't matter.","over18":false},"pronebone":{"lang":"en","description":"Pronebone - the best sex position!","over18":true},"TheFutureIsNow":{"lang":"en","description":"Showcasing futuristic technology, style, design, and trends that are available now, including working prototypes","over18":false},"starwarsnsfw":{"lang":"en","description":"","over18":true},"MouthWideOpen":{"lang":"en","description":"","over18":true},"beyonce":{"lang":"en","description":"Bey, Queen, our R&B princess. Whatever you call her, this is *the* place to be on Reddit for everything Beyoncé.","over18":false},"AngelaWhite":{"lang":"en","description":"Angela White's home on reddit","over18":true},"PiercedNSFW":{"lang":"en","description":"","over18":true},"MyCherryCrush":{"lang":"en","description":"The official subreddit of the delicious adult model Cherry Crush.","over18":true},"PsychologicalTricks":{"lang":"en","description":"The psychological tricks that work.","over18":false},"tbulges":{"lang":"en","description":"Tgirls, Traps, CDs, Femboys that have a bulge in their panties, bikini etc.","over18":true},"silentmoviegifs":{"lang":"en","description":"Celebrating silent movies by making GIFs out of them","over18":false},"KarmaStore":{"lang":"en","description":"","over18":false},"Funko":{"lang":"en","description":"Share and engage in the latest Funko products and news!","over18":false},"ddlg":{"lang":"en","description":"An 18+ subreddit dedicated to those in the DD/lg (Daddy Dom/little girl BDSM dynamic) community. Caregivers, littles, switches, and anyone curious are welcome here to share pictures, videos, start dis","over18":true},"candy":{"lang":"en","description":"Join us at /r/candy! All Sweet Teeth and Chocoholics are Welcomed!","over18":false},"HIPSTERGURLZ":{"lang":"en","description":"","over18":false},"WholesomeComics":{"lang":"en","description":"Deep dive with comics that will make you feel great about yourself and others! Escape the daily stress with a good hearty comic and come inside, there's plenty of stories for everyone.","over18":false},"TVDetails":{"lang":"en","description":"TVDetails: Interesting and unnoticed details that appear in TV Shows.","over18":false},"nosleepfinder":{"lang":"en","description":"This subreddit was created as a venue for all the requests for help in finding stories that were on /r/nosleep.  If you need help finding a story you read once, but don't remember the title, post here","over18":false},"spreading":{"lang":"en","description":"Spread Wide Open.","over18":true},"insideJorahshead":{"lang":"en","description":"What is going on inside the brave, manly head of Ser Jorah Mormont, former head of House Mormont and Lord of Bear Island? \n\nWhat thoughts cross his mind when his gentle, soothing, deep blue eyes rest ","over18":false},"allrages":{"lang":"en","description":"","over18":false},"KindleFreebies":{"lang":"en","description":"We love links to free Kindle eBooks. We appreciate all genres from non-fiction to sci-fi to romance. As long as it's a 100% free Kindle eBook, it belongs here.\n\n**Make sure you check out the other fre","over18":false},"vargas":{"lang":"en","description":"A subreddit by /u/_vargas_, for /u/_vargas_. ","over18":false},"OddlyArousing":{"lang":"en","description":"Does it have luscious curves? Does it jiggle or move smoothly? Does it look like it might be bursting with pleasure? \n\nDoes it give you that familiar tingling sensation of arousal, even though it isn'","over18":false},"SiegeTeams":{"lang":"en","description":"","over18":false},"FunWithFriends":{"lang":"en","description":"This sub is for images/gifs/videos of friends having NSFW fun watching/participating. It's for TRUE amateur/homemade content, often filmed with a potato.","over18":true},"internships":{"lang":"en","description":"A place to find and post internships.","over18":false},"PremiumSnapReviews":{"lang":"en","description":"Too often people buy premium Snapchat accounts only to find that the user doesn't actually post that much, posts underwhelming content, doesn't post what they said they would, or that they are a scamm","over18":false},"JustFitnessGirls":{"lang":"en","description":"Motivational Videos, Fitness Models & just Beautiful Sporty Girls.","over18":true},"JustOneBoob":{"lang":"en","description":"Everything that shows just one bare boob.","over18":true},"DigitalMarketing":{"lang":"en","description":"A place for digital marketers to come together to have professional conversations on all things marketing.\n\nNo promotional posts. This rule will be strictly enforced.","over18":false},"DrinkingGames":{"lang":"en","description":"Discuss and create all the Drinking Games.","over18":false},"censorship":{"lang":"en","description":"","over18":false},"TwinGirls":{"lang":"en","description":"Beautiful clones with compromised morals. ","over18":true},"NotTimAndEricPics":{"lang":"en","description":"This is subreddit for images that are similar to content that could be found on the Tim and Eric show.","over18":false},"TokeSpot":{"lang":"en","description":"Post your favorite toke spots. Discussions about different types of toking locations is encouraged as well.","over18":false},"lowpoly":{"lang":"en","description":"","over18":false},"Isis":{"lang":"en","description":"All about ISIS and the ongoing conflict in which it is involved worldwide.","over18":false},"vagina":{"lang":"en","description":"","over18":true},"FitToFat":{"lang":"en","description":"/r/FitToFat is a place for sharing \"reverse progress pictures.\" Submission requirements are lax, but do make sure that a marked transition from fit to fat is shown. ","over18":false},"cutekids":{"lang":"en","description":"What it says on the tin: a place to post pics of cute kids. An r/aww for human children.","over18":false},"comics18_story":{"lang":"en","description":"adult comics with a story to tell","over18":true},"humorousreviews":{"lang":"en","description":"This is a place for any and every online (or offline) product review that makes you chuckle, cringe, or remember just how \"creative\" some people truly are.","over18":false},"bestofcraigslist":{"lang":"en","description":"The place to submit all the funny, crazy, and WTF things that you see on Craigslist. ","over18":false},"noir":{"lang":"en","description":"In this subreddit you can post anything remotely related to noir and neo-noir. May it be film, drawings, books, music, clothes, people, et cetera. All are welcomed.","over18":false},"BaileyJay":{"lang":"en","description":"All about the Transsexual SuperStar Bailey Jay ","over18":true},"DIYfail":{"lang":"en","description":"Perfectly good ideas executed... poorly","over18":false},"TheSquadOnPoint":{"lang":"en","description":"When your squad on point.","over18":false},"betakeys":{"lang":"en","description":"Collective place to share beta keys and sign ups for the various game titles having beta testing.","over18":false},"softwaredevelopment":{"lang":"en","description":"Software development methodologies, techniques, and tools. Not to be confused with programming. Covering Agile, RUP, Waterfall, Crystal, Extreme Programming, Scrum, Lean, Kanban and more.","over18":false},"DickSlips":{"lang":"en","description":"A place to post picture of dicks slipping out into view. Accidental nudity and public exhibition of nudity, or near nudity, is good enough. Visible penis lines go to /r/Bulges ","over18":true},"fsm":{"lang":"en","description":"","over18":false},"modernromantics":{"lang":"en","description":"Hi I'm comedian Aziz Ansari. I'm working on a book about modern romance and wanted to reach out to the reddit community to share their experiences. I've read and been told many interesting stories tha","over18":false},"moviemusic":{"lang":"en","description":"Ever watched a movie and couldn't get the soundtrack out of your head? Or heard a movie soundtrack that was so incredibly amazing that you just had to share it? YOU'VE FOUND THE RIGHT PLACE!\n\nHere, yo","over18":false},"Threesome":{"lang":"en","description":"","over18":true},"BubbleButts":{"lang":"en","description":"For booty and bubble butts\n\nnsfw","over18":true},"rawcelebs":{"lang":"en","description":"","over18":true},"animalssmiling":{"lang":"en","description":"A subreddit for smiling animals.","over18":false},"chicagojobs":{"lang":"en","description":"","over18":false},"Gloryholes":{"lang":"en","description":"","over18":true},"replayhut":{"lang":"en","description":"","over18":false},"ABDLPersonals":{"lang":"en","description":"This is a place to post or find like minded people interested in all things related to Age Play, Adult Diapers/Nappies, Diaper Lovers and Adult Baby. Please be respectful of other people, failure to d","over18":true},"mildyinfuriating":{"lang":"en","description":"","over18":false},"socialscience":{"lang":"en","description":"The social sciences comprise academic disciplines concerned with the study of the social life of human groups and individuals including anthropology, communication studies, economics, human geography,","over18":false},"Stardew_Valley":{"lang":"en","description":"Go to /r/StardewValley, this is the wrong subreddit","over18":false},"mintuit":{"lang":"en","description":"A place to discuss the Mint.com budgeting suite","over18":false},"gag_spit":{"lang":"en","description":"Girls doing what we love most; choking on dick and letting the gag spit flow.","over18":true},"kilian":{"lang":"en","description":"The world is too damn serious. This is the Kilian Experience. \nComedic game reviews that makes you think about the meaning of life. Home of the Garbage Series.","over18":false},"before_after_cumsluts":{"lang":"en","description":"Ever wondered what a girl looked like before that cumshot? Now you don't have to! Here is your one stop shop for all your before/after cumshot needs! ","over18":true},"palletfurniture":{"lang":"en","description":"A subreddit dedicated to exploring mankind's contemporary love affair with the humble and versatile pallet, and what can be achieved with them. Desks, chairs, garden furniture - you name it. Your tool","over18":false},"WeddingsGoneWild":{"lang":"en","description":"Weddings Gonewild - Sexy wedding photos and videos. Brides getting dressed, bridesmaids getting naughty and more.","over18":true},"amateur_milfs":{"lang":"en","description":"Daylie fresh pictures of horny MILFs, Matures and Cougars. Amateur pics, camshots and hot selfies of girls and women.","over18":true},"sims":{"lang":null,"description":"Subreddit forbidden","over18":null},"cfnm":{"lang":"en","description":"Clothed Female Nude Male","over18":true},"mensfashion":{"lang":"en","description":"Talk about menswear—news, styles, trends, and gear. ","over18":false},"war":{"lang":"en","description":"Warfare — its history, present and future. Discussions of battlefields, weapons, tactics, strategy, organization and logistics. Coups, operations, insurgencies and counterinsurgencies.","over18":false},"DatBoi":{"lang":"en","description":"oh shit its dat boi / \"frog on a circle bike thing\" - Shakespeare 1990","over18":false},"nba2k17":{"lang":"en","description":"Anything and everything about NBA 2K17.","over18":false},"boobgifs":{"lang":"en","description":"Gifs. Of Boobs.","over18":true},"net_neutrality":{"lang":"en","description":"Here to save net neutrality\n\nPlease click the profile /u/agentpao and then hit the follow button.\n\n/u/agentpao will be your voice and your champion but you need to follow .\n\n\n\nAgent Pao\n\nAjent Pao\n\nAj","over18":false},"sploot":{"lang":"en","description":"Welcome to /r/Sploot! We are a community dedicated to animals posing with their arms/legs stretched out, which is also referred to as \"frogging\" by some people.","over18":false},"DarkNetDeals":{"lang":null,"description":"Subreddit no longer exists","over18":null},"13or30":{"lang":"en","description":"People who look multiple ages","over18":false},"scholarships":{"lang":"en","description":"Looking for scholarships? This subreddit lists opportunities for **U.S. students** who are seeing free money for college. Come back often, as we frequently add new scholarships to our growing list of ","over18":false},"crazystairs":{"lang":"en","description":"Stairs, staircases, even escalators and ramps! Sometimes dangerous, often abandoned, always interesting.","over18":false},"rockstar":{"lang":"en","description":"The unofficial subreddit of Rockstar Games. ","over18":false},"longstabbything":{"lang":"en","description":"A subreddit for anything relating to wild TV show host Karl Stefanovic, who is best known for his videos **long stabby thing** and for being really drunk one morning on air.\n\n**[Long Stabby Thing](htt","over18":false},"wtfdidijustread":{"lang":"en","description":"A place to post REALLY WTF comments.\n\nHave you ever found a comment or self post that made you say \"What the fuck did I just read...\" and wanted to share it with the world? Well then this is the place","over18":false},"Scary":{"lang":"en","description":"/R/Scary is a subreddit for scary things!","over18":false},"iphonewallpapers":{"lang":"en","description":"","over18":false},"EmilyBloom":{"lang":"en","description":"A subreddit dedicated to the beautiful Emily Bloom","over18":true},"nycpics":{"lang":"en","description":"","over18":false},"cuckquean":{"lang":"en","description":"Pics, gifs, and vids of of men having sex with women other than their wife/girlfriend. The woman should be present and less than pleased (at least initially).  \n","over18":true},"pimpcats":{"lang":"en","description":"Who you calling a pussy?","over18":false},"tilwtf":{"lang":"en","description":"What did you learn today that made you go, \"WTF\"?","over18":false},"AnimalsBeingGeniuses":{"lang":"en","description":"They are getting smarter. Let the proof be shown!","over18":false},"multihub":{"lang":"en","description":"Your one-stop shop for all the multireddits!  Easily searchable and organized by category!\n\nCheck out our Wiki for the most complete list of subreddits available.","over18":false},"NSFW_Tributes":{"lang":"en","description":"Offering Cock/Cum tributes.","over18":true},"stolendogbeds":{"lang":"en","description":"","over18":false},"girlsinleggings":{"lang":"en","description":"Pics/Videos of girls in leggings","over18":true},"TraditionalCurses":{"lang":"en","description":"An invitation to post curses.\n\nA curse (also called a jinx, hex or execration) is any expressed wish that some form of adversity or misfortune will befall or attach to some other entity—one or more pe","over18":false},"WoahTube":{"lang":"en","description":"The best VIDEOS to watch while you're STONED!\n\nTrippy & mesmerizing videos that make you go 'woah dude!'","over18":false},"SWTORGuilds":{"lang":"en","description":"","over18":false},"txs":{"lang":"en","description":"Welcome to TxS, the official world boss slayer alliance for daily EU Tequatl/Wurm Runs. Important! You can't join us if you are playing on a US server; if you are on a US server, please have a look at","over18":false},"lesdom":{"lang":"en","description":"For all things girl on girl domination, such as forced lesbian, forced bi or just general lesbian domination/femdom. ","over18":true},"InvisibleBicycles":{"lang":"en","description":"A place to post pictures of people riding invisible bicycles!","over18":false},"SluttyHalloween":{"lang":"en","description":"The name says it all. Posts pictures of girls in their scanty halloween finery.","over18":true},"HereComesTheBoom":{"lang":"en","description":"Hard hits during sporting events","over18":false},"Feels":{"lang":"en","description":"We're an EXCLUSIVE emotional sub featuring the BEST in emotional content! Grab that box of tissues cause you'll need them.\n","over18":false},"GirlsWearingVS":{"lang":"en","description":"A subreddit dedicated to any and all girls wearing Victoria's Secret lingerie and clothing.","over18":true},"reverseanimalrescue":{"lang":"en","description":"A subreddit dedicated to reversing gifs to make it look like animals/People in them are being put into dangerous situations.","over18":false},"twerking":{"lang":"en","description":"MAKE DAT ASS CLAP","over18":true},"UrbanMyths":{"lang":"en","description":"Do you believe in **Bigfoot**? how about **Slenderman**? do you know who the **Slit-Mouth Woman** is? /r/urbanmyths is a subreddit dedicated to anything and everything Urban-Myth associated.","over18":false},"kittengifs":{"lang":"en","description":"The best place for all your kitten watching needs. ","over18":false},"Portlandia":{"lang":"en","description":"Portlandia, the sketch comedy TV show set in Portland, Oregon. ","over18":false},"promote":{"lang":"en","description":"","over18":false},"hawwkey":{"lang":"en","description":"","over18":false},"phantoml0rd":{"lang":"en","description":"Subreddit for all things PhantomL0rd!","over18":false},"hackers":{"lang":null,"description":"Subreddit forbidden","over18":null},"workout":{"lang":"en","description":"","over18":false},"realitydicks":{"lang":"en","description":"Average penises in a pornographic context","over18":true},"DiabloClans":{"lang":"en","description":"Just post your topics in /r/Diablo instead.","over18":false},"redhead":{"lang":"en","description":"A subreddit dedicated for pictures of redhead girls :)","over18":true},"nonose":{"lang":"en","description":"","over18":false},"girlsdoingnerdythings":{"lang":"en","description":"A place for photos of girls doing nerdy stuff. Examples: Playing videogames, using a computer, cosplaying, etc. Dressed or undressed is fine. We don't care about whether or not the girl is actually a ","over18":true},"csgo_trade":{"lang":"en","description":"","over18":false},"dontlookdown":{"lang":"en","description":"A subreddit for pictures and videos taken from insane heights. We welcome content that gives you that queasy feeling in your stomach and a tingling sensation in your feet.","over18":false},"AllisonParker":{"lang":null,"description":"Subreddit no longer exists","over18":null},"videogamescience":{"lang":"en","description":"Posts about from UI design, game engine physics, how components were made, and anything else regarding the real science of video games!","over18":false},"DumpsterSluts":{"lang":"en","description":"**Dumpster Sluts**, drunk sluts, cum sluts, All Slutty attitude inside","over18":true},"Fapstronauts":{"lang":null,"description":"Subreddit forbidden","over18":null},"TheCatTrapIsWorking":{"lang":"en","description":"Cats in boxes","over18":false},"lookingforgroup":{"lang":"en","description":"","over18":false},"Miniworlds":{"lang":"en","description":"For the tiny places you discover (or make) that look like they could be a world of their own.","over18":false},"doublelift":{"lang":"en","description":"meme city","over18":false},"catsvstechnology":{"lang":"en","description":"","over18":false},"IncestPersonals":{"lang":null,"description":"Subreddit forbidden","over18":null},"antibaw":{"lang":"en","description":"","over18":false},"PussyMound":{"lang":"en","description":"A subreddit where people can post and view pictures of those beautiful pussy bumps.","over18":true},"Entrepreneurship":{"lang":"en","description":"","over18":false},"truecreepyPMs":{"lang":"en","description":"A subreddit for posting funny private messages you get from trolls or socially awkward people on Reddit and other websites.","over18":false},"FuckMyShitUp":{"lang":"en","description":"This subreddit is for haircuts so ridiculous that they make you wonder how it happened or what the customer even said to be granted with such a hairstyle. The customer obviously told the barber to jus","over18":false},"cougars":{"lang":"en","description":"","over18":true},"Cloud":{"lang":"en","description":"All about Cloud Computing!!!","over18":false},"DSLs":{"lang":"en","description":"For girls born with lips simply made for sucking dicks. DSLs. Blowjob lips.\n\n","over18":true},"UsernamesIllustrated":{"lang":"en","description":"","over18":false},"PicsOfDeadKids":{"lang":null,"description":"Subreddit no longer exists","over18":null},"ShittyQuotesPorn":{"lang":"en","description":"The best and worst quotes said by Abraham Lincoln and friends.","over18":false},"VideoPorn":{"lang":"en","description":"High quality videos of the SFWPorn Network subreddits.","over18":false},"r4rplus":{"lang":"en","description":"The 18+ place for plus sized dates and relationships, singles, couples, gay, straight, ALL ARE WELCOME, NO HARASSMENT! Tag your posts appropriately for best results and good luck! ","over18":true},"blowjobsandwich":{"lang":"en","description":"Two heads are better than one.","over18":true},"wifeshare":{"lang":"en","description":"A place to show off how sexy your wife is. ","over18":true},"send_nudes":{"lang":"en","description":"Gifs and Images Requesting Nudes","over18":false},"BreadStapledToTrees":{"lang":"en","description":"Pictures of bread that have been stapled to trees.","over18":false},"BradyHaran":{"lang":"en","description":"Subreddit dedicated to the various videos and other stuff created by  Brady Haran, including Numberphile, Periodic Videos and Sixty Symbols.","over18":false},"Irony":{"lang":"en","description":"***Irony*** is a figure of speech defining an outcome of events which occur in a way that is contrary to what was, or might have been expected.  It can often be funny, but is also characterized in tra","over18":false},"LanguageBuds":{"lang":"en","description":"As language learners we know how hard it is to be able to get a real insight of the language one is learning, so we created this new subreddit for people to help themselves learn languages.","over18":false},"Erotica":{"lang":"en","description":"We, as a community,are welcome to all shapes,sizes and desires! Show us your naughty, your pleasure, your desire and we will fulfill it!!","over18":true},"imgur":{"lang":null,"description":"Subreddit forbidden","over18":null},"bestofTLDR":{"lang":"en","description":"The best TL;DRs of Reddit.","over18":false},"holdmyturban":{"lang":"en","description":"post news, video, or pictures of strange or out of the ordinary things from the mid east","over18":true},"makingfriends":{"lang":"en","description":"","over18":false},"metarage":{"lang":"en","description":"","over18":false},"MinimalWallpaper":{"lang":"en","description":"Wallpapers that have a simple and minimalist design. ","over18":false},"Home":{"lang":"en","description":"","over18":false},"enf":{"lang":"en","description":"","over18":true},"creampiegifs":{"lang":"en","description":"A place to share GIFs of women getting creampied.","over18":true},"ffx":{"lang":"en","description":"This is a subreddit for all things Final Fantasy X.  This includes comics or pictures, new and exciting ways to play the game, or just any discussion you want to have about the game.  Anything goes, a","over18":false},"untrustworthypoptarts":{"lang":"en","description":"We know you staged that photo, OP.","over18":false},"GTAorRussia":{"lang":"en","description":"Is this GTA or Russia ?","over18":false},"t:1990s":{"lang":"en","description":"","over18":false},"TrollingAnimals":{"lang":"en","description":"Where Animals are the ones getting trolled!","over18":false},"BadRocketLeagueGoals":{"lang":"en","description":"","over18":false},"CucumbersScaringCats":{"lang":"en","description":"Cucumbers scare cats, apparently.","over18":false},"FoggyPics":{"lang":"en","description":"","over18":false},"Facials":{"lang":"en","description":"","over18":true},"whitepeoplefacebook":{"lang":"en","description":"Down-home folks on social media.","over18":false},"PimpYourMomForKarma":{"lang":"en","description":"Anything to milk that last drop of karma from dear old mom!","over18":false},"deepseacreatures":{"lang":"en","description":"View and submit posts containing the wonderful, dark, and largely unknown world in the deepest depths of our oceans. ","over18":false},"StreetArtPorn":{"lang":"en","description":"Street Art Porn: a subreddit for any kind of art that can be seen from the street or in an urban setting. It can be graffiti, a sicker, a stenciling, sidewalk chalk/painting, a mural on the side of a ","over18":false},"AnimalsBeingConfused":{"lang":"en","description":"A place for sharing videos, gifs, and images of animals being confused.","over18":false},"CuckoldPersonals":{"lang":"en","description":"","over18":true},"HumansAreMetal":{"lang":"en","description":"People doing badass and impressive things. ","over18":false},"textdoor":{"lang":"en","description":"Send a message to your text door neighbor and post it here.","over18":false},"mymusic":{"lang":"en","description":"The musical promotion subreddit. Post here your band, your best tune, or your promotion tips. \n\n","over18":false},"snapchat_nudes":{"lang":"en","description":"Share your own nudes or find others to trade with.","over18":true},"SurrealGifs":{"lang":"en","description":"A Subreddit for gifs that are all a bit surreal. If it moves and is weird, this is the place for it. ","over18":false},"TalesofPrivilege":{"lang":"en","description":"A place to post your tales of privilege. No matter the kind. ","over18":false},"faceswap":{"lang":"en","description":"","over18":false},"shareyourmusic":{"lang":"en","description":"A subreddit for new and upcoming musicians to share their music and a place for listeners to discover, give feedback and support new bands.","over18":false},"ello2":{"lang":"en","description":"A subreddit dedicated to the social network Ello. It's called Ello2 because r/ello is already taken and set to private. I'll probably regret the name in the long-run, but oh well. (If an Ello subreddi","over18":false},"MasterReturns":{"lang":"en","description":"A subreddit dedicated to videos and pictures of dogs (and other pets!) being reunited with their owners after and extended absence! We consider these to be some of the best videos on the internet and ","over18":false},"Random_Acts_Of_Sex":{"lang":"en","description":"Whether you have some pent up sexual energy or want to fulfill something on your fuck-it list, Random_Acts_Of_Sex is here for you. All are welcome.","over18":true},"FittitBuddy":{"lang":"en","description":"","over18":false},"lookwhoimet":{"lang":"en","description":"A place to show where you, who you, and when you saw a celebrity or important figure.","over18":false},"Lilwa_Dexel":{"lang":"en","description":"Welcome to Lilwa's Little Library!","over18":false},"piratebay":{"lang":"en","description":"www.thepiratebay.se","over18":false},"BirdsForScale":{"lang":"en","description":"Art where birds give scale or perspective to the size of the subject.","over18":false},"palatecleanser":{"lang":"en","description":"Wash horrors found on the internet from your mind!","over18":false},"Ellenpaohate":{"lang":"en","description":"Is reddit over?","over18":false},"killthecameraman":{"lang":"en","description":"The sub for sideways recordings, cameramen with parkinson, videos with horible focus or where the cameraman has an zoom fetish. Here you can see videos of interesting/entertaining things but the camer","over18":false},"amateurgirlsbigcocks":{"lang":"en","description":"Amateur Girls and Big Cocks","over18":true},"ImSavingUpForThis":{"lang":"en","description":"Stuff you've wanted for awhile, but haven't had the money to buy.\n\n","over18":false},"revolution":{"lang":"en","description":"","over18":false},"OralCreampie":{"lang":"en","description":"Oral Creampies - Cumming in the mouth. ","over18":true},"braceface":{"lang":"en","description":"Photos of girls with braces, no jailbait. Nude or non nude girls (18+ only)","over18":true},"naturaltitties":{"lang":"en","description":"A subreddit dedicated to the pursuit of finding the most exquisite collection of natural titties the internet has to offer!  ","over18":true},"Presenting":{"lang":"en","description":"\"The act of directing the hindquarters toward another individual, either in sexual solicitation or as a gesture of appeasement derived from sexual presenting.\" (Estes, 1991)","over18":true},"features":{"lang":"en","description":"For US news there is /r/news, for world news there is /r/worldnews, but what about deep and interesting feature articles? Welcome to /r/features, an evolving SubReddit for high-quality and evocative l","over18":false},"howimetyourmother":{"lang":"en","description":"About the show How I met Your Mother","over18":false},"dirndls":{"lang":"en","description":"A sub for dirndls and the women who wear them.\n\nA dirndl is a type of traditional dress worn in Germany, especially Bavaria; Austria; and the South Tyrol, based on the traditional clothing of Alps pea","over18":false},"XXX_Animated_Gifs":{"lang":"en","description":"XXX Animated Gifs","over18":true},"mmgirls":{"lang":"en","description":"Girls masturbating with other girls","over18":true},"Hearthstonekeys":{"lang":"en","description":"Hey all, got a spare Hearthstone beta key that you don't want or need? \n\nThis is the place to come to host a giveaway! Due to obvious reasons (the same reasons giveaways were banned from /r/hearthston","over18":false},"Goatparkour":{"lang":"en","description":"The Best Goat Parkour!","over18":false},"snoovatars":{"lang":"en","description":"A place to post your snoovatar, discuss the project and make suggestions on items to be included.","over18":false},"Annoyedtobenude":{"lang":"en","description":"Pictures of girls who look annoyed or ashamed to be in a state of undress.  No Bondage pics: there is already a subreddit for that.  ","over18":true},"nsfw_snapchat_share":{"lang":null,"description":"Subreddit no longer exists","over18":null},"Breakfast":{"lang":"en","description":"","over18":false},"bestofcollege":{"lang":"en","description":"Hottest college sluts","over18":true},"Tay_Tweets":{"lang":"en","description":"Tay is an artificial intelligent chat bot developed by Microsoft's Technology and Research and Bing teams to experiment with and conduct research on conversational understanding. Tay is designed to en","over18":false},"TheUnderboob":{"lang":"en","description":"We celebrate the legendary underboob. Submit pictures of babes with underboob. Girls with the lower part of the breast hanging out under a (very short) top. Big boobs or small tits, anyone can do it!\n","over18":true},"GamingDetails":{"lang":"en","description":"GamingDetails: Interesting and unnoticed details that appear in games.","over18":false},"CreepyAskredditBot":{"lang":"en","description":"I made this bot because I love all things creepy and Askreddit was a good source of these type of stories. I am a beginner coder and since Ive always wanted someone to do a similar tool I decided to t","over18":false},"ExplainLikeImPHD":{"lang":"en","description":"Common questions to be answered in terms that only a PHD student could understand.","over18":false},"treecaching":{"lang":"en","description":"Love trees? How about treasure hunting? \n\nWhy not bring them together with Tree Caching!\n\n","over18":false},"peopleofwalmart":{"lang":"en","description":"","over18":false},"redditdonate":{"lang":"en","description":"The official reddit donate forum!\n\n\n","over18":false},"RisingThreads":{"lang":"en","description":"We've decided to go private as a fundraiser. You can get access to the subreddit by [messaging the mods](http://www.reddit.com/message/compose?to=%2Fr%2FRisingThreads) to show that you've made a donat","over18":false},"HoldMyNip":{"lang":"en","description":"/r/holdmycatnip ","over18":false},"SubtleNudity":{"lang":null,"description":"Subreddit forbidden","over18":null},"NobodyAsked":{"lang":"en","description":"A sub for people who were never asked and yet, still explained far too much.","over18":false},"HOTandTRENDING":{"lang":null,"description":"Subreddit no longer exists","over18":null},"adultgifs":{"lang":"en","description":"This subreddit is intended for scenes from adult movies/video clips that make good animated gifs for quick viewing.","over18":true},"BlancNoir":{"lang":"en","description":"Subreddit dedicated to BlancNoir aka Missnoir/Tulip","over18":true},"comcastnazi":{"lang":"en","description":"","over18":false},"FirstNameBasis":{"lang":"en","description":"Good luck forgetting the folks in these videos!","over18":false},"WowThisSubExistsNSFW":{"lang":null,"description":"Subreddit forbidden","over18":null},"GOTradeReferences":{"lang":"en","description":"","over18":false},"everything":{"lang":"en","description":"","over18":false},"naughtyfromneglect":{"lang":"en","description":"","over18":true},"request":{"lang":"en","description":"","over18":false},"watchpeoplesurvive":{"lang":"en","description":"r/watchpeoplesurvive is like r/watchpeopledie, but dedicated to people surviving near misses, eg:\n\n- Car accidents\n- Plane crashes\n- Parachute failure\n- Burping instead of spontaneously combusting\n- e","over18":false},"u_Shitty_Watercolour":{"lang":"en","description":"Hello I make shitty watercolour paintings pls follow me","over18":false},"oldbabies":{"lang":"en","description":"","over18":false},"TakeOneStepForward":{"lang":"en","description":"Discovering new and interesting Easter eggs in the world of Google Street View is as easy as taking one step forward","over18":false},"NamFlashbacks":{"lang":"en","description":"Nam","over18":false},"Animalsthatlovemagic":{"lang":"en","description":"Have an animal surprised by a magic trick, funny reaction to a trick or some great tomfoolery?! Share it here!","over18":false},"ErinAshford":{"lang":"en","description":"Make sure you subscribe to see all my posts :)\n","over18":true},"Snapchatsexting":{"lang":null,"description":"Subreddit forbidden","over18":null},"PlayfulPikachu":{"lang":"en","description":"","over18":true},"Watch_Me_Ban_You":{"lang":"en","description":"","over18":false},"happycryingdads":{"lang":"en","description":"Post reactions to stuff that make dads cry tears of happiness.","over18":false},"Word_Analyzer":{"lang":"en","description":"Questions? Comments? Requests to analyze your comments? I'll try to work in as many requests as possible, but it's \"manual\" for me so please don't hate me if I don't get to your request!","over18":false},"CiciKicks":{"lang":"en","description":"We're from chian,We are selling different brands luxuries with highest quality and most competitive price. Please just feel free to contact us if you need anyting.  . Subscribe to my subreddit and I w","over18":false},"Shopping":{"lang":"en","description":"This reddit is for sharing cool things and deals that you can purchase.\n\nWhether it’s something that you own, you want to rave about or just happen to stumble across something really cool, please subm","over18":false},"barkour":{"lang":"en","description":"Dogs doing parkour","over18":false},"wc2010_crests":{"lang":"en","description":"","over18":false},"PigJargon":{"lang":"en","description":"","over18":false}}

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_request__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_request___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_request__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var serverUri='http://ec2-35-183-185-93.ca-central-1.compute.amazonaws.com/';//let serverUri = 'http://localhost:3001/';
var UserScoreShared=function(){function UserScoreShared(){_classCallCheck(this,UserScoreShared);}_createClass(UserScoreShared,null,[{key:'loadUserScores',value:function loadUserScores(dataset,n,callback){var url=serverUri+"user_score_quiz/"+dataset+"/get_random";var results=[];var allUserIds=[];var handler=function handler(error,response,body){var user=JSON.parse(body);if(allUserIds.indexOf(user.item_id)==-1){allUserIds.push(user.item_id);results.push(user);}if(results.length<n){__WEBPACK_IMPORTED_MODULE_0_request___default()(url,handler);}else{// Done!
callback(results);}};__WEBPACK_IMPORTED_MODULE_0_request___default()(url,handler);}},{key:'submitResponses',value:function submitResponses(dataset,name,responses,points,callback){var url=serverUri+"user_score_quiz/submit_responses";__WEBPACK_IMPORTED_MODULE_0_request___default.a.post(url,{form:{responses:JSON.stringify(responses),points:points,name:name}},function(error,response,body){body=JSON.parse(body);callback(body);});}},{key:'loadLeaderboard',value:function loadLeaderboard(browserId,callback){var url=serverUri+"user_score_quiz/leaderboard?browser_id="+browserId;__WEBPACK_IMPORTED_MODULE_0_request___default()(url,function(error,response,body){body=JSON.parse(body);callback(body);});}}]);return UserScoreShared;}();/* harmony default export */ __webpack_exports__["a"] = (UserScoreShared);

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright 2010-2012 Mikeal Rogers
//
//    Licensed under the Apache License, Version 2.0 (the "License");
//    you may not use this file except in compliance with the License.
//    You may obtain a copy of the License at
//
//        http://www.apache.org/licenses/LICENSE-2.0
//
//    Unless required by applicable law or agreed to in writing, software
//    distributed under the License is distributed on an "AS IS" BASIS,
//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//    See the License for the specific language governing permissions and
//    limitations under the License.



var extend = __webpack_require__(61)
var cookies = __webpack_require__(87)
var helpers = __webpack_require__(63)

var paramsHaveRequestBody = helpers.paramsHaveRequestBody

// organize params for patch, post, put, head, del
function initParams (uri, options, callback) {
  if (typeof options === 'function') {
    callback = options
  }

  var params = {}
  if (typeof options === 'object') {
    extend(params, options, {uri: uri})
  } else if (typeof uri === 'string') {
    extend(params, {uri: uri})
  } else {
    extend(params, uri)
  }

  params.callback = callback || params.callback
  return params
}

function request (uri, options, callback) {
  if (typeof uri === 'undefined') {
    throw new Error('undefined is not a valid uri or options object.')
  }

  var params = initParams(uri, options, callback)

  if (params.method === 'HEAD' && paramsHaveRequestBody(params)) {
    throw new Error('HTTP HEAD requests MUST NOT include a request body.')
  }

  return new request.Request(params)
}

function verbFunc (verb) {
  var method = verb.toUpperCase()
  return function (uri, options, callback) {
    var params = initParams(uri, options, callback)
    params.method = method
    return request(params, params.callback)
  }
}

// define like this to please codeintel/intellisense IDEs
request.get = verbFunc('get')
request.head = verbFunc('head')
request.options = verbFunc('options')
request.post = verbFunc('post')
request.put = verbFunc('put')
request.patch = verbFunc('patch')
request.del = verbFunc('delete')
request['delete'] = verbFunc('delete')

request.jar = function (store) {
  return cookies.jar(store)
}

request.cookie = function (str) {
  return cookies.parse(str)
}

function wrapRequestMethod (method, options, requester, verb) {
  return function (uri, opts, callback) {
    var params = initParams(uri, opts, callback)

    var target = {}
    extend(true, target, options, params)

    target.pool = params.pool || options.pool

    if (verb) {
      target.method = verb.toUpperCase()
    }

    if (typeof requester === 'function') {
      method = requester
    }

    return method(target, target.callback)
  }
}

request.defaults = function (options, requester) {
  var self = this

  options = options || {}

  if (typeof options === 'function') {
    requester = options
    options = {}
  }

  var defaults = wrapRequestMethod(self, options, requester)

  var verbs = ['get', 'head', 'post', 'put', 'patch', 'del', 'delete']
  verbs.forEach(function (verb) {
    defaults[verb] = wrapRequestMethod(self[verb], options, requester, verb)
  })

  defaults.cookie = wrapRequestMethod(self.cookie, options, requester)
  defaults.jar = self.jar
  defaults.defaults = self.defaults
  return defaults
}

request.forever = function (agentOptions, optionsArg) {
  var options = {}
  if (optionsArg) {
    extend(options, optionsArg)
  }
  if (agentOptions) {
    options.agentOptions = agentOptions
  }

  options.forever = true
  return request.defaults(options)
}

// Exports

module.exports = request
request.Request = __webpack_require__(266)
request.initParams = initParams

// Backwards compatibility for request.debug
Object.defineProperty(request, 'debug', {
  enumerable: true,
  get: function () {
    return request.Request.debug
  },
  set: function (debug) {
    request.Request.debug = debug
  }
})


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * Copyright (c) 2015, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

var net = __webpack_require__(30);
var urlParse = __webpack_require__(16).parse;
var util = __webpack_require__(5);
var pubsuffix = __webpack_require__(89);
var Store = __webpack_require__(90).Store;
var MemoryCookieStore = __webpack_require__(179).MemoryCookieStore;
var pathMatch = __webpack_require__(92).pathMatch;
var VERSION = __webpack_require__(180).version;

var punycode;
try {
  punycode = __webpack_require__(62);
} catch(e) {
  console.warn("tough-cookie: can't load punycode; won't use punycode for domain normalization");
}

// From RFC6265 S4.1.1
// note that it excludes \x3B ";"
var COOKIE_OCTETS = /^[\x21\x23-\x2B\x2D-\x3A\x3C-\x5B\x5D-\x7E]+$/;

var CONTROL_CHARS = /[\x00-\x1F]/;

// From Chromium // '\r', '\n' and '\0' should be treated as a terminator in
// the "relaxed" mode, see:
// https://github.com/ChromiumWebApps/chromium/blob/b3d3b4da8bb94c1b2e061600df106d590fda3620/net/cookies/parsed_cookie.cc#L60
var TERMINATORS = ['\n', '\r', '\0'];

// RFC6265 S4.1.1 defines path value as 'any CHAR except CTLs or ";"'
// Note ';' is \x3B
var PATH_VALUE = /[\x20-\x3A\x3C-\x7E]+/;

// date-time parsing constants (RFC6265 S5.1.1)

var DATE_DELIM = /[\x09\x20-\x2F\x3B-\x40\x5B-\x60\x7B-\x7E]/;

var MONTH_TO_NUM = {
  jan:0, feb:1, mar:2, apr:3, may:4, jun:5,
  jul:6, aug:7, sep:8, oct:9, nov:10, dec:11
};
var NUM_TO_MONTH = [
  'Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'
];
var NUM_TO_DAY = [
  'Sun','Mon','Tue','Wed','Thu','Fri','Sat'
];

var MAX_TIME = 2147483647000; // 31-bit max
var MIN_TIME = 0; // 31-bit min

/*
 * Parses a Natural number (i.e., non-negative integer) with either the
 *    <min>*<max>DIGIT ( non-digit *OCTET )
 * or
 *    <min>*<max>DIGIT
 * grammar (RFC6265 S5.1.1).
 *
 * The "trailingOK" boolean controls if the grammar accepts a
 * "( non-digit *OCTET )" trailer.
 */
function parseDigits(token, minDigits, maxDigits, trailingOK) {
  var count = 0;
  while (count < token.length) {
    var c = token.charCodeAt(count);
    // "non-digit = %x00-2F / %x3A-FF"
    if (c <= 0x2F || c >= 0x3A) {
      break;
    }
    count++;
  }

  // constrain to a minimum and maximum number of digits.
  if (count < minDigits || count > maxDigits) {
    return null;
  }

  if (!trailingOK && count != token.length) {
    return null;
  }

  return parseInt(token.substr(0,count), 10);
}

function parseTime(token) {
  var parts = token.split(':');
  var result = [0,0,0];

  /* RF6256 S5.1.1:
   *      time            = hms-time ( non-digit *OCTET )
   *      hms-time        = time-field ":" time-field ":" time-field
   *      time-field      = 1*2DIGIT
   */

  if (parts.length !== 3) {
    return null;
  }

  for (var i = 0; i < 3; i++) {
    // "time-field" must be strictly "1*2DIGIT", HOWEVER, "hms-time" can be
    // followed by "( non-digit *OCTET )" so therefore the last time-field can
    // have a trailer
    var trailingOK = (i == 2);
    var num = parseDigits(parts[i], 1, 2, trailingOK);
    if (num === null) {
      return null;
    }
    result[i] = num;
  }

  return result;
}

function parseMonth(token) {
  token = String(token).substr(0,3).toLowerCase();
  var num = MONTH_TO_NUM[token];
  return num >= 0 ? num : null;
}

/*
 * RFC6265 S5.1.1 date parser (see RFC for full grammar)
 */
function parseDate(str) {
  if (!str) {
    return;
  }

  /* RFC6265 S5.1.1:
   * 2. Process each date-token sequentially in the order the date-tokens
   * appear in the cookie-date
   */
  var tokens = str.split(DATE_DELIM);
  if (!tokens) {
    return;
  }

  var hour = null;
  var minute = null;
  var second = null;
  var dayOfMonth = null;
  var month = null;
  var year = null;

  for (var i=0; i<tokens.length; i++) {
    var token = tokens[i].trim();
    if (!token.length) {
      continue;
    }

    var result;

    /* 2.1. If the found-time flag is not set and the token matches the time
     * production, set the found-time flag and set the hour- value,
     * minute-value, and second-value to the numbers denoted by the digits in
     * the date-token, respectively.  Skip the remaining sub-steps and continue
     * to the next date-token.
     */
    if (second === null) {
      result = parseTime(token);
      if (result) {
        hour = result[0];
        minute = result[1];
        second = result[2];
        continue;
      }
    }

    /* 2.2. If the found-day-of-month flag is not set and the date-token matches
     * the day-of-month production, set the found-day-of- month flag and set
     * the day-of-month-value to the number denoted by the date-token.  Skip
     * the remaining sub-steps and continue to the next date-token.
     */
    if (dayOfMonth === null) {
      // "day-of-month = 1*2DIGIT ( non-digit *OCTET )"
      result = parseDigits(token, 1, 2, true);
      if (result !== null) {
        dayOfMonth = result;
        continue;
      }
    }

    /* 2.3. If the found-month flag is not set and the date-token matches the
     * month production, set the found-month flag and set the month-value to
     * the month denoted by the date-token.  Skip the remaining sub-steps and
     * continue to the next date-token.
     */
    if (month === null) {
      result = parseMonth(token);
      if (result !== null) {
        month = result;
        continue;
      }
    }

    /* 2.4. If the found-year flag is not set and the date-token matches the
     * year production, set the found-year flag and set the year-value to the
     * number denoted by the date-token.  Skip the remaining sub-steps and
     * continue to the next date-token.
     */
    if (year === null) {
      // "year = 2*4DIGIT ( non-digit *OCTET )"
      result = parseDigits(token, 2, 4, true);
      if (result !== null) {
        year = result;
        /* From S5.1.1:
         * 3.  If the year-value is greater than or equal to 70 and less
         * than or equal to 99, increment the year-value by 1900.
         * 4.  If the year-value is greater than or equal to 0 and less
         * than or equal to 69, increment the year-value by 2000.
         */
        if (year >= 70 && year <= 99) {
          year += 1900;
        } else if (year >= 0 && year <= 69) {
          year += 2000;
        }
      }
    }
  }

  /* RFC 6265 S5.1.1
   * "5. Abort these steps and fail to parse the cookie-date if:
   *     *  at least one of the found-day-of-month, found-month, found-
   *        year, or found-time flags is not set,
   *     *  the day-of-month-value is less than 1 or greater than 31,
   *     *  the year-value is less than 1601,
   *     *  the hour-value is greater than 23,
   *     *  the minute-value is greater than 59, or
   *     *  the second-value is greater than 59.
   *     (Note that leap seconds cannot be represented in this syntax.)"
   *
   * So, in order as above:
   */
  if (
    dayOfMonth === null || month === null || year === null || second === null ||
    dayOfMonth < 1 || dayOfMonth > 31 ||
    year < 1601 ||
    hour > 23 ||
    minute > 59 ||
    second > 59
  ) {
    return;
  }

  return new Date(Date.UTC(year, month, dayOfMonth, hour, minute, second));
}

function formatDate(date) {
  var d = date.getUTCDate(); d = d >= 10 ? d : '0'+d;
  var h = date.getUTCHours(); h = h >= 10 ? h : '0'+h;
  var m = date.getUTCMinutes(); m = m >= 10 ? m : '0'+m;
  var s = date.getUTCSeconds(); s = s >= 10 ? s : '0'+s;
  return NUM_TO_DAY[date.getUTCDay()] + ', ' +
    d+' '+ NUM_TO_MONTH[date.getUTCMonth()] +' '+ date.getUTCFullYear() +' '+
    h+':'+m+':'+s+' GMT';
}

// S5.1.2 Canonicalized Host Names
function canonicalDomain(str) {
  if (str == null) {
    return null;
  }
  str = str.trim().replace(/^\./,''); // S4.1.2.3 & S5.2.3: ignore leading .

  // convert to IDN if any non-ASCII characters
  if (punycode && /[^\u0001-\u007f]/.test(str)) {
    str = punycode.toASCII(str);
  }

  return str.toLowerCase();
}

// S5.1.3 Domain Matching
function domainMatch(str, domStr, canonicalize) {
  if (str == null || domStr == null) {
    return null;
  }
  if (canonicalize !== false) {
    str = canonicalDomain(str);
    domStr = canonicalDomain(domStr);
  }

  /*
   * "The domain string and the string are identical. (Note that both the
   * domain string and the string will have been canonicalized to lower case at
   * this point)"
   */
  if (str == domStr) {
    return true;
  }

  /* "All of the following [three] conditions hold:" (order adjusted from the RFC) */

  /* "* The string is a host name (i.e., not an IP address)." */
  if (net.isIP(str)) {
    return false;
  }

  /* "* The domain string is a suffix of the string" */
  var idx = str.indexOf(domStr);
  if (idx <= 0) {
    return false; // it's a non-match (-1) or prefix (0)
  }

  // e.g "a.b.c".indexOf("b.c") === 2
  // 5 === 3+2
  if (str.length !== domStr.length + idx) { // it's not a suffix
    return false;
  }

  /* "* The last character of the string that is not included in the domain
  * string is a %x2E (".") character." */
  if (str.substr(idx-1,1) !== '.') {
    return false;
  }

  return true;
}


// RFC6265 S5.1.4 Paths and Path-Match

/*
 * "The user agent MUST use an algorithm equivalent to the following algorithm
 * to compute the default-path of a cookie:"
 *
 * Assumption: the path (and not query part or absolute uri) is passed in.
 */
function defaultPath(path) {
  // "2. If the uri-path is empty or if the first character of the uri-path is not
  // a %x2F ("/") character, output %x2F ("/") and skip the remaining steps.
  if (!path || path.substr(0,1) !== "/") {
    return "/";
  }

  // "3. If the uri-path contains no more than one %x2F ("/") character, output
  // %x2F ("/") and skip the remaining step."
  if (path === "/") {
    return path;
  }

  var rightSlash = path.lastIndexOf("/");
  if (rightSlash === 0) {
    return "/";
  }

  // "4. Output the characters of the uri-path from the first character up to,
  // but not including, the right-most %x2F ("/")."
  return path.slice(0, rightSlash);
}

function trimTerminator(str) {
  for (var t = 0; t < TERMINATORS.length; t++) {
    var terminatorIdx = str.indexOf(TERMINATORS[t]);
    if (terminatorIdx !== -1) {
      str = str.substr(0,terminatorIdx);
    }
  }

  return str;
}

function parseCookiePair(cookiePair, looseMode) {
  cookiePair = trimTerminator(cookiePair);

  var firstEq = cookiePair.indexOf('=');
  if (looseMode) {
    if (firstEq === 0) { // '=' is immediately at start
      cookiePair = cookiePair.substr(1);
      firstEq = cookiePair.indexOf('='); // might still need to split on '='
    }
  } else { // non-loose mode
    if (firstEq <= 0) { // no '=' or is at start
      return; // needs to have non-empty "cookie-name"
    }
  }

  var cookieName, cookieValue;
  if (firstEq <= 0) {
    cookieName = "";
    cookieValue = cookiePair.trim();
  } else {
    cookieName = cookiePair.substr(0, firstEq).trim();
    cookieValue = cookiePair.substr(firstEq+1).trim();
  }

  if (CONTROL_CHARS.test(cookieName) || CONTROL_CHARS.test(cookieValue)) {
    return;
  }

  var c = new Cookie();
  c.key = cookieName;
  c.value = cookieValue;
  return c;
}

function parse(str, options) {
  if (!options || typeof options !== 'object') {
    options = {};
  }
  str = str.trim();

  // We use a regex to parse the "name-value-pair" part of S5.2
  var firstSemi = str.indexOf(';'); // S5.2 step 1
  var cookiePair = (firstSemi === -1) ? str : str.substr(0, firstSemi);
  var c = parseCookiePair(cookiePair, !!options.loose);
  if (!c) {
    return;
  }

  if (firstSemi === -1) {
    return c;
  }

  // S5.2.3 "unparsed-attributes consist of the remainder of the set-cookie-string
  // (including the %x3B (";") in question)." plus later on in the same section
  // "discard the first ";" and trim".
  var unparsed = str.slice(firstSemi + 1).trim();

  // "If the unparsed-attributes string is empty, skip the rest of these
  // steps."
  if (unparsed.length === 0) {
    return c;
  }

  /*
   * S5.2 says that when looping over the items "[p]rocess the attribute-name
   * and attribute-value according to the requirements in the following
   * subsections" for every item.  Plus, for many of the individual attributes
   * in S5.3 it says to use the "attribute-value of the last attribute in the
   * cookie-attribute-list".  Therefore, in this implementation, we overwrite
   * the previous value.
   */
  var cookie_avs = unparsed.split(';');
  while (cookie_avs.length) {
    var av = cookie_avs.shift().trim();
    if (av.length === 0) { // happens if ";;" appears
      continue;
    }
    var av_sep = av.indexOf('=');
    var av_key, av_value;

    if (av_sep === -1) {
      av_key = av;
      av_value = null;
    } else {
      av_key = av.substr(0,av_sep);
      av_value = av.substr(av_sep+1);
    }

    av_key = av_key.trim().toLowerCase();

    if (av_value) {
      av_value = av_value.trim();
    }

    switch(av_key) {
    case 'expires': // S5.2.1
      if (av_value) {
        var exp = parseDate(av_value);
        // "If the attribute-value failed to parse as a cookie date, ignore the
        // cookie-av."
        if (exp) {
          // over and underflow not realistically a concern: V8's getTime() seems to
          // store something larger than a 32-bit time_t (even with 32-bit node)
          c.expires = exp;
        }
      }
      break;

    case 'max-age': // S5.2.2
      if (av_value) {
        // "If the first character of the attribute-value is not a DIGIT or a "-"
        // character ...[or]... If the remainder of attribute-value contains a
        // non-DIGIT character, ignore the cookie-av."
        if (/^-?[0-9]+$/.test(av_value)) {
          var delta = parseInt(av_value, 10);
          // "If delta-seconds is less than or equal to zero (0), let expiry-time
          // be the earliest representable date and time."
          c.setMaxAge(delta);
        }
      }
      break;

    case 'domain': // S5.2.3
      // "If the attribute-value is empty, the behavior is undefined.  However,
      // the user agent SHOULD ignore the cookie-av entirely."
      if (av_value) {
        // S5.2.3 "Let cookie-domain be the attribute-value without the leading %x2E
        // (".") character."
        var domain = av_value.trim().replace(/^\./, '');
        if (domain) {
          // "Convert the cookie-domain to lower case."
          c.domain = domain.toLowerCase();
        }
      }
      break;

    case 'path': // S5.2.4
      /*
       * "If the attribute-value is empty or if the first character of the
       * attribute-value is not %x2F ("/"):
       *   Let cookie-path be the default-path.
       * Otherwise:
       *   Let cookie-path be the attribute-value."
       *
       * We'll represent the default-path as null since it depends on the
       * context of the parsing.
       */
      c.path = av_value && av_value[0] === "/" ? av_value : null;
      break;

    case 'secure': // S5.2.5
      /*
       * "If the attribute-name case-insensitively matches the string "Secure",
       * the user agent MUST append an attribute to the cookie-attribute-list
       * with an attribute-name of Secure and an empty attribute-value."
       */
      c.secure = true;
      break;

    case 'httponly': // S5.2.6 -- effectively the same as 'secure'
      c.httpOnly = true;
      break;

    default:
      c.extensions = c.extensions || [];
      c.extensions.push(av);
      break;
    }
  }

  return c;
}

// avoid the V8 deoptimization monster!
function jsonParse(str) {
  var obj;
  try {
    obj = JSON.parse(str);
  } catch (e) {
    return e;
  }
  return obj;
}

function fromJSON(str) {
  if (!str) {
    return null;
  }

  var obj;
  if (typeof str === 'string') {
    obj = jsonParse(str);
    if (obj instanceof Error) {
      return null;
    }
  } else {
    // assume it's an Object
    obj = str;
  }

  var c = new Cookie();
  for (var i=0; i<Cookie.serializableProperties.length; i++) {
    var prop = Cookie.serializableProperties[i];
    if (obj[prop] === undefined ||
        obj[prop] === Cookie.prototype[prop])
    {
      continue; // leave as prototype default
    }

    if (prop === 'expires' ||
        prop === 'creation' ||
        prop === 'lastAccessed')
    {
      if (obj[prop] === null) {
        c[prop] = null;
      } else {
        c[prop] = obj[prop] == "Infinity" ?
          "Infinity" : new Date(obj[prop]);
      }
    } else {
      c[prop] = obj[prop];
    }
  }

  return c;
}

/* Section 5.4 part 2:
 * "*  Cookies with longer paths are listed before cookies with
 *     shorter paths.
 *
 *  *  Among cookies that have equal-length path fields, cookies with
 *     earlier creation-times are listed before cookies with later
 *     creation-times."
 */

function cookieCompare(a,b) {
  var cmp = 0;

  // descending for length: b CMP a
  var aPathLen = a.path ? a.path.length : 0;
  var bPathLen = b.path ? b.path.length : 0;
  cmp = bPathLen - aPathLen;
  if (cmp !== 0) {
    return cmp;
  }

  // ascending for time: a CMP b
  var aTime = a.creation ? a.creation.getTime() : MAX_TIME;
  var bTime = b.creation ? b.creation.getTime() : MAX_TIME;
  cmp = aTime - bTime;
  if (cmp !== 0) {
    return cmp;
  }

  // break ties for the same millisecond (precision of JavaScript's clock)
  cmp = a.creationIndex - b.creationIndex;

  return cmp;
}

// Gives the permutation of all possible pathMatch()es of a given path. The
// array is in longest-to-shortest order.  Handy for indexing.
function permutePath(path) {
  if (path === '/') {
    return ['/'];
  }
  if (path.lastIndexOf('/') === path.length-1) {
    path = path.substr(0,path.length-1);
  }
  var permutations = [path];
  while (path.length > 1) {
    var lindex = path.lastIndexOf('/');
    if (lindex === 0) {
      break;
    }
    path = path.substr(0,lindex);
    permutations.push(path);
  }
  permutations.push('/');
  return permutations;
}

function getCookieContext(url) {
  if (url instanceof Object) {
    return url;
  }
  // NOTE: decodeURI will throw on malformed URIs (see GH-32).
  // Therefore, we will just skip decoding for such URIs.
  try {
    url = decodeURI(url);
  }
  catch(err) {
    // Silently swallow error
  }

  return urlParse(url);
}

function Cookie(options) {
  options = options || {};

  Object.keys(options).forEach(function(prop) {
    if (Cookie.prototype.hasOwnProperty(prop) &&
        Cookie.prototype[prop] !== options[prop] &&
        prop.substr(0,1) !== '_')
    {
      this[prop] = options[prop];
    }
  }, this);

  this.creation = this.creation || new Date();

  // used to break creation ties in cookieCompare():
  Object.defineProperty(this, 'creationIndex', {
    configurable: false,
    enumerable: false, // important for assert.deepEqual checks
    writable: true,
    value: ++Cookie.cookiesCreated
  });
}

Cookie.cookiesCreated = 0; // incremented each time a cookie is created

Cookie.parse = parse;
Cookie.fromJSON = fromJSON;

Cookie.prototype.key = "";
Cookie.prototype.value = "";

// the order in which the RFC has them:
Cookie.prototype.expires = "Infinity"; // coerces to literal Infinity
Cookie.prototype.maxAge = null; // takes precedence over expires for TTL
Cookie.prototype.domain = null;
Cookie.prototype.path = null;
Cookie.prototype.secure = false;
Cookie.prototype.httpOnly = false;
Cookie.prototype.extensions = null;

// set by the CookieJar:
Cookie.prototype.hostOnly = null; // boolean when set
Cookie.prototype.pathIsDefault = null; // boolean when set
Cookie.prototype.creation = null; // Date when set; defaulted by Cookie.parse
Cookie.prototype.lastAccessed = null; // Date when set
Object.defineProperty(Cookie.prototype, 'creationIndex', {
  configurable: true,
  enumerable: false,
  writable: true,
  value: 0
});

Cookie.serializableProperties = Object.keys(Cookie.prototype)
  .filter(function(prop) {
    return !(
      Cookie.prototype[prop] instanceof Function ||
      prop === 'creationIndex' ||
      prop.substr(0,1) === '_'
    );
  });

Cookie.prototype.inspect = function inspect() {
  var now = Date.now();
  return 'Cookie="'+this.toString() +
    '; hostOnly='+(this.hostOnly != null ? this.hostOnly : '?') +
    '; aAge='+(this.lastAccessed ? (now-this.lastAccessed.getTime())+'ms' : '?') +
    '; cAge='+(this.creation ? (now-this.creation.getTime())+'ms' : '?') +
    '"';
};

// Use the new custom inspection symbol to add the custom inspect function if
// available.
if (util.inspect.custom) {
  Cookie.prototype[util.inspect.custom] = Cookie.prototype.inspect;
}

Cookie.prototype.toJSON = function() {
  var obj = {};

  var props = Cookie.serializableProperties;
  for (var i=0; i<props.length; i++) {
    var prop = props[i];
    if (this[prop] === Cookie.prototype[prop]) {
      continue; // leave as prototype default
    }

    if (prop === 'expires' ||
        prop === 'creation' ||
        prop === 'lastAccessed')
    {
      if (this[prop] === null) {
        obj[prop] = null;
      } else {
        obj[prop] = this[prop] == "Infinity" ? // intentionally not ===
          "Infinity" : this[prop].toISOString();
      }
    } else if (prop === 'maxAge') {
      if (this[prop] !== null) {
        // again, intentionally not ===
        obj[prop] = (this[prop] == Infinity || this[prop] == -Infinity) ?
          this[prop].toString() : this[prop];
      }
    } else {
      if (this[prop] !== Cookie.prototype[prop]) {
        obj[prop] = this[prop];
      }
    }
  }

  return obj;
};

Cookie.prototype.clone = function() {
  return fromJSON(this.toJSON());
};

Cookie.prototype.validate = function validate() {
  if (!COOKIE_OCTETS.test(this.value)) {
    return false;
  }
  if (this.expires != Infinity && !(this.expires instanceof Date) && !parseDate(this.expires)) {
    return false;
  }
  if (this.maxAge != null && this.maxAge <= 0) {
    return false; // "Max-Age=" non-zero-digit *DIGIT
  }
  if (this.path != null && !PATH_VALUE.test(this.path)) {
    return false;
  }

  var cdomain = this.cdomain();
  if (cdomain) {
    if (cdomain.match(/\.$/)) {
      return false; // S4.1.2.3 suggests that this is bad. domainMatch() tests confirm this
    }
    var suffix = pubsuffix.getPublicSuffix(cdomain);
    if (suffix == null) { // it's a public suffix
      return false;
    }
  }
  return true;
};

Cookie.prototype.setExpires = function setExpires(exp) {
  if (exp instanceof Date) {
    this.expires = exp;
  } else {
    this.expires = parseDate(exp) || "Infinity";
  }
};

Cookie.prototype.setMaxAge = function setMaxAge(age) {
  if (age === Infinity || age === -Infinity) {
    this.maxAge = age.toString(); // so JSON.stringify() works
  } else {
    this.maxAge = age;
  }
};

// gives Cookie header format
Cookie.prototype.cookieString = function cookieString() {
  var val = this.value;
  if (val == null) {
    val = '';
  }
  if (this.key === '') {
    return val;
  }
  return this.key+'='+val;
};

// gives Set-Cookie header format
Cookie.prototype.toString = function toString() {
  var str = this.cookieString();

  if (this.expires != Infinity) {
    if (this.expires instanceof Date) {
      str += '; Expires='+formatDate(this.expires);
    } else {
      str += '; Expires='+this.expires;
    }
  }

  if (this.maxAge != null && this.maxAge != Infinity) {
    str += '; Max-Age='+this.maxAge;
  }

  if (this.domain && !this.hostOnly) {
    str += '; Domain='+this.domain;
  }
  if (this.path) {
    str += '; Path='+this.path;
  }

  if (this.secure) {
    str += '; Secure';
  }
  if (this.httpOnly) {
    str += '; HttpOnly';
  }
  if (this.extensions) {
    this.extensions.forEach(function(ext) {
      str += '; '+ext;
    });
  }

  return str;
};

// TTL() partially replaces the "expiry-time" parts of S5.3 step 3 (setCookie()
// elsewhere)
// S5.3 says to give the "latest representable date" for which we use Infinity
// For "expired" we use 0
Cookie.prototype.TTL = function TTL(now) {
  /* RFC6265 S4.1.2.2 If a cookie has both the Max-Age and the Expires
   * attribute, the Max-Age attribute has precedence and controls the
   * expiration date of the cookie.
   * (Concurs with S5.3 step 3)
   */
  if (this.maxAge != null) {
    return this.maxAge<=0 ? 0 : this.maxAge*1000;
  }

  var expires = this.expires;
  if (expires != Infinity) {
    if (!(expires instanceof Date)) {
      expires = parseDate(expires) || Infinity;
    }

    if (expires == Infinity) {
      return Infinity;
    }

    return expires.getTime() - (now || Date.now());
  }

  return Infinity;
};

// expiryTime() replaces the "expiry-time" parts of S5.3 step 3 (setCookie()
// elsewhere)
Cookie.prototype.expiryTime = function expiryTime(now) {
  if (this.maxAge != null) {
    var relativeTo = now || this.creation || new Date();
    var age = (this.maxAge <= 0) ? -Infinity : this.maxAge*1000;
    return relativeTo.getTime() + age;
  }

  if (this.expires == Infinity) {
    return Infinity;
  }
  return this.expires.getTime();
};

// expiryDate() replaces the "expiry-time" parts of S5.3 step 3 (setCookie()
// elsewhere), except it returns a Date
Cookie.prototype.expiryDate = function expiryDate(now) {
  var millisec = this.expiryTime(now);
  if (millisec == Infinity) {
    return new Date(MAX_TIME);
  } else if (millisec == -Infinity) {
    return new Date(MIN_TIME);
  } else {
    return new Date(millisec);
  }
};

// This replaces the "persistent-flag" parts of S5.3 step 3
Cookie.prototype.isPersistent = function isPersistent() {
  return (this.maxAge != null || this.expires != Infinity);
};

// Mostly S5.1.2 and S5.2.3:
Cookie.prototype.cdomain =
Cookie.prototype.canonicalizedDomain = function canonicalizedDomain() {
  if (this.domain == null) {
    return null;
  }
  return canonicalDomain(this.domain);
};

function CookieJar(store, options) {
  if (typeof options === "boolean") {
    options = {rejectPublicSuffixes: options};
  } else if (options == null) {
    options = {};
  }
  if (options.rejectPublicSuffixes != null) {
    this.rejectPublicSuffixes = options.rejectPublicSuffixes;
  }
  if (options.looseMode != null) {
    this.enableLooseMode = options.looseMode;
  }

  if (!store) {
    store = new MemoryCookieStore();
  }
  this.store = store;
}
CookieJar.prototype.store = null;
CookieJar.prototype.rejectPublicSuffixes = true;
CookieJar.prototype.enableLooseMode = false;
var CAN_BE_SYNC = [];

CAN_BE_SYNC.push('setCookie');
CookieJar.prototype.setCookie = function(cookie, url, options, cb) {
  var err;
  var context = getCookieContext(url);
  if (options instanceof Function) {
    cb = options;
    options = {};
  }

  var host = canonicalDomain(context.hostname);
  var loose = this.enableLooseMode;
  if (options.loose != null) {
    loose = options.loose;
  }

  // S5.3 step 1
  if (!(cookie instanceof Cookie)) {
    cookie = Cookie.parse(cookie, { loose: loose });
  }
  if (!cookie) {
    err = new Error("Cookie failed to parse");
    return cb(options.ignoreError ? null : err);
  }

  // S5.3 step 2
  var now = options.now || new Date(); // will assign later to save effort in the face of errors

  // S5.3 step 3: NOOP; persistent-flag and expiry-time is handled by getCookie()

  // S5.3 step 4: NOOP; domain is null by default

  // S5.3 step 5: public suffixes
  if (this.rejectPublicSuffixes && cookie.domain) {
    var suffix = pubsuffix.getPublicSuffix(cookie.cdomain());
    if (suffix == null) { // e.g. "com"
      err = new Error("Cookie has domain set to a public suffix");
      return cb(options.ignoreError ? null : err);
    }
  }

  // S5.3 step 6:
  if (cookie.domain) {
    if (!domainMatch(host, cookie.cdomain(), false)) {
      err = new Error("Cookie not in this host's domain. Cookie:"+cookie.cdomain()+" Request:"+host);
      return cb(options.ignoreError ? null : err);
    }

    if (cookie.hostOnly == null) { // don't reset if already set
      cookie.hostOnly = false;
    }

  } else {
    cookie.hostOnly = true;
    cookie.domain = host;
  }

  //S5.2.4 If the attribute-value is empty or if the first character of the
  //attribute-value is not %x2F ("/"):
  //Let cookie-path be the default-path.
  if (!cookie.path || cookie.path[0] !== '/') {
    cookie.path = defaultPath(context.pathname);
    cookie.pathIsDefault = true;
  }

  // S5.3 step 8: NOOP; secure attribute
  // S5.3 step 9: NOOP; httpOnly attribute

  // S5.3 step 10
  if (options.http === false && cookie.httpOnly) {
    err = new Error("Cookie is HttpOnly and this isn't an HTTP API");
    return cb(options.ignoreError ? null : err);
  }

  var store = this.store;

  if (!store.updateCookie) {
    store.updateCookie = function(oldCookie, newCookie, cb) {
      this.putCookie(newCookie, cb);
    };
  }

  function withCookie(err, oldCookie) {
    if (err) {
      return cb(err);
    }

    var next = function(err) {
      if (err) {
        return cb(err);
      } else {
        cb(null, cookie);
      }
    };

    if (oldCookie) {
      // S5.3 step 11 - "If the cookie store contains a cookie with the same name,
      // domain, and path as the newly created cookie:"
      if (options.http === false && oldCookie.httpOnly) { // step 11.2
        err = new Error("old Cookie is HttpOnly and this isn't an HTTP API");
        return cb(options.ignoreError ? null : err);
      }
      cookie.creation = oldCookie.creation; // step 11.3
      cookie.creationIndex = oldCookie.creationIndex; // preserve tie-breaker
      cookie.lastAccessed = now;
      // Step 11.4 (delete cookie) is implied by just setting the new one:
      store.updateCookie(oldCookie, cookie, next); // step 12

    } else {
      cookie.creation = cookie.lastAccessed = now;
      store.putCookie(cookie, next); // step 12
    }
  }

  store.findCookie(cookie.domain, cookie.path, cookie.key, withCookie);
};

// RFC6365 S5.4
CAN_BE_SYNC.push('getCookies');
CookieJar.prototype.getCookies = function(url, options, cb) {
  var context = getCookieContext(url);
  if (options instanceof Function) {
    cb = options;
    options = {};
  }

  var host = canonicalDomain(context.hostname);
  var path = context.pathname || '/';

  var secure = options.secure;
  if (secure == null && context.protocol &&
      (context.protocol == 'https:' || context.protocol == 'wss:'))
  {
    secure = true;
  }

  var http = options.http;
  if (http == null) {
    http = true;
  }

  var now = options.now || Date.now();
  var expireCheck = options.expire !== false;
  var allPaths = !!options.allPaths;
  var store = this.store;

  function matchingCookie(c) {
    // "Either:
    //   The cookie's host-only-flag is true and the canonicalized
    //   request-host is identical to the cookie's domain.
    // Or:
    //   The cookie's host-only-flag is false and the canonicalized
    //   request-host domain-matches the cookie's domain."
    if (c.hostOnly) {
      if (c.domain != host) {
        return false;
      }
    } else {
      if (!domainMatch(host, c.domain, false)) {
        return false;
      }
    }

    // "The request-uri's path path-matches the cookie's path."
    if (!allPaths && !pathMatch(path, c.path)) {
      return false;
    }

    // "If the cookie's secure-only-flag is true, then the request-uri's
    // scheme must denote a "secure" protocol"
    if (c.secure && !secure) {
      return false;
    }

    // "If the cookie's http-only-flag is true, then exclude the cookie if the
    // cookie-string is being generated for a "non-HTTP" API"
    if (c.httpOnly && !http) {
      return false;
    }

    // deferred from S5.3
    // non-RFC: allow retention of expired cookies by choice
    if (expireCheck && c.expiryTime() <= now) {
      store.removeCookie(c.domain, c.path, c.key, function(){}); // result ignored
      return false;
    }

    return true;
  }

  store.findCookies(host, allPaths ? null : path, function(err,cookies) {
    if (err) {
      return cb(err);
    }

    cookies = cookies.filter(matchingCookie);

    // sorting of S5.4 part 2
    if (options.sort !== false) {
      cookies = cookies.sort(cookieCompare);
    }

    // S5.4 part 3
    var now = new Date();
    cookies.forEach(function(c) {
      c.lastAccessed = now;
    });
    // TODO persist lastAccessed

    cb(null,cookies);
  });
};

CAN_BE_SYNC.push('getCookieString');
CookieJar.prototype.getCookieString = function(/*..., cb*/) {
  var args = Array.prototype.slice.call(arguments,0);
  var cb = args.pop();
  var next = function(err,cookies) {
    if (err) {
      cb(err);
    } else {
      cb(null, cookies
        .sort(cookieCompare)
        .map(function(c){
          return c.cookieString();
        })
        .join('; '));
    }
  };
  args.push(next);
  this.getCookies.apply(this,args);
};

CAN_BE_SYNC.push('getSetCookieStrings');
CookieJar.prototype.getSetCookieStrings = function(/*..., cb*/) {
  var args = Array.prototype.slice.call(arguments,0);
  var cb = args.pop();
  var next = function(err,cookies) {
    if (err) {
      cb(err);
    } else {
      cb(null, cookies.map(function(c){
        return c.toString();
      }));
    }
  };
  args.push(next);
  this.getCookies.apply(this,args);
};

CAN_BE_SYNC.push('serialize');
CookieJar.prototype.serialize = function(cb) {
  var type = this.store.constructor.name;
  if (type === 'Object') {
    type = null;
  }

  // update README.md "Serialization Format" if you change this, please!
  var serialized = {
    // The version of tough-cookie that serialized this jar. Generally a good
    // practice since future versions can make data import decisions based on
    // known past behavior. When/if this matters, use `semver`.
    version: 'tough-cookie@'+VERSION,

    // add the store type, to make humans happy:
    storeType: type,

    // CookieJar configuration:
    rejectPublicSuffixes: !!this.rejectPublicSuffixes,

    // this gets filled from getAllCookies:
    cookies: []
  };

  if (!(this.store.getAllCookies &&
        typeof this.store.getAllCookies === 'function'))
  {
    return cb(new Error('store does not support getAllCookies and cannot be serialized'));
  }

  this.store.getAllCookies(function(err,cookies) {
    if (err) {
      return cb(err);
    }

    serialized.cookies = cookies.map(function(cookie) {
      // convert to serialized 'raw' cookies
      cookie = (cookie instanceof Cookie) ? cookie.toJSON() : cookie;

      // Remove the index so new ones get assigned during deserialization
      delete cookie.creationIndex;

      return cookie;
    });

    return cb(null, serialized);
  });
};

// well-known name that JSON.stringify calls
CookieJar.prototype.toJSON = function() {
  return this.serializeSync();
};

// use the class method CookieJar.deserialize instead of calling this directly
CAN_BE_SYNC.push('_importCookies');
CookieJar.prototype._importCookies = function(serialized, cb) {
  var jar = this;
  var cookies = serialized.cookies;
  if (!cookies || !Array.isArray(cookies)) {
    return cb(new Error('serialized jar has no cookies array'));
  }
  cookies = cookies.slice(); // do not modify the original

  function putNext(err) {
    if (err) {
      return cb(err);
    }

    if (!cookies.length) {
      return cb(err, jar);
    }

    var cookie;
    try {
      cookie = fromJSON(cookies.shift());
    } catch (e) {
      return cb(e);
    }

    if (cookie === null) {
      return putNext(null); // skip this cookie
    }

    jar.store.putCookie(cookie, putNext);
  }

  putNext();
};

CookieJar.deserialize = function(strOrObj, store, cb) {
  if (arguments.length !== 3) {
    // store is optional
    cb = store;
    store = null;
  }

  var serialized;
  if (typeof strOrObj === 'string') {
    serialized = jsonParse(strOrObj);
    if (serialized instanceof Error) {
      return cb(serialized);
    }
  } else {
    serialized = strOrObj;
  }

  var jar = new CookieJar(store, serialized.rejectPublicSuffixes);
  jar._importCookies(serialized, function(err) {
    if (err) {
      return cb(err);
    }
    cb(null, jar);
  });
};

CookieJar.deserializeSync = function(strOrObj, store) {
  var serialized = typeof strOrObj === 'string' ?
    JSON.parse(strOrObj) : strOrObj;
  var jar = new CookieJar(store, serialized.rejectPublicSuffixes);

  // catch this mistake early:
  if (!jar.store.synchronous) {
    throw new Error('CookieJar store is not synchronous; use async API instead.');
  }

  jar._importCookiesSync(serialized);
  return jar;
};
CookieJar.fromJSON = CookieJar.deserializeSync;

CAN_BE_SYNC.push('clone');
CookieJar.prototype.clone = function(newStore, cb) {
  if (arguments.length === 1) {
    cb = newStore;
    newStore = null;
  }

  this.serialize(function(err,serialized) {
    if (err) {
      return cb(err);
    }
    CookieJar.deserialize(newStore, serialized, cb);
  });
};

// Use a closure to provide a true imperative API for synchronous stores.
function syncWrap(method) {
  return function() {
    if (!this.store.synchronous) {
      throw new Error('CookieJar store is not synchronous; use async API instead.');
    }

    var args = Array.prototype.slice.call(arguments);
    var syncErr, syncResult;
    args.push(function syncCb(err, result) {
      syncErr = err;
      syncResult = result;
    });
    this[method].apply(this, args);

    if (syncErr) {
      throw syncErr;
    }
    return syncResult;
  };
}

// wrap all declared CAN_BE_SYNC methods in the sync wrapper
CAN_BE_SYNC.forEach(function(method) {
  CookieJar.prototype[method+'Sync'] = syncWrap(method);
});

exports.CookieJar = CookieJar;
exports.Cookie = Cookie;
exports.Store = Store;
exports.MemoryCookieStore = MemoryCookieStore;
exports.parseDate = parseDate;
exports.formatDate = formatDate;
exports.parse = parse;
exports.fromJSON = fromJSON;
exports.domainMatch = domainMatch;
exports.defaultPath = defaultPath;
exports.pathMatch = pathMatch;
exports.getPublicSuffix = pubsuffix.getPublicSuffix;
exports.cookieCompare = cookieCompare;
exports.permuteDomain = __webpack_require__(91).permuteDomain;
exports.permutePath = permutePath;
exports.canonicalDomain = canonicalDomain;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint no-var:0, prefer-arrow-callback: 0, object-shorthand: 0 */



var Punycode = __webpack_require__(62);


var internals = {};


//
// Read rules from file.
//
internals.rules = __webpack_require__(178).map(function (rule) {

  return {
    rule: rule,
    suffix: rule.replace(/^(\*\.|\!)/, ''),
    punySuffix: -1,
    wildcard: rule.charAt(0) === '*',
    exception: rule.charAt(0) === '!'
  };
});


//
// Check is given string ends with `suffix`.
//
internals.endsWith = function (str, suffix) {

  return str.indexOf(suffix, str.length - suffix.length) !== -1;
};


//
// Find rule for a given domain.
//
internals.findRule = function (domain) {

  var punyDomain = Punycode.toASCII(domain);
  return internals.rules.reduce(function (memo, rule) {

    if (rule.punySuffix === -1){
      rule.punySuffix = Punycode.toASCII(rule.suffix);
    }
    if (!internals.endsWith(punyDomain, '.' + rule.punySuffix) && punyDomain !== rule.punySuffix) {
      return memo;
    }
    // This has been commented out as it never seems to run. This is because
    // sub tlds always appear after their parents and we never find a shorter
    // match.
    //if (memo) {
    //  var memoSuffix = Punycode.toASCII(memo.suffix);
    //  if (memoSuffix.length >= punySuffix.length) {
    //    return memo;
    //  }
    //}
    return rule;
  }, null);
};


//
// Error codes and messages.
//
exports.errorCodes = {
  DOMAIN_TOO_SHORT: 'Domain name too short.',
  DOMAIN_TOO_LONG: 'Domain name too long. It should be no more than 255 chars.',
  LABEL_STARTS_WITH_DASH: 'Domain name label can not start with a dash.',
  LABEL_ENDS_WITH_DASH: 'Domain name label can not end with a dash.',
  LABEL_TOO_LONG: 'Domain name label should be at most 63 chars long.',
  LABEL_TOO_SHORT: 'Domain name label should be at least 1 character long.',
  LABEL_INVALID_CHARS: 'Domain name label can only contain alphanumeric characters or dashes.'
};


//
// Validate domain name and throw if not valid.
//
// From wikipedia:
//
// Hostnames are composed of series of labels concatenated with dots, as are all
// domain names. Each label must be between 1 and 63 characters long, and the
// entire hostname (including the delimiting dots) has a maximum of 255 chars.
//
// Allowed chars:
//
// * `a-z`
// * `0-9`
// * `-` but not as a starting or ending character
// * `.` as a separator for the textual portions of a domain name
//
// * http://en.wikipedia.org/wiki/Domain_name
// * http://en.wikipedia.org/wiki/Hostname
//
internals.validate = function (input) {

  // Before we can validate we need to take care of IDNs with unicode chars.
  var ascii = Punycode.toASCII(input);

  if (ascii.length < 1) {
    return 'DOMAIN_TOO_SHORT';
  }
  if (ascii.length > 255) {
    return 'DOMAIN_TOO_LONG';
  }

  // Check each part's length and allowed chars.
  var labels = ascii.split('.');
  var label;

  for (var i = 0; i < labels.length; ++i) {
    label = labels[i];
    if (!label.length) {
      return 'LABEL_TOO_SHORT';
    }
    if (label.length > 63) {
      return 'LABEL_TOO_LONG';
    }
    if (label.charAt(0) === '-') {
      return 'LABEL_STARTS_WITH_DASH';
    }
    if (label.charAt(label.length - 1) === '-') {
      return 'LABEL_ENDS_WITH_DASH';
    }
    if (!/^[a-z0-9\-]+$/.test(label)) {
      return 'LABEL_INVALID_CHARS';
    }
  }
};


//
// Public API
//


//
// Parse domain.
//
exports.parse = function (input) {

  if (typeof input !== 'string') {
    throw new TypeError('Domain name must be a string.');
  }

  // Force domain to lowercase.
  var domain = input.slice(0).toLowerCase();

  // Handle FQDN.
  // TODO: Simply remove trailing dot?
  if (domain.charAt(domain.length - 1) === '.') {
    domain = domain.slice(0, domain.length - 1);
  }

  // Validate and sanitise input.
  var error = internals.validate(domain);
  if (error) {
    return {
      input: input,
      error: {
        message: exports.errorCodes[error],
        code: error
      }
    };
  }

  var parsed = {
    input: input,
    tld: null,
    sld: null,
    domain: null,
    subdomain: null,
    listed: false
  };

  var domainParts = domain.split('.');

  // Non-Internet TLD
  if (domainParts[domainParts.length - 1] === 'local') {
    return parsed;
  }

  var handlePunycode = function () {

    if (!/xn--/.test(domain)) {
      return parsed;
    }
    if (parsed.domain) {
      parsed.domain = Punycode.toASCII(parsed.domain);
    }
    if (parsed.subdomain) {
      parsed.subdomain = Punycode.toASCII(parsed.subdomain);
    }
    return parsed;
  };

  var rule = internals.findRule(domain);

  // Unlisted tld.
  if (!rule) {
    if (domainParts.length < 2) {
      return parsed;
    }
    parsed.tld = domainParts.pop();
    parsed.sld = domainParts.pop();
    parsed.domain = [parsed.sld, parsed.tld].join('.');
    if (domainParts.length) {
      parsed.subdomain = domainParts.pop();
    }
    return handlePunycode();
  }

  // At this point we know the public suffix is listed.
  parsed.listed = true;

  var tldParts = rule.suffix.split('.');
  var privateParts = domainParts.slice(0, domainParts.length - tldParts.length);

  if (rule.exception) {
    privateParts.push(tldParts.shift());
  }

  parsed.tld = tldParts.join('.');

  if (!privateParts.length) {
    return handlePunycode();
  }

  if (rule.wildcard) {
    tldParts.unshift(privateParts.pop());
    parsed.tld = tldParts.join('.');
  }

  if (!privateParts.length) {
    return handlePunycode();
  }

  parsed.sld = privateParts.pop();
  parsed.domain = [parsed.sld,  parsed.tld].join('.');

  if (privateParts.length) {
    parsed.subdomain = privateParts.join('.');
  }

  return handlePunycode();
};


//
// Get domain.
//
exports.get = function (domain) {

  if (!domain) {
    return null;
  }
  return exports.parse(domain).domain || null;
};


//
// Check whether domain belongs to a known public suffix.
//
exports.isValid = function (domain) {

  var parsed = exports.parse(domain);
  return Boolean(parsed.domain && parsed.listed);
};


/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = ["ac","com.ac","edu.ac","gov.ac","net.ac","mil.ac","org.ac","ad","nom.ad","ae","co.ae","net.ae","org.ae","sch.ae","ac.ae","gov.ae","mil.ae","aero","accident-investigation.aero","accident-prevention.aero","aerobatic.aero","aeroclub.aero","aerodrome.aero","agents.aero","aircraft.aero","airline.aero","airport.aero","air-surveillance.aero","airtraffic.aero","air-traffic-control.aero","ambulance.aero","amusement.aero","association.aero","author.aero","ballooning.aero","broker.aero","caa.aero","cargo.aero","catering.aero","certification.aero","championship.aero","charter.aero","civilaviation.aero","club.aero","conference.aero","consultant.aero","consulting.aero","control.aero","council.aero","crew.aero","design.aero","dgca.aero","educator.aero","emergency.aero","engine.aero","engineer.aero","entertainment.aero","equipment.aero","exchange.aero","express.aero","federation.aero","flight.aero","freight.aero","fuel.aero","gliding.aero","government.aero","groundhandling.aero","group.aero","hanggliding.aero","homebuilt.aero","insurance.aero","journal.aero","journalist.aero","leasing.aero","logistics.aero","magazine.aero","maintenance.aero","media.aero","microlight.aero","modelling.aero","navigation.aero","parachuting.aero","paragliding.aero","passenger-association.aero","pilot.aero","press.aero","production.aero","recreation.aero","repbody.aero","res.aero","research.aero","rotorcraft.aero","safety.aero","scientist.aero","services.aero","show.aero","skydiving.aero","software.aero","student.aero","trader.aero","trading.aero","trainer.aero","union.aero","workinggroup.aero","works.aero","af","gov.af","com.af","org.af","net.af","edu.af","ag","com.ag","org.ag","net.ag","co.ag","nom.ag","ai","off.ai","com.ai","net.ai","org.ai","al","com.al","edu.al","gov.al","mil.al","net.al","org.al","am","ao","ed.ao","gv.ao","og.ao","co.ao","pb.ao","it.ao","aq","ar","com.ar","edu.ar","gob.ar","gov.ar","int.ar","mil.ar","musica.ar","net.ar","org.ar","tur.ar","arpa","e164.arpa","in-addr.arpa","ip6.arpa","iris.arpa","uri.arpa","urn.arpa","as","gov.as","asia","at","ac.at","co.at","gv.at","or.at","au","com.au","net.au","org.au","edu.au","gov.au","asn.au","id.au","info.au","conf.au","oz.au","act.au","nsw.au","nt.au","qld.au","sa.au","tas.au","vic.au","wa.au","act.edu.au","nsw.edu.au","nt.edu.au","qld.edu.au","sa.edu.au","tas.edu.au","vic.edu.au","wa.edu.au","qld.gov.au","sa.gov.au","tas.gov.au","vic.gov.au","wa.gov.au","aw","com.aw","ax","az","com.az","net.az","int.az","gov.az","org.az","edu.az","info.az","pp.az","mil.az","name.az","pro.az","biz.az","ba","com.ba","edu.ba","gov.ba","mil.ba","net.ba","org.ba","bb","biz.bb","co.bb","com.bb","edu.bb","gov.bb","info.bb","net.bb","org.bb","store.bb","tv.bb","*.bd","be","ac.be","bf","gov.bf","bg","a.bg","b.bg","c.bg","d.bg","e.bg","f.bg","g.bg","h.bg","i.bg","j.bg","k.bg","l.bg","m.bg","n.bg","o.bg","p.bg","q.bg","r.bg","s.bg","t.bg","u.bg","v.bg","w.bg","x.bg","y.bg","z.bg","0.bg","1.bg","2.bg","3.bg","4.bg","5.bg","6.bg","7.bg","8.bg","9.bg","bh","com.bh","edu.bh","net.bh","org.bh","gov.bh","bi","co.bi","com.bi","edu.bi","or.bi","org.bi","biz","bj","asso.bj","barreau.bj","gouv.bj","bm","com.bm","edu.bm","gov.bm","net.bm","org.bm","*.bn","bo","com.bo","edu.bo","gob.bo","int.bo","org.bo","net.bo","mil.bo","tv.bo","web.bo","academia.bo","agro.bo","arte.bo","blog.bo","bolivia.bo","ciencia.bo","cooperativa.bo","democracia.bo","deporte.bo","ecologia.bo","economia.bo","empresa.bo","indigena.bo","industria.bo","info.bo","medicina.bo","movimiento.bo","musica.bo","natural.bo","nombre.bo","noticias.bo","patria.bo","politica.bo","profesional.bo","plurinacional.bo","pueblo.bo","revista.bo","salud.bo","tecnologia.bo","tksat.bo","transporte.bo","wiki.bo","br","9guacu.br","abc.br","adm.br","adv.br","agr.br","aju.br","am.br","anani.br","aparecida.br","arq.br","art.br","ato.br","b.br","barueri.br","belem.br","bhz.br","bio.br","blog.br","bmd.br","boavista.br","bsb.br","campinagrande.br","campinas.br","caxias.br","cim.br","cng.br","cnt.br","com.br","contagem.br","coop.br","cri.br","cuiaba.br","curitiba.br","def.br","ecn.br","eco.br","edu.br","emp.br","eng.br","esp.br","etc.br","eti.br","far.br","feira.br","flog.br","floripa.br","fm.br","fnd.br","fortal.br","fot.br","foz.br","fst.br","g12.br","ggf.br","goiania.br","gov.br","ac.gov.br","al.gov.br","am.gov.br","ap.gov.br","ba.gov.br","ce.gov.br","df.gov.br","es.gov.br","go.gov.br","ma.gov.br","mg.gov.br","ms.gov.br","mt.gov.br","pa.gov.br","pb.gov.br","pe.gov.br","pi.gov.br","pr.gov.br","rj.gov.br","rn.gov.br","ro.gov.br","rr.gov.br","rs.gov.br","sc.gov.br","se.gov.br","sp.gov.br","to.gov.br","gru.br","imb.br","ind.br","inf.br","jab.br","jampa.br","jdf.br","joinville.br","jor.br","jus.br","leg.br","lel.br","londrina.br","macapa.br","maceio.br","manaus.br","maringa.br","mat.br","med.br","mil.br","morena.br","mp.br","mus.br","natal.br","net.br","niteroi.br","*.nom.br","not.br","ntr.br","odo.br","org.br","osasco.br","palmas.br","poa.br","ppg.br","pro.br","psc.br","psi.br","pvh.br","qsl.br","radio.br","rec.br","recife.br","ribeirao.br","rio.br","riobranco.br","riopreto.br","salvador.br","sampa.br","santamaria.br","santoandre.br","saobernardo.br","saogonca.br","sjc.br","slg.br","slz.br","sorocaba.br","srv.br","taxi.br","teo.br","the.br","tmp.br","trd.br","tur.br","tv.br","udi.br","vet.br","vix.br","vlog.br","wiki.br","zlg.br","bs","com.bs","net.bs","org.bs","edu.bs","gov.bs","bt","com.bt","edu.bt","gov.bt","net.bt","org.bt","bv","bw","co.bw","org.bw","by","gov.by","mil.by","com.by","of.by","bz","com.bz","net.bz","org.bz","edu.bz","gov.bz","ca","ab.ca","bc.ca","mb.ca","nb.ca","nf.ca","nl.ca","ns.ca","nt.ca","nu.ca","on.ca","pe.ca","qc.ca","sk.ca","yk.ca","gc.ca","cat","cc","cd","gov.cd","cf","cg","ch","ci","org.ci","or.ci","com.ci","co.ci","edu.ci","ed.ci","ac.ci","net.ci","go.ci","asso.ci","aéroport.ci","int.ci","presse.ci","md.ci","gouv.ci","*.ck","!www.ck","cl","gov.cl","gob.cl","co.cl","mil.cl","cm","co.cm","com.cm","gov.cm","net.cm","cn","ac.cn","com.cn","edu.cn","gov.cn","net.cn","org.cn","mil.cn","公司.cn","网络.cn","網絡.cn","ah.cn","bj.cn","cq.cn","fj.cn","gd.cn","gs.cn","gz.cn","gx.cn","ha.cn","hb.cn","he.cn","hi.cn","hl.cn","hn.cn","jl.cn","js.cn","jx.cn","ln.cn","nm.cn","nx.cn","qh.cn","sc.cn","sd.cn","sh.cn","sn.cn","sx.cn","tj.cn","xj.cn","xz.cn","yn.cn","zj.cn","hk.cn","mo.cn","tw.cn","co","arts.co","com.co","edu.co","firm.co","gov.co","info.co","int.co","mil.co","net.co","nom.co","org.co","rec.co","web.co","com","coop","cr","ac.cr","co.cr","ed.cr","fi.cr","go.cr","or.cr","sa.cr","cu","com.cu","edu.cu","org.cu","net.cu","gov.cu","inf.cu","cv","cw","com.cw","edu.cw","net.cw","org.cw","cx","gov.cx","cy","ac.cy","biz.cy","com.cy","ekloges.cy","gov.cy","ltd.cy","name.cy","net.cy","org.cy","parliament.cy","press.cy","pro.cy","tm.cy","cz","de","dj","dk","dm","com.dm","net.dm","org.dm","edu.dm","gov.dm","do","art.do","com.do","edu.do","gob.do","gov.do","mil.do","net.do","org.do","sld.do","web.do","dz","com.dz","org.dz","net.dz","gov.dz","edu.dz","asso.dz","pol.dz","art.dz","ec","com.ec","info.ec","net.ec","fin.ec","k12.ec","med.ec","pro.ec","org.ec","edu.ec","gov.ec","gob.ec","mil.ec","edu","ee","edu.ee","gov.ee","riik.ee","lib.ee","med.ee","com.ee","pri.ee","aip.ee","org.ee","fie.ee","eg","com.eg","edu.eg","eun.eg","gov.eg","mil.eg","name.eg","net.eg","org.eg","sci.eg","*.er","es","com.es","nom.es","org.es","gob.es","edu.es","et","com.et","gov.et","org.et","edu.et","biz.et","name.et","info.et","net.et","eu","fi","aland.fi","*.fj","*.fk","fm","fo","fr","com.fr","asso.fr","nom.fr","prd.fr","presse.fr","tm.fr","aeroport.fr","assedic.fr","avocat.fr","avoues.fr","cci.fr","chambagri.fr","chirurgiens-dentistes.fr","experts-comptables.fr","geometre-expert.fr","gouv.fr","greta.fr","huissier-justice.fr","medecin.fr","notaires.fr","pharmacien.fr","port.fr","veterinaire.fr","ga","gb","gd","ge","com.ge","edu.ge","gov.ge","org.ge","mil.ge","net.ge","pvt.ge","gf","gg","co.gg","net.gg","org.gg","gh","com.gh","edu.gh","gov.gh","org.gh","mil.gh","gi","com.gi","ltd.gi","gov.gi","mod.gi","edu.gi","org.gi","gl","co.gl","com.gl","edu.gl","net.gl","org.gl","gm","gn","ac.gn","com.gn","edu.gn","gov.gn","org.gn","net.gn","gov","gp","com.gp","net.gp","mobi.gp","edu.gp","org.gp","asso.gp","gq","gr","com.gr","edu.gr","net.gr","org.gr","gov.gr","gs","gt","com.gt","edu.gt","gob.gt","ind.gt","mil.gt","net.gt","org.gt","gu","com.gu","edu.gu","gov.gu","guam.gu","info.gu","net.gu","org.gu","web.gu","gw","gy","co.gy","com.gy","edu.gy","gov.gy","net.gy","org.gy","hk","com.hk","edu.hk","gov.hk","idv.hk","net.hk","org.hk","公司.hk","教育.hk","敎育.hk","政府.hk","個人.hk","个人.hk","箇人.hk","網络.hk","网络.hk","组織.hk","網絡.hk","网絡.hk","组织.hk","組織.hk","組织.hk","hm","hn","com.hn","edu.hn","org.hn","net.hn","mil.hn","gob.hn","hr","iz.hr","from.hr","name.hr","com.hr","ht","com.ht","shop.ht","firm.ht","info.ht","adult.ht","net.ht","pro.ht","org.ht","med.ht","art.ht","coop.ht","pol.ht","asso.ht","edu.ht","rel.ht","gouv.ht","perso.ht","hu","co.hu","info.hu","org.hu","priv.hu","sport.hu","tm.hu","2000.hu","agrar.hu","bolt.hu","casino.hu","city.hu","erotica.hu","erotika.hu","film.hu","forum.hu","games.hu","hotel.hu","ingatlan.hu","jogasz.hu","konyvelo.hu","lakas.hu","media.hu","news.hu","reklam.hu","sex.hu","shop.hu","suli.hu","szex.hu","tozsde.hu","utazas.hu","video.hu","id","ac.id","biz.id","co.id","desa.id","go.id","mil.id","my.id","net.id","or.id","sch.id","web.id","ie","gov.ie","il","ac.il","co.il","gov.il","idf.il","k12.il","muni.il","net.il","org.il","im","ac.im","co.im","com.im","ltd.co.im","net.im","org.im","plc.co.im","tt.im","tv.im","in","co.in","firm.in","net.in","org.in","gen.in","ind.in","nic.in","ac.in","edu.in","res.in","gov.in","mil.in","info","int","eu.int","io","com.io","iq","gov.iq","edu.iq","mil.iq","com.iq","org.iq","net.iq","ir","ac.ir","co.ir","gov.ir","id.ir","net.ir","org.ir","sch.ir","ایران.ir","ايران.ir","is","net.is","com.is","edu.is","gov.is","org.is","int.is","it","gov.it","edu.it","abr.it","abruzzo.it","aosta-valley.it","aostavalley.it","bas.it","basilicata.it","cal.it","calabria.it","cam.it","campania.it","emilia-romagna.it","emiliaromagna.it","emr.it","friuli-v-giulia.it","friuli-ve-giulia.it","friuli-vegiulia.it","friuli-venezia-giulia.it","friuli-veneziagiulia.it","friuli-vgiulia.it","friuliv-giulia.it","friulive-giulia.it","friulivegiulia.it","friulivenezia-giulia.it","friuliveneziagiulia.it","friulivgiulia.it","fvg.it","laz.it","lazio.it","lig.it","liguria.it","lom.it","lombardia.it","lombardy.it","lucania.it","mar.it","marche.it","mol.it","molise.it","piedmont.it","piemonte.it","pmn.it","pug.it","puglia.it","sar.it","sardegna.it","sardinia.it","sic.it","sicilia.it","sicily.it","taa.it","tos.it","toscana.it","trentin-sud-tirol.it","trentin-süd-tirol.it","trentin-sudtirol.it","trentin-südtirol.it","trentin-sued-tirol.it","trentin-suedtirol.it","trentino-a-adige.it","trentino-aadige.it","trentino-alto-adige.it","trentino-altoadige.it","trentino-s-tirol.it","trentino-stirol.it","trentino-sud-tirol.it","trentino-süd-tirol.it","trentino-sudtirol.it","trentino-südtirol.it","trentino-sued-tirol.it","trentino-suedtirol.it","trentino.it","trentinoa-adige.it","trentinoaadige.it","trentinoalto-adige.it","trentinoaltoadige.it","trentinos-tirol.it","trentinostirol.it","trentinosud-tirol.it","trentinosüd-tirol.it","trentinosudtirol.it","trentinosüdtirol.it","trentinosued-tirol.it","trentinosuedtirol.it","trentinsud-tirol.it","trentinsüd-tirol.it","trentinsudtirol.it","trentinsüdtirol.it","trentinsued-tirol.it","trentinsuedtirol.it","tuscany.it","umb.it","umbria.it","val-d-aosta.it","val-daosta.it","vald-aosta.it","valdaosta.it","valle-aosta.it","valle-d-aosta.it","valle-daosta.it","valleaosta.it","valled-aosta.it","valledaosta.it","vallee-aoste.it","vallée-aoste.it","vallee-d-aoste.it","vallée-d-aoste.it","valleeaoste.it","valléeaoste.it","valleedaoste.it","valléedaoste.it","vao.it","vda.it","ven.it","veneto.it","ag.it","agrigento.it","al.it","alessandria.it","alto-adige.it","altoadige.it","an.it","ancona.it","andria-barletta-trani.it","andria-trani-barletta.it","andriabarlettatrani.it","andriatranibarletta.it","ao.it","aosta.it","aoste.it","ap.it","aq.it","aquila.it","ar.it","arezzo.it","ascoli-piceno.it","ascolipiceno.it","asti.it","at.it","av.it","avellino.it","ba.it","balsan-sudtirol.it","balsan-südtirol.it","balsan-suedtirol.it","balsan.it","bari.it","barletta-trani-andria.it","barlettatraniandria.it","belluno.it","benevento.it","bergamo.it","bg.it","bi.it","biella.it","bl.it","bn.it","bo.it","bologna.it","bolzano-altoadige.it","bolzano.it","bozen-sudtirol.it","bozen-südtirol.it","bozen-suedtirol.it","bozen.it","br.it","brescia.it","brindisi.it","bs.it","bt.it","bulsan-sudtirol.it","bulsan-südtirol.it","bulsan-suedtirol.it","bulsan.it","bz.it","ca.it","cagliari.it","caltanissetta.it","campidano-medio.it","campidanomedio.it","campobasso.it","carbonia-iglesias.it","carboniaiglesias.it","carrara-massa.it","carraramassa.it","caserta.it","catania.it","catanzaro.it","cb.it","ce.it","cesena-forli.it","cesena-forlì.it","cesenaforli.it","cesenaforlì.it","ch.it","chieti.it","ci.it","cl.it","cn.it","co.it","como.it","cosenza.it","cr.it","cremona.it","crotone.it","cs.it","ct.it","cuneo.it","cz.it","dell-ogliastra.it","dellogliastra.it","en.it","enna.it","fc.it","fe.it","fermo.it","ferrara.it","fg.it","fi.it","firenze.it","florence.it","fm.it","foggia.it","forli-cesena.it","forlì-cesena.it","forlicesena.it","forlìcesena.it","fr.it","frosinone.it","ge.it","genoa.it","genova.it","go.it","gorizia.it","gr.it","grosseto.it","iglesias-carbonia.it","iglesiascarbonia.it","im.it","imperia.it","is.it","isernia.it","kr.it","la-spezia.it","laquila.it","laspezia.it","latina.it","lc.it","le.it","lecce.it","lecco.it","li.it","livorno.it","lo.it","lodi.it","lt.it","lu.it","lucca.it","macerata.it","mantova.it","massa-carrara.it","massacarrara.it","matera.it","mb.it","mc.it","me.it","medio-campidano.it","mediocampidano.it","messina.it","mi.it","milan.it","milano.it","mn.it","mo.it","modena.it","monza-brianza.it","monza-e-della-brianza.it","monza.it","monzabrianza.it","monzaebrianza.it","monzaedellabrianza.it","ms.it","mt.it","na.it","naples.it","napoli.it","no.it","novara.it","nu.it","nuoro.it","og.it","ogliastra.it","olbia-tempio.it","olbiatempio.it","or.it","oristano.it","ot.it","pa.it","padova.it","padua.it","palermo.it","parma.it","pavia.it","pc.it","pd.it","pe.it","perugia.it","pesaro-urbino.it","pesarourbino.it","pescara.it","pg.it","pi.it","piacenza.it","pisa.it","pistoia.it","pn.it","po.it","pordenone.it","potenza.it","pr.it","prato.it","pt.it","pu.it","pv.it","pz.it","ra.it","ragusa.it","ravenna.it","rc.it","re.it","reggio-calabria.it","reggio-emilia.it","reggiocalabria.it","reggioemilia.it","rg.it","ri.it","rieti.it","rimini.it","rm.it","rn.it","ro.it","roma.it","rome.it","rovigo.it","sa.it","salerno.it","sassari.it","savona.it","si.it","siena.it","siracusa.it","so.it","sondrio.it","sp.it","sr.it","ss.it","suedtirol.it","südtirol.it","sv.it","ta.it","taranto.it","te.it","tempio-olbia.it","tempioolbia.it","teramo.it","terni.it","tn.it","to.it","torino.it","tp.it","tr.it","trani-andria-barletta.it","trani-barletta-andria.it","traniandriabarletta.it","tranibarlettaandria.it","trapani.it","trento.it","treviso.it","trieste.it","ts.it","turin.it","tv.it","ud.it","udine.it","urbino-pesaro.it","urbinopesaro.it","va.it","varese.it","vb.it","vc.it","ve.it","venezia.it","venice.it","verbania.it","vercelli.it","verona.it","vi.it","vibo-valentia.it","vibovalentia.it","vicenza.it","viterbo.it","vr.it","vs.it","vt.it","vv.it","je","co.je","net.je","org.je","*.jm","jo","com.jo","org.jo","net.jo","edu.jo","sch.jo","gov.jo","mil.jo","name.jo","jobs","jp","ac.jp","ad.jp","co.jp","ed.jp","go.jp","gr.jp","lg.jp","ne.jp","or.jp","aichi.jp","akita.jp","aomori.jp","chiba.jp","ehime.jp","fukui.jp","fukuoka.jp","fukushima.jp","gifu.jp","gunma.jp","hiroshima.jp","hokkaido.jp","hyogo.jp","ibaraki.jp","ishikawa.jp","iwate.jp","kagawa.jp","kagoshima.jp","kanagawa.jp","kochi.jp","kumamoto.jp","kyoto.jp","mie.jp","miyagi.jp","miyazaki.jp","nagano.jp","nagasaki.jp","nara.jp","niigata.jp","oita.jp","okayama.jp","okinawa.jp","osaka.jp","saga.jp","saitama.jp","shiga.jp","shimane.jp","shizuoka.jp","tochigi.jp","tokushima.jp","tokyo.jp","tottori.jp","toyama.jp","wakayama.jp","yamagata.jp","yamaguchi.jp","yamanashi.jp","栃木.jp","愛知.jp","愛媛.jp","兵庫.jp","熊本.jp","茨城.jp","北海道.jp","千葉.jp","和歌山.jp","長崎.jp","長野.jp","新潟.jp","青森.jp","静岡.jp","東京.jp","石川.jp","埼玉.jp","三重.jp","京都.jp","佐賀.jp","大分.jp","大阪.jp","奈良.jp","宮城.jp","宮崎.jp","富山.jp","山口.jp","山形.jp","山梨.jp","岩手.jp","岐阜.jp","岡山.jp","島根.jp","広島.jp","徳島.jp","沖縄.jp","滋賀.jp","神奈川.jp","福井.jp","福岡.jp","福島.jp","秋田.jp","群馬.jp","香川.jp","高知.jp","鳥取.jp","鹿児島.jp","*.kawasaki.jp","*.kitakyushu.jp","*.kobe.jp","*.nagoya.jp","*.sapporo.jp","*.sendai.jp","*.yokohama.jp","!city.kawasaki.jp","!city.kitakyushu.jp","!city.kobe.jp","!city.nagoya.jp","!city.sapporo.jp","!city.sendai.jp","!city.yokohama.jp","aisai.aichi.jp","ama.aichi.jp","anjo.aichi.jp","asuke.aichi.jp","chiryu.aichi.jp","chita.aichi.jp","fuso.aichi.jp","gamagori.aichi.jp","handa.aichi.jp","hazu.aichi.jp","hekinan.aichi.jp","higashiura.aichi.jp","ichinomiya.aichi.jp","inazawa.aichi.jp","inuyama.aichi.jp","isshiki.aichi.jp","iwakura.aichi.jp","kanie.aichi.jp","kariya.aichi.jp","kasugai.aichi.jp","kira.aichi.jp","kiyosu.aichi.jp","komaki.aichi.jp","konan.aichi.jp","kota.aichi.jp","mihama.aichi.jp","miyoshi.aichi.jp","nishio.aichi.jp","nisshin.aichi.jp","obu.aichi.jp","oguchi.aichi.jp","oharu.aichi.jp","okazaki.aichi.jp","owariasahi.aichi.jp","seto.aichi.jp","shikatsu.aichi.jp","shinshiro.aichi.jp","shitara.aichi.jp","tahara.aichi.jp","takahama.aichi.jp","tobishima.aichi.jp","toei.aichi.jp","togo.aichi.jp","tokai.aichi.jp","tokoname.aichi.jp","toyoake.aichi.jp","toyohashi.aichi.jp","toyokawa.aichi.jp","toyone.aichi.jp","toyota.aichi.jp","tsushima.aichi.jp","yatomi.aichi.jp","akita.akita.jp","daisen.akita.jp","fujisato.akita.jp","gojome.akita.jp","hachirogata.akita.jp","happou.akita.jp","higashinaruse.akita.jp","honjo.akita.jp","honjyo.akita.jp","ikawa.akita.jp","kamikoani.akita.jp","kamioka.akita.jp","katagami.akita.jp","kazuno.akita.jp","kitaakita.akita.jp","kosaka.akita.jp","kyowa.akita.jp","misato.akita.jp","mitane.akita.jp","moriyoshi.akita.jp","nikaho.akita.jp","noshiro.akita.jp","odate.akita.jp","oga.akita.jp","ogata.akita.jp","semboku.akita.jp","yokote.akita.jp","yurihonjo.akita.jp","aomori.aomori.jp","gonohe.aomori.jp","hachinohe.aomori.jp","hashikami.aomori.jp","hiranai.aomori.jp","hirosaki.aomori.jp","itayanagi.aomori.jp","kuroishi.aomori.jp","misawa.aomori.jp","mutsu.aomori.jp","nakadomari.aomori.jp","noheji.aomori.jp","oirase.aomori.jp","owani.aomori.jp","rokunohe.aomori.jp","sannohe.aomori.jp","shichinohe.aomori.jp","shingo.aomori.jp","takko.aomori.jp","towada.aomori.jp","tsugaru.aomori.jp","tsuruta.aomori.jp","abiko.chiba.jp","asahi.chiba.jp","chonan.chiba.jp","chosei.chiba.jp","choshi.chiba.jp","chuo.chiba.jp","funabashi.chiba.jp","futtsu.chiba.jp","hanamigawa.chiba.jp","ichihara.chiba.jp","ichikawa.chiba.jp","ichinomiya.chiba.jp","inzai.chiba.jp","isumi.chiba.jp","kamagaya.chiba.jp","kamogawa.chiba.jp","kashiwa.chiba.jp","katori.chiba.jp","katsuura.chiba.jp","kimitsu.chiba.jp","kisarazu.chiba.jp","kozaki.chiba.jp","kujukuri.chiba.jp","kyonan.chiba.jp","matsudo.chiba.jp","midori.chiba.jp","mihama.chiba.jp","minamiboso.chiba.jp","mobara.chiba.jp","mutsuzawa.chiba.jp","nagara.chiba.jp","nagareyama.chiba.jp","narashino.chiba.jp","narita.chiba.jp","noda.chiba.jp","oamishirasato.chiba.jp","omigawa.chiba.jp","onjuku.chiba.jp","otaki.chiba.jp","sakae.chiba.jp","sakura.chiba.jp","shimofusa.chiba.jp","shirako.chiba.jp","shiroi.chiba.jp","shisui.chiba.jp","sodegaura.chiba.jp","sosa.chiba.jp","tako.chiba.jp","tateyama.chiba.jp","togane.chiba.jp","tohnosho.chiba.jp","tomisato.chiba.jp","urayasu.chiba.jp","yachimata.chiba.jp","yachiyo.chiba.jp","yokaichiba.chiba.jp","yokoshibahikari.chiba.jp","yotsukaido.chiba.jp","ainan.ehime.jp","honai.ehime.jp","ikata.ehime.jp","imabari.ehime.jp","iyo.ehime.jp","kamijima.ehime.jp","kihoku.ehime.jp","kumakogen.ehime.jp","masaki.ehime.jp","matsuno.ehime.jp","matsuyama.ehime.jp","namikata.ehime.jp","niihama.ehime.jp","ozu.ehime.jp","saijo.ehime.jp","seiyo.ehime.jp","shikokuchuo.ehime.jp","tobe.ehime.jp","toon.ehime.jp","uchiko.ehime.jp","uwajima.ehime.jp","yawatahama.ehime.jp","echizen.fukui.jp","eiheiji.fukui.jp","fukui.fukui.jp","ikeda.fukui.jp","katsuyama.fukui.jp","mihama.fukui.jp","minamiechizen.fukui.jp","obama.fukui.jp","ohi.fukui.jp","ono.fukui.jp","sabae.fukui.jp","sakai.fukui.jp","takahama.fukui.jp","tsuruga.fukui.jp","wakasa.fukui.jp","ashiya.fukuoka.jp","buzen.fukuoka.jp","chikugo.fukuoka.jp","chikuho.fukuoka.jp","chikujo.fukuoka.jp","chikushino.fukuoka.jp","chikuzen.fukuoka.jp","chuo.fukuoka.jp","dazaifu.fukuoka.jp","fukuchi.fukuoka.jp","hakata.fukuoka.jp","higashi.fukuoka.jp","hirokawa.fukuoka.jp","hisayama.fukuoka.jp","iizuka.fukuoka.jp","inatsuki.fukuoka.jp","kaho.fukuoka.jp","kasuga.fukuoka.jp","kasuya.fukuoka.jp","kawara.fukuoka.jp","keisen.fukuoka.jp","koga.fukuoka.jp","kurate.fukuoka.jp","kurogi.fukuoka.jp","kurume.fukuoka.jp","minami.fukuoka.jp","miyako.fukuoka.jp","miyama.fukuoka.jp","miyawaka.fukuoka.jp","mizumaki.fukuoka.jp","munakata.fukuoka.jp","nakagawa.fukuoka.jp","nakama.fukuoka.jp","nishi.fukuoka.jp","nogata.fukuoka.jp","ogori.fukuoka.jp","okagaki.fukuoka.jp","okawa.fukuoka.jp","oki.fukuoka.jp","omuta.fukuoka.jp","onga.fukuoka.jp","onojo.fukuoka.jp","oto.fukuoka.jp","saigawa.fukuoka.jp","sasaguri.fukuoka.jp","shingu.fukuoka.jp","shinyoshitomi.fukuoka.jp","shonai.fukuoka.jp","soeda.fukuoka.jp","sue.fukuoka.jp","tachiarai.fukuoka.jp","tagawa.fukuoka.jp","takata.fukuoka.jp","toho.fukuoka.jp","toyotsu.fukuoka.jp","tsuiki.fukuoka.jp","ukiha.fukuoka.jp","umi.fukuoka.jp","usui.fukuoka.jp","yamada.fukuoka.jp","yame.fukuoka.jp","yanagawa.fukuoka.jp","yukuhashi.fukuoka.jp","aizubange.fukushima.jp","aizumisato.fukushima.jp","aizuwakamatsu.fukushima.jp","asakawa.fukushima.jp","bandai.fukushima.jp","date.fukushima.jp","fukushima.fukushima.jp","furudono.fukushima.jp","futaba.fukushima.jp","hanawa.fukushima.jp","higashi.fukushima.jp","hirata.fukushima.jp","hirono.fukushima.jp","iitate.fukushima.jp","inawashiro.fukushima.jp","ishikawa.fukushima.jp","iwaki.fukushima.jp","izumizaki.fukushima.jp","kagamiishi.fukushima.jp","kaneyama.fukushima.jp","kawamata.fukushima.jp","kitakata.fukushima.jp","kitashiobara.fukushima.jp","koori.fukushima.jp","koriyama.fukushima.jp","kunimi.fukushima.jp","miharu.fukushima.jp","mishima.fukushima.jp","namie.fukushima.jp","nango.fukushima.jp","nishiaizu.fukushima.jp","nishigo.fukushima.jp","okuma.fukushima.jp","omotego.fukushima.jp","ono.fukushima.jp","otama.fukushima.jp","samegawa.fukushima.jp","shimogo.fukushima.jp","shirakawa.fukushima.jp","showa.fukushima.jp","soma.fukushima.jp","sukagawa.fukushima.jp","taishin.fukushima.jp","tamakawa.fukushima.jp","tanagura.fukushima.jp","tenei.fukushima.jp","yabuki.fukushima.jp","yamato.fukushima.jp","yamatsuri.fukushima.jp","yanaizu.fukushima.jp","yugawa.fukushima.jp","anpachi.gifu.jp","ena.gifu.jp","gifu.gifu.jp","ginan.gifu.jp","godo.gifu.jp","gujo.gifu.jp","hashima.gifu.jp","hichiso.gifu.jp","hida.gifu.jp","higashishirakawa.gifu.jp","ibigawa.gifu.jp","ikeda.gifu.jp","kakamigahara.gifu.jp","kani.gifu.jp","kasahara.gifu.jp","kasamatsu.gifu.jp","kawaue.gifu.jp","kitagata.gifu.jp","mino.gifu.jp","minokamo.gifu.jp","mitake.gifu.jp","mizunami.gifu.jp","motosu.gifu.jp","nakatsugawa.gifu.jp","ogaki.gifu.jp","sakahogi.gifu.jp","seki.gifu.jp","sekigahara.gifu.jp","shirakawa.gifu.jp","tajimi.gifu.jp","takayama.gifu.jp","tarui.gifu.jp","toki.gifu.jp","tomika.gifu.jp","wanouchi.gifu.jp","yamagata.gifu.jp","yaotsu.gifu.jp","yoro.gifu.jp","annaka.gunma.jp","chiyoda.gunma.jp","fujioka.gunma.jp","higashiagatsuma.gunma.jp","isesaki.gunma.jp","itakura.gunma.jp","kanna.gunma.jp","kanra.gunma.jp","katashina.gunma.jp","kawaba.gunma.jp","kiryu.gunma.jp","kusatsu.gunma.jp","maebashi.gunma.jp","meiwa.gunma.jp","midori.gunma.jp","minakami.gunma.jp","naganohara.gunma.jp","nakanojo.gunma.jp","nanmoku.gunma.jp","numata.gunma.jp","oizumi.gunma.jp","ora.gunma.jp","ota.gunma.jp","shibukawa.gunma.jp","shimonita.gunma.jp","shinto.gunma.jp","showa.gunma.jp","takasaki.gunma.jp","takayama.gunma.jp","tamamura.gunma.jp","tatebayashi.gunma.jp","tomioka.gunma.jp","tsukiyono.gunma.jp","tsumagoi.gunma.jp","ueno.gunma.jp","yoshioka.gunma.jp","asaminami.hiroshima.jp","daiwa.hiroshima.jp","etajima.hiroshima.jp","fuchu.hiroshima.jp","fukuyama.hiroshima.jp","hatsukaichi.hiroshima.jp","higashihiroshima.hiroshima.jp","hongo.hiroshima.jp","jinsekikogen.hiroshima.jp","kaita.hiroshima.jp","kui.hiroshima.jp","kumano.hiroshima.jp","kure.hiroshima.jp","mihara.hiroshima.jp","miyoshi.hiroshima.jp","naka.hiroshima.jp","onomichi.hiroshima.jp","osakikamijima.hiroshima.jp","otake.hiroshima.jp","saka.hiroshima.jp","sera.hiroshima.jp","seranishi.hiroshima.jp","shinichi.hiroshima.jp","shobara.hiroshima.jp","takehara.hiroshima.jp","abashiri.hokkaido.jp","abira.hokkaido.jp","aibetsu.hokkaido.jp","akabira.hokkaido.jp","akkeshi.hokkaido.jp","asahikawa.hokkaido.jp","ashibetsu.hokkaido.jp","ashoro.hokkaido.jp","assabu.hokkaido.jp","atsuma.hokkaido.jp","bibai.hokkaido.jp","biei.hokkaido.jp","bifuka.hokkaido.jp","bihoro.hokkaido.jp","biratori.hokkaido.jp","chippubetsu.hokkaido.jp","chitose.hokkaido.jp","date.hokkaido.jp","ebetsu.hokkaido.jp","embetsu.hokkaido.jp","eniwa.hokkaido.jp","erimo.hokkaido.jp","esan.hokkaido.jp","esashi.hokkaido.jp","fukagawa.hokkaido.jp","fukushima.hokkaido.jp","furano.hokkaido.jp","furubira.hokkaido.jp","haboro.hokkaido.jp","hakodate.hokkaido.jp","hamatonbetsu.hokkaido.jp","hidaka.hokkaido.jp","higashikagura.hokkaido.jp","higashikawa.hokkaido.jp","hiroo.hokkaido.jp","hokuryu.hokkaido.jp","hokuto.hokkaido.jp","honbetsu.hokkaido.jp","horokanai.hokkaido.jp","horonobe.hokkaido.jp","ikeda.hokkaido.jp","imakane.hokkaido.jp","ishikari.hokkaido.jp","iwamizawa.hokkaido.jp","iwanai.hokkaido.jp","kamifurano.hokkaido.jp","kamikawa.hokkaido.jp","kamishihoro.hokkaido.jp","kamisunagawa.hokkaido.jp","kamoenai.hokkaido.jp","kayabe.hokkaido.jp","kembuchi.hokkaido.jp","kikonai.hokkaido.jp","kimobetsu.hokkaido.jp","kitahiroshima.hokkaido.jp","kitami.hokkaido.jp","kiyosato.hokkaido.jp","koshimizu.hokkaido.jp","kunneppu.hokkaido.jp","kuriyama.hokkaido.jp","kuromatsunai.hokkaido.jp","kushiro.hokkaido.jp","kutchan.hokkaido.jp","kyowa.hokkaido.jp","mashike.hokkaido.jp","matsumae.hokkaido.jp","mikasa.hokkaido.jp","minamifurano.hokkaido.jp","mombetsu.hokkaido.jp","moseushi.hokkaido.jp","mukawa.hokkaido.jp","muroran.hokkaido.jp","naie.hokkaido.jp","nakagawa.hokkaido.jp","nakasatsunai.hokkaido.jp","nakatombetsu.hokkaido.jp","nanae.hokkaido.jp","nanporo.hokkaido.jp","nayoro.hokkaido.jp","nemuro.hokkaido.jp","niikappu.hokkaido.jp","niki.hokkaido.jp","nishiokoppe.hokkaido.jp","noboribetsu.hokkaido.jp","numata.hokkaido.jp","obihiro.hokkaido.jp","obira.hokkaido.jp","oketo.hokkaido.jp","okoppe.hokkaido.jp","otaru.hokkaido.jp","otobe.hokkaido.jp","otofuke.hokkaido.jp","otoineppu.hokkaido.jp","oumu.hokkaido.jp","ozora.hokkaido.jp","pippu.hokkaido.jp","rankoshi.hokkaido.jp","rebun.hokkaido.jp","rikubetsu.hokkaido.jp","rishiri.hokkaido.jp","rishirifuji.hokkaido.jp","saroma.hokkaido.jp","sarufutsu.hokkaido.jp","shakotan.hokkaido.jp","shari.hokkaido.jp","shibecha.hokkaido.jp","shibetsu.hokkaido.jp","shikabe.hokkaido.jp","shikaoi.hokkaido.jp","shimamaki.hokkaido.jp","shimizu.hokkaido.jp","shimokawa.hokkaido.jp","shinshinotsu.hokkaido.jp","shintoku.hokkaido.jp","shiranuka.hokkaido.jp","shiraoi.hokkaido.jp","shiriuchi.hokkaido.jp","sobetsu.hokkaido.jp","sunagawa.hokkaido.jp","taiki.hokkaido.jp","takasu.hokkaido.jp","takikawa.hokkaido.jp","takinoue.hokkaido.jp","teshikaga.hokkaido.jp","tobetsu.hokkaido.jp","tohma.hokkaido.jp","tomakomai.hokkaido.jp","tomari.hokkaido.jp","toya.hokkaido.jp","toyako.hokkaido.jp","toyotomi.hokkaido.jp","toyoura.hokkaido.jp","tsubetsu.hokkaido.jp","tsukigata.hokkaido.jp","urakawa.hokkaido.jp","urausu.hokkaido.jp","uryu.hokkaido.jp","utashinai.hokkaido.jp","wakkanai.hokkaido.jp","wassamu.hokkaido.jp","yakumo.hokkaido.jp","yoichi.hokkaido.jp","aioi.hyogo.jp","akashi.hyogo.jp","ako.hyogo.jp","amagasaki.hyogo.jp","aogaki.hyogo.jp","asago.hyogo.jp","ashiya.hyogo.jp","awaji.hyogo.jp","fukusaki.hyogo.jp","goshiki.hyogo.jp","harima.hyogo.jp","himeji.hyogo.jp","ichikawa.hyogo.jp","inagawa.hyogo.jp","itami.hyogo.jp","kakogawa.hyogo.jp","kamigori.hyogo.jp","kamikawa.hyogo.jp","kasai.hyogo.jp","kasuga.hyogo.jp","kawanishi.hyogo.jp","miki.hyogo.jp","minamiawaji.hyogo.jp","nishinomiya.hyogo.jp","nishiwaki.hyogo.jp","ono.hyogo.jp","sanda.hyogo.jp","sannan.hyogo.jp","sasayama.hyogo.jp","sayo.hyogo.jp","shingu.hyogo.jp","shinonsen.hyogo.jp","shiso.hyogo.jp","sumoto.hyogo.jp","taishi.hyogo.jp","taka.hyogo.jp","takarazuka.hyogo.jp","takasago.hyogo.jp","takino.hyogo.jp","tamba.hyogo.jp","tatsuno.hyogo.jp","toyooka.hyogo.jp","yabu.hyogo.jp","yashiro.hyogo.jp","yoka.hyogo.jp","yokawa.hyogo.jp","ami.ibaraki.jp","asahi.ibaraki.jp","bando.ibaraki.jp","chikusei.ibaraki.jp","daigo.ibaraki.jp","fujishiro.ibaraki.jp","hitachi.ibaraki.jp","hitachinaka.ibaraki.jp","hitachiomiya.ibaraki.jp","hitachiota.ibaraki.jp","ibaraki.ibaraki.jp","ina.ibaraki.jp","inashiki.ibaraki.jp","itako.ibaraki.jp","iwama.ibaraki.jp","joso.ibaraki.jp","kamisu.ibaraki.jp","kasama.ibaraki.jp","kashima.ibaraki.jp","kasumigaura.ibaraki.jp","koga.ibaraki.jp","miho.ibaraki.jp","mito.ibaraki.jp","moriya.ibaraki.jp","naka.ibaraki.jp","namegata.ibaraki.jp","oarai.ibaraki.jp","ogawa.ibaraki.jp","omitama.ibaraki.jp","ryugasaki.ibaraki.jp","sakai.ibaraki.jp","sakuragawa.ibaraki.jp","shimodate.ibaraki.jp","shimotsuma.ibaraki.jp","shirosato.ibaraki.jp","sowa.ibaraki.jp","suifu.ibaraki.jp","takahagi.ibaraki.jp","tamatsukuri.ibaraki.jp","tokai.ibaraki.jp","tomobe.ibaraki.jp","tone.ibaraki.jp","toride.ibaraki.jp","tsuchiura.ibaraki.jp","tsukuba.ibaraki.jp","uchihara.ibaraki.jp","ushiku.ibaraki.jp","yachiyo.ibaraki.jp","yamagata.ibaraki.jp","yawara.ibaraki.jp","yuki.ibaraki.jp","anamizu.ishikawa.jp","hakui.ishikawa.jp","hakusan.ishikawa.jp","kaga.ishikawa.jp","kahoku.ishikawa.jp","kanazawa.ishikawa.jp","kawakita.ishikawa.jp","komatsu.ishikawa.jp","nakanoto.ishikawa.jp","nanao.ishikawa.jp","nomi.ishikawa.jp","nonoichi.ishikawa.jp","noto.ishikawa.jp","shika.ishikawa.jp","suzu.ishikawa.jp","tsubata.ishikawa.jp","tsurugi.ishikawa.jp","uchinada.ishikawa.jp","wajima.ishikawa.jp","fudai.iwate.jp","fujisawa.iwate.jp","hanamaki.iwate.jp","hiraizumi.iwate.jp","hirono.iwate.jp","ichinohe.iwate.jp","ichinoseki.iwate.jp","iwaizumi.iwate.jp","iwate.iwate.jp","joboji.iwate.jp","kamaishi.iwate.jp","kanegasaki.iwate.jp","karumai.iwate.jp","kawai.iwate.jp","kitakami.iwate.jp","kuji.iwate.jp","kunohe.iwate.jp","kuzumaki.iwate.jp","miyako.iwate.jp","mizusawa.iwate.jp","morioka.iwate.jp","ninohe.iwate.jp","noda.iwate.jp","ofunato.iwate.jp","oshu.iwate.jp","otsuchi.iwate.jp","rikuzentakata.iwate.jp","shiwa.iwate.jp","shizukuishi.iwate.jp","sumita.iwate.jp","tanohata.iwate.jp","tono.iwate.jp","yahaba.iwate.jp","yamada.iwate.jp","ayagawa.kagawa.jp","higashikagawa.kagawa.jp","kanonji.kagawa.jp","kotohira.kagawa.jp","manno.kagawa.jp","marugame.kagawa.jp","mitoyo.kagawa.jp","naoshima.kagawa.jp","sanuki.kagawa.jp","tadotsu.kagawa.jp","takamatsu.kagawa.jp","tonosho.kagawa.jp","uchinomi.kagawa.jp","utazu.kagawa.jp","zentsuji.kagawa.jp","akune.kagoshima.jp","amami.kagoshima.jp","hioki.kagoshima.jp","isa.kagoshima.jp","isen.kagoshima.jp","izumi.kagoshima.jp","kagoshima.kagoshima.jp","kanoya.kagoshima.jp","kawanabe.kagoshima.jp","kinko.kagoshima.jp","kouyama.kagoshima.jp","makurazaki.kagoshima.jp","matsumoto.kagoshima.jp","minamitane.kagoshima.jp","nakatane.kagoshima.jp","nishinoomote.kagoshima.jp","satsumasendai.kagoshima.jp","soo.kagoshima.jp","tarumizu.kagoshima.jp","yusui.kagoshima.jp","aikawa.kanagawa.jp","atsugi.kanagawa.jp","ayase.kanagawa.jp","chigasaki.kanagawa.jp","ebina.kanagawa.jp","fujisawa.kanagawa.jp","hadano.kanagawa.jp","hakone.kanagawa.jp","hiratsuka.kanagawa.jp","isehara.kanagawa.jp","kaisei.kanagawa.jp","kamakura.kanagawa.jp","kiyokawa.kanagawa.jp","matsuda.kanagawa.jp","minamiashigara.kanagawa.jp","miura.kanagawa.jp","nakai.kanagawa.jp","ninomiya.kanagawa.jp","odawara.kanagawa.jp","oi.kanagawa.jp","oiso.kanagawa.jp","sagamihara.kanagawa.jp","samukawa.kanagawa.jp","tsukui.kanagawa.jp","yamakita.kanagawa.jp","yamato.kanagawa.jp","yokosuka.kanagawa.jp","yugawara.kanagawa.jp","zama.kanagawa.jp","zushi.kanagawa.jp","aki.kochi.jp","geisei.kochi.jp","hidaka.kochi.jp","higashitsuno.kochi.jp","ino.kochi.jp","kagami.kochi.jp","kami.kochi.jp","kitagawa.kochi.jp","kochi.kochi.jp","mihara.kochi.jp","motoyama.kochi.jp","muroto.kochi.jp","nahari.kochi.jp","nakamura.kochi.jp","nankoku.kochi.jp","nishitosa.kochi.jp","niyodogawa.kochi.jp","ochi.kochi.jp","okawa.kochi.jp","otoyo.kochi.jp","otsuki.kochi.jp","sakawa.kochi.jp","sukumo.kochi.jp","susaki.kochi.jp","tosa.kochi.jp","tosashimizu.kochi.jp","toyo.kochi.jp","tsuno.kochi.jp","umaji.kochi.jp","yasuda.kochi.jp","yusuhara.kochi.jp","amakusa.kumamoto.jp","arao.kumamoto.jp","aso.kumamoto.jp","choyo.kumamoto.jp","gyokuto.kumamoto.jp","kamiamakusa.kumamoto.jp","kikuchi.kumamoto.jp","kumamoto.kumamoto.jp","mashiki.kumamoto.jp","mifune.kumamoto.jp","minamata.kumamoto.jp","minamioguni.kumamoto.jp","nagasu.kumamoto.jp","nishihara.kumamoto.jp","oguni.kumamoto.jp","ozu.kumamoto.jp","sumoto.kumamoto.jp","takamori.kumamoto.jp","uki.kumamoto.jp","uto.kumamoto.jp","yamaga.kumamoto.jp","yamato.kumamoto.jp","yatsushiro.kumamoto.jp","ayabe.kyoto.jp","fukuchiyama.kyoto.jp","higashiyama.kyoto.jp","ide.kyoto.jp","ine.kyoto.jp","joyo.kyoto.jp","kameoka.kyoto.jp","kamo.kyoto.jp","kita.kyoto.jp","kizu.kyoto.jp","kumiyama.kyoto.jp","kyotamba.kyoto.jp","kyotanabe.kyoto.jp","kyotango.kyoto.jp","maizuru.kyoto.jp","minami.kyoto.jp","minamiyamashiro.kyoto.jp","miyazu.kyoto.jp","muko.kyoto.jp","nagaokakyo.kyoto.jp","nakagyo.kyoto.jp","nantan.kyoto.jp","oyamazaki.kyoto.jp","sakyo.kyoto.jp","seika.kyoto.jp","tanabe.kyoto.jp","uji.kyoto.jp","ujitawara.kyoto.jp","wazuka.kyoto.jp","yamashina.kyoto.jp","yawata.kyoto.jp","asahi.mie.jp","inabe.mie.jp","ise.mie.jp","kameyama.mie.jp","kawagoe.mie.jp","kiho.mie.jp","kisosaki.mie.jp","kiwa.mie.jp","komono.mie.jp","kumano.mie.jp","kuwana.mie.jp","matsusaka.mie.jp","meiwa.mie.jp","mihama.mie.jp","minamiise.mie.jp","misugi.mie.jp","miyama.mie.jp","nabari.mie.jp","shima.mie.jp","suzuka.mie.jp","tado.mie.jp","taiki.mie.jp","taki.mie.jp","tamaki.mie.jp","toba.mie.jp","tsu.mie.jp","udono.mie.jp","ureshino.mie.jp","watarai.mie.jp","yokkaichi.mie.jp","furukawa.miyagi.jp","higashimatsushima.miyagi.jp","ishinomaki.miyagi.jp","iwanuma.miyagi.jp","kakuda.miyagi.jp","kami.miyagi.jp","kawasaki.miyagi.jp","marumori.miyagi.jp","matsushima.miyagi.jp","minamisanriku.miyagi.jp","misato.miyagi.jp","murata.miyagi.jp","natori.miyagi.jp","ogawara.miyagi.jp","ohira.miyagi.jp","onagawa.miyagi.jp","osaki.miyagi.jp","rifu.miyagi.jp","semine.miyagi.jp","shibata.miyagi.jp","shichikashuku.miyagi.jp","shikama.miyagi.jp","shiogama.miyagi.jp","shiroishi.miyagi.jp","tagajo.miyagi.jp","taiwa.miyagi.jp","tome.miyagi.jp","tomiya.miyagi.jp","wakuya.miyagi.jp","watari.miyagi.jp","yamamoto.miyagi.jp","zao.miyagi.jp","aya.miyazaki.jp","ebino.miyazaki.jp","gokase.miyazaki.jp","hyuga.miyazaki.jp","kadogawa.miyazaki.jp","kawaminami.miyazaki.jp","kijo.miyazaki.jp","kitagawa.miyazaki.jp","kitakata.miyazaki.jp","kitaura.miyazaki.jp","kobayashi.miyazaki.jp","kunitomi.miyazaki.jp","kushima.miyazaki.jp","mimata.miyazaki.jp","miyakonojo.miyazaki.jp","miyazaki.miyazaki.jp","morotsuka.miyazaki.jp","nichinan.miyazaki.jp","nishimera.miyazaki.jp","nobeoka.miyazaki.jp","saito.miyazaki.jp","shiiba.miyazaki.jp","shintomi.miyazaki.jp","takaharu.miyazaki.jp","takanabe.miyazaki.jp","takazaki.miyazaki.jp","tsuno.miyazaki.jp","achi.nagano.jp","agematsu.nagano.jp","anan.nagano.jp","aoki.nagano.jp","asahi.nagano.jp","azumino.nagano.jp","chikuhoku.nagano.jp","chikuma.nagano.jp","chino.nagano.jp","fujimi.nagano.jp","hakuba.nagano.jp","hara.nagano.jp","hiraya.nagano.jp","iida.nagano.jp","iijima.nagano.jp","iiyama.nagano.jp","iizuna.nagano.jp","ikeda.nagano.jp","ikusaka.nagano.jp","ina.nagano.jp","karuizawa.nagano.jp","kawakami.nagano.jp","kiso.nagano.jp","kisofukushima.nagano.jp","kitaaiki.nagano.jp","komagane.nagano.jp","komoro.nagano.jp","matsukawa.nagano.jp","matsumoto.nagano.jp","miasa.nagano.jp","minamiaiki.nagano.jp","minamimaki.nagano.jp","minamiminowa.nagano.jp","minowa.nagano.jp","miyada.nagano.jp","miyota.nagano.jp","mochizuki.nagano.jp","nagano.nagano.jp","nagawa.nagano.jp","nagiso.nagano.jp","nakagawa.nagano.jp","nakano.nagano.jp","nozawaonsen.nagano.jp","obuse.nagano.jp","ogawa.nagano.jp","okaya.nagano.jp","omachi.nagano.jp","omi.nagano.jp","ookuwa.nagano.jp","ooshika.nagano.jp","otaki.nagano.jp","otari.nagano.jp","sakae.nagano.jp","sakaki.nagano.jp","saku.nagano.jp","sakuho.nagano.jp","shimosuwa.nagano.jp","shinanomachi.nagano.jp","shiojiri.nagano.jp","suwa.nagano.jp","suzaka.nagano.jp","takagi.nagano.jp","takamori.nagano.jp","takayama.nagano.jp","tateshina.nagano.jp","tatsuno.nagano.jp","togakushi.nagano.jp","togura.nagano.jp","tomi.nagano.jp","ueda.nagano.jp","wada.nagano.jp","yamagata.nagano.jp","yamanouchi.nagano.jp","yasaka.nagano.jp","yasuoka.nagano.jp","chijiwa.nagasaki.jp","futsu.nagasaki.jp","goto.nagasaki.jp","hasami.nagasaki.jp","hirado.nagasaki.jp","iki.nagasaki.jp","isahaya.nagasaki.jp","kawatana.nagasaki.jp","kuchinotsu.nagasaki.jp","matsuura.nagasaki.jp","nagasaki.nagasaki.jp","obama.nagasaki.jp","omura.nagasaki.jp","oseto.nagasaki.jp","saikai.nagasaki.jp","sasebo.nagasaki.jp","seihi.nagasaki.jp","shimabara.nagasaki.jp","shinkamigoto.nagasaki.jp","togitsu.nagasaki.jp","tsushima.nagasaki.jp","unzen.nagasaki.jp","ando.nara.jp","gose.nara.jp","heguri.nara.jp","higashiyoshino.nara.jp","ikaruga.nara.jp","ikoma.nara.jp","kamikitayama.nara.jp","kanmaki.nara.jp","kashiba.nara.jp","kashihara.nara.jp","katsuragi.nara.jp","kawai.nara.jp","kawakami.nara.jp","kawanishi.nara.jp","koryo.nara.jp","kurotaki.nara.jp","mitsue.nara.jp","miyake.nara.jp","nara.nara.jp","nosegawa.nara.jp","oji.nara.jp","ouda.nara.jp","oyodo.nara.jp","sakurai.nara.jp","sango.nara.jp","shimoichi.nara.jp","shimokitayama.nara.jp","shinjo.nara.jp","soni.nara.jp","takatori.nara.jp","tawaramoto.nara.jp","tenkawa.nara.jp","tenri.nara.jp","uda.nara.jp","yamatokoriyama.nara.jp","yamatotakada.nara.jp","yamazoe.nara.jp","yoshino.nara.jp","aga.niigata.jp","agano.niigata.jp","gosen.niigata.jp","itoigawa.niigata.jp","izumozaki.niigata.jp","joetsu.niigata.jp","kamo.niigata.jp","kariwa.niigata.jp","kashiwazaki.niigata.jp","minamiuonuma.niigata.jp","mitsuke.niigata.jp","muika.niigata.jp","murakami.niigata.jp","myoko.niigata.jp","nagaoka.niigata.jp","niigata.niigata.jp","ojiya.niigata.jp","omi.niigata.jp","sado.niigata.jp","sanjo.niigata.jp","seiro.niigata.jp","seirou.niigata.jp","sekikawa.niigata.jp","shibata.niigata.jp","tagami.niigata.jp","tainai.niigata.jp","tochio.niigata.jp","tokamachi.niigata.jp","tsubame.niigata.jp","tsunan.niigata.jp","uonuma.niigata.jp","yahiko.niigata.jp","yoita.niigata.jp","yuzawa.niigata.jp","beppu.oita.jp","bungoono.oita.jp","bungotakada.oita.jp","hasama.oita.jp","hiji.oita.jp","himeshima.oita.jp","hita.oita.jp","kamitsue.oita.jp","kokonoe.oita.jp","kuju.oita.jp","kunisaki.oita.jp","kusu.oita.jp","oita.oita.jp","saiki.oita.jp","taketa.oita.jp","tsukumi.oita.jp","usa.oita.jp","usuki.oita.jp","yufu.oita.jp","akaiwa.okayama.jp","asakuchi.okayama.jp","bizen.okayama.jp","hayashima.okayama.jp","ibara.okayama.jp","kagamino.okayama.jp","kasaoka.okayama.jp","kibichuo.okayama.jp","kumenan.okayama.jp","kurashiki.okayama.jp","maniwa.okayama.jp","misaki.okayama.jp","nagi.okayama.jp","niimi.okayama.jp","nishiawakura.okayama.jp","okayama.okayama.jp","satosho.okayama.jp","setouchi.okayama.jp","shinjo.okayama.jp","shoo.okayama.jp","soja.okayama.jp","takahashi.okayama.jp","tamano.okayama.jp","tsuyama.okayama.jp","wake.okayama.jp","yakage.okayama.jp","aguni.okinawa.jp","ginowan.okinawa.jp","ginoza.okinawa.jp","gushikami.okinawa.jp","haebaru.okinawa.jp","higashi.okinawa.jp","hirara.okinawa.jp","iheya.okinawa.jp","ishigaki.okinawa.jp","ishikawa.okinawa.jp","itoman.okinawa.jp","izena.okinawa.jp","kadena.okinawa.jp","kin.okinawa.jp","kitadaito.okinawa.jp","kitanakagusuku.okinawa.jp","kumejima.okinawa.jp","kunigami.okinawa.jp","minamidaito.okinawa.jp","motobu.okinawa.jp","nago.okinawa.jp","naha.okinawa.jp","nakagusuku.okinawa.jp","nakijin.okinawa.jp","nanjo.okinawa.jp","nishihara.okinawa.jp","ogimi.okinawa.jp","okinawa.okinawa.jp","onna.okinawa.jp","shimoji.okinawa.jp","taketomi.okinawa.jp","tarama.okinawa.jp","tokashiki.okinawa.jp","tomigusuku.okinawa.jp","tonaki.okinawa.jp","urasoe.okinawa.jp","uruma.okinawa.jp","yaese.okinawa.jp","yomitan.okinawa.jp","yonabaru.okinawa.jp","yonaguni.okinawa.jp","zamami.okinawa.jp","abeno.osaka.jp","chihayaakasaka.osaka.jp","chuo.osaka.jp","daito.osaka.jp","fujiidera.osaka.jp","habikino.osaka.jp","hannan.osaka.jp","higashiosaka.osaka.jp","higashisumiyoshi.osaka.jp","higashiyodogawa.osaka.jp","hirakata.osaka.jp","ibaraki.osaka.jp","ikeda.osaka.jp","izumi.osaka.jp","izumiotsu.osaka.jp","izumisano.osaka.jp","kadoma.osaka.jp","kaizuka.osaka.jp","kanan.osaka.jp","kashiwara.osaka.jp","katano.osaka.jp","kawachinagano.osaka.jp","kishiwada.osaka.jp","kita.osaka.jp","kumatori.osaka.jp","matsubara.osaka.jp","minato.osaka.jp","minoh.osaka.jp","misaki.osaka.jp","moriguchi.osaka.jp","neyagawa.osaka.jp","nishi.osaka.jp","nose.osaka.jp","osakasayama.osaka.jp","sakai.osaka.jp","sayama.osaka.jp","sennan.osaka.jp","settsu.osaka.jp","shijonawate.osaka.jp","shimamoto.osaka.jp","suita.osaka.jp","tadaoka.osaka.jp","taishi.osaka.jp","tajiri.osaka.jp","takaishi.osaka.jp","takatsuki.osaka.jp","tondabayashi.osaka.jp","toyonaka.osaka.jp","toyono.osaka.jp","yao.osaka.jp","ariake.saga.jp","arita.saga.jp","fukudomi.saga.jp","genkai.saga.jp","hamatama.saga.jp","hizen.saga.jp","imari.saga.jp","kamimine.saga.jp","kanzaki.saga.jp","karatsu.saga.jp","kashima.saga.jp","kitagata.saga.jp","kitahata.saga.jp","kiyama.saga.jp","kouhoku.saga.jp","kyuragi.saga.jp","nishiarita.saga.jp","ogi.saga.jp","omachi.saga.jp","ouchi.saga.jp","saga.saga.jp","shiroishi.saga.jp","taku.saga.jp","tara.saga.jp","tosu.saga.jp","yoshinogari.saga.jp","arakawa.saitama.jp","asaka.saitama.jp","chichibu.saitama.jp","fujimi.saitama.jp","fujimino.saitama.jp","fukaya.saitama.jp","hanno.saitama.jp","hanyu.saitama.jp","hasuda.saitama.jp","hatogaya.saitama.jp","hatoyama.saitama.jp","hidaka.saitama.jp","higashichichibu.saitama.jp","higashimatsuyama.saitama.jp","honjo.saitama.jp","ina.saitama.jp","iruma.saitama.jp","iwatsuki.saitama.jp","kamiizumi.saitama.jp","kamikawa.saitama.jp","kamisato.saitama.jp","kasukabe.saitama.jp","kawagoe.saitama.jp","kawaguchi.saitama.jp","kawajima.saitama.jp","kazo.saitama.jp","kitamoto.saitama.jp","koshigaya.saitama.jp","kounosu.saitama.jp","kuki.saitama.jp","kumagaya.saitama.jp","matsubushi.saitama.jp","minano.saitama.jp","misato.saitama.jp","miyashiro.saitama.jp","miyoshi.saitama.jp","moroyama.saitama.jp","nagatoro.saitama.jp","namegawa.saitama.jp","niiza.saitama.jp","ogano.saitama.jp","ogawa.saitama.jp","ogose.saitama.jp","okegawa.saitama.jp","omiya.saitama.jp","otaki.saitama.jp","ranzan.saitama.jp","ryokami.saitama.jp","saitama.saitama.jp","sakado.saitama.jp","satte.saitama.jp","sayama.saitama.jp","shiki.saitama.jp","shiraoka.saitama.jp","soka.saitama.jp","sugito.saitama.jp","toda.saitama.jp","tokigawa.saitama.jp","tokorozawa.saitama.jp","tsurugashima.saitama.jp","urawa.saitama.jp","warabi.saitama.jp","yashio.saitama.jp","yokoze.saitama.jp","yono.saitama.jp","yorii.saitama.jp","yoshida.saitama.jp","yoshikawa.saitama.jp","yoshimi.saitama.jp","aisho.shiga.jp","gamo.shiga.jp","higashiomi.shiga.jp","hikone.shiga.jp","koka.shiga.jp","konan.shiga.jp","kosei.shiga.jp","koto.shiga.jp","kusatsu.shiga.jp","maibara.shiga.jp","moriyama.shiga.jp","nagahama.shiga.jp","nishiazai.shiga.jp","notogawa.shiga.jp","omihachiman.shiga.jp","otsu.shiga.jp","ritto.shiga.jp","ryuoh.shiga.jp","takashima.shiga.jp","takatsuki.shiga.jp","torahime.shiga.jp","toyosato.shiga.jp","yasu.shiga.jp","akagi.shimane.jp","ama.shimane.jp","gotsu.shimane.jp","hamada.shimane.jp","higashiizumo.shimane.jp","hikawa.shimane.jp","hikimi.shimane.jp","izumo.shimane.jp","kakinoki.shimane.jp","masuda.shimane.jp","matsue.shimane.jp","misato.shimane.jp","nishinoshima.shimane.jp","ohda.shimane.jp","okinoshima.shimane.jp","okuizumo.shimane.jp","shimane.shimane.jp","tamayu.shimane.jp","tsuwano.shimane.jp","unnan.shimane.jp","yakumo.shimane.jp","yasugi.shimane.jp","yatsuka.shimane.jp","arai.shizuoka.jp","atami.shizuoka.jp","fuji.shizuoka.jp","fujieda.shizuoka.jp","fujikawa.shizuoka.jp","fujinomiya.shizuoka.jp","fukuroi.shizuoka.jp","gotemba.shizuoka.jp","haibara.shizuoka.jp","hamamatsu.shizuoka.jp","higashiizu.shizuoka.jp","ito.shizuoka.jp","iwata.shizuoka.jp","izu.shizuoka.jp","izunokuni.shizuoka.jp","kakegawa.shizuoka.jp","kannami.shizuoka.jp","kawanehon.shizuoka.jp","kawazu.shizuoka.jp","kikugawa.shizuoka.jp","kosai.shizuoka.jp","makinohara.shizuoka.jp","matsuzaki.shizuoka.jp","minamiizu.shizuoka.jp","mishima.shizuoka.jp","morimachi.shizuoka.jp","nishiizu.shizuoka.jp","numazu.shizuoka.jp","omaezaki.shizuoka.jp","shimada.shizuoka.jp","shimizu.shizuoka.jp","shimoda.shizuoka.jp","shizuoka.shizuoka.jp","susono.shizuoka.jp","yaizu.shizuoka.jp","yoshida.shizuoka.jp","ashikaga.tochigi.jp","bato.tochigi.jp","haga.tochigi.jp","ichikai.tochigi.jp","iwafune.tochigi.jp","kaminokawa.tochigi.jp","kanuma.tochigi.jp","karasuyama.tochigi.jp","kuroiso.tochigi.jp","mashiko.tochigi.jp","mibu.tochigi.jp","moka.tochigi.jp","motegi.tochigi.jp","nasu.tochigi.jp","nasushiobara.tochigi.jp","nikko.tochigi.jp","nishikata.tochigi.jp","nogi.tochigi.jp","ohira.tochigi.jp","ohtawara.tochigi.jp","oyama.tochigi.jp","sakura.tochigi.jp","sano.tochigi.jp","shimotsuke.tochigi.jp","shioya.tochigi.jp","takanezawa.tochigi.jp","tochigi.tochigi.jp","tsuga.tochigi.jp","ujiie.tochigi.jp","utsunomiya.tochigi.jp","yaita.tochigi.jp","aizumi.tokushima.jp","anan.tokushima.jp","ichiba.tokushima.jp","itano.tokushima.jp","kainan.tokushima.jp","komatsushima.tokushima.jp","matsushige.tokushima.jp","mima.tokushima.jp","minami.tokushima.jp","miyoshi.tokushima.jp","mugi.tokushima.jp","nakagawa.tokushima.jp","naruto.tokushima.jp","sanagochi.tokushima.jp","shishikui.tokushima.jp","tokushima.tokushima.jp","wajiki.tokushima.jp","adachi.tokyo.jp","akiruno.tokyo.jp","akishima.tokyo.jp","aogashima.tokyo.jp","arakawa.tokyo.jp","bunkyo.tokyo.jp","chiyoda.tokyo.jp","chofu.tokyo.jp","chuo.tokyo.jp","edogawa.tokyo.jp","fuchu.tokyo.jp","fussa.tokyo.jp","hachijo.tokyo.jp","hachioji.tokyo.jp","hamura.tokyo.jp","higashikurume.tokyo.jp","higashimurayama.tokyo.jp","higashiyamato.tokyo.jp","hino.tokyo.jp","hinode.tokyo.jp","hinohara.tokyo.jp","inagi.tokyo.jp","itabashi.tokyo.jp","katsushika.tokyo.jp","kita.tokyo.jp","kiyose.tokyo.jp","kodaira.tokyo.jp","koganei.tokyo.jp","kokubunji.tokyo.jp","komae.tokyo.jp","koto.tokyo.jp","kouzushima.tokyo.jp","kunitachi.tokyo.jp","machida.tokyo.jp","meguro.tokyo.jp","minato.tokyo.jp","mitaka.tokyo.jp","mizuho.tokyo.jp","musashimurayama.tokyo.jp","musashino.tokyo.jp","nakano.tokyo.jp","nerima.tokyo.jp","ogasawara.tokyo.jp","okutama.tokyo.jp","ome.tokyo.jp","oshima.tokyo.jp","ota.tokyo.jp","setagaya.tokyo.jp","shibuya.tokyo.jp","shinagawa.tokyo.jp","shinjuku.tokyo.jp","suginami.tokyo.jp","sumida.tokyo.jp","tachikawa.tokyo.jp","taito.tokyo.jp","tama.tokyo.jp","toshima.tokyo.jp","chizu.tottori.jp","hino.tottori.jp","kawahara.tottori.jp","koge.tottori.jp","kotoura.tottori.jp","misasa.tottori.jp","nanbu.tottori.jp","nichinan.tottori.jp","sakaiminato.tottori.jp","tottori.tottori.jp","wakasa.tottori.jp","yazu.tottori.jp","yonago.tottori.jp","asahi.toyama.jp","fuchu.toyama.jp","fukumitsu.toyama.jp","funahashi.toyama.jp","himi.toyama.jp","imizu.toyama.jp","inami.toyama.jp","johana.toyama.jp","kamiichi.toyama.jp","kurobe.toyama.jp","nakaniikawa.toyama.jp","namerikawa.toyama.jp","nanto.toyama.jp","nyuzen.toyama.jp","oyabe.toyama.jp","taira.toyama.jp","takaoka.toyama.jp","tateyama.toyama.jp","toga.toyama.jp","tonami.toyama.jp","toyama.toyama.jp","unazuki.toyama.jp","uozu.toyama.jp","yamada.toyama.jp","arida.wakayama.jp","aridagawa.wakayama.jp","gobo.wakayama.jp","hashimoto.wakayama.jp","hidaka.wakayama.jp","hirogawa.wakayama.jp","inami.wakayama.jp","iwade.wakayama.jp","kainan.wakayama.jp","kamitonda.wakayama.jp","katsuragi.wakayama.jp","kimino.wakayama.jp","kinokawa.wakayama.jp","kitayama.wakayama.jp","koya.wakayama.jp","koza.wakayama.jp","kozagawa.wakayama.jp","kudoyama.wakayama.jp","kushimoto.wakayama.jp","mihama.wakayama.jp","misato.wakayama.jp","nachikatsuura.wakayama.jp","shingu.wakayama.jp","shirahama.wakayama.jp","taiji.wakayama.jp","tanabe.wakayama.jp","wakayama.wakayama.jp","yuasa.wakayama.jp","yura.wakayama.jp","asahi.yamagata.jp","funagata.yamagata.jp","higashine.yamagata.jp","iide.yamagata.jp","kahoku.yamagata.jp","kaminoyama.yamagata.jp","kaneyama.yamagata.jp","kawanishi.yamagata.jp","mamurogawa.yamagata.jp","mikawa.yamagata.jp","murayama.yamagata.jp","nagai.yamagata.jp","nakayama.yamagata.jp","nanyo.yamagata.jp","nishikawa.yamagata.jp","obanazawa.yamagata.jp","oe.yamagata.jp","oguni.yamagata.jp","ohkura.yamagata.jp","oishida.yamagata.jp","sagae.yamagata.jp","sakata.yamagata.jp","sakegawa.yamagata.jp","shinjo.yamagata.jp","shirataka.yamagata.jp","shonai.yamagata.jp","takahata.yamagata.jp","tendo.yamagata.jp","tozawa.yamagata.jp","tsuruoka.yamagata.jp","yamagata.yamagata.jp","yamanobe.yamagata.jp","yonezawa.yamagata.jp","yuza.yamagata.jp","abu.yamaguchi.jp","hagi.yamaguchi.jp","hikari.yamaguchi.jp","hofu.yamaguchi.jp","iwakuni.yamaguchi.jp","kudamatsu.yamaguchi.jp","mitou.yamaguchi.jp","nagato.yamaguchi.jp","oshima.yamaguchi.jp","shimonoseki.yamaguchi.jp","shunan.yamaguchi.jp","tabuse.yamaguchi.jp","tokuyama.yamaguchi.jp","toyota.yamaguchi.jp","ube.yamaguchi.jp","yuu.yamaguchi.jp","chuo.yamanashi.jp","doshi.yamanashi.jp","fuefuki.yamanashi.jp","fujikawa.yamanashi.jp","fujikawaguchiko.yamanashi.jp","fujiyoshida.yamanashi.jp","hayakawa.yamanashi.jp","hokuto.yamanashi.jp","ichikawamisato.yamanashi.jp","kai.yamanashi.jp","kofu.yamanashi.jp","koshu.yamanashi.jp","kosuge.yamanashi.jp","minami-alps.yamanashi.jp","minobu.yamanashi.jp","nakamichi.yamanashi.jp","nanbu.yamanashi.jp","narusawa.yamanashi.jp","nirasaki.yamanashi.jp","nishikatsura.yamanashi.jp","oshino.yamanashi.jp","otsuki.yamanashi.jp","showa.yamanashi.jp","tabayama.yamanashi.jp","tsuru.yamanashi.jp","uenohara.yamanashi.jp","yamanakako.yamanashi.jp","yamanashi.yamanashi.jp","ke","ac.ke","co.ke","go.ke","info.ke","me.ke","mobi.ke","ne.ke","or.ke","sc.ke","kg","org.kg","net.kg","com.kg","edu.kg","gov.kg","mil.kg","*.kh","ki","edu.ki","biz.ki","net.ki","org.ki","gov.ki","info.ki","com.ki","km","org.km","nom.km","gov.km","prd.km","tm.km","edu.km","mil.km","ass.km","com.km","coop.km","asso.km","presse.km","medecin.km","notaires.km","pharmaciens.km","veterinaire.km","gouv.km","kn","net.kn","org.kn","edu.kn","gov.kn","kp","com.kp","edu.kp","gov.kp","org.kp","rep.kp","tra.kp","kr","ac.kr","co.kr","es.kr","go.kr","hs.kr","kg.kr","mil.kr","ms.kr","ne.kr","or.kr","pe.kr","re.kr","sc.kr","busan.kr","chungbuk.kr","chungnam.kr","daegu.kr","daejeon.kr","gangwon.kr","gwangju.kr","gyeongbuk.kr","gyeonggi.kr","gyeongnam.kr","incheon.kr","jeju.kr","jeonbuk.kr","jeonnam.kr","seoul.kr","ulsan.kr","kw","com.kw","edu.kw","emb.kw","gov.kw","ind.kw","net.kw","org.kw","ky","edu.ky","gov.ky","com.ky","org.ky","net.ky","kz","org.kz","edu.kz","net.kz","gov.kz","mil.kz","com.kz","la","int.la","net.la","info.la","edu.la","gov.la","per.la","com.la","org.la","lb","com.lb","edu.lb","gov.lb","net.lb","org.lb","lc","com.lc","net.lc","co.lc","org.lc","edu.lc","gov.lc","li","lk","gov.lk","sch.lk","net.lk","int.lk","com.lk","org.lk","edu.lk","ngo.lk","soc.lk","web.lk","ltd.lk","assn.lk","grp.lk","hotel.lk","ac.lk","lr","com.lr","edu.lr","gov.lr","org.lr","net.lr","ls","co.ls","org.ls","lt","gov.lt","lu","lv","com.lv","edu.lv","gov.lv","org.lv","mil.lv","id.lv","net.lv","asn.lv","conf.lv","ly","com.ly","net.ly","gov.ly","plc.ly","edu.ly","sch.ly","med.ly","org.ly","id.ly","ma","co.ma","net.ma","gov.ma","org.ma","ac.ma","press.ma","mc","tm.mc","asso.mc","md","me","co.me","net.me","org.me","edu.me","ac.me","gov.me","its.me","priv.me","mg","org.mg","nom.mg","gov.mg","prd.mg","tm.mg","edu.mg","mil.mg","com.mg","co.mg","mh","mil","mk","com.mk","org.mk","net.mk","edu.mk","gov.mk","inf.mk","name.mk","ml","com.ml","edu.ml","gouv.ml","gov.ml","net.ml","org.ml","presse.ml","*.mm","mn","gov.mn","edu.mn","org.mn","mo","com.mo","net.mo","org.mo","edu.mo","gov.mo","mobi","mp","mq","mr","gov.mr","ms","com.ms","edu.ms","gov.ms","net.ms","org.ms","mt","com.mt","edu.mt","net.mt","org.mt","mu","com.mu","net.mu","org.mu","gov.mu","ac.mu","co.mu","or.mu","museum","academy.museum","agriculture.museum","air.museum","airguard.museum","alabama.museum","alaska.museum","amber.museum","ambulance.museum","american.museum","americana.museum","americanantiques.museum","americanart.museum","amsterdam.museum","and.museum","annefrank.museum","anthro.museum","anthropology.museum","antiques.museum","aquarium.museum","arboretum.museum","archaeological.museum","archaeology.museum","architecture.museum","art.museum","artanddesign.museum","artcenter.museum","artdeco.museum","arteducation.museum","artgallery.museum","arts.museum","artsandcrafts.museum","asmatart.museum","assassination.museum","assisi.museum","association.museum","astronomy.museum","atlanta.museum","austin.museum","australia.museum","automotive.museum","aviation.museum","axis.museum","badajoz.museum","baghdad.museum","bahn.museum","bale.museum","baltimore.museum","barcelona.museum","baseball.museum","basel.museum","baths.museum","bauern.museum","beauxarts.museum","beeldengeluid.museum","bellevue.museum","bergbau.museum","berkeley.museum","berlin.museum","bern.museum","bible.museum","bilbao.museum","bill.museum","birdart.museum","birthplace.museum","bonn.museum","boston.museum","botanical.museum","botanicalgarden.museum","botanicgarden.museum","botany.museum","brandywinevalley.museum","brasil.museum","bristol.museum","british.museum","britishcolumbia.museum","broadcast.museum","brunel.museum","brussel.museum","brussels.museum","bruxelles.museum","building.museum","burghof.museum","bus.museum","bushey.museum","cadaques.museum","california.museum","cambridge.museum","can.museum","canada.museum","capebreton.museum","carrier.museum","cartoonart.museum","casadelamoneda.museum","castle.museum","castres.museum","celtic.museum","center.museum","chattanooga.museum","cheltenham.museum","chesapeakebay.museum","chicago.museum","children.museum","childrens.museum","childrensgarden.museum","chiropractic.museum","chocolate.museum","christiansburg.museum","cincinnati.museum","cinema.museum","circus.museum","civilisation.museum","civilization.museum","civilwar.museum","clinton.museum","clock.museum","coal.museum","coastaldefence.museum","cody.museum","coldwar.museum","collection.museum","colonialwilliamsburg.museum","coloradoplateau.museum","columbia.museum","columbus.museum","communication.museum","communications.museum","community.museum","computer.museum","computerhistory.museum","comunicações.museum","contemporary.museum","contemporaryart.museum","convent.museum","copenhagen.museum","corporation.museum","correios-e-telecomunicações.museum","corvette.museum","costume.museum","countryestate.museum","county.museum","crafts.museum","cranbrook.museum","creation.museum","cultural.museum","culturalcenter.museum","culture.museum","cyber.museum","cymru.museum","dali.museum","dallas.museum","database.museum","ddr.museum","decorativearts.museum","delaware.museum","delmenhorst.museum","denmark.museum","depot.museum","design.museum","detroit.museum","dinosaur.museum","discovery.museum","dolls.museum","donostia.museum","durham.museum","eastafrica.museum","eastcoast.museum","education.museum","educational.museum","egyptian.museum","eisenbahn.museum","elburg.museum","elvendrell.museum","embroidery.museum","encyclopedic.museum","england.museum","entomology.museum","environment.museum","environmentalconservation.museum","epilepsy.museum","essex.museum","estate.museum","ethnology.museum","exeter.museum","exhibition.museum","family.museum","farm.museum","farmequipment.museum","farmers.museum","farmstead.museum","field.museum","figueres.museum","filatelia.museum","film.museum","fineart.museum","finearts.museum","finland.museum","flanders.museum","florida.museum","force.museum","fortmissoula.museum","fortworth.museum","foundation.museum","francaise.museum","frankfurt.museum","franziskaner.museum","freemasonry.museum","freiburg.museum","fribourg.museum","frog.museum","fundacio.museum","furniture.museum","gallery.museum","garden.museum","gateway.museum","geelvinck.museum","gemological.museum","geology.museum","georgia.museum","giessen.museum","glas.museum","glass.museum","gorge.museum","grandrapids.museum","graz.museum","guernsey.museum","halloffame.museum","hamburg.museum","handson.museum","harvestcelebration.museum","hawaii.museum","health.museum","heimatunduhren.museum","hellas.museum","helsinki.museum","hembygdsforbund.museum","heritage.museum","histoire.museum","historical.museum","historicalsociety.museum","historichouses.museum","historisch.museum","historisches.museum","history.museum","historyofscience.museum","horology.museum","house.museum","humanities.museum","illustration.museum","imageandsound.museum","indian.museum","indiana.museum","indianapolis.museum","indianmarket.museum","intelligence.museum","interactive.museum","iraq.museum","iron.museum","isleofman.museum","jamison.museum","jefferson.museum","jerusalem.museum","jewelry.museum","jewish.museum","jewishart.museum","jfk.museum","journalism.museum","judaica.museum","judygarland.museum","juedisches.museum","juif.museum","karate.museum","karikatur.museum","kids.museum","koebenhavn.museum","koeln.museum","kunst.museum","kunstsammlung.museum","kunstunddesign.museum","labor.museum","labour.museum","lajolla.museum","lancashire.museum","landes.museum","lans.museum","läns.museum","larsson.museum","lewismiller.museum","lincoln.museum","linz.museum","living.museum","livinghistory.museum","localhistory.museum","london.museum","losangeles.museum","louvre.museum","loyalist.museum","lucerne.museum","luxembourg.museum","luzern.museum","mad.museum","madrid.museum","mallorca.museum","manchester.museum","mansion.museum","mansions.museum","manx.museum","marburg.museum","maritime.museum","maritimo.museum","maryland.museum","marylhurst.museum","media.museum","medical.museum","medizinhistorisches.museum","meeres.museum","memorial.museum","mesaverde.museum","michigan.museum","midatlantic.museum","military.museum","mill.museum","miners.museum","mining.museum","minnesota.museum","missile.museum","missoula.museum","modern.museum","moma.museum","money.museum","monmouth.museum","monticello.museum","montreal.museum","moscow.museum","motorcycle.museum","muenchen.museum","muenster.museum","mulhouse.museum","muncie.museum","museet.museum","museumcenter.museum","museumvereniging.museum","music.museum","national.museum","nationalfirearms.museum","nationalheritage.museum","nativeamerican.museum","naturalhistory.museum","naturalhistorymuseum.museum","naturalsciences.museum","nature.museum","naturhistorisches.museum","natuurwetenschappen.museum","naumburg.museum","naval.museum","nebraska.museum","neues.museum","newhampshire.museum","newjersey.museum","newmexico.museum","newport.museum","newspaper.museum","newyork.museum","niepce.museum","norfolk.museum","north.museum","nrw.museum","nuernberg.museum","nuremberg.museum","nyc.museum","nyny.museum","oceanographic.museum","oceanographique.museum","omaha.museum","online.museum","ontario.museum","openair.museum","oregon.museum","oregontrail.museum","otago.museum","oxford.museum","pacific.museum","paderborn.museum","palace.museum","paleo.museum","palmsprings.museum","panama.museum","paris.museum","pasadena.museum","pharmacy.museum","philadelphia.museum","philadelphiaarea.museum","philately.museum","phoenix.museum","photography.museum","pilots.museum","pittsburgh.museum","planetarium.museum","plantation.museum","plants.museum","plaza.museum","portal.museum","portland.museum","portlligat.museum","posts-and-telecommunications.museum","preservation.museum","presidio.museum","press.museum","project.museum","public.museum","pubol.museum","quebec.museum","railroad.museum","railway.museum","research.museum","resistance.museum","riodejaneiro.museum","rochester.museum","rockart.museum","roma.museum","russia.museum","saintlouis.museum","salem.museum","salvadordali.museum","salzburg.museum","sandiego.museum","sanfrancisco.museum","santabarbara.museum","santacruz.museum","santafe.museum","saskatchewan.museum","satx.museum","savannahga.museum","schlesisches.museum","schoenbrunn.museum","schokoladen.museum","school.museum","schweiz.museum","science.museum","scienceandhistory.museum","scienceandindustry.museum","sciencecenter.museum","sciencecenters.museum","science-fiction.museum","sciencehistory.museum","sciences.museum","sciencesnaturelles.museum","scotland.museum","seaport.museum","settlement.museum","settlers.museum","shell.museum","sherbrooke.museum","sibenik.museum","silk.museum","ski.museum","skole.museum","society.museum","sologne.museum","soundandvision.museum","southcarolina.museum","southwest.museum","space.museum","spy.museum","square.museum","stadt.museum","stalbans.museum","starnberg.museum","state.museum","stateofdelaware.museum","station.museum","steam.museum","steiermark.museum","stjohn.museum","stockholm.museum","stpetersburg.museum","stuttgart.museum","suisse.museum","surgeonshall.museum","surrey.museum","svizzera.museum","sweden.museum","sydney.museum","tank.museum","tcm.museum","technology.museum","telekommunikation.museum","television.museum","texas.museum","textile.museum","theater.museum","time.museum","timekeeping.museum","topology.museum","torino.museum","touch.museum","town.museum","transport.museum","tree.museum","trolley.museum","trust.museum","trustee.museum","uhren.museum","ulm.museum","undersea.museum","university.museum","usa.museum","usantiques.museum","usarts.museum","uscountryestate.museum","usculture.museum","usdecorativearts.museum","usgarden.museum","ushistory.museum","ushuaia.museum","uslivinghistory.museum","utah.museum","uvic.museum","valley.museum","vantaa.museum","versailles.museum","viking.museum","village.museum","virginia.museum","virtual.museum","virtuel.museum","vlaanderen.museum","volkenkunde.museum","wales.museum","wallonie.museum","war.museum","washingtondc.museum","watchandclock.museum","watch-and-clock.museum","western.museum","westfalen.museum","whaling.museum","wildlife.museum","williamsburg.museum","windmill.museum","workshop.museum","york.museum","yorkshire.museum","yosemite.museum","youth.museum","zoological.museum","zoology.museum","ירושלים.museum","иком.museum","mv","aero.mv","biz.mv","com.mv","coop.mv","edu.mv","gov.mv","info.mv","int.mv","mil.mv","museum.mv","name.mv","net.mv","org.mv","pro.mv","mw","ac.mw","biz.mw","co.mw","com.mw","coop.mw","edu.mw","gov.mw","int.mw","museum.mw","net.mw","org.mw","mx","com.mx","org.mx","gob.mx","edu.mx","net.mx","my","com.my","net.my","org.my","gov.my","edu.my","mil.my","name.my","mz","ac.mz","adv.mz","co.mz","edu.mz","gov.mz","mil.mz","net.mz","org.mz","na","info.na","pro.na","name.na","school.na","or.na","dr.na","us.na","mx.na","ca.na","in.na","cc.na","tv.na","ws.na","mobi.na","co.na","com.na","org.na","name","nc","asso.nc","nom.nc","ne","net","nf","com.nf","net.nf","per.nf","rec.nf","web.nf","arts.nf","firm.nf","info.nf","other.nf","store.nf","ng","com.ng","edu.ng","gov.ng","i.ng","mil.ng","mobi.ng","name.ng","net.ng","org.ng","sch.ng","ni","ac.ni","biz.ni","co.ni","com.ni","edu.ni","gob.ni","in.ni","info.ni","int.ni","mil.ni","net.ni","nom.ni","org.ni","web.ni","nl","bv.nl","no","fhs.no","vgs.no","fylkesbibl.no","folkebibl.no","museum.no","idrett.no","priv.no","mil.no","stat.no","dep.no","kommune.no","herad.no","aa.no","ah.no","bu.no","fm.no","hl.no","hm.no","jan-mayen.no","mr.no","nl.no","nt.no","of.no","ol.no","oslo.no","rl.no","sf.no","st.no","svalbard.no","tm.no","tr.no","va.no","vf.no","gs.aa.no","gs.ah.no","gs.bu.no","gs.fm.no","gs.hl.no","gs.hm.no","gs.jan-mayen.no","gs.mr.no","gs.nl.no","gs.nt.no","gs.of.no","gs.ol.no","gs.oslo.no","gs.rl.no","gs.sf.no","gs.st.no","gs.svalbard.no","gs.tm.no","gs.tr.no","gs.va.no","gs.vf.no","akrehamn.no","åkrehamn.no","algard.no","ålgård.no","arna.no","brumunddal.no","bryne.no","bronnoysund.no","brønnøysund.no","drobak.no","drøbak.no","egersund.no","fetsund.no","floro.no","florø.no","fredrikstad.no","hokksund.no","honefoss.no","hønefoss.no","jessheim.no","jorpeland.no","jørpeland.no","kirkenes.no","kopervik.no","krokstadelva.no","langevag.no","langevåg.no","leirvik.no","mjondalen.no","mjøndalen.no","mo-i-rana.no","mosjoen.no","mosjøen.no","nesoddtangen.no","orkanger.no","osoyro.no","osøyro.no","raholt.no","råholt.no","sandnessjoen.no","sandnessjøen.no","skedsmokorset.no","slattum.no","spjelkavik.no","stathelle.no","stavern.no","stjordalshalsen.no","stjørdalshalsen.no","tananger.no","tranby.no","vossevangen.no","afjord.no","åfjord.no","agdenes.no","al.no","ål.no","alesund.no","ålesund.no","alstahaug.no","alta.no","áltá.no","alaheadju.no","álaheadju.no","alvdal.no","amli.no","åmli.no","amot.no","åmot.no","andebu.no","andoy.no","andøy.no","andasuolo.no","ardal.no","årdal.no","aremark.no","arendal.no","ås.no","aseral.no","åseral.no","asker.no","askim.no","askvoll.no","askoy.no","askøy.no","asnes.no","åsnes.no","audnedaln.no","aukra.no","aure.no","aurland.no","aurskog-holand.no","aurskog-høland.no","austevoll.no","austrheim.no","averoy.no","averøy.no","balestrand.no","ballangen.no","balat.no","bálát.no","balsfjord.no","bahccavuotna.no","báhccavuotna.no","bamble.no","bardu.no","beardu.no","beiarn.no","bajddar.no","bájddar.no","baidar.no","báidár.no","berg.no","bergen.no","berlevag.no","berlevåg.no","bearalvahki.no","bearalváhki.no","bindal.no","birkenes.no","bjarkoy.no","bjarkøy.no","bjerkreim.no","bjugn.no","bodo.no","bodø.no","badaddja.no","bådåddjå.no","budejju.no","bokn.no","bremanger.no","bronnoy.no","brønnøy.no","bygland.no","bykle.no","barum.no","bærum.no","bo.telemark.no","bø.telemark.no","bo.nordland.no","bø.nordland.no","bievat.no","bievát.no","bomlo.no","bømlo.no","batsfjord.no","båtsfjord.no","bahcavuotna.no","báhcavuotna.no","dovre.no","drammen.no","drangedal.no","dyroy.no","dyrøy.no","donna.no","dønna.no","eid.no","eidfjord.no","eidsberg.no","eidskog.no","eidsvoll.no","eigersund.no","elverum.no","enebakk.no","engerdal.no","etne.no","etnedal.no","evenes.no","evenassi.no","evenášši.no","evje-og-hornnes.no","farsund.no","fauske.no","fuossko.no","fuoisku.no","fedje.no","fet.no","finnoy.no","finnøy.no","fitjar.no","fjaler.no","fjell.no","flakstad.no","flatanger.no","flekkefjord.no","flesberg.no","flora.no","fla.no","flå.no","folldal.no","forsand.no","fosnes.no","frei.no","frogn.no","froland.no","frosta.no","frana.no","fræna.no","froya.no","frøya.no","fusa.no","fyresdal.no","forde.no","førde.no","gamvik.no","gangaviika.no","gáŋgaviika.no","gaular.no","gausdal.no","gildeskal.no","gildeskål.no","giske.no","gjemnes.no","gjerdrum.no","gjerstad.no","gjesdal.no","gjovik.no","gjøvik.no","gloppen.no","gol.no","gran.no","grane.no","granvin.no","gratangen.no","grimstad.no","grong.no","kraanghke.no","kråanghke.no","grue.no","gulen.no","hadsel.no","halden.no","halsa.no","hamar.no","hamaroy.no","habmer.no","hábmer.no","hapmir.no","hápmir.no","hammerfest.no","hammarfeasta.no","hámmárfeasta.no","haram.no","hareid.no","harstad.no","hasvik.no","aknoluokta.no","ákŋoluokta.no","hattfjelldal.no","aarborte.no","haugesund.no","hemne.no","hemnes.no","hemsedal.no","heroy.more-og-romsdal.no","herøy.møre-og-romsdal.no","heroy.nordland.no","herøy.nordland.no","hitra.no","hjartdal.no","hjelmeland.no","hobol.no","hobøl.no","hof.no","hol.no","hole.no","holmestrand.no","holtalen.no","holtålen.no","hornindal.no","horten.no","hurdal.no","hurum.no","hvaler.no","hyllestad.no","hagebostad.no","hægebostad.no","hoyanger.no","høyanger.no","hoylandet.no","høylandet.no","ha.no","hå.no","ibestad.no","inderoy.no","inderøy.no","iveland.no","jevnaker.no","jondal.no","jolster.no","jølster.no","karasjok.no","karasjohka.no","kárášjohka.no","karlsoy.no","galsa.no","gálsá.no","karmoy.no","karmøy.no","kautokeino.no","guovdageaidnu.no","klepp.no","klabu.no","klæbu.no","kongsberg.no","kongsvinger.no","kragero.no","kragerø.no","kristiansand.no","kristiansund.no","krodsherad.no","krødsherad.no","kvalsund.no","rahkkeravju.no","ráhkkerávju.no","kvam.no","kvinesdal.no","kvinnherad.no","kviteseid.no","kvitsoy.no","kvitsøy.no","kvafjord.no","kvæfjord.no","giehtavuoatna.no","kvanangen.no","kvænangen.no","navuotna.no","návuotna.no","kafjord.no","kåfjord.no","gaivuotna.no","gáivuotna.no","larvik.no","lavangen.no","lavagis.no","loabat.no","loabát.no","lebesby.no","davvesiida.no","leikanger.no","leirfjord.no","leka.no","leksvik.no","lenvik.no","leangaviika.no","leaŋgaviika.no","lesja.no","levanger.no","lier.no","lierne.no","lillehammer.no","lillesand.no","lindesnes.no","lindas.no","lindås.no","lom.no","loppa.no","lahppi.no","láhppi.no","lund.no","lunner.no","luroy.no","lurøy.no","luster.no","lyngdal.no","lyngen.no","ivgu.no","lardal.no","lerdal.no","lærdal.no","lodingen.no","lødingen.no","lorenskog.no","lørenskog.no","loten.no","løten.no","malvik.no","masoy.no","måsøy.no","muosat.no","muosát.no","mandal.no","marker.no","marnardal.no","masfjorden.no","meland.no","meldal.no","melhus.no","meloy.no","meløy.no","meraker.no","meråker.no","moareke.no","moåreke.no","midsund.no","midtre-gauldal.no","modalen.no","modum.no","molde.no","moskenes.no","moss.no","mosvik.no","malselv.no","målselv.no","malatvuopmi.no","málatvuopmi.no","namdalseid.no","aejrie.no","namsos.no","namsskogan.no","naamesjevuemie.no","nååmesjevuemie.no","laakesvuemie.no","nannestad.no","narvik.no","narviika.no","naustdal.no","nedre-eiker.no","nes.akershus.no","nes.buskerud.no","nesna.no","nesodden.no","nesseby.no","unjarga.no","unjárga.no","nesset.no","nissedal.no","nittedal.no","nord-aurdal.no","nord-fron.no","nord-odal.no","norddal.no","nordkapp.no","davvenjarga.no","davvenjárga.no","nordre-land.no","nordreisa.no","raisa.no","ráisa.no","nore-og-uvdal.no","notodden.no","naroy.no","nærøy.no","notteroy.no","nøtterøy.no","odda.no","oksnes.no","øksnes.no","oppdal.no","oppegard.no","oppegård.no","orkdal.no","orland.no","ørland.no","orskog.no","ørskog.no","orsta.no","ørsta.no","os.hedmark.no","os.hordaland.no","osen.no","osteroy.no","osterøy.no","ostre-toten.no","østre-toten.no","overhalla.no","ovre-eiker.no","øvre-eiker.no","oyer.no","øyer.no","oygarden.no","øygarden.no","oystre-slidre.no","øystre-slidre.no","porsanger.no","porsangu.no","porsáŋgu.no","porsgrunn.no","radoy.no","radøy.no","rakkestad.no","rana.no","ruovat.no","randaberg.no","rauma.no","rendalen.no","rennebu.no","rennesoy.no","rennesøy.no","rindal.no","ringebu.no","ringerike.no","ringsaker.no","rissa.no","risor.no","risør.no","roan.no","rollag.no","rygge.no","ralingen.no","rælingen.no","rodoy.no","rødøy.no","romskog.no","rømskog.no","roros.no","røros.no","rost.no","røst.no","royken.no","røyken.no","royrvik.no","røyrvik.no","rade.no","råde.no","salangen.no","siellak.no","saltdal.no","salat.no","sálát.no","sálat.no","samnanger.no","sande.more-og-romsdal.no","sande.møre-og-romsdal.no","sande.vestfold.no","sandefjord.no","sandnes.no","sandoy.no","sandøy.no","sarpsborg.no","sauda.no","sauherad.no","sel.no","selbu.no","selje.no","seljord.no","sigdal.no","siljan.no","sirdal.no","skaun.no","skedsmo.no","ski.no","skien.no","skiptvet.no","skjervoy.no","skjervøy.no","skierva.no","skiervá.no","skjak.no","skjåk.no","skodje.no","skanland.no","skånland.no","skanit.no","skánit.no","smola.no","smøla.no","snillfjord.no","snasa.no","snåsa.no","snoasa.no","snaase.no","snåase.no","sogndal.no","sokndal.no","sola.no","solund.no","songdalen.no","sortland.no","spydeberg.no","stange.no","stavanger.no","steigen.no","steinkjer.no","stjordal.no","stjørdal.no","stokke.no","stor-elvdal.no","stord.no","stordal.no","storfjord.no","omasvuotna.no","strand.no","stranda.no","stryn.no","sula.no","suldal.no","sund.no","sunndal.no","surnadal.no","sveio.no","svelvik.no","sykkylven.no","sogne.no","søgne.no","somna.no","sømna.no","sondre-land.no","søndre-land.no","sor-aurdal.no","sør-aurdal.no","sor-fron.no","sør-fron.no","sor-odal.no","sør-odal.no","sor-varanger.no","sør-varanger.no","matta-varjjat.no","mátta-várjjat.no","sorfold.no","sørfold.no","sorreisa.no","sørreisa.no","sorum.no","sørum.no","tana.no","deatnu.no","time.no","tingvoll.no","tinn.no","tjeldsund.no","dielddanuorri.no","tjome.no","tjøme.no","tokke.no","tolga.no","torsken.no","tranoy.no","tranøy.no","tromso.no","tromsø.no","tromsa.no","romsa.no","trondheim.no","troandin.no","trysil.no","trana.no","træna.no","trogstad.no","trøgstad.no","tvedestrand.no","tydal.no","tynset.no","tysfjord.no","divtasvuodna.no","divttasvuotna.no","tysnes.no","tysvar.no","tysvær.no","tonsberg.no","tønsberg.no","ullensaker.no","ullensvang.no","ulvik.no","utsira.no","vadso.no","vadsø.no","cahcesuolo.no","čáhcesuolo.no","vaksdal.no","valle.no","vang.no","vanylven.no","vardo.no","vardø.no","varggat.no","várggát.no","vefsn.no","vaapste.no","vega.no","vegarshei.no","vegårshei.no","vennesla.no","verdal.no","verran.no","vestby.no","vestnes.no","vestre-slidre.no","vestre-toten.no","vestvagoy.no","vestvågøy.no","vevelstad.no","vik.no","vikna.no","vindafjord.no","volda.no","voss.no","varoy.no","værøy.no","vagan.no","vågan.no","voagat.no","vagsoy.no","vågsøy.no","vaga.no","vågå.no","valer.ostfold.no","våler.østfold.no","valer.hedmark.no","våler.hedmark.no","*.np","nr","biz.nr","info.nr","gov.nr","edu.nr","org.nr","net.nr","com.nr","nu","nz","ac.nz","co.nz","cri.nz","geek.nz","gen.nz","govt.nz","health.nz","iwi.nz","kiwi.nz","maori.nz","mil.nz","māori.nz","net.nz","org.nz","parliament.nz","school.nz","om","co.om","com.om","edu.om","gov.om","med.om","museum.om","net.om","org.om","pro.om","onion","org","pa","ac.pa","gob.pa","com.pa","org.pa","sld.pa","edu.pa","net.pa","ing.pa","abo.pa","med.pa","nom.pa","pe","edu.pe","gob.pe","nom.pe","mil.pe","org.pe","com.pe","net.pe","pf","com.pf","org.pf","edu.pf","*.pg","ph","com.ph","net.ph","org.ph","gov.ph","edu.ph","ngo.ph","mil.ph","i.ph","pk","com.pk","net.pk","edu.pk","org.pk","fam.pk","biz.pk","web.pk","gov.pk","gob.pk","gok.pk","gon.pk","gop.pk","gos.pk","info.pk","pl","com.pl","net.pl","org.pl","aid.pl","agro.pl","atm.pl","auto.pl","biz.pl","edu.pl","gmina.pl","gsm.pl","info.pl","mail.pl","miasta.pl","media.pl","mil.pl","nieruchomosci.pl","nom.pl","pc.pl","powiat.pl","priv.pl","realestate.pl","rel.pl","sex.pl","shop.pl","sklep.pl","sos.pl","szkola.pl","targi.pl","tm.pl","tourism.pl","travel.pl","turystyka.pl","gov.pl","ap.gov.pl","ic.gov.pl","is.gov.pl","us.gov.pl","kmpsp.gov.pl","kppsp.gov.pl","kwpsp.gov.pl","psp.gov.pl","wskr.gov.pl","kwp.gov.pl","mw.gov.pl","ug.gov.pl","um.gov.pl","umig.gov.pl","ugim.gov.pl","upow.gov.pl","uw.gov.pl","starostwo.gov.pl","pa.gov.pl","po.gov.pl","psse.gov.pl","pup.gov.pl","rzgw.gov.pl","sa.gov.pl","so.gov.pl","sr.gov.pl","wsa.gov.pl","sko.gov.pl","uzs.gov.pl","wiih.gov.pl","winb.gov.pl","pinb.gov.pl","wios.gov.pl","witd.gov.pl","wzmiuw.gov.pl","piw.gov.pl","wiw.gov.pl","griw.gov.pl","wif.gov.pl","oum.gov.pl","sdn.gov.pl","zp.gov.pl","uppo.gov.pl","mup.gov.pl","wuoz.gov.pl","konsulat.gov.pl","oirm.gov.pl","augustow.pl","babia-gora.pl","bedzin.pl","beskidy.pl","bialowieza.pl","bialystok.pl","bielawa.pl","bieszczady.pl","boleslawiec.pl","bydgoszcz.pl","bytom.pl","cieszyn.pl","czeladz.pl","czest.pl","dlugoleka.pl","elblag.pl","elk.pl","glogow.pl","gniezno.pl","gorlice.pl","grajewo.pl","ilawa.pl","jaworzno.pl","jelenia-gora.pl","jgora.pl","kalisz.pl","kazimierz-dolny.pl","karpacz.pl","kartuzy.pl","kaszuby.pl","katowice.pl","kepno.pl","ketrzyn.pl","klodzko.pl","kobierzyce.pl","kolobrzeg.pl","konin.pl","konskowola.pl","kutno.pl","lapy.pl","lebork.pl","legnica.pl","lezajsk.pl","limanowa.pl","lomza.pl","lowicz.pl","lubin.pl","lukow.pl","malbork.pl","malopolska.pl","mazowsze.pl","mazury.pl","mielec.pl","mielno.pl","mragowo.pl","naklo.pl","nowaruda.pl","nysa.pl","olawa.pl","olecko.pl","olkusz.pl","olsztyn.pl","opoczno.pl","opole.pl","ostroda.pl","ostroleka.pl","ostrowiec.pl","ostrowwlkp.pl","pila.pl","pisz.pl","podhale.pl","podlasie.pl","polkowice.pl","pomorze.pl","pomorskie.pl","prochowice.pl","pruszkow.pl","przeworsk.pl","pulawy.pl","radom.pl","rawa-maz.pl","rybnik.pl","rzeszow.pl","sanok.pl","sejny.pl","slask.pl","slupsk.pl","sosnowiec.pl","stalowa-wola.pl","skoczow.pl","starachowice.pl","stargard.pl","suwalki.pl","swidnica.pl","swiebodzin.pl","swinoujscie.pl","szczecin.pl","szczytno.pl","tarnobrzeg.pl","tgory.pl","turek.pl","tychy.pl","ustka.pl","walbrzych.pl","warmia.pl","warszawa.pl","waw.pl","wegrow.pl","wielun.pl","wlocl.pl","wloclawek.pl","wodzislaw.pl","wolomin.pl","wroclaw.pl","zachpomor.pl","zagan.pl","zarow.pl","zgora.pl","zgorzelec.pl","pm","pn","gov.pn","co.pn","org.pn","edu.pn","net.pn","post","pr","com.pr","net.pr","org.pr","gov.pr","edu.pr","isla.pr","pro.pr","biz.pr","info.pr","name.pr","est.pr","prof.pr","ac.pr","pro","aaa.pro","aca.pro","acct.pro","avocat.pro","bar.pro","cpa.pro","eng.pro","jur.pro","law.pro","med.pro","recht.pro","ps","edu.ps","gov.ps","sec.ps","plo.ps","com.ps","org.ps","net.ps","pt","net.pt","gov.pt","org.pt","edu.pt","int.pt","publ.pt","com.pt","nome.pt","pw","co.pw","ne.pw","or.pw","ed.pw","go.pw","belau.pw","py","com.py","coop.py","edu.py","gov.py","mil.py","net.py","org.py","qa","com.qa","edu.qa","gov.qa","mil.qa","name.qa","net.qa","org.qa","sch.qa","re","asso.re","com.re","nom.re","ro","arts.ro","com.ro","firm.ro","info.ro","nom.ro","nt.ro","org.ro","rec.ro","store.ro","tm.ro","www.ro","rs","ac.rs","co.rs","edu.rs","gov.rs","in.rs","org.rs","ru","ac.ru","edu.ru","gov.ru","int.ru","mil.ru","test.ru","rw","gov.rw","net.rw","edu.rw","ac.rw","com.rw","co.rw","int.rw","mil.rw","gouv.rw","sa","com.sa","net.sa","org.sa","gov.sa","med.sa","pub.sa","edu.sa","sch.sa","sb","com.sb","edu.sb","gov.sb","net.sb","org.sb","sc","com.sc","gov.sc","net.sc","org.sc","edu.sc","sd","com.sd","net.sd","org.sd","edu.sd","med.sd","tv.sd","gov.sd","info.sd","se","a.se","ac.se","b.se","bd.se","brand.se","c.se","d.se","e.se","f.se","fh.se","fhsk.se","fhv.se","g.se","h.se","i.se","k.se","komforb.se","kommunalforbund.se","komvux.se","l.se","lanbib.se","m.se","n.se","naturbruksgymn.se","o.se","org.se","p.se","parti.se","pp.se","press.se","r.se","s.se","t.se","tm.se","u.se","w.se","x.se","y.se","z.se","sg","com.sg","net.sg","org.sg","gov.sg","edu.sg","per.sg","sh","com.sh","net.sh","gov.sh","org.sh","mil.sh","si","sj","sk","sl","com.sl","net.sl","edu.sl","gov.sl","org.sl","sm","sn","art.sn","com.sn","edu.sn","gouv.sn","org.sn","perso.sn","univ.sn","so","com.so","net.so","org.so","sr","st","co.st","com.st","consulado.st","edu.st","embaixada.st","gov.st","mil.st","net.st","org.st","principe.st","saotome.st","store.st","su","sv","com.sv","edu.sv","gob.sv","org.sv","red.sv","sx","gov.sx","sy","edu.sy","gov.sy","net.sy","mil.sy","com.sy","org.sy","sz","co.sz","ac.sz","org.sz","tc","td","tel","tf","tg","th","ac.th","co.th","go.th","in.th","mi.th","net.th","or.th","tj","ac.tj","biz.tj","co.tj","com.tj","edu.tj","go.tj","gov.tj","int.tj","mil.tj","name.tj","net.tj","nic.tj","org.tj","test.tj","web.tj","tk","tl","gov.tl","tm","com.tm","co.tm","org.tm","net.tm","nom.tm","gov.tm","mil.tm","edu.tm","tn","com.tn","ens.tn","fin.tn","gov.tn","ind.tn","intl.tn","nat.tn","net.tn","org.tn","info.tn","perso.tn","tourism.tn","edunet.tn","rnrt.tn","rns.tn","rnu.tn","mincom.tn","agrinet.tn","defense.tn","turen.tn","to","com.to","gov.to","net.to","org.to","edu.to","mil.to","tr","com.tr","info.tr","biz.tr","net.tr","org.tr","web.tr","gen.tr","tv.tr","av.tr","dr.tr","bbs.tr","name.tr","tel.tr","gov.tr","bel.tr","pol.tr","mil.tr","k12.tr","edu.tr","kep.tr","nc.tr","gov.nc.tr","tt","co.tt","com.tt","org.tt","net.tt","biz.tt","info.tt","pro.tt","int.tt","coop.tt","jobs.tt","mobi.tt","travel.tt","museum.tt","aero.tt","name.tt","gov.tt","edu.tt","tv","tw","edu.tw","gov.tw","mil.tw","com.tw","net.tw","org.tw","idv.tw","game.tw","ebiz.tw","club.tw","網路.tw","組織.tw","商業.tw","tz","ac.tz","co.tz","go.tz","hotel.tz","info.tz","me.tz","mil.tz","mobi.tz","ne.tz","or.tz","sc.tz","tv.tz","ua","com.ua","edu.ua","gov.ua","in.ua","net.ua","org.ua","cherkassy.ua","cherkasy.ua","chernigov.ua","chernihiv.ua","chernivtsi.ua","chernovtsy.ua","ck.ua","cn.ua","cr.ua","crimea.ua","cv.ua","dn.ua","dnepropetrovsk.ua","dnipropetrovsk.ua","dominic.ua","donetsk.ua","dp.ua","if.ua","ivano-frankivsk.ua","kh.ua","kharkiv.ua","kharkov.ua","kherson.ua","khmelnitskiy.ua","khmelnytskyi.ua","kiev.ua","kirovograd.ua","km.ua","kr.ua","krym.ua","ks.ua","kv.ua","kyiv.ua","lg.ua","lt.ua","lugansk.ua","lutsk.ua","lv.ua","lviv.ua","mk.ua","mykolaiv.ua","nikolaev.ua","od.ua","odesa.ua","odessa.ua","pl.ua","poltava.ua","rivne.ua","rovno.ua","rv.ua","sb.ua","sebastopol.ua","sevastopol.ua","sm.ua","sumy.ua","te.ua","ternopil.ua","uz.ua","uzhgorod.ua","vinnica.ua","vinnytsia.ua","vn.ua","volyn.ua","yalta.ua","zaporizhzhe.ua","zaporizhzhia.ua","zhitomir.ua","zhytomyr.ua","zp.ua","zt.ua","ug","co.ug","or.ug","ac.ug","sc.ug","go.ug","ne.ug","com.ug","org.ug","uk","ac.uk","co.uk","gov.uk","ltd.uk","me.uk","net.uk","nhs.uk","org.uk","plc.uk","police.uk","*.sch.uk","us","dni.us","fed.us","isa.us","kids.us","nsn.us","ak.us","al.us","ar.us","as.us","az.us","ca.us","co.us","ct.us","dc.us","de.us","fl.us","ga.us","gu.us","hi.us","ia.us","id.us","il.us","in.us","ks.us","ky.us","la.us","ma.us","md.us","me.us","mi.us","mn.us","mo.us","ms.us","mt.us","nc.us","nd.us","ne.us","nh.us","nj.us","nm.us","nv.us","ny.us","oh.us","ok.us","or.us","pa.us","pr.us","ri.us","sc.us","sd.us","tn.us","tx.us","ut.us","vi.us","vt.us","va.us","wa.us","wi.us","wv.us","wy.us","k12.ak.us","k12.al.us","k12.ar.us","k12.as.us","k12.az.us","k12.ca.us","k12.co.us","k12.ct.us","k12.dc.us","k12.de.us","k12.fl.us","k12.ga.us","k12.gu.us","k12.ia.us","k12.id.us","k12.il.us","k12.in.us","k12.ks.us","k12.ky.us","k12.la.us","k12.ma.us","k12.md.us","k12.me.us","k12.mi.us","k12.mn.us","k12.mo.us","k12.ms.us","k12.mt.us","k12.nc.us","k12.ne.us","k12.nh.us","k12.nj.us","k12.nm.us","k12.nv.us","k12.ny.us","k12.oh.us","k12.ok.us","k12.or.us","k12.pa.us","k12.pr.us","k12.ri.us","k12.sc.us","k12.tn.us","k12.tx.us","k12.ut.us","k12.vi.us","k12.vt.us","k12.va.us","k12.wa.us","k12.wi.us","k12.wy.us","cc.ak.us","cc.al.us","cc.ar.us","cc.as.us","cc.az.us","cc.ca.us","cc.co.us","cc.ct.us","cc.dc.us","cc.de.us","cc.fl.us","cc.ga.us","cc.gu.us","cc.hi.us","cc.ia.us","cc.id.us","cc.il.us","cc.in.us","cc.ks.us","cc.ky.us","cc.la.us","cc.ma.us","cc.md.us","cc.me.us","cc.mi.us","cc.mn.us","cc.mo.us","cc.ms.us","cc.mt.us","cc.nc.us","cc.nd.us","cc.ne.us","cc.nh.us","cc.nj.us","cc.nm.us","cc.nv.us","cc.ny.us","cc.oh.us","cc.ok.us","cc.or.us","cc.pa.us","cc.pr.us","cc.ri.us","cc.sc.us","cc.sd.us","cc.tn.us","cc.tx.us","cc.ut.us","cc.vi.us","cc.vt.us","cc.va.us","cc.wa.us","cc.wi.us","cc.wv.us","cc.wy.us","lib.ak.us","lib.al.us","lib.ar.us","lib.as.us","lib.az.us","lib.ca.us","lib.co.us","lib.ct.us","lib.dc.us","lib.fl.us","lib.ga.us","lib.gu.us","lib.hi.us","lib.ia.us","lib.id.us","lib.il.us","lib.in.us","lib.ks.us","lib.ky.us","lib.la.us","lib.ma.us","lib.md.us","lib.me.us","lib.mi.us","lib.mn.us","lib.mo.us","lib.ms.us","lib.mt.us","lib.nc.us","lib.nd.us","lib.ne.us","lib.nh.us","lib.nj.us","lib.nm.us","lib.nv.us","lib.ny.us","lib.oh.us","lib.ok.us","lib.or.us","lib.pa.us","lib.pr.us","lib.ri.us","lib.sc.us","lib.sd.us","lib.tn.us","lib.tx.us","lib.ut.us","lib.vi.us","lib.vt.us","lib.va.us","lib.wa.us","lib.wi.us","lib.wy.us","pvt.k12.ma.us","chtr.k12.ma.us","paroch.k12.ma.us","ann-arbor.mi.us","cog.mi.us","dst.mi.us","eaton.mi.us","gen.mi.us","mus.mi.us","tec.mi.us","washtenaw.mi.us","uy","com.uy","edu.uy","gub.uy","mil.uy","net.uy","org.uy","uz","co.uz","com.uz","net.uz","org.uz","va","vc","com.vc","net.vc","org.vc","gov.vc","mil.vc","edu.vc","ve","arts.ve","co.ve","com.ve","e12.ve","edu.ve","firm.ve","gob.ve","gov.ve","info.ve","int.ve","mil.ve","net.ve","org.ve","rec.ve","store.ve","tec.ve","web.ve","vg","vi","co.vi","com.vi","k12.vi","net.vi","org.vi","vn","com.vn","net.vn","org.vn","edu.vn","gov.vn","int.vn","ac.vn","biz.vn","info.vn","name.vn","pro.vn","health.vn","vu","com.vu","edu.vu","net.vu","org.vu","wf","ws","com.ws","net.ws","org.ws","gov.ws","edu.ws","yt","امارات","հայ","বাংলা","бг","бел","中国","中國","الجزائر","مصر","ею","გე","ελ","香港","公司.香港","教育.香港","政府.香港","個人.香港","網絡.香港","組織.香港","ಭಾರತ","ଭାରତ","ভাৰত","भारतम्","भारोत","ڀارت","ഭാരതം","भारत","بارت","بھارت","భారత్","ભારત","ਭਾਰਤ","ভারত","இந்தியா","ایران","ايران","عراق","الاردن","한국","қаз","ලංකා","இலங்கை","المغرب","мкд","мон","澳門","澳门","مليسيا","عمان","پاکستان","پاكستان","فلسطين","срб","пр.срб","орг.срб","обр.срб","од.срб","упр.срб","ак.срб","рф","قطر","السعودية","السعودیة","السعودیۃ","السعوديه","سودان","新加坡","சிங்கப்பூர்","سورية","سوريا","ไทย","ศึกษา.ไทย","ธุรกิจ.ไทย","รัฐบาล.ไทย","ทหาร.ไทย","เน็ต.ไทย","องค์กร.ไทย","تونس","台灣","台湾","臺灣","укр","اليمن","xxx","*.ye","ac.za","agric.za","alt.za","co.za","edu.za","gov.za","grondar.za","law.za","mil.za","net.za","ngo.za","nis.za","nom.za","org.za","school.za","tm.za","web.za","zm","ac.zm","biz.zm","co.zm","com.zm","edu.zm","gov.zm","info.zm","mil.zm","net.zm","org.zm","sch.zm","zw","ac.zw","co.zw","gov.zw","mil.zw","org.zw","aaa","aarp","abarth","abb","abbott","abbvie","abc","able","abogado","abudhabi","academy","accenture","accountant","accountants","aco","active","actor","adac","ads","adult","aeg","aetna","afamilycompany","afl","africa","agakhan","agency","aig","aigo","airbus","airforce","airtel","akdn","alfaromeo","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","aol","apartments","app","apple","aquarelle","arab","aramco","archi","army","art","arte","asda","associates","athleta","attorney","auction","audi","audible","audio","auspost","author","auto","autos","avianca","aws","axa","azure","baby","baidu","banamex","bananarepublic","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bbc","bbt","bbva","bcg","bcn","beats","beauty","beer","bentley","berlin","best","bestbuy","bet","bharti","bible","bid","bike","bing","bingo","bio","black","blackfriday","blanco","blockbuster","blog","bloomberg","blue","bms","bmw","bnl","bnpparibas","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","bradesco","bridgestone","broadway","broker","brother","brussels","budapest","bugatti","build","builders","business","buy","buzz","bzh","cab","cafe","cal","call","calvinklein","cam","camera","camp","cancerresearch","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","cartier","casa","case","caseih","cash","casino","catering","catholic","cba","cbn","cbre","cbs","ceb","center","ceo","cern","cfa","cfd","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","chrysler","church","cipriani","circle","cisco","citadel","citi","citic","city","cityeats","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","coach","codes","coffee","college","cologne","comcast","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cookingchannel","cool","corsica","country","coupon","coupons","courses","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","csc","cuisinella","cymru","cyou","dabur","dad","dance","data","date","dating","datsun","day","dclk","dds","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dnp","docs","doctor","dodge","dog","doha","domains","dot","download","drive","dtv","dubai","duck","dunlop","duns","dupont","durban","dvag","dvr","earth","eat","eco","edeka","education","email","emerck","energy","engineer","engineering","enterprises","epost","epson","equipment","ericsson","erni","esq","estate","esurance","etisalat","eurovision","eus","events","everbank","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fiat","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","flickr","flights","flir","florist","flowers","fly","foo","food","foodnetwork","football","ford","forex","forsale","forum","foundation","fox","free","fresenius","frl","frogans","frontdoor","frontier","ftr","fujitsu","fujixerox","fun","fund","furniture","futbol","fyi","gal","gallery","gallo","gallup","game","games","gap","garden","gbiz","gdn","gea","gent","genting","george","ggee","gift","gifts","gives","giving","glade","glass","gle","global","globo","gmail","gmbh","gmo","gmx","godaddy","gold","goldpoint","golf","goo","goodhands","goodyear","goog","google","gop","got","grainger","graphics","gratis","green","gripe","grocery","group","guardian","gucci","guge","guide","guitars","guru","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hgtv","hiphop","hisamitsu","hitachi","hiv","hkt","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","honeywell","horse","hospital","host","hosting","hot","hoteles","hotels","hotmail","house","how","hsbc","hughes","hyatt","hyundai","ibm","icbc","ice","icu","ieee","ifm","ikano","imamat","imdb","immo","immobilien","inc","industries","infiniti","ing","ink","institute","insurance","insure","intel","international","intuit","investments","ipiranga","irish","iselect","ismaili","ist","istanbul","itau","itv","iveco","jaguar","java","jcb","jcp","jeep","jetzt","jewelry","jio","jlc","jll","jmp","jnj","joburg","jot","joy","jpmorgan","jprs","juegos","juniper","kaufen","kddi","kerryhotels","kerrylogistics","kerryproperties","kfh","kia","kim","kinder","kindle","kitchen","kiwi","koeln","komatsu","kosher","kpmg","kpn","krd","kred","kuokgroup","kyoto","lacaixa","ladbrokes","lamborghini","lamer","lancaster","lancia","lancome","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","liaison","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","linde","link","lipsy","live","living","lixil","llc","loan","loans","locker","locus","loft","lol","london","lotte","lotto","love","lpl","lplfinancial","ltd","ltda","lundbeck","lupin","luxe","luxury","macys","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","maserati","mattel","mba","mckinsey","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","metlife","miami","microsoft","mini","mint","mit","mitsubishi","mlb","mls","mma","mobile","mobily","moda","moe","moi","mom","monash","money","monster","mopar","mormon","mortgage","moscow","moto","motorcycles","mov","movie","movistar","msd","mtn","mtr","mutual","nab","nadex","nagoya","nationwide","natura","navy","nba","nec","netbank","netflix","network","neustar","new","newholland","news","next","nextdirect","nexus","nfl","ngo","nhk","nico","nike","nikon","ninja","nissan","nissay","nokia","northwesternmutual","norton","now","nowruz","nowtv","nra","nrw","ntt","nyc","obi","observer","off","office","okinawa","olayan","olayangroup","oldnavy","ollo","omega","one","ong","onl","online","onyourside","ooo","open","oracle","orange","organic","origins","osaka","otsuka","ott","ovh","page","panasonic","panerai","paris","pars","partners","parts","party","passagens","pay","pccw","pet","pfizer","pharmacy","phd","philips","phone","photo","photography","photos","physio","piaget","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","place","play","playstation","plumbing","plus","pnc","pohl","poker","politie","porn","pramerica","praxi","press","prime","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","pub","pwc","qpon","quebec","quest","qvc","racing","radio","raid","read","realestate","realtor","realty","recipes","red","redstone","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","rightathome","ril","rio","rip","rmit","rocher","rocks","rodeo","rogers","room","rsvp","rugby","ruhr","run","rwe","ryukyu","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sbi","sbs","sca","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scjohnson","scor","scot","search","seat","secure","security","seek","select","sener","services","ses","seven","sew","sex","sexy","sfr","shangrila","sharp","shaw","shell","shia","shiksha","shoes","shop","shopping","shouji","show","showtime","shriram","silk","sina","singles","site","ski","skin","sky","skype","sling","smart","smile","sncf","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","space","spiegel","sport","spot","spreadbetting","srl","srt","stada","staples","star","starhub","statebank","statefarm","statoil","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","sucks","supplies","supply","support","surf","surgery","suzuki","swatch","swiftcover","swiss","sydney","symantec","systems","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tci","tdk","team","tech","technology","telecity","telefonica","temasek","tennis","teva","thd","theater","theatre","tiaa","tickets","tienda","tiffany","tips","tires","tirol","tjmaxx","tjx","tkmaxx","tmall","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","trade","trading","training","travel","travelchannel","travelers","travelersinsurance","trust","trv","tube","tui","tunes","tushu","tvs","ubank","ubs","uconnect","unicom","university","uno","uol","ups","vacations","vana","vanguard","vegas","ventures","verisign","versicherung","vet","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","vista","vistaprint","viva","vivo","vlaanderen","vodka","volkswagen","volvo","vote","voting","voto","voyage","vuelos","wales","walmart","walter","wang","wanggou","warman","watch","watches","weather","weatherchannel","webcam","weber","website","wed","wedding","weibo","weir","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","wtc","wtf","xbox","xerox","xfinity","xihuan","xin","कॉम","セール","佛山","慈善","集团","在线","大众汽车","点看","คอม","八卦","موقع","公益","公司","香格里拉","网站","移动","我爱你","москва","католик","онлайн","сайт","联通","קום","时尚","微博","淡马锡","ファッション","орг","नेट","ストア","삼성","商标","商店","商城","дети","ポイント","新闻","工行","家電","كوم","中文网","中信","娱乐","谷歌","電訊盈科","购物","クラウド","通販","网店","संगठन","餐厅","网络","ком","诺基亚","食品","飞利浦","手表","手机","ارامكو","العليان","اتصالات","بازار","موبايلي","ابوظبي","كاثوليك","همراه","닷컴","政府","شبكة","بيتك","عرب","机构","组织机构","健康","招聘","рус","珠宝","大拿","みんな","グーグル","世界","書籍","网址","닷넷","コム","天主教","游戏","vermögensberater","vermögensberatung","企业","信息","嘉里大酒店","嘉里","广东","政务","xyz","yachts","yahoo","yamaxun","yandex","yodobashi","yoga","yokohama","you","youtube","yun","zappos","zara","zero","zip","zippo","zone","zuerich","cc.ua","inf.ua","ltd.ua","beep.pl","*.compute.estate","*.alces.network","alwaysdata.net","cloudfront.net","*.compute.amazonaws.com","*.compute-1.amazonaws.com","*.compute.amazonaws.com.cn","us-east-1.amazonaws.com","cn-north-1.eb.amazonaws.com.cn","elasticbeanstalk.com","ap-northeast-1.elasticbeanstalk.com","ap-northeast-2.elasticbeanstalk.com","ap-northeast-3.elasticbeanstalk.com","ap-south-1.elasticbeanstalk.com","ap-southeast-1.elasticbeanstalk.com","ap-southeast-2.elasticbeanstalk.com","ca-central-1.elasticbeanstalk.com","eu-central-1.elasticbeanstalk.com","eu-west-1.elasticbeanstalk.com","eu-west-2.elasticbeanstalk.com","eu-west-3.elasticbeanstalk.com","sa-east-1.elasticbeanstalk.com","us-east-1.elasticbeanstalk.com","us-east-2.elasticbeanstalk.com","us-gov-west-1.elasticbeanstalk.com","us-west-1.elasticbeanstalk.com","us-west-2.elasticbeanstalk.com","*.elb.amazonaws.com","*.elb.amazonaws.com.cn","s3.amazonaws.com","s3-ap-northeast-1.amazonaws.com","s3-ap-northeast-2.amazonaws.com","s3-ap-south-1.amazonaws.com","s3-ap-southeast-1.amazonaws.com","s3-ap-southeast-2.amazonaws.com","s3-ca-central-1.amazonaws.com","s3-eu-central-1.amazonaws.com","s3-eu-west-1.amazonaws.com","s3-eu-west-2.amazonaws.com","s3-eu-west-3.amazonaws.com","s3-external-1.amazonaws.com","s3-fips-us-gov-west-1.amazonaws.com","s3-sa-east-1.amazonaws.com","s3-us-gov-west-1.amazonaws.com","s3-us-east-2.amazonaws.com","s3-us-west-1.amazonaws.com","s3-us-west-2.amazonaws.com","s3.ap-northeast-2.amazonaws.com","s3.ap-south-1.amazonaws.com","s3.cn-north-1.amazonaws.com.cn","s3.ca-central-1.amazonaws.com","s3.eu-central-1.amazonaws.com","s3.eu-west-2.amazonaws.com","s3.eu-west-3.amazonaws.com","s3.us-east-2.amazonaws.com","s3.dualstack.ap-northeast-1.amazonaws.com","s3.dualstack.ap-northeast-2.amazonaws.com","s3.dualstack.ap-south-1.amazonaws.com","s3.dualstack.ap-southeast-1.amazonaws.com","s3.dualstack.ap-southeast-2.amazonaws.com","s3.dualstack.ca-central-1.amazonaws.com","s3.dualstack.eu-central-1.amazonaws.com","s3.dualstack.eu-west-1.amazonaws.com","s3.dualstack.eu-west-2.amazonaws.com","s3.dualstack.eu-west-3.amazonaws.com","s3.dualstack.sa-east-1.amazonaws.com","s3.dualstack.us-east-1.amazonaws.com","s3.dualstack.us-east-2.amazonaws.com","s3-website-us-east-1.amazonaws.com","s3-website-us-west-1.amazonaws.com","s3-website-us-west-2.amazonaws.com","s3-website-ap-northeast-1.amazonaws.com","s3-website-ap-southeast-1.amazonaws.com","s3-website-ap-southeast-2.amazonaws.com","s3-website-eu-west-1.amazonaws.com","s3-website-sa-east-1.amazonaws.com","s3-website.ap-northeast-2.amazonaws.com","s3-website.ap-south-1.amazonaws.com","s3-website.ca-central-1.amazonaws.com","s3-website.eu-central-1.amazonaws.com","s3-website.eu-west-2.amazonaws.com","s3-website.eu-west-3.amazonaws.com","s3-website.us-east-2.amazonaws.com","t3l3p0rt.net","tele.amune.org","on-aptible.com","user.party.eus","pimienta.org","poivron.org","potager.org","sweetpepper.org","myasustor.com","myfritz.net","*.awdev.ca","*.advisor.ws","backplaneapp.io","betainabox.com","bnr.la","blackbaudcdn.net","boomla.net","boxfuse.io","square7.ch","bplaced.com","bplaced.de","square7.de","bplaced.net","square7.net","browsersafetymark.io","mycd.eu","ae.org","ar.com","br.com","cn.com","com.de","com.se","de.com","eu.com","gb.com","gb.net","hu.com","hu.net","jp.net","jpn.com","kr.com","mex.com","no.com","qc.com","ru.com","sa.com","se.net","uk.com","uk.net","us.com","uy.com","za.bz","za.com","africa.com","gr.com","in.net","us.org","co.com","c.la","certmgr.org","xenapponazure.com","virtueeldomein.nl","cleverapps.io","c66.me","cloud66.ws","jdevcloud.com","wpdevcloud.com","cloudaccess.host","freesite.host","cloudaccess.net","cloudcontrolled.com","cloudcontrolapp.com","co.ca","*.otap.co","co.cz","c.cdn77.org","cdn77-ssl.net","r.cdn77.net","rsc.cdn77.org","ssl.origin.cdn77-secure.org","cloudns.asia","cloudns.biz","cloudns.club","cloudns.cc","cloudns.eu","cloudns.in","cloudns.info","cloudns.org","cloudns.pro","cloudns.pw","cloudns.us","cloudeity.net","cnpy.gdn","co.nl","co.no","webhosting.be","hosting-cluster.nl","dyn.cosidns.de","dynamisches-dns.de","dnsupdater.de","internet-dns.de","l-o-g-i-n.de","dynamic-dns.info","feste-ip.net","knx-server.net","static-access.net","realm.cz","*.cryptonomic.net","cupcake.is","cyon.link","cyon.site","daplie.me","localhost.daplie.me","dattolocal.com","dattorelay.com","dattoweb.com","mydatto.com","dattolocal.net","mydatto.net","biz.dk","co.dk","firm.dk","reg.dk","store.dk","debian.net","dedyn.io","dnshome.de","drayddns.com","dreamhosters.com","mydrobo.com","drud.io","drud.us","duckdns.org","dy.fi","tunk.org","dyndns-at-home.com","dyndns-at-work.com","dyndns-blog.com","dyndns-free.com","dyndns-home.com","dyndns-ip.com","dyndns-mail.com","dyndns-office.com","dyndns-pics.com","dyndns-remote.com","dyndns-server.com","dyndns-web.com","dyndns-wiki.com","dyndns-work.com","dyndns.biz","dyndns.info","dyndns.org","dyndns.tv","at-band-camp.net","ath.cx","barrel-of-knowledge.info","barrell-of-knowledge.info","better-than.tv","blogdns.com","blogdns.net","blogdns.org","blogsite.org","boldlygoingnowhere.org","broke-it.net","buyshouses.net","cechire.com","dnsalias.com","dnsalias.net","dnsalias.org","dnsdojo.com","dnsdojo.net","dnsdojo.org","does-it.net","doesntexist.com","doesntexist.org","dontexist.com","dontexist.net","dontexist.org","doomdns.com","doomdns.org","dvrdns.org","dyn-o-saur.com","dynalias.com","dynalias.net","dynalias.org","dynathome.net","dyndns.ws","endofinternet.net","endofinternet.org","endoftheinternet.org","est-a-la-maison.com","est-a-la-masion.com","est-le-patron.com","est-mon-blogueur.com","for-better.biz","for-more.biz","for-our.info","for-some.biz","for-the.biz","forgot.her.name","forgot.his.name","from-ak.com","from-al.com","from-ar.com","from-az.net","from-ca.com","from-co.net","from-ct.com","from-dc.com","from-de.com","from-fl.com","from-ga.com","from-hi.com","from-ia.com","from-id.com","from-il.com","from-in.com","from-ks.com","from-ky.com","from-la.net","from-ma.com","from-md.com","from-me.org","from-mi.com","from-mn.com","from-mo.com","from-ms.com","from-mt.com","from-nc.com","from-nd.com","from-ne.com","from-nh.com","from-nj.com","from-nm.com","from-nv.com","from-ny.net","from-oh.com","from-ok.com","from-or.com","from-pa.com","from-pr.com","from-ri.com","from-sc.com","from-sd.com","from-tn.com","from-tx.com","from-ut.com","from-va.com","from-vt.com","from-wa.com","from-wi.com","from-wv.com","from-wy.com","ftpaccess.cc","fuettertdasnetz.de","game-host.org","game-server.cc","getmyip.com","gets-it.net","go.dyndns.org","gotdns.com","gotdns.org","groks-the.info","groks-this.info","ham-radio-op.net","here-for-more.info","hobby-site.com","hobby-site.org","home.dyndns.org","homedns.org","homeftp.net","homeftp.org","homeip.net","homelinux.com","homelinux.net","homelinux.org","homeunix.com","homeunix.net","homeunix.org","iamallama.com","in-the-band.net","is-a-anarchist.com","is-a-blogger.com","is-a-bookkeeper.com","is-a-bruinsfan.org","is-a-bulls-fan.com","is-a-candidate.org","is-a-caterer.com","is-a-celticsfan.org","is-a-chef.com","is-a-chef.net","is-a-chef.org","is-a-conservative.com","is-a-cpa.com","is-a-cubicle-slave.com","is-a-democrat.com","is-a-designer.com","is-a-doctor.com","is-a-financialadvisor.com","is-a-geek.com","is-a-geek.net","is-a-geek.org","is-a-green.com","is-a-guru.com","is-a-hard-worker.com","is-a-hunter.com","is-a-knight.org","is-a-landscaper.com","is-a-lawyer.com","is-a-liberal.com","is-a-libertarian.com","is-a-linux-user.org","is-a-llama.com","is-a-musician.com","is-a-nascarfan.com","is-a-nurse.com","is-a-painter.com","is-a-patsfan.org","is-a-personaltrainer.com","is-a-photographer.com","is-a-player.com","is-a-republican.com","is-a-rockstar.com","is-a-socialist.com","is-a-soxfan.org","is-a-student.com","is-a-teacher.com","is-a-techie.com","is-a-therapist.com","is-an-accountant.com","is-an-actor.com","is-an-actress.com","is-an-anarchist.com","is-an-artist.com","is-an-engineer.com","is-an-entertainer.com","is-by.us","is-certified.com","is-found.org","is-gone.com","is-into-anime.com","is-into-cars.com","is-into-cartoons.com","is-into-games.com","is-leet.com","is-lost.org","is-not-certified.com","is-saved.org","is-slick.com","is-uberleet.com","is-very-bad.org","is-very-evil.org","is-very-good.org","is-very-nice.org","is-very-sweet.org","is-with-theband.com","isa-geek.com","isa-geek.net","isa-geek.org","isa-hockeynut.com","issmarterthanyou.com","isteingeek.de","istmein.de","kicks-ass.net","kicks-ass.org","knowsitall.info","land-4-sale.us","lebtimnetz.de","leitungsen.de","likes-pie.com","likescandy.com","merseine.nu","mine.nu","misconfused.org","mypets.ws","myphotos.cc","neat-url.com","office-on-the.net","on-the-web.tv","podzone.net","podzone.org","readmyblog.org","saves-the-whales.com","scrapper-site.net","scrapping.cc","selfip.biz","selfip.com","selfip.info","selfip.net","selfip.org","sells-for-less.com","sells-for-u.com","sells-it.net","sellsyourhome.org","servebbs.com","servebbs.net","servebbs.org","serveftp.net","serveftp.org","servegame.org","shacknet.nu","simple-url.com","space-to-rent.com","stuff-4-sale.org","stuff-4-sale.us","teaches-yoga.com","thruhere.net","traeumtgerade.de","webhop.biz","webhop.info","webhop.net","webhop.org","worse-than.tv","writesthisblog.com","ddnss.de","dyn.ddnss.de","dyndns.ddnss.de","dyndns1.de","dyn-ip24.de","home-webserver.de","dyn.home-webserver.de","myhome-server.de","ddnss.org","definima.net","definima.io","bci.dnstrace.pro","ddnsfree.com","ddnsgeek.com","giize.com","gleeze.com","kozow.com","loseyourip.com","ooguy.com","theworkpc.com","casacam.net","dynu.net","accesscam.org","camdvr.org","freeddns.org","mywire.org","webredirect.org","myddns.rocks","blogsite.xyz","dynv6.net","e4.cz","mytuleap.com","enonic.io","customer.enonic.io","eu.org","al.eu.org","asso.eu.org","at.eu.org","au.eu.org","be.eu.org","bg.eu.org","ca.eu.org","cd.eu.org","ch.eu.org","cn.eu.org","cy.eu.org","cz.eu.org","de.eu.org","dk.eu.org","edu.eu.org","ee.eu.org","es.eu.org","fi.eu.org","fr.eu.org","gr.eu.org","hr.eu.org","hu.eu.org","ie.eu.org","il.eu.org","in.eu.org","int.eu.org","is.eu.org","it.eu.org","jp.eu.org","kr.eu.org","lt.eu.org","lu.eu.org","lv.eu.org","mc.eu.org","me.eu.org","mk.eu.org","mt.eu.org","my.eu.org","net.eu.org","ng.eu.org","nl.eu.org","no.eu.org","nz.eu.org","paris.eu.org","pl.eu.org","pt.eu.org","q-a.eu.org","ro.eu.org","ru.eu.org","se.eu.org","si.eu.org","sk.eu.org","tr.eu.org","uk.eu.org","us.eu.org","eu-1.evennode.com","eu-2.evennode.com","eu-3.evennode.com","eu-4.evennode.com","us-1.evennode.com","us-2.evennode.com","us-3.evennode.com","us-4.evennode.com","twmail.cc","twmail.net","twmail.org","mymailer.com.tw","url.tw","apps.fbsbx.com","ru.net","adygeya.ru","bashkiria.ru","bir.ru","cbg.ru","com.ru","dagestan.ru","grozny.ru","kalmykia.ru","kustanai.ru","marine.ru","mordovia.ru","msk.ru","mytis.ru","nalchik.ru","nov.ru","pyatigorsk.ru","spb.ru","vladikavkaz.ru","vladimir.ru","abkhazia.su","adygeya.su","aktyubinsk.su","arkhangelsk.su","armenia.su","ashgabad.su","azerbaijan.su","balashov.su","bashkiria.su","bryansk.su","bukhara.su","chimkent.su","dagestan.su","east-kazakhstan.su","exnet.su","georgia.su","grozny.su","ivanovo.su","jambyl.su","kalmykia.su","kaluga.su","karacol.su","karaganda.su","karelia.su","khakassia.su","krasnodar.su","kurgan.su","kustanai.su","lenug.su","mangyshlak.su","mordovia.su","msk.su","murmansk.su","nalchik.su","navoi.su","north-kazakhstan.su","nov.su","obninsk.su","penza.su","pokrovsk.su","sochi.su","spb.su","tashkent.su","termez.su","togliatti.su","troitsk.su","tselinograd.su","tula.su","tuva.su","vladikavkaz.su","vladimir.su","vologda.su","channelsdvr.net","fastlylb.net","map.fastlylb.net","freetls.fastly.net","map.fastly.net","a.prod.fastly.net","global.prod.fastly.net","a.ssl.fastly.net","b.ssl.fastly.net","global.ssl.fastly.net","fastpanel.direct","fastvps-server.com","fhapp.xyz","fedorainfracloud.org","fedorapeople.org","cloud.fedoraproject.org","app.os.fedoraproject.org","app.os.stg.fedoraproject.org","filegear.me","firebaseapp.com","flynnhub.com","flynnhosting.net","freebox-os.com","freeboxos.com","fbx-os.fr","fbxos.fr","freebox-os.fr","freeboxos.fr","freedesktop.org","*.futurecms.at","*.ex.futurecms.at","*.in.futurecms.at","futurehosting.at","futuremailing.at","*.ex.ortsinfo.at","*.kunden.ortsinfo.at","*.statics.cloud","service.gov.uk","github.io","githubusercontent.com","gitlab.io","homeoffice.gov.uk","ro.im","shop.ro","goip.de","*.0emm.com","appspot.com","blogspot.ae","blogspot.al","blogspot.am","blogspot.ba","blogspot.be","blogspot.bg","blogspot.bj","blogspot.ca","blogspot.cf","blogspot.ch","blogspot.cl","blogspot.co.at","blogspot.co.id","blogspot.co.il","blogspot.co.ke","blogspot.co.nz","blogspot.co.uk","blogspot.co.za","blogspot.com","blogspot.com.ar","blogspot.com.au","blogspot.com.br","blogspot.com.by","blogspot.com.co","blogspot.com.cy","blogspot.com.ee","blogspot.com.eg","blogspot.com.es","blogspot.com.mt","blogspot.com.ng","blogspot.com.tr","blogspot.com.uy","blogspot.cv","blogspot.cz","blogspot.de","blogspot.dk","blogspot.fi","blogspot.fr","blogspot.gr","blogspot.hk","blogspot.hr","blogspot.hu","blogspot.ie","blogspot.in","blogspot.is","blogspot.it","blogspot.jp","blogspot.kr","blogspot.li","blogspot.lt","blogspot.lu","blogspot.md","blogspot.mk","blogspot.mr","blogspot.mx","blogspot.my","blogspot.nl","blogspot.no","blogspot.pe","blogspot.pt","blogspot.qa","blogspot.re","blogspot.ro","blogspot.rs","blogspot.ru","blogspot.se","blogspot.sg","blogspot.si","blogspot.sk","blogspot.sn","blogspot.td","blogspot.tw","blogspot.ug","blogspot.vn","cloudfunctions.net","cloud.goog","codespot.com","googleapis.com","googlecode.com","pagespeedmobilizer.com","publishproxy.com","withgoogle.com","withyoutube.com","hashbang.sh","hasura.app","hasura-app.io","hepforge.org","herokuapp.com","herokussl.com","myravendb.com","ravendb.community","ravendb.me","development.run","ravendb.run","moonscale.net","iki.fi","biz.at","info.at","info.cx","ac.leg.br","al.leg.br","am.leg.br","ap.leg.br","ba.leg.br","ce.leg.br","df.leg.br","es.leg.br","go.leg.br","ma.leg.br","mg.leg.br","ms.leg.br","mt.leg.br","pa.leg.br","pb.leg.br","pe.leg.br","pi.leg.br","pr.leg.br","rj.leg.br","rn.leg.br","ro.leg.br","rr.leg.br","rs.leg.br","sc.leg.br","se.leg.br","sp.leg.br","to.leg.br","pixolino.com","ipifony.net","mein-iserv.de","test-iserv.de","myjino.ru","*.hosting.myjino.ru","*.landing.myjino.ru","*.spectrum.myjino.ru","*.vps.myjino.ru","*.triton.zone","*.cns.joyent.com","js.org","keymachine.de","knightpoint.systems","co.krd","edu.krd","git-repos.de","lcube-server.de","svn-repos.de","app.lmpm.com","linkitools.space","linkyard.cloud","linkyard-cloud.ch","we.bs","uklugs.org","glug.org.uk","lug.org.uk","lugs.org.uk","barsy.bg","barsy.co.uk","barsyonline.co.uk","barsycenter.com","barsyonline.com","barsy.club","barsy.de","barsy.eu","barsy.in","barsy.info","barsy.io","barsy.me","barsy.menu","barsy.mobi","barsy.net","barsy.online","barsy.org","barsy.pro","barsy.pub","barsy.shop","barsy.site","barsy.support","barsy.uk","*.magentosite.cloud","mayfirst.info","mayfirst.org","hb.cldmail.ru","miniserver.com","memset.net","cloud.metacentrum.cz","custom.metacentrum.cz","flt.cloud.muni.cz","usr.cloud.muni.cz","meteorapp.com","eu.meteorapp.com","co.pl","azurecontainer.io","azurewebsites.net","azure-mobile.net","cloudapp.net","mozilla-iot.org","bmoattachments.org","net.ru","org.ru","pp.ru","bitballoon.com","netlify.com","4u.com","ngrok.io","nh-serv.co.uk","nfshost.com","dnsking.ch","mypi.co","n4t.co","001www.com","ddnslive.com","myiphost.com","forumz.info","16-b.it","32-b.it","64-b.it","soundcast.me","tcp4.me","dnsup.net","hicam.net","now-dns.net","ownip.net","vpndns.net","dynserv.org","now-dns.org","x443.pw","now-dns.top","ntdll.top","freeddns.us","crafting.xyz","zapto.xyz","nsupdate.info","nerdpol.ovh","blogsyte.com","brasilia.me","cable-modem.org","ciscofreak.com","collegefan.org","couchpotatofries.org","damnserver.com","ddns.me","ditchyourip.com","dnsfor.me","dnsiskinky.com","dvrcam.info","dynns.com","eating-organic.net","fantasyleague.cc","geekgalaxy.com","golffan.us","health-carereform.com","homesecuritymac.com","homesecuritypc.com","hopto.me","ilovecollege.info","loginto.me","mlbfan.org","mmafan.biz","myactivedirectory.com","mydissent.net","myeffect.net","mymediapc.net","mypsx.net","mysecuritycamera.com","mysecuritycamera.net","mysecuritycamera.org","net-freaks.com","nflfan.org","nhlfan.net","no-ip.ca","no-ip.co.uk","no-ip.net","noip.us","onthewifi.com","pgafan.net","point2this.com","pointto.us","privatizehealthinsurance.net","quicksytes.com","read-books.org","securitytactics.com","serveexchange.com","servehumour.com","servep2p.com","servesarcasm.com","stufftoread.com","ufcfan.org","unusualperson.com","workisboring.com","3utilities.com","bounceme.net","ddns.net","ddnsking.com","gotdns.ch","hopto.org","myftp.biz","myftp.org","myvnc.com","no-ip.biz","no-ip.info","no-ip.org","noip.me","redirectme.net","servebeer.com","serveblog.net","servecounterstrike.com","serveftp.com","servegame.com","servehalflife.com","servehttp.com","serveirc.com","serveminecraft.net","servemp3.com","servepics.com","servequake.com","sytes.net","webhop.me","zapto.org","stage.nodeart.io","nodum.co","nodum.io","pcloud.host","nyc.mn","nom.ae","nom.af","nom.ai","nom.al","nym.by","nym.bz","nom.cl","nom.gd","nom.ge","nom.gl","nym.gr","nom.gt","nym.gy","nom.hn","nym.ie","nom.im","nom.ke","nym.kz","nym.la","nym.lc","nom.li","nym.li","nym.lt","nym.lu","nym.me","nom.mk","nym.mn","nym.mx","nom.nu","nym.nz","nym.pe","nym.pt","nom.pw","nom.qa","nym.ro","nom.rs","nom.si","nym.sk","nom.st","nym.su","nym.sx","nom.tj","nym.tw","nom.ug","nom.uy","nom.vc","nom.vg","cya.gg","cloudycluster.net","nid.io","opencraft.hosting","operaunite.com","outsystemscloud.com","ownprovider.com","own.pm","ox.rs","oy.lc","pgfog.com","pagefrontapp.com","art.pl","gliwice.pl","krakow.pl","poznan.pl","wroc.pl","zakopane.pl","pantheonsite.io","gotpantheon.com","mypep.link","on-web.fr","*.platform.sh","*.platformsh.site","xen.prgmr.com","priv.at","protonet.io","chirurgiens-dentistes-en-france.fr","byen.site","ras.ru","qa2.com","dev-myqnapcloud.com","alpha-myqnapcloud.com","myqnapcloud.com","*.quipelements.com","vapor.cloud","vaporcloud.io","rackmaze.com","rackmaze.net","rhcloud.com","resindevice.io","devices.resinstaging.io","hzc.io","wellbeingzone.eu","ptplus.fit","wellbeingzone.co.uk","sandcats.io","logoip.de","logoip.com","schokokeks.net","scrysec.com","firewall-gateway.com","firewall-gateway.de","my-gateway.de","my-router.de","spdns.de","spdns.eu","firewall-gateway.net","my-firewall.org","myfirewall.org","spdns.org","*.s5y.io","*.sensiosite.cloud","biz.ua","co.ua","pp.ua","shiftedit.io","myshopblocks.com","1kapp.com","appchizi.com","applinzi.com","sinaapp.com","vipsinaapp.com","bounty-full.com","alpha.bounty-full.com","beta.bounty-full.com","static.land","dev.static.land","sites.static.land","apps.lair.io","*.stolos.io","spacekit.io","customer.speedpartner.de","storj.farm","utwente.io","temp-dns.com","diskstation.me","dscloud.biz","dscloud.me","dscloud.mobi","dsmynas.com","dsmynas.net","dsmynas.org","familyds.com","familyds.net","familyds.org","i234.me","myds.me","synology.me","vpnplus.to","taifun-dns.de","gda.pl","gdansk.pl","gdynia.pl","med.pl","sopot.pl","gwiddle.co.uk","cust.dev.thingdust.io","cust.disrec.thingdust.io","cust.prod.thingdust.io","cust.testing.thingdust.io","bloxcms.com","townnews-staging.com","12hp.at","2ix.at","4lima.at","lima-city.at","12hp.ch","2ix.ch","4lima.ch","lima-city.ch","trafficplex.cloud","de.cool","12hp.de","2ix.de","4lima.de","lima-city.de","1337.pictures","clan.rip","lima-city.rocks","webspace.rocks","lima.zone","*.transurl.be","*.transurl.eu","*.transurl.nl","tuxfamily.org","dd-dns.de","diskstation.eu","diskstation.org","dray-dns.de","draydns.de","dyn-vpn.de","dynvpn.de","mein-vigor.de","my-vigor.de","my-wan.de","syno-ds.de","synology-diskstation.de","synology-ds.de","uber.space","*.uberspace.de","hk.com","hk.org","ltd.hk","inc.hk","virtualuser.de","virtual-user.de","lib.de.us","2038.io","router.management","v-info.info","wedeploy.io","wedeploy.me","wedeploy.sh","remotewd.com","wmflabs.org","half.host","xnbay.com","u2.xnbay.com","u2-local.xnbay.com","cistron.nl","demon.nl","xs4all.space","official.academy","yolasite.com","ybo.faith","yombo.me","homelink.one","ybo.party","ybo.review","ybo.science","ybo.trade","nohost.me","noho.st","za.net","za.org","now.sh","zone.id"]

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * Copyright (c) 2015, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */

var Store = __webpack_require__(90).Store;
var permuteDomain = __webpack_require__(91).permuteDomain;
var pathMatch = __webpack_require__(92).pathMatch;
var util = __webpack_require__(5);

function MemoryCookieStore() {
  Store.call(this);
  this.idx = {};
}
util.inherits(MemoryCookieStore, Store);
exports.MemoryCookieStore = MemoryCookieStore;
MemoryCookieStore.prototype.idx = null;

// Since it's just a struct in RAM, this Store is synchronous
MemoryCookieStore.prototype.synchronous = true;

// force a default depth:
MemoryCookieStore.prototype.inspect = function() {
  return "{ idx: "+util.inspect(this.idx, false, 2)+' }';
};

// Use the new custom inspection symbol to add the custom inspect function if
// available.
if (util.inspect.custom) {
  MemoryCookieStore.prototype[util.inspect.custom] = MemoryCookieStore.prototype.inspect;
}

MemoryCookieStore.prototype.findCookie = function(domain, path, key, cb) {
  if (!this.idx[domain]) {
    return cb(null,undefined);
  }
  if (!this.idx[domain][path]) {
    return cb(null,undefined);
  }
  return cb(null,this.idx[domain][path][key]||null);
};

MemoryCookieStore.prototype.findCookies = function(domain, path, cb) {
  var results = [];
  if (!domain) {
    return cb(null,[]);
  }

  var pathMatcher;
  if (!path) {
    // null means "all paths"
    pathMatcher = function matchAll(domainIndex) {
      for (var curPath in domainIndex) {
        var pathIndex = domainIndex[curPath];
        for (var key in pathIndex) {
          results.push(pathIndex[key]);
        }
      }
    };

  } else {
    pathMatcher = function matchRFC(domainIndex) {
       //NOTE: we should use path-match algorithm from S5.1.4 here
       //(see : https://github.com/ChromiumWebApps/chromium/blob/b3d3b4da8bb94c1b2e061600df106d590fda3620/net/cookies/canonical_cookie.cc#L299)
       Object.keys(domainIndex).forEach(function (cookiePath) {
         if (pathMatch(path, cookiePath)) {
           var pathIndex = domainIndex[cookiePath];

           for (var key in pathIndex) {
             results.push(pathIndex[key]);
           }
         }
       });
     };
  }

  var domains = permuteDomain(domain) || [domain];
  var idx = this.idx;
  domains.forEach(function(curDomain) {
    var domainIndex = idx[curDomain];
    if (!domainIndex) {
      return;
    }
    pathMatcher(domainIndex);
  });

  cb(null,results);
};

MemoryCookieStore.prototype.putCookie = function(cookie, cb) {
  if (!this.idx[cookie.domain]) {
    this.idx[cookie.domain] = {};
  }
  if (!this.idx[cookie.domain][cookie.path]) {
    this.idx[cookie.domain][cookie.path] = {};
  }
  this.idx[cookie.domain][cookie.path][cookie.key] = cookie;
  cb(null);
};

MemoryCookieStore.prototype.updateCookie = function(oldCookie, newCookie, cb) {
  // updateCookie() may avoid updating cookies that are identical.  For example,
  // lastAccessed may not be important to some stores and an equality
  // comparison could exclude that field.
  this.putCookie(newCookie,cb);
};

MemoryCookieStore.prototype.removeCookie = function(domain, path, key, cb) {
  if (this.idx[domain] && this.idx[domain][path] && this.idx[domain][path][key]) {
    delete this.idx[domain][path][key];
  }
  cb(null);
};

MemoryCookieStore.prototype.removeCookies = function(domain, path, cb) {
  if (this.idx[domain]) {
    if (path) {
      delete this.idx[domain][path];
    } else {
      delete this.idx[domain];
    }
  }
  return cb(null);
};

MemoryCookieStore.prototype.getAllCookies = function(cb) {
  var cookies = [];
  var idx = this.idx;

  var domains = Object.keys(idx);
  domains.forEach(function(domain) {
    var paths = Object.keys(idx[domain]);
    paths.forEach(function(path) {
      var keys = Object.keys(idx[domain][path]);
      keys.forEach(function(key) {
        if (key !== null) {
          cookies.push(idx[domain][path][key]);
        }
      });
    });
  });

  // Sort by creationIndex so deserializing retains the creation order.
  // When implementing your own store, this SHOULD retain the order too
  cookies.sort(function(a,b) {
    return (a.creationIndex||0) - (b.creationIndex||0);
  });

  cb(null, cookies);
};


/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = {"_from":"tough-cookie@^2.3.2","_id":"tough-cookie@2.4.3","_inBundle":false,"_integrity":"sha512-Q5srk/4vDM54WJsJio3XNn6K2sCG+CQ8G5Wz6bZhRZoAe/+TxjWB/GlFAnYEbkYVlON9FMk/fE3h2RLpPXo4lQ==","_location":"/tough-cookie","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"tough-cookie@^2.3.2","name":"tough-cookie","escapedName":"tough-cookie","rawSpec":"^2.3.2","saveSpec":null,"fetchSpec":"^2.3.2"},"_requiredBy":["/jsdom","/request"],"_resolved":"https://registry.npmjs.org/tough-cookie/-/tough-cookie-2.4.3.tgz","_shasum":"53f36da3f47783b0925afa06ff9f3b165280f781","_spec":"tough-cookie@^2.3.2","_where":"/mnt/c/Users/isaac/Documents/GitHub/community-embeddings-toolkit/node_modules/jsdom","author":{"name":"Jeremy Stashewsky","email":"jstash@gmail.com"},"bugs":{"url":"https://github.com/salesforce/tough-cookie/issues"},"bundleDependencies":false,"contributors":[{"name":"Alexander Savin"},{"name":"Ian Livingstone"},{"name":"Ivan Nikulin"},{"name":"Lalit Kapoor"},{"name":"Sam Thompson"},{"name":"Sebastian Mayr"}],"dependencies":{"psl":"^1.1.24","punycode":"^1.4.1"},"deprecated":false,"description":"RFC6265 Cookies and Cookie Jar for node.js","devDependencies":{"async":"^1.4.2","nyc":"^11.6.0","string.prototype.repeat":"^0.2.0","vows":"^0.8.1"},"engines":{"node":">=0.8"},"files":["lib"],"homepage":"https://github.com/salesforce/tough-cookie","keywords":["HTTP","cookie","cookies","set-cookie","cookiejar","jar","RFC6265","RFC2965"],"license":"BSD-3-Clause","main":"./lib/cookie","name":"tough-cookie","repository":{"type":"git","url":"git://github.com/salesforce/tough-cookie.git"},"scripts":{"cover":"nyc --reporter=lcov --reporter=html vows test/*_test.js","test":"vows test/*_test.js"},"version":"2.4.3"}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(6)))

/***/ }),
/* 182 */
/***/ (function(module, exports) {

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 184 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 185 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(1).Buffer;
var util = __webpack_require__(187);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 187 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(98);

/*<replacement>*/
var util = __webpack_require__(32);
util.inherits = __webpack_require__(0);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(66);


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(27);


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(36).Transform


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(36).PassThrough


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(0)
var Hash = __webpack_require__(33)
var Buffer = __webpack_require__(1).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(0)
var Hash = __webpack_require__(33)
var Buffer = __webpack_require__(1).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(0)
var Sha256 = __webpack_require__(99)
var Hash = __webpack_require__(33)
var Buffer = __webpack_require__(1).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0)
var SHA512 = __webpack_require__(100)
var Hash = __webpack_require__(33)
var Buffer = __webpack_require__(1).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(0)
var Buffer = __webpack_require__(1).Buffer

var Base = __webpack_require__(24)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(103)


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(105)
var defaultEncoding = __webpack_require__(106)
var sync = __webpack_require__(107)
var Buffer = __webpack_require__(1).Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(6)))

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(202)
var aes = __webpack_require__(71)
var aesModes = __webpack_require__(72)
var desModes = __webpack_require__(217)
var ebtk = __webpack_require__(52)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(24)
var des = __webpack_require__(70)
var inherits = __webpack_require__(0)
var Buffer = __webpack_require__(1).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(15);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(15);
var inherits = __webpack_require__(0);

var des = __webpack_require__(70);
var utils = des.utils;
var Cipher = des.Cipher;

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(15);
var inherits = __webpack_require__(0);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(15);
var inherits = __webpack_require__(0);

var des = __webpack_require__(70);
var Cipher = des.Cipher;
var DES = des.DES;

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(72)
var AuthCipher = __webpack_require__(111)
var Buffer = __webpack_require__(1).Buffer
var StreamCipher = __webpack_require__(112)
var Transform = __webpack_require__(24)
var aes = __webpack_require__(51)
var ebtk = __webpack_require__(52)
var inherits = __webpack_require__(0)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),
/* 209 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(37)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer
var xor = __webpack_require__(37)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(37)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(111)
var Buffer = __webpack_require__(1).Buffer
var MODES = __webpack_require__(72)
var StreamCipher = __webpack_require__(112)
var Transform = __webpack_require__(24)
var aes = __webpack_require__(51)
var ebtk = __webpack_require__(52)
var inherits = __webpack_require__(0)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),
/* 217 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(113)
var primes = __webpack_require__(221)

var DH = __webpack_require__(222)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 219 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 220 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(8);
var MillerRabin = __webpack_require__(114);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(113);
var randomBytes = __webpack_require__(31);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(35)
var stream = __webpack_require__(17)
var inherits = __webpack_require__(0)
var sign = __webpack_require__(224)
var verify = __webpack_require__(260)

var algorithms = __webpack_require__(103)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(101)
var crt = __webpack_require__(73)
var EC = __webpack_require__(14).ec
var BN = __webpack_require__(8)
var parseKeys = __webpack_require__(54)
var curves = __webpack_require__(124)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.0.0","_id":"elliptic@6.4.1","_inBundle":false,"_integrity":"sha512-BsXLz5sqX8OHcsh7CqBMztyXARmGQ3LWPtGjJi6DiJHq5C/qvi9P3OqgswKSDftbu8+IoI/QDTAm2fFnQ9SZSQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.0.0","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.0.0","saveSpec":null,"fetchSpec":"^6.0.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.1.tgz","_shasum":"c2d0b7776911b86722c632c3c06c60f2f819939a","_spec":"elliptic@^6.0.0","_where":"/mnt/c/Users/isaac/Documents/GitHub/community-embeddings-toolkit/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.1"}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(8);
var minAssert = __webpack_require__(15);
var minUtils = __webpack_require__(116);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w) {
  var naf = [];
  var ws = 1 << (w + 1);
  var k = num.clone();
  while (k.cmpn(1) >= 0) {
    var z;
    if (k.isOdd()) {
      var mod = k.andln(ws - 1);
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }
    naf.push(z);

    // Optimization, shift by word if possible
    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
    for (var i = 1; i < shift; i++)
      naf.push(0);
    k.iushrn(shift);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(8);
var elliptic = __webpack_require__(14);
var utils = elliptic.utils;
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a]);
      naf[b] = getNAF(coeffs[b], wndWidth[b]);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(53);
var elliptic = __webpack_require__(14);
var BN = __webpack_require__(8);
var inherits = __webpack_require__(0);
var Base = curve.base;

var assert = elliptic.utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);

  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(53);
var BN = __webpack_require__(8);
var inherits = __webpack_require__(0);
var Base = curve.base;

var elliptic = __webpack_require__(14);
var utils = elliptic.utils;

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(53);
var elliptic = __webpack_require__(14);
var BN = __webpack_require__(8);
var inherits = __webpack_require__(0);
var Base = curve.base;

var assert = elliptic.utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(74);
var elliptic = __webpack_require__(14);

var assert = elliptic.utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new elliptic.curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new elliptic.curve.edwards(options);
  else
    this.curve = new elliptic.curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(238);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(233);
exports.sha224 = __webpack_require__(234);
exports.sha256 = __webpack_require__(118);
exports.sha384 = __webpack_require__(235);
exports.sha512 = __webpack_require__(119);


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);
var common = __webpack_require__(38);
var shaCommon = __webpack_require__(117);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);
var SHA256 = __webpack_require__(118);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

var SHA512 = __webpack_require__(119);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);
var common = __webpack_require__(38);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);
var assert = __webpack_require__(15);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(8);
var HmacDRBG = __webpack_require__(240);
var elliptic = __webpack_require__(14);
var utils = elliptic.utils;
var assert = utils.assert;

var KeyPair = __webpack_require__(241);
var Signature = __webpack_require__(242);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = elliptic.curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof elliptic.curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || elliptic.rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(74);
var utils = __webpack_require__(116);
var assert = __webpack_require__(15);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(8);
var elliptic = __webpack_require__(14);
var utils = elliptic.utils;
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(8);

var elliptic = __webpack_require__(14);
var utils = elliptic.utils;
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(74);
var elliptic = __webpack_require__(14);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(244);
var Signature = __webpack_require__(245);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = elliptic.curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = __webpack_require__(14);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(8);
var elliptic = __webpack_require__(14);
var utils = elliptic.utils;
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(39)

exports.certificate = __webpack_require__(257)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(39);
var inherits = __webpack_require__(0);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(248).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(249);

var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    forEach(Object_keys(ctx), function (key) {
        context[key] = ctx[key];
    });

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 249 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(40).Reporter;
var EncoderBuffer = __webpack_require__(40).EncoderBuffer;
var DecoderBuffer = __webpack_require__(40).DecoderBuffer;
var assert = __webpack_require__(15);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(121);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(122);
decoders.pem = __webpack_require__(254);


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0);
var Buffer = __webpack_require__(2).Buffer;

var DERDecoder = __webpack_require__(122);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(123);
encoders.pem = __webpack_require__(256);


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0);

var DEREncoder = __webpack_require__(123);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(39)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__(52)
var ciphers = __webpack_require__(71)
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = new Buffer(match[2], 'hex')
    var cipherText = new Buffer(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(8)
var EC = __webpack_require__(14).ec
var parseKeys = __webpack_require__(54)
var curves = __webpack_require__(124)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(14)
var BN = __webpack_require__(8)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(263);
exports.privateDecrypt = __webpack_require__(264);

exports.privateEncrypt = function privateEncrypt(key, buf) {
  return exports.publicEncrypt(key, buf, true);
};

exports.publicDecrypt = function publicDecrypt(key, buf) {
  return exports.privateDecrypt(key, buf, true);
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var parseKeys = __webpack_require__(54);
var randomBytes = __webpack_require__(31);
var createHash = __webpack_require__(35);
var mgf = __webpack_require__(125);
var xor = __webpack_require__(126);
var bn = __webpack_require__(8);
var withPublic = __webpack_require__(127);
var crt = __webpack_require__(73);

var constants = {
  RSA_PKCS1_OAEP_PADDING: 4,
  RSA_PKCS1_PADDIN: 1,
  RSA_NO_PADDING: 3
};

module.exports = function publicEncrypt(public_key, msg, reverse) {
  var padding;
  if (public_key.padding) {
    padding = public_key.padding;
  } else if (reverse) {
    padding = 1;
  } else {
    padding = 4;
  }
  var key = parseKeys(public_key);
  var paddedMsg;
  if (padding === 4) {
    paddedMsg = oaep(key, msg);
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse);
  } else if (padding === 3) {
    paddedMsg = new bn(msg);
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus');
    }
  } else {
    throw new Error('unknown padding');
  }
  if (reverse) {
    return crt(paddedMsg, key);
  } else {
    return withPublic(paddedMsg, key);
  }
};

function oaep(key, msg){
  var k = key.modulus.byteLength();
  var mLen = msg.length;
  var iHash = createHash('sha1').update(new Buffer('')).digest();
  var hLen = iHash.length;
  var hLen2 = 2 * hLen;
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long');
  }
  var ps = new Buffer(k - mLen - hLen2 - 2);
  ps.fill(0);
  var dblen = k - hLen - 1;
  var seed = randomBytes(hLen);
  var maskedDb = xor(Buffer.concat([iHash, ps, new Buffer([1]), msg], dblen), mgf(seed, dblen));
  var maskedSeed = xor(seed, mgf(maskedDb, hLen));
  return new bn(Buffer.concat([new Buffer([0]), maskedSeed, maskedDb], k));
}
function pkcs1(key, msg, reverse){
  var mLen = msg.length;
  var k = key.modulus.byteLength();
  if (mLen > k - 11) {
    throw new Error('message too long');
  }
  var ps;
  if (reverse) {
    ps = new Buffer(k - mLen - 3);
    ps.fill(0xff);
  } else {
    ps = nonZero(k - mLen - 3);
  }
  return new bn(Buffer.concat([new Buffer([0, reverse?1:2]), ps, new Buffer([0]), msg], k));
}
function nonZero(len, crypto) {
  var out = new Buffer(len);
  var i = 0;
  var cache = randomBytes(len*2);
  var cur = 0;
  var num;
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len*2);
      cur = 0;
    }
    num = cache[cur++];
    if (num) {
      out[i++] = num;
    }
  }
  return out;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var parseKeys = __webpack_require__(54);
var mgf = __webpack_require__(125);
var xor = __webpack_require__(126);
var bn = __webpack_require__(8);
var crt = __webpack_require__(73);
var createHash = __webpack_require__(35);
var withPublic = __webpack_require__(127);
module.exports = function privateDecrypt(private_key, enc, reverse) {
  var padding;
  if (private_key.padding) {
    padding = private_key.padding;
  } else if (reverse) {
    padding = 1;
  } else {
    padding = 4;
  }
  
  var key = parseKeys(private_key);
  var k = key.modulus.byteLength();
  if (enc.length > k || new bn(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error');
  }
  var msg;
  if (reverse) {
    msg = withPublic(new bn(enc), key);
  } else {
    msg = crt(enc, key);
  }
  var zBuffer = new Buffer(k - msg.length);
  zBuffer.fill(0);
  msg = Buffer.concat([zBuffer, msg], k);
  if (padding === 4) {
    return oaep(key, msg);
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse);
  } else if (padding === 3) {
    return msg;
  } else {
    throw new Error('unknown padding');
  }
};

function oaep(key, msg){
  var n = key.modulus;
  var k = key.modulus.byteLength();
  var mLen = msg.length;
  var iHash = createHash('sha1').update(new Buffer('')).digest();
  var hLen = iHash.length;
  var hLen2 = 2 * hLen;
  if (msg[0] !== 0) {
    throw new Error('decryption error');
  }
  var maskedSeed = msg.slice(1, hLen + 1);
  var maskedDb =  msg.slice(hLen + 1);
  var seed = xor(maskedSeed, mgf(maskedDb, hLen));
  var db = xor(maskedDb, mgf(seed, k - hLen - 1));
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error');
  }
  var i = hLen;
  while (db[i] === 0) {
    i++;
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error');
  }
  return db.slice(i);
}

function pkcs1(key, msg, reverse){
  var p1 = msg.slice(0, 2);
  var i = 2;
  var status = 0;
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++;
      break;
    }
  }
  var ps = msg.slice(2, i - 1);
  var p2 = msg.slice(i - 1, i);

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)){
    status++;
  }
  if (ps.length < 8) {
    status++;
  }
  if (status) {
    throw new Error('decryption error');
  }
  return  msg.slice(i);
}
function compare(a, b){
  a = new Buffer(a);
  b = new Buffer(b);
  var dif = 0;
  var len = a.length;
  if (a.length !== b.length) {
    dif++;
    len = Math.min(a.length, b.length);
  }
  var i = -1;
  while (++i < len) {
    dif += (a[i] ^ b[i]);
  }
  return dif;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(1)
var randombytes = __webpack_require__(31)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(6)))

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var http = __webpack_require__(41)
var https = __webpack_require__(75)
var url = __webpack_require__(16)
var util = __webpack_require__(5)
var stream = __webpack_require__(17)
var zlib = __webpack_require__(271)
var aws2 = __webpack_require__(281)
var aws4 = __webpack_require__(282)
var httpSignature = __webpack_require__(284)
var mime = __webpack_require__(298)
var caseless = __webpack_require__(82)
var ForeverAgent = __webpack_require__(302)
var FormData = __webpack_require__(303)
var extend = __webpack_require__(61)
var isstream = __webpack_require__(139)
var isTypedArray = __webpack_require__(304).strict
var helpers = __webpack_require__(63)
var cookies = __webpack_require__(87)
var getProxyFromURI = __webpack_require__(305)
var Querystring = __webpack_require__(306).Querystring
var Har = __webpack_require__(309).Har
var Auth = __webpack_require__(363).Auth
var OAuth = __webpack_require__(366).OAuth
var hawk = __webpack_require__(368)
var Multipart = __webpack_require__(369).Multipart
var Redirect = __webpack_require__(373).Redirect
var Tunnel = __webpack_require__(374).Tunnel
var now = __webpack_require__(376)
var Buffer = __webpack_require__(1).Buffer

var safeStringify = helpers.safeStringify
var isReadStream = helpers.isReadStream
var toBase64 = helpers.toBase64
var defer = helpers.defer
var copy = helpers.copy
var version = helpers.version
var globalCookieJar = cookies.jar()

var globalPool = {}

function filterForNonReserved (reserved, options) {
  // Filter out properties that are not reserved.
  // Reserved values are passed in at call site.

  var object = {}
  for (var i in options) {
    var notReserved = (reserved.indexOf(i) === -1)
    if (notReserved) {
      object[i] = options[i]
    }
  }
  return object
}

function filterOutReservedFunctions (reserved, options) {
  // Filter out properties that are functions and are reserved.
  // Reserved values are passed in at call site.

  var object = {}
  for (var i in options) {
    var isReserved = !(reserved.indexOf(i) === -1)
    var isFunction = (typeof options[i] === 'function')
    if (!(isReserved && isFunction)) {
      object[i] = options[i]
    }
  }
  return object
}

// Return a simpler request object to allow serialization
function requestToJSON () {
  var self = this
  return {
    uri: self.uri,
    method: self.method,
    headers: self.headers
  }
}

// Return a simpler response object to allow serialization
function responseToJSON () {
  var self = this
  return {
    statusCode: self.statusCode,
    body: self.body,
    headers: self.headers,
    request: requestToJSON.call(self.request)
  }
}

function Request (options) {
  // if given the method property in options, set property explicitMethod to true

  // extend the Request instance with any non-reserved properties
  // remove any reserved functions from the options object
  // set Request instance to be readable and writable
  // call init

  var self = this

  // start with HAR, then override with additional options
  if (options.har) {
    self._har = new Har(self)
    options = self._har.options(options)
  }

  stream.Stream.call(self)
  var reserved = Object.keys(Request.prototype)
  var nonReserved = filterForNonReserved(reserved, options)

  extend(self, nonReserved)
  options = filterOutReservedFunctions(reserved, options)

  self.readable = true
  self.writable = true
  if (options.method) {
    self.explicitMethod = true
  }
  self._qs = new Querystring(self)
  self._auth = new Auth(self)
  self._oauth = new OAuth(self)
  self._multipart = new Multipart(self)
  self._redirect = new Redirect(self)
  self._tunnel = new Tunnel(self)
  self.init(options)
}

util.inherits(Request, stream.Stream)

// Debugging
Request.debug = Object({"NODE_ENV":"production","PUBLIC_URL":"."}).NODE_DEBUG && /\brequest\b/.test(Object({"NODE_ENV":"production","PUBLIC_URL":"."}).NODE_DEBUG)
function debug () {
  if (Request.debug) {
    console.error('REQUEST %s', util.format.apply(util, arguments))
  }
}
Request.prototype.debug = debug

Request.prototype.init = function (options) {
  // init() contains all the code to setup the request object.
  // the actual outgoing request is not started until start() is called
  // this function is called from both the constructor and on redirect.
  var self = this
  if (!options) {
    options = {}
  }
  self.headers = self.headers ? copy(self.headers) : {}

  // Delete headers with value undefined since they break
  // ClientRequest.OutgoingMessage.setHeader in node 0.12
  for (var headerName in self.headers) {
    if (typeof self.headers[headerName] === 'undefined') {
      delete self.headers[headerName]
    }
  }

  caseless.httpify(self, self.headers)

  if (!self.method) {
    self.method = options.method || 'GET'
  }
  if (!self.localAddress) {
    self.localAddress = options.localAddress
  }

  self._qs.init(options)

  debug(options)
  if (!self.pool && self.pool !== false) {
    self.pool = globalPool
  }
  self.dests = self.dests || []
  self.__isRequestRequest = true

  // Protect against double callback
  if (!self._callback && self.callback) {
    self._callback = self.callback
    self.callback = function () {
      if (self._callbackCalled) {
        return // Print a warning maybe?
      }
      self._callbackCalled = true
      self._callback.apply(self, arguments)
    }
    self.on('error', self.callback.bind())
    self.on('complete', self.callback.bind(self, null))
  }

  // People use this property instead all the time, so support it
  if (!self.uri && self.url) {
    self.uri = self.url
    delete self.url
  }

  // If there's a baseUrl, then use it as the base URL (i.e. uri must be
  // specified as a relative path and is appended to baseUrl).
  if (self.baseUrl) {
    if (typeof self.baseUrl !== 'string') {
      return self.emit('error', new Error('options.baseUrl must be a string'))
    }

    if (typeof self.uri !== 'string') {
      return self.emit('error', new Error('options.uri must be a string when using options.baseUrl'))
    }

    if (self.uri.indexOf('//') === 0 || self.uri.indexOf('://') !== -1) {
      return self.emit('error', new Error('options.uri must be a path when using options.baseUrl'))
    }

    // Handle all cases to make sure that there's only one slash between
    // baseUrl and uri.
    var baseUrlEndsWithSlash = self.baseUrl.lastIndexOf('/') === self.baseUrl.length - 1
    var uriStartsWithSlash = self.uri.indexOf('/') === 0

    if (baseUrlEndsWithSlash && uriStartsWithSlash) {
      self.uri = self.baseUrl + self.uri.slice(1)
    } else if (baseUrlEndsWithSlash || uriStartsWithSlash) {
      self.uri = self.baseUrl + self.uri
    } else if (self.uri === '') {
      self.uri = self.baseUrl
    } else {
      self.uri = self.baseUrl + '/' + self.uri
    }
    delete self.baseUrl
  }

  // A URI is needed by this point, emit error if we haven't been able to get one
  if (!self.uri) {
    return self.emit('error', new Error('options.uri is a required argument'))
  }

  // If a string URI/URL was given, parse it into a URL object
  if (typeof self.uri === 'string') {
    self.uri = url.parse(self.uri)
  }

  // Some URL objects are not from a URL parsed string and need href added
  if (!self.uri.href) {
    self.uri.href = url.format(self.uri)
  }

  // DEPRECATED: Warning for users of the old Unix Sockets URL Scheme
  if (self.uri.protocol === 'unix:') {
    return self.emit('error', new Error('`unix://` URL scheme is no longer supported. Please use the format `http://unix:SOCKET:PATH`'))
  }

  // Support Unix Sockets
  if (self.uri.host === 'unix') {
    self.enableUnixSocket()
  }

  if (self.strictSSL === false) {
    self.rejectUnauthorized = false
  }

  if (!self.uri.pathname) { self.uri.pathname = '/' }

  if (!(self.uri.host || (self.uri.hostname && self.uri.port)) && !self.uri.isUnix) {
    // Invalid URI: it may generate lot of bad errors, like 'TypeError: Cannot call method `indexOf` of undefined' in CookieJar
    // Detect and reject it as soon as possible
    var faultyUri = url.format(self.uri)
    var message = 'Invalid URI "' + faultyUri + '"'
    if (Object.keys(options).length === 0) {
      // No option ? This can be the sign of a redirect
      // As this is a case where the user cannot do anything (they didn't call request directly with this URL)
      // they should be warned that it can be caused by a redirection (can save some hair)
      message += '. This can be caused by a crappy redirection.'
    }
    // This error was fatal
    self.abort()
    return self.emit('error', new Error(message))
  }

  if (!self.hasOwnProperty('proxy')) {
    self.proxy = getProxyFromURI(self.uri)
  }

  self.tunnel = self._tunnel.isEnabled()
  if (self.proxy) {
    self._tunnel.setup(options)
  }

  self._redirect.onRequest(options)

  self.setHost = false
  if (!self.hasHeader('host')) {
    var hostHeaderName = self.originalHostHeaderName || 'host'
    self.setHeader(hostHeaderName, self.uri.host)
    // Drop :port suffix from Host header if known protocol.
    if (self.uri.port) {
      if ((self.uri.port === '80' && self.uri.protocol === 'http:') ||
          (self.uri.port === '443' && self.uri.protocol === 'https:')) {
        self.setHeader(hostHeaderName, self.uri.hostname)
      }
    }
    self.setHost = true
  }

  self.jar(self._jar || options.jar)

  if (!self.uri.port) {
    if (self.uri.protocol === 'http:') { self.uri.port = 80 } else if (self.uri.protocol === 'https:') { self.uri.port = 443 }
  }

  if (self.proxy && !self.tunnel) {
    self.port = self.proxy.port
    self.host = self.proxy.hostname
  } else {
    self.port = self.uri.port
    self.host = self.uri.hostname
  }

  if (options.form) {
    self.form(options.form)
  }

  if (options.formData) {
    var formData = options.formData
    var requestForm = self.form()
    var appendFormValue = function (key, value) {
      if (value && value.hasOwnProperty('value') && value.hasOwnProperty('options')) {
        requestForm.append(key, value.value, value.options)
      } else {
        requestForm.append(key, value)
      }
    }
    for (var formKey in formData) {
      if (formData.hasOwnProperty(formKey)) {
        var formValue = formData[formKey]
        if (formValue instanceof Array) {
          for (var j = 0; j < formValue.length; j++) {
            appendFormValue(formKey, formValue[j])
          }
        } else {
          appendFormValue(formKey, formValue)
        }
      }
    }
  }

  if (options.qs) {
    self.qs(options.qs)
  }

  if (self.uri.path) {
    self.path = self.uri.path
  } else {
    self.path = self.uri.pathname + (self.uri.search || '')
  }

  if (self.path.length === 0) {
    self.path = '/'
  }

  // Auth must happen last in case signing is dependent on other headers
  if (options.aws) {
    self.aws(options.aws)
  }

  if (options.hawk) {
    self.hawk(options.hawk)
  }

  if (options.httpSignature) {
    self.httpSignature(options.httpSignature)
  }

  if (options.auth) {
    if (Object.prototype.hasOwnProperty.call(options.auth, 'username')) {
      options.auth.user = options.auth.username
    }
    if (Object.prototype.hasOwnProperty.call(options.auth, 'password')) {
      options.auth.pass = options.auth.password
    }

    self.auth(
      options.auth.user,
      options.auth.pass,
      options.auth.sendImmediately,
      options.auth.bearer
    )
  }

  if (self.gzip && !self.hasHeader('accept-encoding')) {
    self.setHeader('accept-encoding', 'gzip, deflate')
  }

  if (self.uri.auth && !self.hasHeader('authorization')) {
    var uriAuthPieces = self.uri.auth.split(':').map(function (item) { return self._qs.unescape(item) })
    self.auth(uriAuthPieces[0], uriAuthPieces.slice(1).join(':'), true)
  }

  if (!self.tunnel && self.proxy && self.proxy.auth && !self.hasHeader('proxy-authorization')) {
    var proxyAuthPieces = self.proxy.auth.split(':').map(function (item) { return self._qs.unescape(item) })
    var authHeader = 'Basic ' + toBase64(proxyAuthPieces.join(':'))
    self.setHeader('proxy-authorization', authHeader)
  }

  if (self.proxy && !self.tunnel) {
    self.path = (self.uri.protocol + '//' + self.uri.host + self.path)
  }

  if (options.json) {
    self.json(options.json)
  }
  if (options.multipart) {
    self.multipart(options.multipart)
  }

  if (options.time) {
    self.timing = true

    // NOTE: elapsedTime is deprecated in favor of .timings
    self.elapsedTime = self.elapsedTime || 0
  }

  function setContentLength () {
    if (isTypedArray(self.body)) {
      self.body = Buffer.from(self.body)
    }

    if (!self.hasHeader('content-length')) {
      var length
      if (typeof self.body === 'string') {
        length = Buffer.byteLength(self.body)
      } else if (Array.isArray(self.body)) {
        length = self.body.reduce(function (a, b) { return a + b.length }, 0)
      } else {
        length = self.body.length
      }

      if (length) {
        self.setHeader('content-length', length)
      } else {
        self.emit('error', new Error('Argument error, options.body.'))
      }
    }
  }
  if (self.body && !isstream(self.body)) {
    setContentLength()
  }

  if (options.oauth) {
    self.oauth(options.oauth)
  } else if (self._oauth.params && self.hasHeader('authorization')) {
    self.oauth(self._oauth.params)
  }

  var protocol = self.proxy && !self.tunnel ? self.proxy.protocol : self.uri.protocol
  var defaultModules = {'http:': http, 'https:': https}
  var httpModules = self.httpModules || {}

  self.httpModule = httpModules[protocol] || defaultModules[protocol]

  if (!self.httpModule) {
    return self.emit('error', new Error('Invalid protocol: ' + protocol))
  }

  if (options.ca) {
    self.ca = options.ca
  }

  if (!self.agent) {
    if (options.agentOptions) {
      self.agentOptions = options.agentOptions
    }

    if (options.agentClass) {
      self.agentClass = options.agentClass
    } else if (options.forever) {
      var v = version()
      // use ForeverAgent in node 0.10- only
      if (v.major === 0 && v.minor <= 10) {
        self.agentClass = protocol === 'http:' ? ForeverAgent : ForeverAgent.SSL
      } else {
        self.agentClass = self.httpModule.Agent
        self.agentOptions = self.agentOptions || {}
        self.agentOptions.keepAlive = true
      }
    } else {
      self.agentClass = self.httpModule.Agent
    }
  }

  if (self.pool === false) {
    self.agent = false
  } else {
    self.agent = self.agent || self.getNewAgent()
  }

  self.on('pipe', function (src) {
    if (self.ntick && self._started) {
      self.emit('error', new Error('You cannot pipe to this stream after the outbound request has started.'))
    }
    self.src = src
    if (isReadStream(src)) {
      if (!self.hasHeader('content-type')) {
        self.setHeader('content-type', mime.lookup(src.path))
      }
    } else {
      if (src.headers) {
        for (var i in src.headers) {
          if (!self.hasHeader(i)) {
            self.setHeader(i, src.headers[i])
          }
        }
      }
      if (self._json && !self.hasHeader('content-type')) {
        self.setHeader('content-type', 'application/json')
      }
      if (src.method && !self.explicitMethod) {
        self.method = src.method
      }
    }

  // self.on('pipe', function () {
  //   console.error('You have already piped to this stream. Pipeing twice is likely to break the request.')
  // })
  })

  defer(function () {
    if (self._aborted) {
      return
    }

    var end = function () {
      if (self._form) {
        if (!self._auth.hasAuth) {
          self._form.pipe(self)
        } else if (self._auth.hasAuth && self._auth.sentAuth) {
          self._form.pipe(self)
        }
      }
      if (self._multipart && self._multipart.chunked) {
        self._multipart.body.pipe(self)
      }
      if (self.body) {
        if (isstream(self.body)) {
          self.body.pipe(self)
        } else {
          setContentLength()
          if (Array.isArray(self.body)) {
            self.body.forEach(function (part) {
              self.write(part)
            })
          } else {
            self.write(self.body)
          }
          self.end()
        }
      } else if (self.requestBodyStream) {
        console.warn('options.requestBodyStream is deprecated, please pass the request object to stream.pipe.')
        self.requestBodyStream.pipe(self)
      } else if (!self.src) {
        if (self._auth.hasAuth && !self._auth.sentAuth) {
          self.end()
          return
        }
        if (self.method !== 'GET' && typeof self.method !== 'undefined') {
          self.setHeader('content-length', 0)
        }
        self.end()
      }
    }

    if (self._form && !self.hasHeader('content-length')) {
      // Before ending the request, we had to compute the length of the whole form, asyncly
      self.setHeader(self._form.getHeaders(), true)
      self._form.getLength(function (err, length) {
        if (!err && !isNaN(length)) {
          self.setHeader('content-length', length)
        }
        end()
      })
    } else {
      end()
    }

    self.ntick = true
  })
}

Request.prototype.getNewAgent = function () {
  var self = this
  var Agent = self.agentClass
  var options = {}
  if (self.agentOptions) {
    for (var i in self.agentOptions) {
      options[i] = self.agentOptions[i]
    }
  }
  if (self.ca) {
    options.ca = self.ca
  }
  if (self.ciphers) {
    options.ciphers = self.ciphers
  }
  if (self.secureProtocol) {
    options.secureProtocol = self.secureProtocol
  }
  if (self.secureOptions) {
    options.secureOptions = self.secureOptions
  }
  if (typeof self.rejectUnauthorized !== 'undefined') {
    options.rejectUnauthorized = self.rejectUnauthorized
  }

  if (self.cert && self.key) {
    options.key = self.key
    options.cert = self.cert
  }

  if (self.pfx) {
    options.pfx = self.pfx
  }

  if (self.passphrase) {
    options.passphrase = self.passphrase
  }

  var poolKey = ''

  // different types of agents are in different pools
  if (Agent !== self.httpModule.Agent) {
    poolKey += Agent.name
  }

  // ca option is only relevant if proxy or destination are https
  var proxy = self.proxy
  if (typeof proxy === 'string') {
    proxy = url.parse(proxy)
  }
  var isHttps = (proxy && proxy.protocol === 'https:') || this.uri.protocol === 'https:'

  if (isHttps) {
    if (options.ca) {
      if (poolKey) {
        poolKey += ':'
      }
      poolKey += options.ca
    }

    if (typeof options.rejectUnauthorized !== 'undefined') {
      if (poolKey) {
        poolKey += ':'
      }
      poolKey += options.rejectUnauthorized
    }

    if (options.cert) {
      if (poolKey) {
        poolKey += ':'
      }
      poolKey += options.cert.toString('ascii') + options.key.toString('ascii')
    }

    if (options.pfx) {
      if (poolKey) {
        poolKey += ':'
      }
      poolKey += options.pfx.toString('ascii')
    }

    if (options.ciphers) {
      if (poolKey) {
        poolKey += ':'
      }
      poolKey += options.ciphers
    }

    if (options.secureProtocol) {
      if (poolKey) {
        poolKey += ':'
      }
      poolKey += options.secureProtocol
    }

    if (options.secureOptions) {
      if (poolKey) {
        poolKey += ':'
      }
      poolKey += options.secureOptions
    }
  }

  if (self.pool === globalPool && !poolKey && Object.keys(options).length === 0 && self.httpModule.globalAgent) {
    // not doing anything special.  Use the globalAgent
    return self.httpModule.globalAgent
  }

  // we're using a stored agent.  Make sure it's protocol-specific
  poolKey = self.uri.protocol + poolKey

  // generate a new agent for this setting if none yet exists
  if (!self.pool[poolKey]) {
    self.pool[poolKey] = new Agent(options)
    // properly set maxSockets on new agents
    if (self.pool.maxSockets) {
      self.pool[poolKey].maxSockets = self.pool.maxSockets
    }
  }

  return self.pool[poolKey]
}

Request.prototype.start = function () {
  // start() is called once we are ready to send the outgoing HTTP request.
  // this is usually called on the first write(), end() or on nextTick()
  var self = this

  if (self.timing) {
    // All timings will be relative to this request's startTime.  In order to do this,
    // we need to capture the wall-clock start time (via Date), immediately followed
    // by the high-resolution timer (via now()).  While these two won't be set
    // at the _exact_ same time, they should be close enough to be able to calculate
    // high-resolution, monotonically non-decreasing timestamps relative to startTime.
    var startTime = new Date().getTime()
    var startTimeNow = now()
  }

  if (self._aborted) {
    return
  }

  self._started = true
  self.method = self.method || 'GET'
  self.href = self.uri.href

  if (self.src && self.src.stat && self.src.stat.size && !self.hasHeader('content-length')) {
    self.setHeader('content-length', self.src.stat.size)
  }
  if (self._aws) {
    self.aws(self._aws, true)
  }

  // We have a method named auth, which is completely different from the http.request
  // auth option.  If we don't remove it, we're gonna have a bad time.
  var reqOptions = copy(self)
  delete reqOptions.auth

  debug('make request', self.uri.href)

  // node v6.8.0 now supports a `timeout` value in `http.request()`, but we
  // should delete it for now since we handle timeouts manually for better
  // consistency with node versions before v6.8.0
  delete reqOptions.timeout

  try {
    self.req = self.httpModule.request(reqOptions)
  } catch (err) {
    self.emit('error', err)
    return
  }

  if (self.timing) {
    self.startTime = startTime
    self.startTimeNow = startTimeNow

    // Timing values will all be relative to startTime (by comparing to startTimeNow
    // so we have an accurate clock)
    self.timings = {}
  }

  var timeout
  if (self.timeout && !self.timeoutTimer) {
    if (self.timeout < 0) {
      timeout = 0
    } else if (typeof self.timeout === 'number' && isFinite(self.timeout)) {
      timeout = self.timeout
    }
  }

  self.req.on('response', self.onRequestResponse.bind(self))
  self.req.on('error', self.onRequestError.bind(self))
  self.req.on('drain', function () {
    self.emit('drain')
  })

  self.req.on('socket', function (socket) {
    // `._connecting` was the old property which was made public in node v6.1.0
    var isConnecting = socket._connecting || socket.connecting
    if (self.timing) {
      self.timings.socket = now() - self.startTimeNow

      if (isConnecting) {
        var onLookupTiming = function () {
          self.timings.lookup = now() - self.startTimeNow
        }

        var onConnectTiming = function () {
          self.timings.connect = now() - self.startTimeNow
        }

        socket.once('lookup', onLookupTiming)
        socket.once('connect', onConnectTiming)

        // clean up timing event listeners if needed on error
        self.req.once('error', function () {
          socket.removeListener('lookup', onLookupTiming)
          socket.removeListener('connect', onConnectTiming)
        })
      }
    }

    var setReqTimeout = function () {
      // This timeout sets the amount of time to wait *between* bytes sent
      // from the server once connected.
      //
      // In particular, it's useful for erroring if the server fails to send
      // data halfway through streaming a response.
      self.req.setTimeout(timeout, function () {
        if (self.req) {
          self.abort()
          var e = new Error('ESOCKETTIMEDOUT')
          e.code = 'ESOCKETTIMEDOUT'
          e.connect = false
          self.emit('error', e)
        }
      })
    }
    if (timeout !== undefined) {
      // Only start the connection timer if we're actually connecting a new
      // socket, otherwise if we're already connected (because this is a
      // keep-alive connection) do not bother. This is important since we won't
      // get a 'connect' event for an already connected socket.
      if (isConnecting) {
        var onReqSockConnect = function () {
          socket.removeListener('connect', onReqSockConnect)
          clearTimeout(self.timeoutTimer)
          self.timeoutTimer = null
          setReqTimeout()
        }

        socket.on('connect', onReqSockConnect)

        self.req.on('error', function (err) { // eslint-disable-line handle-callback-err
          socket.removeListener('connect', onReqSockConnect)
        })

        // Set a timeout in memory - this block will throw if the server takes more
        // than `timeout` to write the HTTP status and headers (corresponding to
        // the on('response') event on the client). NB: this measures wall-clock
        // time, not the time between bytes sent by the server.
        self.timeoutTimer = setTimeout(function () {
          socket.removeListener('connect', onReqSockConnect)
          self.abort()
          var e = new Error('ETIMEDOUT')
          e.code = 'ETIMEDOUT'
          e.connect = true
          self.emit('error', e)
        }, timeout)
      } else {
        // We're already connected
        setReqTimeout()
      }
    }
    self.emit('socket', socket)
  })

  self.emit('request', self.req)
}

Request.prototype.onRequestError = function (error) {
  var self = this
  if (self._aborted) {
    return
  }
  if (self.req && self.req._reusedSocket && error.code === 'ECONNRESET' &&
    self.agent.addRequestNoreuse) {
    self.agent = { addRequest: self.agent.addRequestNoreuse.bind(self.agent) }
    self.start()
    self.req.end()
    return
  }
  if (self.timeout && self.timeoutTimer) {
    clearTimeout(self.timeoutTimer)
    self.timeoutTimer = null
  }
  self.emit('error', error)
}

Request.prototype.onRequestResponse = function (response) {
  var self = this

  if (self.timing) {
    self.timings.response = now() - self.startTimeNow
  }

  debug('onRequestResponse', self.uri.href, response.statusCode, response.headers)
  response.on('end', function () {
    if (self.timing) {
      self.timings.end = now() - self.startTimeNow
      response.timingStart = self.startTime

      // fill in the blanks for any periods that didn't trigger, such as
      // no lookup or connect due to keep alive
      if (!self.timings.socket) {
        self.timings.socket = 0
      }
      if (!self.timings.lookup) {
        self.timings.lookup = self.timings.socket
      }
      if (!self.timings.connect) {
        self.timings.connect = self.timings.lookup
      }
      if (!self.timings.response) {
        self.timings.response = self.timings.connect
      }

      debug('elapsed time', self.timings.end)

      // elapsedTime includes all redirects
      self.elapsedTime += Math.round(self.timings.end)

      // NOTE: elapsedTime is deprecated in favor of .timings
      response.elapsedTime = self.elapsedTime

      // timings is just for the final fetch
      response.timings = self.timings

      // pre-calculate phase timings as well
      response.timingPhases = {
        wait: self.timings.socket,
        dns: self.timings.lookup - self.timings.socket,
        tcp: self.timings.connect - self.timings.lookup,
        firstByte: self.timings.response - self.timings.connect,
        download: self.timings.end - self.timings.response,
        total: self.timings.end
      }
    }
    debug('response end', self.uri.href, response.statusCode, response.headers)
  })

  if (self._aborted) {
    debug('aborted', self.uri.href)
    response.resume()
    return
  }

  self.response = response
  response.request = self
  response.toJSON = responseToJSON

  // XXX This is different on 0.10, because SSL is strict by default
  if (self.httpModule === https &&
    self.strictSSL && (!response.hasOwnProperty('socket') ||
    !response.socket.authorized)) {
    debug('strict ssl error', self.uri.href)
    var sslErr = response.hasOwnProperty('socket') ? response.socket.authorizationError : self.uri.href + ' does not support SSL'
    self.emit('error', new Error('SSL Error: ' + sslErr))
    return
  }

  // Save the original host before any redirect (if it changes, we need to
  // remove any authorization headers).  Also remember the case of the header
  // name because lots of broken servers expect Host instead of host and we
  // want the caller to be able to specify this.
  self.originalHost = self.getHeader('host')
  if (!self.originalHostHeaderName) {
    self.originalHostHeaderName = self.hasHeader('host')
  }
  if (self.setHost) {
    self.removeHeader('host')
  }
  if (self.timeout && self.timeoutTimer) {
    clearTimeout(self.timeoutTimer)
    self.timeoutTimer = null
  }

  var targetCookieJar = (self._jar && self._jar.setCookie) ? self._jar : globalCookieJar
  var addCookie = function (cookie) {
    // set the cookie if it's domain in the href's domain.
    try {
      targetCookieJar.setCookie(cookie, self.uri.href, {ignoreError: true})
    } catch (e) {
      self.emit('error', e)
    }
  }

  response.caseless = caseless(response.headers)

  if (response.caseless.has('set-cookie') && (!self._disableCookies)) {
    var headerName = response.caseless.has('set-cookie')
    if (Array.isArray(response.headers[headerName])) {
      response.headers[headerName].forEach(addCookie)
    } else {
      addCookie(response.headers[headerName])
    }
  }

  if (self._redirect.onResponse(response)) {
    return // Ignore the rest of the response
  } else {
    // Be a good stream and emit end when the response is finished.
    // Hack to emit end on close because of a core bug that never fires end
    response.on('close', function () {
      if (!self._ended) {
        self.response.emit('end')
      }
    })

    response.once('end', function () {
      self._ended = true
    })

    var noBody = function (code) {
      return (
        self.method === 'HEAD' ||
        // Informational
        (code >= 100 && code < 200) ||
        // No Content
        code === 204 ||
        // Not Modified
        code === 304
      )
    }

    var responseContent
    if (self.gzip && !noBody(response.statusCode)) {
      var contentEncoding = response.headers['content-encoding'] || 'identity'
      contentEncoding = contentEncoding.trim().toLowerCase()

      // Be more lenient with decoding compressed responses, since (very rarely)
      // servers send slightly invalid gzip responses that are still accepted
      // by common browsers.
      // Always using Z_SYNC_FLUSH is what cURL does.
      var zlibOptions = {
        flush: zlib.Z_SYNC_FLUSH,
        finishFlush: zlib.Z_SYNC_FLUSH
      }

      if (contentEncoding === 'gzip') {
        responseContent = zlib.createGunzip(zlibOptions)
        response.pipe(responseContent)
      } else if (contentEncoding === 'deflate') {
        responseContent = zlib.createInflate(zlibOptions)
        response.pipe(responseContent)
      } else {
        // Since previous versions didn't check for Content-Encoding header,
        // ignore any invalid values to preserve backwards-compatibility
        if (contentEncoding !== 'identity') {
          debug('ignoring unrecognized Content-Encoding ' + contentEncoding)
        }
        responseContent = response
      }
    } else {
      responseContent = response
    }

    if (self.encoding) {
      if (self.dests.length !== 0) {
        console.error('Ignoring encoding parameter as this stream is being piped to another stream which makes the encoding option invalid.')
      } else {
        responseContent.setEncoding(self.encoding)
      }
    }

    if (self._paused) {
      responseContent.pause()
    }

    self.responseContent = responseContent

    self.emit('response', response)

    self.dests.forEach(function (dest) {
      self.pipeDest(dest)
    })

    responseContent.on('data', function (chunk) {
      if (self.timing && !self.responseStarted) {
        self.responseStartTime = (new Date()).getTime()

        // NOTE: responseStartTime is deprecated in favor of .timings
        response.responseStartTime = self.responseStartTime
      }
      self._destdata = true
      self.emit('data', chunk)
    })
    responseContent.once('end', function (chunk) {
      self.emit('end', chunk)
    })
    responseContent.on('error', function (error) {
      self.emit('error', error)
    })
    responseContent.on('close', function () { self.emit('close') })

    if (self.callback) {
      self.readResponseBody(response)
    } else { // if no callback
      self.on('end', function () {
        if (self._aborted) {
          debug('aborted', self.uri.href)
          return
        }
        self.emit('complete', response)
      })
    }
  }
  debug('finish init function', self.uri.href)
}

Request.prototype.readResponseBody = function (response) {
  var self = this
  debug("reading response's body")
  var buffers = []
  var bufferLength = 0
  var strings = []

  self.on('data', function (chunk) {
    if (!Buffer.isBuffer(chunk)) {
      strings.push(chunk)
    } else if (chunk.length) {
      bufferLength += chunk.length
      buffers.push(chunk)
    }
  })
  self.on('end', function () {
    debug('end event', self.uri.href)
    if (self._aborted) {
      debug('aborted', self.uri.href)
      // `buffer` is defined in the parent scope and used in a closure it exists for the life of the request.
      // This can lead to leaky behavior if the user retains a reference to the request object.
      buffers = []
      bufferLength = 0
      return
    }

    if (bufferLength) {
      debug('has body', self.uri.href, bufferLength)
      response.body = Buffer.concat(buffers, bufferLength)
      if (self.encoding !== null) {
        response.body = response.body.toString(self.encoding)
      }
      // `buffer` is defined in the parent scope and used in a closure it exists for the life of the Request.
      // This can lead to leaky behavior if the user retains a reference to the request object.
      buffers = []
      bufferLength = 0
    } else if (strings.length) {
      // The UTF8 BOM [0xEF,0xBB,0xBF] is converted to [0xFE,0xFF] in the JS UTC16/UCS2 representation.
      // Strip this value out when the encoding is set to 'utf8', as upstream consumers won't expect it and it breaks JSON.parse().
      if (self.encoding === 'utf8' && strings[0].length > 0 && strings[0][0] === '\uFEFF') {
        strings[0] = strings[0].substring(1)
      }
      response.body = strings.join('')
    }

    if (self._json) {
      try {
        response.body = JSON.parse(response.body, self._jsonReviver)
      } catch (e) {
        debug('invalid JSON received', self.uri.href)
      }
    }
    debug('emitting complete', self.uri.href)
    if (typeof response.body === 'undefined' && !self._json) {
      response.body = self.encoding === null ? Buffer.alloc(0) : ''
    }
    self.emit('complete', response, response.body)
  })
}

Request.prototype.abort = function () {
  var self = this
  self._aborted = true

  if (self.req) {
    self.req.abort()
  } else if (self.response) {
    self.response.destroy()
  }

  self.emit('abort')
}

Request.prototype.pipeDest = function (dest) {
  var self = this
  var response = self.response
  // Called after the response is received
  if (dest.headers && !dest.headersSent) {
    if (response.caseless.has('content-type')) {
      var ctname = response.caseless.has('content-type')
      if (dest.setHeader) {
        dest.setHeader(ctname, response.headers[ctname])
      } else {
        dest.headers[ctname] = response.headers[ctname]
      }
    }

    if (response.caseless.has('content-length')) {
      var clname = response.caseless.has('content-length')
      if (dest.setHeader) {
        dest.setHeader(clname, response.headers[clname])
      } else {
        dest.headers[clname] = response.headers[clname]
      }
    }
  }
  if (dest.setHeader && !dest.headersSent) {
    for (var i in response.headers) {
      // If the response content is being decoded, the Content-Encoding header
      // of the response doesn't represent the piped content, so don't pass it.
      if (!self.gzip || i !== 'content-encoding') {
        dest.setHeader(i, response.headers[i])
      }
    }
    dest.statusCode = response.statusCode
  }
  if (self.pipefilter) {
    self.pipefilter(response, dest)
  }
}

Request.prototype.qs = function (q, clobber) {
  var self = this
  var base
  if (!clobber && self.uri.query) {
    base = self._qs.parse(self.uri.query)
  } else {
    base = {}
  }

  for (var i in q) {
    base[i] = q[i]
  }

  var qs = self._qs.stringify(base)

  if (qs === '') {
    return self
  }

  self.uri = url.parse(self.uri.href.split('?')[0] + '?' + qs)
  self.url = self.uri
  self.path = self.uri.path

  if (self.uri.host === 'unix') {
    self.enableUnixSocket()
  }

  return self
}
Request.prototype.form = function (form) {
  var self = this
  if (form) {
    if (!/^application\/x-www-form-urlencoded\b/.test(self.getHeader('content-type'))) {
      self.setHeader('content-type', 'application/x-www-form-urlencoded')
    }
    self.body = (typeof form === 'string')
      ? self._qs.rfc3986(form.toString('utf8'))
      : self._qs.stringify(form).toString('utf8')
    return self
  }
  // create form-data object
  self._form = new FormData()
  self._form.on('error', function (err) {
    err.message = 'form-data: ' + err.message
    self.emit('error', err)
    self.abort()
  })
  return self._form
}
Request.prototype.multipart = function (multipart) {
  var self = this

  self._multipart.onRequest(multipart)

  if (!self._multipart.chunked) {
    self.body = self._multipart.body
  }

  return self
}
Request.prototype.json = function (val) {
  var self = this

  if (!self.hasHeader('accept')) {
    self.setHeader('accept', 'application/json')
  }

  if (typeof self.jsonReplacer === 'function') {
    self._jsonReplacer = self.jsonReplacer
  }

  self._json = true
  if (typeof val === 'boolean') {
    if (self.body !== undefined) {
      if (!/^application\/x-www-form-urlencoded\b/.test(self.getHeader('content-type'))) {
        self.body = safeStringify(self.body, self._jsonReplacer)
      } else {
        self.body = self._qs.rfc3986(self.body)
      }
      if (!self.hasHeader('content-type')) {
        self.setHeader('content-type', 'application/json')
      }
    }
  } else {
    self.body = safeStringify(val, self._jsonReplacer)
    if (!self.hasHeader('content-type')) {
      self.setHeader('content-type', 'application/json')
    }
  }

  if (typeof self.jsonReviver === 'function') {
    self._jsonReviver = self.jsonReviver
  }

  return self
}
Request.prototype.getHeader = function (name, headers) {
  var self = this
  var result, re, match
  if (!headers) {
    headers = self.headers
  }
  Object.keys(headers).forEach(function (key) {
    if (key.length !== name.length) {
      return
    }
    re = new RegExp(name, 'i')
    match = key.match(re)
    if (match) {
      result = headers[key]
    }
  })
  return result
}
Request.prototype.enableUnixSocket = function () {
  // Get the socket & request paths from the URL
  var unixParts = this.uri.path.split(':')
  var host = unixParts[0]
  var path = unixParts[1]
  // Apply unix properties to request
  this.socketPath = host
  this.uri.pathname = path
  this.uri.path = path
  this.uri.host = host
  this.uri.hostname = host
  this.uri.isUnix = true
}

Request.prototype.auth = function (user, pass, sendImmediately, bearer) {
  var self = this

  self._auth.onRequest(user, pass, sendImmediately, bearer)

  return self
}
Request.prototype.aws = function (opts, now) {
  var self = this

  if (!now) {
    self._aws = opts
    return self
  }

  if (opts.sign_version === 4 || opts.sign_version === '4') {
    // use aws4
    var options = {
      host: self.uri.host,
      path: self.uri.path,
      method: self.method,
      headers: self.headers,
      body: self.body
    }
    if (opts.service) {
      options.service = opts.service
    }
    var signRes = aws4.sign(options, {
      accessKeyId: opts.key,
      secretAccessKey: opts.secret,
      sessionToken: opts.session
    })
    self.setHeader('authorization', signRes.headers.Authorization)
    self.setHeader('x-amz-date', signRes.headers['X-Amz-Date'])
    if (signRes.headers['X-Amz-Security-Token']) {
      self.setHeader('x-amz-security-token', signRes.headers['X-Amz-Security-Token'])
    }
  } else {
    // default: use aws-sign2
    var date = new Date()
    self.setHeader('date', date.toUTCString())
    var auth = {
      key: opts.key,
      secret: opts.secret,
      verb: self.method.toUpperCase(),
      date: date,
      contentType: self.getHeader('content-type') || '',
      md5: self.getHeader('content-md5') || '',
      amazonHeaders: aws2.canonicalizeHeaders(self.headers)
    }
    var path = self.uri.path
    if (opts.bucket && path) {
      auth.resource = '/' + opts.bucket + path
    } else if (opts.bucket && !path) {
      auth.resource = '/' + opts.bucket
    } else if (!opts.bucket && path) {
      auth.resource = path
    } else if (!opts.bucket && !path) {
      auth.resource = '/'
    }
    auth.resource = aws2.canonicalizeResource(auth.resource)
    self.setHeader('authorization', aws2.authorization(auth))
  }

  return self
}
Request.prototype.httpSignature = function (opts) {
  var self = this
  httpSignature.signRequest({
    getHeader: function (header) {
      return self.getHeader(header, self.headers)
    },
    setHeader: function (header, value) {
      self.setHeader(header, value)
    },
    method: self.method,
    path: self.path
  }, opts)
  debug('httpSignature authorization', self.getHeader('authorization'))

  return self
}
Request.prototype.hawk = function (opts) {
  var self = this
  self.setHeader('Authorization', hawk.header(self.uri, self.method, opts))
}
Request.prototype.oauth = function (_oauth) {
  var self = this

  self._oauth.onRequest(_oauth)

  return self
}

Request.prototype.jar = function (jar) {
  var self = this
  var cookies

  if (self._redirect.redirectsFollowed === 0) {
    self.originalCookieHeader = self.getHeader('cookie')
  }

  if (!jar) {
    // disable cookies
    cookies = false
    self._disableCookies = true
  } else {
    var targetCookieJar = (jar && jar.getCookieString) ? jar : globalCookieJar
    var urihref = self.uri.href
    // fetch cookie in the Specified host
    if (targetCookieJar) {
      cookies = targetCookieJar.getCookieString(urihref)
    }
  }

  // if need cookie and cookie is not empty
  if (cookies && cookies.length) {
    if (self.originalCookieHeader) {
      // Don't overwrite existing Cookie header
      self.setHeader('cookie', self.originalCookieHeader + '; ' + cookies)
    } else {
      self.setHeader('cookie', cookies)
    }
  }
  self._jar = jar
  return self
}

// Stream API
Request.prototype.pipe = function (dest, opts) {
  var self = this

  if (self.response) {
    if (self._destdata) {
      self.emit('error', new Error('You cannot pipe after data has been emitted from the response.'))
    } else if (self._ended) {
      self.emit('error', new Error('You cannot pipe after the response has been ended.'))
    } else {
      stream.Stream.prototype.pipe.call(self, dest, opts)
      self.pipeDest(dest)
      return dest
    }
  } else {
    self.dests.push(dest)
    stream.Stream.prototype.pipe.call(self, dest, opts)
    return dest
  }
}
Request.prototype.write = function () {
  var self = this
  if (self._aborted) { return }

  if (!self._started) {
    self.start()
  }
  if (self.req) {
    return self.req.write.apply(self.req, arguments)
  }
}
Request.prototype.end = function (chunk) {
  var self = this
  if (self._aborted) { return }

  if (chunk) {
    self.write(chunk)
  }
  if (!self._started) {
    self.start()
  }
  if (self.req) {
    self.req.end()
  }
}
Request.prototype.pause = function () {
  var self = this
  if (!self.responseContent) {
    self._paused = true
  } else {
    self.responseContent.pause.apply(self.responseContent, arguments)
  }
}
Request.prototype.resume = function () {
  var self = this
  if (!self.responseContent) {
    self._paused = false
  } else {
    self.responseContent.resume.apply(self.responseContent, arguments)
  }
}
Request.prototype.destroy = function () {
  var self = this
  if (!self._ended) {
    self.end()
  } else if (self.response) {
    self.response.destroy()
  }
}

Request.defaultProxyHeaderWhiteList =
  Tunnel.defaultProxyHeaderWhiteList.slice()

Request.defaultProxyHeaderExclusiveList =
  Tunnel.defaultProxyHeaderExclusiveList.slice()

// Exports

Request.prototype.toJSON = requestToJSON
module.exports = Request


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {var capability = __webpack_require__(128)
var inherits = __webpack_require__(0)
var response = __webpack_require__(129)
var stream = __webpack_require__(36)
var toArrayBuffer = __webpack_require__(268)

var IncomingMessage = response.IncomingMessage
var rStates = response.readyStates

function decideMode (preferBinary, useFetch) {
	if (capability.fetch && useFetch) {
		return 'fetch'
	} else if (capability.mozchunkedarraybuffer) {
		return 'moz-chunked-arraybuffer'
	} else if (capability.msstream) {
		return 'ms-stream'
	} else if (capability.arraybuffer && preferBinary) {
		return 'arraybuffer'
	} else if (capability.vbArray && preferBinary) {
		return 'text:vbarray'
	} else {
		return 'text'
	}
}

var ClientRequest = module.exports = function (opts) {
	var self = this
	stream.Writable.call(self)

	self._opts = opts
	self._body = []
	self._headers = {}
	if (opts.auth)
		self.setHeader('Authorization', 'Basic ' + new Buffer(opts.auth).toString('base64'))
	Object.keys(opts.headers).forEach(function (name) {
		self.setHeader(name, opts.headers[name])
	})

	var preferBinary
	var useFetch = true
	if (opts.mode === 'disable-fetch' || ('requestTimeout' in opts && !capability.abortController)) {
		// If the use of XHR should be preferred. Not typically needed.
		useFetch = false
		preferBinary = true
	} else if (opts.mode === 'prefer-streaming') {
		// If streaming is a high priority but binary compatibility and
		// the accuracy of the 'content-type' header aren't
		preferBinary = false
	} else if (opts.mode === 'allow-wrong-content-type') {
		// If streaming is more important than preserving the 'content-type' header
		preferBinary = !capability.overrideMimeType
	} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
		// Use binary if text streaming may corrupt data or the content-type header, or for speed
		preferBinary = true
	} else {
		throw new Error('Invalid value for opts.mode')
	}
	self._mode = decideMode(preferBinary, useFetch)
	self._fetchTimer = null

	self.on('finish', function () {
		self._onFinish()
	})
}

inherits(ClientRequest, stream.Writable)

ClientRequest.prototype.setHeader = function (name, value) {
	var self = this
	var lowerName = name.toLowerCase()
	// This check is not necessary, but it prevents warnings from browsers about setting unsafe
	// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
	// http-browserify did it, so I will too.
	if (unsafeHeaders.indexOf(lowerName) !== -1)
		return

	self._headers[lowerName] = {
		name: name,
		value: value
	}
}

ClientRequest.prototype.getHeader = function (name) {
	var header = this._headers[name.toLowerCase()]
	if (header)
		return header.value
	return null
}

ClientRequest.prototype.removeHeader = function (name) {
	var self = this
	delete self._headers[name.toLowerCase()]
}

ClientRequest.prototype._onFinish = function () {
	var self = this

	if (self._destroyed)
		return
	var opts = self._opts

	var headersObj = self._headers
	var body = null
	if (opts.method !== 'GET' && opts.method !== 'HEAD') {
		if (capability.arraybuffer) {
			body = toArrayBuffer(Buffer.concat(self._body))
		} else if (capability.blobConstructor) {
			body = new global.Blob(self._body.map(function (buffer) {
				return toArrayBuffer(buffer)
			}), {
				type: (headersObj['content-type'] || {}).value || ''
			})
		} else {
			// get utf8 string
			body = Buffer.concat(self._body).toString()
		}
	}

	// create flattened list of headers
	var headersList = []
	Object.keys(headersObj).forEach(function (keyName) {
		var name = headersObj[keyName].name
		var value = headersObj[keyName].value
		if (Array.isArray(value)) {
			value.forEach(function (v) {
				headersList.push([name, v])
			})
		} else {
			headersList.push([name, value])
		}
	})

	if (self._mode === 'fetch') {
		var signal = null
		var fetchTimer = null
		if (capability.abortController) {
			var controller = new AbortController()
			signal = controller.signal
			self._fetchAbortController = controller

			if ('requestTimeout' in opts && opts.requestTimeout !== 0) {
				self._fetchTimer = global.setTimeout(function () {
					self.emit('requestTimeout')
					if (self._fetchAbortController)
						self._fetchAbortController.abort()
				}, opts.requestTimeout)
			}
		}

		global.fetch(self._opts.url, {
			method: self._opts.method,
			headers: headersList,
			body: body || undefined,
			mode: 'cors',
			credentials: opts.withCredentials ? 'include' : 'same-origin',
			signal: signal
		}).then(function (response) {
			self._fetchResponse = response
			self._connect()
		}, function (reason) {
			global.clearTimeout(self._fetchTimer)
			if (!self._destroyed)
				self.emit('error', reason)
		})
	} else {
		var xhr = self._xhr = new global.XMLHttpRequest()
		try {
			xhr.open(self._opts.method, self._opts.url, true)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}

		// Can't set responseType on really old browsers
		if ('responseType' in xhr)
			xhr.responseType = self._mode.split(':')[0]

		if ('withCredentials' in xhr)
			xhr.withCredentials = !!opts.withCredentials

		if (self._mode === 'text' && 'overrideMimeType' in xhr)
			xhr.overrideMimeType('text/plain; charset=x-user-defined')

		if ('requestTimeout' in opts) {
			xhr.timeout = opts.requestTimeout
			xhr.ontimeout = function () {
				self.emit('requestTimeout')
			}
		}

		headersList.forEach(function (header) {
			xhr.setRequestHeader(header[0], header[1])
		})

		self._response = null
		xhr.onreadystatechange = function () {
			switch (xhr.readyState) {
				case rStates.LOADING:
				case rStates.DONE:
					self._onXHRProgress()
					break
			}
		}
		// Necessary for streaming in Firefox, since xhr.response is ONLY defined
		// in onprogress, not in onreadystatechange with xhr.readyState = 3
		if (self._mode === 'moz-chunked-arraybuffer') {
			xhr.onprogress = function () {
				self._onXHRProgress()
			}
		}

		xhr.onerror = function () {
			if (self._destroyed)
				return
			self.emit('error', new Error('XHR error'))
		}

		try {
			xhr.send(body)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}
	}
}

/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */
function statusValid (xhr) {
	try {
		var status = xhr.status
		return (status !== null && status !== 0)
	} catch (e) {
		return false
	}
}

ClientRequest.prototype._onXHRProgress = function () {
	var self = this

	if (!statusValid(self._xhr) || self._destroyed)
		return

	if (!self._response)
		self._connect()

	self._response._onXHRProgress()
}

ClientRequest.prototype._connect = function () {
	var self = this

	if (self._destroyed)
		return

	self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._fetchTimer)
	self._response.on('error', function(err) {
		self.emit('error', err)
	})

	self.emit('response', self._response)
}

ClientRequest.prototype._write = function (chunk, encoding, cb) {
	var self = this

	self._body.push(chunk)
	cb()
}

ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function () {
	var self = this
	self._destroyed = true
	global.clearTimeout(self._fetchTimer)
	if (self._response)
		self._response._destroyed = true
	if (self._xhr)
		self._xhr.abort()
	else if (self._fetchAbortController)
		self._fetchAbortController.abort()
}

ClientRequest.prototype.end = function (data, encoding, cb) {
	var self = this
	if (typeof data === 'function') {
		cb = data
		data = undefined
	}

	stream.Writable.prototype.end.call(self, data, encoding, cb)
}

ClientRequest.prototype.flushHeaders = function () {}
ClientRequest.prototype.setTimeout = function () {}
ClientRequest.prototype.setNoDelay = function () {}
ClientRequest.prototype.setSocketKeepAlive = function () {}

// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var unsafeHeaders = [
	'accept-charset',
	'accept-encoding',
	'access-control-request-headers',
	'access-control-request-method',
	'connection',
	'content-length',
	'cookie',
	'cookie2',
	'date',
	'dnt',
	'expect',
	'host',
	'keep-alive',
	'origin',
	'referer',
	'te',
	'trailer',
	'transfer-encoding',
	'upgrade',
	'via'
]

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer, __webpack_require__(10), __webpack_require__(6)))

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(2).Buffer

module.exports = function (buf) {
	// If the buffer is backed by a Uint8Array, a faster version will work
	if (buf instanceof Uint8Array) {
		// If the buffer isn't a subarray, return the underlying ArrayBuffer
		if (buf.byteOffset === 0 && buf.byteLength === buf.buffer.byteLength) {
			return buf.buffer
		} else if (typeof buf.buffer.slice === 'function') {
			// Otherwise we need to get a proper copy
			return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength)
		}
	}

	if (Buffer.isBuffer(buf)) {
		// This is the slow version that will work with any Buffer
		// implementation (even in old browsers)
		var arrayCopy = new Uint8Array(buf.length)
		var len = buf.length
		for (var i = 0; i < len; i++) {
			arrayCopy[i] = buf[i]
		}
		return arrayCopy.buffer
	} else {
		throw new Error('Argument must be a Buffer')
	}
}


/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = {
  "100": "Continue",
  "101": "Switching Protocols",
  "102": "Processing",
  "200": "OK",
  "201": "Created",
  "202": "Accepted",
  "203": "Non-Authoritative Information",
  "204": "No Content",
  "205": "Reset Content",
  "206": "Partial Content",
  "207": "Multi-Status",
  "208": "Already Reported",
  "226": "IM Used",
  "300": "Multiple Choices",
  "301": "Moved Permanently",
  "302": "Found",
  "303": "See Other",
  "304": "Not Modified",
  "305": "Use Proxy",
  "307": "Temporary Redirect",
  "308": "Permanent Redirect",
  "400": "Bad Request",
  "401": "Unauthorized",
  "402": "Payment Required",
  "403": "Forbidden",
  "404": "Not Found",
  "405": "Method Not Allowed",
  "406": "Not Acceptable",
  "407": "Proxy Authentication Required",
  "408": "Request Timeout",
  "409": "Conflict",
  "410": "Gone",
  "411": "Length Required",
  "412": "Precondition Failed",
  "413": "Payload Too Large",
  "414": "URI Too Long",
  "415": "Unsupported Media Type",
  "416": "Range Not Satisfiable",
  "417": "Expectation Failed",
  "418": "I'm a teapot",
  "421": "Misdirected Request",
  "422": "Unprocessable Entity",
  "423": "Locked",
  "424": "Failed Dependency",
  "425": "Unordered Collection",
  "426": "Upgrade Required",
  "428": "Precondition Required",
  "429": "Too Many Requests",
  "431": "Request Header Fields Too Large",
  "451": "Unavailable For Legal Reasons",
  "500": "Internal Server Error",
  "501": "Not Implemented",
  "502": "Bad Gateway",
  "503": "Service Unavailable",
  "504": "Gateway Timeout",
  "505": "HTTP Version Not Supported",
  "506": "Variant Also Negotiates",
  "507": "Insufficient Storage",
  "508": "Loop Detected",
  "509": "Bandwidth Limit Exceeded",
  "510": "Not Extended",
  "511": "Network Authentication Required"
}


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var Buffer = __webpack_require__(2).Buffer;
var Transform = __webpack_require__(17).Transform;
var binding = __webpack_require__(272);
var util = __webpack_require__(5);
var assert = __webpack_require__(28).ok;
var kMaxLength = __webpack_require__(2).kMaxLength;
var kRangeErrorMessage = 'Cannot create final Buffer. It would be larger ' + 'than 0x' + kMaxLength.toString(16) + ' bytes';

// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
binding.Z_MIN_WINDOWBITS = 8;
binding.Z_MAX_WINDOWBITS = 15;
binding.Z_DEFAULT_WINDOWBITS = 15;

// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
binding.Z_MIN_CHUNK = 64;
binding.Z_MAX_CHUNK = Infinity;
binding.Z_DEFAULT_CHUNK = 16 * 1024;

binding.Z_MIN_MEMLEVEL = 1;
binding.Z_MAX_MEMLEVEL = 9;
binding.Z_DEFAULT_MEMLEVEL = 8;

binding.Z_MIN_LEVEL = -1;
binding.Z_MAX_LEVEL = 9;
binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;

// expose all the zlib constants
var bkeys = Object.keys(binding);
for (var bk = 0; bk < bkeys.length; bk++) {
  var bkey = bkeys[bk];
  if (bkey.match(/^Z/)) {
    Object.defineProperty(exports, bkey, {
      enumerable: true, value: binding[bkey], writable: false
    });
  }
}

// translation table for return codes.
var codes = {
  Z_OK: binding.Z_OK,
  Z_STREAM_END: binding.Z_STREAM_END,
  Z_NEED_DICT: binding.Z_NEED_DICT,
  Z_ERRNO: binding.Z_ERRNO,
  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
  Z_DATA_ERROR: binding.Z_DATA_ERROR,
  Z_MEM_ERROR: binding.Z_MEM_ERROR,
  Z_BUF_ERROR: binding.Z_BUF_ERROR,
  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
};

var ckeys = Object.keys(codes);
for (var ck = 0; ck < ckeys.length; ck++) {
  var ckey = ckeys[ck];
  codes[codes[ckey]] = ckey;
}

Object.defineProperty(exports, 'codes', {
  enumerable: true, value: Object.freeze(codes), writable: false
});

exports.Deflate = Deflate;
exports.Inflate = Inflate;
exports.Gzip = Gzip;
exports.Gunzip = Gunzip;
exports.DeflateRaw = DeflateRaw;
exports.InflateRaw = InflateRaw;
exports.Unzip = Unzip;

exports.createDeflate = function (o) {
  return new Deflate(o);
};

exports.createInflate = function (o) {
  return new Inflate(o);
};

exports.createDeflateRaw = function (o) {
  return new DeflateRaw(o);
};

exports.createInflateRaw = function (o) {
  return new InflateRaw(o);
};

exports.createGzip = function (o) {
  return new Gzip(o);
};

exports.createGunzip = function (o) {
  return new Gunzip(o);
};

exports.createUnzip = function (o) {
  return new Unzip(o);
};

// Convenience methods.
// compress/decompress a string or buffer in one step.
exports.deflate = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Deflate(opts), buffer, callback);
};

exports.deflateSync = function (buffer, opts) {
  return zlibBufferSync(new Deflate(opts), buffer);
};

exports.gzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gzip(opts), buffer, callback);
};

exports.gzipSync = function (buffer, opts) {
  return zlibBufferSync(new Gzip(opts), buffer);
};

exports.deflateRaw = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
};

exports.deflateRawSync = function (buffer, opts) {
  return zlibBufferSync(new DeflateRaw(opts), buffer);
};

exports.unzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Unzip(opts), buffer, callback);
};

exports.unzipSync = function (buffer, opts) {
  return zlibBufferSync(new Unzip(opts), buffer);
};

exports.inflate = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Inflate(opts), buffer, callback);
};

exports.inflateSync = function (buffer, opts) {
  return zlibBufferSync(new Inflate(opts), buffer);
};

exports.gunzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gunzip(opts), buffer, callback);
};

exports.gunzipSync = function (buffer, opts) {
  return zlibBufferSync(new Gunzip(opts), buffer);
};

exports.inflateRaw = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new InflateRaw(opts), buffer, callback);
};

exports.inflateRawSync = function (buffer, opts) {
  return zlibBufferSync(new InflateRaw(opts), buffer);
};

function zlibBuffer(engine, buffer, callback) {
  var buffers = [];
  var nread = 0;

  engine.on('error', onError);
  engine.on('end', onEnd);

  engine.end(buffer);
  flow();

  function flow() {
    var chunk;
    while (null !== (chunk = engine.read())) {
      buffers.push(chunk);
      nread += chunk.length;
    }
    engine.once('readable', flow);
  }

  function onError(err) {
    engine.removeListener('end', onEnd);
    engine.removeListener('readable', flow);
    callback(err);
  }

  function onEnd() {
    var buf;
    var err = null;

    if (nread >= kMaxLength) {
      err = new RangeError(kRangeErrorMessage);
    } else {
      buf = Buffer.concat(buffers, nread);
    }

    buffers = [];
    engine.close();
    callback(err, buf);
  }
}

function zlibBufferSync(engine, buffer) {
  if (typeof buffer === 'string') buffer = Buffer.from(buffer);

  if (!Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');

  var flushFlag = engine._finishFlushFlag;

  return engine._processChunk(buffer, flushFlag);
}

// generic zlib
// minimal 2-byte header
function Deflate(opts) {
  if (!(this instanceof Deflate)) return new Deflate(opts);
  Zlib.call(this, opts, binding.DEFLATE);
}

function Inflate(opts) {
  if (!(this instanceof Inflate)) return new Inflate(opts);
  Zlib.call(this, opts, binding.INFLATE);
}

// gzip - bigger header, same deflate compression
function Gzip(opts) {
  if (!(this instanceof Gzip)) return new Gzip(opts);
  Zlib.call(this, opts, binding.GZIP);
}

function Gunzip(opts) {
  if (!(this instanceof Gunzip)) return new Gunzip(opts);
  Zlib.call(this, opts, binding.GUNZIP);
}

// raw - no header
function DeflateRaw(opts) {
  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
  Zlib.call(this, opts, binding.DEFLATERAW);
}

function InflateRaw(opts) {
  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
  Zlib.call(this, opts, binding.INFLATERAW);
}

// auto-detect header.
function Unzip(opts) {
  if (!(this instanceof Unzip)) return new Unzip(opts);
  Zlib.call(this, opts, binding.UNZIP);
}

function isValidFlushFlag(flag) {
  return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
}

// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.

function Zlib(opts, mode) {
  var _this = this;

  this._opts = opts = opts || {};
  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;

  Transform.call(this, opts);

  if (opts.flush && !isValidFlushFlag(opts.flush)) {
    throw new Error('Invalid flush flag: ' + opts.flush);
  }
  if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) {
    throw new Error('Invalid flush flag: ' + opts.finishFlush);
  }

  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
  this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : binding.Z_FINISH;

  if (opts.chunkSize) {
    if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) {
      throw new Error('Invalid chunk size: ' + opts.chunkSize);
    }
  }

  if (opts.windowBits) {
    if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) {
      throw new Error('Invalid windowBits: ' + opts.windowBits);
    }
  }

  if (opts.level) {
    if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) {
      throw new Error('Invalid compression level: ' + opts.level);
    }
  }

  if (opts.memLevel) {
    if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) {
      throw new Error('Invalid memLevel: ' + opts.memLevel);
    }
  }

  if (opts.strategy) {
    if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) {
      throw new Error('Invalid strategy: ' + opts.strategy);
    }
  }

  if (opts.dictionary) {
    if (!Buffer.isBuffer(opts.dictionary)) {
      throw new Error('Invalid dictionary: it should be a Buffer instance');
    }
  }

  this._handle = new binding.Zlib(mode);

  var self = this;
  this._hadError = false;
  this._handle.onerror = function (message, errno) {
    // there is no way to cleanly recover.
    // continuing only obscures problems.
    _close(self);
    self._hadError = true;

    var error = new Error(message);
    error.errno = errno;
    error.code = exports.codes[errno];
    self.emit('error', error);
  };

  var level = exports.Z_DEFAULT_COMPRESSION;
  if (typeof opts.level === 'number') level = opts.level;

  var strategy = exports.Z_DEFAULT_STRATEGY;
  if (typeof opts.strategy === 'number') strategy = opts.strategy;

  this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);

  this._buffer = Buffer.allocUnsafe(this._chunkSize);
  this._offset = 0;
  this._level = level;
  this._strategy = strategy;

  this.once('end', this.close);

  Object.defineProperty(this, '_closed', {
    get: function () {
      return !_this._handle;
    },
    configurable: true,
    enumerable: true
  });
}

util.inherits(Zlib, Transform);

Zlib.prototype.params = function (level, strategy, callback) {
  if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) {
    throw new RangeError('Invalid compression level: ' + level);
  }
  if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) {
    throw new TypeError('Invalid strategy: ' + strategy);
  }

  if (this._level !== level || this._strategy !== strategy) {
    var self = this;
    this.flush(binding.Z_SYNC_FLUSH, function () {
      assert(self._handle, 'zlib binding closed');
      self._handle.params(level, strategy);
      if (!self._hadError) {
        self._level = level;
        self._strategy = strategy;
        if (callback) callback();
      }
    });
  } else {
    process.nextTick(callback);
  }
};

Zlib.prototype.reset = function () {
  assert(this._handle, 'zlib binding closed');
  return this._handle.reset();
};

// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
Zlib.prototype._flush = function (callback) {
  this._transform(Buffer.alloc(0), '', callback);
};

Zlib.prototype.flush = function (kind, callback) {
  var _this2 = this;

  var ws = this._writableState;

  if (typeof kind === 'function' || kind === undefined && !callback) {
    callback = kind;
    kind = binding.Z_FULL_FLUSH;
  }

  if (ws.ended) {
    if (callback) process.nextTick(callback);
  } else if (ws.ending) {
    if (callback) this.once('end', callback);
  } else if (ws.needDrain) {
    if (callback) {
      this.once('drain', function () {
        return _this2.flush(kind, callback);
      });
    }
  } else {
    this._flushFlag = kind;
    this.write(Buffer.alloc(0), '', callback);
  }
};

Zlib.prototype.close = function (callback) {
  _close(this, callback);
  process.nextTick(emitCloseNT, this);
};

function _close(engine, callback) {
  if (callback) process.nextTick(callback);

  // Caller may invoke .close after a zlib error (which will null _handle).
  if (!engine._handle) return;

  engine._handle.close();
  engine._handle = null;
}

function emitCloseNT(self) {
  self.emit('close');
}

Zlib.prototype._transform = function (chunk, encoding, cb) {
  var flushFlag;
  var ws = this._writableState;
  var ending = ws.ending || ws.ended;
  var last = ending && (!chunk || ws.length === chunk.length);

  if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));

  if (!this._handle) return cb(new Error('zlib binding closed'));

  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
  // (or whatever flag was provided using opts.finishFlush).
  // If it's explicitly flushing at some other time, then we use
  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
  // goodness.
  if (last) flushFlag = this._finishFlushFlag;else {
    flushFlag = this._flushFlag;
    // once we've flushed the last of the queue, stop flushing and
    // go back to the normal behavior.
    if (chunk.length >= ws.length) {
      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
    }
  }

  this._processChunk(chunk, flushFlag, cb);
};

Zlib.prototype._processChunk = function (chunk, flushFlag, cb) {
  var availInBefore = chunk && chunk.length;
  var availOutBefore = this._chunkSize - this._offset;
  var inOff = 0;

  var self = this;

  var async = typeof cb === 'function';

  if (!async) {
    var buffers = [];
    var nread = 0;

    var error;
    this.on('error', function (er) {
      error = er;
    });

    assert(this._handle, 'zlib binding closed');
    do {
      var res = this._handle.writeSync(flushFlag, chunk, // in
      inOff, // in_off
      availInBefore, // in_len
      this._buffer, // out
      this._offset, //out_off
      availOutBefore); // out_len
    } while (!this._hadError && callback(res[0], res[1]));

    if (this._hadError) {
      throw error;
    }

    if (nread >= kMaxLength) {
      _close(this);
      throw new RangeError(kRangeErrorMessage);
    }

    var buf = Buffer.concat(buffers, nread);
    _close(this);

    return buf;
  }

  assert(this._handle, 'zlib binding closed');
  var req = this._handle.write(flushFlag, chunk, // in
  inOff, // in_off
  availInBefore, // in_len
  this._buffer, // out
  this._offset, //out_off
  availOutBefore); // out_len

  req.buffer = chunk;
  req.callback = callback;

  function callback(availInAfter, availOutAfter) {
    // When the callback is used in an async write, the callback's
    // context is the `req` object that was created. The req object
    // is === this._handle, and that's why it's important to null
    // out the values after they are done being used. `this._handle`
    // can stay in memory longer than the callback and buffer are needed.
    if (this) {
      this.buffer = null;
      this.callback = null;
    }

    if (self._hadError) return;

    var have = availOutBefore - availOutAfter;
    assert(have >= 0, 'have should not go down');

    if (have > 0) {
      var out = self._buffer.slice(self._offset, self._offset + have);
      self._offset += have;
      // serve some output to the consumer.
      if (async) {
        self.push(out);
      } else {
        buffers.push(out);
        nread += out.length;
      }
    }

    // exhausted the output buffer, or used all the input create a new one.
    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
      availOutBefore = self._chunkSize;
      self._offset = 0;
      self._buffer = Buffer.allocUnsafe(self._chunkSize);
    }

    if (availOutAfter === 0) {
      // Not actually done.  Need to reprocess.
      // Also, update the availInBefore to the availInAfter value,
      // so that if we have to hit it a third (fourth, etc.) time,
      // it'll have the correct byte counts.
      inOff += availInBefore - availInAfter;
      availInBefore = availInAfter;

      if (!async) return true;

      var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
      newReq.callback = callback; // this same function
      newReq.buffer = chunk;
      return;
    }

    if (!async) return false;

    // finished with the chunk.
    cb();
  }
};

util.inherits(Deflate, Zlib);
util.inherits(Inflate, Zlib);
util.inherits(Gzip, Zlib);
util.inherits(Gunzip, Zlib);
util.inherits(DeflateRaw, Zlib);
util.inherits(InflateRaw, Zlib);
util.inherits(Unzip, Zlib);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, process) {
/* eslint camelcase: "off" */

var assert = __webpack_require__(28);

var Zstream = __webpack_require__(273);
var zlib_deflate = __webpack_require__(274);
var zlib_inflate = __webpack_require__(277);
var constants = __webpack_require__(280);

for (var key in constants) {
  exports[key] = constants[key];
}

// zlib modes
exports.NONE = 0;
exports.DEFLATE = 1;
exports.INFLATE = 2;
exports.GZIP = 3;
exports.GUNZIP = 4;
exports.DEFLATERAW = 5;
exports.INFLATERAW = 6;
exports.UNZIP = 7;

var GZIP_HEADER_ID1 = 0x1f;
var GZIP_HEADER_ID2 = 0x8b;

/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */
function Zlib(mode) {
  if (typeof mode !== 'number' || mode < exports.DEFLATE || mode > exports.UNZIP) {
    throw new TypeError('Bad argument');
  }

  this.dictionary = null;
  this.err = 0;
  this.flush = 0;
  this.init_done = false;
  this.level = 0;
  this.memLevel = 0;
  this.mode = mode;
  this.strategy = 0;
  this.windowBits = 0;
  this.write_in_progress = false;
  this.pending_close = false;
  this.gzip_id_bytes_read = 0;
}

Zlib.prototype.close = function () {
  if (this.write_in_progress) {
    this.pending_close = true;
    return;
  }

  this.pending_close = false;

  assert(this.init_done, 'close before init');
  assert(this.mode <= exports.UNZIP);

  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
    zlib_deflate.deflateEnd(this.strm);
  } else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) {
    zlib_inflate.inflateEnd(this.strm);
  }

  this.mode = exports.NONE;

  this.dictionary = null;
};

Zlib.prototype.write = function (flush, input, in_off, in_len, out, out_off, out_len) {
  return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};

Zlib.prototype.writeSync = function (flush, input, in_off, in_len, out, out_off, out_len) {
  return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};

Zlib.prototype._write = function (async, flush, input, in_off, in_len, out, out_off, out_len) {
  assert.equal(arguments.length, 8);

  assert(this.init_done, 'write before init');
  assert(this.mode !== exports.NONE, 'already finalized');
  assert.equal(false, this.write_in_progress, 'write already in progress');
  assert.equal(false, this.pending_close, 'close is pending');

  this.write_in_progress = true;

  assert.equal(false, flush === undefined, 'must provide flush value');

  this.write_in_progress = true;

  if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) {
    throw new Error('Invalid flush value');
  }

  if (input == null) {
    input = Buffer.alloc(0);
    in_len = 0;
    in_off = 0;
  }

  this.strm.avail_in = in_len;
  this.strm.input = input;
  this.strm.next_in = in_off;
  this.strm.avail_out = out_len;
  this.strm.output = out;
  this.strm.next_out = out_off;
  this.flush = flush;

  if (!async) {
    // sync version
    this._process();

    if (this._checkError()) {
      return this._afterSync();
    }
    return;
  }

  // async version
  var self = this;
  process.nextTick(function () {
    self._process();
    self._after();
  });

  return this;
};

Zlib.prototype._afterSync = function () {
  var avail_out = this.strm.avail_out;
  var avail_in = this.strm.avail_in;

  this.write_in_progress = false;

  return [avail_in, avail_out];
};

Zlib.prototype._process = function () {
  var next_expected_header_byte = null;

  // If the avail_out is left at 0, then it means that it ran out
  // of room.  If there was avail_out left over, then it means
  // that all of the input was consumed.
  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflate(this.strm, this.flush);
      break;
    case exports.UNZIP:
      if (this.strm.avail_in > 0) {
        next_expected_header_byte = this.strm.next_in;
      }

      switch (this.gzip_id_bytes_read) {
        case 0:
          if (next_expected_header_byte === null) {
            break;
          }

          if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
            this.gzip_id_bytes_read = 1;
            next_expected_header_byte++;

            if (this.strm.avail_in === 1) {
              // The only available byte was already read.
              break;
            }
          } else {
            this.mode = exports.INFLATE;
            break;
          }

        // fallthrough
        case 1:
          if (next_expected_header_byte === null) {
            break;
          }

          if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
            this.gzip_id_bytes_read = 2;
            this.mode = exports.GUNZIP;
          } else {
            // There is no actual difference between INFLATE and INFLATERAW
            // (after initialization).
            this.mode = exports.INFLATE;
          }

          break;
        default:
          throw new Error('invalid number of gzip magic number bytes read');
      }

    // fallthrough
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
      this.err = zlib_inflate.inflate(this.strm, this.flush

      // If data was encoded with dictionary
      );if (this.err === exports.Z_NEED_DICT && this.dictionary) {
        // Load it
        this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
        if (this.err === exports.Z_OK) {
          // And try to decode again
          this.err = zlib_inflate.inflate(this.strm, this.flush);
        } else if (this.err === exports.Z_DATA_ERROR) {
          // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
          // Make it possible for After() to tell a bad dictionary from bad
          // input.
          this.err = exports.Z_NEED_DICT;
        }
      }
      while (this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00) {
        // Bytes remain in input buffer. Perhaps this is another compressed
        // member in the same archive, or just trailing garbage.
        // Trailing zero bytes are okay, though, since they are frequently
        // used for padding.

        this.reset();
        this.err = zlib_inflate.inflate(this.strm, this.flush);
      }
      break;
    default:
      throw new Error('Unknown mode ' + this.mode);
  }
};

Zlib.prototype._checkError = function () {
  // Acceptable error states depend on the type of zlib stream.
  switch (this.err) {
    case exports.Z_OK:
    case exports.Z_BUF_ERROR:
      if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
        this._error('unexpected end of file');
        return false;
      }
      break;
    case exports.Z_STREAM_END:
      // normal statuses, not fatal
      break;
    case exports.Z_NEED_DICT:
      if (this.dictionary == null) {
        this._error('Missing dictionary');
      } else {
        this._error('Bad dictionary');
      }
      return false;
    default:
      // something else.
      this._error('Zlib error');
      return false;
  }

  return true;
};

Zlib.prototype._after = function () {
  if (!this._checkError()) {
    return;
  }

  var avail_out = this.strm.avail_out;
  var avail_in = this.strm.avail_in;

  this.write_in_progress = false;

  // call the write() cb
  this.callback(avail_in, avail_out);

  if (this.pending_close) {
    this.close();
  }
};

Zlib.prototype._error = function (message) {
  if (this.strm.msg) {
    message = this.strm.msg;
  }
  this.onerror(message, this.err

  // no hope of rescue.
  );this.write_in_progress = false;
  if (this.pending_close) {
    this.close();
  }
};

Zlib.prototype.init = function (windowBits, level, memLevel, strategy, dictionary) {
  assert(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');

  assert(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
  assert(level >= -1 && level <= 9, 'invalid compression level');

  assert(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');

  assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, 'invalid strategy');

  this._init(level, windowBits, memLevel, strategy, dictionary);
  this._setDictionary();
};

Zlib.prototype.params = function () {
  throw new Error('deflateParams Not supported');
};

Zlib.prototype.reset = function () {
  this._reset();
  this._setDictionary();
};

Zlib.prototype._init = function (level, windowBits, memLevel, strategy, dictionary) {
  this.level = level;
  this.windowBits = windowBits;
  this.memLevel = memLevel;
  this.strategy = strategy;

  this.flush = exports.Z_NO_FLUSH;

  this.err = exports.Z_OK;

  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) {
    this.windowBits += 16;
  }

  if (this.mode === exports.UNZIP) {
    this.windowBits += 32;
  }

  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) {
    this.windowBits = -1 * this.windowBits;
  }

  this.strm = new Zstream();

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
      break;
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
    case exports.UNZIP:
      this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
      break;
    default:
      throw new Error('Unknown mode ' + this.mode);
  }

  if (this.err !== exports.Z_OK) {
    this._error('Init error');
  }

  this.dictionary = dictionary;

  this.write_in_progress = false;
  this.init_done = true;
};

Zlib.prototype._setDictionary = function () {
  if (this.dictionary == null) {
    return;
  }

  this.err = exports.Z_OK;

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
      break;
    default:
      break;
  }

  if (this.err !== exports.Z_OK) {
    this._error('Failed to set dictionary');
  }
};

Zlib.prototype._reset = function () {
  this.err = exports.Z_OK;

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.DEFLATERAW:
    case exports.GZIP:
      this.err = zlib_deflate.deflateReset(this.strm);
      break;
    case exports.INFLATE:
    case exports.INFLATERAW:
    case exports.GUNZIP:
      this.err = zlib_inflate.inflateReset(this.strm);
      break;
    default:
      break;
  }

  if (this.err !== exports.Z_OK) {
    this._error('Failed to reset stream');
  }
};

exports.Zlib = Zlib;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer, __webpack_require__(6)))

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = __webpack_require__(55);
var trees   = __webpack_require__(275);
var adler32 = __webpack_require__(130);
var crc32   = __webpack_require__(131);
var msg     = __webpack_require__(276);

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
                );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = __webpack_require__(55);

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils         = __webpack_require__(55);
var adler32       = __webpack_require__(130);
var crc32         = __webpack_require__(131);
var inflate_fast  = __webpack_require__(278);
var inflate_table = __webpack_require__(279);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;           /* expect zlib header */
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }
        state.dmax = 1 << len;
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Array(state.head.extra_len);
              }
              utils.arraySet(
                state.head.extra,
                input,
                next,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                copy,
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          utils.arraySet(output, input, next, copy, put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inflate_fast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check =
                /*UPDATE(state.check, put - _out, _out);*/
                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = __webpack_require__(55);

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {


/*!
 *  Copyright 2010 LearnBoost <dev@learnboost.com>
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Module dependencies.
 */

var crypto = __webpack_require__(7)
  , parse = __webpack_require__(16).parse
  ;

/**
 * Valid keys.
 */

var keys = 
  [ 'acl'
  , 'location'
  , 'logging'
  , 'notification'
  , 'partNumber'
  , 'policy'
  , 'requestPayment'
  , 'torrent'
  , 'uploadId'
  , 'uploads'
  , 'versionId'
  , 'versioning'
  , 'versions'
  , 'website'
  ]

/**
 * Return an "Authorization" header value with the given `options`
 * in the form of "AWS <key>:<signature>"
 *
 * @param {Object} options
 * @return {String}
 * @api private
 */

function authorization (options) {
  return 'AWS ' + options.key + ':' + sign(options)
}

module.exports = authorization
module.exports.authorization = authorization

/**
 * Simple HMAC-SHA1 Wrapper
 *
 * @param {Object} options
 * @return {String}
 * @api private
 */ 

function hmacSha1 (options) {
  return crypto.createHmac('sha1', options.secret).update(options.message).digest('base64')
}

module.exports.hmacSha1 = hmacSha1

/**
 * Create a base64 sha1 HMAC for `options`. 
 * 
 * @param {Object} options
 * @return {String}
 * @api private
 */

function sign (options) {
  options.message = stringToSign(options)
  return hmacSha1(options)
}
module.exports.sign = sign

/**
 * Create a base64 sha1 HMAC for `options`. 
 *
 * Specifically to be used with S3 presigned URLs
 * 
 * @param {Object} options
 * @return {String}
 * @api private
 */

function signQuery (options) {
  options.message = queryStringToSign(options)
  return hmacSha1(options)
}
module.exports.signQuery= signQuery

/**
 * Return a string for sign() with the given `options`.
 *
 * Spec:
 * 
 *    <verb>\n
 *    <md5>\n
 *    <content-type>\n
 *    <date>\n
 *    [headers\n]
 *    <resource>
 *
 * @param {Object} options
 * @return {String}
 * @api private
 */

function stringToSign (options) {
  var headers = options.amazonHeaders || ''
  if (headers) headers += '\n'
  var r = 
    [ options.verb
    , options.md5
    , options.contentType
    , options.date ? options.date.toUTCString() : ''
    , headers + options.resource
    ]
  return r.join('\n')
}
module.exports.stringToSign = stringToSign

/**
 * Return a string for sign() with the given `options`, but is meant exclusively
 * for S3 presigned URLs
 *
 * Spec:
 * 
 *    <date>\n
 *    <resource>
 *
 * @param {Object} options
 * @return {String}
 * @api private
 */

function queryStringToSign (options){
  return 'GET\n\n\n' + options.date + '\n' + options.resource
}
module.exports.queryStringToSign = queryStringToSign

/**
 * Perform the following:
 *
 *  - ignore non-amazon headers
 *  - lowercase fields
 *  - sort lexicographically
 *  - trim whitespace between ":"
 *  - join with newline
 *
 * @param {Object} headers
 * @return {String}
 * @api private
 */

function canonicalizeHeaders (headers) {
  var buf = []
    , fields = Object.keys(headers)
    ;
  for (var i = 0, len = fields.length; i < len; ++i) {
    var field = fields[i]
      , val = headers[field]
      , field = field.toLowerCase()
      ;
    if (0 !== field.indexOf('x-amz')) continue
    buf.push(field + ':' + val)
  }
  return buf.sort().join('\n')
}
module.exports.canonicalizeHeaders = canonicalizeHeaders

/**
 * Perform the following:
 *
 *  - ignore non sub-resources
 *  - sort lexicographically
 *
 * @param {String} resource
 * @return {String}
 * @api private
 */

function canonicalizeResource (resource) {
  var url = parse(resource, true)
    , path = url.pathname
    , buf = []
    ;

  Object.keys(url.query).forEach(function(key){
    if (!~keys.indexOf(key)) return
    var val = '' == url.query[key] ? '' : '=' + encodeURIComponent(url.query[key])
    buf.push(key + val)
  })

  return path + (buf.length ? '?' + buf.sort().join('&') : '')
}
module.exports.canonicalizeResource = canonicalizeResource


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var aws4 = exports,
    url = __webpack_require__(16),
    querystring = __webpack_require__(48),
    crypto = __webpack_require__(7),
    lru = __webpack_require__(283),
    credentialsCache = lru(1000)

// http://docs.amazonwebservices.com/general/latest/gr/signature-version-4.html

function hmac(key, string, encoding) {
  return crypto.createHmac('sha256', key).update(string, 'utf8').digest(encoding)
}

function hash(string, encoding) {
  return crypto.createHash('sha256').update(string, 'utf8').digest(encoding)
}

// This function assumes the string has already been percent encoded
function encodeRfc3986(urlEncodedString) {
  return urlEncodedString.replace(/[!'()*]/g, function(c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

// request: { path | body, [host], [method], [headers], [service], [region] }
// credentials: { accessKeyId, secretAccessKey, [sessionToken] }
function RequestSigner(request, credentials) {

  if (typeof request === 'string') request = url.parse(request)

  var headers = request.headers = (request.headers || {}),
      hostParts = this.matchHost(request.hostname || request.host || headers.Host || headers.host)

  this.request = request
  this.credentials = credentials || this.defaultCredentials()

  this.service = request.service || hostParts[0] || ''
  this.region = request.region || hostParts[1] || 'us-east-1'

  // SES uses a different domain from the service name
  if (this.service === 'email') this.service = 'ses'

  if (!request.method && request.body)
    request.method = 'POST'

  if (!headers.Host && !headers.host) {
    headers.Host = request.hostname || request.host || this.createHost()

    // If a port is specified explicitly, use it as is
    if (request.port)
      headers.Host += ':' + request.port
  }
  if (!request.hostname && !request.host)
    request.hostname = headers.Host || headers.host

  this.isCodeCommitGit = this.service === 'codecommit' && request.method === 'GIT'
}

RequestSigner.prototype.matchHost = function(host) {
  var match = (host || '').match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com(\.cn)?$/)
  var hostParts = (match || []).slice(1, 3)

  // ES's hostParts are sometimes the other way round, if the value that is expected
  // to be region equals ‘es’ switch them back
  // e.g. search-cluster-name-aaaa00aaaa0aaa0aaaaaaa0aaa.us-east-1.es.amazonaws.com
  if (hostParts[1] === 'es')
    hostParts = hostParts.reverse()

  return hostParts
}

// http://docs.aws.amazon.com/general/latest/gr/rande.html
RequestSigner.prototype.isSingleRegion = function() {
  // Special case for S3 and SimpleDB in us-east-1
  if (['s3', 'sdb'].indexOf(this.service) >= 0 && this.region === 'us-east-1') return true

  return ['cloudfront', 'ls', 'route53', 'iam', 'importexport', 'sts']
    .indexOf(this.service) >= 0
}

RequestSigner.prototype.createHost = function() {
  var region = this.isSingleRegion() ? '' :
        (this.service === 's3' && this.region !== 'us-east-1' ? '-' : '.') + this.region,
      service = this.service === 'ses' ? 'email' : this.service
  return service + region + '.amazonaws.com'
}

RequestSigner.prototype.prepareRequest = function() {
  this.parsePath()

  var request = this.request, headers = request.headers, query

  if (request.signQuery) {

    this.parsedPath.query = query = this.parsedPath.query || {}

    if (this.credentials.sessionToken)
      query['X-Amz-Security-Token'] = this.credentials.sessionToken

    if (this.service === 's3' && !query['X-Amz-Expires'])
      query['X-Amz-Expires'] = 86400

    if (query['X-Amz-Date'])
      this.datetime = query['X-Amz-Date']
    else
      query['X-Amz-Date'] = this.getDateTime()

    query['X-Amz-Algorithm'] = 'AWS4-HMAC-SHA256'
    query['X-Amz-Credential'] = this.credentials.accessKeyId + '/' + this.credentialString()
    query['X-Amz-SignedHeaders'] = this.signedHeaders()

  } else {

    if (!request.doNotModifyHeaders && !this.isCodeCommitGit) {
      if (request.body && !headers['Content-Type'] && !headers['content-type'])
        headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'

      if (request.body && !headers['Content-Length'] && !headers['content-length'])
        headers['Content-Length'] = Buffer.byteLength(request.body)

      if (this.credentials.sessionToken && !headers['X-Amz-Security-Token'] && !headers['x-amz-security-token'])
        headers['X-Amz-Security-Token'] = this.credentials.sessionToken

      if (this.service === 's3' && !headers['X-Amz-Content-Sha256'] && !headers['x-amz-content-sha256'])
        headers['X-Amz-Content-Sha256'] = hash(this.request.body || '', 'hex')

      if (headers['X-Amz-Date'] || headers['x-amz-date'])
        this.datetime = headers['X-Amz-Date'] || headers['x-amz-date']
      else
        headers['X-Amz-Date'] = this.getDateTime()
    }

    delete headers.Authorization
    delete headers.authorization
  }
}

RequestSigner.prototype.sign = function() {
  if (!this.parsedPath) this.prepareRequest()

  if (this.request.signQuery) {
    this.parsedPath.query['X-Amz-Signature'] = this.signature()
  } else {
    this.request.headers.Authorization = this.authHeader()
  }

  this.request.path = this.formatPath()

  return this.request
}

RequestSigner.prototype.getDateTime = function() {
  if (!this.datetime) {
    var headers = this.request.headers,
      date = new Date(headers.Date || headers.date || new Date)

    this.datetime = date.toISOString().replace(/[:\-]|\.\d{3}/g, '')

    // Remove the trailing 'Z' on the timestamp string for CodeCommit git access
    if (this.isCodeCommitGit) this.datetime = this.datetime.slice(0, -1)
  }
  return this.datetime
}

RequestSigner.prototype.getDate = function() {
  return this.getDateTime().substr(0, 8)
}

RequestSigner.prototype.authHeader = function() {
  return [
    'AWS4-HMAC-SHA256 Credential=' + this.credentials.accessKeyId + '/' + this.credentialString(),
    'SignedHeaders=' + this.signedHeaders(),
    'Signature=' + this.signature(),
  ].join(', ')
}

RequestSigner.prototype.signature = function() {
  var date = this.getDate(),
      cacheKey = [this.credentials.secretAccessKey, date, this.region, this.service].join(),
      kDate, kRegion, kService, kCredentials = credentialsCache.get(cacheKey)
  if (!kCredentials) {
    kDate = hmac('AWS4' + this.credentials.secretAccessKey, date)
    kRegion = hmac(kDate, this.region)
    kService = hmac(kRegion, this.service)
    kCredentials = hmac(kService, 'aws4_request')
    credentialsCache.set(cacheKey, kCredentials)
  }
  return hmac(kCredentials, this.stringToSign(), 'hex')
}

RequestSigner.prototype.stringToSign = function() {
  return [
    'AWS4-HMAC-SHA256',
    this.getDateTime(),
    this.credentialString(),
    hash(this.canonicalString(), 'hex'),
  ].join('\n')
}

RequestSigner.prototype.canonicalString = function() {
  if (!this.parsedPath) this.prepareRequest()

  var pathStr = this.parsedPath.path,
      query = this.parsedPath.query,
      headers = this.request.headers,
      queryStr = '',
      normalizePath = this.service !== 's3',
      decodePath = this.service === 's3' || this.request.doNotEncodePath,
      decodeSlashesInPath = this.service === 's3',
      firstValOnly = this.service === 's3',
      bodyHash

  if (this.service === 's3' && this.request.signQuery) {
    bodyHash = 'UNSIGNED-PAYLOAD'
  } else if (this.isCodeCommitGit) {
    bodyHash = ''
  } else {
    bodyHash = headers['X-Amz-Content-Sha256'] || headers['x-amz-content-sha256'] ||
      hash(this.request.body || '', 'hex')
  }

  if (query) {
    queryStr = encodeRfc3986(querystring.stringify(Object.keys(query).sort().reduce(function(obj, key) {
      if (!key) return obj
      obj[key] = !Array.isArray(query[key]) ? query[key] :
        (firstValOnly ? query[key][0] : query[key].slice().sort())
      return obj
    }, {})))
  }
  if (pathStr !== '/') {
    if (normalizePath) pathStr = pathStr.replace(/\/{2,}/g, '/')
    pathStr = pathStr.split('/').reduce(function(path, piece) {
      if (normalizePath && piece === '..') {
        path.pop()
      } else if (!normalizePath || piece !== '.') {
        if (decodePath) piece = decodeURIComponent(piece)
        path.push(encodeRfc3986(encodeURIComponent(piece)))
      }
      return path
    }, []).join('/')
    if (pathStr[0] !== '/') pathStr = '/' + pathStr
    if (decodeSlashesInPath) pathStr = pathStr.replace(/%2F/g, '/')
  }

  return [
    this.request.method || 'GET',
    pathStr,
    queryStr,
    this.canonicalHeaders() + '\n',
    this.signedHeaders(),
    bodyHash,
  ].join('\n')
}

RequestSigner.prototype.canonicalHeaders = function() {
  var headers = this.request.headers
  function trimAll(header) {
    return header.toString().trim().replace(/\s+/g, ' ')
  }
  return Object.keys(headers)
    .sort(function(a, b) { return a.toLowerCase() < b.toLowerCase() ? -1 : 1 })
    .map(function(key) { return key.toLowerCase() + ':' + trimAll(headers[key]) })
    .join('\n')
}

RequestSigner.prototype.signedHeaders = function() {
  return Object.keys(this.request.headers)
    .map(function(key) { return key.toLowerCase() })
    .sort()
    .join(';')
}

RequestSigner.prototype.credentialString = function() {
  return [
    this.getDate(),
    this.region,
    this.service,
    'aws4_request',
  ].join('/')
}

RequestSigner.prototype.defaultCredentials = function() {
  var env = Object({"NODE_ENV":"production","PUBLIC_URL":"."})
  return {
    accessKeyId: env.AWS_ACCESS_KEY_ID || env.AWS_ACCESS_KEY,
    secretAccessKey: env.AWS_SECRET_ACCESS_KEY || env.AWS_SECRET_KEY,
    sessionToken: env.AWS_SESSION_TOKEN,
  }
}

RequestSigner.prototype.parsePath = function() {
  var path = this.request.path || '/',
      queryIx = path.indexOf('?'),
      query = null

  if (queryIx >= 0) {
    query = querystring.parse(path.slice(queryIx + 1))
    path = path.slice(0, queryIx)
  }

  // S3 doesn't always encode characters > 127 correctly and
  // all services don't encode characters > 255 correctly
  // So if there are non-reserved chars (and it's not already all % encoded), just encode them all
  if (/[^0-9A-Za-z!'()*\-._~%/]/.test(path)) {
    path = path.split('/').map(function(piece) {
      return encodeURIComponent(decodeURIComponent(piece))
    }).join('/')
  }

  this.parsedPath = {
    path: path,
    query: query,
  }
}

RequestSigner.prototype.formatPath = function() {
  var path = this.parsedPath.path,
      query = this.parsedPath.query

  if (!query) return path

  // Services don't support empty query string keys
  if (query[''] != null) delete query['']

  return path + '?' + encodeRfc3986(querystring.stringify(query))
}

aws4.RequestSigner = RequestSigner

aws4.sign = function(request, credentials) {
  return new RequestSigner(request, credentials).sign()
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = function(size) {
  return new LruCache(size)
}

function LruCache(size) {
  this.capacity = size | 0
  this.map = Object.create(null)
  this.list = new DoublyLinkedList()
}

LruCache.prototype.get = function(key) {
  var node = this.map[key]
  if (node == null) return undefined
  this.used(node)
  return node.val
}

LruCache.prototype.set = function(key, val) {
  var node = this.map[key]
  if (node != null) {
    node.val = val
  } else {
    if (!this.capacity) this.prune()
    if (!this.capacity) return false
    node = new DoublyLinkedNode(key, val)
    this.map[key] = node
    this.capacity--
  }
  this.used(node)
  return true
}

LruCache.prototype.used = function(node) {
  this.list.moveToFront(node)
}

LruCache.prototype.prune = function() {
  var node = this.list.pop()
  if (node != null) {
    delete this.map[node.key]
    this.capacity++
  }
}


function DoublyLinkedList() {
  this.firstNode = null
  this.lastNode = null
}

DoublyLinkedList.prototype.moveToFront = function(node) {
  if (this.firstNode == node) return

  this.remove(node)

  if (this.firstNode == null) {
    this.firstNode = node
    this.lastNode = node
    node.prev = null
    node.next = null
  } else {
    node.prev = null
    node.next = this.firstNode
    node.next.prev = node
    this.firstNode = node
  }
}

DoublyLinkedList.prototype.pop = function() {
  var lastNode = this.lastNode
  if (lastNode != null) {
    this.remove(lastNode)
  }
  return lastNode
}

DoublyLinkedList.prototype.remove = function(node) {
  if (this.firstNode == node) {
    this.firstNode = node.next
  } else if (node.prev != null) {
    node.prev.next = node.next
  }
  if (this.lastNode == node) {
    this.lastNode = node.prev
  } else if (node.next != null) {
    node.next.prev = node.prev
  }
}


function DoublyLinkedNode(key, val) {
  this.key = key
  this.val = val
  this.prev = null
  this.next = null
}


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2015 Joyent, Inc.

var parser = __webpack_require__(285);
var signer = __webpack_require__(293);
var verify = __webpack_require__(297);
var utils = __webpack_require__(56);



///--- API

module.exports = {

  parse: parser.parseRequest,
  parseRequest: parser.parseRequest,

  sign: signer.signRequest,
  signRequest: signer.signRequest,
  createSigner: signer.createSigner,
  isSigner: signer.isSigner,

  sshKeyToPEM: utils.sshKeyToPEM,
  sshKeyFingerprint: utils.fingerprint,
  pemToRsaSSHKey: utils.pemToRsaSSHKey,

  verify: verify.verifySignature,
  verifySignature: verify.verifySignature,
  verifyHMAC: verify.verifyHMAC
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2012 Joyent, Inc.  All rights reserved.

var assert = __webpack_require__(3);
var util = __webpack_require__(5);
var utils = __webpack_require__(56);



///--- Globals

var HASH_ALGOS = utils.HASH_ALGOS;
var PK_ALGOS = utils.PK_ALGOS;
var HttpSignatureError = utils.HttpSignatureError;
var InvalidAlgorithmError = utils.InvalidAlgorithmError;
var validateAlgorithm = utils.validateAlgorithm;

var State = {
  New: 0,
  Params: 1
};

var ParamsState = {
  Name: 0,
  Quote: 1,
  Value: 2,
  Comma: 3
};


///--- Specific Errors


function ExpiredRequestError(message) {
  HttpSignatureError.call(this, message, ExpiredRequestError);
}
util.inherits(ExpiredRequestError, HttpSignatureError);


function InvalidHeaderError(message) {
  HttpSignatureError.call(this, message, InvalidHeaderError);
}
util.inherits(InvalidHeaderError, HttpSignatureError);


function InvalidParamsError(message) {
  HttpSignatureError.call(this, message, InvalidParamsError);
}
util.inherits(InvalidParamsError, HttpSignatureError);


function MissingHeaderError(message) {
  HttpSignatureError.call(this, message, MissingHeaderError);
}
util.inherits(MissingHeaderError, HttpSignatureError);

function StrictParsingError(message) {
  HttpSignatureError.call(this, message, StrictParsingError);
}
util.inherits(StrictParsingError, HttpSignatureError);

///--- Exported API

module.exports = {

  /**
   * Parses the 'Authorization' header out of an http.ServerRequest object.
   *
   * Note that this API will fully validate the Authorization header, and throw
   * on any error.  It will not however check the signature, or the keyId format
   * as those are specific to your environment.  You can use the options object
   * to pass in extra constraints.
   *
   * As a response object you can expect this:
   *
   *     {
   *       "scheme": "Signature",
   *       "params": {
   *         "keyId": "foo",
   *         "algorithm": "rsa-sha256",
   *         "headers": [
   *           "date" or "x-date",
   *           "digest"
   *         ],
   *         "signature": "base64"
   *       },
   *       "signingString": "ready to be passed to crypto.verify()"
   *     }
   *
   * @param {Object} request an http.ServerRequest.
   * @param {Object} options an optional options object with:
   *                   - clockSkew: allowed clock skew in seconds (default 300).
   *                   - headers: required header names (def: date or x-date)
   *                   - algorithms: algorithms to support (default: all).
   *                   - strict: should enforce latest spec parsing
   *                             (default: false).
   * @return {Object} parsed out object (see above).
   * @throws {TypeError} on invalid input.
   * @throws {InvalidHeaderError} on an invalid Authorization header error.
   * @throws {InvalidParamsError} if the params in the scheme are invalid.
   * @throws {MissingHeaderError} if the params indicate a header not present,
   *                              either in the request headers from the params,
   *                              or not in the params from a required header
   *                              in options.
   * @throws {StrictParsingError} if old attributes are used in strict parsing
   *                              mode.
   * @throws {ExpiredRequestError} if the value of date or x-date exceeds skew.
   */
  parseRequest: function parseRequest(request, options) {
    assert.object(request, 'request');
    assert.object(request.headers, 'request.headers');
    if (options === undefined) {
      options = {};
    }
    if (options.headers === undefined) {
      options.headers = [request.headers['x-date'] ? 'x-date' : 'date'];
    }
    assert.object(options, 'options');
    assert.arrayOfString(options.headers, 'options.headers');
    assert.optionalFinite(options.clockSkew, 'options.clockSkew');

    var authzHeaderName = options.authorizationHeaderName || 'authorization';

    if (!request.headers[authzHeaderName]) {
      throw new MissingHeaderError('no ' + authzHeaderName + ' header ' +
                                   'present in the request');
    }

    options.clockSkew = options.clockSkew || 300;


    var i = 0;
    var state = State.New;
    var substate = ParamsState.Name;
    var tmpName = '';
    var tmpValue = '';

    var parsed = {
      scheme: '',
      params: {},
      signingString: ''
    };

    var authz = request.headers[authzHeaderName];
    for (i = 0; i < authz.length; i++) {
      var c = authz.charAt(i);

      switch (Number(state)) {

      case State.New:
        if (c !== ' ') parsed.scheme += c;
        else state = State.Params;
        break;

      case State.Params:
        switch (Number(substate)) {

        case ParamsState.Name:
          var code = c.charCodeAt(0);
          // restricted name of A-Z / a-z
          if ((code >= 0x41 && code <= 0x5a) || // A-Z
              (code >= 0x61 && code <= 0x7a)) { // a-z
            tmpName += c;
          } else if (c === '=') {
            if (tmpName.length === 0)
              throw new InvalidHeaderError('bad param format');
            substate = ParamsState.Quote;
          } else {
            throw new InvalidHeaderError('bad param format');
          }
          break;

        case ParamsState.Quote:
          if (c === '"') {
            tmpValue = '';
            substate = ParamsState.Value;
          } else {
            throw new InvalidHeaderError('bad param format');
          }
          break;

        case ParamsState.Value:
          if (c === '"') {
            parsed.params[tmpName] = tmpValue;
            substate = ParamsState.Comma;
          } else {
            tmpValue += c;
          }
          break;

        case ParamsState.Comma:
          if (c === ',') {
            tmpName = '';
            substate = ParamsState.Name;
          } else {
            throw new InvalidHeaderError('bad param format');
          }
          break;

        default:
          throw new Error('Invalid substate');
        }
        break;

      default:
        throw new Error('Invalid substate');
      }

    }

    if (!parsed.params.headers || parsed.params.headers === '') {
      if (request.headers['x-date']) {
        parsed.params.headers = ['x-date'];
      } else {
        parsed.params.headers = ['date'];
      }
    } else {
      parsed.params.headers = parsed.params.headers.split(' ');
    }

    // Minimally validate the parsed object
    if (!parsed.scheme || parsed.scheme !== 'Signature')
      throw new InvalidHeaderError('scheme was not "Signature"');

    if (!parsed.params.keyId)
      throw new InvalidHeaderError('keyId was not specified');

    if (!parsed.params.algorithm)
      throw new InvalidHeaderError('algorithm was not specified');

    if (!parsed.params.signature)
      throw new InvalidHeaderError('signature was not specified');

    // Check the algorithm against the official list
    parsed.params.algorithm = parsed.params.algorithm.toLowerCase();
    try {
      validateAlgorithm(parsed.params.algorithm);
    } catch (e) {
      if (e instanceof InvalidAlgorithmError)
        throw (new InvalidParamsError(parsed.params.algorithm + ' is not ' +
          'supported'));
      else
        throw (e);
    }

    // Build the signingString
    for (i = 0; i < parsed.params.headers.length; i++) {
      var h = parsed.params.headers[i].toLowerCase();
      parsed.params.headers[i] = h;

      if (h === 'request-line') {
        if (!options.strict) {
          /*
           * We allow headers from the older spec drafts if strict parsing isn't
           * specified in options.
           */
          parsed.signingString +=
            request.method + ' ' + request.url + ' HTTP/' + request.httpVersion;
        } else {
          /* Strict parsing doesn't allow older draft headers. */
          throw (new StrictParsingError('request-line is not a valid header ' +
            'with strict parsing enabled.'));
        }
      } else if (h === '(request-target)') {
        parsed.signingString +=
          '(request-target): ' + request.method.toLowerCase() + ' ' +
          request.url;
      } else {
        var value = request.headers[h];
        if (value === undefined)
          throw new MissingHeaderError(h + ' was not in the request');
        parsed.signingString += h + ': ' + value;
      }

      if ((i + 1) < parsed.params.headers.length)
        parsed.signingString += '\n';
    }

    // Check against the constraints
    var date;
    if (request.headers.date || request.headers['x-date']) {
        if (request.headers['x-date']) {
          date = new Date(request.headers['x-date']);
        } else {
          date = new Date(request.headers.date);
        }
      var now = new Date();
      var skew = Math.abs(now.getTime() - date.getTime());

      if (skew > options.clockSkew * 1000) {
        throw new ExpiredRequestError('clock skew of ' +
                                      (skew / 1000) +
                                      's was greater than ' +
                                      options.clockSkew + 's');
      }
    }

    options.headers.forEach(function (hdr) {
      // Remember that we already checked any headers in the params
      // were in the request, so if this passes we're good.
      if (parsed.params.headers.indexOf(hdr.toLowerCase()) < 0)
        throw new MissingHeaderError(hdr + ' was not a signed header');
    });

    if (options.algorithms) {
      if (options.algorithms.indexOf(parsed.params.algorithm) === -1)
        throw new InvalidParamsError(parsed.params.algorithm +
                                     ' is not a supported algorithm');
    }

    parsed.algorithm = parsed.params.algorithm.toUpperCase();
    parsed.keyId = parsed.params.keyId;
    return parsed;
  }

};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// Named EC curves

// Requires ec.js, jsbn.js, and jsbn2.js
var BigInteger = __webpack_require__(25).BigInteger
var ECCurveFp = __webpack_require__(44).ECCurveFp


// ----------------
// X9ECParameters

// constructor
function X9ECParameters(curve,g,n,h) {
    this.curve = curve;
    this.g = g;
    this.n = n;
    this.h = h;
}

function x9getCurve() {
    return this.curve;
}

function x9getG() {
    return this.g;
}

function x9getN() {
    return this.n;
}

function x9getH() {
    return this.h;
}

X9ECParameters.prototype.getCurve = x9getCurve;
X9ECParameters.prototype.getG = x9getG;
X9ECParameters.prototype.getN = x9getN;
X9ECParameters.prototype.getH = x9getH;

// ----------------
// SECNamedCurves

function fromHex(s) { return new BigInteger(s, 16); }

function secp128r1() {
    // p = 2^128 - 2^97 - 1
    var p = fromHex("FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF");
    var a = fromHex("FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC");
    var b = fromHex("E87579C11079F43DD824993C2CEE5ED3");
    //byte[] S = Hex.decode("000E0D4D696E6768756151750CC03A4473D03679");
    var n = fromHex("FFFFFFFE0000000075A30D1B9038A115");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04"
                + "161FF7528B899B2D0C28607CA52C5B86"
		+ "CF5AC8395BAFEB13C02DA292DDED7A83");
    return new X9ECParameters(curve, G, n, h);
}

function secp160k1() {
    // p = 2^160 - 2^32 - 2^14 - 2^12 - 2^9 - 2^8 - 2^7 - 2^3 - 2^2 - 1
    var p = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73");
    var a = BigInteger.ZERO;
    var b = fromHex("7");
    //byte[] S = null;
    var n = fromHex("0100000000000000000001B8FA16DFAB9ACA16B6B3");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04"
                + "3B4C382CE37AA192A4019E763036F4F5DD4D7EBB"
                + "938CF935318FDCED6BC28286531733C3F03C4FEE");
    return new X9ECParameters(curve, G, n, h);
}

function secp160r1() {
    // p = 2^160 - 2^31 - 1
    var p = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF");
    var a = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC");
    var b = fromHex("1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45");
    //byte[] S = Hex.decode("1053CDE42C14D696E67687561517533BF3F83345");
    var n = fromHex("0100000000000000000001F4C8F927AED3CA752257");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04"
		+ "4A96B5688EF573284664698968C38BB913CBFC82"
		+ "23A628553168947D59DCC912042351377AC5FB32");
    return new X9ECParameters(curve, G, n, h);
}

function secp192k1() {
    // p = 2^192 - 2^32 - 2^12 - 2^8 - 2^7 - 2^6 - 2^3 - 1
    var p = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37");
    var a = BigInteger.ZERO;
    var b = fromHex("3");
    //byte[] S = null;
    var n = fromHex("FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04"
                + "DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D"
                + "9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D");
    return new X9ECParameters(curve, G, n, h);
}

function secp192r1() {
    // p = 2^192 - 2^64 - 1
    var p = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF");
    var a = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC");
    var b = fromHex("64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1");
    //byte[] S = Hex.decode("3045AE6FC8422F64ED579528D38120EAE12196D5");
    var n = fromHex("FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04"
                + "188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012"
                + "07192B95FFC8DA78631011ED6B24CDD573F977A11E794811");
    return new X9ECParameters(curve, G, n, h);
}

function secp224r1() {
    // p = 2^224 - 2^96 + 1
    var p = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001");
    var a = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE");
    var b = fromHex("B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4");
    //byte[] S = Hex.decode("BD71344799D5C7FCDC45B59FA3B9AB8F6A948BC5");
    var n = fromHex("FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04"
                + "B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21"
                + "BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34");
    return new X9ECParameters(curve, G, n, h);
}

function secp256r1() {
    // p = 2^224 (2^32 - 1) + 2^192 + 2^96 - 1
    var p = fromHex("FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF");
    var a = fromHex("FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC");
    var b = fromHex("5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B");
    //byte[] S = Hex.decode("C49D360886E704936A6678E1139D26B7819F7E90");
    var n = fromHex("FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551");
    var h = BigInteger.ONE;
    var curve = new ECCurveFp(p, a, b);
    var G = curve.decodePointHex("04"
                + "6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296"
		+ "4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5");
    return new X9ECParameters(curve, G, n, h);
}

// TODO: make this into a proper hashtable
function getSECCurveByName(name) {
    if(name == "secp128r1") return secp128r1();
    if(name == "secp160k1") return secp160k1();
    if(name == "secp160r1") return secp160r1();
    if(name == "secp192k1") return secp192k1();
    if(name == "secp192r1") return secp192r1();
    if(name == "secp224r1") return secp224r1();
    if(name == "secp256r1") return secp256r1();
    return null;
}

module.exports = {
  "secp128r1":secp128r1,
  "secp160k1":secp160k1,
  "secp160r1":secp160r1,
  "secp192k1":secp192k1,
  "secp192r1":secp192r1,
  "secp224r1":secp224r1,
  "secp256r1":secp256r1
}


/***/ }),
/* 287 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.

var errors = __webpack_require__(78);
var types = __webpack_require__(79);

var Reader = __webpack_require__(289);
var Writer = __webpack_require__(290);


// --- Exports

module.exports = {

  Reader: Reader,

  Writer: Writer

};

for (var t in types) {
  if (types.hasOwnProperty(t))
    module.exports[t] = types[t];
}
for (var e in errors) {
  if (errors.hasOwnProperty(e))
    module.exports[e] = errors[e];
}


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.

var assert = __webpack_require__(28);
var Buffer = __webpack_require__(4).Buffer;

var ASN1 = __webpack_require__(79);
var errors = __webpack_require__(78);


// --- Globals

var newInvalidAsn1Error = errors.newInvalidAsn1Error;



// --- API

function Reader(data) {
  if (!data || !Buffer.isBuffer(data))
    throw new TypeError('data must be a node Buffer');

  this._buf = data;
  this._size = data.length;

  // These hold the "current" state
  this._len = 0;
  this._offset = 0;
}

Object.defineProperty(Reader.prototype, 'length', {
  enumerable: true,
  get: function () { return (this._len); }
});

Object.defineProperty(Reader.prototype, 'offset', {
  enumerable: true,
  get: function () { return (this._offset); }
});

Object.defineProperty(Reader.prototype, 'remain', {
  get: function () { return (this._size - this._offset); }
});

Object.defineProperty(Reader.prototype, 'buffer', {
  get: function () { return (this._buf.slice(this._offset)); }
});


/**
 * Reads a single byte and advances offset; you can pass in `true` to make this
 * a "peek" operation (i.e., get the byte, but don't advance the offset).
 *
 * @param {Boolean} peek true means don't move offset.
 * @return {Number} the next byte, null if not enough data.
 */
Reader.prototype.readByte = function (peek) {
  if (this._size - this._offset < 1)
    return null;

  var b = this._buf[this._offset] & 0xff;

  if (!peek)
    this._offset += 1;

  return b;
};


Reader.prototype.peek = function () {
  return this.readByte(true);
};


/**
 * Reads a (potentially) variable length off the BER buffer.  This call is
 * not really meant to be called directly, as callers have to manipulate
 * the internal buffer afterwards.
 *
 * As a result of this call, you can call `Reader.length`, until the
 * next thing called that does a readLength.
 *
 * @return {Number} the amount of offset to advance the buffer.
 * @throws {InvalidAsn1Error} on bad ASN.1
 */
Reader.prototype.readLength = function (offset) {
  if (offset === undefined)
    offset = this._offset;

  if (offset >= this._size)
    return null;

  var lenB = this._buf[offset++] & 0xff;
  if (lenB === null)
    return null;

  if ((lenB & 0x80) === 0x80) {
    lenB &= 0x7f;

    if (lenB === 0)
      throw newInvalidAsn1Error('Indefinite length not supported');

    if (lenB > 4)
      throw newInvalidAsn1Error('encoding too long');

    if (this._size - offset < lenB)
      return null;

    this._len = 0;
    for (var i = 0; i < lenB; i++)
      this._len = (this._len << 8) + (this._buf[offset++] & 0xff);

  } else {
    // Wasn't a variable length
    this._len = lenB;
  }

  return offset;
};


/**
 * Parses the next sequence in this BER buffer.
 *
 * To get the length of the sequence, call `Reader.length`.
 *
 * @return {Number} the sequence's tag.
 */
Reader.prototype.readSequence = function (tag) {
  var seq = this.peek();
  if (seq === null)
    return null;
  if (tag !== undefined && tag !== seq)
    throw newInvalidAsn1Error('Expected 0x' + tag.toString(16) +
                              ': got 0x' + seq.toString(16));

  var o = this.readLength(this._offset + 1); // stored in `length`
  if (o === null)
    return null;

  this._offset = o;
  return seq;
};


Reader.prototype.readInt = function () {
  return this._readTag(ASN1.Integer);
};


Reader.prototype.readBoolean = function () {
  return (this._readTag(ASN1.Boolean) === 0 ? false : true);
};


Reader.prototype.readEnumeration = function () {
  return this._readTag(ASN1.Enumeration);
};


Reader.prototype.readString = function (tag, retbuf) {
  if (!tag)
    tag = ASN1.OctetString;

  var b = this.peek();
  if (b === null)
    return null;

  if (b !== tag)
    throw newInvalidAsn1Error('Expected 0x' + tag.toString(16) +
                              ': got 0x' + b.toString(16));

  var o = this.readLength(this._offset + 1); // stored in `length`

  if (o === null)
    return null;

  if (this.length > this._size - o)
    return null;

  this._offset = o;

  if (this.length === 0)
    return retbuf ? Buffer.alloc(0) : '';

  var str = this._buf.slice(this._offset, this._offset + this.length);
  this._offset += this.length;

  return retbuf ? str : str.toString('utf8');
};

Reader.prototype.readOID = function (tag) {
  if (!tag)
    tag = ASN1.OID;

  var b = this.readString(tag, true);
  if (b === null)
    return null;

  var values = [];
  var value = 0;

  for (var i = 0; i < b.length; i++) {
    var byte = b[i] & 0xff;

    value <<= 7;
    value += byte & 0x7f;
    if ((byte & 0x80) === 0) {
      values.push(value);
      value = 0;
    }
  }

  value = values.shift();
  values.unshift(value % 40);
  values.unshift((value / 40) >> 0);

  return values.join('.');
};


Reader.prototype._readTag = function (tag) {
  assert.ok(tag !== undefined);

  var b = this.peek();

  if (b === null)
    return null;

  if (b !== tag)
    throw newInvalidAsn1Error('Expected 0x' + tag.toString(16) +
                              ': got 0x' + b.toString(16));

  var o = this.readLength(this._offset + 1); // stored in `length`
  if (o === null)
    return null;

  if (this.length > 4)
    throw newInvalidAsn1Error('Integer too long: ' + this.length);

  if (this.length > this._size - o)
    return null;
  this._offset = o;

  var fb = this._buf[this._offset];
  var value = 0;

  for (var i = 0; i < this.length; i++) {
    value <<= 8;
    value |= (this._buf[this._offset++] & 0xff);
  }

  if ((fb & 0x80) === 0x80 && i !== 4)
    value -= (1 << (i * 8));

  return value >> 0;
};



// --- Exported API

module.exports = Reader;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2011 Mark Cavage <mcavage@gmail.com> All rights reserved.

var assert = __webpack_require__(28);
var Buffer = __webpack_require__(4).Buffer;
var ASN1 = __webpack_require__(79);
var errors = __webpack_require__(78);


// --- Globals

var newInvalidAsn1Error = errors.newInvalidAsn1Error;

var DEFAULT_OPTS = {
  size: 1024,
  growthFactor: 8
};


// --- Helpers

function merge(from, to) {
  assert.ok(from);
  assert.equal(typeof (from), 'object');
  assert.ok(to);
  assert.equal(typeof (to), 'object');

  var keys = Object.getOwnPropertyNames(from);
  keys.forEach(function (key) {
    if (to[key])
      return;

    var value = Object.getOwnPropertyDescriptor(from, key);
    Object.defineProperty(to, key, value);
  });

  return to;
}



// --- API

function Writer(options) {
  options = merge(DEFAULT_OPTS, options || {});

  this._buf = Buffer.alloc(options.size || 1024);
  this._size = this._buf.length;
  this._offset = 0;
  this._options = options;

  // A list of offsets in the buffer where we need to insert
  // sequence tag/len pairs.
  this._seq = [];
}

Object.defineProperty(Writer.prototype, 'buffer', {
  get: function () {
    if (this._seq.length)
      throw newInvalidAsn1Error(this._seq.length + ' unended sequence(s)');

    return (this._buf.slice(0, this._offset));
  }
});

Writer.prototype.writeByte = function (b) {
  if (typeof (b) !== 'number')
    throw new TypeError('argument must be a Number');

  this._ensure(1);
  this._buf[this._offset++] = b;
};


Writer.prototype.writeInt = function (i, tag) {
  if (typeof (i) !== 'number')
    throw new TypeError('argument must be a Number');
  if (typeof (tag) !== 'number')
    tag = ASN1.Integer;

  var sz = 4;

  while ((((i & 0xff800000) === 0) || ((i & 0xff800000) === 0xff800000 >> 0)) &&
        (sz > 1)) {
    sz--;
    i <<= 8;
  }

  if (sz > 4)
    throw newInvalidAsn1Error('BER ints cannot be > 0xffffffff');

  this._ensure(2 + sz);
  this._buf[this._offset++] = tag;
  this._buf[this._offset++] = sz;

  while (sz-- > 0) {
    this._buf[this._offset++] = ((i & 0xff000000) >>> 24);
    i <<= 8;
  }

};


Writer.prototype.writeNull = function () {
  this.writeByte(ASN1.Null);
  this.writeByte(0x00);
};


Writer.prototype.writeEnumeration = function (i, tag) {
  if (typeof (i) !== 'number')
    throw new TypeError('argument must be a Number');
  if (typeof (tag) !== 'number')
    tag = ASN1.Enumeration;

  return this.writeInt(i, tag);
};


Writer.prototype.writeBoolean = function (b, tag) {
  if (typeof (b) !== 'boolean')
    throw new TypeError('argument must be a Boolean');
  if (typeof (tag) !== 'number')
    tag = ASN1.Boolean;

  this._ensure(3);
  this._buf[this._offset++] = tag;
  this._buf[this._offset++] = 0x01;
  this._buf[this._offset++] = b ? 0xff : 0x00;
};


Writer.prototype.writeString = function (s, tag) {
  if (typeof (s) !== 'string')
    throw new TypeError('argument must be a string (was: ' + typeof (s) + ')');
  if (typeof (tag) !== 'number')
    tag = ASN1.OctetString;

  var len = Buffer.byteLength(s);
  this.writeByte(tag);
  this.writeLength(len);
  if (len) {
    this._ensure(len);
    this._buf.write(s, this._offset);
    this._offset += len;
  }
};


Writer.prototype.writeBuffer = function (buf, tag) {
  if (typeof (tag) !== 'number')
    throw new TypeError('tag must be a number');
  if (!Buffer.isBuffer(buf))
    throw new TypeError('argument must be a buffer');

  this.writeByte(tag);
  this.writeLength(buf.length);
  this._ensure(buf.length);
  buf.copy(this._buf, this._offset, 0, buf.length);
  this._offset += buf.length;
};


Writer.prototype.writeStringArray = function (strings) {
  if ((!strings instanceof Array))
    throw new TypeError('argument must be an Array[String]');

  var self = this;
  strings.forEach(function (s) {
    self.writeString(s);
  });
};

// This is really to solve DER cases, but whatever for now
Writer.prototype.writeOID = function (s, tag) {
  if (typeof (s) !== 'string')
    throw new TypeError('argument must be a string');
  if (typeof (tag) !== 'number')
    tag = ASN1.OID;

  if (!/^([0-9]+\.){3,}[0-9]+$/.test(s))
    throw new Error('argument is not a valid OID string');

  function encodeOctet(bytes, octet) {
    if (octet < 128) {
        bytes.push(octet);
    } else if (octet < 16384) {
        bytes.push((octet >>> 7) | 0x80);
        bytes.push(octet & 0x7F);
    } else if (octet < 2097152) {
      bytes.push((octet >>> 14) | 0x80);
      bytes.push(((octet >>> 7) | 0x80) & 0xFF);
      bytes.push(octet & 0x7F);
    } else if (octet < 268435456) {
      bytes.push((octet >>> 21) | 0x80);
      bytes.push(((octet >>> 14) | 0x80) & 0xFF);
      bytes.push(((octet >>> 7) | 0x80) & 0xFF);
      bytes.push(octet & 0x7F);
    } else {
      bytes.push(((octet >>> 28) | 0x80) & 0xFF);
      bytes.push(((octet >>> 21) | 0x80) & 0xFF);
      bytes.push(((octet >>> 14) | 0x80) & 0xFF);
      bytes.push(((octet >>> 7) | 0x80) & 0xFF);
      bytes.push(octet & 0x7F);
    }
  }

  var tmp = s.split('.');
  var bytes = [];
  bytes.push(parseInt(tmp[0], 10) * 40 + parseInt(tmp[1], 10));
  tmp.slice(2).forEach(function (b) {
    encodeOctet(bytes, parseInt(b, 10));
  });

  var self = this;
  this._ensure(2 + bytes.length);
  this.writeByte(tag);
  this.writeLength(bytes.length);
  bytes.forEach(function (b) {
    self.writeByte(b);
  });
};


Writer.prototype.writeLength = function (len) {
  if (typeof (len) !== 'number')
    throw new TypeError('argument must be a Number');

  this._ensure(4);

  if (len <= 0x7f) {
    this._buf[this._offset++] = len;
  } else if (len <= 0xff) {
    this._buf[this._offset++] = 0x81;
    this._buf[this._offset++] = len;
  } else if (len <= 0xffff) {
    this._buf[this._offset++] = 0x82;
    this._buf[this._offset++] = len >> 8;
    this._buf[this._offset++] = len;
  } else if (len <= 0xffffff) {
    this._buf[this._offset++] = 0x83;
    this._buf[this._offset++] = len >> 16;
    this._buf[this._offset++] = len >> 8;
    this._buf[this._offset++] = len;
  } else {
    throw newInvalidAsn1Error('Length too long (> 4 bytes)');
  }
};

Writer.prototype.startSequence = function (tag) {
  if (typeof (tag) !== 'number')
    tag = ASN1.Sequence | ASN1.Constructor;

  this.writeByte(tag);
  this._seq.push(this._offset);
  this._ensure(3);
  this._offset += 3;
};


Writer.prototype.endSequence = function () {
  var seq = this._seq.pop();
  var start = seq + 3;
  var len = this._offset - start;

  if (len <= 0x7f) {
    this._shift(start, len, -2);
    this._buf[seq] = len;
  } else if (len <= 0xff) {
    this._shift(start, len, -1);
    this._buf[seq] = 0x81;
    this._buf[seq + 1] = len;
  } else if (len <= 0xffff) {
    this._buf[seq] = 0x82;
    this._buf[seq + 1] = len >> 8;
    this._buf[seq + 2] = len;
  } else if (len <= 0xffffff) {
    this._shift(start, len, 1);
    this._buf[seq] = 0x83;
    this._buf[seq + 1] = len >> 16;
    this._buf[seq + 2] = len >> 8;
    this._buf[seq + 3] = len;
  } else {
    throw newInvalidAsn1Error('Sequence too long');
  }
};


Writer.prototype._shift = function (start, len, shift) {
  assert.ok(start !== undefined);
  assert.ok(len !== undefined);
  assert.ok(shift);

  this._buf.copy(this._buf, start + shift, start, start + len);
  this._offset += shift;
};

Writer.prototype._ensure = function (len) {
  assert.ok(len);

  if (this._size - this._offset < len) {
    var sz = this._size * this._options.growthFactor;
    if (sz - this._offset < len)
      sz += len;

    var buf = Buffer.alloc(sz);

    this._buf.copy(buf, 0, 0, this._offset);
    this._buf = buf;
    this._size = sz;
  }
};



// --- Exported API

module.exports = Writer;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2017 Joyent, Inc.

module.exports = {
	read: read,
	verify: verify,
	sign: sign,
	signAsync: signAsync,
	write: write,

	/* Internal private API */
	fromBuffer: fromBuffer,
	toBuffer: toBuffer
};

var assert = __webpack_require__(3);
var SSHBuffer = __webpack_require__(46);
var crypto = __webpack_require__(7);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);
var Identity = __webpack_require__(47);
var rfc4253 = __webpack_require__(29);
var Signature = __webpack_require__(20);
var utils = __webpack_require__(9);
var Certificate = __webpack_require__(43);

function verify(cert, key) {
	/*
	 * We always give an issuerKey, so if our verify() is being called then
	 * there was no signature. Return false.
	 */
	return (false);
}

var TYPES = {
	'user': 1,
	'host': 2
};
Object.keys(TYPES).forEach(function (k) { TYPES[TYPES[k]] = k; });

var ECDSA_ALGO = /^ecdsa-sha2-([^@-]+)-cert-v01@openssh.com$/;

function read(buf, options) {
	if (Buffer.isBuffer(buf))
		buf = buf.toString('ascii');
	var parts = buf.trim().split(/[ \t\n]+/g);
	if (parts.length < 2 || parts.length > 3)
		throw (new Error('Not a valid SSH certificate line'));

	var algo = parts[0];
	var data = parts[1];

	data = Buffer.from(data, 'base64');
	return (fromBuffer(data, algo));
}

function fromBuffer(data, algo, partial) {
	var sshbuf = new SSHBuffer({ buffer: data });
	var innerAlgo = sshbuf.readString();
	if (algo !== undefined && innerAlgo !== algo)
		throw (new Error('SSH certificate algorithm mismatch'));
	if (algo === undefined)
		algo = innerAlgo;

	var cert = {};
	cert.signatures = {};
	cert.signatures.openssh = {};

	cert.signatures.openssh.nonce = sshbuf.readBuffer();

	var key = {};
	var parts = (key.parts = []);
	key.type = getAlg(algo);

	var partCount = algs.info[key.type].parts.length;
	while (parts.length < partCount)
		parts.push(sshbuf.readPart());
	assert.ok(parts.length >= 1, 'key must have at least one part');

	var algInfo = algs.info[key.type];
	if (key.type === 'ecdsa') {
		var res = ECDSA_ALGO.exec(algo);
		assert.ok(res !== null);
		assert.strictEqual(res[1], parts[0].data.toString());
	}

	for (var i = 0; i < algInfo.parts.length; ++i) {
		parts[i].name = algInfo.parts[i];
		if (parts[i].name !== 'curve' &&
		    algInfo.normalize !== false) {
			var p = parts[i];
			p.data = utils.mpNormalize(p.data);
		}
	}

	cert.subjectKey = new Key(key);

	cert.serial = sshbuf.readInt64();

	var type = TYPES[sshbuf.readInt()];
	assert.string(type, 'valid cert type');

	cert.signatures.openssh.keyId = sshbuf.readString();

	var principals = [];
	var pbuf = sshbuf.readBuffer();
	var psshbuf = new SSHBuffer({ buffer: pbuf });
	while (!psshbuf.atEnd())
		principals.push(psshbuf.readString());
	if (principals.length === 0)
		principals = ['*'];

	cert.subjects = principals.map(function (pr) {
		if (type === 'user')
			return (Identity.forUser(pr));
		else if (type === 'host')
			return (Identity.forHost(pr));
		throw (new Error('Unknown identity type ' + type));
	});

	cert.validFrom = int64ToDate(sshbuf.readInt64());
	cert.validUntil = int64ToDate(sshbuf.readInt64());

	cert.signatures.openssh.critical = sshbuf.readBuffer();
	cert.signatures.openssh.exts = sshbuf.readBuffer();

	/* reserved */
	sshbuf.readBuffer();

	var signingKeyBuf = sshbuf.readBuffer();
	cert.issuerKey = rfc4253.read(signingKeyBuf);

	/*
	 * OpenSSH certs don't give the identity of the issuer, just their
	 * public key. So, we use an Identity that matches anything. The
	 * isSignedBy() function will later tell you if the key matches.
	 */
	cert.issuer = Identity.forHost('**');

	var sigBuf = sshbuf.readBuffer();
	cert.signatures.openssh.signature =
	    Signature.parse(sigBuf, cert.issuerKey.type, 'ssh');

	if (partial !== undefined) {
		partial.remainder = sshbuf.remainder();
		partial.consumed = sshbuf._offset;
	}

	return (new Certificate(cert));
}

function int64ToDate(buf) {
	var i = buf.readUInt32BE(0) * 4294967296;
	i += buf.readUInt32BE(4);
	var d = new Date();
	d.setTime(i * 1000);
	d.sourceInt64 = buf;
	return (d);
}

function dateToInt64(date) {
	if (date.sourceInt64 !== undefined)
		return (date.sourceInt64);
	var i = Math.round(date.getTime() / 1000);
	var upper = Math.floor(i / 4294967296);
	var lower = Math.floor(i % 4294967296);
	var buf = Buffer.alloc(8);
	buf.writeUInt32BE(upper, 0);
	buf.writeUInt32BE(lower, 4);
	return (buf);
}

function sign(cert, key) {
	if (cert.signatures.openssh === undefined)
		cert.signatures.openssh = {};
	try {
		var blob = toBuffer(cert, true);
	} catch (e) {
		delete (cert.signatures.openssh);
		return (false);
	}
	var sig = cert.signatures.openssh;
	var hashAlgo = undefined;
	if (key.type === 'rsa' || key.type === 'dsa')
		hashAlgo = 'sha1';
	var signer = key.createSign(hashAlgo);
	signer.write(blob);
	sig.signature = signer.sign();
	return (true);
}

function signAsync(cert, signer, done) {
	if (cert.signatures.openssh === undefined)
		cert.signatures.openssh = {};
	try {
		var blob = toBuffer(cert, true);
	} catch (e) {
		delete (cert.signatures.openssh);
		done(e);
		return;
	}
	var sig = cert.signatures.openssh;

	signer(blob, function (err, signature) {
		if (err) {
			done(err);
			return;
		}
		try {
			/*
			 * This will throw if the signature isn't of a
			 * type/algo that can be used for SSH.
			 */
			signature.toBuffer('ssh');
		} catch (e) {
			done(e);
			return;
		}
		sig.signature = signature;
		done();
	});
}

function write(cert, options) {
	if (options === undefined)
		options = {};

	var blob = toBuffer(cert);
	var out = getCertType(cert.subjectKey) + ' ' + blob.toString('base64');
	if (options.comment)
		out = out + ' ' + options.comment;
	return (out);
}


function toBuffer(cert, noSig) {
	assert.object(cert.signatures.openssh, 'signature for openssh format');
	var sig = cert.signatures.openssh;

	if (sig.nonce === undefined)
		sig.nonce = crypto.randomBytes(16);
	var buf = new SSHBuffer({});
	buf.writeString(getCertType(cert.subjectKey));
	buf.writeBuffer(sig.nonce);

	var key = cert.subjectKey;
	var algInfo = algs.info[key.type];
	algInfo.parts.forEach(function (part) {
		buf.writePart(key.part[part]);
	});

	buf.writeInt64(cert.serial);

	var type = cert.subjects[0].type;
	assert.notStrictEqual(type, 'unknown');
	cert.subjects.forEach(function (id) {
		assert.strictEqual(id.type, type);
	});
	type = TYPES[type];
	buf.writeInt(type);

	if (sig.keyId === undefined) {
		sig.keyId = cert.subjects[0].type + '_' +
		    (cert.subjects[0].uid || cert.subjects[0].hostname);
	}
	buf.writeString(sig.keyId);

	var sub = new SSHBuffer({});
	cert.subjects.forEach(function (id) {
		if (type === TYPES.host)
			sub.writeString(id.hostname);
		else if (type === TYPES.user)
			sub.writeString(id.uid);
	});
	buf.writeBuffer(sub.toBuffer());

	buf.writeInt64(dateToInt64(cert.validFrom));
	buf.writeInt64(dateToInt64(cert.validUntil));

	if (sig.critical === undefined)
		sig.critical = Buffer.alloc(0);
	buf.writeBuffer(sig.critical);

	if (sig.exts === undefined)
		sig.exts = Buffer.alloc(0);
	buf.writeBuffer(sig.exts);

	/* reserved */
	buf.writeBuffer(Buffer.alloc(0));

	sub = rfc4253.write(cert.issuerKey);
	buf.writeBuffer(sub);

	if (!noSig)
		buf.writeBuffer(sig.signature.toBuffer('ssh'));

	return (buf.toBuffer());
}

function getAlg(certType) {
	if (certType === 'ssh-rsa-cert-v01@openssh.com')
		return ('rsa');
	if (certType === 'ssh-dss-cert-v01@openssh.com')
		return ('dsa');
	if (certType.match(ECDSA_ALGO))
		return ('ecdsa');
	if (certType === 'ssh-ed25519-cert-v01@openssh.com')
		return ('ed25519');
	throw (new Error('Unsupported cert type ' + certType));
}

function getCertType(key) {
	if (key.type === 'rsa')
		return ('ssh-rsa-cert-v01@openssh.com');
	if (key.type === 'dsa')
		return ('ssh-dss-cert-v01@openssh.com');
	if (key.type === 'ecdsa')
		return ('ecdsa-sha2-' + key.curve + '-cert-v01@openssh.com');
	if (key.type === 'ed25519')
		return ('ssh-ed25519-cert-v01@openssh.com');
	throw (new Error('Unsupported key type ' + key.type));
}


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright 2016 Joyent, Inc.

var x509 = __webpack_require__(137);

module.exports = {
	read: read,
	verify: x509.verify,
	sign: x509.sign,
	write: write
};

var assert = __webpack_require__(3);
var asn1 = __webpack_require__(22);
var Buffer = __webpack_require__(4).Buffer;
var algs = __webpack_require__(12);
var utils = __webpack_require__(9);
var Key = __webpack_require__(11);
var PrivateKey = __webpack_require__(13);
var pem = __webpack_require__(26);
var Identity = __webpack_require__(47);
var Signature = __webpack_require__(20);
var Certificate = __webpack_require__(43);

function read(buf, options) {
	if (typeof (buf) !== 'string') {
		assert.buffer(buf, 'buf');
		buf = buf.toString('ascii');
	}

	var lines = buf.trim().split(/[\r\n]+/g);

	var m = lines[0].match(/*JSSTYLED*/
	    /[-]+[ ]*BEGIN CERTIFICATE[ ]*[-]+/);
	assert.ok(m, 'invalid PEM header');

	var m2 = lines[lines.length - 1].match(/*JSSTYLED*/
	    /[-]+[ ]*END CERTIFICATE[ ]*[-]+/);
	assert.ok(m2, 'invalid PEM footer');

	var headers = {};
	while (true) {
		lines = lines.slice(1);
		m = lines[0].match(/*JSSTYLED*/
		    /^([A-Za-z0-9-]+): (.+)$/);
		if (!m)
			break;
		headers[m[1].toLowerCase()] = m[2];
	}

	/* Chop off the first and last lines */
	lines = lines.slice(0, -1).join('');
	buf = Buffer.from(lines, 'base64');

	return (x509.read(buf, options));
}

function write(cert, options) {
	var dbuf = x509.write(cert, options);

	var header = 'CERTIFICATE';
	var tmp = dbuf.toString('base64');
	var len = tmp.length + (tmp.length / 64) +
	    18 + 16 + header.length*2 + 10;
	var buf = Buffer.alloc(len);
	var o = 0;
	o += buf.write('-----BEGIN ' + header + '-----\n', o);
	for (var i = 0; i < tmp.length; ) {
		var limit = i + 64;
		if (limit > tmp.length)
			limit = tmp.length;
		o += buf.write(tmp.slice(i, limit), o);
		buf[o++] = 10;
		i = limit;
	}
	o += buf.write('-----END ' + header + '-----\n', o);

	return (buf.slice(0, o));
}


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright 2012 Joyent, Inc.  All rights reserved.

var assert = __webpack_require__(3);
var crypto = __webpack_require__(7);
var http = __webpack_require__(41);
var util = __webpack_require__(5);
var sshpk = __webpack_require__(76);
var jsprim = __webpack_require__(294);
var utils = __webpack_require__(56);

var sprintf = __webpack_require__(5).format;

var HASH_ALGOS = utils.HASH_ALGOS;
var PK_ALGOS = utils.PK_ALGOS;
var InvalidAlgorithmError = utils.InvalidAlgorithmError;
var HttpSignatureError = utils.HttpSignatureError;
var validateAlgorithm = utils.validateAlgorithm;

///--- Globals

var AUTHZ_FMT =
  'Signature keyId="%s",algorithm="%s",headers="%s",signature="%s"';

///--- Specific Errors

function MissingHeaderError(message) {
  HttpSignatureError.call(this, message, MissingHeaderError);
}
util.inherits(MissingHeaderError, HttpSignatureError);

function StrictParsingError(message) {
  HttpSignatureError.call(this, message, StrictParsingError);
}
util.inherits(StrictParsingError, HttpSignatureError);

/* See createSigner() */
function RequestSigner(options) {
  assert.object(options, 'options');

  var alg = [];
  if (options.algorithm !== undefined) {
    assert.string(options.algorithm, 'options.algorithm');
    alg = validateAlgorithm(options.algorithm);
  }
  this.rs_alg = alg;

  /*
   * RequestSigners come in two varieties: ones with an rs_signFunc, and ones
   * with an rs_signer.
   *
   * rs_signFunc-based RequestSigners have to build up their entire signing
   * string within the rs_lines array and give it to rs_signFunc as a single
   * concat'd blob. rs_signer-based RequestSigners can add a line at a time to
   * their signing state by using rs_signer.update(), thus only needing to
   * buffer the hash function state and one line at a time.
   */
  if (options.sign !== undefined) {
    assert.func(options.sign, 'options.sign');
    this.rs_signFunc = options.sign;

  } else if (alg[0] === 'hmac' && options.key !== undefined) {
    assert.string(options.keyId, 'options.keyId');
    this.rs_keyId = options.keyId;

    if (typeof (options.key) !== 'string' && !Buffer.isBuffer(options.key))
      throw (new TypeError('options.key for HMAC must be a string or Buffer'));

    /*
     * Make an rs_signer for HMACs, not a rs_signFunc -- HMACs digest their
     * data in chunks rather than requiring it all to be given in one go
     * at the end, so they are more similar to signers than signFuncs.
     */
    this.rs_signer = crypto.createHmac(alg[1].toUpperCase(), options.key);
    this.rs_signer.sign = function () {
      var digest = this.digest('base64');
      return ({
        hashAlgorithm: alg[1],
        toString: function () { return (digest); }
      });
    };

  } else if (options.key !== undefined) {
    var key = options.key;
    if (typeof (key) === 'string' || Buffer.isBuffer(key))
      key = sshpk.parsePrivateKey(key);

    assert.ok(sshpk.PrivateKey.isPrivateKey(key, [1, 2]),
      'options.key must be a sshpk.PrivateKey');
    this.rs_key = key;

    assert.string(options.keyId, 'options.keyId');
    this.rs_keyId = options.keyId;

    if (!PK_ALGOS[key.type]) {
      throw (new InvalidAlgorithmError(key.type.toUpperCase() + ' type ' +
        'keys are not supported'));
    }

    if (alg[0] !== undefined && key.type !== alg[0]) {
      throw (new InvalidAlgorithmError('options.key must be a ' +
        alg[0].toUpperCase() + ' key, was given a ' +
        key.type.toUpperCase() + ' key instead'));
    }

    this.rs_signer = key.createSign(alg[1]);

  } else {
    throw (new TypeError('options.sign (func) or options.key is required'));
  }

  this.rs_headers = [];
  this.rs_lines = [];
}

/**
 * Adds a header to be signed, with its value, into this signer.
 *
 * @param {String} header
 * @param {String} value
 * @return {String} value written
 */
RequestSigner.prototype.writeHeader = function (header, value) {
  assert.string(header, 'header');
  header = header.toLowerCase();
  assert.string(value, 'value');

  this.rs_headers.push(header);

  if (this.rs_signFunc) {
    this.rs_lines.push(header + ': ' + value);

  } else {
    var line = header + ': ' + value;
    if (this.rs_headers.length > 0)
      line = '\n' + line;
    this.rs_signer.update(line);
  }

  return (value);
};

/**
 * Adds a default Date header, returning its value.
 *
 * @return {String}
 */
RequestSigner.prototype.writeDateHeader = function () {
  return (this.writeHeader('date', jsprim.rfc1123(new Date())));
};

/**
 * Adds the request target line to be signed.
 *
 * @param {String} method, HTTP method (e.g. 'get', 'post', 'put')
 * @param {String} path
 */
RequestSigner.prototype.writeTarget = function (method, path) {
  assert.string(method, 'method');
  assert.string(path, 'path');
  method = method.toLowerCase();
  this.writeHeader('(request-target)', method + ' ' + path);
};

/**
 * Calculate the value for the Authorization header on this request
 * asynchronously.
 *
 * @param {Func} callback (err, authz)
 */
RequestSigner.prototype.sign = function (cb) {
  assert.func(cb, 'callback');

  if (this.rs_headers.length < 1)
    throw (new Error('At least one header must be signed'));

  var alg, authz;
  if (this.rs_signFunc) {
    var data = this.rs_lines.join('\n');
    var self = this;
    this.rs_signFunc(data, function (err, sig) {
      if (err) {
        cb(err);
        return;
      }
      try {
        assert.object(sig, 'signature');
        assert.string(sig.keyId, 'signature.keyId');
        assert.string(sig.algorithm, 'signature.algorithm');
        assert.string(sig.signature, 'signature.signature');
        alg = validateAlgorithm(sig.algorithm);

        authz = sprintf(AUTHZ_FMT,
          sig.keyId,
          sig.algorithm,
          self.rs_headers.join(' '),
          sig.signature);
      } catch (e) {
        cb(e);
        return;
      }
      cb(null, authz);
    });

  } else {
    try {
      var sigObj = this.rs_signer.sign();
    } catch (e) {
      cb(e);
      return;
    }
    alg = (this.rs_alg[0] || this.rs_key.type) + '-' + sigObj.hashAlgorithm;
    var signature = sigObj.toString();
    authz = sprintf(AUTHZ_FMT,
      this.rs_keyId,
      alg,
      this.rs_headers.join(' '),
      signature);
    cb(null, authz);
  }
};

///--- Exported API

module.exports = {
  /**
   * Identifies whether a given object is a request signer or not.
   *
   * @param {Object} object, the object to identify
   * @returns {Boolean}
   */
  isSigner: function (obj) {
    if (typeof (obj) === 'object' && obj instanceof RequestSigner)
      return (true);
    return (false);
  },

  /**
   * Creates a request signer, used to asynchronously build a signature
   * for a request (does not have to be an http.ClientRequest).
   *
   * @param {Object} options, either:
   *                   - {String} keyId
   *                   - {String|Buffer} key
   *                   - {String} algorithm (optional, required for HMAC)
   *                 or:
   *                   - {Func} sign (data, cb)
   * @return {RequestSigner}
   */
  createSigner: function createSigner(options) {
    return (new RequestSigner(options));
  },

  /**
   * Adds an 'Authorization' header to an http.ClientRequest object.
   *
   * Note that this API will add a Date header if it's not already set. Any
   * other headers in the options.headers array MUST be present, or this
   * will throw.
   *
   * You shouldn't need to check the return type; it's just there if you want
   * to be pedantic.
   *
   * The optional flag indicates whether parsing should use strict enforcement
   * of the version draft-cavage-http-signatures-04 of the spec or beyond.
   * The default is to be loose and support
   * older versions for compatibility.
   *
   * @param {Object} request an instance of http.ClientRequest.
   * @param {Object} options signing parameters object:
   *                   - {String} keyId required.
   *                   - {String} key required (either a PEM or HMAC key).
   *                   - {Array} headers optional; defaults to ['date'].
   *                   - {String} algorithm optional (unless key is HMAC);
   *                              default is the same as the sshpk default
   *                              signing algorithm for the type of key given
   *                   - {String} httpVersion optional; defaults to '1.1'.
   *                   - {Boolean} strict optional; defaults to 'false'.
   * @return {Boolean} true if Authorization (and optionally Date) were added.
   * @throws {TypeError} on bad parameter types (input).
   * @throws {InvalidAlgorithmError} if algorithm was bad or incompatible with
   *                                 the given key.
   * @throws {sshpk.KeyParseError} if key was bad.
   * @throws {MissingHeaderError} if a header to be signed was specified but
   *                              was not present.
   */
  signRequest: function signRequest(request, options) {
    assert.object(request, 'request');
    assert.object(options, 'options');
    assert.optionalString(options.algorithm, 'options.algorithm');
    assert.string(options.keyId, 'options.keyId');
    assert.optionalArrayOfString(options.headers, 'options.headers');
    assert.optionalString(options.httpVersion, 'options.httpVersion');

    if (!request.getHeader('Date'))
      request.setHeader('Date', jsprim.rfc1123(new Date()));
    if (!options.headers)
      options.headers = ['date'];
    if (!options.httpVersion)
      options.httpVersion = '1.1';

    var alg = [];
    if (options.algorithm) {
      options.algorithm = options.algorithm.toLowerCase();
      alg = validateAlgorithm(options.algorithm);
    }

    var i;
    var stringToSign = '';
    for (i = 0; i < options.headers.length; i++) {
      if (typeof (options.headers[i]) !== 'string')
        throw new TypeError('options.headers must be an array of Strings');

      var h = options.headers[i].toLowerCase();

      if (h === 'request-line') {
        if (!options.strict) {
          /**
           * We allow headers from the older spec drafts if strict parsing isn't
           * specified in options.
           */
          stringToSign +=
            request.method + ' ' + request.path + ' HTTP/' +
            options.httpVersion;
        } else {
          /* Strict parsing doesn't allow older draft headers. */
          throw (new StrictParsingError('request-line is not a valid header ' +
            'with strict parsing enabled.'));
        }
      } else if (h === '(request-target)') {
        stringToSign +=
          '(request-target): ' + request.method.toLowerCase() + ' ' +
          request.path;
      } else {
        var value = request.getHeader(h);
        if (value === undefined || value === '') {
          throw new MissingHeaderError(h + ' was not in the request');
        }
        stringToSign += h + ': ' + value;
      }

      if ((i + 1) < options.headers.length)
        stringToSign += '\n';
    }

    /* This is just for unit tests. */
    if (request.hasOwnProperty('_stringToSign')) {
      request._stringToSign = stringToSign;
    }

    var signature;
    if (alg[0] === 'hmac') {
      if (typeof (options.key) !== 'string' && !Buffer.isBuffer(options.key))
        throw (new TypeError('options.key must be a string or Buffer'));

      var hmac = crypto.createHmac(alg[1].toUpperCase(), options.key);
      hmac.update(stringToSign);
      signature = hmac.digest('base64');

    } else {
      var key = options.key;
      if (typeof (key) === 'string' || Buffer.isBuffer(key))
        key = sshpk.parsePrivateKey(options.key);

      assert.ok(sshpk.PrivateKey.isPrivateKey(key, [1, 2]),
        'options.key must be a sshpk.PrivateKey');

      if (!PK_ALGOS[key.type]) {
        throw (new InvalidAlgorithmError(key.type.toUpperCase() + ' type ' +
          'keys are not supported'));
      }

      if (alg[0] !== undefined && key.type !== alg[0]) {
        throw (new InvalidAlgorithmError('options.key must be a ' +
          alg[0].toUpperCase() + ' key, was given a ' +
          key.type.toUpperCase() + ' key instead'));
      }

      var signer = key.createSign(alg[1]);
      signer.update(stringToSign);
      var sigObj = signer.sign();
      if (!HASH_ALGOS[sigObj.hashAlgorithm]) {
        throw (new InvalidAlgorithmError(sigObj.hashAlgorithm.toUpperCase() +
          ' is not a supported hash algorithm'));
      }
      options.algorithm = key.type + '-' + sigObj.hashAlgorithm;
      signature = sigObj.toString();
      assert.notStrictEqual(signature, '', 'empty signature produced');
    }

    var authzHeaderName = options.authorizationHeaderName || 'Authorization';

    request.setHeader(authzHeaderName, sprintf(AUTHZ_FMT,
                                               options.keyId,
                                               options.algorithm,
                                               options.headers.join(' '),
                                               signature));

    return true;
  }

};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * lib/jsprim.js: utilities for primitive JavaScript types
 */

var mod_assert = __webpack_require__(3);
var mod_util = __webpack_require__(5);

var mod_extsprintf = __webpack_require__(138);
var mod_verror = __webpack_require__(295);
var mod_jsonschema = __webpack_require__(296);

/*
 * Public interface
 */
exports.deepCopy = deepCopy;
exports.deepEqual = deepEqual;
exports.isEmpty = isEmpty;
exports.hasKey = hasKey;
exports.forEachKey = forEachKey;
exports.pluck = pluck;
exports.flattenObject = flattenObject;
exports.flattenIter = flattenIter;
exports.validateJsonObject = validateJsonObjectJS;
exports.validateJsonObjectJS = validateJsonObjectJS;
exports.randElt = randElt;
exports.extraProperties = extraProperties;
exports.mergeObjects = mergeObjects;

exports.startsWith = startsWith;
exports.endsWith = endsWith;

exports.parseInteger = parseInteger;

exports.iso8601 = iso8601;
exports.rfc1123 = rfc1123;
exports.parseDateTime = parseDateTime;

exports.hrtimediff = hrtimeDiff;
exports.hrtimeDiff = hrtimeDiff;
exports.hrtimeAccum = hrtimeAccum;
exports.hrtimeAdd = hrtimeAdd;
exports.hrtimeNanosec = hrtimeNanosec;
exports.hrtimeMicrosec = hrtimeMicrosec;
exports.hrtimeMillisec = hrtimeMillisec;


/*
 * Deep copy an acyclic *basic* Javascript object.  This only handles basic
 * scalars (strings, numbers, booleans) and arbitrarily deep arrays and objects
 * containing these.  This does *not* handle instances of other classes.
 */
function deepCopy(obj)
{
	var ret, key;
	var marker = '__deepCopy';

	if (obj && obj[marker])
		throw (new Error('attempted deep copy of cyclic object'));

	if (obj && obj.constructor == Object) {
		ret = {};
		obj[marker] = true;

		for (key in obj) {
			if (key == marker)
				continue;

			ret[key] = deepCopy(obj[key]);
		}

		delete (obj[marker]);
		return (ret);
	}

	if (obj && obj.constructor == Array) {
		ret = [];
		obj[marker] = true;

		for (key = 0; key < obj.length; key++)
			ret.push(deepCopy(obj[key]));

		delete (obj[marker]);
		return (ret);
	}

	/*
	 * It must be a primitive type -- just return it.
	 */
	return (obj);
}

function deepEqual(obj1, obj2)
{
	if (typeof (obj1) != typeof (obj2))
		return (false);

	if (obj1 === null || obj2 === null || typeof (obj1) != 'object')
		return (obj1 === obj2);

	if (obj1.constructor != obj2.constructor)
		return (false);

	var k;
	for (k in obj1) {
		if (!obj2.hasOwnProperty(k))
			return (false);

		if (!deepEqual(obj1[k], obj2[k]))
			return (false);
	}

	for (k in obj2) {
		if (!obj1.hasOwnProperty(k))
			return (false);
	}

	return (true);
}

function isEmpty(obj)
{
	var key;
	for (key in obj)
		return (false);
	return (true);
}

function hasKey(obj, key)
{
	mod_assert.equal(typeof (key), 'string');
	return (Object.prototype.hasOwnProperty.call(obj, key));
}

function forEachKey(obj, callback)
{
	for (var key in obj) {
		if (hasKey(obj, key)) {
			callback(key, obj[key]);
		}
	}
}

function pluck(obj, key)
{
	mod_assert.equal(typeof (key), 'string');
	return (pluckv(obj, key));
}

function pluckv(obj, key)
{
	if (obj === null || typeof (obj) !== 'object')
		return (undefined);

	if (obj.hasOwnProperty(key))
		return (obj[key]);

	var i = key.indexOf('.');
	if (i == -1)
		return (undefined);

	var key1 = key.substr(0, i);
	if (!obj.hasOwnProperty(key1))
		return (undefined);

	return (pluckv(obj[key1], key.substr(i + 1)));
}

/*
 * Invoke callback(row) for each entry in the array that would be returned by
 * flattenObject(data, depth).  This is just like flattenObject(data,
 * depth).forEach(callback), except that the intermediate array is never
 * created.
 */
function flattenIter(data, depth, callback)
{
	doFlattenIter(data, depth, [], callback);
}

function doFlattenIter(data, depth, accum, callback)
{
	var each;
	var key;

	if (depth === 0) {
		each = accum.slice(0);
		each.push(data);
		callback(each);
		return;
	}

	mod_assert.ok(data !== null);
	mod_assert.equal(typeof (data), 'object');
	mod_assert.equal(typeof (depth), 'number');
	mod_assert.ok(depth >= 0);

	for (key in data) {
		each = accum.slice(0);
		each.push(key);
		doFlattenIter(data[key], depth - 1, each, callback);
	}
}

function flattenObject(data, depth)
{
	if (depth === 0)
		return ([ data ]);

	mod_assert.ok(data !== null);
	mod_assert.equal(typeof (data), 'object');
	mod_assert.equal(typeof (depth), 'number');
	mod_assert.ok(depth >= 0);

	var rv = [];
	var key;

	for (key in data) {
		flattenObject(data[key], depth - 1).forEach(function (p) {
			rv.push([ key ].concat(p));
		});
	}

	return (rv);
}

function startsWith(str, prefix)
{
	return (str.substr(0, prefix.length) == prefix);
}

function endsWith(str, suffix)
{
	return (str.substr(
	    str.length - suffix.length, suffix.length) == suffix);
}

function iso8601(d)
{
	if (typeof (d) == 'number')
		d = new Date(d);
	mod_assert.ok(d.constructor === Date);
	return (mod_extsprintf.sprintf('%4d-%02d-%02dT%02d:%02d:%02d.%03dZ',
	    d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate(),
	    d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(),
	    d.getUTCMilliseconds()));
}

var RFC1123_MONTHS = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var RFC1123_DAYS = [
    'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function rfc1123(date) {
	return (mod_extsprintf.sprintf('%s, %02d %s %04d %02d:%02d:%02d GMT',
	    RFC1123_DAYS[date.getUTCDay()], date.getUTCDate(),
	    RFC1123_MONTHS[date.getUTCMonth()], date.getUTCFullYear(),
	    date.getUTCHours(), date.getUTCMinutes(),
	    date.getUTCSeconds()));
}

/*
 * Parses a date expressed as a string, as either a number of milliseconds since
 * the epoch or any string format that Date accepts, giving preference to the
 * former where these two sets overlap (e.g., small numbers).
 */
function parseDateTime(str)
{
	/*
	 * This is irritatingly implicit, but significantly more concise than
	 * alternatives.  The "+str" will convert a string containing only a
	 * number directly to a Number, or NaN for other strings.  Thus, if the
	 * conversion succeeds, we use it (this is the milliseconds-since-epoch
	 * case).  Otherwise, we pass the string directly to the Date
	 * constructor to parse.
	 */
	var numeric = +str;
	if (!isNaN(numeric)) {
		return (new Date(numeric));
	} else {
		return (new Date(str));
	}
}


/*
 * Number.*_SAFE_INTEGER isn't present before node v0.12, so we hardcode
 * the ES6 definitions here, while allowing for them to someday be higher.
 */
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
var MIN_SAFE_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;


/*
 * Default options for parseInteger().
 */
var PI_DEFAULTS = {
	base: 10,
	allowSign: true,
	allowPrefix: false,
	allowTrailing: false,
	allowImprecise: false,
	trimWhitespace: false,
	leadingZeroIsOctal: false
};

var CP_0 = 0x30;
var CP_9 = 0x39;

var CP_A = 0x41;
var CP_B = 0x42;
var CP_O = 0x4f;
var CP_T = 0x54;
var CP_X = 0x58;
var CP_Z = 0x5a;

var CP_a = 0x61;
var CP_b = 0x62;
var CP_o = 0x6f;
var CP_t = 0x74;
var CP_x = 0x78;
var CP_z = 0x7a;

var PI_CONV_DEC = 0x30;
var PI_CONV_UC = 0x37;
var PI_CONV_LC = 0x57;


/*
 * A stricter version of parseInt() that provides options for changing what
 * is an acceptable string (for example, disallowing trailing characters).
 */
function parseInteger(str, uopts)
{
	mod_assert.string(str, 'str');
	mod_assert.optionalObject(uopts, 'options');

	var baseOverride = false;
	var options = PI_DEFAULTS;

	if (uopts) {
		baseOverride = hasKey(uopts, 'base');
		options = mergeObjects(options, uopts);
		mod_assert.number(options.base, 'options.base');
		mod_assert.ok(options.base >= 2, 'options.base >= 2');
		mod_assert.ok(options.base <= 36, 'options.base <= 36');
		mod_assert.bool(options.allowSign, 'options.allowSign');
		mod_assert.bool(options.allowPrefix, 'options.allowPrefix');
		mod_assert.bool(options.allowTrailing,
		    'options.allowTrailing');
		mod_assert.bool(options.allowImprecise,
		    'options.allowImprecise');
		mod_assert.bool(options.trimWhitespace,
		    'options.trimWhitespace');
		mod_assert.bool(options.leadingZeroIsOctal,
		    'options.leadingZeroIsOctal');

		if (options.leadingZeroIsOctal) {
			mod_assert.ok(!baseOverride,
			    '"base" and "leadingZeroIsOctal" are ' +
			    'mutually exclusive');
		}
	}

	var c;
	var pbase = -1;
	var base = options.base;
	var start;
	var mult = 1;
	var value = 0;
	var idx = 0;
	var len = str.length;

	/* Trim any whitespace on the left side. */
	if (options.trimWhitespace) {
		while (idx < len && isSpace(str.charCodeAt(idx))) {
			++idx;
		}
	}

	/* Check the number for a leading sign. */
	if (options.allowSign) {
		if (str[idx] === '-') {
			idx += 1;
			mult = -1;
		} else if (str[idx] === '+') {
			idx += 1;
		}
	}

	/* Parse the base-indicating prefix if there is one. */
	if (str[idx] === '0') {
		if (options.allowPrefix) {
			pbase = prefixToBase(str.charCodeAt(idx + 1));
			if (pbase !== -1 && (!baseOverride || pbase === base)) {
				base = pbase;
				idx += 2;
			}
		}

		if (pbase === -1 && options.leadingZeroIsOctal) {
			base = 8;
		}
	}

	/* Parse the actual digits. */
	for (start = idx; idx < len; ++idx) {
		c = translateDigit(str.charCodeAt(idx));
		if (c !== -1 && c < base) {
			value *= base;
			value += c;
		} else {
			break;
		}
	}

	/* If we didn't parse any digits, we have an invalid number. */
	if (start === idx) {
		return (new Error('invalid number: ' + JSON.stringify(str)));
	}

	/* Trim any whitespace on the right side. */
	if (options.trimWhitespace) {
		while (idx < len && isSpace(str.charCodeAt(idx))) {
			++idx;
		}
	}

	/* Check for trailing characters. */
	if (idx < len && !options.allowTrailing) {
		return (new Error('trailing characters after number: ' +
		    JSON.stringify(str.slice(idx))));
	}

	/* If our value is 0, we return now, to avoid returning -0. */
	if (value === 0) {
		return (0);
	}

	/* Calculate our final value. */
	var result = value * mult;

	/*
	 * If the string represents a value that cannot be precisely represented
	 * by JavaScript, then we want to check that:
	 *
	 * - We never increased the value past MAX_SAFE_INTEGER
	 * - We don't make the result negative and below MIN_SAFE_INTEGER
	 *
	 * Because we only ever increment the value during parsing, there's no
	 * chance of moving past MAX_SAFE_INTEGER and then dropping below it
	 * again, losing precision in the process. This means that we only need
	 * to do our checks here, at the end.
	 */
	if (!options.allowImprecise &&
	    (value > MAX_SAFE_INTEGER || result < MIN_SAFE_INTEGER)) {
		return (new Error('number is outside of the supported range: ' +
		    JSON.stringify(str.slice(start, idx))));
	}

	return (result);
}


/*
 * Interpret a character code as a base-36 digit.
 */
function translateDigit(d)
{
	if (d >= CP_0 && d <= CP_9) {
		/* '0' to '9' -> 0 to 9 */
		return (d - PI_CONV_DEC);
	} else if (d >= CP_A && d <= CP_Z) {
		/* 'A' - 'Z' -> 10 to 35 */
		return (d - PI_CONV_UC);
	} else if (d >= CP_a && d <= CP_z) {
		/* 'a' - 'z' -> 10 to 35 */
		return (d - PI_CONV_LC);
	} else {
		/* Invalid character code */
		return (-1);
	}
}


/*
 * Test if a value matches the ECMAScript definition of trimmable whitespace.
 */
function isSpace(c)
{
	return (c === 0x20) ||
	    (c >= 0x0009 && c <= 0x000d) ||
	    (c === 0x00a0) ||
	    (c === 0x1680) ||
	    (c === 0x180e) ||
	    (c >= 0x2000 && c <= 0x200a) ||
	    (c === 0x2028) ||
	    (c === 0x2029) ||
	    (c === 0x202f) ||
	    (c === 0x205f) ||
	    (c === 0x3000) ||
	    (c === 0xfeff);
}


/*
 * Determine which base a character indicates (e.g., 'x' indicates hex).
 */
function prefixToBase(c)
{
	if (c === CP_b || c === CP_B) {
		/* 0b/0B (binary) */
		return (2);
	} else if (c === CP_o || c === CP_O) {
		/* 0o/0O (octal) */
		return (8);
	} else if (c === CP_t || c === CP_T) {
		/* 0t/0T (decimal) */
		return (10);
	} else if (c === CP_x || c === CP_X) {
		/* 0x/0X (hexadecimal) */
		return (16);
	} else {
		/* Not a meaningful character */
		return (-1);
	}
}


function validateJsonObjectJS(schema, input)
{
	var report = mod_jsonschema.validate(input, schema);

	if (report.errors.length === 0)
		return (null);

	/* Currently, we only do anything useful with the first error. */
	var error = report.errors[0];

	/* The failed property is given by a URI with an irrelevant prefix. */
	var propname = error['property'];
	var reason = error['message'].toLowerCase();
	var i, j;

	/*
	 * There's at least one case where the property error message is
	 * confusing at best.  We work around this here.
	 */
	if ((i = reason.indexOf('the property ')) != -1 &&
	    (j = reason.indexOf(' is not defined in the schema and the ' +
	    'schema does not allow additional properties')) != -1) {
		i += 'the property '.length;
		if (propname === '')
			propname = reason.substr(i, j - i);
		else
			propname = propname + '.' + reason.substr(i, j - i);

		reason = 'unsupported property';
	}

	var rv = new mod_verror.VError('property "%s": %s', propname, reason);
	rv.jsv_details = error;
	return (rv);
}

function randElt(arr)
{
	mod_assert.ok(Array.isArray(arr) && arr.length > 0,
	    'randElt argument must be a non-empty array');

	return (arr[Math.floor(Math.random() * arr.length)]);
}

function assertHrtime(a)
{
	mod_assert.ok(a[0] >= 0 && a[1] >= 0,
	    'negative numbers not allowed in hrtimes');
	mod_assert.ok(a[1] < 1e9, 'nanoseconds column overflow');
}

/*
 * Compute the time elapsed between hrtime readings A and B, where A is later
 * than B.  hrtime readings come from Node's process.hrtime().  There is no
 * defined way to represent negative deltas, so it's illegal to diff B from A
 * where the time denoted by B is later than the time denoted by A.  If this
 * becomes valuable, we can define a representation and extend the
 * implementation to support it.
 */
function hrtimeDiff(a, b)
{
	assertHrtime(a);
	assertHrtime(b);
	mod_assert.ok(a[0] > b[0] || (a[0] == b[0] && a[1] >= b[1]),
	    'negative differences not allowed');

	var rv = [ a[0] - b[0], 0 ];

	if (a[1] >= b[1]) {
		rv[1] = a[1] - b[1];
	} else {
		rv[0]--;
		rv[1] = 1e9 - (b[1] - a[1]);
	}

	return (rv);
}

/*
 * Convert a hrtime reading from the array format returned by Node's
 * process.hrtime() into a scalar number of nanoseconds.
 */
function hrtimeNanosec(a)
{
	assertHrtime(a);

	return (Math.floor(a[0] * 1e9 + a[1]));
}

/*
 * Convert a hrtime reading from the array format returned by Node's
 * process.hrtime() into a scalar number of microseconds.
 */
function hrtimeMicrosec(a)
{
	assertHrtime(a);

	return (Math.floor(a[0] * 1e6 + a[1] / 1e3));
}

/*
 * Convert a hrtime reading from the array format returned by Node's
 * process.hrtime() into a scalar number of milliseconds.
 */
function hrtimeMillisec(a)
{
	assertHrtime(a);

	return (Math.floor(a[0] * 1e3 + a[1] / 1e6));
}

/*
 * Add two hrtime readings A and B, overwriting A with the result of the
 * addition.  This function is useful for accumulating several hrtime intervals
 * into a counter.  Returns A.
 */
function hrtimeAccum(a, b)
{
	assertHrtime(a);
	assertHrtime(b);

	/*
	 * Accumulate the nanosecond component.
	 */
	a[1] += b[1];
	if (a[1] >= 1e9) {
		/*
		 * The nanosecond component overflowed, so carry to the seconds
		 * field.
		 */
		a[0]++;
		a[1] -= 1e9;
	}

	/*
	 * Accumulate the seconds component.
	 */
	a[0] += b[0];

	return (a);
}

/*
 * Add two hrtime readings A and B, returning the result as a new hrtime array.
 * Does not modify either input argument.
 */
function hrtimeAdd(a, b)
{
	assertHrtime(a);

	var rv = [ a[0], a[1] ];

	return (hrtimeAccum(rv, b));
}


/*
 * Check an object for unexpected properties.  Accepts the object to check, and
 * an array of allowed property names (strings).  Returns an array of key names
 * that were found on the object, but did not appear in the list of allowed
 * properties.  If no properties were found, the returned array will be of
 * zero length.
 */
function extraProperties(obj, allowed)
{
	mod_assert.ok(typeof (obj) === 'object' && obj !== null,
	    'obj argument must be a non-null object');
	mod_assert.ok(Array.isArray(allowed),
	    'allowed argument must be an array of strings');
	for (var i = 0; i < allowed.length; i++) {
		mod_assert.ok(typeof (allowed[i]) === 'string',
		    'allowed argument must be an array of strings');
	}

	return (Object.keys(obj).filter(function (key) {
		return (allowed.indexOf(key) === -1);
	}));
}

/*
 * Given three sets of properties "provided" (may be undefined), "overrides"
 * (required), and "defaults" (may be undefined), construct an object containing
 * the union of these sets with "overrides" overriding "provided", and
 * "provided" overriding "defaults".  None of the input objects are modified.
 */
function mergeObjects(provided, overrides, defaults)
{
	var rv, k;

	rv = {};
	if (defaults) {
		for (k in defaults)
			rv[k] = defaults[k];
	}

	if (provided) {
		for (k in provided)
			rv[k] = provided[k];
	}

	if (overrides) {
		for (k in overrides)
			rv[k] = overrides[k];
	}

	return (rv);
}


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * verror.js: richer JavaScript errors
 */

var mod_assertplus = __webpack_require__(3);
var mod_util = __webpack_require__(5);

var mod_extsprintf = __webpack_require__(138);
var mod_isError = __webpack_require__(32).isError;
var sprintf = mod_extsprintf.sprintf;

/*
 * Public interface
 */

/* So you can 'var VError = require('verror')' */
module.exports = VError;
/* For compatibility */
VError.VError = VError;
/* Other exported classes */
VError.SError = SError;
VError.WError = WError;
VError.MultiError = MultiError;

/*
 * Common function used to parse constructor arguments for VError, WError, and
 * SError.  Named arguments to this function:
 *
 *     strict		force strict interpretation of sprintf arguments, even
 *     			if the options in "argv" don't say so
 *
 *     argv		error's constructor arguments, which are to be
 *     			interpreted as described in README.md.  For quick
 *     			reference, "argv" has one of the following forms:
 *
 *          [ sprintf_args... ]           (argv[0] is a string)
 *          [ cause, sprintf_args... ]    (argv[0] is an Error)
 *          [ options, sprintf_args... ]  (argv[0] is an object)
 *
 * This function normalizes these forms, producing an object with the following
 * properties:
 *
 *    options           equivalent to "options" in third form.  This will never
 *    			be a direct reference to what the caller passed in
 *    			(i.e., it may be a shallow copy), so it can be freely
 *    			modified.
 *
 *    shortmessage      result of sprintf(sprintf_args), taking options.strict
 *    			into account as described in README.md.
 */
function parseConstructorArguments(args)
{
	var argv, options, sprintf_args, shortmessage, k;

	mod_assertplus.object(args, 'args');
	mod_assertplus.bool(args.strict, 'args.strict');
	mod_assertplus.array(args.argv, 'args.argv');
	argv = args.argv;

	/*
	 * First, figure out which form of invocation we've been given.
	 */
	if (argv.length === 0) {
		options = {};
		sprintf_args = [];
	} else if (mod_isError(argv[0])) {
		options = { 'cause': argv[0] };
		sprintf_args = argv.slice(1);
	} else if (typeof (argv[0]) === 'object') {
		options = {};
		for (k in argv[0]) {
			options[k] = argv[0][k];
		}
		sprintf_args = argv.slice(1);
	} else {
		mod_assertplus.string(argv[0],
		    'first argument to VError, SError, or WError ' +
		    'constructor must be a string, object, or Error');
		options = {};
		sprintf_args = argv;
	}

	/*
	 * Now construct the error's message.
	 *
	 * extsprintf (which we invoke here with our caller's arguments in order
	 * to construct this Error's message) is strict in its interpretation of
	 * values to be processed by the "%s" specifier.  The value passed to
	 * extsprintf must actually be a string or something convertible to a
	 * String using .toString().  Passing other values (notably "null" and
	 * "undefined") is considered a programmer error.  The assumption is
	 * that if you actually want to print the string "null" or "undefined",
	 * then that's easy to do that when you're calling extsprintf; on the
	 * other hand, if you did NOT want that (i.e., there's actually a bug
	 * where the program assumes some variable is non-null and tries to
	 * print it, which might happen when constructing a packet or file in
	 * some specific format), then it's better to stop immediately than
	 * produce bogus output.
	 *
	 * However, sometimes the bug is only in the code calling VError, and a
	 * programmer might prefer to have the error message contain "null" or
	 * "undefined" rather than have the bug in the error path crash the
	 * program (making the first bug harder to identify).  For that reason,
	 * by default VError converts "null" or "undefined" arguments to their
	 * string representations and passes those to extsprintf.  Programmers
	 * desiring the strict behavior can use the SError class or pass the
	 * "strict" option to the VError constructor.
	 */
	mod_assertplus.object(options);
	if (!options.strict && !args.strict) {
		sprintf_args = sprintf_args.map(function (a) {
			return (a === null ? 'null' :
			    a === undefined ? 'undefined' : a);
		});
	}

	if (sprintf_args.length === 0) {
		shortmessage = '';
	} else {
		shortmessage = sprintf.apply(null, sprintf_args);
	}

	return ({
	    'options': options,
	    'shortmessage': shortmessage
	});
}

/*
 * See README.md for reference documentation.
 */
function VError()
{
	var args, obj, parsed, cause, ctor, message, k;

	args = Array.prototype.slice.call(arguments, 0);

	/*
	 * This is a regrettable pattern, but JavaScript's built-in Error class
	 * is defined to work this way, so we allow the constructor to be called
	 * without "new".
	 */
	if (!(this instanceof VError)) {
		obj = Object.create(VError.prototype);
		VError.apply(obj, arguments);
		return (obj);
	}

	/*
	 * For convenience and backwards compatibility, we support several
	 * different calling forms.  Normalize them here.
	 */
	parsed = parseConstructorArguments({
	    'argv': args,
	    'strict': false
	});

	/*
	 * If we've been given a name, apply it now.
	 */
	if (parsed.options.name) {
		mod_assertplus.string(parsed.options.name,
		    'error\'s "name" must be a string');
		this.name = parsed.options.name;
	}

	/*
	 * For debugging, we keep track of the original short message (attached
	 * this Error particularly) separately from the complete message (which
	 * includes the messages of our cause chain).
	 */
	this.jse_shortmsg = parsed.shortmessage;
	message = parsed.shortmessage;

	/*
	 * If we've been given a cause, record a reference to it and update our
	 * message appropriately.
	 */
	cause = parsed.options.cause;
	if (cause) {
		mod_assertplus.ok(mod_isError(cause), 'cause is not an Error');
		this.jse_cause = cause;

		if (!parsed.options.skipCauseMessage) {
			message += ': ' + cause.message;
		}
	}

	/*
	 * If we've been given an object with properties, shallow-copy that
	 * here.  We don't want to use a deep copy in case there are non-plain
	 * objects here, but we don't want to use the original object in case
	 * the caller modifies it later.
	 */
	this.jse_info = {};
	if (parsed.options.info) {
		for (k in parsed.options.info) {
			this.jse_info[k] = parsed.options.info[k];
		}
	}

	this.message = message;
	Error.call(this, message);

	if (Error.captureStackTrace) {
		ctor = parsed.options.constructorOpt || this.constructor;
		Error.captureStackTrace(this, ctor);
	}

	return (this);
}

mod_util.inherits(VError, Error);
VError.prototype.name = 'VError';

VError.prototype.toString = function ve_toString()
{
	var str = (this.hasOwnProperty('name') && this.name ||
		this.constructor.name || this.constructor.prototype.name);
	if (this.message)
		str += ': ' + this.message;

	return (str);
};

/*
 * This method is provided for compatibility.  New callers should use
 * VError.cause() instead.  That method also uses the saner `null` return value
 * when there is no cause.
 */
VError.prototype.cause = function ve_cause()
{
	var cause = VError.cause(this);
	return (cause === null ? undefined : cause);
};

/*
 * Static methods
 *
 * These class-level methods are provided so that callers can use them on
 * instances of Errors that are not VErrors.  New interfaces should be provided
 * only using static methods to eliminate the class of programming mistake where
 * people fail to check whether the Error object has the corresponding methods.
 */

VError.cause = function (err)
{
	mod_assertplus.ok(mod_isError(err), 'err must be an Error');
	return (mod_isError(err.jse_cause) ? err.jse_cause : null);
};

VError.info = function (err)
{
	var rv, cause, k;

	mod_assertplus.ok(mod_isError(err), 'err must be an Error');
	cause = VError.cause(err);
	if (cause !== null) {
		rv = VError.info(cause);
	} else {
		rv = {};
	}

	if (typeof (err.jse_info) == 'object' && err.jse_info !== null) {
		for (k in err.jse_info) {
			rv[k] = err.jse_info[k];
		}
	}

	return (rv);
};

VError.findCauseByName = function (err, name)
{
	var cause;

	mod_assertplus.ok(mod_isError(err), 'err must be an Error');
	mod_assertplus.string(name, 'name');
	mod_assertplus.ok(name.length > 0, 'name cannot be empty');

	for (cause = err; cause !== null; cause = VError.cause(cause)) {
		mod_assertplus.ok(mod_isError(cause));
		if (cause.name == name) {
			return (cause);
		}
	}

	return (null);
};

VError.hasCauseWithName = function (err, name)
{
	return (VError.findCauseByName(err, name) !== null);
};

VError.fullStack = function (err)
{
	mod_assertplus.ok(mod_isError(err), 'err must be an Error');

	var cause = VError.cause(err);

	if (cause) {
		return (err.stack + '\ncaused by: ' + VError.fullStack(cause));
	}

	return (err.stack);
};

VError.errorFromList = function (errors)
{
	mod_assertplus.arrayOfObject(errors, 'errors');

	if (errors.length === 0) {
		return (null);
	}

	errors.forEach(function (e) {
		mod_assertplus.ok(mod_isError(e));
	});

	if (errors.length == 1) {
		return (errors[0]);
	}

	return (new MultiError(errors));
};

VError.errorForEach = function (err, func)
{
	mod_assertplus.ok(mod_isError(err), 'err must be an Error');
	mod_assertplus.func(func, 'func');

	if (err instanceof MultiError) {
		err.errors().forEach(function iterError(e) { func(e); });
	} else {
		func(err);
	}
};


/*
 * SError is like VError, but stricter about types.  You cannot pass "null" or
 * "undefined" as string arguments to the formatter.
 */
function SError()
{
	var args, obj, parsed, options;

	args = Array.prototype.slice.call(arguments, 0);
	if (!(this instanceof SError)) {
		obj = Object.create(SError.prototype);
		SError.apply(obj, arguments);
		return (obj);
	}

	parsed = parseConstructorArguments({
	    'argv': args,
	    'strict': true
	});

	options = parsed.options;
	VError.call(this, options, '%s', parsed.shortmessage);

	return (this);
}

/*
 * We don't bother setting SError.prototype.name because once constructed,
 * SErrors are just like VErrors.
 */
mod_util.inherits(SError, VError);


/*
 * Represents a collection of errors for the purpose of consumers that generally
 * only deal with one error.  Callers can extract the individual errors
 * contained in this object, but may also just treat it as a normal single
 * error, in which case a summary message will be printed.
 */
function MultiError(errors)
{
	mod_assertplus.array(errors, 'list of errors');
	mod_assertplus.ok(errors.length > 0, 'must be at least one error');
	this.ase_errors = errors;

	VError.call(this, {
	    'cause': errors[0]
	}, 'first of %d error%s', errors.length, errors.length == 1 ? '' : 's');
}

mod_util.inherits(MultiError, VError);
MultiError.prototype.name = 'MultiError';

MultiError.prototype.errors = function me_errors()
{
	return (this.ase_errors.slice(0));
};


/*
 * See README.md for reference details.
 */
function WError()
{
	var args, obj, parsed, options;

	args = Array.prototype.slice.call(arguments, 0);
	if (!(this instanceof WError)) {
		obj = Object.create(WError.prototype);
		WError.apply(obj, args);
		return (obj);
	}

	parsed = parseConstructorArguments({
	    'argv': args,
	    'strict': false
	});

	options = parsed.options;
	options['skipCauseMessage'] = true;
	VError.call(this, options, '%s', parsed.shortmessage);

	return (this);
}

mod_util.inherits(WError, VError);
WError.prototype.name = 'WError';

WError.prototype.toString = function we_toString()
{
	var str = (this.hasOwnProperty('name') && this.name ||
		this.constructor.name || this.constructor.prototype.name);
	if (this.message)
		str += ': ' + this.message;
	if (this.jse_cause && this.jse_cause.message)
		str += '; caused by ' + this.jse_cause.toString();

	return (str);
};

/*
 * For purely historical reasons, WError's cause() function allows you to set
 * the cause.
 */
WError.prototype.cause = function we_cause(c)
{
	if (mod_isError(c))
		this.jse_cause = c;

	return (this.jse_cause);
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * JSONSchema Validator - Validates JavaScript objects using JSON Schemas
 *	(http://www.json.com/json-schema-proposal/)
 *
 * Copyright (c) 2007 Kris Zyp SitePen (www.sitepen.com)
 * Licensed under the MIT (MIT-LICENSE.txt) license.
To use the validator call the validate function with an instance object and an optional schema object.
If a schema is provided, it will be used to validate. If the instance object refers to a schema (self-validating),
that schema will be used to validate and the schema parameter is not necessary (if both exist,
both validations will occur).
The validate method will return an array of validation errors. If there are no errors, then an
empty list will be returned. A validation error will have two properties:
"property" which indicates which property had the error
"message" which indicates what the error was
 */
(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return factory();
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals
        root.jsonSchema = factory();
    }
}(this, function () {// setup primitive classes to be JSON Schema types
var exports = validate
exports.Integer = {type:"integer"};
var primitiveConstructors = {
	String: String,
	Boolean: Boolean,
	Number: Number,
	Object: Object,
	Array: Array,
	Date: Date
}
exports.validate = validate;
function validate(/*Any*/instance,/*Object*/schema) {
		// Summary:
		//  	To use the validator call JSONSchema.validate with an instance object and an optional schema object.
		// 		If a schema is provided, it will be used to validate. If the instance object refers to a schema (self-validating),
		// 		that schema will be used to validate and the schema parameter is not necessary (if both exist,
		// 		both validations will occur).
		// 		The validate method will return an object with two properties:
		// 			valid: A boolean indicating if the instance is valid by the schema
		// 			errors: An array of validation errors. If there are no errors, then an
		// 					empty list will be returned. A validation error will have two properties:
		// 						property: which indicates which property had the error
		// 						message: which indicates what the error was
		//
		return validate(instance, schema, {changing: false});//, coerce: false, existingOnly: false});
	};
exports.checkPropertyChange = function(/*Any*/value,/*Object*/schema, /*String*/property) {
		// Summary:
		// 		The checkPropertyChange method will check to see if an value can legally be in property with the given schema
		// 		This is slightly different than the validate method in that it will fail if the schema is readonly and it will
		// 		not check for self-validation, it is assumed that the passed in value is already internally valid.
		// 		The checkPropertyChange method will return the same object type as validate, see JSONSchema.validate for
		// 		information.
		//
		return validate(value, schema, {changing: property || "property"});
	};
var validate = exports._validate = function(/*Any*/instance,/*Object*/schema,/*Object*/options) {

	if (!options) options = {};
	var _changing = options.changing;

	function getType(schema){
		return schema.type || (primitiveConstructors[schema.name] == schema && schema.name.toLowerCase());
	}
	var errors = [];
	// validate a value against a property definition
	function checkProp(value, schema, path,i){

		var l;
		path += path ? typeof i == 'number' ? '[' + i + ']' : typeof i == 'undefined' ? '' : '.' + i : i;
		function addError(message){
			errors.push({property:path,message:message});
		}

		if((typeof schema != 'object' || schema instanceof Array) && (path || typeof schema != 'function') && !(schema && getType(schema))){
			if(typeof schema == 'function'){
				if(!(value instanceof schema)){
					addError("is not an instance of the class/constructor " + schema.name);
				}
			}else if(schema){
				addError("Invalid schema/property definition " + schema);
			}
			return null;
		}
		if(_changing && schema.readonly){
			addError("is a readonly field, it can not be changed");
		}
		if(schema['extends']){ // if it extends another schema, it must pass that schema as well
			checkProp(value,schema['extends'],path,i);
		}
		// validate a value against a type definition
		function checkType(type,value){
			if(type){
				if(typeof type == 'string' && type != 'any' &&
						(type == 'null' ? value !== null : typeof value != type) &&
						!(value instanceof Array && type == 'array') &&
						!(value instanceof Date && type == 'date') &&
						!(type == 'integer' && value%1===0)){
					return [{property:path,message:(typeof value) + " value found, but a " + type + " is required"}];
				}
				if(type instanceof Array){
					var unionErrors=[];
					for(var j = 0; j < type.length; j++){ // a union type
						if(!(unionErrors=checkType(type[j],value)).length){
							break;
						}
					}
					if(unionErrors.length){
						return unionErrors;
					}
				}else if(typeof type == 'object'){
					var priorErrors = errors;
					errors = [];
					checkProp(value,type,path);
					var theseErrors = errors;
					errors = priorErrors;
					return theseErrors;
				}
			}
			return [];
		}
		if(value === undefined){
			if(schema.required){
				addError("is missing and it is required");
			}
		}else{
			errors = errors.concat(checkType(getType(schema),value));
			if(schema.disallow && !checkType(schema.disallow,value).length){
				addError(" disallowed value was matched");
			}
			if(value !== null){
				if(value instanceof Array){
					if(schema.items){
						var itemsIsArray = schema.items instanceof Array;
						var propDef = schema.items;
						for (i = 0, l = value.length; i < l; i += 1) {
							if (itemsIsArray)
								propDef = schema.items[i];
							if (options.coerce)
								value[i] = options.coerce(value[i], propDef);
							errors.concat(checkProp(value[i],propDef,path,i));
						}
					}
					if(schema.minItems && value.length < schema.minItems){
						addError("There must be a minimum of " + schema.minItems + " in the array");
					}
					if(schema.maxItems && value.length > schema.maxItems){
						addError("There must be a maximum of " + schema.maxItems + " in the array");
					}
				}else if(schema.properties || schema.additionalProperties){
					errors.concat(checkObj(value, schema.properties, path, schema.additionalProperties));
				}
				if(schema.pattern && typeof value == 'string' && !value.match(schema.pattern)){
					addError("does not match the regex pattern " + schema.pattern);
				}
				if(schema.maxLength && typeof value == 'string' && value.length > schema.maxLength){
					addError("may only be " + schema.maxLength + " characters long");
				}
				if(schema.minLength && typeof value == 'string' && value.length < schema.minLength){
					addError("must be at least " + schema.minLength + " characters long");
				}
				if(typeof schema.minimum !== undefined && typeof value == typeof schema.minimum &&
						schema.minimum > value){
					addError("must have a minimum value of " + schema.minimum);
				}
				if(typeof schema.maximum !== undefined && typeof value == typeof schema.maximum &&
						schema.maximum < value){
					addError("must have a maximum value of " + schema.maximum);
				}
				if(schema['enum']){
					var enumer = schema['enum'];
					l = enumer.length;
					var found;
					for(var j = 0; j < l; j++){
						if(enumer[j]===value){
							found=1;
							break;
						}
					}
					if(!found){
						addError("does not have a value in the enumeration " + enumer.join(", "));
					}
				}
				if(typeof schema.maxDecimal == 'number' &&
					(value.toString().match(new RegExp("\\.[0-9]{" + (schema.maxDecimal + 1) + ",}")))){
					addError("may only have " + schema.maxDecimal + " digits of decimal places");
				}
			}
		}
		return null;
	}
	// validate an object against a schema
	function checkObj(instance,objTypeDef,path,additionalProp){

		if(typeof objTypeDef =='object'){
			if(typeof instance != 'object' || instance instanceof Array){
				errors.push({property:path,message:"an object is required"});
			}
			
			for(var i in objTypeDef){ 
				if(objTypeDef.hasOwnProperty(i)){
					var value = instance[i];
					// skip _not_ specified properties
					if (value === undefined && options.existingOnly) continue;
					var propDef = objTypeDef[i];
					// set default
					if(value === undefined && propDef["default"]){
						value = instance[i] = propDef["default"];
					}
					if(options.coerce && i in instance){
						value = instance[i] = options.coerce(value, propDef);
					}
					checkProp(value,propDef,path,i);
				}
			}
		}
		for(i in instance){
			if(instance.hasOwnProperty(i) && !(i.charAt(0) == '_' && i.charAt(1) == '_') && objTypeDef && !objTypeDef[i] && additionalProp===false){
				if (options.filter) {
					delete instance[i];
					continue;
				} else {
					errors.push({property:path,message:(typeof value) + "The property " + i +
						" is not defined in the schema and the schema does not allow additional properties"});
				}
			}
			var requires = objTypeDef && objTypeDef[i] && objTypeDef[i].requires;
			if(requires && !(requires in instance)){
				errors.push({property:path,message:"the presence of the property " + i + " requires that " + requires + " also be present"});
			}
			value = instance[i];
			if(additionalProp && (!(objTypeDef && typeof objTypeDef == 'object') || !(i in objTypeDef))){
				if(options.coerce){
					value = instance[i] = options.coerce(value, additionalProp);
				}
				checkProp(value,additionalProp,path,i);
			}
			if(!_changing && value && value.$schema){
				errors = errors.concat(checkProp(value,value.$schema,path,i));
			}
		}
		return errors;
	}
	if(schema){
		checkProp(instance,schema,'',_changing || '');
	}
	if(!_changing && instance && instance.$schema){
		checkProp(instance,instance.$schema,'','');
	}
	return {valid:!errors.length,errors:errors};
};
exports.mustBeValid = function(result){
	//	summary:
	//		This checks to ensure that the result is valid and will throw an appropriate error message if it is not
	// result: the result returned from checkPropertyChange or validate
	if(!result.valid){
		throw new TypeError(result.errors.map(function(error){return "for property " + error.property + ': ' + error.message;}).join(", \n"));
	}
}

return exports;
}));


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright 2015 Joyent, Inc.

var assert = __webpack_require__(3);
var crypto = __webpack_require__(7);
var sshpk = __webpack_require__(76);
var utils = __webpack_require__(56);

var HASH_ALGOS = utils.HASH_ALGOS;
var PK_ALGOS = utils.PK_ALGOS;
var InvalidAlgorithmError = utils.InvalidAlgorithmError;
var HttpSignatureError = utils.HttpSignatureError;
var validateAlgorithm = utils.validateAlgorithm;

///--- Exported API

module.exports = {
  /**
   * Verify RSA/DSA signature against public key.  You are expected to pass in
   * an object that was returned from `parse()`.
   *
   * @param {Object} parsedSignature the object you got from `parse`.
   * @param {String} pubkey RSA/DSA private key PEM.
   * @return {Boolean} true if valid, false otherwise.
   * @throws {TypeError} if you pass in bad arguments.
   * @throws {InvalidAlgorithmError}
   */
  verifySignature: function verifySignature(parsedSignature, pubkey) {
    assert.object(parsedSignature, 'parsedSignature');
    if (typeof (pubkey) === 'string' || Buffer.isBuffer(pubkey))
      pubkey = sshpk.parseKey(pubkey);
    assert.ok(sshpk.Key.isKey(pubkey, [1, 1]), 'pubkey must be a sshpk.Key');

    var alg = validateAlgorithm(parsedSignature.algorithm);
    if (alg[0] === 'hmac' || alg[0] !== pubkey.type)
      return (false);

    var v = pubkey.createVerify(alg[1]);
    v.update(parsedSignature.signingString);
    return (v.verify(parsedSignature.params.signature, 'base64'));
  },

  /**
   * Verify HMAC against shared secret.  You are expected to pass in an object
   * that was returned from `parse()`.
   *
   * @param {Object} parsedSignature the object you got from `parse`.
   * @param {String} secret HMAC shared secret.
   * @return {Boolean} true if valid, false otherwise.
   * @throws {TypeError} if you pass in bad arguments.
   * @throws {InvalidAlgorithmError}
   */
  verifyHMAC: function verifyHMAC(parsedSignature, secret) {
    assert.object(parsedSignature, 'parsedHMAC');
    assert.string(secret, 'secret');

    var alg = validateAlgorithm(parsedSignature.algorithm);
    if (alg[0] !== 'hmac')
      return (false);

    var hashAlg = alg[1].toUpperCase();

    var hmac = crypto.createHmac(hashAlg, secret);
    hmac.update(parsedSignature.signingString);

    /*
     * Now double-hash to avoid leaking timing information - there's
     * no easy constant-time compare in JS, so we use this approach
     * instead. See for more info:
     * https://www.isecpartners.com/blog/2011/february/double-hmac-
     * verification.aspx
     */
    var h1 = crypto.createHmac(hashAlg, secret);
    h1.update(hmac.digest());
    h1 = h1.digest();
    var h2 = crypto.createHmac(hashAlg, secret);
    h2.update(new Buffer(parsedSignature.params.signature, 'base64'));
    h2 = h2.digest();

    /* Node 0.8 returns strings from .digest(). */
    if (typeof (h1) === 'string')
      return (h1 === h2);
    /* And node 0.10 lacks the .equals() method on Buffers. */
    if (Buffer.isBuffer(h1) && !h1.equals)
      return (h1.toString('binary') === h2.toString('binary'));

    return (h1.equals(h2));
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module dependencies.
 * @private
 */

var db = __webpack_require__(299)
var extname = __webpack_require__(301).extname

/**
 * Module variables.
 * @private
 */

var EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/
var TEXT_TYPE_REGEXP = /^text\//i

/**
 * Module exports.
 * @public
 */

exports.charset = charset
exports.charsets = { lookup: charset }
exports.contentType = contentType
exports.extension = extension
exports.extensions = Object.create(null)
exports.lookup = lookup
exports.types = Object.create(null)

// Populate the extensions/types maps
populateMaps(exports.extensions, exports.types)

/**
 * Get the default charset for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */

function charset (type) {
  if (!type || typeof type !== 'string') {
    return false
  }

  // TODO: use media-typer
  var match = EXTRACT_TYPE_REGEXP.exec(type)
  var mime = match && db[match[1].toLowerCase()]

  if (mime && mime.charset) {
    return mime.charset
  }

  // default text/* to utf-8
  if (match && TEXT_TYPE_REGEXP.test(match[1])) {
    return 'UTF-8'
  }

  return false
}

/**
 * Create a full Content-Type header given a MIME type or extension.
 *
 * @param {string} str
 * @return {boolean|string}
 */

function contentType (str) {
  // TODO: should this even be in this module?
  if (!str || typeof str !== 'string') {
    return false
  }

  var mime = str.indexOf('/') === -1
    ? exports.lookup(str)
    : str

  if (!mime) {
    return false
  }

  // TODO: use content-type or other module
  if (mime.indexOf('charset') === -1) {
    var charset = exports.charset(mime)
    if (charset) mime += '; charset=' + charset.toLowerCase()
  }

  return mime
}

/**
 * Get the default extension for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */

function extension (type) {
  if (!type || typeof type !== 'string') {
    return false
  }

  // TODO: use media-typer
  var match = EXTRACT_TYPE_REGEXP.exec(type)

  // get extensions
  var exts = match && exports.extensions[match[1].toLowerCase()]

  if (!exts || !exts.length) {
    return false
  }

  return exts[0]
}

/**
 * Lookup the MIME type for a file path/extension.
 *
 * @param {string} path
 * @return {boolean|string}
 */

function lookup (path) {
  if (!path || typeof path !== 'string') {
    return false
  }

  // get the extension ("ext" or ".ext" or full path)
  var extension = extname('x.' + path)
    .toLowerCase()
    .substr(1)

  if (!extension) {
    return false
  }

  return exports.types[extension] || false
}

/**
 * Populate the extensions and types maps.
 * @private
 */

function populateMaps (extensions, types) {
  // source preference (least -> most)
  var preference = ['nginx', 'apache', undefined, 'iana']

  Object.keys(db).forEach(function forEachMimeType (type) {
    var mime = db[type]
    var exts = mime.extensions

    if (!exts || !exts.length) {
      return
    }

    // mime -> extensions
    extensions[type] = exts

    // extension -> mime
    for (var i = 0; i < exts.length; i++) {
      var extension = exts[i]

      if (types[extension]) {
        var from = preference.indexOf(db[types[extension]].source)
        var to = preference.indexOf(mime.source)

        if (types[extension] !== 'application/octet-stream' &&
          (from > to || (from === to && types[extension].substr(0, 12) === 'application/'))) {
          // skip the remapping
          continue
        }
      }

      // set the extension -> mime
      types[extension] = type
    }
  })
}


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * MIT Licensed
 */

/**
 * Module exports.
 */

module.exports = __webpack_require__(300)


/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = {"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/cbor":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["ecma","es"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true},"application/fhir+json":{"source":"iana","compressible":true},"application/fhir+xml":{"source":"iana","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mmt-usd+xml":{"source":"iana","compressible":true},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","compressible":true},"application/msc-mixer+xml":{"source":"iana","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana"},"application/n-triples":{"source":"iana"},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana"},"application/news-groupinfo":{"source":"iana"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana"},"application/nss":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p2p-overlay+xml":{"source":"iana","compressible":true},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana"},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","compressible":true},"application/pidf-diff+xml":{"source":"iana","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true},"application/route-s-tsid+xml":{"source":"iana","compressible":true},"application/route-usd+xml":{"source":"iana","compressible":true},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana"},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana"},"application/ttml+xml":{"source":"iana","compressible":true},"application/tve-trigger":{"source":"iana"},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true},"application/urc-targetdesc+xml":{"source":"iana","compressible":true},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["keynote"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana"},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana"},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","compressible":true},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"apache","extensions":["der","crt","pem"]},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true},"application/xcap-caps+xml":{"source":"iana","compressible":true},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana"},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana"},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana"},"image/avcs":{"source":"iana"},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana"},"image/heic-sequence":{"source":"iana"},"image/heif":{"source":"iana"},"image/heif-sequence":{"source":"iana"},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/stl":{"source":"iana"},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana"},"model/vnd.parasolid.transmit.binary":{"source":"iana"},"model/vnd.parasolid.transmit.text":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.usdz+zip":{"source":"iana","compressible":false},"model/vnd.valve.source.compiled-map":{"source":"iana"},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana"},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana"},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana","compressible":false},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shex":{"extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana"},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vp8":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = ForeverAgent
ForeverAgent.SSL = ForeverAgentSSL

var util = __webpack_require__(5)
  , Agent = __webpack_require__(41).Agent
  , net = __webpack_require__(30)
  , tls = __webpack_require__(30)
  , AgentSSL = __webpack_require__(75).Agent
  
function getConnectionName(host, port) {  
  var name = ''
  if (typeof host === 'string') {
    name = host + ':' + port
  } else {
    // For node.js v012.0 and iojs-v1.5.1, host is an object. And any existing localAddress is part of the connection name.
    name = host.host + ':' + host.port + ':' + (host.localAddress ? (host.localAddress + ':') : ':')
  }
  return name
}    

function ForeverAgent(options) {
  var self = this
  self.options = options || {}
  self.requests = {}
  self.sockets = {}
  self.freeSockets = {}
  self.maxSockets = self.options.maxSockets || Agent.defaultMaxSockets
  self.minSockets = self.options.minSockets || ForeverAgent.defaultMinSockets
  self.on('free', function(socket, host, port) {
    var name = getConnectionName(host, port)

    if (self.requests[name] && self.requests[name].length) {
      self.requests[name].shift().onSocket(socket)
    } else if (self.sockets[name].length < self.minSockets) {
      if (!self.freeSockets[name]) self.freeSockets[name] = []
      self.freeSockets[name].push(socket)
      
      // if an error happens while we don't use the socket anyway, meh, throw the socket away
      var onIdleError = function() {
        socket.destroy()
      }
      socket._onIdleError = onIdleError
      socket.on('error', onIdleError)
    } else {
      // If there are no pending requests just destroy the
      // socket and it will get removed from the pool. This
      // gets us out of timeout issues and allows us to
      // default to Connection:keep-alive.
      socket.destroy()
    }
  })

}
util.inherits(ForeverAgent, Agent)

ForeverAgent.defaultMinSockets = 5


ForeverAgent.prototype.createConnection = net.createConnection
ForeverAgent.prototype.addRequestNoreuse = Agent.prototype.addRequest
ForeverAgent.prototype.addRequest = function(req, host, port) {
  var name = getConnectionName(host, port)
  
  if (typeof host !== 'string') {
    var options = host
    port = options.port
    host = options.host
  }

  if (this.freeSockets[name] && this.freeSockets[name].length > 0 && !req.useChunkedEncodingByDefault) {
    var idleSocket = this.freeSockets[name].pop()
    idleSocket.removeListener('error', idleSocket._onIdleError)
    delete idleSocket._onIdleError
    req._reusedSocket = true
    req.onSocket(idleSocket)
  } else {
    this.addRequestNoreuse(req, host, port)
  }
}

ForeverAgent.prototype.removeSocket = function(s, name, host, port) {
  if (this.sockets[name]) {
    var index = this.sockets[name].indexOf(s)
    if (index !== -1) {
      this.sockets[name].splice(index, 1)
    }
  } else if (this.sockets[name] && this.sockets[name].length === 0) {
    // don't leak
    delete this.sockets[name]
    delete this.requests[name]
  }
  
  if (this.freeSockets[name]) {
    var index = this.freeSockets[name].indexOf(s)
    if (index !== -1) {
      this.freeSockets[name].splice(index, 1)
      if (this.freeSockets[name].length === 0) {
        delete this.freeSockets[name]
      }
    }
  }

  if (this.requests[name] && this.requests[name].length) {
    // If we have pending requests and a socket gets closed a new one
    // needs to be created to take over in the pool for the one that closed.
    this.createSocket(name, host, port).emit('free')
  }
}

function ForeverAgentSSL (options) {
  ForeverAgent.call(this, options)
}
util.inherits(ForeverAgentSSL, ForeverAgent)

ForeverAgentSSL.prototype.createConnection = createConnectionSSL
ForeverAgentSSL.prototype.addRequestNoreuse = AgentSSL.prototype.addRequest

function createConnectionSSL (port, host, options) {
  if (typeof port === 'object') {
    options = port;
  } else if (typeof host === 'object') {
    options = host;
  } else if (typeof options === 'object') {
    options = options;
  } else {
    options = {};
  }

  if (typeof port === 'number') {
    options.port = port;
  }

  if (typeof host === 'string') {
    options.host = host;
  }

  return tls.connect(options);
}


/***/ }),
/* 303 */
/***/ (function(module, exports) {

/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;


/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports      = isTypedArray
isTypedArray.strict = isStrictTypedArray
isTypedArray.loose  = isLooseTypedArray

var toString = Object.prototype.toString
var names = {
    '[object Int8Array]': true
  , '[object Int16Array]': true
  , '[object Int32Array]': true
  , '[object Uint8Array]': true
  , '[object Uint8ClampedArray]': true
  , '[object Uint16Array]': true
  , '[object Uint32Array]': true
  , '[object Float32Array]': true
  , '[object Float64Array]': true
}

function isTypedArray(arr) {
  return (
       isStrictTypedArray(arr)
    || isLooseTypedArray(arr)
  )
}

function isStrictTypedArray(arr) {
  return (
       arr instanceof Int8Array
    || arr instanceof Int16Array
    || arr instanceof Int32Array
    || arr instanceof Uint8Array
    || arr instanceof Uint8ClampedArray
    || arr instanceof Uint16Array
    || arr instanceof Uint32Array
    || arr instanceof Float32Array
    || arr instanceof Float64Array
  )
}

function isLooseTypedArray(arr) {
  return names[toString.call(arr)]
}


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function formatHostname (hostname) {
  // canonicalize the hostname, so that 'oogle.com' won't match 'google.com'
  return hostname.replace(/^\.*/, '.').toLowerCase()
}

function parseNoProxyZone (zone) {
  zone = zone.trim().toLowerCase()

  var zoneParts = zone.split(':', 2)
  var zoneHost = formatHostname(zoneParts[0])
  var zonePort = zoneParts[1]
  var hasPort = zone.indexOf(':') > -1

  return {hostname: zoneHost, port: zonePort, hasPort: hasPort}
}

function uriInNoProxy (uri, noProxy) {
  var port = uri.port || (uri.protocol === 'https:' ? '443' : '80')
  var hostname = formatHostname(uri.hostname)
  var noProxyList = noProxy.split(',')

  // iterate through the noProxyList until it finds a match.
  return noProxyList.map(parseNoProxyZone).some(function (noProxyZone) {
    var isMatchedAt = hostname.indexOf(noProxyZone.hostname)
    var hostnameMatched = (
      isMatchedAt > -1 &&
        (isMatchedAt === hostname.length - noProxyZone.hostname.length)
    )

    if (noProxyZone.hasPort) {
      return (port === noProxyZone.port) && hostnameMatched
    }

    return hostnameMatched
  })
}

function getProxyFromURI (uri) {
  // Decide the proper request proxy to use based on the request URI object and the
  // environmental variables (NO_PROXY, HTTP_PROXY, etc.)
  // respect NO_PROXY environment variables (see: http://lynx.isc.org/current/breakout/lynx_help/keystrokes/environments.html)

  var noProxy = Object({"NODE_ENV":"production","PUBLIC_URL":"."}).NO_PROXY || Object({"NODE_ENV":"production","PUBLIC_URL":"."}).no_proxy || ''

  // if the noProxy is a wildcard then return null

  if (noProxy === '*') {
    return null
  }

  // if the noProxy is not empty and the uri is found return null

  if (noProxy !== '' && uriInNoProxy(uri, noProxy)) {
    return null
  }

  // Check for HTTP or HTTPS Proxy in environment Else default to null

  if (uri.protocol === 'http:') {
    return Object({"NODE_ENV":"production","PUBLIC_URL":"."}).HTTP_PROXY ||
      Object({"NODE_ENV":"production","PUBLIC_URL":"."}).http_proxy || null
  }

  if (uri.protocol === 'https:') {
    return Object({"NODE_ENV":"production","PUBLIC_URL":"."}).HTTPS_PROXY ||
      Object({"NODE_ENV":"production","PUBLIC_URL":"."}).https_proxy ||
      Object({"NODE_ENV":"production","PUBLIC_URL":"."}).HTTP_PROXY ||
      Object({"NODE_ENV":"production","PUBLIC_URL":"."}).http_proxy || null
  }

  // if none of that works, return null
  // (What uri protocol are you using then?)

  return null
}

module.exports = getProxyFromURI


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var qs = __webpack_require__(140)
var querystring = __webpack_require__(48)

function Querystring (request) {
  this.request = request
  this.lib = null
  this.useQuerystring = null
  this.parseOptions = null
  this.stringifyOptions = null
}

Querystring.prototype.init = function (options) {
  if (this.lib) { return }

  this.useQuerystring = options.useQuerystring
  this.lib = (this.useQuerystring ? querystring : qs)

  this.parseOptions = options.qsParseOptions || {}
  this.stringifyOptions = options.qsStringifyOptions || {}
}

Querystring.prototype.stringify = function (obj) {
  return (this.useQuerystring)
    ? this.rfc3986(this.lib.stringify(obj,
      this.stringifyOptions.sep || null,
      this.stringifyOptions.eq || null,
      this.stringifyOptions))
    : this.lib.stringify(obj, this.stringifyOptions)
}

Querystring.prototype.parse = function (str) {
  return (this.useQuerystring)
    ? this.lib.parse(str,
      this.parseOptions.sep || null,
      this.parseOptions.eq || null,
      this.parseOptions)
    : this.lib.parse(str, this.parseOptions)
}

Querystring.prototype.rfc3986 = function (str) {
  return str.replace(/[!'()*]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

Querystring.prototype.unescape = querystring.unescape

exports.Querystring = Querystring


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(141);
var formats = __webpack_require__(142);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(141);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]') {
            obj = [];
            obj = obj.concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fs = __webpack_require__(30)
var qs = __webpack_require__(48)
var validate = __webpack_require__(310)
var extend = __webpack_require__(61)

function Har (request) {
  this.request = request
}

Har.prototype.reducer = function (obj, pair) {
  // new property ?
  if (obj[pair.name] === undefined) {
    obj[pair.name] = pair.value
    return obj
  }

  // existing? convert to array
  var arr = [
    obj[pair.name],
    pair.value
  ]

  obj[pair.name] = arr

  return obj
}

Har.prototype.prep = function (data) {
  // construct utility properties
  data.queryObj = {}
  data.headersObj = {}
  data.postData.jsonObj = false
  data.postData.paramsObj = false

  // construct query objects
  if (data.queryString && data.queryString.length) {
    data.queryObj = data.queryString.reduce(this.reducer, {})
  }

  // construct headers objects
  if (data.headers && data.headers.length) {
    // loweCase header keys
    data.headersObj = data.headers.reduceRight(function (headers, header) {
      headers[header.name] = header.value
      return headers
    }, {})
  }

  // construct Cookie header
  if (data.cookies && data.cookies.length) {
    var cookies = data.cookies.map(function (cookie) {
      return cookie.name + '=' + cookie.value
    })

    if (cookies.length) {
      data.headersObj.cookie = cookies.join('; ')
    }
  }

  // prep body
  function some (arr) {
    return arr.some(function (type) {
      return data.postData.mimeType.indexOf(type) === 0
    })
  }

  if (some([
    'multipart/mixed',
    'multipart/related',
    'multipart/form-data',
    'multipart/alternative'])) {
    // reset values
    data.postData.mimeType = 'multipart/form-data'
  } else if (some([
    'application/x-www-form-urlencoded'])) {
    if (!data.postData.params) {
      data.postData.text = ''
    } else {
      data.postData.paramsObj = data.postData.params.reduce(this.reducer, {})

      // always overwrite
      data.postData.text = qs.stringify(data.postData.paramsObj)
    }
  } else if (some([
    'text/json',
    'text/x-json',
    'application/json',
    'application/x-json'])) {
    data.postData.mimeType = 'application/json'

    if (data.postData.text) {
      try {
        data.postData.jsonObj = JSON.parse(data.postData.text)
      } catch (e) {
        this.request.debug(e)

        // force back to text/plain
        data.postData.mimeType = 'text/plain'
      }
    }
  }

  return data
}

Har.prototype.options = function (options) {
  // skip if no har property defined
  if (!options.har) {
    return options
  }

  var har = {}
  extend(har, options.har)

  // only process the first entry
  if (har.log && har.log.entries) {
    har = har.log.entries[0]
  }

  // add optional properties to make validation successful
  har.url = har.url || options.url || options.uri || options.baseUrl || '/'
  har.httpVersion = har.httpVersion || 'HTTP/1.1'
  har.queryString = har.queryString || []
  har.headers = har.headers || []
  har.cookies = har.cookies || []
  har.postData = har.postData || {}
  har.postData.mimeType = har.postData.mimeType || 'application/octet-stream'

  har.bodySize = 0
  har.headersSize = 0
  har.postData.size = 0

  if (!validate.request(har)) {
    return options
  }

  // clean up and get some utility properties
  var req = this.prep(har)

  // construct new options
  if (req.url) {
    options.url = req.url
  }

  if (req.method) {
    options.method = req.method
  }

  if (Object.keys(req.queryObj).length) {
    options.qs = req.queryObj
  }

  if (Object.keys(req.headersObj).length) {
    options.headers = req.headersObj
  }

  function test (type) {
    return req.postData.mimeType.indexOf(type) === 0
  }
  if (test('application/x-www-form-urlencoded')) {
    options.form = req.postData.paramsObj
  } else if (test('application/json')) {
    if (req.postData.jsonObj) {
      options.body = req.postData.jsonObj
      options.json = true
    }
  } else if (test('multipart/form-data')) {
    options.formData = {}

    req.postData.params.forEach(function (param) {
      var attachment = {}

      if (!param.fileName && !param.fileName && !param.contentType) {
        options.formData[param.name] = param.value
        return
      }

      // attempt to read from disk!
      if (param.fileName && !param.value) {
        attachment.value = fs.createReadStream(param.fileName)
      } else if (param.value) {
        attachment.value = param.value
      }

      if (param.fileName) {
        attachment.options = {
          filename: param.fileName,
          contentType: param.contentType ? param.contentType : null
        }
      }

      options.formData[param.name] = attachment
    })
  } else {
    if (req.postData.text) {
      options.body = req.postData.text
    }
  }

  return options
}

exports.Har = Har


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Ajv = __webpack_require__(311)
var HARError = __webpack_require__(343)
var schemas = __webpack_require__(344)

var ajv

function validate (name, data) {
  data = data || {}

  // validator config
  ajv = ajv || new Ajv({
    allErrors: true,
    schemas: schemas
  })

  var validate = ajv.getSchema(name + '.json')

  return new Promise(function (resolve, reject) {
    var valid = validate(data)

    !valid ? reject(new HARError(validate.errors)) : resolve(data)
  })
}

exports.afterRequest = function (data) {
  return validate('afterRequest', data)
}

exports.beforeRequest = function (data) {
  return validate('beforeRequest', data)
}

exports.browser = function (data) {
  return validate('browser', data)
}

exports.cache = function (data) {
  return validate('cache', data)
}

exports.content = function (data) {
  return validate('content', data)
}

exports.cookie = function (data) {
  return validate('cookie', data)
}

exports.creator = function (data) {
  return validate('creator', data)
}

exports.entry = function (data) {
  return validate('entry', data)
}

exports.har = function (data) {
  return validate('har', data)
}

exports.header = function (data) {
  return validate('header', data)
}

exports.log = function (data) {
  return validate('log', data)
}

exports.page = function (data) {
  return validate('page', data)
}

exports.pageTimings = function (data) {
  return validate('pageTimings', data)
}

exports.postData = function (data) {
  return validate('postData', data)
}

exports.query = function (data) {
  return validate('query', data)
}

exports.request = function (data) {
  return validate('request', data)
}

exports.response = function (data) {
  return validate('response', data)
}

exports.timings = function (data) {
  return validate('timings', data)
}


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compileSchema = __webpack_require__(312)
  , resolve = __webpack_require__(83)
  , Cache = __webpack_require__(315)
  , SchemaObject = __webpack_require__(143)
  , stableStringify = __webpack_require__(144)
  , formats = __webpack_require__(316)
  , rules = __webpack_require__(317)
  , $dataMetaSchema = __webpack_require__(336)
  , patternGroups = __webpack_require__(337)
  , util = __webpack_require__(34)
  , co = __webpack_require__(146);

module.exports = Ajv;

Ajv.prototype.validate = validate;
Ajv.prototype.compile = compile;
Ajv.prototype.addSchema = addSchema;
Ajv.prototype.addMetaSchema = addMetaSchema;
Ajv.prototype.validateSchema = validateSchema;
Ajv.prototype.getSchema = getSchema;
Ajv.prototype.removeSchema = removeSchema;
Ajv.prototype.addFormat = addFormat;
Ajv.prototype.errorsText = errorsText;

Ajv.prototype._addSchema = _addSchema;
Ajv.prototype._compile = _compile;

Ajv.prototype.compileAsync = __webpack_require__(338);
var customKeyword = __webpack_require__(339);
Ajv.prototype.addKeyword = customKeyword.add;
Ajv.prototype.getKeyword = customKeyword.get;
Ajv.prototype.removeKeyword = customKeyword.remove;

var errorClasses = __webpack_require__(85);
Ajv.ValidationError = errorClasses.Validation;
Ajv.MissingRefError = errorClasses.MissingRef;
Ajv.$dataMetaSchema = $dataMetaSchema;

var META_SCHEMA_ID = 'http://json-schema.org/draft-06/schema';

var META_IGNORE_OPTIONS = [ 'removeAdditional', 'useDefaults', 'coerceTypes' ];
var META_SUPPORT_DATA = ['/properties'];

/**
 * Creates validator instance.
 * Usage: `Ajv(opts)`
 * @param {Object} opts optional options
 * @return {Object} ajv instance
 */
function Ajv(opts) {
  if (!(this instanceof Ajv)) return new Ajv(opts);
  opts = this._opts = util.copy(opts) || {};
  setLogger(this);
  this._schemas = {};
  this._refs = {};
  this._fragments = {};
  this._formats = formats(opts.format);
  var schemaUriFormat = this._schemaUriFormat = this._formats['uri-reference'];
  this._schemaUriFormatFunc = function (str) { return schemaUriFormat.test(str); };

  this._cache = opts.cache || new Cache;
  this._loadingSchemas = {};
  this._compilations = [];
  this.RULES = rules();
  this._getId = chooseGetId(opts);

  opts.loopRequired = opts.loopRequired || Infinity;
  if (opts.errorDataPath == 'property') opts._errorDataPathProperty = true;
  if (opts.serialize === undefined) opts.serialize = stableStringify;
  this._metaOpts = getMetaSchemaOptions(this);

  if (opts.formats) addInitialFormats(this);
  addDraft6MetaSchema(this);
  if (typeof opts.meta == 'object') this.addMetaSchema(opts.meta);
  addInitialSchemas(this);
  if (opts.patternGroups) patternGroups(this);
}



/**
 * Validate data using schema
 * Schema will be compiled and cached (using serialized JSON as key. [fast-json-stable-stringify](https://github.com/epoberezkin/fast-json-stable-stringify) is used to serialize.
 * @this   Ajv
 * @param  {String|Object} schemaKeyRef key, ref or schema object
 * @param  {Any} data to be validated
 * @return {Boolean} validation result. Errors from the last validation will be available in `ajv.errors` (and also in compiled schema: `schema.errors`).
 */
function validate(schemaKeyRef, data) {
  var v;
  if (typeof schemaKeyRef == 'string') {
    v = this.getSchema(schemaKeyRef);
    if (!v) throw new Error('no schema with key or ref "' + schemaKeyRef + '"');
  } else {
    var schemaObj = this._addSchema(schemaKeyRef);
    v = schemaObj.validate || this._compile(schemaObj);
  }

  var valid = v(data);
  if (v.$async === true)
    return this._opts.async == '*' ? co(valid) : valid;
  this.errors = v.errors;
  return valid;
}


/**
 * Create validating function for passed schema.
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Boolean} _meta true if schema is a meta-schema. Used internally to compile meta schemas of custom keywords.
 * @return {Function} validating function
 */
function compile(schema, _meta) {
  var schemaObj = this._addSchema(schema, undefined, _meta);
  return schemaObj.validate || this._compile(schemaObj);
}


/**
 * Adds schema to the instance.
 * @this   Ajv
 * @param {Object|Array} schema schema or array of schemas. If array is passed, `key` and other parameters will be ignored.
 * @param {String} key Optional schema key. Can be passed to `validate` method instead of schema object or id/ref. One schema per instance can have empty `id` and `key`.
 * @param {Boolean} _skipValidation true to skip schema validation. Used internally, option validateSchema should be used instead.
 * @param {Boolean} _meta true if schema is a meta-schema. Used internally, addMetaSchema should be used instead.
 * @return {Ajv} this for method chaining
 */
function addSchema(schema, key, _skipValidation, _meta) {
  if (Array.isArray(schema)){
    for (var i=0; i<schema.length; i++) this.addSchema(schema[i], undefined, _skipValidation, _meta);
    return this;
  }
  var id = this._getId(schema);
  if (id !== undefined && typeof id != 'string')
    throw new Error('schema id must be string');
  key = resolve.normalizeId(key || id);
  checkUnique(this, key);
  this._schemas[key] = this._addSchema(schema, _skipValidation, _meta, true);
  return this;
}


/**
 * Add schema that will be used to validate other schemas
 * options in META_IGNORE_OPTIONS are alway set to false
 * @this   Ajv
 * @param {Object} schema schema object
 * @param {String} key optional schema key
 * @param {Boolean} skipValidation true to skip schema validation, can be used to override validateSchema option for meta-schema
 * @return {Ajv} this for method chaining
 */
function addMetaSchema(schema, key, skipValidation) {
  this.addSchema(schema, key, skipValidation, true);
  return this;
}


/**
 * Validate schema
 * @this   Ajv
 * @param {Object} schema schema to validate
 * @param {Boolean} throwOrLogError pass true to throw (or log) an error if invalid
 * @return {Boolean} true if schema is valid
 */
function validateSchema(schema, throwOrLogError) {
  var $schema = schema.$schema;
  if ($schema !== undefined && typeof $schema != 'string')
    throw new Error('$schema must be a string');
  $schema = $schema || this._opts.defaultMeta || defaultMeta(this);
  if (!$schema) {
    this.logger.warn('meta-schema not available');
    this.errors = null;
    return true;
  }
  var currentUriFormat = this._formats.uri;
  this._formats.uri = typeof currentUriFormat == 'function'
                      ? this._schemaUriFormatFunc
                      : this._schemaUriFormat;
  var valid;
  try { valid = this.validate($schema, schema); }
  finally { this._formats.uri = currentUriFormat; }
  if (!valid && throwOrLogError) {
    var message = 'schema is invalid: ' + this.errorsText();
    if (this._opts.validateSchema == 'log') this.logger.error(message);
    else throw new Error(message);
  }
  return valid;
}


function defaultMeta(self) {
  var meta = self._opts.meta;
  self._opts.defaultMeta = typeof meta == 'object'
                            ? self._getId(meta) || meta
                            : self.getSchema(META_SCHEMA_ID)
                              ? META_SCHEMA_ID
                              : undefined;
  return self._opts.defaultMeta;
}


/**
 * Get compiled schema from the instance by `key` or `ref`.
 * @this   Ajv
 * @param  {String} keyRef `key` that was passed to `addSchema` or full schema reference (`schema.id` or resolved id).
 * @return {Function} schema validating function (with property `schema`).
 */
function getSchema(keyRef) {
  var schemaObj = _getSchemaObj(this, keyRef);
  switch (typeof schemaObj) {
    case 'object': return schemaObj.validate || this._compile(schemaObj);
    case 'string': return this.getSchema(schemaObj);
    case 'undefined': return _getSchemaFragment(this, keyRef);
  }
}


function _getSchemaFragment(self, ref) {
  var res = resolve.schema.call(self, { schema: {} }, ref);
  if (res) {
    var schema = res.schema
      , root = res.root
      , baseId = res.baseId;
    var v = compileSchema.call(self, schema, root, undefined, baseId);
    self._fragments[ref] = new SchemaObject({
      ref: ref,
      fragment: true,
      schema: schema,
      root: root,
      baseId: baseId,
      validate: v
    });
    return v;
  }
}


function _getSchemaObj(self, keyRef) {
  keyRef = resolve.normalizeId(keyRef);
  return self._schemas[keyRef] || self._refs[keyRef] || self._fragments[keyRef];
}


/**
 * Remove cached schema(s).
 * If no parameter is passed all schemas but meta-schemas are removed.
 * If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
 * Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
 * @this   Ajv
 * @param  {String|Object|RegExp} schemaKeyRef key, ref, pattern to match key/ref or schema object
 * @return {Ajv} this for method chaining
 */
function removeSchema(schemaKeyRef) {
  if (schemaKeyRef instanceof RegExp) {
    _removeAllSchemas(this, this._schemas, schemaKeyRef);
    _removeAllSchemas(this, this._refs, schemaKeyRef);
    return this;
  }
  switch (typeof schemaKeyRef) {
    case 'undefined':
      _removeAllSchemas(this, this._schemas);
      _removeAllSchemas(this, this._refs);
      this._cache.clear();
      return this;
    case 'string':
      var schemaObj = _getSchemaObj(this, schemaKeyRef);
      if (schemaObj) this._cache.del(schemaObj.cacheKey);
      delete this._schemas[schemaKeyRef];
      delete this._refs[schemaKeyRef];
      return this;
    case 'object':
      var serialize = this._opts.serialize;
      var cacheKey = serialize ? serialize(schemaKeyRef) : schemaKeyRef;
      this._cache.del(cacheKey);
      var id = this._getId(schemaKeyRef);
      if (id) {
        id = resolve.normalizeId(id);
        delete this._schemas[id];
        delete this._refs[id];
      }
  }
  return this;
}


function _removeAllSchemas(self, schemas, regex) {
  for (var keyRef in schemas) {
    var schemaObj = schemas[keyRef];
    if (!schemaObj.meta && (!regex || regex.test(keyRef))) {
      self._cache.del(schemaObj.cacheKey);
      delete schemas[keyRef];
    }
  }
}


/* @this   Ajv */
function _addSchema(schema, skipValidation, meta, shouldAddSchema) {
  if (typeof schema != 'object' && typeof schema != 'boolean')
    throw new Error('schema should be object or boolean');
  var serialize = this._opts.serialize;
  var cacheKey = serialize ? serialize(schema) : schema;
  var cached = this._cache.get(cacheKey);
  if (cached) return cached;

  shouldAddSchema = shouldAddSchema || this._opts.addUsedSchema !== false;

  var id = resolve.normalizeId(this._getId(schema));
  if (id && shouldAddSchema) checkUnique(this, id);

  var willValidate = this._opts.validateSchema !== false && !skipValidation;
  var recursiveMeta;
  if (willValidate && !(recursiveMeta = id && id == resolve.normalizeId(schema.$schema)))
    this.validateSchema(schema, true);

  var localRefs = resolve.ids.call(this, schema);

  var schemaObj = new SchemaObject({
    id: id,
    schema: schema,
    localRefs: localRefs,
    cacheKey: cacheKey,
    meta: meta
  });

  if (id[0] != '#' && shouldAddSchema) this._refs[id] = schemaObj;
  this._cache.put(cacheKey, schemaObj);

  if (willValidate && recursiveMeta) this.validateSchema(schema, true);

  return schemaObj;
}


/* @this   Ajv */
function _compile(schemaObj, root) {
  if (schemaObj.compiling) {
    schemaObj.validate = callValidate;
    callValidate.schema = schemaObj.schema;
    callValidate.errors = null;
    callValidate.root = root ? root : callValidate;
    if (schemaObj.schema.$async === true)
      callValidate.$async = true;
    return callValidate;
  }
  schemaObj.compiling = true;

  var currentOpts;
  if (schemaObj.meta) {
    currentOpts = this._opts;
    this._opts = this._metaOpts;
  }

  var v;
  try { v = compileSchema.call(this, schemaObj.schema, root, schemaObj.localRefs); }
  finally {
    schemaObj.compiling = false;
    if (schemaObj.meta) this._opts = currentOpts;
  }

  schemaObj.validate = v;
  schemaObj.refs = v.refs;
  schemaObj.refVal = v.refVal;
  schemaObj.root = v.root;
  return v;


  function callValidate() {
    var _validate = schemaObj.validate;
    var result = _validate.apply(null, arguments);
    callValidate.errors = _validate.errors;
    return result;
  }
}


function chooseGetId(opts) {
  switch (opts.schemaId) {
    case '$id': return _get$Id;
    case 'id': return _getId;
    default: return _get$IdOrId;
  }
}

/* @this   Ajv */
function _getId(schema) {
  if (schema.$id) this.logger.warn('schema $id ignored', schema.$id);
  return schema.id;
}

/* @this   Ajv */
function _get$Id(schema) {
  if (schema.id) this.logger.warn('schema id ignored', schema.id);
  return schema.$id;
}


function _get$IdOrId(schema) {
  if (schema.$id && schema.id && schema.$id != schema.id)
    throw new Error('schema $id is different from id');
  return schema.$id || schema.id;
}


/**
 * Convert array of error message objects to string
 * @this   Ajv
 * @param  {Array<Object>} errors optional array of validation errors, if not passed errors from the instance are used.
 * @param  {Object} options optional options with properties `separator` and `dataVar`.
 * @return {String} human readable string with all errors descriptions
 */
function errorsText(errors, options) {
  errors = errors || this.errors;
  if (!errors) return 'No errors';
  options = options || {};
  var separator = options.separator === undefined ? ', ' : options.separator;
  var dataVar = options.dataVar === undefined ? 'data' : options.dataVar;

  var text = '';
  for (var i=0; i<errors.length; i++) {
    var e = errors[i];
    if (e) text += dataVar + e.dataPath + ' ' + e.message + separator;
  }
  return text.slice(0, -separator.length);
}


/**
 * Add custom format
 * @this   Ajv
 * @param {String} name format name
 * @param {String|RegExp|Function} format string is converted to RegExp; function should return boolean (true when valid)
 * @return {Ajv} this for method chaining
 */
function addFormat(name, format) {
  if (typeof format == 'string') format = new RegExp(format);
  this._formats[name] = format;
  return this;
}


function addDraft6MetaSchema(self) {
  var $dataSchema;
  if (self._opts.$data) {
    $dataSchema = __webpack_require__(341);
    self.addMetaSchema($dataSchema, $dataSchema.$id, true);
  }
  if (self._opts.meta === false) return;
  var metaSchema = __webpack_require__(342);
  if (self._opts.$data) metaSchema = $dataMetaSchema(metaSchema, META_SUPPORT_DATA);
  self.addMetaSchema(metaSchema, META_SCHEMA_ID, true);
  self._refs['http://json-schema.org/schema'] = META_SCHEMA_ID;
}


function addInitialSchemas(self) {
  var optsSchemas = self._opts.schemas;
  if (!optsSchemas) return;
  if (Array.isArray(optsSchemas)) self.addSchema(optsSchemas);
  else for (var key in optsSchemas) self.addSchema(optsSchemas[key], key);
}


function addInitialFormats(self) {
  for (var name in self._opts.formats) {
    var format = self._opts.formats[name];
    self.addFormat(name, format);
  }
}


function checkUnique(self, id) {
  if (self._schemas[id] || self._refs[id])
    throw new Error('schema with key or id "' + id + '" already exists');
}


function getMetaSchemaOptions(self) {
  var metaOpts = util.copy(self._opts);
  for (var i=0; i<META_IGNORE_OPTIONS.length; i++)
    delete metaOpts[META_IGNORE_OPTIONS[i]];
  return metaOpts;
}


function setLogger(self) {
  var logger = self._opts.logger;
  if (logger === false) {
    self.logger = {log: noop, warn: noop, error: noop};
  } else {
    if (logger === undefined) logger = console;
    if (!(typeof logger == 'object' && logger.log && logger.warn && logger.error))
      throw new Error('logger must implement log, warn and error methods');
    self.logger = logger;
  }
}


function noop() {}


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var resolve = __webpack_require__(83)
  , util = __webpack_require__(34)
  , errorClasses = __webpack_require__(85)
  , stableStringify = __webpack_require__(144);

var validateGenerator = __webpack_require__(145);

/**
 * Functions below are used inside compiled validations function
 */

var co = __webpack_require__(146);
var ucs2length = util.ucs2length;
var equal = __webpack_require__(84);

// this error is thrown by async schemas to return validation errors via exception
var ValidationError = errorClasses.Validation;

module.exports = compile;


/**
 * Compiles schema to validation function
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Object} root object with information about the root schema for this schema
 * @param  {Object} localRefs the hash of local references inside the schema (created by resolve.id), used for inline resolution
 * @param  {String} baseId base ID for IDs in the schema
 * @return {Function} validation function
 */
function compile(schema, root, localRefs, baseId) {
  /* jshint validthis: true, evil: true */
  /* eslint no-shadow: 0 */
  var self = this
    , opts = this._opts
    , refVal = [ undefined ]
    , refs = {}
    , patterns = []
    , patternsHash = {}
    , defaults = []
    , defaultsHash = {}
    , customRules = [];

  root = root || { schema: schema, refVal: refVal, refs: refs };

  var c = checkCompiling.call(this, schema, root, baseId);
  var compilation = this._compilations[c.index];
  if (c.compiling) return (compilation.callValidate = callValidate);

  var formats = this._formats;
  var RULES = this.RULES;

  try {
    var v = localCompile(schema, root, localRefs, baseId);
    compilation.validate = v;
    var cv = compilation.callValidate;
    if (cv) {
      cv.schema = v.schema;
      cv.errors = null;
      cv.refs = v.refs;
      cv.refVal = v.refVal;
      cv.root = v.root;
      cv.$async = v.$async;
      if (opts.sourceCode) cv.source = v.source;
    }
    return v;
  } finally {
    endCompiling.call(this, schema, root, baseId);
  }

  function callValidate() {
    var validate = compilation.validate;
    var result = validate.apply(null, arguments);
    callValidate.errors = validate.errors;
    return result;
  }

  function localCompile(_schema, _root, localRefs, baseId) {
    var isRoot = !_root || (_root && _root.schema == _schema);
    if (_root.schema != root.schema)
      return compile.call(self, _schema, _root, localRefs, baseId);

    var $async = _schema.$async === true;

    var sourceCode = validateGenerator({
      isTop: true,
      schema: _schema,
      isRoot: isRoot,
      baseId: baseId,
      root: _root,
      schemaPath: '',
      errSchemaPath: '#',
      errorPath: '""',
      MissingRefError: errorClasses.MissingRef,
      RULES: RULES,
      validate: validateGenerator,
      util: util,
      resolve: resolve,
      resolveRef: resolveRef,
      usePattern: usePattern,
      useDefault: useDefault,
      useCustomRule: useCustomRule,
      opts: opts,
      formats: formats,
      logger: self.logger,
      self: self
    });

    sourceCode = vars(refVal, refValCode) + vars(patterns, patternCode)
                   + vars(defaults, defaultCode) + vars(customRules, customRuleCode)
                   + sourceCode;

    if (opts.processCode) sourceCode = opts.processCode(sourceCode);
    // console.log('\n\n\n *** \n', JSON.stringify(sourceCode));
    var validate;
    try {
      var makeValidate = new Function(
        'self',
        'RULES',
        'formats',
        'root',
        'refVal',
        'defaults',
        'customRules',
        'co',
        'equal',
        'ucs2length',
        'ValidationError',
        sourceCode
      );

      validate = makeValidate(
        self,
        RULES,
        formats,
        root,
        refVal,
        defaults,
        customRules,
        co,
        equal,
        ucs2length,
        ValidationError
      );

      refVal[0] = validate;
    } catch(e) {
      self.logger.error('Error compiling schema, function code:', sourceCode);
      throw e;
    }

    validate.schema = _schema;
    validate.errors = null;
    validate.refs = refs;
    validate.refVal = refVal;
    validate.root = isRoot ? validate : _root;
    if ($async) validate.$async = true;
    if (opts.sourceCode === true) {
      validate.source = {
        code: sourceCode,
        patterns: patterns,
        defaults: defaults
      };
    }

    return validate;
  }

  function resolveRef(baseId, ref, isRoot) {
    ref = resolve.url(baseId, ref);
    var refIndex = refs[ref];
    var _refVal, refCode;
    if (refIndex !== undefined) {
      _refVal = refVal[refIndex];
      refCode = 'refVal[' + refIndex + ']';
      return resolvedRef(_refVal, refCode);
    }
    if (!isRoot && root.refs) {
      var rootRefId = root.refs[ref];
      if (rootRefId !== undefined) {
        _refVal = root.refVal[rootRefId];
        refCode = addLocalRef(ref, _refVal);
        return resolvedRef(_refVal, refCode);
      }
    }

    refCode = addLocalRef(ref);
    var v = resolve.call(self, localCompile, root, ref);
    if (v === undefined) {
      var localSchema = localRefs && localRefs[ref];
      if (localSchema) {
        v = resolve.inlineRef(localSchema, opts.inlineRefs)
            ? localSchema
            : compile.call(self, localSchema, root, localRefs, baseId);
      }
    }

    if (v === undefined) {
      removeLocalRef(ref);
    } else {
      replaceLocalRef(ref, v);
      return resolvedRef(v, refCode);
    }
  }

  function addLocalRef(ref, v) {
    var refId = refVal.length;
    refVal[refId] = v;
    refs[ref] = refId;
    return 'refVal' + refId;
  }

  function removeLocalRef(ref) {
    delete refs[ref];
  }

  function replaceLocalRef(ref, v) {
    var refId = refs[ref];
    refVal[refId] = v;
  }

  function resolvedRef(refVal, code) {
    return typeof refVal == 'object' || typeof refVal == 'boolean'
            ? { code: code, schema: refVal, inline: true }
            : { code: code, $async: refVal && refVal.$async };
  }

  function usePattern(regexStr) {
    var index = patternsHash[regexStr];
    if (index === undefined) {
      index = patternsHash[regexStr] = patterns.length;
      patterns[index] = regexStr;
    }
    return 'pattern' + index;
  }

  function useDefault(value) {
    switch (typeof value) {
      case 'boolean':
      case 'number':
        return '' + value;
      case 'string':
        return util.toQuotedString(value);
      case 'object':
        if (value === null) return 'null';
        var valueStr = stableStringify(value);
        var index = defaultsHash[valueStr];
        if (index === undefined) {
          index = defaultsHash[valueStr] = defaults.length;
          defaults[index] = value;
        }
        return 'default' + index;
    }
  }

  function useCustomRule(rule, schema, parentSchema, it) {
    var validateSchema = rule.definition.validateSchema;
    if (validateSchema && self._opts.validateSchema !== false) {
      var valid = validateSchema(schema);
      if (!valid) {
        var message = 'keyword schema is invalid: ' + self.errorsText(validateSchema.errors);
        if (self._opts.validateSchema == 'log') self.logger.error(message);
        else throw new Error(message);
      }
    }

    var compile = rule.definition.compile
      , inline = rule.definition.inline
      , macro = rule.definition.macro;

    var validate;
    if (compile) {
      validate = compile.call(self, schema, parentSchema, it);
    } else if (macro) {
      validate = macro.call(self, schema, parentSchema, it);
      if (opts.validateSchema !== false) self.validateSchema(validate, true);
    } else if (inline) {
      validate = inline.call(self, it, rule.keyword, schema, parentSchema);
    } else {
      validate = rule.definition.validate;
      if (!validate) return;
    }

    if (validate === undefined)
      throw new Error('custom keyword "' + rule.keyword + '"failed to compile');

    var index = customRules.length;
    customRules[index] = validate;

    return {
      code: 'customRule' + index,
      validate: validate
    };
  }
}


/**
 * Checks if the schema is currently compiled
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Object} object with properties "index" (compilation index) and "compiling" (boolean)
 */
function checkCompiling(schema, root, baseId) {
  /* jshint validthis: true */
  var index = compIndex.call(this, schema, root, baseId);
  if (index >= 0) return { index: index, compiling: true };
  index = this._compilations.length;
  this._compilations[index] = {
    schema: schema,
    root: root,
    baseId: baseId
  };
  return { index: index, compiling: false };
}


/**
 * Removes the schema from the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 */
function endCompiling(schema, root, baseId) {
  /* jshint validthis: true */
  var i = compIndex.call(this, schema, root, baseId);
  if (i >= 0) this._compilations.splice(i, 1);
}


/**
 * Index of schema compilation in the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Integer} compilation index
 */
function compIndex(schema, root, baseId) {
  /* jshint validthis: true */
  for (var i=0; i<this._compilations.length; i++) {
    var c = this._compilations[i];
    if (c.schema == schema && c.root == root && c.baseId == baseId) return i;
  }
  return -1;
}


function patternCode(i, patterns) {
  return 'var pattern' + i + ' = new RegExp(' + util.toQuotedString(patterns[i]) + ');';
}


function defaultCode(i) {
  return 'var default' + i + ' = defaults[' + i + '];';
}


function refValCode(i, refVal) {
  return refVal[i] === undefined ? '' : 'var refVal' + i + ' = refVal[' + i + '];';
}


function customRuleCode(i) {
  return 'var customRule' + i + ' = customRules[' + i + '];';
}


function vars(arr, statement) {
  if (!arr.length) return '';
  var code = '';
  for (var i=0; i<arr.length; i++)
    code += statement(i, arr);
  return code;
}


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
module.exports = function ucs2length(str) {
  var length = 0
    , len = str.length
    , pos = 0
    , value;
  while (pos < len) {
    length++;
    value = str.charCodeAt(pos++);
    if (value >= 0xD800 && value <= 0xDBFF && pos < len) {
      // high surrogate, and there is a next character
      value = str.charCodeAt(pos);
      if ((value & 0xFC00) == 0xDC00) pos++; // low surrogate
    }
  }
  return length;
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var traverse = module.exports = function (schema, opts, cb) {
  if (typeof opts == 'function') {
    cb = opts;
    opts = {};
  }
  _traverse(opts, cb, schema, '', schema);
};


traverse.keywords = {
  additionalItems: true,
  items: true,
  contains: true,
  additionalProperties: true,
  propertyNames: true,
  not: true
};

traverse.arrayKeywords = {
  items: true,
  allOf: true,
  anyOf: true,
  oneOf: true
};

traverse.propsKeywords = {
  definitions: true,
  properties: true,
  patternProperties: true,
  dependencies: true
};

traverse.skipKeywords = {
  enum: true,
  const: true,
  required: true,
  maximum: true,
  minimum: true,
  exclusiveMaximum: true,
  exclusiveMinimum: true,
  multipleOf: true,
  maxLength: true,
  minLength: true,
  pattern: true,
  format: true,
  maxItems: true,
  minItems: true,
  uniqueItems: true,
  maxProperties: true,
  minProperties: true
};


function _traverse(opts, cb, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
  if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
    cb(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    for (var key in schema) {
      var sch = schema[key];
      if (Array.isArray(sch)) {
        if (key in traverse.arrayKeywords) {
          for (var i=0; i<sch.length; i++)
            _traverse(opts, cb, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
        }
      } else if (key in traverse.propsKeywords) {
        if (sch && typeof sch == 'object') {
          for (var prop in sch)
            _traverse(opts, cb, sch[prop], jsonPtr + '/' + key + '/' + escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
        }
      } else if (key in traverse.keywords || (opts.allKeys && !(key in traverse.skipKeywords))) {
        _traverse(opts, cb, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
      }
    }
  }
}


function escapeJsonPtr(str) {
  return str.replace(/~/g, '~0').replace(/\//g, '~1');
}


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var Cache = module.exports = function Cache() {
  this._cache = {};
};


Cache.prototype.put = function Cache_put(key, value) {
  this._cache[key] = value;
};


Cache.prototype.get = function Cache_get(key) {
  return this._cache[key];
};


Cache.prototype.del = function Cache_del(key) {
  delete this._cache[key];
};


Cache.prototype.clear = function Cache_clear() {
  this._cache = {};
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(34);

var DATE = /^\d\d\d\d-(\d\d)-(\d\d)$/;
var DAYS = [0,31,29,31,30,31,30,31,31,30,31,30,31];
var TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d:\d\d)?$/i;
var HOSTNAME = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*$/i;
var URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
var URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
// uri-template: https://tools.ietf.org/html/rfc6570
var URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
// For the source: https://gist.github.com/dperini/729294
// For test cases: https://mathiasbynens.be/demo/url-regex
// @todo Delete current URL in favour of the commented out URL rule when this issue is fixed https://github.com/eslint/eslint/issues/7983.
// var URL = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
var URL = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-?)*(?:[0-9KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[KSa-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i;
var UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
var JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$|^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
var RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;


module.exports = formats;

function formats(mode) {
  mode = mode == 'full' ? 'full' : 'fast';
  return util.copy(formats[mode]);
}


formats.fast = {
  // date: http://tools.ietf.org/html/rfc3339#section-5.6
  date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
  // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
  time: /^[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?(?:z|[+-]\d\d:\d\d)?$/i,
  'date-time': /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s][0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?(?:z|[+-]\d\d:\d\d)$/i,
  // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
  uri: /^(?:[a-z][a-z0-9+-.]*)(?::|\/)\/?[^\s]*$/i,
  'uri-reference': /^(?:(?:[a-z][a-z0-9+-.]*:)?\/\/)?[^\s]*$/i,
  'uri-template': URITEMPLATE,
  url: URL,
  // email (sources from jsen validator):
  // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
  // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'willful violation')
  email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
  hostname: HOSTNAME,
  // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
  ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  // optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
  ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
  regex: regex,
  // uuid: http://tools.ietf.org/html/rfc4122
  uuid: UUID,
  // JSON-pointer: https://tools.ietf.org/html/rfc6901
  // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
  'json-pointer': JSON_POINTER,
  // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
  'relative-json-pointer': RELATIVE_JSON_POINTER
};


formats.full = {
  date: date,
  time: time,
  'date-time': date_time,
  uri: uri,
  'uri-reference': URIREF,
  'uri-template': URITEMPLATE,
  url: URL,
  email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&''*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
  hostname: hostname,
  ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
  ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
  regex: regex,
  uuid: UUID,
  'json-pointer': JSON_POINTER,
  'relative-json-pointer': RELATIVE_JSON_POINTER
};


function date(str) {
  // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
  var matches = str.match(DATE);
  if (!matches) return false;

  var month = +matches[1];
  var day = +matches[2];
  return month >= 1 && month <= 12 && day >= 1 && day <= DAYS[month];
}


function time(str, full) {
  var matches = str.match(TIME);
  if (!matches) return false;

  var hour = matches[1];
  var minute = matches[2];
  var second = matches[3];
  var timeZone = matches[5];
  return hour <= 23 && minute <= 59 && second <= 59 && (!full || timeZone);
}


var DATE_TIME_SEPARATOR = /t|\s/i;
function date_time(str) {
  // http://tools.ietf.org/html/rfc3339#section-5.6
  var dateTime = str.split(DATE_TIME_SEPARATOR);
  return dateTime.length == 2 && date(dateTime[0]) && time(dateTime[1], true);
}


function hostname(str) {
  // https://tools.ietf.org/html/rfc1034#section-3.5
  // https://tools.ietf.org/html/rfc1123#section-2
  return str.length <= 255 && HOSTNAME.test(str);
}


var NOT_URI_FRAGMENT = /\/|:/;
function uri(str) {
  // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
  return NOT_URI_FRAGMENT.test(str) && URI.test(str);
}


var Z_ANCHOR = /[^\\]\\Z/;
function regex(str) {
  if (Z_ANCHOR.test(str)) return false;
  try {
    new RegExp(str);
    return true;
  } catch(e) {
    return false;
  }
}


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ruleModules = __webpack_require__(318)
  , toHash = __webpack_require__(34).toHash;

module.exports = function rules() {
  var RULES = [
    { type: 'number',
      rules: [ { 'maximum': ['exclusiveMaximum'] },
               { 'minimum': ['exclusiveMinimum'] }, 'multipleOf', 'format'] },
    { type: 'string',
      rules: [ 'maxLength', 'minLength', 'pattern', 'format' ] },
    { type: 'array',
      rules: [ 'maxItems', 'minItems', 'uniqueItems', 'contains', 'items' ] },
    { type: 'object',
      rules: [ 'maxProperties', 'minProperties', 'required', 'dependencies', 'propertyNames',
               { 'properties': ['additionalProperties', 'patternProperties'] } ] },
    { rules: [ '$ref', 'const', 'enum', 'not', 'anyOf', 'oneOf', 'allOf' ] }
  ];

  var ALL = [ 'type' ];
  var KEYWORDS = [
    'additionalItems', '$schema', '$id', 'id', 'title',
    'description', 'default', 'definitions'
  ];
  var TYPES = [ 'number', 'integer', 'string', 'array', 'object', 'boolean', 'null' ];
  RULES.all = toHash(ALL);
  RULES.types = toHash(TYPES);

  RULES.forEach(function (group) {
    group.rules = group.rules.map(function (keyword) {
      var implKeywords;
      if (typeof keyword == 'object') {
        var key = Object.keys(keyword)[0];
        implKeywords = keyword[key];
        keyword = key;
        implKeywords.forEach(function (k) {
          ALL.push(k);
          RULES.all[k] = true;
        });
      }
      ALL.push(keyword);
      var rule = RULES.all[keyword] = {
        keyword: keyword,
        code: ruleModules[keyword],
        implements: implKeywords
      };
      return rule;
    });

    if (group.type) RULES.types[group.type] = group;
  });

  RULES.keywords = toHash(ALL.concat(KEYWORDS));
  RULES.custom = {};

  return RULES;
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//all requires must be explicit because browserify won't work with dynamic requires
module.exports = {
  '$ref': __webpack_require__(319),
  allOf: __webpack_require__(320),
  anyOf: __webpack_require__(321),
  const: __webpack_require__(322),
  contains: __webpack_require__(323),
  dependencies: __webpack_require__(324),
  'enum': __webpack_require__(325),
  format: __webpack_require__(326),
  items: __webpack_require__(327),
  maximum: __webpack_require__(147),
  minimum: __webpack_require__(147),
  maxItems: __webpack_require__(148),
  minItems: __webpack_require__(148),
  maxLength: __webpack_require__(149),
  minLength: __webpack_require__(149),
  maxProperties: __webpack_require__(150),
  minProperties: __webpack_require__(150),
  multipleOf: __webpack_require__(328),
  not: __webpack_require__(329),
  oneOf: __webpack_require__(330),
  pattern: __webpack_require__(331),
  properties: __webpack_require__(332),
  propertyNames: __webpack_require__(333),
  required: __webpack_require__(334),
  uniqueItems: __webpack_require__(335),
  validate: __webpack_require__(145)
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_ref(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $async, $refCode;
  if ($schema == '#' || $schema == '#/') {
    if (it.isRoot) {
      $async = it.async;
      $refCode = 'validate';
    } else {
      $async = it.root.schema.$async === true;
      $refCode = 'root.refVal[0]';
    }
  } else {
    var $refVal = it.resolveRef(it.baseId, $schema, it.isRoot);
    if ($refVal === undefined) {
      var $message = it.MissingRefError.message(it.baseId, $schema);
      if (it.opts.missingRefs == 'fail') {
        it.logger.error($message);
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('$ref') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { ref: \'' + (it.util.escapeQuotes($schema)) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'can\\\'t resolve reference ' + (it.util.escapeQuotes($schema)) + '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: ' + (it.util.toQuotedString($schema)) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        if ($breakOnError) {
          out += ' if (false) { ';
        }
      } else if (it.opts.missingRefs == 'ignore') {
        it.logger.warn($message);
        if ($breakOnError) {
          out += ' if (true) { ';
        }
      } else {
        throw new it.MissingRefError(it.baseId, $schema, $message);
      }
    } else if ($refVal.inline) {
      var $it = it.util.copy(it);
      $it.level++;
      var $nextValid = 'valid' + $it.level;
      $it.schema = $refVal.schema;
      $it.schemaPath = '';
      $it.errSchemaPath = $schema;
      var $code = it.validate($it).replace(/validate\.schema/g, $refVal.code);
      out += ' ' + ($code) + ' ';
      if ($breakOnError) {
        out += ' if (' + ($nextValid) + ') { ';
      }
    } else {
      $async = $refVal.$async === true;
      $refCode = $refVal.code;
    }
  }
  if ($refCode) {
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = '';
    if (it.opts.passContext) {
      out += ' ' + ($refCode) + '.call(this, ';
    } else {
      out += ' ' + ($refCode) + '( ';
    }
    out += ' ' + ($data) + ', (dataPath || \'\')';
    if (it.errorPath != '""') {
      out += ' + ' + (it.errorPath);
    }
    var $parentData = $dataLvl ? 'data' + (($dataLvl - 1) || '') : 'parentData',
      $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
    out += ' , ' + ($parentData) + ' , ' + ($parentDataProperty) + ', rootData)  ';
    var __callValidate = out;
    out = $$outStack.pop();
    if ($async) {
      if (!it.async) throw new Error('async schema referenced by sync schema');
      if ($breakOnError) {
        out += ' var ' + ($valid) + '; ';
      }
      out += ' try { ' + (it.yieldAwait) + ' ' + (__callValidate) + '; ';
      if ($breakOnError) {
        out += ' ' + ($valid) + ' = true; ';
      }
      out += ' } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ';
      if ($breakOnError) {
        out += ' ' + ($valid) + ' = false; ';
      }
      out += ' } ';
      if ($breakOnError) {
        out += ' if (' + ($valid) + ') { ';
      }
    } else {
      out += ' if (!' + (__callValidate) + ') { if (vErrors === null) vErrors = ' + ($refCode) + '.errors; else vErrors = vErrors.concat(' + ($refCode) + '.errors); errors = vErrors.length; } ';
      if ($breakOnError) {
        out += ' else { ';
      }
    }
  }
  return out;
}


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_allOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $currentBaseId = $it.baseId,
    $allSchemasEmpty = true;
  var arr1 = $schema;
  if (arr1) {
    var $sch, $i = -1,
      l1 = arr1.length - 1;
    while ($i < l1) {
      $sch = arr1[$i += 1];
      if (it.util.schemaHasRules($sch, it.RULES.all)) {
        $allSchemasEmpty = false;
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + '[' + $i + ']';
        $it.errSchemaPath = $errSchemaPath + '/' + $i;
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
        if ($breakOnError) {
          out += ' if (' + ($nextValid) + ') { ';
          $closingBraces += '}';
        }
      }
    }
  }
  if ($breakOnError) {
    if ($allSchemasEmpty) {
      out += ' if (true) { ';
    } else {
      out += ' ' + ($closingBraces.slice(0, -1)) + ' ';
    }
  }
  out = it.util.cleanUpCode(out);
  return out;
}


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_anyOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $noEmptySchema = $schema.every(function($sch) {
    return it.util.schemaHasRules($sch, it.RULES.all);
  });
  if ($noEmptySchema) {
    var $currentBaseId = $it.baseId;
    out += ' var ' + ($errs) + ' = errors; var ' + ($valid) + ' = false;  ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var arr1 = $schema;
    if (arr1) {
      var $sch, $i = -1,
        l1 = arr1.length - 1;
      while ($i < l1) {
        $sch = arr1[$i += 1];
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + '[' + $i + ']';
        $it.errSchemaPath = $errSchemaPath + '/' + $i;
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
        out += ' ' + ($valid) + ' = ' + ($valid) + ' || ' + ($nextValid) + '; if (!' + ($valid) + ') { ';
        $closingBraces += '}';
      }
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' ' + ($closingBraces) + ' if (!' + ($valid) + ') {   var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('anyOf') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should match some schema in anyOf\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError(vErrors); ';
      } else {
        out += ' validate.errors = vErrors; return false; ';
      }
    }
    out += ' } else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } ';
    if (it.opts.allErrors) {
      out += ' } ';
    }
    out = it.util.cleanUpCode(out);
  } else {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  }
  return out;
}


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_const(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (!$isData) {
    out += ' var schema' + ($lvl) + ' = validate.schema' + ($schemaPath) + ';';
  }
  out += 'var ' + ($valid) + ' = equal(' + ($data) + ', schema' + ($lvl) + '); if (!' + ($valid) + ') {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('const') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be equal to constant\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' }';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_contains(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $idx = 'i' + $lvl,
    $dataNxt = $it.dataLevel = it.dataLevel + 1,
    $nextData = 'data' + $dataNxt,
    $currentBaseId = it.baseId,
    $nonEmptySchema = it.util.schemaHasRules($schema, it.RULES.all);
  out += 'var ' + ($errs) + ' = errors;var ' + ($valid) + ';';
  if ($nonEmptySchema) {
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += ' var ' + ($nextValid) + ' = false; for (var ' + ($idx) + ' = 0; ' + ($idx) + ' < ' + ($data) + '.length; ' + ($idx) + '++) { ';
    $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
    var $passData = $data + '[' + $idx + ']';
    $it.dataPathArr[$dataNxt] = $idx;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
    } else {
      out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
    }
    out += ' if (' + ($nextValid) + ') break; }  ';
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' ' + ($closingBraces) + ' if (!' + ($nextValid) + ') {';
  } else {
    out += ' if (' + ($data) + '.length == 0) {';
  }
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('contains') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should contain a valid item\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' } else { ';
  if ($nonEmptySchema) {
    out += '  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } ';
  }
  if (it.opts.allErrors) {
    out += ' } ';
  }
  out = it.util.cleanUpCode(out);
  return out;
}


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_dependencies(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $schemaDeps = {},
    $propertyDeps = {},
    $ownProperties = it.opts.ownProperties;
  for ($property in $schema) {
    var $sch = $schema[$property];
    var $deps = Array.isArray($sch) ? $propertyDeps : $schemaDeps;
    $deps[$property] = $sch;
  }
  out += 'var ' + ($errs) + ' = errors;';
  var $currentErrorPath = it.errorPath;
  out += 'var missing' + ($lvl) + ';';
  for (var $property in $propertyDeps) {
    $deps = $propertyDeps[$property];
    if ($deps.length) {
      out += ' if ( ' + ($data) + (it.util.getProperty($property)) + ' !== undefined ';
      if ($ownProperties) {
        out += ' && Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($property)) + '\') ';
      }
      if ($breakOnError) {
        out += ' && ( ';
        var arr1 = $deps;
        if (arr1) {
          var $propertyKey, $i = -1,
            l1 = arr1.length - 1;
          while ($i < l1) {
            $propertyKey = arr1[$i += 1];
            if ($i) {
              out += ' || ';
            }
            var $prop = it.util.getProperty($propertyKey),
              $useData = $data + $prop;
            out += ' ( ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') && (missing' + ($lvl) + ' = ' + (it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop)) + ') ) ';
          }
        }
        out += ')) {  ';
        var $propertyPath = 'missing' + $lvl,
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
        }
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('dependencies') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { property: \'' + (it.util.escapeQuotes($property)) + '\', missingProperty: \'' + ($missingProperty) + '\', depsCount: ' + ($deps.length) + ', deps: \'' + (it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", "))) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'should have ';
            if ($deps.length == 1) {
              out += 'property ' + (it.util.escapeQuotes($deps[0]));
            } else {
              out += 'properties ' + (it.util.escapeQuotes($deps.join(", ")));
            }
            out += ' when property ' + (it.util.escapeQuotes($property)) + ' is present\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
      } else {
        out += ' ) { ';
        var arr2 = $deps;
        if (arr2) {
          var $propertyKey, i2 = -1,
            l2 = arr2.length - 1;
          while (i2 < l2) {
            $propertyKey = arr2[i2 += 1];
            var $prop = it.util.getProperty($propertyKey),
              $missingProperty = it.util.escapeQuotes($propertyKey),
              $useData = $data + $prop;
            if (it.opts._errorDataPathProperty) {
              it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
            }
            out += ' if ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') {  var err =   '; /* istanbul ignore else */
            if (it.createErrors !== false) {
              out += ' { keyword: \'' + ('dependencies') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { property: \'' + (it.util.escapeQuotes($property)) + '\', missingProperty: \'' + ($missingProperty) + '\', depsCount: ' + ($deps.length) + ', deps: \'' + (it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", "))) + '\' } ';
              if (it.opts.messages !== false) {
                out += ' , message: \'should have ';
                if ($deps.length == 1) {
                  out += 'property ' + (it.util.escapeQuotes($deps[0]));
                } else {
                  out += 'properties ' + (it.util.escapeQuotes($deps.join(", ")));
                }
                out += ' when property ' + (it.util.escapeQuotes($property)) + ' is present\' ';
              }
              if (it.opts.verbose) {
                out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
              }
              out += ' } ';
            } else {
              out += ' {} ';
            }
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
          }
        }
      }
      out += ' }   ';
      if ($breakOnError) {
        $closingBraces += '}';
        out += ' else { ';
      }
    }
  }
  it.errorPath = $currentErrorPath;
  var $currentBaseId = $it.baseId;
  for (var $property in $schemaDeps) {
    var $sch = $schemaDeps[$property];
    if (it.util.schemaHasRules($sch, it.RULES.all)) {
      out += ' ' + ($nextValid) + ' = true; if ( ' + ($data) + (it.util.getProperty($property)) + ' !== undefined ';
      if ($ownProperties) {
        out += ' && Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($property)) + '\') ';
      }
      out += ') { ';
      $it.schema = $sch;
      $it.schemaPath = $schemaPath + it.util.getProperty($property);
      $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($property);
      out += '  ' + (it.validate($it)) + ' ';
      $it.baseId = $currentBaseId;
      out += ' }  ';
      if ($breakOnError) {
        out += ' if (' + ($nextValid) + ') { ';
        $closingBraces += '}';
      }
    }
  }
  if ($breakOnError) {
    out += '   ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  out = it.util.cleanUpCode(out);
  return out;
}


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_enum(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $i = 'i' + $lvl,
    $vSchema = 'schema' + $lvl;
  if (!$isData) {
    out += ' var ' + ($vSchema) + ' = validate.schema' + ($schemaPath) + ';';
  }
  out += 'var ' + ($valid) + ';';
  if ($isData) {
    out += ' if (schema' + ($lvl) + ' === undefined) ' + ($valid) + ' = true; else if (!Array.isArray(schema' + ($lvl) + ')) ' + ($valid) + ' = false; else {';
  }
  out += '' + ($valid) + ' = false;for (var ' + ($i) + '=0; ' + ($i) + '<' + ($vSchema) + '.length; ' + ($i) + '++) if (equal(' + ($data) + ', ' + ($vSchema) + '[' + ($i) + '])) { ' + ($valid) + ' = true; break; }';
  if ($isData) {
    out += '  }  ';
  }
  out += ' if (!' + ($valid) + ') {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('enum') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { allowedValues: schema' + ($lvl) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be equal to one of the allowed values\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' }';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_format(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  if (it.opts.format === false) {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
    return out;
  }
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $unknownFormats = it.opts.unknownFormats,
    $allowUnknown = Array.isArray($unknownFormats);
  if ($isData) {
    var $format = 'format' + $lvl,
      $isObject = 'isObject' + $lvl,
      $formatType = 'formatType' + $lvl;
    out += ' var ' + ($format) + ' = formats[' + ($schemaValue) + ']; var ' + ($isObject) + ' = typeof ' + ($format) + ' == \'object\' && !(' + ($format) + ' instanceof RegExp) && ' + ($format) + '.validate; var ' + ($formatType) + ' = ' + ($isObject) + ' && ' + ($format) + '.type || \'string\'; if (' + ($isObject) + ') { ';
    if (it.async) {
      out += ' var async' + ($lvl) + ' = ' + ($format) + '.async; ';
    }
    out += ' ' + ($format) + ' = ' + ($format) + '.validate; } if (  ';
    if ($isData) {
      out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'string\') || ';
    }
    out += ' (';
    if ($unknownFormats != 'ignore') {
      out += ' (' + ($schemaValue) + ' && !' + ($format) + ' ';
      if ($allowUnknown) {
        out += ' && self._opts.unknownFormats.indexOf(' + ($schemaValue) + ') == -1 ';
      }
      out += ') || ';
    }
    out += ' (' + ($format) + ' && ' + ($formatType) + ' == \'' + ($ruleType) + '\' && !(typeof ' + ($format) + ' == \'function\' ? ';
    if (it.async) {
      out += ' (async' + ($lvl) + ' ? ' + (it.yieldAwait) + ' ' + ($format) + '(' + ($data) + ') : ' + ($format) + '(' + ($data) + ')) ';
    } else {
      out += ' ' + ($format) + '(' + ($data) + ') ';
    }
    out += ' : ' + ($format) + '.test(' + ($data) + '))))) {';
  } else {
    var $format = it.formats[$schema];
    if (!$format) {
      if ($unknownFormats == 'ignore') {
        it.logger.warn('unknown format "' + $schema + '" ignored in schema at path "' + it.errSchemaPath + '"');
        if ($breakOnError) {
          out += ' if (true) { ';
        }
        return out;
      } else if ($allowUnknown && $unknownFormats.indexOf($schema) >= 0) {
        if ($breakOnError) {
          out += ' if (true) { ';
        }
        return out;
      } else {
        throw new Error('unknown format "' + $schema + '" is used in schema at path "' + it.errSchemaPath + '"');
      }
    }
    var $isObject = typeof $format == 'object' && !($format instanceof RegExp) && $format.validate;
    var $formatType = $isObject && $format.type || 'string';
    if ($isObject) {
      var $async = $format.async === true;
      $format = $format.validate;
    }
    if ($formatType != $ruleType) {
      if ($breakOnError) {
        out += ' if (true) { ';
      }
      return out;
    }
    if ($async) {
      if (!it.async) throw new Error('async format in sync schema');
      var $formatRef = 'formats' + it.util.getProperty($schema) + '.validate';
      out += ' if (!(' + (it.yieldAwait) + ' ' + ($formatRef) + '(' + ($data) + '))) { ';
    } else {
      out += ' if (! ';
      var $formatRef = 'formats' + it.util.getProperty($schema);
      if ($isObject) $formatRef += '.validate';
      if (typeof $format == 'function') {
        out += ' ' + ($formatRef) + '(' + ($data) + ') ';
      } else {
        out += ' ' + ($formatRef) + '.test(' + ($data) + ') ';
      }
      out += ') { ';
    }
  }
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('format') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { format:  ';
    if ($isData) {
      out += '' + ($schemaValue);
    } else {
      out += '' + (it.util.toQuotedString($schema));
    }
    out += '  } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should match format "';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + (it.util.escapeQuotes($schema));
      }
      out += '"\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + (it.util.toQuotedString($schema));
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += ' } ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_items(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $idx = 'i' + $lvl,
    $dataNxt = $it.dataLevel = it.dataLevel + 1,
    $nextData = 'data' + $dataNxt,
    $currentBaseId = it.baseId;
  out += 'var ' + ($errs) + ' = errors;var ' + ($valid) + ';';
  if (Array.isArray($schema)) {
    var $additionalItems = it.schema.additionalItems;
    if ($additionalItems === false) {
      out += ' ' + ($valid) + ' = ' + ($data) + '.length <= ' + ($schema.length) + '; ';
      var $currErrSchemaPath = $errSchemaPath;
      $errSchemaPath = it.errSchemaPath + '/additionalItems';
      out += '  if (!' + ($valid) + ') {   ';
      var $$outStack = $$outStack || [];
      $$outStack.push(out);
      out = ''; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ('additionalItems') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { limit: ' + ($schema.length) + ' } ';
        if (it.opts.messages !== false) {
          out += ' , message: \'should NOT have more than ' + ($schema.length) + ' items\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: false , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      var __err = out;
      out = $$outStack.pop();
      if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
        if (it.async) {
          out += ' throw new ValidationError([' + (__err) + ']); ';
        } else {
          out += ' validate.errors = [' + (__err) + ']; return false; ';
        }
      } else {
        out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
      }
      out += ' } ';
      $errSchemaPath = $currErrSchemaPath;
      if ($breakOnError) {
        $closingBraces += '}';
        out += ' else { ';
      }
    }
    var arr1 = $schema;
    if (arr1) {
      var $sch, $i = -1,
        l1 = arr1.length - 1;
      while ($i < l1) {
        $sch = arr1[$i += 1];
        if (it.util.schemaHasRules($sch, it.RULES.all)) {
          out += ' ' + ($nextValid) + ' = true; if (' + ($data) + '.length > ' + ($i) + ') { ';
          var $passData = $data + '[' + $i + ']';
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + '[' + $i + ']';
          $it.errSchemaPath = $errSchemaPath + '/' + $i;
          $it.errorPath = it.util.getPathExpr(it.errorPath, $i, it.opts.jsonPointers, true);
          $it.dataPathArr[$dataNxt] = $i;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          out += ' }  ';
          if ($breakOnError) {
            out += ' if (' + ($nextValid) + ') { ';
            $closingBraces += '}';
          }
        }
      }
    }
    if (typeof $additionalItems == 'object' && it.util.schemaHasRules($additionalItems, it.RULES.all)) {
      $it.schema = $additionalItems;
      $it.schemaPath = it.schemaPath + '.additionalItems';
      $it.errSchemaPath = it.errSchemaPath + '/additionalItems';
      out += ' ' + ($nextValid) + ' = true; if (' + ($data) + '.length > ' + ($schema.length) + ') {  for (var ' + ($idx) + ' = ' + ($schema.length) + '; ' + ($idx) + ' < ' + ($data) + '.length; ' + ($idx) + '++) { ';
      $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
      var $passData = $data + '[' + $idx + ']';
      $it.dataPathArr[$dataNxt] = $idx;
      var $code = it.validate($it);
      $it.baseId = $currentBaseId;
      if (it.util.varOccurences($code, $nextData) < 2) {
        out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
      } else {
        out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
      }
      if ($breakOnError) {
        out += ' if (!' + ($nextValid) + ') break; ';
      }
      out += ' } }  ';
      if ($breakOnError) {
        out += ' if (' + ($nextValid) + ') { ';
        $closingBraces += '}';
      }
    }
  } else if (it.util.schemaHasRules($schema, it.RULES.all)) {
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += '  for (var ' + ($idx) + ' = ' + (0) + '; ' + ($idx) + ' < ' + ($data) + '.length; ' + ($idx) + '++) { ';
    $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
    var $passData = $data + '[' + $idx + ']';
    $it.dataPathArr[$dataNxt] = $idx;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
    } else {
      out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
    }
    if ($breakOnError) {
      out += ' if (!' + ($nextValid) + ') break; ';
    }
    out += ' }';
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  out = it.util.cleanUpCode(out);
  return out;
}


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_multipleOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  out += 'var division' + ($lvl) + ';if (';
  if ($isData) {
    out += ' ' + ($schemaValue) + ' !== undefined && ( typeof ' + ($schemaValue) + ' != \'number\' || ';
  }
  out += ' (division' + ($lvl) + ' = ' + ($data) + ' / ' + ($schemaValue) + ', ';
  if (it.opts.multipleOfPrecision) {
    out += ' Math.abs(Math.round(division' + ($lvl) + ') - division' + ($lvl) + ') > 1e-' + (it.opts.multipleOfPrecision) + ' ';
  } else {
    out += ' division' + ($lvl) + ' !== parseInt(division' + ($lvl) + ') ';
  }
  out += ' ) ';
  if ($isData) {
    out += '  )  ';
  }
  out += ' ) {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('multipleOf') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { multipleOf: ' + ($schemaValue) + ' } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should be multiple of ';
      if ($isData) {
        out += '\' + ' + ($schemaValue);
      } else {
        out += '' + ($schemaValue) + '\'';
      }
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + ($schema);
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_not(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  if (it.util.schemaHasRules($schema, it.RULES.all)) {
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    out += ' var ' + ($errs) + ' = errors;  ';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    $it.createErrors = false;
    var $allErrorsOption;
    if ($it.opts.allErrors) {
      $allErrorsOption = $it.opts.allErrors;
      $it.opts.allErrors = false;
    }
    out += ' ' + (it.validate($it)) + ' ';
    $it.createErrors = true;
    if ($allErrorsOption) $it.opts.allErrors = $allErrorsOption;
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' if (' + ($nextValid) + ') {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('not') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should NOT be valid\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' } else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; } ';
    if (it.opts.allErrors) {
      out += ' } ';
    }
  } else {
    out += '  var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('not') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should NOT be valid\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if ($breakOnError) {
      out += ' if (false) { ';
    }
  }
  return out;
}


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_oneOf(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  out += 'var ' + ($errs) + ' = errors;var prevValid' + ($lvl) + ' = false;var ' + ($valid) + ' = false;';
  var $currentBaseId = $it.baseId;
  var $wasComposite = it.compositeRule;
  it.compositeRule = $it.compositeRule = true;
  var arr1 = $schema;
  if (arr1) {
    var $sch, $i = -1,
      l1 = arr1.length - 1;
    while ($i < l1) {
      $sch = arr1[$i += 1];
      if (it.util.schemaHasRules($sch, it.RULES.all)) {
        $it.schema = $sch;
        $it.schemaPath = $schemaPath + '[' + $i + ']';
        $it.errSchemaPath = $errSchemaPath + '/' + $i;
        out += '  ' + (it.validate($it)) + ' ';
        $it.baseId = $currentBaseId;
      } else {
        out += ' var ' + ($nextValid) + ' = true; ';
      }
      if ($i) {
        out += ' if (' + ($nextValid) + ' && prevValid' + ($lvl) + ') ' + ($valid) + ' = false; else { ';
        $closingBraces += '}';
      }
      out += ' if (' + ($nextValid) + ') ' + ($valid) + ' = prevValid' + ($lvl) + ' = true;';
    }
  }
  it.compositeRule = $it.compositeRule = $wasComposite;
  out += '' + ($closingBraces) + 'if (!' + ($valid) + ') {   var err =   '; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('oneOf') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: {} ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should match exactly one schema in oneOf\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError(vErrors); ';
    } else {
      out += ' validate.errors = vErrors; return false; ';
    }
  }
  out += '} else {  errors = ' + ($errs) + '; if (vErrors !== null) { if (' + ($errs) + ') vErrors.length = ' + ($errs) + '; else vErrors = null; }';
  if (it.opts.allErrors) {
    out += ' } ';
  }
  return out;
}


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_pattern(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $regexp = $isData ? '(new RegExp(' + $schemaValue + '))' : it.usePattern($schema);
  out += 'if ( ';
  if ($isData) {
    out += ' (' + ($schemaValue) + ' !== undefined && typeof ' + ($schemaValue) + ' != \'string\') || ';
  }
  out += ' !' + ($regexp) + '.test(' + ($data) + ') ) {   ';
  var $$outStack = $$outStack || [];
  $$outStack.push(out);
  out = ''; /* istanbul ignore else */
  if (it.createErrors !== false) {
    out += ' { keyword: \'' + ('pattern') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { pattern:  ';
    if ($isData) {
      out += '' + ($schemaValue);
    } else {
      out += '' + (it.util.toQuotedString($schema));
    }
    out += '  } ';
    if (it.opts.messages !== false) {
      out += ' , message: \'should match pattern "';
      if ($isData) {
        out += '\' + ' + ($schemaValue) + ' + \'';
      } else {
        out += '' + (it.util.escapeQuotes($schema));
      }
      out += '"\' ';
    }
    if (it.opts.verbose) {
      out += ' , schema:  ';
      if ($isData) {
        out += 'validate.schema' + ($schemaPath);
      } else {
        out += '' + (it.util.toQuotedString($schema));
      }
      out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
    }
    out += ' } ';
  } else {
    out += ' {} ';
  }
  var __err = out;
  out = $$outStack.pop();
  if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
    if (it.async) {
      out += ' throw new ValidationError([' + (__err) + ']); ';
    } else {
      out += ' validate.errors = [' + (__err) + ']; return false; ';
    }
  } else {
    out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
  }
  out += '} ';
  if ($breakOnError) {
    out += ' else { ';
  }
  return out;
}


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_properties(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  var $key = 'key' + $lvl,
    $idx = 'idx' + $lvl,
    $dataNxt = $it.dataLevel = it.dataLevel + 1,
    $nextData = 'data' + $dataNxt,
    $dataProperties = 'dataProperties' + $lvl;
  var $schemaKeys = Object.keys($schema || {}),
    $pProperties = it.schema.patternProperties || {},
    $pPropertyKeys = Object.keys($pProperties),
    $aProperties = it.schema.additionalProperties,
    $someProperties = $schemaKeys.length || $pPropertyKeys.length,
    $noAdditional = $aProperties === false,
    $additionalIsSchema = typeof $aProperties == 'object' && Object.keys($aProperties).length,
    $removeAdditional = it.opts.removeAdditional,
    $checkAdditional = $noAdditional || $additionalIsSchema || $removeAdditional,
    $ownProperties = it.opts.ownProperties,
    $currentBaseId = it.baseId;
  var $required = it.schema.required;
  if ($required && !(it.opts.v5 && $required.$data) && $required.length < it.opts.loopRequired) var $requiredHash = it.util.toHash($required);
  if (it.opts.patternGroups) {
    var $pgProperties = it.schema.patternGroups || {},
      $pgPropertyKeys = Object.keys($pgProperties);
  }
  out += 'var ' + ($errs) + ' = errors;var ' + ($nextValid) + ' = true;';
  if ($ownProperties) {
    out += ' var ' + ($dataProperties) + ' = undefined;';
  }
  if ($checkAdditional) {
    if ($ownProperties) {
      out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
    } else {
      out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
    }
    if ($someProperties) {
      out += ' var isAdditional' + ($lvl) + ' = !(false ';
      if ($schemaKeys.length) {
        if ($schemaKeys.length > 5) {
          out += ' || validate.schema' + ($schemaPath) + '[' + ($key) + '] ';
        } else {
          var arr1 = $schemaKeys;
          if (arr1) {
            var $propertyKey, i1 = -1,
              l1 = arr1.length - 1;
            while (i1 < l1) {
              $propertyKey = arr1[i1 += 1];
              out += ' || ' + ($key) + ' == ' + (it.util.toQuotedString($propertyKey)) + ' ';
            }
          }
        }
      }
      if ($pPropertyKeys.length) {
        var arr2 = $pPropertyKeys;
        if (arr2) {
          var $pProperty, $i = -1,
            l2 = arr2.length - 1;
          while ($i < l2) {
            $pProperty = arr2[$i += 1];
            out += ' || ' + (it.usePattern($pProperty)) + '.test(' + ($key) + ') ';
          }
        }
      }
      if (it.opts.patternGroups && $pgPropertyKeys.length) {
        var arr3 = $pgPropertyKeys;
        if (arr3) {
          var $pgProperty, $i = -1,
            l3 = arr3.length - 1;
          while ($i < l3) {
            $pgProperty = arr3[$i += 1];
            out += ' || ' + (it.usePattern($pgProperty)) + '.test(' + ($key) + ') ';
          }
        }
      }
      out += ' ); if (isAdditional' + ($lvl) + ') { ';
    }
    if ($removeAdditional == 'all') {
      out += ' delete ' + ($data) + '[' + ($key) + ']; ';
    } else {
      var $currentErrorPath = it.errorPath;
      var $additionalProperty = '\' + ' + $key + ' + \'';
      if (it.opts._errorDataPathProperty) {
        it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
      }
      if ($noAdditional) {
        if ($removeAdditional) {
          out += ' delete ' + ($data) + '[' + ($key) + ']; ';
        } else {
          out += ' ' + ($nextValid) + ' = false; ';
          var $currErrSchemaPath = $errSchemaPath;
          $errSchemaPath = it.errSchemaPath + '/additionalProperties';
          var $$outStack = $$outStack || [];
          $$outStack.push(out);
          out = ''; /* istanbul ignore else */
          if (it.createErrors !== false) {
            out += ' { keyword: \'' + ('additionalProperties') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { additionalProperty: \'' + ($additionalProperty) + '\' } ';
            if (it.opts.messages !== false) {
              out += ' , message: \'should NOT have additional properties\' ';
            }
            if (it.opts.verbose) {
              out += ' , schema: false , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
            }
            out += ' } ';
          } else {
            out += ' {} ';
          }
          var __err = out;
          out = $$outStack.pop();
          if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
            if (it.async) {
              out += ' throw new ValidationError([' + (__err) + ']); ';
            } else {
              out += ' validate.errors = [' + (__err) + ']; return false; ';
            }
          } else {
            out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
          }
          $errSchemaPath = $currErrSchemaPath;
          if ($breakOnError) {
            out += ' break; ';
          }
        }
      } else if ($additionalIsSchema) {
        if ($removeAdditional == 'failing') {
          out += ' var ' + ($errs) + ' = errors;  ';
          var $wasComposite = it.compositeRule;
          it.compositeRule = $it.compositeRule = true;
          $it.schema = $aProperties;
          $it.schemaPath = it.schemaPath + '.additionalProperties';
          $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
          $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          out += ' if (!' + ($nextValid) + ') { errors = ' + ($errs) + '; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete ' + ($data) + '[' + ($key) + ']; }  ';
          it.compositeRule = $it.compositeRule = $wasComposite;
        } else {
          $it.schema = $aProperties;
          $it.schemaPath = it.schemaPath + '.additionalProperties';
          $it.errSchemaPath = it.errSchemaPath + '/additionalProperties';
          $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          if ($breakOnError) {
            out += ' if (!' + ($nextValid) + ') break; ';
          }
        }
      }
      it.errorPath = $currentErrorPath;
    }
    if ($someProperties) {
      out += ' } ';
    }
    out += ' }  ';
    if ($breakOnError) {
      out += ' if (' + ($nextValid) + ') { ';
      $closingBraces += '}';
    }
  }
  var $useDefaults = it.opts.useDefaults && !it.compositeRule;
  if ($schemaKeys.length) {
    var arr4 = $schemaKeys;
    if (arr4) {
      var $propertyKey, i4 = -1,
        l4 = arr4.length - 1;
      while (i4 < l4) {
        $propertyKey = arr4[i4 += 1];
        var $sch = $schema[$propertyKey];
        if (it.util.schemaHasRules($sch, it.RULES.all)) {
          var $prop = it.util.getProperty($propertyKey),
            $passData = $data + $prop,
            $hasDefault = $useDefaults && $sch.default !== undefined;
          $it.schema = $sch;
          $it.schemaPath = $schemaPath + $prop;
          $it.errSchemaPath = $errSchemaPath + '/' + it.util.escapeFragment($propertyKey);
          $it.errorPath = it.util.getPath(it.errorPath, $propertyKey, it.opts.jsonPointers);
          $it.dataPathArr[$dataNxt] = it.util.toQuotedString($propertyKey);
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            $code = it.util.varReplace($code, $nextData, $passData);
            var $useData = $passData;
          } else {
            var $useData = $nextData;
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ';
          }
          if ($hasDefault) {
            out += ' ' + ($code) + ' ';
          } else {
            if ($requiredHash && $requiredHash[$propertyKey]) {
              out += ' if ( ' + ($useData) + ' === undefined ';
              if ($ownProperties) {
                out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
              }
              out += ') { ' + ($nextValid) + ' = false; ';
              var $currentErrorPath = it.errorPath,
                $currErrSchemaPath = $errSchemaPath,
                $missingProperty = it.util.escapeQuotes($propertyKey);
              if (it.opts._errorDataPathProperty) {
                it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
              }
              $errSchemaPath = it.errSchemaPath + '/required';
              var $$outStack = $$outStack || [];
              $$outStack.push(out);
              out = ''; /* istanbul ignore else */
              if (it.createErrors !== false) {
                out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
                if (it.opts.messages !== false) {
                  out += ' , message: \'';
                  if (it.opts._errorDataPathProperty) {
                    out += 'is a required property';
                  } else {
                    out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
                  }
                  out += '\' ';
                }
                if (it.opts.verbose) {
                  out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
                }
                out += ' } ';
              } else {
                out += ' {} ';
              }
              var __err = out;
              out = $$outStack.pop();
              if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
                if (it.async) {
                  out += ' throw new ValidationError([' + (__err) + ']); ';
                } else {
                  out += ' validate.errors = [' + (__err) + ']; return false; ';
                }
              } else {
                out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
              }
              $errSchemaPath = $currErrSchemaPath;
              it.errorPath = $currentErrorPath;
              out += ' } else { ';
            } else {
              if ($breakOnError) {
                out += ' if ( ' + ($useData) + ' === undefined ';
                if ($ownProperties) {
                  out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
                }
                out += ') { ' + ($nextValid) + ' = true; } else { ';
              } else {
                out += ' if (' + ($useData) + ' !== undefined ';
                if ($ownProperties) {
                  out += ' &&   Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
                }
                out += ' ) { ';
              }
            }
            out += ' ' + ($code) + ' } ';
          }
        }
        if ($breakOnError) {
          out += ' if (' + ($nextValid) + ') { ';
          $closingBraces += '}';
        }
      }
    }
  }
  if ($pPropertyKeys.length) {
    var arr5 = $pPropertyKeys;
    if (arr5) {
      var $pProperty, i5 = -1,
        l5 = arr5.length - 1;
      while (i5 < l5) {
        $pProperty = arr5[i5 += 1];
        var $sch = $pProperties[$pProperty];
        if (it.util.schemaHasRules($sch, it.RULES.all)) {
          $it.schema = $sch;
          $it.schemaPath = it.schemaPath + '.patternProperties' + it.util.getProperty($pProperty);
          $it.errSchemaPath = it.errSchemaPath + '/patternProperties/' + it.util.escapeFragment($pProperty);
          if ($ownProperties) {
            out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
          } else {
            out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
          }
          out += ' if (' + (it.usePattern($pProperty)) + '.test(' + ($key) + ')) { ';
          $it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          if ($breakOnError) {
            out += ' if (!' + ($nextValid) + ') break; ';
          }
          out += ' } ';
          if ($breakOnError) {
            out += ' else ' + ($nextValid) + ' = true; ';
          }
          out += ' }  ';
          if ($breakOnError) {
            out += ' if (' + ($nextValid) + ') { ';
            $closingBraces += '}';
          }
        }
      }
    }
  }
  if (it.opts.patternGroups && $pgPropertyKeys.length) {
    var arr6 = $pgPropertyKeys;
    if (arr6) {
      var $pgProperty, i6 = -1,
        l6 = arr6.length - 1;
      while (i6 < l6) {
        $pgProperty = arr6[i6 += 1];
        var $pgSchema = $pgProperties[$pgProperty],
          $sch = $pgSchema.schema;
        if (it.util.schemaHasRules($sch, it.RULES.all)) {
          $it.schema = $sch;
          $it.schemaPath = it.schemaPath + '.patternGroups' + it.util.getProperty($pgProperty) + '.schema';
          $it.errSchemaPath = it.errSchemaPath + '/patternGroups/' + it.util.escapeFragment($pgProperty) + '/schema';
          out += ' var pgPropCount' + ($lvl) + ' = 0;  ';
          if ($ownProperties) {
            out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
          } else {
            out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
          }
          out += ' if (' + (it.usePattern($pgProperty)) + '.test(' + ($key) + ')) { pgPropCount' + ($lvl) + '++; ';
          $it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
          var $passData = $data + '[' + $key + ']';
          $it.dataPathArr[$dataNxt] = $key;
          var $code = it.validate($it);
          $it.baseId = $currentBaseId;
          if (it.util.varOccurences($code, $nextData) < 2) {
            out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
          } else {
            out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
          }
          if ($breakOnError) {
            out += ' if (!' + ($nextValid) + ') break; ';
          }
          out += ' } ';
          if ($breakOnError) {
            out += ' else ' + ($nextValid) + ' = true; ';
          }
          out += ' }  ';
          if ($breakOnError) {
            out += ' if (' + ($nextValid) + ') { ';
            $closingBraces += '}';
          }
          var $pgMin = $pgSchema.minimum,
            $pgMax = $pgSchema.maximum;
          if ($pgMin !== undefined || $pgMax !== undefined) {
            out += ' var ' + ($valid) + ' = true; ';
            var $currErrSchemaPath = $errSchemaPath;
            if ($pgMin !== undefined) {
              var $limit = $pgMin,
                $reason = 'minimum',
                $moreOrLess = 'less';
              out += ' ' + ($valid) + ' = pgPropCount' + ($lvl) + ' >= ' + ($pgMin) + '; ';
              $errSchemaPath = it.errSchemaPath + '/patternGroups/minimum';
              out += '  if (!' + ($valid) + ') {   ';
              var $$outStack = $$outStack || [];
              $$outStack.push(out);
              out = ''; /* istanbul ignore else */
              if (it.createErrors !== false) {
                out += ' { keyword: \'' + ('patternGroups') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { reason: \'' + ($reason) + '\', limit: ' + ($limit) + ', pattern: \'' + (it.util.escapeQuotes($pgProperty)) + '\' } ';
                if (it.opts.messages !== false) {
                  out += ' , message: \'should NOT have ' + ($moreOrLess) + ' than ' + ($limit) + ' properties matching pattern "' + (it.util.escapeQuotes($pgProperty)) + '"\' ';
                }
                if (it.opts.verbose) {
                  out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
                }
                out += ' } ';
              } else {
                out += ' {} ';
              }
              var __err = out;
              out = $$outStack.pop();
              if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
                if (it.async) {
                  out += ' throw new ValidationError([' + (__err) + ']); ';
                } else {
                  out += ' validate.errors = [' + (__err) + ']; return false; ';
                }
              } else {
                out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
              }
              out += ' } ';
              if ($pgMax !== undefined) {
                out += ' else ';
              }
            }
            if ($pgMax !== undefined) {
              var $limit = $pgMax,
                $reason = 'maximum',
                $moreOrLess = 'more';
              out += ' ' + ($valid) + ' = pgPropCount' + ($lvl) + ' <= ' + ($pgMax) + '; ';
              $errSchemaPath = it.errSchemaPath + '/patternGroups/maximum';
              out += '  if (!' + ($valid) + ') {   ';
              var $$outStack = $$outStack || [];
              $$outStack.push(out);
              out = ''; /* istanbul ignore else */
              if (it.createErrors !== false) {
                out += ' { keyword: \'' + ('patternGroups') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { reason: \'' + ($reason) + '\', limit: ' + ($limit) + ', pattern: \'' + (it.util.escapeQuotes($pgProperty)) + '\' } ';
                if (it.opts.messages !== false) {
                  out += ' , message: \'should NOT have ' + ($moreOrLess) + ' than ' + ($limit) + ' properties matching pattern "' + (it.util.escapeQuotes($pgProperty)) + '"\' ';
                }
                if (it.opts.verbose) {
                  out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
                }
                out += ' } ';
              } else {
                out += ' {} ';
              }
              var __err = out;
              out = $$outStack.pop();
              if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
                if (it.async) {
                  out += ' throw new ValidationError([' + (__err) + ']); ';
                } else {
                  out += ' validate.errors = [' + (__err) + ']; return false; ';
                }
              } else {
                out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
              }
              out += ' } ';
            }
            $errSchemaPath = $currErrSchemaPath;
            if ($breakOnError) {
              out += ' if (' + ($valid) + ') { ';
              $closingBraces += '}';
            }
          }
        }
      }
    }
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  out = it.util.cleanUpCode(out);
  return out;
}


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_propertyNames(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $errs = 'errs__' + $lvl;
  var $it = it.util.copy(it);
  var $closingBraces = '';
  $it.level++;
  var $nextValid = 'valid' + $it.level;
  if (it.util.schemaHasRules($schema, it.RULES.all)) {
    $it.schema = $schema;
    $it.schemaPath = $schemaPath;
    $it.errSchemaPath = $errSchemaPath;
    var $key = 'key' + $lvl,
      $idx = 'idx' + $lvl,
      $i = 'i' + $lvl,
      $invalidName = '\' + ' + $key + ' + \'',
      $dataNxt = $it.dataLevel = it.dataLevel + 1,
      $nextData = 'data' + $dataNxt,
      $dataProperties = 'dataProperties' + $lvl,
      $ownProperties = it.opts.ownProperties,
      $currentBaseId = it.baseId;
    out += ' var ' + ($errs) + ' = errors; ';
    if ($ownProperties) {
      out += ' var ' + ($dataProperties) + ' = undefined; ';
    }
    if ($ownProperties) {
      out += ' ' + ($dataProperties) + ' = ' + ($dataProperties) + ' || Object.keys(' + ($data) + '); for (var ' + ($idx) + '=0; ' + ($idx) + '<' + ($dataProperties) + '.length; ' + ($idx) + '++) { var ' + ($key) + ' = ' + ($dataProperties) + '[' + ($idx) + ']; ';
    } else {
      out += ' for (var ' + ($key) + ' in ' + ($data) + ') { ';
    }
    out += ' var startErrs' + ($lvl) + ' = errors; ';
    var $passData = $key;
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var $code = it.validate($it);
    $it.baseId = $currentBaseId;
    if (it.util.varOccurences($code, $nextData) < 2) {
      out += ' ' + (it.util.varReplace($code, $nextData, $passData)) + ' ';
    } else {
      out += ' var ' + ($nextData) + ' = ' + ($passData) + '; ' + ($code) + ' ';
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' if (!' + ($nextValid) + ') { for (var ' + ($i) + '=startErrs' + ($lvl) + '; ' + ($i) + '<errors; ' + ($i) + '++) { vErrors[' + ($i) + '].propertyName = ' + ($key) + '; }   var err =   '; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('propertyNames') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { propertyName: \'' + ($invalidName) + '\' } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'property name \\\'' + ($invalidName) + '\\\' is invalid\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError(vErrors); ';
      } else {
        out += ' validate.errors = vErrors; return false; ';
      }
    }
    if ($breakOnError) {
      out += ' break; ';
    }
    out += ' } }';
  }
  if ($breakOnError) {
    out += ' ' + ($closingBraces) + ' if (' + ($errs) + ' == errors) {';
  }
  out = it.util.cleanUpCode(out);
  return out;
}


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_required(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $vSchema = 'schema' + $lvl;
  if (!$isData) {
    if ($schema.length < it.opts.loopRequired && it.schema.properties && Object.keys(it.schema.properties).length) {
      var $required = [];
      var arr1 = $schema;
      if (arr1) {
        var $property, i1 = -1,
          l1 = arr1.length - 1;
        while (i1 < l1) {
          $property = arr1[i1 += 1];
          var $propertySch = it.schema.properties[$property];
          if (!($propertySch && it.util.schemaHasRules($propertySch, it.RULES.all))) {
            $required[$required.length] = $property;
          }
        }
      }
    } else {
      var $required = $schema;
    }
  }
  if ($isData || $required.length) {
    var $currentErrorPath = it.errorPath,
      $loopRequired = $isData || $required.length >= it.opts.loopRequired,
      $ownProperties = it.opts.ownProperties;
    if ($breakOnError) {
      out += ' var missing' + ($lvl) + '; ';
      if ($loopRequired) {
        if (!$isData) {
          out += ' var ' + ($vSchema) + ' = validate.schema' + ($schemaPath) + '; ';
        }
        var $i = 'i' + $lvl,
          $propertyPath = 'schema' + $lvl + '[' + $i + ']',
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
        }
        out += ' var ' + ($valid) + ' = true; ';
        if ($isData) {
          out += ' if (schema' + ($lvl) + ' === undefined) ' + ($valid) + ' = true; else if (!Array.isArray(schema' + ($lvl) + ')) ' + ($valid) + ' = false; else {';
        }
        out += ' for (var ' + ($i) + ' = 0; ' + ($i) + ' < ' + ($vSchema) + '.length; ' + ($i) + '++) { ' + ($valid) + ' = ' + ($data) + '[' + ($vSchema) + '[' + ($i) + ']] !== undefined ';
        if ($ownProperties) {
          out += ' &&   Object.prototype.hasOwnProperty.call(' + ($data) + ', ' + ($vSchema) + '[' + ($i) + ']) ';
        }
        out += '; if (!' + ($valid) + ') break; } ';
        if ($isData) {
          out += '  }  ';
        }
        out += '  if (!' + ($valid) + ') {   ';
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'';
            if (it.opts._errorDataPathProperty) {
              out += 'is a required property';
            } else {
              out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        out += ' } else { ';
      } else {
        out += ' if ( ';
        var arr2 = $required;
        if (arr2) {
          var $propertyKey, $i = -1,
            l2 = arr2.length - 1;
          while ($i < l2) {
            $propertyKey = arr2[$i += 1];
            if ($i) {
              out += ' || ';
            }
            var $prop = it.util.getProperty($propertyKey),
              $useData = $data + $prop;
            out += ' ( ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') && (missing' + ($lvl) + ' = ' + (it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop)) + ') ) ';
          }
        }
        out += ') {  ';
        var $propertyPath = 'missing' + $lvl,
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + ' + ' + $propertyPath;
        }
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ''; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'';
            if (it.opts._errorDataPathProperty) {
              out += 'is a required property';
            } else {
              out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
          if (it.async) {
            out += ' throw new ValidationError([' + (__err) + ']); ';
          } else {
            out += ' validate.errors = [' + (__err) + ']; return false; ';
          }
        } else {
          out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
        }
        out += ' } else { ';
      }
    } else {
      if ($loopRequired) {
        if (!$isData) {
          out += ' var ' + ($vSchema) + ' = validate.schema' + ($schemaPath) + '; ';
        }
        var $i = 'i' + $lvl,
          $propertyPath = 'schema' + $lvl + '[' + $i + ']',
          $missingProperty = '\' + ' + $propertyPath + ' + \'';
        if (it.opts._errorDataPathProperty) {
          it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
        }
        if ($isData) {
          out += ' if (' + ($vSchema) + ' && !Array.isArray(' + ($vSchema) + ')) {  var err =   '; /* istanbul ignore else */
          if (it.createErrors !== false) {
            out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
            if (it.opts.messages !== false) {
              out += ' , message: \'';
              if (it.opts._errorDataPathProperty) {
                out += 'is a required property';
              } else {
                out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
              }
              out += '\' ';
            }
            if (it.opts.verbose) {
              out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
            }
            out += ' } ';
          } else {
            out += ' {} ';
          }
          out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (' + ($vSchema) + ' !== undefined) { ';
        }
        out += ' for (var ' + ($i) + ' = 0; ' + ($i) + ' < ' + ($vSchema) + '.length; ' + ($i) + '++) { if (' + ($data) + '[' + ($vSchema) + '[' + ($i) + ']] === undefined ';
        if ($ownProperties) {
          out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', ' + ($vSchema) + '[' + ($i) + ']) ';
        }
        out += ') {  var err =   '; /* istanbul ignore else */
        if (it.createErrors !== false) {
          out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
          if (it.opts.messages !== false) {
            out += ' , message: \'';
            if (it.opts._errorDataPathProperty) {
              out += 'is a required property';
            } else {
              out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
            }
            out += '\' ';
          }
          if (it.opts.verbose) {
            out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
          }
          out += ' } ';
        } else {
          out += ' {} ';
        }
        out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ';
        if ($isData) {
          out += '  }  ';
        }
      } else {
        var arr3 = $required;
        if (arr3) {
          var $propertyKey, i3 = -1,
            l3 = arr3.length - 1;
          while (i3 < l3) {
            $propertyKey = arr3[i3 += 1];
            var $prop = it.util.getProperty($propertyKey),
              $missingProperty = it.util.escapeQuotes($propertyKey),
              $useData = $data + $prop;
            if (it.opts._errorDataPathProperty) {
              it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
            }
            out += ' if ( ' + ($useData) + ' === undefined ';
            if ($ownProperties) {
              out += ' || ! Object.prototype.hasOwnProperty.call(' + ($data) + ', \'' + (it.util.escapeQuotes($propertyKey)) + '\') ';
            }
            out += ') {  var err =   '; /* istanbul ignore else */
            if (it.createErrors !== false) {
              out += ' { keyword: \'' + ('required') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { missingProperty: \'' + ($missingProperty) + '\' } ';
              if (it.opts.messages !== false) {
                out += ' , message: \'';
                if (it.opts._errorDataPathProperty) {
                  out += 'is a required property';
                } else {
                  out += 'should have required property \\\'' + ($missingProperty) + '\\\'';
                }
                out += '\' ';
              }
              if (it.opts.verbose) {
                out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
              }
              out += ' } ';
            } else {
              out += ' {} ';
            }
            out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ';
          }
        }
      }
    }
    it.errorPath = $currentErrorPath;
  } else if ($breakOnError) {
    out += ' if (true) {';
  }
  return out;
}


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_uniqueItems(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  if (($schema || $isData) && it.opts.uniqueItems !== false) {
    if ($isData) {
      out += ' var ' + ($valid) + '; if (' + ($schemaValue) + ' === false || ' + ($schemaValue) + ' === undefined) ' + ($valid) + ' = true; else if (typeof ' + ($schemaValue) + ' != \'boolean\') ' + ($valid) + ' = false; else { ';
    }
    out += ' var ' + ($valid) + ' = true; if (' + ($data) + '.length > 1) { var i = ' + ($data) + '.length, j; outer: for (;i--;) { for (j = i; j--;) { if (equal(' + ($data) + '[i], ' + ($data) + '[j])) { ' + ($valid) + ' = false; break outer; } } } } ';
    if ($isData) {
      out += '  }  ';
    }
    out += ' if (!' + ($valid) + ') {   ';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ('uniqueItems') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { i: i, j: j } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should NOT have duplicate items (items ## \' + j + \' and \' + i + \' are identical)\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema:  ';
        if ($isData) {
          out += 'validate.schema' + ($schemaPath);
        } else {
          out += '' + ($schema);
        }
        out += '         , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    out += ' } ';
    if ($breakOnError) {
      out += ' else { ';
    }
  } else {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  }
  return out;
}


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var KEYWORDS = [
  'multipleOf',
  'maximum',
  'exclusiveMaximum',
  'minimum',
  'exclusiveMinimum',
  'maxLength',
  'minLength',
  'pattern',
  'additionalItems',
  'maxItems',
  'minItems',
  'uniqueItems',
  'maxProperties',
  'minProperties',
  'required',
  'additionalProperties',
  'enum',
  'format',
  'const'
];

module.exports = function (metaSchema, keywordsJsonPointers) {
  for (var i=0; i<keywordsJsonPointers.length; i++) {
    metaSchema = JSON.parse(JSON.stringify(metaSchema));
    var segments = keywordsJsonPointers[i].split('/');
    var keywords = metaSchema;
    var j;
    for (j=1; j<segments.length; j++)
      keywords = keywords[segments[j]];

    for (j=0; j<KEYWORDS.length; j++) {
      var key = KEYWORDS[j];
      var schema = keywords[key];
      if (schema) {
        keywords[key] = {
          anyOf: [
            schema,
            { $ref: 'https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/$data.json#' }
          ]
        };
      }
    }
  }

  return metaSchema;
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var META_SCHEMA_ID = 'http://json-schema.org/draft-06/schema';

module.exports = function (ajv) {
  var defaultMeta = ajv._opts.defaultMeta;
  var metaSchemaRef = typeof defaultMeta == 'string'
                      ? { $ref: defaultMeta }
                      : ajv.getSchema(META_SCHEMA_ID)
                        ? { $ref: META_SCHEMA_ID }
                        : {};

  ajv.addKeyword('patternGroups', {
    // implemented in properties.jst
    metaSchema: {
      type: 'object',
      additionalProperties: {
        type: 'object',
        required: [ 'schema' ],
        properties: {
          maximum: {
            type: 'integer',
            minimum: 0
          },
          minimum: {
            type: 'integer',
            minimum: 0
          },
          schema: metaSchemaRef
        },
        additionalProperties: false
      }
    }
  });
  ajv.RULES.all.properties.implements.push('patternGroups');
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MissingRefError = __webpack_require__(85).MissingRef;

module.exports = compileAsync;


/**
 * Creates validating function for passed schema with asynchronous loading of missing schemas.
 * `loadSchema` option should be a function that accepts schema uri and returns promise that resolves with the schema.
 * @this  Ajv
 * @param {Object}   schema schema object
 * @param {Boolean}  meta optional true to compile meta-schema; this parameter can be skipped
 * @param {Function} callback an optional node-style callback, it is called with 2 parameters: error (or null) and validating function.
 * @return {Promise} promise that resolves with a validating function.
 */
function compileAsync(schema, meta, callback) {
  /* eslint no-shadow: 0 */
  /* global Promise */
  /* jshint validthis: true */
  var self = this;
  if (typeof this._opts.loadSchema != 'function')
    throw new Error('options.loadSchema should be a function');

  if (typeof meta == 'function') {
    callback = meta;
    meta = undefined;
  }

  var p = loadMetaSchemaOf(schema).then(function () {
    var schemaObj = self._addSchema(schema, undefined, meta);
    return schemaObj.validate || _compileAsync(schemaObj);
  });

  if (callback) {
    p.then(
      function(v) { callback(null, v); },
      callback
    );
  }

  return p;


  function loadMetaSchemaOf(sch) {
    var $schema = sch.$schema;
    return $schema && !self.getSchema($schema)
            ? compileAsync.call(self, { $ref: $schema }, true)
            : Promise.resolve();
  }


  function _compileAsync(schemaObj) {
    try { return self._compile(schemaObj); }
    catch(e) {
      if (e instanceof MissingRefError) return loadMissingSchema(e);
      throw e;
    }


    function loadMissingSchema(e) {
      var ref = e.missingSchema;
      if (added(ref)) throw new Error('Schema ' + ref + ' is loaded but ' + e.missingRef + ' cannot be resolved');

      var schemaPromise = self._loadingSchemas[ref];
      if (!schemaPromise) {
        schemaPromise = self._loadingSchemas[ref] = self._opts.loadSchema(ref);
        schemaPromise.then(removePromise, removePromise);
      }

      return schemaPromise.then(function (sch) {
        if (!added(ref)) {
          return loadMetaSchemaOf(sch).then(function () {
            if (!added(ref)) self.addSchema(sch, ref, undefined, meta);
          });
        }
      }).then(function() {
        return _compileAsync(schemaObj);
      });

      function removePromise() {
        delete self._loadingSchemas[ref];
      }

      function added(ref) {
        return self._refs[ref] || self._schemas[ref];
      }
    }
  }
}


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var IDENTIFIER = /^[a-z_$][a-z0-9_$-]*$/i;
var customRuleCode = __webpack_require__(340);

module.exports = {
  add: addKeyword,
  get: getKeyword,
  remove: removeKeyword
};

/**
 * Define custom keyword
 * @this  Ajv
 * @param {String} keyword custom keyword, should be unique (including different from all standard, custom and macro keywords).
 * @param {Object} definition keyword definition object with properties `type` (type(s) which the keyword applies to), `validate` or `compile`.
 * @return {Ajv} this for method chaining
 */
function addKeyword(keyword, definition) {
  /* jshint validthis: true */
  /* eslint no-shadow: 0 */
  var RULES = this.RULES;

  if (RULES.keywords[keyword])
    throw new Error('Keyword ' + keyword + ' is already defined');

  if (!IDENTIFIER.test(keyword))
    throw new Error('Keyword ' + keyword + ' is not a valid identifier');

  if (definition) {
    if (definition.macro && definition.valid !== undefined)
      throw new Error('"valid" option cannot be used with macro keywords');

    var dataType = definition.type;
    if (Array.isArray(dataType)) {
      var i, len = dataType.length;
      for (i=0; i<len; i++) checkDataType(dataType[i]);
      for (i=0; i<len; i++) _addRule(keyword, dataType[i], definition);
    } else {
      if (dataType) checkDataType(dataType);
      _addRule(keyword, dataType, definition);
    }

    var $data = definition.$data === true && this._opts.$data;
    if ($data && !definition.validate)
      throw new Error('$data support: "validate" function is not defined');

    var metaSchema = definition.metaSchema;
    if (metaSchema) {
      if ($data) {
        metaSchema = {
          anyOf: [
            metaSchema,
            { '$ref': 'https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/$data.json#' }
          ]
        };
      }
      definition.validateSchema = this.compile(metaSchema, true);
    }
  }

  RULES.keywords[keyword] = RULES.all[keyword] = true;


  function _addRule(keyword, dataType, definition) {
    var ruleGroup;
    for (var i=0; i<RULES.length; i++) {
      var rg = RULES[i];
      if (rg.type == dataType) {
        ruleGroup = rg;
        break;
      }
    }

    if (!ruleGroup) {
      ruleGroup = { type: dataType, rules: [] };
      RULES.push(ruleGroup);
    }

    var rule = {
      keyword: keyword,
      definition: definition,
      custom: true,
      code: customRuleCode,
      implements: definition.implements
    };
    ruleGroup.rules.push(rule);
    RULES.custom[keyword] = rule;
  }


  function checkDataType(dataType) {
    if (!RULES.types[dataType]) throw new Error('Unknown type ' + dataType);
  }

  return this;
}


/**
 * Get keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Object|Boolean} custom keyword definition, `true` if it is a predefined keyword, `false` otherwise.
 */
function getKeyword(keyword) {
  /* jshint validthis: true */
  var rule = this.RULES.custom[keyword];
  return rule ? rule.definition : this.RULES.keywords[keyword] || false;
}


/**
 * Remove keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Ajv} this for method chaining
 */
function removeKeyword(keyword) {
  /* jshint validthis: true */
  var RULES = this.RULES;
  delete RULES.keywords[keyword];
  delete RULES.all[keyword];
  delete RULES.custom[keyword];
  for (var i=0; i<RULES.length; i++) {
    var rules = RULES[i].rules;
    for (var j=0; j<rules.length; j++) {
      if (rules[j].keyword == keyword) {
        rules.splice(j, 1);
        break;
      }
    }
  }
  return this;
}


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function generate_custom(it, $keyword, $ruleType) {
  var out = ' ';
  var $lvl = it.level;
  var $dataLvl = it.dataLevel;
  var $schema = it.schema[$keyword];
  var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
  var $errSchemaPath = it.errSchemaPath + '/' + $keyword;
  var $breakOnError = !it.opts.allErrors;
  var $errorKeyword;
  var $data = 'data' + ($dataLvl || '');
  var $valid = 'valid' + $lvl;
  var $errs = 'errs__' + $lvl;
  var $isData = it.opts.$data && $schema && $schema.$data,
    $schemaValue;
  if ($isData) {
    out += ' var schema' + ($lvl) + ' = ' + (it.util.getData($schema.$data, $dataLvl, it.dataPathArr)) + '; ';
    $schemaValue = 'schema' + $lvl;
  } else {
    $schemaValue = $schema;
  }
  var $rule = this,
    $definition = 'definition' + $lvl,
    $rDef = $rule.definition,
    $closingBraces = '';
  var $compile, $inline, $macro, $ruleValidate, $validateCode;
  if ($isData && $rDef.$data) {
    $validateCode = 'keywordValidate' + $lvl;
    var $validateSchema = $rDef.validateSchema;
    out += ' var ' + ($definition) + ' = RULES.custom[\'' + ($keyword) + '\'].definition; var ' + ($validateCode) + ' = ' + ($definition) + '.validate;';
  } else {
    $ruleValidate = it.useCustomRule($rule, $schema, it.schema, it);
    if (!$ruleValidate) return;
    $schemaValue = 'validate.schema' + $schemaPath;
    $validateCode = $ruleValidate.code;
    $compile = $rDef.compile;
    $inline = $rDef.inline;
    $macro = $rDef.macro;
  }
  var $ruleErrs = $validateCode + '.errors',
    $i = 'i' + $lvl,
    $ruleErr = 'ruleErr' + $lvl,
    $asyncKeyword = $rDef.async;
  if ($asyncKeyword && !it.async) throw new Error('async keyword in sync schema');
  if (!($inline || $macro)) {
    out += '' + ($ruleErrs) + ' = null;';
  }
  out += 'var ' + ($errs) + ' = errors;var ' + ($valid) + ';';
  if ($isData && $rDef.$data) {
    $closingBraces += '}';
    out += ' if (' + ($schemaValue) + ' === undefined) { ' + ($valid) + ' = true; } else { ';
    if ($validateSchema) {
      $closingBraces += '}';
      out += ' ' + ($valid) + ' = ' + ($definition) + '.validateSchema(' + ($schemaValue) + '); if (' + ($valid) + ') { ';
    }
  }
  if ($inline) {
    if ($rDef.statements) {
      out += ' ' + ($ruleValidate.validate) + ' ';
    } else {
      out += ' ' + ($valid) + ' = ' + ($ruleValidate.validate) + '; ';
    }
  } else if ($macro) {
    var $it = it.util.copy(it);
    var $closingBraces = '';
    $it.level++;
    var $nextValid = 'valid' + $it.level;
    $it.schema = $ruleValidate.validate;
    $it.schemaPath = '';
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var $code = it.validate($it).replace(/validate\.schema/g, $validateCode);
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += ' ' + ($code);
  } else {
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = '';
    out += '  ' + ($validateCode) + '.call( ';
    if (it.opts.passContext) {
      out += 'this';
    } else {
      out += 'self';
    }
    if ($compile || $rDef.schema === false) {
      out += ' , ' + ($data) + ' ';
    } else {
      out += ' , ' + ($schemaValue) + ' , ' + ($data) + ' , validate.schema' + (it.schemaPath) + ' ';
    }
    out += ' , (dataPath || \'\')';
    if (it.errorPath != '""') {
      out += ' + ' + (it.errorPath);
    }
    var $parentData = $dataLvl ? 'data' + (($dataLvl - 1) || '') : 'parentData',
      $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : 'parentDataProperty';
    out += ' , ' + ($parentData) + ' , ' + ($parentDataProperty) + ' , rootData )  ';
    var def_callRuleValidate = out;
    out = $$outStack.pop();
    if ($rDef.errors === false) {
      out += ' ' + ($valid) + ' = ';
      if ($asyncKeyword) {
        out += '' + (it.yieldAwait);
      }
      out += '' + (def_callRuleValidate) + '; ';
    } else {
      if ($asyncKeyword) {
        $ruleErrs = 'customErrors' + $lvl;
        out += ' var ' + ($ruleErrs) + ' = null; try { ' + ($valid) + ' = ' + (it.yieldAwait) + (def_callRuleValidate) + '; } catch (e) { ' + ($valid) + ' = false; if (e instanceof ValidationError) ' + ($ruleErrs) + ' = e.errors; else throw e; } ';
      } else {
        out += ' ' + ($ruleErrs) + ' = null; ' + ($valid) + ' = ' + (def_callRuleValidate) + '; ';
      }
    }
  }
  if ($rDef.modifying) {
    out += ' if (' + ($parentData) + ') ' + ($data) + ' = ' + ($parentData) + '[' + ($parentDataProperty) + '];';
  }
  out += '' + ($closingBraces);
  if ($rDef.valid) {
    if ($breakOnError) {
      out += ' if (true) { ';
    }
  } else {
    out += ' if ( ';
    if ($rDef.valid === undefined) {
      out += ' !';
      if ($macro) {
        out += '' + ($nextValid);
      } else {
        out += '' + ($valid);
      }
    } else {
      out += ' ' + (!$rDef.valid) + ' ';
    }
    out += ') { ';
    $errorKeyword = $rule.keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = '';
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ''; /* istanbul ignore else */
    if (it.createErrors !== false) {
      out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { keyword: \'' + ($rule.keyword) + '\' } ';
      if (it.opts.messages !== false) {
        out += ' , message: \'should pass "' + ($rule.keyword) + '" keyword validation\' ';
      }
      if (it.opts.verbose) {
        out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
      }
      out += ' } ';
    } else {
      out += ' {} ';
    }
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
      if (it.async) {
        out += ' throw new ValidationError([' + (__err) + ']); ';
      } else {
        out += ' validate.errors = [' + (__err) + ']; return false; ';
      }
    } else {
      out += ' var err = ' + (__err) + ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
    }
    var def_customError = out;
    out = $$outStack.pop();
    if ($inline) {
      if ($rDef.errors) {
        if ($rDef.errors != 'full') {
          out += '  for (var ' + ($i) + '=' + ($errs) + '; ' + ($i) + '<errors; ' + ($i) + '++) { var ' + ($ruleErr) + ' = vErrors[' + ($i) + ']; if (' + ($ruleErr) + '.dataPath === undefined) ' + ($ruleErr) + '.dataPath = (dataPath || \'\') + ' + (it.errorPath) + '; if (' + ($ruleErr) + '.schemaPath === undefined) { ' + ($ruleErr) + '.schemaPath = "' + ($errSchemaPath) + '"; } ';
          if (it.opts.verbose) {
            out += ' ' + ($ruleErr) + '.schema = ' + ($schemaValue) + '; ' + ($ruleErr) + '.data = ' + ($data) + '; ';
          }
          out += ' } ';
        }
      } else {
        if ($rDef.errors === false) {
          out += ' ' + (def_customError) + ' ';
        } else {
          out += ' if (' + ($errs) + ' == errors) { ' + (def_customError) + ' } else {  for (var ' + ($i) + '=' + ($errs) + '; ' + ($i) + '<errors; ' + ($i) + '++) { var ' + ($ruleErr) + ' = vErrors[' + ($i) + ']; if (' + ($ruleErr) + '.dataPath === undefined) ' + ($ruleErr) + '.dataPath = (dataPath || \'\') + ' + (it.errorPath) + '; if (' + ($ruleErr) + '.schemaPath === undefined) { ' + ($ruleErr) + '.schemaPath = "' + ($errSchemaPath) + '"; } ';
          if (it.opts.verbose) {
            out += ' ' + ($ruleErr) + '.schema = ' + ($schemaValue) + '; ' + ($ruleErr) + '.data = ' + ($data) + '; ';
          }
          out += ' } } ';
        }
      }
    } else if ($macro) {
      out += '   var err =   '; /* istanbul ignore else */
      if (it.createErrors !== false) {
        out += ' { keyword: \'' + ($errorKeyword || 'custom') + '\' , dataPath: (dataPath || \'\') + ' + (it.errorPath) + ' , schemaPath: ' + (it.util.toQuotedString($errSchemaPath)) + ' , params: { keyword: \'' + ($rule.keyword) + '\' } ';
        if (it.opts.messages !== false) {
          out += ' , message: \'should pass "' + ($rule.keyword) + '" keyword validation\' ';
        }
        if (it.opts.verbose) {
          out += ' , schema: validate.schema' + ($schemaPath) + ' , parentSchema: validate.schema' + (it.schemaPath) + ' , data: ' + ($data) + ' ';
        }
        out += ' } ';
      } else {
        out += ' {} ';
      }
      out += ';  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ';
      if (!it.compositeRule && $breakOnError) { /* istanbul ignore if */
        if (it.async) {
          out += ' throw new ValidationError(vErrors); ';
        } else {
          out += ' validate.errors = vErrors; return false; ';
        }
      }
    } else {
      if ($rDef.errors === false) {
        out += ' ' + (def_customError) + ' ';
      } else {
        out += ' if (Array.isArray(' + ($ruleErrs) + ')) { if (vErrors === null) vErrors = ' + ($ruleErrs) + '; else vErrors = vErrors.concat(' + ($ruleErrs) + '); errors = vErrors.length;  for (var ' + ($i) + '=' + ($errs) + '; ' + ($i) + '<errors; ' + ($i) + '++) { var ' + ($ruleErr) + ' = vErrors[' + ($i) + ']; if (' + ($ruleErr) + '.dataPath === undefined) ' + ($ruleErr) + '.dataPath = (dataPath || \'\') + ' + (it.errorPath) + ';  ' + ($ruleErr) + '.schemaPath = "' + ($errSchemaPath) + '";  ';
        if (it.opts.verbose) {
          out += ' ' + ($ruleErr) + '.schema = ' + ($schemaValue) + '; ' + ($ruleErr) + '.data = ' + ($data) + '; ';
        }
        out += ' } } else { ' + (def_customError) + ' } ';
      }
    }
    out += ' } ';
    if ($breakOnError) {
      out += ' else { ';
    }
  }
  return out;
}


/***/ }),
/* 341 */
/***/ (function(module, exports) {

module.exports = {"$schema":"http://json-schema.org/draft-06/schema#","$id":"https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/$data.json#","description":"Meta-schema for $data reference (JSON-schema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports = {"$schema":"http://json-schema.org/draft-06/schema#","$id":"http://json-schema.org/draft-06/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"examples":{"type":"array","items":{}},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":{},"enum":{"type":"array","minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":{}}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

function HARError (errors) {
  var message = 'validation failed'

  this.name = 'HARError'
  this.message = message
  this.errors = errors

  if (typeof Error.captureStackTrace === 'function') {
    Error.captureStackTrace(this, this.constructor)
  } else {
    this.stack = (new Error(message)).stack
  }
}

HARError.prototype = Error.prototype

module.exports = HARError


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  afterRequest: __webpack_require__(345),
  beforeRequest: __webpack_require__(346),
  browser: __webpack_require__(347),
  cache: __webpack_require__(348),
  content: __webpack_require__(349),
  cookie: __webpack_require__(350),
  creator: __webpack_require__(351),
  entry: __webpack_require__(352),
  har: __webpack_require__(353),
  header: __webpack_require__(354),
  log: __webpack_require__(355),
  page: __webpack_require__(356),
  pageTimings: __webpack_require__(357),
  postData: __webpack_require__(358),
  query: __webpack_require__(359),
  request: __webpack_require__(360),
  response: __webpack_require__(361),
  timings: __webpack_require__(362)
}


/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = {"$id":"afterRequest.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["lastAccess","eTag","hitCount"],"properties":{"expires":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"lastAccess":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"eTag":{"type":"string"},"hitCount":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

module.exports = {"$id":"beforeRequest.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["lastAccess","eTag","hitCount"],"properties":{"expires":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"lastAccess":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"eTag":{"type":"string"},"hitCount":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = {"$id":"browser.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","version"],"properties":{"name":{"type":"string"},"version":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = {"$id":"cache.json#","$schema":"http://json-schema.org/draft-06/schema#","properties":{"beforeRequest":{"oneOf":[{"type":"null"},{"$ref":"beforeRequest.json#"}]},"afterRequest":{"oneOf":[{"type":"null"},{"$ref":"afterRequest.json#"}]},"comment":{"type":"string"}}}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports = {"$id":"content.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["size","mimeType"],"properties":{"size":{"type":"integer"},"compression":{"type":"integer"},"mimeType":{"type":"string"},"text":{"type":"string"},"encoding":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

module.exports = {"$id":"cookie.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"path":{"type":"string"},"domain":{"type":"string"},"expires":{"type":["string","null"],"format":"date-time"},"httpOnly":{"type":"boolean"},"secure":{"type":"boolean"},"comment":{"type":"string"}}}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports = {"$id":"creator.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","version"],"properties":{"name":{"type":"string"},"version":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports = {"$id":"entry.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["startedDateTime","time","request","response","cache","timings"],"properties":{"pageref":{"type":"string"},"startedDateTime":{"type":"string","format":"date-time","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))"},"time":{"type":"number","min":0},"request":{"$ref":"request.json#"},"response":{"$ref":"response.json#"},"cache":{"$ref":"cache.json#"},"timings":{"$ref":"timings.json#"},"serverIPAddress":{"type":"string","oneOf":[{"format":"ipv4"},{"format":"ipv6"}]},"connection":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = {"$id":"har.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["log"],"properties":{"log":{"$ref":"log.json#"}}}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports = {"$id":"header.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports = {"$id":"log.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["version","creator","entries"],"properties":{"version":{"type":"string"},"creator":{"$ref":"creator.json#"},"browser":{"$ref":"browser.json#"},"pages":{"type":"array","items":{"$ref":"page.json#"}},"entries":{"type":"array","items":{"$ref":"entry.json#"}},"comment":{"type":"string"}}}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

module.exports = {"$id":"page.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["startedDateTime","id","title","pageTimings"],"properties":{"startedDateTime":{"type":"string","format":"date-time","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))"},"id":{"type":"string","unique":true},"title":{"type":"string"},"pageTimings":{"$ref":"pageTimings.json#"},"comment":{"type":"string"}}}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports = {"$id":"pageTimings.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","properties":{"onContentLoad":{"type":"number","min":-1},"onLoad":{"type":"number","min":-1},"comment":{"type":"string"}}}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports = {"$id":"postData.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["mimeType"],"properties":{"mimeType":{"type":"string"},"text":{"type":"string"},"params":{"type":"array","required":["name"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"fileName":{"type":"string"},"contentType":{"type":"string"},"comment":{"type":"string"}}},"comment":{"type":"string"}}}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

module.exports = {"$id":"query.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports = {"$id":"request.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["method","url","httpVersion","cookies","headers","queryString","headersSize","bodySize"],"properties":{"method":{"type":"string"},"url":{"type":"string","format":"uri"},"httpVersion":{"type":"string"},"cookies":{"type":"array","items":{"$ref":"cookie.json#"}},"headers":{"type":"array","items":{"$ref":"header.json#"}},"queryString":{"type":"array","items":{"$ref":"query.json#"}},"postData":{"$ref":"postData.json#"},"headersSize":{"type":"integer"},"bodySize":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = {"$id":"response.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["status","statusText","httpVersion","cookies","headers","content","redirectURL","headersSize","bodySize"],"properties":{"status":{"type":"integer"},"statusText":{"type":"string"},"httpVersion":{"type":"string"},"cookies":{"type":"array","items":{"$ref":"cookie.json#"}},"headers":{"type":"array","items":{"$ref":"header.json#"}},"content":{"$ref":"content.json#"},"redirectURL":{"type":"string"},"headersSize":{"type":"integer"},"bodySize":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = {"$id":"timings.json#","$schema":"http://json-schema.org/draft-06/schema#","required":["send","wait","receive"],"properties":{"dns":{"type":"number","min":-1},"connect":{"type":"number","min":-1},"blocked":{"type":"number","min":-1},"send":{"type":"number","min":-1},"wait":{"type":"number","min":-1},"receive":{"type":"number","min":-1},"ssl":{"type":"number","min":-1},"comment":{"type":"string"}}}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var caseless = __webpack_require__(82)
var uuid = __webpack_require__(58)
var helpers = __webpack_require__(63)

var md5 = helpers.md5
var toBase64 = helpers.toBase64

function Auth (request) {
  // define all public properties here
  this.request = request
  this.hasAuth = false
  this.sentAuth = false
  this.bearerToken = null
  this.user = null
  this.pass = null
}

Auth.prototype.basic = function (user, pass, sendImmediately) {
  var self = this
  if (typeof user !== 'string' || (pass !== undefined && typeof pass !== 'string')) {
    self.request.emit('error', new Error('auth() received invalid user or password'))
  }
  self.user = user
  self.pass = pass
  self.hasAuth = true
  var header = user + ':' + (pass || '')
  if (sendImmediately || typeof sendImmediately === 'undefined') {
    var authHeader = 'Basic ' + toBase64(header)
    self.sentAuth = true
    return authHeader
  }
}

Auth.prototype.bearer = function (bearer, sendImmediately) {
  var self = this
  self.bearerToken = bearer
  self.hasAuth = true
  if (sendImmediately || typeof sendImmediately === 'undefined') {
    if (typeof bearer === 'function') {
      bearer = bearer()
    }
    var authHeader = 'Bearer ' + (bearer || '')
    self.sentAuth = true
    return authHeader
  }
}

Auth.prototype.digest = function (method, path, authHeader) {
  // TODO: More complete implementation of RFC 2617.
  //   - handle challenge.domain
  //   - support qop="auth-int" only
  //   - handle Authentication-Info (not necessarily?)
  //   - check challenge.stale (not necessarily?)
  //   - increase nc (not necessarily?)
  // For reference:
  // http://tools.ietf.org/html/rfc2617#section-3
  // https://github.com/bagder/curl/blob/master/lib/http_digest.c

  var self = this

  var challenge = {}
  var re = /([a-z0-9_-]+)=(?:"([^"]+)"|([a-z0-9_-]+))/gi
  for (;;) {
    var match = re.exec(authHeader)
    if (!match) {
      break
    }
    challenge[match[1]] = match[2] || match[3]
  }

  /**
   * RFC 2617: handle both MD5 and MD5-sess algorithms.
   *
   * If the algorithm directive's value is "MD5" or unspecified, then HA1 is
   *   HA1=MD5(username:realm:password)
   * If the algorithm directive's value is "MD5-sess", then HA1 is
   *   HA1=MD5(MD5(username:realm:password):nonce:cnonce)
   */
  var ha1Compute = function (algorithm, user, realm, pass, nonce, cnonce) {
    var ha1 = md5(user + ':' + realm + ':' + pass)
    if (algorithm && algorithm.toLowerCase() === 'md5-sess') {
      return md5(ha1 + ':' + nonce + ':' + cnonce)
    } else {
      return ha1
    }
  }

  var qop = /(^|,)\s*auth\s*($|,)/.test(challenge.qop) && 'auth'
  var nc = qop && '00000001'
  var cnonce = qop && uuid().replace(/-/g, '')
  var ha1 = ha1Compute(challenge.algorithm, self.user, challenge.realm, self.pass, challenge.nonce, cnonce)
  var ha2 = md5(method + ':' + path)
  var digestResponse = qop
    ? md5(ha1 + ':' + challenge.nonce + ':' + nc + ':' + cnonce + ':' + qop + ':' + ha2)
    : md5(ha1 + ':' + challenge.nonce + ':' + ha2)
  var authValues = {
    username: self.user,
    realm: challenge.realm,
    nonce: challenge.nonce,
    uri: path,
    qop: qop,
    response: digestResponse,
    nc: nc,
    cnonce: cnonce,
    algorithm: challenge.algorithm,
    opaque: challenge.opaque
  }

  authHeader = []
  for (var k in authValues) {
    if (authValues[k]) {
      if (k === 'qop' || k === 'nc' || k === 'algorithm') {
        authHeader.push(k + '=' + authValues[k])
      } else {
        authHeader.push(k + '="' + authValues[k] + '"')
      }
    }
  }
  authHeader = 'Digest ' + authHeader.join(', ')
  self.sentAuth = true
  return authHeader
}

Auth.prototype.onRequest = function (user, pass, sendImmediately, bearer) {
  var self = this
  var request = self.request

  var authHeader
  if (bearer === undefined && user === undefined) {
    self.request.emit('error', new Error('no auth mechanism defined'))
  } else if (bearer !== undefined) {
    authHeader = self.bearer(bearer, sendImmediately)
  } else {
    authHeader = self.basic(user, pass, sendImmediately)
  }
  if (authHeader) {
    request.setHeader('authorization', authHeader)
  }
}

Auth.prototype.onResponse = function (response) {
  var self = this
  var request = self.request

  if (!self.hasAuth || self.sentAuth) { return null }

  var c = caseless(response.headers)

  var authHeader = c.get('www-authenticate')
  var authVerb = authHeader && authHeader.split(' ')[0].toLowerCase()
  request.debug('reauth', authVerb)

  switch (authVerb) {
    case 'basic':
      return self.basic(self.user, self.pass, true)

    case 'bearer':
      return self.bearer(self.bearerToken, true)

    case 'digest':
      return self.digest(request.method, request.path, authHeader)
  }
}

exports.Auth = Auth


/***/ }),
/* 364 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 365 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var url = __webpack_require__(16)
var qs = __webpack_require__(140)
var caseless = __webpack_require__(82)
var uuid = __webpack_require__(58)
var oauth = __webpack_require__(367)
var crypto = __webpack_require__(7)
var Buffer = __webpack_require__(1).Buffer

function OAuth (request) {
  this.request = request
  this.params = null
}

OAuth.prototype.buildParams = function (_oauth, uri, method, query, form, qsLib) {
  var oa = {}
  for (var i in _oauth) {
    oa['oauth_' + i] = _oauth[i]
  }
  if (!oa.oauth_version) {
    oa.oauth_version = '1.0'
  }
  if (!oa.oauth_timestamp) {
    oa.oauth_timestamp = Math.floor(Date.now() / 1000).toString()
  }
  if (!oa.oauth_nonce) {
    oa.oauth_nonce = uuid().replace(/-/g, '')
  }
  if (!oa.oauth_signature_method) {
    oa.oauth_signature_method = 'HMAC-SHA1'
  }

  var consumer_secret_or_private_key = oa.oauth_consumer_secret || oa.oauth_private_key // eslint-disable-line camelcase
  delete oa.oauth_consumer_secret
  delete oa.oauth_private_key

  var token_secret = oa.oauth_token_secret // eslint-disable-line camelcase
  delete oa.oauth_token_secret

  var realm = oa.oauth_realm
  delete oa.oauth_realm
  delete oa.oauth_transport_method

  var baseurl = uri.protocol + '//' + uri.host + uri.pathname
  var params = qsLib.parse([].concat(query, form, qsLib.stringify(oa)).join('&'))

  oa.oauth_signature = oauth.sign(
    oa.oauth_signature_method,
    method,
    baseurl,
    params,
    consumer_secret_or_private_key, // eslint-disable-line camelcase
    token_secret // eslint-disable-line camelcase
  )

  if (realm) {
    oa.realm = realm
  }

  return oa
}

OAuth.prototype.buildBodyHash = function (_oauth, body) {
  if (['HMAC-SHA1', 'RSA-SHA1'].indexOf(_oauth.signature_method || 'HMAC-SHA1') < 0) {
    this.request.emit('error', new Error('oauth: ' + _oauth.signature_method +
      ' signature_method not supported with body_hash signing.'))
  }

  var shasum = crypto.createHash('sha1')
  shasum.update(body || '')
  var sha1 = shasum.digest('hex')

  return Buffer.from(sha1, 'hex').toString('base64')
}

OAuth.prototype.concatParams = function (oa, sep, wrap) {
  wrap = wrap || ''

  var params = Object.keys(oa).filter(function (i) {
    return i !== 'realm' && i !== 'oauth_signature'
  }).sort()

  if (oa.realm) {
    params.splice(0, 0, 'realm')
  }
  params.push('oauth_signature')

  return params.map(function (i) {
    return i + '=' + wrap + oauth.rfc3986(oa[i]) + wrap
  }).join(sep)
}

OAuth.prototype.onRequest = function (_oauth) {
  var self = this
  self.params = _oauth

  var uri = self.request.uri || {}
  var method = self.request.method || ''
  var headers = caseless(self.request.headers)
  var body = self.request.body || ''
  var qsLib = self.request.qsLib || qs

  var form
  var query
  var contentType = headers.get('content-type') || ''
  var formContentType = 'application/x-www-form-urlencoded'
  var transport = _oauth.transport_method || 'header'

  if (contentType.slice(0, formContentType.length) === formContentType) {
    contentType = formContentType
    form = body
  }
  if (uri.query) {
    query = uri.query
  }
  if (transport === 'body' && (method !== 'POST' || contentType !== formContentType)) {
    self.request.emit('error', new Error('oauth: transport_method of body requires POST ' +
      'and content-type ' + formContentType))
  }

  if (!form && typeof _oauth.body_hash === 'boolean') {
    _oauth.body_hash = self.buildBodyHash(_oauth, self.request.body.toString())
  }

  var oa = self.buildParams(_oauth, uri, method, query, form, qsLib)

  switch (transport) {
    case 'header':
      self.request.setHeader('Authorization', 'OAuth ' + self.concatParams(oa, ',', '"'))
      break

    case 'query':
      var href = self.request.uri.href += (query ? '&' : '?') + self.concatParams(oa, '&')
      self.request.uri = url.parse(href)
      self.request.path = self.request.uri.path
      break

    case 'body':
      self.request.body = (form ? form + '&' : '') + self.concatParams(oa, '&')
      break

    default:
      self.request.emit('error', new Error('oauth: transport_method invalid'))
  }
}

exports.OAuth = OAuth


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var crypto = __webpack_require__(7)

function sha (key, body, algorithm) {
  return crypto.createHmac(algorithm, key).update(body).digest('base64')
}

function rsa (key, body) {
  return crypto.createSign('RSA-SHA1').update(body).sign(key, 'base64')
}

function rfc3986 (str) {
  return encodeURIComponent(str)
    .replace(/!/g,'%21')
    .replace(/\*/g,'%2A')
    .replace(/\(/g,'%28')
    .replace(/\)/g,'%29')
    .replace(/'/g,'%27')
}

// Maps object to bi-dimensional array
// Converts { foo: 'A', bar: [ 'b', 'B' ]} to
// [ ['foo', 'A'], ['bar', 'b'], ['bar', 'B'] ]
function map (obj) {
  var key, val, arr = []
  for (key in obj) {
    val = obj[key]
    if (Array.isArray(val))
      for (var i = 0; i < val.length; i++)
        arr.push([key, val[i]])
    else if (typeof val === 'object')
      for (var prop in val)
        arr.push([key + '[' + prop + ']', val[prop]])
    else
      arr.push([key, val])
  }
  return arr
}

// Compare function for sort
function compare (a, b) {
  return a > b ? 1 : a < b ? -1 : 0
}

function generateBase (httpMethod, base_uri, params) {
  // adapted from https://dev.twitter.com/docs/auth/oauth and 
  // https://dev.twitter.com/docs/auth/creating-signature

  // Parameter normalization
  // http://tools.ietf.org/html/rfc5849#section-3.4.1.3.2
  var normalized = map(params)
  // 1.  First, the name and value of each parameter are encoded
  .map(function (p) {
    return [ rfc3986(p[0]), rfc3986(p[1] || '') ]
  })
  // 2.  The parameters are sorted by name, using ascending byte value
  //     ordering.  If two or more parameters share the same name, they
  //     are sorted by their value.
  .sort(function (a, b) {
    return compare(a[0], b[0]) || compare(a[1], b[1])
  })
  // 3.  The name of each parameter is concatenated to its corresponding
  //     value using an "=" character (ASCII code 61) as a separator, even
  //     if the value is empty.
  .map(function (p) { return p.join('=') })
   // 4.  The sorted name/value pairs are concatenated together into a
   //     single string by using an "&" character (ASCII code 38) as
   //     separator.
  .join('&')

  var base = [
    rfc3986(httpMethod ? httpMethod.toUpperCase() : 'GET'),
    rfc3986(base_uri),
    rfc3986(normalized)
  ].join('&')

  return base
}

function hmacsign (httpMethod, base_uri, params, consumer_secret, token_secret) {
  var base = generateBase(httpMethod, base_uri, params)
  var key = [
    consumer_secret || '',
    token_secret || ''
  ].map(rfc3986).join('&')

  return sha(key, base, 'sha1')
}

function hmacsign256 (httpMethod, base_uri, params, consumer_secret, token_secret) {
  var base = generateBase(httpMethod, base_uri, params)
  var key = [
    consumer_secret || '',
    token_secret || ''
  ].map(rfc3986).join('&')

  return sha(key, base, 'sha256')
}

function rsasign (httpMethod, base_uri, params, private_key, token_secret) {
  var base = generateBase(httpMethod, base_uri, params)
  var key = private_key || ''

  return rsa(key, base)
}

function plaintext (consumer_secret, token_secret) {
  var key = [
    consumer_secret || '',
    token_secret || ''
  ].map(rfc3986).join('&')

  return key
}

function sign (signMethod, httpMethod, base_uri, params, consumer_secret, token_secret) {
  var method
  var skipArgs = 1

  switch (signMethod) {
    case 'RSA-SHA1':
      method = rsasign
      break
    case 'HMAC-SHA1':
      method = hmacsign
      break
    case 'HMAC-SHA256':
      method = hmacsign256
      break
    case 'PLAINTEXT':
      method = plaintext
      skipArgs = 4
      break
    default:
     throw new Error('Signature method not supported: ' + signMethod)
  }

  return method.apply(null, [].slice.call(arguments, skipArgs))
}

exports.hmacsign = hmacsign
exports.hmacsign256 = hmacsign256
exports.rsasign = rsasign
exports.plaintext = plaintext
exports.sign = sign
exports.rfc3986 = rfc3986
exports.generateBase = generateBase

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = __webpack_require__(7)

function randomString (size) {
  var bits = (size + 1) * 6
  var buffer = crypto.randomBytes(Math.ceil(bits / 8))
  var string = buffer.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')
  return string.slice(0, size)
}

function calculatePayloadHash (payload, algorithm, contentType) {
  var hash = crypto.createHash(algorithm)
  hash.update('hawk.1.payload\n')
  hash.update((contentType ? contentType.split(';')[0].trim().toLowerCase() : '') + '\n')
  hash.update(payload || '')
  hash.update('\n')
  return hash.digest('base64')
}

exports.calculateMac = function (credentials, opts) {
  var normalized = 'hawk.1.header\n' +
    opts.ts + '\n' +
    opts.nonce + '\n' +
    (opts.method || '').toUpperCase() + '\n' +
    opts.resource + '\n' +
    opts.host.toLowerCase() + '\n' +
    opts.port + '\n' +
    (opts.hash || '') + '\n'

  if (opts.ext) {
    normalized = normalized + opts.ext.replace('\\', '\\\\').replace('\n', '\\n')
  }

  normalized = normalized + '\n'

  if (opts.app) {
    normalized = normalized + opts.app + '\n' + (opts.dlg || '') + '\n'
  }

  var hmac = crypto.createHmac(credentials.algorithm, credentials.key).update(normalized)
  var digest = hmac.digest('base64')
  return digest
}

exports.header = function (uri, method, opts) {
  var timestamp = opts.timestamp || Math.floor((Date.now() + (opts.localtimeOffsetMsec || 0)) / 1000)
  var credentials = opts.credentials
  if (!credentials || !credentials.id || !credentials.key || !credentials.algorithm) {
    return ''
  }

  if (['sha1', 'sha256'].indexOf(credentials.algorithm) === -1) {
    return ''
  }

  var artifacts = {
    ts: timestamp,
    nonce: opts.nonce || randomString(6),
    method: method,
    resource: uri.pathname + (uri.search || ''),
    host: uri.hostname,
    port: uri.port || (uri.protocol === 'http:' ? 80 : 443),
    hash: opts.hash,
    ext: opts.ext,
    app: opts.app,
    dlg: opts.dlg
  }

  if (!artifacts.hash && (opts.payload || opts.payload === '')) {
    artifacts.hash = calculatePayloadHash(opts.payload, credentials.algorithm, opts.contentType)
  }

  var mac = exports.calculateMac(credentials, artifacts)

  var hasExt = artifacts.ext !== null && artifacts.ext !== undefined && artifacts.ext !== ''
  var header = 'Hawk id="' + credentials.id +
    '", ts="' + artifacts.ts +
    '", nonce="' + artifacts.nonce +
    (artifacts.hash ? '", hash="' + artifacts.hash : '') +
    (hasExt ? '", ext="' + artifacts.ext.replace(/\\/g, '\\\\').replace(/"/g, '\\"') : '') +
    '", mac="' + mac + '"'

  if (artifacts.app) {
    header = header + ', app="' + artifacts.app + (artifacts.dlg ? '", dlg="' + artifacts.dlg : '') + '"'
  }

  return header
}


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uuid = __webpack_require__(58)
var CombinedStream = __webpack_require__(370)
var isstream = __webpack_require__(139)
var Buffer = __webpack_require__(1).Buffer

function Multipart (request) {
  this.request = request
  this.boundary = uuid()
  this.chunked = false
  this.body = null
}

Multipart.prototype.isChunked = function (options) {
  var self = this
  var chunked = false
  var parts = options.data || options

  if (!parts.forEach) {
    self.request.emit('error', new Error('Argument error, options.multipart.'))
  }

  if (options.chunked !== undefined) {
    chunked = options.chunked
  }

  if (self.request.getHeader('transfer-encoding') === 'chunked') {
    chunked = true
  }

  if (!chunked) {
    parts.forEach(function (part) {
      if (typeof part.body === 'undefined') {
        self.request.emit('error', new Error('Body attribute missing in multipart.'))
      }
      if (isstream(part.body)) {
        chunked = true
      }
    })
  }

  return chunked
}

Multipart.prototype.setHeaders = function (chunked) {
  var self = this

  if (chunked && !self.request.hasHeader('transfer-encoding')) {
    self.request.setHeader('transfer-encoding', 'chunked')
  }

  var header = self.request.getHeader('content-type')

  if (!header || header.indexOf('multipart') === -1) {
    self.request.setHeader('content-type', 'multipart/related; boundary=' + self.boundary)
  } else {
    if (header.indexOf('boundary') !== -1) {
      self.boundary = header.replace(/.*boundary=([^\s;]+).*/, '$1')
    } else {
      self.request.setHeader('content-type', header + '; boundary=' + self.boundary)
    }
  }
}

Multipart.prototype.build = function (parts, chunked) {
  var self = this
  var body = chunked ? new CombinedStream() : []

  function add (part) {
    if (typeof part === 'number') {
      part = part.toString()
    }
    return chunked ? body.append(part) : body.push(Buffer.from(part))
  }

  if (self.request.preambleCRLF) {
    add('\r\n')
  }

  parts.forEach(function (part) {
    var preamble = '--' + self.boundary + '\r\n'
    Object.keys(part).forEach(function (key) {
      if (key === 'body') { return }
      preamble += key + ': ' + part[key] + '\r\n'
    })
    preamble += '\r\n'
    add(preamble)
    add(part.body)
    add('\r\n')
  })
  add('--' + self.boundary + '--')

  if (self.request.postambleCRLF) {
    add('\r\n')
  }

  return body
}

Multipart.prototype.onRequest = function (options) {
  var self = this

  var chunked = self.isChunked(options)
  var parts = options.data || options

  self.setHeaders(chunked)
  self.chunked = chunked
  self.body = self.build(parts, chunked)
}

exports.Multipart = Multipart


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var util = __webpack_require__(5);
var Stream = __webpack_require__(17).Stream;
var DelayedStream = __webpack_require__(371);
var defer = __webpack_require__(372);

module.exports = CombinedStream;
function CombinedStream() {
  this.writable = false;
  this.readable = true;
  this.dataSize = 0;
  this.maxDataSize = 2 * 1024 * 1024;
  this.pauseStreams = true;

  this._released = false;
  this._streams = [];
  this._currentStream = null;
}
util.inherits(CombinedStream, Stream);

CombinedStream.create = function(options) {
  var combinedStream = new this();

  options = options || {};
  for (var option in options) {
    combinedStream[option] = options[option];
  }

  return combinedStream;
};

CombinedStream.isStreamLike = function(stream) {
  return (typeof stream !== 'function')
    && (typeof stream !== 'string')
    && (typeof stream !== 'boolean')
    && (typeof stream !== 'number')
    && (!Buffer.isBuffer(stream));
};

CombinedStream.prototype.append = function(stream) {
  var isStreamLike = CombinedStream.isStreamLike(stream);

  if (isStreamLike) {
    if (!(stream instanceof DelayedStream)) {
      var newStream = DelayedStream.create(stream, {
        maxDataSize: Infinity,
        pauseStream: this.pauseStreams,
      });
      stream.on('data', this._checkDataSize.bind(this));
      stream = newStream;
    }

    this._handleErrors(stream);

    if (this.pauseStreams) {
      stream.pause();
    }
  }

  this._streams.push(stream);
  return this;
};

CombinedStream.prototype.pipe = function(dest, options) {
  Stream.prototype.pipe.call(this, dest, options);
  this.resume();
  return dest;
};

CombinedStream.prototype._getNext = function() {
  this._currentStream = null;
  var stream = this._streams.shift();


  if (typeof stream == 'undefined') {
    this.end();
    return;
  }

  if (typeof stream !== 'function') {
    this._pipeNext(stream);
    return;
  }

  var getStream = stream;
  getStream(function(stream) {
    var isStreamLike = CombinedStream.isStreamLike(stream);
    if (isStreamLike) {
      stream.on('data', this._checkDataSize.bind(this));
      this._handleErrors(stream);
    }

    defer(this._pipeNext.bind(this, stream));
  }.bind(this));
};

CombinedStream.prototype._pipeNext = function(stream) {
  this._currentStream = stream;

  var isStreamLike = CombinedStream.isStreamLike(stream);
  if (isStreamLike) {
    stream.on('end', this._getNext.bind(this));
    stream.pipe(this, {end: false});
    return;
  }

  var value = stream;
  this.write(value);
  this._getNext();
};

CombinedStream.prototype._handleErrors = function(stream) {
  var self = this;
  stream.on('error', function(err) {
    self._emitError(err);
  });
};

CombinedStream.prototype.write = function(data) {
  this.emit('data', data);
};

CombinedStream.prototype.pause = function() {
  if (!this.pauseStreams) {
    return;
  }

  if(this.pauseStreams && this._currentStream && typeof(this._currentStream.pause) == 'function') this._currentStream.pause();
  this.emit('pause');
};

CombinedStream.prototype.resume = function() {
  if (!this._released) {
    this._released = true;
    this.writable = true;
    this._getNext();
  }

  if(this.pauseStreams && this._currentStream && typeof(this._currentStream.resume) == 'function') this._currentStream.resume();
  this.emit('resume');
};

CombinedStream.prototype.end = function() {
  this._reset();
  this.emit('end');
};

CombinedStream.prototype.destroy = function() {
  this._reset();
  this.emit('close');
};

CombinedStream.prototype._reset = function() {
  this.writable = false;
  this._streams = [];
  this._currentStream = null;
};

CombinedStream.prototype._checkDataSize = function() {
  this._updateDataSize();
  if (this.dataSize <= this.maxDataSize) {
    return;
  }

  var message =
    'DelayedStream#maxDataSize of ' + this.maxDataSize + ' bytes exceeded.';
  this._emitError(new Error(message));
};

CombinedStream.prototype._updateDataSize = function() {
  this.dataSize = 0;

  var self = this;
  this._streams.forEach(function(stream) {
    if (!stream.dataSize) {
      return;
    }

    self.dataSize += stream.dataSize;
  });

  if (this._currentStream && this._currentStream.dataSize) {
    this.dataSize += this._currentStream.dataSize;
  }
};

CombinedStream.prototype._emitError = function(err) {
  this._reset();
  this.emit('error', err);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer))

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var Stream = __webpack_require__(17).Stream;
var util = __webpack_require__(5);

module.exports = DelayedStream;
function DelayedStream() {
  this.source = null;
  this.dataSize = 0;
  this.maxDataSize = 1024 * 1024;
  this.pauseStream = true;

  this._maxDataSizeExceeded = false;
  this._released = false;
  this._bufferedEvents = [];
}
util.inherits(DelayedStream, Stream);

DelayedStream.create = function(source, options) {
  var delayedStream = new this();

  options = options || {};
  for (var option in options) {
    delayedStream[option] = options[option];
  }

  delayedStream.source = source;

  var realEmit = source.emit;
  source.emit = function() {
    delayedStream._handleEmit(arguments);
    return realEmit.apply(source, arguments);
  };

  source.on('error', function() {});
  if (delayedStream.pauseStream) {
    source.pause();
  }

  return delayedStream;
};

Object.defineProperty(DelayedStream.prototype, 'readable', {
  configurable: true,
  enumerable: true,
  get: function() {
    return this.source.readable;
  }
});

DelayedStream.prototype.setEncoding = function() {
  return this.source.setEncoding.apply(this.source, arguments);
};

DelayedStream.prototype.resume = function() {
  if (!this._released) {
    this.release();
  }

  this.source.resume();
};

DelayedStream.prototype.pause = function() {
  this.source.pause();
};

DelayedStream.prototype.release = function() {
  this._released = true;

  this._bufferedEvents.forEach(function(args) {
    this.emit.apply(this, args);
  }.bind(this));
  this._bufferedEvents = [];
};

DelayedStream.prototype.pipe = function() {
  var r = Stream.prototype.pipe.apply(this, arguments);
  this.resume();
  return r;
};

DelayedStream.prototype._handleEmit = function(args) {
  if (this._released) {
    this.emit.apply(this, args);
    return;
  }

  if (args[0] === 'data') {
    this.dataSize += args[1].length;
    this._checkIfMaxDataSizeExceeded();
  }

  this._bufferedEvents.push(args);
};

DelayedStream.prototype._checkIfMaxDataSizeExceeded = function() {
  if (this._maxDataSizeExceeded) {
    return;
  }

  if (this.dataSize <= this.maxDataSize) {
    return;
  }

  this._maxDataSizeExceeded = true;
  var message =
    'DelayedStream#maxDataSize of ' + this.maxDataSize + ' bytes exceeded.'
  this.emit('error', new Error(message));
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, process) {module.exports = defer;

/**
 * Runs provided function on next iteration of the event loop
 *
 * @param {function} fn - function to run
 */
function defer(fn)
{
  var nextTick = typeof setImmediate == 'function'
    ? setImmediate
    : (
      typeof process == 'object' && typeof process.nextTick == 'function'
      ? process.nextTick
      : null
    );

  if (nextTick)
  {
    nextTick(fn);
  }
  else
  {
    setTimeout(fn, 0);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(64).setImmediate, __webpack_require__(6)))

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var url = __webpack_require__(16)
var isUrl = /^https?:/

function Redirect (request) {
  this.request = request
  this.followRedirect = true
  this.followRedirects = true
  this.followAllRedirects = false
  this.followOriginalHttpMethod = false
  this.allowRedirect = function () { return true }
  this.maxRedirects = 10
  this.redirects = []
  this.redirectsFollowed = 0
  this.removeRefererHeader = false
}

Redirect.prototype.onRequest = function (options) {
  var self = this

  if (options.maxRedirects !== undefined) {
    self.maxRedirects = options.maxRedirects
  }
  if (typeof options.followRedirect === 'function') {
    self.allowRedirect = options.followRedirect
  }
  if (options.followRedirect !== undefined) {
    self.followRedirects = !!options.followRedirect
  }
  if (options.followAllRedirects !== undefined) {
    self.followAllRedirects = options.followAllRedirects
  }
  if (self.followRedirects || self.followAllRedirects) {
    self.redirects = self.redirects || []
  }
  if (options.removeRefererHeader !== undefined) {
    self.removeRefererHeader = options.removeRefererHeader
  }
  if (options.followOriginalHttpMethod !== undefined) {
    self.followOriginalHttpMethod = options.followOriginalHttpMethod
  }
}

Redirect.prototype.redirectTo = function (response) {
  var self = this
  var request = self.request

  var redirectTo = null
  if (response.statusCode >= 300 && response.statusCode < 400 && response.caseless.has('location')) {
    var location = response.caseless.get('location')
    request.debug('redirect', location)

    if (self.followAllRedirects) {
      redirectTo = location
    } else if (self.followRedirects) {
      switch (request.method) {
        case 'PATCH':
        case 'PUT':
        case 'POST':
        case 'DELETE':
          // Do not follow redirects
          break
        default:
          redirectTo = location
          break
      }
    }
  } else if (response.statusCode === 401) {
    var authHeader = request._auth.onResponse(response)
    if (authHeader) {
      request.setHeader('authorization', authHeader)
      redirectTo = request.uri
    }
  }
  return redirectTo
}

Redirect.prototype.onResponse = function (response) {
  var self = this
  var request = self.request

  var redirectTo = self.redirectTo(response)
  if (!redirectTo || !self.allowRedirect.call(request, response)) {
    return false
  }

  request.debug('redirect to', redirectTo)

  // ignore any potential response body.  it cannot possibly be useful
  // to us at this point.
  // response.resume should be defined, but check anyway before calling. Workaround for browserify.
  if (response.resume) {
    response.resume()
  }

  if (self.redirectsFollowed >= self.maxRedirects) {
    request.emit('error', new Error('Exceeded maxRedirects. Probably stuck in a redirect loop ' + request.uri.href))
    return false
  }
  self.redirectsFollowed += 1

  if (!isUrl.test(redirectTo)) {
    redirectTo = url.resolve(request.uri.href, redirectTo)
  }

  var uriPrev = request.uri
  request.uri = url.parse(redirectTo)

  // handle the case where we change protocol from https to http or vice versa
  if (request.uri.protocol !== uriPrev.protocol) {
    delete request.agent
  }

  self.redirects.push({ statusCode: response.statusCode, redirectUri: redirectTo })

  if (self.followAllRedirects && request.method !== 'HEAD' &&
    response.statusCode !== 401 && response.statusCode !== 307) {
    request.method = self.followOriginalHttpMethod ? request.method : 'GET'
  }
  // request.method = 'GET' // Force all redirects to use GET || commented out fixes #215
  delete request.src
  delete request.req
  delete request._started
  if (response.statusCode !== 401 && response.statusCode !== 307) {
    // Remove parameters from the previous response, unless this is the second request
    // for a server that requires digest authentication.
    delete request.body
    delete request._form
    if (request.headers) {
      request.removeHeader('host')
      request.removeHeader('content-type')
      request.removeHeader('content-length')
      if (request.uri.hostname !== request.originalHost.split(':')[0]) {
        // Remove authorization if changing hostnames (but not if just
        // changing ports or protocols).  This matches the behavior of curl:
        // https://github.com/bagder/curl/blob/6beb0eee/lib/http.c#L710
        request.removeHeader('authorization')
      }
    }
  }

  if (!self.removeRefererHeader) {
    request.setHeader('referer', uriPrev.href)
  }

  request.emit('redirect')

  request.init()

  return true
}

exports.Redirect = Redirect


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var url = __webpack_require__(16)
var tunnel = __webpack_require__(375)

var defaultProxyHeaderWhiteList = [
  'accept',
  'accept-charset',
  'accept-encoding',
  'accept-language',
  'accept-ranges',
  'cache-control',
  'content-encoding',
  'content-language',
  'content-location',
  'content-md5',
  'content-range',
  'content-type',
  'connection',
  'date',
  'expect',
  'max-forwards',
  'pragma',
  'referer',
  'te',
  'user-agent',
  'via'
]

var defaultProxyHeaderExclusiveList = [
  'proxy-authorization'
]

function constructProxyHost (uriObject) {
  var port = uriObject.port
  var protocol = uriObject.protocol
  var proxyHost = uriObject.hostname + ':'

  if (port) {
    proxyHost += port
  } else if (protocol === 'https:') {
    proxyHost += '443'
  } else {
    proxyHost += '80'
  }

  return proxyHost
}

function constructProxyHeaderWhiteList (headers, proxyHeaderWhiteList) {
  var whiteList = proxyHeaderWhiteList
    .reduce(function (set, header) {
      set[header.toLowerCase()] = true
      return set
    }, {})

  return Object.keys(headers)
    .filter(function (header) {
      return whiteList[header.toLowerCase()]
    })
    .reduce(function (set, header) {
      set[header] = headers[header]
      return set
    }, {})
}

function constructTunnelOptions (request, proxyHeaders) {
  var proxy = request.proxy

  var tunnelOptions = {
    proxy: {
      host: proxy.hostname,
      port: +proxy.port,
      proxyAuth: proxy.auth,
      headers: proxyHeaders
    },
    headers: request.headers,
    ca: request.ca,
    cert: request.cert,
    key: request.key,
    passphrase: request.passphrase,
    pfx: request.pfx,
    ciphers: request.ciphers,
    rejectUnauthorized: request.rejectUnauthorized,
    secureOptions: request.secureOptions,
    secureProtocol: request.secureProtocol
  }

  return tunnelOptions
}

function constructTunnelFnName (uri, proxy) {
  var uriProtocol = (uri.protocol === 'https:' ? 'https' : 'http')
  var proxyProtocol = (proxy.protocol === 'https:' ? 'Https' : 'Http')
  return [uriProtocol, proxyProtocol].join('Over')
}

function getTunnelFn (request) {
  var uri = request.uri
  var proxy = request.proxy
  var tunnelFnName = constructTunnelFnName(uri, proxy)
  return tunnel[tunnelFnName]
}

function Tunnel (request) {
  this.request = request
  this.proxyHeaderWhiteList = defaultProxyHeaderWhiteList
  this.proxyHeaderExclusiveList = []
  if (typeof request.tunnel !== 'undefined') {
    this.tunnelOverride = request.tunnel
  }
}

Tunnel.prototype.isEnabled = function () {
  var self = this
  var request = self.request
    // Tunnel HTTPS by default. Allow the user to override this setting.

  // If self.tunnelOverride is set (the user specified a value), use it.
  if (typeof self.tunnelOverride !== 'undefined') {
    return self.tunnelOverride
  }

  // If the destination is HTTPS, tunnel.
  if (request.uri.protocol === 'https:') {
    return true
  }

  // Otherwise, do not use tunnel.
  return false
}

Tunnel.prototype.setup = function (options) {
  var self = this
  var request = self.request

  options = options || {}

  if (typeof request.proxy === 'string') {
    request.proxy = url.parse(request.proxy)
  }

  if (!request.proxy || !request.tunnel) {
    return false
  }

  // Setup Proxy Header Exclusive List and White List
  if (options.proxyHeaderWhiteList) {
    self.proxyHeaderWhiteList = options.proxyHeaderWhiteList
  }
  if (options.proxyHeaderExclusiveList) {
    self.proxyHeaderExclusiveList = options.proxyHeaderExclusiveList
  }

  var proxyHeaderExclusiveList = self.proxyHeaderExclusiveList.concat(defaultProxyHeaderExclusiveList)
  var proxyHeaderWhiteList = self.proxyHeaderWhiteList.concat(proxyHeaderExclusiveList)

  // Setup Proxy Headers and Proxy Headers Host
  // Only send the Proxy White Listed Header names
  var proxyHeaders = constructProxyHeaderWhiteList(request.headers, proxyHeaderWhiteList)
  proxyHeaders.host = constructProxyHost(request.uri)

  proxyHeaderExclusiveList.forEach(request.removeHeader, request)

  // Set Agent from Tunnel Data
  var tunnelFn = getTunnelFn(request)
  var tunnelOptions = constructTunnelOptions(request, proxyHeaders)
  request.agent = tunnelFn(tunnelOptions)

  return true
}

Tunnel.defaultProxyHeaderWhiteList = defaultProxyHeaderWhiteList
Tunnel.defaultProxyHeaderExclusiveList = defaultProxyHeaderExclusiveList
exports.Tunnel = Tunnel


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var net = __webpack_require__(30)
  , tls = __webpack_require__(30)
  , http = __webpack_require__(41)
  , https = __webpack_require__(75)
  , events = __webpack_require__(49)
  , assert = __webpack_require__(28)
  , util = __webpack_require__(5)
  , Buffer = __webpack_require__(1).Buffer
  ;

exports.httpOverHttp = httpOverHttp
exports.httpsOverHttp = httpsOverHttp
exports.httpOverHttps = httpOverHttps
exports.httpsOverHttps = httpsOverHttps


function httpOverHttp(options) {
  var agent = new TunnelingAgent(options)
  agent.request = http.request
  return agent
}

function httpsOverHttp(options) {
  var agent = new TunnelingAgent(options)
  agent.request = http.request
  agent.createSocket = createSecureSocket
  agent.defaultPort = 443
  return agent
}

function httpOverHttps(options) {
  var agent = new TunnelingAgent(options)
  agent.request = https.request
  return agent
}

function httpsOverHttps(options) {
  var agent = new TunnelingAgent(options)
  agent.request = https.request
  agent.createSocket = createSecureSocket
  agent.defaultPort = 443
  return agent
}


function TunnelingAgent(options) {
  var self = this
  self.options = options || {}
  self.proxyOptions = self.options.proxy || {}
  self.maxSockets = self.options.maxSockets || http.Agent.defaultMaxSockets
  self.requests = []
  self.sockets = []

  self.on('free', function onFree(socket, host, port) {
    for (var i = 0, len = self.requests.length; i < len; ++i) {
      var pending = self.requests[i]
      if (pending.host === host && pending.port === port) {
        // Detect the request to connect same origin server,
        // reuse the connection.
        self.requests.splice(i, 1)
        pending.request.onSocket(socket)
        return
      }
    }
    socket.destroy()
    self.removeSocket(socket)
  })
}
util.inherits(TunnelingAgent, events.EventEmitter)

TunnelingAgent.prototype.addRequest = function addRequest(req, options) {
  var self = this

   // Legacy API: addRequest(req, host, port, path)
  if (typeof options === 'string') {
    options = {
      host: options,
      port: arguments[2],
      path: arguments[3]
    };
  }

  if (self.sockets.length >= this.maxSockets) {
    // We are over limit so we'll add it to the queue.
    self.requests.push({host: options.host, port: options.port, request: req})
    return
  }

  // If we are under maxSockets create a new one.
  self.createConnection({host: options.host, port: options.port, request: req})
}

TunnelingAgent.prototype.createConnection = function createConnection(pending) {
  var self = this

  self.createSocket(pending, function(socket) {
    socket.on('free', onFree)
    socket.on('close', onCloseOrRemove)
    socket.on('agentRemove', onCloseOrRemove)
    pending.request.onSocket(socket)

    function onFree() {
      self.emit('free', socket, pending.host, pending.port)
    }

    function onCloseOrRemove(err) {
      self.removeSocket(socket)
      socket.removeListener('free', onFree)
      socket.removeListener('close', onCloseOrRemove)
      socket.removeListener('agentRemove', onCloseOrRemove)
    }
  })
}

TunnelingAgent.prototype.createSocket = function createSocket(options, cb) {
  var self = this
  var placeholder = {}
  self.sockets.push(placeholder)

  var connectOptions = mergeOptions({}, self.proxyOptions,
    { method: 'CONNECT'
    , path: options.host + ':' + options.port
    , agent: false
    }
  )
  if (connectOptions.proxyAuth) {
    connectOptions.headers = connectOptions.headers || {}
    connectOptions.headers['Proxy-Authorization'] = 'Basic ' +
        Buffer.from(connectOptions.proxyAuth).toString('base64')
  }

  debug('making CONNECT request')
  var connectReq = self.request(connectOptions)
  connectReq.useChunkedEncodingByDefault = false // for v0.6
  connectReq.once('response', onResponse) // for v0.6
  connectReq.once('upgrade', onUpgrade)   // for v0.6
  connectReq.once('connect', onConnect)   // for v0.7 or later
  connectReq.once('error', onError)
  connectReq.end()

  function onResponse(res) {
    // Very hacky. This is necessary to avoid http-parser leaks.
    res.upgrade = true
  }

  function onUpgrade(res, socket, head) {
    // Hacky.
    process.nextTick(function() {
      onConnect(res, socket, head)
    })
  }

  function onConnect(res, socket, head) {
    connectReq.removeAllListeners()
    socket.removeAllListeners()

    if (res.statusCode === 200) {
      assert.equal(head.length, 0)
      debug('tunneling connection has established')
      self.sockets[self.sockets.indexOf(placeholder)] = socket
      cb(socket)
    } else {
      debug('tunneling socket could not be established, statusCode=%d', res.statusCode)
      var error = new Error('tunneling socket could not be established, ' + 'statusCode=' + res.statusCode)
      error.code = 'ECONNRESET'
      options.request.emit('error', error)
      self.removeSocket(placeholder)
    }
  }

  function onError(cause) {
    connectReq.removeAllListeners()

    debug('tunneling socket could not be established, cause=%s\n', cause.message, cause.stack)
    var error = new Error('tunneling socket could not be established, ' + 'cause=' + cause.message)
    error.code = 'ECONNRESET'
    options.request.emit('error', error)
    self.removeSocket(placeholder)
  }
}

TunnelingAgent.prototype.removeSocket = function removeSocket(socket) {
  var pos = this.sockets.indexOf(socket)
  if (pos === -1) return

  this.sockets.splice(pos, 1)

  var pending = this.requests.shift()
  if (pending) {
    // If we have pending requests and a socket gets closed a new one
    // needs to be created to take over in the pool for the one that closed.
    this.createConnection(pending)
  }
}

function createSecureSocket(options, cb) {
  var self = this
  TunnelingAgent.prototype.createSocket.call(self, options, function(socket) {
    // 0 is dummy port for v0.6
    var secureSocket = tls.connect(0, mergeOptions({}, self.options,
      { servername: options.host
      , socket: socket
      }
    ))
    self.sockets[self.sockets.indexOf(socket)] = secureSocket
    cb(secureSocket)
  })
}


function mergeOptions(target) {
  for (var i = 1, len = arguments.length; i < len; ++i) {
    var overrides = arguments[i]
    if (typeof overrides === 'object') {
      var keys = Object.keys(overrides)
      for (var j = 0, keyLen = keys.length; j < keyLen; ++j) {
        var k = keys[j]
        if (overrides[k] !== undefined) {
          target[k] = overrides[k]
        }
      }
    }
  }
  return target
}


var debug
if (Object({"NODE_ENV":"production","PUBLIC_URL":"."}).NODE_DEBUG && /\btunnel\b/.test(Object({"NODE_ENV":"production","PUBLIC_URL":"."}).NODE_DEBUG)) {
  debug = function() {
    var args = Array.prototype.slice.call(arguments)
    if (typeof args[0] === 'string') {
      args[0] = 'TUNNEL: ' + args[0]
    } else {
      args.unshift('TUNNEL:')
    }
    console.error.apply(console, args)
  }
} else {
  debug = function() {}
}
exports.debug = debug // for test

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserComponent__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WelcomeScreen=function(_Component){_inherits(WelcomeScreen,_Component);function WelcomeScreen(){_classCallCheck(this,WelcomeScreen);return _possibleConstructorReturn(this,(WelcomeScreen.__proto__||Object.getPrototypeOf(WelcomeScreen)).apply(this,arguments));}_createClass(WelcomeScreen,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'welcome'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Welcome to the Community Scoring Survey!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In this survey, you need to identify whether or not a social media user is a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'specialist'),' or a ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'generalist'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'You will be presented with a list of online communities someone is a part of. The bar shows what percentage of their activity is in this community.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UserComponent__["a" /* default */],{communities:"gaming:5;fashion:1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'After reviewing their activity, please rank how generalist or specialist the user is using these buttons.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScoringComponent,{preview:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Thank you for your participation!'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn btn-primary',onClick:this.props.onBegin},'Next Step')));}}]);return WelcomeScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ScoringComponent=function(_Component2){_inherits(ScoringComponent,_Component2);function ScoringComponent(props){_classCallCheck(this,ScoringComponent);var _this2=_possibleConstructorReturn(this,(ScoringComponent.__proto__||Object.getPrototypeOf(ScoringComponent)).call(this,props));_this2.state={selectedScore:null};return _this2;}_createClass(ScoringComponent,[{key:'render',value:function render(){var _this3=this;var preview=this.props.preview;var result=function result(score){return function(){return _this3.setState({selectedScore:score});};};var selected=this.state.selectedScore;var submit=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn btn-primary',onClick:function onClick(){return _this3.props.onResponse(_this3.state.selectedScore);}},'Submit'));if(selected==null){submit=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'btn btn-disabled'},'Submit'));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scoring'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:result(1),className:selected==1?"active":null},'Very Generalist'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:result(2),className:selected==2?"active":null},'Somewhat Generalist'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:result(3),className:selected==3?"active":null},'Neutral'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:result(4),className:selected==4?"active":null},'Somewhat Specialist'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:result(5),className:selected==5?"active":null},'Very Specialist')),preview?null:submit);}}]);return ScoringComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var QuestionScreen=function(_Component3){_inherits(QuestionScreen,_Component3);function QuestionScreen(){_classCallCheck(this,QuestionScreen);return _possibleConstructorReturn(this,(QuestionScreen.__proto__||Object.getPrototypeOf(QuestionScreen)).apply(this,arguments));}_createClass(QuestionScreen,[{key:'render',value:function render(){var question=this.props.question;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'question'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Is this user a generalist or a specialist?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__UserComponent__["a" /* default */],{communities:question.communities}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScoringComponent,{onResponse:this.props.onResponse}));}}]);return QuestionScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var UserScoreSingleQuiz=function(){function UserScoreSingleQuiz(){_classCallCheck(this,UserScoreSingleQuiz);}_createClass(UserScoreSingleQuiz,[{key:'renderWelcome',value:function renderWelcome(onBegin){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WelcomeScreen,{onBegin:onBegin});}},{key:'loadQuizData',value:function loadQuizData(callback){var testQuizData=[{user_id:"example:2017-1",communities:"Vegetarianism:10;veganrecipes:6;vegan:2;veganfitness:2;PlantBasedDiet:1"},{user_id:"example:2017-1",communities:"lol:100;apple:101;nintendo:102;h3h3productions:104;JETProgramme:60"},{user_id:"example:2017-1",communities:"nfl:30;baseball:7;daddit:1;Colts:17;Cardinals:8"},{user_id:"example:2017-1",communities:"AskReddit:1;leagueoflegends:3;Fitness:1;mildlyinteresting:1;pathofexile:41"},{user_id:"example:2017-1",communities:"politics:2;The_Donald:431;promos:1;AskThe_Donald:122;electronicmusic:13"},{user_id:"example:2017-1",communities:"pics:9;wow:11;funny:9;elderscrollsonline:14;worldofpvp:8"},{user_id:"example:2017-1",communities:"canada:13;PersonalFinanceCanada:2;CampingandHiking:1;CanadaPolitics:8;flightsim:45"},{user_id:"example:2017-1",communities:"Enough_Sanders_Spam:15;tmobile:1;SwagBucks:4;Louisville:31;NotFoolingAnybody:4"},{user_id:"example:2017-1",communities:"personalfinance:3;toronto:29;Hamilton:21;Animals:2;askTO:32"},{user_id:"example:2017-1",communities:"StardewValley:10;SWGalaxyOfHeroes:25;sto:29;totalwar:45;ContestOfChampions:13"}];callback(testQuizData);}},{key:'questionComponent',value:function questionComponent(){return QuestionScreen;}}]);return UserScoreSingleQuiz;}();/* unused harmony default export */ var _unused_webpack_default_export = (UserScoreSingleQuiz);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Leaderboard=function(_Component){_inherits(Leaderboard,_Component);function Leaderboard(props){_classCallCheck(this,Leaderboard);var _this=_possibleConstructorReturn(this,(Leaderboard.__proto__||Object.getPrototypeOf(Leaderboard)).call(this,props));_this.state={leaderboardData:null};_this.leaderboardLoadStatus="idle";return _this;}_createClass(Leaderboard,[{key:"loadLeaderboardData",value:function loadLeaderboardData(){var _this2=this;if(this.leaderboardLoadStatus=="loading"){// Let load
}else{this.leaderboardLoadStatus="loading";this.props.loader(function(leaderboard){if(_this2.leaderboardLoadStatus=="loading"){_this2.setState({leaderboardData:leaderboard});_this2.leaderboardLoadStatus="idle";}});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.leaderboardLoadStatus="unmounted";}},{key:"render",value:function render(){var _this3=this;var data=this.state.leaderboardData;if(!data){setTimeout(function(){return _this3.loadLeaderboardData();},100);}var elms=[];if(data){var last_index=-1;for(var i=0;i<data.length;i+=1){var dat=data[i];var name=dat.name||__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",null,"Anonymous");if(last_index!=dat.index-1){// discontinuity
elms.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i+"_d",className:"discontinuity"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"fas fa-ellipsis-h"})));}last_index=dat.index;elms.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i,className:"entry"+(dat.is_me?" me":"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"rank"},dat.rank,"."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"name"},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"points"},dat.points," points")));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"leaderboard"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"header"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Worldwide Leaderboard"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"close",onClick:this.props.onClose},"Close")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"entries"},elms),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You receive one point for each answer you get correct. Keep playing to help us collect more data and get more points.")));}}]);return Leaderboard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Leaderboard);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL(".",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="."+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.7dc9e729.js